(function() {
    'use strict';

    angular
        .module('ipmApp', [
            'ngStorage', 
            'tmh.dynamicLocale',
            'pascalprecht.translate', 
            'ngResource',
            'ngCookies',
            'ngSanitize',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.sortable',
            'infinite-scroll',
            'ngImgCrop',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'angular-hal',
            'rorymadden.date-dropdowns',
            'signature',
            'pdf',
            'ui.select'
        ])
        .run(run);

    run.$inject = ['$rootScope', '$state', 'stateHandler', 'translationHandler'];

    function run($rootScope, $state, stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
        
        // error page
        $rootScope.$on('ipmApp.httpError', function(response) {
        	$state.go('error');
        });
        
        $rootScope.$on( '$stateChangeStart', function ( event, to, toParams, from, fromParams ) {
        	from.params = fromParams;
        	$state.previous = from;
        });
    }
})();
;
(function() {
    'use strict';


    SuggestCourseController.$inject = ['$state', 'SurveyWorkflowService'];

    function SuggestCourseController($state, SurveyWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.loadingFinish = false;
        vm.register = register;
        vm.noThank = noThank;
        vm.handleRecommendationChange = handleRecommendationChange;
        vm.isRegisterDisable = isRegisterDisable;

        init();

        function init() {
            SurveyWorkflowService.getSuggestCourse().then(function(res) {
                if (res.data.recommended && res.data.recommended.length === 0 && res.data.recommended && res.data.consider.length === 0) {
                    $state.go('survey-workflow-thankyou');
                } else {
                    vm.loadingFinish = true;

                    vm.recommendations = [];

                    if (vm.patientCourseRegistration.suggestedCourses) {
                        _.forEach(res.data.recommended, function(o) {
                            if (_.indexOf(vm.patientCourseRegistration.suggestedCourses, o.id) !== -1) {
                                o.checked = true;
                            }
                        });
                    }

                    // High && Strongly && Recommended
                    var recommendedItem = {
                        text: 'surveyWorkflow.courseRegistration.suggestCourse.text2',
                        items: _.orderBy(res.data.recommended, ['score', 'name'], ['desc', 'asc'])
                    }
                    vm.recommendations.push(recommendedItem);
                    // Consider
                    var considerItem = {
                        text: _.isEmpty(res.data.recommended) ? 'surveyWorkflow.courseRegistration.suggestCourse.text4' : 'surveyWorkflow.courseRegistration.suggestCourse.text3',
                        items: _.orderBy(res.data.consider, ['score', 'name'], ['desc', 'asc'])
                    }
                    vm.recommendations.push(considerItem);
                }

            }, function() {
                $state.go('error');
            });


        }

        function register() {
            // add by recommended
            addIdToListData(vm.recommendations[0].items);
            // add by consider
            addIdToListData(vm.recommendations[1].items);

            vm.next();
        }

        function noThank() {
            vm.skip();
        }

        function handleRecommendationChange(data) {
        }

        function addIdToListData(list) {
            _.forEach(list, function(o) { 
                if (o.checked) {
                    vm.patientCourseRegistration.suggestedCourses.push(o.id);
                }
             });
        }

        function isRegisterDisable() {
            return isEmptyCheckedList(vm.recommendations[0].items) && isEmptyCheckedList(vm.recommendations[1].items);
        }

        function isEmptyCheckedList(list) {
            return _.isEmpty(_.filter(list, function(o) { return o.checked }));
        }
    }

    angular.module('ipmApp').component('suggestCourseStep', {
        bindings: {
            patientCourseRegistration: "=",
            next: '&',
            skip: '&'
        },
        templateUrl: 'app/survey-workflow/partial/course-register-workflow/step/suggest-course/suggest-course.html',
        controller: SuggestCourseController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();


(function() {
    'use strict';


    RecommendationItemComponent.$inject = ['$timeout', '$scope'];

    function RecommendationItemComponent($timeout, $scope) {
        var vm = this; //jshint ignore:line
        vm.handleCheckboxChange = handleCheckboxChange;
        init();

        function init() {
        }

        function handleCheckboxChange(item, checked) {
            vm.onChange({ data: { item: item } });
        }
    }

    angular.module('ipmApp').component('recommendationItem', {
        bindings: {
            text: '<',
            items: '<',
            onChange: '&'
        },
        template:   '<div class="col-md-12 h5 primary title mt-2" translate="{{vm.text}}">' +

                    '</div>' +
                    '<form name="evaluationForm" role="form" novalidate>' +
                            '<div class="col-md-12" ng-repeat="item in vm.items track by item.id">' +
                                '<div class="col-v4-12">' +
                                    '<div class="form-check-v4">' +
                                        '<input type="checkbox"' +
                                            'id="checkbox_{{item.id}}"' +
                                            'name="checkbox_{{item.id}}"' +
                                            'class="form-check-input-v4"' +
                                            'value="{{item}}"' +
                                            'ng-model="item.checked"' +
                                            'ng-change="vm.handleCheckboxChange(item, item.checked)">' +
                                            '<label class="form-check-label-v4" for="checkbox_{{item.id}}" >{{item.name}}</label>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</form>',
        controller: RecommendationItemComponent,
        controllerAs: 'vm'
    })
})();

;
(function() {
    'use strict';


    InstructionDetailListController.$inject = ['$rootScope', '$scope', 'SurveyWorkflowService'];

    function InstructionDetailListController($rootScope, $scope, SurveyWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.select = select;
        vm.noThank = noThank;
        vm.goBack = goBack;

        init();

        function init() {
            // get data
            SurveyWorkflowService.coursesRegistration(vm.patientCourseRegistration).then(function(response) {
                $rootScope.$broadcast('UpdateCourseRegistration', response.data);
            });
        }

        function select(instructorSchedule) {
            console.log('InstructorSchedule selected', instructorSchedule);
        	vm.patientCourseRegistration.instructorScheduleSelected = instructorSchedule;
            vm.next();

        }

        function noThank() {
            vm.skip();
        }

        function goBack() {
            vm.back();
        }
    }

    angular.module('ipmApp').component('instructionDetailListStep', {
        bindings: {
            patientCourseRegistration: "=",
            update: '&onUpdate',
            next: '&',
            skip: '&',
            back: '&'
        },
        templateUrl: 'app/survey-workflow/partial/course-register-workflow/step/instruction-detail-list/instruction-detail-list.html',
        controller: InstructionDetailListController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        },
        bindToController: true
    })
})();
;
 (function (){
     'use strict'

     angular.module('ipmApp').controller('classSessionModalController',ClassSessionModalController)

     ClassSessionModalController.$inject = ['$uibModalInstance','coursename','classsequence','classlist','orderByFilter']

     function ClassSessionModalController($uibModalInstance,coursename,classsequence,classlist, orderBy) {
        var vm = this;
        vm.courseName = coursename;
        vm.classSequence  = classsequence;
        vm.classList = orderBy(classlist,'classStart') ;
        vm.cancel = closeClassDialog;
        vm.selectedClass = selectedClass;
        function closeClassDialog() {
            $uibModalInstance.dismiss();
        }
        function selectedClass(selectedClass) {
            $uibModalInstance.close(selectedClass);
        }
     }
 })();;
(function () {
    "use strict";

    ClassSessionDetailDetailListController.$inject = ['$rootScope', '$scope','$uibModal','SurveyWorkflowService'];

    function ClassSessionDetailDetailListController($rootScope, $scope, $uibModal, SurveyWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.register = register;
        vm.noThank = noThank;
        vm.goBack = goBack;
        vm.openClassDialog = openClassDialog;
        init();

        function init() {
            vm.patientCourseRegistration.acceptRegister = false;
            SurveyWorkflowService.registerCourses(
                vm.patientCourseRegistration
            ).then(function (response) {
                $rootScope.$broadcast('UpdateCourseRegistration', response.data);
            });
        }

        function register() {
            vm.patientCourseRegistration.acceptRegister = true;
            SurveyWorkflowService.registerCourses(
                vm.patientCourseRegistration
            ).then(function (response) {
                vm.skip();
            });
        }

        function noThank() {
            vm.skip();
        }

        function goBack() {
            vm.back();
        }

        function openClassDialog($index, classSessionId, classSequence) {
            $uibModal
                .open({
                    templateUrl:
                        "app/survey-workflow/partial/course-register-workflow/step/class-session-detail-list/class-session-modal.html",
                    controller: "classSessionModalController",
                    controllerAs: "vm",
                    backdrop: "static",
                    windowClass: 'absolute-center vertical-center',
                    size: "lg",
                    resolve: {
                        coursename: function () {
                            return  vm.patientCourseRegistration.courseNameSelected;
                        },
                        classsequence: function() {
                            return  classSequence;
                        },
                        classlist: ['SurveyWorkflowService', '$q', function (SurveyWorkflowService, $q) {
                            var deferred = $q.defer();
                            SurveyWorkflowService.getFirstTimeOfClassBySkipClassSessionId(classSessionId, vm.patientCourseRegistration ).then(function (response) {
                                deferred.resolve(response.data);
                            });
                            return deferred.promise;
                        }],
                    },
                })
                .result.then(
                    function (selectedClass) {
                        if (selectedClass !== undefined) {
                            vm.patientCourseRegistration.scheduledClassesSelected[$index] = selectedClass;
                        }
                    },
                    function () {}
                );
        }
    }

    angular.module("ipmApp").component("classSessionDetailListStep", {
        bindings: {
            patientCourseRegistration: "=",
            next: "&",
            skip: "&",
            back: "&",
        },
        templateUrl:
            "app/survey-workflow/partial/course-register-workflow/step/class-session-detail-list/class-session-detail-list.html",
        controller: ClassSessionDetailDetailListController,
        controllerAs: "vm",
        resolve: {
            translatePartialLoader: [
                "$translate",
                "$translatePartialLoader",
                function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart("surveyWorkflow");
                    return $translate.refresh();
                },
            ],
        },
        bindToController: true,
    });
})();
;
(function() {
    'use strict';


    CPRTextInputQuestionController.$inject = ['$scope', '$state', 'ipmConstants'];

    function CPRTextInputQuestionController($scope, $state, ipmConstants) {
        var vm = this; //jshint ignore:line
        vm.isFreeTextInputRequired = isFreeTextInputRequired;
        vm.getEditorTextId = ''; // used to show quill editor
        vm.freeTextFieldId = ''; // used to check validation field
        init();

        function init() {
            if (vm.question) {
                vm.getEditorTextId = 'editorTextField_' + vm.question.id;
                vm.freeTextFieldId = 'freeTextField_' + vm.question.id;
            }
            // init answer
            if (vm.answers) {
                vm.valueAnswer = vm.answers.get(vm.question.code);
            }
        }

        function isFreeTextInputRequired() {
            return vm.question.required;
        }

        vm.minlengthInputRequired = function() {
            if (ipmConstants.MINLENGTH_FREETEXT_REQUIRED_CODE.includes(vm.question.code)) {
                return 0;
            }
            if (vm.question.code === 'CPR_040') {
                return 10;
            }
            if (vm.isFreeTextInputRequired()) {
                return 25;
            }
            return 0;
        };

        vm.isDisplayLabel = function () {
            return ipmConstants.DISPLAY_LABEL_CODE.includes(vm.question.code);
        }

        vm.handleTextChange = function(data, evaluationForm) {
            if (evaluationForm && evaluationForm[vm.freeTextFieldId] && !evaluationForm[vm.freeTextFieldId].$dirty) {
                evaluationForm[vm.freeTextFieldId].$setDirty();
            }
            vm.valueAnswer = data; // update data valueAnswer
            vm.onChange({ data: { question: vm.question, value: vm.valueAnswer }});
        };

        vm.getMaxLength = function() {
            if (vm.question.code === 'CPR_012') {
                return 10000;
            }
            return undefined;
        };
    }

    angular.module('ipmApp').component('cprTextInputQuestion', {
        bindings: {
            question: '<',
            answers: '<',
            onChange: '&'
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/question-component/text-input/text-input.html',
        controller: CPRTextInputQuestionController,
        controllerAs: 'vm'
    });
})();
;
(function() {
    'use strict';


    CPRDateInputQuestionController.$inject = ['$scope', '$state'];

    function CPRDateInputQuestionController($scope, $state) {
        var vm = this; //jshint ignore:line
        vm.datePickerOpenStatus = {};
        vm.dateFormat = 'MM/DD/YYYY';

        init();

        function init() {
            // init answer
            if (vm.answers) {
                var a = vm.answers.get(vm.question.code);
                if (a) {
                    vm.valueAnswer = new Date(a);
                }
            }
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.handleTextChange = function() {
            var valueToString = moment(vm.valueAnswer).format(vm.dateFormat);
            vm.onChange({ data: { question: vm.question, value: valueToString }});
        }
    }

    angular.module('ipmApp').component('cprDateInputQuestion', {
        bindings: {
            question: '<',
            answers: '<',
            onChange: '&',
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/question-component/date-input/date-input.html',
        controller: CPRDateInputQuestionController,
        controllerAs: 'vm',
    })
})();
;
(function() {
    'use strict';


    CPRSingleChoiceQuestionController.$inject = ['$scope', '$state'];

    function CPRSingleChoiceQuestionController($scope, $state) {
        var vm = this; //jshint ignore:line
        vm.isOtherSingleChoiceTextInputRequired = isOtherSingleChoiceTextInputRequired;
        vm.nameQuestionValueUnclear = 'Unclear';
        init();

        function init() {
            // init answer
            if (vm.answers) {
                _.forEach(vm.question.optionNames, function (option) {
                    if (option.value === 'Other') {
                        var otherAnswer = vm.answers.get(vm.question.code);
                        if (otherAnswer) {
                            var parts = otherAnswer.split('---');
                            var otherCheckboxValue = parts[0];
                            vm.valueOtherSingleChoiceTextInputValue = parts[1];
                            vm.answers.set(vm.question.code, otherCheckboxValue);
                        }
                    }
                });

                vm.valueAnswer = vm.answers.get(vm.question.code);
            }
        }

        vm.handleSingleChoiceChange = function(option) {
            vm.onChange({ data: { question: vm.question, value: vm.valueAnswer, clearChilds: true }});
        }

        vm.isDisplayCheckBoxInline = function() {
            if (vm.question.code === 'CPR_013' || vm.question.code === 'CPR_015') { // special case following mockup
                return false;
            }

            if (vm.question.code === 'CPR_018' || vm.question.code === 'CPR_020' || vm.question.code === 'CPR_009' ||  vm.question.code === 'CPR_055') { // special case following mockup
                return true;
            }
            return Object.entries(vm.question.optionNames).length < 3;
        }

        function isOtherSingleChoiceTextInputRequired() {
            if (vm.valueAnswer) {
                return vm.valueAnswer === 'Other' ? true : false
            }
            return false;
        }

        vm.isDisplayFreeTextOtherCheckbox = function() {
            return isOtherCheckboxTextInputRequired();
        }

        vm.handleOtherSingleChoiceTextInput = function () {
            if (vm.valueAnswer === 'Other') {
                vm.onChange({ data: { question: vm.question, value: vm.valueAnswer + '---' + vm.valueOtherSingleChoiceTextInputValue, clearChilds: false } });
            }
        }

        vm.isDisplayTextAreaOtherSingleChoice = function() {
            if (isOtherSingleChoiceTextInputRequired()) {
                if (vm.question.code !== 'CPR_016') {
                    return true;
                }
            }
            return false;
        }

        vm.isDisplayTextFieldOtherSingleChoice = function() {
            if (isOtherSingleChoiceTextInputRequired()) {
                if (vm.question.code === 'CPR_016') {
                    return true;
                }
            }
            return false;
        }

        vm.checkShowLabelRequiredCheckBox = function (option) {
            if (option.value === vm.nameQuestionValueUnclear && vm.valueAnswer == vm.nameQuestionValueUnclear) {
                return true;
            }
            return false;
        }
    }

    angular.module('ipmApp').component('cprSingleChoiceQuestion', {
        bindings: {
            question: '<',
            answers: '<',
            onChange: '&',
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/question-component/single-choice/single-choice.html',
        controller: CPRSingleChoiceQuestionController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    CPRCheckboxQuestionController.$inject = ['$scope', '$state', 'ipmConstants'];

    function CPRCheckboxQuestionController($scope, $state, ipmConstants) {
        var vm = this; //jshint ignore:line
        vm.handleCheckboxChange = handleCheckboxChange;
        vm.isOtherCheckboxTextInputRequired = isOtherCheckboxTextInputRequired;
        vm.checkClearChildByCheckboxValues = checkClearChildByCheckboxValues;
        vm.isOtherCheckboxTextInputRequired = isOtherCheckboxTextInputRequired;
        vm.nameCheckBoxOther = 'Other'; // used to show required label checkbox other
        vm.cprQuestionItemConductedId = 16;
        init();

        function init() {
            vm.checkboxValues = [];
            // order child by order number
            vm.question.questionItems = _.orderBy(vm.question.questionItems, ['orderNumber'], ['esc']);

            // init answer
            if (vm.answers) {
                vm.checkboxValues = vm.answers.get(vm.question.code) ? vm.answers.get(vm.question.code) : [];
                _.forEach(vm.question.questionItems, function (q) {
                    q.checked = false;
                    var k = _.find(vm.checkboxValues, function(l) { return l.value === q.value});
                    if(k) {
                        q.checked = true;
                    } else if (q.name === 'Other') {
                        var y = _.find(vm.checkboxValues, function(l) { return l.name === q.name});
                        if (y) {
                            q.checked = true;
                            vm.valueOtherCheckboxTextInputValue = y.value.split('---')[1];
                        }
                    }
                });
            }
        }

        function handleCheckboxChange(item, checked) {
            var k = undefined;
            if (item.name === 'Other') {
                k = _.find(vm.checkboxValues, function(l) { return l.name === 'Other'});
                if (!checked) {
                    vm.valueOtherCheckboxTextInputValue = undefined;
                }
            } else {
                k = _.find(vm.checkboxValues, function(l) { return l.value === item.value});
            }
            if (k) {
                _.remove(vm.checkboxValues, function(n) {
                    return n.value === item.value || (k.name === 'Other' && n.name === 'Other');
                  });
            } else {
                if (checked) {
                    vm.checkboxValues.push({name: item.name, value: item.value, orderNumber: item.orderNumber});
                }
            }
            var isClearChilds = vm.checkClearChildByCheckboxValues();
            vm.onChange({ data: { question: vm.question, value: vm.checkboxValues, clearChilds: isClearChilds }});
        }

        function checkClearChildByCheckboxValues() {
            var isClearChilds = false;
            if (_.isEmpty(vm.checkboxValues)) {
                isClearChilds = true;
            }
            return isClearChilds;
        }

        vm.handleOtherCheckboxTextInput = function () {
            var k = _.find(vm.checkboxValues, function(l) { return l.name === 'Other' });
            k.value = k.name + '---' + vm.valueOtherCheckboxTextInputValue;
            var isClearChilds = vm.checkClearChildByCheckboxValues();
            vm.onChange({ data: { question: vm.question, value: vm.checkboxValues, clearChilds: isClearChilds } });
        }

        vm.checkBoxRequired = function() {
            if (ipmConstants.DISPLAY_MESSAGE_REQUIRED_SUB_CHECKBOX.includes(vm.question.code)) {
            var result = true;
            for(var i = 0; i < vm.question.questionItems.length; i++) {
                var n = vm.question.questionItems[i];
                if (n.checked) {
                    result = false;
                    break;
                }
            }
            return result;
            }
            
            return false
        }

        function isOtherCheckboxTextInputRequired() {
            if (!vm.question.haveAutoComplete) {
                var k = _.find(vm.checkboxValues, function(l) { return l.name === 'Other' });
                return k ? true : false
            }
            return false;
        }

        function isOtherCheckboxTextInputRequired() {
            if (!vm.question.haveAutoComplete) {
                var k = _.find(vm.checkboxValues, function(l) { return l.name === 'Other' });
                return k ? true : false
            }
            return false;
        }

        vm.isDisplayLabelCheckbox = function() {
            if (isOtherCheckboxTextInputRequired()) {
                if (ipmConstants.DISPLAY_LABEL_CODE.includes(vm.question.code)) {
                    return true;
                }
            }
            return false;
        }

        vm.isDisplayTextAreaOtherCheckbox = function() {
            if (isOtherCheckboxTextInputRequired()) {
                if (!ipmConstants.DISPLAY_OTHER_TEXT_FIELD_CODE.includes(vm.question.code)) {
                    return true;
                }
            }
            return false;
        }

        vm.isDisplayTextFieldOtherCheckbox = function() {
            if (isOtherCheckboxTextInputRequired()) {
                if (ipmConstants.DISPLAY_OTHER_TEXT_FIELD_CODE.includes(vm.question.code)) {
                    return true;
                }
            }
            return false;
        }

        vm.checkShowLabelRequiredCheckBox= function(optionItem) {
           return optionItem.checked && (optionItem.name === vm.nameCheckBoxOther || ipmConstants.OPTION_ITEM_ID_REQUIRED.includes(optionItem.id));
        }
    }

    angular.module('ipmApp').component('cprCheckboxQuestion', {
        bindings: {
            question: '<',
            answers: '<',
            onChange: '&',
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/question-component/checkbox/checkbox.html',
        controller: CPRCheckboxQuestionController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    CPRTreatmentHistoryTableController.$inject = ['ipmConstants', '$scope', '$uibModal'];

    function CPRTreatmentHistoryTableController(constants, $scope, $uibModal) {
        var vm = this; //jshint ignore:line
        vm.emitData = emitData;
        vm.datePickerOpenStatus = {};
        vm.dateFormat = 'MM/DD/YYYY';
        
        init();

        function init() {
        }

        function emitData(treatmentType) {
            vm.onValueChange(
                { data: 
                    {
                        orderNumber: treatmentType.orderNumber,
                        sessionsCompleted: treatmentType.sessionsCompleted,
                        lastDate: treatmentType.lastDate ? moment(treatmentType.lastDate).format(vm.dateFormat) : '',
                        authResponseDate: treatmentType.authResponseDate ? moment(treatmentType.authResponseDate).format(vm.dateFormat) : '',
                        status: treatmentType.status,
                        treatment: treatmentType.value
                    }
                }
            );
        }

        vm.handleLastDateChange = function(treatmentType) {
            vm.emitData(treatmentType);
        }

        vm.handleAuthResponseDateChange = function(treatmentType) {
            vm.emitData(treatmentType);
        }

        vm.handleStatusChange = function(treatmentType) {
            vm.emitData(treatmentType);
        }

        vm.handleSessionsCompletedChange = function(treatmentType) {
            vm.emitData(treatmentType);
        }

        vm.openCalendar = function(treatmentType, date) {
            treatmentType.datePickerOpenStatus[date] = true;
        };

        vm.clearTreatmentRowData = function(treatmentType, index) {

            $uibModal.open({
                templateUrl: 'app/components/dialog/common-question/common-question.modal.html',
                controller: 'CommonQuestionModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    tests: function () {
                        return {
                            title: 'ipmApp.qhpWorkflow.treatmentHistory.clearModal.title',
                            question: 'ipmApp.qhpWorkflow.treatmentHistory.clearModal.question',
                            actionConfirm: 'entity.action.ok',
                            actionCancel: 'entity.action.cancel',
                        };
                    }
                }
            }).result.then(function() {
                // clear validation
                $scope.evaluationForm['sessionsCompleted_' + index].$setPristine();
                $scope.evaluationForm['sessionsCompleted_' + index].$setValidity('invalidRange', true);

                if (treatmentType) {
                    treatmentType.sessionsCompleted = undefined;
                    treatmentType.lastDate = null;
                    treatmentType.status = null;
                    treatmentType.authResponseDate = null;

                    vm.emitData(treatmentType);
                }
            }, function() {
            });
        }

        vm.isButtonClearTreamentDataDisable = function(treatmentType, index) {
            if ($scope.evaluationForm['lastDate_' + index].$invalid
            || $scope.evaluationForm['authResponseDate_' + index].$invalid) {
                return false;
            }
            return (treatmentType.sessionsCompleted === undefined || treatmentType.sessionsCompleted === '')
                && (treatmentType.lastDate === undefined || treatmentType.lastDate === null)
                && (treatmentType.status === undefined || treatmentType.status === null)
                && (treatmentType.authResponseDate === undefined || treatmentType.authResponseDate === null);
        }

        vm.isAuthResponseDateRequired = function(treatmentType) {
            return false;
        }

        vm.isLastDateRequired = function(treatmentType) { // completed

            if (treatmentType.status === 'approvedInProgress') {
                return isSessionCompletedHaveValue(treatmentType) || treatmentType.authResponseDate;
            }

            if (isMDEWithStatusInProgress(treatmentType)) { // MDE and status In Progress
                return true;
            }

            if (isSessionCompletedHaveValue(treatmentType)) {
                return true;
            }

            return false;
        }

        vm.isStatusRequired = function(treatmentType) {
            if (isSessionCompletedIsEqualZero(treatmentType)) {
                return true;
            }
            return false
        }

        vm.isSessionCompletedRequired = function(treatmentType) {
            if (treatmentType.status === 'approvedInProgress') {
                return treatmentType.lastDate || treatmentType.authResponseDate;
            }
            return false;
        }

        function isSessionCompletedHaveValue(treatmentType) {
            return treatmentType.sessionsCompleted && Number(treatmentType.sessionsCompleted) > 0;
        }

        function isSessionCompletedIsEqualZero(treatmentType) {
            return treatmentType.sessionsCompleted && Number(treatmentType.sessionsCompleted) === 0;
        }

        function isMDEWithStatusInProgress(treatmentType) {
            return treatmentType.value === constants.TREATMENT_HISTORY_TYPE[4] && treatmentType.status === 'inProgress';
        }
    }

    angular.module('ipmApp').component('cprTreatmentHistoryTable', {
        bindings: {
            section: '<',
            treatmentTypes: '<',
            onValueChange: '&',
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/treatment-history-table/treatment-history-table.html',
        controller: CPRTreatmentHistoryTableController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    CPRCasesTableController.$inject = ['ipmConstants', '$scope', '$uibModal', 'DateUtils', 'User', '$window'];

    function CPRCasesTableController(constants, $scope, $uibModal, DateUtils, User, $window) {
        var vm = this;
        vm.dateFormat = 'MM/dd/yyyy';
        vm.caseStatuses = constants.CASE_STATUSES;
        vm.workStatuses = constants.WORK_STATUSES;
        vm.selectedCaseIndex = null;
        vm.selectedIsNotBillable = false;

        vm.caseBillToOnChange = caseBillToOnChange;
        vm.getServiceExclusionReason = getServiceExclusionReason;
        init();

        function init() {
            if (!vm.cases || _.isEmpty(vm.cases)) {
                addNewCase();
            }
            _.forEach(vm.cases, function(item) {
                item.datePickerOpenStatus = {};
                item.doi = item.doi ? DateUtils.convertDateTimeFromServer(item.doi) : null;
            });

            setSelectedBillTo();
            checkSelectedIsNotBillable();
        }

        vm.openCalendar = function(caseItem, date) {
            caseItem.datePickerOpenStatus[date] = true;
        };

        vm.clearCaseRowData = function(caseItem, index) {

            $uibModal.open({
                templateUrl: 'app/components/dialog/common-question/common-question.modal.html',
                controller: 'CommonQuestionModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    tests: function () {
                        return {
                            title: 'ipmApp.qhpWorkflow.cases.removeModal.title',
                            question: 'ipmApp.qhpWorkflow.cases.removeModal.question',
                            actionConfirm: 'entity.action.ok',
                            actionCancel: 'entity.action.cancel'
                        };
                    }
                }
            }).result.then(function() {
                deletedCase(index);
            }, function() {
            });
        };

        function deletedCase(index) {
            var caseItem = vm.cases[index];
            if (caseItem.id || caseItem.patientCaseId) { // Deleted cases have an ID, or cases have a patientCase master
                caseItem.active = false;
                vm.deletedCases.push(caseItem);
            }
            if (caseItem.billTo === true) {
                vm.selectedCaseIndex = null; // reset selectedCaseIndex when deleted
            }
            vm.cases.splice(index, 1);

            setSelectedBillTo();
        }
        function addNewCase() {
            var newCaseItem = {};
            newCaseItem.billTo = false;
            newCaseItem.caseNumber = null;
            newCaseItem.doi = null;
            newCaseItem.caseStatus = null;
            newCaseItem.workStatus = null;
            newCaseItem.ptp = null;
            newCaseItem.carrier = null;
            newCaseItem.bodyParts = null;
            newCaseItem.active = true;
            newCaseItem.datePickerOpenStatus = {};
            newCaseItem.cprId = vm.cprId;
            vm.cases.push(newCaseItem);
        }
        
        vm.addNewCase = function() {
            addNewCase();
        };

        vm.handleCaseNumberOnChange = function (caseItem, $index) {
            var formControlId = 'caseNumber_' + $index;
            if (caseItem.caseNumber && vm.evaluationForm[formControlId].$name) {
                // Check in cases current ignoring the current item
                var existingCase = _.find(vm.cases, function (c) {
                    return c.caseNumber === caseItem.caseNumber && c !== caseItem;
                });

                if (existingCase) {
                    vm.evaluationForm[formControlId].$setValidity('existsValue', false);
                    return;
                }

                User.checkUniquePatientCase(caseItem.caseNumber).then(function (response) {
                    if (response && response === true) {
                        setValidityCaseNumber(vm.evaluationForm[formControlId], true);
                    } else {
                        setValidityCaseNumber(vm.evaluationForm[formControlId], false);
                    }
                }).catch(function (error) {
                    setValidityCaseNumber(vm.evaluationForm[formControlId], false);
                });
            } else {
                setValidityCaseNumber(vm.evaluationForm[formControlId], true);
            }
        };

        function setValidityCaseNumber(formControl, value) {
            if (formControl) {
                formControl.$setValidity('existsValue', value);
            }
        }

        function setSelectedBillTo() {
            var index = vm.cases.findIndex(function (caseItem) {
                return caseItem && caseItem.billTo;
            });
            if (index >= 0) { // update selected radio by index
                vm.selectedCaseIndex = index;
            }
        }

        function caseBillToOnChange() {
            angular.forEach(vm.cases, function (caseItem, i) {
                if (vm.selectedCaseIndex !== i) {
                    caseItem.billTo = false; // update other bill to uncheck
                }
            });
            vm.cases[vm.selectedCaseIndex].billTo = true;
            checkSelectedIsNotBillable();
        }

        function checkSelectedIsNotBillable() {
            var caseSelected = getCaseSelected();
            if (caseSelected && caseSelected.cprServiceExclusion) {
                vm.selectedIsNotBillable = true;
            } else {
                vm.selectedIsNotBillable = false;
            }
        }

        function getCaseSelected() {
            if (vm.selectedCaseIndex >= 0) {
                var caseSelected = vm.cases[vm.selectedCaseIndex];
                return caseSelected;
            }
            return null;
        }

        function getServiceExclusionReason() {
            var caseSelected = getCaseSelected();
            if (caseSelected) {
                return caseSelected.cprServiceExclusionReason;
            }
        }

    }

    angular.module('ipmApp').component('cprCasesTable', {
        bindings: {
            section: '<',
            caseItems: '<',
            onValueChange: '&',
            cases: '=',
            deletedCases: '=',
            cprId: '<'
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/cases-table/cases-table.html',
        controller: CPRCasesTableController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    CPRQuestionController.$inject = ['ipmConstants'];

    function CPRQuestionController(ipmConstants) {
        var vm = this; //jshint ignore:line
        vm.isSingleChoiceQuestion = isSingleChoiceQuestion;
        vm.isCheckBoxQuestion = isCheckBoxQuestion;
        vm.isTextInputQuestion = isTextInputQuestion;
        vm.isDateQuestion = isDateQuestion;
        vm.isDisplayCheckboxQuestion = isDisplayCheckboxQuestion;
        init();

        function init() {
            // init answer
            if (vm.answers) {
                vm.valueAnswer = vm.answers.get(vm.question.code);
            }

            if (vm.question.code === 'CPR_002') {
                vm.question.text = vm.question.text + ' ' + vm.patientWorkStatus;
            }

            if (vm.question.code === 'CPR_017') {
                if (vm.surgicalCandidacyStatus) {
                    vm.question.text = 'Current status: ' + vm.surgicalCandidacyStatus + '. ' + vm.question.text;
                }
            }
        }

        vm.handleSingleChoiceQuestion = function(data) {
            if (data) {
                vm.valueAnswer = data.value;
                vm.onChange({data: data});
            }
        }

        vm.handleTextInputQuestion = function(data) {
            if (data) {
                vm.valueAnswer = data.value;
                vm.onChange({data: data});
            }
        }

        vm.handleCheckboxQuestion = function(data) {
            if (data) {
                vm.valueAnswer = data.value;
                vm.onChange({data: data});
            }
        }

        vm.handleDateQuestion = function(data) {
            if (data) {
                vm.valueAnswer = data.value;
                vm.onChange({data: data});
            }
        }

        vm.subQuestionChange = function(data) {
            vm.onChange({data: data});
        }


        vm.isDisplaySubQuestion = function(subQuestion) {

            if (subQuestion.code === 'CPR_002') {
                return vm.patientWorkStatus ? true : false
            }
            if (subQuestion.code === 'CPR_003') {
                return vm.patientWorkStatus ? false : true
            }

            if (vm.question.answerType === 'SINGLE_CHOICE') {
                return subQuestion.parentAnswer === vm.valueAnswer;
            }


            if (ipmConstants.DISPLAY_SCHEDULING_SUB_QUESTION_ACTION.includes(subQuestion.code)) {
                return vm.answers.get('CPR_041') && vm.answers.get('CPR_041').length > 0;
            }

            if (ipmConstants.DISPLAY_GATHER_SUB_QUESTION_ACTION.includes(subQuestion.code)) {
                return vm.answers.get('CPR_050') && vm.answers.get('CPR_050').length > 0;
            }

            if (ipmConstants.DISPLAY_SUB_QUESTION_ACTION.includes(subQuestion.code)) {
                return vm.valueAnswer && vm.valueAnswer.length > 0;
            }
        }

        function isSingleChoiceQuestion() {
            return vm.question && vm.question.answerType === 'SINGLE_CHOICE';
        }

        function isCheckBoxQuestion() {
            return vm.question && vm.question.answerType === 'CHECKBOX';
        }

        function isDisplayCheckboxQuestion() {
            return vm.question && (vm.question.code !== 'CPR_042' && vm.question.code !== 'CPR_051')
        }

        function isTextInputQuestion() {
            return vm.question && vm.question.answerType === 'FREE_TEXT_INPUT';
        }

        function isDateQuestion() {
            return vm.question && vm.question.answerType === 'DATE_INPUT';
        }

        vm.getCssClass = function() {
            if (vm.question.text || (vm.isCheckBoxQuestion() && vm.isDisplayCheckboxQuestion())) {
                return 'ml-4';
            }
            return '';
        }

        vm.isRequiredQuestion = function() {
            return vm.question.required;
        }

        vm.isDisplayMessageRequiredSubCheckbox = function() {
            if (ipmConstants.DISPLAY_MESSAGE_REQUIRED_SUB_CHECKBOX.includes(vm.question.code)) {
                if (ipmConstants.HAVE_ANSWERS_CHECKBOX_QUESTION_CODE.includes(vm.question.code)) {
                    return !checkHaveAnswersCheckboxQuestionByCode(vm.question.code);
                }
                if (ipmConstants.CONTAINER_CHECKBOX_CODE.includes(vm.question.code)) {
                    return !checkHaveAnswersCheckboxContainerSubActionQuestionByCode(vm.question.code);
                }
            }
            return false;
        }

        function checkHaveAnswersCheckboxQuestionByCode(code) {
            var a = vm.answers.get(code);
            if (a) {
                if (a.length > 0) {
                    return true;
                }
            }
            return false;
        }

        function checkHaveAnswersCheckboxContainerSubActionQuestionByCode(code) {
            return  _.some(ipmConstants.CONTAINER_SUB_ACTION_MAPPING[code], function (child) {
                return vm.answers.get(child) && vm.answers.get(child).length > 0;
            });
        }
    }

    angular.module('ipmApp').component('cprQuestion', {
        bindings: {
            question: '<',
            patientWorkStatus: '<', // just use for 'CPR_001' checking patient Work status in HAQ Workflow
            surgicalCandidacyStatus:  '<', // just use for 'CPR_017' display
            answers: '<',
            onChange: '&'
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/question-component/question.html',
        controller: CPRQuestionController,
        controllerAs: 'vm',
    })
})();
;
(function () {
    'use strict';

    CallLogListController.$inject = ['$scope'];

    function CallLogListController($scope) {
        var vm = this;//jshint ignore:line

        init();

        function init() {
            vm.callLogs = vm.callLogs ? vm.callLogs : [];
        }
    }

    angular.module('ipmApp').component('callLogList', {
        bindings: {
            callLogs: '<',
            onChange: '&'
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/call-log/partial/call-log-list.html',
        controller: CallLogListController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('global');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular.module('ipmApp')
        .controller('CallLogDialogController', CallLogDialogController);

    CallLogDialogController.$inject = ['$scope', '$uibModalInstance', 'ipmConstants', 'entity', 'CallLogService', 'isAdHoc', 'User'];

    function CallLogDialogController ($scope, $uibModalInstance, constants, entity, CallLogService, isAdHoc, User) {
        var vm = this;

        vm.partyTypes = constants.PARTY_TYPES;
        vm.patientId = entity.patientId;
        vm.callLogs = [];
        vm.callLog = entity;
        vm.datePickerOpenStatus = {};
        vm.close = close;
        vm.save = save;
        vm.isSaving = false;
        vm.page = 1;
        vm.predicate = 'dateLog';
        vm.reverse = true;
        vm.qhpUserAdHocId = null;

        init();

        function init() {
            if (isAdHoc) {
                User.getUserByCurrentLogin().then(function (response) {
                    vm.qhpUserAdHocId = response ? response.id : null;
                    updateCallLog();
                });
            }
            loadAllCallLogs();
        }

        function updateCallLog() {
            vm.callLog.qhpUserAdHocId = vm.qhpUserAdHocId;
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };


        function createInitCallLog() {
            vm.callLog = {
                id: null,
                patientId: entity.patientId,
                qhpUserId: entity.qhpUserId,
                qhpUserAdHocId: vm.qhpUserAdHocId,
                dateLog: Date.now(),
                party: null,
                summary: null,
                carePlanReviewId: entity.carePlanReviewId
            };
        }

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.callLog) {
                if (vm.callLog.party !== 'OTHER') {
                    vm.callLog.selectedProvide = '';
                }
                if (!vm.callLog.id) {
                    CallLogService.create(vm.callLog, onSaveSuccess, onSaveError);
                } else {
                    CallLogService.update(vm.callLog, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            // reset object callLog
            resetForm();
            // reload list callLogs
            loadAllCallLogs();
        }

        function resetForm() {
            createInitCallLog();
            if ($scope.editForm !== null && $scope.editForm !== undefined) {
                $scope.editForm.$setPristine();
                $scope.editForm.$setUntouched();
            }
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
                $uibModalInstance.close(error);
            }
        }

        function loadAllCallLogs() {
            if (vm.patientId) {
                var pageable = {
                    page: vm.page > 0 ? vm.page - 1 : vm.page,
                    size: constants.PAGE_SIZE_MAX,
                    sort: sort()
                };
                CallLogService.findAllByPatientId(vm.patientId, pageable).then(function (response) {
                    vm.callLogs = response ? response.data : [];
                });
            }
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeWorkersCompensationComponent', psychIntakeWorkersCompensationComponent);

    psychIntakeWorkersCompensationComponent.$inject = [];

    function psychIntakeWorkersCompensationComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeWorkersCompensationController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/workers-compensation.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeWorkersCompensationController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeWorkersCompensationController($scope, $stateParams, $element) {
        var vm = this;
        
        vm.datePickerOpenStatus = {
            dateOfInjury: false,
            lastDayWorked: false
        };

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeWellnessStatusComponent', psychIntakeWellnessStatusComponent);

    psychIntakeWellnessStatusComponent.$inject = [];

    function psychIntakeWellnessStatusComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeWellnessStatusController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/wellness-status.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeWellnessStatusController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeWellnessStatusController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();

        vm.disabledCheck = function(item) {
            if ($scope.vm.workflow.answer && $scope.vm.workflow.answer.stressorsSelected) {
                var selected = $scope.vm.workflow.answer.stressorsSelected;
	            if (item === 'NONE') {
	                var symptoms = ['RELATIONSHIP_PROBLEMS', 'FINANCIAL_PROBLEMS', 'HOUSING_PROBLEMS', 'DEATH_OF_LOVED_ONE', 'SERIOUS_FAMILY_ILLNESS', 'JOB_ISSUES'];
	                return symptoms.some(function(symptom) {
	                    return selected[symptom];
	                });
	            } else {
	                return selected['NONE'];
	            }
            } else {
            	return false;
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeSocialHistoryComponent', psychIntakeSocialHistoryComponent);

    psychIntakeSocialHistoryComponent.$inject = [];

    function psychIntakeSocialHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeSocialHistoryController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/social-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeSocialHistoryController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeSocialHistoryController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakePreviousTreatmentComponent', psychIntakePreviousTreatmentComponent);

    psychIntakePreviousTreatmentComponent.$inject = [];

    function psychIntakePreviousTreatmentComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakePreviousTreatmentController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/previous-treatment.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakePreviousTreatmentController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakePreviousTreatmentController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();

        vm.disabledCheck = function(item) {
            if ($scope.vm.workflow.answer && $scope.vm.workflow.answer.followingTreatmentSelected) {
                var selected = $scope.vm.workflow.answer.followingTreatmentSelected;
	            if (item === 'NONE') {
	                var symptoms = ['PHYSICAL_THERAPY', 'AQUATIC_THERAPY', 'CHIROPRACTIC', 'ACUPUNCTURE', 'TENS_HWAVE', 'INJECTIONS', 'GROUP_PSYCHOTHERAPY',
		                'INDIVIDUAL_PSYCHOTHERAPY', 'FAMILY_THERAPY', 'MEDICATION_PSYCHIATRY', 'INPATIENT_CARE', 'SCS_EVALUATION_TRIAL', 'OTHER'];
	                return symptoms.some(function(symptom) {
	                    return selected[symptom];
	                });
	            } else {
	                return selected['NONE'];
	            }
            } else {
            	return false;
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakePersonalInjuryComponent', psychIntakePersonalInjuryComponent);

    psychIntakePersonalInjuryComponent.$inject = [];

    function psychIntakePersonalInjuryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakePersonalInjuryController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/personal-injury.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakePersonalInjuryController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakePersonalInjuryController($scope, $stateParams, $element) {
        var vm = this;
        
        vm.datePickerOpenStatus = {
            datePersonalInjury: false
        };

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeMedicationsComponent', psychIntakeMedicationsComponent);

    psychIntakeMedicationsComponent.$inject = [];

    function psychIntakeMedicationsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeMedicationsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/medications.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeMedicationsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeMedicationsController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeMedicalHistoryComponent', psychIntakeMedicalHistoryComponent);

    psychIntakeMedicalHistoryComponent.$inject = [];

    function psychIntakeMedicalHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeMedicalHistoryController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/medical-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeMedicalHistoryController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeMedicalHistoryController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeHabitsComponent', psychIntakeHabitsComponent);

    psychIntakeHabitsComponent.$inject = [];

    function psychIntakeHabitsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeHabitsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/habits.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeHabitsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeHabitsController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeDiagnosticStudiesComponent', psychIntakeDiagnosticStudiesComponent);

    psychIntakeDiagnosticStudiesComponent.$inject = [];

    function psychIntakeDiagnosticStudiesComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeDiagnosticStudiesController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/diagnostic-studies.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeDiagnosticStudiesController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeDiagnosticStudiesController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        vm.hadAnyDiagnosticStudiesResponse = function() {
            var find = _.find(vm.workflow.answer.diagnostics, function(d) {
		        return d.checked && d.diagnosticStudy && d.diagnosticStudy.code !== "NONE";
		    });
            return find;
        };

        init();

        vm.disabledCheck = function(item) {
			var diagnostics = $scope.vm.workflow.answer && $scope.vm.workflow.answer.diagnostics;
		    if (!diagnostics || !Array.isArray(diagnostics)) {
		        return false;
		    }

		    var selectedCodes = diagnostics
		        .filter(function(d) {
		            return d.checked;
		        })
		        .map(function(d) {
		            return d.diagnosticStudy.code;
		        });
		    if (selectedCodes.length === 0) {
				return false;
			}
			if (selectedCodes.indexOf("NONE") !== -1) {
		        return item.diagnosticStudy.code !== "NONE";
		    }

            var hasOther = ["XRAY", "MRI", "CT", "EMG_NCV"].some(function(c) {
		        return selectedCodes.indexOf(c) !== -1;
		    });
		    if (hasOther) {
		        return item.diagnosticStudy.code === "NONE";
		    }
		
		    return false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeDemographicsComponent', psychIntakeDemographicsComponent);

    psychIntakeDemographicsComponent.$inject = [];

    function psychIntakeDemographicsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeDemographicsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/demographics.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeDemographicsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeDemographicsController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeChiefComplaintComponent', psychIntakeChiefComplaintComponent);

    psychIntakeChiefComplaintComponent.$inject = [];

    function psychIntakeChiefComplaintComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeChiefComplaintController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/chief-complaint.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeChiefComplaintController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeChiefComplaintController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();
        
        vm.disabledCheck = function(item) {
            if ($scope.vm.workflow.answer && $scope.vm.workflow.answer.currentSymptomsSelected) {
                var selected = $scope.vm.workflow.answer.currentSymptomsSelected;
                if (item === 'NONE') {
		        	var symptoms = ['ANXIETY', 'DEPRESSION', 'SLEEP_PROBLEMS', 'IRRITABILITY_ANGER', 'PANIC_ATTACKS', 'NIGHTMARES_FLASHBACKS', 'OTHER'];
			        return symptoms.some(function(symptom) {
			            return selected[symptom];
			        });
		        } else {
		        	return selected['NONE'];
		        }
            } else {
            	return false;
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementTelehealthInformedConsentComponent', agreementTelehealthInformedConsentComponent);

    agreementTelehealthInformedConsentComponent.$inject = [];

    function agreementTelehealthInformedConsentComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementTelehealthInformedConsentController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-telehealth-informed-consent.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementTelehealthInformedConsentController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementTelehealthInformedConsentController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPsychotherapySessionsComponent', agreementPsychotherapySessionsComponent);

    agreementPsychotherapySessionsComponent.$inject = [];

    function agreementPsychotherapySessionsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPsychotherapySessionsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-psychotherapy-sessions.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPsychotherapySessionsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPsychotherapySessionsController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPrivacyPracticeComponent', agreementPrivacyPracticeComponent);

    agreementPrivacyPracticeComponent.$inject = [];

    function agreementPrivacyPracticeComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPrivacyPracticeController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-privacy-practice.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPrivacyPracticeController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPrivacyPracticeController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPoliciesProceduresComponent', agreementPoliciesProceduresComponent);

    agreementPoliciesProceduresComponent.$inject = [];

    function agreementPoliciesProceduresComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPoliciesProceduresController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-policies-procedures.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPoliciesProceduresController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPoliciesProceduresController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPcsgInformationPoliciesComponent', agreementPcsgInformationPoliciesComponent);

    agreementPcsgInformationPoliciesComponent.$inject = [];

    function agreementPcsgInformationPoliciesComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPcsgInformationPoliciesController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-pcsg-information-policies.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPcsgInformationPoliciesController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPcsgInformationPoliciesController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPatientAcknowledgementComponent', agreementPatientAcknowledgementComponent);

    agreementPatientAcknowledgementComponent.$inject = [];

    function agreementPatientAcknowledgementComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPatientAcknowledgementController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-patient-acknowledgement.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPatientAcknowledgementController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPatientAcknowledgementController($scope, $stateParams, $element) {
        var vm = this;
        vm.onChangeSignature = onChangeSignature;

        function init() {
        	if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
        
        function onChangeSignature(data) {
            vm.workflow.answer.agreement.patientSignature = data;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('workRelatedInjuriesComponent', workRelatedInjuriesComponent);

    workRelatedInjuriesComponent.$inject = [];

    function workRelatedInjuriesComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveWorkRelatedInjuriesController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/work-related-injuries.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveWorkRelatedInjuriesController.$inject = ['$scope', '$stateParams', '$element', '$timeout', 'ipmConstants'];
    function DirectiveWorkRelatedInjuriesController($scope, $stateParams, $element, $timeout, constants) {
        var vm = this;
        
        vm.datePickerOpenStatus = {
            dateOfInjury: false,
            lastDayWorked: false
        };
        
        vm.datePickerOptions = {
            maxDate: new Date()
        };
        
        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('treatmentHistoryComponent', treatmentHistoryComponent);

    treatmentHistoryComponent.$inject = [];

    function treatmentHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveTreatmentHistoryController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/treatment-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveTreatmentHistoryController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveTreatmentHistoryController($scope, $stateParams, $element, $timeout) {
        
        function init() {
            
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('socialHistoryComponent', socialHistoryComponent);

    socialHistoryComponent.$inject = [];

    function socialHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveSocialHistoryComponentController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/social-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveSocialHistoryComponentController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveSocialHistoryComponentController($scope, $stateParams, $element, $timeout) {
        
        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('reviewOfSystemsComponent', reviewOfSystemsComponent);

    reviewOfSystemsComponent.$inject = [];

    function reviewOfSystemsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '=',
                symptomGroups: '='
            },
            link: linkFunc,
            controller: DirectiveReviewOfSystemsController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/review-of-systems.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveReviewOfSystemsController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveReviewOfSystemsController($scope, $stateParams, $element, $timeout) {
        var vm = this;
        
        function init() {
            for (var i = 0; i < vm.symptomGroups.length; i++) {
                var group = vm.symptomGroups[i];
                var symptomNoneNormal = group.symptomsSorted[0];
                var disabled = vm.workflow.answer.symptomIdsSelected[symptomNoneNormal.id] || false;
                for(var j = 1; j < group.symptomsSorted.length; j ++) {
                    var symptom = group.symptomsSorted[j];
                    symptom.disabled = disabled;
                    if(disabled && symptom.id) {
                        vm.workflow.answer.symptomIdsSelected[symptom.id] = false;
                    }
                }
            }
        }

        vm.symptomChanged = function(group) {
            var symptomNoneNormal = group.symptomsSorted[0];
            var disabled = vm.workflow.answer.symptomIdsSelected[symptomNoneNormal.id] || false;
            for(var j = 1; j < group.symptomsSorted.length; j ++) {
                var symptom = group.symptomsSorted[j];
                symptom.disabled = disabled;
                if (disabled && symptom.id) {
                    vm.workflow.answer.symptomIdsSelected[symptom.id] = false;
                }
            }
        };
        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('presentComplaintsComponent', presentComplaintsComponent);

    presentComplaintsComponent.$inject = [];

    function presentComplaintsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            require:"^form", //inject parent form as the forth parameter to the link functio
            link: linkFunc,
            controller: DirectivePresentComplaintsController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/present-complaints.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs, form) {
            scope.form = form;
        }
    }

    DirectivePresentComplaintsController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectivePresentComplaintsController($scope, $stateParams, $element, $timeout) {
        var vm = this;
        
        vm.frontBody = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 
            'F11', 'F12', 'F13', 'F14', 'F15', 'F16', 'F17', 'F18', 'F19', 'F20', 'F21', 'F22', 'F23', 'F24', 
            'F25', 'F26', 'F27', 'F28', 'F29', 'F30', 'F31', 
            'F32', 'F33', 'F34', 'F35', 'F36', 'F37', 'F38','F39'];

        vm.backBody = ['B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 
            'B11', 'B12', 'B13', 'B14', 'B15', 'B16', 'B17', 'B18', 'B19', 'B20', 'B21', 'B22', 'B23', 'B24', 
            'B25', 'B26', 'B27', 'B28', 'B29', 'B30', 'B31', 
            'B32', 'B33', 'B34', 'B35', 'B36', 'B37', 'B38', 'B39'];

        function init() {
            
        }

        vm.optionsResponseRequired = function(pro1, pro2) {
            var find = _.find(_.values(vm.workflow.answer[pro1]), function(checked) {
                return checked;
            });

            if(!find && pro2) {
                find = _.find(_.values(vm.workflow.answer[pro2]), function(checked) {
                    return checked;
                });
            }
            return !find;
        };

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('personalInjuryComponent', personalInjuryComponent);

        personalInjuryComponent.$inject = [];

    function personalInjuryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePersonalInjuryController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/personal-injury.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePersonalInjuryController.$inject = ['$scope', '$stateParams', '$element', '$timeout', 'ipmConstants'];
    function DirectivePersonalInjuryController($scope, $stateParams, $element, $timeout, constants) {
        var vm = this;
        
        vm.datePickerOpenStatus = {
            dateOfAccident: false,
            medicalSoughtDate: false,
        };
        
        vm.datePickerOptions = {
            maxDate: new Date()
        };
        
        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('pastMedicalHistoryComponent', pastMedicalHistoryComponent);

    pastMedicalHistoryComponent.$inject = [];

    function pastMedicalHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '=',
                pastMedicalHistoryGroups: '='
            },
            link: linkFunc,
            controller: DirectivePastMedicalHistoryController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/past-medical-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePastMedicalHistoryController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectivePastMedicalHistoryController($scope, $stateParams, $element, $timeout) {
        
        function init() {
            
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('medicationsComponent', medicationsComponent);

    medicationsComponent.$inject = [];

    function medicationsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '=',
                medicationGroups: '='                
            },
            link: linkFunc,
            controller: DirectiveMedicationsController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/medications.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveMedicationsController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveMedicationsController($scope, $stateParams, $element, $timeout) {
        var vm = this;
        
        function init() {
            if(vm.workflow.answer.haveEverStoppedMedications == 'YES') {
                if(vm.workflow.answer.medicationStoppedsResponse.length == 0) {
                    vm.workflow.answer.medicationStoppedsResponse.push({
                        "id":null, 
                        "discontinuedMedications":"",
                        "sideEffectReasonStopping":""
                    })
                }
            }
        };

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        vm.removeMedicationStopped = function(index) {
            vm.workflow.answer.medicationStoppedsResponse.splice(index, 1);
        };

        vm.addMedicationStopped = function() {
            vm.workflow.answer.medicationStoppedsResponse.push({
                "id":null, 
                "discontinuedMedications":"",
                "sideEffectReasonStopping":""
            });
        };

        vm.haveEverStoppedMedicationsChanged = function() {
            if(vm.workflow.answer.haveEverStoppedMedications === 'YES') {
                if(vm.workflow.answer.medicationStoppedsResponse.length === 0) {
                    vm.workflow.answer.medicationStoppedsResponse.push({
                        "id":null, 
                        "discontinuedMedications":"",
                        "sideEffectReasonStopping":""
                    });
                }
            }
        };
        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('injuryDetailsComponent', injuryDetailsComponent);

    injuryDetailsComponent.$inject = [];

    function injuryDetailsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveInjuryDetailsController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/injury-details.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveInjuryDetailsController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveInjuryDetailsController($scope, $stateParams, $element, $timeout) {
        var vm = this;
        
        vm.datePickerOpenStatus = {
            theApproximateDateOfTheInjury: false
        };

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        function init() {
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('diagnosticStudiesComponent', diagnosticStudiesComponent);

    diagnosticStudiesComponent.$inject = [];

    function diagnosticStudiesComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveDiagnosticStudiesController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/diagnostic-studies.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveDiagnosticStudiesController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveDiagnosticStudiesController($scope, $stateParams, $element, $timeout) {
        var vm = this;
        
        function init() {
        }

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        vm.hadAnyDiagnosticStudiesResponse = function() {
            var find = _.find(vm.workflow.answer.diagnostics, { 'checked': true });
            return find;
        };

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('demographicsComponent', demographicsComponent);

    demographicsComponent.$inject = [];

    function demographicsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveDemographicsController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/demographics.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveDemographicsController.$inject = ['$scope', '$stateParams', '$element', '$timeout', 'REGEX_PATTERN', 'ipmConstants'];
    function DirectiveDemographicsController($scope, $stateParams, $element, $timeout, REGEX_PATTERN, constants) {
        var vm = this;
        
        var answerClone = _.cloneDeep(vm.workflow.answer);
        vm.REGEX_PATTERN = REGEX_PATTERN;

        function init() {
        }

        vm.requirePhoneNumbers = function() {
            return !vm.workflow.answer.homeTelephone && !vm.workflow.answer.cellNumber;
        };

        vm.getAge = function () {
            var dateOfBirth = Date.parse(vm.workflow.answer.dateOfBirth);
            var birthDay = new Date(dateOfBirth).getUTCDate();
            var birthMonth = new Date(dateOfBirth).getUTCMonth();
            var birthYear = new Date(dateOfBirth).getUTCFullYear();
            var todayDate = new Date();
            var todayYear = todayDate.getFullYear();
            var todayMonth = todayDate.getMonth();
            var todayDay = todayDate.getDate();
            var age = todayYear - birthYear;
    
            if (todayMonth < birthMonth - 1) {
                age--;
            }
    
            if (birthMonth - 1 === todayMonth && todayDay < birthDay.date) {
                age--;
            }
    
            return age;
        };

        vm.doNotHaveSSNChanged = function() {
            if(vm.workflow.answer.doNotHaveSSN) {
                vm.workflow.answer.socialSecurityNumberEncrypted = '';
            } else {
                vm.workflow.answer.socialSecurityNumberEncrypted = answerClone.socialSecurityNumber;
            }
        };
        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('currentIndicationsComponent', currentIndicationsComponent);

    currentIndicationsComponent.$inject = [];

    function currentIndicationsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            require:"^form", //inject parent form as the forth parameter to the link functio
            link: linkFunc,
            controller: DirectiveCurrentIndicationsController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/current-indications.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs, form) {
            scope.form = form;            
        }
    }

    DirectiveCurrentIndicationsController.$inject = ['$scope', '$element', '$timeout'];
    function DirectiveCurrentIndicationsController($scope, $element, $timeout) {
        var vm = this;

        function init() {            
        }

        vm.numbnessTinglingResponseRequired = function() {
            var find = _.find(vm.workflow.answer.numbnessTinglingResponse, { 'checked': true });
            return vm.workflow.answer.haveAnyNumbnessOrTingling === 'YES' && !find;
        };

        vm.weaknessResponseRequired = function() {
            var find = _.find(vm.workflow.answer.weaknessResponse, { 'checked': true });
            return vm.workflow.answer.haveAnyWeakness === 'YES' && !find;
        };
        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('allergiesComponent', allergiesComponent);

    allergiesComponent.$inject = [];

    function allergiesComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAllergiesController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/allergies.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAllergiesController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveAllergiesController($scope, $stateParams, $element, $timeout) {
        var vm = this;
        
        function init() {
            
        }

        vm.optionsResponseRequired = function(pro) {
            var find = _.find(_.values(vm.workflow.answer[pro]), function(checked) {
                return checked;
            });
            return vm.workflow.answer.allergicToAnyMedications === 'YES' && !find;
        };

        init();
    }
})();
;
(function() {
    'use strict';

    ProgressTrackerItemController.$inject = ['ipmConstants'];

    function ProgressTrackerItemController(constants) {
        var vm = this; //jshint ignore:line
        vm.constants = constants;

        init();

        function init() {
        }

        vm.getClass = function() {
            if (vm.item.status === 'INPROGRESS') {
                return 'inProgress';
            }

            if (vm.item.status === 'COMPLETE') {
                return 'completed';
            }
        }

        vm.getIcon = function() {
            if (vm.item.status === 'NOT_STARTED') {
                return 'glyphicon-option-horizontal';
            }

            if (vm.item.status === 'INPROGRESS') {
                return 'glyphicon-repeat';
            }

            if (vm.item.status === 'COMPLETE') {
                return 'glyphicon-ok';
            }
        }

        
    }

    angular.module('ipmApp').component('progressTrackerItem', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/frp-mde/tab/mde/component/progress-tracker-item.html',
        controller: ProgressTrackerItemController,
        controllerAs: 'vm'
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('EnrollPatientDialogController', EnrollPatientDialogController);

    EnrollPatientDialogController.$inject = ['$uibModalInstance', 'frpProgramId', 'frpMdeService', '$q', 'frpStartDate'];

    function EnrollPatientDialogController($uibModalInstance, frpProgramId, frpMdeService, $q, frpStartDate) {
        var vm = this;
        vm.searchResultEle = null;
        vm.modalLoaded = modalLoaded;
        vm.frpProgramId = frpProgramId ? frpProgramId : null;
        vm.frpStartDate = frpStartDate ? frpStartDate : null;
        vm.clear = clear;
        vm.enrollPatient = enrollPatient;
        vm.patientSearchSelect = '';
        vm.searchPatient = searchPatient;
        vm.predicate ='pfm.id';

        init();

        function init() {
        }

        function modalLoaded() {
            vm.searchResultEle = angular.element("#searchEnrollPatientAutoComplete");
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function enrollPatient() {
            vm.isSaving = true;
            if (vm.patientSearchSelect && vm.patientSearchSelect.id) {
                frpMdeService.enrollPatientById(vm.patientSearchSelect.id, vm.frpStartDate).then(function(res) {
                    onSaveSuccess(res);
                }).catch(function (error) {
                    onSaveError(error);
                });
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            $uibModalInstance.close(error);
        }

        function searchPatient($item) {
            var inputData = $item ? $item : '';
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };
            var param = {
                patientId: null,
                frpProgramIds: vm.frpProgramId,
                startDate: null,
                query: inputData
            };
            return $q(function (resolve, reject) {
                frpMdeService.searchEnrollPatient(param, pageable).then(function (response) {
                    if (response.data && response.data.length) {
                        resolve(filterAutoCompletedPatientList(response.data));
                    }
                    resolve([]);
                },function () {
                    reject([]);
                });
            })
        }

        function filterAutoCompletedPatientList(data){
            var patients = _.compact(_.map(data, function(obj) {
                if (obj.patient){
                    return {
                        id: obj.id,
                        name: obj.patient.firstName + ' ' + obj.patient.lastName + " (" + obj.patient.patientId + ")"
                    }
                }
                return null;
            }));
            return patients;
        }

        function sort() {
            var  result = [vm.predicate + ',desc'];
            return result;
        }

        vm.selectPatientData = function($item) {
        }

        vm.checkDisabledEnroll = function () {
            if (vm.patientSearchSelect && vm.patientSearchSelect.id) {
                return false;
            }
            return true;
        }

    }
})();
;
(function() {
    'use strict';

    SubjectiveRowController.$inject = ['ipmConstants'];

    function SubjectiveRowController(ipmConstants) {
        var vm = this; //jshint ignore:line
        vm.severity = ipmConstants.SEVERITY;
        init();

        function init() {
        }

        vm.checkboxChange = function() {
            // clear value;
            vm.item.score = null;
            vm.item.severity = null;
            vm.item.notes = null;
            vm.onChange();
        }
    }

    angular.module('ipmApp').component('subjectiveRow', {
        bindings: {
            item: '<',
            isDisabled: '<',
            onChange: '&'
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/subjective-row.html',
        controller: SubjectiveRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    selectAllCheckboxController.$inject = [];

    function selectAllCheckboxController() {
        var vm = this; //jshint ignore:line
        init();

        function init() {

        }

        vm.onClick = function() {
           vm.item[vm.reportType].forEach(function (child) {
               child.checked = vm.item[vm.reportType + 'Checked'];
               if(!child.checked) {
                   clearValue(child);
               }
           })
        }

        function clearValue(child) {
            // clear value
            child.score = null;
            child.severity = null;
            child.mdeReport = null;
        }
    }

    angular.module('ipmApp').component('selectAllCheckbox', {
        bindings: {
            item: '<',
            isDisabled: '<',
            reportType:'<'
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/select-all-checkbox.html',
        controller: selectAllCheckboxController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    PhysicalDemandLevelRowController.$inject = ['MdeReportService'];

    function PhysicalDemandLevelRowController(MdeReportService) {
        var vm = this; //jshint ignore:line

        init();

        function init() {
            MdeReportService.getPhysicalDemandLevels().then(function(data) {
                vm.dropdownValues = data;
            });
        }
    }

    angular.module('ipmApp').component('physicalDemandLevelRow', {
        bindings: {
            item: '<',
            isDisabled: '<',
            onChange: '&'
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/physical-demand-level-row.html',
        controller: PhysicalDemandLevelRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    OtherObjectiveRowController.$inject = [];

    function OtherObjectiveRowController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
        }

        vm.change = function() {
            if (!vm.item.checked) {
                // clear valua
                vm.item.value = null;
                vm.item.leftValue = null;
                vm.item.rightValue = null;
            }
            vm.onChange();
        }

        vm.removeOtherObjective = function() {
            if (vm.isDisabled) return;
            vm.item.active = false;
            vm.onDelete({data: vm.item});
            vm.onChange();
        }
    }

    angular.module('ipmApp').component('otherObjectiveRow', {
        bindings: {
            item: '<',
            isDisabled: '<',
            onChange: '&',
            onDelete: '&'
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/other-objective-row.html',
        controller: OtherObjectiveRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    ObjectiveSelectAllController.$inject = [];

    function ObjectiveSelectAllController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {

        }

        vm.onClick = function() {
            vm.item.childs.forEach(function (child) {
                child.checked = vm.item.checked;
                if(child.checked) {
                    clearValue(child);
                }
            })

            vm.others.forEach(function (other){
                if(other.typeReportId === vm.item.typeReportId) {
                    other.checked = vm.item.checked;
                }
            })
        }

        function clearValue(child) {
            // clear value
            child.value = null;
            child.leftValue = null;
            child.rightValue = null;
        }
    }

    angular.module('ipmApp').component('objectiveSelectAll', {
        bindings: {
            item: '<',
            others: '<',
            isDisabled: '<',
            onChange: '&'
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/objective-select-all.html',
        controller: ObjectiveSelectAllController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    ObjectiveRowController.$inject = [];

    function ObjectiveRowController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
            vm.isAverage = vm.item.code === 'O40';
        }

        vm.change = function() {
            if(vm.isAverage){
                return;
            }
            if (!vm.item.checked) {
                // clear valua
                vm.item.value = null;
                vm.item.leftValue = null;
                vm.item.rightValue = null;
            }
            vm.onChange();
        }

        vm.changeLR = function() {
            vm.onChange();
        }

        vm.updateSelectAll = function(){
            vm.onClick();
        }
    }

    angular.module('ipmApp').component('objectiveRow', {
        bindings: {
            item: '<',
            isDisabled: '<',
            onChange: '&',
            onClick: '&'
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/objective-row.html',
        controller: ObjectiveRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    GoalRowController.$inject = [];

    function GoalRowController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
            vm.dropdownValues = ['Sedentary', 'Light', 'Medium', 'Heavy', 'Very Heavy'];
        }

        vm.checkboxChange = function() {
            vm.item.inputValue = null;
            vm.item.selectedValue = null;
        }

        vm.addNewGoal = function() {
            if (vm.isDisabled) return;
            vm.onClickAddNewGoal();
        }
    }

    angular.module('ipmApp').component('goalRow', {
        bindings: {
            item: '<',
            isDisabled: '<',
            onChange: '&',
            onClickAddNewGoal: '&',
            showAddGoal: '<',
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/goal-row.html',
        styleUrls: 'app/frp-mde/mde-report/pt/components/goal-row.scss',
        controller: GoalRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    GoalAddNewRowController.$inject = [];

    function GoalAddNewRowController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
        }

        vm.checkboxChange = function() {
            vm.item.midSessionChecked = null;
            vm.item.dischargeChecked = null;
            vm.item.midSessionInputValue = null;
            vm.item.dischargeInputValue = null;
            vm.item.midSessionSelectedValue = null;
            vm.item.dischargeSelectedValue = null;
        }

        vm.removeGoalAddNew = function() {
            if (vm.isDisabled) return;
            vm.item.active = false;
            vm.onDelete({data: vm.item});
        }

        vm.addNewGoal = function() {
            if (vm.isDisabled) return;
            vm.onClickAddNewGoal();
        }
    }

    angular.module('ipmApp').component('goalAddNewRow', {
        bindings: {
            item: '<',
            isDisabled: '<',
            onChange: '&',
            onDelete: '&',
            lastItem: '<',
            onClickAddNewGoal: '&'
        },
        templateUrl: 'app/frp-mde/mde-report/pt/components/goal-add-new-row.html',
        controller: GoalAddNewRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    CheckboxRowController.$inject = [];

    function CheckboxRowController() {
        var vm = this; //jshint ignore:line
        vm.specialTextField = 'LEFT_RIGHT_TEXT_FIELD';
        vm.isDisableClassification = true;

        init();

        function init() {
            if (vm.item) {
                vm.item.convertItemCode = vm.item.code.replace("-", "_");
            }
        }

        vm.checkboxChange = function() {
            // clear value;
            vm.item.score = null;
            vm.item.scoreLeft = null;
            vm.item.scoreRight = null;
            vm.item.severity = null;
            vm.item.notes = null;
            vm.onChange();
        }

        vm.getIdScore = function (srCode) {
            return 'score_' + srCode;
        }

        vm.getIdScoreRight = function (srCode) {
            return 'scoreRight_' + srCode;
        }

        vm.getIdScoreLeft = function (srCode) {
            return 'scoreLeft_' + srCode;
        }
    }

    angular.module('ipmApp').component('checkboxRow', {
        bindings: {
            item: '<',
            typeRow: '<',
            isDisabled: '<',
            severity: '<',
            onChange: '&'
        },
        templateUrl: 'app/frp-mde/mde-report/psych/components/checkbox-row.html',
        controller: CheckboxRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    PsychSubjectiveTestingController.$inject = ['ipmConstants', '$uibModal', 'DateUtils', '$scope'];

    function PsychSubjectiveTestingController(constants, $uibModal, DateUtils, $scope) {
        var vm = this; //jshint ignore:line
        vm.addMidsessionClick = addMidsessionClick;
        vm.colLimit = 1000;
        vm.dateFormat = 'MM/dd/yyyy';
        vm.colMidsessionsSubjective = [];
        vm.colSubjectiveDateChange = colSubjectiveDateChange;
        vm.updateSelectAllCheckboxSubjective = updateSelectAllCheckboxSubjective;
        vm.isMidSessionReport = false;
        vm.isOtherReport = false;
        vm.isWeeklyReport = false;
        vm.deletingMidsessionColumnMessage = 'ipmApp.frpReport.pt.deletingMidsessionColumn';

        init();

        function init() {
            if (vm.subjectiveResponses) {
                // set the first subjectiveResponses colMidsessions
                setColMidsessionSubjective(vm.subjectiveResponses[0].midsessions);

            }
            vm.isMidSessionReport = vm.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT;
            vm.isOtherReport = vm.reportType === constants.FRP_REPORT_TYPE.OTHER_REPORT;
            vm.isWeeklyReport = vm.reportType === constants.FRP_REPORT_TYPE.WEEKLY_REPORT;
            vm.isDischargeReport = vm.reportType === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT;
            vm.isFirstReport = vm.reportType === constants.FRP_REPORT_TYPE.FIRST_REPORT;
            updateSelectAllCheckboxSubjective();
        }

        function setColMidsessionSubjective(midsessions) {
            if (midsessions) {
                _.forEach(midsessions, function (o) {
                    o.dated = DateUtils.convertDateTimeFromServer(o.dated);
                });
            }
            vm.colMidsessionsSubjective = midsessions;
        }

        function addNewMidsession(orderNumber, subjectiveResponseId) {
            return {id: null,
                frpReportPsychSubjectiveResponseId: subjectiveResponseId,
                dated: new Date(),
                testScore: "",
                testScoreRight: "",
                testScoreLeft: "",
                orderNumber: orderNumber,
                active: true,
                $isOpenCalendar: false};
        }

        function addMidsessionClick() {
            if (vm.subjectiveResponses && vm.colMidsessionsSubjective.length < vm.colLimit) {
                var orderNumber = _.isEmpty(vm.colMidsessionsSubjective) ? 0 : vm.colMidsessionsSubjective.length + 1;
                vm.subjectiveResponses.forEach(function (item) {
                        var midsession = addNewMidsession(orderNumber, item.id);
                        item.midsessions.push(midsession);
                });
                setColMidsessionSubjective(vm.subjectiveResponses[0].midsessions);
                emitOnchangeMidsessions(vm.subjectiveResponses);
            }
        }

        function emitOnchangeMidsessions(subjectiveResponses) {
            vm.onChangeMidsessions({subjectiveResponses: subjectiveResponses});
        }

        function colSubjectiveDateChange(colSub) {
            updateSubjectiveResponses(colSub);
        }

        function updateSubjectiveResponses(colSub) {
            // comment out because effect to isChanged(), updated on prepareMidssessionDated before submit data
            // vm.subjectiveResponses.forEach(function (item) {
            //     if (item.midsessions.length > 0) {
            //         item.midsessions.forEach(function (itemMidsessions) {
            //             if (itemMidsessions && colSub && itemMidsessions.orderNumber === colSub.orderNumber) {
            //                 itemMidsessions.dated = colSub.dated;
            //             }
            //         });
            //     }
            // });
        }

        vm.openCalendar = function (colSub) {
            colSub.$isOpenCalendar = !colSub.$isOpenCalendar;
        };

        vm.checkDisableMidsessions = function (rowMidIndex, midsessions) {
            // If there is more than 1 Midsession column then the most recent one should be editable
            if (midsessions && midsessions.length > 0) {
                if (midsessions.length === 1) {
                    return false;
                } else {
                    if (midsessions.length <= 1 || rowMidIndex !== midsessions.length - 1) {
                        return true;
                    }
                }
            }
        }

        vm.removeColMidsessions = function (colSub, $index) {
            vm.confirmDialogRemoveMidsessions(vm.deletingMidsessionColumnMessage, colSub, $index);
        }

        vm.removeColMidsessionsCallBack = function (colSub, $index) {
            if (vm.subjectiveResponses) {
                vm.subjectiveResponses.forEach(function (item) {
                    if (item && item.midsessions) {
                        if (item.midsessions[$index] && item.midsessions[$index].id) {
                            addToMidsessionsRemoved(item.midsessions[$index]);
                        }
                        item.midsessions.splice($index, 1);
                        // update orderNumber for midsessions
                        updateOrderNumberMidsession(item.midsessions);
                    }
                });
            }
        };

        function updateOrderNumberMidsession(midsessions) {
            if (midsessions) {
                midsessions.forEach(function (ms, index) {
                    ms.orderNumber = index;
                });
            }
        }

        function addToMidsessionsRemoved(midsessions) {
            if (midsessions) {
                midsessions.active = false;
                vm.midsessionsRemovedList.push(midsessions);
            }
        }

        vm.checkDisableColMidsessions = function ($index) {
            return vm.disableFields.testingColMidsession || vm.checkDisableMidsessions($index, vm.colMidsessionsSubjective)
                    || vm.disableFields.testingColMidsessionLeft || vm.disableFields.testingColMidsessionRight;
        };

        vm.checkRequiredDateMidsession = function ($index) {
            if (vm.checkDisableColMidsessions($index)) {
                return false;
            }
            var hasDataMidsession = _.some(vm.subjectiveResponses, function (item) {
                return item.midsessions && item.midsessions[$index] &&
                    (item.midsessions[$index].testScore || item.midsessions[$index].testScoreLeft || item.midsessions[$index].testScoreRight);
            });
            return hasDataMidsession;
        };

        vm.checkRequiredColMidsessions = function ($index) {
            // If the report type is "First Report", the "Initial Score" column will be required.
            return !vm.isFirstReport && !vm.isOtherReport
                && !vm.disableFields.testingColMidsession
                && !vm.disableFields.testingColMidsessionLeft
                && !vm.disableFields.testingColMidsessionRight
                && !vm.checkDisableMidsessions($index, vm.colMidsessionsSubjective)
                && checkRequiredMidByWeeklyReport();
        }

        vm.checkRequiredFieldScore = function() {
            return !vm.isOtherReport;
        }

        vm.checkRequiredFieldDischarge= function() {
            return vm.isDischargeReport;
        }

        vm.checkDisableRemoveColMidsessions = function () {
            return (!vm.isMidSessionReport && !vm.isOtherReport) || vm.disableFields.testingColMidsession || vm.disableFields.testingColMidsessionLeft  || vm.disableFields.testingColMidsessionRight;
        }

        function checkRequiredMidByWeeklyReport() {
            if (vm.isWeeklyReport) {
                return vm.haveMidsessionPrevious ? true : false;
            }
            return true; //other WeeklyReport
        }

        vm.confirmDialogRemoveMidsessions = function (message, object, $index) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'center-dialog-message vertical-center',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    vm.removeColMidsessionsCallBack(object, $index);
                }
            });
        }

        vm.onClickSelectAllSubjective = function() {
            vm.subjectiveResponses.forEach(function (child) {
                child.checked = vm.checked;
            });
        }

         function updateSelectAllCheckboxSubjective() {
            var isCheckAll = true;
            vm.subjectiveResponses.forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })
            vm.checked = isCheckAll;
        }

        vm.getIdInitialScoreLR = function (sr, type) {
            // formatId:: initialScoreLeft_CES_D
            return 'initialScore' + type + '_' + sr.instrument;
        }

        vm.getIdDischargeLR = function (sr, type) {
            // formatId:: dischargeRight_{{sr.instrument}}
            return 'discharge' + type + '_' + sr.instrument;
        }

        vm.getIdMidsessionLR = function (sr, type, idx) {
            // formatId:: rowMidRight_{{sr.instrument}}_{{$index}}
            return 'rowMid' + type + '_' + sr.instrument + '_' + idx;
        }

        vm.getIdInitialScore = function (sr) {
            return 'initialScore_' + sr.instrument;
        }

        vm.getIdDischarge = function (sr) {
            return 'discharge_' + sr.instrument;
        }

        vm.getIdMidSession = function (sr, $index) {
            return 'rowMid_' + sr.instrument + '_' + $index;
        }

        $scope.$watch('vm.subjectiveImportMdeScores', function (newValue) {
            updateSelectAllCheckboxSubjective();
        });
    }

    angular.module('ipmApp').component('psychSubjectiveTestingController', {
        bindings: {
            subjectiveImportMdeScores: '=',
            subjectiveResponses: '=',
            midsessionsRemovedList: '=',
            disableFields: '<',
            reportType: '<',
            parentForm: '<',
            haveMidsessionPrevious: '<',
            onChange: '&',
            severity: '<',
            onChangeMidsessions: '&'
        },
        templateUrl: 'app/frp-mde/frp-report/psych/components/psych-subjective-testing.html',
        controller: PsychSubjectiveTestingController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    PsychObjectiveTestingController.$inject = ['ipmConstants', '$uibModal', 'DateUtils', '$scope'];

    function PsychObjectiveTestingController(constants, $uibModal, DateUtils, $scope) {
        var vm = this; //jshint ignore:line

        vm.addMidsessionClick = addMidsessionClick;
        vm.colLimit = 1000;
        vm.dateFormat = 'MM/dd/yyyy';
        vm.colMidsessions = [];
        vm.colSubjectiveDateChange = colSubjectiveDateChange;
        vm.updateSelectAllCheckbox = updateSelectAllCheckbox;
        vm.colspanNotes = 4;
        vm.isMidSessionReport = false;
        vm.deletingMidsessionColumnMessage = 'ipmApp.frpReport.pt.deletingMidsessionColumn';

        init();

        function init() {
            if (vm.objectiveResponses) {
                // set the first subjectiveResponses colMidsessions
                setColMidsessionSubjective(vm.objectiveResponses[0].midsessions);
                // updateSeverity(vm.objectiveResponses);
            }
            vm.isMidSessionReport = vm.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT;
            vm.isOtherReport = vm.reportType === constants.FRP_REPORT_TYPE.OTHER_REPORT;
            vm.isWeeklyReport = vm.reportType === constants.FRP_REPORT_TYPE.WEEKLY_REPORT;
            vm.isDischargeReport = vm.reportType === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT;
            vm.isFirstReport = vm.reportType === constants.FRP_REPORT_TYPE.FIRST_REPORT;
            updateSelectAllCheckbox();
        }

        function setColMidsessionSubjective(midsessions) {
            if (midsessions) {
                _.forEach(midsessions, function (o) {
                    o.dated = DateUtils.convertDateTimeFromServer(o.dated);
                });
            }
            vm.colMidsessions = midsessions;
        }

        function addNewMidsession(orderNumber, objectiveResponseId) {
            return {id: null,
                frpReportPsychObjectiveResponseId: objectiveResponseId,
                dated: new Date(),
                testScore: "",
                orderNumber: orderNumber,
                active: true,
                $isOpenCalendar: false};
        }

        function addMidsessionClick() {
            if (vm.objectiveResponses && vm.colMidsessions.length < vm.colLimit) {
                var orderNumber = _.isEmpty(vm.colMidsessions) ? 0 : vm.colMidsessions.length + 1;
                vm.objectiveResponses.forEach(function (item) {
                        var midsession = addNewMidsession(orderNumber, item.id);
                        item.midsessions.push(midsession);
                });
                setColMidsessionSubjective(vm.objectiveResponses[0].midsessions);
                vm.colspanNotes++;
                emitOnchangeMidsessions(vm.objectiveResponses);
            }
        }

        function emitOnchangeMidsessions(objectiveResponses) {
            vm.onChangeMidsessions({objectiveResponses: objectiveResponses});
        }

        function colSubjectiveDateChange(colSub) {
            updateSubjectiveResponses(colSub);
        }

        function updateSubjectiveResponses(colSub) {
            // comment out because effect to isChanged(), updated on prepareMidssessionDated before submit data
            // vm.objectiveResponses.forEach(function (item) {
            //     if (item.midsessions.length > 0) {
            //         item.midsessions.forEach(function (itemMidsessions) {
            //             if (itemMidsessions && colSub && itemMidsessions.orderNumber === colSub.orderNumber) {
            //                 itemMidsessions.dated = colSub.dated;
            //             }
            //         });
            //     }
            // });
        }

        vm.openCalendar = function (colSub) {
            colSub.$isOpenCalendar = !colSub.$isOpenCalendar;
        };

        vm.checkDisableMidsessions = function (rowMidIndex, midsessions) {
            // If there is more than 1 Midsession column then the most recent one should be editable
            if (midsessions && midsessions.length > 0) {
                if (midsessions.length === 1) {
                    return false;
                } else {
                    if (midsessions.length <= 1 || rowMidIndex !== midsessions.length - 1) {
                        return true;
                    }
                }
            }
            return false;
        }

        vm.checkDisableColMidsessions = function ($index) {
            return vm.disableFields.testingColMidsession || vm.checkDisableMidsessions($index, vm.colMidsessions);
        };

        vm.checkRequiredDateMidsession = function ($index) {
            if (vm.checkDisableColMidsessions($index)) {
                return false;
            }
            var hasDataMidsession = _.some(vm.objectiveResponses, function (item) {
                return item.midsessions && item.midsessions[$index] &&
                    (item.midsessions[$index].testScore || item.midsessions[$index].testScoreLeft || item.midsessions[$index].testScoreRight);
            });
            return hasDataMidsession;
        };

        // vm.checkRequiredColMidsessions = function ($index) {
        //     // If the report type is "First Report", the "Initial Score" column will be required.
        //     return !vm.isFirstReport && !vm.isOtherReport && !vm.disableFields.testingColMidsession && !vm.checkDisableMidsessions($index, vm.colMidsessions)
        //         && checkRequiredMidByWeeklyReport();
        // }

        vm.checkRequiredFieldScore = function() {
            return !vm.isOtherReport;
        }

        vm.checkRequiredFieldDischarge= function() {
            return vm.isDischargeReport;
        }

        vm.checkRequiredFields = function() {
            return vm.isMidSessionReport;
        }

        vm.checkDisableRemoveColMidsessions = function () {
            return (!vm.isMidSessionReport && !vm.isOtherReport) || vm.disableFields.testingColMidsession;
        }

        vm.removeColMidsessions = function (colSub, $index) {
            vm.confirmDialogRemoveMidsessions(vm.deletingMidsessionColumnMessage, colSub, $index);
        }

        vm.removeColMidsessionsCallBack = function (colSub, $index) {
            if (vm.objectiveResponses) {
                vm.objectiveResponses.forEach(function (item) {
                    if (item && item.midsessions) {
                        if (item.midsessions[$index] && item.midsessions[$index].id) {
                            addToMidsessionsRemoved(item.midsessions[$index]);
                        }
                        item.midsessions.splice($index, 1);
                        // update OrderNumber Midsessions
                        updateOrderNumberMidsession(item.midsessions);
                    }
                });
                setIsMidSessionObjectiveUpdated();
            }
        };

        function updateOrderNumberMidsession(midsessions) {
            if (midsessions) {
                midsessions.forEach(function (ms, index) {
                    ms.orderNumber = index;
                });
            }
        }

        function setIsMidSessionObjectiveUpdated() {
            if (!vm.isMidSessionObjectiveUpdated) {
                vm.isMidSessionObjectiveUpdated = true;
            }
        }

        function addToMidsessionsRemoved(midsessions) {
            if (midsessions) {
                midsessions.active = false;
                vm.midsessionsRemovedList.push(midsessions);
            }
        }

        function checkRequiredMidByWeeklyReport() {
            if (vm.isWeeklyReport) {
                return vm.haveMidsessionPrevious ? true : false;
            }
            return true; //other WeeklyReport
        }

        vm.confirmDialogRemoveMidsessions = function (message, object, $index) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'center-dialog-message vertical-center',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    vm.removeColMidsessionsCallBack(object, $index);
                }
            });
        }

        vm.onClickSelectAll = function() {
            vm.objectiveResponses.forEach(function (child) {
                child.checked = vm.checked;
            });
        }

         function updateSelectAllCheckbox() {
            var isCheckAll = true;
            vm.objectiveResponses.forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })

            vm.checked = isCheckAll;
        }

        vm.getIdInitialScore = function (sr) {
            return 'initialScore_' + sr.instrument;
        }

        vm.getIdDischarge = function (sr) {
            return 'discharge_' + sr.instrument;
        }

        vm.getIdMidSession = function (sr, $index) {
            return 'rowMid_' + sr.instrument + '_' + $index;
        }

        $scope.$watch('vm.objectiveImportMdeScores', function (newValue) {
            updateSelectAllCheckbox();
        });
    }

    angular.module('ipmApp').component('psychObjectiveTestingController', {
        bindings: {
            objectiveImportMdeScores: '=',
            objectiveResponses: '=',
            midsessionsRemovedList: '=',
            isMidSessionObjectiveUpdated: '=',
            disableFields: '<',
            reportType: '<',
            parentForm: '<',
            haveMidsessionPrevious: '<',
            onChange: '&',
            severity: '<',
            onChangeMidsessions: '&'
        },
        templateUrl: 'app/frp-mde/frp-report/psych/components/psych-objective-testing.html',
        controller: PsychObjectiveTestingController,
        controllerAs: 'vm'
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SelectGoalStatusController', SelectGoalStatusController);

    SelectGoalStatusController.$inject = [];

    function SelectGoalStatusController() {
        var vm = this;
        vm.goalsStatus = ['COMPLETE', 'INPROGRESS'];
        init();

        function init() {
            vm.isShowValidation = vm.isShowValidation ? true : false;
            vm.isRequired = vm.isRequired ? true : false;
        }

        vm.goalStatusChange = function () {
            vm.selectOnchange({goalStatus: vm.goalStatus});
        };
    }

    angular.module('ipmApp').component('selectGoalStatus', {
        bindings: {
            isRequired: '<',
            disabled: '<',
            formReference: '<',
            isShowValidation: '<',
            goalStatusName: '<',
            goalStatus: '=',
            selectOnchange: '&'
        },
        templateUrl: 'app/frp-mde/frp-report/conclusion/components/select-goal-status.html',
        controller: SelectGoalStatusController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('global');
                $translatePartialLoader.addPart('goalStatus');
                return $translate.refresh();
            }]
        }
    });
})();
;
(function() {
    'use strict';

    FRPGoalRowController.$inject = [];

    function FRPGoalRowController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
            vm.dropdownValues = ['Sedentary', 'Light', 'Medium', 'Heavy', 'Very Heavy'];
        }

        vm.checkboxChange = function() {
            vm.item.inputValue = null;
            vm.item.selectedValue = null;
            resetDefaultChecked();
        }

        vm.addNewGoal = function() {
            if (vm.isDisabled) return;
            vm.onClickAddNewGoal();
        }

        vm.selectGoalStatusOnchange = function(goalStatus) {
            if (!goalStatus) {
                vm.item.goalStatus = null;
            }
            if (goalStatus && goalStatus === 'INPROGRESS') {
                return;
            }
            resetGoalExplanation();
        };

        function resetDefaultChecked() {
            if (vm.item.checked) {
                if (!vm.item.goalStatus) {
                    vm.item.goalStatus = 'INPROGRESS';
                }
            } else {
                vm.item.checked = null;
            }
        }

        function resetGoalExplanation() {
            if (vm.item) {
                vm.item.goalExplanation = null;
            }
        }
    }

    angular.module('ipmApp').component('frpGoalRow', {
        bindings: {
            item: '<',
            type: '<',
            onChange: '&',
            onClickAddNewGoal: '&',
            showAddGoal: '<',
            isDisabled: '<',
            formReference: '<'
        },
        templateUrl: 'app/frp-mde/frp-report/conclusion/components/frp-goal-row.html',
        styleUrls: 'app/frp-mde/frp-report/conclusion/components/frp-goal-row.scss',
        controller: FRPGoalRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    FRPGoalAddNewRowController.$inject = [];

    function FRPGoalAddNewRowController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
        }

        vm.checkboxChange = function() {
            resetDefaultChecked();
        }

        vm.removeGoalAddNew = function() {
            if (vm.isDisabled) return;
            vm.item.active = false;
            vm.onDelete({data: vm.item});
        }

        vm.addNewGoal = function() {
            if (vm.isDisabled) return;
            vm.onClickAddNewGoal();
        }

        vm.selectGoalStatusOnchange = function(goalStatus) {
            if (!goalStatus) {
                vm.item.goalStatus = null;
            }
            if (goalStatus && goalStatus === 'INPROGRESS') {
                return;
            }
            resetGoalExplanation();
        };

        function resetDefaultChecked() {
            if (vm.item.checked) {
                if (!vm.item.goalStatus) {
                    vm.item.goalStatus = 'INPROGRESS';
                }
            } else {
                vm.item.checked = null;
            }
        }

        function resetGoalExplanation() {
            if (vm.item) {
                vm.item.goalExplanation = null;
            }
        }

    }

    angular.module('ipmApp').component('frpGoalAddNewRow', {
        bindings: {
            item: '<',
            type: '<',
            onChange: '&',
            onDelete: '&',
            lastItem: '<',
            onClickAddNewGoal: '&',
            isDisabled: '<',
            formReference: '<'
        },
        templateUrl: 'app/frp-mde/frp-report/conclusion/components/frp-goal-add-new-row.html',
        controller: FRPGoalAddNewRowController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('UploadSignatureDialogController', UploadSignatureDialogController);

    UploadSignatureDialogController.$inject = ['$scope', '$uibModalInstance', 'signature'];

    function UploadSignatureDialogController ($scope, $uibModalInstance, signature) {
        var vm = this;
        vm.signature = signature ? signature : {};
        init();

        function init() {

        }

        var onSaveSuccess = function (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            onSaveSuccess(vm.signature);
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CourseRegisterWorkflowController', CourseRegisterWorkflowController);

        CourseRegisterWorkflowController.$inject = ['$rootScope', '$scope', '$state', 'ipmConstants', 'SurveyWorkflowService'];

        function CourseRegisterWorkflowController($rootScope, $scope, $state, constants, SurveyWorkflowService) {
            var vm = this;
            vm.allSteps = constants.COURSE_REGISTRATION_STEPS;
            vm.suggestCourseStep = constants.COURSE_REGISTRATION_STEPS[0];
            vm.instructionDetailListStep = constants.COURSE_REGISTRATION_STEPS[1];
            vm.classSessionDetailListStep = constants.COURSE_REGISTRATION_STEPS[2];
            vm.patientCourseRegistration = {
                suggestedCourses: [],
                courseIdSelected: null,
                instructorSchedules: [],
                instructorScheduleSelected: {},
                scheduledClassesSelected: [],
                acceptRegister: false
            };
            vm.handleSuggestCourseNext = handleSuggestCourseNext;
            vm.handleInstructionDetailListNext = handleInstructionDetailListNext;
            vm.handleClassSessionDetailListNext = handleClassSessionDetailListNext;
            vm.handleInstructionDetailListBack = handleInstructionDetailListBack;
            vm.handleClassSessionDetailListBack = handleClassSessionDetailListBack;
            vm.skip = skip;

            init();

            function init() {
                vm.currentStep = vm.suggestCourseStep;
            }

            $rootScope.$on('UpdateCourseRegistration', function(event, responseData) {
                console.log("Event-UpdateCourseRegistration ", responseData);
                updateCourseRegistration(responseData);
            });

            function updateCourseRegistration(responseData) {
                vm.patientCourseRegistration.suggestedCourses = responseData.suggestedCourses;
                vm.patientCourseRegistration.courseIdSelected = responseData.courseIdSelected;
                vm.patientCourseRegistration.courseNameSelected = responseData.courseNameSelected;
                vm.patientCourseRegistration.instructorSchedules = responseData.instructorSchedules;
                vm.patientCourseRegistration.instructorScheduleSelected = responseData.instructorScheduleSelected;
                vm.patientCourseRegistration.scheduledClassesSelected = responseData.scheduledClassesSelected;
                vm.patientCourseRegistration.acceptRegister = responseData.acceptRegister;
            }
            function handleSuggestCourseNext() {
                vm.currentStep = vm.instructionDetailListStep;
            }

            function handleInstructionDetailListNext() {
                vm.currentStep = vm.classSessionDetailListStep;
            }

            function handleClassSessionDetailListNext() {
                vm.skip();
            }

            function skip() {
                if(vm.currentStep != vm.suggestCourseStep) {
                    if(vm.patientCourseRegistration.suggestedCourses.length > 0) {
                        vm.patientCourseRegistration.suggestedCourses.shift();
                    }
                    if(vm.patientCourseRegistration.suggestedCourses.length == 0) {
                        SurveyWorkflowService.courseRegisterConfirmed().then(function() {
                            $state.go('survey-workflow-thankyou');
                        });
                    } else {
                        handleSuggestCourseNext();
                        SurveyWorkflowService.coursesRegistration(vm.patientCourseRegistration).then(function(response) {
                            updateCourseRegistration(response.data);
                            console.log("Course Registration View 1", vm.patientCourseRegistration);
                        });
                    }
                } else {
                    SurveyWorkflowService.courseRegisterConfirmed().then(function() {
                        $state.go('survey-workflow-thankyou');
                    });
                }
            }

            function handleInstructionDetailListBack() {
                vm.currentStep = vm.suggestCourseStep;
            }

            function handleClassSessionDetailListBack() {
                vm.currentStep = vm.instructionDetailListStep;
            }
        }
})();

;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('WebWorkerEvlService', WebWorkerEvlService);
    WebWorkerEvlService.$inject = ['ipmConstants'];

    function WebWorkerEvlService(constants) {
        var service = {
            'close': close,
            'getWebWorker': getWebWorker,
            'startTimeSpent': startTimeSpent,
            'resetTimeSpent': resetTimeSpent,
            'clearTimeSpent': clearTimeSpent,
            'startIntervalAutoSave': startIntervalAutoSave,
            'resetIntervalAutoSave': resetIntervalAutoSave,
            'clearIntervalAutoSave': clearIntervalAutoSave
        };

        var webWorker = null;
        var versionWorker = 'v1';
        var urlWorker = 'content/js/workers/eval-worker-' + versionWorker + '.js'; // we will change the version from eval-worker-v1.js to clear the cache

        // Function to terminate and clean up the web worker
        function close() {
            if (webWorker) {
                sendMessageToWorker(constants.WEB_WORKER.CLOSE);
                webWorker.terminate();
                webWorker = null;
            }
        }

        // Function to start the time spent interval
        function startTimeSpent(force) {
            if (force || !webWorker) {
                initializeWorker();
            }
            sendMessageToWorker(constants.WEB_WORKER.START_TIME_SPENT_INTERVAL_EVL);
            return webWorker;
        }

        // Function to reset the time spent interval
        function resetTimeSpent() {
            sendMessageToWorker(constants.WEB_WORKER.RESET_TIME_SPENT_INTERVAL_EVL);
        }

        // Function to clear the time spent interval
        function clearTimeSpent() {
            sendMessageToWorker(constants.WEB_WORKER.CLEAR_TIME_SPENT_INTERVAL_EVL);
        }

        // Function to start the auto-save interval
        function startIntervalAutoSave() {
            if (!webWorker) {
                initializeWorker();
            }
            sendMessageToWorker(constants.WEB_WORKER.START_AUTO_SAVE_INTERVAL_EVL);
            return webWorker;
        }

        // Function to clear the auto-save interval
        function clearIntervalAutoSave() {
            sendMessageToWorker(constants.WEB_WORKER.CLEAR_AUTO_SAVE_INTERVAL_EVL);
        }

        // Function to reset the auto-save interval
        function resetIntervalAutoSave() {
            sendMessageToWorker(constants.WEB_WORKER.RESET_AUTO_SAVE_INTERVAL_EVL);
        }

        // Helper function to get the current web worker instance
        function getWebWorker() {
            return webWorker;
        }

        // Helper function to initialize the web worker
        function initializeWorker() {
            close(); // Clean up any existing worker before creating a new one
            webWorker = new Worker(urlWorker);
        }

        // Helper function to send messages to the web worker safely
        function sendMessageToWorker(messageType) {
            if (webWorker) {
                webWorker.postMessage({type: messageType});
            } else {
                console.warn('WebWorker is not initialized.');
            }
        }

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('skipEvaluationDialogController', skipEvaluationDialogController);

    skipEvaluationDialogController.$inject = ['$stateParams', '$state', '$uibModalInstance', 'entity', 'HaqEvaluationSkipsService'];

    function skipEvaluationDialogController($stateParams, $state, $uibModalInstance, entity, HaqEvaluationSkipsService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.skipReviewEvaluation = entity;

        init();

        function init() {
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.isSaving || !vm.skipReviewEvaluation.reason) {
                return;
            }
            vm.isSaving = true;
            HaqEvaluationSkipsService.addHaqEvaluationSkip(vm.skipReviewEvaluation).then(function (res) {
                onSaveSuccess(res);
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            // var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status !== 200) {
                $uibModalInstance.close(error);
            }
        }
    }
})();
;
(function() {
    'use strict';

    QuestionDescriptionBottom.$inject = [];

    function QuestionDescriptionBottom() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
        }

        vm.isDisplayDescriptionBottom = function() {
            if (vm.questionCode === 'Q-43' || vm.questionCode === 'Q-65') {
                return true;
            }
            return false;
        }
    }

    angular.module('ipmApp').component('questionDescriptionBottom', {
        bindings: {
            questionCode: '<',
            translateKey: '<'
        },
        templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/question-description-bottom/question-description-bottom.html',
        controller: QuestionDescriptionBottom,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    MultipleColumnCheckboxController.$inject = [];

    function MultipleColumnCheckboxController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
            vm.answers = vm.config.answers;
            vm.code = vm.config.question.code;
            vm.keyOtherMultipleCheckboxColumnOnEvaluationStoreage = vm.code + '-otherMultipleCheckboxColumn';
            vm.ortherCheckboxExcludeIds = [];

            _.forEach(vm.config.question.questionItems, function (q) {
                vm.ortherCheckboxExcludeIds.push(q.id);
            });
            
            // get other checkbox from evaluation store if have selected
            var a = vm.evaluationStorage.get(vm.keyOtherMultipleCheckboxColumnOnEvaluationStoreage) 
            var z = vm.answers.get(vm.config.question.code);
            if (a) {
                _.forEach(a, function (b) {
                    var c = _.find(vm.config.question.questionItems, function(d) { return b.id === d.id; });
                    if (!c) {
                        vm.config.question.questionItems.push(b);
                    }
                    // handle case change parent answer, remove other checkbox selected
                    if (!z) {
                        _.remove(vm.config.question.questionItems, function(d) { return b.id === d.id; });
                    }
                });
            }
        }

        vm.handleItemCheckboxChange = function(data) {
            if (!vm.answers.get(vm.code)) {
                vm.answers.set(vm.code, new Map());
            }
            var a = vm.answers.get(vm.code)
            if (a) {
                a = new Map(Object.entries(a)); // convert back to Map
                if (!a.get(data.column)) {
                    a.set(data.column, []);
                }
                var b = a.get(data.column);
                if (b) {
                    if (data.checked) {
                        b.push({ name: data.checkboxValue.name, value: data.checkboxValue.value })
                    } else {
                        _.remove(b, function(n) {
                            return n.name === data.checkboxValue.name;
                        });
                    }
                }
            }
            // clear another column
            _.forEach(vm.config.columns, function(c) {
                if (c.value !== data.column) {
                    var x = a.get(c.value);
                    if (x) {
                        _.remove(x, function(n) {
                            return n.name === data.checkboxValue.name;
                        });
                    } else {
                        a.set(c.value, []);
                    }
                }
            });
            vm.onAnswerChange({ data: { question: vm.config.question, value: Object.fromEntries(a) } }); // Object.fromEntries -> convert to submit map into server
        }

        vm.handleOrtherCheckboxSelected = function(item) {
            if (item) {
                vm.config.checkboxItems.push(item);
                vm.ortherCheckboxExcludeIds.push(item.id);

                // push into evaluationStorage
                if (vm.evaluationStorage) {
                    
                    var u = vm.evaluationStorage.get(vm.keyOtherMultipleCheckboxColumnOnEvaluationStoreage);
                    if (!u) {
                        u = [];
                        vm.evaluationStorage.set(vm.keyOtherMultipleCheckboxColumnOnEvaluationStoreage, u);
                    }
                    u.push(item);
                }
            }
        }
    }

    angular.module('ipmApp').component('multipleColumnCheckbox', {
        bindings: {
            config: '<',
            evaluationStorage: '<',
            onAnswerChange: '&'
        },
        templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/multiple-column-checkbox-question/multiple-column-checkbox.html',
        controller: MultipleColumnCheckboxController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    ColumnCheckboxItemController.$inject = [];

    function ColumnCheckboxItemController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
            vm.columns = _.cloneDeep(vm.config.columns);
            var answer = vm.config.answers.get(vm.config.question.code);
            
            if (answer) {
                answer = new Map(Object.entries((answer)));
                for(var i = 0; i < vm.columns.length; i++) {
                    var c = vm.columns[i];
                    if (answer.get(c.value)) {
                        var d = answer.get(c.value);
                        if (!_.isEmpty(_.filter(d, function(q) {
                            return q.name === vm.item.name;
                        }))) {
                            c.checked = true;
                            break;
                        }
                    }
                }
            }
            
        }

        vm.change = function(item, checked) {
            if (checked) {
                // clear another column
                _.forEach(vm.columns, function(l) {
                    if (l.value !== item.value) {
                        l.checked = false;
                    }
                });
            }
            vm.onChange({ data: { column: item.value, checked: checked, checkboxValue: vm.item } });
        }
    }

    angular.module('ipmApp').component('columnCheckboxItem', {
        bindings: {
            config: '<',
            item: '<',
            onChange: '&'
        },
        templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/multiple-column-checkbox-question/column-checkbox-item.html',
        controller: ColumnCheckboxItemController,
        controllerAs: 'vm'
    })
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('WebWorkerService', WebWorkerService);
    WebWorkerService.$inject = ['ipmConstants'];

    function WebWorkerService(constants) {
        var service = {
            'activate': activate,
            'close': close,
            'startTimeSpent': startTimeSpent,
            'getWebWorker': getWebWorker,
            'startLogoffInterval' : startLogoffInterval,
            'resetLogoffInterval': resetLogoffInterval,
            'clearLogoffInterval': clearLogoffInterval,
            'startNoticingLogoffInterval': startNoticingLogoffInterval,
            'resetNoticingLogoffInterval': resetNoticingLogoffInterval,
            'clearNoticingLogoffInterval': clearNoticingLogoffInterval
        }

        var webWorker = null;
        var versionCprWorker = 'v1';
        var urlCprWorker = 'content/js/workers/cpr-worker-' + versionCprWorker + '.js'; // we will change the version from cpr-worker-v1.js to clear the cache

        // Activation methods.
        function activate(force) {
            if (!webWorker || force) {
                webWorker = new Worker(urlCprWorker);
            }
            webWorker.postMessage({type: constants.WEB_WORKER.START});
            return webWorker;
        }

        function close() {
            if (webWorker) {
                webWorker.postMessage({type: constants.WEB_WORKER.CLOSE});
                webWorker.terminate();
                webWorker = null;
            }
        }

        function startTimeSpent(force) {
            if (!webWorker || force) {
                webWorker = new Worker(urlCprWorker);
            }
            webWorker.postMessage({type: constants.WEB_WORKER.START_TIME_SPENT});
            return webWorker;
        }

        function startLogoffInterval() {
            if (!webWorker) {
                webWorker = new Worker(urlCprWorker);
            }
            webWorker.postMessage({type: constants.WEB_WORKER.START_LOGOFF_INTERVAL});
            return webWorker;
        }

        function resetLogoffInterval() {
            if (webWorker) {
                webWorker.postMessage({type: constants.WEB_WORKER.RESET_LOGOFF_INTERVAL});
            }
        }

        function clearLogoffInterval() {
            if (webWorker) {
                webWorker.postMessage({type: constants.WEB_WORKER.CLEAR_LOGOFF_INTERVAL});
            }
        }

        function startNoticingLogoffInterval() {
            if (!webWorker) {
                webWorker = new Worker(urlCprWorker);
            }
            webWorker.postMessage({type: constants.WEB_WORKER.START_NOTICING_LOGOFF_INTERVAL});
            return webWorker;
        }

        function resetNoticingLogoffInterval() {
            if (webWorker) {
                webWorker.postMessage({type: constants.WEB_WORKER.RESET_NOTICING_LOGOFF_INTERVAL});
            }
        }

        function clearNoticingLogoffInterval() {
            if (webWorker) {
                webWorker.postMessage({type: constants.WEB_WORKER.CLEAR_NOTICING_LOGOFF_INTERVAL});
            }
        }

        function getWebWorker() {
            return webWorker;
        }

        return service;
    }
})();;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('skipDialogController', skipDialogController);

    skipDialogController.$inject = [
        '$scope',
        '$uibModalInstance',
        '$q',
        '$state',
        'ipmConstants',
        'patientId',
        'CarePlanReviewWorkflowService'
    ];

    function skipDialogController($scope, $uibModalInstance, $q, $state, ipmConstants, patientId, CarePlanReviewWorkflowService) {
        var vm = this;
        vm.skipReasons = ipmConstants.SKIP_REASON;
        vm.skipReview = {};
        vm.skipReview.patientId = patientId;
        vm.isSaving = false;

        vm.yes = function () {
            vm.isSaving = true;
            CarePlanReviewWorkflowService.skipReviewCPR(vm.skipReview).then(function (res) {
                if (res) {
                    vm.isSaving = false;
                    $uibModalInstance.close(true);
                    $uibModalInstance.dismiss('cancel');
                    $state.go('care-plan-review');
                }
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        vm.no = function(){
            $uibModalInstance.close(false);
            $uibModalInstance.dismiss('cancel');
        }
    }

})();
;
(function() {
    'use strict';


    CPRStatusIndicatorController.$inject = ['$scope', '$state'];

    function CPRStatusIndicatorController($scope, $state) {
        var vm = this; //jshint ignore:line
        
        init();

        function init() {
        }

        
    }

    angular.module('ipmApp').component('cprStatusIndicator', {
        bindings: {
            statusIndicator: '<',
            css: '<',
            onSectionAnswerChange: '&',
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/status-indicator/status-indicator.html',
        controller: CPRStatusIndicatorController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('sectionTimeoutDialogController', sectionTimeoutDialogController);

        sectionTimeoutDialogController.$inject = [
        '$interval',
        '$uibModalInstance',
        'remainingSeconds'
    ];

    function sectionTimeoutDialogController($interval, $uibModalInstance,  remainingSeconds) {
        var vm = this;
        vm.remainingSeconds = remainingSeconds;
        $interval(countdown, 1000);
        vm.stayLoggedIn = function () {
            $uibModalInstance.close(true);
        }

        vm.logOff = function(){
            $uibModalInstance.close(false);
            $uibModalInstance.dismiss('cancel');
        }

        function countdown() {
            vm.remainingSeconds--;
            if (vm.remainingSeconds == 0) {
                $uibModalInstance.close(true);
            }
        }
    }
})();
;
(function() {
    'use strict';


    CPRSectionController.$inject = ['$scope', '$state', 'ipmConstants'];

    function CPRSectionController($scope, $state, constants) {
        var vm = this; //jshint ignore:line
        vm.getValueTreatment = getValueTreatment;
        vm.getLastDate = getLastDate;
        vm.getAuthResponseDate = getAuthResponseDate;
        vm.getStatus = getStatus;
        vm.getSessionsCompleted = getSessionsCompleted;
        vm.isDisplayQuestionCPR13 = isDisplayQuestionCPR13;
        vm.isDisplayQuestionCPR15 = isDisplayQuestionCPR15;
        vm.surgicalCandidacySectionId = 3;
        vm.treamentHistorySectionId = 2;
        vm.removeChildsNewAnswersByCode = removeChildsNewAnswersByCode;
        vm.handleSurgicalCandidacyStatus = handleSurgicalCandidacyStatus;
        vm.checkInValidBillTo = checkInValidBillTo;

        var PHYSICAL_THERAPY = constants.TREATMENT_HISTORY_TYPE[0];
        var ACUPUNCTURE = constants.TREATMENT_HISTORY_TYPE[1];
        var CHIRO = constants.TREATMENT_HISTORY_TYPE[2];
        var PSYCH = constants.TREATMENT_HISTORY_TYPE[3];
        var MDE = constants.TREATMENT_HISTORY_TYPE[4];
        var FRP = constants.TREATMENT_HISTORY_TYPE[5];
        var INJECTIONS = constants.TREATMENT_HISTORY_TYPE[6];
        var selectStatusOptionForTreatmentTable = [
            'approvedNeedToSchedule',
            'approvedNoCompletionInfo',
            'approvedInProgress',
            'approvedPatientDeclined',
            'completed',
            'deniedURDenial',
            'deniedIMRDenial',
            'appealInProgress',
            'noAuthRequestFound',
            'authSentPending',
            'authSentNoResponse',
            'approvedMedicalHold',
            'deferredNotReviewed',
            'authorizedRetrospective'
        ];

        init();

        function init() {
            vm.answers = new Map(Object.entries(vm.section.answers));
            // vm.surgicalCandidacyStatus = vm.values.get(vm.surgicalCandidacyStatusValueKey);

            vm.treatmentTypes = [
                {
                    orderNumber: 0,
                    value: PHYSICAL_THERAPY,
                    datePickerOpenStatus: {},
                    lastDate: vm.getLastDate(PHYSICAL_THERAPY),
                    status: vm.getStatus(PHYSICAL_THERAPY),
                    sessionsCompleted: vm.getSessionsCompleted(PHYSICAL_THERAPY),
                    authResponseDate: vm.getAuthResponseDate(PHYSICAL_THERAPY),
                    sessionsCompletedMin: '0',
                    sessionsCompletedMax: '99',
                    treatmentStatuses: selectStatusOptionForTreatmentTable
                },
                {
                    orderNumber: 1,
                    value: ACUPUNCTURE,
                    datePickerOpenStatus: {},
                    lastDate: vm.getLastDate(ACUPUNCTURE),
                    status: vm.getStatus(ACUPUNCTURE),
                    sessionsCompleted: vm.getSessionsCompleted(ACUPUNCTURE),
                    authResponseDate: vm.getAuthResponseDate(ACUPUNCTURE),
                    sessionsCompletedMin: '0',
                    sessionsCompletedMax: '99',
                    treatmentStatuses: selectStatusOptionForTreatmentTable
                },
                {
                    orderNumber: 2,
                    value: CHIRO,
                    datePickerOpenStatus: {},
                    lastDate: vm.getLastDate(CHIRO),
                    status: vm.getStatus(CHIRO),
                    sessionsCompleted: vm.getSessionsCompleted(CHIRO),
                    authResponseDate: vm.getAuthResponseDate(CHIRO),
                    sessionsCompletedMin: '0',
                    sessionsCompletedMax: '99',
                    treatmentStatuses: selectStatusOptionForTreatmentTable
                },
                {
                    orderNumber: 3,
                    value: PSYCH,
                    datePickerOpenStatus: {},
                    lastDate: vm.getLastDate(PSYCH),
                    status: vm.getStatus(PSYCH),
                    sessionsCompleted: vm.getSessionsCompleted(PSYCH),
                    authResponseDate: vm.getAuthResponseDate(PSYCH),
                    sessionsCompletedMin: '0',
                    sessionsCompletedMax: '99',
                    treatmentStatuses: selectStatusOptionForTreatmentTable
                },
                {
                    orderNumber: 4,
                    value: MDE,
                    datePickerOpenStatus: {},
                    lastDate: vm.getLastDate(MDE),
                    status: vm.getStatus(MDE),
                    sessionsCompleted: vm.getSessionsCompleted(MDE),
                    authResponseDate: vm.getAuthResponseDate(MDE),
                    sessionsCompletedMin: '1',
                    sessionsCompletedMax: '1',
                    treatmentStatuses: [ // IPMproject-396: CPR Edits: #4 In the Treatment History table, for the Status drop-down for the MDE treatment, please add a new status option "In Progress". This should be added above "Completed" and below "Approved - Patient Declined".
                        'approvedNeedToSchedule',
                        'approvedNoCompletionInfo',
                        'approvedInProgress',
                        'approvedPatientDeclined',
                        'inProgress',
                        'completed',
                        'deniedURDenial',
                        'deniedIMRDenial',
                        'appealInProgress',
                        'noAuthRequestFound',
                        'authSentPending',
                        'authSentNoResponse',
                        'approvedMedicalHold',
                        'deferredNotReviewed',
                        'authorizedRetrospective'
                    ]
                },
                {
                    orderNumber: 5,
                    value: FRP,
                    datePickerOpenStatus: {},
                    lastDate: vm.getLastDate(FRP),
                    status: vm.getStatus(FRP),
                    sessionsCompleted: vm.getSessionsCompleted(FRP),
                    authResponseDate: vm.getAuthResponseDate(FRP),
                    sessionsCompletedMin: '0',
                    sessionsCompletedMax: '200',
                    treatmentStatuses: selectStatusOptionForTreatmentTable
                },
                {
                    orderNumber: 6,
                    value: INJECTIONS,
                    datePickerOpenStatus: {},
                    lastDate: vm.getLastDate(INJECTIONS),
                    status: vm.getStatus(INJECTIONS),
                    sessionsCompleted: vm.getSessionsCompleted(INJECTIONS),
                    authResponseDate: vm.getAuthResponseDate(INJECTIONS),
                    sessionsCompletedMin: '0',
                    sessionsCompletedMax: '20',
                    treatmentStatuses: selectStatusOptionForTreatmentTable
                }
            ];
        }

        vm.handleTreatmentHistoryTable = function(data) {
            var a = vm.values.get(constants.CPR_MAP_KEY_VALUES[0]);
            if (!a) {
                a = [];
            }
            var existing = _.head(_.filter(a, function(b) { return b.treatment === data.treatment; }));
            if (existing) {
                existing.sessionsCompleted = data.sessionsCompleted;
                existing.lastDate = data.lastDate;
                existing.authResponseDate = data.authResponseDate;
                existing.status = data.status
            } else {
                a.push(data);
            }
            
            vm.onSectionValuesChange({ data: { key: constants.CPR_MAP_KEY_VALUES[0], value: a } });
        }


        vm.onAnswerChange = function(data) {
            if (data.clearChilds) {
                // clear childs
                vm.removeChildsNewAnswersByCode(data.question);
            }
            // update value for this code
            vm.answers.set(data.question.code, data.value);
            vm.allAnswers.set(data.question.code, data.value);
            // emit to parent
            vm.onSectionAnswerChange({data: {section: vm.section, answer: vm.answers}});

            if (vm.section.id === vm.surgicalCandidacySectionId) {
                // handle Surgical Candidacy Status
                var currentSurgicalCandidacyStatus = vm.handleSurgicalCandidacyStatus(data);
                vm.onSectionValuesChange({data: {key: constants.CPR_MAP_KEY_VALUES[1], value: currentSurgicalCandidacyStatus}});
            }
        }

        function removeChildsNewAnswersByCode(question) {
            if (question) {
                _.forEach(question.childs, function(c) {
                    vm.removeChildsNewAnswersByCode(c);
                    vm.answers.delete(question.code);
                });
                vm.answers.delete(question.code);

                _.forEach(question.childs, function(c) {
                    vm.removeChildsNewAnswersByCode(c);
                    vm.allAnswers.delete(question.code);
                });
                vm.allAnswers.delete(question.code);
            }
        }

        function handleSurgicalCandidacyStatus(data) {
            var status = vm.surgicalCandidacyStatus;
            if (data) {
                if (data.question.code === 'CPR_018') {
                    if (data.value === 'NO') {
                        status = 'Not a candidate';
                    } else if (data.value === 'UNCLEAR') {
                        status = 'Unclear, need to update'
                    }
                } else if (data.question.code === 'CPR_019') {
                    if (data.value === 'NO') {
                        status = 'Candidate, Surgery not requested';
                    } else {
                        status = undefined;
                    }
                } else if (data.question.code === 'CPR_020') {
                    if (data.value === 'DENIED') {
                        status = 'Denied';
                    } else if (data.value === 'NO RESPONSE') {
                        status = 'No response to surgery RFA';
                    } else {
                        status = undefined;
                    }
                } else if (data.question.code === 'CPR_024') {
                    status = 'Denied on ' + data.value;
                } else if (data.question.code === 'CPR_021') {
                    if (data.value === 'YES') {
                        status = 'Surgery authorized, but patient declined';
                    } else if (data.value === 'NO') {
                        status = 'Surgery authorized patient accepted';
                    }
                } else if (data.question.code === 'CPR_022') {
                    if (data.value === 'YES') {
                        status = 'Patient had surgery';
                    } else if (data.value === 'NO') {
                        status = 'Authorized, pending surgery';
                    }
                }
            }
            vm.surgicalCandidacyStatus = status; // re-update status
            return status;
        }

        vm.isTreatmentHistorySection = function() {
            return vm.section.id === vm.treamentHistorySectionId;
        }

        function getValueTreatment(key) {
            var a = vm.values.get(constants.CPR_MAP_KEY_VALUES[0]);
            var value = _.head(_.filter(a, function(b) { return b.treatment === key; }));
            return value;
        }

        function getLastDate(key) {
            var a = getValueTreatment(key);
            if (a && a.lastDate) {
                return new Date(a.lastDate);
            }
        }

        function getAuthResponseDate(key) {
            var a = getValueTreatment(key);
            if (a && a.authResponseDate) {
                return new Date(a.authResponseDate);
            }
        }

        function getStatus(key) {
            var a = getValueTreatment(key);
            if (a) {
                return a.status;
            }
        }

        function getSessionsCompleted(key) {
            var a = getValueTreatment(key);
            if (a) {
                return a.sessionsCompleted;
            }
        }

        vm.displayQuestion = function(question) {
            if (question.code === 'CPR_013') {
                return vm.isDisplayQuestionCPR13();
            }
            if (question.code === 'CPR_015') {
                return vm.isDisplayQuestionCPR15();
            }
            return true;
        }

        function isDisplayQuestionCPR13() {

            var acupuncture  = vm.getSessionsCompleted(ACUPUNCTURE) >= 6 || vm.getStatus(ACUPUNCTURE) === 'approvedPatientDeclined' || vm.getStatus(ACUPUNCTURE) === 'deniedURDenial' || vm.getStatus(ACUPUNCTURE) === 'deniedIMRDenial';
            var psych = vm.getSessionsCompleted(PSYCH) >= 6 || vm.getStatus(PSYCH) === 'approvedPatientDeclined' || vm.getStatus(PSYCH) === 'deniedURDenial' || vm.getStatus(PSYCH) === 'deniedIMRDenial';
            var physicalTherapy = vm.getSessionsCompleted(PHYSICAL_THERAPY) >= 6 || vm.getStatus(PHYSICAL_THERAPY) === 'approvedPatientDeclined' || vm.getStatus(PHYSICAL_THERAPY) === 'deniedURDenial' || vm.getStatus(PHYSICAL_THERAPY) === 'deniedIMRDenial';
            var chiro = vm.getSessionsCompleted(CHIRO) >= 6 || vm.getStatus(CHIRO) === 'approvedPatientDeclined' || vm.getStatus(CHIRO) === 'deniedURDenial' || vm.getStatus(CHIRO) === 'deniedIMRDenial';

            if (acupuncture && psych && (physicalTherapy || chiro)) {
                return true;
            }
            clearAnswerValueByCode('CPR_013');
            return false;
        }

        function isDisplayQuestionCPR15() {
            var isValidWorkStatus = false;
            if (vm.allAnswers.get('CPR_009') === 'Part Time' || vm.allAnswers.get('CPR_009') === 'Non-working'
                            || vm.allAnswers.get('CPR_010') === 'Full Time Modified') {
                isValidWorkStatus = true;
            }
            if (!vm.allAnswers.get('CPR_009') && !vm.allAnswers.get('CPR_010')) {
                if (vm.patientWorkStatus === 'Part Time' || vm.patientWorkStatus === 'Part Time Modified' || vm.patientWorkStatus === 'Part Time Unmodified' || vm.patientWorkStatus === 'Non-working'
                            || vm.patientWorkStatus === 'Full Time Modified') {
                    isValidWorkStatus = true;
                }
            }
            if (isValidWorkStatus) {
                if (vm.allAnswers.get('CPR_018') === 'NO' || ((!vm.allAnswers.get('CPR_018') || vm.allAnswers.get('CPR_018') === 'NO') && (vm.allPreviousAnswers.get('CPR_018') === 'NO' || vm.surgicalCandidacyStatus === 'Not a candidate'))) {
                    if (vm.allAnswers.get('CPR_013') === 'YES') {
                        if (vm.isDisplayQuestionCPR13()) {
                            return true;
                        }
                    }
                }
            }
            // clear value if not display question 'CPR_015'
            clearAnswerValueByCode('CPR_015');
        }

        function getWorkStatus() {

        }

        function clearAnswerValueByCode(code) {
            var question = _.head(_.filter(vm.section.questions, function(q) { return q.code === code; }));
            if (question) {
                vm.answers.delete(question.code);
                vm.removeChildsNewAnswersByCode(question);
            }
        }

        vm.isSectionRequired = function() {
            return vm.section && (vm.section.id === 5 || vm.section.id === 6); // 'Case Summary & Notes' and 'Records Reviewed'
        }

        function checkInValidBillTo() {
            var hasCheck = !_.isEmpty(_.filter(vm.cases, function (caseItem) {
                return caseItem && caseItem.billTo;
            }));
            return !hasCheck;
        }
    }

    angular.module('ipmApp').component('cprSection', {
        bindings: {
            section: '<',
            values: '<',
            patientWorkStatus: '<',
            surgicalCandidacyStatus: '<',
            allAnswers: '<',
            allPreviousAnswers: '<',
            onSectionAnswerChange: '&',
            onSectionValuesChange: '&',
            cases: '=',
            deletedCases: '=',
            cprId: '<'
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-component/section.html',
        controller: CPRSectionController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CallLogController', CallLogController);

    CallLogController.$inject = ['$scope', '$filter', '$uibModal'];

    function CallLogController($scope, $filter, $uibModal) {
        var vm = this;
        vm.callLogClick = callLogClick;
        init();

        function init() {
        }

        function callLogClick() {
            openCallLogDialog();
        }

        function openCallLogDialog() {
            $uibModal.open({
                templateUrl: 'app/qhp-workflow/care-plan-review-workflow/call-log/partial/call-log-dialog.html',
                controller: 'CallLogDialogController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                windowClass: 'call-log',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            patientId: vm.patientId,
                            qhpUserId: vm.qhpUserId,
                            carePlanReviewId: vm.carePlanReviewId,
                            dateLog: Date.now(),
                            party: null,
                            summary: null
                        };
                    },
                    isAdHoc: function () {
                        return vm.isAdHoc;
                    }
                }
            });
        }

    }

    angular.module('ipmApp').component('callLog', {
        bindings: {
            patientId: '<',
            qhpUserId: '<',
            carePlanReviewId: '<',
            isAdHoc: '<',
            onChange: '&'
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/call-log/call-log.html',
        controller: CallLogController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                // $translatePartialLoader.addPart('global');
                // $translatePartialLoader.addPart('callLog');
                // $translatePartialLoader.addPart('partyType');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    InternalReviewController.$inject = ['$scope'];

    function InternalReviewController($scope) {
        var vm = this;

        init();

        function init() {
            vm.cpr.evaluatedForMDE = vm.cpr ? vm.cpr.evaluatedForMDE : false;
            vm.cpr.evaluatedForPS = vm.cpr ? vm.cpr.evaluatedForPS : false;
        }
    }

    angular.module('ipmApp').component('internalReview', {
        bindings: {
            cpr: '='
        },
        templateUrl: 'app/qhp-workflow/care-plan-review-workflow/Internal-review/internal-review.html',
        controller: InternalReviewController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    });
})();
;
(function() {
    'use strict';


    PatientResponseSummaryController.$inject = ['$scope', '$state', '$window', 'ipmConstants', 'PatientPresentationService'];

    function PatientResponseSummaryController($scope, $state, $window, constants, PatientPresentationService) {
        var vm = this;
        vm.currentSection = 2;
        var submitDebounced = _.debounce(submitResponse, 300);

        init();

        function init() {
        }

        function submitResponse() {
            PatientPresentationService.submitResponse(vm.patientPresentation).then(function(res) {
                if (res) {
                    vm.patientPresentation = res;
                    changePatientPresentation();
                }
            });
        }

        function changePatientPresentation() {
            vm.onChange({patientPresentation: vm.patientPresentation});
            vm.isChangePatientPresentation = !vm.isChangePatientPresentation;
        }

        $scope.$watch('vm.patientPresentation', function(nval, oval) {
            if (nval === null || angular.equals(nval, oval) || vm.isSavingDrapChange) {
                return;
            }
            vm.patientPresentation.patientPresentationResponses.forEach(function(patientPresentationResponse) {
                if(patientPresentationResponse.slide.type === 'QUESTION') {
                    if(patientPresentationResponse.slide.question.type === 'MULTI_SELECT') {
                        var selected = [];
                        var keys = Object.keys(patientPresentationResponse.multiResponse);
                        for (var i = 0; i < keys.length; i++) {
                            if(patientPresentationResponse.multiResponse[keys[i]]) {
                                selected.push(parseInt(keys[i]));
                            }
                        }
                        patientPresentationResponse.response = JSON.stringify(selected);
                    }
                }
            });
            submitDebounced();
        }, true);
    }

    angular.module('ipmApp').component('patientResponseSummary', {
        bindings: {
            deck: '=',
            patientPresentation: '=',
            accordionStatus: '=',
            isPatientOpen: '=',
            isChangePatientPresentation: '=',
            slides: '<',
            isSavingDrapChange: '<',
            onChange: '&'
        },
        templateUrl: 'app/presentation-controls-instructor/presentation-patient-response/patient-response-summary/patient-response-summary.html',
        controller: PatientResponseSummaryController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    PatientResponseSummarySlideController.$inject = ['$scope'];

    function PatientResponseSummarySlideController($scope) {
        var vm = this;

        init();

        function init() {
            vm.slidesCountAll = vm.slidesCountAll ? vm.slidesCountAll : 0;
            vm.slide = vm.patientPresentationResponse ? vm.patientPresentationResponse.slide : null;
        }
    }

    angular.module('ipmApp').component('patientResponseSummarySlide', {
        bindings: {
            patientPresentationResponse: '=',
            slidesCountAll: '<'
        },
        templateUrl: 'app/presentation-controls-instructor/presentation-patient-response/patient-response-summary/patient-response-summary-slide.html',
        controller: PatientResponseSummarySlideController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    PatientResponseDetailsController.$inject = ['$scope', '$state', '$window', 'ipmConstants', 'PatientPresentationService'];

    function PatientResponseDetailsController($scope, $state, $window, constants, PatientPresentationService) {
        var vm = this;

        vm.accordionStatus = {
            responseOpen: vm.isShowResponseOpen,
            attendanceOpen: vm.isShowAttendanceOpen,
        };
        vm.currentSection = 2;
        var submitDebounced = _.debounce(submitResponse, 300);
        vm.currentResponseIndex = -1;
        vm.currentResponseId = 0;
        init();

        function init() {
            vm.isShowResponseOpen = vm.isShowResponseOpen ? vm.isShowResponseOpen : false;
            vm.currentResponseIndex = findIndexResponses();
            if (vm.currentResponseIndex > -1) {
                vm.currentResponseId = vm.patientPresentation.patientPresentationResponses[vm.currentResponseIndex].id;
            }
        }

        function findIndexResponses() {
            return _.findIndex(vm.patientPresentation.patientPresentationResponses, function(o) {
                return o.slide && vm.slide && o.slide.id === vm.slide.id;
            });
        }

        function submitResponse() {
            PatientPresentationService.submitResponse(vm.patientPresentation).then(function(res) {
                if (res) {
                    vm.patientPresentation = res;
                    changePatientPresentation();
                }
            });
        }

        function changePatientPresentation() {
            vm.onChange({patientPresentation: vm.patientPresentation});
            vm.isChangePatientPresentation = !vm.isChangePatientPresentation;
        }

        $scope.$watch('vm.isPatientOpen', function(nval, oval) {
            if(nval === null || angular.equals(nval, oval)) {
                return;
            }
            if(nval === false) {
                vm.accordionStatus.responseOpen = false;
                vm.accordionStatus.attendanceOpen = false;
            } else {
                if(vm.currentSection == 2) {
                    vm.accordionStatus.attendanceOpen = true;
                } else {
                    vm.accordionStatus.responseOpen = true;
                }
            }
        });

        $scope.$watch('vm.accordionStatus.attendanceOpen', function(nval, oval) {
            if(nval === null || angular.equals(nval, oval)) {
                return;
            }
            if(nval == true) {
                vm.currentSection = 2;
                vm.accordionStatus.responseOpen = false;
                if(vm.isPatientOpen == false) {
                    vm.isPatientOpen = true;
                }
            } else {
                if(vm.isPatientOpen && vm.patientPresentation.presentationStatus === 'PRESENT') {
                    vm.accordionStatus.responseOpen = true;
                    vm.currentSection = 1;
                } else {
                    vm.isPatientOpen = false;
                }
            }
        });

        $scope.$watch('vm.patientPresentation.patientPresentationResponses[vm.currentResponseIndex].multiResponse', function(nval, oval) {
            if(nval === null || angular.equals(nval, oval)) {
                return;
            }

            var selected = [];
            var keys = Object.keys(nval);
            for (var i = 0; i < keys.length; i++) {
                if(nval[keys[i]]) {
                    selected.push(parseInt(keys[i]));
                }
            }
            vm.patientPresentation.patientPresentationResponses[vm.currentResponseIndex].response = JSON.stringify(selected);
        }, true);

        // $scope.$watch('vm.currentResponse', function(nval, oval) {
        //     var index = findIndexResponses();
        //     if (index > -1) {
        //         vm.patientPresentation.patientPresentationResponses[index] = vm.currentResponse;
        //     } else {
        //         vm.patientPresentation.patientPresentationResponses.push(vm.currentResponse);
        //     }
        // }, true);

        $scope.$watch('vm.patientPresentation', function(nval, oval) {
            if(nval === null || angular.equals(nval, oval) || vm.isSavingDrapChange) {
                return;
            }
            submitDebounced();
        }, true);
    }

    angular.module('ipmApp').component('patientResponseDetails', {
        bindings: {
            deck: '=',
            slide: '=',
            patientPresentation: '=',
            isPatientOpen: '=',
            isChangePatientPresentation: '=',
            isShowResponseOpen: '<',
            isSavingDrapChange: '<',
            isShowAttendanceOpen: '<',
            onChange: '&'
        },
        templateUrl: 'app/presentation-controls-instructor/presentation-patient-response/patient-response-details/patient-response-details.html',
        controller: PatientResponseDetailsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    TemplateSelectController.$inject = ['$uibModal', 'ipmConstants'];

    function TemplateSelectController($uibModal, constants) {
        var vm = this; //jshint ignore:line
        vm.filterTemplate = filterTemplate;
        vm.change = change;
        vm.createOrEditTemplate = createOrEditTemplate;
        vm.selectTemplateOption;
        vm.templateType = constants.FRP_MDE_TEMPLATE.USER;

        init();

        function init() {
            _.forEach(vm.templates, function(t) { t.value = t.id ? t.id.toString() : t.value });
            if (vm.option && vm.option.id && vm.option.name) {
                vm.option.value = vm.option.id.toString();
                var template = findTemplate();
                if (!template) { // not its owner
                    vm.option.disabled = true;
                    vm.templates.unshift(vm.option);
                }
            }
            if (vm.isGlobalTemplate) {
                vm.templateType = constants.FRP_MDE_TEMPLATE.GLOBAL;
            }
        }

        function initOption() {
            return { value: "" };
        }

        function findTemplate() {
            if (!vm.option) return null;
            return _.find(vm.templates, function (t) { return t.value === vm.option.value && t.inputType === vm.inputType; });
        }

        function filterTemplate () {
            var result = _.filter(vm.templates, function (t) { return t.inputType === vm.inputType && t.active && t.type === (vm.isGlobalTemplate ? constants.FRP_MDE_TEMPLATE.GLOBAL : constants.FRP_MDE_TEMPLATE.USER); });
            if (!vm.isGlobalTemplate) {
                result.unshift({value: "create_template", name: "Create Template"});
            }
            return result;
        }

        function change() {
            if (!vm.option) {
                vm.report = '';
            } else {
                if (vm.option.value === 'create_template') {
                    createOrEditTemplate(true);
                } else {
                    var template = findTemplate();
                    if (template && template.id) {
                        var content = template.content;
                        if (vm.isGlobalTemplate && content) {
                            if (vm.gender) {
                                var isFemale = vm.gender.toLowerCase() === 'female';
                                var heShe = isFemale ? 'she' : 'he';
                                var heSheFirstUpperCase = isFemale ? 'She' : 'He';
                                var mrMsFirstUpperCase = isFemale ? 'Ms' : 'Mr';
                                var hisHer = isFemale ? 'her' : 'his';
                                content = content.replaceAll('<he/she>', heShe);
                                content = content.replaceAll('<his/her>', hisHer);
                                content = content.replaceAll('<HE/SHE>', heSheFirstUpperCase);
                                content = content.replaceAll('<MR/MS>', mrMsFirstUpperCase);
                            }
                            if (vm.lastname) {
                                content = content.replaceAll('<LASTNAME>', vm.lastname);
                            }
                        }
                        if (vm.isReportType && template.name) {
                            vm.reportType = template.name;
                        }
                        vm.report = content;
                    }
                }
            }

        }

        function createOrEditTemplate(isCreate) {
            var template;
            if (isCreate) {
                template = {
                    type: constants.FRP_MDE_TEMPLATE.USER,
                    inputType: vm.inputType,
                    active: true
                }
            } else {
                template = findTemplate();
            }
            if (template.disabled || vm.isDisabled) return; // reject edit if not its owner or view mode
            $uibModal.open({
                templateUrl: 'app/frp-mde/template/template-dialog.html',
                controller: 'FRPMDETemplateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'center-modal',
                size: 'md',
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    titleKey: function() {
                        return vm.controlTitleKey;
                    },
                    template: function() {
                        return template;
                    }
                }
            }).result.then(function (data) {
                // create -> not apply new content, add new template to dropdown, reset dropdown to 'Select Template'
                // edit -> apply new content, keep current dropdown selected
                // delete -> reset dropdown to 'Select Template'
                // cancel create request -> reset dropdown to 'Select Template'
                // cancel edit request -> keep current dropdown selected
                if (isCreate) { // create
                    vm.option = initOption();
                    template = data.toJSON();
                    template.value = template.id.toString();
                    vm.templates.push(template);
                    vm.report = template.content;
                    vm.option = template;
                } else if (template.id) {
                    if (data === 'delete_template_success') {
                        template.active = false;
                    } else {
                        template = data.toJSON();
                        template.value = template.id.toString();
                        vm.report = template.content;
                        vm.option = template;
                    }
                }
            }, function (err) {
                if (template && !template.id) {
                    vm.option = initOption();
                }
            });
        }
    }

    angular.module('ipmApp').component('templateSelect', {
        bindings: {
            templates: '<',
            report: '=',
            inputType: '<',
            controlTitleKey: '<',
            isDisabled: '<',
            option: '=',
            isGlobalTemplate: '<',
            isAllowClearTemplate: '<',
            gender: '<',
            lastname: '<',
            isReportType: '<',
            reportType: '='
        },
        templateUrl: 'app/frp-mde/template/components/template-select.html',
        controller: TemplateSelectController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    selectStatusFrpController.$inject = ['ipmConstants'];

    function selectStatusFrpController(constants) {
        var vm = this; //jshint ignore:line
        vm.frpStatus = constants.FRP_STATUS;
        init();

        function init() {
        }

        vm.changeStatusFrpSelected = function () {
            vm.onChangeStatus({data: vm.patientFrp});
        }

    }

    angular.module('ipmApp').component('selectStatusFrp', {
        bindings: {
            isView: '<',
            patientFrp: '=',
            onChangeStatus: '&'
        },
        templateUrl: 'app/frp-mde/tab/select-status-frp/select-status-frp.html',
        controller: selectStatusFrpController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    reportFinalizedViewController.$inject = [];

    function reportFinalizedViewController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
        }

        vm.reportFinalizedStyle = function (type) {
            if (type === 'GREEN_DOT') {
                return 'report bg-success';
            } else if (type === 'GREY_DOT') {
                return 'report bg-info';
            } else { //  (type === 'ORANGE_DOT')
                return 'report bg-warning';
            }
        }
    }

    angular.module('ipmApp').component('reportFinalizedView', {
        bindings: {
            reportFinalizedType: '<'
        },
        templateUrl: 'app/frp-mde/tab/report-finalized-view/report-finalized-view.html',
        controller: reportFinalizedViewController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    mdeController.$inject = ['$state', '$rootScope', '$scope','ipmConstants', 'frpMdeService', '$filter', 'MdeReportService'];

    function mdeController($state, $rootScope, $scope, constants, frpMdeService, $filter, MdeReportService) {
        var vm = this; //jshint ignore:line
        vm.page = 1;
        vm.predicate = 'mder.status';
        vm.reverse = false;
        vm.pageSize = 15;
        vm.totalItems = 0;
        vm.patientFrpMdes = [];
        vm.constants = constants;
        vm.mdeStatus = constants.MDE_STATUS;
        vm.statusDefault = ['MDE_PENDING', 'MDE_IN_PROGRESS'];
        vm.status = [];
        vm.loadAll = loadAll;
        vm.search = search;
        vm.downloadReport = downloadReport;
        vm.isDownLoading = false;
        init();

        function init() {
            if (vm.status && vm.status.length === 0) {
                vm.status = angular.copy(vm.statusDefault);
            }
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };
            var param = {
                officeId: null,
                query: vm.searchQuery,
                mdeStatus: vm.status && vm.status.length === 0 ? vm.mdeStatus : vm.status,
                frpProgramIds: getFrpProgramIds(),
            };
            frpMdeService.getMDE(param,pageable).then(function(res) {
                vm.patientFrpMdes = res.data;
                vm.totalItems = res.headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                // implement progress trackers
                _.forEach(vm.patientFrpMdes, function(patientFrpMde) {

                    if (!patientFrpMde.startDate) { // not yet create MDE Report
                        patientFrpMde.displayStartButton = true;
                    }

                    patientFrpMde.processTrackers = [];
                    // Admin
                    patientFrpMde.processTrackers.push({text: 'frpmdeDashboard.mdeTab.processTracker.admin', status: patientFrpMde.allReportStatus[0]});

                    // Medical
                    patientFrpMde.processTrackers.push({text: 'frpmdeDashboard.mdeTab.processTracker.medical', status: patientFrpMde.allReportStatus[1]});

                    // PT
                    patientFrpMde.processTrackers.push({text: 'frpmdeDashboard.mdeTab.processTracker.pt', status: patientFrpMde.allReportStatus[2]});

                    // Psych
                    patientFrpMde.processTrackers.push({text: 'frpmdeDashboard.mdeTab.processTracker.psych', status: patientFrpMde.allReportStatus[3]});

                    // Conclusion
                    patientFrpMde.processTrackers.push({text: 'frpmdeDashboard.mdeTab.processTracker.conclusion', status: patientFrpMde.allReportStatus[4]});
                });
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'mder.id') {
                result.push('mder.id' + ',' + (vm.reverse ? 'asc' : 'desc'));
            }
            return result;
        }

        function search() {
            vm.loadAll();
        }

        function downloadReport(patientFrpMde) {
            if (patientFrpMde && patientFrpMde.mdeReportId && !vm.isDownLoading) {
                vm.isDownLoading = true;
                MdeReportService.downloadMDEReport(patientFrpMde.mdeReportId).then(function (response) {
                    vm.isDownLoading = false;
                });
            }
        }

        vm.startReport = function(patientFrpMdeId) {
            MdeReportService.createMdeReport(patientFrpMdeId).then(function(res) {
                goToMdeReportBuilder(res.data);
            });
        }

        vm.editReport = function(id) {
            goToMdeReportBuilder(id);
        }

        vm.viewReport = function(id) {
            goToMdeReportBuilder(id);
        }

        function goToMdeReportBuilder(id) {
            $state.go('mde-report', { id: id });
        }

        function filterFrpProgramIds() {
            if (vm.frpPrograms) {
                return $filter('filter')(vm.frpPrograms).map(function (item) {
                    return item.id;
                });
            }
            return [];
        }

        function getFrpProgramIds() {
            if (vm.frpProgramId) {
                return [vm.frpProgramId];
            } else {
                return filterFrpProgramIds();
            }
        }

        vm.selectedStatus = function() {
            vm.loadAll();
        }

        $scope.$on("CHANGE_PROGRAM_FRP_MDE_DROPDOWN", function(event, res) {
            vm.frpProgramId = res;
            loadAll();
        });

        $scope.$on(constants.ADD_ENROLL_SUCCESS, function() {
            loadAll();
        });

    }

    angular.module('ipmApp').component('mdeTab', {
        bindings: {
            frpProgramId: '<',
            frpPrograms: '<',
            isView: '<'
        },
        templateUrl: 'app/frp-mde/tab/mde/mde.html',
        controller: mdeController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        },
        bindToController: true
    })
})();
;
(function() {
    'use strict';


    inactivePatientsController.$inject = ['$rootScope', '$scope', 'frpMdeService', 'ipmConstants'];

    function inactivePatientsController($rootScope, $scope, frpMdeService, constants) {
        var vm = this; //jshint ignore:line
        vm.page = 1;
        vm.predicate = 'us.firstName';
        vm.reverse = false;
        vm.pageSize = 15;
        vm.totalItems = 0;
        vm.inactivePatients = [];
        vm.inactivePatientsOld = [];
        vm.inactivePatientsStatus = constants.INACTIVE_PATIENTS_STATUS;
        vm.loadAll = loadAll;
        vm.search = search;
        init();

        function init() {
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };
            var param = { officeId: null, query: vm.searchQuery,
                mdeStatus: filterStatusMDE(vm.status),
                frpStatus: filterStatusFRP(vm.status),
                frpProgramIds: getFrpProgramIds() };
            frpMdeService.inactivePatient(param, pageable).then(function (res) {
                vm.inactivePatientsOld = res.data;
                vm.inactivePatients = Object.assign({}, vm.inactivePatientsOld);
                vm.totalItems = res.headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
            });
        }

        function filterStatusFRP(status) {
            if (status) {
                var statusFRPInactive = ['FRP_GRADUATED', 'FRP_EARLY_DISCHARGE', 'FRP_INACTIVE_HOLD'];
                return _.filter(statusFRPInactive, function (item) {
                    return item && item === status;
                });
            }
        }


        function filterStatusMDE(status) {
            if (status) {
                var statusMDEInactive = ['MDE_COMPLETED_NOT_RECOMMENDED','MDE_ABANDONED'];
                return _.filter(statusMDEInactive, function (item) {
                    return item && item === status;
                });
            }
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        function search() {
            vm.loadAll();
        }

        function filterFrpProgramIds() {
            if (vm.frpPrograms) {
                return $filter('filter')(vm.frpPrograms).map(function (item) {
                    return item.id;
                });
            }
            return [];
        }

        function getFrpProgramIds() {
            if (vm.frpProgramId) {
                return [vm.frpProgramId];
            } else {
                return filterFrpProgramIds();
            }
        }

        vm.filterStatus = function () {
            vm.loadAll();
        }

        $scope.$on("CHANGE_PROGRAM_FRP_MDE_DROPDOWN", function(event, res) {
            vm.frpProgramId = res;
            loadAll();
        });
    }

    angular.module('ipmApp').component('inactivePatientsTab', {
        bindings: {
            frpProgramId: '<',
            frpPrograms: '<'
        },
        templateUrl: 'app/frp-mde/tab/inactive-patients/inactive-patients.html',
        controller: inactivePatientsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        },
        bindToController: true
    })
})();
;
(function() {
    'use strict';


    frpController.$inject = ['$state', '$rootScope', '$scope', 'frpMdeService', 'FrpReportService', '$timeout', 'ipmConstants', '$filter', 'DateUtils', '$uibModal', 'DataUtils', 'ClearLocalStorageService'];

    function frpController($state, $rootScope, $scope, frpMdeService, FrpReportService, $timeout, constants, $filter, DateUtils, $uibModal, DataUtils, ClearLocalStorageService) {
        var vm = this; //jshint ignore:line
        vm.page = 1;
        vm.pageSize = 15;
        vm.predicate = 'pfm.id';
        vm.reverse = false;
        vm.totalItems = 0;
        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.startDate = moment();
        vm.endDate = moment();
        vm.dateFormat = "MM/dd/yyyy";
        vm.datePickerOpenStatus = {startDate: false, endDate: false};
        vm.dateOptions = {
            dateDisabled: dateDisabled,
            formatYear: 'yyyy',
            startingDay: 6
        };

        vm.frpStatus = constants.FRP_STATUS_FILTER;
        vm.isLoading = false;
        vm.isDownLoading = false;
        vm.isSaving = false;
        vm.loadAll = loadAll;
        vm.frps = [];
        vm.attendanceTrackers = [];
        vm.checkDisableAttendanceTracker = checkDisableAttendanceTracker;
        vm.checkEditReport = checkEditReport;
        vm.formatStartDatePrevious = formatStartDatePrevious;
        vm.downloadReport = downloadReport;
        vm.openEnrollPatient = openEnrollPatient;
        vm.daysExtend = 6;
        vm.numberDayOfWeekEnable = 6; // saturday
        vm.numberDayOfWeekStartDate = 6;

        init();

        function init() {
            setDefaultStatus();
            setStartDate();
            setEndDate(vm.startDate);
            vm.loadAll();
        }

        vm.openStartDate = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changedTime = function () {
            if (vm.startDate) {
                $timeout(function () {
                    if (vm.startDate) {
                        setEndDate(vm.startDate);
                        vm.loadAll();
                    }
                }, 500);
            }
        };

        function setDefaultStatus() {
            vm.status = 'FRP_ENROLLED';
        }

        function setStartDate() {
            var numDayOfWeek = vm.startDate.day();
            if (numDayOfWeek === vm.numberDayOfWeekStartDate) { // Check if the current day is already Saturday
                vm.startDate = vm.startDate.toDate();
                return;
            }
            // Calculate the previous week's Saturday
            var theSaturdayOfPreviousWeek = vm.startDate.clone().subtract(1, 'week').day(vm.numberDayOfWeekStartDate);
            // Update startDate if theSaturdayOfPreviousWeek is a valid moment object
            if (theSaturdayOfPreviousWeek) {
                vm.startDate = theSaturdayOfPreviousWeek.toDate();
            }
        }

        function setEndDate(startDate) {
            vm.endDate = moment(new Date(startDate)).add(vm.daysExtend, 'd').toDate(); // add 6 days
        }

        function frpReportAdminIsCompleted(frp) {
            return frp && frp.frpReport && frp.frpReport.frpReportAdmin && frp.frpReport.frpReportAdmin.status === 'COMPLETE';

        }
        function checkDisableAttendanceTracker(frp) {
            return checkIsFRPHold(frp) || !checkEditReport(frp) || frpReportAdminIsCompleted(frp);
        }

        function checkEditReport(frp) {
            return frp && frp.reportStatus === constants.FRP_REPORT_STATUS_VIEW.EDIT_REPORT;
        }
        function checkIsFRPHold(frp) {
            // 4.	Disable these buttons if the status is FRP Hold
            return frp && frp.frpStatus === 'FRP_ACTIVE_HOLD';
        }

        vm.search = function () {
            return vm.loadAll();
        };

        vm.filterStatus = function () {
                vm.loadAll();
        };

        vm.filterByDate = function () {
            vm.loadAll();
        };

        function filterFrpProgramIds() {
            if (vm.frpPrograms) {
                return $filter('filter')(vm.frpPrograms).map(function (item) {
                    return item.id;
                });
            }
            return [];
        }

        function getFrpProgramIds() {
            if (vm.frpProgramId) {
                return [vm.frpProgramId];
            } else {
                return filterFrpProgramIds();
            }
        }

        function loadAll() {
            if (!vm.startDate) {
                return;
            }
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };
            var startDate = null;
            var endDate = null;
            if (vm.startDate) {
                startDate = $filter('date')(vm.startDate, vm.dateFormatToServer);
            }
            if (vm.endDate) {
                endDate = $filter('date')(vm.endDate, vm.dateFormatToServer);
            }
            var param = {
                patientId: null,
                frpProgramIds: getFrpProgramIds(),
                frpStatus: vm.status ? [vm.status] : [],
                startDate: startDate ? startDate : null,
                endDate: endDate ? endDate : null,
                query: vm.searchQuery
            };
            frpMdeService.getFPR(param, pageable).then(function (response) {
                vm.frps = response && response.data ? response.data : [];
                _.forEach(vm.frps, function(frp) {
                    if (frp.frpReport && frp.frpReport.attendanceTracker) {
                        frp.frpReport.attendanceTracker.isInValidAttendance = isInValidAttendance(frp.frpReport.attendanceTracker, frp.frpReport.patientFRPMDE, frp.frpReport.sumAtHours);
                    }
                });
                vm.isLoading = false;
                vm.totalItems = response.headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                setWarningMessagePreviousWeek(vm.frps)
            }, function error(error) {
                if (vm.frpProgramId) {
                    ClearLocalStorageService.addFRPProgramsError(vm.frpProgramId);
                }
                openErrorDialog();
            });
        };

        function sort() {
            var result = [];
            if (vm.predicate == 'authorizedHours') {
                result.push('sumAuthorizedHours' + ',' + (vm.reverse ? 'asc' : 'desc'));
            } else if (vm.predicate == 'remainingHours') {
                result.push('remainingHours' + ',' + (vm.reverse ? 'asc' : 'desc'));
            } else if (vm.predicate == 'patient') {
                result.push('pa.user.firstName' + ',' + (vm.reverse ? 'desc' : 'asc'));
                result.push('pa.user.lastName' + ',' + (vm.reverse ? 'desc' : 'asc'));
                result.push('pa.patientId' + ',' + (vm.reverse ? 'desc' : 'asc'));
            } else {
                result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            }
            return result;
        }

        vm.btnBackClick = function () {
            reloadAttendanceTrackersChange();
            setWeekPrevious();

            // start filter
            vm.filterByDate();
        };

        vm.btnNextClick = function () {
            reloadAttendanceTrackersChange();
            setWeekNext();
            // start filter
            vm.filterByDate();
        };

        function setWeekPrevious() {
            vm.startDate = moment(new Date(vm.startDate)).subtract(1, "w").toDate();
            vm.endDate = moment(new Date(vm.endDate)).subtract(1, "w").toDate();
        };

        function setWeekNext() {
            vm.startDate = moment(new Date(vm.startDate)).add(1, "w").toDate();
            vm.endDate = moment(new Date(vm.endDate)).add(1, "w").toDate();
        };

        // only Enable saturday selection
        function dateDisabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() !== vm.numberDayOfWeekEnable); // 6 is Saturday
        }

        function reloadAttendanceTrackersChange() {
            if (vm.frps && vm.frps.length > 0) {
                vm.frps.forEach(function (item) {
                    if (item && item.frpReport) {
                        item.frpReport.attendanceTracker = createNewAttendanceTracker();
                    }
                });
            }
        }

        vm.attendanceTrackersChange = function (attendanceTracker, frp) {
            if (attendanceTracker) {
                if (!isInValidAttendance(attendanceTracker, frp.frpReport.patientFRPMDE, frp.frpReport.sumAtHours)) {
                    frp.frpReport.attendanceTracker = attendanceTracker;
                    saveAttendanceTracker(frp);
                } else {
                    frp.frpReport.attendanceTracker.isInValidAttendance = true;
                }
            }
        };

        vm.onChangeStatusFRP = function(data) {
            if (data) {
                FrpReportService.updateStatusFRP(data).then(function (res) {
                    if (res) {
                        loadAll();
                    }
                });
            }
        }

        function saveAttendanceTracker(frp) {
            FrpReportService.savedAttendanceTracker(frp).then( function (res) {
                if (res) {
                    loadAll();
                }
            });
        }

        function createNewAttendanceTracker() {
            var attendanceTracker = {
                id: null,
                mon: null,
                tue: null,
                wed: null,
                thu: null,
                fri: null,
                sat: null, 
                sun: null
            };
            return attendanceTracker;
        }

        function getPoint(attendanceTracker) {
            if (attendanceTracker) {
                return constants.NUMBER_HRS_ATTENDED * DataUtils.countAttendanceTrackerNotAbsent(attendanceTracker);
            }
            return 0;
        }
        
        function isInValidAttendance(attendanceTracker, patientFRPMDE, initCheckedAttended) {
            var totalHoursAttended = patientFRPMDE.previouslyCompletedHours + patientFRPMDE.sumHoursDaysAttended;
            return totalHoursAttended - initCheckedAttended + getPoint(attendanceTracker) > constants.HOURS_ATTENDED_CAN_NOT_EXCEED;
        }

        $scope.$on("CHANGE_PROGRAM_FRP_MDE_DROPDOWN", function(event, res) {
            vm.frpProgramId = res;
            loadAll();
        });

        $scope.$on(constants.ADD_ENROLL_SUCCESS, function() {
            loadAll();
        });

        vm.checkDisableStatus = function(frp) {
            if (frp && vm.isView) {
                return frp.reportStatus !== constants.FRP_REPORT_STATUS_VIEW.EDIT_REPORT && frp.reportStatus !== constants.FRP_REPORT_STATUS_VIEW.VIEW_REPORT;
            }
            return false;
        }

        vm.openReport = function (frp) {
            if (frp) {
                if (frp.reportStatus === constants.FRP_REPORT_STATUS_VIEW.FRP_REPORT_PREVIOUS_NOT_FINALIZED) {
                    createFrpReport(frp);
                } else if (frp.reportStatus === constants.FRP_REPORT_STATUS_VIEW.EDIT_REPORT && frp.frpReport) {
                    goToFrpReportBuilder(frp.frpReport.id)
                } else if (frp.reportStatus === constants.FRP_REPORT_STATUS_VIEW.VIEW_REPORT && frp.frpReport) {
                    goToFrpReportBuilder(frp.frpReport.id)
                } else { // ADD_NEW_REPORT
                    createFrpReport(frp);
                }
            }
        }

        function createNewFRPReportBySelectedDate(reportStatus) {
            return {
                startDate: DateUtils.convertLocalDateToServer(vm.startDate),
                endDate: DateUtils.convertLocalDateToServer(vm.endDate),
                reportStatus: reportStatus
            };
        }

        function createFrpReport(frp) {
            frp.frpReport = createNewFRPReportBySelectedDate(constants.FRP_REPORT_STATUS_VIEW.ADD_NEW_REPORT);
            vm.isSaving = true;
            FrpReportService.createFrpReport(frp).then(function(res) {
                goToFrpReportBuilder(res.id);
                vm.isSaving = false;
            });
        }

        function goToFrpReportBuilder(id) {
            $state.go('frp-report', { id: id });
        }

        function goToHome() {
            $state.go('home');
        }

        function formatStartDatePrevious(date) {
            if (date) {
                var dateFormat = moment(date).format("MMMM Do"); // ex: February 14th
                if (dateFormat) {
                    return dateFormat.replace(/(\d)(st|nd|rd|th)/g, '$1<sup>$2</sup>');
                }
            }
            return '';
        }

        function downloadReport(frp) {
            if (frp && frp.frpReport && frp.frpReport.id && !vm.isDownLoading) {
                vm.isDownLoading = true;
                FrpReportService.downloadFrpReport(frp.frpReport.id).then(function (response) {
                    vm.isDownLoading = false;
                });
            }
        }

        function setWarningMessagePreviousWeek(frps) {
            vm.isShowWarningMessagePreviousWeekNotFinalized = !_.isEmpty(_.filter(frps, function (frp) {
                return frp && frp.id && frp.reportStatus === constants.FRP_REPORT_STATUS_VIEW.FRP_REPORT_PREVIOUS_NOT_FINALIZED;
            }));
        }

        vm.checkPreviousWeekNotFinalized = function (frp) {
            if (frp && frp.id && frp.reportStatus === constants.FRP_REPORT_STATUS_VIEW.FRP_REPORT_PREVIOUS_NOT_FINALIZED) {
                return 'link-danger';
            }
            return '';
        }

        function openEnrollPatient() {
            $uibModal.open({
                templateUrl: 'app/frp-mde/tab/frp/enroll-patient/enroll-patient-dialog.html',
                controller: 'EnrollPatientDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    frpProgramId: function () {
                        return vm.frpProgramId
                    },
                    frpStartDate: function () {
                        return vm.startDate;
                    }

                }
            }).result.then(function (result) {
                if (result) {
                    loadAll();
                }
            }, function () {
            });
        }

        /**
         * @param frp
         * @returns reportStatus
         */
        vm.getReportStatus = function (frp) {
            if (frp && frp.frpReport && frp.frpReport.id) {
                if (frp.frpReport.statusFinal === 'FINALIZED') {
                    return constants.FRP_REPORT_STATUS_VIEW.VIEW_REPORT;
                } else if (frp.frpReport.statusFinal === 'OPEN') {
                    return constants.FRP_REPORT_STATUS_VIEW.EDIT_REPORT;
                }
            }
            return constants.FRP_REPORT_STATUS_VIEW.ADD_NEW_REPORT;
        }

        vm.checkShowDownload = function (frp) {
            return frp && frp.frpReport && frp.reportStatus === 'VIEW_REPORT' && frp.frpReport.statusFinal === 'FINALIZED';
        }

        function openErrorDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.frpReport.error.loadReportErrorMessage"},
                    title: function () {return "ipmApp.frpReport.error.title"}
                }
            }).result.then(function() {
                goToHome();
            }, function() {
            });
        }
    }

    angular.module('ipmApp').component('frpTab', {
        bindings: {
            frpProgramId: '<',
            frpPrograms: '<',
            isView: '<',
            isShowWarningMessagePreviousWeekNotFinalized: '='
        },
        templateUrl: 'app/frp-mde/tab/frp/frp.html',
        controller: frpController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate','$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('attendanceTracker');
                return $translate.refresh();
            }]
        },
        bindToController: true
    })
})();

;
(function() {
    'use strict';


    checkBoxVController.$inject = [];

    function checkBoxVController() {
        var vm = this; //jshint ignore:line
        vm.typeUnCheck = 0; // 0 = case check null
        vm.typeCheckV = 1; // 1 = case check v
        vm.typeCheckX = 2; // 2 = case check X
        init();

        function init() {
            vm.isView = vm.isView ? true : false;
        }

        vm.checkboxChange = function (itemValue, itemType) {
                if (itemValue === vm.value) {
                    if (itemType === vm.typeUnCheck) {
                        vm.check = true;
                        vm.type = vm.typeCheckV;
                    } else if (itemType === vm.typeCheckV) {
                        vm.check = true;
                        vm.type = vm.typeCheckX;
                    } else if (itemType === vm.typeCheckX) {
                        vm.check = false;
                        vm.type = vm.typeUnCheck;
                    }
                }
            vm.onChange({value: vm.value, check: vm.check, type: vm.type});
        }
    }

    angular.module('ipmApp').component('checkBoxV', {
        bindings: {
            value: '=',
            check: '=',
            type: '=',
            id: '<',
            isView: '<',
            onChange: '&',
        },
        templateUrl: 'app/frp-mde/tab/attendance-tracker/check-box-v.html',
        controller: checkBoxVController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        },
        bindToController: true
    })
})();
;
(function() {
    'use strict';


    attendanceTrackerController.$inject = ['$rootScope', '$scope', 'ipmConstants'];

    function attendanceTrackerController($rootScope, $scope, constants) {
        var vm = this; //jshint ignore:line
        // vm.attendanceTrackers = [];
        vm.typeUnCheck = 0; // case check null
        vm.typeCheckV = 1; // case check V
        vm.typeCheckX = 2; // case check X
        vm.checkDisableInFuture = checkDisableInFuture;

        init();

        function init() {
            if (!vm.attendanceTrackers || vm.attendanceTrackers.length === 0) { // init data first
                vm.attendanceTrackers = [];
                _.forEach(constants.ATTENDANCE_TRACKERS, function (i) {
                    vm.attendanceTrackers.push(createAttendanceTracker(i, 0, false));
                });
            }
            updateAttendanceTracker(vm.attendanceTracker);
            // } else {
            //     vm.attendanceTracker = initAttendanceTrackerDefault();
            // }
        }

        function updateAttendanceTracker(attendanceTracker) {
            if (attendanceTracker) {
                _.forEach(vm.attendanceTrackers, function (item) {
                    return item = attendanceTrackerToCheckBox(attendanceTracker, item);
                });
            } else {
                vm.attendanceTracker = initAttendanceTrackerDefault();
            }
        }

        function initAttendanceTrackerDefault() {
            var attendanceTracker = {
                id: null,
                mon: null,
                tue: null,
                wed: null,
                thu: null,
                fri: null,
                sat: null,
                sun: null
            };
            return attendanceTracker;
        }

        function attendanceTrackerToCheckBox(attendanceTracker, checkBoxV) {
            var atSelect;
            if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[0]) { // sat
                atSelect = attendanceTracker.sat;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[1]) { // sun
                atSelect = attendanceTracker.sun;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[2]) { // M mon
                atSelect = attendanceTracker.mon;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[3]) { // tue
                atSelect = attendanceTracker.tue;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[4]) { // wed
                atSelect = attendanceTracker.wed;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[5]) { // thu
                atSelect = attendanceTracker.thu;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[6]) { // fri
                atSelect = attendanceTracker.fri;
            }

            if (atSelect && atSelect === true) {
                checkBoxV.type = vm.typeCheckV;
                checkBoxV.check = true;
            } else if (atSelect === false) {
                checkBoxV.type = vm.typeCheckX;
                checkBoxV.check = true;
            } else {
                checkBoxV.type = vm.typeUnCheck;
                checkBoxV.check = false;
            }
            return checkBoxV;
        }

        function checkBoxToAttendanceTracker(checkBoxV, attendanceTracker) {
            if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[0]) { // sat
                attendanceTracker.sat = checkBoxV.type == vm.typeUnCheck ? null : checkBoxV.type == vm.typeCheckV ? true : false;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[1]) { // sun
                attendanceTracker.sun = checkBoxV.type == vm.typeUnCheck ? null : checkBoxV.type == vm.typeCheckV ? true : false;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[2]) { // M mon
                attendanceTracker.mon = checkBoxV.type == vm.typeUnCheck ? null : checkBoxV.type == vm.typeCheckV ? true : false;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[3]) { // tue
                attendanceTracker.tue = checkBoxV.type == vm.typeUnCheck ? null : checkBoxV.type == vm.typeCheckV ? true : false;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[4]) { // wed
                attendanceTracker.wed = checkBoxV.type == vm.typeUnCheck ? null : checkBoxV.type == vm.typeCheckV ? true : false;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[5]) { // thu
                attendanceTracker.thu = checkBoxV.type == vm.typeUnCheck ? null : checkBoxV.type == vm.typeCheckV ? true : false;
            } else if (checkBoxV.value === constants.ATTENDANCE_TRACKERS[6]) { // fri
                attendanceTracker.fri = checkBoxV.type == vm.typeUnCheck ? null : checkBoxV.type == vm.typeCheckV ? true : false;
            } 
            return attendanceTracker;
        }

        function convertCheckBoxsToAttendanceTracker() {
            _.forEach(vm.attendanceTrackers, function (item) {
                vm.attendanceTracker = checkBoxToAttendanceTracker(item, vm.attendanceTracker);
            });
        }

        function createAttendanceTracker(value, type, check) {
            return {value: value, type: type, check: check};
        }

        function updateAttendanceTrackers(value, check, type) {
            _.forEach(vm.attendanceTrackers, function (item) {
                if (item.value === value) {
                    item.check = check;
                    item.type = type;
                }
            });
        }

        function checkDisableInFuture(at) {
            var now = new moment();
            // case week future
            if (moment(vm.startDate).isAfter(now)) {
                return true;
            }
            // only check week current
            var valueOfDate = moment().day(at.value).subtract(2, 'days');
            if (vm.startDate
                && vm.endDate
                && now.isAfter(vm.startDate)
                && now.isBefore(vm.endDate)
                && now.isBefore(valueOfDate)) {
                return true;
            }
            return false;
        }

        vm.checkboxChange = function (value, check, type) {
            updateAttendanceTrackers(value, check, type);
            convertCheckBoxsToAttendanceTracker();
            vm.onChange({attendanceTracker: vm.attendanceTracker});
        }

        $scope.$watch('vm.attendanceTracker', function (newValue) {
            updateAttendanceTracker(vm.attendanceTracker);
        });
    }

    angular.module('ipmApp').component('attendanceTracker', {
        bindings: {
            attendanceTracker: '=',
            isView: '<',
            disableInFuture: '<',
            startDate: '<',
            endDate: '<',
            onChange: '&'
        },
        templateUrl: 'app/frp-mde/tab/attendance-tracker/attendance-tracker.html',
        controller: attendanceTrackerController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        },
        bindToController: true
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('MDEReportPTPController', MDEReportPTPController);

    MDEReportPTPController.$inject = ['$scope', '$state', '$uibModal', 'mdeReport', 'templates', 'ipmConstants', '$window', 'MdeReportService', 'FRPMDETemplateService', 'DataUtils', 'isView'];

    function MDEReportPTPController($scope, $state, $uibModal, mdeReport, templates, ipmConstants, $window, MdeReportService, FRPMDETemplateService, DataUtils, isView) {
        var vm = this;
        vm.mdeReport = mdeReport ? mdeReport : {};
        vm.templates = templates ? templates : [];
        vm.mdeReportOld = {};
        vm.presentComplaintsSelect = null;
        vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';
        vm.templateInputType = ipmConstants.FRP_MDE_TEMPLATE;

        vm.save = save;
        vm.isRequired = true;
        vm.isFinalize = false;
        vm.isDisabled = false;
        vm.isChanged = isChanged;
        vm.isView = isView ? true : vm.mdeReport ? vm.mdeReport.statusFinal === ipmConstants.STATUS_FINAL_FRP_MDE : false;
        vm.submitted = false;
        vm.fieldRequrieds = [
            'historyofPresentIllness',
            'mechanismOfInjury',
            'presentComplaints',
            'conservativeCare',
            'surgicalHistory',
            'currentMedications',
            'summaryAndRecommendations'
        ];

        vm.dataHeaderReport = {};

        init();

        function init() {
            setTemplateValue();
            vm.mdeReportOld = DataUtils.deepCopy(mdeReport);
            vm.isFinalize = vm.mdeReport && vm.mdeReport.mdeReportMediacal
            && (vm.mdeReport.mdeReportMediacal.status === 'COMPLETE') ? true : false;
            setIsDisabled();
            vm.dataHeaderReport = buildDataHeaderReport(vm.mdeReport.patientFRPMDE);
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    mdeOfficeName: patientFRPMDE.mdeOfficeName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };

        function setTemplateValue() {
            if (mdeReport && mdeReport.mdeReportMediacal) {
                templateValue(mdeReport.mdeReportMediacal.historyofPresentIllnessTemplate);
                templateValue(mdeReport.mdeReportMediacal.mechanismOfInjuryTemplate);
                templateValue(mdeReport.mdeReportMediacal.presentComplaintsTemplate);
                templateValue(mdeReport.mdeReportMediacal.conservativeCareTemplate);
                templateValue(mdeReport.mdeReportMediacal.surgicalHistoryTemplate);
                templateValue(mdeReport.mdeReportMediacal.summaryAndRecommendationsTemplate);
            }
        }

        function templateValue(template) {
            if (template && template.id) {
                template.value = template.id.toString();
                if (!_.find(vm.templates, function (t) { return t.id === template.id && t.inputType === template.inputType; })) {
                    template.disabled = true;
                }
            }
        }

        function setIsDisabled() {
            if (vm.isView || (vm.mdeReport.patientFRPMDE && (vm.mdeReport.status === 'MDE_ABANDONED' || vm.mdeReport.patientFRPMDE.isViewFrpProgram))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

        function isChanged() {
            for (var field in vm.mdeReport.mdeReportMediacal) {
                if (!vm.mdeReport.mdeReportMediacal[field]) {
                    vm.mdeReport.mdeReportMediacal[field] = null;
                }
            }
            for (var fieldOld in vm.mdeReportOld.mdeReportMediacal) {
                if (!vm.mdeReportOld.mdeReportMediacal[fieldOld]) {
                    vm.mdeReportOld.mdeReportMediacal[fieldOld] = null;
                }
            }
            return !angular.equals(vm.mdeReport, vm.mdeReportOld);
        }

        vm.cancel = function() {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                goToMdeReport();
            }
        }

        vm.confirmDialog = function (message) {
            if (vm.isView) {
                return;
            }
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                       return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    goToMdeReport();
                }
            });
        }

        function goToMdeReport() {
            $state.go('mde-report', {id: vm.mdeReport.id});
        }

        vm.finalize = function () {
            vm.isRequired = true;
            if (vm.isView) {
                return;
            }
            checkValidation();
            if (vm.editForm.$invalid) {
                return;
            }
            this.submitted = true;
            vm.isSaving = true;
            if (vm.mdeReport) {
                // vm.mdeReport.mdeReportMediacal.status = 'COMPLETE';
                vm.mdeReport.finalize = true;
                MdeReportService.saveMDEReportPTP(vm.mdeReport).then(function (response) {
                    onSaveSuccess(response)
                }, function error(e) {
                    onSaveError(e);
                });
            }
        }

        function checkValidation() {
            vm.fieldRequrieds.forEach(function (field) {
                if (field && vm.editForm[field]) {
                    vm.editForm[field].$setDirty();
                }
            });
        }

        function save() {
            // vm.isRequired = false;
            // checkValidation();
            // if (vm.editForm.$invalid) {
            //     return;
            // }
            vm.isSaving = true;
            if (vm.mdeReport) {
                if (vm.mdeReport.mdeReportMediacal) {
                    if (vm.mdeReport.mdeReportMediacal.historyofPresentIllnessTemplate && vm.mdeReport.mdeReportMediacal.historyofPresentIllnessTemplate.content != vm.mdeReport.mdeReportMediacal.historyofPresentIllness) {
                        vm.mdeReport.mdeReportMediacal.historyofPresentIllnessTemplate = null;
                    }
                    if (vm.mdeReport.mdeReportMediacal.mechanismOfInjuryTemplate && vm.mdeReport.mdeReportMediacal.mechanismOfInjuryTemplate.content != vm.mdeReport.mdeReportMediacal.mechanismOfInjury) {
                        vm.mdeReport.mdeReportMediacal.mechanismOfInjuryTemplate = null;
                    }
                    if (vm.mdeReport.mdeReportMediacal.presentComplaintsTemplate && vm.mdeReport.mdeReportMediacal.presentComplaintsTemplate.content != vm.mdeReport.mdeReportMediacal.presentComplaints) {
                        vm.mdeReport.mdeReportMediacal.presentComplaintsTemplate = null;
                    }
                    if (vm.mdeReport.mdeReportMediacal.conservativeCareTemplate && vm.mdeReport.mdeReportMediacal.conservativeCareTemplate.content != vm.mdeReport.mdeReportMediacal.conservativeCare) {
                        vm.mdeReport.mdeReportMediacal.conservativeCareTemplate = null;
                    }
                    if (vm.mdeReport.mdeReportMediacal.surgicalHistoryTemplate && vm.mdeReport.mdeReportMediacal.surgicalHistoryTemplate.content != vm.mdeReport.mdeReportMediacal.surgicalHistory) {
                        vm.mdeReport.mdeReportMediacal.surgicalHistoryTemplate = null;
                    }
                    if (vm.mdeReport.mdeReportMediacal.summaryAndRecommendationsTemplate && vm.mdeReport.mdeReportMediacal.summaryAndRecommendationsTemplate.content != vm.mdeReport.mdeReportMediacal.summaryAndRecommendations) {
                        vm.mdeReport.mdeReportMediacal.summaryAndRecommendationsTemplate = null;
                    }
                }
                vm.mdeReport.mdeReportMediacal.status = 'INPROGRESS';
                MdeReportService.saveMDEReportPTP(vm.mdeReport).then(function (response) {
                    onSaveSuccess(response)
                }, function error(e) {
                    onSaveError(e);
                });
            }
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            goToMdeReport();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('MDEReportPTController', MDEReportPTController);

    MDEReportPTController.$inject = ['$state', '$stateParams', '$uibModal', 'MdeReportService', 'ipmConstants', 'mdeReport', 'templates', 'DataUtils', 'isView', '$window'];

    function MDEReportPTController($state, $stateParams, $uibModal, MdeReportService, ipmConstants, mdeReport, templates, DataUtils, isView, $window) {
        var vm = this;
        vm.mdeReport = mdeReport ? mdeReport : {};
        vm.templates = templates ? templates : [];
        vm.sortGoalAddNewDeletes = [];
        vm.longGoalAddNewDeletes = [];
        vm.isSaving = false;
        vm.isFinalize = false;
        vm.isDisabled = false;
        vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';
        vm.templateInputType = ipmConstants.FRP_MDE_TEMPLATE;
        vm.isChanged = isChanged;
        vm.isView = isView ? true : vm.mdeReport ? vm.mdeReport.statusFinal === ipmConstants.STATUS_FINAL_FRP_MDE : false;
        vm.subjectiveNoneRomTest = ['O1','O2','O3','O4','O5'];
        vm.subjectiveRomTest = ['O6','O7','O8','O9','O10','O11','O12','O13','O14', 'O100'];
        vm.notRequiredObjectives = ['O4','O5'];
        vm.dataHeaderReport = {};
        vm.otherObjectiveDeletes = [];
        vm.reportSubjectiveType = 'subjectives';
        vm.averageCode = 'O40';
        init();

        function init() {
            vm.mdeReportId = $stateParams.id;

            MdeReportService.getMdePtReport($stateParams.id).then(function(data) {
                vm.report = data;
                vm.reportOld = DataUtils.deepCopy(data);
                vm.isFinalize = vm.report && vm.report.finalize;
                vm.updateSelectAllCheckboxSubjective();
                _.forEach(vm.report.objectives, function(o) { o.isCollapsed = true });
            });
            setIsDisabled();
            vm.dataHeaderReport = buildDataHeaderReport(vm.mdeReport.patientFRPMDE);
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    mdeOfficeName: patientFRPMDE.mdeOfficeName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };

        function setIsDisabled() {
            if (vm.isView || (vm.mdeReport && (vm.mdeReport.status === 'MDE_ABANDONED' || (vm.mdeReport.patientFRPMDE && vm.mdeReport.patientFRPMDE.isViewFrpProgram)))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

        vm.calculatorLR = function() {
            vm.report.objectives.forEach(function (objective) {
                if(objective.code === 'O5') {
                    var rightValue = 0;
                    var leftValue = 0;
                    var countR = 0;
                    var countL = 0;
                    var isAllCheck = true;
                    objective.childs.forEach(function (child) {
                        if(child.code != vm.averageCode) {
                            if(child.checked) {
                                    if(child.rightValue && !isNaN(child.rightValue) && Number(child.rightValue) !== 0) {
                                        rightValue += Number(child.rightValue);
                                        countR ++;
                                    }
                                    if(child.leftValue && !isNaN(child.leftValue) && Number(child.leftValue) !== 0) {
                                        leftValue += Number(child.leftValue);
                                        countL ++;
                                    }
                            } else {
                                 isAllCheck = false;
                            }
                        } else {
                            if(isAllCheck) {
                                if(countR != 0) {
                                    child.rightValue = (rightValue/countR).toFixed(2);
                                } else {
                                    child.rightValue = null;
                                }
                                if(countL != 0) {
                                    child.leftValue = (leftValue/countL).toFixed(2);
                                } else {
                                    child.leftValue = null;
                                }
                                child.checked = true;
                            } else {
                                 child.rightValue = null;
                                 child.leftValue = null;
                                 child.checked = false;
                            }
                        }
                    })
                }
            })
        }

        function checkValidation() {
            vm.editForm['subjective_complaints'].$setDirty();
            vm.editForm['physical_functional_narrative'].$setDirty();
            _.forEach(vm.report.subjectives, function(s) {
                if (vm.editForm['subjectiveRow_' + s.code]['score_' + s.code]) {
                    vm.editForm['subjectiveRow_' + s.code]['score_' + s.code].$setDirty();
                }
                if (vm.editForm['subjectiveRow_' + s.code]['severity_' + s.code]) {
                    vm.editForm['subjectiveRow_' + s.code]['severity_' + s.code].$setDirty();
                }
            });
            _.forEach(vm.report.objectives, function(o) {
                _.forEach(o.childs, function(c) {
                    var formKey = 'objectiveRow_' + c.code;
                    var inputKey = 'input_' + c.code;
                    var lefInputKey = 'left_input_' + c.code;
                    var rightInputKey = 'right_input_' + c.code;
                    if (c.type === 'NORMAL_TEXT_FIELD' && vm.editForm[formKey][inputKey]) {
                        vm.editForm[formKey][inputKey].$setDirty();
                    } else if (c.type === 'LEFT_RIGHT_TEXT_FIELD' && vm.editForm[formKey][lefInputKey] && vm.editForm[formKey][rightInputKey]) {
                        vm.editForm[formKey][lefInputKey].$setDirty();
                        vm.editForm[formKey][rightInputKey].$setDirty();
                    }
                });
            });
            _.forEach(vm.report.otherObjectives, function(o) {
                var formKey = 'otherObjectiveRow_' + o.code;
                var inputKey = 'name_' + o.code;
                var inputValue = 'input_' + o.code;
                vm.editForm[formKey][inputKey].$setDirty();
                vm.editForm[formKey][inputValue].$setDirty();
            });
            _.forEach(vm.report.sortTermGoalResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code + '_' + t.goalType;
                var selectKey = 'select_m_' + t.code + '_' + t.goalType;
                if (t.type === 'TEXT_FIELD' && vm.editForm[formKey][inputKey]) {
                    vm.editForm[formKey][inputKey].$setDirty();
                } else if (t.type === 'DROP_DOWN' && vm.editForm[formKey][selectKey]) {
                    vm.editForm[formKey][selectKey].$setDirty();
                }
            });
            _.forEach(vm.report.longTermGoalResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code + '_' + t.goalType;
                var selectKey = 'select_m_' + t.code + '_' + t.goalType;
                if (t.type === 'TEXT_FIELD' && vm.editForm[formKey][inputKey]) {
                    vm.editForm[formKey][inputKey].$setDirty();
                } else if (t.type === 'DROP_DOWN' && vm.editForm[formKey][selectKey]) {
                    vm.editForm[formKey][selectKey].$setDirty();
                }
            });
            _.forEach(vm.report.sortTermGoalAddNewResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code;
                if (vm.editForm[formKey][inputKey]) {
                    vm.editForm[formKey][inputKey].$setDirty();
                }
            });
            _.forEach(vm.report.longTermGoalAddNewResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code;
                if (vm.editForm[formKey][inputKey]) {
                    vm.editForm[formKey][inputKey].$setDirty();
                }
            });
        }

        vm.save = function() {
            submitData(false);
        }

        vm.finalize = function() {
            checkValidation();
            if (vm.editForm.$invalid || !vm.hasTestingChecked()) {
                return;
            }
            if (vm.isView) {
                return;
            }
            submitData(true);
        }

        function isEqualSubjectives(v1, v2) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var subjectiveOld = v1[idx];
                var subjective = v2[idx];
                isEqual = DataUtils.isEqualBoolean(subjectiveOld.checked, subjective.checked);
                if (!isEqual) return false;
                if (subjectiveOld.checked && subjective.checked) {
                    isEqual = DataUtils.isEqualText(subjectiveOld.score, subjective.score);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(subjectiveOld.severity, subjective.severity);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(subjectiveOld.notes, subjective.notes);
                    if (!isEqual) return false;
                }
            }
            return isEqual;
        }

        function isEqualObjectives(v1, v2) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var objectiveOld = v1[idx];
                var objective = v2[idx];
                for (var index = 0; index < objectiveOld.childs.length; index++) {
                    var childOld = objectiveOld.childs[index];
                    var child = objective.childs[index];
                    isEqual = DataUtils.isEqualBoolean(childOld.checked, child.checked);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(childOld.notes, child.notes);
                    if (!isEqual) return false;
                    if (childOld.checked && child.checked) {
                        if (childOld.type === 'NORMAL_TEXT_FIELD') {
                            isEqual = DataUtils.isEqualText(childOld.value, child.value);
                            if (!isEqual) return false;
                        } else if (childOld.type === 'LEFT_RIGHT_TEXT_FIELD') {
                            isEqual = DataUtils.isEqualText(childOld.leftValue, child.leftValue);
                            if (!isEqual) return false;
                            isEqual = DataUtils.isEqualText(childOld.rightValue, child.rightValue);
                            if (!isEqual) return false;
                        }
                    }
                }
            }
            return isEqual;
        }

        function isEqualOtherObjectives(v1, v2) {
            var isEqual = true;
            if (v1.length != v2.length) {
                return false;
            }
            for (var idx = 0; idx < v1.length; idx++) {
                var otherObjectiveOld = v1[idx];
                var otherObjective = v2[idx];
                isEqual = DataUtils.isEqualBoolean(otherObjectiveOld.checked, otherObjective.checked);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(otherObjectiveOld.name, otherObjective.name);
                if (!isEqual) return false;
                if (otherObjectiveOld.checked && otherObjective.checked) {
                    if (otherObjectiveOld.type === 'NORMAL_TEXT_FIELD') {
                        isEqual = DataUtils.isEqualText(otherObjectiveOld.value, otherObjective.value);
                        if (!isEqual) return false;
                    } else if (otherObjectiveOld.type === 'LEFT_RIGHT_TEXT_FIELD') {
                        isEqual = DataUtils.isEqualText(otherObjectiveOld.leftValue, otherObjective.leftValue);
                        if (!isEqual) return false;
                        isEqual = DataUtils.isEqualText(otherObjectiveOld.rightValue, otherObjective.rightValue);
                        if (!isEqual) return false;
                    }
                }
            }
            return isEqual;
        }
        function isEqualPhysicalDemandLevels(v1, v2) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var physicalDemandLevelOld = v1[idx];
                var physicalDemandLevel = v2[idx];
                isEqual = DataUtils.isEqualText(physicalDemandLevelOld.value, physicalDemandLevel.value);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(physicalDemandLevelOld.note, physicalDemandLevel.note);
                if (!isEqual) return false;
            }
            return isEqual;
        }

        function isExistTermGoalNew(sortTermGoalAddNew, longTermGoalAddNew) {
            var sortTermGoalNew = _.find(sortTermGoalAddNew, function(s) { return s.id === null || s.id === undefined; });
            var longTermGoalNew = _.find(longTermGoalAddNew, function(l) { return l.id === null || l.id === undefined; });
            return sortTermGoalNew || longTermGoalNew;
        }

        function isExistTermGoalDeleted() {
            return vm.sortGoalAddNewDeletes.length > 0 || vm.longGoalAddNewDeletes.length > 0;
        }

        function isEqualTermGoal(v1, v2, isNewTermGoal) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var termGoalOld = v1[idx];
                var termGoal = v2[idx];
                isEqual = DataUtils.isEqualBoolean(termGoalOld.checked, termGoal.checked);
                if (!isEqual) return false;
                if (isNewTermGoal) {
                    isEqual = DataUtils.isEqualText(termGoalOld.goal, termGoal.goal);
                }
                if (!isEqual) return false;
                if (isNewTermGoal && termGoalOld.checked && termGoal.checked) {
                    isEqual = DataUtils.isEqualText(termGoalOld.inputValue, termGoal.inputValue);
                }
                if (!isEqual) return false;
                if (termGoalOld.type === 'TEXT_FIELD') {
                    isEqual = DataUtils.isEqualText(termGoalOld.value, termGoal.value);
                } else if (termGoalOld.type === 'DROP_DOWN') {
                    isEqual = DataUtils.isEqualText(termGoalOld.selectedValue, termGoal.selectedValue);
                }
                if (!isEqual) return false;
            }
            return isEqual;
        }

        function isChanged() {
            var isEqual = true;
            // Subjective Complaints
            isEqual = DataUtils.isEqualText(vm.reportOld.subjectiveComplaints, vm.report.subjectiveComplaints);
            if (!isEqual) return true;
            // Physical Functional Narrative
            isEqual = DataUtils.isEqualText(vm.reportOld.physicalFunctionalNarrative, vm.report.physicalFunctionalNarrative);
            if (!isEqual) return true;
            // Subjectives
            isEqual = isEqualSubjectives(vm.reportOld.subjectives, vm.report.subjectives);
            if (!isEqual) return true;
            // Objectives
            isEqual = isEqualObjectives(vm.reportOld.objectives, vm.report.objectives);
            if (!isEqual) return true;
            if (!_.isEmpty(vm.reportOld.otherObjectives) || !_.isEmpty(vm.report.otherObjectives)) {
                isEqual = isEqualOtherObjectives(vm.reportOld.otherObjectives, vm.report.otherObjectives);
                if (!isEqual) return true;
            }
            // Physical Demand Levels
            isEqual = isEqualPhysicalDemandLevels(vm.reportOld.physicalDemandLevels, vm.report.physicalDemandLevels);
            if (!isEqual) return true;
            // Is exists Term Goal Add New
            var isChangeTermGoal = isExistTermGoalNew(vm.report.sortTermGoalAddNewResponses, vm.report.longTermGoalAddNewResponses);
            if (isChangeTermGoal) return true;
            // Is exists Term Goal Deleted
            isChangeTermGoal = isExistTermGoalDeleted();
            if (isChangeTermGoal) return true;
            // Term Goal
            isEqual = isEqualTermGoal(vm.reportOld.sortTermGoalResponses, vm.report.sortTermGoalResponses, false);
            if (!isEqual) return true;
            isEqual = isEqualTermGoal(vm.reportOld.longTermGoalResponses, vm.report.longTermGoalResponses, false);
            if (!isEqual) return true;
            // Term Goal Add New
            isEqual = isEqualTermGoal(vm.reportOld.sortTermGoalAddNewResponses, vm.report.sortTermGoalAddNewResponses, true);
            if (!isEqual) return true;
            isEqual = isEqualTermGoal(vm.reportOld.longTermGoalAddNewResponses, vm.report.longTermGoalAddNewResponses, true);
            if (!isEqual) return true;
            return !isEqual;
        }

        function back() {
            $state.go('mde-report', {id: vm.mdeReportId});
        }

        vm.cancel = function() {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        function submitData(finalize) {
            if (finalize) {
                checkValidation();
                if (vm.editForm.$invalid || !vm.hasTestingChecked()) {
                    return;
                }
            }
            if (vm.isView) {
                return;
            }

            vm.isSaving = true;
            vm.report.finalize = finalize;
            prepairDataForSave();
            MdeReportService.saveMdePtReport(vm.mdeReportId, vm.report).then(function (response) {
                onSaveSuccess(response);
            }, function error(e) {
                onSaveError(e);
            });
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            back();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error && (error.status === 409 || error.status === 400)) {
                vm.error = 'ERROR';
                openErrorDuplicateDialog();
            }
        }

        function prepairDataForSave() {
            // Feedback before the Demo - June 09, 2022 - Feedback #22
            // goal-add-new rule
            // new, checked, not-empty        -> save text and checked state
            // new, checked, empty            -> form invalid
            // new, uncheck, not-empty        -> save text and uncheck state
            // new, uncheck, empty            -> not save
            // old, checked, not-empty        -> save text and checked state
            // old, checked, empty            -> form invalid
            // old, uncheck, not-empty        -> save text and uncheck state
            // old, uncheck, empty            -> term-goal delete (database update to inactive)

            // filter new, checked/checked, not-empty sort-term-goal
            vm.report.sortTermGoalAddNewResponses = _.filter(vm.report.sortTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            // filter new, checked, not-empty long-term-goal
            vm.report.longTermGoalAddNewResponses = _.filter(vm.report.longTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            // delete old, uncheck, empty sort-term-goal
            _.forEach(vm.report.sortTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });
            // delete old, uncheck, empty long-term-goal
            _.forEach(vm.report.longTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });

            _.forEach(vm.report.otherObjectives, function(other) {
                if (!other.checked) {
                    other.checked = false;
                }
                if (!other.checked && !other.name) {
                    other.active = false;
                }
            });
            // merge add goals add new list
            vm.report.sortTermGoalAddNewResponses.push.apply(vm.report.sortTermGoalAddNewResponses, vm.sortGoalAddNewDeletes);
            vm.report.longTermGoalAddNewResponses.push.apply(vm.report.longTermGoalAddNewResponses, vm.longGoalAddNewDeletes);
            vm.report.otherObjectives.push.apply(vm.report.otherObjectives, vm.otherObjectiveDeletes);

            // check Template content changed
            if (vm.report) {
                if (vm.report.subjectiveComplaintsTemplate && vm.report.subjectiveComplaintsTemplate.content != vm.report.subjectiveComplaints) {
                    vm.report.subjectiveComplaintsTemplate = null;
                }
            }
        }

        vm.hasItemChecked = function (listItem) {
            if (listItem) {
                return !_.isEmpty(_.filter(listItem, function (s) { return s.checked; }))
            }
            return false;
        }

        vm.hasItemCheckedInvalid = function(listItem) {
            for (var index = 0; index < listItem.length; index++) {
                var s = listItem[index];
                if (s.checked) {
                    var controlScore = vm.editForm['subjectiveRow_' + s.code]['score_' + s.code];
                    if (controlScore.$dirty && controlScore.$error.required) return true;
                    var controlSeverity = vm.editForm['subjectiveRow_' + s.code]['severity_' + s.code];
                    if (controlSeverity.$dirty && controlSeverity.$error.required) return true;
                }
            }
        }

        vm.hasObjectiveChecked = function() {
            var isChecked = false;
            for (var index = 0; index < vm.report.objectives.length; index++) {
                isChecked = vm.hasChildChecked(vm.report.objectives[index]);
                if (!isChecked) return false;
            }
            return isChecked;
        }

        vm.hasOtherObjectiveChecked = function() {
            if (_.isEmpty(vm.report.otherObjectives)) {
                return true;
            }
            var isChecked = false;
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                isChecked = vm.hasChildChecked(vm.report.otherObjectives[index]);
                if (!isChecked) return false;
            }
            return isChecked;
        }

        vm.hasObjectiveCheckedInvalid = function() {
            for (var index = 0; index < vm.report.objectives.length; index++) {
                var o = vm.report.objectives[index];
                var invalid = vm.hasChildCheckedInvalid(o);
                if (invalid) return true;
            }
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var o = vm.report.otherObjectives[index];
                var invalid = vm.hasOtherCheckedInvalid(o);
                if (invalid) return true;
            }
            return false;
        }

        vm.hasChildCheckedNotCheckRom = function(objective) {
            if (objective) {
                return !_.isEmpty(_.filter(objective.childs, function(o) { return o.checked; })) || !_.isEmpty(_.filter(vm.report.otherObjectives, function(o) { return o.checked && o.typeReportId === objective.typeReportId; }))
            }
            return false;
        }

        vm.hasChildChecked = function(objective) {
            if (vm.notRequiredObjectives.includes(objective.code)) return true;
            if (objective) {
                if (vm.subjectiveNoneRomTest.includes(objective.code)) {
                    return !_.isEmpty(_.filter(objective.childs, function(o) { return o.checked; })) || !_.isEmpty(_.filter(vm.report.otherObjectives, function(o) { return o.checked && o.typeReportId === objective.typeReportId; }))
                } else if (vm.subjectiveRomTest.includes(objective.code)) {
                    return vm.hasRomTestingChecked();
                }
            }
            return false;
        }

        vm.hasChildCheckedInvalid = function(objective) {
            for (var index = 0; index < objective.childs.length; index++) {
                var c = objective.childs[index];
                if (c.checked) {
                    var formKey = 'objectiveRow_' + c.code;
                    var inputKey = 'input_' + c.code;
                    var lefInputKey = 'left_input_' + c.code;
                    var rightInputKey = 'right_input_' + c.code;
                    if (c.type === 'NORMAL_TEXT_FIELD') {
                        var control = vm.editForm[formKey][inputKey];
                        if (control.$dirty && control.$error.required) return true;
                    } else if (c.type === 'LEFT_RIGHT_TEXT_FIELD') {
                        var controlLeft = vm.editForm[formKey][lefInputKey];
                        var controlRight = vm.editForm[formKey][rightInputKey];
                        if (controlLeft.$dirty && controlLeft.$error.required) return true;
                        if (controlRight.$dirty && controlRight.$error.required) return true;
                    }
                }
            }
            return false;
        }

        vm.hasOtherCheckedInvalid = function(objective) {
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var otherObjective = vm.report.otherObjectives[index];
                if (otherObjective.checked && getParentCode(otherObjective.code) === objective.code) {
                    var formKey = 'otherObjectiveRow_' + otherObjective.code;
                    var inputKey = 'name_' + otherObjective.code;
                    var inputValue = 'input_' + otherObjective.code;
                    var controlName = vm.editForm[formKey][inputKey];
                    var controlValue = vm.editForm[formKey][inputValue];
                    if (controlName && controlName.$dirty && controlName.$error.required)
                        return true;
                    if (controlValue && controlValue.$dirty && controlValue.$error.required)
                        return true;
                }
            }
            return false;
        }

        vm.hasRomTestingChecked = function() {
            for (var index = 0; index < vm.report.objectives.length; index++) {
                var objective = vm.report.objectives[index];
                if (vm.subjectiveRomTest.includes(objective.code)) {
                    var isChecked = !_.isEmpty(_.filter(objective.childs, function(o) { return o.checked; }))
                    if (isChecked) return true;
                }
            }
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var objective = vm.report.otherObjectives[index];
                if (vm.subjectiveRomTest.includes(getParentCode(objective.code))) {
                    var isChecked = objective.checked;
                    if (isChecked) return true;
                }
            }
            return false;
        }

        vm.isChildRequired = function(objective) {
            if (objective) {
                if (vm.subjectiveNoneRomTest.includes(objective.code)) {
                    return !(vm.notRequiredObjectives.includes(objective.code));
                } else if (vm.subjectiveRomTest.includes(objective.code)) {
                    if (vm.hasRomTestingChecked()) {
                        return vm.hasChildCheckedNotCheckRom(objective);
                    } else {
                        return true;
                    }
                }
            }
            return false;
        }

        vm.hasTermGoalChecked = function(isSort) {
            var termGoalChecked;
            var termGoalAddNewChecked
            if (isSort) {
                // At least 1 Short Term Goal is required
                termGoalChecked = vm.hasItemChecked(vm.report.sortTermGoalResponses);
                termGoalAddNewChecked = vm.hasItemChecked(vm.report.sortTermGoalAddNewResponses);
            } else {
                // At least 1 Long Term Goal is required
                termGoalChecked = vm.hasItemChecked(vm.report.longTermGoalResponses);
                termGoalAddNewChecked = vm.hasItemChecked(vm.report.longTermGoalAddNewResponses);
            }
            if (!termGoalChecked && !termGoalAddNewChecked) return false;
            return true;
        }

        vm.hasTermGoalCheckedInvalid = function(isSort) {
            var termGoalCheckedInvalid;
            var termGoalAddNewCheckedInvalid;
            if (isSort) {
                termGoalCheckedInvalid = isTermGoalCheckedInvalid(vm.report.sortTermGoalResponses);
                termGoalAddNewCheckedInvalid = isTermGoalAddNewCheckedInvalid(vm.report.sortTermGoalAddNewResponses);
            } else {
                termGoalCheckedInvalid = isTermGoalCheckedInvalid(vm.report.longTermGoalResponses);
                termGoalAddNewCheckedInvalid = isTermGoalAddNewCheckedInvalid(vm.report.longTermGoalAddNewResponses);
            }
            if (termGoalCheckedInvalid || termGoalAddNewCheckedInvalid) return true;
            return false;
        }

        function isTermGoalCheckedInvalid(items) {
            for (var index = 0; index < items.length; index++) {
                var t = items[index];
                if (t.checked) {
                    var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                    var control;
                    if (t.type === 'TEXT_FIELD') {
                        var inputKey = 'input_m_' + t.code + '_' + t.goalType;
                        control = vm.editForm[formKey][inputKey];
                        if (control.$dirty && control.$error.required) return true;
                    } else if (t.type === 'DROP_DOWN') {
                        var selectKey = 'select_m_' + t.code + '_' + t.goalType;
                        control = vm.editForm[formKey][selectKey];
                        if (control.$dirty && control.$error.required) return true;
                    }
                }
            }
            return false;
        }

        function isTermGoalAddNewCheckedInvalid(items) {
            for (var index = 0; index < items.length; index++) {
                var t = items[index];
                if (t.checked) {
                    var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                    var inputKey = 'input_m_' + t.code;
                    var control = vm.editForm[formKey][inputKey];
                    if (control.$dirty && control.$error.required) return true;
                }
            }
            return false;
        }

        vm.hasTestingChecked = function() {
            // At least 1 Subjective Test is required
            var isChecked = vm.hasItemChecked(vm.report.subjectives);
            if (!isChecked) return false;
            // At least 1 Activity Test of Objective Test is required
            isChecked = vm.hasObjectiveChecked();
            if (!isChecked) return false;
            // At least 1 Short Term Goal is required
            isChecked = vm.hasTermGoalChecked(true);
            if (!isChecked) return false;
            // At least 1 Long Term Goal is required
            isChecked = vm.hasTermGoalChecked(false);
            if (!isChecked) return false;
            return true;
        }

        vm.addNewSortTermGoal = function() {
            var orderNumber = _.isEmpty(vm.report.sortTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.sortTermGoalAddNewResponses, function (o) { return o.orderNumber } ).orderNumber + 1;
            var code = 'STG' + orderNumber;
            var newGoal = {code: code, orderNumber: orderNumber, active: true, goalType: 'SORT_TERM'};
            vm.report.sortTermGoalAddNewResponses.push(newGoal);
        }

        vm.addNewLongTermGoal = function() {
            var orderNumber = _.isEmpty(vm.report.longTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.longTermGoalAddNewResponses, function (o) { return o.orderNumber } ).orderNumber + 1;
            var code = 'LTG' + orderNumber;
            var newGoal = {code: code, orderNumber: orderNumber, active: true, goalType: 'LONG_TERM'};
            vm.report.longTermGoalAddNewResponses.push(newGoal);
        }

        vm.deleteSortTermGoalAddNew = function(deleteItem) {

            _.remove(vm.report.sortTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

            if (!deleteItem.id && !deleteItem.active) {
                return;
            }
            vm.sortGoalAddNewDeletes.push(deleteItem);

        }

        vm.deleteLongTermGoalAddNew = function(deleteItem) {

            _.remove(vm.report.longTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

            if (!deleteItem.id && !deleteItem.active) {
                return;
            }
            vm.longGoalAddNewDeletes.push(deleteItem);

        }

        vm.showAddGoal = function($last, isLongTerm) {
            // filter active Goal
            var addNewItem;
            if (isLongTerm) {
                addNewItem = _.filter(vm.report.longTermGoalAddNewResponses, function (i) { return i.active; });
            } else {
                addNewItem = _.filter(vm.report.sortTermGoalAddNewResponses, function (i) { return i.active; });
            }
            return $last && _.isEmpty(addNewItem);
        }

        vm.addOtherObjective = function(objective) {
            var orderNumber = 0;
            _.forEach(vm.report.otherObjectives, function(otherObjective) {
                if (otherObjective.typeReportId == objective.typeReportId && orderNumber < otherObjective.orderNumber) {
                    orderNumber = otherObjective.orderNumber;
                }
            });
            orderNumber++;
            var code = objective.code + '_O' + orderNumber;
            var copyObjective = DataUtils.deepCopy(objective.childs[0]);
            copyObjective.name = '';
            copyObjective.orderNumber = orderNumber;
            copyObjective.code = code;
            copyObjective.type = 'NORMAL_TEXT_FIELD';
            copyObjective.checked = true;
            copyObjective.typeReportId = objective.typeReportId;
            copyObjective.id = null;
            copyObjective.active = true;
            copyObjective.value = '';
            copyObjective.rightValue = '';
            copyObjective.leftValue = '';

            vm.report.otherObjectives.push(copyObjective);
        }

        vm.deleteOtherObjectives = function(deleteItem) {
            _.remove(vm.report.otherObjectives, function (o) { return o.code === deleteItem.code; });

            if (!deleteItem.id && !deleteItem.active) {
                return;
            }
            vm.otherObjectiveDeletes.push(deleteItem);
        }

        function getParentCode(code) {
            return code.split('_')[0];
        }

        vm.updateSelectAllCheckbox = function(objective) {
            var isCheckAll = true;
            objective.childs.forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })

             vm.report.otherObjectives.forEach(function (other){
                if(other.typeReportId === objective.typeReportId) {
                    if(!other.checked) {
                        isCheckAll = false;
                        return;
                    }
                }
            })
            objective.checked = isCheckAll;
        }

        vm.updateSelectAllCheckboxSubjective = function() {
            var isCheckAll = true;
            vm.report.subjectives.forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })

            vm.report[vm.reportSubjectiveType + 'Checked'] = isCheckAll;
        }

        function openErrorDuplicateDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.mdeReport.error.saveReportDuplicateMessage"},
                    title: function () {return "ipmApp.mdeReport.error.saveReportDuplicateTitle"}
                }
            }).result.then(function() {
                $window.location.reload(); // reload page to load new data MDE
            }, function() {
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('MDEReportPsychController', MDEReportPsychController);

    MDEReportPsychController.$inject = ['$uibModal', '$state', '$stateParams', 'MdeReportService', 'Principal', 'ipmConstants', 'DataUtils', 'templates', 'isView'];

    function MDEReportPsychController($uibModal, $state, $stateParams, MdeReportService, Principal, ipmConstants, DataUtils, templates, isView) {
        var vm = this;
        vm.templates = templates ? templates : [];
        vm.sortGoalAddNewDeletes = [];
        vm.longGoalAddNewDeletes = [];
        vm.isSaving = false;
        vm.isFinalize = false;
        vm.isDisabled = false;
		vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';
        vm.templateInputType = ipmConstants.FRP_MDE_TEMPLATE;
        vm.updateSelectAllCheckbox = updateSelectAllCheckbox;
        vm.isChanged = isChanged;
        vm.isView = isView ? true : false;
        vm.fieldRequrieds = [
            'subjectiveComplaints',
            'pyschosocialHistory',
            'mentalStatus',
            'psychologicalSequelaeOfWorkInjury',
            'psychiatricDiagnosis',
            'psychologicalGoalsOfTreatment',
            'summaryAndImpressions',
            {formKey: 'checkBoxRow_CES_D', controlKey: ['score_CES_D']},
            {formKey: 'checkBoxRow_GAD_7', controlKey: ['score_GAD_7']},
            {formKey: 'checkBoxRow_TSK', controlKey: ['score_TSK']},
            {formKey: 'checkBoxRow_BPI', controlKey: ['score_BPI']},
            {formKey: 'checkBoxRow_BPI', controlKey: ['scoreRight_BPI']},
            {formKey: 'checkBoxRow_BPI', controlKey: ['scoreLeft_BPI']},
            // {formKey: 'checkBoxRow_BPI', controlKey: ['severity_right_BPI']},
            // {formKey: 'checkBoxRow_BPI', controlKey: ['severity_left_BPI']},
            {formKey: 'checkBoxRow_ISI', controlKey: ['score_ISI']},
            {formKey: 'checkBoxRow_PHQ_9', controlKey: ['score_PHQ_9']},
            // {formKey: 'checkBoxRow_CES_D', controlKey: ['severity_CES_D']},
            // {formKey: 'checkBoxRow_GAD_7', controlKey: ['severity_GAD_7']},
            // {formKey: 'checkBoxRow_TSK', controlKey: ['severity_TSK']},
            // {formKey: 'checkBoxRow_BPI', controlKey: ['severity_BPI']},
            // {formKey: 'checkBoxRow_ISI', controlKey: ['severity_ISI']},
            // {formKey: 'checkBoxRow_PHQ_9', controlKey: ['severity_PHQ_9']}
        ];

        vm.dataHeaderReport = {};
        vm.objectiveChecked = false;
        vm.subjectiveChecked = false;
        vm.reportType = {
            OBJECTIVE: "objectives",
            SUBJECTIVE : "subjectives"
        }

        vm.severity = angular.copy(ipmConstants.FRP_PSYCH_SEVERITY);
        vm.severitySubjectives = vm.severity ? vm.severity.subjectives : {};
        vm.severityObjectives = vm.severity ? vm.severity.objectives : {};

        init();

        function init() {
            vm.mdeReportId = $stateParams.id;

            MdeReportService.getMdePsychReport($stateParams.id).then(function(data) {
                vm.report = data;
                vm.reportOld = DataUtils.deepCopy(data);
                vm.isView = vm.isView ? true : vm.report ? vm.report.statusFinal === ipmConstants.STATUS_FINAL_FRP_MDE : false;
                setIsDisabled();
                vm.isFinalize = vm.report && vm.report.status === 'COMPLETE' ? true : false;
                vm.dataHeaderReport = buildDataHeaderReport(vm.report);
                updateSelectAllCheckbox(vm.reportType.OBJECTIVE);
                updateSelectAllCheckbox(vm.reportType.SUBJECTIVE);
            });
        }

        function setIsDisabled() {
            if (vm.isView || (vm.report && (vm.report.mdeStatus === 'MDE_ABANDONED' || vm.report.isViewFrpProgram))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

        vm.save = function() {
            submitData(false);
        }

        vm.finalize = function() {
            submitData(true);
        }

        function isEqualPsychTesting(v1, v2) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var psychTestingOld = v1[idx];
                var psychTesting = v2[idx];
                isEqual = DataUtils.isEqualBoolean(psychTestingOld.checked, psychTesting.checked);
                if (!isEqual) return false;
                if (psychTestingOld.checked && psychTesting.checked) {
                    isEqual = DataUtils.isEqualText(psychTestingOld.score, psychTesting.score);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(psychTestingOld.scoreLeft, psychTesting.scoreLeft);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(psychTestingOld.scoreRight, psychTesting.scoreRight);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(psychTestingOld.severity, psychTesting.severity);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(psychTestingOld.notes, psychTesting.notes);
                    if (!isEqual) return false;
                }
            }
            return isEqual;
        }

        function isExistTermGoalNew(sortTermGoalAddNew, longTermGoalAddNew) {
            var sortTermGoalNew = _.find(sortTermGoalAddNew, function(s) { return s.id === null || s.id === undefined; });
            var longTermGoalNew = _.find(longTermGoalAddNew, function(l) { return l.id === null || l.id === undefined; });
            return sortTermGoalNew || longTermGoalNew;
        }

        function isExistTermGoalDeleted() {
            return vm.sortGoalAddNewDeletes.length > 0 || vm.longGoalAddNewDeletes.length > 0;
        }

        function isEqualTermGoal(v1, v2, isNewTermGoal) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var termGoalOld = v1[idx];
                var termGoal = v2[idx];
                isEqual = DataUtils.isEqualBoolean(termGoalOld.checked, termGoal.checked);
                if (!isEqual) return false;
                if (isNewTermGoal) {
                    isEqual = DataUtils.isEqualText(termGoalOld.goal, termGoal.goal);
                }
                if (!isEqual) return false;
                if (isNewTermGoal && termGoalOld.checked && termGoal.checked) {
                    isEqual = DataUtils.isEqualText(termGoalOld.inputValue, termGoal.inputValue);
                }
                if (!isEqual) return false;
                if (termGoalOld.type === 'TEXT_FIELD') {
                    isEqual = DataUtils.isEqualText(termGoalOld.value, termGoal.value);
                } else if (termGoalOld.type === 'DROP_DOWN') {
                    isEqual = DataUtils.isEqualText(termGoalOld.selectedValue, termGoal.selectedValue);
                }
                if (!isEqual) return false;
            }
            return isEqual;
        }

        function isChanged() {
            var isEqual = true;
            // Subjective Complaints and History
            isEqual = DataUtils.isEqualText(vm.reportOld.subjectiveComplaints, vm.report.subjectiveComplaints);
            if (!isEqual) return true;
            // Subjective Complaints and History
            isEqual = DataUtils.isEqualText(vm.reportOld.pyschosocialHistory, vm.report.pyschosocialHistory);
            if (!isEqual) return true;
            // Mental Status
            isEqual = DataUtils.isEqualText(vm.reportOld.mentalStatus, vm.report.mentalStatus);
            if (!isEqual) return true;
            // Psychological Sequelae of Work Injury
            isEqual = DataUtils.isEqualText(vm.reportOld.psychologicalSequelaeOfWorkInjury, vm.report.psychologicalSequelaeOfWorkInjury);
            if (!isEqual) return true;
            // Psychiatric Diagnosis
            isEqual = DataUtils.isEqualText(vm.reportOld.psychiatricDiagnosis, vm.report.psychiatricDiagnosis);
            if (!isEqual) return true;
            // Psychological Goals of Treatment Narrative
            isEqual = DataUtils.isEqualText(vm.reportOld.psychologicalGoalsOfTreatment, vm.report.psychologicalGoalsOfTreatment);
            if (!isEqual) return true;
            // Summary and Impressions
            isEqual = DataUtils.isEqualText(vm.reportOld.summaryAndImpressions, vm.report.summaryAndImpressions);
            if (!isEqual) return true;
            // Subjective Testing
            isEqual = isEqualPsychTesting(vm.reportOld.subjectives, vm.report.subjectives);
            if (!isEqual) return true;
            // Objective Testing
            isEqual = isEqualPsychTesting(vm.reportOld.objectives, vm.report.objectives);
            if (!isEqual) return true;
            // Is exists Term Goal Add New
            var isChangeTermGoal = isExistTermGoalNew(vm.report.sortTermGoalAddNewResponses, vm.report.longTermGoalAddNewResponses);
            if (isChangeTermGoal) return true;
            // Is exists Term Goal Deleted
            isChangeTermGoal = isExistTermGoalDeleted();
            if (isChangeTermGoal) return true;
            // Term Goal
            isEqual = isEqualTermGoal(vm.reportOld.sortTermGoalResponses, vm.report.sortTermGoalResponses, false);
            if (!isEqual) return true;
            isEqual = isEqualTermGoal(vm.reportOld.longTermGoalResponses, vm.report.longTermGoalResponses, false);
            if (!isEqual) return true;
            // Term Goal Add New
            isEqual = isEqualTermGoal(vm.reportOld.sortTermGoalAddNewResponses, vm.report.sortTermGoalAddNewResponses, true);
            if (!isEqual) return true;
            isEqual = isEqualTermGoal(vm.reportOld.longTermGoalAddNewResponses, vm.report.longTermGoalAddNewResponses, true);
            if (!isEqual) return true;
            return !isEqual;
        }

        function back() {
            $state.go('mde-report', {id: vm.mdeReportId});
        }

        vm.cancel = function() {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        function checkValidation() {
            vm.fieldRequrieds.forEach(function (field) {
                if (field) {
                    if (typeof field === 'string' && vm.psychReportForm[field]) {
                        vm.psychReportForm[field].$setDirty();
                    } else if (typeof field === 'object' && vm.psychReportForm[field.formKey]) {
                        field.controlKey.forEach(function (f) {
                            if (f && vm.psychReportForm[field.formKey][f]) {
                                vm.psychReportForm[field.formKey][f].$setDirty();
                            }
                        });
                    }
                }
            });
            _.forEach(vm.report.sortTermGoalResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code + '_' + t.goalType;
                var selectKey = 'select_m_' + t.code + '_' + t.goalType;
                if (t.type === 'TEXT_FIELD' && vm.psychReportForm[formKey][inputKey]) {
                    vm.psychReportForm[formKey][inputKey].$setDirty();
                } else if (t.type === 'DROP_DOWN' && vm.psychReportForm[formKey][selectKey]) {
                    vm.psychReportForm[formKey][selectKey].$setDirty();
                }
            });
            _.forEach(vm.report.longTermGoalResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code + '_' + t.goalType;
                var selectKey = 'select_m_' + t.code + '_' + t.goalType;
                if (t.type === 'TEXT_FIELD' && vm.psychReportForm[formKey][inputKey]) {
                    vm.psychReportForm[formKey][inputKey].$setDirty();
                } else if (t.type === 'DROP_DOWN' && vm.psychReportForm[formKey][selectKey]) {
                    vm.psychReportForm[formKey][selectKey].$setDirty();
                }
            });
            _.forEach(vm.report.sortTermGoalAddNewResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code;
                if (vm.psychReportForm[formKey][inputKey]) {
                    vm.psychReportForm[formKey][inputKey].$setDirty();
                }
            });
            _.forEach(vm.report.longTermGoalAddNewResponses, function(t) {
                var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                var inputKey = 'input_m_' + t.code;
                if (vm.psychReportForm[formKey][inputKey]) {
                    vm.psychReportForm[formKey][inputKey].$setDirty();
                }
            });
        }

        function submitData(finalize) {
            if (vm.isView) {
                return;
            }
            if (finalize) {
                checkValidation();
                if (vm.psychReportForm.$invalid || !vm.hasRequiredCheck()) {
                    return;
                }
            }

            if(vm.report.subjectiveComplaintsAndHistoryTemplate && vm.report.subjectiveComplaintsAndHistoryTemplate.content != vm.report.subjectiveComplaintsAndHistory) {
                vm.report.subjectiveComplaintsAndHistoryTemplate = null;
            }

            if(vm.report.mentalStatusTemplate && vm.report.mentalStatusTemplate.content != vm.report.mentalStatus) {
                vm.report.mentalStatusTemplate = null;
            }

            vm.isSaving = true;
            vm.report.finalize = finalize;
            prepairDataForSave();
            MdeReportService.saveMdePsychReport(vm.mdeReportId, vm.report).then(function (response) {
                onSaveSuccess(response)
            }, function error(e) {
                onSaveError(e);
            });
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            back();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error && (error.status === 409 || error.status === 400)) {
                vm.error = 'ERROR';
                openErrorDuplicateDialog();
            }
        }

        function prepairDataForSave() {
            // goal-add-new rule
            // new, checked, not-empty        -> save text and checked state
            // new, checked, empty            -> form invalid
            // new, uncheck, not-empty        -> save text and uncheck state
            // new, uncheck, empty            -> not save
            // old, checked, not-empty        -> save text and checked state
            // old, checked, empty            -> form invalid
            // old, uncheck, not-empty        -> save text and uncheck state
            // old, uncheck, empty            -> term-goal delete (database update to inactive)

            // filter new, checked/checked, not-empty sort-term-goal
            vm.report.sortTermGoalAddNewResponses = _.filter(vm.report.sortTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            // filter new, checked, not-empty long-term-goal
            vm.report.longTermGoalAddNewResponses = _.filter(vm.report.longTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            // delete old, uncheck, empty sort-term-goal
            _.forEach(vm.report.sortTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });
            // delete old, uncheck, empty long-term-goal
            _.forEach(vm.report.longTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });
            // merge add goals add new list
            vm.report.sortTermGoalAddNewResponses.push.apply(vm.report.sortTermGoalAddNewResponses, vm.sortGoalAddNewDeletes);
            vm.report.longTermGoalAddNewResponses.push.apply(vm.report.longTermGoalAddNewResponses, vm.longGoalAddNewDeletes);
        }

        function hasItemChecked(listItem) {
            if (listItem) {
                return !_.isEmpty(_.filter(listItem, function (s) { return s.checked; }))
            }
            return false;
        }

        vm.hasTestingChecked = function() {
            // At least 1 Subjective Test is required
            var isChecked = hasItemChecked(vm.report.subjectives);
            if (!isChecked) return false;
            return true;
        }

        vm.hasRequiredCheck = function() {
            // At least 1 Subjective Test is required
            var isChecked = hasItemChecked(vm.report.subjectives);
            if (!isChecked) return false;
            // At least 1 Short Term Goal is required
            isChecked = vm.hasTermGoalChecked(true);
            if (!isChecked) return false;
            // At least 1 Long Term Goal is required
            isChecked = vm.hasTermGoalChecked(false);
            if (!isChecked) return false;
            return true;
        }

        vm.hasItemCheckedInvalid = function() {
            for (var index = 0; index < vm.report.subjectives.length; index++) {
                var s = vm.report.subjectives[index];
                if (s.checked) {
                    var convertItemCode = s.code.replace("-", "_");
                    var controlScore = vm.psychReportForm['checkBoxRow_' + convertItemCode]['score_' + convertItemCode];
                    if (controlScore.$dirty && controlScore.$error.required) return true;
                    var controlScore = vm.psychReportForm['checkBoxRow_' + convertItemCode]['severity_' + convertItemCode];
                    if (controlScore.$dirty && controlScore.$error.required) return true;
                }
            }
        }

        vm.hasTermGoalChecked = function(isSort) {
            var termGoalChecked;
            var termGoalAddNewChecked
            if (isSort) {
                // At least 1 Short Term Goal is required
                termGoalChecked = hasItemChecked(vm.report.sortTermGoalResponses);
                termGoalAddNewChecked = hasItemChecked(vm.report.sortTermGoalAddNewResponses);
            } else {
                // At least 1 Long Term Goal is required
                termGoalChecked = hasItemChecked(vm.report.longTermGoalResponses);
                termGoalAddNewChecked = hasItemChecked(vm.report.longTermGoalAddNewResponses);
            }
            if (!termGoalChecked && !termGoalAddNewChecked) return false;
            return true;
        }

        vm.hasTermGoalCheckedInvalid = function(isSort) {
            var termGoalCheckedInvalid;
            var termGoalAddNewCheckedInvalid;
            if (isSort) {
                termGoalCheckedInvalid = isTermGoalCheckedInvalid(vm.report.sortTermGoalResponses);
                termGoalAddNewCheckedInvalid = isTermGoalAddNewCheckedInvalid(vm.report.sortTermGoalAddNewResponses);
            } else {
                termGoalCheckedInvalid = isTermGoalCheckedInvalid(vm.report.longTermGoalResponses);
                termGoalAddNewCheckedInvalid = isTermGoalAddNewCheckedInvalid(vm.report.longTermGoalAddNewResponses);
            }
            if (termGoalCheckedInvalid || termGoalAddNewCheckedInvalid) return true;
            return false;
        }

        function isTermGoalCheckedInvalid(items) {
            for (var index = 0; index < items.length; index++) {
                var t = items[index];
                if (t.checked) {
                    var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                    var control;
                    if (t.type === 'TEXT_FIELD') {
                        var inputKey = 'input_m_' + t.code + '_' + t.goalType;
                        control = vm.psychReportForm[formKey][inputKey];
                        if (control.$dirty && control.$error.required) return true;
                    } else if (t.type === 'DROP_DOWN') {
                        var selectKey = 'select_m_' + t.code + '_' + t.goalType;
                        control = vm.psychReportForm[formKey][selectKey];
                        if (control.$dirty && control.$error.required) return true;
                    }
                }
            }
            return false;
        }

        function isTermGoalAddNewCheckedInvalid(items) {
            for (var index = 0; index < items.length; index++) {
                var t = items[index];
                if (t.checked) {
                    var formKey = 'termGoalRow_' + t.code + '_' + t.goalType;
                    var inputKey = 'input_m_' + t.code;
                    var control = vm.psychReportForm[formKey][inputKey];
                    if (control.$dirty && control.$error.required) return true;
                }
            }
            return false;
        }

        vm.addNewSortTermGoal = function() {
            var orderNumber = _.isEmpty(vm.report.sortTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.sortTermGoalAddNewResponses, function (o) { return o.orderNumber } ).orderNumber + 1;
            var code = 'STG' + orderNumber;
            var newGoal = {code: code, orderNumber: orderNumber, active: true, goalType: 'SORT_TERM'};
            vm.report.sortTermGoalAddNewResponses.push(newGoal);
        }

        vm.addNewLongTermGoal = function() {
            var orderNumber = _.isEmpty(vm.report.longTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.longTermGoalAddNewResponses, function (o) { return o.orderNumber } ).orderNumber + 1;
            var code = 'LTG' + orderNumber;
            var newGoal = {code: code, orderNumber: orderNumber, active: true, goalType: 'LONG_TERM'};
            vm.report.longTermGoalAddNewResponses.push(newGoal);
        }

        vm.deleteSortTermGoalAddNew = function(deleteItem) {

            _.remove(vm.report.sortTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

            if (!deleteItem.id && !deleteItem.active) {
                return;
            }
            vm.sortGoalAddNewDeletes.push(deleteItem);

        }

        vm.deleteLongTermGoalAddNew = function(deleteItem) {

            _.remove(vm.report.longTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

            if (!deleteItem.id && !deleteItem.active) {
                return;
            }
            vm.longGoalAddNewDeletes.push(deleteItem);

        }

        vm.showAddGoal = function($last, isLongTerm) {
            // filter active Goal
            var addNewItem;
            if (isLongTerm) {
                addNewItem = _.filter(vm.report.longTermGoalAddNewResponses, function (i) { return i.active; });
            } else {
                addNewItem = _.filter(vm.report.sortTermGoalAddNewResponses, function (i) { return i.active; });
            }
            return $last && _.isEmpty(addNewItem);
        }

        function buildDataHeaderReport(data) {
            if (data) {
                return {
                    patientName: data.patientName,
                    chartNumber: data.chartNumber,
                    authorizedProviderName: data.authorizedProviderName,
                    frpProgramName: data.frpProgramName,
                    mdeOfficeName: data.mdeOfficeName,
                    caseNumber: data.caseNumber,
                    dateOfBirth: data.dateOfBirth
                };
            }
        };


        function updateSelectAllCheckbox(type) {
            var isCheckAll = true;
            vm.report[type].forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })

            vm.report[type + 'Checked'] = isCheckAll;
        }

        function openErrorDuplicateDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.mdeReport.error.saveReportDuplicateMessage"},
                    title: function () {return "ipmApp.mdeReport.error.saveReportDuplicateTitle"}
                }
            }).result.then(function() {
                $window.location.reload(); // reload page to load new data MDE
            }, function() {
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('MDEReportHomeController', MDEReportHomeController);

    MDEReportHomeController.$inject = ['$scope', '$state', '$q', 'Principal', 'ipmConstants', 'MdeReportService', '$stateParams'];

    function MDEReportHomeController($scope, $state, $q, Principal, ipmConstants, MdeReportService, $stateParams) {
        var vm = this;
        vm.mdeReport = {};
        vm.patient = {};
        vm.reports = [];
        vm.isView = false;
        vm.checkCompletedAllReport = checkCompletedAllReport;
        vm.dataHeaderReport = {};

        init();

        function init() {
        	MdeReportService.get($stateParams.id).then(function(response) {
                vm.mdeReport = response.data ? response.data : {};
                setIsView();
                vm.patient = response.data.patient;
                vm.patient.dateOfBirth =  moment(vm.patient.dateOfBirth).format('MM/DD/YYYY');
                vm.reports =  response.data.reports;
                vm.dataHeaderReport = buildDataHeaderReport(vm.mdeReport.patientFRPMDE);
            });
        }

        function setIsView() {
            vm.isView = vm.mdeReport && ((vm.mdeReport.statusFinal && vm.mdeReport.statusFinal === 'FINALIZED') || vm.mdeReport.status === 'MDE_ABANDONED' || (vm.mdeReport.patientFRPMDE && vm.mdeReport.patientFRPMDE.isViewFrpProgram)) ? true : false;
        }

        function checkCompletedAllReport() {
            if (vm.mdeReport && vm.mdeReport.reports && vm.mdeReport.reports.length > 0) {
                return _.isEmpty(_.filter(vm.mdeReport.reports, function (item) {
                    return item.status !== 'COMPLETE' && item.role !== 'MEDICAL' && item.role !== 'ADDENDUM';
                }));
            }
            return false;
        }

        vm.editPage = function(name){
            if(name)
                $state.go('mde-report.' + name);
        }

        vm.viewPage = function (name) {
            if (name) {
                $state.go('mde-report.' + name + '.VIEW');
                return;
            }
        }

        vm.finalAndSignOffClick = function () {
            if (checkCompletedAllReport()) {
                MdeReportService.finalizeMdeReport(vm.mdeReport.id).then(function(response) {
                    onSaveSuccess(response)
                }, function error(e) {
                    onSaveError(e);
                });
            }
        }

        vm.preview = function() {
            $state.go('mde-report-preview');
        }
        
        function onSaveSuccess (response) {
            vm.isSaving = false;
            goToMdeTab();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }

        function goToMdeTab() {
            $state.go('frp-mde', {tab:1});
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    mdeOfficeName: patientFRPMDE.mdeOfficeName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('MDEReportConclusionController', MDEReportConclusionController);

    MDEReportConclusionController.$inject = ['$uibModal', '$state', '$scope', '$stateParams', 'MdeReportService', 'Principal', 'ipmConstants', 'DataUtils', 'templates', 'isView'];

    function MDEReportConclusionController($uibModal, $state, $scope, $stateParams, MdeReportService, Principal, ipmConstants, DataUtils, templates, isView) {
        var vm = this;
        vm.templates = templates ? templates : [];
        vm.isSaving = false;
        vm.isDisabled = false;
		vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';
        vm.templateInputType = ipmConstants.FRP_MDE_TEMPLATE;
        vm.isView = isView ? true : false;
        vm.requiredFields = [
            'field_conclusion',
            'field_frp',
            'field_description'
        ];
        vm.dataHeaderReport = {};

        init();

        function init() {
            vm.mdeReportId = $stateParams.id;
            MdeReportService.getMdeConclusionReport($stateParams.id).then(function(data) {
                vm.report = data;
                vm.reportOld = DataUtils.deepCopy(data);
                vm.isView = vm.isView ? true : vm.report ? vm.report.statusFinal === ipmConstants.STATUS_FINAL_FRP_MDE : false;
                if (vm.report.mdeStatus === 'MDE_ABANDONED' || vm.isView || vm.report.isViewFrpProgram) {
                    vm.isDisabled = true;
                }
                vm.dataHeaderReport = buildDataHeaderReport(vm.report);
            });
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patientName,
                    chartNumber: patientFRPMDE.chartNumber,
                    authorizedProviderName: patientFRPMDE.providerName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    mdeOfficeName: patientFRPMDE.mdeOfficeName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.dateOfBirth
                };
            }
        }

        vm.frpChange = function() {
        	if (vm.report.frp === null) {
                vm.report.hours = null;
        	} else {
                vm.report.hours = 'MDE_HOURS_180';
            }

            if(DataUtils.isEqualText(vm.reportOld.frp, vm.report.frp)) {
                vm.report.treatmentContent = vm.reportOld.treatmentContent;
            } else {
                vm.report.treatmentContent = null;
            }
        }

        function checkValidation() {
            vm.requiredFields.forEach(function (field) {
                if (field && vm.editForm[field]) {
                    vm.editForm[field].$setDirty();
                }
            });
        }

        vm.save = function() {
            submitData(false);
        }

        vm.finalize = function() {
            checkValidation();
            if (vm.editForm.$invalid) {
                return;
            }
            submitData(true);
        }

        vm.isChange = function () {
            if(!vm.report)
                return false;

            var isEqual = true;
            // Conclusion
            isEqual = DataUtils.isEqualText(vm.reportOld.conclusion, vm.report.conclusion);
            if (!isEqual) return true;
            // What treatment option do you recommend?
            isEqual = DataUtils.isEqualText(vm.reportOld.frp, vm.report.frp);
            if (!isEqual) return true;
            // Hours
            isEqual = DataUtils.isEqualText(vm.reportOld.hours, vm.report.hours) && DataUtils.isEqualText(vm.reportOld.treatmentContent, vm.report.treatmentContent);
            if (!isEqual) return true;
            return !isEqual;
        }

        function back() {
            $state.go('mde-report', {id: vm.mdeReportId});
        }

        vm.cancel = function() {
            var isReportChanged = vm.isChange();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        function submitData(finalize) {
            if (vm.isView) {
                return;
            }
            vm.report.finalize = finalize;
            vm.isSaving = true;
            MdeReportService.saveMdeConclusionReport(vm.mdeReportId, vm.report).then(function (response) {
                onSaveSuccess(response)
            }, function error(e) {
                onSaveError(e);
            });
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            back();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }
    }
})();
;
(function () {
	'use strict';

	angular
	.module('ipmApp')
	.controller('MDEReportAdminController', MDEReportAdminController);

	MDEReportAdminController.$inject = ['$scope', '$state', '$stateParams', '$filter', '$q', '$uibModal', 'Principal', 'ipmConstants', 'userDetails', 'MdeReportService', 'supportedDataList', 'qhpUsers', 'staffUsers', 'isView'];

	function MDEReportAdminController($scope, $state, $stateParams, $filter, $q, $uibModal,Principal, ipmConstants, userDetails, MdeReportService, supportedDataList, qhpUsers, staffUsers, isView) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.users = qhpUsers;
		vm.adminUsers = staffUsers.concat(qhpUsers);
		vm.save = save;
		vm.submitted = false;
		vm.isDisabled = false;
		vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';
		vm.abandonedMessage = 'ipmApp.mdeReport.admin.confirmAbandoned';
		vm.providers = supportedDataList.providerList;
		vm.states = ipmConstants.STATES_OF_AMERICA;
        vm.isView = isView ? true : false;
        vm.requiredFields = [
            'caseNumber',
            'provider',
            'medical',
            'pt',
            'psych',
            'dateOfService'
        ];
        vm.dataHeaderReport = {};

		init();

		function init() {
			MdeReportService.getMdeAdminReport($stateParams.id).then(function(response) {
			    vm.admin = response;
                vm.isView = vm.isView ? true : vm.admin ? vm.admin.statusFinal === ipmConstants.STATUS_FINAL_FRP_MDE : false;

                vm.admin.injuryDate = vm.admin.injuryDate ? moment(vm.admin.injuryDate)._d : null;
                vm.admin.dateOfService = vm.admin.dateOfService ? moment(vm.admin.dateOfService)._d : null;
				vm.admin.dateOfBirthStr = vm.admin.dateOfBirth ?  moment(vm.admin.dateOfBirth).format('MM/DD/YYYY') : "";
				vm.adminOriginal = Object.assign({}, vm.admin);
				setIsDisabled(vm.admin.mdeStatus);
                vm.dataHeaderReport = buildDataHeaderReport(vm.admin.patientFRPMDE);
			});
			getFrpProgramList();
		}

        function getFrpProgramList() {
            Principal.identity(false).then(function(res) {
                if (Principal.hasAnyAuthority([ipmConstants.ROLE_STAFF]) === true) {
                    vm.frpPrograms  = userDetails.staffUserDetail ? userDetails.staffUserDetail.frpPrograms : [];
                } else if (Principal.hasAnyAuthority([ipmConstants.ROLE_QHP]) === true) {
                    vm.frpPrograms = userDetails.qhpUserDetail ? userDetails.qhpUserDetail.frpPrograms : [];
                }
            });
        }

        vm.updateAdminAbandoned = function(){
            MdeReportService.updateAdminAbandoned($stateParams.id).then(function(res) {
                $state.go('frp-mde', {tab:2});
            })
        }

        function setIsDisabled(status){
            if(vm.isView || status === 'MDE_ABANDONED' || (vm.admin.patientFRPMDE && vm.admin.patientFRPMDE.isViewFrpProgram)) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

		vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.submitButton = function(){
            vm.submitted = true;
        }

        function checkValidation() {
            vm.requiredFields.forEach(function (field) {
                if (field && vm.editForm[field]) {
                    vm.editForm[field].$setDirty();
                }
            });
        }

		function save(status){
            if (vm.isView) {
                return;
            }
            vm.admin.status = 'INPROGRESS';
            MdeReportService.saveMdeAdminReport($stateParams.id, vm.admin).then(function(res) {
                $state.go('mde-report');
            })
		}

        vm.final = function(){
           if (vm.isView) {
               return;
           }
           checkValidation();
           if (vm.editForm.$invalid) {
               return;
           }
           vm.admin.status = 'COMPLETE';
           MdeReportService.saveMdeAdminReport($stateParams.id, vm.admin).then(function(res) {
               $state.go('mde-report');
           })
        }

        vm.confirmDialog = function (message, callback) {
            if (vm.isView) {
                return;
            }
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                windowClass: 'absolute-center warning-dialog',
                size: 'sm',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if(result) {
                    callback();
                }
            });
        }

        vm.checkCancel = function(edited){
            if(edited) {
                vm.confirmDialog(vm.cancelMessage, vm.backHome);
            } else {
                vm.backHome();
            }

        }

        vm.backHome = function() {
            $state.go('mde-report');
        }

        vm.isChanged = function() {
        	for (var prop in vm.admin) {
        		  if(!vm.admin[prop]) {
        			  vm.admin[prop] = null;
        		  }
        	}
            for (var prop in vm.adminOriginal) {
                if (!vm.adminOriginal[prop]) {
                    vm.adminOriginal[prop] = null;
                }
            }
        	return !angular.equals(vm.admin, vm.adminOriginal);
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    mdeOfficeName: patientFRPMDE.mdeOfficeName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };

		}
	})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('MDEReportAddendumController', MDEReportAddendumController);

    MDEReportAddendumController.$inject = ['$scope', '$state', '$uibModal', 'mdeReport', 'ipmConstants', '$window', 'MdeReportService', 'DataUtils', 'isView'];

    function MDEReportAddendumController($scope, $state, $uibModal, mdeReport, ipmConstants, $window, MdeReportService, DataUtils, isView) {
        var vm = this;
        vm.mdeReport = mdeReport ? mdeReport : {};
        vm.mdeReportOld = {};
        vm.save = save;
        vm.isRequired = false;
        vm.isFinalize = false;
        vm.isDisabled = false;
        vm.isChanged = isChanged;
        vm.isView = isView;
        vm.submitted = false;
        vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';

        init();

        function init() {
            vm.mdeReportOld = DataUtils.deepCopy(vm.mdeReport);
            vm.isFinalize = vm.mdeReport && vm.mdeReport.mdeReportAddendum
            && (vm.mdeReport.mdeReportAddendum.status === 'COMPLETE') ? true : false;
            setIsDisabled();
        }

        function setIsDisabled() {
            if (vm.isView || (vm.mdeReport.patientFRPMDE && (vm.mdeReport.status === 'MDE_ABANDONED' || vm.mdeReport.patientFRPMDE.isViewFrpProgram))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

        function isChanged() {
            for (var field in vm.mdeReport.mdeReportAddendum) {
                if (!vm.mdeReport.mdeReportAddendum[field]) {
                    vm.mdeReport.mdeReportAddendum[field] = null;
                }
            }
            for (var fieldOld in vm.mdeReportOld.mdeReportAddendum) {
                if (!vm.mdeReportOld.mdeReportAddendum[fieldOld]) {
                    vm.mdeReportOld.mdeReportAddendum[fieldOld] = null;
                }
            }
            return !angular.equals(vm.mdeReport, vm.mdeReportOld);
        }

        function save() {
            vm.isSaving = true;
            if (vm.mdeReport) {
                vm.mdeReport.mdeReportAddendum.status = 'COMPLETE'; // set status COMPLETE when save addendum
                MdeReportService.saveMDEReportAddendum(vm.mdeReport).then(function (response) {
                    onSaveSuccess(response)
                }, function error(e) {
                    onSaveError(e);
                });
            }
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            goToMdeReport();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }

        vm.cancel = function() {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                goToMdeReport();
            }
        }

        vm.confirmDialog = function (message) {
            if (vm.isView) {
                return;
            }
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    goToMdeReport();
                }
            });
        }

        function goToMdeReport() {
            $state.go('mde-report', {id: vm.mdeReport.id});
        }
    }
})();
;
(function () {
    'use strict';

    angular
    .module('ipmApp')
    .controller('FRPReportPTPController', FRPReportPTPController);

    FRPReportPTPController.$inject = ['$scope', '$state', '$stateParams', 'frpReport', 'FrpReportService', '$uibModal', 'DataUtils', 'ipmConstants', 'isView', 'templates'];

    function FRPReportPTPController($scope, $state, $stateParams, frpReport, FrpReportService, $uibModal, DataUtils, constants, isView, templates) {
        var vm = this;
        vm.frpReport = frpReport ? frpReport : {};
        vm.isWeeklyReport = false;
		vm.isFinalize = false;
        vm.isChanged = isChanged;
        vm.isView = isView ? true : frpReport ? frpReport.statusFinal === constants.STATUS_FINAL_FRP_MDE : false;
		vm.cancelMessage = 'ipmApp.frpReport.admin.confirmCancel';
		vm.templates = templates ? templates : [];
		vm.templateInputType = constants.FRP_MDE_TEMPLATE;

        vm.dataHeaderReport = {};

        init();

        function init() {
            if (vm.frpReport && vm.frpReport.frpReportAdmin && vm.frpReport.frpReportAdmin.reportType === constants.FRP_REPORT_TYPE.WEEKLY_REPORT) {
                vm.isWeeklyReport = true;
            }
            vm.frpReportId = $stateParams.id;
            FrpReportService.getFrpMedicalReport($stateParams.id).then(function (data) {
                vm.report = data;
                vm.reportOld = DataUtils.deepCopy(data);
				vm.isFinalize = vm.report && vm.report.status === 'COMPLETE' ? true : false;
            });
            if (vm.isView || (vm.frpReport.patientFRPMDE && (vm.frpReport.patientFRPMDE.status === 'MDE_ABANDONED' || frpReport.patientFRPMDE.isViewFrpProgram))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }

            vm.dataHeaderReport = buildDataHeaderReport(vm.frpReport.patientFRPMDE);
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        }

		vm.save = function() {
            submitData(false);
        }

        vm.finalize = function() {
            submitData(true);
        }

        vm.cancel = function() {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

		vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        function submitData(finalize) {
            vm.isSaving = true;
            vm.report.status = finalize ? 'COMPLETE' : 'INPROGRESS';
            FrpReportService.saveFrpMedicalReport(vm.frpReportId, vm.report).then(function (response) {
                onSaveSuccess(response);
            }, function error(e) {
                onSaveError(e);
            });
        }

        function onSaveSuccess(response) {
            vm.isSaving = false;
            back();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }

        function isChanged() {
            return JSON.stringify(vm.report) !== JSON.stringify(vm.reportOld);
        }

        function back() {
            $state.go('frp-report', {id: vm.frpReportId});
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('FRPReportPsychController', FRPReportPsychController);

    FRPReportPsychController.$inject = ['$scope', '$state', '$stateParams', 'frpReport', 'templates', 'FrpReportService', 'DataUtils', 'ipmConstants', '$uibModal', 'isView', 'DateUtils', '$filter', 'MdeReportService', '$window', '$rootScope', '$timeout'];

    function FRPReportPsychController($scope, $state, $stateParams, frpReport, templates, FrpReportService, DataUtils, constants, $uibModal, isView, DateUtils, $filter, MdeReportService, $window, $rootScope, $timeout) {
        var vm = this;
        vm.frpReportOld = null;
        vm.frpReport = frpReport ? frpReport : {};
        vm.templates = templates ? templates : [];
        vm.isLoadingData = false;
        vm.isDisabled = false;
        vm.isFinalize = false;
        vm.isChanged = isChanged;
        vm.disableFields = {
            subjective: false,
            psychologicalNarrative: false,
            psychTestingSelect: false,
            testingInitialScore: false,
            testingInitialScoreLeft: false,
            testingInitialScoreRight: false,
            testingColMidsession: false,
            testingColMidsessionRight: false,
            testingColMidsessionLeft: false,
            testingMidsession: false,
            testingMidsessionLeft: false,
            testingMidsessionRight: false,
            testingDischarge: false,
            testingDischargeLeft: false,
            testingDischargeRight: false,
            testingNotes: false
        };
        vm.cancelMessage = 'ipmApp.frpReport.admin.confirmCancel';
        vm.templateInputType = constants.FRP_MDE_TEMPLATE;
        vm.isView = isView ? true : frpReport ? frpReport.statusFinal === constants.STATUS_FINAL_FRP_MDE : false;
        vm.isWeekly = false;
        vm.isMidSession = false;
        vm.isOther = false;
        vm.requiredFields = [
            'subjective',
            'psychologicalNarrative'
        ];
        vm.midsessionsRemovedList = []; // all for objective and subjective

        vm.checkInValidationSubjectiveTesting = checkInValidationSubjectiveTesting;
        vm.checkInValidationObjectiveTesting = checkInValidationObjectiveTesting;
        vm.dataHeaderReport = {};
        vm.subjectiveImportMdeScores = false;
        vm.objectiveImportMdeScores = false;
        vm.midsessionFields = ["id", "dated",	"testScore", "testScoreLeft", "testScoreRight", "orderNumber", "active", "frpReportPsychSubjectiveResponseId", "frpReportPsychObjectiveResponseId"];
        vm.severity = angular.copy(constants.FRP_PSYCH_SEVERITY);
        vm.severitySubjectives = vm.severity ? vm.severity.subjectives : {};
        vm.severityObjectives = vm.severity ? vm.severity.objectives : {};

        init();

        function init() {
            vm.isMidSession = vm.frpReport && vm.frpReport.frpReportAdmin && vm.frpReport.frpReportAdmin.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT;
            vm.reportType = vm.frpReport && vm.frpReport.frpReportAdmin ? vm.frpReport.frpReportAdmin.reportType : null;
            setMidsessionObjectiveResponses();
            setMidsessionSubjectiveResponses();
            setIsFinal();
            setIsDisabled();
            setDisableFields();

            vm.frpReportId = $stateParams.id;
            vm.dataHeaderReport = buildDataHeaderReport(vm.frpReport.patientFRPMDE);

            if (vm.frpReport.firstReport && vm.frpReport.mdeReportId > 0) {
                MdeReportService.getMdePsychReport(vm.frpReport.mdeReportId).then(function(data) {
                    vm.mdePsychReport = data;
                });
            }
        }

        $rootScope.$on('$viewContentLoaded', function() {
            $timeout(function () { // used $timeout to $digest directly
                initCloneFRP();
                vm.isLoadingData = true;
            }, 1000);
        });

        function initCloneFRP() {
            // clone FRPReport after add midSession
            vm.frpReportOld = DataUtils.deepCopy(vm.frpReport);
            if (vm.frpReportOld.frpReportPsych && vm.frpReportOld.frpReportPsych.objectiveResponses) {
                var item = vm.frpReportOld.frpReportPsych.objectiveResponses[0];
                if (item.midsessions) {
                    _.forEach(item.midsessions, function (o) {
                        if (o.dated) {
                            o.dated = new Date(o.dated);
                        }
                    });
                }
            }
            if (vm.frpReportOld.frpReportPsych && vm.frpReportOld.frpReportPsych.subjectiveResponses) {
                var item = vm.frpReportOld.frpReportPsych.subjectiveResponses[0];
                if (item.midsessions) {
                    _.forEach(item.midsessions, function (o) {
                        if (o.dated) {
                            o.dated = new Date(o.dated);
                        }
                    });
                }
            }
            var subjectiveTemplateReportOld = vm.frpReportOld.frpReportPsych.subjectiveTemplate;
            var subjectiveTemplateReport = vm.frpReport.frpReportPsych.subjectiveTemplate;
            if (subjectiveTemplateReportOld) {
                subjectiveTemplateReportOld.value = subjectiveTemplateReport.id.toString();
                if (!_.find(vm.templates, function (t) { return t.id === subjectiveTemplateReport.id && t.inputType === subjectiveTemplateReport.inputType; })) {
                    subjectiveTemplateReportOld.disabled = true;
                }
            }

            var psychologicalNarrativeTemplateReportOld = vm.frpReportOld.frpReportPsych.psychologicalNarrativeTemplate;
            var psychologicalNarrativeTemplateReport = vm.frpReport.frpReportPsych.psychologicalNarrativeTemplate;
            if (psychologicalNarrativeTemplateReportOld) {
                psychologicalNarrativeTemplateReportOld.value = psychologicalNarrativeTemplateReport.id.toString();
                if (!_.find(vm.templates, function (t) { return t.id === psychologicalNarrativeTemplateReport.id && t.inputType === psychologicalNarrativeTemplateReport.inputType; })) {
                    psychologicalNarrativeTemplateReportOld.disabled = true;
                }
            }
        }

        function setMidsessionSubjectiveResponses() {
            if (!vm.reportType) {
                return;
            }
            if (vm.frpReport.frpReportPsych && vm.frpReport.frpReportPsych.subjectiveResponses) {
                vm.frpReport.frpReportPsych.subjectiveResponses.forEach(function (item) {
                    convertDateMidsessions(item.midsessions);
                    item.midsessions = item.midsessions ? item.midsessions : [];
                    var orderNumber = 0;
                    if (item && item.midsessions.length === 0 && !vm.frpReport.frpReportPsych.isMidSessionSubjectiveUpdated) {
                        // IPM FRP_MDE Feedback-20220727 #37, fix clone object frpReport is error
                        var dateMid = !vm.isMidSession ? null : new Date();
                        var midsession = addNewMidsessionSubjective(orderNumber, item.id, dateMid);
                        item.midsessions.push(midsession);
                    }
                    updateOrderNumberMidsession(item.midsessions);
                });
            }
        }

        function addNewMidsessionSubjective(orderNumber, subjectiveResponseId, dateMid) {
            return {id: null,
                frpReportPsychSubjectiveResponseId: subjectiveResponseId,
                frpReportPsychObjectiveResponseId: null,
                dated: dateMid,
                testScore: "",
                testScoreRight: "",
                testScoreLeft: "",
                testScoreSeverity: null,
                testScoreSeverityRight: null,
                testScoreSeverityLeft: null,
                orderNumber: orderNumber,
                active: true,
                $isOpenCalendar: false};
        }

        function setMidsessionObjectiveResponses() {
            if (!vm.reportType) {
                return;
            }
            if (vm.frpReport.frpReportPsych && vm.frpReport.frpReportPsych.objectiveResponses) {
                vm.frpReport.frpReportPsych.objectiveResponses.forEach(function (item) {
                    convertDateMidsessions(item.midsessions);
                    item.midsessions = item.midsessions ? item.midsessions : [];
                    var orderNumber = 0;
                    if (item && item.midsessions.length === 0 && !vm.frpReport.frpReportPsych.isMidSessionObjectiveUpdated) {
                        // IPM FRP_MDE Feedback-20220727 #37, fix clone object frpReport is error
                        var dateMid = !vm.isMidSession ? null : new Date();
                        var midsession = addNewMidsessionObjective(orderNumber, item.id, dateMid);
                        item.midsessions.push(midsession);
                    }
                    updateOrderNumberMidsession(item.midsessions);
                });
            }
        }

        function updateOrderNumberMidsession(midsessions) {
            if (midsessions) {
                midsessions.forEach(function (ms, index) {
                    ms.orderNumber = index;
                });
            }
        }

        function convertDateMidsessions(midsessions) {
            if (midsessions) {
                _.forEach(midsessions, function (o) {
                    o.dated = DateUtils.convertDateIgnoreTimeZone(o.dated);
                    updateDateMidSession(o); // not convertDateIgnoreTimeZone
                });
            }
        }

        /**
         * updateDateMidSession.
         * fix bug IPMproject-B1918: update date null = now
         * @param midsession
         */
        function updateDateMidSession(midsession) {
            if (vm.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT) {
                midsession.dated = midsession.dated ? midsession.dated : new Date();
            }
        }

        function addNewMidsessionObjective(orderNumber, objectiveResponseId, dateMid) {
            return {id: null,
                frpReportPsychObjectiveResponseId: objectiveResponseId,
                frpReportPsychSubjectiveResponseId: null,
                dated: dateMid,
                testScore: "",
                testScoreRight: "",
                testScoreLeft: "",
                testScoreSeverity: null,
                testScoreSeverityRight: null,
                testScoreSeverityLeft: null,
                orderNumber: orderNumber,
                active: true,
                $isOpenCalendar: false};
        }

        function setDisableFields() {
            if (vm.isView) {
                setDisableAllField();
            } else if (vm.frpReport.frpReportAdmin && vm.frpReport.frpReportAdmin.reportType) {
                if (vm.frpReport.frpReportAdmin.reportType === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT) {
                    setEnableAllField();
                } else if (vm.frpReport.frpReportAdmin.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT) {
                    setEnableAllField();
                } else if (vm.frpReport.frpReportAdmin.reportType === constants.FRP_REPORT_TYPE.FIRST_REPORT) {
                    setEnableAllField();
                } else if (vm.frpReport.frpReportAdmin.reportType === constants.FRP_REPORT_TYPE.OTHER_REPORT) {
                    vm.isOther = true;
                    setEnableAllField();
                } else if (vm.frpReport.frpReportAdmin.reportType === constants.FRP_REPORT_TYPE.WEEKLY_REPORT) {
                    vm.isWeekly = true;
                    setEnableAllField();
                }
            } else { // Disable field with ReportType is Empty
                setDisableReportTypeEmpty();
            }
        }

        function setDisableReportTypeEmpty() {
            for (var field in vm.disableFields) {
                if (field === 'testingMidsession'
                    || field === 'testingMidsessionLeft'
                    || field === 'testingMidsessionRight'
                    || field === 'psychTestingSelect'
                    || field === 'testingNotes'
                    || field === 'testingDischarge'
                    || field === 'testingInitialScore'
                    || field === 'testingColMidsession'
                    || field === 'testingInitialScoreLeft'
                    || field === 'testingInitialScoreRight'
                    || field === 'testingDischargeLeft'
                    || field === 'testingDischargeRight'
                    || field === 'testingColMidsessionLeft'
                    || field === 'testingColMidsessionRight' ) {
                    vm.disableFields[field] = true;
                } else {
                    vm.disableFields[field] = false;
                }
            }
        }

        function setEnableAllField() {
            for (var field in vm.disableFields) {
                vm.disableFields[field] = false;
            }
        }

        function setDisableAllField() {
            for (var field in vm.disableFields) {
                vm.disableFields[field] = true;
            }
        }

        function setIsFinal() {
            vm.isFinalize = vm.frpReport && vm.frpReport.frpReportPsych
            && (vm.frpReport.frpReportPsych.status === 'COMPLETE') ? true : false;
        }

        function setIsDisabled() {
            if (vm.isView || (vm.frpReport.patientFRPMDE && (vm.frpReport.patientFRPMDE.status === 'MDE_ABANDONED' || vm.frpReport.patientFRPMDE.isViewFrpProgram))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

        function isChanged() {
            if (!vm.frpReportOld || !vm.frpReport) { // isLoading
                return false;
            }
            var fieldsChild = ['objectiveResponses', 'subjectiveResponses'];
            for (var field in vm.frpReport.frpReportPsych) {
                if (!vm.frpReport.frpReportPsych[field]) {
                    vm.frpReport.frpReportPsych[field] = null;
                }
            }
            for (var fieldOld in vm.frpReportOld.frpReportPsych) {
                if (!vm.frpReportOld.frpReportPsych[fieldOld]) {
                    vm.frpReportOld.frpReportPsych[fieldOld] = null;
                }
                if (vm.frpReport.frpReportAdmin.reportType && fieldsChild.includes(fieldOld)) { // just check if there is a report type and the FRP report is opened.
                    updateChildScoreNoMatchPsychResponse(vm.frpReportOld.frpReportPsych[fieldOld], vm.frpReport.frpReportPsych[fieldOld]);
                }
            }
            resolveSubjectiveResponses(vm.frpReportOld.frpReportPsych.subjectiveResponses, vm.frpReport.frpReportPsych.subjectiveResponses);
            return !angular.equals(vm.frpReport, vm.frpReportOld);
        }

        function updateChildScoreNoMatchPsychResponse(frpReportPsychChild, frpReportPsychChildNew) {
            if (!_.isEmpty(frpReportPsychChild)) {
                // add child scoreNoMatch for objectiveResponses or subjectiveResponses
                frpReportPsychChild.forEach(function (child, index) {
                    setChildScoreNoMatch(child, frpReportPsychChildNew[index]);
                    // updateTestScoreSeverityResponse(child);
                    if (!_.isEmpty(child.midsessions)) { // check and update Midsession
                        child.midsessions.forEach(function (childMid) {
                            setChildScoreNoMatch(childMid);
                            // updateTestScoreSeverityMid(childMid);
                        });
                    }
                });
            }
        }

        function updateTestScoreSeverityResponse(fieldResponse) {
            if (fieldResponse) {
                // Properties to check and update if they are empty strings
                var propertiesToCheck = [
                    'initialScoreSeverity',
                    'initialScoreSeverityRight',
                    'initialScoreSeverityLeft',
                    'dischargeSeverity',
                    'dischargeSeverityRight',
                    'dischargeSeverityLeft'
                ];
                // Loop through the properties and set them to null if they are empty strings
                propertiesToCheck.forEach(function (property)  {
                    if (fieldResponse[property] === "") {
                        fieldResponse[property] = null;
                    }
                });
            }
        }

        function updateTestScoreSeverityMid(fieldMid) {
            if (fieldMid) {
                // Properties to check and update if they are empty strings
                var propertiesToCheck = [
                    'testScoreSeverity',
                    'testScoreSeverityRight',
                    'testScoreSeverityLeft'
                ];

                // Loop through the properties and set them to null if they are empty strings
                propertiesToCheck.forEach(function (property) {
                    if (fieldMid[property] === "") {
                        fieldMid[property] = null;
                    }
                });
            }
        }

        function setChildScoreNoMatch(fieldElement, fieldElementNew) {
            if (fieldElementNew && fieldElementNew.scoreNoMatch) {
                fieldElement.scoreNoMatch = fieldElementNew.scoreNoMatch;
            }
        }

        function resolveSubjectiveResponses(subjectiveResponsesOld, subjectiveResponses) {
            if (!subjectiveResponsesOld && !subjectiveResponses) {
                return;
            }
            for (var index = 0; index < subjectiveResponsesOld.length; index++) {
                resolveMisessions(subjectiveResponsesOld[index].midsessions, subjectiveResponses[index].midsessions);
            }
        }

        function resolveMisessions(midsessionsOld, midsessions) {
            if (midsessionsOld && midsessions && midsessionsOld.length !== midsessions.length) {
                return;
            }
            for (var index = 0; index < midsessionsOld.length; index++) {
                resolveMisession(midsessionsOld[index], midsessions[index]);
            }
        }
        function resolveMisession(oldMidsession, midsession) {
            for (var field in vm.midsessionFields) {
                if (!oldMidsession[vm.midsessionFields[field]]) {
                    oldMidsession[vm.midsessionFields[field]] = null;
                }
                if (!midsession[vm.midsessionFields[field]]) {
                    midsession[vm.midsessionFields[field]] = null;
                }
            }

        }
        function checkValidation() {
            var requiredFields = vm.requiredFields.slice();
            if (!vm.isOther) {
                var inputRowMid = "rowMid_{code}_{idx}"; // rowMid_CES_D_0
                var inputRowMidLeft = "rowMidLeft_{code}_{idx}"; // rowMidLeft_CES_D_0
                var inputRowMidRight = "rowMidRight_{code}_{idx}"; // rowMidRight_CES_D_0
                if (vm.frpReport.frpReportPsych.objectiveResponses) {
                    vm.frpReport.frpReportPsych.objectiveResponses.forEach(function (item) {
                        if (item.checked) {
                            requiredFields.push("initialScore_" + item.instrument);
                            requiredFields.push("discharge_" + item.instrument);
                            if (item.midsessions) {
                                item.midsessions.forEach(function (itemMis, index) {
                                    var idRowMid = inputRowMid.replace('{code}', item.instrument).replace('{idx}', index);
                                    requiredFields.push(idRowMid);
                                });
                            }
                        }
                    });
                    // get first row midsessions objective
                    var midsessionsColFirst = vm.frpReport.frpReportPsych.objectiveResponses[0].midsessions;
                    if (midsessionsColFirst) {
                        midsessionsColFirst.forEach(function (item, $index) {
                            // $setDirty colMisDate_objective_{{index}}
                            var colName = 'colMisDate_objective_' + $index;
                            requiredFields.push(colName);
                        });
                    }
                }

                if (vm.frpReport.frpReportPsych.subjectiveResponses) {
                    vm.frpReport.frpReportPsych.subjectiveResponses.forEach(function (item) {
                        if (item.checked) {
                            requiredFields.push("initialScore_" + item.instrument);
                            requiredFields.push("initialScoreLeft_" + item.instrument);
                            requiredFields.push("initialScoreRight_" + item.instrument);
                            requiredFields.push("discharge_" + item.instrument);
                            requiredFields.push("dischargeLeft_" + item.instrument);
                            requiredFields.push("dischargeRight_" + item.instrument);
                            if (item.midsessions) {
                                item.midsessions.forEach(function (itemMis, index) {
                                    var idRowMid = inputRowMid.replace('{code}', item.instrument).replace('{idx}', index);
                                    requiredFields.push(idRowMid);
                                    var idRowMidLeft = inputRowMidLeft.replace('{code}', item.instrument).replace('{idx}', index);
                                    requiredFields.push(idRowMidLeft);
                                    var idRowMidRight = inputRowMidRight.replace('{code}', item.instrument).replace('{idx}', index);
                                    requiredFields.push(idRowMidRight);
                                });
                            }
                        }
                    });
                    // get first row midsessions subjectives
                    var midsessionsColFirst = vm.frpReport.frpReportPsych.subjectiveResponses[0].midsessions;
                    if (midsessionsColFirst) {
                        midsessionsColFirst.forEach(function (item, $index) {
                            // $setDirty colMisDate_subjective_{{index}}
                            var colName = 'colMisDate_subjective_' + $index;
                            requiredFields.push(colName);
                        });
                    }
                }

            }

            requiredFields.forEach(function (field) {
                if (field && vm.editForm[field]) {
                    vm.editForm[field].$setDirty();
                }
            });
        }

        function updateMidssessionsRemoved() {
            vm.frpReport.frpReportPsych.midsessionsRemoved = vm.midsessionsRemovedList;
        }

        vm.save = function () {
            submitData(false);
        }

        vm.finalize = function () {
            submitData(true);
        }

        vm.cancel = function () {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };

        function back() {
            goToFrpReport();
        }

        function goToFrpReport() {
            $state.go('frp-report', {id: vm.frpReportId});
        }

        function submitData(finalize) {
            if (vm.isView) {
                return;
            }
            var isInvalidMaxLength = DataUtils.checkForMaxLengthErrors(vm.editForm);
            if (isInvalidMaxLength) {
                return;
            }
            if (finalize) {
                checkValidation();
                // var hasSubjectiveResponses = vm.hasTestingChecked(vm.frpReport.frpReportPsych.subjectiveResponses);
                // var hasObjectiveResponses = vm.hasTestingChecked(vm.frpReport.frpReportPsych.objectiveResponses);
                // if (vm.editForm.$invalid || !hasSubjectiveResponses || !hasObjectiveResponses) {
                if (!vm.reportType || vm.editForm.$invalid) {
                    return;
                }
            }

            if(vm.frpReport.frpReportPsych.psychologicalNarrativeTemplate && vm.frpReport.frpReportPsych.psychologicalNarrativeTemplate.content != vm.frpReport.frpReportPsych.psychologicalNarrative) {
                vm.frpReport.frpReportPsych.psychologicalNarrativeTemplate = null;
            }

            if(vm.frpReport.frpReportPsych.subjectiveTemplate && vm.frpReport.frpReportPsych.subjectiveTemplate.content != vm.frpReport.frpReportPsych.subjective) {
                vm.frpReport.frpReportPsych.subjectiveTemplate = null;
            }
            if (vm.frpReport && vm.frpReport.frpReportPsych) {
                var isValidMidSession = checkValidMidSession(vm.frpReport.frpReportPsych);
                if (!isValidMidSession) {
                    openErrorDialog();
                    return;
                }
                vm.isSaving = true;
                vm.frpReport.frpReportPsych.status = finalize ? 'COMPLETE' : 'INPROGRESS';

                if (vm.reportType) { // fix bug IPMproject-B1917: only update when have reportType
                    vm.frpReport.frpReportPsych.initializedDataTesting = true; // always update initializedDataTesting is true when save frpReportPsych
                    // prepair for Subjectives Testing
                    prepareMidssessionDated(vm.frpReport.frpReportPsych.subjectiveResponses);
                    // prepair for Objectives Testing
                    prepareMidssessionDated(vm.frpReport.frpReportPsych.objectiveResponses);
                    updateMidssessionsRemoved();
                    _.forEach(vm.frpReport.frpReportPsych.midsessionsRemoved, function (item) {
                        item.dated = $filter('date')(item.dated, DateUtils.dateformat());
                    });
                } else {
                    // clear midsessions when report type is not selected
                    if (vm.frpReport.frpReportPsych.subjectiveResponses) {
                        vm.frpReport.frpReportPsych.subjectiveResponses.forEach(function (sr) {
                            sr.midsessions = [];
                        });
                    }
                    if (vm.frpReport.frpReportPsych.objectiveResponses) {
                        vm.frpReport.frpReportPsych.objectiveResponses.forEach(function (sr) {
                            sr.midsessions = [];
                        });
                    }
                }
                FrpReportService.saveFRPReportPsych(vm.frpReport).then(function (response) {
                    onSaveSuccess(response)
                }, function error(e) {
                    onSaveError(e);
                });
            }
        }

        function checkValidMidSession(frpReportPsych) {
            var isValid = false;
            if (frpReportPsych.subjectiveResponses) {
                var lengthMidSessionSub = _.size(frpReportPsych.subjectiveResponses[0].midsessions); // size firstItem subjective
                isValid = _.isEmpty(_.filter(frpReportPsych.subjectiveResponses, function (item) {
                    return lengthMidSessionSub !== _.size(item.midsessions);
                }));
            }
            if (isValid && frpReportPsych.objectiveResponses) {
                var lengthMidSessionObj = _.size(frpReportPsych.objectiveResponses[0].midsessions); // size firstItem objective
                isValid = _.isEmpty(_.filter(frpReportPsych.objectiveResponses, function (item) {
                    return lengthMidSessionObj !== _.size(item.midsessions);
                }));
            }
            return isValid;
        }

        function prepareMidssessionDated(items) {
            var firstItem = items[0];
            if (!_.isEmpty(firstItem.midsessions)) {
                _.forEach(items, function (item) {
                    formatDateToServer(item.midsessions, firstItem);
                });
            }
        }

        function formatDateToServer(midsessions, item) {
            _.forEach(midsessions, function (ms, $index) {
                if (item.midsessions[$index])
                ms.dated = DateUtils.convertLocalDateToServer(item.midsessions[$index].dated);
            });
        }

        function onSaveSuccess(response) {
            vm.isSaving = false;
            goToFrpReport();
        }

        function onSaveError(error) {

            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error && (error.status === 409 || error.status === 400)) {
                vm.error = 'ERROR';
                openErrorDuplicateDialog();
            }
            vm.isSaving = false;
        }

        function checkInValidationSubjectiveTesting() {
            if (vm.frpReport.frpReportPsych && vm.frpReport.frpReportPsych.subjectiveResponses) {
                return _.isEmpty(_.filter(vm.frpReport.frpReportPsych.subjectiveResponses, function (item) {
                    return item && item.checked;
                }));
            }
            return false;
        }

        // vm.hasTestingChecked = function(listItem) {
        //     if (vm.isOther) return true;
        //     // At least 1 Testing is required
        //     if (listItem) {
        //         return !_.isEmpty(_.filter(listItem, function (s) { return s.checked; }))
        //     }
        //     return false;
        // }

        function checkInValidationObjectiveTesting() {
            if (vm.frpReport.frpReportPsych && vm.frpReport.frpReportPsych.objectiveResponses) {
                return _.isEmpty(_.filter(vm.frpReport.frpReportPsych.objectiveResponses, function (item) {
                    return item && item.checked;
                }));
            }
            return false;
        }

        vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        vm.importMdeScores = function(type) {
            if (type === 'subjective') {
                if (vm.subjectiveImportMdeScores && vm.mdePsychReport.subjectives) {
                    _.forEach(vm.frpReport.frpReportPsych.subjectiveResponses, function (frpSub) {
                        var mdeSub = _.first(_.filter(vm.mdePsychReport.subjectives, function (item) {
                            var code = item.code.replace("-", "");
                            var instrument = frpSub.instrument.replace("_", "");
                            return item && frpSub && code === instrument;
                        }));
                        if (mdeSub) {
                            frpSub.initialScore = mdeSub.score;
                            frpSub.initialScoreLeft = mdeSub.scoreLeft;
                            frpSub.initialScoreRight = mdeSub.scoreRight;
                            frpSub.checked = mdeSub.checked; // clone checked
                        }
                    });
                }
            } else if (type === 'objective') {
                if (vm.objectiveImportMdeScores && vm.mdePsychReport.objectives) {
                    _.forEach(vm.frpReport.frpReportPsych.objectiveResponses, function (frpSub) {
                        var mdeSub = _.first(_.filter(vm.mdePsychReport.objectives, function (item) {
                            var code = item.code.replace("-", "");
                            var instrument = frpSub.instrument.replace("_", "");
                            return item && frpSub && code === instrument;
                        }));
                        if (mdeSub) {
                            frpSub.initialScore = mdeSub.score;
                            frpSub.checked = mdeSub.checked; // clone checked
                        }
                    });
                }
            }
        }

        function openErrorDuplicateDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.frpReport.error.saveReportDuplicateMessage"},
                    title: function () {return "ipmApp.frpReport.error.saveReportDuplicateTitle"}
                }
            }).result.then(function() {
                $window.location.reload(); // reload page to load new data FRP
            }, function() {
            });
        }

        function openErrorDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.frpReport.error.saveReportDuplicateMessage"},
                    title: function () {return "ipmApp.frpReport.error.saveReportDuplicateTitle"}
                }
            }).result.then(function() {

            }, function() {
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('FRPReportPTController', FRPReportPTController);

    FRPReportPTController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', 'FrpReportService', 'frpReport', '$timeout', 'DataUtils', '$filter', 'ipmConstants', 'isView', 'templates', 'DateUtils', 'MdeReportService', '$window'];

    function FRPReportPTController($scope, $state, $stateParams, $uibModal, FrpReportService, frpReport, $timeout, DataUtils, $filter, constants, isView, templates, DateUtils, MdeReportService, $window) {
        var vm = this;
        vm.averageCode = 'O40';
        vm.frpReport = frpReport ? frpReport : {};
        vm.isSaving = false;
        vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';
        vm.deletingMidsessionColumnMessage = 'ipmApp.frpReport.pt.deletingMidsessionColumn';
        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1
        };
        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = "MM/dd/yyyy";
        vm.isFinalize = false;
        vm.isChanged = isChanged;
        vm.isDisabled = getIsView();
        vm.subjectiveNoneRomTest = ['O1','O2','O3','O4','O5'];
        vm.subjectiveRomTest = ['O6','O7','O8','O9','O10','O11','O12','O13','O14', 'O100'];
        vm.templateInputType = constants.FRP_MDE_TEMPLATE;
        vm.templates = templates ? templates : [];
        vm.midsessionsRemovedList = [];
        vm.typeSubjectives = 0;
        vm.typeObjective = 1;
        vm.notRequiredObjectives = ['O4','O5'];
        vm.isSubjectiveRequired = true;
        vm.severity = constants.SEVERITY;
        vm.dataHeaderReport = {};
        vm.otherObjectiveDeletes = [];
        vm.subjectiveImportMdeScores = false;
        vm.objectiveImportMdeScores = false;
        vm.subjectiveChecked = false;
        vm.isDischargeReport = false;
        vm.isFirstReport = false;
        vm.haveMidsessionPrevious = false;
        init();

        function init() {
            vm.frpReportId = $stateParams.id;
            vm.dataHeaderReport = buildDataHeaderReport(vm.frpReport.patientFRPMDE);
            vm.haveMidsessionPrevious = vm.frpReport && vm.frpReport.haveMidsessionPrevious ? true : false;
            if (vm.frpReport && vm.frpReport.frpReportAdmin && vm.frpReport.frpReportAdmin.reportType) {
                vm.reportType = vm.frpReport.frpReportAdmin.reportType;
                if (vm.reportType === constants.FRP_REPORT_TYPE.FIRST_REPORT) {
                    vm.isFirstReport = true;
                } else if (vm.reportType === constants.FRP_REPORT_TYPE.WEEKLY_REPORT) {
                    vm.isWeeklyReport = true;
                    vm.isSubjectiveRequired = false;
                } else if (vm.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT){
                    vm.isMidsessionReport = true;
                } else if (vm.reportType === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT) {
                    vm.isDischargeReport = true;
                } else if (vm.reportType === constants.FRP_REPORT_TYPE.OTHER_REPORT) {
                    vm.isOtherReport = true;
                }
            }

            FrpReportService.getFrpPtReport($stateParams.id).then(function (data) {
                vm.report = data;
                vm.isFinalize = vm.report && vm.report.finalize;
                vm.updateSelectAllCheckboxSubjective();
                if (vm.frpReport.firstReport && vm.frpReport.mdeReportId > 0) {
                    MdeReportService.getMdePtReport(vm.frpReport.mdeReportId).then(function(data) {
                        vm.mdePtReport = data;
                    });
                }

                // convert before add new midsession column
                _.forEach(vm.report.subjectives[0].midsessions, function(ms) {
                    if (ms && ms.dated) {
                        ms.dated = DateUtils.convertDateIgnoreTimeZone(ms.dated);
                    }
                    updateDateMidSession(ms); // not convertDateIgnoreTimeZone
                });
                if (vm.report && !_.isEmpty(vm.report.subjectives) && _.isEmpty(vm.report.subjectives[0].midsessions) && !vm.report.isMidSessionSubjectiveUpdated) {
                    vm.addMidsessionToSubjectiveTesting();
                }

                // convert before add new midsession column
                _.forEach(vm.report.objectives, function (o) {
                    o.$isCollapsed = true;
                    _.forEach(o.childs[0].midsessions, function(ms) {
                        if (ms && ms.dated) {
                            ms.dated = DateUtils.convertDateIgnoreTimeZone(ms.dated);
                        }
                        updateDateMidSession(ms); // not convertDateIgnoreTimeZone
                    });
                    // set checked if it is all objective checked of object parent
                    setIsAllObjectiveChecked(o, getOtherObjectiveOfObjective(o));
                });
                if (vm.report && !_.isEmpty(vm.report.objectives) && !vm.report.isMidSessionObjectiveUpdated) {
                    _.forEach(vm.report.objectives, function (objective) {
                        if (!_.isEmpty(objective.childs) && _.isEmpty(objective.childs[0].midsessions)) {
                            vm.addMidsessionToObjectiveTesting(objective);
                        } else { // init data missession for otherObjective, don't create for objectives
                            // get otherObjectives Of Objective parent by typeReportId
                            var otherObjectivesOfObjective = getOtherObjectiveOfObjective(objective);
                            // create new mission when missions is empty
                            if (!_.isEmpty(otherObjectivesOfObjective) && _.isEmpty(otherObjectivesOfObjective[0].midsessions)) {
                                addNewMidsessionsToOtherObjective(otherObjectivesOfObjective, objective);
                            }
                        }

                    });
                }

                vm.reportOld = DataUtils.deepCopy(data);

                resetDateRequest(vm.report);
                resetDateRequest(vm.reportOld);
            });
        }

        function getOtherObjectiveOfObjective(objective) {
            return _.filter(vm.report.otherObjectives, function (other) {
                return other.typeReportId === objective.typeReportId;
            });
        }

        function setIsAllObjectiveChecked(objective, otherObjectivesOfObjective) {
            var isAllObjectiveChecked = !_.isEmpty(objective.childs) && _.isEmpty(_.filter(objective.childs, function (child) { return child.code !== vm.averageCode && !child.checked; }));
            if (isAllObjectiveChecked && !_.isEmpty(otherObjectivesOfObjective)) {
                isAllObjectiveChecked = _.every(otherObjectivesOfObjective, function (child) { return child.checked; });
            }
            objective.checked = isAllObjectiveChecked;
            vm.calculatorLR(objective);
        }

        function getIsView() {
            if (isView) {
                return true;
            }
            if (frpReport) {
                return frpReport.statusFinal === constants.STATUS_FINAL_FRP_MDE || (frpReport.patientFRPMDE && frpReport.patientFRPMDE.isViewFrpProgram);
            }
            return false;
        }

        vm.calculatorLR = function (objective) {
            if (objective && objective.code === 'O5') {
                calcAndUpdateSum(objective.childs, constants.FRP_REPORT_TYPE.FIRST_REPORT);  // update first report

                for (var i = 0; i < objective.childs[0].midsessions.length; i++) {
                    calcAndUpdateSum(objective.childs, constants.FRP_REPORT_TYPE.MID_SESSION_REPORT, i); // update midsession report
                }

                calcAndUpdateSum(objective.childs, constants.FRP_REPORT_TYPE.DISCHARGE_REPORT); //update orther report
            }
        }

        function calcAndUpdateSum(childs, type, index) {
            var rightValue = 0;
            var leftValue = 0;
            var countR = 0;
            var countL = 0;
            var isAllCheck = true;
            childs.forEach(function (child) {
                var left = getLeftChild(child, type, index);
                var right = getRightChild(child, type, index);
                if (child.code != vm.averageCode) {
                    if (child.checked) { // calculate total Average
                         if(right && !isNaN(right) && Number(right) !== 0) {
                             rightValue += Number(right);
                             countR ++;
                         }
                        if (left && !isNaN(left) && Number(left) !== 0) {
                            leftValue += Number(left);
                            countL++;
                        }
                    } else if(isAllCheck){
                       isAllCheck = false;
                    }
                } else { // calculate Average
                     if(isAllCheck) {
                         right = calAverage(rightValue, countR);
                         left = calAverage(leftValue, countL);
                         // update Average
                         updateAverage(child, left, right, type, index);
                     } else {
                        updateAverage(child, null, null, type, index);  //set average is null if have a Notch uncheck
                    }
                    // show average when all checked
                    child.checked = isAllCheck;
                     return;
                }
            });
        }

        function updateAverage(child, left, right, type, index) {
            if (type === constants.FRP_REPORT_TYPE.FIRST_REPORT) {
                child.leftValue = left;
                child.rightValue = right;
            }

            if (type === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT) {
                child.midsessions[index].testScoreLeft = left;
                child.midsessions[index].testScoreRight = right;
            }

            if (type === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT) {
                child.dischargeLeft = left;
                child.dischargeRight = right;
            }
        }

        function getLeftChild(child, type, index){
             if (type === constants.FRP_REPORT_TYPE.FIRST_REPORT) {
                return child.leftValue;
             }

             if (type === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT) {
                return child.midsessions[index].testScoreLeft;
             }

             if (type === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT) {
                return child.dischargeLeft;
             }
        }

        function getRightChild(child, type, index){
            if (type === constants.FRP_REPORT_TYPE.FIRST_REPORT) {
                return child.rightValue;
            }

            if (type === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT) {
               return child.midsessions[index].testScoreRight;
            }

            if (type === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT) {
                return child.dischargeRight;
            }
        }

        function calAverage(total, count) {
            if (count > 0) {
                return (total / count).toFixed(2);
            } else {
                return null;
            }
        }
        /**
         * updateDateMidSession.
         * fix bug IPMproject-B1918: update date null = now
         * @param midsession
         */
        function updateDateMidSession(midsession) {
            if (!vm.isDisabled) {
                midsession.dated = midsession.dated ? midsession.dated : new Date();
            }
        }

        vm.isAverage = function(child) {
            return child.code === vm.averageCode;
        }

        function checkValidation() {
            vm.editForm['subjective'].$setDirty();
            vm.editForm['physical_functional_narrative'].$setDirty();
            _.forEach(vm.report.subjectives, function(s) {
                if (s.checked) {
                    vm.editForm['score_' + s.code].$setDirty();
                    vm.editForm['discharge_' + s.code].$setDirty();
                    s.midsessions.forEach(function (itemMis, index) {
                        vm.editForm[s.code + '_midsession_' + index].$setDirty();
                    });
                }
            });
            _.forEach(vm.report.objectives, function(o) {
                _.forEach(o.childs, function(c) {
                    validateObjectives(c);
                });
            });
            _.forEach(vm.report.otherObjectives, function(o) {
                validateObjectives(o);
                vm.editForm['name_' + o.code].$setDirty();
            });
            checkValidationColumnMidsessions();
        }

        function checkValidationColumnMidsessions() {
            // set $setDirty for midsessionsDate column subjectives
            var midsessionsSubFirst = vm.report.subjectives[0].midsessions;
            if (midsessionsSubFirst) {
                midsessionsSubFirst.forEach(function (item, $index) {
                    var colName = 'field_subjective_midsession_date_' + $index;
                    vm.editForm[colName].$setDirty();
                });
            }
            // set $setDirty for midsessionsDate column objectives
            vm.report.objectives.forEach(function (obj) {
                if (obj.childs) {
                    var childMidsessionsfrist = obj.childs[0].midsessions;
                    if (childMidsessionsfrist) {
                        childMidsessionsfrist.forEach(function (item, $index) {
                            var colName = 'field_objective_midsession_date_' + obj.code + "_" + $index;
                            vm.editForm[colName].$setDirty();
                        });
                    }
                }
            });
        }

        vm.save = function () {
            submitData(false);
        }

        vm.finalize = function () {
            submitData(true);
        }

        function validateObjectives(c) {
            if (c.checked) {
                if (c.type === 'NORMAL_TEXT_FIELD') {
                    vm.editForm['input_' + c.code].$setDirty();
                } else if (c.type === 'LEFT_RIGHT_TEXT_FIELD') {
                    vm.editForm['left_input_' + c.code].$setDirty();
                    vm.editForm['right_input_' + c.code].$setDirty();
                }
                // Discharge
                if (c.type === 'NORMAL_TEXT_FIELD') {
                    vm.editForm['discharge_' + c.code].$setDirty();
                } else if (c.type === 'LEFT_RIGHT_TEXT_FIELD') {
                    vm.editForm['discharge_left_' + c.code].$setDirty();
                    vm.editForm['discharge_right_' + c.code].$setDirty();
                }
                // Midsession
                for (var indexMs = 0; indexMs < c.midsessions.length; indexMs++) {
                    if (c.type === 'NORMAL_TEXT_FIELD') {
                        vm.editForm[c.code + '_midsession_' + indexMs].$setDirty();
                    } else if (c.type === 'LEFT_RIGHT_TEXT_FIELD') {
                        vm.editForm[c.code + '_midsession_right_' + indexMs].$setDirty();
                        vm.editForm[c.code + '_midsession_left_' + indexMs].$setDirty();
                    }
                }
            }
        }

        function isEqualSubjectives(v1, v2) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var subjectiveOld = v1[idx];
                var subjective = v2[idx];
                isEqual = DataUtils.isEqualBoolean(subjectiveOld.checked, subjective.checked);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(subjectiveOld.score, subjective.score);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(subjectiveOld.notes, subjective.notes);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(subjectiveOld.discharge, subjective.discharge);
                if (!isEqual) return false;
                isEqual = isEqualMidsessions(subjectiveOld.midsessions, subjective.midsessions);
                if (!isEqual) return false;
            }
            return isEqual;
        }

        function isEqualObjectives(v1, v2) {
            var isEqual = true;
            for (var idx = 0; idx < v1.length; idx++) {
                var objectiveOld = v1[idx];
                var objective = v2[idx];
                for (var index = 0; index < objectiveOld.childs.length; index++) {
                    var childOld = objectiveOld.childs[index];
                    var child = objective.childs[index];
                    isEqual = DataUtils.isEqualBoolean(childOld.checked, child.checked);
                    if (!isEqual) return false;
                    if (childOld.type === 'NORMAL_TEXT_FIELD') {
                        isEqual = DataUtils.isEqualText(childOld.value, child.value);
                        if (!isEqual) return false;
                    } else if (childOld.type === 'LEFT_RIGHT_TEXT_FIELD') {
                        isEqual = DataUtils.isEqualText(childOld.leftValue, child.leftValue);
                        if (!isEqual) return false;
                        isEqual = DataUtils.isEqualText(childOld.rightValue, child.rightValue);
                        if (!isEqual) return false;
                    }
                    if (childOld.type === 'NORMAL_TEXT_FIELD') {
                        isEqual = DataUtils.isEqualText(childOld.discharge, child.discharge);
                        if (!isEqual) return false;
                    } else if (childOld.type === 'LEFT_RIGHT_TEXT_FIELD') {
                        isEqual = DataUtils.isEqualText(childOld.dischargeLeft, child.dischargeLeft);
                        if (!isEqual) return false;
                        isEqual = DataUtils.isEqualText(childOld.dischargeRight, child.dischargeRight);
                        if (!isEqual) return false;
                    }

                    isEqual = DataUtils.isEqualText(childOld.notes, child.notes);
                    if (!isEqual) return false;
                    isEqual = isEqualMidsessions(childOld.midsessions, child.midsessions);
                    if (!isEqual) return false;
                }
            }
            return isEqual;
        }

        function isEqualOtherObjectives(v1, v2) {
            var isEqual = true;
            if (v1.length != v2.length) {
                return false;
            }
            for (var idx = 0; idx < v1.length; idx++) {
                var otherObjectiveOld = v1[idx];
                var otherObjective = v2[idx];
                isEqual = DataUtils.isEqualBoolean(otherObjectiveOld.checked, otherObjective.checked);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(otherObjectiveOld.name, otherObjective.name);
                if (!isEqual) return false;
                if (otherObjectiveOld.type === 'NORMAL_TEXT_FIELD') {
                    isEqual = DataUtils.isEqualText(otherObjectiveOld.value, otherObjective.value);
                    if (!isEqual) return false;
                } else if (otherObjectiveOld.type === 'LEFT_RIGHT_TEXT_FIELD') {
                    isEqual = DataUtils.isEqualText(otherObjectiveOld.leftValue, otherObjective.leftValue);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(otherObjectiveOld.rightValue, otherObjective.rightValue);
                    if (!isEqual) return false;
                }
                if (otherObjectiveOld.type === 'NORMAL_TEXT_FIELD') {
                    isEqual = DataUtils.isEqualText(otherObjectiveOld.discharge, otherObjective.discharge);
                    if (!isEqual) return false;
                } else if (otherObjectiveOld.type === 'LEFT_RIGHT_TEXT_FIELD') {
                    isEqual = DataUtils.isEqualText(otherObjectiveOld.dischargeLeft, otherObjective.dischargeLeft);
                    if (!isEqual) return false;
                    isEqual = DataUtils.isEqualText(otherObjectiveOld.dischargeRight, otherObjective.dischargeRight);
                    if (!isEqual) return false;
                }

                isEqual = DataUtils.isEqualText(otherObjectiveOld.notes, otherObjective.notes);
                if (!isEqual) return false;
                isEqual = isEqualMidsessions(otherObjectiveOld.midsessions, otherObjective.midsessions);
                if (!isEqual) return false;
            }
            return isEqual;
        }

        function isChanged() {
            var isEqual = true;
            // Subjective
            isEqual = DataUtils.isEqualText(vm.reportOld.subjective, vm.report.subjective);
            if (!isEqual) return true;
            // Physical Functional Narrative
            isEqual = DataUtils.isEqualText(vm.reportOld.physicalFunctionalNarrative, vm.report.physicalFunctionalNarrative);
            if (!isEqual) return true;
            // Subjectives Testing
            isEqual = isEqualSubjectives(vm.reportOld.subjectives, vm.report.subjectives);
            if (!isEqual) return true;
            // Objective Testing
            isEqual = isEqualObjectives(vm.reportOld.objectives, vm.report.objectives);
            if (!isEqual) return true;
            if (!_.isEmpty(vm.reportOld.otherObjectives) || !_.isEmpty(vm.report.otherObjectives)) {
                isEqual = isEqualOtherObjectives(vm.reportOld.otherObjectives, vm.report.otherObjectives);
                if (!isEqual) return true;
            }
            return !isEqual;
        }

        function back() {
            $state.go('frp-report', { id: vm.frpReportId });
        }

        vm.cancel = function () {
            if (vm.isDisabled) {
                back();
                return;
            }
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        vm.confirmDialogRemoveMidsessions = function (message, type, object, $index) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'center-dialog-message vertical-center',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    if (type === vm.typeSubjectives) {
                        vm.removeColMidsessionsSubjectivesCallBack(object, $index);
                        vm.report.isMidSessionSubjectiveUpdated = true;
                    }

                    if (type === vm.typeObjective) {
                        vm.removeColMidsessionsObjectivesCallBack(object, $index);
                        vm.report.isMidSessionObjectiveUpdated = true;
                    }
                }
            });
        };
        
        function submitData(finalize) {
            var isInvalidMaxLength = DataUtils.checkForMaxLengthErrors(vm.editForm);
            if (isInvalidMaxLength) {
                return;
            }
            if (finalize) {
                checkValidation();
                if (vm.editForm.$invalid || !vm.hasTestingChecked()) {
                    return;
                }
            }
            vm.isSaving = true;
            vm.report.finalize = finalize;
            if(vm.report.physicalFunctionalNarrativeTemplate && vm.report.physicalFunctionalNarrativeTemplate.content != vm.report.physicalFunctionalNarrative) {
                vm.report.physicalFunctionalNarrativeTemplate = null;
            }

            if(vm.report.subjectiveTemplate && vm.report.subjectiveTemplate.content != vm.report.subjective) {
                vm.report.subjectiveTemplate = null;
            }

            if (vm.reportType) { // fix bug IPMproject-B1917: only update when have reportType
                prepairDataForSave();
                vm.report.initializedDataTesting = true; // always update initializedDataTesting is true when save frpReportPT
            } else {
                // clear midsessions when report type is not selected
                if (vm.report.objectives) {
                    vm.report.objectives.forEach(function (sr) {
                        if (sr.childs) {
                            sr.childs.forEach(function (sc) {
                                sc.midsessions = [];
                            });
                        }
                    });
                }
                if (vm.report.subjectives) {
                    vm.report.subjectives.forEach(function (sr) {
                        sr.midsessions = [];
                    });
                }
            }
            FrpReportService.saveFrpPtReport(vm.frpReportId, vm.report).then(function (response) {
                onSaveSuccess(response);
            }, function error(e) {
                onSaveError(e);
            });
        }

        function onSaveSuccess(response) {
            vm.isSaving = false;
            back();
        }

        function onSaveError(error) {
            // var errorMessage = error.headers('X-ipmApp-error-message');
            if (error && (error.status === 409 || error.status === 400)) {
                vm.error = 'ERROR';
                openErrorDuplicateDialog();
            }
            vm.isSaving = false;
        }

        function prepairDataForSave() {
            // prepair for Subjectives Testing
            prepareMidssessionDated(vm.report.subjectives);
            // prepair for Objectives Testing
            _.forEach(vm.report.objectives, function (objective) {
                prepareMidssessionDated(objective.childs);
            });

            if (vm.report.otherObjectives && !_.isEmpty(vm.report.otherObjectives)) {
                prepareMidssessionDatedOfOtherObjectives(vm.report.otherObjectives);
            }
            // update Midssession removed
            updateMidssessionRemoved();
            // prepareMidssessionDated(vm.report.midsessionsRemoved[0].dated);
            _.forEach(vm.report.midsessionsRemoved, function (item) {
                if (!Number.isNaN(item)) {
                    item.dated = $filter('date')(item.dated, vm.dateFormatToServer);
                }
            });
            $filter('date')(vm.report.midsessionsRemoved.dated, vm.dateFormatToServer)

            _.forEach(vm.report.otherObjectives, function(other) {
                if (!other.checked) {
                    other.checked = false;
                }
                if (!other.checked && !other.value && !other.discharge && !other.name && !isDirtyMs(other)) {
                    other.active = false;
                }
            });

            _.forEach(vm.otherObjectiveDeletes, function (otherObjectiveDelete) {
                _.forEach(otherObjectiveDelete.midsessions, function(item) {
                    if (!Number.isNaN(item)) {
                        item.dated = $filter('date')(item.dated, vm.dateFormatToServer);
                    }
                })
            });
            vm.report.otherObjectives.push.apply(vm.report.otherObjectives, vm.otherObjectiveDeletes);
        }

        function isDirtyMs(other) {
            _.forEach(other.midsessions, function (ms) {
                if (ms.value) {
                    other.active = true;
                    return true;
                }
            });
            return false;
        }

        function prepareMidssessionDated(items) {
            var firstItem = items[0];
            if (!_.isEmpty(firstItem.midsessions)) {
                _.forEach(items, function (item) {
                    formatDateToServer(item.midsessions, firstItem);
                });
            }
        }

        function prepareMidssessionDatedOfOtherObjectives(items) {
            var firstItem = items[0];
            if (!_.isEmpty(firstItem.midsessions)) {
                _.forEach(items, function (item) {
                    _.forEach(item.midsessions, function (ms) {
                        ms.dated = $filter('date')(ms.dated, vm.dateFormatToServer);
                    });
                });
            }
        }

        function formatDateToServer(midsessions, item) {
            _.forEach(midsessions, function (ms, $index) {
                ms.dated = $filter('date')(item.midsessions[$index].dated, vm.dateFormatToServer);
            });
        }
        vm.hasObjectiveChecked = function() {
            // Report Type undefined
            if (!vm.reportType) return false;
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport) return true;
            var isChecked = false;
            for (var index = 0; index < vm.report.objectives.length; index++) {
                isChecked = vm.hasChildChecked(vm.report.objectives[index]);
                if (!isChecked) return false;
            }
            return isChecked;
        }

        vm.hasOtherObjectiveChecked = function() {
            // Report Type undefined
            if (!vm.reportType) return false;
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport || _.isEmpty(_.filter(vm.report.otherObjectives, function(o) { return o.checked; })) ) return true;
            var isChecked = false;
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                isChecked = vm.hasOtherChecked(vm.report.otherObjectives[index]);
                if (!isChecked) return false;
            }
            return isChecked;
        }

        vm.hasObjectiveCheckedInvalid = function() {
            // Report Type undefined
            if (!vm.reportType) return false;
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport) return false;
            for (var index = 0; index < vm.report.objectives.length; index++) {
                var o = vm.report.objectives[index];
                var invalid = vm.hasChildCheckedInvalid(o);
                if (invalid) return true;
            }
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var o = vm.report.otherObjectives[index];
                var invalid = vm.hasOtherCheckedInvalid(o);
                if (invalid) return true;
            }
            return false;
        }

        vm.hasOtherObjectiveCheckedInvalid = function() {
            // Report Type undefined
            if (!vm.reportType) return false;
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport) return false;
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var o = vm.report.otherObjectives[index];
                var invalid = vm.hasOtherCheckedInvalid(o);
                if (invalid) return true;
            }
            return false;
        }

        vm.hasChildChecked = function (objective) {
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport || vm.notRequiredObjectives.includes(objective.code)) return true;
            if (objective) {
                if (vm.subjectiveNoneRomTest.includes(objective.code)) {
                    return !_.isEmpty(_.filter(objective.childs, function(o) { return o.checked; })) || !_.isEmpty(_.filter(vm.report.otherObjectives, function(o) { return o.checked && o.typeReportId === objective.typeReportId; }))
                } else if (vm.subjectiveRomTest.includes(objective.code)) {
                    return vm.hasRomTestingChecked();
                }
            }
            return false;
        }

        vm.hasOtherChecked = function (otherObjective) {
            var parentCode = getParentCode(otherObjective.code);
            if (vm.isOtherReport || vm.notRequiredObjectives.includes(parentCode)) return true;
            if (otherObjective) {
                if (vm.subjectiveNoneRomTest.includes(parentCode)) {
                    return otherObjective.checked;
                } else if (vm.subjectiveRomTest.includes(parentCode)) {
                    return vm.hasOtherRomTestingChecked();
                }
            }
            return false;
        }

        vm.isChildRequired = function(objective) {
            if (vm.isOtherReport) return false;
            if (objective) {
                if (vm.subjectiveNoneRomTest.includes(objective.code)) {
                    return !(vm.notRequiredObjectives.includes(objective.code));
                } else if (vm.subjectiveRomTest.includes(objective.code)) {
                    if (vm.hasRomTestingChecked()) {
                        return vm.hasChildCheckedNotCheckRom(objective);
                    } else {
                        return true;
                    }
                }
            }
            return false;
        }

        vm.isOtherRequired = function(objective) {
            if (vm.isOtherReport) return false;
            var parentCode = getParentCode(objective.code);
            if (objective) {
                if (vm.subjectiveNoneRomTest.includes(parentCode)) {
                    return !(vm.notRequiredObjectives.includes(parentCode));
                } else if (vm.subjectiveRomTest.includes(parentCode)) {
                    if (vm.hasOtherRomTestingChecked()) {
                        return vm.hasOtherCheckedNotCheckRom(objective);
                    } else {
                        return true;
                    }
                }
            }
            return false;
        }

        vm.hasRomTestingChecked = function() {
            for (var index = 0; index < vm.report.objectives.length; index++) {
                var objective = vm.report.objectives[index];
                if (vm.subjectiveRomTest.includes(objective.code)) {
                    var isChecked = !_.isEmpty(_.filter(objective.childs, function(o) { return o.checked; }))
                    if (isChecked) return true;
                }
            }
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var objective = vm.report.otherObjectives[index];
                if (vm.subjectiveRomTest.includes(getParentCode(objective.code))) {
                    var isChecked = objective.checked;
                    if (isChecked) return true;
                }
            }
            return false;
        }

        vm.hasOtherRomTestingChecked = function() {
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var otherObjective = vm.report.otherObjectives[index];
                if (vm.subjectiveRomTest.includes(getParentCode(otherObjective.code))) {
                    var isChecked = otherObjective.checked;
                    if (isChecked) return true;
                }
            }
            return false;
        }

        vm.hasChildCheckedNotCheckRom = function(objective) {
            if (objective) {
                return !_.isEmpty(_.filter(objective.childs, function(o) { return o.checked; })) || !_.isEmpty(_.filter(vm.report.otherObjectives, function(o) { return o.checked && o.typeReportId === objective.typeReportId; }))
            }
            return false;
        }

        vm.hasOtherCheckedNotCheckRom = function(objective) {
            if (objective) {
                return !_.isEmpty(_.filter(vm.report.otherObjectives, function(o) { return o.checked && o.typeReportId == objective.typeReportId; }))
            }
            return false;
        }

        vm.hasChildCheckedInvalid = function(objective) {
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport) return false;
            for (var index = 0; index < objective.childs.length; index++) {
                var c = objective.childs[index];
                if (c.checked) {
                        if (c.type === 'NORMAL_TEXT_FIELD') {
                            var control = vm.editForm['input_' + c.code];
                            var controlDischarge = vm.editForm['discharge_' + c.code];
                            if (control && control.$dirty && control.$error.required) return true;
                            if (controlDischarge && controlDischarge.$dirty && controlDischarge.$error.required) return true;
                        } else if (c.type === 'LEFT_RIGHT_TEXT_FIELD') {
                            var controlLeft = vm.editForm['left_input_' + c.code];
                            var controlRight = vm.editForm['right_input_' + c.code];
                            var controlDischargeRight = vm.editForm['discharge_right_' + c.code];
                            var controlDischargeLeft = vm.editForm['discharge_left_' + c.code];
                            if (controlLeft && controlLeft.$dirty && controlLeft.$error.required) return true;
                            if (controlRight && controlRight.$dirty && controlRight.$error.required) return true;
                            if (controlDischargeRight && controlDischargeRight.$dirty && controlDischargeRight.$error.required) return true;
                            if (controlDischargeLeft && controlDischargeLeft.$dirty && controlDischargeLeft.$error.required) return true;
                        }
                    for (var indexMs = 0; indexMs < c.midsessions.length; indexMs++) {
                        if (c.type === 'NORMAL_TEXT_FIELD') {
                            var msControl = vm.editForm[c.code + '_midsession_' + indexMs]
                            if (msControl && msControl.$dirty && msControl.$error.required) return true;
                        } else if (c.type === 'LEFT_RIGHT_TEXT_FIELD') {
                            var msControlLeft = vm.editForm[c.code + '_midsession_left_' + indexMs];
                            var msControlRight = vm.editForm[c.code + '_midsession_right_' + indexMs];
                            if (msControlLeft && msControlLeft.$dirty && msControlLeft.$error.required) return true;
                            if (msControlRight && msControlRight.$dirty && msControlRight.$error.required) return true;
                        }
                    }
                }
            }
            return false;
        }

        vm.hasOtherCheckedInvalid = function(objective) {
            if (vm.isOtherReport) return false;
            for (var index = 0; index < vm.report.otherObjectives.length; index++) {
                var otherObjective = vm.report.otherObjectives[index];
                if (otherObjective.checked && otherObjective.typeReportId === objective.typeReportId) {
                    var controlName = vm.editForm['name_' + otherObjective.code];
                    if (controlName && controlName.$dirty && controlName.$error.required) return true;
                    if (otherObjective.type === 'NORMAL_TEXT_FIELD') {
                        var control = vm.editForm['input_' + otherObjective.code];
                        if (control && control.$dirty && control.$error.required) return true;
                    } else if (otherObjective.type === 'LEFT_RIGHT_TEXT_FIELD') {
                        var controlLeft = vm.editForm['left_input_' + otherObjective.code];
                        var controlRight = vm.editForm['right_input_' + otherObjective.code];
                        if (controlLeft && controlLeft.$dirty && controlLeft.$error.required) return true;
                        if (controlRight && controlRight.$dirty && controlRight.$error.required) return true;
                    }
                    for (var indexMs = 0; indexMs < otherObjective.midsessions.length; indexMs++) {
                        if (otherObjective.type === 'NORMAL_TEXT_FIELD') {
                            var msControl = vm.editForm[otherObjective.code + '_midsession_' + indexMs]
                            if (msControl && msControl.$dirty && msControl.$error.required) return true;
                        } else if (otherObjective.type === 'LEFT_RIGHT_TEXT_FIELD') {
                            var msControlLeft = vm.editForm[otherObjective.code + '_midsession_left_' + indexMs];
                            var msControlRight = vm.editForm[otherObjective.code + '_midsession_right_' + indexMs];
                            if (msControlLeft && msControlLeft.$dirty && msControlLeft.$error.required) return true;
                            if (msControlRight && msControlRight.$dirty && msControlRight.$error.required) return true;
                        }
                    }
                }
            }
            return false;
        }

        vm.hasItemChecked = function (listItem) {
            // Report Type undefined
            if (!vm.reportType) return false;
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport) return true;
            if (listItem) {
                return !_.isEmpty(_.filter(listItem, function (s) { return s.checked; }))
            }
            return false;
        }

        vm.hasItemCheckedInvalid = function(listItem) {
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport) return false;
            for (var index = 0; index < listItem.length; index++) {
                var s = listItem[index];
                if (s.checked) {
                    var control = vm.editForm['score_' + s.code];
                    if (control.$dirty && control.$error.required) return true;
                }
            }
        }

        vm.hasTestingChecked = function() {
            // Report Type undefined
            if (!vm.reportType) return false;
            // Other Report not required Subjective Test and Objective Test
            if (vm.isOtherReport) return true;
            // At least 1 Subjective Test is required
            var isChecked = vm.hasItemChecked(vm.report.subjectives);
            if (!isChecked) return false;
            // At least 1 Activity Test of Objective Test is required
            for (var index = 0; index < vm.report.objectives.length; index++) {
                var objective = vm.report.objectives[index];
                isChecked = vm.hasChildChecked(objective);
                if (!isChecked) return false;
            }
            return true;
        }

        function resetDateRequest(data) {
            if (data && !_.isEmpty(data.subjectives) && !_.isEmpty(data.subjectives[0].midsessions)) {
                _.forEach(data.subjectives, function (s, $idx) {
                    _.forEach(s.midsessions, function (ms) {
                        onResetDateRequest(ms, $idx === 0);
                    });
                });
            }
            if (data && !_.isEmpty(data.objectives)) {
                if (!_.isEmpty(data.objectives[0].childs) && !_.isEmpty(data.objectives[0].childs[0].midsessions)) {
                    _.forEach(data.objectives, function (o, $id) {
                        _.forEach(o.childs, function (c, $idx) {
                            _.forEach(c.midsessions, function (ms) {
                                onResetDateRequest(ms, $id === 0 && $idx === 0);
                            });
                        });
                    });
                }
            }
        }

        function onResetDateRequest(midsession, isFirstLine) {
            if (isFirstLine) {
                midsession.datePickerOpenStatus = { dateRequested: false }
            }
        }

        vm.addMidsessionToSubjectiveTesting = function () {
            var firstSubjective = vm.report.subjectives[0];
            var currentDate = vm.isMidsessionReport ? new Date() : null;
            var orderNumber = _.isEmpty(firstSubjective.midsessions) ? 0 : _.maxBy(firstSubjective.midsessions, function (ms) { return ms.orderNumber }).orderNumber + 1;

            _.forEach(vm.report.subjectives, function (s) {
                s.midsessions.push({
                    dated: currentDate,
                    testScore: '',
                    testScoreRight: '',
                    testScoreLeft: '',
                    orderNumber: orderNumber,
                    active: true,
                    frpReportPTSubjectiveResponseId: s.id
                });
            });
        }

        vm.addMidsessionToObjectiveTesting = function (objective) {
            var firstChildObjective = objective.childs[0];
            var currentDate = vm.isMidsessionReport ? new Date() : null;
            var orderNumber = _.isEmpty(firstChildObjective.midsessions) ? 0 : _.maxBy(firstChildObjective.midsessions, function (ms) { return ms.orderNumber }).orderNumber + 1;
            _.forEach(objective.childs, function (c) {
                c.midsessions.push({
                    dated: currentDate,
                    testScore: '',
                    testScoreRight: '',
                    testScoreLeft: '',
                    orderNumber: orderNumber,
                    active: true,
                    frpReportPTObjectiveResponseId: c.id
                });
            });
            _.forEach(vm.report.otherObjectives, function (other) {
                if (other.typeReportId == objective.typeReportId) {
                    other.midsessions.push(createNewMidsession(currentDate, orderNumber));
                }

            });
        }

        function addNewMidsessionsToOtherObjective(otherObjectives, objective) {
            if (otherObjectives && objective)
            var firstChildObjective = objective.childs[0];
            var currentDate = vm.isMidsessionReport ? new Date() : null;
            var orderNumber = _.isEmpty(firstChildObjective.midsessions) ? 0 : _.maxBy(firstChildObjective.midsessions, function (ms) { return ms.orderNumber }).orderNumber + 1;
            _.forEach(otherObjectives, function (other) {
                    other.midsessions.push(createNewMidsession(currentDate, orderNumber));
            })
        }

        /**
         * createNewMidsession
         * clone old logic create NewMidsession
         * @param currentDate
         * @param orderNumber
         * @return {{testScoreRight: string, orderNumber: *, testScore: string, dated: *, active: boolean, testScoreLeft: string}}
         */
        function createNewMidsession(currentDate, orderNumber) {
            return {
                dated: currentDate,
                testScore: '',
                testScoreRight: '',
                testScoreLeft: '',
                orderNumber: orderNumber,
                active: true
            }
        }

        vm.openSubjectiveCalendar = function ($idx, date) {
            if (vm.checkDisableColMidsessions($idx, vm.report.subjectives[0].midsessions)) {
                return;
            }
            if (!vm.report.subjectives[0].midsessions[$idx].datePickerOpenStatus) {
                vm.report.subjectives[0].midsessions[$idx].datePickerOpenStatus = {
                    dateRequested: true
                };
            }
            vm.report.subjectives[0].midsessions[$idx].datePickerOpenStatus[date] = true;
        };

        vm.openObjectiveCalendar = function (objective, $idx, date) {
            if (vm.checkDisableColMidsessions($idx, objective.childs[0].midsessions)) {
                return;
            }
            if (!objective.childs[0].midsessions[$idx].datePickerOpenStatus) {
                objective.childs[0].midsessions[$idx].datePickerOpenStatus = {
                    dateRequested: true
                };
            }
            objective.childs[0].midsessions[$idx].datePickerOpenStatus[date] = true;
        };

        vm.subjectiveChangedTime = function ($index) {
            $timeout(function () {
                var firstSubjective = vm.report.subjectives[0];
                if (firstSubjective.midsessions[$index].dated) {
                    _.forEach(vm.report.subjectives, function (s, $idx) {
                        if ($idx > 0) { // skip first Subjective
                            s.midsessions[$index].dated = firstSubjective.midsessions[$index].dated;
                        }
                    });
                }
            }, 300);
        };

        vm.objectiveChangedTime = function (objective, $index) {
            $timeout(function () {
                var firstChildObjective = objective.childs[0];
                if (firstChildObjective.midsessions[$index].dated) {
                    _.forEach(vm.report.objectives, function (o, $id) {
                        if ($id > 0) { // skip first Objective
                            _.forEach(o.childs, function (c, $idx) {
                                if ($idx > 0) { // skip first Child Objective
                                    c.midsessions[$index].dated = firstChildObjective.midsessions[$index].dated;
                                }
                            });
                        }
                    });
                }
            }, 300);
        };

        vm.checkboxSubjectiveTestingChange = function(subjective) {
             vm.updateSelectAllCheckboxSubjective();
            // clear value;
            // subjective.score = null;
            // subjective.discharge = null;
            // subjective.notes = null;
        }
        vm.checkboxObjectiveTestingChange = function(objective, child) {
            vm.calculatorLR(objective);
            vm.updateSelectAllCheckbox(objective);
            // clear value;
            // child.value = null;
            // child.leftValue = null;
            // child.rightValue = null;
            // child.discharge = null;
        }
        vm.checkboxOtherObjectiveTestingChange = function(objective, child) {
        }
        vm.calculatorColspan = function(child) {
            return 4 + (child.midsessions ? child.midsessions.length : 0);
        }

        vm.removeColMidsessionsSubjectives = function (colSub, $index) {
            vm.confirmDialogRemoveMidsessions(vm.deletingMidsessionColumnMessage, vm.typeSubjectives, colSub, $index);

        }

        vm.removeColMidsessionsSubjectivesCallBack = function(colSub, $index) {
            if (vm.report.subjectives) {
                vm.report.subjectives.forEach(function (item) {
                    if (item.midsessions) {
                        if (item.midsessions[$index] && item.midsessions[$index].id) {
                            addToMidsessionsRemoved(item.midsessions[$index]);
                        }
                        item.midsessions.splice($index, 1);
                    }
                });
            }
        }

        vm.removeColMidsessionsObjectives = function (objective, $index) {
            vm.confirmDialogRemoveMidsessions(vm.deletingMidsessionColumnMessage, vm.typeObjective, objective, $index);
        }

        vm.removeColMidsessionsObjectivesCallBack = function(objective, $index) {
            if (objective) {
                objective.childs.forEach(function (item) {
                    if (item.midsessions) {
                        if (item.midsessions[$index] && item.midsessions[$index].id) {
                            addToMidsessionsRemoved(item.midsessions[$index]);
                        }
                        item.midsessions.splice($index, 1);
                    }
                });
                _.forEach(vm.report.otherObjectives, function(other) {
                    if (other.typeReportId === objective.typeReportId && other.midsessions) {
                        if (other.midsessions[$index] && other.midsessions[$index].id) {
                            addToMidsessionsRemoved(other.midsessions[$index]);
                        }
                        other.midsessions.splice($index, 1);
                    }
                })
            }
        }

        vm.disableRemoveColMidsessions = function () {
            return (!vm.isMidsessionReport && !vm.isOtherReport) || vm.isDisabled;
        }

        vm.checkDisableColMidsessions = function ($index, $midsessions) {
            return vm.isDisabled || vm.checkDisableMidsessions($index, $midsessions);
        }

        vm.checkDisableMidsessions = function (rowMidIndex, midsessions) {
            // If there is more than 1 Midsession column then the most recent one should be editable
            if (midsessions && midsessions.length > 0) {
                if (midsessions.length === 1) {
                    return false;
                } else {
                    if (midsessions.length <= 1 || rowMidIndex !== midsessions.length - 1) {
                        return true;
                    }
                }
            }
        }

        /**
         * checkHasDataMidsession
         * @param dataReport is subjectives or objectives
         * @param $index
         * @return {*}
         */
        function checkHasDataMidsession(dataReport, $index) {
            if (!dataReport) {
                return false;
            }
            return _.some(dataReport, function (item) {
                // get column date of midsession by index
                return item.midsessions && item.midsessions[$index] &&
                    (item.midsessions[$index].testScore || item.midsessions[$index].testScoreLeft || item.midsessions[$index].testScoreRight);
            });
        }

        vm.checkRequiredDateMidsessionSubjectives = function ($index) {
            if (!vm.report.subjectives[0] || !vm.report.subjectives[0].midsessions || vm.checkDisableColMidsessions($index, vm.report.subjectives[0].midsessions)) {
                return false;
            }
            var hasDataMidsession = checkHasDataMidsession(vm.report.subjectives, $index);
            return hasDataMidsession;
        };

        function getOtherObjectiveChildBy(objective) {
            // get report otherObjectives child.typeReportId == objective.typeReportId
            if (vm.report.otherObjectives && vm.report.otherObjectives.length > 0) {
                var otherObjectivesChild = _.filter(vm.report.otherObjectives, function (otherObjective) {
                    return objective.typeReportId === otherObjective.typeReportId;
                });
                return otherObjectivesChild;
            }
            return [];
        }

        vm.checkRequiredDateMidsession = function (objective, $index) {
            var firstChildObjective = objective.childs[0];

            if (!firstChildObjective || !firstChildObjective.midsessions || vm.checkDisableColMidsessions($index, firstChildObjective.midsessions)) {
                return false;
            }
            var hasDataMidsession = checkHasDataMidsession(objective.childs, $index);
            if (!hasDataMidsession) { // continue check in otherObjective if hasDataMidsession is false
                var otherObjectivesChild = getOtherObjectiveChildBy(objective);
                hasDataMidsession = checkHasDataMidsession(otherObjectivesChild, $index);
            }
            return hasDataMidsession;
        };

        vm.checkRequiredColMidsessions = function ($index, midsessions) {

            // If the report type is "First Report", the "Initial Score" column will be required.
            return !vm.isFirstReport && !vm.isOtherReport && !vm.checkDisableMidsessions($index, midsessions) && checkRequiredMidByWeeklyReport();
        }

        vm.checkRequiredFieldScore = function() {
            return !vm.isOtherReport;
        }

        vm.checkRequiredFieldDischarge= function() {
            return vm.isDischargeReport;
        }

        function checkRequiredMidByWeeklyReport() {
            if (vm.isWeeklyReport) {
                return vm.haveMidsessionPrevious ? true : false;
            }
            return true; //other WeeklyReport
        }

        vm.addOtherObjective = function(objective) {
            var orderNumber = 0;
            _.forEach(vm.report.otherObjectives, function(otherObjective) {
                if (otherObjective.typeReportId == objective.typeReportId && orderNumber < otherObjective.orderNumber) {
                    orderNumber = otherObjective.orderNumber;
                }
            });
            orderNumber++;
            var code = objective.code + '_O' + orderNumber;
            var copyObjective = DataUtils.deepCopy(objective.childs[0]);
            copyObjective.name = '';
            copyObjective.orderNumber = orderNumber;
            copyObjective.code = code;
            copyObjective.type = 'NORMAL_TEXT_FIELD';
            copyObjective.checked = true;
            copyObjective.typeReportId = objective.typeReportId;
            copyObjective.id = null;
            copyObjective.active = true;
            copyObjective.value = '';
            copyObjective.rightValue = '';
            copyObjective.leftValue = '';
            copyObjective.notes = '';
            copyObjective.discharge = '';
            copyObjective.dischargeLeft = '';
            copyObjective.dischargeRight = '';

            _.forEach(copyObjective.midsessions, function(ms) {
                ms.testScore = '';
                ms.testScoreLeft = '';
                ms.testScoreRight = '';
                ms.id = null;
            })
            vm.report.otherObjectives.push(copyObjective);
        }

        vm.deleteOtherObjectives = function(deleteItem) {
            _.remove(vm.report.otherObjectives, function (o) { return o.code === deleteItem.code; });
            if (!deleteItem.id && !deleteItem.active) {
                return;
            }
            deleteItem.active = false;
            vm.otherObjectiveDeletes.push(deleteItem);
            vm.updateOtherObjective(deleteItem);
        }

        function addToMidsessionsRemoved(midsessions) {
            if (midsessions) {
                midsessions.active = false;
                vm.midsessionsRemovedList.push(midsessions);
            }
        }

        function updateMidssessionRemoved() {
            vm.report.midsessionsRemoved = vm.midsessionsRemovedList;
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };

        function isEqualMidsessions(midsessionsOld, midsessions) {
            var isEqual = true;
            if ((midsessionsOld && midsessions && (midsessionsOld.length != midsessions.length) && vm.reportType)) return false;
            for (var indexMs = 0; indexMs < midsessionsOld.length; indexMs++) {
                isEqual = midsessionsOld[indexMs].id === midsessions[indexMs].id;
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(midsessionsOld[indexMs].dated, midsessions[indexMs].dated);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(midsessionsOld[indexMs].testScore, midsessions[indexMs].testScore);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(midsessionsOld[indexMs].testScoreRight, midsessions[indexMs].testScoreRight);
                if (!isEqual) return false;
                isEqual = DataUtils.isEqualText(midsessionsOld[indexMs].testScoreLeft, midsessions[indexMs].testScoreLeft);
                if (!isEqual) return false;
            }
            return isEqual;
        }

        function getParentCode(code) {
            return code.split('_')[0];
        }

        vm.importMdeScores = function(type) {
            if (type === 'subjective') {
                if (vm.subjectiveImportMdeScores && vm.mdePtReport.subjectives) {
                    _.forEach(vm.report.subjectives, function (frpSub) {
                        var mdeSub = _.first(_.filter(vm.mdePtReport.subjectives, function (item) {
                            return item && frpSub && item.code === frpSub.code;
                        }));
                        if (mdeSub) {
                            frpSub.score = mdeSub.score;
                            frpSub.checked = mdeSub.checked; // clone checked
                        }
                    });
                    // update check box select all Subjective
                    vm.updateSelectAllCheckboxSubjective();
                }
            } else if (type === 'objective') {
                if (vm.objectiveImportMdeScores && vm.mdePtReport.objectives) {
                    _.forEach(vm.report.objectives, function (frpObj) {
                        var mdeObj = _.first(_.filter(vm.mdePtReport.objectives, function (item) {
                            return item && frpObj && item.code === frpObj.code;
                        }));
                        if (mdeObj) {
                            _.forEach(frpObj.childs, function (frpChild) {
                                var mdeChild = _.first(_.filter(mdeObj.childs, function (child) {
                                    return child && frpChild && child.code === frpChild.code;
                                }));
                                if (mdeChild) {
                                    frpChild.value = mdeChild.value;
                                    frpChild.leftValue = mdeChild.leftValue;
                                    frpChild.rightValue = mdeChild.rightValue;
                                    frpChild.checked = mdeChild.checked; // clone checked
                                }
                            });
                        }
                        // update check box select all objective
                        vm.updateSelectAllCheckbox(frpObj);
                    });

                    vm.report.otherObjectives = [];
                    _.forEach(vm.mdePtReport.otherObjectives, function (objective) {
                        var copyObjective = DataUtils.deepCopy(objective);
                        copyObjective.id = null;
                        copyObjective.active = true;
                        copyObjective.discharge = '';
                        copyObjective.dischargeLeft = '';
                        copyObjective.dischargeRight = '';
                        copyObjective.fromMDE = true;

                        copyObjective.midsessions = [];
                        copyObjective.midsessions.push({
                            dated: new Date(),
                            testScore: '',
                            testScoreRight: '',
                            testScoreLeft: '',
                            orderNumber: 0,
                            active: true,
                            id: null
                        });
                        vm.report.otherObjectives.push(copyObjective);
                    });
                }
            }
        }

        vm.updateSelectAllCheckbox = function(objective) {
            var isCheckAll = true;
            objective.childs.forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })
            vm.report.otherObjectives.forEach(function (other){
                if(other.typeReportId === objective.typeReportId) {
                    if(!other.checked) {
                        isCheckAll = false;
                        return;
                    }
                }
            })

            objective.checked = isCheckAll;
        }

        vm.updateOtherObjective = function (child) {
            vm.report.objectives.forEach(function (objective) {
                if(child.typeReportId === objective.typeReportId) {
                    vm.updateSelectAllCheckbox(objective);
                }
            })
        }

        vm.onClickSelectAll = function(objective) {
            objective.childs.forEach(function (child) {
                child.checked = objective.checked;
            });
            vm.report.otherObjectives.forEach(function (other){
                if(other.typeReportId === objective.typeReportId) {
                    other.checked = objective.checked;
                }
            });

            vm.calculatorLR(objective);

        }

        vm.onClickSelectAllSubjective = function() {
            vm.report.subjectives.forEach(function (child) {
                child.checked = vm.subjectiveChecked;
            });
        }

        vm.updateSelectAllCheckboxSubjective = function() {
            var isCheckAll = true;
            vm.report.subjectives.forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })

            vm.subjectiveChecked = isCheckAll;
        };

        function openErrorDuplicateDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.frpReport.error.saveReportDuplicateMessage"},
                    title: function () {return "ipmApp.frpReport.error.saveReportDuplicateTitle"}
                }
            }).result.then(function() {
                $window.location.reload(); // reload page to load new data FRP
            }, function() {
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('FRPReportConclusionController', FRPReportConclusionController);

    FRPReportConclusionController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', 'FrpReportService', 'frpReport', 'templates', 'DataUtils', 'ipmConstants', 'isView'];

    function FRPReportConclusionController($scope, $state, $stateParams, $uibModal, FrpReportService, frpReport, templates, DataUtils, constants, isView) {
        var vm = this;
        vm.frpReport = frpReport ? frpReport : {};
        vm.reportOld = {};
        vm.templates = templates ? templates : [];
        vm.ptSortGoalAddNewDeletes = [];
        vm.ptLongGoalAddNewDeletes = [];
        vm.psychSortGoalAddNewDeletes = [];
        vm.psychLongGoalAddNewDeletes = [];
        vm.isSaving = false;
        vm.isFinalize = false;
        vm.cancelMessage = 'ipmApp.mdeReport.admin.confirmCancel';
        vm.isChanged = isChanged;
        vm.isView = isView ? true : frpReport ? frpReport.statusFinal === constants.STATUS_FINAL_FRP_MDE : false;
        vm.fieldRequrieds = [
            'treatment_team_observations',
            // 'input_hours_completed',
            // 'input_hours_requested',
            'checkbox_request_for_treatment',
            'input_m_G5_SORT_TERM',
            'input_m_G6_SORT_TERM',
            'select_m_G9_SORT_TERM',
            'input_m_G5_LONG_TERM',
            'input_m_G6_LONG_TERM',
            'select_m_G9_LONG_TERM',
        ];

        vm.dataHeaderReport = {};
        vm.templateInputType = constants.FRP_MDE_TEMPLATE;
        vm.typeGoalsPT = 'PT';
        vm.typeGoalsPSYCH = 'PSYCH';

        init();

        function init() {
            vm.frpReportId = $stateParams.id;
            vm.dataHeaderReport = buildDataHeaderReport(vm.frpReport.patientFRPMDE);
            if (vm.frpReport && vm.frpReport.frpReportAdmin && vm.frpReport.frpReportAdmin.reportType) {
                vm.reportType = vm.frpReport.frpReportAdmin.reportType;
                if (vm.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT){
                    vm.isMidsessionReport = true;
                }
            }
            if (vm.frpReport && vm.frpReport.gender) {
                vm.isMale = vm.frpReport.gender !== 'female';
            }

            FrpReportService.getFrpConclusionReport($stateParams.id).then(function (data) {
                vm.report = data;
                vm.reportOld = DataUtils.deepCopy(data);
                vm.isFinalize = vm.report && vm.report.finalize;
                setIsDisabled();
                updateFieldRequrieds();
            });
        }

        function updateFieldRequrieds() {
            // build accomplished_{G1}_LONG_TERM, checkbox_G1_LONG_TERM
            buildTerm(vm.report.ptLongTermGoalResponses, 'LONG_TERM', vm.typeGoalsPT);
            buildTerm(vm.report.psychLongTermGoalResponses, 'LONG_TERM', vm.typeGoalsPSYCH);

            // build accomplished_{G1}_SORT_TERM, checkbox_G1_SORT_TERM
            buildTerm(vm.report.ptSortTermGoalResponses, 'SORT_TERM', vm.typeGoalsPT);
            buildTerm(vm.report.psychSortTermGoalResponses, 'SORT_TERM', vm.typeGoalsPSYCH);

            if (vm.isMidsessionReport) {
                vm.fieldRequrieds.push('input_hours_completed');
                vm.fieldRequrieds.push('input_hours_requested');
            }
        }

        function buildTerm(termGoalResponses, type, typeGoals) {
            if (termGoalResponses) {
                var goalStatusTerm = "goalStatus_{code}_" + type + "_" + typeGoals; // ex: goalStatus_STG0_SORT_TERM_PT
                var checkboxLong = "checkbox_{code}_" +  type;
                termGoalResponses.forEach(function (item) {
                    if (item && item.code) {
                        vm.fieldRequrieds.push(goalStatusTerm.replace('{code}', item.code));
                        vm.fieldRequrieds.push(checkboxLong.replace('{code}', item.code));
                    }
                });
            }
        }

        function setIsDisabled() {
            if (vm.isView || (vm.frpReport && (vm.frpReport.status === 'MDE_ABANDONED' || (vm.frpReport.patientFRPMDE && vm.frpReport.patientFRPMDE.isViewFrpProgram)))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

        vm.save = function () {
            submitData(false);
        }

        vm.finalize = function () {
            submitData(true);
        }

        function isChanged() {
            return !angular.equals(vm.report, vm.reportOld);
        }

        function back() {
            $state.go('frp-report', { id: vm.frpReportId });
        }

        vm.cancel = function () {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        function checkValidation() {
            addValidationTermGoal(vm.report.ptLongTermGoalAddNewResponses, 'LONG_TERM', vm.typeGoalsPT);
            addValidationTermGoal(vm.report.psychLongTermGoalAddNewResponses, 'LONG_TERM', vm.typeGoalsPSYCH);
            addValidationTermGoal(vm.report.ptSortTermGoalAddNewResponses, 'SORT_TERM', vm.typeGoalsPT);
            addValidationTermGoal(vm.report.psychSortTermGoalAddNewResponses, 'SORT_TERM', vm.typeGoalsPSYCH);

            vm.fieldRequrieds.forEach(function (field) {
                if (field && vm.conclusionReportForm[field]) {
                    vm.conclusionReportForm[field].$setDirty();
                }
            });
        }

        function addValidationTermGoal(termGoalAddNewResponses, type, typeGoals) {
            var inputLongShort = "input_m_{code}"; // input_m_LTG0
            var goalStatusTerm = "goalStatus_{code}_" + type + "_" + typeGoals; // ex: goalStatus_STG0_SORT_TERM_PT
            if (termGoalAddNewResponses) {
                termGoalAddNewResponses.forEach(function (item) {
                    if (item.active && item.checked) {
                        vm.fieldRequrieds.push(inputLongShort.replace('{code}', item.code));
                        vm.fieldRequrieds.push(goalStatusTerm.replace('{code}', item.code));
                    }
                });
            }
        }

        function submitData(finalize) {
            if (vm.isView) {
                return;
            }
            if (finalize) {
                checkValidation();
                if (vm.conclusionReportForm.$invalid || !hasTestingChecked()) {
                    return;
                }
            }
            vm.isSaving = true;
            vm.report.finalize = finalize;
            prepairDataForSave();
            FrpReportService.saveFrpConclusionReport(vm.frpReportId, vm.report).then(function (response) {
                onSaveSuccess(response);
            }, function error(e) {
                onSaveError(e);
            });
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            back();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }

        function prepairDataForSave() {
            // Feedback before the Demo - June 09, 2022 - Feedback #22
            // goal-add-new rule
            // new, checked, not-empty        -> save text and checked state
            // new, checked, empty            -> form invalid
            // new, uncheck, not-empty        -> save text and uncheck state
            // new, uncheck, empty            -> not save
            // old, checked, not-empty        -> save text and checked state
            // old, checked, empty            -> form invalid
            // old, uncheck, not-empty        -> save text and uncheck state
            // old, uncheck, empty            -> term-goal delete (database update to inactive)

            // filter new, checked/checked, not-empty sort-term-goal
            vm.report.ptSortTermGoalAddNewResponses = _.filter(vm.report.ptSortTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            vm.report.psychSortTermGoalAddNewResponses = _.filter(vm.report.psychSortTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            // filter new, checked, not-empty long-term-goal
            vm.report.ptLongTermGoalAddNewResponses = _.filter(vm.report.ptLongTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            vm.report.psychLongTermGoalAddNewResponses = _.filter(vm.report.psychLongTermGoalAddNewResponses, function(termGoal) {
                return termGoal.id || termGoal.goal;
            });
            // delete old, uncheck, empty sort-term-goal
            _.forEach(vm.report.ptSortTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });
            _.forEach(vm.report.psychSortTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });
            // delete old, uncheck, empty long-term-goal
            _.forEach(vm.report.ptLongTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });
            _.forEach(vm.report.psychLongTermGoalAddNewResponses, function(termGoal) {
                if (termGoal.id && !termGoal.checked && !termGoal.goal) {
                    termGoal.active = false;
                }
            });
            // merge add goals add new list
            vm.report.ptSortTermGoalAddNewResponses.push.apply(vm.report.ptSortTermGoalAddNewResponses, vm.ptSortGoalAddNewDeletes);
            vm.report.ptLongTermGoalAddNewResponses.push.apply(vm.report.ptLongTermGoalAddNewResponses, vm.ptLongGoalAddNewDeletes);
            vm.report.psychSortTermGoalAddNewResponses.push.apply(vm.report.psychSortTermGoalAddNewResponses, vm.psychSortGoalAddNewDeletes);
            vm.report.psychLongTermGoalAddNewResponses.push.apply(vm.report.psychLongTermGoalAddNewResponses, vm.psychLongGoalAddNewDeletes);

            // Set data to convert Template content for Treatment Team Observations
            if (vm.report.treatmentTeamObservationsTemplate && vm.report.treatmentTeamObservationsTemplate.id) {
                vm.report.treatmentTeamObservationsTemplate.isGlobalTemplate = true;
                vm.report.treatmentTeamObservationsTemplate.gender = vm.frpReport.gender;
                vm.report.treatmentTeamObservationsTemplate.lastname = vm.frpReport.patientFRPMDE.patient.lastName;
            }
        }

        vm.addNewSortTermGoal = function (type) {
            if (type === 'PT') {
                var orderNumber = _.isEmpty(vm.report.ptSortTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.ptSortTermGoalAddNewResponses, function (o) { return o.orderNumber }).orderNumber + 1;
                var code = 'STG' + orderNumber;
                var newGoal = { code: code, orderNumber: orderNumber, active: true, goalType: 'SORT_TERM', goalGroup: 'PT' };
                vm.report.ptSortTermGoalAddNewResponses.push(newGoal);
            } else if (type === 'PSYCH') {
                var orderNumber = _.isEmpty(vm.report.psychSortTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.psychSortTermGoalAddNewResponses, function (o) { return o.orderNumber }).orderNumber + 1;
                var code = 'STG' + orderNumber;
                var newGoal = { code: code, orderNumber: orderNumber, active: true, goalType: 'SORT_TERM', goalGroup: 'PSYCH' };
                vm.report.psychSortTermGoalAddNewResponses.push(newGoal);
            }
        }

        vm.addNewLongTermGoal = function (type) {
            if (type === 'PT') {
                var orderNumber = _.isEmpty(vm.report.ptLongTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.ptLongTermGoalAddNewResponses, function (o) { return o.orderNumber }).orderNumber + 1;
                var code = 'LTG' + orderNumber;
                var newGoal = { code: code, orderNumber: orderNumber, active: true, goalType: 'LONG_TERM', goalGroup: 'PT' };
                vm.report.ptLongTermGoalAddNewResponses.push(newGoal);
            } else if (type === 'PSYCH') {
                var orderNumber = _.isEmpty(vm.report.psychLongTermGoalAddNewResponses) ? 0 : _.maxBy(vm.report.psychLongTermGoalAddNewResponses, function (o) { return o.orderNumber }).orderNumber + 1;
                var code = 'LTG' + orderNumber;
                var newGoal = { code: code, orderNumber: orderNumber, active: true, goalType: 'LONG_TERM', goalGroup: 'PSYCH' };
                vm.report.psychLongTermGoalAddNewResponses.push(newGoal);
            }
        }

        vm.deleteSortTermGoalAddNew = function (deleteItem, type) {
            if (type === 'PT') {
                _.remove(vm.report.ptSortTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

                if (!deleteItem.id && !deleteItem.active) {
                    return;
                }
                vm.ptSortGoalAddNewDeletes.push(deleteItem);
            } else if (type === 'PSYCH') {
                _.remove(vm.report.psychSortTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

                if (!deleteItem.id && !deleteItem.active) {
                    return;
                }
                vm.psychSortGoalAddNewDeletes.push(deleteItem);
            }

        }

        vm.deleteLongTermGoalAddNew = function (deleteItem, type) {
            if (type === 'PT') {
                _.remove(vm.report.ptLongTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

                if (!deleteItem.id && !deleteItem.active) {
                    return;
                }
                vm.ptLongGoalAddNewDeletes.push(deleteItem);
            } else if (type === 'PSYCH') {
                _.remove(vm.report.psychLongTermGoalAddNewResponses, function (o) { return o.code === deleteItem.code; });

                if (!deleteItem.id && !deleteItem.active) {
                    return;
                }
                vm.psychLongGoalAddNewDeletes.push(deleteItem);
            }
        }

        vm.showAddGoal = function($last, isLongTerm, type) {
            // filter active Goal
            var addNewItem;
            if (type === 'PT') {
                if (isLongTerm) {
                    addNewItem = _.filter(vm.report.ptLongTermGoalAddNewResponses, function (i) { return i.active; });
                } else {
                    addNewItem = _.filter(vm.report.ptSortTermGoalAddNewResponses, function (i) { return i.active; });
                }
            } else if (type === 'PSYCH') {
                if (isLongTerm) {
                    addNewItem = _.filter(vm.report.psychLongTermGoalAddNewResponses, function (i) { return i.active; });
                } else {
                    addNewItem = _.filter(vm.report.psychSortTermGoalAddNewResponses, function (i) { return i.active; });
                }
            }
            return $last && _.isEmpty(addNewItem);
        }

        vm.checkValidationShortTermGoals = function () {
            if (!vm.isMidsessionReport) return true;
            return !_.isEmpty(_.filter(vm.report.ptSortTermGoalResponses, function (i) {
                    return i.checked;
                })) ||
                !_.isEmpty(_.filter(vm.report.ptSortTermGoalAddNewResponses, function (i) {
                    return i.checked;
                })) ||
                !_.isEmpty(_.filter(vm.report.psychSortTermGoalResponses, function (i) {
                    return i.checked;
                })) ||
                !_.isEmpty(_.filter(vm.report.psychSortTermGoalAddNewResponses, function (i) {
                    return i.checked;
                }));
        }

        vm.checkValidationLongTermGoals = function () {
            if (!vm.isMidsessionReport) return true;
            return !_.isEmpty(_.filter(vm.report.ptLongTermGoalResponses, function (i) {
                    return i.checked;
                })) ||
                !_.isEmpty(_.filter(vm.report.ptLongTermGoalAddNewResponses, function (i) {
                    return i.checked;
                })) ||
                !_.isEmpty(_.filter(vm.report.psychLongTermGoalResponses, function (i) {
                    return i.checked;
                })) ||
                !_.isEmpty(_.filter(vm.report.psychLongTermGoalAddNewResponses, function (i) {
                    return i.checked;
                }));
        }

        function hasTestingChecked() {
            // At least 1 Short Term Goal is required
            var isChecked = vm.hasTermGoalChecked(true);
            if (!isChecked) return false;
            // At least 1 Long Term Goal is required
            isChecked = vm.hasTermGoalChecked(false);
            if (!isChecked) return false;
            return true;
        }

        vm.hasItemChecked = function (listItem) {
            if (listItem) {
                return !_.isEmpty(_.filter(listItem, function (s) { return s.checked; }))
            }
            return false;
        }

        vm.hasTermGoalChecked = function(isSort) {
            if (!vm.isMidsessionReport) return true;
            var termGoalChecked;
            var termGoalAddNewChecked
            if (isSort) {
                // At least 1 Short Term Goal is required
                termGoalChecked = vm.hasItemChecked(vm.report.ptSortTermGoalResponses) || vm.hasItemChecked(vm.report.psychSortTermGoalResponses);
                termGoalAddNewChecked = vm.hasItemChecked(vm.report.ptSortTermGoalAddNewResponses) || vm.hasItemChecked(vm.report.psychSortTermGoalAddNewResponses);
            } else {
                // At least 1 Long Term Goal is required
                termGoalChecked = vm.hasItemChecked(vm.report.ptLongTermGoalResponses) || vm.hasItemChecked(vm.report.psychLongTermGoalResponses);
                termGoalAddNewChecked = vm.hasItemChecked(vm.report.ptLongTermGoalAddNewResponses) || vm.hasItemChecked(vm.report.psychLongTermGoalAddNewResponses);
            }
            if (!termGoalChecked && !termGoalAddNewChecked) return false;
            return true;
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('FRPReportHomeController', FRPReportHomeController);

    FRPReportHomeController.$inject = ['$state', 'FrpReportService', '$stateParams', '$uibModal'];

    function FRPReportHomeController($state, FrpReportService, $stateParams, $uibModal) {
        var vm = this;
        vm.frpReport = {};
        vm.patient = {};
        vm.reports = [];
        vm.isView = false;
        vm.checkCompletedAllReport = checkCompletedAllReport;
        vm.dataHeaderReport = {};

        init();

        function init() {
            // Data sample for show UI - This Data incorrect
        	FrpReportService.get($stateParams.id).then(function(response) {
                vm.frpReport = response.data ? response.data : {};
                setIsView();
                vm.patient = response.data.patient;
                vm.patient.dateOfBirth =  moment(vm.patient.dateOfBirth).format('MM/DD/YYYY');
                vm.reports =  response.data.reports;
                vm.dataHeaderReport = buildDataHeaderReport(vm.frpReport.patientFRPMDE);
            });
        }

        function setIsView() {
            vm.isView = (vm.frpReport && vm.frpReport.statusFinal === 'FINALIZED') ? true : false;
        }

        vm.editPage = function(name){
            if(name)
                $state.go('frp-report.' + name);
        }

        vm.viewPage = function (name) {
            if (name) {
                $state.go('frp-report.' + name + '.VIEW');
                return;
            }
        }

        function checkCompletedAllReport() {
            if (vm.frpReport && vm.frpReport.reports && vm.frpReport.reports.length > 0) {
                return _.isEmpty(_.filter(vm.frpReport.reports, function (item) {
                    return item.status !== 'COMPLETE' && item.role !== 'MEDICAL' && item.role !== 'ADDENDUM';
                }));
            }
            return false;
        }

        function checkSignedProvider() {
            return vm.frpReport && vm.frpReport.patientFRPMDE && vm.frpReport.patientFRPMDE.signature && vm.frpReport.patientFRPMDE.signature.id && vm.frpReport.patientFRPMDE.signature.data;
        }

        function finalizeFrpReport(signature) {
            signature = signature ? signature : {};
            FrpReportService.finalizeFrpReport(vm.frpReport.id, signature).then(function (response) {
                onSaveSuccess(response)
            }, function error(e) {
                onSaveError(e);
            });
        }

        vm.finalAndSignOffClick = function () {
            if (checkCompletedAllReport()) {
                if (!checkSignedProvider()) { // final with signature
                    openProviderDialog(angular.copy(vm.frpReport.patientFRPMDE.signature)); // fix reload signature when open again
                } else { // final without signature
                    finalizeFrpReport(null);
                }
            }
        }

        vm.preview = function() {
            $state.go('frp-report-preview');
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            goToFRPTab();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }

        function goToFRPTab() {
            $state.go('frp-mde', {tab:0});
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };

        function openProviderDialog(signature) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/frp-report/home/upload-signature-dialog/upload-signature-dialog.html',
                controller: 'UploadSignatureDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'center-modal',
                size: 'md',
                resolve: {
                    signature: function () {
                        return signature;
                    }
                }
            }).result.then(function(result) {
                finalizeFrpReport(result);
            }, function() {
            });
        }
    }
})();
;
(function () {
	'use strict';

	angular
	.module('ipmApp')
	.controller('FRPReportAdminController', FRPReportAdminController);

	FRPReportAdminController.$inject = ['$scope', '$state', '$stateParams', 'Principal', 'userDetails', 'FrpReportService', 'supportedDataList', 'ipmConstants', 'User', 'qhpUsers', 'staffUsers', 'reportAdmin', 'frpReport', 'templates', '$uibModal', 'isView', 'lectures', 'DataUtils'];

	function FRPReportAdminController($scope, $state, $stateParams, Principal, userDetails, FrpReportService, supportedDataList, ipmConstants, User, qhpUsers, staffUsers, reportAdmin, frpReport, templates, $uibModal, isView, lectures, DataUtils) {
		var vm = this;
        vm.isChanged = isChanged;
        vm.datePickerOpenStatus = {};
        reportAdmin.injuryDate = reportAdmin.injuryDate ? moment(reportAdmin.injuryDate)._d : null;
        reportAdmin.dateOfBirthStr = reportAdmin.dateOfBirth ? moment(reportAdmin.dateOfBirth).format('MM/DD/YYYY') : "";
        vm.cancelMessage = 'ipmApp.frpReport.admin.confirmCancel';
        vm.admin = angular.copy(reportAdmin);
        vm.isFinalize = vm.admin && vm.admin.status === 'COMPLETE' ? true : false;
		vm.frp = {};
        vm.attendanceTrackers = [];
		vm.users = qhpUsers;
        vm.adminUsers = staffUsers.concat(qhpUsers);
        vm.editCaseNumber = true;
        vm.states = ipmConstants.STATES_OF_AMERICA;
        vm.lectures = lectures;
        vm.reportType = ipmConstants.FRP_REPORT_TYPE_2;
        vm.checkDisableAttendanceTracker = checkDisableAttendanceTracker;
        vm.providers = supportedDataList.providerList;
        vm.frpPrograms  =  supportedDataList.frpProgramsList;
        vm.requiredFields = [
            'caseNumber',
            'medical',
            'pt',
            'psych',
            'lectures',
            'reportType',
            'introduction',
            'templateSelect_REPORT_TYPE'
        ];

        vm.attendanceTrackerInvalid = false;
        vm.trackerStartDate = vm.admin.startDate;
        vm.trackerEndDate = vm.admin.endDate;
        vm.isDisabled = false;
        vm.isView = isView ? true : frpReport ? frpReport.statusFinal === ipmConstants.STATUS_FINAL_FRP_MDE : false;
        vm.frpReport = frpReport ? frpReport : {};
        vm.templateInputType = ipmConstants.FRP_MDE_TEMPLATE;
        vm.templates = templates ? templates : [];
        vm.dataHeaderReport = {};
        vm.sumHoursDaysAttendedIgnoreReportCurrent = 0;
        vm.previouslyCompletedHours = 0;

        init();

        function init() {
            setSumHoursDaysAttendedIgnoreReportCurrent();
            setPreviouslyCompletedHours();
            setTemplateValue();
            if (vm.isView || (frpReport.patientFRPMDE && frpReport.patientFRPMDE.isViewFrpProgram)) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
            vm.dataHeaderReport = buildDataHeaderReport(vm.frpReport.patientFRPMDE);
        }

        function setPreviouslyCompletedHours() {
            if (vm.frpReport && vm.frpReport.patientFRPMDE && vm.frpReport.patientFRPMDE.previouslyCompletedHours > 0) {
                vm.previouslyCompletedHours = vm.frpReport.patientFRPMDE.previouslyCompletedHours;
            }
        }

        function setSumHoursDaysAttendedIgnoreReportCurrent() {
            if (vm.frpReport && vm.frpReport.patientFRPMDE && !_.isNaN(vm.frpReport.patientFRPMDE.sumHoursDaysAttended) && !_.isNaN(vm.frpReport.sumAtHours)) {
                vm.sumHoursDaysAttendedIgnoreReportCurrent = vm.frpReport.patientFRPMDE.sumHoursDaysAttended - vm.frpReport.sumAtHours; // sum hours all - sum hours of report current
            }
        }

        function setTemplateValue() {
            if (reportAdmin && reportAdmin.introductionTemplate) {
                reportAdmin.introductionTemplate.value = reportAdmin.introductionTemplate.id.toString();
            }
        }

        vm.onReportTypeChange = function() {
            //TODO
            vm.admin.introduction = 'Get content of report type ' + vm.admin.reportType;
        }

		vm.save = function() {
            submitData(false);
        }

        vm.finalize = function() {
            submitData(true);
        }

        vm.getAttendanceTracker = function(frp) {
            if (frp && frp.attendanceTracker) {
                return frp.attendanceTracker
            }
            frp.attendanceTracker = createNewAttendanceTracker();
            return frp.attendanceTracker;
        }

        function createNewAttendanceTracker() {
            var attendanceTracker = {
                id: null,
                mon: null,
                tue: null,
                wed: null,
                thu: null,
                fri: null,
                sat: null,
                sun: null
            };
            return attendanceTracker;
        }

        vm.attendanceTrackersChange = function(attendanceTracker) {
            if (attendanceTracker) {
                vm.admin.attendanceTracker = attendanceTracker;
                checkRequiredAttendanceTracker();
            }
            // ToDo:: implement save or Update attendanceTracker
        };

        function checkRequiredAttendanceTracker() {
            var numberDayOfWeek = 7;
            if (vm.admin.attendanceTracker) {
                for (var idx = 1; idx <= numberDayOfWeek; idx++) {
                    var element  = getAttendanceTrackerElement(idx);
                    var attendanceTracker = getAttendanceTracker(idx);
                    if (attendanceTracker === null) {
                        var required = checkRequiredAt(idx);
                        if (required) {
                            addRequiredCssClass(element);
                        } else {
                            removeRequiredCssClass(element);
                        }
                    } else {
                        removeRequiredCssClass(element);
                    }
                }
            }
            vm.attendanceTrackerInvalid = isInvalidAttendanceTracker();
        }

        function checkRequiredAt(idx) {
            var now = new moment();
            var endDate = vm.admin.endDate;
            // case in the past
            if (endDate && now.isAfter(moment(endDate)))
            {
                return true;
            }
            var dayOnWeek = getDayOnWeek(idx);
            return moment(dayOnWeek).isAfter(now) ? false : true;
        }

        function removeRequiredCssClass(element) {
            if (element) {
                element.removeClass('required-at');
            }
        }

        function addRequiredCssClass(element) {
            if (element) {
                element.addClass('required-at');
            }
        }

        function getAttendanceTracker(idx) {
            switch (idx) {
                case 1:
                    return vm.admin.attendanceTracker.sat;
                case 2:
                    return vm.admin.attendanceTracker.sun;
                case 3:
                    return vm.admin.attendanceTracker.mon;
                case 4:
                    return vm.admin.attendanceTracker.tue;
                case 5:
                    return vm.admin.attendanceTracker.wed;
                case 6:
                    return vm.admin.attendanceTracker.thu;
                case 7:
                    return vm.admin.attendanceTracker.fri;
                default:
                    break;
            }
        }

        function getDayOnWeek(idx) {
            switch (idx) {
                case 1:
                    return moment().day("Saturday").toDate();
                case 2:
                    return moment().day("Sunday").toDate();
                case 3:
                    return moment().day("Monday").toDate();
                case 4:
                    return moment().day("Tuesday").toDate();
                case 5:
                    return moment().day("Wednesday").toDate();
                case 6:
                    return moment().day("Thursday").toDate();
                case 7:
                    return moment().day("Friday").toDate();
                default:
                    break;
            }
        }

        function getAttendanceTrackerElement(idx) {
            var element = angular.element(document.querySelector('#attendance-tracker_' + idx));
            if (element != null) {
                return element;
            }
        }

        function isInvalidAttendanceTracker() {
            var elements = document.querySelector('.required-at');
            if (elements != null) {
                return true;
            }
            return false;
        }

        function checkDisableAttendanceTracker() {
            return vm.isDisabled || vm.admin && vm.admin.reportStatus === 'FRP_ACTIVE_HOLD';
        }

        function checkValidation() {
            vm.requiredFields.forEach(function (field) {
                if (field && vm.editForm[field]) {
                    vm.editForm[field].$setDirty();
                }
            });
            checkRequiredAttendanceTracker();
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function submitData(finalize) {
            if(finalize) {
                checkValidation();
                if (vm.editForm.$invalid || vm.attendanceTrackerInvalid) {
                    return;
                }
            }

            vm.isSaving = true;
            vm.admin.status = finalize ? 'COMPLETE' : 'INPROGRESS';
            FrpReportService.saveAdminReport($stateParams.id, vm.admin).then(function(response) {
                onSaveSuccess(response);
            }, function error(e) {
                onSaveError(e);
            });
        }

        function onSaveSuccess(response) {
            vm.isSaving = false;
            back();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }

        vm.confirmDialog = function (message) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    back();
                }
            });
        }

        vm.cancel = function() {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        function back() {
            $state.go('frp-report', {id: $stateParams.id});
        }

        function isChanged() {
        	for (var prop in vm.admin) {
        		if(!vm.admin[prop]) {
        		    vm.admin[prop] = null;
        		}
        	}
            for (var prop in reportAdmin) {
                if (!reportAdmin[prop]) {
                    reportAdmin[prop] = null;
                }
            }
        	return !angular.equals(vm.admin, reportAdmin);
        }

        function buildDataHeaderReport(patientFRPMDE) {
            if (patientFRPMDE) {
                return {
                    patientName: patientFRPMDE.patient.firstName + " " + patientFRPMDE.patient.lastName,
                    chartNumber: patientFRPMDE.patient.patientId,
                    authorizedProviderName: patientFRPMDE.authorizedProviderName,
                    frpProgramName: patientFRPMDE.frpProgramName,
                    caseNumber: patientFRPMDE.caseNumber,
                    dateOfBirth: patientFRPMDE.patient.dateOfBirth
                };
            }
        };

        vm.checkInValidHoursAttendedExceed = function () {
            if (vm.admin.attendanceTracker) {
                var sumHoursDaysAttendedAll = calcSumHourOfReport(vm.admin.attendanceTracker) + vm.sumHoursDaysAttendedIgnoreReportCurrent + vm.previouslyCompletedHours;
                return sumHoursDaysAttendedAll > ipmConstants.HOURS_ATTENDED_CAN_NOT_EXCEED;
            }
            return false;
        }

        function calcSumHourOfReport(attendanceTracker) {
            var countAttendanceTrackerNotAbsent = DataUtils.countAttendanceTrackerNotAbsent(attendanceTracker);
            return Number(ipmConstants.NUMBER_HRS_ATTENDED) * Number(countAttendanceTrackerNotAbsent);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('FRPReportAddendumController', FRPReportAddendumController);

    FRPReportAddendumController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', 'frpReport', 'ipmConstants', '$window', 'FrpReportService', 'DataUtils', 'isView'];

    function FRPReportAddendumController($scope, $state, $stateParams, $uibModal, frpReport, ipmConstants, $window, FrpReportService, DataUtils, isView) {
        var vm = this;
        vm.frpReport = frpReport ? frpReport : {};
        vm.frpReportOld = {};
        vm.save = save;
        vm.isRequired = false;
        vm.isFinalize = false;
        vm.isDisabled = false;
        vm.isChanged = isChanged;
        vm.isView = isView;
        vm.submitted = false;
        vm.cancelMessage = 'ipmApp.frpReport.admin.confirmCancel';

        init();

        function init() {
            vm.frpReportId = $stateParams.id;
            vm.frpReportOld = DataUtils.deepCopy(vm.frpReport);
            vm.isFinalize = vm.frpReport && vm.frpReport.frpReportAddendum
            && (vm.frpReport.frpReportAddendum.status === 'COMPLETE') ? true : false;
            setIsDisabled();
        }

        function setIsDisabled() {
            if (vm.isView || (vm.frpReport.patientFRPMDE && (vm.frpReport.status === 'MDE_ABANDONED' || vm.frpReport.patientFRPMDE.isViewFrpProgram))) {
                vm.isDisabled = true;
            } else {
                vm.isDisabled = false;
            }
        }

        function isChanged() {
            for (var field in vm.frpReport.frpReportAddendum) {
                if (!vm.frpReport.frpReportAddendum[field]) {
                    vm.frpReport.frpReportAddendum[field] = null;
                }
            }
            for (var fieldOld in vm.frpReportOld.frpReportAddendum) {
                if (!vm.frpReportOld.frpReportAddendum[fieldOld]) {
                    vm.frpReportOld.frpReportAddendum[fieldOld] = null;
                }
            }
            return !angular.equals(vm.frpReport, vm.frpReportOld);
        }

        function save() {
            vm.isSaving = true;
            if (vm.frpReport) {
                vm.frpReport.frpReportAddendum.status = 'COMPLETE'; // set status COMPLETE when save addendum
                FrpReportService.saveFRPReportAddendum(vm.frpReport).then(function (response) {
                    onSaveSuccess(response)
                }, function error(e) {
                    onSaveError(e);
                });
            }
        }

        function onSaveSuccess (response) {
            vm.isSaving = false;
            goToFRPReport();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
            }
        }

        vm.cancel = function() {
            var isReportChanged = isChanged();
            if (isReportChanged) {
                vm.confirmDialog(vm.cancelMessage);
            } else {
                back();
            }
        }

        function back() {
            $state.go('frp-report', { id: vm.frpReportId });
        }

        vm.confirmDialog = function (message) {
            if (vm.isView) {
                return;
            }
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    goToFRPReport();
                }
            });
        }

        function goToFRPReport() {
            $state.go('frp-report', {id: vm.frpReport.id});
        }
    }
})();
;
(function() {
    'use strict';


    TestsAssignedsListController.$inject = ['$scope', '$state', 'ipmConstants', 'HaqsBatteryService', 'Test'];

    function TestsAssignedsListController($scope, $state, constants, HaqsBatteryService, Test) {
        var vm = this;//jshint ignore:line
        vm.pageSize = constants.PAGE_SIZE_MAX;
        vm.testsDefault = [];
        vm.batteryTestsDeleted = [];
        vm.assignedBatteryTestsOriginal = [];
        vm.unassignedBatteryTests = [];
        vm.unassignBatteryTestsClick = unassignBatteryTestsClick;
        vm.assignedBatteryTestsClick = assignedBatteryTestsClick;
        vm.batteryTestsClick = batteryTestsClick;
        vm.testClick = testClick;
        vm.sortableOptions = {
            placeholder: "ui-state-highlight",
            helper: function (event, ui) {
                var table = '<table style="position: absolute;" class="jh-table table table-striped"></table>';
                var draggedItem = $(table).append(ui[0].outerHTML);
                return draggedItem;
            },
            update: function(e, ui) {
                assignedBatteryTestsEmit();
            },
            stop: function(e, ui) {
                var batteryTests = ui.item.sortable.sourceModel;
                batteryTests.forEach(function(batteryTest, index) {
                    batteryTest.orderNumber = (index + 1);
                });
            },
            disabled: vm.batteryId && !vm.isStateDuplicate ? true : false
        };

        init();

        function init() {
            vm.batteryTests = vm.batteryTests ? vm.batteryTests : [];
            vm.assignedBatteryTestsOriginal = _.cloneDeep(vm.batteryTests); // init clone data assignedBatteryTests
            initData();
        }

        function initData() {
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize
            };
            Test.getAllTestsByActive(pageable).then(function (response) {
                vm.testsDefault = response && response.data ? response.data : [];
                if (!vm.batteryTests || vm.batteryTests.length == 0) {
                    vm.unassignedBatteryTests = vm.testsDefault;
                } else {
                   vm.unassignedBatteryTests = _.filter(vm.testsDefault, function(item) {
                        return findExitsTestInBatteryTests(item) == -1; // not found
                    });
                }
            });
        }

        function reOrderNumberBatteryTest() {
            vm.batteryTests.forEach(function(batteryTest, index) {
                batteryTest.orderNumber = (index + 1);
            });
        }

        /**
         *
         * @param battery
         * @returns {number} -1 not found
         */
        function findExitsTestInBatteryTests(tests) {
            return _.findIndex(vm.batteryTests, function(o) { return o && tests && o.testId == tests.id; });
        }

        function findIndexTestInUnassignedBatteryTests(test) {
            return _.findIndex(vm.unassignedBatteryTests, function(o) { return o && test && o.id == test.id; });
        }

        function findIndexBatteryTests(batteryTest) {
            return _.findIndex(vm.batteryTests, function(o) { return o && batteryTest && o.testId && o.testId == batteryTest.testId;});
        }

        function findIndexBatteryTestsDeleted(batteryTest) {
            return _.findIndex(vm.batteryTestsDeleted, function(o) { return o && batteryTest && o.testId && o.testId == batteryTest.testId;});
        }

        function unassignBatteryTestsClick(batteryTest) {
            if (vm.isAdHoc) {
                return;
            }
            var indexBatteryTest = findIndexBatteryTests(batteryTest);
            if (indexBatteryTest != -1) {
                // add batteryTest remove
                if (batteryTest.id) {
                    if (findIndexBatteryTestsDeleted(batteryTest) == -1) {
                        batteryTest.active = false;
                        vm.batteryTestsDeleted.push(batteryTest);
                    }
                }
                // remove batteryTest
                vm.batteryTests.splice(indexBatteryTest, 1);

                // add batteryTest to unassignedBatteryTests
                if (batteryTest.test) {
                    vm.unassignedBatteryTests.push(batteryTest.test);
                }
                assignedBatteryTestsEmit();
                reOrderNumberBatteryTest();
            }
        }

        function assignedBatteryTestsClick(test) {
            if (findExitsTestInBatteryTests(test) == -1) {
                // find batteryTest in batteryTests original if exists add from batteryTests else add new
                var indexBatteryTestOriginal =  _.findIndex(vm.assignedBatteryTestsOriginal, function(o) { return o && test && o.testId == test.id; });
                var batteryTestsAssigned;
                if (indexBatteryTestOriginal != -1) {
                    batteryTestsAssigned = vm.assignedBatteryTestsOriginal.slice(indexBatteryTestOriginal, indexBatteryTestOriginal + 1)[0];
                } else {
                    // add new BatteryTests
                    batteryTestsAssigned = {
                        id: null,
                        test: test,
                        testId: test.id,
                        batteryId: vm.batteryId,
                        active: true
                    };

                }
                // fix bug: IPMproject-B1050 and IPMproject-B1049
                var listOrder = [];
                _.forEach(vm.batteryTests, function(test) {
                    listOrder.push(test.orderNumber);
                });
                var maxOrderNumber = _.isEmpty(listOrder) ? 1 : _.max(listOrder) + 1;
                batteryTestsAssigned.orderNumber = maxOrderNumber;
                vm.batteryTests.push(batteryTestsAssigned);

                // remove test from assignedBatteryTests
                removeUnassignedBatteryTests(test);
                // recheck batteryTestsDeleted
                updateBatteryTestsDeleted(test);
                assignedBatteryTestsEmit();
            }
        }

        function updateBatteryTestsDeleted(test) {
            var indexTest = _.findIndex(vm.batteryTestsDeleted, function (o) {
                return o && test && o.testId == test.id;
            });
            if (indexTest != -1) {
                vm.batteryTestsDeleted.splice(indexTest, 1);
            }
        }

        function removeUnassignedBatteryTests(test) {
            var indexTest = findIndexTestInUnassignedBatteryTests(test);
            if (indexTest != -1) {
                vm.unassignedBatteryTests.splice(indexTest, 1);
            }
        }

        function assignedBatteryTestsEmit() {
            vm.onChange({
                batteryTests: vm.batteryTests ? vm.batteryTests : [],
                batteryTestsDeleted : vm.batteryTestsDeleted ? vm.batteryTestsDeleted : []
            });
        }

        function batteryTestsClick(batteryTest) {
            vm.testsOnChange({test:batteryTest.test});
        }

        function testClick(test) {
            vm.testsOnChange({test:test});
        }
    }

    angular.module('ipmApp').component('testsAssignedsList', {
        bindings: {
            batteryTests: '<',
            batteryId: '<',
            isStateDuplicate: '<',
            isAdHoc: '<',
            onChange: '&',
            testsOnChange: '&'
        },
        templateUrl: 'app/entities/haqs-battery/tests-assigned/tests-assigned-list.html',
        controller: TestsAssignedsListController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('global');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    BatteryTestsListController.$inject = ['$scope', '$state'];

    function BatteryTestsListController($scope, $state) {
        var vm = this;//jshint ignore:line
        vm.batteryTestsClick = batteryTestsClick;
        vm.batteryTestsView = [];
        init();

        function init() {
            vm.batteryTestsView = _.cloneDeep(vm.batteryTests);
            vm.batteryTestsView = removeBatteryTestsInactive(vm.batteryTestsView);
        }

        function removeBatteryTestsInactive(batteryTests) {
            var batteryTestsActive = [];
            if (batteryTests) {
                batteryTestsActive = _.remove(batteryTests, function (n) {
                    return n.id && n.test && n.test.activated;
                });
            }
            return batteryTestsActive;
        }

        function batteryTestsClick(batteryTest) {
            if (batteryTest && batteryTest.test && batteryTest.test.id) {
                $state.go('test.edit', {id: batteryTest.test.id, isFromHAQ: true});
            }
        }
    }

    angular.module('ipmApp').component('batteryTestsList', {
        bindings: {
            batteryTests: '<'
        },
        templateUrl: 'app/entities/haqs-battery/battery-tests-list/battery-tests-list.html',
        controller: BatteryTestsListController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('global');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';


    TracksAssignedsListController.$inject = ['$scope', '$state', '$window', 'Principal', 'ipmConstants', 'HaqTracksService', '$uibModal'];

    function TracksAssignedsListController($scope, $state, $window, Principal, constants, HaqTracksService, $uibModal) {
        var vm = this;//jshint ignore:line
        vm.batteries = []; // list batteries is Original, not change data
        vm.unassignedBatteries = [];
        vm.tracksAssignedsOriginal = [];
        vm.trackAssignedBatteryEvent = trackAssignedBatteryEvent;
        vm.assignBatteryClick = assignBatteryClick;
        vm.unassignBatteryClick = unassignBatteryClick;
        vm.sortableOptions = {
            placeholder: "ui-state-highlight",
            helper: function (event, ui) {
                var table = '<table style="position: absolute;" class="jh-table table table-striped"></table>';
                var draggedItem = $(table).append(ui[0].outerHTML);
                return draggedItem;
            },
            update: function (e, ui) {

            },
            stop: function (e, ui) {
                var tracksAssigneds = ui.item.sortable.sourceModel;
                tracksAssigneds.forEach(function (tracksAssigned, index) {
                    tracksAssigned.orderNumber = (index + 1);
                });
            }
        };

        init();

        function init() {
            vm.isAdHoc = vm.isAdHoc ? vm.isAdHoc : false;
            vm.tracksAssigneds = vm.tracksAssigneds ? _.orderBy(vm.tracksAssigneds, ['orderNumber'], ['esc']) : [];
            vm.tracksAssignedsOriginal = _.cloneDeep(vm.tracksAssigneds); // init clone data tracksAssigneds
            initData();
        }

        function initData() {
            HaqTracksService.getAllBatteryDefault().then(function (response) {
                vm.batteries = response ? response : [];
                if (!vm.tracksAssigneds || vm.tracksAssigneds.length == 0) {
                    vm.unassignedBatteries = _.cloneDeep(vm.batteries);
                } else {
                    vm.unassignedBatteries = _.filter(vm.batteries, function (item) {
                        return findExitsBatteriesInTrackAssign(item) == -1;
                    });
                }
            });
        }

        /**
         *
         * @param battery
         * @returns {number} -1 not found
         */
        function findExitsBatteriesInTrackAssign(battery) {
            return _.findIndex(vm.tracksAssigneds, function (o) {
                return o && battery && o.batteryId == battery.id;
            });
        }

        function assignBatteryClick(battery) {
            if (vm.isAdHoc) {
                return;
            }
            if (battery) {
                var indextracksAssigneds = _.findIndex(vm.tracksAssignedsOriginal, function (o) {
                    return o && o.batteryId == battery.id;
                });
                var haqTracksAssignedTemp;
                if (indextracksAssigneds != -1) { // find battery in tracksAssignedsOriginal if exists add from tracksAssignedsOriginal else add new HAQTracksAssigned
                    haqTracksAssignedTemp = vm.tracksAssignedsOriginal.slice(indextracksAssigneds, indextracksAssigneds + 1)[0];
                    haqTracksAssignedTemp.orderNumber = null;
                } else { // add new HAQTracksAssigned
                    haqTracksAssignedTemp = {
                        id: null,
                        batteryName: battery.nameEn,
                        batteryAssignStatus: "ASSIGNED",
                        orderNumber: battery.orderNumber ? battery.orderNumber : vm.tracksAssigneds.length + 1,
                        batteryId: battery && battery.id ? battery.id : null,
                        battery: battery
                    };
                }
                trackAssignedBatteryEvent(haqTracksAssignedTemp);
            }
        }

        function trackAssignedBatteryEvent(trackAssigned) {
            vm.tracksAssigneds.push(trackAssigned);
            tracksAssignedEmit();
            unassignedBatteries(trackAssigned.batteryId);
            reOrderNumberTracksAssigned();
        }

        function unassignedBatteries(batteryId) {
            _.remove(vm.unassignedBatteries, function (n) {
                return batteryId && n.id === batteryId;
            });
        }

        function tracksAssignedEmit() {
            vm.onChange({tracksAssigneds: vm.tracksAssigneds ? vm.tracksAssigneds : []});
        }

        function unassignBatteryClick(trackAssigned) {
            if (vm.isAdHoc) {
                return;
            }
            if (trackAssigned) {
                var index = _.findIndex(vm.tracksAssigneds, function (n) {
                    return trackAssigned.batteryId && n.batteryId === trackAssigned.batteryId;
                });
                if (index != -1) { // trackAssigned is exists, update trackAssigned
                    // remove tracksAssigneds
                    vm.tracksAssigneds.splice(index, 1);

                    // add to list unassignedBatteries
                    var unassignedBatteriesExist = _.filter(vm.batteries, function (o) {
                        return o.id && o.id === trackAssigned.batteryId;
                    });
                    if (unassignedBatteriesExist && unassignedBatteriesExist.length > 0) {
                        vm.unassignedBatteries.push(unassignedBatteriesExist[0]);
                    }

                }
                reOrderNumberTracksAssigned();
            }
        }

        function reOrderNumberTracksAssigned() {
            vm.tracksAssigneds.forEach(function (tracksAssigned, index) {
                tracksAssigned.orderNumber = (index + 1);
            });
        }
    }

    angular.module('ipmApp').component('tracksAssignedsList', {
        bindings: {
            tracksAssigneds: '<',
            isAdHoc: '<',
            onChange: '&'
        },
        templateUrl: 'app/entities/haq-tracks/tracks-assigneds/tracks-assigneds-list.html',
        controller: TracksAssignedsListController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('global');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('NotesController', NotesController);

    NotesController.$inject = [
        '$scope',
        '$uibModalInstance',
        '$q',
        '$state',
        'CarePlanReviewService',
        'cpr'
    ];

    function NotesController($scope, $uibModalInstance, $q, $state, CarePlanReviewService, cpr) {
        var vm = this;
        vm.cpr = cpr;

        vm.save = function () {
            $uibModalInstance.close(CarePlanReviewService.updateNotes(cpr) ? cpr.notes : null);
            $uibModalInstance.dismiss('cancel');
        }

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CommonQuestionModalController', CommonQuestionModalController);

        CommonQuestionModalController.$inject = ['$uibModalInstance', 'tests'];

    function CommonQuestionModalController ($uibModalInstance, tests) {
        var vm = this;
        vm.tests = tests;
        vm.confirm = confirm;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm () {
            $uibModalInstance.close(true);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('patientCaseTableController', patientCaseTableController);

    patientCaseTableController.$inject = ['$scope', '$uibModal'];

    function patientCaseTableController($scope, $uibModal) {
        var vm = this;
        vm.addPatientCase = addPatientCase;
        vm.patientCaseIdsRemove = vm.patientCaseIdsRemove ? vm.patientCaseIdsRemove : [];

        init();

        function init() {
            if (!_.isEmpty(vm.patientCases)) {
                vm.patientCases[0].isOpen = true;
            }
        }

        function addPatientCase(caseNumber) {
            if (!vm.patientCases) {
                vm.patientCases = [];
            }
            var patientCase = createNewPatientCase(caseNumber);
            patientCase.isOpen = true;
            vm.patientCases.push(patientCase);
        }

        function editPatientCase(indexPatientCase, caseNumber) {
            if (vm.patientCases) {
                vm.patientCases[indexPatientCase].caseNumber = caseNumber;
            }
        }

        function createNewPatientCase(caseNumber) {
            if (!caseNumber) {
                return null;
            }
            var billableConfig = {
                id: null,
                haqTestServiceExclusion: false,
                haqTestBillingExclusion: false,
                haqEvalServiceExclusion: false,
                haqEvalBillingExclusion: false,
                cprServiceExclusion: false,
                cprBillingExclusion: false,
                pneServiceExclusion: false,
                haqTestServiceExclusionReason: null,
                haqTestBillingExclusionReason: null,
                haqEvalServiceExclusionReason: null,
                haqEvalBillingExclusionReason: null,
                cprServiceExclusionReason: null,
                cprBillingExclusionReason: null,
                pneServiceExclusionReason: null,
                active: true
            };
            var patientCase = {
                id: null,
                caseNumber: caseNumber,
                active: true,
                billableConfig: billableConfig,
                patient: {
                    id: vm.patientId
                }
            };

            return patientCase;
        }

        vm.editCaseNumber = function (idx) {
            if (vm.patientCases) {
                var patientCase = vm.patientCases[idx];
                vm.openPatientCaseEdit(true, patientCase, idx);
            }
        };

        vm.removeCaseNumber = function (idx, event) {
            event.preventDefault();
            if (vm.patientCases) {
                var patientCase = vm.patientCases[idx];
                if (patientCase && patientCase.id) {
                    vm.patientCaseIdsRemove.push(patientCase.id);
                }
                vm.patientCases.splice(idx, 1);
            }
        };

        vm.openPatientCaseEdit = function (isEdit, patientCase, indexPatientCase) {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/patient-case-table/patient-case-edit.html',
                controller: 'PatientCaseEditController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    isEdit: function () {
                        return isEdit;
                    },
                    patientCases: function () {
                        return vm.patientCases;
                    },
                    caseNumber: function () {
                        return patientCase && patientCase.caseNumber ? patientCase.caseNumber : '';
                    },
                    patientCaseId: function () {
                        return patientCase && patientCase.id ? patientCase.id : null;
                    }
                }
            }).result.then(function (caseNumber) {
                if (caseNumber) {
                    if (isEdit) {
                        editPatientCase(indexPatientCase, caseNumber);
                    } else {
                        addPatientCase(caseNumber);
                    }
                }
            });
        };
    }

    angular.module('ipmApp').component('patientCaseTable', {
        bindings: {
            isAllowAction: '<',
            isUpdateBillable: '<',
            patientId: '<',
            patientCases: '=',
            patientCaseIdsRemove: '='
        },
        templateUrl: 'app/admin/user-management/patient-case-table/patient-case-table.html',
        controller: patientCaseTableController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                return $translate.refresh();
            }]
        }
    });
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientCaseEditController', PatientCaseEditController);

    PatientCaseEditController.$inject = ['$uibModalInstance', 'User', 'patientCases', 'caseNumber', 'isEdit', 'patientCaseId'];

    function PatientCaseEditController($uibModalInstance, User, patientCases, caseNumber, isEdit, patientCaseId) {
        var vm = this;
        vm.patientCaseId = patientCaseId;
        vm.patientCases = patientCases ? patientCases : [];
        vm.caseNumber = caseNumber ? caseNumber : '';
        vm.isEdit = isEdit ? isEdit : false;
        vm.error = false;

        // Public Functions
        vm.save = save;
        vm.clear = clear;
        vm.namePatientCaseOnChange = namePatientCaseOnChange;

        function checkExistsCaseNumberInCurrent(caseNumber) {
            return vm.patientCases.some(function (patientCase) {
                return patientCase.caseNumber.toLowerCase() === caseNumber.toLowerCase()
                    && (!patientCase.id || (patientCase.id && patientCase.id !== vm.patientCaseId));
            });
        }

        function save() {
            if (!vm.caseNumber) {
                return;
            }
            // check exists caseNumber in current patientCases
            if (checkExistsCaseNumberInCurrent(vm.caseNumber)) {
                vm.error = true;
                return;
            }

            User.checkUniquePatientCase(vm.caseNumber, vm.patientCaseId).then(function (response) {
                if (response && response === true) {
                    vm.error = false;
                    saveCloseModal();
                } else {
                    vm.error = true;
                }
            }).catch(function (error) {
                vm.error = true;
            });
        }
        function saveCloseModal() {
            $uibModalInstance.close(vm.caseNumber);
            $uibModalInstance.dismiss('cancel');
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function namePatientCaseOnChange() {
            vm.error = false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('patientBillableConfigController', patientBillableConfigController);

    patientBillableConfigController.$inject = ['$scope'];

    function patientBillableConfigController($scope) {
        var vm = this;
        vm.isDisabled = vm.isDisabled ? vm.isDisabled : false;
        vm.reasonFieldDisable = {
            haqTestServiceExclusionReason: false,
            haqTestBillingExclusionReason: false,
            haqEvalServiceExclusionReason: false,
            haqEvalBillingExclusionReason: false,
            cprServiceExclusionReason: false,
            cprBillingExclusionReason: false,
            pneServiceExclusionReason: false
        };

        vm.checkDisabledReason = checkDisabledReason;

        init();

        function init() {
            if (vm.patientBillableConfig && vm.patientBillableConfig.id) {
                setExclusionReasonFieldDisable();
            }
        }

        function setExclusionReasonFieldDisable() {
            for (var reason in vm.reasonFieldDisable) {
                vm.reasonFieldDisable[reason] = !!vm.patientBillableConfig[reason]; // convert the value to boolean
            }
        }

        function checkDisabledReason(property) {
            if (vm.reasonFieldDisable && vm.patientBillableConfig) {
                return  !!vm.patientBillableConfig[property] && vm.reasonFieldDisable[property];
            }
        }

        function toggleProperty(property) {
            if (vm.patientBillableConfig) {
                vm.patientBillableConfig[property] = !vm.patientBillableConfig[property];
            }
        }

        function updatePatientExclusionReason(property, value) {
            if (vm.patientBillableConfig) {
                vm.patientBillableConfig[property] = value;
            }
        }

        function changeExclusion(property, reason) {
            toggleProperty(property);
            updatePatientExclusionReason(reason, '');
        }

        // Function to change HAQ Test Service Exclusion
        vm.changeHaqTestServiceExclusion = function () {
            changeExclusion('haqTestServiceExclusion', 'haqTestServiceExclusionReason');
        };

        // Function to change HAQ Test Billing Exclusion
        vm.changeHaqTestBillingExclusion = function () {
            changeExclusion('haqTestBillingExclusion', 'haqTestBillingExclusionReason');
        };

        // Function to change HAQ Eval Service Exclusion
        vm.changeHaqEvalServiceExclusion = function () {
            changeExclusion('haqEvalServiceExclusion', 'haqEvalServiceExclusionReason');
        };

        // Function to change HAQ Eval Billing Exclusion
        vm.changeHaqEvalBillingExclusion = function () {
            changeExclusion('haqEvalBillingExclusion', 'haqEvalBillingExclusionReason');
        };

        // Function to change CPR Service Exclusion
        vm.changeCprServiceExclusion = function () {
            changeExclusion('cprServiceExclusion', 'cprServiceExclusionReason');
        };

        // Function to change CPR Billing Exclusion
        vm.changeCprBillingExclusion = function () {
            changeExclusion('cprBillingExclusion', 'cprBillingExclusionReason');
        };

        // Function to change PNE Service Exclusion
        vm.changePneServiceExclusion = function () {
            changeExclusion('pneServiceExclusion', 'pneServiceExclusionReason');
        };
    }

    angular.module('ipmApp').component('patientBillableConfig', {
        bindings: {
            isDisabled: '<',
            patientBillableConfig: '='
        },
        templateUrl: 'app/admin/user-management/patient-case-table/patient-billable-config.html',
        controller: patientBillableConfigController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                return $translate.refresh();
            }]
        }
    });
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QhpTasksController', QhpTasksController);

    QhpTasksController.$inject = ['$scope', '$filter', 'ipmConstants'];

    function QhpTasksController($scope, $filter, constants) {
        var vm = this;
        vm.tasksInit = [];
        vm.checkRequired = checkRequired;
        vm.isTaskCheckBoxDirty = false;
        init();

        function init() {
            if (vm.role && vm.role === constants.ROLE_STAFF) { // init task for ROLE_STAFF
                vm.tasksInit.push(createQHPTask(constants.FRP_MDE, false));
                vm.tasksInit.push(createQHPTask(constants.CONTINUITY_OF_CARE, false));
            } else if (vm.tasksInit.length === 0) { // default init task for ROLE_QHP
                vm.tasksInit.push(createQHPTask(constants.HAQ_EVALUATION, false));
                vm.tasksInit.push(createQHPTask(constants.HAQ_BRIEF_REVIEW, false));
                vm.tasksInit.push(createQHPTask(constants.CARE_PLAN_REVIEW, false));
                if (!constants.HIDE_WELLNESS_CLASSES) {
                    vm.tasksInit.push(createQHPTask(constants.INSTRUCTOR, false));
                }
                vm.tasksInit.push(createQHPTask(constants.FRP_MDE, false));
            }

            if (vm.tasks && vm.tasks.length > 0) {
                initTask();
            }

            onChangeCheckbox(); // init First Change
        }

        function createQHPTask(qhpTaskType, active) {
            return {type: qhpTaskType, active: active};
        }

        vm.checkboxChange = function () {
            vm.isTaskCheckBoxDirty = true;
            onChangeCheckbox();
        }

        function checkRequired() {
            return vm.tasks && vm.tasks.length > 0;
        }

        function initTask() {
            if (vm.tasksInit.length > 0) {
                vm.tasksInit.forEach(function (item) {
                    item.active = checkExistsTask(item.type);
                });
            }
        }

        function checkExistsTask(task) {
            if (vm.tasks && vm.tasks.length > 0) {
                var countTask = $filter('filter')(vm.tasks, function (item) {
                    return item === task;
                }).length;
                if (countTask > 0) {
                    return true;
                }
            }
            return false;
        }

        function onChangeCheckbox() {
            var taskCheckBox = [];
            if (vm.tasksInit) {
                vm.tasksInit.forEach(function (task) {
                    if (task && task.active) {
                        taskCheckBox.push(task.type);
                    }
                });
            }
            vm.onChange({tasks: taskCheckBox ? taskCheckBox : []});
        }

    }

    angular.module('ipmApp').component('qhpTasks', {
        bindings: {
            tasks: '<',
            role: '<',
            onChange: '&'
        },
        templateUrl: 'app/admin/user-management/qhp-tasks/qhp-tasks.html',
        controller: QhpTasksController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('multiOfficeController', multiOfficeController);

    multiOfficeController.$inject = [];

    function multiOfficeController() {
        var vm = this;
        vm.addAnotherOFfice = addAnotherOFfice;
        vm.removeSelectedOffice = removeSelectedOffice;
        vm.filteredOffices = filteredOffices;
        vm.changeSelectedOffice = changeSelectedOffice;
        vm.isShowAddAnotherOfficeLink = isShowAddAnotherOfficeLink;
        init();

        function init() {
            vm.selectedOffices = vm.selectedOffices && vm.selectedOffices != undefined ? vm.selectedOffices : [];
        }

        function addAnotherOFfice() {
            vm.selectedOffices.push({});

        }

        function removeSelectedOffice(index) {
            if (vm.selectedOffices && vm.selectedOffices.length === 1) {
                return;
            }
            vm.selectedOffices.splice(index, 1);
        }

        function changeSelectedOffice(index, office) {
            vm.selectedOffices[index] = office;

        }

        function filteredOffices(selectedOffice) {
            if (vm.selectedOffices.length == 0) {
                return vm.offices;
            }
            var filteredList = [];
            vm.offices.forEach(function (item) {
                if (item.id == selectedOffice.id || _.findIndex(vm.selectedOffices, {
                        id: item.id
                    }) === -1) {
                    filteredList.push(item);
                }

            })
            return filteredList;
        }

        function isShowAddAnotherOfficeLink() {
            return vm.selectedOffices && vm.selectedOffices.length < vm.offices.length;
        }
    }

    angular.module('ipmApp').component('multiOffices', {
        bindings: {
            formReference: '<',
            offices: '<',
            translateKey: '<',
            selectedOffices: '='
        },
        templateUrl: 'app/admin/user-management/multi-offices/multi-offices.html',
        controller: multiOfficeController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('user-management');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('multiFrpProgramsController', multiFrpProgramsController);

    multiFrpProgramsController.$inject = [];

    function multiFrpProgramsController() {
        var vm = this;
        vm.addAnotherFrpProgram = addAnotherFrpProgram;
        vm.removeSelectedFrpProgram = removeSelectedFrpProgram;
        vm.filteredFrpPrograms = filteredFrpPrograms;
        vm.changeSelectedFrpProgram = changeSelectedFrpProgram;
        vm.isShowAddAnotherFrpProgramLink = isShowAddAnotherFrpProgramLink;
        init();

        function init() {
            vm.selectedFrpPrograms = vm.selectedFrpPrograms && vm.selectedFrpPrograms != undefined ? vm.selectedFrpPrograms : [];
            if (vm.selectedFrpPrograms && vm.selectedFrpPrograms.length === 0) {
                addAnotherFrpProgram();
            }
        }

        function addAnotherFrpProgram() {
            vm.selectedFrpPrograms.push({});

        }

        function removeSelectedFrpProgram(index) {
            if (vm.selectedFrpPrograms && vm.selectedFrpPrograms.length === 1) {
                return;
            }
            vm.selectedFrpPrograms.splice(index, 1);
        }

        function changeSelectedFrpProgram(index, frpProgram) {
            vm.selectedFrpPrograms[index] = frpProgram;

        }

        function filteredFrpPrograms(selectedFrpProgram) {
            if (vm.selectedFrpPrograms.length == 0) {
                return vm.frpPrograms;
            }
            var filteredList = [];
            vm.frpPrograms.forEach(function (item) {
                if (item.id == selectedFrpProgram.id || _.findIndex(vm.selectedFrpPrograms, {
                        id: item.id
                    }) === -1) {
                    filteredList.push(item);
                }

            })
            return filteredList;
        }

        function isShowAddAnotherFrpProgramLink() {
            return vm.frpPrograms && vm.selectedFrpPrograms && vm.selectedFrpPrograms.length < vm.frpPrograms.length;
        }
    }

    angular.module('ipmApp').component('multiFrpPrograms', {
        bindings: {
            formReference: '<',
            frpPrograms: '<',
            translateKey: '<',
            selectedFrpPrograms: '='
        },
        templateUrl: 'app/admin/user-management/multi-frp-programs/multi-frp-programs.html',
        controller: multiFrpProgramsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('user-management');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    CocAgreementNotifyController.$inject = [];

    function CocAgreementNotifyController() {
        var vm = this; //jshint ignore:line
        vm.collapse = true;

        init();

        function init() {}

        vm.changeCollapse = function() {
            vm.collapse = !vm.collapse;
        }
    }

    angular.module('ipmApp').component('cocNotifyComponent', {
        bindings: {
            patientIds: '<',
            textNotify: '<',
            type: '<', // error or success
            values: '<',
        },
        templateUrl: 'app/admin/coc-agreement/notify-component/notify.component.html',
        controller: CocAgreementNotifyController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'ipmConstants'];

    function RequestResetController ($timeout, Auth, constants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('[ng-model="resetAccount.email"]').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key&invitation',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$rootScope', '$stateParams','$window', 'ipmConstants', '$timeout','$state', 'Auth', 'LoginService'];

    function ResetFinishController ($rootScope, $stateParams, $window, constants, $timeout, $state, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;
        vm.invitation = Boolean;

        $timeout(function (){angular.element('[ng-model="vm.resetAccount.password"]').focus();});

        init();

        function init(){
            vm.invitation = $stateParams.invitation ;
        }

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                    // $window.location.href = '/#/npq-questionnaire/workflow';
                    $rootScope.$broadcast(constants.EVT_AUTHENTICATION_SUCCESS_BY_INVITATION);
                    $state.go('home');
                }).catch(function (response) {
                    vm.success = null;
                    vm.error = response.data;
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ThankYouController', ThankYouController);

    ThankYouController.$inject = ['$scope', '$state', '$uibModal', '$translate', '$translatePartialLoader', '$rootScope', '$sessionStorage', 'SurveyWorkflowService', 'Auth', 'ClearLocalStorageService', '$localStorage', '$window', 'ipmConstants', 'isAdHoc', 'haqBatteryAdHoc', 'surveyResultType'];

    function ThankYouController($scope, $state, $uibModal, $translate, $translatePartialLoader, $rootScope, $sessionStorage, SurveyWorkflowService, Auth, ClearLocalStorageService, $localStorage, $window, constants, isAdHoc, haqBatteryAdHoc, surveyResultType) {
        var vm = this;
        vm.comment = null;
        vm.currentSurveyResultId = $sessionStorage.currentSurveyResultId;
        vm.isAdHoc = isAdHoc ? isAdHoc : false;
        vm.haqBatteryAdHoc = haqBatteryAdHoc ? haqBatteryAdHoc : null;
        vm.hasNextAdHoc = false;
        vm.surveyResultType = surveyResultType;
        $translatePartialLoader.addPart('surveyWorkflow');
        $translate.refresh();
        vm.showSkypeDialog = function() {
        	$uibModal.open({
                controller: function ($uibModalInstance) {
                	var vm = this;
                	vm.close = function() {
                		$uibModalInstance.dismiss('cancel');
                	}
                },
                templateUrl: 'app/survey-workflow/partial/skype-confirm-dialog.html',
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static',
                windowClass: 'absolute-center warning-dialog'
            });
        };

        init();

        function init() {
            if (!vm.currentSurveyResultId) {
                SurveyWorkflowService.getCurrentSurveyResultId().then(function(res){
                    $sessionStorage.currentSurveyResultId = res;
                    vm.currentSurveyResultId = res;
                });
            }
            vm.hasNextAdHoc = vm.haqBatteryAdHoc && vm.haqBatteryAdHoc.batteryTestId ? true : false;
            if (!vm.hasNextAdHoc && ClearLocalStorageService.getLaunchFrom() === constants.HAQ_ADHOC) {
                ClearLocalStorageService.clearLaunchFrom();
            }
        }

        vm.back = function() {
            $rootScope.sessionTimeOut = null;
            vm.currentSurveyResultId = null;
            $sessionStorage.currentSurveyResultId = null;
            delete $localStorage.isQuestionnaireIncomplete;
            delete $localStorage.firstIdOfAllNPQQuestionnaireNotComplete;
            delete $localStorage.isQuestionnaireCount;
            ClearLocalStorageService.clearAll();
            Auth.logout();
            $state.go('home');
        }

        vm.goToLandingPage = function() {
            vm.currentSurveyResultId = null;
            $sessionStorage.currentSurveyResultId = null;
            delete $localStorage.isQuestionnaireIncomplete;
            delete $localStorage.firstIdOfAllNPQQuestionnaireNotComplete;
            delete $localStorage.isQuestionnaireCount;
            if (getSurveyResultId()) {
                ClearLocalStorageService.setKeepLandingPage(true); // KeepLandingPage
            }
            var launchFrom = ClearLocalStorageService.getLaunchFrom();

            ClearLocalStorageService.clearAll();
            ClearLocalStorageService.clearLandingPage();

            // keep value
            if (!launchFrom || launchFrom === constants.HAQ_ADHOC || launchFrom === constants.HAQ_BATTERY) {
                ClearLocalStorageService.clearKeepLandingPage();
            } else if (launchFrom === constants.HAQ) {
                ClearLocalStorageService.setLaunchFrom(launchFrom);
            }

            $state.go('landing-page');
        };

        vm.nextAdHoc = function () {
            var batteryTestId = vm.haqBatteryAdHoc.batteryTestId;
            if (batteryTestId) {
                ClearLocalStorageService.clearSurveyResultId();
                ClearLocalStorageService.setSurveyResultId(vm.haqBatteryAdHoc.surveyResult.id);
                goToSurveyWorkflow(batteryTestId);
            }
        };

        function goToSurveyWorkflow(batteryTestId) {
            $state.go('survey-workflow', {id: batteryTestId});
        }

        function getSurveyResultId() {
            return $window.localStorage.getItem(constants.SURVEY_RESULT_ID);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ErrorDialogController', ErrorDialogController);

    ErrorDialogController.$inject = ['$scope', '$uibModalInstance', '$q', '$state', 'isTranslate', 'message', 'title'];

    function ErrorDialogController($scope, $uibModalInstance, $q, $state, isTranslate, message, title) {
        var vm = this;
        vm.message = message;
        vm.title = title;
        vm.isTranslate = isTranslate ? isTranslate : false;

        vm.yes = function () {
            $uibModalInstance.close(true);
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ConfirmDownloadController', ConfirmDownloadController);

    ConfirmDownloadController.$inject = ['$uibModalInstance'];

    function ConfirmDownloadController($uibModalInstance) {
        var vm = this;
        
        vm.yes = function () {
            $uibModalInstance.close(true);
            $uibModalInstance.dismiss('cancel');
        };

        vm.no = function () {
            $uibModalInstance.close(false);
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ConfirmYesNoController', ConfirmYesNoController);

    ConfirmYesNoController.$inject = ['$scope', '$uibModalInstance', '$q', '$state', 'isTranslate', 'message', 'title'];

    function ConfirmYesNoController($scope, $uibModalInstance, $q, $state, isTranslate, message, title) {
        var vm = this;
        vm.message = message;
        vm.title = title;
        vm.isTranslate = isTranslate ? isTranslate : false;

        vm.yes = function () {
            $uibModalInstance.close(true);
            $uibModalInstance.dismiss('cancel');
        };

        vm.no = function () {
            $uibModalInstance.close(false);
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
;
(function () {
    'use strict';

    ChatSupportController.$inject = ['$scope', '$window'];

    function ChatSupportController($scope, $window) {
        var vm = this; //jshint ignore:line
        init();

        function init() {
            vm.isShow = vm.isShow ? vm.isShow : false;
            if ($window.icPatronChat && vm.isShow) {
                showOrHidePatronChat(true);
                if (checkShowChat()) {
                    return;
                }
                $window.icPatronChat.init({
                    serverHost: 'https://home-c61.nice-incontact.com',
                    bus_no: 4605429,
                    poc: '627b7874-c36f-45ce-aa5d-cf92c3f30683',
                    params: ['FirstName', 'Last Name', 'first.last@company.com', 555 - 555 - 5555]
                });
            }
        }

        function showOrHidePatronChat(isShow) {
            var customerChatElement = document.querySelector('.ie-div-position-customer-chat')
            if (customerChatElement) {
                customerChatElement.style.display = isShow ? "block" : "none";
            }
        }

        function checkShowChat() {
            var hasElement = document.querySelector('.ie-div-position-customer-chat');
            return hasElement !== null;
        }

        $scope.$on('$destroy', function () {
            if ($window.icPatronChat) {
                $window.icPatronChat.hide();
                showOrHidePatronChat(false);
            }
        });

    }

    angular.module('ipmApp').component('chatSupport', {
        bindings: {
            isShow: '<'
        },
        template: '',
        controller: ChatSupportController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('ipmApp')
        .factory('PhoneUtilsService', PhoneUtilsService);

    PhoneUtilsService.$inject = [];

    function PhoneUtilsService() {
        var service = {
            formatPhone: formatPhone
        };

        return service;

        function formatPhone(tel) {
            if (!tel) { return ''; }
	
            var value = tel.toString().trim().replace(/^\+/, '');
    
            if (value.match(/[^0-9]/)) {
                return tel;
            }
    
            var country, city, number;
    
            switch (value.length) {
                case 1:
                case 2:
                case 3:
                    city = value;
                    break;
    
                default:
                    city = value.slice(0, 3);
                    number = value.slice(3);
            }
    
            if(number){
                
                if(number.length>3){
                    number = number.slice(0, 3) + '-' + number.slice(3,7);
                }
                else{
                    number = number;
                }
    
                return ("(" + city + ") " + number).trim();
            }
            else{
                
                return "(" + city;
            }
        }
    }
})();
;
(function () {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('ipmApp')
        .factory('FormatUtilsService', FormatUtilsService);

    FormatUtilsService.$inject = [];

    function FormatUtilsService() {
        var service = {
            removeHrefHtml: removeHrefHtml,
            formatMinuteBySeconds: formatMinuteBySeconds,
            formatMinuteToSecond: formatMinuteToSecond
        };

        return service;

        /**
         * formatMinuteBySeconds.
         * to format minutes care plan review
         * @param totalSeconds
         */
        function formatMinuteBySeconds(totalSeconds) {
            if (totalSeconds) {
                var minutes = parseInt(totalSeconds / 60);
                var extraSeconds = totalSeconds % 60;
                if (extraSeconds >= 30) {
                    minutes += 1;
                }
                return minutes;
            }
        }

        function formatMinuteToSecond(minutes) {
            if (!isNaN(minutes))
                return parseInt(minutes * 60);
        }

        function removeHrefHtml(htmlString) {
            if (!htmlString) {
                return '';
            }
            var tagRemove = "a";
            var regex = '<(\/)?' + tagRemove + '([^>]*)>';
            return htmlString.replace(new RegExp(regex, 'g'), '');
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('ipmApp')
        .factory('DownloadBlobService', DownloadBlobService);

    DownloadBlobService.$inject = ['$window'];
    function DownloadBlobService ($window) {
        var service = {
            download : download,
            downloadAndOpen : downloadAndOpen,
            getFileName: getFileName
        };

        return service;

        function download(blob, downloadName, contentDisposition) {
            if(downloadName === null && contentDisposition){
                downloadName = getFileName(contentDisposition);
            }
            if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(blob, downloadName);
            } else {
                var objectUrl = URL.createObjectURL(blob);
                var element = document.createElement('a');
                element.href = objectUrl;
                element.setAttribute('download', downloadName);
                document.body.appendChild(element);
                element.click();
                $(element).remove();
            }
        }

        function downloadAndOpen(blob, downloadName, contentDisposition) {
            if (downloadName === null && contentDisposition) {
                downloadName = getFileName(contentDisposition);
            }
            if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(blob, downloadName);
            } else {
                var file = new Blob([blob], {type: 'application/pdf'});
                var objectUrl = URL.createObjectURL(file);
                $window.open(objectUrl, '_blank');
            }
        }

        function getFileName(contentDisposition){
            var filename = "";
            if (contentDisposition) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, '');
                }
            }
            return filename;
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('ipmApp')
        .factory('ClearLocalStorageService', ClearLocalStorageService);

    ClearLocalStorageService.$inject = ['$window', 'ipmConstants', '$localStorage', '$sessionStorage'];
    function ClearLocalStorageService ($window, constants, $localStorage, $sessionStorage) {
        var service = {
            'clearWorkflow': clearWorkflow,
            'clearAll': clearAll,
            'clearAllAndWorkflow': clearAllAndWorkflow,
            'clearLandingPage': clearLandingPage,
            'setLandingPage': setLandingPage,
            'getLandingPage': getLandingPage,
            'setKeepLandingPage': setKeepLandingPage,
            'clearKeepLandingPage': clearKeepLandingPage,
            'setTimeSpent': setTimeSpent,
            'clearTimeSpent': clearTimeSpent,
            'getTimeSpent': getTimeSpent,
            'getTimerHasElapsed': getTimerHasElapsed,
            'setTimerHasElapsed': setTimerHasElapsed,
            'clearTimerHasElapsed': clearTimerHasElapsed,
            'setPatientIdForCPRWorkflow': setPatientIdForCPRWorkflow,
            'clearPatientIdForCPRWorkflow': clearPatientIdForCPRWorkflow,
            'getPatientIdForCPRWorkflow': getPatientIdForCPRWorkflow,
            'getHighlightDays': getHighlightDays,
            'setHighlightDays': setHighlightDays,
            'getTimeSpentCPR': getTimeSpentCPR,
            'setTimeSpentCPR': setTimeSpentCPR,
            'clearTimeSpentCPR': clearTimeSpentCPR,
            'getCurrentSlideWC': getCurrentSlideWC,
            'setCurrentSlideWC': setCurrentSlideWC,
            'clearCurrentSlideWC': clearCurrentSlideWC,
            'getCurrentPagePdfViewSlide': getCurrentPagePdfViewSlide,
            'setCurrentPagePdfViewSlide': setCurrentPagePdfViewSlide,
            'clearCurrentPagePdfViewSlide': clearCurrentPagePdfViewSlide,
            'getScaleZoomIn': getScaleZoomIn,
            'setScaleZoomIn': setScaleZoomIn,
            'clearScaleZoomIn': clearScaleZoomIn,
            'getScaleZoomOut': getScaleZoomOut,
            'setScaleZoomOut': setScaleZoomOut,
            'clearScaleZoomOut': clearScaleZoomOut,
            'getNameClassPresentationView' : getNameClassPresentationView,
            'setNameClassPresentationView' : setNameClassPresentationView,
            'clearNameClassPresentationView' : clearNameClassPresentationView,
            'getFRPProgram': getFRPProgram,
            'setFRPProgram': setFRPProgram,
            'clearFRPProgram': clearFRPProgram,
            'clearTimeCPRLogin': clearTimeCPRLogin,
            'getTimeCPRLogin': getTimeCPRLogin,
            'setTimeCPRLogin': setTimeCPRLogin,
            'clearFRPProgramsError': clearFRPProgramsError,
            'getFRPProgramsError': getFRPProgramsError,
            'addFRPProgramsError': addFRPProgramsError,
            'setInitDataCPRWorkflow': setInitDataCPRWorkflow,
            'getInitDataCPRWorkflow': getInitDataCPRWorkflow,
            'clearInitDataCPRWorkflow': clearInitDataCPRWorkflow,
            'getSurveyResultId': getSurveyResultId,
            'setSurveyResultId': setSurveyResultId,
            'clearSurveyResultId': clearSurveyResultId,
            'getLaunchFrom': getLaunchFrom,
            'setLaunchFrom': setLaunchFrom,
            'clearLaunchFrom': clearLaunchFrom,
            'clearAfterLogout': clearAfterLogout,
            'getQuestionIdEvaluationWorkflow': getQuestionIdEvaluationWorkflow,
            'setQuestionIdEvaluationWorkflow': setQuestionIdEvaluationWorkflow,
            'clearQuestionIdEvaluationWorkflow': clearQuestionIdEvaluationWorkflow,
            'getActionEvaluationWorkflow': getActionEvaluationWorkflow,
            'setActionEvaluationWorkflow': setActionEvaluationWorkflow,
            'clearActionEvaluationWorkflow': clearActionEvaluationWorkflow
        };
        return service;

        function clearWorkflow() {
            $window.localStorage.removeItem(constants.SURVEY_RESULT_ID);
            $window.localStorage.removeItem(constants.NPQ_QUESTIONNAIRE_ID);
            $window.localStorage.removeItem(constants.PSYCH_INTAKE_FORM_ID);
            $window.localStorage.removeItem(constants.PASS_RESTRICTION);
            $window.localStorage.removeItem(constants.LAUNCH_FROM);
            $window.localStorage.removeItem(constants.PATIENT_AGREEMENT_ID);
        }

        function clearAll() {
            $window.localStorage.removeItem(constants.INVITATION_WORKFLOW);
            $window.localStorage.removeItem(constants.SURVEY_RESULT_ID);
            $window.localStorage.removeItem(constants.NPQ_QUESTIONNAIRE_ID);
            $window.localStorage.removeItem(constants.PSYCH_INTAKE_FORM_ID);
            $window.localStorage.removeItem(constants.PASS_RESTRICTION);
            $window.localStorage.removeItem(constants.INVITATION_SECRET_KEY);
            $window.localStorage.removeItem(constants.LAUNCH_FROM);
            $window.localStorage.removeItem(constants.PATIENT_AGREEMENT_ID);

        }

        function clearAllAndWorkflow() {
            $sessionStorage.currentSurveyResultId = null;
            delete $localStorage.isQuestionnaireIncomplete;
            delete $localStorage.firstIdOfAllNPQQuestionnaireNotComplete;
            delete $localStorage.isQuestionnaireCount;
            $window.localStorage.removeItem(constants.SURVEY_RESULT_ID);
            $window.localStorage.removeItem(constants.NPQ_QUESTIONNAIRE_ID);
            $window.localStorage.removeItem(constants.PSYCH_INTAKE_FORM_ID);
            $window.localStorage.removeItem(constants.LAUNCH_FROM);
            $window.localStorage.removeItem(constants.PATIENT_AGREEMENT_ID);
            clearAll();
        }

        function clearLandingPage() {
            $window.localStorage.removeItem(constants.PASS_LANDING_PAGE);
        }

        function setLandingPage(value) {
            $window.localStorage.setItem(constants.PASS_LANDING_PAGE, true === Boolean(value) ? value : false);
        }

        function setKeepLandingPage(value) {
            $window.localStorage.setItem(constants.KEEP_LANDING_PAGE, true === Boolean(value) ? value : false);
        }

        function getLandingPage() {
            return $window.localStorage.getItem(constants.PASS_LANDING_PAGE);
        }

        function clearKeepLandingPage() {
            $window.localStorage.removeItem(constants.KEEP_LANDING_PAGE);
        }

        function getTimeSpent() {
            return $window.localStorage.getItem(constants.TIME_SPENT);
        }

        function setTimeSpent() {
            $window.localStorage.setItem(constants.TIME_SPENT, true);
        }

        function clearTimeSpent() {
            $window.localStorage.removeItem(constants.TIME_SPENT);
        }

        function getTimerHasElapsed() {
            return $window.localStorage.getItem(constants.TIMER_HAS_ELAPSED);
        }

        function setTimerHasElapsed(time) {
            return $window.localStorage.setItem(constants.TIMER_HAS_ELAPSED, time);
        }

        function clearTimerHasElapsed() {
            return $window.localStorage.removeItem(constants.TIMER_HAS_ELAPSED);
        }

        function getPatientIdForCPRWorkflow() {
            var dataCPR = $window.localStorage.getItem(constants.PATIENT_ID_FOR_CPR_WORKFLOW);
            return dataCPR ? JSON.parse(dataCPR) : null;
        }

        function setPatientIdForCPRWorkflow(patientId, cprId) {
            var dataCPR = {patientId: patientId, cprId: cprId};
            $window.localStorage.setItem(constants.PATIENT_ID_FOR_CPR_WORKFLOW, JSON.stringify(dataCPR));
        }

        function clearPatientIdForCPRWorkflow() {
            $window.localStorage.removeItem(constants.PATIENT_ID_FOR_CPR_WORKFLOW);
        }

        function getHighlightDays() {
            return $window.localStorage.getItem(constants.HIGHLIGHT_DAYS);
        }

        function setHighlightDays(days) {
            $window.localStorage.setItem(constants.HIGHLIGHT_DAYS, days);
        }

        function getTimeSpentCPR() {
            return $window.localStorage.getItem(constants.TIME_SPENT_CPR_WORKFLOW);
        }

        function setTimeSpentCPR(time) {
            $window.localStorage.setItem(constants.TIME_SPENT_CPR_WORKFLOW, time);
        }

        function clearTimeCPRLogin() {
            $window.localStorage.removeItem(constants.TIME_CPR_LOGIN);
        }

        function getTimeCPRLogin() {
            return $window.localStorage.getItem(constants.TIME_CPR_LOGIN);
        }

        function setTimeCPRLogin(time) {
            $window.localStorage.setItem(constants.TIME_CPR_LOGIN, time);
        }

        function clearTimeSpentCPR() {
            $window.localStorage.removeItem(constants.TIME_SPENT_CPR_WORKFLOW);
        }

        function getCurrentSlideWC() {
            return $window.localStorage.getItem(constants.CURRENT_SLIDE_WC);
        }

        function setCurrentSlideWC(id) {
            $window.localStorage.setItem(constants.CURRENT_SLIDE_WC, id);
        }

        function clearCurrentSlideWC() {
            $window.localStorage.removeItem(constants.CURRENT_SLIDE_WC);
        }

        function getCurrentPagePdfViewSlide() {
            return $window.localStorage.getItem(constants.CURRENT_PAGE_PDF_VIEW);
        }

        function setCurrentPagePdfViewSlide(currentPage) {
            $window.localStorage.setItem(constants.CURRENT_PAGE_PDF_VIEW, currentPage);
        }

        function clearCurrentPagePdfViewSlide() {
            $window.localStorage.removeItem(constants.CURRENT_PAGE_PDF_VIEW);
        }

        function getScaleZoomIn() {
            return $window.localStorage.getItem(constants.SCALE_ZOOM_IN);
        }

        function setScaleZoomIn(currentPage) {
            $window.localStorage.setItem(constants.SCALE_ZOOM_IN, currentPage);
        }

        function clearScaleZoomIn() {
            $window.localStorage.removeItem(constants.SCALE_ZOOM_IN);
        }

        function getScaleZoomOut() {
            return $window.localStorage.getItem(constants.SCALE_ZOOM_OUT);
        }

        function setScaleZoomOut(currentPage) {
            $window.localStorage.setItem(constants.SCALE_ZOOM_OUT, currentPage);
        }

        function clearScaleZoomOut() {
            $window.localStorage.removeItem(constants.SCALE_ZOOM_OUT);
        }
        function getNameClassPresentationView () {
            return $window.localStorage.getItem(constants.PRESENTATION_VIEW);
        }

        function setNameClassPresentationView(name) {
            $window.localStorage.setItem(constants.PRESENTATION_VIEW,name);
        }

        function clearNameClassPresentationView() {
            $window.localStorage.removeItem(constants.PRESENTATION_VIEW);
        }

        function clearFRPProgram() {
            $window.localStorage.removeItem(constants.FRP_PROGRAM);
        }

        function getFRPProgram() {
            return $window.localStorage.getItem(constants.FRP_PROGRAM);
        }

        function setFRPProgram(id) {
            $window.localStorage.setItem(constants.FRP_PROGRAM, id);
        }

        function clearFRPProgramsError() {
            $window.localStorage.removeItem(constants.FRP_PROGRAMS_ERROR);
        }

        function getFRPProgramsError() {
            var frpProgramsErrorJSON = $window.localStorage.getItem(constants.FRP_PROGRAMS_ERROR);
            return frpProgramsErrorJSON ? JSON.parse(frpProgramsErrorJSON) : [];
        }

        function addFRPProgramsError(id) {
            var frpProgramsError = getFRPProgramsError();
            if (!frpProgramsError.includes(id)) {
                frpProgramsError.push(id);
            }
            $window.localStorage.setItem(constants.FRP_PROGRAMS_ERROR, JSON.stringify(frpProgramsError));
        }

        function getInitDataCPRWorkflow() {
            var initDataCPR = $window.localStorage.getItem(constants.INIT_DATA_CPR);
            return initDataCPR === 'true'; // This assumes the value is stored as a string 'true' in the localStorage.
        }

        function setInitDataCPRWorkflow(hasInitialized) {
            $window.localStorage.setItem(constants.INIT_DATA_CPR, hasInitialized);
        }

        function clearInitDataCPRWorkflow() {
            $window.localStorage.removeItem(constants.INIT_DATA_CPR);
        }

        function getSurveyResultId() {
            return $window.localStorage.getItem(constants.SURVEY_RESULT_ID);
        }

        function setSurveyResultId(surveyResultId) {
            $window.localStorage.setItem(constants.SURVEY_RESULT_ID, surveyResultId);
        }

        function clearSurveyResultId() {
            $window.localStorage.removeItem(constants.SURVEY_RESULT_ID);
        }

        function getLaunchFrom() {
            return $window.localStorage.getItem(constants.LAUNCH_FROM);
        }

        function setLaunchFrom(value) {
            $window.localStorage.setItem(constants.LAUNCH_FROM, value);
        }

        function clearLaunchFrom() {
            $window.localStorage.removeItem(constants.LAUNCH_FROM);
        }

		function clearAfterLogout() {
		    delete $localStorage.isQuestionnaireIncomplete;
		    delete $localStorage.firstIdOfAllNPQQuestionnaireNotComplete;
            delete $localStorage.isQuestionnaireCount;
            clearAll();
            clearLandingPage();
            clearKeepLandingPage();
            clearTimeSpent();
            clearTimerHasElapsed();
            clearFRPProgramsError();
		}

        function getQuestionIdEvaluationWorkflow() {
            var questionId = $window.localStorage.getItem(constants.QUESTION_ID_EVALUATION_WORKFLOW);
            return parseInt(questionId);
        }

        function setQuestionIdEvaluationWorkflow(value) {
            $window.localStorage.setItem(constants.QUESTION_ID_EVALUATION_WORKFLOW, value);
        }

        function clearQuestionIdEvaluationWorkflow() {
            $window.localStorage.removeItem(constants.QUESTION_ID_EVALUATION_WORKFLOW);
        }

        function getActionEvaluationWorkflow() {
            return $window.localStorage.getItem(constants.ACTION_EVALUATION_WORKFLOW);
        }

        function setActionEvaluationWorkflow(value) {
            $window.localStorage.setItem(constants.ACTION_EVALUATION_WORKFLOW, value);
        }

        function clearActionEvaluationWorkflow() {
            $window.localStorage.removeItem(constants.ACTION_EVALUATION_WORKFLOW);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('User', User);

    User.$inject = ['$resource', 'DateUtils', '$q', 'halClient', '$http'];

    function User ($resource, DateUtils, $q, halClient, $http) {
        var baseUrl = 'api/users';
        var service = $resource('api/users/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateOfBirth = DateUtils.convertLocalDateFromServer(data.dateOfBirth);
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateOfBirth = DateUtils.convertLocalDateToServer(data.dateOfBirth);
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateOfBirth = DateUtils.convertLocalDateToServer(data.dateOfBirth);
                    return angular.toJson(data);
                }
            },
            'delete':{ method:'DELETE'}
        });

        service.getAllQHPUsersWithInstructorTask = getAllQHPUsersWithInstructorTask;
        service.getUserByCurrentLogin = getUserByCurrentLogin;
        service.getAllQHPUsers = getAllQHPUsers;
        service.getAllStaffUsers = getAllStaffUsers;
        service.getAllPatientCaseByUserId = getAllPatientCaseByUserId;
        service.checkUniquePatientCase = checkUniquePatientCase;
        service.updatePatientCases = updatePatientCases;
        service.getAzureLogoutUri = getAzureLogoutUri;

        function updatePatientCases(data, onSaveSuccess, onSaveError) {
            var deferred = $q.defer();
            var url = baseUrl + '/patient-cases';
            $http.put(url, data).success(function (result) {
                deferred.resolve(result);
                onSaveSuccess();
            }).error(function (error) {
                deferred.reject(error);
                onSaveError();
            });

            return deferred.promise;
        };

        function getAllQHPUsersWithInstructorTask() {
            var deferred = $q.defer();

            var url = baseUrl + '/qhp-instructor-users';
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        function getUserByCurrentLogin() {
            var deferred = $q.defer();

            var url = baseUrl + '/get-user-by-current-login';
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        function getAllQHPUsers() {
            var deferred = $q.defer();

            var url = baseUrl +'/qhp-users';
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        function getAllStaffUsers() {
            var deferred = $q.defer();

            var url = baseUrl +'/staff-users';
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        function getAllPatientCaseByUserId(userId) {
            var deferred = $q.defer();
            var url = baseUrl +'/get-all-patient-case-by-user-id/' + userId;
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function checkUniquePatientCase(caseName, patientCaseId) {
            var deferred = $q.defer();

            var url = baseUrl + '/check-unique-patient-case';
            $http.get(url,
                {
                    params: {caseName: caseName, patientCaseId: patientCaseId}
                })
                .success(function (data, status) {
                    if (status === 200) {
                        deferred.resolve(data);
                    } else {
                        deferred.resolve(null);
                    }
                })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function getAzureLogoutUri() {
            var url = baseUrl + '/get-azure-logout-url';
            return $http.get(url).then(function (resp) {
                return resp ? resp.data : null;
            });
        }

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$q', '$http'];

    function UserSearch ($q, $http) {
    	var baseUrl = 'api';

        var service = {
        	'searchUsers': searchUsers
        };

        function searchUsers(query, pageable) {
    		var deferred = $q.defer();

        	var url = baseUrl + '/users/search';
        	$http.get(url, {
				params: {
					query: ((query != null) ? encodeURIComponent(query) : null),
					page: pageable.page,
					size: pageable.size,
					sort: pageable.sort
				}
			})
			.success(function(data) {
				deferred.resolve(data);
			})
			.error(function(e) {
				deferred.reject(e);
			});

			return deferred.promise;
        }
        
        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            }).error(function(e) {
            	return e;
    		});
        }

        function logout () {
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$http', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'ipmConstants', '$window'];

    function Auth ($rootScope, $state, $http, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, constants, $window) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            confirmEmailAndInjuredType: confirmEmailAndInjuredType,
            confirmEmailAndInjuredTypes: confirmEmailAndInjuredTypes,
            createAccount: createAccount,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            getSupportedListRegister: getSupportedListRegister,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getSupportedListRegister(){
        	var deferred = $q.defer();
        	var url = "api/patients/register/get-supported-list-register";
        	$http.get(url).success(function(data) {
    			deferred.resolve(data);
    		})
    		.error(function(err) {
    			deferred.reject(err);
    		});

    		return deferred.promise;
        }
        
        function confirmEmailAndInjuredType(email, injuredType){
            var deferred = $q.defer();
            var url = "api/users/confirm-email-injuredtype?email=" + email + "&injuredType=" + injuredType;
            $http.put(url).then(function successCallback(response) {
                return deferred.resolve(response);
            }, function errorCallback(response) {
              return deferred.resolve(response);
            });
            return deferred.promise;
        }
        
        function confirmEmailAndInjuredTypes(email, injuredTypes){
            var deferred = $q.defer();
            var url = "api/users/confirm-email-injuredtypes?email=" + email;
            $http.put(url, injuredTypes).then(function successCallback(response) {
                return deferred.resolve(response);
            }, function errorCallback(response) {
              return deferred.resolve(response);
            });
            return deferred.promise;
        }
        
        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'finishReset')) {
                    $state.go('home');
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $rootScope.redirected = true;
                        $rootScope.previousStateName = $rootScope.toState;
                        $rootScope.previousStateNameParams = $rootScope.toStateParams;

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied');
                        LoginService.open();
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
            $rootScope.$broadcast(constants.EVT_AUTHENTICATION_SUCCESS);

            // Reset state memory if not redirected
            if(!$rootScope.redirected) {
                $rootScope.previousStateName = undefined;
                $rootScope.previousStateNameParams = undefined;
            }
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
        
        return service;
    }
})();
;
(function(){
    'use strict';

    angular.module('ipmApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider.state('wellness-class-list', {
            parent: 'app',
            url: '/wellness-class-list',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_QHP'],
            },

            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/wellness-class-list/wellness-class-list.html',
                    controller: 'WellnessClassListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('qhpWorkflow');
                    $translatePartialLoader.addPart('carePlanReviewStatus');
                    $translatePartialLoader.addPart('callLog');
                    $translatePartialLoader.addPart('partyType');
                    $translatePartialLoader.addPart('class-session');
                    return $translate.refresh();
                }]
            }
        })
        .state('wellness-class-list.view', {
            parent: 'wellness-class-list',
            url: '/{classSessionId}/view',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_QHP'],
                pageTitle: 'ipmApp.classSession.home.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-session/class-session-editor.html',
                    controller: 'ClassSessionEditorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        isEdit: function () {
                            return false;
                        },
                        isCreateNew: function () {
                            return false;
                        },
                        isView: function () {
                            return true;
                        },
                        entity: ['ClassSessionService', function (ClassSessionService) {
                            return ClassSessionService.get($stateParams.classSessionId);
                        }],
                        course: function() {
                            return {};
                        },
                        instructors: ['User', function (User) {
                            return User.getAllQHPUsersWithInstructorTask();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('WellnessClassListService', WellnessClassListService);

    WellnessClassListService.$inject = ['$resource', '$http', '$q'];

    function WellnessClassListService ($resource, $http) {
        var resourceUrl = "api/class-sessions/get-up-comming-session-by-qhp";
        var service = $resource(resourceUrl, {}, {});
        service.getUpComingSessionsByInstructorId = getUpComingSessionsByInstructorId;

        function  getUpComingSessionsByInstructorId(pageable, addedTime) {
            return $http.get(resourceUrl, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort,
                    addedTime: addedTime
                }
            }).then(function (response) {
                return response;
            });
        };
        return service;
    };
})();
;
(function() {
    "use strict";

    angular.module('ipmApp').controller('WellnessClassListController',WellnessClassListController);

    WellnessClassListController.$inject = ['$scope','WellnessClassListService','paginationConstants', '$state'];

    function WellnessClassListController($scope, WellnessClassListService, paginationConstants, $state) {
        var vm = this;

        vm.classSessions = [];
        vm.totalItems = 0;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.page = 1;
        vm.predicate = 'classStart';
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.isLoading = false;
        init();
        function init() {
            vm.loadAll();
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };
            WellnessClassListService.getUpComingSessionsByInstructorId(pageable, 2).then(function (response) {
                var headers = response.headers;
                vm.totalItems = headers('X-Total-Count');
                vm.classSessions = response && response.data ? response.data : [];
                vm.isLoading = false;
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        vm.openControlsInterface = function (id) {
            if (id) {
                $state.go('presentation-controls-instructor', {csId: id});
            }
        };

        vm.checkDisabledLaunchClass = function (classSession) {
            if (classSession) {
                if ((classSession.instructorPresentationStatus
                    && classSession.instructorPresentationStatus === 'FINAL')
                    || classSession.numOfRegistered < 1) {
                    return true;
                }
                return false;
            }
        };
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SubmitPageHAQEvaluationController', SubmitPageHAQEvaluationController);

        SubmitPageHAQEvaluationController.$inject = ['$state', 'evaluationEntity', 'HAQEvaluationWorkflowService', 'signature', 'ClearLocalStorageService'];

    function SubmitPageHAQEvaluationController($state, evaluationEntity, HAQEvaluationWorkflowService, signature, ClearLocalStorageService) {
        var vm = this;
        vm.isSaving = false;
        vm.evaluationEntity = evaluationEntity;
        vm.mostRecentSignature = signature ? signature : null;
        vm.isShowSignaturePad = true;
        vm.signatureId = null; // if signatureId is not null used mostRecent signature
        init();

        function init() {
            ClearLocalStorageService.clearTimeSpent(); // clear & stop time spent
            vm.isShowSignaturePad = vm.mostRecentSignature && vm.mostRecentSignature.id && vm.mostRecentSignature.data ? false : true;
        }

        vm.onChangeSignature = function(data) {
            vm.signatureString = data;
        }

        vm.finishEvaluation = function() {
            vm.isSaving = true;
            if (!vm.signatureString && !vm.isShowSignaturePad && vm.mostRecentSignature && vm.mostRecentSignature.id) {
                vm.signatureId = vm.mostRecentSignature.id;
            }
            HAQEvaluationWorkflowService.finishEvaluation({ haqEvaluationId: vm.evaluationEntity.haqEvaluationId, signatureString: vm.signatureString, signatureId: vm.signatureId }).then(function() {
                $state.go('home');
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        vm.checkSignature = function() {
            if (vm.isShowSignaturePad) {
                return !vm.signatureString;
            }
            return !(vm.mostRecentSignature && vm.mostRecentSignature.id);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.status === 400) {
                ClearLocalStorageService.clearTimeSpent();
                $state.go('home');
            }
        }
    }
})();
;
(function() {
    'use strict';

    SearchCheckboxAutoCompleteController.$inject = ['QHPMedicationService'];

    function SearchCheckboxAutoCompleteController(QHPMedicationService) {
        var vm = this; //jshint ignore:line

        init();

        function init() {}

        vm.loader = function (name) {
            return QHPMedicationService.searchByName(name, (vm.excludeIds && vm.excludeIds.length > 0) ? vm.excludeIds : [0], vm.type).then(function (res) {
                return res;
            })
        }

        vm.handleSelected = function () {
            vm.onSelected({ data: vm.ortherCheckbox });
            vm.ortherCheckbox = "";
        }
    }

    angular.module('ipmApp').component('searchCheckboxAutoComplete', {
        bindings: {
            excludeIds: '<',
            type: '<',
            onSelected: '&'
        },
        templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/search-checkbox-autocomplete.html',
        controller: SearchCheckboxAutoCompleteController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';


    HaqReviewOverviewController.$inject = ['$translate'];

    function HaqReviewOverviewController($translate) {
        var vm = this; //jshint ignore:line
        vm.rangeReviewText = '';
        init();

        function init() {
            vm.rangeReviewText = vm.rangeReview ? $translate.instant( 'ipmApp.landingPageHAQ.home.rangeReview.' + vm.rangeReview) : '';
        }
    }

    angular.module('ipmApp').component('haqReviewOverview', {
        bindings: {
            type: '<',
            patientName: '<',
            score: '<',
            scoreInterpretation: '<',
            rangeReview: '<'
        },
        templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/review-overview.html',
        controller: HaqReviewOverviewController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    HaqEvaluationQuestionController.$inject = ['$timeout', '$state'];

    function HaqEvaluationQuestionController($timeout, $state) {
        var vm = this; //jshint ignore:line
        vm.isSingleChoiceQuestion = isSingleChoiceQuestion;
        vm.isCheckBoxQuestion = isCheckBoxQuestion;
        vm.isNumericalEntryQuestion = isNumericalEntryQuestion;
        vm.findAndOutputParentAnswer = findAndOutputParentAnswer;
        vm.findAndOutputTheSameLevelAnswer = findAndOutputTheSameLevelAnswer;
        vm.isFreeTextQuestion = isFreeTextQuestion;
        vm.handleCheckboxChange = handleCheckboxChange;
        vm.isOtherCheckboxTextInputRequired = isOtherCheckboxTextInputRequired;
        vm.isOtherSingleChoiceTextInputRequired = isOtherSingleChoiceTextInputRequired;
        vm.handleFABQ_TSK_PCS = handleFABQ_TSK_PCS;
        vm.isMultipleCheckBoxColumnQuestion = isMultipleCheckBoxColumnQuestion;
        vm.getStringAnswerFromMultipleColumnCheckboxValue = getStringAnswerFromMultipleColumnCheckboxValue;
        vm.sortQuestionItemByName = sortQuestionItemByName;
        vm.checkClearChildByCheckboxValues = checkClearChildByCheckboxValues;
        vm.isCheckboxQuestionHaveOption = isCheckboxQuestionHaveOption;
        vm.isDisplayQuestionName = isDisplayQuestionName;
        
        vm.keyOtherCheckBoxOnEvaluationStoreage = vm.question.code + '-otherCheckbox';

        init();

        function init() {

            

            if (vm.isCheckBoxQuestion()) {
                vm.checkboxValues = [];
                vm.ortherCheckboxExcludeIds = [];
                // get other checkbox from evaluation store if have check
                var a = vm.evaluationStorage.get(vm.keyOtherCheckBoxOnEvaluationStoreage) 
                var z = vm.answers.get(vm.question.code);
                if (a) {
                    _.forEach(a, function (b) {
                        var c = _.find(vm.question.questionItems, function(d) { return b.id === d.id; });
                        if (!c) {
                            vm.question.questionItems.push(b);
                        }
                        // handle case change parent answer, remove other checkbox selected
                        if (!z) {
                            _.remove(vm.question.questionItems, function(d) { return b.id === d.id; });
                        }
                    });
                }
                // order child by order number
                vm.question.questionItems = _.orderBy(vm.question.questionItems, ['orderNumber'], ['esc']);
                vm.sortQuestionItemByName();
                // init answer
                if (vm.answers) {
                    vm.checkboxValues = vm.answers.get(vm.question.code) ? vm.answers.get(vm.question.code) : [];
                    _.forEach(vm.question.questionItems, function (q) {
                        q.checked = false;
                        var k = _.find(vm.checkboxValues, function(l) { return l.value === q.value});
                        if(k) {
                            q.checked = true;
                        } else if (q.name === 'Other') {
                            var y = _.find(vm.checkboxValues, function(l) { return l.name === q.name});
                            if (y) {
                                q.checked = true;
                                vm.valueOtherCheckboxTextInputValue = y.value;
                            }
                        }
                        vm.ortherCheckboxExcludeIds.push(q.id);
                    });
                    // [Start] IPMproject-Q328: Confirm the logic of item #3
                    if (vm.question.code === "Q-21" || vm.question.code === "Q-39") {
                        var newValueCheckbox = [];
                        _.forEach(vm.checkboxValues, function (q) {
                            var k = _.find(vm.question.questionItems, function(l) { return l.value === q.value});
                            if (k) {
                                newValueCheckbox.push(q);
                            }
                        });
                        vm.checkboxValues = newValueCheckbox;
                        vm.answers.set(vm.question.code, newValueCheckbox);
                        vm.onAnswerChange({ data: { question: vm.question, value: vm.checkboxValues, clearChilds: false }});
                    }
                    // [End] IPMproject-Q328: Confirm the logic of item #3
                }
            } else if (vm.isMultipleCheckBoxColumnQuestion()) {
                vm.sortQuestionItemByName();
                if(vm.question.type === 'CONTROLLED_SUBSTANCES' || vm.question.type === 'PSYCHOTROPIC_MEDICATIONS') {
                    vm.question.questionItems = _.orderBy(vm.question.questionItems, ['name'], ['esc']);
                }
                if (vm.question.code === 'Q-6' || vm.question.code === 'Q-24') { // IPMproject-341 -> feedback #3: Please combine the questions....
                    vm.multipleCheckBoxColumnConfig = { 
                        answers: vm.answers,
                        question: vm.question, 
                        checkboxItems: vm.question.questionItems, 
                        columns: [{value: 'ipm_prescribed'}, {value: 'externally_prescribed'}] }
                        if (!vm.answers.get(vm.question.code)) {
                            vm.newAnswers.set(vm.question.code, {ipm_prescribed: [], externally_prescribed: []});   
                        }
                }
            } else {
                // init for single choice if childs not have parent answer [EPWORTH && ISI]
                var list = [];
                if (vm.isSingleChoiceQuestion()) {
                    _.forEach(vm.question.childs, function (child) {
                        if (!child.parentAnswer) {
                            list.push(child);
                        }
                    });
                    if (!_.isEmpty(list)) {
                        var i = 100;
                        _.mapValues(vm.question.optionNames, function(o) {
                            _.forEach(list, function (l) {
                                var k = _.cloneDeep(l);
                                k.parentAnswer = o.value;
                                k.id = l.id + i; // avoid duplicate on UI
                                // find existing
                                if (_.isEmpty(_.filter(vm.question.childs, function (existingItem) {
                                    return existingItem.id === k.id
                                }))) {
                                    vm.question.childs.push(k);
                                }
                                i = i + 10;
                            });
                            
                        });
                    }
                    // IPMproject-Q320
                    _.forEach(vm.question.optionNames, function (option) {
                        if (option.value === 'Other') {
                            var otherAnswer = vm.answers.get(vm.question.code);
                            if (otherAnswer) {
                                var parts = otherAnswer.split('---');
                                var otherCheckboxValue = parts[0];
                                vm.valueOtherSingleChoiceTextInputValue = parts[1];
                                vm.answers.set(vm.question.code, otherCheckboxValue);
                            }
                        }
                    });
                }
                // order child by order number
                vm.question.childs = _.orderBy(vm.question.childs, ['orderNumber'], ['esc']);
                // init answer
                if (vm.answers) {
                    vm.valueAnswer = vm.answers.get(vm.question.code);
                }
            }
        }

        vm.isDisplaySubQuestion = function(subQuestion) {
            if (vm.question.answerType === 'SINGLE_CHOICE') {
                return subQuestion.parentAnswer === vm.valueAnswer;
            }
            if (!subQuestion.specialCase) {
                return true;
            } else {
                return vm.handleSpecialCase(subQuestion);
            }
        }

        vm.handleYesNoChange = function () {
            vm.valueOtherSingleChoiceTextInputValue = undefined; // clear value
            vm.onAnswerChange({ data: { question: vm.question, value: vm.valueAnswer, clearChilds: true } });
        }

        function handleCheckboxChange(item, checked) {
            var k = undefined;
            if (item.name === 'Other') {
                k = _.find(vm.checkboxValues, function(l) { return l.name === 'Other'});
                if (!checked) {
                    vm.valueOtherCheckboxTextInputValue = undefined;
                }
            } else {
                k = _.find(vm.checkboxValues, function(l) { return l.value === item.value});
            }
            if (k) {
                _.remove(vm.checkboxValues, function(n) {
                    return n.value === item.value || (k.name === 'Other' && n.name === 'Other');
                  });
            } else {
                if (checked) {
                    vm.checkboxValues.push({name: item.name, value: item.value, orderNumber: item.orderNumber});
                }
            }
            var isClearChilds = vm.checkClearChildByCheckboxValues(); // fix bug : IPMproject-B1188
            vm.onAnswerChange({ data: { question: vm.question, value: vm.checkboxValues, clearChilds: isClearChilds }});
        }

        vm.handleSubQuestionAnswerChange = function (data) {
            resetExplanationNA();
            vm.onAnswerChange({ data: data, clearChilds: true});
            vm.findAndOutputParentAnswer(vm.mainQuestion, data.question.parentCode);
        };

        vm.handleNumericalChange = function () {
            vm.onAnswerChange({ data: { question: vm.question, value: vm.valueAnswer, clearChilds: true } });
        }

        vm.handleFreeTextChange = function () {
            vm.onAnswerChange({ data: { question: vm.question, value: vm.valueAnswer, clearChilds: true } });
        }

        vm.handleOtherCheckboxTextInput = function () {
            var k = _.find(vm.checkboxValues, function(l) { return l.name === 'Other' });
            k.value = vm.valueOtherCheckboxTextInputValue;
            var isClearChilds = vm.checkClearChildByCheckboxValues(); // fix bug : IPMproject-B1188
            vm.onAnswerChange({ data: { question: vm.question, value: vm.checkboxValues, clearChilds: isClearChilds } });
        }

        vm.handleOtherSingleChoiceTextInput = function () {
            if (vm.valueAnswer === 'Other') {
                vm.onAnswerChange({ data: { question: vm.question, value: vm.valueAnswer + '---' + vm.valueOtherSingleChoiceTextInputValue, clearChilds: true } });
            }
        }

        vm.handleMultipleColumnCheckboxAnswerChange = function (data) {
            vm.onAnswerChange({ data: { question: data.question, value: data.value, clearChilds: true } });
        }

        vm.getTextForOption = function(key) {
            return vm.optionName.get(key);
        }

        function isSingleChoiceQuestion() {
            return vm.question && vm.question.answerType === 'SINGLE_CHOICE';
        }

        function isCheckBoxQuestion() {
            return vm.question && vm.question.answerType === 'CHECKBOX';
        }

        function isNumericalEntryQuestion() {
            return vm.question && vm.question.answerType === 'NUMERICAL_INPUT';
        }

        function isFreeTextQuestion() {
            return vm.question && vm.question.answerType === 'FREE_TEXT_INPUT';
        }

        function isMultipleCheckBoxColumnQuestion() {
            return vm.question && vm.question.answerType === 'MULTIPLE_COLUMN_CHECKBOX';
        }

        function isCheckboxQuestionHaveOption() {
            return vm.question.questionItems && vm.question.questionItems.length > 0;
        }

        function isDisplayQuestionName() {
            if (vm.isCheckBoxQuestion()) {
                if (!vm.isCheckboxQuestionHaveOption()) {
                    return false;
                }
            }
            return vm.question.name ? true : false;
        }

        vm.checkboxChecked = function(option) {
            if (_.indexOf(vm.checkboxValues, option.value) === -1) {
                return false;
            }
            return true;
        }

        function checkClearChildByCheckboxValues() {
            var isClearChilds = false;
            if (_.isEmpty(vm.checkboxValues)) {
                isClearChilds = true;
            }
            return isClearChilds;
        }

        /**
         * This function Description:
         * - find and output all answer of tree to parent component
         **/
        function findAndOutputParentAnswer(question, parentCode) {
            var parentQuestion;
            if (question.code === parentCode) {
                parentQuestion = question;
            } else {
                _.forEach(question.childs, function(c) {
                    if (c.code === parentCode) {
                        parentQuestion = c;
                    } else {
                        vm.findAndOutputParentAnswer(c, parentCode);// find and output in childs of tree
                    }
                })
            }
            if (parentQuestion) {
                var parentValue = vm.answers.get(parentCode);
                    if (parentValue) {
                        vm.onAnswerChange({ data: { question: { code: parentQuestion.code }, value: parentValue }});
                    }
                if (parentQuestion.parentCode) {
                    vm.findAndOutputParentAnswer(vm.mainQuestion, parentQuestion.parentCode); // find and output parent of tree
                }
                vm.findAndOutputTheSameLevelAnswer(parentQuestion); // find and output the same level and childs of tree
            }
        }

        function findAndOutputTheSameLevelAnswer(question) {
            if (question) {
                _.forEach(question.childs, function(c) {
                    var value = vm.answers.get(c.code);
                    if (value) {
                        vm.onAnswerChange({ data: { question: { code: c.code }, value: value }});
                    }
                    vm.findAndOutputTheSameLevelAnswer(c);
                });
            }
        }

        vm.checkBoxRequired = function() {
            var result = true;
            for(var i = 0; i < vm.question.questionItems.length; i++) {
                var n = vm.question.questionItems[i];
                if (n.checked) {
                    result = false;
                    break;
                }
            }
            return result;
        }

        vm.handleOrtherCheckboxSelected = function(item) {
            if (item) {
                // auto checked
                item.checked = true;
                vm.question.questionItems.push(item);
                vm.handleCheckboxChange(item, item.checked);
                vm.ortherCheckboxExcludeIds.push(item.id);

                // push into evaluationStorage
                if (vm.evaluationStorage) {

                    var u = vm.evaluationStorage.get(vm.keyOtherCheckBoxOnEvaluationStoreage);
                    if (!u) {
                        u = [];
                        vm.evaluationStorage.set(vm.keyOtherCheckBoxOnEvaluationStoreage, u);
                    }
                    u.push(item);
                }
            }
        }

        vm.isFreeTextInputRequired = function() {
            /*if (vm.question.code === 'Q-5') { // is common last
                return false;
            }*/
            if (vm.question.code === 'Q-59' || vm.question.code === 'Q-83') { // [EPWORTH && ISI] Are there other things causing you to wake in the night?
                return false;
            }
            return true;
        }

        /**
         * IPMproject-342
         * requiring 50+ words (tokenize the text using spaces, and count the # of tokens).
         * @returns {number}
         */
        vm.minlengthInputRequired = function () {
            if (vm.isCommonLast()) { // is common last
                return 50;
            }
            return 0;
        }

        vm.isCommonLast = function () {
            if (vm.question.code === 'Q-5' || vm.question.code === 'Q-8' ||  vm.question.code === 'Q-26') { // is common last
                return true;
            }
            return false;
        }

        function isOtherCheckboxTextInputRequired() {
            if (!vm.question.haveAutoComplete) {
                var k = _.find(vm.checkboxValues, function(l) { return l.name === 'Other' });
                return k ? true : false
            }
            return false;
        }

        function isOtherSingleChoiceTextInputRequired() {
            if (vm.valueAnswer) {
                return vm.valueAnswer === 'Other' ? true : false
            }
            return false;
        }

        function resetExplanationNA() {
            var isExplanationShown = checkShowExplanationNA();
            // Reset explanations for "N/A"
            if (!isExplanationShown) {
                resetAnswerIfNotSelectNA('Q-168');
                resetAnswerIfNotSelectNA('Q-169');
            }
        }

        function resetAnswerIfNotSelectNA(questionCode) {
            if (vm.answers.get(questionCode)) {
                vm.answers.set(questionCode, null);
            }
        }

        function checkShowExplanationNA() {
            if (!vm.mainQuestion) {
                return false;
            }

            var Q_26 = 'Q-26';
            var Q_8 = 'Q-8';

            // Check if the main question is Q-8 or Q-26
            if (vm.mainQuestion.code === Q_8 || vm.mainQuestion.code === Q_26) {
                var answers = vm.answers;
                var keysToCheck = ['Q-14', 'Q-15', 'Q-16', 'Q-17', 'Q-32', 'Q-33', 'Q-34', 'Q-35'];
                var countAnswerNa = 0;

                for (var key in keysToCheck) {
                    var keyAnswer = answers.get(keysToCheck[key]);

                    // Check if the answer is "N/A"
                    if (keyAnswer && keyAnswer === "N/A") {
                        countAnswerNa++;
                    }
                }

                // Return true if at least one answer is "N/A"
                return countAnswerNa > 0;
            }

            return false; // Return false if the main question is not Q-8 or Q-26
        }


        vm.isDisplayFreeTextOtherCheckbox = function() {
            return isOtherCheckboxTextInputRequired();
        }

        vm.isDisplayFreeTextOtherSingleChoice = function() {
            return isOtherSingleChoiceTextInputRequired();
        }

        vm.isDisplayCheckBoxInline = function() {
            return Object.entries(vm.question.optionNames).length < 3;
        }

        vm.getPlaceHolderForOtherCheckbox = function() {
            if (vm.question.code === 'Q-91' || vm.question.code === 'Q-91') {
                return 'List any psychological issues identified in the chart';
            }
            return '';
        }

        vm.handleSpecialCase = function(subQuestion) {
            // COMM
            if (subQuestion.code === 'Q-17') {
                var q6 = vm.getStringAnswerFromMultipleColumnCheckboxValue('Q-6');
                 if (q6 === 'YES' || vm.answers.get('Q-7') === 'YES'
                    || (vm.newAnswers.get('Q-22') && vm.newAnswers.get('Q-22').length > 0)
                    || (vm.answers.get('Q-22') && vm.answers.get('Q-22').length > 0)) {
                    return true;
                } else {
                    vm.newAnswers.delete('Q-17');
                    vm.answers.delete('Q-17');
                    vm.findAndOutputParentAnswer(vm.mainQuestion, subQuestion.parentCode); // re-out out parent answer without 'Q-17'
                    return false;
                }
            }
            if (subQuestion.code === 'Q-18') {
                var q6 = vm.getStringAnswerFromMultipleColumnCheckboxValue('Q-6');
                if (q6 === 'YES' || (vm.newAnswers.get('Q-22') && vm.newAnswers.get('Q-22').length > 0)
                    || (vm.answers.get('Q-22') && vm.answers.get('Q-22').length > 0)) {
                    return true;
                } else {
                    vm.newAnswers.delete('Q-18');
                    vm.answers.delete('Q-18');
                    vm.onAnswerChange({ data: { question: { code: subQuestion.code }, value: "" }}); // reset answer with code 'Q-18'
                    return false;
                }
            }
            if (subQuestion.code === 'Q-168') {
                return checkShowExplanationNA();
            }
            // SOAPP_5
            if (subQuestion.code === 'Q-35') {
                var q24 = vm.getStringAnswerFromMultipleColumnCheckboxValue('Q-24');
                if (q24 === 'YES' || vm.answers.get('Q-25') === 'YES'
                    || (vm.newAnswers.get('Q-40') && vm.newAnswers.get('Q-40').length > 0)
                    || (vm.answers.get('Q-40') && vm.answers.get('Q-40').length > 0)) {
                    return true;
                } else {
                    vm.newAnswers.delete('Q-35');
                    vm.answers.delete('Q-35');
                    vm.findAndOutputParentAnswer(vm.mainQuestion, subQuestion.parentCode); // re-out out parent answer without 'Q-35'
                    return false;
                }
            }
            if (subQuestion.code === 'Q-36') {
                var q24 = vm.getStringAnswerFromMultipleColumnCheckboxValue('Q-24');
                if (q24 === 'YES' || (vm.newAnswers.get('Q-40') && vm.newAnswers.get('Q-40').length > 0)
                || (vm.answers.get('Q-40') && vm.answers.get('Q-40').length > 0)) {
                    return true;
                } else {
                    vm.newAnswers.delete('Q-36');
                    vm.answers.delete('Q-36');
                    vm.onAnswerChange({ data: { question: { code: subQuestion.code }, value: "" }}); // reset answer with code 'Q-36'
                    return false;
                }
            }
            if (subQuestion.code === 'Q-169') {
                return checkShowExplanationNA();
            }
            // FAB-Q_TSK_PCS
            if (subQuestion.code === 'Q-112') {
                return vm.handleFABQ_TSK_PCS('Q-109')
            }
            if (subQuestion.code === 'Q-121') {
                return vm.handleFABQ_TSK_PCS('Q-118')
            }
            if (subQuestion.code === 'Q-130') {
                return vm.handleFABQ_TSK_PCS('Q-127')
            }
            if (subQuestion.code === 'Q-139') {
                return vm.handleFABQ_TSK_PCS('Q-136')
            }
            if (subQuestion.code === 'Q-148') {
                return vm.handleFABQ_TSK_PCS('Q-145')
            }
            if (subQuestion.code === 'Q-157') {
                return vm.handleFABQ_TSK_PCS('Q-154')
            }
            if (subQuestion.code === 'Q-166') {
                return vm.handleFABQ_TSK_PCS('Q-163')
            }
        }

        function handleFABQ_TSK_PCS (parentAnswerCode) {
            if (vm.answers.get(parentAnswerCode) && vm.answers.get(parentAnswerCode).length > 0) {
                return true;
            }
            return false;
        }

        function getStringAnswerFromMultipleColumnCheckboxValue(code) {
            if (vm.answers.get(code)) {
                var a = new Map(Object.entries(vm.answers.get(code)));
                if ((a.get('ipm_prescribed') && a.get('ipm_prescribed').length > 0)
                    || (a.get('externally_prescribed') && a.get('externally_prescribed').length > 0)) {
                        return 'YES';
                }
            }
            return 'NO';
        }

        function sortQuestionItemByName() {
            if(vm.question.type === 'CONTROLLED_SUBSTANCES' || vm.question.type === 'PSYCHOTROPIC_MEDICATIONS') {
                vm.question.questionItems = _.orderBy(vm.question.questionItems, ['name'], ['esc']);
            }
        }
    }

    angular.module('ipmApp').component('haqEvaluationQuestion', {
        bindings: {
            question: '<',
            mainQuestion: '<',
            answers: '<',
            newAnswers: '<',
            evaluationStorage: '<',
            onAnswerChange: '&'
        },
        templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/question.html',
        controller: HaqEvaluationQuestionController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('LandingPageHAQEvaluationController', LandingPageHAQEvaluationController);

    LandingPageHAQEvaluationController.$inject = ['$scope', '$state', 'evaluationEntity', 'SurveyResultService', 'HAQEvaluationWorkflowService', 'DataUtils', 'ClearLocalStorageService', '$uibModal', '$window'];

    function LandingPageHAQEvaluationController($scope, $state, evaluationEntity, SurveyResultService, HAQEvaluationWorkflowService, DataUtils, ClearLocalStorageService, $uibModal, $window) {
        var vm = this;
        vm.evaluationEntity = evaluationEntity;
        vm.downloadResultPdf = downloadResultPdf;
        vm.downloadResponsePdf = downloadResponsePdf;
        vm.timerSeconds = vm.evaluationEntity.timeSpent ? vm.evaluationEntity.timeSpent : 0;
        vm.timerTextClass = timerTextClass;
        vm.isStopTimer = isStopTimer;
        vm.resetTimeLogin = resetTimeLogin;
        vm.isResume = false;
        vm.isLoading = false;

        vm.typeScores = {
            highScores: 'HIGH_SCORES'
        };

        init();

        function init() {
            resetTimeLogin();
            ClearLocalStorageService.clearTimeSpent();
            if (!vm.evaluationEntity.haqTest) {
                vm.noHaveHaqReadyForReview = true;
                return;
            }
            if (vm.evaluationEntity.status === 'UNDER_REVIEW' && (Object.entries(vm.evaluationEntity.answers).length > 0 || vm.evaluationEntity.timeSpent > 0)) {
                vm.isResume = true;
            }

            // if (vm.evaluationEntity.mainQuestion.lastQuestion) {
            //     $state.go('haq-evaluation.submit');
            //     return;
            // }
        }

        vm.start = function () {
            if (vm.isLoading || !vm.evaluationEntity.wholeBatteries) {
                return;
            }
            if (vm.evaluationEntity && vm.evaluationEntity.haqEvaluationId) {
                if (!vm.isResume) { // start HAQ evaluation
                    HAQEvaluationWorkflowService.startHaqEvaluation(vm.evaluationEntity.haqEvaluationId).then(function (res) {
                        ClearLocalStorageService.setTimeSpent();
                        var timestamp = new Date().getTime();
                        $state.go('haq-evaluation.workflow', { timestamp: timestamp });
                        return;
                    });
                } else {
                    HAQEvaluationWorkflowService.updateTimeSpent(vm.evaluationEntity.haqEvaluationId, false, false, false).then(function (res) {
                        ClearLocalStorageService.setTimeSpent();
                        var timestamp = new Date().getTime();
                        $state.go('haq-evaluation.workflow', { timestamp: timestamp });
                        return;
                    });
                }
            }
        };

        vm.skipReviewEvaluation = function () {
            if (!vm.evaluationEntity.haqEvaluationId) {
                return;
            }
            vm.isLoading = true;
            $uibModal.open({
                templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/skip-evaluation/skip-evaluation-dialog.html',
                controller: 'skipEvaluationDialogController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message confirm-dialog',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            haqEvaluationId: vm.evaluationEntity.haqEvaluationId,
                            reason: null
                        };
                    }
                }
            }).result.then(function () {
                $state.go('home');
                vm.isLoading = false;
            }, function () {
                vm.isLoading = false;
            });
        };

        function setIsResume(resume) {
            vm.isResume = resume ? resume : false;
        }

        function resetTimeLogin() {
            if (vm.evaluationEntity && vm.evaluationEntity.haqEvaluationId) {
                vm.isLoading = true;
                $window.setTimeout(function () {
                    HAQEvaluationWorkflowService.onlyResetTimeSpentLogin(vm.evaluationEntity.haqEvaluationId).then(function (res) {
                        vm.timerSeconds = res ? res : 0;
                        vm.isLoading = false;
                    });
                }, 300); // Set a timeout to get the most recent time spent after workflow destroy updateTimeSpent
            }
        }

        function isStopTimer() {
            // var timeSpent = ClearLocalStorageService.getTimeSpent();
            // return vm.isResume || !timeSpent;
            return true;
        }

        function timerTextClass() {
            return DataUtils.timerTextClass(vm.timerSeconds);
        }

        function downloadResultPdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResult(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        function downloadResponsePdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResponse(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('haq-evaluation', {
            parent: 'app',
            url: '/haq-evaluation',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/landing-page.html',
                    controller: 'LandingPageHAQEvaluationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('landingPageHaq');
                    return $translate.refresh();
                }],
                evaluationEntity: ['HAQEvaluationWorkflowService', function(HAQEvaluationWorkflowService) {
                    return HAQEvaluationWorkflowService.getInQueue();
                }],
                evaluationStorage: [ function () {
                    return new Map();
                }]
            }
        })
        .state('haq-evaluation.workflow', {
            parent: 'haq-evaluation',
            url: '/workflow?timestamp',
            data: {
                authorities: ['ROLE_QHP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/haq-evaluation-workflow.html',
                    controller: 'HAQEvaluationWorkflowController',
                    controllerAs: 'vm'
                }
            },
            params: {
                timestamp: null
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('landingPageHaq');
                    return $translate.refresh();
                }],
                timeSpent: ['HAQEvaluationWorkflowService', function(HAQEvaluationWorkflowService) {
                    return HAQEvaluationWorkflowService.getTimeSpent();
                }],
                timerHasElapsed: ['HAQEvaluationWorkflowService', 'ClearLocalStorageService', function(HAQEvaluationWorkflowService, ClearLocalStorageService) {
                    var timerHasElapsed = ClearLocalStorageService.getTimerHasElapsed();
                    if (timerHasElapsed) {
                        return parseInt(timerHasElapsed);
                    }
                    return HAQEvaluationWorkflowService.getTimerHasElapsed();
                }],
                evaluationEntity: ['HAQEvaluationWorkflowService', 'ClearLocalStorageService', function(HAQEvaluationWorkflowService, ClearLocalStorageService) {
                    var actionEvaluation = ClearLocalStorageService.getActionEvaluationWorkflow();
                    return HAQEvaluationWorkflowService.getInQueue(actionEvaluation);
                }]
            }
        })
        .state('haq-evaluation.submit', {
            parent: 'haq-evaluation',
            url: '/submit',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/submit-page.html',
                    controller: 'SubmitPageHAQEvaluationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('landingPageHaq');
                    return $translate.refresh();
                }],
                signature: ['HAQEvaluationWorkflowService', function(HAQEvaluationWorkflowService) {
                    return HAQEvaluationWorkflowService.getMostRecentSignature(true);
                }]
            }
        });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('HAQEvaluationWorkflowService', HAQEvaluationWorkflowService);

        HAQEvaluationWorkflowService.$inject = ['$resource', '$http', '$q', 'DownloadBlobService'];

    function HAQEvaluationWorkflowService ($resource, $http, $q, DownloadBlobService) {
        var resourceUrl = "api/haq-evaluation-workflow";
        var service = $resource(resourceUrl, {}, {});
        service.getInQueue = getInQueue;
        service.navigationBatteryTestEvaluationWorkflow = navigationBatteryTestEvaluationWorkflow;
        service.sumbitEvaluation = sumbitEvaluation;
        service.finishEvaluation = finishEvaluation;
        service.downloadHaqEvaluation = downloadHaqEvaluation;
        service.updateTimeSpent = updateTimeSpent;
        service.adhocUpdateTimeSpent = adhocUpdateTimeSpent;
        service.getMostRecentSignature = getMostRecentSignature;
        service.getTimerHasElapsed = getTimerHasElapsed;
        service.getTimeSpent = getTimeSpent;
        service.findByPatientPaganition = findByPatientPaganition;
        service.findReadyForReviewPaginationByPatient = findReadyForReviewPaginationByPatient;
        service.isReviewingHaqEvaluation = isReviewingHaqEvaluation;
        service.startHaqEvaluation = startHaqEvaluation;
        service.onlyResetTimeSpentLogin = onlyResetTimeSpentLogin;

        function onlyResetTimeSpentLogin(haqEvaluationId) {
            return $http.post(resourceUrl + '/only-reset-time-spent-login/' + haqEvaluationId, {}).then(function (resp) {
                return resp.data;
            });
        }

        function startHaqEvaluation(haqEvaluationId) {
            return $http.post(resourceUrl + '/start-haq-evaluation/' + haqEvaluationId, {}).then(function (resp) {
                return resp.data;
            });
        }

        function getInQueue(action) {
            return $http.get(resourceUrl + '/get-in-queue', {
                params: {
                    action: action ? action : null
                }
            }).then(function (response) {
                return response.data;
            });
        };

        function navigationBatteryTestEvaluationWorkflow(evaluationRequest) {
            return $http.post(resourceUrl + '/navigation-battery-test-evaluation-workflow', evaluationRequest, {'Content-Type': 'application/x-www-form-urlencoded'}).then(function (resp) {
                return resp.data;
            });
        };

        function sumbitEvaluation(evaluationRequest) {
            return $http.post(resourceUrl + '/submit-evaluation', evaluationRequest, {'Content-Type': 'application/x-www-form-urlencoded'}).then(function (resp) {
                return resp.data;
            });
        };

        function finishEvaluation(finishEvaluationRequest) {
            return $http.post(resourceUrl + '/finish-evaluation', finishEvaluationRequest).then(function (resp) {
                return resp.data;
            });
        };

        function updateTimeSpent(id, timeUpdate, resetTimeLogin, isRefresh) {
            return $http.get(resourceUrl + '/update-time-spent/' + id, { params: { timeUpdate: timeUpdate, resetTimeLogin: resetTimeLogin, isRefresh: isRefresh }}).then(function (resp) {
                return resp.data;
            });
        };

        function adhocUpdateTimeSpent(id, timeUpdate, resetTimeLogin, isRefresh) {
            return $http.get(resourceUrl + '/adhoc-update-time-spent/' + id, { params: { timeUpdate: timeUpdate, resetTimeLogin: resetTimeLogin, isRefresh: isRefresh }}).then(function (resp) {
                return resp.data;
            });
        };

        function getMostRecentSignature(resetTimeLogin) {
            return $http.get(resourceUrl + '/get-most-recent-signature', { params: { resetTimeLogin: resetTimeLogin}}).then(function (response) {
                return response.data;
            });
        };

        function getTimerHasElapsed() {
            return $http.get(resourceUrl + '/get-timer-has-elapsed').then(function (response) {
                return response.data;
            });
        };

        function getTimeSpent() {
            return $http.get(resourceUrl + '/get-time-spent-current').then(function (response) {
                return response.data;
            });
        };

        function downloadHaqEvaluation(fromDate, toDate) {
            var deferred = $q.defer();
            var url = resourceUrl + '/download-haq-evaluation';
            $http({
                url: url,
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function findByPatientPaganition(patientId, pageable) {
            var deferred = $q.defer();
            var url = resourceUrl + '/find-by-patient';

            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            })
                .success(function (data, status, headers) {
                    var result = new Object();
                    result.data = data && data !== undefined ? data : [];
                    result.totalItems = headers('X-Total-Count');
                    deferred.resolve(result);
                }).error(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function findReadyForReviewPaginationByPatient(patientId, pageable) {
            var deferred = $q.defer();
            var url = resourceUrl + '/find-ready-for-review';

            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            })
                .success(function (data, status, headers) {
                    var result = new Object();
                    result.data = data && data !== undefined ? data : [];
                    result.totalItems = headers('X-Total-Count');
                    deferred.resolve(result);
                }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function isReviewingHaqEvaluation(id) {
            return $http.get(resourceUrl + '/is-reviewing-haq-evaluation/' + id).then(function (resp) {
                return resp.data;
            });
        };

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HAQEvaluationWorkflowController', HAQEvaluationWorkflowController);

    HAQEvaluationWorkflowController.$inject = ['$scope', '$state', 'evaluationEntity', 'HAQEvaluationWorkflowService', '$timeout', 'evaluationStorage', 'SurveyResultService', 'DataUtils', 'ClearLocalStorageService', 'timerHasElapsed', 'ipmConstants', 'timeSpent', 'Principal', 'WebWorkerEvlService', '$uibModal'];

    function HAQEvaluationWorkflowController($scope, $state, evaluationEntity, HAQEvaluationWorkflowService, $timeout, evaluationStorage, SurveyResultService, DataUtils, ClearLocalStorageService, timerHasElapsed, constants, timeSpent, Principal, WebWorkerEvlService, $uibModal ) {
        var vm = this;
        vm.evaluationEntity = evaluationEntity;
        vm.haqTest = vm.evaluationEntity.haqTest;
        vm.mainQuestion = vm.evaluationEntity.mainQuestion;
        vm.findQuestion = findQuestion;
        vm.sumitAnswer = sumitAnswer;
        vm.removeOldAnswer = removeOldAnswer;
        vm.storeCurrentAnswerIntoStorage = storeCurrentAnswerIntoStorage;
        vm.findAndUpdateOldChildAnswer = findAndUpdateOldChildAnswer;
        vm.init = init;
        vm.downloadResultPdf = downloadResultPdf;
        vm.downloadResponsePdf = downloadResponsePdf;
        vm.removeChildsNewAnswersByCode = removeChildsNewAnswersByCode;
        vm.timerSeconds = timeSpent ? timeSpent : 0;
        vm.timerTextClass = timerTextClass;

        vm.timerHasElapsed = timerHasElapsed && timerHasElapsed !== 0 ? timerHasElapsed : constants.TIME_ELAPSED_DEFAULT; // default 31 minutes # get timerHasElapsed from config
        vm.isSaving = false;
        vm.isSavingTimeSpent = false;

        vm.firstQuestionCode = 'Q-1';
        vm.lastQuestionCode = 'Q-5';

        function init() {
            initWorkerService();
            if (vm.timerHasElapsed && !ClearLocalStorageService.getTimerHasElapsed()) {
                ClearLocalStorageService.setTimerHasElapsed(vm.timerHasElapsed);
            }
            if (vm.mainQuestion) {
                ClearLocalStorageService.clearActionEvaluationWorkflow();
                ClearLocalStorageService.setQuestionIdEvaluationWorkflow(vm.mainQuestion.id);
                // update TimeSpent when reload, back or next.
                refreshTimeSpent();
                // init list value to submit server
                vm.newAnswersSubmitServer = new Map();
                // init answers list
                vm.answers = new Map(Object.entries(vm.evaluationEntity.answers));
                // push list temp answer into list answer and list submit
                vm.evaluationStorage = evaluationStorage;
                var tempAnswerMap = vm.evaluationStorage.get(vm.mainQuestion.code);
                if (tempAnswerMap) {
                    tempAnswerMap.forEach(function(value, key) {
                        vm.answers.set(key, value);
                        vm.newAnswersSubmitServer.set(key, value);
                        // update old value answer value to new value store in evaluation storage
                        vm.findAndUpdateOldChildAnswer(vm.mainQuestion, tempAnswerMap);
                    });
                }
                // [start] block code for type [EPWORTH] and [ISI] remove relate question answers
                if (vm.mainQuestion.code === 'Q-42') {
                    vm.specialValue = vm.answers.get('Q-42');
                } else if (vm.mainQuestion.code === 'Q-64') {
                    vm.specialValue = vm.answers.get('Q-64');
                }
                // [end] block code for type [EPWORTH] and [ISI] remove relate question answers
            }
            document.addEventListener('visibilitychange', handleVisibilityChange, false);
        }

        function initWorkerService() {
            WebWorkerEvlService.startTimeSpent();
            WebWorkerEvlService.startIntervalAutoSave();
            if (WebWorkerEvlService.getWebWorker()) {
                WebWorkerEvlService.getWebWorker().onmessage = function (event) {
                    if (event.data && event.data === constants.WEB_WORKER.START_TIME_SPENT_INTERVAL_EVL) {
                        timeSpentChangeW();
                    } else if (event.data === constants.WEB_WORKER.START_AUTO_SAVE_INTERVAL_EVL) {
                        startAutoSaveTimeSpentW();
                    }
                };
                WebWorkerEvlService.getWebWorker().addEventListener('error', function (event) {
                    // console.error('WebWorkerEvlService is offline');
                    openErrorClearCacheDialog();
                });
            } else {
                // console.error('WebWorkerEvlService is not available');
                openErrorClearCacheDialog();
            }
        }

        function timeSpentChangeW() {
            vm.timerSeconds += 1;
            $scope.$digest();
            // console.log('timerSeconds', vm.timerSeconds, elapsedTime);
        }

        function startAutoSaveTimeSpentW() {
            updateTimeSpent(false, false);
        }

        function handleVisibilityChange() {
            if (document.hidden) {
                console.log('handleVisibilityChange - the browser window or tab is minimized');
            } else {
                console.log('handleVisibilityChange - the browser window or tab is resume');
            }
            startAutoSaveTimeSpentW();
        }

        function findAndUpdateOldChildAnswer (question, tempMapAnswer) {
            if (vm.answers.get(question.code)) {
                if (tempMapAnswer.get(question.code)) {
                    vm.answers.set(question.code, tempMapAnswer.get(question.code))
                } else {
                    vm.answers.delete(question.code);
                }
            }
            // continue to find childs in tree
            _.forEach(question.childs, function (a) {
                if (vm.answers.get(a.code)) {
                    vm.answers.set(a.code, tempMapAnswer.get(a.code));
                    vm.findAndUpdateOldChildAnswer(a, tempMapAnswer);
                }
            });
        }

        function navigationBatteryTestEvaluationWorkflow(haqEvaluation, evaluationAction) {
            var evaluationRequest = {
                haqEvaluation: haqEvaluation.haqEvaluationId,
                evaluationAction: evaluationAction
            };
            ClearLocalStorageService.setActionEvaluationWorkflow(evaluationAction); // to resume question when next, previous battery test
            HAQEvaluationWorkflowService.navigationBatteryTestEvaluationWorkflow(evaluationRequest).then(function (res) {
                if (res) {
                    $state.go('haq-evaluation.workflow', {timestamp: new Date().getTime()});
                    return;
                }
            });
        }

        function getSubmitLastQuestion(isNextAction) {
            return isNextAction && vm.evaluationEntity.navigationHaqEvaluation && vm.evaluationEntity.navigationHaqEvaluation.lastBatteryTest && vm.evaluationEntity.mainQuestion.lastQuestion;
        }

        function sumitAnswer(isNextAction) {
            vm.isSaving = true;
            var convertMap = Object.fromEntries(vm.newAnswersSubmitServer);

            var evaluationRequest = {
                haqEvaluation: vm.evaluationEntity.haqEvaluationId,
                questionId: vm.evaluationEntity.mainQuestion.id,
                haqTestId: vm.evaluationEntity.haqTest.id,
                values: isNextAction ? JSON.stringify(convertMap) : "{}",
                nextAction: isNextAction,
                submitLastQuestion: getSubmitLastQuestion(isNextAction)
            };

            HAQEvaluationWorkflowService.sumbitEvaluation(evaluationRequest).then(function(res) {
                // console.log('res', res.navigationHaqEvaluation, isNextAction);
                if (isNextAction && res && vm.evaluationEntity.navigationHaqEvaluation && vm.evaluationEntity.navigationHaqEvaluation.navigationNext && vm.evaluationEntity.navigationHaqEvaluation.nextBatteryTestId) { // next click
                    navigationBatteryTestEvaluationWorkflow(vm.evaluationEntity, 'NEXT_BATTERY_TEST');
                    return;
                } else if (!isNextAction && res && vm.evaluationEntity.navigationHaqEvaluation && vm.evaluationEntity.navigationHaqEvaluation.navigationPrevious && vm.evaluationEntity.navigationHaqEvaluation.previousBatteryTestId) { // previous click
                    navigationBatteryTestEvaluationWorkflow(vm.evaluationEntity, 'PREVIOUS_BATTERY_TEST');
                    return;
                }
                if (isNextAction) {
                    // go to submit page
                    if (vm.evaluationEntity.navigationHaqEvaluation && vm.evaluationEntity.navigationHaqEvaluation.lastBatteryTest && vm.evaluationEntity.mainQuestion.lastQuestion) {
                        $state.go('haq-evaluation.submit');
                        return;
                    }
                    // remove answer storage if submit already into server
                    vm.evaluationStorage.delete(vm.mainQuestion.code);

                    // [start] handle remove special case code type [EPWORTH] and [ISI]
                    if (vm.mainQuestion.code === 'Q-42' && vm.specialValue !== vm.answers.get('Q-42')) {
                        vm.evaluationStorage.delete('Q-43');
                        vm.evaluationStorage.delete('Q-44');
                        vm.evaluationStorage.delete('Q-45');
                        vm.evaluationStorage.delete('Q-48');
                    }
                    if (vm.mainQuestion.code === 'Q-64' && vm.specialValue !== vm.answers.get('Q-64')) {
                        vm.evaluationStorage.delete('Q-65');
                        vm.evaluationStorage.delete('Q-66');
                        vm.evaluationStorage.delete('Q-67');
                        vm.evaluationStorage.delete('Q-70');
                    }
                    // [end] handle remove special case code type [EPWORTH] and [ISI]
                }
                vm.mainQuestion = null;
                vm.isSaving = false;
                $timeout(function(){
                    // re-init
                    vm.evaluationEntity = res;
                    vm.mainQuestion = vm.evaluationEntity.mainQuestion;
                    vm.haqTest = vm.evaluationEntity.haqTest;
                    vm.init();
                }, 10);

            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        function onSaveError(error) {
            if (error.status === 400) {
                // remove answer storage if submit already into server
                vm.evaluationStorage.delete(vm.mainQuestion.code);
                $state.go('home');
            }
        }

        function isFirstQuestionOfTest() {
            return vm.evaluationEntity.mainQuestion && vm.evaluationEntity.mainQuestion.firstQuestion;
        }

        vm.checkQuestionSkipCommon = function (evaluationTestScores) {
            var qhpQuestionsSkipped = evaluationTestScores.qhpQuestionsSkipped;
            var typeScore = evaluationTestScores.typeScore;
            var type = evaluationTestScores.type;
            if (typeScore !== 'HIGH_SCORES') {
                return false;
            }
            if ((vm.mainQuestion && (vm.mainQuestion.code === vm.firstQuestionCode
                || vm.mainQuestion.code === vm.lastQuestionCode))
                || vm.evaluationEntity.questionTypeWorkflow === type) {
                return true;
            }
            if (!qhpQuestionsSkipped || qhpQuestionsSkipped.length === 0) {
                return false;
            }
            return !_.isEmpty(_.filter(qhpQuestionsSkipped, function (qhpQuestion) {
                return vm.mainQuestion && qhpQuestion && qhpQuestion.qhpQuestionGetDataId === vm.mainQuestion.id;
            }));
        };

        vm.previous = function() {
            if (vm.isDisablePreviousButton()) {
                return;
            }
            vm.storeCurrentAnswerIntoStorage();
            if (!vm.isSaving) {
                vm.sumitAnswer(false);
            }
            clearIntervalWorker();
        };

        vm.next = function(isFormInvalid) {
            if (isFormInvalid || vm.isDisableNextButton()) {
                return;
            }
            if (!isValidTimeSpent()) {
                return;
            }

            if (!vm.isSaving) {
                vm.sumitAnswer(true);
            }
            clearIntervalWorker();
        };

        vm.isDisablePreviousButton = function() {
            return isFirstQuestionOfTest() && vm.evaluationEntity.navigationHaqEvaluation && vm.evaluationEntity.navigationHaqEvaluation.firstBatteryTest ;
        }

        vm.isShowTimeSpentErrorMessage = function() {
            return vm.evaluationEntity.mainQuestion.lastQuestion && vm.isDisableNextButton();
        }

        vm.isDisableNextButton = function() {
            if (!isValidTimeSpent()) {
                return true;
            }
            return false;
        }

        function isValidTimeSpent() {
            if (vm.evaluationEntity.mainQuestion.lastQuestion) {
                var timerMinutes = vm.timerSeconds ? parseInt(vm.timerSeconds / 60) : 0;
                return timerMinutes >= vm.timerHasElapsed;
            }
            return true;
        }

        vm.handleQuestionAnswerChange = function(data) {
            if (data.clearChilds) {
                // find parent question to clear childs answer and put parent answer into map
                var parentQuestion = vm.findQuestion(vm.mainQuestion, data.question.code);
                if (parentQuestion) {
                    vm.removeChildsNewAnswersByCode(parentQuestion);
                }
                // remove old childs answer value
                vm.removeOldAnswer(data.question.code);
            }
            vm.newAnswersSubmitServer.set(data.question.code, data.value);
            // update value for this code
            vm.answers.set(data.question.code, data.value);
        }

        function removeChildsNewAnswersByCode(parentQuestion) {
            if (parentQuestion) {
                _.forEach(parentQuestion.childs, function(c) {
                    vm.removeChildsNewAnswersByCode(c);
                })
                vm.newAnswersSubmitServer.delete(parentQuestion.code); // clear childs answers
            }
        }

        /**
         * This function Description:
         * - when back-previous question
         * - not save into server
         * - we hold data in state storage
         **/
        function storeCurrentAnswerIntoStorage() {
            vm.evaluationStorage.set(vm.mainQuestion.code, vm.newAnswersSubmitServer);
        }

        /**
         * This function Description:
         * - find question in tree
         **/
        function findQuestion(question, code) {
            var parentQuestion = question.code === code ? question : undefined;
            if (parentQuestion) {
                return parentQuestion;
            } else {
                _.forEach(question.childs, function(c) {
                    var a = vm.findQuestion(c, code);
                    if (a) {
                        parentQuestion = a;
                    }
                })
            }
            return parentQuestion;
        }

        /**
         * This function Description:
         * - when back-previous question
         * - change parent answer
         * - we will clear remove child answer in object vm.answers
         **/
        function removeOldAnswer(code) {
            var question = vm.findQuestion(vm.mainQuestion, code);
            if (question) {
                _.forEach(question.childs, function(c) {
                    vm.removeOldAnswer(c.code);
                    vm.answers.delete(c.code); // clear childs vm.answers to compare
                });
            }
            vm.answers.delete(code);
        }

        function downloadResultPdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResult(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        function timerTextClass() {
            return DataUtils.timerTextClass(vm.timerSeconds);
        }

        function downloadResponsePdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResponse(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        function refreshTimeSpent() {
            setTimeout(function () {
                updateTimeSpent(true, false);
            }, 500);
        }

        function updateTimeSpent(isRefresh, isReset) {
            if (vm.isSavingTimeSpent === true) {
                return;
            }
            isRefresh = isRefresh ? true : false;
            isReset = isReset ? true : false;
            vm.isSavingTimeSpent = true;

            HAQEvaluationWorkflowService.updateTimeSpent(vm.evaluationEntity.haqEvaluationId, true, isReset, isRefresh).then(function (res) {
                if (res && res !== vm.timerSeconds) {
                    vm.timerSeconds = res;
                }
                vm.isSavingTimeSpent = false;
            }, function error(e) {
                vm.isSavingTimeSpent = false;
            });
        }

        function clearWorkerService() {
            WebWorkerEvlService.close();
        }

        function clearIntervalWorker() {
            WebWorkerEvlService.clearTimeSpent();
            WebWorkerEvlService.clearIntervalAutoSave();
            // console.log('clearIntervalWorker', new Date());
        }

        function goBack() {
            $state.go('home');
            return;
        }

        function openErrorClearCacheDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.qhpWorkflow.error.clearCache.message"},
                    title: function () {return "ipmApp.qhpWorkflow.error.title"}
                }
            }).result.then(function() {
                goBack();
            }, function() {
            });
        }

        vm.init();

        $scope.$on('$destroy', function() {
            clearIntervalWorker();
            clearWorkerService();
            ClearLocalStorageService.clearQuestionIdEvaluationWorkflow();
            ClearLocalStorageService.clearActionEvaluationWorkflow();
            // eslint-disable-next-line angular/document-service
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            Principal.identity(false).then(function (account) {
                if (account) {
                    updateTimeSpent(false, true); // reset timeSpentLogin
                }
            });
        });

    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SubmitPageHAQBriefReviewController', SubmitPageHAQBriefReviewController);

        SubmitPageHAQBriefReviewController.$inject = ['$state', 'briefReviewEntity', 'HAQBriefReviewWorkflowService', 'signature', 'ClearLocalStorageService'];

    function SubmitPageHAQBriefReviewController($state, briefReviewEntity, HAQBriefReviewWorkflowService, signature, ClearLocalStorageService) {
        var vm = this;
        vm.isSaving = false;
        vm.briefReviewEntity = briefReviewEntity;
        vm.mostRecentSignature = signature ? signature : null;
        vm.isShowSignaturePad = true;
        vm.signatureId = null; // if signatureId is not null used mostRecent signature
        init();

        function init() {
            ClearLocalStorageService.clearTimeSpent(); // clear & stop time spent
            vm.isShowSignaturePad = vm.mostRecentSignature && vm.mostRecentSignature.id && vm.mostRecentSignature.data ? false : true;
        }

        vm.onChangeSignature = function(data) {
            vm.signatureString = data;
        }

        vm.finishBriefReview = function() {
            vm.isSaving = true;
            if (!vm.signatureString && !vm.isShowSignaturePad && vm.mostRecentSignature && vm.mostRecentSignature.id) {
                vm.signatureId = vm.mostRecentSignature.id;
            }
            HAQBriefReviewWorkflowService.finishBriefReview({ haqEvaluationId: vm.briefReviewEntity.haqEvaluationId, signatureString: vm.signatureString, signatureId: vm.signatureId }).then(function() {
                $state.go('home');
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        vm.checkSignature = function() {
            if (vm.isShowSignaturePad) {
                return !vm.signatureString;
            }
            return !(vm.mostRecentSignature && vm.mostRecentSignature.id);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.status === 400) {
                ClearLocalStorageService.clearTimeSpent();
                $state.go('home');
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('LandingPageHAQBriefReviewController', LandingPageHAQBriefReviewController);

    LandingPageHAQBriefReviewController.$inject = ['$scope', '$state', 'briefReviewEntity', 'SurveyResultService', 'HAQBriefReviewWorkflowService', 'DataUtils', 'ClearLocalStorageService'];

    function LandingPageHAQBriefReviewController($scope, $state, briefReviewEntity, SurveyResultService, HAQBriefReviewWorkflowService, DataUtils, ClearLocalStorageService) {
        var vm = this;
        vm.briefReviewEntity = briefReviewEntity;
        vm.downloadResultPdf = downloadResultPdf;
        vm.downloadResponsePdf = downloadResponsePdf;
        vm.timerSeconds = vm.briefReviewEntity.timeSpent ? vm.briefReviewEntity.timeSpent : 0;
        vm.timerTextClass = timerTextClass;
        vm.isStopTimer = isStopTimer;
        vm.resetTimeLogin = resetTimeLogin;

        vm.typeScores = {
            highScores: 'HIGH_SCORES'
        };

        init();

        function init() {
            resetTimeLogin();
            ClearLocalStorageService.clearTimeSpent();
            if (!vm.briefReviewEntity.haqTest) {
                vm.noHaveHaqBriefReadyForReview = true;
                return;
            }
            if (vm.briefReviewEntity.status === 'UNDER_REVIEW' || vm.briefReviewEntity.briefReviewResponse || vm.briefReviewEntity.timeSpent > 0) {
                vm.isResume = true;
            }

        }

        vm.start = function () {
            if (vm.briefReviewEntity && vm.briefReviewEntity.haqEvaluationId) {
                if (!vm.isResume) { // start HAQ evaluation
                    HAQBriefReviewWorkflowService.startHaqEvaluation(vm.briefReviewEntity.haqEvaluationId).then(function (res) {
                        ClearLocalStorageService.setTimeSpent();
                        $state.go('haq-brief-review.workflow');
                    });
                } else {
                    HAQBriefReviewWorkflowService.updateTimeSpent(vm.briefReviewEntity.haqEvaluationId, false, false, false).then(function (res) {
                        ClearLocalStorageService.setTimeSpent();
                        $state.go('haq-brief-review.workflow');
                    });
                }
            }
        };

        function setIsResume(resume) {
            vm.isResume = resume ? resume : false;
        }

        function resetTimeLogin() {
            if (vm.briefReviewEntity && vm.briefReviewEntity.haqEvaluationId) {
                HAQBriefReviewWorkflowService.updateTimeSpent(vm.briefReviewEntity.haqEvaluationId, false, true, false).then(function (res) {
                    vm.timerSeconds = res ? res : 0;
                    if (vm.timerSeconds > 0) { // fix bug IPMproject-B1301, update Resume after update TimeSpent
                        setIsResume(true);
                    }
                });
            }
        }

        function isStopTimer() {
            var timeSpent = ClearLocalStorageService.getTimeSpent();
            return vm.isResume || !timeSpent;
        }

        function timerTextClass() {
            return DataUtils.timerTextClass(vm.timerSeconds);
        }

        function downloadResultPdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResult(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        function downloadResponsePdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResponse(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('haq-brief-review', {
            parent: 'app',
            url: '/haq-brief-review',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/haq-brief-review-workflow/landing-page.html',
                    controller: 'LandingPageHAQBriefReviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('landingPageHaq');
                    return $translate.refresh();
                }],
                briefReviewEntity: ['HAQBriefReviewWorkflowService', function(HAQBriefReviewWorkflowService) {
                    return HAQBriefReviewWorkflowService.getInQueue();
                }],
                briefReviewStorage: [ function () {
                    return new Map();
                }]
            }
        })
        .state('haq-brief-review.workflow', {
            parent: 'haq-brief-review',
            url: '/workflow?timestamp',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/haq-brief-review-workflow/haq-brief-review-workflow.html',
                    controller: 'HAQBriefReviewWorkflowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('landingPageHaq');
                    return $translate.refresh();
                }],
                timeSpent: ['HAQBriefReviewWorkflowService', function(HAQBriefReviewWorkflowService) {
                    return HAQBriefReviewWorkflowService.getTimeSpent();
                }],
                briefReviewEntity: ['HAQBriefReviewWorkflowService', function(HAQBriefReviewWorkflowService) {
                    var actionEvaluation = null;
                    return HAQBriefReviewWorkflowService.getInQueue(actionEvaluation);
                }]
            }
        })
        .state('haq-brief-review.submit', {
            parent: 'haq-brief-review',
            url: '/submit',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/haq-brief-review-workflow/submit-page.html',
                    controller: 'SubmitPageHAQBriefReviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('landingPageHaq');
                    return $translate.refresh();
                }],
                signature: ['HAQBriefReviewWorkflowService', function(HAQBriefReviewWorkflowService) {
                    return HAQBriefReviewWorkflowService.getMostRecentSignature(true);
                }]
            }
        });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('HAQBriefReviewWorkflowService', HAQBriefReviewWorkflowService);

    HAQBriefReviewWorkflowService.$inject = ['$resource', '$http', '$q', 'DownloadBlobService'];

    function HAQBriefReviewWorkflowService ($resource, $http, $q, DownloadBlobService) {
        var resourceUrl = "api/haq-brief-review-workflow";
        var service = $resource(resourceUrl, {}, {});
        service.getInQueue = getInQueue;
        service.navigationBatteryTestEvaluationWorkflow = navigationBatteryTestEvaluationWorkflow;
        service.sumbitBriefReview = sumbitBriefReview;
        service.finishBriefReview = finishBriefReview;
        service.downloadHaqBriefReview = downloadHaqBriefReview;
        service.updateTimeSpent = updateTimeSpent;
        service.adhocUpdateTimeSpent = adhocUpdateTimeSpent;
        service.getMostRecentSignature = getMostRecentSignature;
        service.getTimeSpent = getTimeSpent;
        service.findByPatientPaganition = findByPatientPaganition;
        service.findReadyForReviewPaginationByPatient = findReadyForReviewPaginationByPatient;
        service.isReviewingHaqBriefReview = isReviewingHaqBriefReview;
        service.startHaqEvaluation = startHaqEvaluation;

        function startHaqEvaluation(haqEvaluationId) {
            return $http.post(resourceUrl + '/start-haq-evaluation/' + haqEvaluationId, {}).then(function (resp) {
                return resp.data;
            });
        }

        function getInQueue(action) {
            return $http.get(resourceUrl + '/get-in-queue', {
                params: {
                    action: action ? action : null
                }
            }).then(function (response) {
                return response.data;
            });
        };

        function navigationBatteryTestEvaluationWorkflow(evaluationRequest) {
            return $http.post(resourceUrl + '/navigation-battery-test-evaluation-workflow', evaluationRequest, {'Content-Type': 'application/x-www-form-urlencoded'}).then(function (resp) {
                return resp.data;
            });
        };

        function sumbitBriefReview(briefReviewRequest) {
            return $http.post(resourceUrl + '/submit-brief-review', briefReviewRequest, {'Content-Type': 'application/x-www-form-urlencoded'}).then(function (resp) {
                return resp.data;
            });
        };

        function finishBriefReview(finishBriefReviewRequest) {
            return $http.post(resourceUrl + '/finish-brief-review', finishBriefReviewRequest).then(function (resp) {
                return resp.data;
            });
        };

        function updateTimeSpent(id, timeUpdate, resetTimeLogin, isRefresh) {
            return $http.get(resourceUrl + '/update-time-spent/' + id, { params: { timeUpdate: timeUpdate, resetTimeLogin: resetTimeLogin, isRefresh: isRefresh }}).then(function (resp) {
                return resp.data;
            });
        };

        function adhocUpdateTimeSpent(id, timeUpdate, resetTimeLogin, isRefresh) {
            return $http.get(resourceUrl + '/adhoc-update-time-spent/' + id, { params: { timeUpdate: timeUpdate, resetTimeLogin: resetTimeLogin, isRefresh: isRefresh }}).then(function (resp) {
                return resp.data;
            });
        };

        function getMostRecentSignature(resetTimeLogin) {
            return $http.get(resourceUrl + '/get-most-recent-signature', { params: { resetTimeLogin: resetTimeLogin}}).then(function (response) {
                return response.data;
            });
        };

        function getTimeSpent() {
            return $http.get(resourceUrl + '/get-time-spent-current').then(function (response) {
                return response.data;
            });
        };

        function downloadHaqBriefReview(fromDate, toDate) {
            var deferred = $q.defer();
            var url = resourceUrl + '/download-haq-brief-review';
            $http({
                url: url,
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function findByPatientPaganition(patientId, pageable) {
            var deferred = $q.defer();
            var url = resourceUrl + '/find-by-patient';

            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            })
                .success(function (data, status, headers) {
                    var result = new Object();
                    result.data = data && data !== undefined ? data : [];
                    result.totalItems = headers('X-Total-Count');
                    deferred.resolve(result);
                }).error(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function findReadyForReviewPaginationByPatient(patientId, pageable) {
            var deferred = $q.defer();
            var url = resourceUrl + '/find-ready-for-review';

            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            })
                .success(function (data, status, headers) {
                    var result = new Object();
                    result.data = data && data !== undefined ? data : [];
                    result.totalItems = headers('X-Total-Count');
                    deferred.resolve(result);
                }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function isReviewingHaqBriefReview(id) {
            return $http.get(resourceUrl + '/is-reviewing-haq-brief-review/' + id).then(function (resp) {
                return resp.data;
            });
        };

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HAQBriefReviewWorkflowController', HAQBriefReviewWorkflowController);

    HAQBriefReviewWorkflowController.$inject = ['$scope', '$state', 'briefReviewEntity', 'HAQBriefReviewWorkflowService', '$timeout', 'briefReviewStorage', 'SurveyResultService', 'DataUtils', 'ClearLocalStorageService', 'ipmConstants', 'timeSpent', 'Principal'];

    function HAQBriefReviewWorkflowController($scope, $state, briefReviewEntity, HAQBriefReviewWorkflowService, $timeout, briefReviewStorage, SurveyResultService, DataUtils, ClearLocalStorageService, constants, timeSpent, Principal ) {
        var vm = this;
        vm.startTimeSpent = startTimeSpent;
        vm.stopTimeSpent = stopTimeSpent;
        vm.briefReviewEntity = briefReviewEntity;
        vm.haqTest = vm.briefReviewEntity.haqTest;
        vm.briefReviewResponse = vm.briefReviewEntity.briefReviewResponse;
        vm.submitAnswer = submitAnswer;
        vm.init = init;
        vm.downloadResultPdf = downloadResultPdf;
        vm.downloadResponsePdf = downloadResponsePdf;
        vm.timerSeconds = timeSpent ? timeSpent : 0;
        vm.timerTextClass = timerTextClass;
        vm.intervalTimeMillisecond = 1000 * 60 * 5; // 5 minutes

        vm.isSaving = false;

        function init() {
            ClearLocalStorageService.clearActionEvaluationWorkflow();
            if (vm.briefReviewResponse) {
                // update TimeSpent when reload, back or next.
                startTimeSpent();
                refreshTimeSpent();
            }
        }

        function navigationBatteryTestEvaluationWorkflow(haqEvaluation, evaluationAction) {
            var evaluationRequest = {
                haqEvaluation: haqEvaluation.haqEvaluationId,
                evaluationAction: evaluationAction
            };
            // ClearLocalStorageService.setActionEvaluationWorkflow(evaluationAction);
            HAQBriefReviewWorkflowService.navigationBatteryTestEvaluationWorkflow(evaluationRequest).then(function (res) {
                if (res) {
                    $state.go('haq-brief-review.workflow', {timestamp: new Date().getTime()});
                    return;
                }
            });
        }

        function submitAnswer(isNextAction) {
            vm.isSaving = true;
            var briefReviewRequest = {
                haqBriefReview: vm.briefReviewEntity.haqEvaluationId,
                briefReviewResponse: vm.briefReviewEntity.briefReviewResponse };

            HAQBriefReviewWorkflowService.sumbitBriefReview(briefReviewRequest).then(function(res) {
                if (isNextAction && res && vm.briefReviewEntity.navigationHaqEvaluation && vm.briefReviewEntity.navigationHaqEvaluation.navigationNext && vm.briefReviewEntity.navigationHaqEvaluation.nextBatteryTestId) { // next click
                    navigationBatteryTestEvaluationWorkflow(vm.briefReviewEntity, 'NEXT_BATTERY_TEST');
                    return;
                } else if (!isNextAction && res && vm.briefReviewEntity.navigationHaqEvaluation && vm.briefReviewEntity.navigationHaqEvaluation.navigationPrevious && vm.briefReviewEntity.navigationHaqEvaluation.previousBatteryTestId) { // previous click
                    navigationBatteryTestEvaluationWorkflow(vm.briefReviewEntity, 'PREVIOUS_BATTERY_TEST');
                    return;
                } else {
                    $state.go('haq-brief-review.submit');
                }
                $timeout(function(){
                    // re-init
                    vm.briefReviewEntity = res;
                    vm.haqTest = vm.briefReviewEntity.haqTest;
                    vm.briefReviewResponse = vm.briefReviewEntity.briefReviewResponse;
                    vm.isSaving = false;
                    // vm.init();
                }, 10);
            }, function errorSave(error) {
                onSaveError(error);
            });
        };

        function onSaveError(error) {
            if (error.status === 400) {
                // remove answer storage if submit already into server
                vm.briefReviewStorage.delete(vm.mainQuestion.code);
                vm.isStopTimer();
                stopTimeSpent();
                $state.go('home');
            }
        }

        vm.next = function(isFormInvalid) {
            if (isFormInvalid) {
                return;
            }

            if (!vm.isSaving) {
                vm.submitAnswer(true);
            }
        };

        vm.previous = function() {
            if (vm.isDisablePreviousButton()) {
                return;
            }
            if (!vm.isSaving) {
                vm.submitAnswer(false);
            }
        };

        vm.isStopTimer = function () {
            var timeSpent = ClearLocalStorageService.getTimeSpent();
            return !timeSpent;
        };

        function stopTimeSpent() {
            ClearLocalStorageService.clearTimeSpent();
        }

        function startTimeSpent() {
            var timeSpent = ClearLocalStorageService.getTimeSpent();
            if (!timeSpent) {
                ClearLocalStorageService.setTimeSpent();
            }
        }

        function downloadResultPdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResult(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        function timerTextClass() {
            return DataUtils.timerTextClass(vm.timerSeconds);
        }

        function downloadResponsePdf(id) {
            vm.noPdf = false;
            SurveyResultService.downloadResponse(id).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        function refreshTimeSpent() {
            setTimeout(function () {
                updateTimeSpent(true, false);
            }, 500);
        }

        function updateTimeSpent(isRefresh, isReset) {
            isRefresh = isRefresh ? true : false;
            isReset = isReset ? true : false;

            HAQBriefReviewWorkflowService.updateTimeSpent(vm.briefReviewEntity.haqEvaluationId, true, isReset, isRefresh).then(function(res) {
                if (res && res != vm.timerSeconds) {
                    vm.stopTimeSpent();
                    vm.timerSeconds = res;
                    vm.startTimeSpent();
                }
            });
        }

        function isFirstQuestionOfTest() {
            return true; // always true
        }

        vm.onChangeTimer = function (data) {
        };

        vm.isDisablePreviousButton = function() {
            return isFirstQuestionOfTest() && vm.briefReviewEntity.navigationHaqEvaluation && vm.briefReviewEntity.navigationHaqEvaluation.firstBatteryTest ;
        };

        vm.isDisableNextButton = function() {
            return false;
        };

        vm.checkQuestionSkipCommon = function (evaluationTestScores) {
            var typeScore = evaluationTestScores.typeScore;
            var type = evaluationTestScores.type;
            if (typeScore !== 'HIGH_SCORES') {
                return false;
            }
            return type === vm.briefReviewEntity.questionTypeWorkflow;
        };

        // [start] intervalUpdateTimeSpent
        var intervalUpdateTimeSpent = null;
        var runIntervalUpdateTimeSpent = function () {
            intervalUpdateTimeSpent = setInterval(function () {
                if (!vm.isStopTimer()) {
                    updateTimeSpent(false, false);
                }
            }, vm.intervalTimeMillisecond);
        };
        runIntervalUpdateTimeSpent();
        // [end] intervalUpdateTimeSpent

        vm.init();

        $scope.$on('$destroy', function() {
            stopTimeSpent();
            clearInterval(intervalUpdateTimeSpent);
            ClearLocalStorageService.clearActionEvaluationWorkflow();
            Principal.identity(false).then(function (account) {
                if (account) {
                    updateTimeSpent(false, true); // reset timeSpentLogin
                }
            });
        });

    }
})();
;
(function() {
    'use strict';


    HaqBriefReviewOverviewController.$inject = ['$translate'];

    function HaqBriefReviewOverviewController($translate) {
        var vm = this; //jshint ignore:line
        vm.rangeReviewText = '';
        init();

        function init() {
            vm.rangeReviewText = vm.rangeReview ? $translate.instant( 'ipmApp.landingPageHAQ.home.rangeReview.' + vm.rangeReview) : '';
        }
    }

    angular.module('ipmApp').component('haqBriefReviewOverview', {
        bindings: {
            type: '<',
            patientName: '<',
            score: '<',
            scoreInterpretation: '<',
            rangeReview: '<'
        },
        templateUrl: 'app/qhp-workflow/haq-brief-review-workflow/brief-review-overview.html',
        controller: HaqBriefReviewOverviewController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('care-plan-review-workflow', {
            parent: 'app',
            url: '/care-plan-review-workflow',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/care-plan-review-workflow/care-plan-review-workflow.html',
                    controller: 'CarePlanReviewWorkflowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('qhpWorkflow');
                    $translatePartialLoader.addPart('carePlanReviewStatus');
                    $translatePartialLoader.addPart('carePlanReview');
                    $translatePartialLoader.addPart('callLog');
                    $translatePartialLoader.addPart('partyType');
                    return $translate.refresh();
                }],
                cprEntity: ['CarePlanReviewWorkflowService', 'ClearLocalStorageService', '$state', '$rootScope', function(CarePlanReviewWorkflowService, ClearLocalStorageService, $state, $rootScope) {
                    var notInitialized = !ClearLocalStorageService.getInitDataCPRWorkflow();
                    var dataCPR = ClearLocalStorageService.getPatientIdForCPRWorkflow();
                    var patientId = dataCPR ? dataCPR.patientId : null;
                    var cprId = dataCPR ? dataCPR.cprId : null;
                    return CarePlanReviewWorkflowService.getData(patientId, cprId, notInitialized).then(function (response) {
                        if (response === 400) { // We will redirect to the homepage and attempt to reload the page.
                            $state.go("home");
                            $rootScope.$broadcast("REFRESH");
                            return;
                        } else {
                            ClearLocalStorageService.setInitDataCPRWorkflow(true);
                            return response;
                        }
                    });
                }],
            }
        });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('CarePlanReviewWorkflowService', CarePlanReviewWorkflowService);

    CarePlanReviewWorkflowService.$inject = ['$resource', '$http', '$q', 'DownloadBlobService'];

    function CarePlanReviewWorkflowService ($resource, $http, $q, DownloadBlobService) {
        var resourceUrl = "api/care-plan-review-workflow";
        var service = $resource(resourceUrl, {}, {});
        service.getData = getData;
        service.updateTimeSpent = updateTimeSpent;
        service.submit = submit;
        service.downloadLastedCPR = downloadLastedCPR;
        service.skipReviewCPR = skipReviewCPR;
        service.clearCprQueue = clearCprQueue;
        service.trackLogsCpr = trackLogsCpr;
        service.checkValidationCPRCase = checkValidationCPRCase;

        function getData(patientId, cprId, notInitialized) {
            var deferred = $q.defer();
            $http.get(resourceUrl + '/get-data', {params: {patientId: patientId,
                    cprId: cprId,
                    notInitialized: notInitialized}})
                .success(function (response) {
                    deferred.resolve(response);
                }).error(function (error, response) {
                    deferred.resolve(response);
                });
            return deferred.promise;
        }

        function updateTimeSpent(data) {
            return $http.post(resourceUrl + '/update-time-spent', data).then(function (response) {
                return response;
            });
        };

        function submit(data) {
            return $http.post(resourceUrl + '/submit', data).then(function (response) {
                return response;
            });
        };

        function clearCprQueue(data) {
            var url = resourceUrl + "/clear-cpr-queue";
            return $http.post(url, data).then(function (response) {
                return response;
            });
        }

        function trackLogsCpr(requestData) {
            var url = resourceUrl + "/track-logs-cpr";
            return $http.post(url, JSON.stringify(requestData)).then(function (response) {
                return response;
            });
        }

        function downloadLastedCPR(previousId) {
            var deferred = $q.defer();
            var url = 'api/care-plan-review/download/' + previousId;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentDisposition = headers('content-disposition');
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    var fileName = DownloadBlobService.getFileName(contentDisposition);
					saveAs(blob, fileName);
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function skipReviewCPR(data){
            return $http.post(resourceUrl + '/skip-review', data).then(function (response) {
                return response;
            });
        }

        function checkValidationCPRCase(cprCase) {
            var deferred = $q.defer();
            $http.post(resourceUrl + '/check-validation-cpr-case', cprCase)
                .success(function (response) {
                    deferred.resolve(response);
                }).error(function (error, response) {
                    deferred.resolve(response);
                });
            return deferred.promise;
        }

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CarePlanReviewWorkflowController', CarePlanReviewWorkflowController);

    CarePlanReviewWorkflowController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'cprEntity', 'CarePlanReviewWorkflowService', 'ClearLocalStorageService', 'ipmConstants', '$interval', '$localStorage', '$timeout', '$uibModal', '$uibModalStack', '$window', 'Principal', '$filter', 'DateUtils', 'WebWorkerService'];

    function CarePlanReviewWorkflowController($rootScope, $scope, $state, Auth, cprEntity, CarePlanReviewWorkflowService, ClearLocalStorageService, constants, $interval, $localStorage, $timeout, $uibModal, $uibModalStack, $window, Principal, $filter, DateUtils, WebWorkerService) {
        var vm = this;
        vm.isSaving = false;
        vm.submit = submit;
        vm.cprEntity = cprEntity;
        vm.timeSpentChange = timeSpentChange;
        vm.saveAndLater = saveAndLater;
        vm.duration = 0; // used to calc display timeSpent
        vm.isShowSignaturePad = true;
        vm.isInvalidTimespentToSubmit = isInvalidTimespentToSubmit;
        vm.isInvalidTimespent = true; // used for faster checking disable submit button
        vm.getCssTimeSpent = getCssTimeSpent;
        vm.isOpenningErrorDialog = false;

        var CONSERVATIVE_CARE = constants.STATUS_INDICATORS[0];
        var INTERVENTIONS = constants.STATUS_INDICATORS[1];
        var EVALUATION_MDE = constants.STATUS_INDICATORS[2];
        var PAIN_PROGRAM = constants.STATUS_INDICATORS[3];

        // auto save and logs people out after 15 mins.  
        vm.minutesLogoffTimer = 15;
        vm.secondsToSectionTimeout = 30;
        vm.remainingSecondsToSectionTimeout = 30;

        vm.statusIndicators = [{ value:  CONSERVATIVE_CARE}, { value:  INTERVENTIONS}, { value:  EVALUATION_MDE}, { value:  PAIN_PROGRAM}];
        vm.isDislayTimer = true;
        vm.submittedCPR = false;
        vm.invalidOpenVisitDateChange = false;
        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.isOpenVisitDate = false;
        vm.datePickerOptions = {
            maxDate: new Date()
        };
        vm.deletedCases = [];
        vm.signatureData = null;
        vm.isShowPatientCaseError = false;
        vm.patientCasesExists = [];

        vm.openVisitDateChange = openVisitDateChange;
        vm.checkInValidBillTo = checkInValidBillTo;

        init();

        function init() {
            initWorkerServiceCPR();

            if (vm.cprEntity) {
                if (vm.cprEntity.adHoc) { // update for addHoc
                    vm.isShowSignaturePad = (vm.cprEntity.signatureAdHoc && vm.cprEntity.signatureAdHoc.data) ? false : true;
                    vm.signatureData = vm.cprEntity.signatureAdHoc && vm.cprEntity.signatureAdHoc.data ? vm.cprEntity.signatureAdHoc.data : null;
                } else {
                    vm.isShowSignaturePad = (vm.cprEntity.signatureId && vm.cprEntity.signatureData) ? false : true
                    vm.signatureData = vm.cprEntity.signatureData;
                }
            }
            vm.submittedCPR = false;
            vm.isOpenningErrorDialog = false;
            var dataCPR = ClearLocalStorageService.getPatientIdForCPRWorkflow();
            vm.patientId = dataCPR ? dataCPR.patientId : null;
            ClearLocalStorageService.setTimeCPRLogin(moment());
            if (!ClearLocalStorageService.getTimeSpentCPR()) {
                ClearLocalStorageService.setTimeSpentCPR(moment()); // set now
                startRunTimeSpent(); // start the first time will set timeSpentLogin = now
            } else {
                updateTimeSpent(constants.TIME_SPENT_TYPE.UPDATE_TIMESPENT, true); // page reload, update timeSpent
            }

            setDuration();
            vm.mapSectionAnswers = new Map();

            if (vm.cprEntity.values) {
                vm.mapSectionValues = new Map(Object.entries(vm.cprEntity.values));
            } else {
                vm.mapSectionValues = new Map();
            }

            vm.allAnswers = new Map(); // to check display question
            _.forEach(vm.cprEntity.sections, function(section) {
                _.forEach(section.answers, function(value, key) {
                    vm.allAnswers.set(key, value);
                })
            });

            vm.allPreviousAnswers = new Map(); // to check display question
            if (vm.cprEntity.previous) {
                _.forEach(vm.cprEntity.previous.sections, function(section) {
                    _.forEach(section.answers, function(value, key) {
                        vm.allPreviousAnswers.set(key, value);
                    })
                });
            }
            if (vm.cprEntity.previous) {
                var previousValues =  new Map(Object.entries(vm.cprEntity.previous.values));
                vm.surgicalCandidacyStatus = previousValues.get(constants.CPR_MAP_KEY_VALUES[1]);
            }


            vm.getCssTimeSpent(vm.duration);
            setLastOfficeVisitDate();
        }

        function setLastOfficeVisitDate() {
            if (!vm.cprEntity.lastOfficeVisitDate) {
                vm.cprEntity.lastOfficeVisitDate = new Date();
            } else {
                vm.cprEntity.lastOfficeVisitDate = DateUtils.convertLocalDateFromServer(vm.cprEntity.lastOfficeVisitDate);
            }
        }

        function openVisitDateChange(formField) {
            if (vm.cprEntity.lastOfficeVisitDate) {
                setValidityLastOfficeVisitDate(formField);
            }
        }

        function filterDate(dateValue) {
            if (dateValue) {
                return $filter('date')(dateValue, vm.dateFormatToServer);
            }
        }

        function setValidityLastOfficeVisitDate(formField) {
            vm.invalidOpenVisitDateChange = moment(vm.cprEntity.lastOfficeVisitDate).isAfter(new moment());
            formField.$setValidity('errorMaxDate', !vm.invalidOpenVisitDateChange);
        }

        function resetLogoffInterval() {
            vm.remainingSecondsToSectionTimeout = vm.secondsToSectionTimeout; // update remainingSeconds to default
            WebWorkerService.resetLogoffInterval();
            WebWorkerService.resetNoticingLogoffInterval();
            ClearLocalStorageService.setTimeCPRLogin(moment());
        }

        function timeSpentChange() {
            vm.duration = vm.cprEntity && vm.cprEntity.timeSpent > vm.duration ? vm.cprEntity.timeSpent : vm.duration;
            vm.duration += 1;
            vm.isInvalidTimespent = isInvalidTimespentToSubmit();
            $scope.$digest();
        }

        function sectionTimeoutDiaglogInterval() {
            vm.openSectionTimeoutDiaglog();
        }
        
        vm.handleSectionAnswerChange = function(data) {
            if (data) {
                resetLogoffInterval();
                var convertMapAnswer = Object.fromEntries(data.answer);
                vm.mapSectionAnswers.set(data.section.id, {id: data.section.id, value: JSON.stringify(convertMapAnswer)});

                _.forEach(convertMapAnswer, function(value, key) {
                    vm.allAnswers.set(key, value);
                })
            }
        }

        vm.handleSectionValuesChange = function(data) {
            if (data) {
                resetLogoffInterval();
                vm.mapSectionValues.set(data.key, data.value);
            }
        }

        vm.onChangeMouseMove = function (position) {
            if (position)
                resetLogoffInterval();
        };

        function clearShowPatientCaseError() {
            vm.isShowPatientCaseError = false;
        }
        function saveAndLater() {
            vm.submit(false);
        }

        function submit(completeAll) {
            if (completeAll === true) {
                checkValidationAndSubmitCPR(completeAll);
            } else {
                submitCPR(completeAll);
            }
            clearShowPatientCaseError();
        }

        function checkValidationAndSubmitCPR(completeAll) {
            vm.isShowPatientCaseError = false;
            vm.patientCasesExists = [];
            var cprWorkflowRequest = {
                id: cprEntity.cprId,
                cases: cprEntity.cases
            };
            CarePlanReviewWorkflowService.checkValidationCPRCase(cprWorkflowRequest).then(function (res) {
                if (res && res.length > 0) {
                    // Handle validation errors or show an error message
                    // showErrorCheckValidationCprCase();
                    vm.isShowPatientCaseError = true;
                    vm.patientCasesExists = res;
                } else {
                    vm.submittedCPR = true;
                    submitCPR(completeAll);
                    vm.isShowPatientCaseError = false;
                }
            });
        }

        function submitCPR(completeAll) {
            if (completeAll && vm.isInvalidTimespentToSubmit()) { // check time-spent > 31m
                return;
            }
            clearIntervalWorkerCPR();
            // push data to server
            pushDataToServer(completeAll, false);
        }

        function pushDataToServer(completeAll, autoSave) {
            if (vm.submittedCPR === true && completeAll === false) { // return if CPR has submitted && completeAll is false
                return;
            }
            if (vm.isSaving === true && completeAll === false && autoSave !== null) { // only check with autoSave without submitted, ignore logout
                return;
            }
            vm.isSaving = true;

            var listSection = [];
            angular.forEach(vm.mapSectionAnswers, function(value, key) {
                listSection.push({ id: value.id, value: value.value });
            });

            var convertMapValues = Object.fromEntries(vm.mapSectionValues);

            var dataRequest = {
                completeAll: completeAll,
                patientId: vm.patientId,
                values: JSON.stringify(convertMapValues),
                cprId: vm.cprEntity.cprId,
                sections: listSection,
                openVisitDate: filterDate(vm.cprEntity.lastOfficeVisitDate),
                signatureData: vm.signatureString,
                timeSpentData: { patientId: vm.patientId,
                    timeSpent: vm.duration,
                    timeSpentType: constants.TIME_SPENT_TYPE.UPDATE_TIMESPENT },
                cases: vm.cprEntity.cases,
                deletedCases: vm.deletedCases,
                evaluatedForMDE: vm.cprEntity.evaluatedForMDE,
                evaluatedForPS: vm.cprEntity.evaluatedForPS
            };
            CarePlanReviewWorkflowService.submit(dataRequest).then(function(res) {
                vm.isSaving = false;
                if (autoSave) {
                    ClearLocalStorageService.setTimeSpentCPR(moment()); // set now
                    if (res && res.data && res.data.timeSpent) {
                        vm.cprEntity.timeSpent = res.data.timeSpent;
                        vm.duration = res.data.timeSpent;

                        vm.cprEntity.cases = res.data.cases;
                        vm.deletedCases = []; // rest deletedCases
                        updateCprCases();
                    }
                } else {
                    if(autoSave === undefined || autoSave === null) {
                        logout('Logoff'); // logoff 15 minute interval
                    } else {
                        goBackToList();
                    }
                }
                }, function error(e) {
                    vm.isSaving = false;
                    clearAndShowOpenErrorSubmitDialog()
                }
            );
        }

        function clearAndShowOpenErrorSubmitDialog() {
            if (!vm.isOpenningErrorDialog) {
                // timerStop();
                clearWorkerServiceCPR();
                openErrorSubmitDialog();
                vm.isOpenningErrorDialog = true;
            }
        }

        function openErrorSubmitDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.qhpWorkflow.error.submitCprError.message"},
                    title: function () {return "ipmApp.qhpWorkflow.error.submitCprError.title"}
                }
            }).result.then(function() {
                logout('ErrorSubmit');
            }, function() {
               // logout();
            });
        }

        vm.back = function() {
            if (vm.submittedCPR === true) {
                goBackToList();
            }
            var requestData = { patientId: vm.patientId};
            CarePlanReviewWorkflowService.updateTimeSpent(requestData).then(function() {
                goBackToList();
            });
        }

        function goBackToList() {
            $state.go('care-plan-review');
        }

        vm.onChangeSignature = function(data) {
            resetLogoffInterval();
            vm.signatureString = data;
        }

        function clearWorkerServiceCPR() {
            WebWorkerService.close();
        }

        function clearIntervalWorkerCPR() {
            WebWorkerService.clearLogoffInterval();
            WebWorkerService.clearNoticingLogoffInterval();
        }

        function autoSaveCprToServe() {
            if (document.hidden) {
                setDuration();
            }
            pushDataToServer(false, true);
        }

        function initWorkerServiceCPR() {
            WebWorkerService.activate();
            WebWorkerService.startTimeSpent();
            // startLogoffInterval
            WebWorkerService.startLogoffInterval();
            WebWorkerService.startNoticingLogoffInterval();
            WebWorkerService.getWebWorker().onmessage = function (event) {
                if (event.data == constants.WEB_WORKER.START) {
                    autoSaveCprToServe();
                } else if (event.data == constants.WEB_WORKER.START_TIME_SPENT) {
                    timeSpentChange();
                } else if (event.data == constants.WEB_WORKER.START_LOGOFF_INTERVAL) {
                    logoff();
                } else if (event.data == constants.WEB_WORKER.START_NOTICING_LOGOFF_INTERVAL) {
                    sectionTimeoutDiaglogInterval();
                }
            };
            WebWorkerService.getWebWorker().addEventListener('error', function(event) {
                console.log('CPR Worker is offline');
                openErrorClearCacheDialog();
            });
        }

        vm.openCalendar = function() {
            vm.isOpenVisitDate = !vm.isOpenVisitDate;
        };

        // clear interval
        $scope.$on('$destroy', function iVeBeenDismissed() {
            $uibModalStack.dismissAll(); // close dialog NoticingLogoffInterval when auto logout
            clearIntervalWorkerCPR();
            clearWorkerServiceCPR();
            // clear localstorage
            ClearLocalStorageService.clearPatientIdForCPRWorkflow();
            ClearLocalStorageService.clearTimeCPRLogin();
            clearDataLocalStorage();
            // timerStop();
            // document.removeEventListener('visibilitychange', handleVisibilityChange);
            Principal.identity(false).then(function (account) {
                if (account) {
                    updateTimeSpent(constants.TIME_SPENT_TYPE.UPDATE_AND_RESET_TIMESPENT_LOGIN);
                }
            });
            clearCprQueue();
          });

        vm.getCssStatusIndicator = function(statusIndicator) {
            /**
             * [IPMproject-Q335]
             *      Conservative Care: code: CPR_013 -> YES
             *      Interventions: code CPR_018 -> NO
             *      Evaluation (MDE): code CPR_015 -> YES OR code CPR_038 -> MDE checked
             *      Pain Program: when the QHP enters 1 in Sessions Completed of the Treatment History table for FRP, or 'Authorized' in the status for FRP in the Treatment History table.
             */

            var css = 'status-indicator';
            var cssActive = 'status-indicator-active';
            if (statusIndicator.value === CONSERVATIVE_CARE) {
                if (vm.allAnswers.get('CPR_013') === 'YES') {
                    return cssActive;
                }
            }
            if (statusIndicator.value === INTERVENTIONS) {
                if (vm.allAnswers.get('CPR_018') === 'NO') {
                    return cssActive;
                }
            }
            if (statusIndicator.value === EVALUATION_MDE) {
                if (vm.allAnswers.get('CPR_015') === 'YES') {
                    return cssActive;
                }
                var a = vm.allAnswers.get('CPR_038');
                if (a) {
                    if (!_.isEmpty(_.filter(a, function(b) { return b.value === 'MDE'}))) {
                        return cssActive;
                    }
                }
            }
            if (statusIndicator.value === PAIN_PROGRAM) {
                var a = vm.mapSectionValues.get(constants.CPR_MAP_KEY_VALUES[0])
                if (a) {
                    var z = _.head(_.filter(a, function(b) { return b.treatment === 'FRP'}));
                    if (z) {
                        if (z.sessionsCompleted === "1" || z.status === 'authSentNoResponse') {
                            return cssActive;
                        }
                    }
                }
            }
            return css;
        }

        function getCssTimeSpent(param) {
            var totalSeconds = param ? param : vm.duration;
            var secondWarning = 1860; // 31 minute
            var secondSuccess = 2100; // 35 minute
            if (totalSeconds) {
                if (totalSeconds < secondWarning) {
                    vm.timeSpentClass = 'text-warning';
                } else if (totalSeconds >= secondWarning && totalSeconds < secondSuccess) {
                    vm.timeSpentClass = 'text-success';
                } else {
                    vm.timeSpentClass = 'text-danger';
                }
            }
            return vm.timeSpentClass;
        }

        function isInvalidTimespentToSubmit() {
            return vm.duration < vm.cprEntity.configuration.timerHasElapsed * 60;
        }

        vm.isDisableSaveAndLater = function(form) {
            var errorCount = 0;
            for (var key in form.$error) {
                errorCount += 1;
            }
            if (errorCount > 1) {
                if (form.$error.required && form.$error.minimumValue) {
                    return false;
                }
                return true;
            }
            if (errorCount === 1 && form.$error) {
                if (form.$error.required || form.$error.minimumValue) {
                    return false;
                }
            }
            return errorCount > 0 ? true : false;
        }

        vm.notHaveSignature = function() {
            if (vm.cprEntity && vm.cprEntity.addHoc) {
                return ((vm.cprEntity.signatureAdHoc && vm.cprEntity.signatureAdHoc.data && !vm.isShowSignaturePad) || vm.signatureString) ? false : true;
            }
            return ((vm.cprEntity.signatureId && vm.cprEntity.signatureData && !vm.isShowSignaturePad) || vm.signatureString) ? false : true;
        }

        vm.downloadLastedCPR = function() {
            CarePlanReviewWorkflowService.downloadLastedCPR(vm.cprEntity.previous.cprId).then();
        }

        vm.isShowTimeSpentErrorMessage = function() {
            return vm.isInvalidTimespentToSubmit();
        }

        function setDuration() {
            vm.isDislayTimer = false;
            vm.duration = vm.cprEntity.timeSpent ? vm.cprEntity.timeSpent : 0;
            $timeout(function(){
                vm.isDislayTimer = true;
            }, 500);
        }

        function startRunTimeSpent() {
            updateTimeSpent(constants.TIME_SPENT_TYPE.START_RUN_TIMESPENT);
        }

        function resetTimeSpentLogin() {
            updateTimeSpent(constants.TIME_SPENT_TYPE.RESET_TIMESPENT_LOGIN);

        }

        function updateResetTimeSpentLoginAndLogout(type) {
            if (vm.submittedCPR === true) {
                logoutEvent(type + '-1');
            }
            var requestData = {
                patientId: vm.patientId,
                timeSpentType: constants.TIME_SPENT_TYPE.UPDATE_AND_RESET_TIMESPENT_LOGIN
            };
            CarePlanReviewWorkflowService.updateTimeSpent(requestData).then(function (res) {
                logoutEvent(type + '-2');
            }, function error(e) {
                logoutEvent(type + '-3');
            });
        }

        function clearCprQueue() {
            var requestData = {
                cprId: vm.cprEntity.cprId,
                patientId: vm.patientId
            };
            CarePlanReviewWorkflowService.clearCprQueue(requestData).then(function (res) {
            });
        }

        function updateTimeSpent(timeSpentType, haveShowErrorDialog) {
            if (vm.submittedCPR === true) {
                return;
            }
            var requestData = {
                cprId: vm.cprEntity.cprId,
                patientId: vm.patientId,
                timeSpent: vm.duration,
                timeSpentType: timeSpentType ? timeSpentType : constants.TIME_SPENT_TYPE.UPDATE_AND_RESET_TIMESPENT_LOGIN
            };
            CarePlanReviewWorkflowService.updateTimeSpent(requestData).then(function (res) {
                if (res && res.data) {
                    vm.duration = Number(res.data);
                }
            }, function error(e) {
                if (haveShowErrorDialog && haveShowErrorDialog === true) {
                    clearAndShowOpenErrorSubmitDialog()
                }
            });
        }

        // function calcSecondsTimeSpent() {
        //     var now = moment();
        //     var dateTimeStartCPR = ClearLocalStorageService.getTimeSpentCPR();
        //     if (dateTimeStartCPR) {
        //         // fix issue which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged
        //         var duration = moment.duration(now.diff(moment(new Date(dateTimeStartCPR))));
        //         var durationSeconds = parseInt(duration.asSeconds());
        //         return vm.cprEntity.timeSpent && vm.cprEntity.timeSpent > 0
        //             ? vm.cprEntity.timeSpent + Number(durationSeconds) : durationSeconds;
        //     }
        //     return vm.cprEntity.timeSpent ? vm.cprEntity.timeSpent : 0;
        // }

        function logoff() {
            if (document.hidden) {
                setDuration();
            }
            pushDataToServer(false, null);
            // resetTimeSpentLogin();
        }

        function logout (type) {
            updateResetTimeSpentLoginAndLogout(type)
            // resetTimeSpentLogin();
            // Auth.logout();
            // $state.go('home');
            // clearDataLocalStorage();
            // timerStop();
            // $rootScope.$broadcast(constants.EVT_LOG_OUT);
        }

        function logoutEvent(typeLogout) {
            var requestData = {
                cprId: vm.cprEntity.cprId,
                typeLogout: typeLogout
            };
            CarePlanReviewWorkflowService.trackLogsCpr(requestData).then(function (res) {});
            Auth.logout();
            clearDataLocalStorage();
            clearWorkerServiceCPR();
            $state.go('home');
            $rootScope.$broadcast(constants.EVT_LOG_OUT);
        }

        function clearDataLocalStorage() {
            delete $localStorage.isQuestionnaireIncomplete;
            delete $localStorage.firstIdOfAllNPQQuestionnaireNotComplete;
            delete $localStorage.isQuestionnaireCount;
            ClearLocalStorageService.clearAll();
            ClearLocalStorageService.clearLandingPage();
            ClearLocalStorageService.clearKeepLandingPage();
            ClearLocalStorageService.clearTimeSpent();
            ClearLocalStorageService.clearTimerHasElapsed();
            ClearLocalStorageService.clearTimeSpentCPR();
            ClearLocalStorageService.clearInitDataCPRWorkflow();
        }

        function checkInValidBillTo() {
            var hasChecked = vm.cprEntity.cases.some(function (caseItem) {
                return caseItem && caseItem.billTo;
            });

            var isValid = vm.cprEntity.cases.every(function (caseItem) {
                return caseItem && caseItem.caseNumber; // Check for valid caseNumber
            });
            return !hasChecked || !isValid;
        }

        vm.skipReview = function() {
            $uibModal.open({
                templateUrl: 'app/qhp-workflow/care-plan-review-workflow/skip-review-dialog/skip-dialog.html',
                controller: 'skipDialogController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message confirm-dialog',
                size: 'sm',
                resolve: {
                    patientId: function() {
                        return vm.patientId;
                    }
                }
            })
        }

        vm.openSectionTimeoutDiaglog = function() {
            var isModalOpen = $uibModalStack.getTop() !== undefined;
            if (isModalOpen) {
                $uibModalStack.dismissAll();
            }
            $uibModal.open({
                templateUrl: 'app/qhp-workflow/care-plan-review-workflow/section-timeout-dialog/section-timeout-dialog.html',
                controller: 'sectionTimeoutDialogController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message confirm-dialog',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    remainingSeconds: function() {
                        return vm.remainingSecondsToSectionTimeout;
                    }
                }
            }).result.then(function(isStayLoggedIn) {
                if (!isStayLoggedIn) {
                    logoutEvent('SectionTimeout' + '-4');
                } else {
                    resetLogoffInterval();
                }
            });
            $window.setTimeout(function () {
                $uibModalStack.dismissAll();
            }, vm.remainingSecondsToSectionTimeout * 1000)
            
        }

        function updateCprCases() {
            if (vm.cprEntity.cases) {
                _.forEach(vm.cprEntity.cases, function (item) {
                    item.datePickerOpenStatus = {};
                    item.doi = item.doi ? DateUtils.convertDateTimeFromServer(item.doi) : null;
                });
            }
        }

        function openErrorClearCacheDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.qhpWorkflow.error.clearCache.message"},
                    title: function () {return "ipmApp.qhpWorkflow.error.title"}
                }
            }).result.then(function() {
                goBackToList();
            }, function() {
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PsychIntakeWorkflowController', PsychIntakeWorkflowController);

    PsychIntakeWorkflowController.$inject = ['$scope', '$state', '$translate', '$timeout', '$location', 'Auth', '$uibModal', '$window', 'JhiLanguageService', 'PsychIntakeService', 'psychIntake', 'dataWorkflow', '$localStorage', 'ipmConstants', '$rootScope', 'ClearLocalStorageService'];

    function PsychIntakeWorkflowController($scope, $state, $translate, $timeout, $location, Auth, $uibModal, $window, JhiLanguageService, PsychIntakeService, psychIntake, dataWorkflow, $localStorage, constants, $rootScope, ClearLocalStorageService) {
        var vm = this;

        vm.psychIntake = psychIntake;
        vm.dataWorkflow = dataWorkflow;

        vm.section = vm.dataWorkflow.section;
        vm.template = '';
        vm.datePickerOpenStatus = {
            dateOfInjury: false
        };
        vm.isInvitation = $window.localStorage.getItem(constants.INVITATION_WORKFLOW);
        vm.isLaunchAction = $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID) ? true : false;

        vm.init = function () {
            if (vm.dataWorkflow.action == 'COMPLETE') {
                vm.template = 'app/psych-intake/workflow/partial/thanks.html';
                vm.psychIntake['currentSection'] = {};
            } else {
                vm.template = 'app/psych-intake/workflow/partial/' + vm.dataWorkflow.section.template + '.html';
            }
        }

        vm.next = function () {
            vm.dataWorkflow.action = 'NEXT';
            vm.dataWorkflow.isInvitation = vm.isInvitation;
            vm.dataWorkflow.isLaunchAction = vm.isLaunchAction;
            PsychIntakeService.submitWorkflow(vm.dataWorkflow).then(function (res) {
                vm.dataWorkflow = res;
                vm.updateCurrentSection(res);
            });
        }

        vm.back = function () {
            vm.dataWorkflow.action = 'BACK';
            vm.dataWorkflow.isInvitation = vm.isInvitation;
            vm.dataWorkflow.isLaunchAction = vm.isLaunchAction;
            PsychIntakeService.submitWorkflow(vm.dataWorkflow).then(function (res) {
                vm.dataWorkflow = res;
                vm.updateCurrentSection(res);
            });
        }

        vm.updateCurrentSection = function (workflow) {
            vm.psychIntake.sectionIdsCompleted = workflow.sectionIdsCompleted;
            vm.psychIntake.totalSectionId = workflow.totalSectionId;
            if (workflow.action == 'COMPLETE') {
                vm.template = 'app/psych-intake/workflow/partial/thanks.html';
                vm.psychIntake['currentSection'] = {};
            } else if (workflow.section) {
                vm.template = 'app/psych-intake/workflow/partial/' + workflow.section.template + '.html';
                if (!vm.psychIntake.currentSection) {
                    vm.psychIntake['currentSection'] = workflow.section;
                } else {
                    vm.psychIntake.currentSection.id = workflow.section.id;
                    vm.psychIntake.currentSection.code = workflow.section.code;
                    vm.psychIntake.currentSection.template = workflow.section.template;
                    vm.psychIntake.currentSection.name = workflow.section.name;
                    vm.psychIntake.currentSection.nameLangKey = workflow.section.nameLangKey;
                    vm.psychIntake.currentSection.orderNumber = workflow.section.orderNumber;
                }
            }

            $window.scrollTo(0, 0);
        }

        vm.init();

        vm.nextPsychOrLogout = function () {
            PsychIntakeService.getNotCompleteForm().then(function (res) {
                if (res) {
                    ClearLocalStorageService.clearWorkflow();
                    goToPsychWorkflow();
                } else {
                    ClearLocalStorageService.clearAllAndWorkflow();
                    ClearLocalStorageService.clearLandingPage();
                    goToLandingPage();
                }
            });
        }

        function goToPsychWorkflow() {
            $state.go('psych-intake.workflow', null, { reload: true });
        }

        function goToLandingPage() {
            $state.go('landing-page');
        }

        vm.disabledIfNotSigned = function () {
            var disabled = false;
            if (vm.dataWorkflow.section.code === 'PATIENT_ACKNOWLEDGEMENT' && vm.dataWorkflow.answer.agreement && !vm.dataWorkflow.answer.agreement.patientSignature) {
                disabled = true;
            }
            return disabled;
        }
    }
})();
;
(function (){
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig)

    stateConfig.$inject = ['$stateProvider'];


    function stateConfig($stateProvider) {
        $stateProvider.state('presentation-view-patient', {
            url: '/presentation-view/{csId}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_QHP'],
                pageTitle: 'ipmApp.patient.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/presentation-controls-instructor/presentation-view-patient/presentation-view-patient.html',
                    controller: 'PresentationViewPatientController',
                    controllerAs: 'vm'
                },
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentationControls');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
            }
        })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory(
            'PresentationViewPatientService',
            PresentationViewPatientService
        );

    PresentationViewPatientService.$inject = [
        'ipmConstants',
        '$state',
        '$rootScope',
    ];

    function PresentationViewPatientService(ipmConstants, $state, $rootScope) {
        var viewWindow = null,
            dispatchedEvents = {},
            onScrollEventReceive = function () {};
        var presentationViewUrl = $state.href(
            'presentation-view-patient',
            {},
            {
                absolute: true,
            }
        );
        var services = {
            getWindow: getWindow,
            openPresentationView: openPresentationView,
            listenToOtherSource: listenToOtherSource,
            changePDFdata: changePDFdata,
            changeCurrentPage: changeCurrentPage,
            zoomOut: zoomOut,
            zoomIn: zoomIn,
            sendScrollPosition: sendScrollPosition,
            addChangePageEvent: addChangePageEvent,
            addChangePDFDataEvent: addChangePDFDataEvent,
            addZoomInEvent: addZoomInEvent,
            addZoomOutEvent: addZoomOutEvent,
            addScrollEvent: addScrollEvent,
            closedPresentationView: closedPresentationView
        };
        return services;

        function openPresentationView(targetId, _viewerWidth) {
            viewWindow = window.open(
                presentationViewUrl,
                targetId,
                'width=' +
                    document.body.clientWidth +
                    ',height=' +
                    document.body.clientHeight
            );
            viewWindow.viewerWidth = _viewerWidth;
            $rootScope.$on(ipmConstants.EVT_LOG_OUT, function () {
                viewWindow.close();
            });
            $rootScope.$on('$stateChangeStart', function () {
                viewWindow.close();
            });
        }

        function closedPresentationView() {
            if (viewWindow) {
                viewWindow.close();
            }
        }

        function listenToOtherSource(_sourceUrl) {
            window.addEventListener(
                'message',
                function (event) {
                    var data = event.data;
                    if (event.origin === _sourceUrl) {
                        if (data.scrollPosition !== undefined) {
                            onScrollEventReceive(data.scrollPosition);
                            return;
                        }
                        for (var property in dispatchedEvents) {
                            if (data == property) {
                                dispatchedEvents[property]();
                                return;
                            }
                        }
                    }
                },
                false
            );
        }

        function getWindow() {
            return window;
        }
        // Call Event
        function changeCurrentPage() {
            viewWindow &&
                viewWindow.postMessage(
                    ipmConstants.EVT_GO_TO_PAGE_SLIDE_WC,
                    presentationViewUrl
                );
        }

        function changePDFdata() {
            viewWindow &&
                viewWindow.postMessage(
                    ipmConstants.EVT_CURRENT_SLIDE_WC,
                    presentationViewUrl
                );
        }

        function zoomIn() {
            viewWindow &&
                viewWindow.postMessage(
                    ipmConstants.EVT_ZOOM_IN_SLIDE_WC,
                    presentationViewUrl
                );
        }

        function zoomOut() {
            viewWindow &&
                viewWindow.postMessage(
                    ipmConstants.EVT_ZOOM_OUT_SLIDE_WC,
                    presentationViewUrl
                );
        }

        function sendScrollPosition(position) {
            viewWindow && viewWindow.postMessage(position, presentationViewUrl);
        }
        // Add Event Function
        function addEventAction(name, action) {
            if (typeof action === 'function') {
                dispatchedEvents[name] = action;
            }
        }

        function addChangePageEvent(action) {
            addEventAction(ipmConstants.EVT_GO_TO_PAGE_SLIDE_WC, action);
        }

        function addChangePDFDataEvent(action) {
            addEventAction(ipmConstants.EVT_CURRENT_SLIDE_WC, action);
        }

        function addZoomInEvent(action) {
            addEventAction(ipmConstants.EVT_ZOOM_IN_SLIDE_WC, action);
        }

        function addZoomOutEvent(action) {
            addEventAction(ipmConstants.EVT_ZOOM_OUT_SLIDE_WC, action);
        }

        function addScrollEvent(action) {
            onScrollEventReceive = action;
        }
    }
})();
;
(function () {
    "use strict";

    angular
        .module("ipmApp")
        .controller(
            "PresentationViewPatientController",
            PresentationViewPatientController
        );

    PresentationViewPatientController.$inject = [
        "$scope",
        "PresentationViewPatientService",
        "ClearLocalStorageService",
        "$window",
        "Deck",
        "ipmConstants"
    ];

    function PresentationViewPatientController(
        $scope,
        PresentationViewPatientService,
        ClearLocalStorageService,
        $window,
        Deck,
        ipmConstants
    ) {
        var vm = this;
        var scaleRate = 1; // presentation view height size / instructor view height size (%)
        var pdfContainer = angular.element(".presentation-view-content");
        vm.zoomToScale = 1;
        vm.pdfCurrentSlide = 1;
        vm.pdfData = null;
        vm.isLoading = false;
        vm.className = ClearLocalStorageService.getNameClassPresentationView();
        vm.init = function () {
            var source = $window.location.origin;
            calculateScaleRate();
            getPDFdata();
            PresentationViewPatientService.listenToOtherSource(source);
            PresentationViewPatientService.addChangePageEvent(changePage);
            PresentationViewPatientService.addChangePDFDataEvent(getPDFdata);
            PresentationViewPatientService.addZoomInEvent(zoomIn);
            PresentationViewPatientService.addZoomOutEvent(zoomOut);
            PresentationViewPatientService.addScrollEvent(scrollView);
            closingWindowEvent();
        };
        vm.init();

        function calculateScaleRate() {
            var pdfViewer = angular.element('.presentation-view-content');
            scaleRate = pdfViewer != undefined ? pdfViewer.width() / ($window.viewerWidth || 1) : 1;
        }

        function closingWindowEvent() {
            $window.onbeforeunload = function (e) {
                e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                e.returnValue = ''; // Chrome requires returnValue to be set
            };
        }

        function changePage() {
            vm.pdfCurrentSlide =
                ClearLocalStorageService.getCurrentPagePdfViewSlide();
            vm.zoomToScale =

                ClearLocalStorageService.getScaleZoomIn() ||
                ClearLocalStorageService.getScaleZoomOut(); //Task: change to Zoom TO
            $scope.$digest();
        }

        function getPDFdata() {
            var id = ClearLocalStorageService.getCurrentSlideWC();
            if (!id) {
                return;
            }
            vm.pdfData = null;
            Deck.downloadSlideBlobFile(id)
                .then(function (response) {
                    vm.pdfData = response ? response : null;
                    vm.pdfCurrentSlide = 1;
                    vm.isLoading = false;
                    setTimeout(function () {
                        vm.zoomToScale = ipmConstants.PDF_DEFAULT_SCALE * scaleRate;
                    }, 0);
                })
                .catch(function () {
                    vm.isLoading = false;
                });
        }

        function zoomIn() {
            vm.zoomToScale = +ClearLocalStorageService.getScaleZoomIn() * scaleRate;
            $scope.$digest();
        }

        function zoomOut() {
            vm.zoomToScale = +ClearLocalStorageService.getScaleZoomOut() * scaleRate;
            $scope.$digest();
        }

        function scrollView(position) {
            pdfContainer.scrollTop(position.top * scaleRate);
            pdfContainer.scrollLeft(position.left * scaleRate);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('PatientPresentationService', PatientPresentationService);

    PatientPresentationService.$inject = ['$resource', '$http', '$q'];

    function PatientPresentationService ($resource, $http, $q) {
        var baseURL = "api/patient-presentation";

        var service = {
            submitResponse: submitResponse,
        };

        function submitResponse(patientPresentation) {
            return $http.post(baseURL + '/submit-response', patientPresentation).then(function (resp) {
                return resp.data;
            });
        };

        return service;
    };
})();
;
(function() {
    'use strict';


    PresentationPatientResponseManagementController.$inject = ['$scope', '$state', '$window', 'ipmConstants'];

    function PresentationPatientResponseManagementController($scope, $state, $window, constants) {
        var vm = this; //jshint ignore:line

        vm.accordionStatus = {};
        vm.patientPresentations = [];
        vm.expandAllClick = expandAllClick;
        vm.onChangePatientPresentation = onChangePatientPresentation;
        vm.isExpandAll = true;
        vm.isChangePatientPresentation = false;
        vm.countPP = 0;
        vm.isShowingAbsentPatients = false;
        vm.sortableOptions = {
            items: '.patient-card-drag-area',
            update: function (e, ui) {

            },
            stop: function (e, ui) {
               var patientPresentations = ui.item.sortable.sourceModel;
               //  patientPresentations.forEach(function (presentationPatient, index) {
               //      presentationPatient.orderNumber = (index + 1);
               //  });
               // vm.patientPresentations = patientPresentations;
                emitOnchangeDrapDrop(patientPresentations);
            }
        };
        init();

        function init() {
            vm.isManagerTemplate = vm.isManagerTemplate ? vm.isManagerTemplate : false;
            vm.isSummaryTemplate = vm.isSummaryTemplate ? vm.isSummaryTemplate : false;
            vm.accordionStatus = {};
            vm.countPP = vm.countPP ? vm.countPP : 0;
            vm.isShowResponseOpen = vm.isShowResponseOpen ? vm.isShowResponseOpen : false;
            vm.slides = vm.slides ? vm.slides : [];
            filterPatientPresentations();
            if (vm.patientPresentations.length > 0) {
                setcountPP();
                // default expand all for presentationStatus PRESENT
                if (vm.presentationStatus === 'PRESENT') {
                    expandAllList(vm.isExpandAll);
                }
            }
        }

        function setcountPP() {
            vm.countPP = vm.patientPresentations ? vm.patientPresentations.length : 0;
        }

        function filterPatientPresentations() {
            if (vm.presentationStatus
                && vm.wellnessClass.instructorPatientPresentation
                && vm.wellnessClass.instructorPatientPresentation.patientPresentations) {
                vm.patientPresentations = _.filter(vm.wellnessClass.instructorPatientPresentation.patientPresentations, function (item) {
                    return item.presentationStatus == vm.presentationStatus;
                });
            }
        }
        function expandAllClick() {
            expandAllList(vm.isExpandAll);
        }

        function expandAllList(isExpand) {
            vm.patientPresentations.forEach(function (patientPresentation) {
                vm.accordionStatus[patientPresentation.patient.id] = isExpand;
            });
            vm.isExpandAll = !isExpand;
        }

        function emitOnchangeDrapDrop(patientPresentations) {
            vm.onChange({patientPresentations: patientPresentations});
        }

        function emitOnChangeReload(value) {
            vm.reloadChangeList({value: value});
        }

        function onChangePatientPresentation(patientPresentation) {
            if (patientPresentation && vm.wellnessClass.instructorPatientPresentation && vm.wellnessClass.instructorPatientPresentation.patientPresentations) {
                var indexPP = findIndexPatientPresentations(patientPresentation);
                // update patientPresentations list
                if (indexPP > -1) {
                    vm.wellnessClass.instructorPatientPresentation.patientPresentations[indexPP] = patientPresentation;
                }
            }
        }

        function findIndexPatientPresentations(patientPresentation) {
            return _.findIndex(vm.wellnessClass.instructorPatientPresentation.patientPresentations, function(item) {
                return item && item.id === patientPresentation.id;
            });
        }

        $scope.$watch('vm.isChangePatientPresentation', function (newValue) {
            emitOnChangeReload(true);
        });

        $scope.$watch('vm.isReloadChange', function (newValue) {
            filterPatientPresentations();
            setcountPP();
        });
    }

    angular.module('ipmApp').component('presentationPatientResponseManagement', {
        bindings: {
            wellnessClass: '=',
            deck: '=',
            slide: '=',
            isReloadChange: '<',
            presentationStatus: '<',
            showExpandAll: '<',
            showPatientNotPresentsLabel: '<',
            isDisableDrapDrop: '<',
            isShowResponseOpen: '<',
            isManagerTemplate: '<',
            isSummaryTemplate: '<',
            isSavingDrapChange : '<',
            slides: '<',
            onChange: '&',
            reloadChangeList: '&',
            isShowAttendanceOpen: '<'
        },
        templateUrl: 'app/presentation-controls-instructor/presentation-patient-response/presentation-patient-response-management.html',
        controller: PresentationPatientResponseManagementController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    ClassSessionRegistrationController.$inject = ['$scope', 'ClassSessionRegistrationService'];

    function ClassSessionRegistrationController($scope, ClassSessionRegistrationService) {
        var vm = this; //jshint ignore:line
        vm.classSessionRegistrations = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'course.name';
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };
            if (vm.patientId) {
                ClassSessionRegistrationService.getRegisteredCourses(vm.patientId, pageable).then(function (response) {
                    vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                    vm.classSessionRegistrations = response ? response.data : [];
                });
            }
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'id') {
                result.push('id' + ',' + (vm.reverse ? 'desc' : 'asc'));
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }
    }

    angular.module('ipmApp').component('classSessionRegistration', {
        bindings: {
            patientId: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/wellness-class/class-session-registration.html',
        controller: ClassSessionRegistrationController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('classSessionRegistration');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ClassSessionRegistrationDeleteController', ClassSessionRegistrationDeleteController);

    ClassSessionRegistrationDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClassSessionRegistrationService'];

    function ClassSessionRegistrationDeleteController($uibModalInstance, entity, ClassSessionRegistrationService) {
        var vm = this;

        vm.classSessionRegistrationId = entity ? entity.id : null;
        vm.wellnessClassName = entity && entity.classSession && entity.classSession.wellnessClass ? entity.classSession.wellnessClass.name : '';

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.isDeleting = false;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            vm.isDeleting = true;
            if (vm.classSessionRegistrationId) {
                ClassSessionRegistrationService.delete({id: vm.classSessionRegistrationId},
                    function () {
                        $uibModalInstance.close(true);
                    });
            }
        }

    }
})();
;

(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ClassSessionRegistrationAddDialogController', ClassSessionRegistrationAddDialogController);

        ClassSessionRegistrationAddDialogController.$inject = ['$stateParams', '$state', '$uibModalInstance','entity', 'courses', 'ipmConstants', 'ClassSessionRegistrationService'];

    function ClassSessionRegistrationAddDialogController ($stateParams, $state, $uibModalInstance, entity, courses, constants, ClassSessionRegistrationService) {
        var vm = this;
        vm.classSessionRegistration = entity;
        vm.courses = courses ? courses : [];
        vm.wellnessClassCurrent = null;

        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.courseChange = courseChange;
        vm.registerClick = registerClick;
        vm.isMaximumNumberRegister = isMaximumNumberRegister;

        init();

        function init() {
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.classSessionRegistration) {
                if (vm.classSessionRegistration.id !== null) {
                    ClassSessionRegistrationService.update(vm.classSessionRegistration, onSaveSuccess, onSaveError);
                } else {
                    ClassSessionRegistrationService.save(vm.classSessionRegistration, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                vm.error = 'ERROR';
                $uibModalInstance.close(error);
            }
        }

        function registerClick(classSessions) {
            if (classSessions && !isMaximumNumberRegister(classSessions)) {
                vm.classSessionRegistration.classSession = classSessions;
                this.save();
            }
        }

        function courseChange() {
            var courseSelected = _.find(vm.courses, function(c) { return c.id === vm.classSessionRegistration.course.id; });
            setNextClass(courseSelected);
        }

        function setNextClass(courseSelected) {
            if (courseSelected) {
                vm.wellnessClassCurrent = getTheFirstWellnessClasses(courseSelected)
            } else { // reset wellnessClassCurrent
                vm.wellnessClassCurrent = null;
            }
        }

        function getTheFirstWellnessClasses(courseSelected) {
            return courseSelected.wellnessClasses && courseSelected.wellnessClasses.length > 0 ? courseSelected.wellnessClasses[0] : null;
        }

        function isMaximumNumberRegister(classSession) {
            if (classSession && (classSession.numOfRegistered >= constants.MAXIMUM_NUMBER_REGISTER)) {
                return true;
            }
            return false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('OptedOutHAQTestDialogController', OptedOutHAQTestDialogController);

    OptedOutHAQTestDialogController.$inject = ['$uibModalInstance', 'patientCase'];

    function OptedOutHAQTestDialogController($uibModalInstance, patientCase) {
        var vm = this;
        vm.exclusionReason = '';

        // Public Functions
        vm.yes = yes;
        vm.no = no;

        function yes() {
            var patientExclusionReason = {
                exclusionReason: vm.exclusionReason,
                patientCase: patientCase
            };
            $uibModalInstance.close(patientExclusionReason);
            $uibModalInstance.dismiss('cancel');
        }

        function no() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('InputPatientCaseDialogController', InputPatientCaseDialogController);

    InputPatientCaseDialogController.$inject = ['$uibModalInstance', '$uibModal', 'PatientService', '$q', 'SurveyResultService', 'surveyResultId', 'patientId'];

    function InputPatientCaseDialogController($uibModalInstance, $uibModal, PatientService, $q, SurveyResultService, surveyResultId, patientId) {
        var vm = this;

        // Variables
        vm.searchResultEle = null;
        vm.patientId = patientId || null;
        vm.patientCases = [];
        vm.patientCaseSelect = null;
        vm.searchText = '';
        vm.predicate = 'id';
        vm.pageSize = 15;
        vm.loadedData = false;

        vm.modalLoaded = modalLoaded;
        vm.clear = clear;
        vm.clickOk = clickOk;
        vm.checkValidInputCase = checkValidInputCase;
        vm.searchPatientCase = searchPatientCase;
        vm.checkCaseHasBeenOptedOut = checkCaseHasBeenOptedOut;
        vm.updateSearchText = updateSearchText;

        // Initialize the controller
        init();

        function init() {
            searchPatientCase();
        }


        function modalLoaded() {
            vm.searchResultEle = angular.element("#searchEnrollPatientAutoComplete");
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function clickOk() {
            var haqTestServiceExclusion = vm.patientCaseSelect && vm.patientCaseSelect.billableConfig && vm.patientCaseSelect.billableConfig.haqTestServiceExclusion ? vm.patientCaseSelect.billableConfig.haqTestServiceExclusion : false;
            // IPMproject-Q627: We are going to remove the WHOLE "override" process. So if a HAQ_test flag is turned on
            // if (vm.searchText && vm.patientCaseSelect && vm.patientCaseSelect.id && haqTestServiceExclusion) {
            //     openDialogOptedOutHAQTest();
            // } else
            if (vm.patientCaseSelect && !haqTestServiceExclusion) { // save CaseSelected && continue
                saveCaseSelected();
            } else { // not selected case
                openConfirmDialog();
            }
        }

        function checkValidInputCase() {
            if (vm.patientCaseSelect) {
                return vm.patientCaseSelect.id
                    && vm.patientCaseSelect.billableConfig
                    && !vm.patientCaseSelect.billableConfig.haqTestServiceExclusion;
            }
            return true;
        }

        function checkCaseHasBeenOptedOut() {
            return vm.patientCaseSelect && vm.patientCaseSelect.id
                && vm.patientCaseSelect.billableConfig
                && vm.patientCaseSelect.billableConfig.haqTestServiceExclusion;
        }

        function openConfirmDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/confirm-dialog/confirm-yes-no-dialog.controller.html',
                controller: 'ConfirmYesNoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    title: function () {
                        return '';
                    },
                    isTranslate: function () {
                        return true;
                    },
                    message: function () {
                        return 'ipmApp.patient.patientCase.messageNotSelectedACase';
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    saveCaseSelected(null);
                }
            });
        }

        // We are going to remove the WHOLE "override" process. So if a HAQ_test flag is turned on
        /*function openDialogOptedOutHAQTest() {
            $uibModal.open({
                templateUrl: 'app/patient/input-patient-case-dialog/opted-out-haq-test-dialog.html',
                controller: 'OptedOutHAQTestDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    patientId: function () {
                        return patientId;
                    },
                    patientCase: function () {
                        return vm.patientCaseSelect;
                    }
                }
            }).result.then(function (result) {
                if (result && result.patientCase && result.exclusionReason) { // result = patientExclusionReason
                    saveCaseSelected(result);
                }
            });
        }*/

        function saveCaseSelected(patientExclusionReason) {
            vm.isSaving = true;
            var patientCaseRequest = {
                id: vm.patientCaseSelect ? vm.patientCaseSelect.id : null,
                surveyResultId: surveyResultId,
                patientExclusionReason: patientExclusionReason ? patientExclusionReason : null
            };
            SurveyResultService.savePatientCaseSelected(surveyResultId, patientCaseRequest)
                .then(onSaveSuccess)
                .catch(onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
            vm.clear();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            $uibModalInstance.close(error);
        }

        vm.searchTextOnChange = function () {
            vm.searchText = null;
        };

        vm.clearPatientCaseSelection = function() {
            if (vm.patientCaseSelect) {
                vm.patientCaseSelect = null;
            }
        };

        function updateSearchText(searchText) {
            vm.searchText = searchText ? searchText : null;
        }

        function searchPatientCase($item) {
            vm.searchText = $item ? $item : '';
            var pageable = {
                page: 0,
                size: vm.pageSize,
                sort: sort()
            };

            return $q(function (resolve, reject) {
                PatientService.searchPatientCase(patientId, vm.searchText, false, pageable)
                    .then(function (response) {
                        if (response && response.length > 0) {
                            resolve(response);
                            vm.patientCases = response;
                        } else {
                            resolve([]);
                        }
                        vm.loadedData = true;
                    }, function () {
                        reject([]);
                    });
            });
        }

        function sort() {
            var result = [vm.predicate + ',desc'];
            return result;
        }
    }
})();
;
(function() {
    'use strict';

    PatientHaqEvaluationsController.$inject = ['$scope', 'HAQEvaluationWorkflowService', '$translate'];

    function PatientHaqEvaluationsController($scope, HAQEvaluationWorkflowService, $translate) {
        var vm = this; //jshint ignore:line

        vm.haqEvaluations = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'surveyResult.id';
        vm.loadAll = loadAll;

        init();

        function init() {
            vm.pageableHaq = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            HAQEvaluationWorkflowService.findByPatientPaganition(vm.patientId, pageable).then(function (response) {
                if (response) {
                    vm.haqEvaluations = response.data;
                    vm.pageableHaq.totalItems = response.totalItems;
                    vm.isLoading = false;
                }
            });
        }

        vm.loadPage = function (page) {
            vm.page = page;
            vm.loadAll();
        }

        vm.getIndex = function(index) {
        	var result = (index + 1) + (vm.page - 1) * vm.pageSize;
        	return result;
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

    }

    angular.module('ipmApp').component('patientHaqEvaluations', {
        bindings: {
            patientId: '<',
            isManager: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/haq-evaluations/haq-evaluations.html',
        controller: PatientHaqEvaluationsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    PatientCprReportsController.$inject = ['$scope', 'CarePlanReviewService', '$translate', 'ipmConstants'];

    function PatientCprReportsController($scope, CarePlanReviewService, $translate, constants) {
        var vm = this; //jshint ignore:line

        vm.carePlanReviews = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'id';
        vm.loadAll = loadAll;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            CarePlanReviewService.findAllByPatientId(vm.patientId, pageable).then(function (response) {
                if (response) {
                    vm.carePlanReviews = response.data;
                    vm.pageableAP.totalItems = response.totalItems;
                    vm.isLoading = false;
                }
            });
        }

        vm.loadPage = function (page) {
            vm.page = page;
            vm.loadAll();
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        vm.formatAndUpdateStatus = function (cpr) {
            if (cpr && cpr.isSkippingReview) { // status SKIPPED
                return $translate.instant('ipmApp.carePlanReviewStatus.' + 'SKIPPED');
            } else if (cpr && cpr.status) {
                return $translate.instant('ipmApp.carePlanReviewStatus.' + cpr.status);
            } else if (cpr.completedDatePrevious) {
                var lastCompletedDateMinus = new moment().subtract(constants.DAYS_PREVIOUS_CPR_COMPLETED, 'days');
                if (lastCompletedDateMinus.isAfter(cpr.completedDatePrevious)) {
                    cpr.status = 'NOT_STARTED'; // update temp status
                    return $translate.instant('ipmApp.carePlanReviewStatus.NOT_STARTED');
                } else {
                    cpr.status = 'NOT_READY'; // update temp status
                    return $translate.instant('ipmApp.carePlanReviewStatus.NOT_READY');
                }
            } else if (!cpr.status && !cpr.completedDatePrevious) {
                cpr.status = 'NOT_STARTED'; // update temp status
                return $translate.instant('ipmApp.carePlanReviewStatus.NOT_STARTED');
            }
            return '';
        }
    }

    angular.module('ipmApp').component('patientCprReports', {
        bindings: {
            patientId: '<'
        },
        templateUrl: 'app/patient/cpr-reports/cpr-reports.html',
        controller: PatientCprReportsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    BatteryTestingListController.$inject =
        ['$scope',
            'SurveyResultService',
            '$window',
            'PatientService',
            'ipmConstants',
            '$state',
            'InvitationService'
        ];

    function BatteryTestingListController(
        $scope,
        SurveyResultService,
        $window,
        PatientService,
        constants,
        $state,
        InvitationService
    ) {
        var vm = this; //jshint ignore:line
        vm.surveyResults = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'id';
        vm.isSendingInvitation = false;
        vm.loadAll = loadAll;
        vm.resendHAQBattery = resendHAQBattery;
        vm.isDisableLaunchResendHAQBattery = isDisableLaunchResendHAQBattery;

        init();

        function init() {
            vm.isManager = vm.isManager ? vm.isManager : false;
            vm.pageableHaq = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            SurveyResultService.findByPatientPaganition(vm.patientId, constants.SURVEY_RESULT_TYPE_BATTERY, pageable).then(function (response) {
                vm.pageableHaq.totalItems = response.totalElements;
                vm.isLoading = false;
                if (response.content !== undefined) {
                    vm.surveyResults = response.content;
                } else {
                    vm.surveyResults = [];
                }
            });
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function lunchHAQPatientAutoLogin(haqBattery) {
            if (!haqBattery.patientId || !haqBattery.id) {
                return;
            }
            PatientService.getPatientByIdAndAutoLogin(haqBattery.patientId, haqBattery.id).then(function (res) {
                $window.localStorage.setItem(constants.SURVEY_RESULT_ID, haqBattery.id);
                $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                $window.localStorage.setItem(constants.LAUNCH_FROM, constants.HAQ_BATTERY);
                $state.go('home');
            });
        }

        function resendHAQBattery(sr){
            if (vm.isSendingInvitation === true || isDisableLaunchResendHAQBattery(sr)) {
                return;
            }
            var surveyResultId = sr.id;

            vm.isSendingInvitation = true;
            InvitationService.resendHAQ(surveyResultId).then(function (res) {
                vm.isSendingInvitation = false;
                if (res.statusCode === 200) {
                    _.forEach(vm.surveyResults, function(s) {
                        if (s.id === surveyResultId && s.status === 'INCOMPLETE') {
                            s.status = 'STARTED';
                        } else if (s.id === surveyResultId && s.status === 'NO_RESULT') {
                            s.status = 'NOT_STARTED';
                        }
                    });
                    InvitationService.openResendInvitationDialog();
                } else if (res.statusCode === 400 && res.message === 'missing_email_phone') {
                    InvitationService.openWarningMissingEmailPhone();
                }
            });
        }

        function isDisableLaunchResendHAQBattery(sr) {
            return (sr && sr.patientCase && sr.patientCase.billableConfig && sr.patientCase.billableConfig.haqTestServiceExclusion) || vm.isBiller;
        }

        vm.loadPage = function (page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.getIndex = function (index) {
            var result = (index + 1) + (vm.page - 1) * vm.pageSize;
            return result;
        };

        vm.goToHAQBattery = function ($event, haqBattery) {
            $event.preventDefault();
            lunchHAQPatientAutoLogin(haqBattery);
        };
    }

    angular.module('ipmApp').component('batteryTestingList', {
        bindings: {
            patientId: '<',
            isManager: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/battery-testing/battery-testing-list.html',
        controller: BatteryTestingListController,
        controllerAs: 'vm'
    });
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestingDeleteController', BatteryTestingDeleteController);

    BatteryTestingDeleteController.$inject = ['$uibModalInstance', 'entity', 'BatteryTestingService'];

    function BatteryTestingDeleteController($uibModalInstance, entity, BatteryTestingService) {
        var vm = this;
        vm.haqBatteryId = entity ? entity.id : null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.isDeleting = false;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            if (!vm.haqBatteryId) {
                return;
            }
            vm.isDeleting = true;
            BatteryTestingService.deleteBatteryTesting(vm.haqBatteryId)
                .then(function (res) {
                    $uibModalInstance.close(true);
                })
                .catch(function (error) {
                    console.error("Failed to delete Battery Testing:", error);
                })
                .finally(function () {
                    vm.isDeleting = false;
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestingAddDialogController', BatteryTestingAddDialogController);

    BatteryTestingAddDialogController.$inject = ['$stateParams', '$state', 'ipmConstants', '$uibModalInstance', 'entity', 'BatteryTestingService', 'HaqsBatteryService', 'patientId'];

    function BatteryTestingAddDialogController($stateParams, $state, constants, $uibModalInstance, entity, BatteryTestingService, HaqsBatteryService, patientId) {
        var vm = this;
        vm.patientId = patientId;
        vm.haqBattery = entity;
        vm.haqBatteries = null;
        vm.haqBatterySeleted = null;
        vm.departmentSeleted = null;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.isInvalidBattery = false;
        vm.departmentTypes = constants.DEPARTMENT_TYPE;

        init();

        function init() {
            getAllBattery();
            vm.departmentSeleted = 'CLINIC';
        }

        function getAllBattery() {
            vm.isLoading = true;

            HaqsBatteryService.getAllBatteryForSelect(constants.DROPDOWN_BATTERIES_TYPE, vm.patientId).then(function (response) {
                vm.haqBatteries = response ? response : [];
                vm.isLoading = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.isSaving || !vm.departmentSeleted || !vm.haqBatterySeleted || vm.haqBatterySeleted.batteryTestCnt < 1) {
                return;
            }
            vm.isSaving = true;
            vm.haqBattery.department = vm.departmentSeleted;
            vm.haqBattery.id = vm.haqBatterySeleted.id;
            BatteryTestingService.saveBatteryTesting(vm.haqBattery).then(function (res) {
                onSaveSuccess(res);
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.status !== 200) {
                $uibModalInstance.close(error);
            }
        }

        vm.selectBatteriesOnChange = function () {
            if (!vm.haqBatterySeleted || vm.haqBatterySeleted.batteryTestCnt < 1) {
                vm.isInvalidBattery = true;
            } else {
                vm.isInvalidBattery = false;
            }
        };
    }
})();
;
(function() {
    'use strict';


    AppointmentListController.$inject = ['$scope', '$state', '$localStorage' , '$stateParams', '$window', 'Principal', 'ipmConstants', 'AppointmentService'];

    function AppointmentListController($scope, $state, $localStorage, $stateParams, $window, Principal, constants, AppointmentService) {
        var vm = this;//jshint ignore:line

        vm.pageSize = 6;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'dateOfAppointment';
        vm.predicateSecond = 'timeOfAppointment';
        vm.reverse = true;
        vm.appointments = [];
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;

        init();

        function init() {
            vm.id = $stateParams.id;
            vm.pageableAP = {
                page: 1,
                size: 6,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };
            if (vm.patientId) {
                AppointmentService.findAllByPatientId(vm.patientId, pageable).then(function (response) {
                        vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                        vm.appointments = response && response.data ? response.data : [];
                });
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function sort() {
            var result;
            if (vm.predicate === 'officeName' || vm.predicate === 'providerTitleFullName') {
                result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            } else {
                result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            }
            if (vm.predicateSecond && vm.predicate == 'dateOfAppointment') {
                result.push(vm.predicateSecond + ',' + (vm.reverse ? 'desc' : 'asc'));
            }
            return result;
        }
    }

    angular.module('ipmApp').component('appointmentList', {
        bindings: {
            patientId: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/appointment/appointment-list.html',
        controller: AppointmentListController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('configuration');
                $translatePartialLoader.addPart('patient');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AppointmentDeleteController', AppointmentDeleteController);

    AppointmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppointmentService'];

    function AppointmentDeleteController($uibModalInstance, entity, AppointmentService) {
        var vm = this;

        vm.appointmentId = entity ? entity.appointmentId : null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.isDeleting = false;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(appointmentId) {
            vm.isDeleting = true;
            if (appointmentId) {
                AppointmentService.delete({id: appointmentId},
                    function () {
                        $uibModalInstance.close(true);
                    });
            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AppointmentCreateQuestionnaireController', AppointmentCreateQuestionnaireController);

    AppointmentCreateQuestionnaireController.$inject = ['$uibModalInstance', 'entity', 'NPQQuestionnaireService'];

    function AppointmentCreateQuestionnaireController($uibModalInstance, entity, NPQQuestionnaireService) {
        var vm = this;

        vm.appointment = entity ? entity : null;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.notAllowCreateQuestionnaire = false;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.notAllowCreateQuestionnaire = false;
            vm.isSaving = true;
            if (vm.appointment && vm.appointment.id && vm.appointment.patientId) {
                var data = {
                    'id': null,
                    'caseNo': null,
                    'appointmentId': vm.appointment.id,
                    'patientId': vm.appointment.patientId
                };
                NPQQuestionnaireService.saveNPQQuestionnaire(data).then(function(res) {
                    onSaveSuccess(res);
                }, function errorSave(error) {
                    onSaveError(error);
                });
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                if (errorMessage === 'notAllowCreateQuestionnaire') {
                    vm.notAllowCreateQuestionnaire = true;
                }
            }
        }
    }
})();
;

(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AppointmentAddDialogController', AppointmentAddDialogController);

        AppointmentAddDialogController.$inject = ['$stateParams', '$state', '$uibModalInstance','entity', 'supportedDataList', 'AppointmentService'];

    function AppointmentAddDialogController ($stateParams, $state, $uibModalInstance, entity, supportedDataList, AppointmentService) {
        var vm = this;
        vm.appointment = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        // load offices, providers
        vm.offices = supportedDataList.officeList ? supportedDataList.officeList : [];
        vm.providers = supportedDataList.providerList ? supportedDataList.providerList : [];

        vm.hourStep = 1;
        vm.minuteStep = 1;
        vm.decrementYear = 3;
        vm.minYear = 1970;
        vm.officeCustom = officeCustom;
        vm.appointmentExist = null;
        vm.appointmentCopy = null;

        init();

        function init() {

        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.appointmentExist = null;
            if (vm.appointment) {
                updateTimeOfAppointment();
                cloneAppointment();
                if (vm.appointment.id !== null) {
                    AppointmentService.update(vm.appointment, onSaveSuccess, onSaveError);
                } else {
                    AppointmentService.save(vm.appointment, onSaveSuccess, onSaveError);
                }
            }
        }

        function cloneAppointment() {
            vm.appointmentCopy = angular.copy(vm.appointment);
        }

        function updateTimeOfAppointment() {
            if (vm.appointment && vm.appointment.dateOfAppointment && vm.appointment.timeOfAppointment) {
                var dateTimeUpdate = vm.appointment.dateOfAppointment;
                // [start] updateTimeOfAppointment by dateOfAppointment
                dateTimeUpdate.setHours(vm.appointment.timeOfAppointment.getHours(), vm.appointment.timeOfAppointment.getMinutes(), 0);
                vm.appointment.timeOfAppointment = dateTimeUpdate;
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                if (errorMessage === 'This Appointment already exists') {
                    vm.appointmentExist = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                    $uibModalInstance.close(error);
                }
                // revert appointment
                vm.appointment = vm.appointmentCopy;
            }
        }

        vm.changedTime = function () {
        };

        function officeCustom(office) {
            return office ? office.name + ' (' + office.officeCode + ')' : '';
        }
    }
})();
;
(function () {
        'use strict';
        angular
            .module('ipmApp')
            .factory('PatientAgreementsService', PatientAgreementsService);

        PatientAgreementsService.$inject = ['$q', 'halClient', '$http'];

        function PatientAgreementsService($q, halClient, $http) {
            var baseUrl = 'api/agreement';
            var service = {
                "getAllAgreementForSelect": getAllAgreementForSelect,
                "saveAgreement" : saveAgreement
            };

            function getAllAgreementForSelect(patientId, type) {
                var deferred = $q.defer();
                var url = baseUrl + '/get-all-agreement-for-select?patientId=' + patientId + '&type=' + type;
                $http.get(url).success(function (data) {
                    deferred.resolve(data !== undefined ? data : []);
                }).error(function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            }

            function saveAgreement(patientId, agreement) {
                var url = baseUrl + '/update';
                var patientAgreementUpdateRequest = {
                    "patientId": patientId,
                    "agreement": agreement
                }
                return $http.post(url, patientAgreementUpdateRequest).then(function (resp) {
                    return resp.data;
                });
            }

            return service;
        }
    }
)();
;
(function() {
    'use strict';


    PatientAgreementsController.$inject = ['$scope', 'AgreementsWorkflowService', 'InvitationService', 'ipmConstants', 'PatientService', '$window' , '$state'];

    function PatientAgreementsController($scope, AgreementsWorkflowService, InvitationService, constants, PatientService, $window, $state) {
        var vm = this; //jshint ignore:line
        vm.PatientAgreementResponse = null;
        vm.patientAgreements = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'createdDate';
        vm.reverse =  true;
        vm.isSendingInvitation = false;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.downloadAll = downloadAll;
        vm.isShowDownloadAll = isShowDownloadAll;
        vm.isAgreementSignedAllByAPI = isAgreementSignedAllByAPI;
        vm.goToPatientAgreement = goToPatientAgreement;
        vm.resendPatientAgreement = resendPatientAgreement;
        vm.isDisableLaunchResendPatientAgreement = isDisableLaunchResendPatientAgreement;
        vm.isDisableAddNewPatientAgreement = isDisableAddNewPatientAgreement;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };
            if (vm.patientId) {
                AgreementsWorkflowService.findAllByPatientId(vm.patientId, pageable).then(function (response) {
                    vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                    vm.patientAgreements = response ? response.data : [];
                });
            }
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function downloadAll() {
            if (vm.patientId) {
                AgreementsWorkflowService.downloadAllAgreementsByPatientId(vm.patientId).then(function (response) {
                });
            }
        }

        function isShowDownloadAll(patientAgreements) {
            if (!patientAgreements || !patientAgreements.length) {
                return false
            }
            return patientAgreements.some(function (item) {
                return item && String(item.status).toUpperCase().trim() === 'COMPLETE' && String(item.createdSource).toUpperCase().trim() !== 'EXTERNAL';
            });
        }

        function isAgreementSignedAllByAPI(patientAgreements) {
            return patientAgreements && patientAgreements.length > 0 && patientAgreements[0].agreementSignedAllByAPI;
        }

        function isDisableLaunchResendPatientAgreement(pa) {
            return (pa != null && pa.status != null && pa.status === 'COMPLETE' || vm.isBiller)
        }

        function resendPatientAgreement(pa){
            if (vm.isSendingInvitation === true || isDisableLaunchResendPatientAgreement(pa) || !pa.id) {
                return;
            }
            vm.isSendingInvitation = true;
            InvitationService.resendPatientAgreement(pa.id).then(function (res) {
                vm.isSendingInvitation = false;
                if (res.statusCode === 200) {
                    InvitationService.openResendInvitationDialog();
                } else if (res.statusCode === 400 && res.message === 'missing_email_phone') {
                    InvitationService.openWarningMissingEmailPhone();
                }
            });
        }

        function goToPatientAgreement($event, patientAgreement) {
            $event.preventDefault();
            if (!vm.patientId || !patientAgreement.id || patientAgreement.status === 'COMPLETE' || patientAgreement.status === 'CANCEL') {
                return;
            }
            PatientService.getPatientByIdAndAutoLogin(vm.patientId, null).then(function (res) {
                $window.localStorage.setItem(constants.PATIENT_AGREEMENT_ID, patientAgreement.id);
                $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                $window.localStorage.setItem(constants.LAUNCH_FROM, constants.PATIENT_AGREEMENT);
                $state.go('home');
            });
        }

        function isDisableAddNewPatientAgreement() {
            return vm.isBiller;
        }
    }

    angular.module('ipmApp').component('patientAgreements', {
        bindings: {
            patientId: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/agreements/patient-agreements.html',
        controller: PatientAgreementsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                $translatePartialLoader.addPart('agreements');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientAgreementsSendDialogController', PatientAgreementsSendDialogController);

    PatientAgreementsSendDialogController.$inject = ['$stateParams', '$state', 'ipmConstants', '$uibModalInstance', 'PatientAgreementsService', 'patientId', '$translate', 'AlertService'];

    function PatientAgreementsSendDialogController($stateParams, $state, constants, $uibModalInstance, PatientAgreementsService, patientId, $translate , AlertService) {
        var vm = this;
        vm.patientId = patientId;
        vm.agreements = null;
        vm.agreementSeleted = null;
        vm.isSaving = false;
        vm.isInvalidAgreement = false;
        vm.clear = clear;
        vm.save = save;
        vm.selectAgreementOnChange = selectAgreementOnChange;

        init();

        function init() {
            getAllAgreement();
        }

        function getAllAgreement() {
            vm.isLoading = true;
            PatientAgreementsService.getAllAgreementForSelect(vm.patientId, constants.SEND_NEW_AGREEMENT).then(function (response) {
                vm.agreements = response ? response : [];
                if (vm.agreements.length > 0) {
                    vm.agreements.forEach(function (value) {
                        value.nameText = value.name
                            ? $translate.instant('ipmApp.agreements.workflowName.' + value.name)
                            : '';
                    });
                }
                vm.isLoading = false;
            });
        }

        function selectAgreementOnChange() {
            if (!vm.agreementSeleted || vm.agreementSeleted.existedAndAllCompleted === true) {
                vm.isInvalidAgreement = true;
            } else {
                vm.isInvalidAgreement = false;
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.isSaving || !vm.agreementSeleted || !vm.patientId) {
                return;
            }
            vm.isSaving = true;
            PatientAgreementsService.saveAgreement(vm.patientId, vm.agreementSeleted).then(function (res) {
                onSaveSuccess(res);
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.status !== 200) {
                console.error("save Patient Agreement Error: ", error);
                AlertService.error("An error occurred while updating the agreement. Please try again");
                $uibModalInstance.dismiss(error);
            }
        }
    }
})();
;
(function () {
    'use strict';

    AdHocTestingController.$inject = ['$scope', 'HAQBatteryAdHocService', '$window', 'PatientService', 'ipmConstants', '$state'];

    function AdHocTestingController($scope, HAQBatteryAdHocService, $window, PatientService, constants, $state) {
        var vm = this; //jshint ignore:line

        vm.haqBatteryAdHocs = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'id';
        vm.loadAll = loadAll;

        init();

        function init() {
            vm.isManager = vm.isManager ? vm.isManager : false;
            vm.pageableHaq = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            HAQBatteryAdHocService.findAllByPatientId(vm.patientId, pageable).then(function (response) {
                if (response) {
                    vm.haqBatteryAdHocs = response.data;
                    vm.pageableHaq.totalItems = response.totalItems;
                    vm.isLoading = false;
                }
            });
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function lunchHAQPatientAutoLogin(haqBatteryAdHoc) {
            if (!haqBatteryAdHoc.patientId || !haqBatteryAdHoc.surveyResult || !haqBatteryAdHoc.surveyResult.id) {
                return;
            }
            PatientService.getPatientByIdAndAutoLogin(haqBatteryAdHoc.patientId, haqBatteryAdHoc.surveyResult.id).then(function (res) {
                $window.localStorage.setItem(constants.SURVEY_RESULT_ID, haqBatteryAdHoc.surveyResult.id);
                $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                $window.localStorage.setItem(constants.LAUNCH_FROM, constants.HAQ_ADHOC);
                $state.go('home');
            });
        }

        vm.loadPage = function (page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.getIndex = function (index) {
            var result = (index + 1) + (vm.page - 1) * vm.pageSize;
            return result;
        };

        vm.goToHAQBattery = function ($event, haqBatteryAdHoc) {
            $event.preventDefault();
            lunchHAQPatientAutoLogin(haqBatteryAdHoc);
        };

    }

    angular.module('ipmApp').component('adHocTestingList', {
        bindings: {
            patientId: '<',
            isManager: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/adhoc-testing/adhoc-testing.html',
        controller: AdHocTestingController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                $translatePartialLoader.addPart('haqBatteryAdHoc');
                return $translate.refresh();
            }]
        }
    });
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AdhocTestingDeleteController', AdhocTestingDeleteController);

    AdhocTestingDeleteController.$inject = ['$uibModalInstance', 'entity', 'HAQBatteryAdHocService'];

    function AdhocTestingDeleteController($uibModalInstance, entity, HAQBatteryAdHocService) {
        var vm = this;

        vm.haqBatteryAdHocId = entity ? entity.id : null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.isDeleting = false;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            vm.isDeleting = true;
            if (vm.haqBatteryAdHocId) {
                HAQBatteryAdHocService.delete({id: vm.haqBatteryAdHocId},
                    function () {
                        $uibModalInstance.close(true);
                    });
            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AdHocTestingAddDialogController', AdHocTestingAddDialogController);

    AdHocTestingAddDialogController.$inject = ['$stateParams', '$state', '$uibModalInstance', 'entity', 'HAQBatteryAdHocService', 'BatteryTest', 'patientId'];

    function AdHocTestingAddDialogController($stateParams, $state, $uibModalInstance, entity, HAQBatteryAdHocService, BatteryTest, patientId) {
        var vm = this;
        vm.patientId = patientId;
        vm.haqBatteryAdHoc = entity;
        vm.haqBatteryAdHocSeleted = null;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.isInvalidBatteryAdHoc = false;

        init();

        function init() {
            getAllBatteryTestsAdHoc();
        }

        function getAllBatteryTestsAdHoc() {
            vm.isLoading = true;
            BatteryTest.getAllBatteryTestsAdHocBy(vm.patientId).then(function (response) {
                vm.haqBatteryAdHocs = response ? response : [];
                vm.isLoading = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.isSaving) {
                return;
            }
            vm.isSaving = true;
            vm.haqBatteryAdHoc.batteryTestId = vm.haqBatteryAdHocSeleted.id ? vm.haqBatteryAdHocSeleted.id : null;
            if (vm.haqBatteryAdHoc && vm.haqBatteryAdHoc.batteryTestId) {
                if (vm.haqBatteryAdHoc.id !== null) {
                    HAQBatteryAdHocService.update(vm.haqBatteryAdHoc, onSaveSuccess, onSaveError);
                } else {
                    HAQBatteryAdHocService.save(vm.haqBatteryAdHoc, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            // var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status !== 200) {
                $uibModalInstance.close(error);
            }
        }

        vm.selectTextOnChange = function () {
            if (!vm.haqBatteryAdHocSeleted || !vm.haqBatteryAdHocSeleted.test || vm.haqBatteryAdHocSeleted.test.countSections < 1) {
                vm.isInvalidBatteryAdHoc = true;
            } else {
                vm.isInvalidBatteryAdHoc = false;
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('NPQQuestionnaireWorkflowController', NPQQuestionnaireWorkflowController);

    NPQQuestionnaireWorkflowController.$inject = ['$scope', '$state', '$translate', '$timeout', '$location', 'Auth', '$uibModal', '$window', 'JhiLanguageService', 'NPQQuestionnaireService', 'npqQuestionnaire', 'masterData', 'dataWorkflow', '$localStorage', 'ipmConstants', '$rootScope', 'ClearLocalStorageService'];

    function NPQQuestionnaireWorkflowController($scope, $state, $translate, $timeout, $location, Auth, $uibModal, $window, JhiLanguageService, NPQQuestionnaireService, npqQuestionnaire, masterData, dataWorkflow, $localStorage, constants, $rootScope, ClearLocalStorageService) {
        var vm = this;

        vm.medicationGroups = masterData.medicationGroups;
        vm.symptomGroups = masterData.symptomGroups;
        vm.pastMedicalHistoryGroups = masterData.pastMedicalHistoryGroups;

        vm.npqQuestionnaire = npqQuestionnaire;
        vm.dataWorkflow = dataWorkflow;

        vm.section = vm.dataWorkflow.section;
        vm.template = '';
        vm.datePickerOpenStatus = {
            theApproximateDateOfTheInjury: false,
            dateOfInjury: false
        };
        vm.isInvitation = $window.localStorage.getItem(constants.INVITATION_WORKFLOW);
        vm.isLaunchAction = $window.localStorage.getItem(constants.NPQ_QUESTIONNAIRE_ID) ? true : false;

        vm.init = function () {
            if (vm.dataWorkflow.action == 'COMPLETE') {
                vm.template = 'app/npq-questionnaire/workflow/partial/thanks.html';
                vm.npqQuestionnaire['currentSection'] = {};
            } else {
                vm.template = 'app/npq-questionnaire/workflow/partial/' + vm.dataWorkflow.section.template + '.html';
            }
        }

        vm.next = function () {
            vm.dataWorkflow.action = 'NEXT';
            vm.dataWorkflow.isInvitation = vm.isInvitation;
            vm.dataWorkflow.isLaunchAction = vm.isLaunchAction;
            NPQQuestionnaireService.submitWorkflow(vm.dataWorkflow).then(function (res) {
                vm.dataWorkflow = res;
                vm.updateCurrentSection(res);
            });
        }

        vm.back = function () {
            vm.dataWorkflow.action = 'BACK';
            vm.dataWorkflow.isInvitation = vm.isInvitation;
            vm.dataWorkflow.isLaunchAction = vm.isLaunchAction;
            NPQQuestionnaireService.submitWorkflow(vm.dataWorkflow).then(function (res) {
                vm.dataWorkflow = res;
                vm.updateCurrentSection(res);
            });
        }

        vm.updateCurrentSection = function (workflow) {
            vm.npqQuestionnaire.sectionIdsCompleted = workflow.sectionIdsCompleted;
            if (workflow.action == 'COMPLETE') {
                vm.template = 'app/npq-questionnaire/workflow/partial/thanks.html';
                vm.npqQuestionnaire['currentSection'] = {};
            } else {
                vm.template = 'app/npq-questionnaire/workflow/partial/' + workflow.section.template + '.html';
                if (!vm.npqQuestionnaire.currentSection) {
                    vm.npqQuestionnaire['currentSection'] = workflow.section;
                } else {
                    vm.npqQuestionnaire.currentSection.id = workflow.section.id;
                    vm.npqQuestionnaire.currentSection.code = workflow.section.code;
                    vm.npqQuestionnaire.currentSection.template = workflow.section.template;
                    vm.npqQuestionnaire.currentSection.name = workflow.section.name;
                    vm.npqQuestionnaire.currentSection.nameLangKey = workflow.section.nameLangKey;
                    vm.npqQuestionnaire.currentSection.orderNumber = workflow.section.orderNumber;
                }
            }

            $window.scrollTo(0, 0);
        }

        vm.logout = function () {
            Auth.logout();
            $state.go('home');
            delete $localStorage.isQuestionnaireIncomplete;
            delete $localStorage.firstIdOfAllNPQQuestionnaireNotComplete;
            delete $localStorage.isQuestionnaireCount;
            $window.localStorage.removeItem(constants.INVITATION_WORKFLOW);
            $window.localStorage.removeItem(constants.SURVEY_RESULT_ID);
            $window.localStorage.removeItem(constants.NPQ_QUESTIONNAIRE_ID);
            $window.localStorage.removeItem(constants.PATIENT_AGREEMENT_ID);
            $rootScope.$broadcast(constants.EVT_LOG_OUT);
        }

        vm.init();

        vm.nextNPQOrLogout = function () {
            NPQQuestionnaireService.checkingStatusPatient().then(function (res) {
                if (res && (res.isOpenCountDialog || res.isOpenResumeDialog || res.forwardToLastStepOfNPQ)) {
                    ClearLocalStorageService.clearWorkflow();
                    goToNPQWorkflow();
                } else {
                    ClearLocalStorageService.clearAllAndWorkflow();
                    ClearLocalStorageService.clearLandingPage();
                    goToLandingPage();
                    // goToHome(); // open HAQ Workflow
                }
            });
        }

        function goToNPQWorkflow() {
            $state.go('npq-questionnaire.workflow', null, { reload: true });
        }

        function goToHome() {
            $state.go('home');
        }

        function goToLandingPage() {
            $state.go('landing-page');
        }
    }
})();
;
(function () {
    'use strict';


    PatientSummaryController.$inject = ['$scope', 'PatientService'];

    function PatientSummaryController($scope, PatientService) {
        var vm = this; //jshint ignore:line
        vm.patient = null;

        init();

        function init() {
            PatientService.get(vm.patientId).then(function (response) {
                vm.patient = response ? response : null;
            });
        }
    }

    angular.module('ipmApp').component('patientSummary', {
        bindings: {
            patientId: '<'
        },
        templateUrl: 'app/notification-history/patient-summary/patient-summary.html',
        controller: PatientSummaryController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                $translatePartialLoader.addPart('surveyResult');
                return $translate.refresh();
            }]
        }
    });
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$location', '$state', 'Auth', 'Principal', 'ENV', 'LoginService', '$scope', 'ipmConstants', '$rootScope', '$uibModal', '$translate', '$translatePartialLoader', '$localStorage', '$window', 'ClearLocalStorageService'];

    function NavbarController ($location, $state, Auth, Principal, ENV, LoginService, $scope, constants, $rootScope, $uibModal, $translate, $translatePartialLoader, $localStorage, $window, ClearLocalStorageService) {
        var vm = this;

        $translatePartialLoader.addPart('surveyWorkflow');
        $translate.refresh();

        vm.navCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        vm.login = login;
        vm.logout = logout;
        vm.$state = $state;
        vm.checkStateShowCPR = checkStateShowCPR;
        vm.isStateCPR = isStateCPR;
        vm.isStateCPRWorkflow = isStateCPRWorkflow;
        vm.navBarHomeId = 1;
        vm.navBarCPRId = 2;
        vm.isHideWellnessClass = constants.HIDE_WELLNESS_CLASSES;
        vm.ddOpen = false;

        setBrowserClass();

        getAccount(true);

        $scope.$on(constants.EVT_AUTHENTICATION_SUCCESS, function() {
            getAccount(false);
        });

        function getAccount(force) {
             Principal.identity(force).then(function(res) {
                vm.account = res;
             });
        }

        function login () {
            $rootScope.sessionTimeOut = null;
            LoginService.open();
        }

        function logout () {
            vm.ddOpen = false;
            Auth.logout();
            $state.go('home');
            ClearLocalStorageService.clearAfterLogout();
            $rootScope.$broadcast(constants.EVT_LOG_OUT);
        }

        vm.showSkypeDialog = function() {
            $uibModal.open({
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.close = function() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                templateUrl: 'app/survey-workflow/partial/skype-confirm-dialog.html',
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static',
                windowClass: 'absolute-center warning-dialog'
            });
        }

        vm.isActive = function (viewLocation) {
            return viewLocation === $location.path();
        };

        vm.isStaffOrManager = function () {
            if (vm.account && (vm.account.authorities.indexOf('ROLE_STAFF') !== -1 || vm.account.authorities.indexOf('ROLE_MANAGER') !== -1)) {
                return true;
            }
            return false;
        };
        vm.carePlanReview = function(navBarId) {
            if (vm.account && (vm.account.authorities.indexOf('ROLE_QHP') !== -1)) {
                var lengthTaskAsignMax = 2;
                var tasks = vm.account.qhpUserDetail && vm.account.qhpUserDetail.tasks ? vm.account.qhpUserDetail.tasks : [];
                if (navBarId === vm.navBarHomeId && tasks && tasks.length > 1
                    && isStateWellnesClass()) {
                    return true;
                }
                // navBar Home id = 1
                if (navBarId === vm.navBarHomeId && tasks && tasks.length < lengthTaskAsignMax
                    && (isStateCPRWorkflow() || isStateCPR())) { // fix bug IPMproject-B1292, IPMproject-B1291
                    return false;
                }
                // navBar carePlanReview id = 2
                if (navBarId === vm.navBarCPRId && isStateCPR()) { // IPMproject-B1295
                    return false;
                }
                // apply only task list carePlanReview
                var isStateShowCarePlanReview = vm.checkStateShowCPR();
                if (isStateShowCarePlanReview && tasks && tasks.length > 0 && (navBarId === vm.navBarHomeId || (navBarId === vm.navBarCPRId && tasks.indexOf('CARE_PLAN_REVIEW') !== -1))) {

                    return true;
                }
            }
            return false;
        };

        vm.checkShowHomeForFRPMDE = function () {
            if (vm.isQHPRole() && (isStateFRPMDE() == true || isStateMDEReport() == true) || isStateMDEReportParent() == true || isStateFRPReport() == true || isStateAdhocHaqEvaluation() || isStateHaqBriefReview()) {
                return true;
            }
            return false;
        };

        vm.isPatient = function () {
            if (vm.account && (vm.account.authorities.indexOf('ROLE_PATIENT') !== -1)) {
                return true;
            }
            return false;
        };

        vm.isStaff = function () {
            if (vm.account && (vm.account.authorities.indexOf('ROLE_STAFF') !== -1)) {
                return true;
            }
            return false;
        };

        vm.isQHPRole = function () {
            if (vm.account && (vm.account.authorities.indexOf('ROLE_QHP') !== -1)) {
                return true;
            }
            return false;
        };

        vm.isShowWellnessClassList = function () {
            if (vm.account && (vm.account.authorities.indexOf('ROLE_QHP') !== -1) && isStatePresentationControls()) {
                return true;
            }
            return false;
        };

        vm.isHaqEvaluationTestMode = function () {
            if (vm.account && (vm.account.authorities.indexOf('ROLE_QHP') !== -1) && vm.account.haqEvaluationTestMode) {
                return true;
            }
            return false;
        }

        function searchString(data) {
            for (var i = 0; i < data.length; i++) {
                var dataString = data[i].string;
                var dataProp = data[i].prop;
                if (dataString) {
                    if (dataString.indexOf(data[i].subString) != -1)
                        return data[i].identity;
                } else if (dataProp)
                    return data[i].identity;
            }
        };

        function checkStateShowCPR () {
            return $state && $state.current && $state.current.url
                && ($state.current.url === '/care-plan-review'
                    || $state.current.url === '/care-plan-review-workflow'
                    || $state.current.url === '/haq-evaluation'
                    || ($state.current.parent === 'haq-evaluation' && ($state.current.url === '/workflow' || $state.current.url === '/submit')));
        };

        function isStateFRPMDE() {
            return $state && $state.current
                && (($state.current.name && $state.current.name === 'frp-mde')
                    || ($state.current.parent && $state.current.parent === 'frp-mde'));
        };

        function isStateMDEReport() {
            return $state && $state.current && $state.current.name
                && ($state.current.name === 'mde-report');
        };

        function isStateMDEReportParent() {
            return $state && $state.current && $state.current.parent
                && ($state.current.parent === 'mde-report');
        };

        function isStateFRPReport() {
            return $state && $state.current && (
                ($state.current.name && $state.current.name === 'frp-report')
                || ($state.current.parent && $state.current.parent === 'frp-report')
            );
        };

        function isStateWellnesClass() {
            return $state && $state.current && $state.current.url
                && ($state.current.url === '/wellness-class-list' || $state.current.parent === 'wellness-class-list');
        };

        function isStateCPR() {
            return $state && $state.current && $state.current.url
                && ($state.current.url === '/care-plan-review');
        };

         function isStateCPRWorkflow() {
            return $state && $state.current && $state.current.url
                && ($state.current.url === '/care-plan-review-workflow');
        };

        function isStatePresentationControls() {
            return $state && $state.current && $state.current.name
                && $state.current.name === 'presentation-controls-instructor';
        };

        function isStateAdhocHaqEvaluation() {
            return $state && $state.current && (
                ($state.current.name && $state.current.name === 'adhoc-haq-evaluation')
                || ($state.current.parent && $state.current.parent === 'adhoc-haq-evaluation')
            );
        };

        function isStateHaqBriefReview() {
            return $state && $state.current && (
                ($state.current.name && $state.current.name === 'haq-brief-review')
                || ($state.current.parent && $state.current.parent === 'haq-brief-review')
            );
        };

        function setBrowserClass() {
            var dataOS = [
                {
                    string: navigator.platform,
                    subString: "Win",
                    identity: "Windows"
                },
                {
                    string: navigator.platform,
                    subString: "Mac",
                    identity: "Mac"
                },
                {
                    string: navigator.userAgent,
                    subString: "iPhone",
                    identity: "iPhone/iPod"
                },
                {
                    string: navigator.platform,
                    subString: "Linux",
                    identity: "Linux"
                }
            ];

            vm.OS = searchString(dataOS) || "unknownOS";
            if (vm.OS == "Mac") {
                angular.element(document.querySelector('body')).addClass(vm.OS.toLowerCase());
            }
        };

        $scope.$on(constants.EVT_AUTHENTICATION_SUCCESS_BY_INVITATION, function() {
            getAccount(true);
        });

        vm.isAdmin = function () {
            if (vm.account && vm.account.authorities.indexOf('ROLE_ADMIN') !== -1) {
                return true;
            }
            return false;
        };

        vm.isBiller = function () {
            if (vm.account && vm.account.authorities.indexOf('ROLE_BILLER') !== -1) {
                return true;
            }
            return false;
        };

        vm.goToHome = function () {
            $state.go('home');
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .directive('adjustBodyHeight', adjustBodyHeight);
    adjustBodyHeight.$inject = ['$document', '$timeout'];

    function adjustBodyHeight($document, $timeout) {
        return {
            require: '^uibDropdown',
            link: function (scope, elem, attrs, dropdownCtrl) {
                var body = $document[0].body;
                var openTimer = null;
                var clickHandler = null;

                function resetMinHeight() {
                    body.style.removeProperty('min-height');
                }

                scope.$watch(function () {
                    return dropdownCtrl.isOpen();
                }, function (isOpen) {
                    if (isOpen) {
                        if (openTimer) {
                            $timeout.cancel(openTimer);
                        }
                        openTimer = $timeout(function () {
                            var menu = elem[0].querySelector('[uib-dropdown-menu]');
                            if (!menu) {
                                return;
                            }
                            if (!clickHandler) {
                                clickHandler = function () {
                                    resetMinHeight();
                                };
                                menu.addEventListener('click', clickHandler);
                            }
                            var rect = menu.getBoundingClientRect();
                            var over = rect.bottom - window.innerHeight;
                            if (over > 0) {
                                body.style.minHeight = body.offsetHeight + over + 'px';
                            }
                        });
                    } else {
                        if (openTimer) {
                            $timeout.cancel(openTimer);
                            openTimer = null;
                        }
                        var menu = elem[0].querySelector('[uib-dropdown-menu]');
                        if (menu && clickHandler) {
                            menu.removeEventListener('click', clickHandler);
                            clickHandler = null;
                        }
                        $timeout(resetMinHeight);
                    }
                });
                scope.$on('$destroy', function () {
                    if (openTimer) {
                        $timeout.cancel(openTimer);
                    }
                    resetMinHeight();
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('activeMenu', activeMenu);

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function () {
    "use strict";

    angular.module("ipmApp").controller("FooterController", FooterController);

    FooterController.$inject = ["$scope"];

    function FooterController($scope) {
        var vm = this;
        vm.currentYear = new Date().getFullYear();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('error-sso', {
                parent: 'app',
                url: '/error/sso',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error-sso.html',
                        controller: 'ErrorSSOController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }],
                    logoutUri: ['User', function (User) {
                        return User.getAzureLogoutUri().then(function(response) {
                            return response ? response.azureLogoutUri : null;
                        });
                    }]
                }
            });
    }
})();
;
(function () {
    "use strict";

    angular.module("ipmApp").controller("ErrorSSOController", ErrorSSOController);

    ErrorSSOController.$inject = ['$scope', 'logoutUri'];

    function ErrorSSOController($scope, logoutUri) {
        var vm = this;
        vm.logoutUri = logoutUri ? logoutUri : 'saml/logout';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('FRPMDETemplateDialogController', FRPMDETemplateDialogController);

    FRPMDETemplateDialogController.$inject = ['$scope', '$stateParams', '$uibModal', '$uibModalInstance', 'FRPMDETemplateService', 'titleKey', 'template', 'DataUtils'];

    function FRPMDETemplateDialogController($scope, $stateParams, $uibModal, $uibModalInstance, FRPMDETemplateService, titleKey, template, DataUtils) {
        var vm = this;
        vm.titleKey = titleKey ? titleKey : 'createOrEditLabel';
        vm.template = template ? template : null;
        vm.name = template.name;
        vm.content = template.content;
        vm.save = save;
        vm.clear = clear;
        vm.deleteTemplate = deleteTemplate;
        vm.cancelCreatingMessage = 'ipmApp.frpMdeTemplate.confirmCancelCreating';
        vm.cancelEditingMessage = 'ipmApp.frpMdeTemplate.confirmCancelEditing';
        vm.deleteMessage = 'ipmApp.frpMdeTemplate.confirmDelete';

        init();
        function init() {
        }

        function isChanged() {
            var isEqual = true;
            // Template Name
            isEqual = DataUtils.isEqualText(vm.name, vm.template.name);
            if (!isEqual) return true;
            // Template Content
            isEqual = DataUtils.isEqualText(vm.content, vm.template.content);
            if (!isEqual) return true;
            return !isEqual;
        }

        function clear() {;
            if (isChanged()) {
                if (vm.template.id) {
                    vm.confirmDialog(vm.cancelEditingMessage, false);
                } else {
                    vm.confirmDialog(vm.cancelCreatingMessage, false);
                }
            } else {
                $uibModalInstance.dismiss('cancel'); // close modal with reason 'cancel'
            }
        }

        vm.confirmDialog = function (message, isDelete) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) { // select 'Yes'
                    if (isDelete) {
                        doDeleteTemplate();
                    } else {
                        $uibModalInstance.dismiss('cancel'); // close modal with reason 'cancel'
                    }
                }
            });
        }

        function save() {
            vm.isSaving = true;
            prepairDataForSave();
            if (vm.template.id) {
                FRPMDETemplateService.update(vm.template, onSaveSuccess, onSaveError);
            } else {
                FRPMDETemplateService.save(vm.template, onSaveSuccess, onSaveError);
            }
        }

        function deleteTemplate() {
            vm.confirmDialog(vm.deleteMessage, true);
        }

        function doDeleteTemplate()  {
            vm.isSaving = true;
            FRPMDETemplateService.delete({id: vm.template.id}, function () {
                vm.isSaving = false;
                $uibModalInstance.close('delete_template_success'); // close modal with reason 'delete_template_success'
            });
        }

        function prepairDataForSave() {
            vm.template.name = vm.name;
            vm.template.content = vm.content;
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result); // close modal with reason 'template object'
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        $scope.$on('modal.closing', function(event, reason, closed) {
            if (isChanged() && reason && reason === 'escape key press') { // close modal with reason 'escape key'
                event.preventDefault(); // reject dialog closing process
                if (vm.template.id) {
                    vm.confirmDialog(vm.cancelEditingMessage, false);
                } else {
                    vm.confirmDialog(vm.cancelCreatingMessage, false);
                }
            }
        });
    }
})();

;
(function() {
    'use strict';

    SelectScoreFrpMdeController.$inject = ['$scope'];

    function SelectScoreFrpMdeController($scope) {
        var vm = this; //jshint ignore:line
        vm.enableSearchTextMatch = false;
        vm.selectScoreOnChange = selectScoreOnChange;

        init();

        function init() {
            vm.numberMaxlength = vm.numberMaxlength ? vm.numberMaxlength : 1000;
            vm.isHideSeverity = vm.isHideSeverity ? true : false;
            vm.selectId = vm.selectId ? vm.selectId : new Date().getTime().toString();
            vm.isDisabled =  vm.isDisabled ? vm.isDisabled : false;
            vm.isRequired =  vm.isRequired ? vm.isRequired : false;
            vm.severityModel = vm.severityModel ? vm.severityModel : null; // it's classification
            vm.scoreNoMatch = false; // init scoreNoMatch is false
            if (vm.isInitData) {
                updateInitSeverityModel();
            }
        }

        function selectScoreOnChange() {
            var selectScores = getDataSelectScore();
            updateSeverity(selectScores);
            updateScoreNoMatch(selectScores);
            emitSeverity();
        }

        function updateScoreNoMatch(selectScores) {
            vm.scoreNoMatch = selectScores && vm.severityModel ? false : true;
        }

        function updateSeverity(selectScores) {
            vm.severityModel = !_.isEmpty(selectScores) ? _.first(selectScores) : '';
        }

        function updateInitSeverityModel() {
            // Update the severityModel if it is initially empty and vm.scoreModel is a valid number.
            // This helps ensure the severityModel reflects the scoreModel.
            if (vm.scoreModel && !vm.severityModel && !_.isNaN(vm.scoreModel)) {
                selectScoreOnChange();
            }
        }

        function emitSeverity() {
            vm.onChange({severity: vm.severityModel});
        }

        function getDataSelectScore() {
            var textScoreModel = angular.copy(vm.scoreModel);
            var initialScore = angular.copy(vm.selectData);
            var textSearch = textScoreModel ? textScoreModel.trim().toLowerCase() : '';

            if (textSearch) {
                var initialScoreResults = _.filter(initialScore, function (item) {

                    var isNumberMatch = !_.isNaN(textSearch) &&
                        checkMinRange(item, textSearch) &&
                        (Number(textSearch) <= item.maxRange);
                    if (vm.enableSearchTextMatch) {
                        var isTextMatch = item.value.toLowerCase().indexOf(textSearch) !== -1;
                        return isTextMatch || isNumberMatch;
                    }
                    return isNumberMatch;
                });
                return formatScoreResult(textScoreModel, initialScoreResults);
            }
            return [];
        };

        function checkMinRange(severityItem, textScore) {
            if (severityItem) {
                if (severityItem.key === 'SEVERE_ANXIETY' || severityItem.key === 'SEVERE_DEPRESSION') { // HAM_A && HAM_D
                    return severityItem.minRange < Number(textScore);
                }
                return severityItem.minRange <= Number(textScore)
            }
            return false;
        }

        function formatScoreResult(textSearch, initialScoreResults) {
            return  _.map(initialScoreResults, function (item) {
                // If textSearch is null, display will using 'value' else use 'name'
                return textSearch ? item.name : item.value;
            });
        }

        $scope.$watch('vm.updateSeverityData', function (oldVal, newVal) {
            if (oldVal !== newVal) {
                selectScoreOnChange();
            }
        });

    }

    angular.module('ipmApp').component('selectScoreFrpMde', {
        bindings: {
            numberMaxlength: '<',
            placeholderLabel: '<',
            isDisabled: '<',
            isRequired: '<',
            selectId: '<',
            selectData: '<',
            isHideSeverity: '<',
            isInitData: '<',
            updateSeverityData: '<',
            scoreNoMatch: '=',
            scoreModel: '=',
            severityModel: '=',
            onChange: '&'
        },
        templateUrl: 'app/frp-mde/select-score-frp-mde-component/select-score-frp-mde.component.html',
        controller: SelectScoreFrpMdeController,
        controllerAs: 'vm'
    })
})();
;
(function () {
	'use strict';

	angular
	.module('ipmApp')
	.controller('PDFReportPreviewDiaglogController', PDFReportPreviewDiaglogController);

	PDFReportPreviewDiaglogController.$inject = ['$scope', '$state', '$uibModalInstance', 'pdfData'];

	function PDFReportPreviewDiaglogController($scope, $state, $uibModalInstance, pdfData) {
		var vm = this;
        vm.pdfData = pdfData;
        init();

        function init() {
        }
		vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('mde-report', {
			parent: 'app',
			url: '/mde-report/{id}',
			data: {
				authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
				pageTitle: ''
			},
			views: {
				'content@': {
					templateUrl: 'app/frp-mde/mde-report/home/mde-report-home.html',
					controller: 'MDEReportHomeController',
					controllerAs: 'vm'
				}
			},
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('mdeReport');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                isPatientActivated: ['MdeReportService',  '$stateParams', '$state' , function (MdeReportService, $stateParams, $state) {
                    MdeReportService.isPatientActivated($stateParams.id).then(function() {});
                 }]
            }
		})
        .state('mde-report.ADMIN', {
            parent: 'mde-report',
            url: '/office',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/mde-report/admin/mde-report-admin.html',
                    controller: 'MDEReportAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mdeReport');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                 supportedDataList: ['Auth', function(Auth) {
                    return Auth.getSupportedListRegister();
                }],
                 userDetails: ['User', function (User) {
                    return User.getUserByCurrentLogin();
                }],
                qhpUsers: ['User', function (User) {
                    return User.getAllQHPUsers();
                }],
                staffUsers: ['User', function (User) {
                    return User.getAllStaffUsers();
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('mde-report.ADMIN.VIEW', {
                parent: 'mde-report',
                url: '/office/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/mde-report/admin/mde-report-admin.html',
                        controller: 'MDEReportAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('mdeReport');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    supportedDataList: ['Auth', function(Auth) {
                        return Auth.getSupportedListRegister();
                    }],
                    userDetails: ['User', function (User) {
                        return User.getUserByCurrentLogin();
                    }],
                    qhpUsers: ['User', function (User) {
                        return User.getAllQHPUsers();
                    }],
                    staffUsers: ['User', function (User) {
                        return User.getAllStaffUsers();
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('mde-report.MEDICAL', {
            parent: 'mde-report',
            url: '/medical',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/mde-report/ptp/mde-report-ptp.html',
                    controller: 'MDEReportPTPController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frpmde');
                    $translatePartialLoader.addPart('mdeReport');
                    return $translate.refresh();
                }],
                mdeReport: ['MdeReportService', '$stateParams', function(MdeReportService, $stateParams) {
                    return MdeReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_MEDIAL);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('mde-report.MEDICAL.VIEW', {
                parent: 'mde-report',
                url: '/medical/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/mde-report/ptp/mde-report-ptp.html',
                        controller: 'MDEReportPTPController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('mdeReport');
                        return $translate.refresh();
                    }],
                    mdeReport: ['MdeReportService', '$stateParams', function(MdeReportService, $stateParams) {
                        return MdeReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_MEDIAL);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('mde-report.PT', {
            parent: 'mde-report',
            url: '/physical-functional',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/mde-report/pt/mde-report-pt.html',
                    controller: 'MDEReportPTController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                mdeReport: ['MdeReportService', '$stateParams', function(MdeReportService, $stateParams) {
                    return MdeReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_PT);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('mde-report.PT.VIEW', {
                parent: 'mde-report',
                url: '/physical-functional/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/mde-report/pt/mde-report-pt.html',
                        controller: 'MDEReportPTController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    mdeReport: ['MdeReportService', '$stateParams', function(MdeReportService, $stateParams) {
                        return MdeReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_PT);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('mde-report.PSYCH', {
            parent: 'mde-report',
            url: '/psych',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/mde-report/psych/mde-report-psych.html',
                    controller: 'MDEReportPsychController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_PSYCH);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('mde-report.PSYCH.VIEW', {
                parent: 'mde-report',
                url: '/psych/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/mde-report/psych/mde-report-psych.html',
                        controller: 'MDEReportPsychController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_PSYCH);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('mde-report.CONCLUSION', {
            parent: 'mde-report',
            url: '/conclusion',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/mde-report/conclusion/mde-report-conclusion.html',
                    controller: 'MDEReportConclusionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frpmde');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_CONCLUSION);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('mde-report.CONCLUSION.VIEW', {
                parent: 'mde-report',
                url: '/conclusion/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/mde-report/conclusion/mde-report-conclusion.html',
                        controller: 'MDEReportConclusionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.MDE_CONCLUSION);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
            .state('mde-report.ADDENDUM', {
                parent: 'mde-report',
                url: '/addendum',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/mde-report/addendum/mde-report-addendum.html',
                        controller: 'MDEReportAddendumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    mdeReport: ['MdeReportService', '$stateParams', function(MdeReportService, $stateParams) {
                        return MdeReportService.findById($stateParams.id);
                    }],
                    isView: function () {
                        return false;
                    }
                }
            })
            .state('mde-report.ADDENDUM.VIEW', {
                parent: 'mde-report',
                url: '/addendum/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/mde-report/addendum/mde-report-addendum.html',
                        controller: 'MDEReportAddendumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    mdeReport: ['MdeReportService', '$stateParams', function(MdeReportService, $stateParams) {
                        return MdeReportService.findById($stateParams.id);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
            .state('mde-report-preview', {
                parent: 'mde-report',
                url: '/preview',
                data: {
                    pageTitle: ''
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/frp-mde/pdf-report-preview-dialog/pdf-report-preview-dialog.html',
                        controller: 'PDFReportPreviewDiaglogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        windowClass: 'absolute-center',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            pdfData: function(MdeReportService) {
                                return MdeReportService.loadPdfReportPreviewData($stateParams.id);
                            }
                        }
                    }).result.then(function() {
                        // $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('MdeReportService', MdeReportService);

    MdeReportService.$inject = ['$http', 'halClient', '$q', 'DownloadBlobService'];

    function MdeReportService ($http, halClient, $q, DownloadBlobService) {
        var baseURL = 'api/mde-report/';
        var prefixApiAdmin = '/office';

        var service = {
            'get': get,
            'getMdeReport': getMdeReport,
            'getMdePtReport': getMdePtReport,
            'getMdePsychReport': getMdePsychReport,
            'findById': findById,
            'saveMdePtReport': saveMdePtReport,
            'saveMdePsychReport': saveMdePsychReport,
            'saveMdeConclusionReport': saveMdeConclusionReport,
            'getMdeAdminReport': getMdeAdminReport,
            'getMdeConclusionReport': getMdeConclusionReport,
            'saveMDEReportPTP': saveMDEReportPTP,
            'finalizeMDEReportPTP': finalizeMDEReportPTP,
            'saveMdeAdminReport': saveMdeAdminReport,
            'createMdeReport': createMdeReport,
            'updateAdminAbandoned': updateAdminAbandoned,
            'getPhysicalDemandLevels': getPhysicalDemandLevels,
            'finalizeMdeReport': finalizeMdeReport,
            'downloadMDEReport': downloadMDEReport,
            'loadPdfReportPreviewData': loadPdfReportPreviewData,
            'saveMDEReportAddendum': saveMDEReportAddendum,
            'isPatientActivated': isPatientActivated
        };

        function finalizeMDEReportPTP(mdeReport) {
            var url = baseURL + 'finalize-mde-report-ptp';
            return $http.post(url, mdeReport).then(function (resp) {
                return resp.data;
            });
        }

        function saveMDEReportPTP(mdeReport) {
            var url = baseURL + 'save-mde-report-ptp';
            return $http.post(url, mdeReport).then(function (resp) {
                return resp.data;
            });
        }

        function saveMDEReportAddendum(mdeReport) {
            var url = baseURL + 'save-mde-report-addendum';
            return $http.post(url, mdeReport).then(function (resp) {
                return resp.data;
            });
        }

        function get(id){
            return $http.get(baseURL + id).then( function(response) {
                return response;
            })
        }

        function getMdeReport(id){
            return $http.get(baseURL + id + '/get-mde-report').then( function(response) {
                return response;
            })
        }

        function getMdePtReport(mdeReportId){
            return $http.get(baseURL + mdeReportId + '/pt').then( function(response) {
                return response.data;
            })
        }

        function saveMdePtReport(mdeReportId, data){
            return $http.post(baseURL + mdeReportId + '/pt', data).then( function(response) {
                return response.data;
            })
        }

        function getMdePsychReport(mdeReportId){
            return $http.get(baseURL + mdeReportId + '/psych').then( function(response) {
                return response.data;
            })
        }

        function saveMdePsychReport(mdeReportId, data){
            return $http.post(baseURL + mdeReportId + '/psych', data).then( function(response) {
                return response.data;
            })
        }

        function getMdeConclusionReport(mdeReportId){
            return $http.get(baseURL + mdeReportId + '/conclusion').then( function(response) {
                return response.data;
            })
        }

        function saveMdeConclusionReport(mdeReportId, data){
            return $http.post(baseURL + mdeReportId + '/conclusion', data).then( function(response) {
                return response.data;
            })
        }

        function getMdeAdminReport(id){
            return $http.get(baseURL + id + prefixApiAdmin).then( function(response) {
                return response.data;
            })
        }

        function findById(id) {
            var deferred = $q.defer();
            var url = baseURL + "find-by-id/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };


        function saveMdeAdminReport(id, data) {
            return $http.put(baseURL + id + prefixApiAdmin, data).then( function(response) {
                return response.data;
            })
        }

        /**
         *
         * @param  mdeId
         *
         * @returns
         */
        function createMdeReport(id){
            var url = baseURL + id;
             return $http.post(url);
         }

        /**
         *
         * @param  mdeId
         * @param searchKey
         * @returns
         */
        function updateAdminAbandoned(id, caseNumber){
            return $http.put(baseURL + id + prefixApiAdmin + "/update-abandoned").then(function (response) {
                 return response.data;
             })
         }

        function finalizeMdeReport(mdeReportId) {
            var url = baseURL + 'finalize-mde-report/' + mdeReportId;
            return $http.put(url).then(function (response) {
                return response.data;
            })
        }

        function downloadMDEReport(mdeReportId) {
            var deferred = $q.defer();
            var url = baseURL + 'download-mde-report/' + mdeReportId;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentDisposition = headers('content-disposition');
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    var fileName = DownloadBlobService.getFileName(contentDisposition);
                    saveAs(blob, fileName);
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function loadPdfReportPreviewData(mdeReportId) {
            var deferred = $q.defer();
            var url = baseURL + 'preview-mde-report/' + mdeReportId;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    deferred.resolve(data);
                }
            });
            return deferred.promise;
        }

        function getPhysicalDemandLevels() {
            return $http.get(baseURL + '/physical-demand-levels').then( function(response) {
                return response.data;
            })
        }

        function isPatientActivated(id) {
            var deferred = $q.defer();
            var url = baseURL + "is-patient-activated/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;
    };
})();
;
(function() {
    'use strict';

    HeaderReportController.$inject = [];

    function HeaderReportController() {
        var vm = this; //jshint ignore:line

        init();

        function init() {
        }

    }

    angular.module('ipmApp').component('headerReport', {
        bindings: {
            report: '<',
            titleTextTranslate: '<',
            isShowMdeOffice: '<'
        },
        templateUrl: 'app/frp-mde/header/header-report.html',
        controller: HeaderReportController,
        controllerAs: 'vm'
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('frp-report', {
			parent: 'app',
			url: '/frp-report/{id}',
			data: {
				authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
				pageTitle: ''
			},
			views: {
				'content@': {
					templateUrl: 'app/frp-mde/frp-report/home/frp-report-home.html',
					controller: 'FRPReportHomeController',
					controllerAs: 'vm'
				}
			},
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                isPatientActivated: ['FrpReportService',  '$stateParams', '$state' , function (FrpReportService, $stateParams, $state) {
                    FrpReportService.isPatientActivated($stateParams.id).then(function() {});
                 }]
            }
		})
        .state('frp-report.ADMIN', {
            parent: 'frp-report',
            url: '/office',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/admin/frp-report-admin.html',
                    controller: 'FRPReportAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('attendanceTracker');
                    return $translate.refresh();
                }],
                 supportedDataList: ['Auth', function(Auth) {
                    return Auth.getSupportedListRegister();
                 }],
                 userDetails: ['User', function (User) {
                    return User.getUserByCurrentLogin();
                 }],
                 qhpUsers: ['User', function (User) {
                      return User.getAllQHPUsers();
                  }],
                 staffUsers: ['User', function (User) {
                      return User.getAllStaffUsers();
                  }],
                 reportAdmin :['FrpReportService',  '$stateParams', function(FrpReportService, $stateParams){
                    return FrpReportService.getAdminReport($stateParams.id);
                 }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                lectures: ['LectureService', function (LectureService) {
                    return LectureService.findAll();
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_ADMIN);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.ADMIN.VIEW', {
                parent: 'frp-report',
                url: '/office/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/admin/frp-report-admin.html',
                        controller: 'FRPReportAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('attendanceTracker');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    supportedDataList: ['Auth', function(Auth) {
                        return Auth.getSupportedListRegister();
                    }],
                    userDetails: ['User', function (User) {
                        return User.getUserByCurrentLogin();
                    }],
                    qhpUsers: ['User', function (User) {
                        return User.getAllQHPUsers();
                    }],
                    staffUsers: ['User', function (User) {
                        return User.getAllStaffUsers();
                    }],
                    reportAdmin :['FrpReportService',  '$stateParams', function(FrpReportService, $stateParams){
                        return FrpReportService.getAdminReport($stateParams.id);
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    lectures: ['LectureService', function (LectureService) {
                        return LectureService.findAll();
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_ADMIN);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.MEDICAL', {
            parent: 'frp-report',
            url: '/medical',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/ptp/frp-report-ptp.html',
                    controller: 'FRPReportPTPController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpmde');
                    $translatePartialLoader.addPart('frpReport');
                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.GENERAL);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.MEDICAL.VIEW', {
                parent: 'frp-report',
                url: '/medical/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/ptp/frp-report-ptp.html',
                        controller: 'FRPReportPTPController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('frpReport');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.GENERAL);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.PT', {
            parent: 'frp-report',
            url: '/physical-functional',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/pt/frp-report-pt.html',
                    controller: 'FRPReportPTController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('mdeReport');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PT);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.PT.VIEW', {
                parent: 'frp-report',
                url: '/physical-functional/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/pt/frp-report-pt.html',
                        controller: 'FRPReportPTController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('mdeReport');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PSYCH);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.PSYCH', {
            parent: 'frp-report',
            url: '/psych',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/psych/frp-report-psych.html',
                    controller: 'FRPReportPsychController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('instrumentType');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.getFRPReportPsych($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PSYCH);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.PSYCH.VIEW', {
                parent: 'frp-report',
                url: '/psych/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/psych/frp-report-psych.html',
                        controller: 'FRPReportPsychController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('instrumentType');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PSYCH);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.CONCLUSION', {
            parent: 'frp-report',
            url: '/conclusion',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/conclusion/frp-report-conclusion.html',
                    controller: 'FRPReportConclusionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('mdeReport');
                    $translatePartialLoader.addPart('frpmde');
                    $translatePartialLoader.addPart('goalStatus');

                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_CONCLUSION);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.CONCLUSION.VIEW', {
                parent: 'frp-report',
                url: '/conclusion/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/conclusion/frp-report-conclusion.html',
                        controller: 'FRPReportConclusionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('mdeReport');
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('goalStatus');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_CONCLUSION);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
            .state('frp-report.ADDENDUM', {
                parent: 'frp-report',
                url: '/addendum',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/addendum/frp-report-addendum.html',
                        controller: 'FRPReportAddendumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    isView: function () {
                        return false;
                    }
                }
            })
            .state('frp-report.ADDENDUM.VIEW', {
                parent: 'frp-report',
                url: '/addendum/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/addendum/frp-report-addendum.html',
                        controller: 'FRPReportAddendumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('mdeReport');
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('goalStatus');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
            .state('frp-report-preview', {
                parent: 'frp-report',
                url: '/preview',
                data: {
                    pageTitle: ''
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/frp-mde/pdf-report-preview-dialog/pdf-report-preview-dialog.html',
                        controller: 'PDFReportPreviewDiaglogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        windowClass: 'absolute-center',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            frpReportId: function($stateParams) {
                                return $stateParams.id;
                            },
                            pdfData: function(FrpReportService) {
                                return FrpReportService.loadPdfReportPreviewData($stateParams.id);
                            }
                        }
                    }).result.then(function() {
                        // $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('FrpReportService', FrpReportService);

    FrpReportService.$inject = ['$http', 'halClient', '$q', 'DownloadBlobService'];

    function FrpReportService ($http, halClient, $q, DownloadBlobService) {
        var baseURL = 'api/frp-report/';
        var prefixApiAdmin = '/office';

        var service = {
            'get': get,
            'createFrpReport': createFrpReport,
            'savedAttendanceTracker': savedAttendanceTracker,
            'getFrpConclusionReport': getFrpConclusionReport,
            'saveFrpConclusionReport': saveFrpConclusionReport,
            'getFrpPtReport': getFrpPtReport,
            'saveFrpPtReport': saveFrpPtReport,
            'getFRPReportPsych': getFRPReportPsych,
            'saveFRPReportPsych': saveFRPReportPsych,
            'getAdminReport': getAdminReport,
            'saveAdminReport': saveAdminReport,
            'getFrpMedicalReport': getFrpMedicalReport,
            'saveFrpMedicalReport': saveFrpMedicalReport,
            'findById': findById,
            'updateStatusFRP': updateStatusFRP,
            'finalizeFrpReport': finalizeFrpReport,
            'downloadFrpReport': downloadFrpReport,
            'loadPdfReportPreviewData': loadPdfReportPreviewData,
            'saveFRPReportAddendum': saveFRPReportAddendum,
            'isPatientActivated': isPatientActivated
        };

        function get(id){
            return $http.get(baseURL + id).then( function(response) {
                return response;
            })
        }

        function createFrpReport(frp) {
            var url = baseURL + 'create-frp-report';
            return $http.post(url, frp).then(function (resp) {
                return resp.data;
            });
        }

        function savedAttendanceTracker(frp) {
            var url = baseURL + 'save-attendance-tracker';
            return $http.post(url, frp).then(function (resp) {
                return resp.data;
            });
        }

        function updateStatusFRP(frp) {
            var url = baseURL + 'update-status-frp';
            return $http.post(url, frp).then(function (resp) {
                return resp.data;
            });
        }



        function getFrpConclusionReport(frpReportId) {
            return $http.get(baseURL + frpReportId + '/conclusion').then(function (response) {
                return response.data;
            })
        }

        function saveFrpConclusionReport(frpReportId, data){
            return $http.post(baseURL + frpReportId + '/conclusion', data).then( function(response) {
                return response.data;
            })
        }

        function getFrpPtReport(frpReportId) {
            return $http.get(baseURL + frpReportId + '/pt').then(function (response) {
                return response.data;
            })
        }

        function saveFrpPtReport(frpReportId, data){
            return $http.post(baseURL + frpReportId + '/pt', data).then( function(response) {
                return response.data;
            })
        }

        function getFRPReportPsych(frpReportId) {
            return $http.get(baseURL + frpReportId + '/psych').then(function (response) {
                return response.data;
            })
        }

        function saveFRPReportPsych(frpReport) {
            var url = baseURL + 'save-frp-report-psych';
            return $http.post(url, frpReport).then(function (resp) {
                return resp.data;
            });
        }

        function getAdminReport(id){
            return $http.get(baseURL + id + prefixApiAdmin).then(function (response) {
                return response.data;
            })
        }

        function saveAdminReport(id, data){
            return $http.put(baseURL + id + prefixApiAdmin, data).then(function (response) {
                return response.data;
            })
        }

        function getFrpMedicalReport(frpReportId) {
            return $http.get(baseURL + frpReportId + '/medical').then(function (response) {
                return response.data;
            })
        }

        function saveFrpMedicalReport(frpReportId, data) {
            return $http.post(baseURL + frpReportId + '/medical', data).then( function(response) {
                return response.data;
            })
        }

        function saveFRPReportAddendum(frpReport) {
            var url = baseURL + 'save-frp-report-addendum';
            return $http.post(url, frpReport).then(function (response) {
                return response.data;
            })
        }

        function findById(id) {
            var deferred = $q.defer();
            var url = baseURL + "find-by-id/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function finalizeFrpReport(frpReportId, signature) {
            var url = baseURL + 'finalize-frp-report/' + frpReportId;
            return $http.put(url, signature).then(function (response) {
                return response.data;
            })
        }

        function downloadFrpReport(frpReportId) {
            var deferred = $q.defer();
            var url = baseURL + 'download-frp-report/' + frpReportId;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentDisposition = headers('content-disposition');
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    var fileName = DownloadBlobService.getFileName(contentDisposition);
                    saveAs(blob, fileName);
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function loadPdfReportPreviewData(frpReportId) {
            var deferred = $q.defer();
            var url = baseURL + 'preview-frp-report/' + frpReportId;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    deferred.resolve(data);
                }
            });
            return deferred.promise;
        }

        function isPatientActivated(id) {
            var deferred = $q.defer();
            var url = baseURL + "is-patient-activated/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ConfirmPasswordDialogController', ConfirmPasswordDialogController);

    ConfirmPasswordDialogController.$inject = ['$scope', '$uibModalInstance', '$q', '$state', 'isTranslate', 'message', 'title', 'frpMdeService'];

    function ConfirmPasswordDialogController($scope, $uibModalInstance, $q, $state, isTranslate, message, title, frpMdeService) {
        var vm = this;
        vm.message = message;
        vm.password = null;
        vm.inCorrectPassword = false;
        vm.title = title;
        vm.isTranslate = isTranslate ? isTranslate : false;

        function continuesDelete() {
                $uibModalInstance.close(vm.password);
                $uibModalInstance.dismiss('cancel');
        };

        vm.no = function () {
            $uibModalInstance.close(false);
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDeleteReport = function() {
            if (vm.password) {
                frpMdeService.confirmPassword(vm.password).then(function (response) {
                   if(response.data) {
                        continuesDelete();
                   } else {
                        vm.inCorrectPassword = true;
                   }
                });
            }
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ConfirmController', ConfirmController);

    ConfirmController.$inject = [
        '$scope',
        '$uibModalInstance',
        '$q',
        '$state',
        'message'
    ];

    function ConfirmController($scope, $uibModalInstance, $q, $state, message) {
        var vm = this;
        vm.message = message;

        vm.yes = function () {
            $uibModalInstance.close(true);
            $uibModalInstance.dismiss('cancel');
        }

        vm.no = function(){
            $uibModalInstance.close(false);
            $uibModalInstance.dismiss('cancel');
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('wellness-question', {
            parent: 'entity',
            url: '/wellness-question?page&sort&search',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.wellnessQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wellness-question/wellness-question.html',
                    controller: 'WellnessQuestionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                searchKey: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        searchKey: $stateParams.searchKey
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wellnessQuestion');
                    $translatePartialLoader.addPart('wellnessQuestionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('wellness-question.new', {
            parent: 'wellness-question',
            url: '/new',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.wellnessQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wellness-question/wellness-question-editor.html',
                    controller: 'WellnessQuestionEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wellnessQuestion');
                    $translatePartialLoader.addPart('wellnessQuestionType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return true;
                },
            }
        })
        .state('wellness-question.edit', {
            parent: 'wellness-question',
            url: '/:id/edit',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.wellnessQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wellness-question/wellness-question-editor.html',
                    controller: 'WellnessQuestionEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wellnessQuestion');
                    $translatePartialLoader.addPart('wellnessQuestionType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return false;
                },
            }
        })
        .state('wellness-question.delete', {
            parent: 'wellness-question',
            url: '/{id}/delete',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wellness-question/wellness-question-delete-dialog.html',
                    controller: 'WellnessQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['WellnessQuestion', function(WellnessQuestion) {
                            return WellnessQuestion.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('wellness-question', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('WellnessQuestion', WellnessQuestion);

    WellnessQuestion.$inject = ['$resource', '$q', 'halClient', '$http'];

    function WellnessQuestion ($resource, $q, halClient, $http) {
        var resourceUrl =  'api/wellness-questions/:id';

        var service = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        service.downloadPatientFacingContent = downloadPatientFacingContent;

        function downloadPatientFacingContent(id) {
            var deferred = $q.defer();
            var url = 'api/wellness-questions/' + id + "/download";
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    saveAs(blob, headers('fileName'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        };

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('WellnessQuestionController', WellnessQuestionController);

    WellnessQuestionController.$inject = ['$scope', '$state', 'Question', 'WellnessQuestion', 'ParseLinks', 'pagingParams', 'paginationConstants'];

    function WellnessQuestionController ($scope, $state, Question, WellnessQuestion, ParseLinks, pagingParams, paginationConstants) {
        var vm = this;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchQuery = pagingParams.searchKey;
        vm.currentSearch = pagingParams.searchKey;
        vm.pageSize = 20;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;

        vm.loadAll();

        function loadAll () {
            WellnessQuestion.query({
                searchKey: pagingParams.searchKey,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.questions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                //AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchKey: vm.currentSearch
            });
        }

        function search (searchKey) {
            if (!searchKey){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchKey;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = '';
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('WellnessQuestionEditorController', WellnessQuestionEditorController);

    WellnessQuestionEditorController.$inject = ['$scope', '$rootScope','$state', '$stateParams', 'isCreateNew', 'WellnessQuestion', 'Upload'];

    function WellnessQuestionEditorController($scope, $rootScope, $state, $stateParams, isCreateNew, WellnessQuestion, Upload) {
        var vm = this;
        vm.isSaving = false;
        vm.isCreateNew = isCreateNew;
        vm.questionTypes = ['SELECT_ONE', 'MULTI_SELECT', 'FREE_TEXT'] ;
        vm.init = init;
        vm.save = save;
        vm.hasChanged = false;
        vm.addOption = addOption;
        vm.removeOption = removeOption;
        vm.fileId = null;
        vm.hasChanged = false;
        init();

        function init() {

            if ($stateParams.id) {
                WellnessQuestion.get({id : $stateParams.id}, function(res) {
                    // set test data
                    vm.question = res;
                    vm.fileId = vm.question.fileId;
                    if (!vm.question.options || vm.question.options.length === 0 ) {
                        vm.question.options = [];
                        vm.question.options.push({});
                        vm.question.options.push({});
                    } else if(vm.question.options.length === 1) {
                        vm.question.options = [];
                        vm.question.options.push({});
                    }
                });
            } else {
                vm.question = {
                    name: null,
                    prompt: null,
                    type: null,
                    id: null,
                    options: [{}, {}]
                };
            }
        }

        vm.uploadChanged = function (file) {
            if(file.length > 0) {
                vm.file = file[0];
                vm.hasChanged = true;
            }
        }

        function save() {
            // remove scoring message empty
            var options = [];
            angular.forEach(vm.question.options, function (option) {
                if (option.name || option.output ) {
                    options.push(option);
                }
            });
            // re-assign to question object
            vm.question.options = options;

            vm.isSaving = true;
            if(vm.isCreateNew) {
                WellnessQuestion.save(vm.question, onSaveSuccess, onSaveError);
            } else {
                WellnessQuestion.update(vm.question, onSaveSuccess, onSaveError);
            }

        }

        var onSaveSuccess = function (result) {
            if(vm.hasChanged) {
                Upload.upload({
                    url: 'api/wellness-questions/'+result.id+'/upload',
                    data: {file: vm.file}
                }).progress(function (evt) {
                    //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (data, status, headers, config) {
                    vm.isSaving = false;
                    $state.go('wellness-question');
                }).error(function (data, status, headers, config) {

                });
            } else {
                vm.isSaving = false;
                $state.go('wellness-question');
            }
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        function addOption() {
            vm.question.options.push({});
        }

        function removeOption (index) {
            vm.question.options = _.reject(vm.question.options, function(v, i) { return index === i });
        }

        vm.removePdf = function() {
            vm.file = null;
            vm.fileId = null;
            vm.hasChanged = true;
        };

        vm.downloadPdf = function () {
            WellnessQuestion.downloadPatientFacingContent( vm.question.id).then(function(res) {

            });
        };

        vm.back = function () {
            $state.go('wellness-question');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('WellnessQuestionDeleteController',WellnessQuestionDeleteController);

    WellnessQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'WellnessQuestion'];

    function WellnessQuestionDeleteController($uibModalInstance, entity, WellnessQuestion) {
        var vm = this;
        vm.question = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            WellnessQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('WellnessClassService', WellnessClassService);

    WellnessClassService.$inject = ['$resource', '$q', 'halClient', '$http'];

    function WellnessClassService($resource,$q, halClient, $http) {
        var baseUrl = 'api/wellness-class';
        var resourceUrl = "api/wellness-class/:id";
        var service = $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'delete': {method: 'DELETE'}
        });

        service.findByClassSessionId = findByClassSessionId;
        service.updateInstructorPatientPresentation = updateInstructorPatientPresentation;

        function findByClassSessionId(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/find-by-class-session-id/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function updateInstructorPatientPresentation(wellnessClassSession) {
            var deferred = $q.defer();
            var url = baseUrl + "/update-instructor-patient-presentation";
            halClient.$post(url, null, wellnessClassSession).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('test', {
            parent: 'entity',
            url: '/test',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.test.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/test/tests.html',
                    controller: 'TestController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('test');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('section');
                    $translatePartialLoader.addPart('questionType');
                    return $translate.refresh();
                }]
            }
        })
        .state('test.new', {
            parent: 'test',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.test.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/test/test-editor.html',
                    controller: 'TestEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('test');
                    return $translate.refresh();
                }],
                isDuplicate: function () {
                    return false;
                },
                isCreateNew: function () {
                    return true;
                },
                isView: function () {
                    return false;
                }
            }
        })
        .state('test.edit', {
            parent: 'test',
            url: '/:id/edit?isFromHAQ',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.test.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/test/test-editor.html',
                    controller: 'TestEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('test');
                    return $translate.refresh();
                }],
                isDuplicate: function () {
                    return false;
                },
                isCreateNew: function () {
                    return false;
                },
                isView: function () {
                    return false;
                },
            }
        })
        .state('test.duplicate', {
            parent: 'test',
            url: '/:id/duplicate',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.test.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/test/test-editor.html',
                    controller: 'TestEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('test');
                    return $translate.refresh();
                }],
                isDuplicate: function () {
                    return true;
                },
                isCreateNew: function () {
                    return false;
                },
                isView: function () {
                    return false;
                },
            }
        })
        .state('test.edit.section-editor', {
            parent: 'test.edit',
            url: '/section/{sectionId}/editor',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.section.editor.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section/section-editor.html',
                    controller: 'SectionEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('section');
                    $translatePartialLoader.addPart('questionType');
                    $translatePartialLoader.addPart('question');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Section', function($stateParams, Section) {
                    return Section.get({id : $stateParams.sectionId});
                }]
            }
        })
        .state('test.edit.section-new', {
            parent: 'test.edit',
            url: '/section/new',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.section.editor.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section/section-editor.html',
                    controller: 'SectionEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('section');
                    $translatePartialLoader.addPart('questionType');
                    $translatePartialLoader.addPart('question');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        nameEn: null,
                        nameEs: null,
                        orderNumber: null,
                        instructionsEn: null,
                        instructionsEs: null,
                        id: null
                    };
                }
            }
        })
        .state('test.edit.section-editor.questionNew', {
            parent: 'test.edit.section-editor',
            url: '/question/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question/question-dialog.html',
                    controller: 'QuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['$stateParams', function ($stateParams) {
                            var d = new Date();
                            var n = d.getTime();
                            return {
                                nameEn: null,
                                nameEs: null,
                                type: null,
                                orderNumber: null,
                                id: null,
                                sectionId: parseInt($stateParams.sectionId)
                                // options: [
                                //     {
                                //         id: -n,
                                //         nameEn: null,
                                //         nameEs: null,
                                //         orderNumber: 1,
                                //         type: 'NUMERIC',
                                //         deleted: false
                                //     }
                                // ]
                            };
                        }],
                        sectionEntity: ['Section', function(Section) {
                            return Section.get({id : $stateParams.sectionId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('test.edit.section-editor.questionEdit', {
            parent: 'test.edit.section-editor',
            url: '/question/{questionId}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question/question-dialog.html',
                    controller: 'QuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Question', function(Question) {
                            return Question.get({id : $stateParams.questionId});
                        }],
                        sectionEntity: ['Section', function(Section) {
                            return Section.get({id : $stateParams.sectionId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('question', null, { reload: true });
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('test.edit.section-editor.questionEditDelete', {
            parent: 'test.edit.section-editor',
            url: '/question/{questionId}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question/question-delete-dialog.html',
                    controller: 'QuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Question', function(Question) {
                            return Question.get({id : $stateParams.questionId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('^',  null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('test.delete', {
            parent: 'test',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/test/test-delete-dialog.html',
                    controller: 'TestDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Test', function(Test) {
                            return Test.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('test', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Test', Test);

    Test.$inject = ['$resource', '$q', 'halClient', '$http'];

    function Test ($resource, $q, halClient, $http) {
        var baseUrl = 'api/tests';
        var resourceUrl =  'api/tests/:id';

        var service =  $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
        service.findAll = findAll;
        service.changeActivated = changeActivated;
        service.getAllTestsByActive = getAllTestsByActive;
        service.getAllActiveAdhocTests = getAllActiveAdhocTests;
        service.duplicate = duplicate;

        function findAll(pageable) {
            var deferred = $q.defer();

            var url = baseUrl;
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function changeActivated(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/change-activated/" + id;
            halClient.$post(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };



        function getAllTestsByActive(pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/get-all-by-active';
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function getAllActiveAdhocTests() {
            var deferred = $q.defer();

            var url = baseUrl + '/get-all-adhoc-tests';
            $http.get(url).success(function (data, status, headers) {
                var result = new Object();
                result = data && data !== undefined ? data : [];
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function duplicate(id, testDTO) {
            var deferred = $q.defer();
            var url = baseUrl + "/" + id + "/" + "duplicate";
            halClient.$post(url, null, testDTO).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('TestSearch', TestSearch);

    TestSearch.$inject = ['$resource'];

    function TestSearch($resource) {
        var resourceUrl =  'api/_search/tests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('TestController', TestController);

    TestController.$inject = ['$scope', '$state', 'Test', 'TestSearch'];

    function TestController ($scope, $state, Test, TestSearch) {
        var vm = this;
        vm.tests = [];

        vm.totalItems = 0;
        vm.pageSize = 20;
        vm.page = 1;
        vm.predicate = 'id';
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.changeActivated = changeActivated;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: 20,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            Test.findAll(pageable).then(function (response) {
                vm.totalItems = response && response.totalItems ? response.totalItems : 0;
                vm.tests = response && response.data ? response.data : [];
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        function changeActivated(id) {
            Test.changeActivated(id).then(function(res) {
                vm.loadAll();
            });
        }

        // vm.loadAll = function() {
        //     Test.query(function(result) {
        //         vm.tests = result;
        //     });
        // };

        // vm.search = function () {
        //     if (!vm.searchQuery) {
        //         return vm.loadAll();
        //     }
        //     TestSearch.query({query: vm.searchQuery}, function(result) {
        //         vm.tests = result;
        //     });
        // };
        // vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('TestEditorController', TestEditorController);

        TestEditorController.$inject = ['$scope', '$rootScope','$state', '$stateParams', 'isView', 'isCreateNew', 'isDuplicate', 'Test', 'BatteryTest', 'Section'];

    function TestEditorController($scope, $rootScope, $state, $stateParams, isView, isCreateNew, isDuplicate, Test, BatteryTest, Section) {
        var vm = this;
        vm.isSaving = false;
        // vm.test = entity;
        vm.isDuplicate = isDuplicate;
        vm.isCreateNew = isCreateNew;
        vm.isView = isView;
        vm.scoringTypes = vm.isView ? ['SUM', 'PERCENTAGE', 'CUSTOM', 'AVERAGE', 'NONE'] : ['SUM', 'PERCENTAGE', 'AVERAGE', 'NONE'];
        vm.thresholdTypes = ['GREATER_THAN', 'LESS_THAN', 'NONE'];
        vm.haqEvaluationTypes = ['COMM', 'SOAPP_5', 'EPWORTH', 'ISI', 'CES_D', 'GAD_7', 'FAB_Q', 'TSK', 'PCS', 'OSWESTRY', 'QUICKDASH', 'PDI', 'NDI'];
        vm.init = init;
        vm.save = save;
        vm.addNewScoreMessage = addNewScoreMessage;
        vm.handlePdfDescription = handlePdfDescription;
        vm.handleInstructionsEn = handleInstructionsEn;
        vm.handleInstructionsEs = handleInstructionsEs;
        vm.handleDescriptionEn = handleDescriptionEn;
        vm.handleDescriptionEs = handleDescriptionEs;
        vm.removeScoringMessages = removeScoringMessages;

        init();

        function init() {

          if ($stateParams.id) {
            Test.get({id : $stateParams.id}, function(res) {
              // set test data
              vm.test = res;

              vm.isEdit = !vm.isView && !vm.isDuplicate && !vm.isCreateNew;

              if (vm.isView) {
                // disable form
              } else {
                  if(vm.isDuplicate || vm.isCreateNew) {
                      if (!vm.test.scoreMessages || vm.test.scoreMessages.length === 0 ) {
                          vm.test.scoreMessages = [];
                          vm.test.scoreMessages.push({});

                      }
                      if(vm.isDuplicate && vm.test.scoringType === 'CUSTOM') {
                        // remove Scoring Type = 'CUSTOM' if is duplicate
                        vm.test.scoringType = undefined;
                      }
                  }
              }
            });
          } else {
            vm.test = {
              nameEn: null,
              nameEs: null,
              instructionsEn: null,
              instructionsEs: null,
              activated: true,
              active: true,
              id: null,
              scoreMessages: [{}]
            };
          }



        }


        function save() {
          // remove scoring message empty
          var newScoreMessagesLists = [];
          angular.forEach(vm.test.scoreMessages, function (scoreMessage) {
              if (scoreMessage.atLeast || scoreMessage.lessThan || scoreMessage.textMessage) {
                newScoreMessagesLists.push(scoreMessage);
              }
          });
          // re-assign to question object
          vm.test.scoreMessages = newScoreMessagesLists;

          vm.isSaving = true;
          if (vm.isDuplicate) {
            Test.duplicate(vm.test.id, vm.test).then(function(res) {
              vm.isSaving = false;
              $state.go('test');
            });
          } else {
            Test.save(vm.test, onSaveSuccess, onSaveError);
          }
        }

        var onSaveSuccess = function (result) {
            vm.isSaving = false;
            $state.go('test');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        function addNewScoreMessage() {
            vm.test.scoreMessages.push({});
        }

        function handleInstructionsEn(value) {
          vm.test.instructionsEn =  value;
        }

        function handleInstructionsEs(value) {
          vm.test.instructionsEs =  value;
        }

        function handleDescriptionEn(value) {
          vm.test.descriptionEn =  value;
        }

        function handleDescriptionEs(value) {
          vm.test.descriptionEs =  value;
        }

        function handlePdfDescription(value, editForm) {
            if (editForm && editForm['pdfDescription'] && !editForm['pdfDescription'].$dirty) {
                editForm['pdfDescription'].$setDirty();
            }
            editForm['pdfDescription'].$setViewValue(value);
        }

        function removeScoringMessages (index) {
          vm.test.scoreMessages = _.reject(vm.test.scoreMessages, function(v, i) { return index === i });
      }

        var unsubscribe = $rootScope.$on('ipmApp:testUpdate', function(event, result) {
          vm.test = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.back = function () {
          if ($stateParams.isFromHAQ) {
              $state.go('haqs-battery');
              return;
          }
          $state.go('test');
      };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('TestDialogController', TestDialogController);

    TestDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Test', 'BatteryTest', 'Section'];

    function TestDialogController ($scope, $stateParams, $uibModalInstance, entity, Test, BatteryTest, Section) {
        var vm = this;
        vm.test = entity;
        vm.batterytests = BatteryTest.query();
        vm.sections = Section.query();
        vm.load = function(id) {
            Test.get({id : id}, function(result) {
                vm.test = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:testUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.test.id !== null) {
                Test.update(vm.test, onSaveSuccess, onSaveError);
            } else {
                Test.save(vm.test, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('TestDetailController', TestDetailController);

    TestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Test', 'BatteryTest', 'Section'];

    function TestDetailController($scope, $rootScope, $stateParams, entity, Test, BatteryTest, Section) {
        var vm = this;
        vm.test = entity;
        vm.load = function (id) {
            Test.get({id: id}, function(result) {
                vm.test = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:testUpdate', function(event, result) {
            vm.test = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('TestDeleteController',TestDeleteController);

    TestDeleteController.$inject = ['$uibModalInstance', 'entity', 'Test'];

    function TestDeleteController($uibModalInstance, entity, Test) {
        var vm = this;
        vm.test = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Test.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('survey-result', {
            parent: 'entity',
            url: '/survey-result',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.surveyResult.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey-result/survey-results.html',
                    controller: 'SurveyResultController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('surveyResultStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('survey-result-detail', {
            parent: 'entity',
            url: '/survey-result/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.surveyResult.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey-result/survey-result-detail.html',
                    controller: 'SurveyResultDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('surveyResultStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SurveyResult', function($stateParams, SurveyResult) {
                    return SurveyResult.get({id : $stateParams.id});
                }]
            }
        })
        .state('survey-result.new', {
            parent: 'survey-result',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-result/survey-result-dialog.html',
                    controller: 'SurveyResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                createdDate: null,
                                lastModifiedDate: null,
                                disposition: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('survey-result', null, { reload: true });
                }, function() {
                    $state.go('survey-result');
                });
            }]
        })
        .state('survey-result.edit', {
            parent: 'survey-result',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-result/survey-result-dialog.html',
                    controller: 'SurveyResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SurveyResult', function(SurveyResult) {
                            return SurveyResult.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey-result', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('survey-result.delete', {
            parent: 'survey-result',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-result/survey-result-delete-dialog.html',
                    controller: 'SurveyResultDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SurveyResult', function(SurveyResult) {
                            return SurveyResult.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey-result', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('SurveyResult', SurveyResult);

    SurveyResult.$inject = ['$resource', 'DateUtils'];

    function SurveyResult ($resource, DateUtils) {
        var resourceUrl =  'api/survey-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('SurveyResultSearch', SurveyResultSearch);

    SurveyResultSearch.$inject = ['$resource'];

    function SurveyResultSearch($resource) {
        var resourceUrl =  'api/_search/survey-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResultController', SurveyResultController);

    SurveyResultController.$inject = ['$scope', '$state', 'SurveyResult', 'SurveyResultSearch'];

    function SurveyResultController ($scope, $state, SurveyResult, SurveyResultSearch) {
        var vm = this;
        vm.surveyResults = [];
        vm.loadAll = function() {
            SurveyResult.query(function(result) {
                vm.surveyResults = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SurveyResultSearch.query({query: vm.searchQuery}, function(result) {
                vm.surveyResults = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResultDialogController', SurveyResultDialogController);

    SurveyResultDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'SurveyResult', 'Patient', 'Battery'];

    function SurveyResultDialogController ($scope, $stateParams, $uibModalInstance, entity, SurveyResult, Patient, Battery) {
        var vm = this;
        vm.surveyResult = entity;
        vm.patients = Patient.query();
        vm.batterys = Battery.query();
        vm.load = function(id) {
            SurveyResult.get({id : id}, function(result) {
                vm.surveyResult = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:surveyResultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.surveyResult.id !== null) {
                SurveyResult.update(vm.surveyResult, onSaveSuccess, onSaveError);
            } else {
                SurveyResult.save(vm.surveyResult, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResultDetailController', SurveyResultDetailController);

    SurveyResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SurveyResult', 'Patient', 'Battery'];

    function SurveyResultDetailController($scope, $rootScope, $stateParams, entity, SurveyResult, Patient, Battery) {
        var vm = this;
        vm.surveyResult = entity;
        vm.load = function (id) {
            SurveyResult.get({id: id}, function(result) {
                vm.surveyResult = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:surveyResultUpdate', function(event, result) {
            vm.surveyResult = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResultDeleteController',SurveyResultDeleteController);

    SurveyResultDeleteController.$inject = ['$uibModalInstance', 'entity', 'SurveyResult'];

    function SurveyResultDeleteController($uibModalInstance, entity, SurveyResult) {
        var vm = this;
        vm.surveyResult = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SurveyResult.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('survey-response', {
            parent: 'entity',
            url: '/survey-response',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.surveyResponse.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey-response/survey-responses.html',
                    controller: 'SurveyResponseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResponse');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('survey-response-detail', {
            parent: 'entity',
            url: '/survey-response/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.surveyResponse.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey-response/survey-response-detail.html',
                    controller: 'SurveyResponseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResponse');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SurveyResponse', function($stateParams, SurveyResponse) {
                    return SurveyResponse.get({id : $stateParams.id});
                }]
            }
        })
        .state('survey-response.new', {
            parent: 'survey-response',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-response/survey-response-dialog.html',
                    controller: 'SurveyResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                answer: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('survey-response', null, { reload: true });
                }, function() {
                    $state.go('survey-response');
                });
            }]
        })
        .state('survey-response.edit', {
            parent: 'survey-response',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-response/survey-response-dialog.html',
                    controller: 'SurveyResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SurveyResponse', function(SurveyResponse) {
                            return SurveyResponse.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey-response', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('survey-response.delete', {
            parent: 'survey-response',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-response/survey-response-delete-dialog.html',
                    controller: 'SurveyResponseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SurveyResponse', function(SurveyResponse) {
                            return SurveyResponse.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey-response', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('SurveyResponse', SurveyResponse);

    SurveyResponse.$inject = ['$resource'];

    function SurveyResponse ($resource) {
        var resourceUrl =  'api/survey-responses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('SurveyResponseSearch', SurveyResponseSearch);

    SurveyResponseSearch.$inject = ['$resource'];

    function SurveyResponseSearch($resource) {
        var resourceUrl =  'api/_search/survey-responses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResponseController', SurveyResponseController);

    SurveyResponseController.$inject = ['$scope', '$state', 'SurveyResponse', 'SurveyResponseSearch'];

    function SurveyResponseController ($scope, $state, SurveyResponse, SurveyResponseSearch) {
        var vm = this;
        vm.surveyResponses = [];
        vm.loadAll = function() {
            SurveyResponse.query(function(result) {
                vm.surveyResponses = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SurveyResponseSearch.query({query: vm.searchQuery}, function(result) {
                vm.surveyResponses = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResponseDialogController', SurveyResponseDialogController);

    SurveyResponseDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'SurveyResponse', 'BatteryTest', 'Patient', 'Question'];

    function SurveyResponseDialogController ($scope, $stateParams, $uibModalInstance, entity, SurveyResponse, BatteryTest, Patient, Question) {
        var vm = this;
        vm.surveyResponse = entity;
        vm.batterytests = BatteryTest.query();
        vm.patients = Patient.query();
        vm.questions = Question.query();
        vm.load = function(id) {
            SurveyResponse.get({id : id}, function(result) {
                vm.surveyResponse = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:surveyResponseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.surveyResponse.id !== null) {
                SurveyResponse.update(vm.surveyResponse, onSaveSuccess, onSaveError);
            } else {
                SurveyResponse.save(vm.surveyResponse, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResponseDetailController', SurveyResponseDetailController);

    SurveyResponseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SurveyResponse', 'BatteryTest', 'Patient', 'Question'];

    function SurveyResponseDetailController($scope, $rootScope, $stateParams, entity, SurveyResponse, BatteryTest, Patient, Question) {
        var vm = this;
        vm.surveyResponse = entity;
        vm.load = function (id) {
            SurveyResponse.get({id: id}, function(result) {
                vm.surveyResponse = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:surveyResponseUpdate', function(event, result) {
            vm.surveyResponse = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResponseDeleteController',SurveyResponseDeleteController);

    SurveyResponseDeleteController.$inject = ['$uibModalInstance', 'entity', 'SurveyResponse'];

    function SurveyResponseDeleteController($uibModalInstance, entity, SurveyResponse) {
        var vm = this;
        vm.surveyResponse = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SurveyResponse.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {       
        $stateProvider
        .state('section', {
            parent: 'entity',
            url: '/section',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.section.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section/sections.html',
                    controller: 'SectionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('section');
                    $translatePartialLoader.addPart('questionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('section-detail', {
            parent: 'entity',
            url: '/section/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.section.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section/section-detail.html',
                    controller: 'SectionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('section');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Section', function($stateParams, Section) {
                    return Section.get({id : $stateParams.id});
                }]
            }
        })
        .state('section-editor', {
            parent: 'entity',
            url: '/section/{id}/editor',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.section.editor.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section/section-editor.html',
                    controller: 'SectionEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('section');
                    $translatePartialLoader.addPart('questionType');
                    $translatePartialLoader.addPart('question');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Section', function($stateParams, Section) {
                    return Section.get({id : $stateParams.id});
                }]
            }
        })
        .state('section.new', {
            parent: 'section',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/section/section-dialog.html',
                    controller: 'SectionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        action: function() { return "NEW"},
                        entity: function () {
                            return {
                                nameEn: null,
                                nameEs: null,
                                orderNumber: null,
                                instructionsEn: null,
                                instructionsEs: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('section', null, { reload: true });
                }, function() {
                    $state.go('section');
                });
            }]
        })
        .state('section.edit', {
            parent: 'section',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/section/section-dialog.html',
                    controller: 'SectionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        action: function() { return "EDIT"},
                        entity: ['Section', function(Section) {
                            return Section.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('section', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('section.view', {
            parent: 'section',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/section/section-dialog.html',
                    controller: 'SectionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        action: function() { return "VIEW"},
                        entity: ['Section', function(Section) {
                            return Section.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('section', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('section.delete', {
            parent: 'section',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/section/section-delete-dialog.html',
                    controller: 'SectionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Section', function(Section) {
                            return Section.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('section', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Section', Section);

    Section.$inject = ['$resource', '$q', '$http'];
    // SectionFilter.$inject = ['$resource'];

    function Section ($resource, $q, $http) {


        var baseUrl = 'api/sections';
        var resourceUrl =  'api/sections/:id';

        var service =  $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        service.findByTest = findByTest;
        service.updateOrderNumber = updateOrderNumber;

        function findByTest(testId, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + "/find-by-test/" + testId;
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };


        function updateOrderNumber(testId, sections) {
            var url = baseUrl + "/update-order-number/" + testId;
            return $http.post(url, sections).then(function (resp) {
                return resp.data;
            });
        };

        return service;

        // var resourceUrl =  'api/sections/:id';

        // return $resource(resourceUrl, {}, {
        //     'query': { method: 'GET', isArray: true},
        //     'get': {
        //         method: 'GET',
        //         transformResponse: function (data) {
        //             data = angular.fromJson(data);
        //             return data;
        //         }
        //     },
        //     'update': { method:'PUT' }
        // });
    }
    // function SectionFilter ($resource) {
    //     var resourceUrl =  'api/sections/search';

    //     return $resource(resourceUrl, {}, {
    //         'search': { method: 'POST', isArray: true}
    //     });
    // }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('SectionSearch', SectionSearch);

    SectionSearch.$inject = ['$resource'];

    function SectionSearch($resource) {
        var resourceUrl =  'api/_search/sections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SectionController', SectionController);

    SectionController.$inject = ['$scope', '$state', 'Section', 'SectionSearch', 'SectionFilter'];

    function SectionController ($scope, $state, Section, SectionSearch, SectionFilter) {
        var vm = this;
        vm.sections = [];        
        vm.loadAll = function() {
            SectionFilter.search({testId: 2},function(result) {
                vm.sections = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SectionSearch.query({query: vm.searchQuery}, function(result) {
                vm.sections = result;
            });
        };
        vm.loadAll();
        
    }

    angular.module('ipmApp').component('sectionList', {
        templateUrl: 'app/entities/section/sections.html',
        controller: SectionController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('section');
                $translatePartialLoader.addPart('questionType');
                $translatePartialLoader.addPart('global');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SectionController', SectionTestController);

    SectionTestController.$inject = ['$scope', '$timeout', 'Section'];

    function SectionTestController ($scope, $timeout, Section) {
        var vm = this;
        vm.totalItems = 0;
        vm.pageSize = 10000;
        vm.page = 1;
        vm.sections = [];
        vm.getSectionByTest = getSectionByTest;
        vm.sortableOptions = {
            placeholder: "ui-state-highlight",
            helper: function (event, ui) {
                var table = '<table style="position: absolute;" class="jh-table table table-striped"></table>';
                var draggedItem = $(table).append(ui[0].outerHTML);
                return draggedItem;
            },
            stop: function(e, ui) {
                var sections = ui.item.sortable.sourceModel;
                sections.forEach(function(section, index) {
                    section.orderNumber = (index + 1);
                });
                // call back-end to update
                Section.updateOrderNumber(vm.idt, sections).then();
            },
            disabled: vm.batteryId ? true : false
        };

        getSectionByTest();

        function getSectionByTest() {
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize
            };
            $timeout(function(){
                if (vm.idt) {
                    Section.findByTest(vm.idt, pageable).then(function(response) {
                        vm.totalItems = response && response.totalItems ? response.totalItems : 0;
                        vm.sections = response && response.data ? response.data : [];
                    })
                }
            }, 100);
            
            
        };
        
    }

    angular.module('ipmApp').component('sectionListForTest', {
        bindings: {
            idt: '<',
        },
        templateUrl: 'app/entities/section/sections-test.html',
        controller: SectionTestController,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SectionEditorController', SectionEditorController);

    SectionEditorController.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'entity', 'Section', 'Test', 'Question', '$uibModal'];

    function SectionEditorController($scope, $state, $rootScope, $stateParams, entity, Section, Test, Question, $uibModal) {
        var vm = this;
        vm.isSaving = false;
        vm.section = entity;
        vm.invertScoring = invertScoring;
        vm.questionTypeChange = questionTypeChange;
        vm.deleteQuestion = deleteQuestion;
        vm.sortableOptions = {
            placeholder: "ui-state-highlight",
            helper: function (event, ui) {
                var table = '<table style="position: absolute;" class="jh-table table table-striped"></table>';
                var draggedItem = $(table).append(ui[0].outerHTML);
                return draggedItem;
            },
            update: function(e, ui) {
                
            },
            stop: function(e, ui) {
                var questions = ui.item.sortable.sourceModel;
                questions.forEach(function(question, index) {
                    question.orderNumber = (index + 1);
                });
                // call back-end to update
                Question.updateOrderNumber(vm.section.id, questions).then();
            }
        };
        vm.load = function (id) {
            Section.get({id: id}, function(result) {
                vm.section = result;
            });
        };
        vm.save = function () {
            vm.isSaving = true;
            // set test id
            vm.section.testId = $stateParams.id;
            if (vm.section.id !== null) {
                Section.update(vm.section, onSaveSuccess, onSaveError);
            } else {
                Section.save(vm.section, onSaveSuccess, onSaveError);
            }
        };
        var onSaveSuccess = function (result) {
            vm.isSaving = false;
            $state.go('test.edit',{id: $stateParams.id});
        };

        var onSaveError = function () {
            vm.isSaving = false;
            vm.load(vm.section.id);
        };

        var unsubscribe = $rootScope.$on('ipmApp:questionUpdate', function(event, result) {
            vm.load(vm.section.id);
        });

        $scope.$on('$destroy', unsubscribe);

        vm.back = function () {
            $state.go('test.edit',{id: $stateParams.id});
        };

        function invertScoring(question) {
            if (question) {
                question.invertScoring = !question.invertScoring
                Question.invertScoring(question.id).then(function(res) {});
            }
        }

        function questionTypeChange() {
            vm.disabledCreateQuestion = true;
        }



        function deleteQuestion(question, index) {
            $uibModal.open({
                templateUrl: 'app/entities/question/question-delete-dialog.html',
                controller: 'QuestionDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: question
                }
            }).result.then(function() {
                vm.section.questions.splice(index, 1);
                // re-index
                angular.forEach(vm.section.questions, function (question, index) {
                    question.orderNumber = index + 1;
                });
                // call back-end to update
                Question.updateOrderNumber(vm.section.id, vm.section.questions).then();
            }, function() {
                // $state.go('^');
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SectionDialogController', SectionDialogController);

    SectionDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Section', 'Test', 'Question', 'action'];

    function SectionDialogController ($scope, $stateParams, $uibModalInstance, entity, Section, Test, Question, action) {
        var vm = this;
        vm.section = entity;
        vm.tests = Test.query();
        vm.questions = Question.query();
        vm.load = function(id) {
            Section.get({id : id}, function(result) {
                vm.section = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:sectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.section.id !== null) {
                Section.update(vm.section, onSaveSuccess, onSaveError);
            } else {
                Section.save(vm.section, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SectionDetailController', SectionDetailController);

    SectionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Section', 'Test', 'Question'];

    function SectionDetailController($scope, $rootScope, $stateParams, entity, Section, Test, Question) {
        var vm = this;
        vm.section = entity;
        vm.load = function (id) {
            Section.get({id: id}, function(result) {
                vm.section = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:sectionUpdate', function(event, result) {
            vm.section = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SectionDeleteController',SectionDeleteController);

    SectionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Section'];

    function SectionDeleteController($uibModalInstance, entity, Section) {
        var vm = this;
        vm.section = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Section.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('question-option', {
            parent: 'entity',
            url: '/question-option',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.questionOption.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/question-option/question-options.html',
                    controller: 'QuestionOptionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('questionOption');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('question-option-detail', {
            parent: 'entity',
            url: '/question-option/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.questionOption.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/question-option/question-option-detail.html',
                    controller: 'QuestionOptionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('questionOption');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QuestionOption', function($stateParams, QuestionOption) {
                    return QuestionOption.get({id : $stateParams.id});
                }]
            }
        })
        .state('question-option.new', {
            parent: 'question-option',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question-option/question-option-dialog.html',
                    controller: 'QuestionOptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nameEn: null,
                                nameEs: null,
                                orderNumber: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('question-option', null, { reload: true });
                }, function() {
                    $state.go('question-option');
                });
            }]
        })
        .state('question-option.edit', {
            parent: 'question-option',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question-option/question-option-dialog.html',
                    controller: 'QuestionOptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QuestionOption', function(QuestionOption) {
                            return QuestionOption.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('question-option', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('question-option.delete', {
            parent: 'question-option',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question-option/question-option-delete-dialog.html',
                    controller: 'QuestionOptionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QuestionOption', function(QuestionOption) {
                            return QuestionOption.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('question-option', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('QuestionOption', QuestionOption);

    QuestionOption.$inject = ['$resource'];

    function QuestionOption ($resource) {
        var resourceUrl =  'api/question-options/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('QuestionOptionSearch', QuestionOptionSearch);

    QuestionOptionSearch.$inject = ['$resource'];

    function QuestionOptionSearch($resource) {
        var resourceUrl =  'api/_search/question-options/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionOptionController', QuestionOptionController);

    QuestionOptionController.$inject = ['$scope', '$state', 'QuestionOption', 'QuestionOptionSearch'];

    function QuestionOptionController ($scope, $state, QuestionOption, QuestionOptionSearch) {
        var vm = this;
        vm.questionOptions = [];
        vm.loadAll = function() {
            QuestionOption.query(function(result) {
                vm.questionOptions = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            QuestionOptionSearch.query({query: vm.searchQuery}, function(result) {
                vm.questionOptions = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionOptionDialogController', QuestionOptionDialogController);

    QuestionOptionDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'QuestionOption', 'Question'];

    function QuestionOptionDialogController ($scope, $stateParams, $uibModalInstance, entity, QuestionOption, Question) {
        var vm = this;
        vm.questionOption = entity;
        vm.questions = Question.query();
        vm.load = function(id) {
            QuestionOption.get({id : id}, function(result) {
                vm.questionOption = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:questionOptionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.questionOption.id !== null) {
                QuestionOption.update(vm.questionOption, onSaveSuccess, onSaveError);
            } else {
                QuestionOption.save(vm.questionOption, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionOptionDetailController', QuestionOptionDetailController);

    QuestionOptionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'QuestionOption', 'Question'];

    function QuestionOptionDetailController($scope, $rootScope, $stateParams, entity, QuestionOption, Question) {
        var vm = this;
        vm.questionOption = entity;
        vm.load = function (id) {
            QuestionOption.get({id: id}, function(result) {
                vm.questionOption = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:questionOptionUpdate', function(event, result) {
            vm.questionOption = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionOptionDeleteController',QuestionOptionDeleteController);

    QuestionOptionDeleteController.$inject = ['$uibModalInstance', 'entity', 'QuestionOption'];

    function QuestionOptionDeleteController($uibModalInstance, entity, QuestionOption) {
        var vm = this;
        vm.questionOption = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            QuestionOption.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('question', {
            parent: 'entity',
            url: '/question',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.question.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/question/questions.html',
                    controller: 'QuestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('question');
                    $translatePartialLoader.addPart('questionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('question-detail', {
            parent: 'entity',
            url: '/question/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.question.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/question/question-detail.html',
                    controller: 'QuestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('question');
                    $translatePartialLoader.addPart('questionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Question', function($stateParams, Question) {
                    return Question.get({id : $stateParams.id});
                }]
            }
        })
        .state('question.new', {
            parent: 'section-editor',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question/question-dialog.html',
                    controller: 'QuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['$stateParams', function ($stateParams) {
                            var d = new Date();
                            var n = d.getTime();
                            return {
                                nameEn: null,
                                nameEs: null,
                                type: null,
                                orderNumber: null,
                                id: null,
                                sectionId: parseInt($stateParams.id),
                                options: [
                                    {
                                        id: -n,
                                        nameEn: null,
                                        nameEs: null,
                                        orderNumber: 1,
                                        type: 'NUMERIC',
                                        deleted: false
                                    }
                                ]
                            };
                        }],
                        sectionEntity: ['Section', function(Section) {
                            return Section.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('question.edit', {
            parent: 'section-editor',
            url: '/{questionId}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question/question-dialog.html',
                    controller: 'QuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Question', function(Question) {
                            return Question.get({id : $stateParams.questionId});
                        }],
                        sectionEntity: ['Section', function(Section) {
                            return Section.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('question', null, { reload: true });
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('question.delete', {
            parent: 'section-editor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/question/question-delete-dialog.html',
                    controller: 'QuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Question', function(Question) {
                            return Question.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('section-editor', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Question', Question);

    Question.$inject = ['$resource', '$q', 'halClient', '$http'];

    function Question ($resource, $q, halClient, $http) {
        var baseUrl = 'api/questions';
        var resourceUrl =  'api/questions/:id';

        var service = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
        service.invertScoring = invertScoring;
        service.updateOrderNumber = updateOrderNumber;

        function invertScoring(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/invert-scoring/" + id;
            halClient.$post(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function updateOrderNumber(testId, sections) {
            var url = baseUrl + "/update-order-number/" + testId;
            return $http.post(url, sections).then(function (resp) {
                return resp.data;
            });
        };

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('QuestionSearch', QuestionSearch);

    QuestionSearch.$inject = ['$resource'];

    function QuestionSearch($resource) {
        var resourceUrl =  'api/_search/questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionController', QuestionController);

    QuestionController.$inject = ['$scope', '$state', 'Question', 'QuestionSearch'];

    function QuestionController ($scope, $state, Question, QuestionSearch) {
        var vm = this;
        vm.questions = [];
        vm.loadAll = function() {
            Question.query(function(result) {
                vm.questions = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            QuestionSearch.query({query: vm.searchQuery}, function(result) {
                vm.questions = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionDialogController', QuestionDialogController);

    QuestionDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'sectionEntity', 'entity', 'Question', 'Section', 'QuestionOption'];

    function QuestionDialogController ($scope, $stateParams, $uibModalInstance, sectionEntity, entity, Question, Section, QuestionOption) {
        var vm = this;
        vm.question = entity;
        vm.maxOption = 6;
        vm.createQuestions = createQuestions;
        vm.optionRequired = optionRequired;
        //all your init controller goodness in here
        this.$onInit = function () {
            vm.isMiscType = sectionEntity.questionType === 'MISC';
            if (!vm.isMiscType) {
                vm.question.type = sectionEntity.questionType;
                // vm.question.orderNumber = sectionEntity.questions.length + 1;
                if(vm.question.type === 'RANK') {
                    vm.maxOption = 5;
                    vm.addRankOption();
                } else if (vm.question.type === 'MULTIPLE_CHOICE' || vm.question.type === 'MULTI_SELECT') {
                    if (vm.question && !vm.question.id) {
                      vm.question.options = [];
                      vm.createQuestions(2); // 2 question
                    }
                }
            } else {
                if(vm.question && vm.question.id && vm.question.type === 'RANK') {
                    vm.maxOption = 5;
                }
            }

        }
        vm.load = function(id) {
            Question.get({id : id}, function(result) {
                vm.question = result;
            });
        };
        vm.sortableOptions = {
            placeholder: "ui-state-highlight",
            helper: function (event, ui) {
                var table = '<table style="position: absolute;" class="jh-table table table-striped"></table>';
                var tbody = '<tbody>'+ui[0].outerHTML+'</tbody>';
                var draggedItem = $(table).append(tbody);
                return draggedItem;
            },
            update: function(e, ui) {

            },
            stop: function(e, ui) {
                var options = ui.item.sortable.sourceModel;
                options.forEach(function(option, index) {
                    option.orderNumber = (index + 1);
                });
            }
        };

        vm.addOption = function() {
            var d = new Date();
            var n = d.getTime();
            vm.question.options.push({
                id: -n,
                nameEn: null,
                nameEs: null,
                orderNumber: vm.question.options.length+1,
                type: 'NUMERIC',
                deleted: false
            });
        };
        vm.removeOption = function(optionId) {
            vm.question.options = _.reject(vm.question.options, { 'id': optionId});
            var index = 1;
            _.forEach(vm.question.options, function(option) {
                option.orderNumber = index++;
            });
        }
        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:questionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.question.type === 'MULTIPLE_CHOICE' || vm.question.type === 'MULTI_SELECT') {
                // remove options blank
                var newOptionLists = [];
                angular.forEach(vm.question.options, function (option) {
                    if (option.nameEn && option.nameEs && option.value) {
                        newOptionLists.push(option);
                    }
                });
                // re-index
                angular.forEach(newOptionLists, function (option, index) {
                    option.orderNumber = index + 1;
                });
                // re-assign to question object
                vm.question.options = newOptionLists;
            }
            if (vm.question.id !== null) {
                Question.update(vm.question, onSaveSuccess, onSaveError);
            } else {
                Question.save(vm.question, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.questionTypeChange = function() {
            vm.question.options = []; // reset
            if(vm.question.type === 'RANK') {
              vm.maxOption = 5;
                vm.addRankOption();
            } else if (vm.question.type === 'MULTIPLE_CHOICE' || vm.question.type === 'MULTI_SELECT') {
                vm.maxOption = 6;
                // add minimum 2 row
                if(vm.question.id === null) {
                  vm.createQuestions(2); // 2 question
                }
            }
        };

        vm.addRankOption = function() {
            if(vm.question.id === null) {
                vm.question.options = [];
                vm.createQuestions(5); // 5 question
            }
        }

        function createQuestions(numberOfRow) {
            for (var i = 1; i <= numberOfRow; i++) {
                vm.addOption();
            }
        }

        function optionRequired(index) {
            if (vm.question.type === 'RANK') {
                return true;
            }
            if (vm.question.type === 'MULTIPLE_CHOICE' || vm.question.type === 'MULTI_SELECT') {
                if (vm.question.options.length === 2) {
                    return true;
                }
                if (vm.question.options.length > 2) {
                    var l = _.filter(vm.question.options, function(option) { return option.nameEn && option.nameEs && option.value });
                    if (l.length < 2) {
                        return true;
                    }
                    var a = vm.question.options[index];
                    return a.nameEn || a.nameEs || a.value;
                }
            }
            return false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionDetailController', QuestionDetailController);

    QuestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Question', 'Section', 'QuestionOption'];

    function QuestionDetailController($scope, $rootScope, $stateParams, entity, Question, Section, QuestionOption) {
        var vm = this;
        vm.question = entity;
        vm.load = function (id) {
            Question.get({id: id}, function(result) {
                vm.question = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:questionUpdate', function(event, result) {
            vm.question = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionDeleteController',QuestionDeleteController);

    QuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Question'];

    function QuestionDeleteController($uibModalInstance, entity, Question) {
        var vm = this;
        vm.question = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Question.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('QHPMedicationService', QHPMedicationService);

        QHPMedicationService.$inject = ['$resource', '$http'];

    function QHPMedicationService($resource, $http) {
        var resourceUrl = 'api/qhp-medication';
        var service = $resource(resourceUrl, {}, {});
        service.searchByName = searchByName;

        function searchByName(name, excludeIds, type) {
            return $http.get(resourceUrl + '/search-by-name', { params: { name: name, excludeIds: excludeIds, type: type }}).then(function (response) {
                return response.data;
            });
        };

        return service;

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider', {
            parent: 'entity',
            url: '/provider?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.provider.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider/providers.html',
                    controller: 'ProviderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'lastName,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-detail', {
            parent: 'entity',
            url: '/provider/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.provider.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider/provider-detail.html',
                    controller: 'ProviderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Provider', function($stateParams, Provider) {
                    return Provider.get({id : $stateParams.id});
                }]
            }
        })
        .state('provider.new', {
            parent: 'provider',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-dialog.html',
                    controller: 'ProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                firstName: null,
                                lastName: null,
                                contactNumber: null,
                                emailAddress: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('provider', null, { reload: true });
                }, function() {
                    $state.go('provider');
                });
            }]
        })
        .state('provider.edit', {
            parent: 'provider',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-dialog.html',
                    controller: 'ProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Provider', function(Provider) {
                            return Provider.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider.delete', {
            parent: 'provider',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-delete-dialog.html',
                    controller: 'ProviderDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['Provider', function(Provider) {
                            return Provider.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Provider', Provider);

    Provider.$inject = ['$resource'];

    function Provider ($resource) {
        var resourceUrl =  'api/providers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('ProviderSearch', ProviderSearch);

    ProviderSearch.$inject = ['$resource'];

    function ProviderSearch($resource) {
        var resourceUrl =  'api/_search/providers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ProviderController', ProviderController);

    ProviderController.$inject = ['$scope', '$state', 'Provider', 'ProviderSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProviderController ($scope, $state, Provider, ProviderSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();
        vm.pageSize = 20;
        vm.totalItems = 0;
        vm.page = 1;

        function loadAll () {
            if (pagingParams.search) {
                ProviderSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Provider.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'lastName') {
                    result.push('lastName');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.providers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'lastName';
            vm.reverse = true;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'lastName';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ProviderDialogController', ProviderDialogController);

    ProviderDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Provider', 'ipmConstants'];

    function ProviderDialogController ($scope, $stateParams, $uibModalInstance, entity, Provider, constants) {
        var vm = this;
        vm.provider = entity;

        vm.load = function(id) {
            Provider.get({id : id}, function(result) {
                vm.provider = result;
                vm.errorContactNumberExists = null;
                vm.errorEmailExists = null;
                vm.errorProviderIdExists = null;
                if (!vm.provider.signature) {
                    vm.provider.signature = {};
                }
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:providerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function (error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if(error.status === 400 ) {
            	if (errorMessage === 'e-mail address already in use'){
            		vm.errorEmailExists = 'ERROR';
            	} else if (errorMessage === 'phone already in use') {
            		vm.errorContactNumberExists = 'ERROR';
            	} else if (errorMessage === 'provider id already in use') {
            		vm.errorProviderIdExists = 'ERROR';
            	} else {
            		vm.error = 'ERROR';
            	}
            }
        };

        vm.save = function () {
            vm.errorContactNumberExists = null;
            vm.errorEmailExists = null;
            vm.errorProviderIdExists = null;
            vm.error = null;

            vm.isSaving = true;
            vm.provider.credentials = vm.provider.credentials ? vm.provider.credentials : null;
            if (vm.provider.id !== null) {
                Provider.update(vm.provider, onSaveSuccess, onSaveError);
            } else {
                Provider.save(vm.provider, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ProviderDetailController', ProviderDetailController);

    ProviderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Provider'];

    function ProviderDetailController($scope, $rootScope, $stateParams, entity, Provider) {
        var vm = this;
        vm.provider = entity;
        vm.load = function (id) {
            Provider.get({id: id}, function(result) {
                vm.provider = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:providerUpdate', function(event, result) {
            vm.provider = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ProviderDeleteController',ProviderDeleteController);

    ProviderDeleteController.$inject = ['$uibModalInstance', 'entity', 'Provider'];

    function ProviderDeleteController($uibModalInstance, entity, Provider) {
        var vm = this;
        vm.provider = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Provider.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient', {
            parent: 'entity',
            url: '/patient',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.patient.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient/patients.html',
                    controller: 'PatientController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        // .state('patient-detail', {
        //     parent: 'entity',
        //     url: '/patient/{id}',
        //     data: {
        //         authorities: ['ROLE_ADMIN'],
        //         pageTitle: 'ipmApp.patient.detail.title'
        //     },
        //     views: {
        //         'content@': {
        //             templateUrl: 'app/entities/patient/patient-detail.html',
        //             controller: 'PatientDetailController',
        //             controllerAs: 'vm'
        //         }
        //     },
        //     resolve: {
        //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
        //             $translatePartialLoader.addPart('patient');
        //             return $translate.refresh();
        //         }],
        //         entity: ['$stateParams', 'Patient', function($stateParams, Patient) {
        //             return Patient.get({id : $stateParams.id});
        //         }]
        //     }
        // })
        .state('patient.new', {
            parent: 'patient',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-dialog.html',
                    controller: 'PatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateOfBirth: null,
                                patientId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient', null, { reload: true });
                }, function() {
                    $state.go('patient');
                });
            }]
        })
        .state('patient.edit', {
            parent: 'patient',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-dialog.html',
                    controller: 'PatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Patient', function(Patient) {
                            return Patient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient.delete', {
            parent: 'patient',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-delete-dialog.html',
                    controller: 'PatientDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Patient', function(Patient) {
                            return Patient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Patient', Patient);

    Patient.$inject = ['$resource', 'DateUtils', '$http'];

    function Patient ($resource, DateUtils, $http) {
        var resourceUrl =  'api/patients/:id';

        var service = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateOfBirth = DateUtils.convertLocalDateFromServer(data.dateOfBirth);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateOfBirth = DateUtils.convertLocalDateToServer(data.dateOfBirth);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateOfBirth = DateUtils.convertLocalDateToServer(data.dateOfBirth);
                    return angular.toJson(data);
                }
            }
        });

        service.findByNameOrChartNumber = findByNameOrChartNumber;

        function findByNameOrChartNumber(query, officeId, pageable) {
            var params = {
                query: query,
                officeId:officeId,
                page: pageable.page,
                size: pageable.size,
                sort: pageable.sort
            };
            return $http.get('api/patients/search/by-name-or-chart-number', {
                params: params
            }).then(function (response) {
                return response;
            });
        }

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('PatientSearch', PatientSearch);

    PatientSearch.$inject = ['$resource'];

    function PatientSearch($resource) {
        var resourceUrl =  'api/_search/patients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientController', PatientController);

    PatientController.$inject = ['$scope', '$state', 'Patient', 'PatientSearch'];

    function PatientController ($scope, $state, Patient, PatientSearch) {
        var vm = this;
        vm.patients = [];
        vm.loadAll = function() {
            Patient.query(function(result) {
                vm.patients = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PatientSearch.query({query: vm.searchQuery}, function(result) {
                vm.patients = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientDialogController', PatientDialogController);

    PatientDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Patient', 'User', 'SurveyResult'];

    function PatientDialogController ($scope, $stateParams, $uibModalInstance, $q, entity, Patient, User, SurveyResult) {
        var vm = this;
        vm.patient = entity;
        vm.users = User.query();
        vm.surveyresults = SurveyResult.query();
        vm.load = function(id) {
            Patient.get({id : id}, function(result) {
                vm.patient = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:patientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patient.id !== null) {
                Patient.update(vm.patient, onSaveSuccess, onSaveError);
            } else {
                Patient.save(vm.patient, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfBirth = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientDetailController', PatientDetailController);

    PatientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Patient', 'User', 'SurveyResult'];

    function PatientDetailController($scope, $rootScope, $stateParams, entity, Patient, User, SurveyResult) {
        var vm = this;
        vm.patient = entity;
        vm.load = function (id) {
            Patient.get({id: id}, function(result) {
                vm.patient = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:patientUpdate', function(event, result) {
            vm.patient = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientDeleteController',PatientDeleteController);

    PatientDeleteController.$inject = ['$uibModalInstance', 'entity', 'Patient'];

    function PatientDeleteController($uibModalInstance, entity, Patient) {
        var vm = this;
        vm.patient = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Patient.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('office', {
            parent: 'entity',
            url: '/office?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.office.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office/offices.html',
                    controller: 'OfficeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('office-detail', {
            parent: 'entity',
            url: '/office/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.office.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office/office-detail.html',
                    controller: 'OfficeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Office', function($stateParams, Office) {
                    return Office.get({id : $stateParams.id});
                }]
            }
        })
        .state('office.new', {
            parent: 'office',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office/office-dialog.html',
                    controller: 'OfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                contacts: [{'id': null, 'phoneNumber': null, 'emailAddress': null}],
                                contactRemoves:[],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: true });
                }, function() {
                    $state.go('office');
                });
            }]
        })
        .state('office.edit', {
            parent: 'office',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office/office-dialog.html',
                    controller: 'OfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Office', function(Office) {
                            return Office.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office.delete', {
            parent: 'office',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office/office-delete-dialog.html',
                    controller: 'OfficeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['Office', function(Office) {
                            return Office.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Office', Office);

    Office.$inject = ['$resource', '$http'];

    function Office ($resource, $http) {
        var resourceUrl =  'api/offices/:id';

        var service =  $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        service.getAllByLinkedUserLogged = getAllByLinkedUserLogged;

        function getAllByLinkedUserLogged(pageable) {
            return $http.get('api/offices/get-by-linked-user-logged', {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).then(function (response) {
                return response;
            });
        }

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('OfficeSearch', OfficeSearch);

    OfficeSearch.$inject = ['$resource'];

    function OfficeSearch($resource) {
        var resourceUrl =  'api/_search/offices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('OfficeController', OfficeController);

    OfficeController.$inject = ['$scope', '$state', 'Office', 'OfficeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OfficeController ($scope, $state, Office, OfficeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();
        vm.pageSize = 20;
        
        function loadAll () {
            if (pagingParams.search) {
                OfficeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Office.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.offices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                //AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('OfficeDialogController', OfficeDialogController);

    OfficeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Office', 'ipmConstants'];

    function OfficeDialogController ($scope, $stateParams, $uibModalInstance, entity, Office, constants) {
        var vm = this;
        vm.office = entity;
        vm.addPhone = addPhone;
        vm.removePhone = removePhone;
        vm.errorPhoneNumber = false;
        vm.duplicatePhoneNumber = false;
        vm.errorEmailAddress = false;
        vm.duplicatePhoneNumber = null;
        vm.load = function(id) {
            Office.get({id : id}, function(result) {
                vm.office = result;
                vm.errorContactNumberExists = null;
                vm.errorOfficeCodeExists = null;
            });
        };
        
        vm.testAdminBy = [
           { name: "Computer", value: "COMPUTER" },
           { name: "Technician", value: "TECHNICIAN" }
        ];
        
        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:officeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function (error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if(error.status === 400 ) {
            	if (errorMessage === 'phone already in use') {
            		vm.errorContactNumberExists = 'ERROR';
            	} else if (errorMessage === 'office code is exist') {
                    vm.errorOfficeCodeExists = 'ERROR';
                } else {
            		vm.error = 'ERROR';
            	}
            }
        };
        
        function addPhone () {
        	var newItem = {
        		    'phoneNumber':'',
        		    'id':'',
        		    'emailAddress':''
        		 }
        	vm.office.contacts.push(newItem);
        };
        
        function removePhone (index) {
        	vm.office.contactRemoves.push(vm.office.contacts[index]);
        	vm.office.contacts.splice(index, 1);
        };
        
        vm.save = function () {
        	vm.errorContactNumberExists = null;
        	vm.errorOfficeCodeExists = null;
        	vm.error = null;
            
            for (var i = 0; i < vm.office.contacts.length; i++) {
            	var contact = vm.office.contacts[i];
            	var count = 0;
            	angular.forEach(vm.office.contacts, function(value, key) {
            		if (contact.phoneNumber != undefined && value.phoneNumber != undefined 
            				&& contact.phoneNumber.length > 0 && value.phoneNumber.length > 0 
            				&& value.phoneNumber === contact.phoneNumber) {
            			count += 1;
            		}
            	});
            	
            	if (count > 1) {
    	  			vm.isSaving = false;
    	  			vm.duplicatePhoneNumber = 'ERROR';
    	  			return;
    			}
            }
            
  			vm.isSaving = true;
  			vm.duplicatePhoneNumber = null;
  			if (vm.office.id !== null) {
                Office.update(vm.office, onSaveSuccess, onSaveError);
            } else {
                Office.save(vm.office, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('OfficeDetailController', OfficeDetailController);

    OfficeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Office'];

    function OfficeDetailController($scope, $rootScope, $stateParams, entity, Office) {
        var vm = this;
        vm.office = entity;
        vm.load = function (id) {
            Office.get({id: id}, function(result) {
                vm.office = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:officeUpdate', function(event, result) {
            vm.office = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('OfficeDeleteController',OfficeDeleteController);

    OfficeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Office'];

    function OfficeDeleteController($uibModalInstance, entity, Office) {
        var vm = this;
        vm.office = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Office.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('MdeOfficeService', MdeOfficeService);

    MdeOfficeService.$inject = ['$resource','$q', 'halClient', '$http'];

    function MdeOfficeService($resource, $q, halClient, $http) {
        var baseUrl = 'api/mde-office';
        var service = {};

        service.findAll = findAll;

        function findAll() {
            var deferred = $q.defer();
            var url = baseUrl;
            $http.get(url).success(function (data) {
                deferred.resolve(data);
            }).error(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }

        return service;
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('LectureService', LectureService);

    LectureService.$inject = ['$resource','$q', 'halClient', '$http'];

    function LectureService($resource, $q, halClient, $http) {
        var baseUrl = 'api/lecture';
        var service = {};

        service.findAll = findAll;

        function findAll() {
            var deferred = $q.defer();
            var url = baseUrl;
            $http.get(url).success(function (data) {
                deferred.resolve(data);
            }).error(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invitation', {
            parent: 'entity',
            url: '/inv/{secretKey}',
            data: {
                authorities: [],
                pageTitle: 'ipmApp.invitation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invitation/invitation.html',
                    controller: 'InvitationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invitation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('InvitationService', InvitationService);

    InvitationService.$inject = ['$resource','$q', 'halClient', '$http', 'DateUtils', '$uibModal'];

    function InvitationService($resource, $q, halClient, $http, DateUtils, $uibModal) {
        var baseUrl = 'api/invitations';
        var resourceUrl = "api/invitations/:id";
        var service = $resource(resourceUrl, {}, {});
        service.resendHAQ = resendHAQ;
        service.resendNPQ = resendNPQ;
        service.resendPsychIntakeForm = resendPsychIntakeForm;
        service.resendPatientAgreement = resendPatientAgreement;
        service.findBySecretKey = findBySecretKey;
        service.openWarningMissingEmailPhone = openWarningMissingEmailPhone;
        service.openResendInvitationDialog = openResendInvitationDialog;

        function findBySecretKey(secretKey) {
            return $http.get(baseUrl, { params: { secretKey: secretKey }}).then(function (response) {
                return response;
            });
        };

        function resendHAQ(surveyResultId) {
            return $http.get(baseUrl + '/re-send-haq', { params: { surveyResultId: surveyResultId }}).then(function (response) {
                return response.data;
            });
        };

        function resendNPQ(nPQQuestionnaireId) {
            return $http.get(baseUrl + '/re-send-npq', { params: { nPQQuestionnaireId: nPQQuestionnaireId }}).then(function (response) {
                return response.data;
            });
        };

        function resendPsychIntakeForm(formId) {
            return $http.get(baseUrl + '/re-send-psych', { params: { formId: formId }}).then(function (response) {
                return response.data;
            });
        };

        function resendPatientAgreement(formId) {
            return $http.get(baseUrl + '/re-send-patient-agreement', {params: {formId: formId}}).then(function (response) {
                return response.data;
            });
        };

        function openWarningMissingEmailPhone() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.patient.resendInvitation.missing_email_phone"},
                    title: function () {return "ipmApp.patient.patientCase.warning"}
                }
            }).result.then(function() {
            });
        }

        function openResendInvitationDialog() {
            $uibModal.open({
                templateUrl: 'app/patient/resend-invitation-dialog.html',
                controller: 'ResendInvitationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                windowClass: 'absolute-center vertical-center'
            }).result.then(function() {});
        }

        return service;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('InvitationController', InvitationController);

    InvitationController.$inject = ['$state', '$stateParams', '$rootScope', 'ipmConstants', 'InvitationService', '$window', '$localStorage', 'ClearLocalStorageService'];

    function InvitationController($state, $stateParams, $rootScope, constants, InvitationService, $window, $localStorage, ClearLocalStorageService) {
        var vm = this;
        // if not have secretKey will navigate to error page
        if ($stateParams.secretKey === null || $stateParams.secretKey === '') {
            $state.go('error');
        }
        vm.errorHaqTestService = false;
        vm.secretKey = $stateParams.secretKey;
        vm.errorNotFound = false;
        vm.expiration = false;
        vm.isPageLoadFinish = false;
        vm.isHAQ = false;
        vm.isNPQ = false;
        vm.isPsychIntake = false;
        vm.isPatientAgreement = false;
        vm.init = init();

        function init() {
            delete $localStorage.isQuestionnaireIncomplete;
            delete $localStorage.firstIdOfAllNPQQuestionnaireNotComplete;
            delete $localStorage.isQuestionnaireCount;
            ClearLocalStorageService.clearWorkflow();
            ClearLocalStorageService.clearLandingPage();

            $window.localStorage.setItem(constants.INVITATION_SECRET_KEY, vm.secretKey);
            InvitationService.findBySecretKey(vm.secretKey).then(function (res) {
                if (res && res.status === 204) {
                    // HAQ_test flag is turned on
                    // If the patient clicks the link in the email they will receive an error message that says, " Looks like something went wrong, you do not need to take this questionaiire at this time. Thank you."
                    vm.errorHaqTestService = true;
                    vm.isPageLoadFinish = true;
                    return;
                }
                var response = res ? res.data : null;
                if (response) {
                    $rootScope.$broadcast(constants.EVT_AUTHENTICATION_SUCCESS_BY_INVITATION);
                    $window.localStorage.setItem(constants.INVITATION_WORKFLOW, true) // to detect when login to take patient go to npq or haq
                    if (response.invitation.expiration) {
                        vm.expiration = true;
                    } else if (response.invitation.surveyResult) {
                        vm.isHAQ = true;
                        vm.haqStatus = response.invitation.surveyResult.status;
                        if (vm.haqStatus !== 'COMPLETE' && vm.haqStatus !== 'DOWNLOADED') {
                            var surveyResultType = response.invitation.surveyResult.surveyResultType;
                            if (surveyResultType && surveyResultType != constants.SURVEY_RESULT_TYPE_BATTERY) {
                                $window.localStorage.setItem(constants.SURVEY_RESULT_ID, response.invitation.surveyResult.id);
                            }
                            $state.go('home');
                            return;
                        }
                    } else if (response.invitation.npqQuestionnaire) {
                        vm.isNPQ = true;
                        vm.npqStatus = response.invitation.npqQuestionnaire.status;
                        if (vm.npqStatus !== 'COMPLETE' && vm.npqStatus !== 'COMPLETED_OFF_PLATFORM' && vm.npqStatus !== 'NOT_NEEDED') {
                            $window.localStorage.setItem(constants.NPQ_QUESTIONNAIRE_ID, response.invitation.npqQuestionnaire.id);
                            $state.go('home');
                            return;
                        }
                    } else if (response.invitation.psychIntakeForm) {
                        vm.isPsychIntake = true;
                        vm.psychIntakeStatus = response.invitation.psychIntakeForm.status;
                        if (vm.psychIntakeStatus !== 'COMPLETE' && vm.psychIntakeStatus !== 'COMPLETED_OFF_PLATFORM' && vm.psychIntakeStatus !== 'NOT_NEEDED') {
                            $window.localStorage.setItem(constants.PSYCH_INTAKE_FORM_ID, response.invitation.psychIntakeForm.id);
                            $state.go('home');
                            return;
                        }
                    } else if (response.invitation.type === 'AGREEMENT' || response.invitation.patientAgreement) {
                        vm.isPatientAgreement = true;
                        if (response.invitation.patientAgreement === null) {
                            $state.go('home');
                            return;
                        }
                        vm.patientAgreementStatus = response.invitation.patientAgreement.status;
                        if (vm.patientAgreementStatus !== 'COMPLETE' && vm.patientAgreementStatus !== 'CANCEL') {
                            $window.localStorage.setItem(constants.PATIENT_AGREEMENT_ID, response.invitation.patientAgreement.id);
                            $state.go('home');
                            return;
                        }
                    }
                    vm.isPageLoadFinish = true;
                }
            }, function (response) {
                vm.isPageLoadFinish = true;
                if (response.status === 404) {
                    vm.errorNotFound = true;
                    return;
                }
                $state.go('error');
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('haqs-battery', {
            parent: 'app',
            url: '/haqs-battery',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.haqsBattery.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/haqs-battery/haqs-battery.html',
                    controller: 'HaqsBatteryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('haqs-battery');
                    $translatePartialLoader.addPart('battery');
                    return $translate.refresh();
                }]
            },
            params: {}
        }).state('haqs-battery.edit', {
            parent: 'haqs-battery',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.haqsBattery.home.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/haqs-battery/haqs-battery-editor.html',
                    controller: 'HaqsBatteryEditorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function (HaqsBatteryService) {
                            return HaqsBatteryService.findById($stateParams.id);
                        },
                    }
                }).result.then(function(test) {
                    if (test && test.id) {
                        $state.go('test.edit', {id: test.id, isFromHAQ: true});
                    } else {
                        $state.go('haqs-battery', null, {reload: true});
                    }
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('haqs-battery.new', {
            parent: 'haqs-battery',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.haqsBattery.home.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/haqs-battery/haqs-battery-editor.html',
                    controller: 'HaqsBatteryEditorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                nameEn: null,
                                nameEs: null,
                                orderNumber: null,
                                batteryId: null,
                                batteryTests: []
                            };
                        }
                    }
                }).result.then(function(test) {
                    if (test && test.id) {
                        $state.go('test.edit', {id: test.id, isFromHAQ: true});
                    } else {
                        $state.go('haqs-battery', null, {reload: true});
                    }
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('haq-tracks.duplicate', {
            parent: 'haqs-battery',
            url: '/{id}/duplicate',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/haqs-battery/haqs-battery-editor.html',
                    controller: 'HaqsBatteryEditorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function (HaqsBatteryService) {
                            return HaqsBatteryService.findById($stateParams.id);
                        },
                    }
                }).result.then(function(test) {
                    if (test && test.id) {
                        $state.go('test.edit', {id: test.id, isFromHAQ: true});
                    } else {
                        $state.go('haqs-battery', null, {reload: true});
                    }
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('HaqsBatteryService', HaqsBatteryService);

    HaqsBatteryService.$inject = ['$resource', '$q', 'halClient', '$http'];

    function HaqsBatteryService($resource, $q, halClient, $http) {
        var baseUrl = 'api/batteries';

        var service = $resource(baseUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
        });

        service.findById = findById;
        service.query= query;
        service.getAllBatteryForSelect= getAllBatteryForSelect;
        service.saveOrUpdate = saveOrUpdate;
        service.batteryDuplicate = batteryDuplicate;

        function query(pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/get-all-haqs-battery';
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        function getAllBatteryForSelect(type, patientId) {
            var deferred = $q.defer();
            var url = baseUrl + '/get-all-battery-for-select?type=' + type;
            if (patientId) {
                url = url + "&patientId=" + patientId;
            }
            $http.get(url).success(function (data) {
                deferred.resolve(data !== undefined ? data : []);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function findById(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/find-by-id/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function saveOrUpdate(battery) {
            var url = baseUrl + "/save-or-update";
            return $http.post(url, battery).then(function (resp) {
                return resp.data;
            });
        }

        function batteryDuplicate(battery) {
            var url = baseUrl + "/battery-duplicate";
            return $http.post(url, battery).then(function (resp) {
                return resp.data;
            });
        }

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqsBatteryController', HaqsBatteryController);

    HaqsBatteryController.$inject = ['$scope', '$state','$stateParams', '$window', 'HaqsBatteryService', 'ipmConstants'];

    function HaqsBatteryController ($scope, $state, $stateParams, $window, HaqsBatteryService, constants) {
        var vm = this;
        vm.haqsBattery = [];
        vm.page = 1;
        vm.totalItems = 0;
        vm.predicate = 'id';
        vm.reverse = false;
        vm.pageSize = constants.PAGE_SIZE;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.back = back;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: constants.PAGE_SIZE,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };
            HaqsBatteryService.query(pageable).then(function (response) {
                vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                vm.haqsBattery = response && response.data ? response.data : [];
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function back() {
            $window.history.back();
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqsBatteryEditorController', HaqsBatteryEditorController);

    HaqsBatteryEditorController.$inject = ['$stateParams', '$state', 'entity', '$window', 'HaqsBatteryService', '$uibModalInstance'];

    function HaqsBatteryEditorController($stateParams, $state, entity, $window, HaqsBatteryService, $uibModalInstance) {
        var vm = this;
        vm.haqsBattery = entity;
        vm.save = save;
        vm.isSaving = false;
        vm.clear = clear;
        vm.onchangeAssignedBatteryTests = onchangeAssignedBatteryTests;
        vm.testsOnChange = testsOnChange;
        vm.handlePdfDescription = handlePdfDescription;
        vm.batteryTestsDeleted = [];
        vm.errorBatteryIdExists = false;
        vm.batteryTests = [];
        vm.isStateDuplicate = false;
        init();

        function init() {
            if ($state.current && $state.current.name === 'haq-tracks.duplicate') {
                vm.isStateDuplicate = true;
            }
            if (vm.isStateDuplicate && vm.haqsBattery) { // duplicate
                vm.haqsBattery.nameEn = null;
                vm.haqsBattery.nameEs = null;
            }
            if (vm.haqsBattery.batteryTests) {
                vm.batteryTests = removeBatteryTestsInactive(vm.haqsBattery.batteryTests);
            }
        }

        function removeBatteryTestsInactive(batteryTests) {
            var batteryTestsActive = [];
            if (batteryTests) {
                batteryTestsActive = _.remove(batteryTests, function (n) {
                    return n.id && n.test && n.test.activated;
                });
            }
            return batteryTestsActive;
        }

        function save() {
            vm.isSaving = true;
            if (vm.haqsBattery) {
                if (vm.isStateDuplicate) { // duplicate
                    vm.haqsBattery.batteryTests = vm.batteryTests;
                    HaqsBatteryService.batteryDuplicate(vm.haqsBattery).then(function (res) {
                        onSaveSuccess(res);
                    }, function errorSave(error) {
                        onSaveError(error);
                    });
                } else { // save or update
                    if (vm.batteryTestsDeleted) {
                        vm.haqsBattery.batteryTests = _.concat(vm.batteryTests, vm.batteryTestsDeleted);
                    }
                    HaqsBatteryService.saveOrUpdate(vm.haqsBattery).then(function (res) {
                        onSaveSuccess(res);
                    }, function errorSave(error) {
                        onSaveError(error);
                    });
                }
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            vm.errorBatteryIdExists = true;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                $uibModalInstance.close(error);
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onchangeAssignedBatteryTests(batteryTests, batteryTestsDeleted) {
            vm.batteryTests = batteryTests ? batteryTests : [];
            vm.batteryTestsDeleted = batteryTestsDeleted ? batteryTestsDeleted : [];
        }

        function testsOnChange(test) {
            if (test && test.id) {
                $uibModalInstance.close(test); // close dialog, open editor test
            }
        }

        function handlePdfDescription(value, editForm) {
            if (editForm && editForm['pdfDescription'] && !editForm['pdfDescription'].$dirty) {
                editForm['pdfDescription'].$setDirty();
            }
            editForm['pdfDescription'].$setViewValue(value);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('haq-tracks', {
            parent: 'entity',
            url: '/haq-tracks',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.haqTracks.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/haq-tracks/haq-tracks.html',
                    controller: 'HaqTracksController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('haq-tracks');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('haq-tracks.new', {
                parent: 'haq-tracks',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/haq-tracks/haq-tracks-dialog.html',
                        controller: 'HaqTracksDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    id: null,
                                    active: true,
                                    isDefault: false,
                                    code: null,
                                    tracksAssigneds: []
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('haq-tracks', null, { reload: true });
                    }, function() {
                        $state.go('haq-tracks');
                    });
                }]
            })
            .state('haq-tracks.edit', {
                parent: 'haq-tracks',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/haq-tracks/haq-tracks-dialog.html',
                        controller: 'HaqTracksDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function (HaqTracksService) {
                                return HaqTracksService.findById($stateParams.id);
                            },
                        }
                    }).result.then(function() {
                        $state.go('haq-tracks', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('haq-tracks.delete', {
                parent: 'haq-tracks',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/haq-tracks/haq-tracks-delete-dialog.html',
                        controller: 'HaqTracksDeleteController',
                        controllerAs: 'vm',
                        size: 'sm',
                        windowClass: 'absolute-center',
                        resolve: {
                            entity: ['HaqTracksService', function(HaqTracksService) {
                                return HaqTracksService.findById($stateParams.id);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('haq-tracks', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('HaqTracksService', HaqTracksService);

    HaqTracksService.$inject = ['$resource','$q', 'halClient', '$http', 'DateUtils'];

    function HaqTracksService($resource, $q, halClient, $http, DateUtils) {
        var baseUrl = 'api/haq-tracks';
        var resourceUrl = "api/haq-tracks/:id";
        var service = $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'delete': {method: 'DELETE'}
        });
        service.getAllBatteryDefault = getAllBatteryDefault;
        service.findAll = findAll;
        service.findById = findById;

        function getAllBatteryDefault() {
            var deferred = $q.defer();
            var url = baseUrl + '/get-all-battery-default';
            $http.get(url)
                .success(function (result) {
                    deferred.resolve(result);
                }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function findAll(pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/find-all';
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function findById(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqTracksController', HaqTracksController);

    HaqTracksController.$inject = ['$scope', '$state', 'HaqTracksService', 'ipmConstants'];

    function HaqTracksController ($scope, $state, HaqTracksService, constants) {
        var vm = this;
        vm.haqTracks = [];
        vm.totalItems = 0;
        vm.pageSize = constants.PAGE_SIZE;
        vm.page = 1;
        vm.predicate = 'isDefault';
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: constants.PAGE_SIZE,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };

            HaqTracksService.findAll(pageable).then(function (response) {
                vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                vm.haqTracks = response && response.data ? response.data : [];
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'id') {
                result.push('id' + ',' + (vm.reverse ? 'desc' : 'asc'));
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.loadAll();
        }
    }
})();
;

(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqTracksDialogController', HaqTracksDialogController);

    HaqTracksDialogController.$inject = ['$stateParams', '$state', '$uibModalInstance','entity', 'HaqTracksService', '$scope'];

    function HaqTracksDialogController ($stateParams, $state, $uibModalInstance, entity, HaqTracksService, $scope) {
        var vm = this;
        vm.haqTracks = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.onchangeTracksAssigneds = onchangeTracksAssigneds;
        vm.haqTracksCodeExists = false;

        init();

        function init() {
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onchangeTracksAssigneds(tracksAssigneds) {
            vm.haqTracks.tracksAssigneds = tracksAssigneds ? tracksAssigneds : [];
        }

        function save() {
            vm.isSaving = true;
            if (vm.haqTracks) {
                if (vm.haqTracks.id !== null) {
                    HaqTracksService.update(vm.haqTracks, onSaveSuccess, onSaveError);
                } else {
                    HaqTracksService.save(vm.haqTracks, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            vm.haqTracksCodeExists = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            vm.haqTracksCodeExists = true;
        }

        $scope.$watch('vm.haqTracks.code', function (newval, oldval) {
            if (newval != oldval && vm.haqTracksCodeExists) {
                vm.haqTracksCodeExists = false;
            }
        });

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqTracksDeleteController', HaqTracksDeleteController);

    HaqTracksDeleteController.$inject = ['$uibModalInstance', 'entity', 'HaqTracksService'];

    function HaqTracksDeleteController($uibModalInstance, entity, HaqTracksService) {
        var vm = this;
        vm.haqTrack = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            HaqTracksService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('haq-evaluation-skips', {
            parent: 'entity',
            url: '/haq-evaluation-skips',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.haqEvaluationSkips.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/haq-evaluation-skips/haq-evaluation-skips.html',
                    controller: 'HaqEvaluationSkipsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('haq-evaluation-skips');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('HaqEvaluationSkipsService', HaqEvaluationSkipsService);

    HaqEvaluationSkipsService.$inject = ['$resource', '$q', 'halClient', '$http'];

    function HaqEvaluationSkipsService($resource, $q, halClient, $http) {
        var baseUrl = 'api/haq-evaluation-skips';
        var resourceUrl = 'api/haq-evaluation-skips/:id';
        var service = $resource(resourceUrl, {}, {});
        service.findAll = findAll;
        service.findById = findById;
        service.addHaqEvaluationSkip = addHaqEvaluationSkip;
        service.addBackHaqEvaluationSkip = addBackHaqEvaluationSkip;
        service.removeHaqEvaluationSkip = removeHaqEvaluationSkip;
        service.addBackMultipleHaqEvaluationSkip = addBackMultipleHaqEvaluationSkip;
        service.removeMultipleHaqEvaluationSkip = removeMultipleHaqEvaluationSkip;

        function findAll(skipFilter, pageable) {
            var deferred = $q.defer();

            var url = baseUrl;
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort,
                    hideRemoved: skipFilter && skipFilter.hideRemoved ? skipFilter.hideRemoved : false
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function findById(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function addHaqEvaluationSkip(skipReviewEvaluation) {
            var url = baseUrl + "/add";
            return $http.post(url, skipReviewEvaluation).then(function (response) {
                return response.data;
            });
        }

        function addBackHaqEvaluationSkip(skipReviewEvaluationAddBack) {
            var url = baseUrl + "/add-back/" + skipReviewEvaluationAddBack.id;
            return $http.post(url, skipReviewEvaluationAddBack).then(function (response) {
                return response.data;
            });
        }

        function removeHaqEvaluationSkip(id) {
            var url = baseUrl + "/" + id;
            return $http.delete(url).then(function (response) {
                return response;
            });
        }

        function addBackMultipleHaqEvaluationSkip(haqSkipsSelected) {
            var url = baseUrl + "/add-back-multiple";
            return $http.post(url, haqSkipsSelected).then(function (response) {
                return response.data;
            });
        }

        function removeMultipleHaqEvaluationSkip(haqSkipsSelected) {
            var url = baseUrl + "/remove-multiple";
            return $http.post(url, haqSkipsSelected).then(function (response) {
                return response;
            });
        }

        return service;

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqEvaluationSkipsController', HaqEvaluationSkipsController);

    HaqEvaluationSkipsController.$inject = ['$scope', '$state', 'HaqEvaluationSkipsService', 'ipmConstants', '$uibModal', '$uibModalStack'];

    function HaqEvaluationSkipsController ($scope, $state, HaqEvaluationSkipsService, constants, $uibModal, $uibModalStack) {
        var vm = this;
        vm.haqSkipsSelectedRows = []; // Allows multiple selection haqSkips
        vm.haqTracks = [];
        vm.haqSkips = [];
        vm.totalItems = 0;
        vm.pageSize = constants.PAGE_SIZE;
        vm.page = 1;
        vm.predicate = 'dateSkipped';
        vm.reverse = false;
        vm.hideRemoved = true;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.onChangeShowRemovedTests = onChangeShowRemovedTests;
        vm.showReasonDialog = showReasonDialog;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: constants.PAGE_SIZE,
                totalItems: 0
            };
            resetHaqSkipSelectedRows(); // reset haqSkips Selected Rows on initialization
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };

            var skipFilter = {
                hideRemoved: vm.hideRemoved
            };
            HaqEvaluationSkipsService.findAll(skipFilter, pageable).then(function (response) {
                vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                vm.haqSkips = response && response.data ? response.data : [];
                _.forEach(vm.haqSkips, function(o) {
                        o.reasonUi = o.reason;
                        o.reasonView = false;
                    if (o.reason && o.reason.length > 14) {
                        o.reasonUi = o.reason.slice(0, 10) + " ...";
                        o.reasonView = true;
                    }
                });
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'id') {
                result.push('id' + ',' + (vm.reverse ? 'desc' : 'asc'));
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.loadAll();
        }

        function onChangeShowRemovedTests() {
            vm.hideRemoved = !vm.hideRemoved;
        	vm.loadAll();
            resetHaqSkipSelectedRows();
        }

        function resetHaqSkipSelectedRows() {
            vm.haqSkipsSelectedRows = [];
        }

        vm.paginationOnChange = function (page) {
            vm.loadPage(page);
            resetHaqSkipSelectedRows();
        };

        vm.updateSelectionHaqSkip = function (row) {
            if (!row || !row.id) return;
            // Find the index of the selected row in the array
            var index = _.findIndex(vm.haqSkipsSelectedRows, function (selectedRow) {
                return selectedRow && selectedRow.id === row.id;
            });

            if (index === -1) {
                // If the row is not in the selection, mark it as selected and add to the list
                row.selected = true;
                vm.haqSkipsSelectedRows.push(row);
            } else {
                // If the row is already selected, remove it from the list and unmark as selected
                row.selected = false;
                vm.haqSkipsSelectedRows.splice(index, 1);
            }
        };

        vm.onClickAddBackMultiselect = function () {
            if (!vm.haqSkipsSelectedRows || vm.haqSkipsSelectedRows.length === 0) {
                return;
            }
            openDialogAddBackMultiple();
        };

        vm.onClickRemoveMultiselect = function () {
            if (!vm.haqSkipsSelectedRows || vm.haqSkipsSelectedRows.length === 0) {
                return;
            }
            openDialogRemoveMultiple();
        };

        vm.onClickAddBack = function (haqSkip) {
            if (!haqSkip || !haqSkip.id || haqSkip.selected || haqSkip.action) {
                return;
            }
            openDialogAddBack(haqSkip);
        };

        vm.onClickRemove = function (haqSkip) {
            if (!haqSkip || !haqSkip.id || haqSkip.selected || haqSkip.action) {
                return;
            }
            openDialogRemove(haqSkip);
        };

        function openDialogAddBack(haqSkip) {
            $uibModal.open({
                templateUrl: 'app/entities/haq-evaluation-skips/haq-evaluation-skips-add-dialog.html',
                controller: 'HaqEvaluationSkipsAddController',
                controllerAs: 'vm',
                size: 'md',
                windowClass: 'center-dialog-message vertical-center',
                backdrop: 'static',
                resolve: {
                    entity: function () {
                        return haqSkip;
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    resetHaqSkipSelectedRows();
                    vm.loadAll();
                }
            });
        }

        function openDialogRemove(haqSkip) {
            $uibModal.open({
                templateUrl: 'app/entities/haq-evaluation-skips/haq-evaluation-skips-remove-dialog.html',
                controller: 'HaqEvaluationSkipsRemoveController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'center-dialog-message vertical-center',
                backdrop: 'static',
                resolve: {
                    entity: function () {
                        return haqSkip;
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    resetHaqSkipSelectedRows();
                    vm.loadAll();
                }
            });
        }

        function openDialogAddBackMultiple() {
            $uibModal.open({
                templateUrl: 'app/entities/haq-evaluation-skips/haq-evaluation-multiple-skips-add-dialog.html',
                controller: 'HaqEvaluationMultipleSkipsAddController',
                controllerAs: 'vm',
                size: 'md',
                windowClass: 'center-dialog-message vertical-center',
                backdrop: 'static',
                resolve: {
                    haqSkipsSelectedRows: function () {
                        return vm.haqSkipsSelectedRows;
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    resetHaqSkipSelectedRows();
                    vm.loadAll();
                }
            });
        }

        function openDialogRemoveMultiple() {
            $uibModal.open({
                templateUrl: 'app/entities/haq-evaluation-skips/haq-evaluation-skips-multiple-remove-dialog.html',
                controller: 'HaqEvaluationSkipsMultipleRemoveController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'center-dialog-message vertical-center',
                backdrop: 'static',
                resolve: {
                    haqSkipsSelectedRows: function () {
                        return vm.haqSkipsSelectedRows;
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    resetHaqSkipSelectedRows();
                    vm.loadAll();
                }
            });
        }

        function showReasonDialog(reason) {
        	$uibModal.open({
                controller: function ($uibModalInstance) {
                	var vm = this;
                	vm.reason = reason;
                	vm.close = function() {
                		$uibModalInstance.dismiss('cancel');
                	}
                },
                templateUrl: 'app/entities/haq-evaluation-skips/skip-reason-dialog.html',
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static',
                windowClass: 'absolute-center warning-dialog'
            });
        };

        $scope.$on('$destroy', function() {
            $uibModalStack.dismissAll();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqEvaluationSkipsRemoveController', HaqEvaluationSkipsRemoveController);

    HaqEvaluationSkipsRemoveController.$inject = ['$uibModalInstance', 'entity', 'HaqEvaluationSkipsService'];

    function HaqEvaluationSkipsRemoveController($uibModalInstance, entity, HaqEvaluationSkipsService) {
        var vm = this;
        vm.haqEvaluationSkip = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function () {
            if (!vm.haqEvaluationSkip || !vm.haqEvaluationSkip.id) {
                return;
            }
            HaqEvaluationSkipsService.removeHaqEvaluationSkip(vm.haqEvaluationSkip.id).then(function (res) {
                $uibModalInstance.close(res);
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqEvaluationSkipsMultipleRemoveController', HaqEvaluationSkipsMultipleRemoveController);

    HaqEvaluationSkipsMultipleRemoveController.$inject = ['$uibModalInstance', 'haqSkipsSelectedRows', 'HaqEvaluationSkipsService'];

    function HaqEvaluationSkipsMultipleRemoveController($uibModalInstance, haqSkipsSelectedRows, HaqEvaluationSkipsService) {
        var vm = this;
        vm.haqSkipsSelectedRows = haqSkipsSelectedRows || [];
        vm.isSaving = false;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function () {
            if (!vm.haqSkipsSelectedRows.length) return;
            vm.isSaving = true;
            var saveData = vm.haqSkipsSelectedRows.map(function (item) {
                return {
                    id: item.id,
                    dateAddedBack: item.dateAddedBack,
                    pickToday: item.pickToday
                };
            });
            HaqEvaluationSkipsService.removeMultipleHaqEvaluationSkip(saveData)
                .then(function (res) {
                    $uibModalInstance.close(res);
                })
                .finally(function () {
                    vm.isSaving = false;
                });
        };
    }
})();
;

(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqEvaluationSkipsAddController', HaqEvaluationSkipsAddController);

    HaqEvaluationSkipsAddController.$inject = ['$stateParams', '$state', '$uibModalInstance','entity', 'HaqEvaluationSkipsService', '$scope'];

    function HaqEvaluationSkipsAddController ($stateParams, $state, $uibModalInstance, entity, HaqEvaluationSkipsService, $scope) {
        var vm = this;
        vm.haqEvaluationSkip = {
            id: entity.id,
            dateAddedBack: entity.dateAddedBack,
            pickToday: false
        };
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.isInValidDate = false;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateAddedBack = false;
            
        vm.datePickerOptions = {
            minDate: new Date()
        };

        init();

        function init() {
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.haqEvaluationSkip && vm.haqEvaluationSkip.id !== null) {
                HaqEvaluationSkipsService.addBackHaqEvaluationSkip(vm.haqEvaluationSkip).then(function (res) {
                    vm.isSaving = false;
                    $uibModalInstance.close(res);
                });
            }
        }

        $scope.$watch("vm.haqEvaluationSkip.dateAddedBack", function(newValue, oldValue) {
            var currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (!vm.haqEvaluationSkip.dateAddedBack) { return; }
            vm.haqEvaluationSkip.pickToday = vm.haqEvaluationSkip.dateAddedBack > currentDate ? false : true;
            vm.isInValidDate = vm.haqEvaluationSkip.dateAddedBack < currentDate ? true : false;
            vm.isSaving = false;
            return;
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqEvaluationMultipleSkipsAddController', HaqEvaluationMultipleSkipsAddController);

    HaqEvaluationMultipleSkipsAddController.$inject = ['$stateParams', '$state', '$uibModalInstance', 'haqSkipsSelectedRows', 'HaqEvaluationSkipsService', '$scope'];

    function HaqEvaluationMultipleSkipsAddController($stateParams, $state, $uibModalInstance, haqSkipsSelectedRows, HaqEvaluationSkipsService, $scope) {
        var vm = this;
        vm.dateAddedBack = null;
        vm.pickToday = false;
        vm.haqSkipsSelectedRows = haqSkipsSelectedRows || [];

        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.isInValidDate = false;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateAddedBack = false;

        vm.datePickerOptions = {
            minDate: new Date()
        };

        init();

        function init() {
        }

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (!vm.dateAddedBack || !vm.haqSkipsSelectedRows.length) return;
            vm.isSaving = true;
            var saveData = vm.haqSkipsSelectedRows.map(function (item) {
                return {
                    id: item.id,
                    dateAddedBack: vm.dateAddedBack,
                    pickToday: vm.pickToday
                };
            });
            HaqEvaluationSkipsService.addBackMultipleHaqEvaluationSkip(saveData)
                .then(function (res) {
                    $uibModalInstance.close(res);
                })
                .finally(function () {
                    vm.isSaving = false;
                });
        }

        $scope.$watch("vm.dateAddedBack", function (newValue) {
            if (!newValue) return;

            var currentDate = moment().startOf('day');
            var selectedDate = moment(newValue).startOf('day');

            vm.pickToday = !selectedDate.isAfter(currentDate);
            vm.isInValidDate = selectedDate.isBefore(currentDate);
            vm.isSaving = false;
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('HAQBatteryAdHocService', HAQBatteryAdHocService);

    HAQBatteryAdHocService.$inject = ['$resource', '$q', 'halClient', '$http'];

    function HAQBatteryAdHocService($resource, $q, halClient, $http) {
        var baseUrl = 'api/haq-battery-adhoc';
        var resourceUrl = "api/haq-battery-adhoc/:id";
        var service = $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'delete': {method: 'DELETE'}
        });
        service.findAllByPatientId = findAllByPatientId;
        service.findById = findById;
        service.getNextHaqBatteryAdhoc = getNextHaqBatteryAdhoc;

        function findAllByPatientId(patientId, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/get-by-patient/' + patientId;
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function findById(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getNextHaqBatteryAdhoc() {
            var deferred = $q.defer();
            var url = baseUrl + "/get-next-haq-battery-adhoc";
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        return service;

    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('FrpProgramService', FrpProgramService);

        FrpProgramService.$inject = ['$resource','$q', 'halClient', '$http'];

    function FrpProgramService($resource, $q, halClient, $http) {
        var baseUrl = 'api/frp-programs';
        var service = {};

        service.findAll = findAll;

        function findAll() {
            var deferred = $q.defer();
            var url = baseUrl;
            $http.get(url).success(function (data) {
                deferred.resolve(data);
            }).error(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }

        return service;
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('FileDownloadService', FileDownloadService);

    FileDownloadService.$inject = ['$resource','$q', 'halClient', '$http', 'DownloadBlobService'];

    function FileDownloadService($resource, $q, halClient, $http, DownloadBlobService) {
        var baseUrl = 'api/file-downloads';
        var service = {
            'createSessionDownload': createSessionDownload,
            'updateTypeDownloadFileHAQ': updateTypeDownloadFileHAQ,
            'getFileDownloadBySecretKey': getFileDownloadBySecretKey,
            'downloadReport': downloadReport,
            'getDownloadStatusBy': getDownloadStatusBy

        };

        function createSessionDownload(fileDownload) {
            return $http.post(baseUrl, fileDownload).then(function (resp) {
                return resp.data;
            });
        }

        function updateTypeDownloadFileHAQ(id, paramDownload) {
            var url = baseUrl + '/update-type-download-file-haq/' + id;

            return $http.post(url, paramDownload
            ).then(function (resp) {
                return resp;
            });
        }

        function getDownloadStatusBy(id) {
            var url = baseUrl + '/get-download-status-by/' + id;
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        }

        function getFileDownloadBySecretKey(secretKey) {
            var url = baseUrl + '/get-file-by-secret-key/' + secretKey;
            return $http.get(url).then(function (resp) {
                return resp;
            });
        }

        function downloadReport(secretKey) {
            var deferred = $q.defer();
            var url = baseUrl + '/download-report/' + secretKey;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        return service;

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
    	$stateProvider
        .state('deck', {
            parent: 'entity',
            url: '/decks?page&sort',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.deck.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/deck/deck.html',
                    controller: 'DeckController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                searchKey: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        searchKey: $stateParams.searchKey
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('deck');
                    return $translate.refresh();
                }]
            }
        })
        .state('deck.new', {
            parent: 'deck',
            url: '/new',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.deck.edit.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/deck/deck-editor.html',
                    controller: 'DeckEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('deck');
                     $translatePartialLoader.addPart('slideType');
                     $translatePartialLoader.addPart('questionRepeatType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return true;
                },
            }
        })
        .state('deck.edit', {
            parent: 'deck',
            url: '/{id}/edit',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.deck.edit.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/deck/deck-editor.html',
                    controller: 'DeckEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('deck');
                    $translatePartialLoader.addPart('slideType');
                    $translatePartialLoader.addPart('questionRepeatType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return false;
                },
            }
        })
        .state('deck.delete', {
            parent: 'deck',
            url: '/{id}/delete',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES] // ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({

                    templateUrl: 'app/entities/deck/deck-delete-dialog.html',
                    controller: 'DeckDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['Deck', function(Deck) {
                            return Deck.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('deck', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Deck', Deck);

    Deck.$inject = ['$resource', '$q', 'halClient', '$http'];

    function Deck ($resource, $q, halClient, $http) {
        var baseUrl = 'api/decks';
        var resourceUrl =  'api/decks/:id';

        var service = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function(data) { // data la Deck
                    var formData = new FormData();
                    if(data.id)
                    	formData.append('id', data.id);
                    formData.append('name', data.name);
                    var index = 0;
                    data.slides.forEach(function(slide) {
                    	formData.append('slides['+index+'].number', index + 1);
                        formData.append('slides['+index+'].name', slide.name);

                        if(slide.speakerNotes)
                        	formData.append('slides['+index+'].speakerNotes', slide.speakerNotes);
                        if(slide.id)
                        	formData.append('slides['+index+'].id', slide.id)
                        if(slide.type)
                        	formData.append('slides['+index+'].type', slide.type);

                        if(slide.type === "QUESTION") {
                        	if(slide.questionRepeatType)
                            	formData.append('slides['+index+'].questionRepeatType', slide.questionRepeatType);
                        	 if(slide.question)
                             	formData.append('slides['+index+'].question.id', slide.question.id);
                        }

                        if(slide.type === "PRESENTATION") {
                        	 if(slide.file)
                                 formData.append('slides['+index+'].multFile', slide.file);
                        	 if(slide.fileId)
                             	formData.append('slides['+index+'].fileId', slide.fileId);
                        }



                        index++;
                    });
                    //formData.append('slide1s[]', data.slides);
                    return formData;
                },
                headers: { 'Content-Type': undefined },
                transformResponse: function(result) {
                    return result;
                }
            }
        });

        service.findAllByActive = findAllByActive;

        function findAllByActive() {
            var deferred = $q.defer();

            var url = baseUrl + '/find-all-by-active';
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        service.downloadSlideFile = downloadSlideFile;

        function downloadSlideFile(id) {
            var deferred = $q.defer();
            var url = 'api/decks/slides/' + id + "/download";
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    saveAs(blob, headers('fileName'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);

            });
            return deferred.promise;
        };

        service.downloadSlideBlobFile = downloadSlideBlobFile;

        function downloadSlideBlobFile(id) {
            var deferred = $q.defer();
            var url = 'api/decks/slides/' + id + "/download-pdf";
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/pdf',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    deferred.resolve(data);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);

            });
            return deferred.promise;
        };
        return service;
    }
})();
;
(function() {
	'use strict';

	angular
	.module('ipmApp')
	.controller('DeckController', DeckController);

	DeckController.$inject = ['$scope', '$state', 'Deck', 'ParseLinks', 'pagingParams', 'paginationConstants'];

	function DeckController($scope, $state, Deck, ParseLinks, pagingParams, paginationConstants) {
			var vm = this;

			vm.currentAccount = null;
			vm.languages = null;
			vm.links = null;
			vm.loadAll = loadAll;
			vm.loadPage = loadPage;
			vm.page = 1;
			vm.predicate = 'd.id';
			vm.predicateDefault = 'd.id';
			vm.reverse = false;
			vm.pageSize = 15;
			vm.totalItems = 0;
			vm.deck = [];

			vm.clear = clear;
			vm.search = search;

			vm.loadAll();

			function loadAll () {
				Deck.query({
					searchKey: pagingParams.searchKey,
					page: pagingParams.page - 1,
					size: paginationConstants.itemsPerPage,
					sort: sort()
				}, onSuccess, onError);

				function sort() {
					var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
					if (vm.predicate !== 'name') {
						result.push('name');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.links = ParseLinks.parse(headers('link'));
					vm.totalItems = headers('X-Total-Count');
					vm.queryCount = vm.totalItems;
					vm.decks = data;
					vm.page = pagingParams.page;
				}
				function onError(error) {
					//AlertService.error(error.data.message);
				}
			}

			function loadPage (page) {
				vm.page = page;
				vm.transition();
			}

			function transition () {
				$state.transitionTo($state.$current, {
					page: vm.page,
					sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
					searchKey: vm.currentSearch
				});
			}

			function search (searchKey) {
				if (!searchKey){
					return vm.clear();
				}
				vm.links = null;
				vm.page = 1;
				vm.predicate = 'name';
				vm.reverse = false;
				vm.currentSearch = searchKey;
				vm.transition();
			}

			function clear () {
				vm.links = null;
				vm.page = 1;
				vm.predicate = 'name';
				vm.reverse = true;
				vm.currentSearch = '';
				vm.transition();
			}
		}
	})();;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DeckEditorController', DeckEditorController);

    DeckEditorController.$inject = ['$scope', '$rootScope','$state', '$stateParams', 'isCreateNew', 'Deck', 'WellnessQuestion', 'Upload'];

    function DeckEditorController($scope, $rootScope, $state, $stateParams, isCreateNew, Deck, WellnessQuestion, Upload) {
        var vm = this;
        vm.isSaving = false;
        vm.isCreateNew = isCreateNew;
        vm.init = init;
        vm.save = save;
        vm.hasChanged = false;
        vm.deck = null;
        vm.slideType = ['PRESENTATION', 'QUESTION'];
        vm.questionRepeatType = ['INITIAL', 'REPEAT'];
        vm.addSlide = addSlide;
        vm.removeSlide = removeSlide;
        init();

        function init() {
            if ($stateParams.id) {
                Deck.get({id : $stateParams.id}, function(res) {
                    vm.deck = res;
                });
            } else {
                vm.deck = {
                    name: null,
                    slides: [{}]
                };
            }
            
            loadQuestion();
        }
        
        function loadQuestion () {
            WellnessQuestion.query({
                searchKey: "",
                page: 0,
                size: 1000,
                sort: "name"
            }, onSuccess, onError);

            
            function onSuccess(data, headers) {
                vm.questions = data;
            }
            function onError(error) {
                //AlertService.error(error.data.message);
            	 vm.isSaving = false;
            }
        }


        function save() {
            vm.isSaving = true;
            Deck.save(vm.deck, onSaveSuccess, onSaveError);
        }
        
        var onSaveSuccess = function (result) {
        	vm.isSaving = false;
        	$state.go('deck');
        };
        
        vm.uploadChanged = function (files, slide) {
            if(files.length > 0) {
                slide = files[0];
                vm.hasChanged = true;
            }
        }

        var onSaveError = function () {
            vm.isSaving = false;
        };


        function addSlide() {
            vm.deck.slides.push({});
        }

        function removeSlide(index) {
            vm.deck.slides = _.reject(vm.deck.slides, function(v, i) { return index === i });
        }
        
        vm.removePdf = function(slide) {
            slide.fileId = null;
            slide.file = null;
        };

        vm.downloadPdf = function (slide) {
            console.log("download pdf by file id: " + slide.id);
            Deck.downloadSlideFile( slide.id);
        };

        vm.back = function () {
            $state.go('deck');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DeckDeleteController', DeckDeleteController);

    DeckDeleteController.$inject = ['$uibModalInstance', 'entity', 'Deck'];

    function DeckDeleteController($uibModalInstance, entity, Deck) {
        var vm = this;
        vm.deck = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Deck.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('course', {
            parent: 'entity',
            url: '/course?page&sort&search',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/courses.html',
                    controller: 'CourseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('course-detail', {
            parent: 'entity',
            url: '/course/{id}',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/course-detail.html',
                    controller: 'CourseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Course', function($stateParams, Course) {
                    return Course.get({id : $stateParams.id});
                }]
            }
        })
        /*.state('course.new', {
            parent: 'course',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/course/course-dialog.html',
                    controller: 'CourseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('course', null, { reload: true });
                }, function() {
                    $state.go('course');
                });
            }]
        })*/
        .state('course.new', {
            parent: 'course',
            url: '/new',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/course-editor.html',
                    controller: 'CourseEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    $translatePartialLoader.addPart('dayOfWeek');
                    $translatePartialLoader.addPart('amPm');
                    $translatePartialLoader.addPart('recommendationType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return true;
                },
            }
        })
        .state('course.edit', {
            parent: 'course',
            url: '/:id/edit',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/course-editor.html',
                    controller: 'CourseEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    $translatePartialLoader.addPart('dayOfWeek');
                    $translatePartialLoader.addPart('amPm');
                    $translatePartialLoader.addPart('recommendationType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return false;
                },
            }
        })
        /*.state('course.edit', {
            parent: 'course',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/course/course-dialog.html',
                    controller: 'CourseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Course', function(Course) {
                            return Course.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('course', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('course.delete', {
            parent: 'course',
            url: '/{id}/delete',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES] // ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/course/course-delete-dialog.html',
                    controller: 'CourseDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['Course', function(Course) {
                            return Course.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('course', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Course', Course);

    Course.$inject = ['$resource', '$q', 'halClient', '$http'];

    function Course ($resource, $q, halClient, $http) {
        var baseUrl = 'api/courses';
        var resourceUrl =  'api/courses/:id';

        var service = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
        service.findAllByActive = findAllByActive;
        service.findAllCoursesRegistrationsByPatient = findAllCoursesRegistrationsByPatient;

        function findAllByActive() {
            var deferred = $q.defer();

            var url = baseUrl + '/find-all-by-active';
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        function findAllCoursesRegistrationsByPatient(patientId) {
            var deferred = $q.defer();

            var url = baseUrl + '/find-all-courses-registrations/' + patientId;
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('CourseSearch', CourseSearch);

    CourseSearch.$inject = ['$resource'];

    function CourseSearch($resource) {
        var resourceUrl =  'api/_search/courses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CourseController', CourseController);

    CourseController.$inject = ['$scope', '$state', 'Course', 'CourseSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CourseController ($scope, $state, Course, CourseSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CourseSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Course.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.courses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CourseEditorController', CourseEditorController);

        CourseEditorController.$inject = ['$scope', '$timeout','$state', '$stateParams', '$translate', '$uibModal', 'isCreateNew', 'Course', 'User', 'Deck', 'Test'];

    function CourseEditorController($scope, $timeout, $state, $stateParams, $translate, $uibModal, isCreateNew, Course, User, Deck, Test) {
        var vm = this;
        vm.isSaving = false;
        vm.isCreateNew = isCreateNew;
        vm.isSaving = false;
        vm.isDuplicateSequence = false;
        vm.duplicateSequence = "";
        vm.isDuplicateIndicator = false;
        vm.duplicateIndicator = "";
        vm.dayOfWeeks = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
        vm.recommendationTypes = ['RECOMMENDED', 'CONSIDER'];
        vm.amPms = ['AM', 'PM'];
        vm.hourOfDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        vm.minuteOfHours = [
            {
                label: '00',
                value: 0
            },
            {
                label: '15',
                value: 15
            },
            {
                label: '30',
                value: 30
            },
            {
                label: '45',
                value: 45
            }
        ];
        vm.users = [];
        vm.decks = [];
        vm.tests = Test.query();

        vm.init = init;

        vm.addClass = addClass;
        vm.removeClass = removeClass;
        vm.addInstructor = addInstructor;
        vm.removeInstructor = removeInstructor;
        vm.addHaqIndicator = addHaqIndicator;
        vm.addRecommendation = addRecommendation;
        vm.removeRecommendation = removeRecommendation;
        vm.onChangeSequence = onChangeSequence;

        init();
        function init() {
          findAllDecks();
          findQHPUsers();

          // sort haq tests
          $timeout(function(){
              vm.tests = _.sortBy(vm.tests, ['nameEn']);
          }, 1000);

          if ($stateParams.id) {
            Course.get({id : $stateParams.id}, function(res) {
              // set course data
              vm.course = res;
            });
          } else {
            vm.course = {
              name: null,
              description: null,
              active: true,
              id: null,
              haqIndicators: [{
                haqTriggers: [{}]
              }],
              classes: [{sequence: 1}],
              instructors: [{}]
            };
          }
        }

        function findAllDecks() {
            Deck.findAllByActive().then(function (response) {
                vm.decks = response ? response : [];
            });
        }

        function findQHPUsers() {
            User.getAllQHPUsersWithInstructorTask().then(function (response) {
                vm.users = response ? response : [];
            });
        }

        vm.onChangeIndicator = function () {
            checkDuplicateIndicator();
            checkDuplicateRecommendationType ();
        }

        vm.onChangeRecommendationType = function () {
            checkDuplicateRecommendationType();
        }

        function onChangeSequence(sequence, index) {
            checkDuplicateSequence();
        }

        var onSaveSuccess = function (result) {
            vm.isSaving = false;
            $state.go('course');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            _.forEach(vm.course.classes, function(o) {
                o.sequence = parseInt(o.sequence);
            });
            vm.course.classes = _.sortBy(vm.course.classes, ['sequence']);

            _.forEach(vm.course.haqIndicators, function(i) {
                _.forEach(i.haqTriggers, function(o) {
                    o.value = parseInt(o.value);
                });
            });

            vm.isSaving = true;
            if (vm.course.id !== null) {
                Course.update(vm.course, onSaveSuccess, onSaveError);
            } else {
                Course.save(vm.course, onSaveSuccess, onSaveError);
            }
        };
        function checkDuplicateRecommendationType () {
            var haqIndicatorsClone = _.cloneDeep(vm.course.haqIndicators);
            var haqIndicators = [];
            _.forEach(haqIndicatorsClone, function(i) {
                if (i.testId) {
                    var test = _.find(vm.tests, function(t) { return t.id === i.testId; });
                    if (test) {
                        var list = [];
                        _.forEach(i.haqTriggers, function(o) {
                            if (o.recommendationType) {
                                var recommendationType = $translate.instant( 'ipmApp.recommendationType.' + o.recommendationType);
                                list.push(
                                    "'" + test.nameEn + "' on '" + recommendationType + "'"
                                );
                            }
                        });
                        haqIndicators = haqIndicators.concat(list);
                    }
                }
            });
            vm.isDuplicateRecommendationType = _.uniq(haqIndicators).length !== haqIndicators.length;

            var groupped = _.groupBy(haqIndicators, function (n) {return n});
            var dup = _.uniq(_.flatten(_.filter(groupped, function (n) {return n.length > 1})));
            vm.duplicateRecommendationType = dup.join(', ');
        }

        function checkDuplicateIndicator () {
            var haqIndicatorsClone = _.cloneDeep(vm.course.haqIndicators);
            var haqIndicators = [];
            _.forEach(haqIndicatorsClone, function(i) {
                if (i.testId) {
                    var test = _.find(vm.tests, function(t) { return t.id === i.testId; });
                    if (test) {
                        var list = [];
                        list.push(
                            "'" + test.nameEn + "'"
                        );
                        var uniqList = [];
                        var groups = _.groupBy(list, function (n) {return n});
                        _.forEach(groups, function(o) {
                            uniqList.push(o[0]);
                        });
                        haqIndicators = haqIndicators.concat(uniqList);
                    }
                }
            });
            vm.isDuplicateIndicator = _.uniq(haqIndicators).length !== haqIndicators.length;

            var groupped = _.groupBy(haqIndicators, function (n) {return n});
            var dup = _.uniq(_.flatten(_.filter(groupped, function (n) {return n.length > 1})));
            vm.duplicateIndicator = dup.join(', ');
        }

        function checkDuplicateSequence () {
            var classesClone = _.cloneDeep(vm.course.classes);
            _.forEach(classesClone, function(o) {
                o.sequence = parseInt(o.sequence);
            });
            var sequences = _.map(classesClone, 'sequence', _.unary(parseInt));
            vm.isDuplicateSequence = _.uniq(sequences).length !== sequences.length;

            var groupped = _.groupBy(sequences, function (n) {return n});
            var dup = _.uniq(_.flatten(_.filter(groupped, function (n) {return n.length > 1})));
            vm.duplicateSequence = dup.join(', ');
        }

        function addClass() {
            var seq = 1;
            var maxSequence = _.maxBy(vm.course.classes, 'sequence');
            if (maxSequence !== undefined) {
                seq = parseInt(maxSequence.sequence) + 1;
            }
            vm.course.classes.push({
                sequence: seq
            });
        }

        function showRemoveConfirm(errorKey) {
            $uibModal.open({
                templateUrl: 'app/entities/course/course-remove-class-dialog.html',
                controller: function($uibModalInstance, errorKey) {
                    var vm = this;
                    vm.errorKey = errorKey;
                    vm.clear = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                resolve: {
                    errorKey: function () {
                        return errorKey;
                    }
                }
            });
        }
        function removeClass(index) {
            if(vm.course.classes[index].used) {
                showRemoveConfirm('classError');
            } else {
                vm.course.classes = _.reject(vm.course.classes, function(v, i) { return index === i });
                checkDuplicateSequence();
            }
        }

        function addInstructor() {
            vm.course.instructors.push({});
        }

        function removeInstructor(index) {
            if(vm.course.instructors[index].used) {
                showRemoveConfirm('instructorError');
            } else {
                vm.course.instructors = _.reject(vm.course.instructors, function(v, i) { return index === i });
            }
        }

        function addHaqIndicator() {
            vm.course.haqIndicators.push({
                haqTriggers: [{}]
            });
        }

        function addRecommendation(haqIdx) {
            vm.course.haqIndicators[haqIdx].haqTriggers.push({});
        }

        function removeRecommendation(haqIdx, index) {
            vm.course.haqIndicators[haqIdx].haqTriggers = _.reject(vm.course.haqIndicators[haqIdx].haqTriggers, function(v, i) { return index === i });
            if (vm.course.haqIndicators[haqIdx].haqTriggers.length === 0) {
                vm.course.haqIndicators = _.reject(vm.course.haqIndicators, function(v, i) { return haqIdx === i });
            }
            checkDuplicateIndicator();
            checkDuplicateRecommendationType ();
        }

        vm.back = function () {
          $state.go('course');
      };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CourseDeleteController',CourseDeleteController);

    CourseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Course'];

    function CourseDeleteController($uibModalInstance, entity, Course) {
        var vm = this;
        vm.course = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Course.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('CocAgreementService', CocAgreementService);

        CocAgreementService.$inject = ['$resource', '$http'];

    function CocAgreementService($resource, $http) {
        var resourceUrl = "api/coc-agreement";
        var service = $resource(resourceUrl, {}, {});
        service.sendInvitations = sendInvitations;
        service.getBySecretKey = getBySecretKey;

        function sendInvitations(chartNumbersText) {
            var url = resourceUrl + '/send-invitations'
            return $http.post(url, { chartNumbersText: chartNumbersText }).then(function (resp) {
                return resp.data;
            });
        }

        function getBySecretKey(secretKey) {
            var url = resourceUrl + '/get-by-secret-key'
            return $http.get(url, { params: { secretKey: secretKey }}).then(function (response) {
                return response.data;
            });
        }

        return service;

    }
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('ClassSessionRegistrationService', ClassSessionRegistrationService);

    ClassSessionRegistrationService.$inject = ['$resource', '$q', 'halClient', '$http'];

    function ClassSessionRegistrationService($resource,$q, halClient, $http) {
        var baseUrl = 'api/class-session-registrations';
        var resourceUrl = "api/class-session-registrations/:id";
        var service = $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'delete': {method: 'DELETE'}
        });

        service.getRegisteredCourses = getRegisteredCourses;
        service.getAllRegisteredCourses = getAllRegisteredCourses;
        service.findById = findById;

        function getRegisteredCourses(patientId, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/get-by-patient';
            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            })
                .success(function (data, status, headers) {
                    var result = new Object();
                    result.data = data && data !== undefined ? data : [];
                    result.totalItems = headers('X-Total-Count');
                    deferred.resolve(result);
                })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function getAllRegisteredCourses(patientId) {
            var deferred = $q.defer();

            var url = baseUrl + '/get-all-registered-courses-by-patient/' + patientId;
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        function findById(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('class-session', {
            abstract: true,
            parent: 'entity',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            params: {
                queryParams: null
            }
        })
        .state('class-session.list', {
            parent: 'class-session',
            url: '/class-session/{courseId}/list',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.classSession.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/class-session/class-session.html',
                    controller: 'ClassSessionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                course: ['Course', '$stateParams', function (Course, $stateParams) {
                    if (constants.HIDE_WELLNESS_CLASSES) {
                        return null;
                    }
                    return Course.get({id: $stateParams.courseId}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('class-session');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('class-session.list.new', {
            parent: 'class-session.list',
            url: '/new',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.classSession.home.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-session/class-session-editor.html',
                    controller: 'ClassSessionEditorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        isEdit: function () {
                            return false;
                        },
                        isCreateNew: function () {
                            return true;
                        },
                        isView: function () {
                            return false;
                        },
                        entity: ['$stateParams', function ($stateParams) {
                            return {
                                id: null,
                                courseId: parseInt($stateParams.courseId)
                            };
                        }],
                        course: ['Course', function (Course) {
                            if (constants.HIDE_WELLNESS_CLASSES) {
                                return null;
                            }
                            return Course.get({id: $stateParams.courseId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-session.list.edit', {
            parent: 'class-session.list',
            url: '/{classSessionId}/edit',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.classSession.home.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-session/class-session-editor.html',
                    controller: 'ClassSessionEditorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        isEdit: function () {
                            return true;
                        },
                        isCreateNew: function () {
                            return false;
                        },
                        isView: function () {
                            return false;
                        },
                        entity: ['ClassSessionService', function (ClassSessionService) {
                            return ClassSessionService.get($stateParams.classSessionId);
                        }],
                        course: ['Course', function (Course) {
                            if (constants.HIDE_WELLNESS_CLASSES) {
                                return null;
                            }
                            return Course.get({id: $stateParams.courseId}).$promise;
                        }],
                        instructors: ['User', function (User) {
                            return User.getAllQHPUsersWithInstructorTask();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-session.list.view', {
            parent: 'class-session.list',
            url: '/{classSessionId}/view',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.classSession.home.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-session/class-session-editor.html',
                    controller: 'ClassSessionEditorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        isEdit: function () {
                            return false;
                        },
                        isCreateNew: function () {
                            return false;
                        },
                        isView: function () {
                            return true;
                        },
                        entity: ['ClassSessionService', function (ClassSessionService) {
                            return ClassSessionService.get($stateParams.classSessionId);
                        }],
                        course: ['Course', function (Course) {
                            if (constants.HIDE_WELLNESS_CLASSES) {
                                return null;
                            }
                            return Course.get({id: $stateParams.courseId}).$promise;
                        }],
                        instructors: ['User', function (User) {
                            return User.getAllQHPUsersWithInstructorTask();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-session.list.delete', {
            parent: 'class-session.list',
            url: '/{classSessionId}/delete',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.classSession.home.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-session/class-session-delete-dialog.html',
                    controller: 'ClassSessionDeleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['ClassSessionService', function (ClassSessionService) {
                            return ClassSessionService.get($stateParams.classSessionId);
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('ClassSessionService', ClassSessionService);

        ClassSessionService.$inject = ['$resource', '$http', '$q'];

    function ClassSessionService ($resource, $http, $q) {
        var resourceUrl = "api/class-sessions";
        var service = $resource(resourceUrl, {}, {});
        service.get = get;
        service.getAllUpcommingSessionByCourseId = getAllUpcommingSessionByCourseId;
        service.createOrUpdate = createOrUpdate;
        service.deleteSesion = deleteSesion;
        service.doAutoGenerate = doAutoGenerate;

        function get(id) {
            var deferred = $q.defer();
            $http.get(resourceUrl + '/' + id).then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };

        function getAllUpcommingSessionByCourseId(pageable, courseId, instructorId) {
            return $http.get(resourceUrl, {
                params: {
                    courseId: courseId,
                    instructorId: instructorId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).then(function (response) {
                return response;
            });
        };

        function createOrUpdate(data) {
            return $http.post(resourceUrl, data).then(function (response) {
                return response;
            });
        };

        function deleteSesion(id) {
            return $http.delete(resourceUrl + '/' + id).then(function (response) {
                return response;
            });
        };

        function doAutoGenerate(courseId, days, timeZone) {
            return $http.get(resourceUrl + "/do-auto-generate", {
                params: {
                    courseId: courseId,
                    days: days,
                    clientTimeZone: timeZone
                }
            }).then(function (response) {
                return response;
            });
        };

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ClassSessionController', ClassSessionController);

        ClassSessionController.$inject = ['$scope', '$stateParams', '$state', '$rootScope', '$uibModal', 'ClassSessionService', 'paginationConstants', 'course'];

    function ClassSessionController ($scope, $stateParams, $state, $rootScope, $uibModal, ClassSessionService, paginationConstants, course) {
        var vm = this;
        vm.classSessions = [];

        vm.totalItems = 0;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.page = 1;
        vm.predicate = 'classStart';
        vm.reverse = false;
        vm.course = course;

        vm.loadAll = loadAll;

        init();

        function init() {
            vm.courseId = vm.course.id;
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            ClassSessionService.getAllUpcommingSessionByCourseId(pageable, vm.courseId).then(function (response) {
                // headers('X-Total-Count')
                var headers = response.headers
                vm.totalItems = headers('X-Total-Count');
                vm.classSessions = response && response.data ? response.data : [];
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        vm.openAutoGenerateDialog = function() {
            $uibModal.open({
                templateUrl: 'app/entities/class-session/class-session-schedule-day-dialog.html',
                controller: 'ScheduleXDayDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center',
                resolve: {
                    courseEntity: function() {
                        return { id:  vm.courseId}
                    }
                }
            }).result.then(function() {
                vm.loadAll();
            }, function() {
                // $state.go('^');
            });
        }

        var unsubscribe = $rootScope.$on('ipmApp:classSessionUpdate', function(event, result) {
            vm.loadAll();
        });
        $scope.$on('$destroy', unsubscribe);

        vm.back = function () {
            $state.go('course');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ScheduleXDayDialogController',ScheduleXDayDialogController);

        ScheduleXDayDialogController.$inject = ['$scope', '$uibModalInstance', 'courseEntity', 'ClassSessionService'];

    function ScheduleXDayDialogController($scope, $uibModalInstance, courseEntity, ClassSessionService) {
        var vm = this;
        vm.course = courseEntity;
        vm.min = 7;
        vm.max = 90;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.doGenerate = function () {
            var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            ClassSessionService.doAutoGenerate(vm.course.id, vm.numberOfDate, timeZone).then(function () {
                $uibModalInstance.close();
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ClassSessionEditorController', ClassSessionEditorController);

        ClassSessionEditorController.$inject = ['$scope', '$rootScope','$state', '$stateParams', '$uibModalInstance', 'entity', 'course', 'ClassSessionService', 'isCreateNew', 'isEdit', 'isView'];

    function ClassSessionEditorController($scope, $rootScope, $state, $stateParams, $uibModalInstance, entity, course, ClassSessionService, isCreateNew, isEdit, isView) {
        var vm = this;
        vm.isSaving = false;
        vm.isCreateNew = isCreateNew;
        vm.isEdit = isEdit;
        vm.isView = isView;

        vm.datePickerOpenStatus = {};
        vm.hourStep = 1;
        vm.minuteStep = 15;

        vm.classSession = entity;
        vm.course = course;
        vm.instructors = vm.course.instructors;

        $scope.startDateOptions = {
            minDate: moment().toDate()
        }
        

        init();

        function init() {
            if (vm.isCreateNew) {
                var d = getRangeMinutes() > 45 ? moment().add(1, 'hours').toDate() : moment().toDate();
                d.setMinutes(getRangeMinutes() > 45 ? 0 : getRangeMinutes());
                d.setSeconds(0);
                vm.classSession.date = d;
                vm.classSession.time = d;

                vm.classSession.courseName = vm.course.name;
            } else {
                vm.classSession.date = moment(vm.classSession.classStart)._d;
                vm.classSession.time = moment(vm.classSession.classStart)._d;
                // set object to selected
                vm.classSession.wellnessClass = {id: vm.classSession.classId};

                if (vm.isView) {
                    vm.course.classes = [{id: vm.classSession.classId, name: vm.classSession.wellnessClassName}];
                    vm.instructors = [{ instructorId: vm.classSession.instructorId, instructorName: vm.classSession.instructorName }]
                }
            }
        }

        vm.save = function() {
            var classStart = vm.classSession.date;
            classStart.setHours(vm.classSession.time.getHours(), vm.classSession.time.getMinutes(), 0);
            vm.classSession.classId = vm.classSession.wellnessClass.id;
            var requestDataObject = {
                id: vm.classSession.id,
                classStart: classStart,
                instructorId: vm.classSession.instructorId,
                classId: vm.classSession.classId,
            }
            ClassSessionService.createOrUpdate(requestDataObject).then(function(res) {
                $scope.$emit('ipmApp:classSessionUpdate');
                vm.clear();
            }, function(error) {
                $rootScope.$emit('ipmApp.httpErrorWithOutGotoErrorPage', error);
            });
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.classChange = function() {
            vm.classSession.classSequence = vm.classSession.wellnessClass.sequence; // set class sequence to UI display
        }

        $scope.$watchGroup(['vm.classSession.date', 'vm.classSession.time'], function() {
            checkingTimeValid();
            return;
        });

        function checkingTimeValid() {
            var date = new Date();
            if (vm.classSession.date) {
                if(vm.classSession.date.getDate() < date.getDate()
                    && vm.classSession.date.getMonth() == date.getMonth()
                    && vm.classSession.date.getYear() == date.getYear()) {
                    vm.invalidDate = true;
                } else {
                    vm.invalidDate = false;
                }
            }
            if (vm.classSession.time) {
                if(vm.classSession.time.getHours() < date.getHours()
                    && theSameCurrentDate()) {
                    vm.invalidTime = true;
                } else if (vm.classSession.time.getHours() === date.getHours()
                    && theSameCurrentDate()) {
                    vm.invalidTime = vm.classSession.time.getMinutes() < date.getMinutes();
                } else {
                    vm.invalidTime = false;
                }
            }
        }

        function theSameCurrentDate() {
            var date = new Date();
            return vm.classSession.date.getDate() === date.getDate()
            && vm.classSession.date.getMonth() === date.getMonth()
            && vm.classSession.date.getYear() === date.getYear();
        }

        function getRangeMinutes() {
            var date = new Date();
            if (date.getMinutes() < 15) {
                return 15;
            }
            if (date.getMinutes() < 30) {
                return 30;
            }
            if (date.getMinutes() < 45) {
                return 45;
            }
            return 59;
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ClassSessionDeleteController',ClassSessionDeleteController);

        ClassSessionDeleteController.$inject = ['$scope', '$uibModalInstance', 'entity', 'ClassSessionService'];

    function ClassSessionDeleteController($scope, $uibModalInstance, entity, ClassSessionService) {
        var vm = this;
        vm.classSession = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            // ClassSessionService.delete({id: id},
            //     function () {
            //         $uibModalInstance.close(true);
            //     });
            ClassSessionService.deleteSesion(id).then(function () {
                $scope.$emit('ipmApp:classSessionUpdate');
                $uibModalInstance.close(true);
            })
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('care-plan-review', {
            parent: 'app',
            url: '/care-plan-review',
            data: {
                authorities: ['ROLE_QHP', 'ROLE_ADMIN'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/care-plan-review/care-plan-review.html',
                    controller: 'CarePlanReviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                cprAssignmentEnable: ['CarePlanReviewService', function(CarePlanReviewService) {
                    return CarePlanReviewService.getConfig();
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('carePlanReview');
                    $translatePartialLoader.addPart('carePlanReviewStatus');
                    $translatePartialLoader.addPart('qhpWorkflow');
                    $translatePartialLoader.addPart('callLog');
                    $translatePartialLoader.addPart('partyType');

                    return $translate.refresh();
                }]
            }
        }).state('care-plan-review.edit', {
                parent: 'care-plan-review',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/care-plan-review/care-plan-review-dialog.html',
                        controller: 'CarePlanReviewDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowClass: 'center-dialog-message',
                        size: 'sm',
                        resolve: {
                            entity: ['CarePlanReviewService', function (CarePlanReviewService) {
                                return CarePlanReviewService.findById($stateParams.id);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('care-plan-review', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('CarePlanReviewService', CarePlanReviewService);

    CarePlanReviewService.$inject = ['$resource', '$http', '$q', 'DownloadBlobService'];

    function CarePlanReviewService ($resource, $http, $q, DownloadBlobService) {
        var resourceUrl = "api/care-plan-review";
        var service = $resource(resourceUrl, {}, {});
        service.searchCPR = searchCPR;
        service.addAssignment = addAssignment;
        service.downloadCarePlanReview = downloadCarePlanReview;
        service.getHighlightDays = getHighlightDays;
        service.findById = findById;
        service.updateTimeSpent = updateTimeSpent;
        service.updateNotes = updateNotes;
        service.unskipReview = unskipReview;
        service.getConfig = getConfig;
        service.findAllByPatientId = findAllByPatientId;
        service.startReview = startReview;

        function findAllByPatientId(patientId, pageable) {
            var deferred = $q.defer();
            var url = resourceUrl + '/find-all-by-patient';
            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function searchCPR(searchQuery, status, pageable, isLoadAllPatients) {
            var deferred = $q.defer();
            var url = resourceUrl + '/search';
            $http.get(url, {
                params: {
                    query: ((searchQuery != null) ? encodeURIComponent(searchQuery) : null),
                    status: status,
                    isLoadAllPatients: isLoadAllPatients,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function addAssignment(patientId) {
            var url = resourceUrl + "/add-assignment";
            return $http.post(url, { "patientId": patientId }).then(function(response) {
                return response.data;
            });
        }

        function downloadCarePlanReview(fromDate, toDate) {
            var deferred = $q.defer();
            var url = resourceUrl + '/download-care-plan-review';
            $http({
                url: url,
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function getHighlightDays() {
            return $http.get(resourceUrl + '/get-highlight-days').then(function (response) {
                return response.data;
            });
        };

        function updateNotes(notes) {
            var url = resourceUrl + "/update-notes";
            return $http.post(url,notes).then(function(response) {
                    return response.data;
            });
        }

        function unskipReview(cpr) {
            var url = resourceUrl + "/unskip-review";
            return $http.post(url,cpr).then(function(response) {
                    return response.data;
            });
        }

        function findById(id) {
            var deferred = $q.defer();
            var url = resourceUrl + "/find-by-id/" + id;
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function updateTimeSpent(carePlanReview) {
            var url = resourceUrl + "/update-time-spent";
            return $http.post(url, carePlanReview).then(function (response) {
                return response;
            });
        }

        function getConfig() {
            var deferred = $q.defer();
            var url = resourceUrl + "/get-config";
            $http.get(url).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function startReview(cprId) {
            var url = resourceUrl + "/start-review/" + cprId;
            return $http.post(url, {}).then(function(response) {
                return response.data;
            });
        }

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CarePlanReviewController', CarePlanReviewController);

    CarePlanReviewController.$inject = ['$scope', '$state', '$stateParams', 'ipmConstants', 'CarePlanReviewService', '$uibModal', 'ClearLocalStorageService', '$translate', 'Principal', 'cprAssignmentEnable', 'PatientService', '$window', 'User'];

    function CarePlanReviewController($scope, $state, $stateParams, constants, CarePlanReviewService, $uibModal, ClearLocalStorageService, $translate, Principal, cprAssignmentEnable, PatientService, $window, User) {
        var vm = this;
        vm.carePlanReviews = [];
        vm.searchQuery = '';
        vm.statuses = constants.CARE_PLAN_REVIEW_STATUS;
        vm.status = null;
        vm.page = 1;
        vm.predicate = 'completedDateNull';
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.search = search;
        vm.launchCPR = launchCPR;
        vm.editTimeSpent = editTimeSpent;
        vm.formatAndUpdateStatus = formatAndUpdateStatus;
        vm.addAssignment = addAssignment;
        vm.isSearching = false;
        vm.isLoading = false;
        vm.isLoadingUser = false;
        vm.cprRowTextClass = cprRowTextClass;
        vm.cprAssignmentEnable = cprAssignmentEnable;
        vm.tabAssignedPatients = 0;
        vm.tabAllPatients = 1;
        vm.tabUnassignedPatients = 2;
        vm.activeTabIndex = vm.tabAssignedPatients;
        vm.tabSelect = tabSelect;
        vm.isQHPRole = false;
        vm.patients = [];
        vm.isSaving = false;
        vm.checkCallLogAdHoc = checkCallLogAdHoc;
        vm.qhpUserAdHocId = null;

        init();

        function init() {
            User.getUserByCurrentLogin().then(function (response) {
                vm.qhpUserAdHocId = response ? response.id : null;
            });
            getAccount(false);
            vm.pageableAP = {
                page: 1,
                size: constants.PAGE_SIZE,
                totalItems: 0
            };
            var paramsInfo = $stateParams.searchCPRParamsInfo ? $stateParams.searchCPRParamsInfo : null;
            if (paramsInfo) {
                vm.status = paramsInfo.status;
                vm.searchQuery = paramsInfo.searchQuery;
                vm.pageableAP.page = paramsInfo.page;
                vm.pageableAP.totalItems = paramsInfo.totalItems;
                vm.pageableAP.size = paramsInfo.pageSize;
                vm.predicate = paramsInfo.predicate;
                vm.reverse = paramsInfo.reverse;
            }
            vm.loadAll();
            vm.isSearching = false;
        }

        function getAccount(force) {
            vm.isLoadingUser = true;
            Principal.identity(force).then(function(res) {
                vm.account = res;
                vm.isLoadingUser = false;
                vm.isQHPRole = checkIsQHPRole();
            });
        }

        function sort() {
            var  result = [vm.predicate + ',' +  (vm.reverse ? 'desc' : 'asc')];

            if (vm.predicate === 'status') {
               result.push('completed_date' + ',' + (vm.reverse ? 'asc' : 'desc')); // fix bug IPMproject-B1261
            }
            if (vm.predicate !== 'id') {
               result.push('id' + ',' + (vm.reverse ? 'desc' : 'asc'));
            }
            return result;
        }

        function search() {
            setSearching();
            vm.page = 0;
            vm.reverse = true;
            vm.loadAll();
        }

        function setSearching() {
            if (vm.status === 'ALL' && !vm.searchQuery) {
                vm.isSearching = false;
            } else {
                vm.isSearching = true;
            }
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            var statusCPR = '';
            if (vm.status && vm.status !== 'ALL') {
                statusCPR = vm.status;
            }

            if (vm.activeTabIndex === vm.tabUnassignedPatients) {
                PatientService.searchCPRPatients(vm.searchQuery, pageable).then(function (response) {
                    if (response) {
                        vm.patients = response.content;
                        vm.pageableAP.totalItems = response.totalElements;
                        vm.isLoading = false;
                    }
                });
            } else {
                CarePlanReviewService.searchCPR(vm.searchQuery, statusCPR, pageable, checkLoadAllPatients()).then(function (response) {
                    if (response) {
                        vm.carePlanReviews = response.data;
                        vm.pageableAP.totalItems = response.totalItems;
                        vm.isLoading = false;
                    }
                });
            }


        }

        function checkLoadAllPatients() {
            if (vm.activeTabIndex === vm.tabAllPatients) {
                return true;
            }
            return false;
        }
        function loadPage(page) {
            vm.page = page;
            vm.loadAll();
        }

        function addAssignment(patientId) {
            vm.isSaving = true;
            CarePlanReviewService.addAssignment(patientId).then(function (cpr) {
                if (cpr) {
                    launchCPR(cpr);
                    vm.isSaving = false;
                }
            });
        }
        function launchCPR(cpr) {
            if (cpr && !cpr.isSkippingReview && !cpr.addHocInProgress) {
                ClearLocalStorageService.clearTimeSpentCPR();
                if (cpr.status === 'NOT_READY') {
                    confirmDialog(cpr);
                    return;
                } else {
                    goToCPRWorkflow(cpr);
                }
            }
        }

        function editTimeSpent(cpr) {
            if (cpr && cpr.id && cpr.status === 'STARTED' && !cpr.addHocInProgress) {
                $state.go('care-plan-review.edit', {id: cpr.id});
            }
        }

        function goToCPRWorkflow(cpr) {
            if (cpr) {
                if (cpr.status === null || cpr.status === 'NOT_READY' || cpr.status === 'NOT_STARTED') {
                    CarePlanReviewService.startReview(cpr.id).then(function () {
                        goCPRWorkflow(cpr);
                    });
                } else {
                    goCPRWorkflow(cpr);
                }
            }
            return;
        }

        function goCPRWorkflow(cpr) {
            ClearLocalStorageService.setPatientIdForCPRWorkflow(cpr.patient.id, cpr.id);
            ClearLocalStorageService.setInitDataCPRWorkflow(false);
            $state.go('care-plan-review-workflow');
        }

        function formatAndUpdateStatus(cpr) {
            if (cpr && cpr.isSkippingReview) { // status SKIPPED
                return $translate.instant('ipmApp.carePlanReviewStatus.' + 'SKIPPED');
            } else if (cpr && cpr.status) {
                return $translate.instant('ipmApp.carePlanReviewStatus.' + cpr.status);
            } else if (cpr.completedDatePrevious) {
                var lastCompletedDateMinus = new moment().subtract(constants.DAYS_PREVIOUS_CPR_COMPLETED, 'days');
                if (lastCompletedDateMinus.isAfter(cpr.completedDatePrevious)) {
                    cpr.status = 'NOT_STARTED'; // update temp status
                    return $translate.instant('ipmApp.carePlanReviewStatus.NOT_STARTED');
                } else {
                    cpr.status = 'NOT_READY'; // update temp status
                    return $translate.instant('ipmApp.carePlanReviewStatus.NOT_READY');
                }
            } else if (!cpr.status && !cpr.completedDatePrevious) {
                cpr.status = 'NOT_STARTED'; // update temp status
                return $translate.instant('ipmApp.carePlanReviewStatus.NOT_STARTED');
            }
            return '';
        }

        function cprRowTextClass(cpr) {
            if (cpr && (cpr.status === 'NOT_READY' || cpr.isSkippingReview)) {
                return 'mask';
            }
            return cpr && cpr.isHighlight ? 'text-danger' : '';
        }

        function checkCallLogAdHoc(cpr) {
            if (vm.activeTabIndex === vm.tabAllPatients) {
                return cpr.qhpUser && cpr.qhpUser.id !== vm.qhpUserAdHocId;
            }
            return false;
        }

        vm.isAdmin = function () {
            if (vm.account && (vm.account.authorities.indexOf(constants.ROLE_ADMIN) !== -1)) {
                return true;
            }
            return false;
        };

        function checkIsQHPRole() {
            if (vm.account && (vm.account.authorities.indexOf(constants.ROLE_QHP) !== -1)) {
                return true;
            }
            return false;
        };

        vm.isShowTabAllPatients = function () {
            return vm.isQHPRole && vm.cprAssignmentEnable;
        }

        function tabSelect(index) {
            vm.activeTabIndex = index;
            loadAll();
        }

        vm.unskipReview = function(cpr) {
            $uibModal.open({
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.message = "unskipReviewMessage";

                    vm.close = function() {
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.okClick = function () {
                        $uibModalInstance.dismiss('cancel');
                        CarePlanReviewService.unskipReview(cpr).then(function() {
                            loadAll();
                        });
                    };
                },
                templateUrl: 'app/entities/care-plan-review/partial/confirm-dialog.html',
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static',
                windowClass: 'absolute-center warning-dialog'
            });
        }

         function confirmDialog(cpr) {
            $uibModal.open({
                controller: function ($uibModalInstance, $state, Auth) {
                    var vm = this;
                    vm.message = "startReviewMessage";

                    vm.close = function() {
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.okClick = function () {
                        $uibModalInstance.dismiss('cancel');
                        goToCPRWorkflow(cpr);
                    };
                },
                templateUrl: 'app/entities/care-plan-review/partial/confirm-dialog.html',
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static',
                windowClass: 'absolute-center warning-dialog'
            });
        }

        vm.openNotesDialog = function (cpr) {
            if (cpr.addHocInProgress) {
                return;
            }
            $uibModal.open({
                controller: 'NotesController',
                templateUrl: 'app/entities/care-plan-review/partial/notes-dialog.html',
                controllerAs: 'vm',
                size: 'md',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    cpr: function () {
                        var notes = {
                            'id': cpr.id,
                            'notes': cpr.notes,
                         };
                        return notes;
                    }
                }
            }).result.then(function (result) {
              if (result != null) {
                  cpr.notes = result;
              }
          });
        }

        function openErrorReloadDialog() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.qhpWorkflow.error.reloadPage.message"},
                    title: function () {return "ipmApp.qhpWorkflow.error.reloadPage.title"}
                }
            }).result.then(function() {
                $window.location.reload(); // fix reload page to break the cache
            }, function() {
            });
        }

        $scope.$on(constants.REFRESH, function () {
            openErrorReloadDialog();
        });

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CarePlanReviewDialogController', CarePlanReviewDialogController);

    CarePlanReviewDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'FormatUtilsService', 'CarePlanReviewService'];

    function CarePlanReviewDialogController ($scope, $uibModalInstance, entity, FormatUtilsService, CarePlanReviewService ) {
        var vm = this;
        vm.carePlanReview = entity;
        vm.timeSpentMinute = 0;
        init();

        function init() {
            if (vm.carePlanReview && vm.carePlanReview.timeSpent) {
                vm.timeSpentMinute = FormatUtilsService.formatMinuteBySeconds(vm.carePlanReview.timeSpent);
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        };

        function onSaveError() {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.carePlanReview && vm.carePlanReview.id && vm.timeSpentMinute >= 0) {
                vm.carePlanReview.timeSpent = FormatUtilsService.formatMinuteToSecond(vm.timeSpentMinute);
                CarePlanReviewService.updateTimeSpent(vm.carePlanReview).then(function (res) {
                    onSaveSuccess(res);
                }, function error(e) {
                    onSaveError();
                });
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('CallLogService', CallLogService);

    CallLogService.$inject = ['$resource','$q', 'halClient', '$http', 'DateUtils'];

    function CallLogService($resource, $q, halClient, $http, DateUtils) {
        var baseUrl = 'api/call-logs';
        var resourceUrl = baseUrl + '/:id';
        var service = $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateLog = DateUtils.convertLocalDateTimeToServer(data.dateLog);
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateLog = DateUtils.convertLocalDateTimeToServer(data.dateLog);
                    return angular.toJson(data);
                }
            },
            'delete': {method: 'DELETE'}
        });
        service.findAllByPatientId = findAllByPatientId;

        function findAllByPatientId(patientId, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/find-all-by-patient-id/' + patientId;
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        return service;

    }
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('BatteryTestingService', BatteryTestingService);

    BatteryTestingService.$inject = ['$resource', '$q', 'halClient', '$http'];

    function BatteryTestingService($resource, $q, halClient, $http) {
        var baseUrl = 'api/haq-battery';

        var service = {
            'saveBatteryTesting': saveBatteryTesting,
            'deleteBatteryTesting': deleteBatteryTesting
        };

        function saveBatteryTesting(haqBattery) {
            var url = baseUrl + '/create';
            return $http.post(url, haqBattery).then(function (resp) {
                return resp.data;
            });
        }

        function deleteBatteryTesting(surveyResultId) {
            if(!surveyResultId){
                return;
            }
            var url = baseUrl + '/delete/' + surveyResultId;
            return $http.delete(url).then(function (resp) {
                return resp.data;
            });
        }
        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('battery-test', {
            parent: 'entity',
            url: '/battery-test',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.batteryTest.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/battery-test/battery-tests.html',
                    controller: 'BatteryTestController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('batteryTest');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('battery-test-detail', {
            parent: 'entity',
            url: '/battery-test/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.batteryTest.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/battery-test/battery-test-detail.html',
                    controller: 'BatteryTestDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('batteryTest');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BatteryTest', function($stateParams, BatteryTest) {
                    return BatteryTest.get({id : $stateParams.id});
                }]
            }
        })
        .state('battery-test.new', {
            parent: 'battery-test',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery-test/battery-test-dialog.html',
                    controller: 'BatteryTestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                orderNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('battery-test', null, { reload: true });
                }, function() {
                    $state.go('battery-test');
                });
            }]
        })
        .state('battery-test.edit', {
            parent: 'battery-test',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery-test/battery-test-dialog.html',
                    controller: 'BatteryTestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BatteryTest', function(BatteryTest) {
                            return BatteryTest.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('battery-test', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('battery-test.delete', {
            parent: 'battery-test',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery-test/battery-test-delete-dialog.html',
                    controller: 'BatteryTestDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BatteryTest', function(BatteryTest) {
                            return BatteryTest.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('battery-test', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('BatteryTest', BatteryTest);

    BatteryTest.$inject = ['$resource', '$q', '$http'];

    function BatteryTest ($resource, $q, $http) {
        var baseUrl = 'api/battery-tests';

        var resourceUrl =  'api/battery-tests/:id';

        var service = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        service.getAllBatteryTests = getAllBatteryTests;
        service.getAllBatteryTestsAdHoc = getAllBatteryTestsAdHoc;
        service.getAllBatteryTestsAdHocBy = getAllBatteryTestsAdHocBy;

        function getAllBatteryTests() {
            var deferred = $q.defer();
            var url = baseUrl;
            $http.get(url)
                .success(function (result) {
                    deferred.resolve(result);
                }).error(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getAllBatteryTestsAdHoc() {
            var deferred = $q.defer();
            var url = baseUrl + '/get-all-adhoc';
            $http.get(url)
                .success(function (result) {
                    deferred.resolve(result);
                }).error(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getAllBatteryTestsAdHocBy(patientId) {
            var deferred = $q.defer();
            var url = baseUrl + '/get-all-adhoc-by/' + patientId;
            $http.get(url)
                .success(function (result) {
                    deferred.resolve(result);
                }).error(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('BatteryTestSearch', BatteryTestSearch);

    BatteryTestSearch.$inject = ['$resource'];

    function BatteryTestSearch($resource) {
        var resourceUrl =  'api/_search/battery-tests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestController', BatteryTestController);

    BatteryTestController.$inject = ['$scope', '$state', 'BatteryTest', 'BatteryTestSearch'];

    function BatteryTestController ($scope, $state, BatteryTest, BatteryTestSearch) {
        var vm = this;
        vm.batteryTests = [];
        vm.loadAll = function() {
            BatteryTest.query(function(result) {
                vm.batteryTests = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            BatteryTestSearch.query({query: vm.searchQuery}, function(result) {
                vm.batteryTests = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestDialogController', BatteryTestDialogController);

    BatteryTestDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'BatteryTest', 'Battery', 'Test'];

    function BatteryTestDialogController ($scope, $stateParams, $uibModalInstance, entity, BatteryTest, Battery, Test) {
        var vm = this;
        vm.batteryTest = entity;
        vm.batterys = Battery.query();
        vm.tests = Test.query();
        vm.load = function(id) {
            BatteryTest.get({id : id}, function(result) {
                vm.batteryTest = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:batteryTestUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.batteryTest.id !== null) {
                BatteryTest.update(vm.batteryTest, onSaveSuccess, onSaveError);
            } else {
                BatteryTest.save(vm.batteryTest, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestDetailController', BatteryTestDetailController);

    BatteryTestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BatteryTest', 'Battery', 'Test'];

    function BatteryTestDetailController($scope, $rootScope, $stateParams, entity, BatteryTest, Battery, Test) {
        var vm = this;
        vm.batteryTest = entity;
        vm.load = function (id) {
            BatteryTest.get({id: id}, function(result) {
                vm.batteryTest = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:batteryTestUpdate', function(event, result) {
            vm.batteryTest = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestDeleteController',BatteryTestDeleteController);

    BatteryTestDeleteController.$inject = ['$uibModalInstance', 'entity', 'BatteryTest'];

    function BatteryTestDeleteController($uibModalInstance, entity, BatteryTest) {
        var vm = this;
        vm.batteryTest = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            BatteryTest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('battery', {
            parent: 'entity',
            url: '/battery',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.battery.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/battery/batteries.html',
                    controller: 'BatteryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('battery');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('battery-detail', {
            parent: 'entity',
            url: '/battery/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.battery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/battery/battery-detail.html',
                    controller: 'BatteryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('battery');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Battery', function($stateParams, Battery) {
                    return Battery.get({id : $stateParams.id});
                }]
            }
        })
        .state('battery.new', {
            parent: 'battery',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery/battery-dialog.html',
                    controller: 'BatteryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nameEn: null,
                                nameEs: null,
                                orderNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('battery', null, { reload: true });
                }, function() {
                    $state.go('battery');
                });
            }]
        })
        .state('battery.edit', {
            parent: 'battery',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery/battery-dialog.html',
                    controller: 'BatteryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Battery', function(Battery) {
                            return Battery.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('battery', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('battery.delete', {
            parent: 'battery',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery/battery-delete-dialog.html',
                    controller: 'BatteryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Battery', function(Battery) {
                            return Battery.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('battery', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Battery', Battery);

    Battery.$inject = ['$resource'];

    function Battery ($resource) {
        var resourceUrl =  'api/batteries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('BatterySearch', BatterySearch);

    BatterySearch.$inject = ['$resource'];

    function BatterySearch($resource) {
        var resourceUrl =  'api/_search/batteries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryController', BatteryController);

    BatteryController.$inject = ['$scope', '$state', 'Battery', 'BatterySearch'];

    function BatteryController ($scope, $state, Battery, BatterySearch) {
        var vm = this;
        vm.batteries = [];
        vm.loadAll = function() {
            Battery.query(function(result) {
                vm.batteries = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            BatterySearch.query({query: vm.searchQuery}, function(result) {
                vm.batteries = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryDialogController', BatteryDialogController);

    BatteryDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Battery', 'BatteryTest'];

    function BatteryDialogController ($scope, $stateParams, $uibModalInstance, entity, Battery, BatteryTest) {
        var vm = this;
        vm.battery = entity;
        vm.batterytests = BatteryTest.query();
        vm.load = function(id) {
            Battery.get({id : id}, function(result) {
                vm.battery = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:batteryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.battery.id !== null) {
                Battery.update(vm.battery, onSaveSuccess, onSaveError);
            } else {
                Battery.save(vm.battery, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryDetailController', BatteryDetailController);

    BatteryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Battery', 'BatteryTest'];

    function BatteryDetailController($scope, $rootScope, $stateParams, entity, Battery, BatteryTest) {
        var vm = this;
        vm.battery = entity;
        vm.load = function (id) {
            Battery.get({id: id}, function(result) {
                vm.battery = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:batteryUpdate', function(event, result) {
            vm.battery = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryDeleteController',BatteryDeleteController);

    BatteryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Battery'];

    function BatteryDeleteController($uibModalInstance, entity, Battery) {
        var vm = this;
        vm.battery = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Battery.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('AppointmentService', AppointmentService);

    AppointmentService.$inject = ['$resource','$q', 'halClient', '$http', 'DateUtils'];

    function AppointmentService($resource, $q, halClient, $http, DateUtils) {
        var baseUrl = 'api/appointments';
        var resourceUrl = "api/appointments/:id";
        var service = $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateOfAppointment = DateUtils.convertLocalDateToServer(data.dateOfAppointment);
                    data.timeOfAppointment = DateUtils.convertLocalDateTimeToServer(data.timeOfAppointment);
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateOfAppointment = DateUtils.convertLocalDateToServer(data.dateOfAppointment);
                    data.timeOfAppointment = DateUtils.convertLocalDateTimeToServer(data.timeOfAppointment);
                    return angular.toJson(data);
                }
            },
            'delete': {method: 'DELETE'}
        });
        service.findAllByPatientId = findAllByPatientId;
        service.findById = findById;

        function findAllByPatientId(patientId, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/find-all-by-patient-id';
            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function findById(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/" + id;
            halClient.$get(url).then(function success(result) {
                result.dateOfAppointment = DateUtils.convertDateTimeToDateFromServerAndUpdateHours(result.timeOfAppointment);
                result.timeOfAppointment = DateUtils.convertDateTimeFromServer(result.timeOfAppointment);
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('adhoc-haq-evaluation', {
            parent: 'app',
            url: '/adhoc-haq-evaluation',
            data: {
                authorities: ['ROLE_QHP', 'ROLE_ADMIN'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/adhoc-haq-evaluation/adhoc-haq-evaluation.html',
                    controller: 'AdhocHaqEvaluationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('carePlanReview');
                    $translatePartialLoader.addPart('carePlanReviewStatus');
                    $translatePartialLoader.addPart('haqEvaluation');
                    $translatePartialLoader.addPart('qhpWorkflow');
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('partyType');
                    $translatePartialLoader.addPart('downloadHaqEvaluation');
                    return $translate.refresh();
                }]
            }
        });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AdhocHaqEvaluationController', AdhocHaqEvaluationController);

    AdhocHaqEvaluationController.$inject = ['$scope', '$state', '$stateParams', 'ipmConstants', '$uibModal', 'HAQEvaluationWorkflowService', '$translate', 'Principal', 'ClearLocalStorageService'];

    function AdhocHaqEvaluationController($scope, $state, $stateParams, constants, $uibModal, HAQEvaluationWorkflowService, $translate, Principal, ClearLocalStorageService) {
        var vm = this; //jshint ignore:line

        vm.haqEvaluations = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'surveyResult.id';
        vm.searchQuery = '';

        vm.loadAll = loadAll;
        vm.search = search;

        init();

        function init() {
            vm.pageableHaq = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            HAQEvaluationWorkflowService.findReadyForReviewPaginationByPatient(vm.searchQuery, pageable).then(function (response) {
                if (response) {
                    vm.haqEvaluations = response.data;
                    vm.pageableHaq.totalItems = response.totalItems;
                    vm.isLoading = false;
                }
            });
        }

        function start(haq) {
            HAQEvaluationWorkflowService.adhocUpdateTimeSpent(haq.haqEvaluationId, false, false, false).then(function (res) {
                ClearLocalStorageService.setTimeSpent();
                // $state.go('haq-evaluation.workflow');
                $state.go('haq-evaluation');
            });
        }

        vm.confirmAndStartHaqEvaluation = function (haq) {
            if (!haq.wholeBatteries) {
                return;
            }
            HAQEvaluationWorkflowService.isReviewingHaqEvaluation(haq.haqEvaluationId).then(function (res) {
                if (res) {
                    openConfirmClearHAQEvaluation(haq);
                } else {
                    start(haq);
                }
            });
        }

         function openConfirmClearHAQEvaluation(haq) {
            $uibModal.open({
                templateUrl: 'app/shared/confirm-dialog/confirm-yes-no-dialog.controller.html',
                controller: 'ConfirmYesNoController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.adhocHaqEvaluation.clearConfirm"},
                    title: function () {return "global.form.confirm"}
                }
            }).result.then(function(result) {
                if (result) {
                    start(haq);
                }
            });
        }

        vm.loadPage = function (page) {
            vm.page = page;
            vm.loadAll();
        }

        vm.getIndex = function(index) {
            var result = (index + 1) + (vm.page - 1) * vm.pageSize;
            return result;
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function search(event) {
            vm.searchQuery = event.target.value;
            vm.page = 0;
            vm.reverse = true;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';
	var module = angular.module('ipmApp')

	module.directive('typeaheadShowOnFocus', function () {
        return {
            require: 'ngModel',
            link: function ($scope, element, attrs, ngModel) {
                element.bind('focus', function () {
                    ngModel.$setViewValue();
                    $(element).trigger('input');
                    $(element).trigger('change');
                });
            }
        };
    });

})();
;
(function() {
    'use strict';
	var module = angular.module('ipmApp')

	module.directive('timer', function($filter, $browser, $timeout, ClearLocalStorageService) {
        return {
            restrict: 'A',
            template: "<span>{{minutes}} minutes, {{seconds}} seconds</span>",
            scope: {
                onChange: '&',
                timeSec: '=',
                stop: '<',
                intervalTimeSecond: '<'
            },
            replace: true,
            link: function(scope, element, attrs) {
                scope.hours = "00";
                scope.minutes = "00";
                scope.seconds = "00";
                var interval = null;

                var endTimer = function() {
                    clearInterval(interval);
                }

                var correctInt = function(number) {
                    if (number < 10) {
                        return "0" + number;
                    }
                    return number;
                }

                var run = function() {
                    interval = setInterval(function () {
                        scope.$apply(function () {
                            if (scope.stop && scope.stop == true) {
                                scope.hours = correctInt(parseInt(scope.timeSec / 3600));
                                scope.minutes = correctInt(parseInt(scope.timeSec / 60));
                                scope.seconds = correctInt(scope.timeSec % 60);
                            } else {
                                var timeSpent = ClearLocalStorageService.getTimeSpent();
                                if (!timeSpent) { // not found
                                    scope.timeSec = 0; // reset timeSec
                                    endTimer();
                                }
                                scope.timeSec += 1;
                                scope.hours = correctInt(parseInt(scope.timeSec / 3600));
                                scope.minutes = correctInt(parseInt(scope.timeSec / 60));//scope.minutes = correctInt(parseInt(scope.timeSec % 3600 / 60));
                                scope.seconds = correctInt(scope.timeSec % 60);

                                if (!scope.intervalTimeSecond) {
                                    scope.intervalTimeSecond = 60; // 60second
                                }
                                if (scope.timeSec % scope.intervalTimeSecond === 0) {
                                    scope.onChange({data: scope.minutes});
                                }
                            }
                        })
                    }, 1000);
                };

                run();
            }
        };
	});

})();
;
'use strict';
angular.module('signature', [])
    .directive('signaturePad', ['$timeout', function ($timeout) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/directives/signature-pad/signature-pad.html',
            scope: {
                disabled: '=?',
                dataurl: '@',
                height: '@',
                width: '@',
                notifyDrawing: '&onDrawing',
                get: '=?',
                clear: '=?',
                removeBlank: '@',
                onChange: '&',
            },
            controller: ['$scope', function ($scope) {
                $scope.onMouseup = function () {
                    $scope.updateModel();
                    // notify that drawing has ended
                    $scope.notifyDrawing({ drawing: false });
                };

                $scope.updateModel = function () {
                    /*
                     defer handling mouseup event until $scope.signaturePad handles
                     first the same event
                     */
                    $timeout().then(function () {
                        $scope.dataurl = $scope.signaturePad.isEmpty() ? null : $scope.signaturePad.toDataURL();
                        $scope.updateData();
                    });
                };

                $scope.updateData = function () {
                    var dataSave = $scope.getDataSave();
                    $scope.onChange({data: dataSave});
                };

                $scope.$watch("dataurl", function (dataUrl) {
                    if (!dataUrl || $scope.signaturePad.toDataURL() === dataUrl) {
                        return;
                    }

                    $scope.setDataUrl(dataUrl);
                });

                $scope.onMouseup = function () {
                    $scope.updateModel();
                    // notify that drawing has ended
                    $scope.notifyDrawing({ drawing: false });
                };

                $scope.onMouseleave = function () {
                    $scope.updateModel();
                    // notify that drawing has ended
                    $scope.notifyDrawing({ drawing: false });
                };

                $scope.getDataURL = function () {
                    if ($scope.signaturePad) {
                        console.log("getDataURL: {}", $scope.signaturePad.toDataURL());
                    }
                }

                $scope.clearDataURL = function () {
                    if ($scope.signaturePad) {
                        $scope.signaturePad.clear();
                        $scope.updateModel();
                    }
                }

                $scope.showGet = function () {
                    return $scope.get === true;
                }

                $scope.showClear = function () {
                    return $scope.clear === true;
                }
            }],
            link: function (scope, element, attrs) {
                var canvas = element.find('canvas')[0];
                var scale = 0;
                var ctx = canvas.getContext('2d');

                var width = parseInt(scope.width, 10);
                var height = parseInt(scope.height, 10);

                // canvas.width = "auto";
                canvas.height = height;

                scope.signaturePad = new SignaturePad(canvas, {
                    minWidth: 1.2,
                    maxWidth: 3,
                    backgroundColor: 'rgba(0, 0, 0, 0)', // default: black, transparent 100%
                    penColor: 'rgb(0, 0, 0)'
                });

                scope.setDataUrl = function (dataUrl) {
                    var ratio = Math.max(window.devicePixelRatio || 1, 1);

                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.scale(ratio, ratio);

                    scope.signaturePad.clear();
                    scope.signaturePad.fromDataURL(dataUrl);

                    $timeout().then(function () {
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.scale(1 / scale, 1 / scale);
                    });
                };

                scope.$watch('disabled', function (val) {
                    val ? scope.signaturePad.off() : scope.signaturePad.on();
                });

                element.on('touchstart', onTouchstart);
                element.on('touchend', onTouchend);

                function onTouchstart(event) {
                    scope.$apply(function () {
                        // notify that drawing has started
                        scope.notifyDrawing({ drawing: true });
                    });
                    event.preventDefault();
                }

                function onTouchend(event) {
                    scope.$apply(function () {
                        // notify that drawing has ended
                        if (event.target instanceof HTMLCanvasElement) { // touch canvas
                            // updateModel
                            scope.updateModel();
                            scope.notifyDrawing({ drawing: false });
                        } else if (event.target instanceof HTMLButtonElement) { // touch clear button
                            scope.clearDataURL();
                        }
                    });
                    event.preventDefault();
                }

                scope.getDataSave = function () {
                    if (scope.signaturePad.isEmpty()) {
                        return null;
                    }
                    if (scope.removeBlank !== undefined && scope.removeBlank === 'true') {
                        // copy the canvas
                        var copy = document.createElement('canvas');
                        copy.width = canvas.width;
                        copy.height = canvas.height;
                        copy.getContext('2d').drawImage(canvas, 0, 0);
                        // then trim it
                        return trimCanvas(copy).toDataURL();
                    } else {
                        return scope.signaturePad.toDataURL();
                    }
                };

                function trimCanvas(canvas) {
                    var context = canvas.getContext('2d');

                    var imgWidth = canvas.width;
                    var imgHeight = canvas.height;

                    var imgData = context.getImageData(0, 0, imgWidth, imgHeight).data;

                    // get the corners of the relevant content (everything that's not white)
                    var cropTop = scanY(true, imgWidth, imgHeight, imgData);
                    var cropBottom = scanY(false, imgWidth, imgHeight, imgData);
                    var cropLeft = scanX(true, imgWidth, imgHeight, imgData);
                    var cropRight = scanX(false, imgWidth, imgHeight, imgData);

                    // + 1 is needed because this is a difference, there are n + 1 pixels in
                    // between the two numbers inclusive
                    var cropXDiff = (cropRight - cropLeft) + 1;
                    var cropYDiff = (cropBottom - cropTop) + 1;

                    // get the relevant data from the calculated coordinates
                    var trimmedData = context.getImageData(cropLeft, cropTop, cropXDiff,
                        cropYDiff);

                    // set the trimmed width and height
                    canvas.width = cropXDiff;
                    canvas.height = cropYDiff;
                    // clear the canvas
                    context.clearRect(0, 0, cropXDiff, cropYDiff);
                    // place the trimmed data into the cleared canvas to create
                    // a new, trimmed canvas
                    context.putImageData(trimmedData, 0, 0);
                    return canvas; // for chaining
                }

                // returns the RGBA values of an x, y coord of imgData
                function getRGBA(x, y, imgWidth, imgData) {
                    return {
                        red: imgData[(imgWidth * y + x) * 4],
                        green: imgData[(imgWidth * y + x) * 4 + 1],
                        blue: imgData[(imgWidth * y + x) * 4 + 2],
                        alpha: imgData[(imgWidth * y + x) * 4 + 3]
                    };
                }

                function getAlpha(x, y, imgWidth, imgData) {
                    return getRGBA(x, y, imgWidth, imgData).alpha;
                }

                // finds the first y coord in imgData that is not white
                function scanY(fromTop, imgWidth, imgHeight, imgData) {
                    var offset = fromTop ? 1 : -1;
                    var firstCol = fromTop ? 0 : imgHeight - 1;

                    // loop through each row
                    for (var y = firstCol; fromTop ? (y < imgHeight) : (y > -1); y += offset) {
                        // loop through each column
                        for (var x = 0; x < imgWidth; x++) {
                            // if not white, return col
                            if (getAlpha(x, y, imgWidth, imgData)) {
                                return y;
                            }
                        }
                    }

                    // the whole image is white already
                    return null;
                }

                // finds the first x coord in imgData that is not white
                function scanX(fromLeft, imgWidth, imgHeight, imgData) {
                    var offset = fromLeft ? 1 : -1;
                    var firstRow = fromLeft ? 0 : imgWidth - 1;

                    // loop through each column
                    for (var x = firstRow; fromLeft ? (x < imgWidth) : (x > -1); x += offset) {
                        // loop through each row
                        for (var y = 0; y < imgHeight; y++) {
                            // if not white, return row
                            if (getAlpha(x, y, imgWidth, imgData)) {
                                return x;
                            }
                        }
                    }

                    // the whole image is white already
                    return null;
                }
            }
        }
    }]);
// Backward compatibility
angular.module('ngSignaturePad', ['signature']);
;
	/*
	Automatic phone number formatting in input field
	
	Credits:
	    - Wade Tandy via
	    http://stackoverflow.com/questions/19094150/using-angularjs-directive-to-format-input-field-while-leaving-scope-variable-unc
	    
	    - kstep via
	    http://stackoverflow.com/questions/12700145/how-to-format-a-telephone-number-in-angularjs
	    
	    - hans via
	    http://codepen.io/hans/details/uDmzf/
	*/
(function() {
    'use strict';
	var module = angular.module('ipmApp')
 
	module.directive('phoneInput', function($filter, $browser, $timeout) {
	    return {
	        require: 'ngModel',
	        link: function($scope, $element, $attrs, ngModelCtrl) {
	            var listener = function() {
	                var value = $element.val().replace(/[^0-9]/g, '');	                
	                $element.val($filter('tel')(value, false));
	            };
	
	            // This runs when we update the text field
	            ngModelCtrl.$parsers.push(function(viewValue) {	            	
	            	var val = viewValue.replace(/[^0-9]/g, '').slice(0,10);
	            	ngModelCtrl.$setViewValue(val);	            	
	                return val;
	            });
	
	            // This runs when the model gets updated on the scope directly and keeps our view in sync
	            ngModelCtrl.$render = function() {
	                $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
	            };
	
	            $element.bind('change', listener);
	            $element.bind('keydown', function(event) {
	                var key = event.keyCode;
	                // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
	                // This lets us support copy and paste too
	                if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)){
	                    return;
	                }
	                $browser.defer(listener); // Have to do this or changes don't get picked up properly
	            });
	
	            $element.bind('paste cut', function() {
	                $browser.defer(listener);
	            });
	        }
	
	    };
	});

	module.filter('tel', function () {
	    return function (tel) {
	        if (!tel) { return ''; }
	
	        var value = tel.toString().trim().replace(/^\+/, '');
	
	        if (value.match(/[^0-9]/)) {
	            return tel;
	        }
	
	        var country, city, number;
	
	        switch (value.length) {
	            case 1:
	            case 2:
	            case 3:
	                city = value;
	                break;
	
	            default:
	                city = value.slice(0, 3);
	                number = value.slice(3);
	        }
	
	        if(number){
	        	
	            if(number.length>3){
	                number = number.slice(0, 3) + '-' + number.slice(3,7);
	            }
	            else{
	                number = number;
	            }
	
	            return ("(" + city + ") " + number).trim();
	        }
	        else{
	        	
	            return "(" + city;
	        }
	
	    };
	});
})();;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('confirmPasswordCheck', passwordCheck);

    function passwordCheck() {
    	 var directive = {            
            require: 'ngModel',            
            link: linkFunc
    	 };

        return directive;

        function linkFunc(scope, elem, attrs, ctrl) {
        	var firstPassword = '#' + attrs.confirmPasswordCheck;
            elem.add(firstPassword).on('keyup blur', function () {
            	scope.$apply(function () {
               		ctrl.$setValidity('pwmatch', ($(firstPassword).val() === $(elem).val()));
            	});
            });
        }
    }
})();;
(function() {
    'use strict';
    
    angular
    .module('ipmApp')
    .directive('numbersOnly', numbersOnly);
    
    function numbersOnly() {
    	return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {

                modelCtrl.$parsers.push(function (inputValue) {
                    var transformedInput = inputValue ? inputValue.toString().replace(/[^\d.-]/g,'') : null;

                    if (transformedInput!=inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
    	};
    };
})();
;
(function () {
    'use strict';
    var module = angular.module('ipmApp')

    module.directive('mouseChange', ['$document', function ($document) {

        function mouseChangeCtrl($scope, $element) {
            $element.on('mousedown', mouseMoveHandler);
            $element.on('mousewheel', mouseMoveHandler);
            $element.on('keydown keyup keypress', mouseMoveHandler);

            function mouseMoveHandler(e) {
                if (e) {
                    $scope.onChangeMouseMove({'position': {x: e.clientX, y: e.clientY}});
                }
            };

        }

        return {
            link: mouseChangeCtrl,
            scope: {
                onChangeMouseMove: '&',
            }
        };
    }]);


})();
;
'use strict';

angular.module('ipmApp')
    .directive('minimumValue', function () {
        return {
            restrict: "A",
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                // var value = element.val();
                modelCtrl.$validators.mininumWords = function(modelValue) {
                    if (attrs.minimumValue !== undefined && attrs.minimumValue !== null) {
                        modelValue = modelValue ? modelValue : null;
                        // remove some HTML tags
                        var strippedHtml = modelValue ? modelValue.toString().replace(/<[^>]+>|&nbsp;/g, '').trim() : null;
                        var words  = strippedHtml ? strippedHtml.split(/\s+/g) : null;
                        if (words && words.length < Number(attrs.minimumValue)) {
                            modelCtrl.$setValidity('minimumValue', false);
                            return modelValue;
                        } else {
                            modelCtrl.$setValidity('minimumValue', true);
                            return modelValue;
                        }
                    } else {
                        modelCtrl.$setValidity('minimumValue', false);
                        return modelValue;
                    }
                };
            }
        };
    });
;
(function() {
    'use strict';
	var module = angular.module('ipmApp')

	module.directive('removeByTag', function($filter, $browser, $timeout) {
	    return {
			require: 'ngModel',
			scope: {
                tagName: '@',
            },
	        link: function($scope, $element, $attrs, ngModelCtrl) {
	            //This runs when the model gets updated on the scope directly and keeps our view in sync
	            ngModelCtrl.$render = function() {
					var regex = '<(\/)?' + $scope.tagName + '([^>]*)>';
					var value = ngModelCtrl.$viewValue.replace(new RegExp(regex, 'g'), '');
	                $element.append($filter('tel')(value, false));
	            };
	        }

	    };
	});

})();;
(function() {
    'use strict';
	var module = angular.module('ipmApp')

	module.directive('dragToScroll',['$document', function($document) {
		
	function dragToScrollCtrl($scope, $element, $attrs, ngModelCtrl) {
		var  pos = { top: 0, left: 0, x: 0, y: 0 };
		$element.addClass('scrollContainer');
		$element.on('mousedown', mouseDownHandler);
		$element.on('scroll', scrollHandler);
		function mouseDownHandler (e) {

			$element.css({cursor:'grabbing' , userSelect: 'none'});
			pos = {
				left: $element.scrollLeft(),
				top: $element.scrollTop(),
				x: e.clientX,
				y: e.clientY,
			};
	
			$document.on('mousemove', mouseMoveHandler);
			$document.on('mouseup', mouseUpHandler);

		};
		function scrollHandler(e)  {
			$scope.onScroll({'position': {top:$element.scrollTop(),left: $element.scrollLeft() }});
		};
		function mouseMoveHandler(e)  {
			var dx = e.clientX - pos.x;
			var dy =  e.clientY - pos.y;
			var top = pos.top - dy;
			var left = pos.left - dx
			$element.scrollTop(top);
			$element.scrollLeft(left);
			$scope.onScroll({'position': {top:$element.scrollTop(),left: $element.scrollLeft() }});
		};
		function mouseUpHandler(e) {
			$document.off('mousemove', mouseMoveHandler);
			$document.off('mouseup', mouseUpHandler);
					$scope.onScroll({'position': {top:$element.scrollTop(),left: $element.scrollLeft()}});
		};
	 }
	    return {
	        link: dragToScrollCtrl,
			scope: {
				onScroll: '&',
				onScrollEnd: '&'
			}
	    };
	}]);


})();;

'use strict';

angular.module('rorymadden.date-dropdowns', [])


.factory('rsmdateutils', function () {
  // reduce the day count if not a valid date (e.g. 30 february)
  function changeDate(date){
    if(date.day > 28) {
      date.day--;
      return date;
    }
    // this case should not exist with a restricted input
    // if a month larger than 11 is entered
    else if (date.month > 11) {
      date.day = 31;
      date.month--;
      return date;
    }
  }

  var self = this;
  this.days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
  this.months = [
    { value: 0, name: 'global.text.january' },
    { value: 1, name: 'global.text.february' },
    { value: 2, name: 'global.text.march' },
    { value: 3, name: 'global.text.april' },
    { value: 4, name: 'global.text.may' },
    { value: 5, name: 'global.text.june' },
    { value: 6, name: 'global.text.july' },
    { value: 7, name: 'global.text.august' },
    { value: 8, name: 'global.text.september' },
    { value: 9, name: 'global.text.october' },
    { value: 10, name: 'global.text.november' },
    { value: 11, name: 'global.text.december' }
  ];

  return {
	  checkDate: function (date) {
	        var d;
	        if (!date || !date.day || date.month === null || date.month === undefined || !date.year) return false;

	        d = new Date(date.year, date.month, date.day);

	        if (d && (d.getMonth() === date.month && d.getDate() === Number(date.day))) {
	          return d;
	        }

	        return this.checkDate(changeDate(date));
	      },
    get: function(name) {
      return self[name];
    }
  };
})

.directive('rsmdatedropdowns', ['rsmdateutils', function (rsmdateutils){
  return {
    restrict: 'A',
    replace: true,
    require: 'ngModel',
    scope: {
      model: '=ngModel',
      dayName: '@',
      monthName: '@',
      yearName: '@',
      decrementYear: '<',
      minYear: '<',
      formatDate: '<',
    },
    controller: ['$scope', 'rsmdateutils', function ($scope, rsmDateUtils) {
      // set up arrays of values
      $scope.days = rsmDateUtils.get('days');
      $scope.months = rsmDateUtils.get('months');

      // split the current date into sections
      $scope.dateFields = {};

      if(!$scope.model) {
    	  $scope.dateFields.day = "";
          $scope.dateFields.month = "";
          $scope.dateFields.year = "";
      } else {
          $scope.dateFields.day = $scope.formatDate === true ? new Date($scope.model).getDate() : new Date($scope.model).getUTCDate();
          $scope.dateFields.month = $scope.formatDate === true ? new Date($scope.model).getMonth() : new Date($scope.model).getUTCMonth();
          $scope.dateFields.year = $scope.formatDate === true ? new Date($scope.model).getFullYear() : new Date($scope.model).getUTCFullYear();
      }

      // validate that the date selected is accurate
      $scope.checkDate = function(){
        // update the date or return false if not all date fields entered.
        var date = rsmDateUtils.checkDate($scope.dateFields);
        if(date){
        	$scope.model = date;
        }
      };
      $scope.isRequired = function() {
        return !$scope.disableFields && ($scope.required
          || ($scope.dateFields.month != undefined && $scope.dateFields.month  != '')
          || ($scope.dateFields.year != undefined && $scope.dateFields.year != '')
          || ($scope.dateFields.day != undefined && $scope.dateFields.day != ''));
      };
    }],
    template:
    '<div class="row-v4">' +
    '  <div class="col-v4-5">' +
    '    <select id="{{monthName}}" name="{{monthName}}" data-ng-model="dateFields.month" placeholder="{{\'global.text.month\' | translate}}" class="form-control" ng-options="month.value as month.name | translate for month in months" value="{{dateField.month}}" ng-change="checkDate()" ng-disabled="disableFields" ng-required="isRequired()"><option value="" selected> {{"global.text.month" | translate}} </option></select>' +
    '  </div>' +
    '<div class="col-v4 col-day">' +
    '    <select id="{{dayName}}" name="{{dayName}}" data-ng-model="dateFields.day" placeholder="{{\'global.text.day\' | translate}}" class="form-control" ng-options="day for day in days" ng-change="checkDate()" ng-disabled="disableFields" ng-required="isRequired()"><option value="" selected> {{"global.text.day" | translate}} </option></select>' +
    '  </div>' +
    '  <div class="col-v4 col-day">' +
    '    <select ng-if="!yearText" id="{{yearName}}" name="{{yearName}}" data-ng-model="dateFields.year" placeholder="{{\'global.text.year\' | translate}}" class="form-control" ng-options="year for year in years" ng-change="checkDate()" ng-disabled="disableFields" ng-required="isRequired()"><option value="" selected> {{"global.text.year" | translate}} </option></select>' +
    '    <input ng-if="yearText" type="text" id="{{yearName}}" name="{{yearName}}" data-ng-model="dateFields.year" placeholder="Year" class="form-control" ng-disabled="disableFields">' +
    '  </div>' +
    '</div>',
    link: function(scope, element, attrs, ctrl){
      if(attrs.ngRequired =='true') {
        scope.required = true;
      } else {
        scope.required = false;
      }
      if(attrs.yearText) {
        scope.yearText = true;
      }
      // allow overwriting of the
      if(attrs.dayDivClass){
        angular.element(element[0].children[0]).removeClass('form-group col-xs-3');
        angular.element(element[0].children[0]).addClass(attrs.dayDivClass);
      }
      if(attrs.dayClass){
        angular.element(element[0].children[0].children[0]).removeClass('form-control');
        angular.element(element[0].children[0].children[0]).addClass(attrs.dayClass);
      }
      if(attrs.monthDivClass){
        angular.element(element[0].children[1]).removeClass('form-group col-xs-5');
        angular.element(element[0].children[1]).addClass(attrs.monthDivClass);
      }
      if(attrs.monthClass){
        angular.element(element[0].children[1].children[0]).removeClass('form-control');
        angular.element(element[0].children[1].children[0]).addClass(attrs.monthClass);
      }
      if(attrs.yearDivClass){
        angular.element(element[0].children[2]).removeClass('form-group col-xs-4');
        angular.element(element[0].children[2]).addClass(attrs.yearDivClass);
      }
      if(attrs.yearClass){
        angular.element(element[0].children[2].children[0]).removeClass('form-control');
        angular.element(element[0].children[2].children[0]).addClass(attrs.yearClass);
      }

      // set the years drop down from attributes or defaults
      var currentYear = parseInt(attrs.startingYear,10) || new Date().getFullYear();
      // add decrementYear
        if (currentYear && scope.decrementYear) {
            currentYear = currentYear + scope.decrementYear;
        }
      var numYears = parseInt(attrs.numYears,10) || 100;
      var oldestYear = currentYear - numYears;

      scope.years = [];
      for(var i = currentYear; i >= oldestYear; i-- ){
          if (scope.minYear && scope.minYear > 0) {
              if (i >= scope.minYear) {
                  scope.years.push(i);
              }
          } else {
              scope.years.push(i);
          }
      }

      // pass down the ng-disabled property
      scope.$parent.$watch(attrs.ngDisabled, function(newVal){
        scope.disableFields = newVal;
      });

      // ensure that fields are entered
      /*if(attrs.required) {
    	  var required = attrs.required.split(' ');
          ctrl.$parsers.push(function(value) {
            angular.forEach(required, function (elem) {
              if(!angular.isNumber(elem)) {
                ctrl.$setValidity('required', false);
              }
            });
            ctrl.$setValidity('required', true);
          });
      }*/
      // var validator = function(){
      //   var valid = true;
      //   // all fields entered
      //   angular.forEach(required, function (elem) {
      //     if(!angular.isNumber(elem)) {
      //       valid = false;
      //     }
      //   });
      //   // if(isNaN(scope.dateFields.day) && isNaN(scope.dateFields.month) && isNaN(scope.dateFields.year)){
      //   //   valid = true;
      //   // }
      //   // else if(!isNaN(scope.dateFields.day) && !isNaN(scope.dateFields.month) && !isNaN(scope.dateFields.year)){
      //   //   valid = true;
      //   // }
      //   // else valid = false;

      //   ctrl.$setValidity('rsmdatedropdowns', valid);
      // };

      // scope.$watch('dateFields.day', function(){
      //   validator();
      // });

      // scope.$watch('dateFields.month', function(){
      //   validator();
      // });

      // scope.$watch('dateFields.year', function(){
      //   validator();
      // });
    }
  };
}]);
;
(function() {
    'use strict';
    
    angular
    .module('ipmApp')
    .directive('convertToNumber', convertToNumber);
    
    function convertToNumber() {
    	return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function(val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function(val) {
                return '' + val;
            });
            }
    	};
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('checkMaxlength', checkMaxlength);

    function checkMaxlength() {
        return {
            restrict: 'A', // This directive will be used as an attribute
            require: 'ngModel', // We need access to ngModelController
            link: function (scope, element, attrs, ngModelCtrl) {

                var maxLength = parseInt(attrs.checkMaxlength, 10);  // Get the maxlength value from the attribute

                // Custom validator for maxlength
                function validateMaxlength(value) {
                    if (value && value.length > 0) {
                        ngModelCtrl.$setDirty(); // fix not showing messages maxlength when invalid
                    }
                    if (maxLength && maxLength > 0) { // only check if maxlength is greater than zero
                        if (value && value.length > maxLength) {
                            ngModelCtrl.$setValidity('maxlength', false);  // Set validity to false if length exceeds maxlength
                        } else {
                            ngModelCtrl.$setValidity('maxlength', true);  // Set validity to true if length is within limit
                        }
                    }
                    return value; // Return the value to the model
                }

                // used to watch changes in the input value and reapply the validation on every user input or format update.
                ngModelCtrl.$parsers.push(validateMaxlength);
                ngModelCtrl.$formatters.push(validateMaxlength);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('ipmApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('numberMinMax', numberMinMax);

        numberMinMax.$inject = [];



    function numberMinMax() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: false,
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, controller) {
            var min = parseInt(attrs.min);
            var max = parseInt(attrs.max);

            controller.$parsers.unshift(function (value) {
                var INTEGER_REGEXP = /^\d+$/;
                if (!value) {
                    controller.$setValidity('invalidRange', true);
                    controller.$setValidity('pattern', true);
                    return value;
                }
                if (INTEGER_REGEXP.test(value)) { // it is valid
                    controller.$setValidity('pattern', true);
                    var number = parseInt(value);
                    if (number < min || number > max) {
                        controller.$setValidity('invalidRange', false);
                        return null;
                    }
                    controller.$setValidity('invalidRange', true);
                    return value;
                }
                controller.$setValidity('pattern', false);
                if (typeof value !== 'number') {
                    controller.$setValidity('invalidRange', true);
                }
                return null;
            });
        }
        
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('ipmApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            convertLocalDateTimeToServer : convertLocalDateTimeToServer,
            convertDateTimeToDateFromServerAndUpdateHours : convertDateTimeToDateFromServerAndUpdateHours,
            dateformat : dateformat,
            convertDateIgnoreTimeZone: convertDateIgnoreTimeZone,
            isValidFromDateAndToDate: isValidFromDateAndToDate
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function convertLocalDateTimeToServer (date) {
            if (date) {
                return $filter('date')(date, "yyyy-MM-dd HH:mm:ss Z");
            } else {
                return null;
            }
        }

        function convertDateTimeToDateFromServerAndUpdateHours(date) {
            if (date == null) {
                return null;
            }
            var convertLocalDate = new Date(date);
            convertLocalDate.setHours(0, 0, 0);
            return convertLocalDate;
        }

        function convertDateIgnoreTimeZone(date) {
            if (date == null) {
                return null;
            }
            var convertLocalDate = new Date(date);
            return convertLocalDate.setMinutes(convertLocalDate.getMinutes() + convertLocalDate.getTimezoneOffset())
        }

        function isValidFromDateAndToDate(fromDate, toDate) {
            var isValid = fromDate !== undefined && toDate !== undefined;
            if (!fromDate || !toDate) {
                return;
            }
            fromDate.setHours(0, 0, 0, 0);
            toDate.setHours(0, 0, 0, 0);
            return isValid && fromDate > toDate;
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64,
            timerTextClass: timerTextClass,
            secondsToMinute: secondsToMinute,
            deepCopy: deepCopy,
            isEqualText: isEqualText,
            isEqualBoolean: isEqualBoolean,
            countAttendanceTrackerNotAbsent: countAttendanceTrackerNotAbsent,
            checkForMaxLengthErrors: checkForMaxLengthErrors
        };

        return service;

        function checkForMaxLengthErrors(form) {
            // Loop through all form controls
            for (var field in form) {
                if (form.hasOwnProperty(field)) {
                    var formField = form[field];

                    // Check if this field is a form control and has the maxlength error
                    if (formField && formField.$error && formField.$error.maxlength) {
                        return true; // Maxlength error found
                    }
                }
            }

            return false; // No maxlength error found
        }

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }

        function timerTextClass(timerSeconds) {
            var timerMinutes = timerSeconds ? parseInt(timerSeconds / 60) : 0;
            if (timerMinutes && timerMinutes >= 35) {
                return 'text-danger';
            } else if (timerMinutes && timerMinutes >= 31 && timerMinutes < 35) {
                return 'text-success';
            }
            return 'text-warning';
        }

        function secondsToMinute(timerSeconds) {
            if (isNaN(timerSeconds)) {
                return 0;
            }
            var minutes = parseInt(timerSeconds / 60);
            var extraSeconds = timerSeconds % 60;
            if (extraSeconds >= 30) { // apply extraSeconds same component timeSpent CarePlanReview
                minutes += 1;
            }
            return minutes;
        }

        function deepCopy(obj) {
            var copy;
            // Handle the 3 simple types, and null or undefined
            if (null == obj || "object" != typeof obj) return obj;
            // Handle Date
            if (obj instanceof Date) {
                copy = new Date();
                copy.setTime(obj.getTime());
                return copy;
            }
            // Handle Array
            if (obj instanceof Array) {
                copy = [];
                for (var i = 0, len = obj.length; i < len; i++) {
                    copy[i] = deepCopy(obj[i]);
                }
                return copy;
            }
            // Handle Object
            if (obj instanceof Object) {
                copy = {};
                for (var attr in obj) {
                    if (obj.hasOwnProperty(attr)) copy[attr] = deepCopy(obj[attr]);
                }
                return copy;
            }
            throw new Error("Unable to copy obj! Its type isn't supported.");
        }

        function isEqualText(v1, v2) {
            return _.isEqualWith(v1, v2, function (a, b) {
                a = a ? a : null;
                b = b ? b : null;
                return angular.equals(a, b);
                // if ((_.isNull(a) || a === '') && (_.isNull(b) || b === '')) {
                //     return true;
                // }
            });
        }

        function isEqualBoolean(v1, v2) {
            return _.isEqualWith(v1, v2, function (a, b) {
                if ((_.isNull(a) || a === false) && (_.isNull(b) || b === false)) {
                    return true;
                }
            });
        }

        /**
         * calcCountAttendanceTrackerNotAbsent.
         * @param attendanceTracker
         * @return days have check is true
         */
        function countAttendanceTrackerNotAbsent(attendanceTracker) {
            var countAttendanceTracker = 0;
            if (attendanceTracker) {
                if (attendanceTracker.mon && attendanceTracker.mon === true) {
                    countAttendanceTracker += 1
                }
                if (attendanceTracker.thu && attendanceTracker.thu === true) {
                    countAttendanceTracker += 1
                }
                if (attendanceTracker.tue && attendanceTracker.tue === true) {
                    countAttendanceTracker += 1
                }
                if (attendanceTracker.wed && attendanceTracker.wed === true) {
                    countAttendanceTracker += 1
                }
                if (attendanceTracker.fri && attendanceTracker.fri === true) {
                    countAttendanceTracker += 1
                }
                if (attendanceTracker.sat && attendanceTracker.sat === true) {
                    countAttendanceTracker += 1
                }
                if (attendanceTracker.sun && attendanceTracker.sun === true) {
                    countAttendanceTracker += 1
                }
            }
            return countAttendanceTracker;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input) {
                input = input.toLowerCase();
                return input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return "";
        }
    }
})();
;
if (!Function.prototype.bind) {
  Function.prototype.bind = function(oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // Function.prototype doesn't have a prototype property
      fNOP.prototype = this.prototype; 
    }
    fBound.prototype = new fNOP();

    return fBound;
  };
};
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('ipmApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function () {
    'use strict';

    UploadImagesComponent.$inject = ['$scope'];

    function UploadImagesComponent($scope) {
        var vm = this; //jshint ignore:line
        vm.picFile = null;
        vm.hasChanged = false;
        vm.cropSize = 300;

        init();

        function init() {
            vm.hasChanged = false;
            vm.imageData = vm.imageData ? vm.imageData : '';
        }

        vm.onImageSelect = function ($files) {
            if ($files && $files.length > 0) {
                vm.hasChanged = true;
            }
        }

        vm.imgCropOnChange = function () {
        }

        vm.removeImage = function () {
            vm.imageData = null;
            vm.picFile = null;
            vm.hasChanged = false;
        }

    }

    angular.module('ipmApp').component('uploadImages', {
        bindings: {
            imageData: '='
        },
        templateUrl: 'app/components/upload-images/upload-images.component.html',
        controller: UploadImagesComponent,
        controllerAs: 'vm',
        resolve: {}
    });
})();
;
(function() {
    'use strict';


    TimeSpentComponent.$inject = ['$timeout', '$scope', '$interval'];

    function TimeSpentComponent($timeout, $scope, $interval) {
        var vm = this; //jshint ignore:line
        vm.updateUI = updateUI;
        vm.start = start;
        vm.stop = stop;
        vm.displayNumber = displayNumber;
        vm.isDisplayHour = isDisplayHour;
        var intervalTimeSpent = null;

        init();

        function init() {
            // $scope.totalSeconds = vm.startTime;
            // calculate
            vm.updateUI(vm.startTime);

            if (vm.autoStart) {
                vm.start();
            }

            $scope.$on('startTimeSpent', function(e) {
                vm.start();
            });

            $scope.$on('stopTimeSpent', function(e) {
                stop();
            });
        }

        function start() {
            if (!vm.interval) {
                vm.interval = 1000; // set default
            }

            intervalTimeSpent = setInterval(function () {

                vm.startTime = Number(vm.startTime) + 1;
                vm.updateUI(vm.startTime);
                // emit update event
                vm.onChange( {data: { totalSeconds: vm.startTime }});
                $scope.$digest();
            }, vm.interval);
        }

        function stop() {
            clearInterval(intervalTimeSpent);
            $interval.cancel(intervalTimeSpent);
        }

        function displayNumber(number) {
            return number < 10 ? "0" + number : number;
        }

        function updateUI(seconds) {
            $scope.hour = vm.displayNumber(parseInt(seconds / 3600));
            if (vm.isDisplayHour() && seconds >= 3600) {
                $scope.minute = vm.displayNumber(parseInt((seconds - (3600 * Number($scope.hour))) / 60));
            } else {
                $scope.minute = vm.displayNumber(parseInt(seconds / 60));
            }
            $scope.second = vm.displayNumber(seconds % 60);
        }

        $scope.isDisplayHour = function() {
            return vm.isDisplayHour()
        }

        function isDisplayHour() {
            return vm.maxTimeUnit == 'hour';
        }

    }

    angular.module('ipmApp').component('timeSpent', {
        bindings: {
            interval: '<', // in millisecond default = 1000
            startTime: '=', // in seconds
            autoStart: '<', // default false
            maxTimeUnit: '<', // max is 'hour', min is 'minute', default is minute
            onChange: '&'
        },
        template: '<span> <span ng-if="isDisplayHour()">{{hour}} hours</span> {{minute}} minutes, {{second}} seconds </span>',
        controller: TimeSpentComponent,
        controllerAs: 'vm'
    })
})();
;
(function () {
    'use strict';

    TimeSpentWorkerComponent.$inject = ['$scope'];

    function TimeSpentWorkerComponent($scope) {
        var vm = this; //jshint ignore:line
        vm.updateUI = updateUI;
        vm.displayNumber = displayNumber;
        vm.isDisplayHour = isDisplayHour;

        init();

        function init() {
            // calculate
            vm.updateUI(vm.startTime);
        }

        function updateUI(seconds) {
            $scope.hour = vm.displayNumber(parseInt(seconds / 3600));
            if (vm.isDisplayHour() && seconds >= 3600) {
                $scope.minute = vm.displayNumber(parseInt((seconds - (3600 * Number($scope.hour))) / 60));
            } else {
                $scope.minute = vm.displayNumber(parseInt(seconds / 60));
            }
            $scope.second = vm.displayNumber(seconds % 60);
        }

        $scope.isDisplayHour = function () {
            return vm.isDisplayHour()
        }

        function isDisplayHour() {
            return vm.maxTimeUnit == 'hour';
        }

        function displayNumber(number) {
            return number < 10 ? "0" + number : number;
        }

        $scope.$watch('vm.startTime', function (newValue) {
            if (vm.startTime) {
                updateUI(vm.startTime);
                // $scope.$digest();
            }

        });

    }

    angular.module('ipmApp').component('timeSpentWorker', {
        bindings: {
            startTime: '=', // in seconds
            maxTimeUnit: '<', // max is 'hour', min is 'minute', default is minute
            onChange: '&'
        },
        template: '<span> <span ng-if="isDisplayHour()">{{hour}} hours</span> {{minute}} minutes, {{second}} seconds </span>',
        controller: TimeSpentWorkerComponent,
        controllerAs: 'vm'
    })
})();
;
(function() {
    'use strict';


    SecondsTransferComponent.$inject = ['$scope'];

    function SecondsTransferComponent($scope) {
        var vm = this; //jshint ignore:line
        

        init();

        function init() {
            if (vm.totalSeconds) {
                $scope.minutes = parseInt(vm.totalSeconds / 60);
                var extraSeconds = vm.totalSeconds % 60;
                if (extraSeconds >= 30) {
                    $scope.minutes += 1;
                }
            }
        }

    }

    angular.module('ipmApp').component('secondsTransfer', {
        bindings: {
            totalSeconds: '<', // in seconds
            to: '<' // in minutes
        },
        template: '<span ng-if="minutes">{{minutes}} min</span>',
        controller: SecondsTransferComponent,
        controllerAs: 'vm'
    })
})();
;
// Import Quill using CommonJS syntax
(function() {
    'use strict';


    QuillEditorComponent.$inject = ['$timeout', '$window'];

    function QuillEditorComponent($timeout, $window) {
        var vm = this; //jshint ignore:line
        var Quill = $window.Quill;
        var Delta = Quill.import('delta');

        init();

        function init() {
            var toolbarOptions = [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                // ['blockquote', 'code-block'],
              
                // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                // [{ 'direction': 'rtl' }],                         // text direction
              
                [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              
                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }]
            ];

            var container = document.getElementById(vm.ids);
            var quill = new Quill(container, {
                modules: {
                    toolbar: vm.hideToolbar ? false : toolbarOptions
                },
                theme: 'snow'
            });
            $timeout(function(){
                var delta = quill.clipboard.convert(vm.value);
                quill.setContents(delta, 'silent');
            }, 100);
            // emit data when change
            quill.on('editor-change', function() {
                if (vm.maxLength && vm.maxLength > 0) {
                    updateMaxTextQuill(quill);
                }
                if (isEmptyQuillContent(quill)) {
                    vm.onEditChange({data: ''});
                } else {
                    vm.onEditChange({data: quill.root.innerHTML});
                }
            });

            // disable if view
            if (vm.view) {
                quill.enable(false);
                var toolbar = quill.getModule('toolbar');
                angular.forEach(toolbar.container.querySelectorAll('select'), function (input) {
                    input.parentElement.className = 'ql-formats quill-select-disabled';
                });
                angular.forEach(toolbar.container.querySelectorAll('button'), function (input) {
                    input.parentElement.className = 'ql-formats quill-select-disabled';
                });
                // change back-ground input
                if (quill.container.classList.contains('ql-container')) {
                    quill.container.classList.add('disabled-background-color');
                }
            }

            // event QuillCopy
            formatPasteEvent(quill);
        }

        function formatPasteEvent(quill) {
            if (vm.enableFormatCopyEvent) {
                quill.container.addEventListener('paste', function (e) {
                    quill.clipboard.addMatcher(Node.ELEMENT_NODE, function (node, delta) {
                        // removes any leading and trailing whitespace from the text before replacing the line breaks.
                        // fix the line breaks when paste in firefox
                        var plaintext = node.textContent ? node.textContent.trim() : '';
                        plaintext = plaintext.replace(/\n/g, '');
                        return new Delta().insert(plaintext);
                    });
                });
            }
        }

        function updateMaxTextQuill(quill) {
            var text = quill.getText();
            // Check if the text length exceeds the maximum length
            if (text && text.length > vm.maxLength) {
                // Delete the excess text
                quill.deleteText(vm.maxLength, text.length);
            }
        }

        function isEmptyQuillContent(quill) {
            if (quill) {
                var delta = quill.getContents();
                if (delta && delta.ops && delta.ops.length > 0) {
                    var opsData = delta.ops[0].insert;
                    var plainText = opsData.replace(/\n/g, '').trim();
                    return plainText.length === 0;
                }
            }
            return true;
        }

    }

    angular.module('ipmApp').component('quillEditor', {
        bindings: {
            value: '=',
            ids: '<',
            view: '<',
            hideToolbar: '<',
            enableFormatCopyEvent: '<',
            maxLength: '<',
            onEditChange: '&'
        },
        template: '',
        controller: QuillEditorComponent,
        controllerAs: 'vm'
    });
})();
;
(function () {
    'use strict';

    PdfViewComponent.$inject = [
        '$scope',
        '$rootScope',
        '$sce',
        'pdfDelegate',
        'ipmConstants',
    ];

    function PdfViewComponent(
        $scope,
        $rootScope,
        $sce,
        pdfDelegate,
        ipmConstants
    ) {
        var vm = this; //jshint ignore:line
        vm.PDF_DELEGATE = 'pdf-container';
        vm.scaleZoom = 0.1;
        vm.scaleZoomCurrent = 1;
        vm.scaleZoomMax = 6; // zoom max 600%, can zoom max 8.6
        vm.zoomToDefault = ipmConstants.PDF_DEFAULT_SCALE;
        vm.convertDataPdf = convertDataPdf;
        vm.zoomIn = zoomIn;
        vm.zoomOut = zoomOut;
        vm.next = next;
        vm.back = back;
        vm.getPageCount = getPageCount;
        vm.currentPage = 1;
        vm.goToPageInput = goToPageInput;
        vm.isShowPdfCanvas = true;

        init();

        function init() {
            vm.scaleZoomCurrent = vm.zoomToDefault;
        }

        function convertDataPdf(pdfData) {
            if (pdfData) {
                if (vm.uint8Enable) {
                    return new Uint8Array(pdfData);
                }
                return pdfData;
            }
        }

        function zoomIn() {
            if (vm.scaleZoomCurrent >= vm.scaleZoomMax) {
                return;
            }
            vm.scaleZoomCurrent += vm.scaleZoom;
            zoomTo(vm.scaleZoomCurrent);
            vm.onchangeZoomIn({
                scaleZoom: vm.scaleZoomCurrent,
            });
        }

        function zoomOut() {
            if (vm.scaleZoomCurrent <= 0) {
                return;
            }
            vm.scaleZoomCurrent -= vm.scaleZoom;
            zoomTo(vm.scaleZoomCurrent);

            vm.onchangeZoomOut({
                scaleZoom: vm.scaleZoomCurrent,
            });
        }

        function zoomTo(scale) {
            pdfDelegate
                .$getByHandle(vm.PDF_DELEGATE)
                .zoomTo(Number(scale) > 0 ? Number(scale) : vm.zoomToDefault);
        }

        function next() {
            vm.currentPage++;
            goToPage();
            vm.onchangeNext({
                currentPage: vm.currentPage,
            });
        }

        function back() {
            vm.currentPage--;
            goToPage();
            vm.onchangeBack({
                currentPage: vm.currentPage,
            });
        }

        function getPageCount() {
            var pdfHandle = pdfDelegate.$getByHandle(vm.PDF_DELEGATE);
            if (pdfHandle) {
                return pdfDelegate.$getByHandle(vm.PDF_DELEGATE).getPageCount();
            }
        }

        function getCurrentPage() {
            return pdfDelegate.$getByHandle(vm.PDF_DELEGATE).getCurrentPage();
        }

        function goToPageInput() {
            goToPage();
            vm.onchangeGoToPage({
                currentPage: vm.currentPage,
            });
        }

        function goToPage(currentPage) {
            pdfDelegate
                .$getByHandle(vm.PDF_DELEGATE)
                .goToPage(currentPage > 0 ? currentPage : vm.currentPage);
        }

        function reloadViewPdf(pdfData) {
            if (pdfData && pdfData.length > 0) {
                // have data
                pdfDelegate.$getByHandle(vm.PDF_DELEGATE).load(pdfData);
                vm.isShowPdfCanvas = true;
                vm.currentPage = 1;
                zoomTo(vm.zoomToDefault);
                vm.scaleZoomCurrent = vm.zoomToDefault;
            } else {
                loadNewBlankFile();
            }
        }

        function loadNewBlankFile() {
            vm.isShowPdfCanvas = false;
        }

        // used reload Pdf when next or back slide
        $scope.$watch('vm.pdfData', function (newValue) {
            reloadViewPdf(convertDataPdf(vm.pdfData));
            if (vm.pdfData && vm.pdfData.length > 0) {
                goToPage();
            }
        });
    }

    angular.module('ipmApp').component('pdfView', {
        bindings: {
            pdfData: '<',
            uint8Enable: '<',
            isShowToolbar: '<',
            onchangeBack: '&',
            onchangeNext: '&',
            onchangeZoomIn: '&',
            onchangeZoomOut: '&',
            onchangeGoToPage: '&',
        },
        template: '<div ng-if="vm.isShowPdfCanvas" class="pdf-viewer-container">' +
            '<div class="py-1 pdf-viewer-toolbar">' +
            '<div ng-if="vm.isShowToolbar" class="btn-group">' +
            '<span><button type="button" ng-disabled="vm.currentPage === 1" class="btn btn-default btn-sm toolbarButton" ng-click="vm.back()" ng-dis title="Previous Page"><span class="glyphicon glyphicon-arrow-up"></span></button></span>|' +
            '<span><button type="button" ng-disabled="vm.currentPage >= vm.getPageCount()" class="btn btn-default btn-sm toolbarButton" ng-click="vm.next()" title="Next Page"><span class="glyphicon glyphicon-arrow-down"></span></button></span>' +
            '<span class="px1"></span><input type="number" class="toolbarField pageNumber" min="1" ng-model="vm.currentPage" ng-change="vm.goToPageInput()" style="width: 15%">  of {{vm.getPageCount()}}</span>' +
            '<span><button type="button" ng-disabled="vm.scaleZoomCurrent <= 0" class="btn btn-default btn-sm toolbarButton" ng-click="vm.zoomOut()" title="Zoom Out"><span class="glyphicon glyphicon-minus"></span></button></span>|' +
            '<span><button type="button" ng-disabled="vm.scaleZoomCurrent >= vm.scaleZoomMax" class="btn btn-default btn-sm toolbarButton" ng-click="vm.zoomIn()" title="Zoom In"><span class="glyphicon glyphicon-plus"></span></button></span>' +
            '</div>' +
            '</div>' +
            '<pdf-viewer ng-if="vm.pdfData" ' +
            'delegate-handle="pdf-container" ' +
            'url="vm.convertDataPdf(vm.pdfData)" ' +
            'scale="1.3" ' +
            'show-toolbar="false" ' +
            "headers=\"{ 'x-you-know-whats-awesome': 'EVERYTHING' }\"></pdf-viewer>" +
            '</div>',
        controller: PdfViewComponent,
        controllerAs: 'vm',
    });
})();
;
(function () {
    'use strict';

    PdfPreviewComponent.$inject = [
        '$scope',
        '$rootScope',
        '$sce',
        'pdfDelegate',
        'ipmConstants',
    ];

    function PdfPreviewComponent(
        $scope,
        $rootScope,
        $sce,
        pdfDelegate,
        ipmConstants
    ) {
        var vm = this; //jshint ignore:line
        vm.PDF_DELEGATE = 'pdf-container';
        vm.scaleZoom = 0.1;
        vm.scaleZoomCurrent = 1;
        vm.scaleZoomMaxDefault = 6; // zoom max 600%, can zoom max 8.6
        vm.zoomToDefault = ipmConstants.PDF_DEFAULT_SCALE;
        vm.convertDataPdf = convertDataPdf;
        vm.zoomIn = zoomIn;
        vm.zoomOut = zoomOut;
        vm.next = next;
        vm.back = back;
        vm.getPageCount = getPageCount;
        vm.currentPage = 1;
        vm.goToPageInput = goToPageInput;
        vm.isShowPdfCanvas = true;

        init();

        function init() {
            vm.scaleZoomCurrent = vm.zoomToDefault;
            vm.scaleZoomMax = vm.scaleZoomMax ? vm.scaleZoomMax : vm.scaleZoomMaxDefault;
        }

        function convertDataPdf(pdfData) {
            if (pdfData) {
                if (vm.uint8Enable) {
                    return new Uint8Array(pdfData);
                }
                return pdfData;
            }
        }

        function zoomIn() {
            if (vm.scaleZoomCurrent >= vm.scaleZoomMax) {
                return;
            }
            vm.scaleZoomCurrent += vm.scaleZoom;
            zoomTo(vm.scaleZoomCurrent);
            vm.onchangeZoomIn({
                scaleZoom: vm.scaleZoomCurrent,
            });
        }

        function zoomOut() {
            if (vm.scaleZoomCurrent <= 0) {
                return;
            }
            vm.scaleZoomCurrent -= vm.scaleZoom;
            zoomTo(vm.scaleZoomCurrent);
            vm.onchangeZoomOut({
                scaleZoom: vm.scaleZoomCurrent,
            });
        }

        function zoomTo(scale) {
            pdfDelegate
                .$getByHandle(vm.PDF_DELEGATE)
                .zoomTo(Number(scale) > 0 ? Number(scale) : vm.zoomToDefault);
        }

        function next() {
            vm.currentPage++;
            goToPage();
            vm.onchangeNext({
                currentPage: vm.currentPage,
            });
        }

        function back() {
            vm.currentPage--;
            goToPage();
            vm.onchangeBack({
                currentPage: vm.currentPage,
            });
        }

        function getPageCount() {
            var pdfHandle = pdfDelegate.$getByHandle(vm.PDF_DELEGATE);
            if (pdfHandle) {
                return pdfDelegate.$getByHandle(vm.PDF_DELEGATE).getPageCount();
            }
        }

        function getCurrentPage() {
            return pdfDelegate.$getByHandle(vm.PDF_DELEGATE).getCurrentPage();
        }

        function goToPageInput() {
            goToPage();
            vm.onchangeGoToPage({
                currentPage: vm.currentPage,
            });
        }

        function goToPage(currentPage) {
            pdfDelegate
                .$getByHandle(vm.PDF_DELEGATE)
                .goToPage(currentPage > 0 ? currentPage : vm.currentPage);
        }

        function reloadViewPdf(pdfData) {
            if (pdfData && pdfData.length > 0) {
                // have data
                pdfDelegate.$getByHandle(vm.PDF_DELEGATE).load(pdfData);
                vm.isShowPdfCanvas = true;
                vm.currentPage = 1;
                zoomTo(vm.zoomToDefault);
                vm.scaleZoomCurrent = vm.zoomToDefault;
            } else {
                loadNewBlankFile();
            }
        }

        function loadNewBlankFile() {
            vm.isShowPdfCanvas = false;
        }

        // used reload Pdf when next or back slide
        $scope.$watch('vm.pdfData', function (newValue) {
            reloadViewPdf(convertDataPdf(vm.pdfData));
            if (vm.pdfData && vm.pdfData.length > 0) {
                goToPage();
            }
        });
    }

    angular.module('ipmApp').component('pdfPreview', {
        bindings: {
            pdfData: '<',
            uint8Enable: '<',
            isShowToolbar: '<',
            onchangeBack: '&',
            onchangeNext: '&',
            onchangeZoomIn: '&',
            onchangeZoomOut: '&',
            onchangeGoToPage: '&',
            scaleZoomMax: '<'
        },
        template: '<div ng-if="vm.isShowPdfCanvas" class="pdf-viewer-container">' +
            '<div class="py-1 pdf-viewer-toolbar">' +
            '<div ng-if="vm.isShowToolbar" class="btn-group">' +
            '<span><button type="button" ng-disabled="vm.currentPage === 1" class="btn btn-default btn-sm toolbarButton" ng-click="vm.back()" ng-dis title="Previous Page"><span class="glyphicon glyphicon-arrow-up"></span></button></span>|' +
            '<span><button type="button" ng-disabled="vm.currentPage >= vm.getPageCount()" class="btn btn-default btn-sm toolbarButton" ng-click="vm.next()" title="Next Page"><span class="glyphicon glyphicon-arrow-down"></span></button></span>' +
            '<span class="px1"></span><input type="number" class="toolbarField pageNumber" min="1" ng-model="vm.currentPage" ng-change="vm.goToPageInput()" style="width: 15%">  of {{vm.getPageCount()}}</span>' +
            '<span><button type="button" ng-disabled="vm.scaleZoomCurrent <= 0" class="btn btn-default btn-sm toolbarButton" ng-click="vm.zoomOut()" title="Zoom Out"><span class="glyphicon glyphicon-minus"></span></button></span>|' +
            '<span><button type="button" ng-disabled="vm.scaleZoomCurrent >= vm.scaleZoomMax" class="btn btn-default btn-sm toolbarButton" ng-click="vm.zoomIn()" title="Zoom In"><span class="glyphicon glyphicon-plus"></span></button></span>' +
            '</div>' +
            '</div>' +
            '<pdf-viewer ng-if="vm.pdfData" ' +
            'delegate-handle="pdf-container" ' +
            'url="vm.convertDataPdf(vm.pdfData)" ' +
            'scale="1.3" ' +
            'show-toolbar="false" ' +
            "headers=\"{ 'x-you-know-whats-awesome': 'EVERYTHING' }\"></pdf-viewer>" +
            '</div>',
        controller: PdfPreviewComponent,
        controllerAs: 'vm',
    });
})();
;
(function () {
    'use strict';

    PdfOnlyViewComponent.$inject = ['$scope', 'pdfDelegate', 'ipmConstants'];

    function PdfOnlyViewComponent($scope, pdfDelegate, ipmConstants) {
        var vm = this; //jshint ignore:line
        vm.PDF_DELEGATE = 'pdf-container';
        vm.zoomToDefault = ipmConstants.PDF_DEFAULT_SCALE;
        vm.convertDataPdf = convertDataPdf;
        vm.isShowPdfCanvas = true;

        init();

        function init() {
            vm.currentPage =
                vm.currentPage && vm.currentPage > 0 ? vm.currentPage : 1;
            vm.zoomToScale = vm.zoomToDefault;
        }

        function convertDataPdf(pdfData) {
            if (pdfData) {
                if (vm.uint8Enable) {
                    return new Uint8Array(pdfData);
                }
                return pdfData;
            }
        }

        function zoomIn() {
            pdfDelegate.$getByHandle(vm.PDF_DELEGATE).zoomIn(Number(vm.zoomInScale));
        }

        function zoomOut() {
            pdfDelegate
                .$getByHandle(vm.PDF_DELEGATE)
                .zoomOut(Number(vm.zoomOutScale));
        }

        function zoomTo() {
            pdfDelegate
                .$getByHandle(vm.PDF_DELEGATE)
                .zoomTo(vm.zoomToScale > 0 ? vm.zoomToScale : vm.zoomToDefault);
        }

        function goToPage(currentPage) {
            pdfDelegate
                .$getByHandle(vm.PDF_DELEGATE)
                .goToPage(currentPage > 0 ? currentPage : vm.currentPage);
        }

        function reloadViewPdf(pdfData) {
            if (pdfData && pdfData.length > 0) {
                // have data
                pdfDelegate.$getByHandle(vm.PDF_DELEGATE).load(pdfData);
                zoomTo();
                vm.isShowPdfCanvas = true;
            } else {
                loadNewBlankFile();
            }
        }

        function loadNewBlankFile() {
            vm.isShowPdfCanvas = false;
        }

        // used reload Pdf when next or back slide
        $scope.$watch('vm.pdfData', function (newValue) {
            reloadViewPdf(convertDataPdf(vm.pdfData));
            if (vm.pdfData && vm.pdfData.length > 0) {
                goToPage();
            }
        });

        $scope.$watch('vm.currentPage', function (newValue) {
            if (vm.currentPage > 0) {
                goToPage();
            }
        });

        $scope.$watch('vm.zoomInScale', function (newValue) {
            if (vm.zoomInScale) {
                zoomIn();
            }
        });

        $scope.$watch('vm.zoomOutScale', function (newValue) {
            if (vm.zoomOutScale) {
                zoomOut();
            }
        });
        $scope.$watch('vm.zoomToScale', function (newValue) {
            if (vm.zoomToScale) {
                zoomTo();
            }
        });
    }

    angular.module('ipmApp').component('pdfOnlyView', {
        bindings: {
            pdfData: '<',
            uint8Enable: '<',
            currentPage: '<',
            zoomInScale: '<',
            zoomOutScale: '<',
            zoomToScale: '<',
        },
        template: '<div ng-if="vm.isShowPdfCanvas">' +
            '<pdf-viewer ng-if="vm.pdfData" ' +
            'delegate-handle="pdf-container" ' +
            'url="vm.convertDataPdf(vm.pdfData)" ' +
            'scale="1.3" ' +
            'show-toolbar="false" ' +
            "headers=\"{ 'x-you-know-whats-awesome': 'EVERYTHING' }\"></pdf-viewer>" +
            '</div>',
        controller: PdfOnlyViewComponent,
        controllerAs: 'vm',
    });
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal', '$state'];

    function LoginService ($uibModal, $state) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            /*modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );*/
            $state.go('home');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope,$state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('[ng-model="vm.username"]').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                // If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
                if ($rootScope.redirected && $rootScope.previousStateName) {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                    $rootScope.redirected = false;
                } else {
                    $rootScope.$broadcast('authenticationSuccess');
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        // function register () {
        //     $uibModalInstance.dismiss('cancel');
        //     $state.go('register');
        // }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES', 'tmhDynamicLocale'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES, tmhDynamicLocale) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent,
            updateLangKey: updateLangKey
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
        
        function updateLangKey () {
            var url = 'api/users/update-langkey?langKey=' + tmhDynamicLocale.get();
            return $http.put(url).then(function (resource) {
                return resource;
            }, function (error) {
                return error;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale', '$rootScope', 'Principal', 'User', 'ipmConstants', '$window', '$state'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale, $rootScope, Principal, User, constants, $window, $state) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;
        vm.currentLanguage = 'en';

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage(languageKey) {
            if (Principal.hasAnyAuthority([constants.ROLE_PATIENT]) === true && tmhDynamicLocale.get() === languageKey) {
                return;
            }
            if (languageKey === null || languageKey === '' || (languageKey !== 'en' && languageKey !== 'es')) {
                languageKey = 'en';
            }
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
            vm.currentLanguage = languageKey;
            if (Principal.hasAnyAuthority([constants.ROLE_PATIENT]) === true) {
                JhiLanguageService.updateLangKey().then(function (resource) {
                    if ($state.includes('survey-workflow') || $state.includes('landing-page')) {
                        $window.location.reload();
                    }
                });
            }
            $rootScope.$emit("changeLanguageCustom", {langKey: vm.currentLanguage});
        }

        $rootScope.$on("changeLanguage", function(event, args){
            if(args.langKey) {
                changeLanguage(args.langKey);
            }
        });

        $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
            $translate.refresh();
        });

        $rootScope.$on('$stateChangeSuccess', function () {
            $translate.use(tmhDynamicLocale.get());
            $translate.fallbackLanguage(['es', 'en']);
            $translate.refresh();
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'es'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(paginationConfig);

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(pagerConfig);

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('ipmApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };
    
    angular
        .module('ipmApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('ipmApp.httpError', function (event, httpResponse) {
            handle(event, httpResponse);
        });

        var cleanHttpErrorListenerAnother = $rootScope.$on('ipmApp.httpErrorWithOutGotoErrorPage', function (event, httpResponse) {
            handle(event, httpResponse);
        });

        function handle(event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-ipmApp-error');
                var entityKey = httpResponse.headers('X-ipmApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('ipmApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        }

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
            if(angular.isDefined(cleanHttpErrorListenerAnother) && cleanHttpErrorListenerAnother !== null){
                cleanHttpErrorListenerAnother();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-ipmApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-ipmApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                // 500 - internal server error
            	// 400 - bad request
            	if (response.status === 500 ) {
                	$rootScope.$emit('ipmApp.httpError', response);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && (response.data.path.indexOf('/api/account') === -1 
                    || response.data.path.indexOf('/api/account/change_password') === 0)){
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                $rootScope.previousStateName = to;
                $rootScope.previousStateNameParams = params;
                var $state = $injector.get('$state');
                if(response.data.path.indexOf('/api/batteries') === -1 && response.data.path.indexOf('/api/authentication') === -1 && $state.current.name !== 'survey-workflow-thankyou') {
                    $rootScope.sessionTimeOut = true;
                    $rootScope.$broadcast('sessionTimeOut');
                } else {
                    $rootScope.sessionTimeOut = null;
                }
                var LoginPopupService = $injector.get('LoginService');
                LoginPopupService.open();
            } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {c = c.substring(1);}

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$translate', 'JhiLanguageService', 'translationHandler', 'ipmConstants',
        'Auth', 'Principal', 'ENV', 'VERSION'];

    function stateHandler($rootScope, $state, $translate, JhiLanguageService, translationHandler, constants,
        Auth, Principal, ENV, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.ENV = ENV;
            $rootScope.VERSION = VERSION;
            $rootScope.back = back;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
                // var isExistsSurveyWorkflowState = false;
                // if (constants.SURVEY_WORKFLOW_STATE && toState) {
                //     isExistsSurveyWorkflowState = constants.SURVEY_WORKFLOW_STATE.indexOf(toState.name) !== -1;
                // }
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Remember previous state unless we've been redirected to login or we've just
                // reset the state memory after logout. If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. If we're going
                // to login directly, we don't want to be sent to some previous state anyway
                if (!$rootScope.redirected && $rootScope.previousStateName) {
                    $rootScope.previousStateName = fromState.name;
                    $rootScope.previousStateParams = fromParams;
                }

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });

            function back() {
                // If previous state is 'activate' or do not exist go to 'home'
                if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                    $state.go('home');
                } else {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider', 'ENV'];

    function compileServiceConfig($compileProvider, ENV) {
        // disable debug data on prod profile to improve performance
        if(ENV === 'prod'){
            $compileProvider.debugInfoEnabled(false);
        }

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ProgressBarController', ProgressBarController);

    ProgressBarController.$inject = ['$scope', '$state'];

    function ProgressBarController($scope, $state) {
        var vm = this;

        vm.widthStyle = function() {
            if (vm.percent > 0) {
                return { width: vm.percent + '%' };
            } else {
                return { width: vm.percent + '%', color: 'transparent' };
            }
        }
    }

    angular.module('ipmApp').component('progressBar', {
        bindings: {
            percent: '<',
        },
        templateUrl: 'app/agreements-workflow/partial/progress-bar.html',
        controller: ProgressBarController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    AgreementsWelcomeController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsWelcomeController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;

        function save() {
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }
    }

    angular.module('ipmApp').component('agreementsWelcome', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-welcome/agreements-welcome.html',
        controller: AgreementsWelcomeController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsTreatmentController.$inject = ['$scope'];

    function AgreementsTreatmentController($scope) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;

        init();

        function init() {
            if (vm.agreement) {
                if (!vm.agreement.dateSigned) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsTreatment', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-treatment/agreements-treatment.html',
        controller: AgreementsTreatmentController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    });
})();
;
(function() {
    'use strict';

    AgreementsTransferMedicalController.$inject = ['$scope'];

    function AgreementsTransferMedicalController($scope) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        vm.birthdayInvalid = null;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfBirth = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
                // [TODO] Sample signature
                // vm.agreement.patientSignature = "data:image/png;base64,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";
            }
        }

        function save() {
            vm.isSaving = true;
            vm.birthdayInvalid = null;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        $scope.$watch("vm.agreement.patientDob", function () {
            var currentDate = new Date();
            if (!vm.agreement.patientDob) { return }
            if (vm.agreement.patientDob > currentDate) {
                vm.birthdayInvalid = 'ERROR';
            } else {
                vm.birthdayInvalid = null;
            }
            vm.isSaving = false;
            return;
        });
    }

    angular.module('ipmApp').component('agreementsTransferMedical', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-transfer-medical/agreements-transfer-medical.html',
        controller: AgreementsTransferMedicalController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AgreementsSignatureController', AgreementsSignatureController);

    AgreementsSignatureController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsSignatureController($scope, AgreementsWorkflowService) {
        var vm = this;
        vm.agreements = [];
        vm.onChangeSignature = onChangeSignature;
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {
            var pageable = {
                page: 0,
                size: 10,
                sort: ['position,asc']
            };
            AgreementsWorkflowService.findAllByPatientId(null, pageable, null, ['INTERNAL', 'EXTERNAL_NO_DATE_SIGN']).then(function (response) {
                var list = (response && response.data) ? response.data : [];
                var seen = Object.create(null);
                vm.agreements = list.filter(function (item) {
                    item = item || {};
                    var status = ((item.status || '') + '').toUpperCase().trim();
                    if (status === 'CANCEL' || status === 'COMPLETE') return false;

                    var key = ((item.agreementName || '') + '').toUpperCase().trim();
                    if (!key) return true;
                    if (seen[key]) return false;
                    seen[key] = true;
                    return true;
                });
            });
        }

        function onChangeSignature(data) {
            vm.agreement.patientSignature = data;
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsSignature', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-signature/agreements-signature.html',
        controller: AgreementsSignatureController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsRiskOfOpioidsController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsRiskOfOpioidsController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsRiskOfOpioids', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-risk-of-opioids/agreements-risk-of-opioids.html',
        controller: AgreementsRiskOfOpioidsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    AgreementsPrivacyPracticesController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsPrivacyPracticesController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.moveTo = moveTo;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

        function moveTo(id) {
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }

        vm.disabledParentSigned = function() {
            return vm.agreement.conservatorSigned === true;
        }

        vm.disabledConservatorSigned = function() {
			return vm.agreement.parentSigned === true;
		}
    }

    angular.module('ipmApp').component('agreementsPrivacyPractices', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-privacy-practices/agreements-privacy-practices.html',
        controller: AgreementsPrivacyPracticesController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsPatientRightsController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsPatientRightsController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
            vm.isSaving = false;
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            vm.agreement = result ? result : null;
            agreementsEmit();
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsPatientRights', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-patient-rights/agreements-patient-rights.html',
        controller: AgreementsPatientRightsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsOpioidMonographController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsOpioidMonographController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {

        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsOpioidMonograph', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-opioid-monograph/agreements-opioid-monograph.html',
        controller: AgreementsOpioidMonographController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    AgreementsNoticePatientsController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsNoticePatientsController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.isSaving = false;
        init();

        function init() {

        }
    }

    angular.module('ipmApp').component('agreementsNoticePatients', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-notice-patients/agreements-notice-patients.html',
        controller: AgreementsNoticePatientsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsNarcoticsController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsNarcoticsController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;

        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsOpioidMonographAndNarcotics', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-narcotics/agreements-narcotics.html',
        controller: AgreementsNarcoticsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsContinuityOfCareController.$inject = [];

    function AgreementsContinuityOfCareController() {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
            vm.isSaving = false;
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsContinuityOfCare', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-continuity-of-care/agreements-continuity-of-care.html',
        controller: AgreementsContinuityOfCareController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsConsentTreatController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsConsentTreatController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
            vm.isSaving = false;
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            vm.agreement = result ? result : null;
            agreementsEmit();
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsConsentTreat', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-consent-treat/agreements-consent-treat.html',
        controller: AgreementsConsentTreatController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    AgreementsAcknowledgmentController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsAcknowledgmentController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
            vm.isSaving = false;
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            vm.agreement = result ? result : null;
            agreementsEmit();
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsAcknowledgment', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-acknowledgment/agreements-acknowledgment.html',
        controller: AgreementsAcknowledgmentController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            },
            params: {
                searchUserParamsInfo: null
            }
        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:id',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'userManagement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('qhpTaskType');
                    return $translate.refresh();
                }]
            },
            params: {
                searchUserParamsInfo: null
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('qhpTaskType');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        },
                        patientCases: function () {
                            return [];
                        },
                        action: function() { return "USER_MANAGEMENT"},
                        supportedDataList: ['Auth', function(Auth) {
                        	return Auth.getSupportedListRegister();
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('qhpTaskType');
                            return $translate.refresh();
                        }],
                        entity: ['User', function(User) {
                        	return User.get({ id: $stateParams.id });
                        }],
                        patientCases: ['User', function (User) {
                            return User.getAllPatientCaseByUserId( $stateParams.id);
                        }],
                        action: function() { return "USER_MANAGEMENT"},
                        supportedDataList: ['Auth', function(Auth) {
                        	return Auth.getSupportedListRegister();
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', {searchUserParamsInfo: null}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['User', function(User) {
                        	return User.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', 'UserSearch', '$stateParams', '$state'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService, UserSearch, $stateParams, $state) {
        var vm = this;

        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.predicate = 'u.firstName';
        vm.predicateDefault = 'u.firstName';
        vm.reverse = false;
        vm.pageSize = 15;
        vm.setActive = setActive;
        vm.totalItems = 0;
        vm.users = [];
        vm.checkDisableDeleted = checkDisableDeleted;

        init();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function init() {
            var paramsInfo = $stateParams.searchUserParamsInfo ? $stateParams.searchUserParamsInfo : null;
            if(paramsInfo) {
                vm.searchQuery = paramsInfo.searchQuery;
                vm.page = paramsInfo.page;
                vm.totalItems = paramsInfo.totalItems;
                vm.pageSize = paramsInfo.pageSize;
                vm.predicate = paramsInfo.predicate;
                vm.reverse = paramsInfo.reverse;
            } else {
                vm.clear();
            }
            vm.loadAll();
        }

        function loadAll () {

        	var pageable = {page: vm.page > 0 ? vm.page - 1 : vm.page,
					size: vm.pageSize,
					sort: sort()};

        	UserSearch.searchUsers(vm.searchQuery, pageable).then( function(response) {
		    	if (response.content !== undefined) {
		    		vm.users = response.content;
				} else {
					vm.surveyResults = [];
				}

		    	vm.totalItems =  response.totalElements;
				if(vm.searchQuery != null && !_.isEmpty(vm.searchQuery)) {
					vm.isShowClearSearchButton = true;
				}else {
					vm.isShowClearSearchButton = false;
				}
		    });

        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        vm.search = function () {
            vm.page = 0;
            vm.predicate = vm.predicateDefault;
            vm.reverse = false;
            vm.loadAll();
        }

        vm.clear = function () {
            vm.surveyResults = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = vm.predicateDefault;
            vm.reverse = true;
            vm.searchQuery = null;
            vm.loadAll();
        };

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            if(vm.editForm !== null && vm.editForm !== undefined) {
            	vm.editForm.$setPristine();
            	vm.editForm.$setUntouched();
            }
        }

        function getSearchUserParamsInfo() {
            var paramsInfo = {
                searchQuery: vm.searchQuery,
                page: vm.page,
                totalItems: vm.totalItems,
                pageSize: vm.pageSize,
                predicate: vm.predicate,
                reverse: vm.reverse
            };
            return paramsInfo;
        }

        function checkDisableDeleted(user) {
            if (isQHPRole(user)) {
                if (user.qhpUserDetail && user.qhpUserDetail.tasks && user.qhpUserDetail.tasks.length > 0) {
                    return true;
                }
                return false;
            }
            return false;
        }

        function isQHPRole(user) {
            if (user && user.authorities && user.authorities.indexOf('ROLE_QHP') !== -1) {
                return true;
            }
            return false;
        };

        vm.goToUserDetails = function(id) {
            var paramsInfo = getSearchUserParamsInfo();
            $state.go('user-management-detail', {id: id, searchUserParamsInfo: paramsInfo});
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'supportedDataList', 'Principal', 'ipmConstants', '$rootScope', '$state', '$scope', 'action', 'patientCases'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, supportedDataList, Principal, constants, $rootScope, $state, $scope, action, patientCases) {
        var vm = this;

        vm.title = "userManagement.home.createOrEditLabel";
        vm.authorities = ['ROLE_ADMIN', 'ROLE_STAFF', 'ROLE_PATIENT', 'ROLE_MANAGER', 'ROLE_QHP', 'ROLE_BILLER'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.disabledRole = null;
        vm.user = entity;
        vm.patientCases = patientCases ? patientCases : [];
        vm.patientCaseIdsRemove = [];
        vm.isAllowActionPatientCase = false;
        vm.isPatientRole = false;
        vm.isAllowEdit = false;
        vm.isBiller = false;
        // load offices, providers
        vm.offices = supportedDataList.officeList;
        vm.providers = supportedDataList.providerList;
        vm.frpPrograms = supportedDataList.frpProgramsList;
        vm.account = null;

        vm.errorEmailExists = null;
        vm.errorPhoneExists = null;
        vm.errorPatientID = null;
        vm.birthdayInvalid = null;
        vm.error = null;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfBirth = false;
        vm.isQHPRole = false;
        vm.isStaffRole = false;
        vm.roleStaff = constants.ROLE_STAFF;
        vm.qhpUserDetail = {};
        vm.staffUserDetail = {id: null, offices:[], tasks: []};
        vm.patientDetailEditState = action && action === 'PATIENT_DETAIL' ? true : false;
        vm.isSaving = false;
        vm.checkTaskFRP = checkTaskFRP;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        getAccount(false);

        function getAccount(force) {
            Principal.identity(force).then(function(res) {
                vm.account = res;
                vm.isBiller = vm.account && vm.account.authorities.indexOf('ROLE_BILLER') !== -1;
                updateAllowActionPatientCase();
            });
        }

        function updateAllowActionPatientCase() {
            vm.isAllowActionPatientCase = vm.account && vm.account.authorities.indexOf('ROLE_ADMIN') !== -1;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError (error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if(error.status === 400 ) {
            	if (errorMessage === 'e-mail address already in use'){
            		vm.errorEmailExists = 'ERROR';
            	} else if (errorMessage === 'phone already in use') {
            		vm.errorPhoneExists = 'ERROR';
            	} else if (errorMessage === 'patientID already in use') {
            		vm.errorPatientID = 'ERROR';
            	} else {
            		vm.error = 'ERROR';
            	}
            }
        }

        vm.disabled = function () {
        	return vm.user.id != 0;
        }

        vm.roleChange = function(){
        	if (vm.user.authorities) {
        		var authority = vm.user.authorities;
            	if( authority === 'ROLE_PATIENT') {
            		vm.isPatientRole = true;
            	} else {
            		vm.isPatientRole = false;
            	}
            	vm.isQHPRole = authority === constants.ROLE_QHP ? true : false;
            	vm.isStaffRole = authority === constants.ROLE_STAFF ? true : false;
            	vm.user.authorities = [authority];
                setUserDetailDefaultByChangeRole(authority);
        	}

        }


        function init() {
        	if(typeof entity.$promise === 'object') {
        		entity.$promise.then(function (result) {
            	    entity = result;
                    setQHPUserDetail();
                    setUserDetail();
            	    if( entity.authorities.length === 1 ) {
            	    	if (entity.authorities.indexOf('ROLE_PATIENT') !== -1 ) {
            	    		vm.disabledRole = true;
            	    		vm.isPatientRole = true;
            	    	} else {
            	    	    setQHPRole(entity);
                            setStaffRole(entity);
            	    		vm.authorities = ['ROLE_ADMIN', 'ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_QHP', 'ROLE_BILLER'];
            	    	}
                    }
            	});
        	} else if(entity.userId > 0) {
                vm.title = "userManagement.home.editLabel";
                User.get({id: entity.userId}, function (result) {
                    vm.user = result;
                    if (vm.user && vm.user.authorities.indexOf('ROLE_PATIENT') !== -1) {
                        vm.disabledRole = true;
                    }
                });
                getRolePermission();
            }
        }

        init();

        function save () {
        	vm.errorEmailExists = null;
            vm.errorPhoneExists = null;
            vm.errorPatientID = null;
            vm.error = null;
        	vm.birthdayInvalid = null;
            // vm.user.qhpUserDetail = vm.qhpUserDetail ? vm.qhpUserDetail : {};
            // update for save vm.user.userDetail
            updateUserDetail();
            // update patient case
            vm.user.patientCases = vm.patientCases;
            vm.user.patientCaseIdsRemove = vm.patientCaseIdsRemove;
            vm.isSaving = true;
            if (vm.user.id !== null) {
                if (vm.isBiller) {
                    vm.user = User.updatePatientCases( { id: vm.user.id, patientCases: vm.patientCases, patientCaseIdsRemove: vm.patientCaseIdsRemove }, onSaveSuccess, onSaveError);
                } else {
                    vm.user = User.update(vm.user, onSaveSuccess, onSaveError);
                }
            } else {
                vm.user = User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function getRolePermission () {
            if (Principal.hasAnyAuthority([constants.ROLE_STAFF]) === true || Principal.hasAnyAuthority([constants.ROLE_MANAGER]) === true
                || Principal.hasAnyAuthority([constants.ROLE_ADMIN]) === true || Principal.hasAnyAuthority([constants.ROLE_BILLER]) === true) {
                vm.isAllowEdit = true;
            } else {
                vm.isAllowEdit = false;
            }
        }

        $scope.$watch("vm.user.dateOfBirth", function(newValue, oldValue) {
            var currentDate = new Date();
            if (!vm.user.dateOfBirth) { return }
            if(vm.user.dateOfBirth > currentDate) {
                vm.birthdayInvalid = 'ERROR';
            } else {
                vm.birthdayInvalid = null;
            }
            vm.isSaving = false;
            return;
        });

        $rootScope.$on( '$stateChangeSuccess', function ( event, to, toParams, from, fromParams ) {
            $uibModalInstance.dismiss('cancel');
        });

        vm.changeIgnoreEmail = function() {
            vm.user.ignoreSendEmail = vm.user.ignoreSendEmail ? false : true;
        }

        vm.changeIgnoreSendSms = function() {
            vm.user.ignoreSendSms = vm.user.ignoreSendSms ? false : true;
        }

        vm.qhpTasksOnChange = function (tasks) {
            vm.qhpUserDetail.tasks = tasks ? tasks : [];
        }

        vm.staffTasksOnChange = function (tasks) {
            vm.staffUserDetail.tasks = tasks ? tasks : [];
        }

        vm.selectedOfficesOnChange = function (selectedOffices) {
            vm.staffUserDetail.offices = selectedOffices ? selectedOffices : [];
        }

        function setQHPRole(entity) {
            if (entity && entity.authorities.indexOf(constants.ROLE_QHP) !== -1) {
                vm.isQHPRole = true;
            } else {
                vm.isQHPRole = false;
            }
        }

        function setStaffRole(entity) {
            if (entity && entity.authorities.indexOf(constants.ROLE_STAFF) !== -1) {
                vm.isStaffRole = true;
            } else {
                vm.isStaffRole = false;
            }
        }

        function setUserDetailDefaultByChangeRole(authority) {
            if (authority && authority === constants.ROLE_QHP ) {
                vm.qhpUserDetail.tasks = entity.qhpUserDetail && entity.qhpUserDetail.id && entity.qhpUserDetail.tasks ? _.cloneDeep(entity.qhpUserDetail.tasks) : [];
                vm.staffUserDetail.tasks = [];
            } else if (authority && authority === constants.ROLE_STAFF ){
                vm.staffUserDetail.tasks = entity.staffUserDetail && entity.staffUserDetail.id && entity.staffUserDetail.tasks ? _.cloneDeep(entity.staffUserDetail.tasks) : [];
                vm.qhpUserDetail.tasks = [];
            }
        }

        function setQHPUserDetail() {
            vm.qhpUserDetail = entity && entity.qhpUserDetail ? entity.qhpUserDetail : {};
        }
        function setUserDetail() {
            vm.staffUserDetail = entity && entity.staffUserDetail ? entity.staffUserDetail : {};
        }

        function updateUserDetail() {
            filterAndUpdateOffices();
            // update UserDetail for User
            vm.user.qhpUserDetail = vm.qhpUserDetail ? vm.qhpUserDetail : {};
            vm.user.staffUserDetail = vm.staffUserDetail ? vm.staffUserDetail : {};
        }

        function filterAndUpdateOffices() {
            if (vm.isQHPRole) {
                vm.qhpUserDetail.frpPrograms = filterFRpPrograms(vm.qhpUserDetail.frpPrograms);
            } else if (vm.isStaffRole) {
                vm.staffUserDetail.frpPrograms = filterFRpPrograms(vm.staffUserDetail.frpPrograms);
            }
        }

        function filterOffice(offices) {
            if (offices && offices.length > 0) {
                return _.filter(offices, function (office) {
                    return office && office.id;
                });
            }
            return [];
        }

        function filterFRpPrograms(frpPrograms) {
            if (frpPrograms && frpPrograms.length > 0) {
                return _.filter(frpPrograms, function (frpProgram) {
                    return frpProgram && frpProgram.id;
                });
            }
            return [];
        }

        function validateFRpProgramsStaff() {
            return filterFRpPrograms(vm.staffUserDetail.frpPrograms).length > 0;
        }

        function validateFRpProgramsQhp() {
            return filterFRpPrograms(vm.qhpUserDetail.frpPrograms).length > 0;
        }

        function checkTaskFRP(tasks) {
            if (tasks && tasks.length > 0) {
                return !_.isEmpty(_.filter(tasks, function (task) {
                    return task === constants.FRP_MDE;
                }));
            }
            return false;
        }

        vm.validateRoleTasks = function () {
            if (vm.isQHPRole) {
                if (vm.qhpUserDetail && vm.qhpUserDetail.tasks && vm.qhpUserDetail.tasks.length > 0) {
                    if (checkTaskFRP(vm.qhpUserDetail.tasks) === true) {
                        return validateFRpProgramsQhp();
                    }
                    return true;
                }
                return false;
            } else if (vm.isStaffRole) {
                if (vm.staffUserDetail && vm.staffUserDetail.tasks && vm.staffUserDetail.tasks.length > 0) {
                    if (checkTaskFRP(vm.staffUserDetail.tasks) === true) {
                        return validateFRpProgramsStaff();
                    }
                    return true;
                }
                return false;
            }
            return true;
        };

        vm.checkUpdateBillablePatientCase = function () {
            if (vm.account && vm.account.authorities) {
                var allowedRoles = [constants.ROLE_ADMIN, constants.ROLE_MANAGER, constants.ROLE_BILLER];
                var hasAllowedRole = _.some(vm.account.authorities, function (role) {
                    return _.includes(allowedRoles, role);
                });
                return !hasAllowedRole;
            }
            return true;
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', '$state'];

    function UserManagementDetailController ($stateParams, User, $state) {
        var vm = this;

        vm.load = load;
        vm.isPatient = null;
        vm.user = {};

        vm.load($stateParams.id);

        function load (id) {
            User.get({id: id}, function(result) {
                vm.user = result;
                if( vm.user.authorities.indexOf('ROLE_PATIENT') !== -1) {
                	vm.isPatient = true;
                } else {
                	vm.isPatient = false;
                }
            });
        }

        vm.backToList = function() {
            var paramsInfo = $stateParams.searchUserParamsInfo;
            if(paramsInfo) {
                $state.go('user-management', {searchUserParamsInfo: paramsInfo});
            } else {
                $state.go('user-management');
            }
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            User.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patientimport', {
            parent: 'entity',
            url: '/patientimport',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.patient.import.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/patient-import/patient-import.html',
                    controller: 'PatientImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('PatientImport', PatientImport);

    PatientImport.$inject = ['$resource'];

    function PatientImport ($resource) {
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientImportController', PatientImportController);

    PatientImportController.$inject = ['$scope', '$state', 'Upload', 'ipmConstants'];

    function PatientImportController ($scope, $state, Upload, constants) {
        var vm = this;
        vm.isSaving = false;
        vm.isNotCsvFile = false;
        vm.isError = false;
        vm.importPatient = function (file) {
            if(file.length > 0) {
                var fileName = file[0].name;
                if(fileName.indexOf(constants.CSV_EXT, fileName.length - constants.CSV_EXT.length) !== -1) {
                    vm.isNotCsvFile = false;
                    vm.isSaving = true;
                    vm.numPatientsCreated = null;
                    vm.numPatientsUpdated = null;
                    vm.errorImportInfo = null;
                    Upload.upload({
                        url: 'api/patients/import',
                        file: file[0]
                    }).progress(function (evt) {
                        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);                        
                    }).success(function (data, status, headers, config) {
                        vm.isSaving = false;
                        vm.isError = false;
                        if(data.errorImportInfo) {
                            vm.errorImportInfo = data.errorImportInfo;
                            vm.errorNumMore = data.errorNumMore;
                        } else {
                            vm.numPatientsCreated = data.numOfPatientCreated;
                            vm.numPatientsUpdated = data.numOfPatientUpdated;
                        }
                    }).error(function (data, status, headers, config) {
                        vm.isSaving = false;
                        vm.isError = true;
                        vm.numPatientsCreated = null;
                        vm.numPatientsUpdated = null;
                    });
                } else {
                    vm.numPatientsCreated = null;
                    vm.numPatientsUpdated = null;
                    vm.errorImportInfo = null;
                    vm.isNotCsvFile = true;
                }
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('metrics/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('api/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var service = {
            checkHealth: checkHealth
        };

        return service;

        function checkHealth () {
            return $http.get('health').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('ipmApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frp-mde-reports', {
            parent: 'entity',
            url: '/frp-mde-reports',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.patient.report.frpMde.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/frp-mde-reports/frp-mde-reports.html',
                    controller: 'FrpMdeReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('FrpMdeReportsService', FrpMdeReportsService);

    FrpMdeReportsService.$inject = ['$http', '$q', 'DownloadBlobService'];

    function FrpMdeReportsService ($http, $q, DownloadBlobService) {
    	return {
    		downloadReports: function(fromDate, toDate) {
                var deferred = $q.defer();
    			$http({
                    url: 'api/frp-mde/download-reports',
                    method: "GET",
                    params: {fromDate: fromDate, toDate: toDate},
                    headers: {
                        'Content-type': 'application/json',
                    },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers, config) {
                    if (status && status === 200) {
                        var contentType = headers('content-type');
                        var blob = new Blob([data], {type: contentType});
                        DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                        deferred.resolve({"status": status});
                    } else {
                        var reason = headers('no-content-reason');
                        deferred.resolve({"status": status, "reason": reason});
                    }
                }).error(function (data, status, headers, config) {
                    deferred.resolve({"status": status});
                });
    			return deferred.promise;
    		}
    	};
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('FrpMdeReportsController', FrpMdeReportsController);

    FrpMdeReportsController.$inject = ['$scope', '$filter', 'FrpMdeReportsService'];

    function FrpMdeReportsController ($scope, $filter, FrpMdeReportsService) {
        var vm = this;

        vm.isProcessing = false;
        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};

        vm.inValidDates = false;
        vm.noPdf = false;
        function init() {
        	// set to Monday of this week
        	vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
        	// set to previous Monday
        	vm.fromDate.setDate(vm.fromDate.getDate() - 7);

        	// set to previous Friday
        	vm.toDate = new Date(vm.fromDate);
        	vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.report = function () {
            vm.isProcessing = true;
            vm.noPdf = false;
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            FrpMdeReportsService.downloadReports(fromDate, toDate).then(function (res) {
                vm.isProcessing = false;
                if (res && res.status === 204) {
                    vm.noPdf = true;
                }
            });
        };

        vm.onChangeDate = function () {
            vm.inValidDates = vm.fromDate !== undefined && vm.toDate !== undefined;
            var fromDate = vm.fromDate;
            var toDate = vm.toDate;
            if (!fromDate || !toDate) {
                return;
            }
            fromDate.setHours(0, 0, 0, 0);
            toDate.setHours(0, 0, 0, 0);
            vm.inValidDates = vm.inValidDates && fromDate > toDate;
        };

        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('completion-reports', {
            parent: 'entity',
            url: '/completion-reports',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.patient.report.completion.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/completion-reports/completion-reports.html',
                    controller: 'CompletionReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('CompletionReportsService', CompletionReportsService);

    CompletionReportsService.$inject = ['$http', '$q', 'DownloadBlobService'];

    function CompletionReportsService ($http, $q, DownloadBlobService) {
    	var deferred = $q.defer();
    	return {
    		exportPatientsCompletedCSV: function(fromDate, toDate) {
    			$http({
                    url: 'api/completion-reports/patients-completed-csv',
                    method: "GET",
                    params: {fromDate: fromDate, toDate: toDate},
                    headers: {
                        'Content-type': 'application/json',
                    },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers, config) {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    
                    deferred.resolve(true);
                }).error(function (data, status, headers, config) {
//                    console.log('Failed to download Excel');
                    deferred.resolve(false);
                });
    			return deferred.promise;
    		}
    	};
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CompletionReportsController', CompletionReportsController);

    CompletionReportsController.$inject = ['$scope', '$filter', 'CompletionReportsService'];

    function CompletionReportsController ($scope, $filter, CompletionReportsService) {
        var vm = this;
        
        vm.isProcessing = false;
        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        
        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        
        function init() {
        	//vm.toDate.setDate(vm.toDate.getDate() - 1);
        	//vm.fromDate.setDate(vm.toDate.getDate() - 7);
        	
        	// set to Monday of this week
        	vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
        	// set to previous Monday
        	vm.fromDate.setDate(vm.fromDate.getDate() - 7);
        	
        	// set to previous Friday
        	vm.toDate = new Date(vm.fromDate);
        	vm.toDate.setDate(vm.toDate.getDate() + 4);
        }
        
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        
        vm.report = function () {
            vm.isProcessing = true;
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            CompletionReportsService.exportPatientsCompletedCSV(fromDate, toDate).then(function(res) {
            	vm.isProcessing = false;
            });
        };
        
        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('coc-agreement-management', {
            parent: 'admin',
            url: '/coc-agreement-management',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_STAFF'],
                pageTitle: 'coc-agreement.home.title.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/coc-agreement/coc-agreement-management.html',
                    controller: 'CoCAgreementManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coc-agreement');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CoCAgreementManagementController', CoCAgreementManagementController);

        CoCAgreementManagementController.$inject = ['CocAgreementService'];

    function CoCAgreementManagementController(CocAgreementService) {
        var vm = this;
        vm.isSaving = false;
        init();

        function init() {}

        vm.sendInvitations = function() {
            vm.isSaving = true;
            vm.isAddedSuccess = false;
            vm.haveError = false;
            CocAgreementService.sendInvitations(vm.chartNumbersValue).then(
                function(res) {
                    vm.isSaving = false;
                    vm.haveError = res.haveError;
                    if (vm.haveError) {
                        vm.havePatientIdNotFounds = res.patientIdNotFounds && !_.isEmpty(res.patientIdNotFounds);
                        if (vm.havePatientIdNotFounds) {
                            vm.patientIdNotFounds = res.patientIdNotFounds
                        }
                        vm.havePatientIdSents = res.patientIdSents && !_.isEmpty(res.patientIdSents);
                        if (vm.havePatientIdSents) {
                            vm.patientIdSents = res.patientIdSents
                        }
                        vm.havePatientIdNoneProviders = res.patientIdNoneProviders && !_.isEmpty(res.patientIdNoneProviders);
                        if (vm.havePatientIdNoneProviders) {
                            vm.patientIdNoneProviders = res.patientIdNoneProviders
                        }
                    }

                    vm.numberAddedSuccess = res.numberAddedSuccess;
                    if (vm.numberAddedSuccess > 0) {
                        vm.isAddedSuccess = true;
                        vm.patientIdAddSuccesses = res.patientIdAddSuccesses;
                        // clear input field
                        vm.chartNumbersValue = undefined;
                    }
            }, function(error) {
                    vm.isSaving = false;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('api/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'ipmConstants'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate, constants) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();
;
// (function() {
//     'use strict';

//     angular
//         .module('ipmApp')
//         .config(stateConfig);

//     stateConfig.$inject = ['$stateProvider'];

//     function stateConfig($stateProvider) {
//         $stateProvider.state('register', {
//             parent: 'account',
//             url: '/register',
//             data: {
//                 authorities: [],
//                 pageTitle: 'register.title'
//             },
//             views: {
//                 'content@': {
//                     templateUrl: 'app/account/register/register.html',
//                     controller: 'RegisterController',
//                     controllerAs: 'vm'
//                 }
//             },
//             resolve: {
//                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                     $translatePartialLoader.addPart('register');
//                     return $translate.refresh();
//                 }]
//             },
//             params: {
//             	patientID: null,
//             	officeId: null,
//             	providerId: null
//             }
//         });
//     }
// })();
;
// (function() {
//     'use strict';
//     angular
//         .module('ipmApp')
//         .factory('RegisterService', RegisterService);

//     RegisterService.$inject = ['$q', 'halClient', '$http'];

//     function RegisterService ($q, halClient, $http) {
//     	var baseUrl = 'api';
//     	var service = {
//             	'checkShowInjured': checkShowInjured
//             };
    	
//     	function checkShowInjured() {
//     		var deferred = $q.defer();
//         	var url = baseUrl + '/show-injured';
        	
//         	$http.get(url)
// 			.success(function(data) {
// 				deferred.resolve(data);
// 			})
// 			.error(function(e) {
// 				deferred.reject(e);
// 			});

// 			return deferred.promise;
//     	}
    	
//         return service;
//     };
// })();
;
// (function() {
//     'use strict';

//     angular
//         .module('ipmApp')
//         .controller('RegisterController', RegisterController);


//     RegisterController.$inject = ['$scope', '$filter', '$translate', '$timeout', 'Auth', 'RegisterService','LoginService', '$stateParams', '$state', '$rootScope', 'ipmConstants'];

//     function RegisterController ($scope, $filter, $translate, $timeout, Auth, RegisterService, LoginService, $stateParams, $state, $rootScope, constants) {
//         var vm = this;
//         vm.patientID = $stateParams.patientID;
//         vm.officeId = $stateParams.officeId;
//         vm.providerId = $stateParams.providerId;
//         // patientID is null redirect to home page
//         if(_.isEmpty(vm.patientID) ||!vm.officeId || !vm.providerId) {
//         	$state.go('home');
//         }
        
//         vm.error = null;
//         vm.errorEmailExists = null;
//         vm.loginExists = null;
//         vm.phoneExists = null;
//         vm.login = LoginService.open;
//         vm.register = register;
//         vm.registerAccount = {};
        
//         vm.datePickerOpenStatus = {};
//         vm.datePickerOpenStatus.dateOfBirth = false;
//         vm.isShowInjured = true;
//         vm.openCalendar = function(date) {
//             vm.datePickerOpenStatus[date] = true;
//         };
//         vm.registerAccount.injuredTypes = [];
//         vm.selectedInjuredTypes = selectedInjuredTypes;
//         vm.injuredTypes = [
//             { name: "register.form.injured.legsfeet", value: "LEGS_FEET", checked: false, disabled: false },
//             { name: "register.form.injured.backspine", value: "BACK_SPINE", checked: false, disabled: false },
//             { name: "register.form.injured.neck", value: "NECK", checked: false, disabled: false },
//             { name: "register.form.injured.armhand", value: "ARM_HAND", checked: false, disabled: false },
//             { name: "register.form.injured.none", value: "NONE", checked: false, disabled: false }
//          ];
         
//          function selectedInjuredTypes(injuredType) {
//         	 if(injuredType.value === 'NONE') {
//         		 if(injuredType.checked == true) {
//         			 vm.registerAccount.injuredTypes = [injuredType.value];
//         			 vm.injuredTypes.forEach(function(item) {
//         				 if(item.value !== 'NONE') {
//         					 item.checked = false;
//         					 item.disabled = true;
//         				 }
//                      });
//         		 } else {
//         			 vm.registerAccount.injuredTypes = [];
//         			 vm.injuredTypes.forEach(function(item) {
//         				 if(item.value !== 'NONE') {
//         					 item.disabled = false;
//         				 }
//                      });
//         		 }    			 
//     		 } else {
//     			 vm.registerAccount.injuredTypes = $filter('filter')(vm.injuredTypes, {checked: true}).map(function(item) {
//  	         		return item.value;
//     			 });
//     			 vm.injuredTypes.forEach(function(item) {
//     				 if(item.value === 'NONE') {
//     					 item.disabled = vm.registerAccount.injuredTypes.length > 0;
//     				 }
//                  });
//     		 }
//          }
        
//         // determine show checkbox or not
//         RegisterService.checkShowInjured().then(function (response) {
//         	vm.isShowInjured = response;
//         });
        
//         $timeout(function (){angular.element('[ng-model="vm.registerAccount.firstName"]').focus();});
        
//         function register () {
//         	vm.registerAccount.langKey = $translate.use();
//         	vm.registerAccount.patientIdCode = vm.patientID;
//         	vm.registerAccount.officeId = vm.officeId;
//         	vm.registerAccount.providerId = vm.providerId;
        	
//             if (_.isEmpty(vm.registerAccount.email)) {
//             	vm.registerAccount.email = null;
//             }
//             vm.error = null;
//             vm.errorEmailExists = null;
//             vm.loginExists = null;
//             vm.phoneExists = null;

//             Auth.createAccount(vm.registerAccount).then(function () {
//             	Auth.login({
//                     username: vm.registerAccount.patientIdCode,
//                     password: vm.registerAccount.password,
//                     rememberMe: true
//             	}).then(function () {
//                  $scope.authenticationError = false;
                 
//                  $rootScope.$broadcast(constants.EVT_AUTHENTICATION_SUCCESS);
//                  // forward to workflow page
//                  $state.go('survey-workflow',{id: 1});
//                }).catch(function () {
//                     $scope.authenticationError = true;
//                });
//             }).catch(function (response) {
//                 if (response.status === 400) {
//                 	if (response.data === 'e-mail address already in use'){
//                 		vm.errorEmailExists = 'ERROR';
//                 	} else if (response.data === 'login already in use') {
//                 		vm.loginExists = 'ERROR';
//                 	} else if (response.data === 'phone already in use') {
//                         vm.phoneExists = 'ERROR';
//                     } else {
//                 		vm.error = 'ERROR';
//                 	}
//                 } else {
//                 	vm.error = 'ERROR';
//                 }
//             });
//         }
//     }
// })();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_PATIENT', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_QHP', 'ROLE_BILLER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$state'];

    function PasswordController (Auth, Principal, $state) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.back = back;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function back() {
            // fix bug IPMproject-B1593: Should go back to class sessions list when clicking Back button on change password page
            if ($state.previous.name === 'presentation-controls-instructor') { // previous state is presentation-controls
                $state.go('wellness-class-list');
                return;
            }
        	$state.go( $state.previous.name, $state.previous.params );
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('survey-workflow', {
            parent: 'app',
            url: '/survey-workflow/:id',
            data: {
                authorities: ['ROLE_PATIENT'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/survey-workflow/survey-workflow.html',
                    controller: 'SurveyWorkflowController',
                    controllerAs: 'vm'
                }
            },
                resolve: {
				 mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					 $translatePartialLoader.addPart('surveyWorkflow');
					 return $translate.refresh();
				 }],
				 entity: ['$stateParams', 'SurveyWorkflowService', function($stateParams, SurveyWorkflowService) {
					 return SurveyWorkflowService.getBatteryTest($stateParams.id);
				 }],
                 isAdHoc: ['SurveyWorkflowService', function(SurveyWorkflowService) {
					 return SurveyWorkflowService.checkIsAdHocHAQ();
				 }],
                 allBatteryTests: ['$stateParams', 'SurveyWorkflowService', '$q', function($stateParams, SurveyWorkflowService, $q) {
                    var deferred = $q.defer();
                    SurveyWorkflowService.getBatteryTest($stateParams.id)
                        .then(function(data){
                            deferred.resolve(SurveyWorkflowService.getAllBatteryTests(data.batteryId, data.id, data.surveyResultId));
                        });

                    return deferred.promise;
				 }],
            }
        })
        .state('survey-workflow-thankyou', {
        	parent: 'app',
        	url: '/survey-workflow-thankyou',
        	data: {
            },
            views: {
                'content@': {
                    templateUrl: 'app/survey-workflow/partial/thank-you.html',
                    controller: 'ThankYouController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                isAdHoc: ['SurveyWorkflowService', function(SurveyWorkflowService) {
                    return SurveyWorkflowService.checkIsAdHocHAQ();
                }],
                haqBatteryAdHoc: ['HAQBatteryAdHocService', function(HAQBatteryAdHocService) {
                    return HAQBatteryAdHocService.getNextHaqBatteryAdhoc();
                }],
                surveyResultType: ['SurveyWorkflowService', function (SurveyWorkflowService) {
                    return SurveyWorkflowService.getSurveyType()
                }],
            }
        })
        .state('course-registration-workflow', {
        	parent: 'app',
        	url: '/course-registration-workflow',
        	data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_PATIENT'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/survey-workflow/partial/course-register-workflow/course-register-workflow.html',
                    controller: 'CourseRegisterWorkflowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('surveyWorkflow');
                    return $translate.refresh();
                }]
            }
        });;
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('SurveyWorkflowService', SurveyWorkflowService);

    SurveyWorkflowService.$inject = ['$http', 'halClient', 'ShowUnexpectedErrorDialogService', '$rootScope', 'ClearLocalStorageService', '$window', 'ipmConstants'];

    function SurveyWorkflowService($http, halClient, ShowUnexpectedErrorDialogService, $rootScope, ClearLocalStorageService, $window, constants) {
        var baseURL = 'api';

        var service = {
            'getBatteryTest': getBatteryTest,
            'saveSurveyResponse': saveSurveyResponse,
            'complete': complete,
            'next': next,
            'sendSMS': sendSMS,
            'getAllBatteryTests': getAllBatteryTests,
            'getCurrentSurveyResultId': getCurrentSurveyResultId,
            'saveComment': saveComment,
            'getSuggestCourse': getSuggestCourse,
            'courseRegisterConfirmed': courseRegisterConfirmed,
            'coursesRegistration': coursesRegistration,
            'registerCourses': registerCourses,
            'getFirstTimeOfClassBySkipClassSessionId': getFirstTimeOfClassBySkipClassSessionId,
            'checkIsAdHocHAQ': checkIsAdHocHAQ,
            'getSurveyType': getSurveyType,
        };

        function getBatteryTest(id, direction) {
            var surveyResultId = getSurvetResultIdFromLocalStorage();

            var url = baseURL + '/survey-workflow/battery-test/' + id + '/' + surveyResultId + "?direction=" + direction;
            return halClient.$get(url)
                .then(function successCallback(response) {
                    return response;
                }, function errorCallback(response) {
                    ClearLocalStorageService.clearWorkflow();
                    ShowUnexpectedErrorDialogService.open(response, 'getBatteryTest', null)
                        .result.then(function (result) {
                            $rootScope.$emit('ipmApp.httpError', response);
                        });
                    return response;
                });
        };

        function saveSurveyResponse(batteryTestId, batteryTest) {
            var surveyResultId = getSurvetResultIdFromLocalStorage();
            var config = {
                method: 'POST',
                url: baseURL + '/survey-workflow/' + batteryTestId + '/' + surveyResultId + '/save-response',
                data: batteryTest
            };
            return $http(config)
                .then(function successCallback(response) {
                    return response;
                }, function errorCallback(response) {
                    ClearLocalStorageService.clearWorkflow();
                    ShowUnexpectedErrorDialogService.open(response, 'saveSurveyResponse', null)
                        .result.then(function (result) {
                            $rootScope.$emit('ipmApp.httpError', response);
                        });
                    return response;
                });
        }

        function next(batteryTestId, batteryTest, isLastQuestion, currentQuestionObj) {
            var surveyResultId = getSurvetResultIdFromLocalStorage();
            var config = {
                method: 'POST',
                url: baseURL + '/survey-workflow/' + batteryTestId + '/' + surveyResultId + '/next?isLastQuestion=' + isLastQuestion,
                data: batteryTest
            };
            return $http(config)
                .then(function successCallback(response) {
                    return response;
                }, function errorCallback(response) {
                    ClearLocalStorageService.clearWorkflow();
                    ShowUnexpectedErrorDialogService.open(response, 'next', currentQuestionObj)
                        .result.then(function (result) {
                            $rootScope.$emit('ipmApp.httpError', response);
                        });
                    return response;
                });
        }

        function complete(batteryId) {
            var url = baseURL + '/survey-workflow/' + batteryId + '/complete';
            return $http.get(url).then(function (resp) {
                return resp;
            });
        }

        function sendSMS(batteryId) {
            var url = baseURL + '/survey-workflow/' + batteryId + '/send-sms';
            return $http.get(url).then(function (resp) {
                return resp;
            });
        }

        function getAllBatteryTests(batteryId, batteryTestId, surveyResultId) {
            var url = baseURL + '/survey-workflow/' + batteryId + '/get-all-battery-tests?batteryTestId=' + batteryTestId + "&surveyResultId=" + surveyResultId;
            return $http.get(url).then(function (resp) {
                return resp;
            });
        }

        function getCurrentSurveyResultId() {
            var url = baseURL + '/survey-workflow/get-current-survey-result';
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function saveComment(id, comment) {
            return $http.post(baseURL + '/survey-workflow/' + id + '/save-comment', comment).then(function (resp) {
                return resp;
            });
        }

        function getSurvetResultIdFromLocalStorage() {
            var surveyResultId = $window.localStorage.getItem(constants.SURVEY_RESULT_ID); // fix issue get wrong HAQ when get BatteryTest [IPMproject-374] - [Production Hotfix October 20, 2021] - Patch request - Issue w/ HAQ Tests on some patients
            if (!surveyResultId) {
                surveyResultId = 0;
            }
            return surveyResultId;
        }

        function getSuggestCourse() {
            var url = baseURL + '/survey-workflow/get-suggest-course';
            return $http.get(url).then(function (resp) {
                return resp;
            });
        }

        function courseRegisterConfirmed() {
            var url = baseURL + '/survey-workflow/course_register_confirmed';
            return $http.post(url).then(function (resp) {
                return resp;
            });
        }

        function coursesRegistration(suggestedCourses) {
            var config = {
                method: 'POST',
                url: baseURL + '/survey-workflow/course_registration',
                data: suggestedCourses
            };
            return $http(config).then(function successCallback(response) {
                return response;
            }, function errorCallback(response) {
                return response;
            });
        }

        function registerCourses(patientCourseRegistration) {
            var config = {
                method: 'POST',
                url: baseURL + '/survey-workflow/register_courses',
                data: patientCourseRegistration
            };
            return $http(config).then(function successCallback(response) {
                return response;
            }, function errorCallback(response) {
                return response;
            });
        }

        function getFirstTimeOfClassBySkipClassSessionId(classSessionId, patientCourseRegistration) {
            var config = {
                method: 'POST',
                url: baseURL + '/survey-workflow/register_courses/class-sessions/skip/' + classSessionId,
                data: patientCourseRegistration
            };
            return $http(config).then(function successCallback(response) {
                return response;
            }, function errorCallback(response) {
                return response;
            });
        }

        function checkIsAdHocHAQ() {
            var surveyResultId = getSurvetResultIdFromLocalStorage();
            var url = baseURL + '/survey-workflow/check-adhoc-haq/' + surveyResultId;
            return $http.get(url).then(function (resp) {
                return resp ? JSON.parse(resp.data) : false;
            });
        }

        function getSurveyType() {
            var surveyResultId = getSurvetResultIdFromLocalStorage();
            var url = baseURL + '/survey-workflow/get-survey-type/' + surveyResultId;
            return $http.get(url).then(function (resp) {
                return resp ? resp.data : 'DEFAULT';
            });
        }

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyWorkflowController', SurveyWorkflowController);

    SurveyWorkflowController.$inject = ['$scope', '$state', '$timeout', 'SurveyWorkflowService', '$uibModal', 'entity', 'allBatteryTests', 'ipmConstants', '$window', '$sessionStorage', 'DateUtils', '$sce', 'isAdHoc', 'ClearLocalStorageService'];

    function SurveyWorkflowController($scope, $state, $timeout, SurveyWorkflowService, $uibModal, entity, allBatteryTests, constants, $window, $sessionStorage, DateUtils, $sce, isAdHoc, ClearLocalStorageService) {
        var vm = this;
        vm.isAdHoc = isAdHoc ? isAdHoc : false;
        vm.listBatteryTest = [entity];

        vm.batteryTest = entity;
        vm.isSaving = false;
        vm.currentSection = 0;
        vm.currentQuestion = -1;
        vm.totalSection = 0;
        vm.totalQuestion = 0;
        vm.totalQuestionPerSection = [];
        vm.previousQuestionTempAnswered = 0;
        vm.previousQuestionAnswered = 0;
        vm.previousTestAnswered = [];
        vm.allQuestion = 0;

        vm.currentQuestionIndex = 0;
        vm.totalQuestionAnswered = 0;
        vm.totalQuestionAnsweredArray = [];

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.datetime = false;
        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.percent = 0;

        vm.widthStyle = function () {
            if (vm.percent > 0) {
                return { width: vm.percent + '%' };
            } else {
                return { width: vm.percent + '%', color: 'transparent' };
            }
        }

        vm.resumeTest = function () {
            // get list battery test
            var currentBatteryTest = vm.listBatteryTest[0];
            if (vm.isAdHoc) {
                currentBatteryTest.nextBatteryTestId = null;
            }
            while (currentBatteryTest.nextBatteryTestId != null) {
                for (var i = 0; i < allBatteryTests.data.length; i++) {
                    if (allBatteryTests.data[i].id == currentBatteryTest.nextBatteryTestId) {
                        vm.listBatteryTest.push(allBatteryTests.data[i]);
                        currentBatteryTest = allBatteryTests.data[i];
                        break;
                    }
                }
            }

            // count total question
            for (var i = 0; i < vm.listBatteryTest.length; i++) {
                for (var j = 0; j < vm.listBatteryTest[i].test.sections.length; j++) {
                    vm.allQuestion += vm.listBatteryTest[i].test.sections[j].questions.length;
                }
            }

            // resume to latest battery
            var founded = false;
            var countQuestions = 0;
            for (var i = 0; i < vm.listBatteryTest.length; i++) {
                countQuestions = 0;
                for (var j = 0; j < vm.listBatteryTest[i].test.sections.length; j++) {
                    countQuestions += vm.listBatteryTest[i].test.sections[j].questions.length;
                    for (var k = 0; k < vm.listBatteryTest[i].test.sections[j].questions.length; k++) {
                        var question = vm.listBatteryTest[i].test.sections[j].questions[k];
                        if (question.currentQuestion) {
                            founded = true;
                            vm.currentSection = j;
                            vm.currentQuestion = (k !== 0 ? k : -1);
                            vm.batteryTest = vm.listBatteryTest[i];
                            break;
                        }
                    }
                    if (founded) break;
                }
                if (founded) {
                    break;
                } else {
                    if (i != vm.listBatteryTest.length - 1) {
                        vm.previousTestAnswered.push(vm.listBatteryTest[i].id);
                        vm.previousQuestionAnswered += countQuestions;
                    }
                }
            }

            if (founded == false) {
                vm.currentSection = vm.listBatteryTest[vm.listBatteryTest.length - 1].test.sections.length - 1;
                vm.currentQuestion = vm.listBatteryTest[vm.listBatteryTest.length - 1].test.sections[vm.currentSection].questions.length;
                vm.batteryTest = vm.listBatteryTest[vm.listBatteryTest.length - 1];
            }
        }

        vm.initTotalData = function () {
            vm.totalSection = vm.batteryTest.test.sections.length;

            vm.totalQuestion = 0;
            vm.totalQuestionPerSection = [];
            _.forEach(vm.batteryTest.test.sections, function (section) {
                vm.totalQuestion += section.questions.length;
                vm.totalQuestionPerSection.push(section.questions.length);
            });
        }

        vm.calculateData = function () {
            var questionAnswered = 0;
            _.forEach(vm.batteryTest.test.sections, function (section) {
                _.forEach(section.questions, function (question) {
                    var emptyTextAnswer = (question.type === 'SHORT_ANSWER') && (question.answerText === null || question.answerText === undefined);
                    var emptySelectAnwer = (question.type === 'RANK' || question.type === 'MULTIPLE_CHOICE') && (question.answer === null || question.answer === undefined);
                    var emptyDatetimeAnwer = (question.type === 'DATE_TIME') && (question.dateValue === null || question.dateValue === undefined);
                    var emptyMultipleSelectAnwer = (question.type === 'MULTI_SELECT') && (question.multiSelectValue === null || question.multiSelectValue === undefined || question.multiSelectValue.length === 0);
                    if (!emptyTextAnswer && !emptySelectAnwer && !emptyDatetimeAnwer && !emptyMultipleSelectAnwer) {
                        questionAnswered++;
                    }
                });
            });
            vm.totalQuestionAnswered = questionAnswered;
            if (vm.previousTestAnswered.indexOf(vm.batteryTest.id) != -1) {
                vm.percent = Math.ceil((((vm.previousQuestionTempAnswered + vm.previousQuestionAnswered) / vm.allQuestion) * 100).toFixed(2));
            } else {
                vm.percent = Math.ceil((((questionAnswered + vm.previousQuestionAnswered) / vm.allQuestion) * 100).toFixed(2));
            }

            // create list question answered
            vm.totalQuestionAnsweredArray = [];
            for (var i = 0; i <= vm.totalQuestionAnswered; i++) {
                if (i != vm.totalQuestion) {
                    vm.totalQuestionAnsweredArray.push(i);
                }
            }
        }

        vm.updateQuestionIndex = function () {
            var tempIdx = 0;
            for (var i = 0; i <= vm.currentSection; i++) {
                if (i == vm.currentSection) {
                    tempIdx += vm.currentQuestion;
                    break;
                } else {
                    tempIdx += vm.totalQuestionPerSection[i];
                }
            }
            vm.currentQuestionIndex = String(tempIdx);
        }

        vm.moveQuestionByIndex = function () {
            var tempIdx = 0;
            for (var i = 0; i <= vm.totalSection; i++) {
                if (tempIdx + vm.totalQuestionPerSection[i] <= vm.currentQuestionIndex) {
                    tempIdx += vm.totalQuestionPerSection[i];
                } else {
                    vm.currentSection = i;
                    vm.currentQuestion = vm.currentQuestionIndex - tempIdx;
                    break;
                }
            }
        }

        vm.start = function () {
            vm.currentQuestion = 0;
            vm.updateQuestionIndex();
        }

        vm.goto = function (direction) {
            if (vm.isSaving) { return; }
            if (direction == 'First') {
                vm.currentSection = 0;
                vm.currentQuestion = 0;
            } else if (direction == 'Previous') {
                if (vm.currentQuestion > 0) {
                    vm.currentQuestion--;
                } else if (vm.currentSection > 0) {
                    vm.currentSection--;
                    vm.currentQuestion = vm.batteryTest.test.sections[vm.currentSection].questions.length - 1;
                } else if (vm.batteryTest.prevBatteryTestId != null) {
                    vm.previous();
                }
            } else if (direction == 'Next') {
                if (vm.currentQuestionIndex >= vm.totalQuestionAnswered && vm.totalQuestionAnswered != vm.totalQuestion) {
                    return;
                }

                if (vm.currentQuestion < vm.totalQuestionPerSection[vm.currentSection] - 1) {
                    vm.currentQuestion++;
                } else if (vm.currentSection < vm.totalSection - 1) {
                    vm.currentQuestion = 0;
                    vm.currentSection++;
                } else if (vm.batteryTest.nextBatteryTestId != null) {
                    vm.next();
                } else {
                    vm.currentQuestion++;
                }
            } else if (direction == 'Last') {
                if (vm.totalQuestionAnswered == vm.totalQuestion) {
                    vm.currentQuestionIndex = vm.totalQuestion - 1;
                } else {
                    vm.currentQuestionIndex = vm.totalQuestionAnswered;
                }
                vm.moveQuestionByIndex();
            }
            vm.updateQuestionIndex();
            vm.updateSaveButton();
        }

        // use for SHORT_ANSWER type with other answer
        vm.showSaveButton = false;
        var firstQuestion = vm.batteryTest.test.sections[0].questions[0];
        if (firstQuestion.type == "SHORT_ANSWER") {
            _.forEach(firstQuestion.questionOptions, function (questionOption) {
                if (questionOption.optionType === 'OTHER' && firstQuestion.answer && firstQuestion.answer.toString() === questionOption.value.toString()) {
                    vm.showSaveButton = true;
                    return;
                }
            });
        }

        vm.checkShowNextTest = function (question, questionOption) {
            if (vm.currentSection == vm.batteryTest.test.sections.length - 1 && vm.currentQuestion == vm.batteryTest.test.sections.length - 1) {
                return true;
            } else {
                return false;
            }
        }

        vm.checkshowOtherText = function (question, questionOption) {
            if (questionOption.optionType === 'OTHER' && question.answer && question.answer.toString() === questionOption.value.toString()) {
                return true;
            } else {
                return false;
            }
        }

        vm.previous = function () {
            vm.isSaving = true;

            if (vm.previousTestAnswered.indexOf(vm.batteryTest.id) == -1) {
                vm.previousQuestionTempAnswered = vm.totalQuestionAnswered;
            }

            SurveyWorkflowService.saveSurveyResponse(vm.batteryTest.id, vm.batteryTest).then(function (response) {
                SurveyWorkflowService.getBatteryTest(vm.batteryTest.prevBatteryTestId, 'previous').then(function (response) {
                    vm.batteryTest = response;
                    vm.isSaving = false;
                    vm.currentQuestion = 0;
                    vm.currentSection = 0;
                    vm.initTotalData();
                    vm.calculateData();
                    vm.updateQuestionIndex();
                    // load value for multiple checkbox
                    vm.initMultiSelectValueAndDate();
                });
            }).finally(function () {
                scrollTop();
            });
        }

        var checkAnswerSuicideRiskTest = function () {
            var condition = true;
            _.forEach(vm.batteryTest.test.sections, function (section) {
                if (!condition) return;
                _.forEach(section.questions, function (question) {
                    var answerSuicideRiskTest = (question.name === constants.SUICIDE_RISK_TEST && question.answer == 0);
                    if (answerSuicideRiskTest) {
                        condition = false;
                        return;
                    }
                });
            });
            return condition;
        }

        function errorOnQuestion(currentQuestionObj) {
            currentQuestionObj.answer = null;
            currentQuestionObj.answerText = null;
        }

        function copyQuestionObj(currentQuestionObj) {
            var result = {};
            angular.copy(currentQuestionObj, result);
            return result;
        }

        vm.questionChecked = function (questionOption) {

            if (questionOption) {
                var currentQ = vm.batteryTest.test.sections[vm.currentSection].questions[vm.currentQuestion];
                if (questionOption.optionType === 'OTHER' && currentQ.answer.toString() === questionOption.value.toString()) {
                    vm.showSaveButton = true;
                    return;
                } else {
                    vm.showSaveButton = false;
                }
            }

            var currentQuestionObj = vm.batteryTest.test.sections[vm.currentSection].questions[vm.currentQuestion];
            // [start - set multiple value]
            currentQuestionObj.multiSelectValue = [];
            var options = currentQuestionObj.questionOptions;
            angular.forEach(options, function (option) {                  // loop options
                if (option.checked) {
                    currentQuestionObj.multiSelectValue.push(option.id); // push id to fix bug: IPMproject-B1067
                }
            });
            // [end - set multiple value]

            // [start - set data value]
            angular.forEach(vm.batteryTest.test.sections, function (section) {                       // loop sections
                var questions = section.questions;
                angular.forEach(questions, function (question) {                         // loop questions
                    if (question.dateValueDisplay) {
                        question.dateValue = DateUtils.convertLocalDateToServer(question.dateValueDisplay);
                    }
                });
            });
            // [end - set data value]

            if (vm.currentQuestion < vm.batteryTest.test.sections[vm.currentSection].questions.length - 1) {
                vm.isSaving = true;
                SurveyWorkflowService.next(vm.batteryTest.id, vm.batteryTest, false, copyQuestionObj(currentQuestionObj)).then(function (response) {
                    vm.isSaving = false;
                    if (response.status === 200) {
                        vm.calculateData();
                        vm.currentQuestion++;
                        vm.updateQuestionIndex();
                        vm.updateSaveButton();
                    } else {
                        errorOnQuestion(currentQuestionObj);
                    }
                });
            } else if (vm.currentSection < vm.totalSection - 1) {
                vm.isSaving = true;
                SurveyWorkflowService.next(vm.batteryTest.id, vm.batteryTest, false, copyQuestionObj(currentQuestionObj)).then(function (response) {
                    vm.isSaving = false;
                    if (response.status === 200) {
                        vm.calculateData();
                        vm.currentQuestion = 0;
                        vm.currentSection++;
                        vm.updateQuestionIndex();
                        vm.updateSaveButton();
                    } else {
                        errorOnQuestion(currentQuestionObj);
                    }
                });
            } else if (vm.batteryTest.nextBatteryTestId === null) {
                vm.isSaving = true;
                SurveyWorkflowService.next(vm.batteryTest.id, vm.batteryTest, true, copyQuestionObj(currentQuestionObj)).then(function (response) {
                    vm.isSaving = false;
                    if (response.status === 200) {
                        vm.calculateData();
                        vm.currentQuestion++;
                        vm.updateQuestionIndex();
                        vm.updateSaveButton();
                        goToCourseRegistrationWorkflow();
                    } else {
                        errorOnQuestion(currentQuestionObj);
                    }
                });
            } else {
                vm.next();
            }
        }

        vm.next = function () {
            var currentQuestionObj = vm.batteryTest.test.sections[vm.currentSection].questions[vm.currentQuestion];
            vm.isSaving = true;
            SurveyWorkflowService.next(vm.batteryTest.id, vm.batteryTest, false, copyQuestionObj(currentQuestionObj)).then(function (response) {
                vm.isSaving = false;
                if (response.status === 200) {
                    if (vm.batteryTest.test.name === constants.PHQ_9 && checkAnswerSuicideRiskTest()) {
                        SurveyWorkflowService.sendSMS(vm.batteryTest.batteryId);
                    }

                    if (vm.previousTestAnswered.indexOf(vm.batteryTest.id) == -1) {
                        vm.previousTestAnswered.push(vm.batteryTest.id);
                        vm.previousQuestionAnswered += vm.totalQuestion;
                    }

                    SurveyWorkflowService.getBatteryTest(vm.batteryTest.nextBatteryTestId, 'next').then(function (response) {
                        if (!angular.isUndefined(response.result) && response.result === constants.BATTERY_COMPLETE) {
                            goToCourseRegistrationWorkflow();
                        }
                        vm.batteryTest = response;
                        vm.totalSection = vm.batteryTest.test.sections.length;

                        vm.currentQuestion = -1;
                        vm.currentSection = 0;
                        vm.initTotalData();
                        vm.calculateData();
                        vm.updateQuestionIndex();
                        vm.updateSaveButton();
                    });
                    scrollTop();
                } else {
                    errorOnQuestion(currentQuestionObj);
                }
            });
        }

        function goToCourseRegistrationWorkflow() {
            if (constants.HIDE_WELLNESS_CLASSES) {
                $state.go('survey-workflow-thankyou');
                return;
            } else {
                $state.go('course-registration-workflow');
            }
        }

        vm.updateSaveButton = function () {
            vm.showSaveButton = false;
            if (vm.currentQuestion >= 0) {
                var currentQ = vm.batteryTest.test.sections[vm.currentSection].questions[vm.currentQuestion];
                if (currentQ && currentQ.type == "SHORT_ANSWER") {
                    _.forEach(currentQ.questionOptions, function (questionOption) {
                        if (questionOption.optionType === 'OTHER' && currentQ.answer && currentQ.answer.toString() === questionOption.value.toString()) {
                            vm.showSaveButton = true;
                            return;
                        }
                    });
                }
            }
        }

        var confirmDialog = function () {
            $uibModal.open({
                controller: function ($uibModalInstance, $state, Auth) {
                    var vm = this;

                    vm.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.logout = function () {
                        $uibModalInstance.dismiss('cancel');
                        Auth.logout();
                        $state.go('home');
                    };
                },
                templateUrl: 'app/survey-workflow/partial/confirm-dialog.html',
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static',
                windowClass: 'absolute-center warning-dialog'
            });
        }

        var scrollTop = function () {
            $timeout(function () {
                $window.scrollTo(0, 0);
            }, 100);
        }

        vm.noMultipleSelect = function (question) {
            return _.isEmpty(_.filter(question.questionOptions, function (questionOption) { return questionOption.checked }));
        }

        vm.initMultiSelectValueAndDate = function () {
            angular.forEach(vm.batteryTest.test.sections, function (section) {                       // loop sections
                var questions = section.questions;
                angular.forEach(questions, function (question) {                         // loop questions
                    var multiSelectValue = question.multiSelectValue ? question.multiSelectValue : [];
                    var options = question.questionOptions;
                    angular.forEach(options, function (option) {                  // loop options
                        option.checked = multiSelectValue.indexOf(option.id) !== -1 ? true : false;
                    });
                    // convert date:
                    if (question.dateValue) {
                        question.dateValueDisplay = DateUtils.convertLocalDateFromServer(question.dateValue);
                    }
                });
            });
        }

        vm.init = function () {
            vm.resumeTest();
            vm.initTotalData();
            vm.calculateData();
            vm.updateQuestionIndex();
            if (vm.currentQuestion == -1) {
                vm.currentQuestion = 0;
                if (vm.currentQuestionIndex > -1) {
                    vm.currentQuestionIndex++;
                    vm.currentQuestionIndex = String(vm.currentQuestionIndex);
                }
            }
            vm.updateSaveButton();

            vm.batteryTest.test.instructions = $sce.trustAsHtml(vm.batteryTest.test.instructions);

            // load value for multiple checkbox
            vm.initMultiSelectValueAndDate();

            var surveyResultId = $window.localStorage.getItem(constants.SURVEY_RESULT_ID);
            if (surveyResultId) {
                $sessionStorage.currentSurveyResultId = surveyResultId;
            } else {
                SurveyWorkflowService.getCurrentSurveyResultId().then(function (res) {
                    $sessionStorage.currentSurveyResultId = res;
                });
            }
        }
        vm.init();

        $scope.$on('$destroy', function () {
            var isLaunchingFromHaqAdhoc = ClearLocalStorageService.getLaunchFrom() === constants.HAQ_ADHOC;
            if (isAdHoc && !isLaunchingFromHaqAdhoc) {
                ClearLocalStorageService.clearSurveyResultId();
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('survey-result-list', {
            parent: 'app',
            url: '/survey-result-list',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER'],
                pageTitle: 'ipmApp.surveyResult.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/survey-result/survey-result-list.html',
                    controller: 'SurveyResultListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('surveyResultStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                supportedDataList: ['SurveyResultService', function(SurveyResultService) {
                	return SurveyResultService.getSupportedDataList();
                }]
            },
            params: {
            	searchSurveyResultParamsInfo: null,
                searchPatientParamsInfo: null
            }
        }).state('survey-result-details', {
            parent: 'app',
            url: '/survey-result-details/{id}',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER'],
                pageTitle: 'ipmApp.surveyResult.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/survey-result/survey-result-details.html',
                    controller: 'SurveyResultDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('surveyResultStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                surveyResult: ['SurveyResultService', '$stateParams', function(SurveyResultService, $stateParams) {
                	return SurveyResultService.getSurveyResult($stateParams.id);
                }]
            },
            params: {
            	searchSurveyResultParamsInfo: null
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('SurveyResultService', SurveyResultService);

    SurveyResultService.$inject = ['$q', 'halClient', '$http', 'DateUtils', 'DownloadBlobService'];

    function SurveyResultService ($q, halClient, $http, DateUtils, DownloadBlobService) {
    	var baseUrl = 'api';

        var service = {
        	'searchSurveyResults': searchSurveyResults,
        	'getSurveyResult': getSurveyResult,
        	'getSupportedDataList': getSupportedDataList,
        	'changeDisposition': changeDisposition,
        	'findByPatient': findByPatient,
        	'findByPatientPaganition': findByPatientPaganition,
        	'getCurrentSurveyResult': getCurrentSurveyResult,
            'downloadResult': downloadResult,
            'downloadResponse': downloadResponse,
            'downloadHAQResultsReports': downloadHAQResultsReports,
            'downloadBatteryResultsReports': downloadBatteryResultsReports,
            'savePatientCaseSelected': savePatientCaseSelected
        };

        function getCurrentSurveyResult(noWait, surveyResultId) {
			if (!surveyResultId) {
				surveyResultId = 0;
			}
        	var deferred = $q.defer();
        	var url = baseUrl + '/survey-results/get-current-survey-result?noWait=' + noWait + '&surveyResultId=' + surveyResultId;

        	halClient.$get(url).then(function success(result) {
        		deferred.resolve(result);
    		}, function error(e) {
    			deferred.reject(error);
    		});

        	return deferred.promise;
        }

        function findByPatient(patientId) {
        	var deferred = $q.defer();
        	var url = baseUrl + '/survey-results/find-by-patient?patientId=' + patientId;

        	halClient.$get(url).then(function success(result) {
        		deferred.resolve(result);
    		}, function error(e) {
    			deferred.reject(error);
    		});

        	return deferred.promise;
        }

        function findByPatientPaganition(patientId, surveyResultType, pageable) {
        	var deferred = $q.defer();
        	var url = baseUrl + '/survey-results/find-by-patient';

        	$http.get(url, {
				params: {
                    surveyResultType: surveyResultType,
					patientId: patientId,
					page: pageable.page,
					size: pageable.size,
					sort: pageable.sort
				}
			})
			.success(function(data) {
                if (data && data.lastModifiedDate) {
                    data.lastModifiedDate = DateUtils.convertLocalDateFromServer(data.lastModifiedDate);
                }
				deferred.resolve(data);
			})
			.error(function(e) {
				deferred.reject(e);
			});

			return deferred.promise;
        }

        function getSurveyResult(id) {
        	var deferred = $q.defer();
        	var url = baseUrl + '/survey-results/' + id;
        	halClient.$get(url).then(function success(result) {
        		deferred.resolve(result);
    		}, function error(e) {
    			deferred.reject(error);
    		});

        	return deferred.promise;
        }

        function getSupportedDataList() {
    		var deferred = $q.defer();

    		var url = baseUrl + '/survey-results/supported-data-list';

    		$http.get(url).success(function(data) {
    			deferred.resolve(data);
    		})
    		.error(function(error) {
    			deferred.reject(error);
    		});

    		return deferred.promise;
    	};

        function searchSurveyResults(query, status, pageable) {
    		var deferred = $q.defer();

        	var url = baseUrl + '/survey-results/search';
        	$http.get(url, {
				params: {
					query: ((query != null) ? encodeURIComponent(query) : null),
					status: status,
					page: pageable.page,
					size: pageable.size,
					sort: pageable.sort
				}
			})
			.success(function(data) {
				deferred.resolve(data);
			})
			.error(function(e) {
				deferred.reject(e);
			});

			return deferred.promise;
        }

        function changeDisposition(id, disposition) {
        	var params = {id: id, disposition: disposition};
        	var url = baseUrl + '/survey-results/change-disposition';
        	halClient.$post(url, null, params).then(function success(result) {
        		return result;
    		}, function error(e) {
    			return e;
    		});
        }

        function downloadResult(id) {
            var deferred = $q.defer();
            var url = baseUrl + '/survey-results/download/' + id;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
					saveAs(blob, "New Patient Questionnaire Result.pdf");
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function downloadResponse(id) {
            var deferred = $q.defer();
            var url = baseUrl + '/survey-results/download-response/' + id;
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
					saveAs(blob, "New Patient Questionnaire Response.pdf");
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function downloadHAQResultsReports(fromDate, toDate, isAdHoc, fileDownloadId) {
            var deferred = $q.defer();
            var url = baseUrl + '/survey-results/download-haq-results-reports/' + fileDownloadId;
            $http({
                url: url,
                method: "GET",
                params: {isAdHoc: isAdHoc, fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                var statusDownload = headers('status-download');
                if (status === 204) {
                    deferred.resolve({status: status, statusDownload: statusDownload});
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve({status: status, statusDownload: statusDownload});
                }
            }).error(function (data, status, headers, config) {
                var statusDownload = headers('status-download');
                deferred.resolve({status: status, statusDownload: statusDownload});
            });
            return deferred.promise;
        }

        function downloadBatteryResultsReports(fromDate, toDate) {
            var deferred = $q.defer();
            var url = baseUrl + '/survey-results/download-battery-results-reports';
            $http({
                url: url,
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                var statusDownload = headers('status-download');
                if (status === 204) {
                    deferred.resolve({status: status, statusDownload: statusDownload});
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve({status: status, statusDownload: statusDownload});
                }
            }).error(function (data, status, headers, config) {
                var statusDownload = headers('status-download');
                deferred.resolve({status: status, statusDownload: statusDownload});
            });
            return deferred.promise;
        }

        function savePatientCaseSelected(surveyResultId, data) {
            var url = baseUrl + '/survey-results/save-patient-case-selected/' + surveyResultId;
            return $http.post(url, data).then(function (response) {
                return response;
            });
        }

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResultListController', SurveyResultListController);

    SurveyResultListController.$inject = ['$scope', '$state', 'SurveyResultService', '$localStorage', 'supportedDataList', '$stateParams', '$window', 'Principal', 'ipmConstants'];

    function SurveyResultListController ($scope, $state, SurveyResultService, $localStorage, supportedDataList, $stateParams, $window, Principal, constants) {
    	var vm = this;
        vm.surveyResults = [];
        vm.statuses = supportedDataList.statuses;
        vm.status = null;
        vm.query = null;
        vm.page = 1;
        vm.totalItems = 0;
        vm.predicate = 'u.firstName';
        vm.reverse = false;
        vm.pageSize = 15;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.isManager = Principal.hasAnyAuthority([constants.ROLE_MANAGER]);
        
        function loadAll() {
        	var pageable = {page: vm.page > 0 ? vm.page - 1 : vm.page,
    						size: vm.pageSize,
    						sort: sort()};
        	
            SurveyResultService.searchSurveyResults(vm.searchQuery, vm.status, pageable).then( function(response) {
            	if (response._embedded !== undefined) {
	        		vm.surveyResults = response._embedded.surveyResultDTOList;
				} else {
					vm.surveyResults = [];
				}
            	
            	vm.totalItems = response.page.totalElements;
	        	vm.totalElements =  response.page ? response.page.totalElements : 0;
        		if(vm.searchQuery != null && !_.isEmpty(vm.searchQuery)) {
        			vm.isShowClearSearchButton = true;
        		}else {
        			vm.isShowClearSearchButton = false;
        		}
            });
            
        };
        
        function init() {
        	var paramsInfo = $stateParams.searchSurveyResultParamsInfo;
        	if(paramsInfo) {
        		vm.status = paramsInfo.status;
        		vm.searchQuery = paramsInfo.searchQuery;
        		vm.page = paramsInfo.page;
        		vm.totalItems = paramsInfo.totalItems;
        		vm.pageSize = paramsInfo.pageSize;
        		vm.predicate = paramsInfo.predicate;
        		vm.reverse = paramsInfo.reverse;
        	}
        	vm.loadAll();
        }
        
        function getSearchSurveyResultParamsInfo() {
        	var paramsInfo = {
        		status: vm.status,
        		searchQuery: vm.searchQuery,
            	page: vm.page,
            	totalItems: vm.totalItems,
            	pageSize: vm.pageSize,
            	predicate: vm.predicate,
            	reverse: vm.reverse
        	}

        	return paramsInfo;
        }

        function getSearchPatientParamsInfo() {
            var paramsInfo = $stateParams.searchPatientParamsInfo;
            if (paramsInfo) {
                vm.status = paramsInfo.status;
                vm.searchQuery = paramsInfo.searchQuery;
                vm.page = paramsInfo.page;
                vm.totalItems = paramsInfo.totalItems;
                vm.pageSize = paramsInfo.pageSize;
                vm.predicate = paramsInfo.predicate;
                vm.reverse = paramsInfo.reverse;
            }
            return paramsInfo;
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        vm.search = function () {
            vm.page = 0;
            vm.predicate = 'u.firstName';
            vm.reverse = false;
            vm.loadAll();
        };

        vm.clear = function () {
            vm.surveyResults = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'u.firstName';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.loadAll();
        };

        vm.downloadAllReport = function() {
        	var url = 'api/survey-results/download-all-completed-report';
        	$window.open(url, '_blank');
        }

        vm.goToSurveyResultDetails = function(surveyResultId) {
        	var paramsInfo = getSearchSurveyResultParamsInfo();
        	$state.go('survey-result-details', {id: surveyResultId, searchSurveyResultParamsInfo: paramsInfo});
        }

        vm.goToPatientDetails = function(patientId) {
            if (patientId) {
                var paramsInfo = getSearchPatientParamsInfo();
                $state.go('patient-detail', {id: patientId, searchPatientParamsInfo: paramsInfo, type: constants.SEARCH_TYPE_HAQ});
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        vm.getDisposition = function(surveyResult) {
        	return surveyResult.disposition;
        }

        vm.changeDisposition = function(surveyResult) {
        	surveyResult.disposition = !surveyResult.disposition;
        	SurveyResultService.changeDisposition(surveyResult.id, surveyResult.disposition);
        }

        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResultDetailsController', SurveyResultDetailsController);

    SurveyResultDetailsController.$inject = ['$scope', '$state', 'SurveyResultService', 'surveyResult', '$window', '$stateParams', 'Principal', 'ipmConstants'];

    function SurveyResultDetailsController ($scope, $state, SurveyResultService, surveyResult, $window, $stateParams, Principal, constants) {
    	var vm = this;
    	vm.page = 1;
        vm.predicate = 'id';
        vm.reverse = true;
        vm.pageSize = 6;
        vm.totalItems = 0;
    	vm.loadPage = loadPage;
    	vm.surveyResults = [];
        vm.surveyResult = surveyResult;
        vm.loadAllResults = loadAllResults;
        vm.isManager = Principal.hasAnyAuthority([constants.ROLE_MANAGER]);

        loadAllResults();

        vm.getDisposition = function() {
        	return vm.surveyResult.disposition;
        }

        vm.getIndex = function(index) {
        	var result = (index + 1) + (vm.page - 1)*vm.pageSize;
        	return result;
        }

        vm.backToList = function() {
        	var paramsInfo = $stateParams.searchSurveyResultParamsInfo;
        	if(paramsInfo) {
        		$state.go('survey-result-list', {searchSurveyResultParamsInfo: paramsInfo});
        	} else {
        		$window.history.back();
        	}
        }

        function loadAllResults() {

        	var pageable = {page: vm.page > 0 ? vm.page - 1 : vm.page,
					size: vm.pageSize,
					sort: sort()};

        	SurveyResultService.findByPatientPaganition(surveyResult.patientId, constants.SURVEY_RESULT_TYPE_DEFAULT , pageable).then( function(response) {
        		vm.totalItems =  response.totalElements;
        		if (response.content !== undefined) {
		    		vm.surveyResults = response.content;
				} else {
					vm.surveyResults = [];
				}
		    });

        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        function loadPage () {
            vm.page = page;
            vm.loadAllResults();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('ShowUnexpectedErrorDialogService', ShowUnexpectedErrorDialogService);

        ShowUnexpectedErrorDialogService.$inject = ['$uibModal'];

    function ShowUnexpectedErrorDialogService ($uibModal) {

        var service = {
            'isOpen': isOpen,
            // 'close': close,
            // 'dismiss': dismiss,
            'open': open,
        };

        var open = false,
        modalInstance;

    function isOpen () {
        return open;
    };

    function open(res, functionName, currentQuestionObj) {
        if (open) {
            return;
        }
        var modal = $uibModal.open({
            controller: function ($uibModalInstance) {
                var vm = this;
                vm.currentQuestionObj = currentQuestionObj;
                vm.functionName = functionName;
                vm.statusCode = res.status;
                if (_.isObject(res.data)) {
                    vm.errorDetails = res.data.description;
                } else {
                    vm.errorDetails = res.data;
                }

                vm.close = function() {
                    $uibModalInstance.close(true);
                }
                
                vm.getResponse = function() {
                    if (vm.currentQuestionObj) {
                        var answer = vm.currentQuestionObj.answer;
                        if (answer) {
                            var questionOptions = _.filter(vm.currentQuestionObj.questionOptions, function(o) { 
                                return o.value == answer;
                            });
                            if (!_.isEmpty(questionOptions)) {
                                return questionOptions[0].name;
                            }
                        }
                    }
                    return null;
                }
            },
            templateUrl: 'app/survey-workflow/partial/unexpected-error-dialog.html',
            controllerAs: 'vm',
            size: 'sm',
            backdrop: 'static',
            keyboard  : false,
            windowClass: 'absolute-center error-dialog'
        });

        //Set open
        open = true;

        //Set modalInstance
        modalInstance = modal;

        //Modal is closed/resolved/dismissed
        modal.result.finally(function () {
            open = false;
        });

        return modal;
    };
    return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('samlLogin', {
                parent: 'app',
                url: '/saml/SSO',
                data: {
                    authorities: [],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        template: '<span></span>',
                        controller: 'SAMLLoginController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    isLogin: function () {
                        return false;
                    }
                }
            })
            .state('samlReLogin', {
                parent: 'app',
                url: '/saml/login',
                data: {
                    authorities: [],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        template: '<span></span>',
                        controller: 'SAMLLoginController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    isLogin: function () {
                        return true;
                    }
                }
            })
        ;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('SamlService', SamlService);

    SamlService.$inject = ['$resource', '$http', '$q'];

    function SamlService($resource, $http, $q) {
        var resourceUrl = "saml/";
        var service = $resource(resourceUrl, {}, {});
        service.forceReLogin = forceReLogin;

        function forceReLogin() {
            var url = resourceUrl + 'force-login';
            return $http.get(url).then(function (response) {
                return response.data;
            });
        }

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SAMLLoginController', SAMLLoginController);

    SAMLLoginController.$inject = ['$scope', '$state', '$window', 'isLogin', 'SamlService'];

    function SAMLLoginController($scope, $state, $window, isLogin, SamlService) {
        init();

        function init() {
            if (!isLogin) { // step 1
                $state.go('samlReLogin', null, {reload: true});
                return;
            } else { // step 2
                SamlService.forceReLogin().then(function () {
                    $window.location.href = "saml/login";
                });
            }
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qhp-workflow-landing-page', {
            parent: 'app',
            url: '/qhp-workflow',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/landing-page.html',
                    controller: 'QHPLandingPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('carePlanReview');
                    $translatePartialLoader.addPart('qhpWorkflow');
                    return $translate.refresh();
                }],
                entity: ['QHPWorkflowService', function (QHPWorkflowService) {
                    return null;
                }],
            }
        });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('QHPWorkflowService', QHPWorkflowService);

    QHPWorkflowService.$inject = ['$resource', '$http', '$q'];

    function QHPWorkflowService ($resource, $http, $q) {
        var resourceUrl = "api/qhp-workflow/";
        var service = $resource(resourceUrl, {}, {});
        service.getQHPUserDetail = getQHPUserDetail;

        function getQHPUserDetail() {
            return $http.get(resourceUrl + '/get-qhp-user').then(function (response) {
                return response.data;
            });
        };

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QHPLandingPageController', QHPLandingPageController);

    QHPLandingPageController.$inject = ['$scope', '$state', 'Principal', 'ipmConstants'];

    function QHPLandingPageController($scope, $state, Principal, constants) {
        var vm = this;
        vm.slides = [];
        

        init();

        function init() {
            Principal.identity(false).then(function (account) {
                vm.tasks = account.qhpUserDetail.tasks;
                initLandingPageItem();
                initLandingPageBackground();
            });
        }

        function initLandingPageItem() {
            // define common variable
            var approxTextTranslate = 'ipmApp.qhpWorkflow.landingPage.approx';

            vm.langdingPageItems = [];

            if (_.indexOf(vm.tasks, constants.CARE_PLAN_REVIEW) !== -1) {
                var CPR_ITEM = {
                    isCPR: true,
                    image: './content/images/assets_agreement.png', 
                    titleTextTranslate: 'ipmApp.qhpWorkflow.landingPage.cpr', 
                    approxTextTranslate: approxTextTranslate,
                    minApprox: 35
                }
                vm.langdingPageItems.push(CPR_ITEM);
            }
            if (_.indexOf(vm.tasks, constants.HAQ_EVALUATION) !== -1) {
                var EVALUATION_ITEM = {
                    isHAQEvaluation: true,
                    image: './content/images/assets_haq.png',
                    titleTextTranslate: 'ipmApp.qhpWorkflow.landingPage.haqEvaluation',
                    approxTextTranslate: approxTextTranslate,
                    minApprox: 35
                }
                vm.langdingPageItems.push(EVALUATION_ITEM);
            }
            if (_.indexOf(vm.tasks, constants.INSTRUCTOR) !== -1 && !constants.HIDE_WELLNESS_CLASSES) {
                var INSTRUCTOR_ITEM = {
                    image: './content/images/assets_haq_wellness_class.png',
                    titleTextTranslate: 'ipmApp.qhpWorkflow.landingPage.wellnessClasses'
                }
                vm.langdingPageItems.push(INSTRUCTOR_ITEM);
            }
            if (_.indexOf(vm.tasks, constants.FRP_MDE) !== -1) {
                var FRP_MDE = {
                    isFRP_MDE: true,
                    image: './content/images/assets_frp_mde.png',
                    titleTextTranslate: 'ipmApp.qhpWorkflow.landingPage.FRP_MDE',
                }
                vm.langdingPageItems.push(FRP_MDE);
            }
            if (_.indexOf(vm.tasks, constants.HAQ_BRIEF_REVIEW) !== -1) {
                var BRIEF_REVIEW_ITEM = {
                    isHAQBriefReview: true,
                    image: './content/images/assets_haq.png',
                    titleTextTranslate: 'ipmApp.qhpWorkflow.landingPage.haqBriefReview',
                    approxTextTranslate: approxTextTranslate,
                    minApprox: 5
                }
                vm.langdingPageItems.push(BRIEF_REVIEW_ITEM);
            }
        }

        function initLandingPageBackground() {
            var currIndex = 0;
            vm.slides.push({
                image: 'content/images/assets_bg.jpg',
                id: currIndex++
            });
        }

        vm.itemLandingPageClick = function(item) {
            if (item) {
                if(item.isCPR) {
                    $state.go('care-plan-review');
                    return;
                } else if (item.isHAQEvaluation) {
                    $state.go('haq-evaluation');
                    return;
                } else if (item.isFRP_MDE) {
                    $state.go('frp-mde');
                    return;
                } else if (item.isHAQBriefReview) {
                    $state.go('haq-brief-review');
                    return;
                } else {
                    $state.go('wellness-class-list');
                    return;
                }
            }
        }

    }
})();
;
(function() {
    'use strict';


    QHPItemLandingPageController.$inject = ['$scope', '$state', '$window', 'LandingPageService', 'ClearLocalStorageService', 'AgreementsWorkflowService', 'ipmConstants'];

    function QHPItemLandingPageController($scope, $state, $window, LandingPageService, ClearLocalStorageService, AgreementsWorkflowService, constants) {
        var vm = this; //jshint ignore:line
        vm.percentCompleted = 100; // completed 100%

        vm.percentTextClass = percentTextClass;
        vm.isShowCompletedText = isShowCompletedText;
        vm.timeRemainingTextClass = timeRemainingTextClass;
        vm.isShowApproxText = isShowApproxText;
        vm.isShowRemainingText = isShowRemainingText;
        vm.isCompleted = isCompleted;
        vm.isStart = isStart;
        vm.isNotYetCompleted = isNotYetCompleted;
        vm.clickAction = clickAction;

        init();

        function init() {
            // setCurrentStep();
        }

        function percentTextClass() {
            if (vm.item && vm.item.percentProgress) {
                if (vm.item.percentProgress === vm.percentCompleted) {
                    return 'text-success';
                } else if (vm.item.percentProgress > 0 && vm.item.percentProgress  < vm.percentCompleted) {
                    return 'text-warning';
                }
            }
            return '';
        }

        function isShowCompletedText() {
            return isCompleted();
        }

        function timeRemainingTextClass() {
            if (vm.item.percentProgress === 0 || vm.item.percentProgress) {
                if (vm.item.percentProgress == vm.percentCompleted) {
                    return '';
                } else if (vm.item.percentProgress > 0 && vm.item.percentProgress < vm.percentCompleted) {
                    return 'text-warning';
                }
                return 'text-success';
            }
            return '';
        }
        function isShowApproxText() {
            return !(vm.item.percentProgress && vm.item.percentProgress > 0);
        }

        function isShowRemainingText() {
            return vm.item.percentProgress && vm.item.percentProgress > 0 && vm.item.percentProgress < vm.percentCompleted
        }

        function isStart() {
            return vm.item && vm.item.percentProgress === 0;
        }

        function isCompleted() {
            return vm.item && vm.item.percentProgress === vm.percentCompleted;
        }

        function isNotYetCompleted() {
            return !isCompleted();
        }

        function clickAction() {
            $window.setTimeout(function () {
                if (vm.item.canDownload && isCompleted()) {
                    vm.onClickDownload();
                    return;
                }
                vm.onClick();
            });
        }
    }

    angular.module('ipmApp').component('qhpItemLandingPage', {
        bindings: {
            item: '<',
            onClick: '&',
            onClickDownload: '&'
        },
        templateUrl: 'app/qhp-workflow/item-landing-page.html',
        controller: QHPItemLandingPageController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('psych-intake', {
                abstract: true,
                parent: 'app',
                url: '/psych-intake',
                data: {
                    authorities: [],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/psych-intake/psych-intake.html',
                        controller: 'PsychIntakeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('psychIntake');
                        $translatePartialLoader.addPart('psychIntakeAgreements');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    psychIntake: ['PsychIntakeService', '$window', 'ipmConstants', function(PsychIntakeService, $window, constants) {
                        var id = $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID);
                        return PsychIntakeService.getPsychIntakeForm(id);
                    }]
                }
            }).state('psych-intake.workflow', {
                parent: 'psych-intake',
                url: '/workflow',
                data: {
                    authorities: [],
                    pageTitle: ''
                },
                views: {
                    'workflow-view@psych-intake': {
                        templateUrl: 'app/psych-intake/workflow/workflow.html',
                        controller: 'PsychIntakeWorkflowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    dataWorkflow: ['$state', 'psychIntake', 'PsychIntakeService', function($state, psychIntake, PsychIntakeService) {
                        if(psychIntake.id) {
                            return PsychIntakeService.viewWorkflow(psychIntake.id);
                        } else {
                            return $state.go('home');
                        }
                    }]
                }
            }).state('psych-intake.agreements-workflow', {
                parent: 'psych-intake',
                url: '/agreements-workflow',
                data: {
                    authorities: [],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/psych-intake/agreements-workflow/agreements-workflow.html',
                        controller: 'PsychIntakeAgreementsWorkflowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    dataWorkflow: ['$state', 'psychIntake', 'PsychIntakeService', function($state, psychIntake, PsychIntakeService) {
                        if(psychIntake.id) {
                            console.log('psych-intake.agreements-workflow', psychIntake.id);
                            return PsychIntakeService.viewWorkflow(psychIntake.id);
                        } else {
                            return $state.go('home');
                        }
                    }]
                }
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('PsychIntakeService', PsychIntakeService);

        PsychIntakeService.$inject = ['$http', '$q', 'DateUtils', 'DownloadBlobService', 'ShowUnexpectedErrorDialogService', '$rootScope', 'ClearLocalStorageService'];

    function PsychIntakeService ($http, $q, DateUtils, DownloadBlobService, ShowUnexpectedErrorDialogService, $rootScope, ClearLocalStorageService) {
        var baseURL = 'api/psych-intake';

    	var service = {
            'getPsychIntakeForm': getPsychIntakeForm,
            'viewWorkflow': viewWorkflow,
            'submitWorkflow': submitWorkflow,
            'getPsychIntakeFormsByPatientId': getPsychIntakeFormsByPatientId,
            'getTheMostRecentPsychIntakeFormOrById': getTheMostRecentPsychIntakeFormOrById,
            'savePsychIntakeForm': savePsychIntakeForm,
            'downloadPsychIntakeFormById': downloadPsychIntakeFormById,
            'downloadPsychIntakes': downloadPsychIntakes,
            'getAgreementByPsychIntakeFormId': getAgreementByPsychIntakeFormId,
            'getNotCompleteForm': getNotCompleteForm
        };

        function convertLocalDateFromServerForWorkflow(workflow) {
            if(workflow && workflow.answer) {
                if(workflow.answer.dateOfInjury) {
                    workflow.answer.dateOfInjury = DateUtils.convertLocalDateFromServer(workflow.answer.dateOfInjury);
                }
                if(workflow.answer.lastDayWorked) {
                    workflow.answer.lastDayWorked = DateUtils.convertLocalDateFromServer(workflow.answer.lastDayWorked);
                }
                if(workflow.answer.datePersonalInjury) {
                    workflow.answer.datePersonalInjury = DateUtils.convertLocalDateFromServer(workflow.answer.datePersonalInjury);
                }
                if (workflow.answer.diagnostics) {
                    for(var i = 0 ; i < workflow.answer.diagnostics.length; i++) {
                         workflow.answer.diagnostics[i].dateOfExam = DateUtils.convertLocalDateFromServer(workflow.answer.diagnostics[i].dateOfExam);
                    }
                }
            }
        }

        function getPsychIntakeForm(formId) {
            var url = baseURL;
            return $http.get(baseURL, { params: { formId: formId }}).then(function (resp) {
                return resp.data;
            });
        };

        function viewWorkflow(formId) {
            var url = baseURL + '/workflow';
            return $http.get(url, { params: { formId: formId }}).then(function (resp) {
                convertLocalDateFromServerForWorkflow(resp.data);
                return resp.data;
            });
        };

        function submitWorkflow(workflow) {
	        if(workflow && workflow.answer) {
	            if(workflow.answer.dateOfInjury) {
	                workflow.answer.dateOfInjury = DateUtils.convertLocalDateToServer(workflow.answer.dateOfInjury);
	            }
	            if(workflow.answer.datePersonalInjury) {
	                workflow.answer.datePersonalInjury = DateUtils.convertLocalDateToServer(workflow.answer.datePersonalInjury);
	            }
	            if(workflow.answer.lastDayWorked) {
	                workflow.answer.lastDayWorked = DateUtils.convertLocalDateToServer(workflow.answer.lastDayWorked);
	            }
	            if (workflow.answer.diagnostics) {
	                for(var i = 0 ; i < workflow.answer.diagnostics.length; i++) {
	                    workflow.answer.diagnostics[i].dateOfExam = DateUtils.convertLocalDateToServer(workflow.answer.diagnostics[i].dateOfExam);
	                }
	            }
            }
            var submitSection = workflow.section.template;
            return $http.post(baseURL + '/workflow/submit-' + submitSection , workflow).then(function (resp) {
                convertLocalDateFromServerForWorkflow(resp.data);
                return resp.data;
            }, function errorCallback(response) {
                ClearLocalStorageService.clearWorkflow();
                ShowUnexpectedErrorDialogService.open(response, 'savePsychIntakeForm', null)
                    .result.then(function (result) {
                    $rootScope.$emit('ipmApp.httpError', response);
                });
                return response;
            });
        }

        function getPsychIntakeFormsByPatientId(id, pageable) {
            var url = baseURL + '/patient';
            return $http.get(url, {
                params: {
                    patientId: id,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).then(function (resp) {
                return resp.data;
            });
        }

        function savePsychIntakeForm(data) {
            var url = baseURL + '/create';
            return $http.post(url, data).then(function (resp) {
                return resp.data;
            });
        }
 
        function getTheMostRecentPsychIntakeFormOrById(psychIntakeFormId) {
            if (!psychIntakeFormId) {
                psychIntakeFormId = 0;
            }
            // if have psychIntakeFormId we will get by id, else we get by most recent
            var url = baseURL + '/most-recent' + '?psychIntakeFormId=' + psychIntakeFormId;
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function downloadPsychIntakeFormById(id) {
            var deferred = $q.defer();
            var url = baseURL + '/download/' + id;
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                var contentType = headers('content-type');
                var blob = new Blob([data], {type: contentType});
                DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                deferred.resolve(true);
            }).error(function (data, status, headers, config) {
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        function downloadPsychIntakes(fromDate, toDate) {
            var deferred = $q.defer();
            var url = baseURL + '/download-psych-intakes';
            $http({
                url: url,
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function getAgreementByPsychIntakeFormId() {
            var url = baseURL + '/agreement/get-agreement-workflow';
            return $http.get(url).then(function (resp) {
                convertLocalDateAgreementFromServer(resp.data);
                return resp;
            });
        };

        function getNotCompleteForm() {
            var url = baseURL + '/not-complete-form';
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function convertLocalDateAgreementFromServer(agreement) {
            if(agreement) {
                if (agreement.dateSigned) {
                    agreement.dateSigned = DateUtils.convertDateTimeFromServer(agreement.dateSigned);
                }
            }
        };
    	return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PsychIntakeController', PsychIntakeController);

        PsychIntakeController.$inject = ['$scope', '$state', '$timeout', '$translate', '$location', 'Auth', '$uibModal', '$window', 'psychIntake', 'ipmConstants'];

    function PsychIntakeController($scope, $state, $timeout, $translate, $location, Auth, $uibModal, $window, psychIntake, ipmConstants) {
        var vm = this;

        vm.psychIntake = psychIntake;
        vm.percent = 0;

        vm.init = function() {
            vm.percent = vm.getPercent();
        }

        vm.getLanguage = function() {
            return $translate.storage().get('NG_TRANSLATE_LANG_KEY');
        }

        vm.widthStyle = function() {
            vm.percent = vm.getPercent();
            if (vm.getPercent() > 0) {
                return { width: vm.getPercent() + '%' };
            } else {
                return { width: vm.getPercent() + '%', color: 'transparent' };
            }
        }

        vm.getPercent = function () {
        	if (vm.psychIntake.sectionIdsCompleted) {
                return Math.ceil((vm.psychIntake.sectionIdsCompleted.length / vm.psychIntake.totalSectionId) * 100);
            } else {
            	return 0;
            }
        }

        vm.init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('presentation-controls-instructor', {
                parent: 'entity',
                url: '/presentation-controls/{csId}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_QHP'],
                    pageTitle: 'ipmApp.patient.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/presentation-controls-instructor/presentation-controls-instructor.html',
                        controller: 'PresentationControlsInstructorController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('presentationControls');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    wellnessClass: ['$stateParams', 'WellnessClassService', function($stateParams, WellnessClassService) {
                        return WellnessClassService.findByClassSessionId($stateParams && $stateParams.csId ? $stateParams.csId : null);
                    }]
                }
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller(
            'PresentationControlsInstructorController',
            PresentationControlsInstructorController
        );

    PresentationControlsInstructorController.$inject = [
        '$scope',
        '$rootScope',
        'wellnessClass',
        'Deck',
        'ClearLocalStorageService',
        'ipmConstants',
        'PresentationViewPatientService',
        'WellnessClassService',
        '$state',
        '$uibModal',
        '$window'
    ];

    function PresentationControlsInstructorController(
        $scope,
        $rootScope,
        wellnessClass,
        Deck,
        ClearLocalStorageService,
        constants,
        PresentationViewPatientService,
        WellnessClassService,
        $state,
        $uibModal,
        $window
    ) {
        var vm = this;
        vm.wellnessClass = wellnessClass;
        vm.wellnessClassName = '';
        vm.deck = null;
        vm.currentSlideIndex = 0;
        vm.currentSlide = null;
        vm.pdfCurrentData = null;
        vm.backClick = backClick;
        vm.nextClick = nextClick;
        vm.startClick = startClick;
        vm.stopPresentingClick = stopPresentingClick;
        vm.finalizeClick = finalizeClick;
        vm.inValidBack = inValidBack;
        vm.inValidNext = inValidNext;
        vm.isLastSilde = isLastSilde;
        vm.isLoading = false;
        vm.onchangePdfBack = onchangePdfBack;
        vm.onchangePdfNext = onchangePdfNext;
        vm.onchangeZoomOut = onchangeZoomOut;
        vm.onchangeZoomIn = onchangeZoomIn;
        vm.onchangeGoToPage = onchangeGoToPage;
        vm.sendScrollPositionToPresentationView = sendScrollPositionToPresentationView;
        vm.classNotesData = '';
        vm.classNotesMouseleave = classNotesMouseleave;
        vm.classNotesMouseEnter = classNotesMouseEnter;
        vm.classNotesOpen = true;
        vm.dragOnchange = dragOnchange;
        vm.isReloadChangeListPatient = false;
        vm.isSavingDrapChange = false;
        vm.isShowingAbsentPatient= false;

        vm.init = function () {
            setWellnessClassName();
            if (wellnessClass && wellnessClass.id && wellnessClass.deckId) {
                getDeskById(wellnessClass.deckId);
                if (vm.wellnessClass.instructorPatientPresentation && vm.wellnessClass.instructorPatientPresentation.currentStep !== 'FINAL') {
                    openPresentationView();
                }
            }
        };

        function openPresentationView() {
            var pdfViewer = angular.element('.pdf-viewer');
            var viewerWidth = pdfViewer.width();
            PresentationViewPatientService.openPresentationView(
                vm.wellnessClass.id,
                viewerWidth
            );
            ClearLocalStorageService.setNameClassPresentationView(
                vm.wellnessClassName
            );
        }

        function setWellnessClassName() {
            if (wellnessClass) {
                vm.wellnessClassName =
                    wellnessClass.courseName +
                    ' - Session #' +
                    wellnessClass.sequence +
                    ': ' +
                    wellnessClass.name;
            }
        }

        function getDeskById(id) {
            Deck.get({
                id: id
            }, function (response) {
                vm.deck = response ? response : null;
                setCurrentSlide(vm.currentSlideIndex);
                if (vm.currentSlide && vm.currentSlide.id) {
                    setPdfCurrentDataBySlideId(vm.currentSlide.id);
                }
            });
        }

        function setCurrentSlide(index) {
            if (vm.deck.slides) {
                vm.currentSlide = getSlideByIndex(index);
            } else {
                vm.currentSlide = null;
            }
        }

        function getSlideByIndex(index) {
            if (vm.deck && vm.deck.slides) {
                return vm.deck.slides[index];
            }
        }

        function setPdfCurrentDataBySlideId(id) {
            Deck.downloadSlideBlobFile(id)
                .then(function (response) {
                    vm.pdfCurrentData = response ? response : null;
                    vm.isLoading = false;
                    onCurrentSlideWCChange();
                })
                .catch(function () {
                    vm.isLoading = false;
                });
        }

        function backClick() {
            vm.isLoading = true;
            if (vm.deck && vm.currentSlideIndex > 0) {
                vm.currentSlideIndex--;
                clearPdfViewConfig();
                setCurrentSlide(vm.currentSlideIndex);
                if (vm.currentSlide && vm.currentSlide.id) {
                    setPdfCurrentDataBySlideId(vm.currentSlide.id);
                }
            }
        }

        function nextClick() {
            vm.isLoading = true;
            if (vm.deck && vm.currentSlideIndex + 1 < vm.deck.numberOfSlides) {
                vm.currentSlideIndex++;
                clearPdfViewConfig();
                setCurrentSlide(vm.currentSlideIndex);
                if (vm.currentSlide && vm.currentSlide.id) {
                    setPdfCurrentDataBySlideId(vm.currentSlide.id);
                }
            }
        }

        function startClick() {
            vm.isLoading = true;
            // update currentStep to INPROGRESS
            vm.wellnessClass.instructorPatientPresentation.currentStep = 'INPROGRESS';
            WellnessClassService.updateInstructorPatientPresentation(vm.wellnessClass).then(function (response) {
                vm.isLoading = false;
            });
        }

        function stopPresentingClick() {
            $uibModal.open({
                templateUrl: 'app/presentation-controls-instructor/presentation-controls-instructor-final-dialog.html',
                controller:['$uibModalInstance','confirm', function($uibModalInstance,confirm) {
                    this.confirm = function() {
                        $uibModalInstance.close();
                        confirm();
                    }
                    this.clear = function (){
                        $uibModalInstance.dismiss('cancel');
                    }
                }],
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                resolve: {
                    confirm: function() {
                        return stopPresenting;
                    },
                }
            }).result.then(function() {
            }, function() {
            });
        }

        function stopPresenting() {
            vm.isLoading = true;
            // update currentStep to FINAL
            vm.wellnessClass.instructorPatientPresentation.currentStep = 'FINAL';
            WellnessClassService.updateInstructorPatientPresentation(vm.wellnessClass).then(function (response) {
                vm.isLoading = false;
                PresentationViewPatientService.closedPresentationView();
            });
        }

        function finalizeClick() {
            vm.isLoading = true;
            // update status to FINAL
            vm.wellnessClass.instructorPatientPresentation.currentStep = 'FINAL';
            vm.wellnessClass.instructorPatientPresentation.status = 'FINAL';
            WellnessClassService.updateInstructorPatientPresentation(vm.wellnessClass).then(function (response) {
                vm.isLoading = false;
                gotToWellnessClassList();
            });
        }

        function classNotesMouseleave() {
            if (vm.wellnessClass.instructorPatientPresentation.classNotes !== vm.classNotesData) {
                WellnessClassService.updateInstructorPatientPresentation(vm.wellnessClass).then(function (response) {
                });
            }
        }

        function classNotesMouseEnter() {
            vm.classNotesData = vm.wellnessClass.instructorPatientPresentation.classNotes;
        }

        function dragOnchange(patientPresentations) {
            if (patientPresentations) {
                vm.isSavingDrapChange = true;
                vm.wellnessClass.instructorPatientPresentation.patientPresentations = patientPresentations;
                WellnessClassService.updateInstructorPatientPresentation(vm.wellnessClass).then(function (response) {
                    vm.wellnessClass = response ? response : vm.wellnessClass;
                    vm.onChangeReloadPPList();
                    // disable patientPresentation watch update
                    $window.setTimeout(function () {
                        vm.isSavingDrapChange = false;
                    }, 300);
                });
            }
        }

        function inValidBack() {
            if (vm.currentSlideIndex > 0) {
                return false;
            }
            return true;
        }

        function inValidNext() {
            if (
                vm.deck &&
                vm.currentSlideIndex >= 0 &&
                vm.currentSlideIndex + 1 < vm.deck.numberOfSlides
            ) {
                return false;
            }
            return true;
        }

        function isLastSilde() {
            return inValidNext() === true;
        }

        function onchangePdfBack(currentPage) {
            ClearLocalStorageService.setCurrentPagePdfViewSlide(currentPage);
            PresentationViewPatientService.changeCurrentPage();
        }

        function onchangePdfNext(currentPage) {
            ClearLocalStorageService.setCurrentPagePdfViewSlide(currentPage);
            PresentationViewPatientService.changeCurrentPage();
        }

        function onchangeZoomIn(scaleZoom) {
            ClearLocalStorageService.setScaleZoomIn(scaleZoom);
            PresentationViewPatientService.zoomIn();
        }

        function onchangeZoomOut(scaleZoom) {
            ClearLocalStorageService.setScaleZoomOut(scaleZoom);
            PresentationViewPatientService.zoomOut();
        }

        function onchangeGoToPage(currentPage) {
            ClearLocalStorageService.setCurrentPagePdfViewSlide(currentPage);
            PresentationViewPatientService.changeCurrentPage();
        }

        function onCurrentSlideWCChange() {
            if (vm.currentSlide) {
                ClearLocalStorageService.setCurrentSlideWC(vm.currentSlide.id);
                PresentationViewPatientService.changePDFdata();
            }
        }

        vm.onChangeReloadPNPList = function onChangeReloadPNPList() {
            vm.isReloadChangeListPatient = !vm.isReloadChangeListPatient;
        };

        vm.onChangeReloadPPList = function onChangeReloadPPList() {
            vm.isReloadChangeListPatient = !vm.isReloadChangeListPatient;
        };

        function clearPdfViewConfig() {
            vm.pdfCurrentData = null;
            vm.currentSlide = 0;
            ClearLocalStorageService.clearCurrentPagePdfViewSlide();
            ClearLocalStorageService.clearScaleZoomIn();
        }

        function sendScrollPositionToPresentationView(position) {
            PresentationViewPatientService.sendScrollPosition({
                scrollPosition: position,
            });
        }

        function gotToWellnessClassList() {
            $state.go('wellness-class-list');
        }

        $scope.$on('$destroy', function () {
            ClearLocalStorageService.clearCurrentSlideWC();
            ClearLocalStorageService.clearNameClassPresentationView();
            clearPdfViewConfig();
        });

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ResendInvitationDialogController', ResendInvitationDialogController);

    ResendInvitationDialogController.$inject = ['$uibModalInstance'];

    function ResendInvitationDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.yes = function() {
            $uibModalInstance.close(true);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('patient-list', {
            parent: 'app',
            url: '/patient-list',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.patient.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/patient/patient-list.html',
                    controller: 'PatientListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('questionnaireStatusFilter');
                    $translatePartialLoader.addPart('questionnaireStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                supportedStatusFilter: ['NPQQuestionnaireService', function(NPQQuestionnaireService) {
                	return NPQQuestionnaireService.getSupportedStatusFilter();
                }]
            },
            params: {
            	searchPatientParamsInfo: null
            }
        })
        .state('patient-list.new', {
            parent: 'patient-list',
            url: '/new',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_BILLER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/patient/patient-dialog.html',
                    controller: 'PatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('patient');
                            $translatePartialLoader.addPart('surveyResultStatus');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('register');
                            $translatePartialLoader.addPart('user-management');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                id: null,
                                firstName: null, middleName: null, lastName: null,
                                email: null,
                                password: null,
                                phone: null,
                                patientIdCode: null,
                                sendRequest: true,
                                dateOfBirth: null,
                                providerId: null,
                                caseNo: null,
                                langKey: null,
                                createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, authorities: null
                            };
                        },
                        supportedDataList: ['Auth', function(Auth) {
                        	return Auth.getSupportedListRegister();
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-list', null, { reload: true });
                }, function() {
                    $state.go('patient-list');
                });
            }]
        })
        .state('patient-detail', {
            parent: 'patient-list',
            url: '/{id}',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.patient.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/patient/patient-detail.html',
                    controller: 'PatientDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('surveyResultStatus');
                    $translatePartialLoader.addPart('questionnaireStatus');
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('agreements');
                    $translatePartialLoader.addPart('classSessionRegistration');
                    $translatePartialLoader.addPart('carePlanReview');
                    $translatePartialLoader.addPart('carePlanReviewStatus');
                    $translatePartialLoader.addPart('downloadHaqEvaluation');
                    $translatePartialLoader.addPart('haqBatteryAdHoc');
                    $translatePartialLoader.addPart('adHocHAQStatus');
                    $translatePartialLoader.addPart('batteryTesting');
                    $translatePartialLoader.addPart('departmentType');
                    return $translate.refresh();
                }],
            },
            params: {
                searchSurveyResultParamsInfo: null,
            	searchPatientParamsInfo: null,
                type: null
            }
        }).state('appointment-new', {
                parent: 'patient-detail',
                url: '/new-appointment',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/patient/appointment/appointment-add-dialog.html',
                        controller: 'AppointmentAddDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('patient');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('appointment');
                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    id: null,
                                    dateOfAppointment: null,
                                    timeOfAppointment: null,
                                    active: true,
                                    officeId: null,
                                    providerId: null,
                                    patientId: $stateParams.id ? $stateParams.id : null
                                };
                            },
                            supportedDataList: ['Auth', function (Auth) {
                                return Auth.getSupportedListRegister();
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('appointment-edit', {
                parent: 'patient-detail',
                url: '/appointment/{appointmentId}/edit',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/patient/appointment/appointment-add-dialog.html',
                        controller: 'AppointmentAddDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('patient');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('appointment');
                                return $translate.refresh();
                            }],
                            entity: function (AppointmentService) {
                                return AppointmentService.findById($stateParams.appointmentId);
                            },
                            supportedDataList: ['Auth', function (Auth) {
                                return Auth.getSupportedListRegister();
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('appointment-delete', {
                parent: 'patient-detail',
                url: '/appointment/{appointmentId}/delete',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/patient/appointment/appointment-delete-dialog.html',
                        controller: 'AppointmentDeleteController',
                        controllerAs: 'vm',
                        size: 'sm',
                        windowClass: 'absolute-center',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('patient');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('appointment');
                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    appointmentId: $stateParams.appointmentId ? $stateParams.appointmentId : null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('appointment-create-questionnaire', {
                parent: 'patient-detail',
                url: '/appointment/{appointmentId}/create-questionnaire',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/patient/appointment/appointment-create-questionnaire.html',
                        controller: 'AppointmentCreateQuestionnaireController',
                        controllerAs: 'vm',
                        size: 'md',
                        windowClass: 'absolute-center',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('patient');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: function (AppointmentService) {
                                return AppointmentService.findById($stateParams.appointmentId);
                            }
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', { id: $stateParams.id }, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            }).state('course-add', {
            parent: 'patient-detail',
            url: '/course/add',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES] // ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/patient/wellness-class/class-session-registration-add-dialog.html',
                    controller: 'ClassSessionRegistrationAddDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('patient');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('classSessionRegistration');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                id: null,
                                course: {id: null},
                                classSession: null,
                                patientId: $stateParams.id ? $stateParams.id : null
                            };
                        },
                        courses: ['Course', function(Course) {
                            return Course.findAllCoursesRegistrationsByPatient($stateParams.id);
                        }],
                    }
                }).result.then(function () {
                    $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                }, function () {
                    $state.go('^');
                });
            }]
        }).state('course-delete', {
            parent: 'patient-detail',
            url: '/course/{csrId}/delete',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES] // ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/patient/wellness-class/class-session-registration-delete-dialog.html',
                    controller: 'ClassSessionRegistrationDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('patient');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('classSessionRegistration');
                            return $translate.refresh();
                        }],
                        entity: ['ClassSessionRegistrationService', function(ClassSessionRegistrationService) {
                            return ClassSessionRegistrationService.findById($stateParams.csrId ? $stateParams.csrId : null);
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('add-adhoc-testing', {
            parent: 'patient-detail',
            url: '/add-adhoc-testing',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/patient/adhoc-testing/adhoc-testing-add-dialog.html',
                    controller: 'AdHocTestingAddDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('patient');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('haqBatteryAdHoc');
                            return $translate.refresh();
                        }],
                        patientId: function () {
                            return $stateParams.id ? $stateParams.id : null;
                        },
                        entity: function () {
                            return {
                                id: null,
                                active: true,
                                surveyResult: null,
                                batteryTestId: null,
                                patientId: $stateParams.id ? $stateParams.id : null
                            };
                        }
                    }
                }).result.then(function () {
                    $state.go('patient-detail', {id: $stateParams.id}, {reload: true});
                }, function () {
                    $state.go('^');
                });
            }]
        }).state('adhoc-testing-delete', {
            parent: 'patient-detail',
            url: '/add-adhoc-testing/{haqBatteryAdHocId}/delete',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/patient/adhoc-testing/adhoc-testing-delete-dialog.html',
                    controller: 'AdhocTestingDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('patient');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('haqBatteryAdHoc');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                id: $stateParams.haqBatteryAdHocId ? $stateParams.haqBatteryAdHocId : null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('battery-testing-add', {
            parent: 'patient-detail',
            url: '/battery-testing/add',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/patient/battery-testing/battery-testing-add-dialog.html',
                    controller: 'BatteryTestingAddDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        patientId: function () {
                            return $stateParams.id ? $stateParams.id : null;
                        },
                        entity: function () {
                            return {
                                id: null,
                                department: null,
                                patientId: $stateParams.id ? $stateParams.id : null
                            };
                        }
                    }
                }).result.then(function () {
                    $state.go('patient-detail', {id: $stateParams.id}, {reload: true});
                }, function () {
                    $state.go('^');
                });
            }]
        }).state('battery-testing-delete', {
            parent: 'patient-detail',
            url: '/battery-testing/{surveyResultId}/delete',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/patient/battery-testing/battery-testing-delete-dialog.html',
                    controller: 'BatteryTestingDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: function () {
                            return {
                                id: $stateParams.surveyResultId ? $stateParams.surveyResultId : null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('agreements-send', {
            parent: 'patient-detail',
            url: '/agreements/send',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal' , '$window', function ($stateParams, $state, $uibModal, $window) {
                $uibModal.open({
                    templateUrl: 'app/patient/agreements/patient-agreements-send-dialog.html',
                    controller: 'PatientAgreementsSendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        patientId: function () {
                            return $stateParams.id ? $stateParams.id : null;
                        }
                    }
                }).result.then(function () {
                    $state.go('patient-detail', {id: $stateParams.id}, {reload: true});
                }, function (result) {
                    if (result && result.status !== undefined && result.status !== 200) {
                        $state.go('^').then(function () {
                            $window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                        });
                    } else {
                        $state.go('^');
                    }
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('PatientService', PatientService);

    PatientService.$inject = ['$q', 'halClient', '$http', 'DateUtils'];

    function PatientService ($q, halClient, $http, DateUtils) {
    	var baseUrl = 'api';

        var service = {
            'searchPatients': searchPatients,
            'searchCPRPatients': searchCPRPatients,
            'savePatient': savePatient,
            'get': get,
            'getPatientByIdAndAutoLogin': getPatientByIdAndAutoLogin,
            'searchPatientCase': searchPatientCase
        };


        function searchPatients(searchText, status, pageable) {
    		var deferred = $q.defer();

            var url = baseUrl + '/patients/search';
            $http.get(url, {
				params: {
                    searchText: (searchText ? encodeURIComponent(searchText) : ''),
                    status: status,
					page: pageable.page,
					size: pageable.size,
					sort: pageable.sort
				}
			})
    		.success(function(data) {
    			deferred.resolve(data);
    		})
    		.error(function(error) {
    			deferred.reject(error);
    		});

    		return deferred.promise;
        };

        function searchCPRPatients(searchText, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/patients/cpr/search';
            $http.get(url, {
                params: {
                    query: (searchText ? encodeURIComponent(searchText) : ''),
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            })
                .success(function(data) {
                    deferred.resolve(data);
                })
                .error(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function get(id) {
            var deferred = $q.defer();
        	var url = baseUrl + '/patients/' + id;
        	halClient.$get(url).then(function success(result) {
        		deferred.resolve(result);
    		}, function error(e) {
    			deferred.reject(error);
    		});
        	return deferred.promise;
        };

        function savePatient(patientQuestionnaireDTO) {
            var url = baseUrl + '/patients/create';
            if(patientQuestionnaireDTO.dateOfBirth) {
                patientQuestionnaireDTO.dateOfBirth = DateUtils.convertLocalDateToServer(patientQuestionnaireDTO.dateOfBirth);
            }
            return $http.post(url, patientQuestionnaireDTO).then(function (resp) {
                return resp.data;
            });
        }

        function getPatientByIdAndAutoLogin(id, surveyResultId) {
            var deferred = $q.defer();

            var url = baseUrl + '/patients/get-patient-and-auto-login/' + id;
            $http.get(url,
                {
                    params: {surveyResultId: surveyResultId}
                })
                .success(function (data) {
                    deferred.resolve(data);
                })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
         * searchPatientCase
         * testFlag = true only get haqTestServiceExclusion = false
         * @param patientId
         * @param searchText
         * @param testFlag
         * @param pageable
         * @return {*}
         */
        function searchPatientCase(patientId, searchText, testFlag, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/patients/search-patient-case';
            $http.get(url, {
                params: {
                    query: (searchText ? encodeURIComponent(searchText) : ''),
                    patientId: patientId,
                    testFlag: testFlag,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            })
                .success(function(data) {
                    deferred.resolve(data);
                })
                .error(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientListController', PatientListController);

        PatientListController.$inject = ['$scope', '$state', 'PatientService', '$localStorage' , 'supportedStatusFilter', '$stateParams', '$window', 'Principal', 'ipmConstants'];

    function PatientListController ($scope, $state, PatientService, $localStorage, supportedStatusFilter, $stateParams, $window, Principal, constants) {
    	var vm = this;
        vm.patients = [];
        vm.statuses = supportedStatusFilter.statuses;
        vm.status = null;
        vm.query = null;
        vm.page = 1;
        vm.totalItems = 0;
        vm.predicate = 'p.user.firstName';
        vm.reverse = false;
        vm.pageSize = 15;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.isBiller = false;

        getAccount(true);

        function getAccount(force) {
            Principal.identity(force).then(function(res) {
                vm.account = res;
                vm.isBiller = Principal.hasAnyAuthority([constants.ROLE_BILLER]);
            });
        }

        function loadAll() {
        	var pageable = {page: vm.page > 0 ? vm.page - 1 : vm.page,
    						size: vm.pageSize,
                            sort: sort()};

            PatientService.searchPatients(vm.searchQuery, vm.status, pageable).then( function(response) {
            	if (response.content !== undefined) {
	        		vm.patients = response.content;
				} else {
					vm.patients = [];
				}

                vm.totalItems =  response.totalElements;
                vm.totalElements =  response.page ? response.page.totalElements : 0;
            });

        };

        function init() {
        	var paramsInfo = $stateParams.searchPatientParamsInfo;
        	if(paramsInfo) {
        		vm.status = paramsInfo.status;
        		vm.searchQuery = paramsInfo.searchQuery;
        		vm.page = paramsInfo.page;
        		vm.totalItems = paramsInfo.totalItems;
        		vm.pageSize = paramsInfo.pageSize;
        		vm.predicate = paramsInfo.predicate;
        		vm.reverse = paramsInfo.reverse;
        	}
        	vm.loadAll();
        }

        vm.goToPatientDetails = function(id) {
        	var paramsInfo = getSearchPatientParamsInfo();
        	$state.go('patient-detail', {id: id, searchPatientParamsInfo: paramsInfo});
        }

        function getSearchPatientParamsInfo() {
        	var paramsInfo = {
        		status: vm.status,
        		searchQuery: vm.searchQuery,
            	page: vm.page,
            	totalItems: vm.totalItems,
            	pageSize: vm.pageSize,
            	predicate: vm.predicate,
            	reverse: vm.reverse
        	}

        	return paramsInfo;
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        vm.search = function () {
            vm.page = 0;
            vm.predicate = 'p.user.firstName';
            vm.reverse = false;
            vm.loadAll();
        };

        vm.clear = function () {
            vm.patients = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'p.user.firstName';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.loadAll();
        };

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientDialogController',PatientDialogController);

    PatientDialogController.$inject = ['$stateParams', '$uibModalInstance', '$translate','PatientService', 'Auth', 'entity', 'supportedDataList', 'ipmConstants', 'Principal'];

    function PatientDialogController ($stateParams, $uibModalInstance, $translate, PatientService, Auth, entity, supportedDataList, constants, Principal) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_STAFF', 'ROLE_PATIENT', 'ROLE_MANAGER'];
        vm.clear = clear;
        vm.save = save;
        vm.disabledRole = null;
        vm.patient = entity;
        vm.errorEmailExists = null;
        vm.errorPatientCodeIdexists = null;
        vm.birthdayInvalid = null;
        vm.error = null;
        vm.patient.langKey = null;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfBirth = false;
        vm.maxDate = new Date();
        vm.account = null;
        vm.patientCases = [];
        vm.patientCaseIdsRemove = [];

        getAccount(false);

        function getAccount(force) {
            Principal.identity(force).then(function(res) {
                vm.account = res;
                updateAllowActionPatientCase();
            });
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function clear () {
            clearData();
            $uibModalInstance.dismiss('cancel');
        }

        function clearData() {
            vm.patient.phone = null;
            vm.patient.firstName = null;
            vm.patient.middleName = null;
            vm.patient.lastName = null;
            vm.patient.patientIdCode = null;
            vm.patient.password = null;
            vm.patient.email = null;
            vm.patient.phone = null;
            vm.patient.dateOfBirth = null;
            vm.patient.caseNo = null;
            vm.patient.ignoreSendSms = false;
            vm.patient.ignoreSendEmail = null;
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        vm.requirePhoneAndEmail = function() {
            return !vm.patient.phone && !vm.patient.email;
        }

        function onSaveError (error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if(error.status === 400 ) {
            	if (errorMessage === 'e-mail address already in use'){
            		vm.errorEmailExists = 'ERROR';
            	} else if (errorMessage === 'patientID already in use') {
            		vm.errorPatientCodeIdexists = 'ERROR';
            	} else {
            		vm.error = 'ERROR';
            	}
            }
        }

        function init() {
            vm.patient.sendRequest = true;
        }

        init();

        function save () {
        	vm.errorEmailExists = null;
            vm.errorPatientCodeIdexists = null;
            vm.error = null;
        	vm.birthdayInvalid = null;

            vm.isSaving = true;
            var currentDate = new Date();
            vm.patient.langKey = $translate.use();
            if(vm.patient.dateOfBirth > currentDate) {
                vm.birthdayInvalid = 'ERROR';
                vm.isSaving = false;
                return;
            }
            if (!vm.patient.id) {
                vm.patient.patientCases = vm.patientCases ? vm.patientCases : [];
                PatientService.savePatient(vm.patient).then(function(res) {
                    onSaveSuccess(res);
                    clearData();
                }, function errorSave(error) {
                    onSaveError(error);
                });
            }
        }

        function updateAllowActionPatientCase() {
            vm.isAllowActionPatientCase = vm.account && vm.account.authorities.indexOf('ROLE_ADMIN') !== -1;
        }

        vm.checkUpdateBillablePatientCase = function () {
            if (vm.account && vm.account.authorities) {
                var allowedRoles = [constants.ROLE_ADMIN, constants.ROLE_MANAGER, constants.ROLE_BILLER];
                var hasAllowedRole = _.some(vm.account.authorities, function (role) {
                    return _.includes(allowedRoles, role);
                });
                return !hasAllowedRole;
            }
            return true;
        };

        vm.changeIgnoreEmail = function() {
            vm.patient.ignoreSendEmail = vm.patient.ignoreSendEmail ? false : true;
        }

        vm.changeIgnoreSendSms = function() {
            vm.patient.ignoreSendSms = vm.patient.ignoreSendSms ? false : true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientDetailController', PatientDetailController);

        PatientDetailController.$inject = ['$state','$stateParams', '$uibModal', 'PatientService', 'SurveyResultService','NPQQuestionnaireService','$window', 'Principal','ipmConstants', 'InvitationService', 'PsychIntakeService'];

    function PatientDetailController ($state, $stateParams, $uibModal, PatientService, SurveyResultService, NPQQuestionnaireService, $window, Principal, constants, InvitationService, PsychIntakeService) {
        var vm = this;
        vm.load = load;
        vm.isPatient = null;
        vm.patient = null;
        vm.id = null;

        vm.pageSize = 6;
        vm.totalItems = 0;
        vm.page = 1;

        vm.predicate = 'id';
        vm.reverse = true;
        vm.predicateQn = 'dateRequested';
        vm.surveyResult = null;
        vm.surveyResults = [];
        vm.mostRecentHAQ = null;
        vm.questionnaires = [];
        vm.psychIntakeForms = [];
        vm.loadAllResults = loadAllResults;
        vm.loadQuestionnaires = loadQuestionnaires;
        vm.loadPsychIntakeForms = loadPsychIntakeForms;
        vm.notAllowCreateQuestionnaire = false;
        vm.notAllowCreatePsychIntakeForm = false;
        vm.isManager = false;
        vm.isBiller = false;
        vm.isSendingInvitation = false;
        vm.checkPermission = checkPermission;
        vm.hideWellnessClasses = constants.HIDE_WELLNESS_CLASSES;
        vm.disableStartHAQ = true; // [ClickUp] - Disable buttons Launch HAQ and Resend HAQ on the Patient Details page

        vm.checkDisableLaunchResendHAQ = checkDisableLaunchResendHAQ;

        init();

        getAccount(true);

        function getAccount(force) {
            Principal.identity(force).then(function(res) {
                vm.account = res;
                vm.isManager = Principal.hasAnyAuthority([constants.ROLE_MANAGER, constants.ROLE_ADMIN]);
                vm.isBiller = Principal.hasAnyAuthority([constants.ROLE_BILLER]);
            });
       }

        function load (id) {
            PatientService.get(id).then( function(response) {
            	if (response !== undefined) {
                    vm.patient = response;
				} else {
					vm.patient = null;
				}
            }).catch(function (error) {
                // IPMproject-577: Duplicate CPR bug -  hide deactivated user
                // IPMproject-B1947: Patient details page should not show when accessing by URL with deactivated patient id
                $state.go('error');
            });
        }

        function init() {
            vm.id = $stateParams.id;
            vm.load(vm.id);
            vm.pageableQn = {
                page: 1,
                size: 6,
                totalItems: 0
            }
            loadAllResults();
            loadQuestionnaires();
            loadPsychIntakeForms();
        }

        function loadAllResults() {
        	var pageable = {page: vm.page > 0 ? vm.page - 1 : vm.page,
					size: vm.pageSize,
					sort: sort()};

        	SurveyResultService.findByPatientPaganition($stateParams.id, constants.SURVEY_RESULT_TYPE_DEFAULT, pageable).then( function(response) {
        		vm.totalItems =  response.totalElements;
        		if (response.content !== undefined) {
		    		vm.surveyResults = response.content;
		    		// filterMostRecentHAQ
                    filterMostRecentHAQ(vm.surveyResults);
				} else {
					vm.surveyResults = [];
				}
		    });
        }

        function loadQuestionnaires() {
        	var pageable = {
                    page: vm.pageableQn.page > 0 ? vm.pageableQn.page - 1 : vm.pageableQn.page,
					size: vm.pageSize,
                    sort: sortQn()
                };

                NPQQuestionnaireService.getNPQQuestionnaireByPatientId($stateParams.id, pageable).then( function(response) {
                vm.pageableQn.totalItems = response.totalElements;
        		if (response.content !== undefined) {
		    		vm.questionnaires = response.content;
				} else {
					vm.questionnaires = [];
				}
		    });
        }

        function loadPsychIntakeForms() {
        	var pageable = {
                    page: vm.pageableQn.page > 0 ? vm.pageableQn.page - 1 : vm.pageableQn.page,
					size: vm.pageSize,
                    sort: sortQn()
                };

                PsychIntakeService.getPsychIntakeFormsByPatientId($stateParams.id, pageable).then( function(response) {
                vm.pageableQn.totalItems = response.totalElements;
        		if (response.content !== undefined) {
		    		vm.psychIntakeForms = response.content;
				} else {
					vm.psychIntakeForms = [];
				}
		    });
        }

        function sortQn() {
            return [vm.predicateQn + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        vm.getDisposition = function() {
        	return vm.surveyResult.disposition;
        }

        function sort() {
            if (vm.predicate === 'battery.id') {
                return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            }
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        vm.getIndex = function(index) {
        	var result = (index + 1) + (vm.page - 1)*vm.pageSize;
        	return result;
        }

        vm.downloadQuestionnaire = function(id) {
            NPQQuestionnaireService.downloadQuestionnaireById(id).then(function(res) {
                vm.isProcessing = false;
                loadQuestionnaires();
            });
        }

        vm.downloadPsychIntakeForm = function(id) {
            PsychIntakeService.downloadPsychIntakeFormById(id).then(function(res) {
                vm.isProcessing = false;
                loadPsychIntakeForms();
            });
        }

        vm.createNpqOrPsych = function(type) {
            vm.notAllowCreatePsychIntakeForm = false;
            $uibModal.open({
                templateUrl: 'app/patient/create-npq-or-psych-dialog.html',
                controller: 'CreateNpqOrPsychDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            caseNo: null,
                            patientId: null,
                            active: true
                        };
                    },
                    requestType: function () {
                        return type;
                    }
                },
                params: {
                    errorQn: null
                }
            }).result.then(function(result) {
				var reload = true;
                if (result.requestType === 'NPQ'){
					if (result.notAllowCreate === true){
	                    vm.notAllowCreateQuestionnaire = true;
	                    reload = false;
	                }
                    // loadQuestionnaires();
                } else if (result.requestType === 'PSYCH'){
					if (result.notAllowCreate === true){
	                    vm.notAllowCreatePsychIntakeForm = true;
	                    reload = false;
	                }
	                // loadPsychIntakeForms();
				}
				if (reload) {
				    $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
				}
            }, function() {
            });
        }

        vm.openAccountEdit = function() {
            if (vm.patient && vm.patient.userId) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('user-management');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                userId: vm.patient.userId
                            };
                        },
                        action: function() { return "PATIENT_DETAIL";},
                        supportedDataList: ['Auth', function(Auth) {
                            return Auth.getSupportedListRegister();
                        }],
                        patientCases: ['User', function (User) {
                            return User.getAllPatientCaseByUserId( vm.patient.userId);
                        }]
                    },
                    params: {
                        errorQn: null
                    }
                }).result.then(function(result) {
                    vm.load(vm.patient.id);
                    vm.loadAllResults();
                }, function() {
                });
            }
        }
        vm.backToList = function() {
        	var paramsInfo = $stateParams.searchPatientParamsInfo;
            var surveyResultParamsInfo = $stateParams.searchSurveyResultParamsInfo;
            var _typeSearch = $stateParams.type;

            // search type = haq
            if (paramsInfo && _typeSearch && _typeSearch === constants.SEARCH_TYPE_HAQ) {
                $state.go('survey-result-list', {searchSurveyResultParamsInfo: surveyResultParamsInfo});
            } else if (paramsInfo) {
                $state.go('patient-list', {searchPatientParamsInfo: paramsInfo});
            } else {
                // $window.history.back();
                $state.go('patient-list');
            }
        }

        vm.goToAppointmentAddDialog = function() {
            $state.go('appointment-new', {id: vm.patient.id});
        }

        function filterMostRecentHAQ(surveyResults) {
            if ((!surveyResults && !(surveyResults.length > 0)) || vm.page != 1) {
                return vm.mostRecentHAQ = null;
            }
            var surveyResultsOrder = _.orderBy(_.filter(surveyResults, function (sr) {
                return sr.status === 'NOT_STARTED' || sr.status === 'STARTED' || sr.status === 'INCOMPLETE' || sr.status === 'NO_RESULT';
            }), ['id'], ['desc']);
            return vm.mostRecentHAQ = surveyResultsOrder && surveyResultsOrder.length > 0 ? surveyResultsOrder[0] : null;
        }

        vm.goToHAQBattery = function ($event, surveyResult) {
            if (vm.disableStartHAQ) {
                return;
            }
            $event.preventDefault();
            if (surveyResult && surveyResult.patientCase && surveyResult.patientCase.billableConfig && surveyResult.patientCase.billableConfig.haqTestServiceExclusion) {
                openWarningHAQExcluded();
                return;
            }
            if (checkDisableLaunchResendHAQ(surveyResult)) {
                return;
            }
            if (surveyResult && surveyResult.id && surveyResult.patientId) {
                if (surveyResult && surveyResult.caseSelected) {
                    lunchHAQPatientAutoLogin(surveyResult);
                } else {
                    openInputPatientCase(surveyResult, surveyResult.patientId);
                }
                // lunchHAQPatientAutoLogin(surveyResult);
                // PatientService.getPatientByIdAndAutoLogin(surveyResult.patientId, surveyResult.id).then(function (res) {
                //     $window.localStorage.setItem(constants.SURVEY_RESULT_ID, surveyResult.id);
                //     $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                //     $state.go('home');
                // });
                //
            }
        };

        function lunchHAQPatientAutoLogin(surveyResult) {
            PatientService.getPatientByIdAndAutoLogin(surveyResult.patientId, surveyResult.id).then(function (res) {
                $window.localStorage.setItem(constants.SURVEY_RESULT_ID, surveyResult.id);
                $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                $window.localStorage.setItem(constants.LAUNCH_FROM, constants.HAQ);
                $state.go('home');
            });
        }

        function openInputPatientCase(surveyResult, patientId) {
            openDialogInputPatientCase(surveyResult, patientId);
        }

        function openWarningHAQExcluded() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.patient.patientCase.haqExcluded"},
                    title: function () {return "ipmApp.patient.patientCase.warning"}
                }
            }).result.then(function() {
            });
        }

        function openDialogInputPatientCase(surveyResult, patientId) {
            $uibModal.open({
                templateUrl: 'app/patient/input-patient-case-dialog/input-patient-case-dialog.html',
                controller: 'InputPatientCaseDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    patientId: function () {
                        return patientId;
                    },
                    surveyResultId: function () {
                        return surveyResult.id;
                    }
                }
            }).result.then(function (result) {
                if (result && result.data && result.data.id) { // sure save surveyResult
                    lunchHAQPatientAutoLogin(surveyResult);
                }
            }, function () {
            });
        }

        vm.goToNPQ = function ($event, questionnair) {
            $event.preventDefault();
            if (questionnair && questionnair.id && questionnair.patientId) {
                PatientService.getPatientByIdAndAutoLogin(questionnair.patientId, null).then(function (res) {
                    $window.localStorage.setItem(constants.NPQ_QUESTIONNAIRE_ID, questionnair.id);
                    $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                    $state.go('home');
                });
            }
        }

        vm.goToPsychIntakeForm = function ($event, psychIntakeForm) {
        	$event.preventDefault();
            if (psychIntakeForm && psychIntakeForm.id && psychIntakeForm.patientId) {
                PatientService.getPatientByIdAndAutoLogin(psychIntakeForm.patientId, null).then(function (res) {
                	$window.localStorage.setItem(constants.PSYCH_INTAKE_FORM_ID, psychIntakeForm.id);
                    $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                    $state.go('home');
                });
            }
        }

        vm.resendHAQ = function(sr) {
            if (vm.isSendingInvitation === true || checkDisableLaunchResendHAQ(sr) || vm.disableStartHAQ) {
                return;
            }
            var surveyResultId = sr.id;

            vm.isSendingInvitation = true;
        	InvitationService.resendHAQ(surveyResultId).then(function (res) {
        	    vm.isSendingInvitation = false;
			    if (res.statusCode === 200) {
				    _.forEach(vm.surveyResults, function(s) {
	                    if (s.id === surveyResultId && s.status === 'INCOMPLETE') {
	                        s.status = 'STARTED';
	                    } else if (s.id === surveyResultId && s.status === 'NO_RESULT') {
	                        s.status = 'NOT_STARTED';
	                    }
	                });
                    InvitationService.openResendInvitationDialog();
			    } else if (res.statusCode === 400 && res.message === 'missing_email_phone') {
                    InvitationService.openWarningMissingEmailPhone();
			    }
            });
        }

        vm.resendNPQ = function(nPQQuestionnaireId) {
            if (vm.isSendingInvitation === true) {
                return;
            }
            vm.isSendingInvitation = true;
        	InvitationService.resendNPQ(nPQQuestionnaireId).then(function (res) {
                vm.isSendingInvitation = false;
                if (res.statusCode === 200) {
                    InvitationService.openResendInvitationDialog();
                } else if (res.statusCode === 400 && res.message === 'missing_email_phone') {
                    InvitationService.openWarningMissingEmailPhone();
			    }

            });
        }

        vm.resendPsychIntakeForm = function(formId) {
            if (vm.isSendingInvitation === true) {
                return;
            }
            vm.isSendingInvitation = true;
        	InvitationService.resendPsychIntakeForm(formId).then(function (res) {
                vm.isSendingInvitation = false;
                if (res.statusCode === 200) {
                    InvitationService.openResendInvitationDialog();
                } else if (res.statusCode === 400 && res.message === 'missing_email_phone') {
                    InvitationService.openWarningMissingEmailPhone();
			    }

            });
        }

        vm.openNotificationHistory = function (patientId) {
            if (patientId) {
                $state.go('notification-history', {patientId: patientId});
            }
        };

        function checkPermission() {
            return vm.account && vm.account.authorities && (vm.account.authorities.indexOf('ROLE_STAFF') !== -1
                || vm.account.authorities.indexOf('ROLE_MANAGER') !== -1
                || vm.account.authorities.indexOf('ROLE_ADMIN') !== -1
                || vm.account.authorities.indexOf('ROLE_BILLER') !== -1)
        }

        function checkDisableLaunchResendHAQ(sr) {
            return (sr && sr.patientCase && sr.patientCase.billableConfig && sr.patientCase.billableConfig.haqTestServiceExclusion) || vm.isBiller;
        }

        vm.getCaseNoNPQ = function (npq) {
            return npq.patientCase ? npq.patientCase.caseNumber : npq.caseNo;
        };
    }
})();
;

(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CreateNpqOrPsychDialogController', CreateNpqOrPsychDialogController);

    CreateNpqOrPsychDialogController.$inject = ['$stateParams', 'ipmConstants', '$uibModalInstance','entity', 'requestType', 'PsychIntakeService', 'NPQQuestionnaireService', 'PatientService', 'PatientAgreementsService', 'HaqsBatteryService', '$q', 'AlertService'];

    function CreateNpqOrPsychDialogController($stateParams, constants, $uibModalInstance, entity, requestType, PsychIntakeService, NPQQuestionnaireService, PatientService, PatientAgreementsService, HaqsBatteryService, $q, AlertService) {
        var vm = this;

        vm.type = requestType;
        vm.requestEntity = entity;
        vm.requestEntity.patientId = null;
        vm.isSaving = false;
        vm.patientCases = [];
        vm.patientCaseSelect = null;
        vm.patientCaseNoCaseNumber = {id: null, caseNumber: "No Case Number"};
        vm.predicate = 'id';
        vm.pageSize = 20;
        vm.patientId = $stateParams.id;

        vm.clear = clear;
        vm.clearSelectedCase = clearSelectedCase;
        vm.save = save;
        vm.searchPatientCase = searchPatientCase;
        vm.agreements = [];
        vm.agreementSeleted = null;
        vm.invalidAgreementCount = 0;
        vm.batteries = [];
        vm.batterySeleted = null;
        vm.isInvalidBattery = false;

        init();

        function init() {
			searchPatientCase();
            getAgreements();
            getBatteries();
        }

        function getAgreements() {
            vm.isLoading = true;
            PatientAgreementsService.getAllAgreementForSelect(vm.patientId, constants.SEND_NEW_AGREEMENT).then(function (response) {
                vm.agreements = response ? response : [];
                defaultSelectedAgreements();
                vm.isLoading = false;
            });
        }

        function getBatteries() {
            vm.isLoading = true;

            HaqsBatteryService.getAllBatteryForSelect(constants.DROPDOWN_BATTERIES_TYPE, vm.patientId).then(function (response) {
                vm.batteries = response ? response : [];
                vm.isLoading = false;
            });
        }

        function defaultSelectedAgreements() {
			vm.agreementSeleted = _.filter(vm.agreements, function(o) { return o.isDefault });
			checkSelectedAgreements();
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function clearSelectedCase () {
            vm.patientCaseSelect = null;
            defaultSelectedAgreements();
            vm.batterySeleted = null;
        }

        function save(){
			vm.requestEntity.patientId = $stateParams.id;
            vm.requestEntity.patientCase = vm.patientCaseSelect ? vm.patientCaseSelect : null;

			if (vm.isSaving || !vm.requestEntity.patientId || !vm.requestEntity.patientCase) {
                return;
            }
            vm.isSaving = true;

            vm.requestEntity.agreements = vm.agreementSeleted ? vm.agreementSeleted : null;
            vm.requestEntity.batteries = vm.batterySeleted ? vm.batterySeleted : null;

            if (vm.type === 'PSYCH') {
                PsychIntakeService.savePsychIntakeForm(vm.requestEntity).then(function(res) {
                    onSaveSuccess(res);
                }, function errorSave(error) {
                    onSaveError(error);
                });
            } else if (vm.type === 'NPQ') {
				NPQQuestionnaireService.saveNPQQuestionnaire(vm.requestEntity).then(function(res) {
                    onSaveSuccess(res);
                }, function errorSave(error) {
                    onSaveError(error);
                });
		    }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close({requestType: vm.type});
        }

        function onSaveError (error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if(error.status === 400 ) {
                if (errorMessage === 'notAllowCreateQuestionnaire' || errorMessage === 'notAllowCreatePsychIntakeForm'){
                    $uibModalInstance.close({requestType: vm.type, notAllowCreate:true});
                }
            } else if (error.status !== 200) {
                if (vm.type === 'PSYCH') {
                    AlertService.error("An error occurred while creating the Psych Intake Form. Please try again");
                } else if (vm.type === 'NPQ') {
                    AlertService.error("An error occurred while creating the New Patient Questionnaires. Please try again");
                }
               $uibModalInstance.dismiss(error);
           }
        }

        function sort() {
            var result = [vm.predicate + ',desc'];
            return result;
        }

        function searchPatientCase($item) {
            vm.searchText = $item ? $item : '';
            var pageable = {
                page: 0,
                size: vm.pageSize,
                sort: sort()
            };
            return $q(function (resolve, reject) {
                PatientService.searchPatientCase(vm.patientId, vm.searchText, false, pageable)
                    .then(function (response) {
                        if (response && response.length > 0) {
                            resolve(response);
                            vm.patientCases = response;
                            vm.patientCases.unshift(vm.patientCaseNoCaseNumber);
                        } else {
                            vm.patientCases.push(vm.patientCaseNoCaseNumber);
                            resolve([]);
                        }
                    }, function () {
                        reject([]);
                    });
            });
        }

        vm.checkDisableSave = function () {
            return !vm.patientCaseSelect || !vm.patientCaseSelect.caseNumber;
        };

        vm.searchTextOnChange = function () {
        };

        vm.notYetSelectedCase = function () {
            return !vm.patientCaseSelect || !vm.patientCaseSelect.caseNumber;
        };

        vm.selectBatteriesOnChange = function () {
			if (!vm.batterySeleted || vm.batterySeleted.length === 0) {
		        vm.isInvalidBattery = false;
		        return;
		    }
		    var hasInvalid = vm.batterySeleted.some(function (battery) {
		        return battery.batteryTestCnt < 1;
		    });
		    vm.isInvalidBattery = hasInvalid;
        };

        vm.selectAgreementsOnChange = function () {
			checkSelectedAgreements();
        }

        function checkSelectedAgreements() {
			if (!vm.agreementSeleted || vm.agreementSeleted.length === 0) {
		        vm.invalidAgreementCount = 0;
		        return;
		    }
            vm.invalidAgreementCount = vm.agreementSeleted.filter(function (agreement) {
                return agreement.existedAndAllCompleted === true;
            }).length;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('npq-questionnaire', {
                abstract: true,
                parent: 'app',
                url: '/npq-questionnaire',
                data: {
                    authorities: [],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/npq-questionnaire/npq-questionnaire.html',
                        controller: 'NPQQuestionnaireController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('npqWorkflowDemographics');
                        $translatePartialLoader.addPart('npqWorkflowWorkRelatedInjuries');
                        $translatePartialLoader.addPart('npqWorkflowInjuryDetails');
                        $translatePartialLoader.addPart('npqWorkflowDiagnosticStudies');
                        $translatePartialLoader.addPart('npqWorkflowPresentComplaints');
                        $translatePartialLoader.addPart('npqWorkflowTreatmentHistory');
                        $translatePartialLoader.addPart('npqWorkflowPastMedicalHistory');
                        $translatePartialLoader.addPart('npqWorkflowSocialHistory');
                        $translatePartialLoader.addPart('npqWorkflowAllergies');
                        $translatePartialLoader.addPart('npqWorkflowMedications');
                        $translatePartialLoader.addPart('npqWorkflowCurrentIndications');
                        $translatePartialLoader.addPart('npqWorkflowReviewOfSystems');
                        $translatePartialLoader.addPart('npqWorkflowPastMedicalHistoryFinish');
                        $translatePartialLoader.addPart('npqWorkflowPersonalInjury');
                        $translatePartialLoader.addPart('npqQuestionnaire');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    npqQuestionnaire: ['NPQQuestionnaireService', '$window', 'ipmConstants', function(NPQQuestionnaireService, $window, constants) {
                        var id = $window.localStorage.getItem(constants.NPQ_QUESTIONNAIRE_ID);
                        return NPQQuestionnaireService.getNPQQuestionnaire(id);
                    }],
                    masterData: ['NPQQuestionnaireService', function(NPQQuestionnaireService) {
                        return NPQQuestionnaireService.getMasterData();
                    }]
                }
            }).state('npq-questionnaire.workflow', {
                parent: 'npq-questionnaire',
                url: '/workflow',
                data: {
                    authorities: [],
                    pageTitle: ''
                },
                views: {
                    'workflow-view@npq-questionnaire': {
                        templateUrl: 'app/npq-questionnaire/workflow/workflow.html',
                        controller: 'NPQQuestionnaireWorkflowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    agreement: ['$state', '$q', 'AgreementsWorkflowService', function ($state, $q, AgreementsWorkflowService) {
                        var deferred = $q.defer();
                        AgreementsWorkflowService.getCurrentAgreementWorkflow(null).then(function (res) {
                            if (res && !res.isFinishAllAgreement) {
                                $state.go('agreements-workflow');
                            } else {
                                deferred.resolve(res);
                            }
                        });
                        return deferred.promise;
                    }],
                    dataWorkflow: ['$state', 'npqQuestionnaire', 'NPQQuestionnaireService', function($state, npqQuestionnaire, NPQQuestionnaireService) {
                        if(npqQuestionnaire.id) {
                            return NPQQuestionnaireService.viewWorkflow(npqQuestionnaire.id);
                        } else {
                            return $state.go('home');
                        }
                    }]
                }
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('NPQQuestionnaireService', NPQQuestionnaireService);

        NPQQuestionnaireService.$inject = ['$http', '$resource', '$q', 'halClient', '$state', 'Auth', '$uibModal', 'DateUtils', 'DownloadBlobService', 'ShowUnexpectedErrorDialogService', '$rootScope', 'ClearLocalStorageService'];

    function NPQQuestionnaireService ($http, $resource, $q, halClient, $state, Auth, $uibModal, DateUtils, DownloadBlobService, ShowUnexpectedErrorDialogService, $rootScope, ClearLocalStorageService) {
        var baseURL = 'api';

    	var service = {
            'getNPQQuestionnaire': getNPQQuestionnaire,
            'getMasterData': getMasterData,
            'viewWorkflow': viewWorkflow,
            'submitWorkflow': submitWorkflow,
            'getNPQQuestionnaireByPatientId': getNPQQuestionnaireByPatientId,
            'saveNPQQuestionnaire': saveNPQQuestionnaire,
            'downloadQuestionnaire': downloadQuestionnaire,
            'downloadQuestionnaireById': downloadQuestionnaireById,
            'getSupportedStatusFilter': getSupportedStatusFilter,
            'getTheMostRecentNPQQuestionnaireOrById': getTheMostRecentNPQQuestionnaireOrById,
            'resumeNPQQuestionnaire': resumeNPQQuestionnaire,
            'getAllNPQQuestionnaireNotComplete': getAllNPQQuestionnaireNotComplete,
            'checkingStatusPatient': checkingStatusPatient
        };

        function convertLocalDateFromServerForWorkflow(workflow) {
            if(workflow && workflow.answer) {
                if(workflow.answer.theApproximateDateOfTheInjury) {
                    workflow.answer.theApproximateDateOfTheInjury = DateUtils.convertLocalDateFromServer(workflow.answer.theApproximateDateOfTheInjury);
                }
                // if(workflow.answer.dateOfBirth) {
                //     workflow.answer.dateOfBirth = DateUtils.convertLocalDateFromServer(workflow.answer.dateOfBirth);
                // }
                if(workflow.answer.dateOfInjury) {
                    workflow.answer.dateOfInjury = DateUtils.convertLocalDateFromServer(workflow.answer.dateOfInjury);
                }
                if(workflow.answer.lastDayWorked) {
                    workflow.answer.lastDayWorked = DateUtils.convertLocalDateFromServer(workflow.answer.lastDayWorked);
                }
                if(workflow.answer.prescriptionsLastFilled) {
                    workflow.answer.prescriptionsLastFilled = DateUtils.convertLocalDateFromServer(workflow.answer.prescriptionsLastFilled);
                }
                if (workflow.answer.diagnostics) {
                    for(var i = 0 ; i < workflow.answer.diagnostics.length; i++) {
                         workflow.answer.diagnostics[i].dateOfExam = DateUtils.convertLocalDateFromServer(workflow.answer.diagnostics[i].dateOfExam);
                    }
                }
                if(workflow.answer.dateOfAccident) {
                    workflow.answer.dateOfAccident = DateUtils.convertLocalDateFromServer(workflow.answer.dateOfAccident);
                }
                if(workflow.answer.medicalSoughtDate) {
                    workflow.answer.medicalSoughtDate = DateUtils.convertLocalDateFromServer(workflow.answer.medicalSoughtDate);
                }
            }
        }
        function getNPQQuestionnaire(npqQuestionairId) {
            var url = baseURL + '/npq-questionnaire';
            return $http.get(url, { params: { npqQuestionairId: npqQuestionairId }}).then(function (resp) {
                return resp.data;
            });
        };

        function getMasterData() {
            var url = baseURL + '/npq-questionnaire/master-data';
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function viewWorkflow(npqQuestionairId) {
            var url = baseURL + '/npq-questionnaire/workflow';
            return $http.get(url, { params: { npqQuestionairId: npqQuestionairId }}).then(function (resp) {
                convertLocalDateFromServerForWorkflow(resp.data);
                return resp.data;
            });
        };

        function submitWorkflow(workflow) {
	        if(workflow && workflow.answer) {
	            if(workflow.answer.theApproximateDateOfTheInjury) {
	                workflow.answer.theApproximateDateOfTheInjury = DateUtils.convertLocalDateToServer(workflow.answer.theApproximateDateOfTheInjury);
	            }
	            if(workflow.answer.dateOfBirth) {
	                workflow.answer.dateOfBirth = DateUtils.convertLocalDateToServer(workflow.answer.dateOfBirth);
	            }
	            if(workflow.answer.dateOfInjury) {
	                workflow.answer.dateOfInjury = DateUtils.convertLocalDateToServer(workflow.answer.dateOfInjury);
	            }
	            if(workflow.answer.dateOfAccident) {
	                workflow.answer.dateOfAccident = DateUtils.convertLocalDateToServer(workflow.answer.dateOfAccident);
	            }
	            if(workflow.answer.medicalSoughtDate) {
	                workflow.answer.medicalSoughtDate = DateUtils.convertLocalDateToServer(workflow.answer.medicalSoughtDate);
	            }
	            if(workflow.answer.lastDayWorked) {
	                workflow.answer.lastDayWorked = DateUtils.convertLocalDateToServer(workflow.answer.lastDayWorked);
	            }
	            
	            if(workflow.answer.prescriptionsLastFilled) {
	                workflow.answer.prescriptionsLastFilled = DateUtils.convertLocalDateToServer(workflow.answer.prescriptionsLastFilled);
	            }
	            if (workflow.answer.diagnostics) {
	                for(var i = 0 ; i < workflow.answer.diagnostics.length; i++) {
	                    workflow.answer.diagnostics[i].dateOfExam = DateUtils.convertLocalDateToServer(workflow.answer.diagnostics[i].dateOfExam);
	                }
	            }
            }
            var submitSection = workflow.section.template.replace(/-/g, '');
            return $http.post(baseURL + '/npq-questionnaire/workflow/submit-' + submitSection , workflow).then(function (resp) {
                convertLocalDateFromServerForWorkflow(resp.data);
                return resp.data;
            }, function errorCallback(response) {
                ClearLocalStorageService.clearWorkflow();
                ShowUnexpectedErrorDialogService.open(response, 'saveNPQQuestionnaire', null)
                    .result.then(function (result) {
                    $rootScope.$emit('ipmApp.httpError', response);
                });
                return response;
            });
        }

        function getNPQQuestionnaireByPatientId(id, pageable) {
            var url = baseURL + '/npq-questionnaire/patient';
            return $http.get(url, {
                params: {
                    patientId: id,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).then(function (resp) {
                return resp.data;
            });
        }

        function saveNPQQuestionnaire(data) {
            var url = baseURL + '/npq-questionnaire/create';
            return $http.post(url, data).then(function (resp) {
                return resp.data;
            });
        }

        function downloadQuestionnaire(fromDate, toDate) {
            var deferred = $q.defer();
            var url = baseURL + '/npq-questionnaire/download-questionnaire';
            $http({
                url: url,
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {                
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function downloadQuestionnaireById(id) {
            var deferred = $q.defer();
            var url = baseURL + '/npq-questionnaire/download/' + id;
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                var contentType = headers('content-type');
                var blob = new Blob([data], {type: contentType});
                DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                deferred.resolve(true);
            }).error(function (data, status, headers, config) {                
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        function getSupportedStatusFilter() {
            var deferred = $q.defer();

            var url = baseURL + '/npq-questionnaire/supported-data-list';

            $http.get(url).success(function(data) {
                deferred.resolve(data);
            })
                .error(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function getTheMostRecentNPQQuestionnaireOrById(npqQuestionairId) {
            if (!npqQuestionairId) {
                npqQuestionairId = 0;
            }
            // if have npqQuestionairId we will get by id, else we get by most recent
            var url = baseURL + '/npq-questionnaire/most-recent' + '?npqQuestionairId=' + npqQuestionairId;
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function resumeNPQQuestionnaire() {
            var url = baseURL + '/npq-questionnaire/resume';
            return $http.get(url).then(function (resp) {
                convertLocalDateFromServerForWorkflow(resp.data);
                return resp.data;
            });
        };

        function getAllNPQQuestionnaireNotComplete() {
            var url = baseURL + '/npq-questionnaire/all-not-complete';
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function checkingStatusPatient() {
            var url = baseURL + '/npq-questionnaire/checking-status-patient';
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function showUnexpectedErrorDialog(res, functionName, currentQuestionObj) {
            $uibModal.open({
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.currentQuestionObj = currentQuestionObj;
                    vm.functionName = functionName;
                    vm.statusCode = res.status;
                    if (_.isObject(res.data)) {
                        vm.errorDetails = res.data.description;
                    } else {
                        vm.errorDetails = res.data;
                    }

                    vm.close = function() {
                        $uibModalInstance.close(true);
                        if (vm.statusCode === 401) { // HttpStatus.UNAUTHORIZED
                            $state.go('home');
                        }
                    }

                    vm.getResponse = function() {
                        if (vm.currentQuestionObj) {
                            var answer = vm.currentQuestionObj.answer;
                            if (answer) {
                                var questionOptions = _.filter(vm.currentQuestionObj.questionOptions, function(o) {
                                    return o.value == answer;
                                });
                                if (!_.isEmpty(questionOptions)) {
                                    return questionOptions[0].name;
                                }
                            }
                        }
                        return null;
                    }
                },
                templateUrl: 'app/survey-workflow/partial/unexpected-error-dialog.html',
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static',
                keyboard  : false,
                windowClass: 'absolute-center error-dialog'
            });
        }

    	return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('NPQQuestionnaireController', NPQQuestionnaireController);

        NPQQuestionnaireController.$inject = ['$scope', '$state', '$timeout', '$translate', '$location', 'Auth', '$uibModal', '$window', 'npqQuestionnaire', 'masterData', 'ipmConstants'];

    function NPQQuestionnaireController($scope, $state, $timeout, $translate, $location, Auth, $uibModal, $window, npqQuestionnaire, masterData, ipmConstants) {
        var vm = this;

        vm.npqQuestionnaire = npqQuestionnaire;
        vm.masterData = masterData;
        vm.percent = 0;
        
        vm.init = function() {
            vm.percent = vm.getPercent();
        }

        vm.getLanguage = function() {
            return $translate.storage().get('NG_TRANSLATE_LANG_KEY');
        }

        vm.widthStyle = function() {
            vm.percent = vm.getPercent();
            if (vm.getPercent() > 0) {
                return { width: vm.getPercent() + '%' };
            } else {
                return { width: vm.getPercent() + '%', color: 'transparent' };
            }           
        }
        
        vm.getPercent = function() {
            return Math.ceil((vm.npqQuestionnaire.sectionIdsCompleted.length/ipmConstants.TOTAL_NPQ_SECTION)*100);
        }
        
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notification-history', {
            parent: 'app',
            url: '/notification-history/{patientId}',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER', 'ROLE_ADMIN'],
                pageTitle: 'ipmApp.notificationHistory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/notification-history/notification-history-list.html',
                    controller: 'NotificationHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('notification-history');
                    return $translate.refresh();
                }]
            },
            params: {}
        });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('NotificationHistoryService', NotificationHistoryService);

    NotificationHistoryService.$inject = ['$q', 'halClient', '$http'];

    function NotificationHistoryService($q, halClient, $http) {
        var baseUrl = 'api/';

        var service = {
            'query': query
        };

        function query(patientId, pageable) {
            var deferred = $q.defer();

            var url = baseUrl + 'notification-histories/' + patientId;
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        return service;
    };
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('NotificationHistoryController', NotificationHistoryController);

    NotificationHistoryController.$inject = ['$scope', '$state','$stateParams', 'NotificationHistoryService', '$window', 'FormatUtilsService', 'PhoneUtilsService'];

    function NotificationHistoryController ($scope, $state, $stateParams, NotificationHistoryService, $window, FormatUtilsService, PhoneUtilsService) {
        var vm = this;
        vm.notificationHistory = [];
        vm.page = 1;
        vm.totalItems = 0;
        vm.predicate = 'dateSent';
        vm.reverse = false;
        vm.pageSize = 15;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.patientId = $stateParams.patientId ? $stateParams.patientId : null;
        vm.back = back;
        vm.formatHtml = formatHtml;
        vm.formatPhone = formatPhone;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: 6,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };
            if (vm.patientId) {
                NotificationHistoryService.query(vm.patientId, pageable).then(function (response) {
                    vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                    vm.notificationHistory = response && response.data ? response.data : [];
                });
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function back() {
            $window.history.back();
        }

        function formatHtml(messageContent) {
            return FormatUtilsService.removeHrefHtml(messageContent);
        }

        function formatPhone(phone) {
            return PhoneUtilsService.formatPhone(phone);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PsychCountDialogController', PsychCountDialogController);

    PsychCountDialogController.$inject = ['$uibModalInstance', 'count'];

    function PsychCountDialogController($uibModalInstance, count) {
        var vm = this;
        vm.count = count;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.yes = function() {
            $uibModalInstance.close(true);
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('landing-page', {
                parent: 'app',
                url: '/landing-page',
                data: {
                    authorities: ['ROLE_PATIENT'],
                    pageTitle: 'ipmApp.landingPage.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/landing-page/landing-page.html',
                        controller: 'LandingPageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('landingPage');
                        return $translate.refresh();
                    }],
                },
                params: {
                    id: null
                }
            });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('LandingPageService', LandingPageService);

    LandingPageService.$inject = ['$http', 'halClient', '$q'];

    function LandingPageService ($http, halClient, $q) {
        var baseURL = 'api/landing-page/';

        var service = {
            'getLandingPage': getLandingPage
        };

        function getLandingPage(isLaunchAction, noWait, haqId) {
            var url = baseURL;
            return $http.get(url, { params: { isLaunchAction: isLaunchAction, noWait: noWait, haqId: haqId }}).then(function (resp) {
                return resp;
            });
        };

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('LandingPageController', LandingPageController);

    LandingPageController.$inject = ['$scope', '$state', '$window', 'LandingPageService', 'ClearLocalStorageService', 'AgreementsWorkflowService', 'ipmConstants', 'SurveyResultService',
        'Principal', 'tmhDynamicLocale', '$rootScope', '$uibModal'];

    function LandingPageController($scope, $state, $window, LandingPageService, ClearLocalStorageService, AgreementsWorkflowService, constants, SurveyResultService,
        Principal, tmhDynamicLocale, $rootScope, $uibModal) {
        var vm = this;
        vm.landingpage = null;
        vm.haqBatteries = [];
        vm.slides = [];
        vm.myInterval = false;
        vm.noWrapSlides = false;
        vm.active = true;
        vm.percentCompleted = 100; // completed 100%
        vm.isProcessing = false;
        vm.step1 = 1;
        vm.step2 = 2;
        vm.step3 = 3;
        vm.step4 = 4;
        vm.stepPsychIntake = 'Psych Intake';
        vm.openCountDialog = false;
        vm.currentStep = null;
        vm.isHideHAQStep = false;
        vm.isHideHAQStepBackground = false;
        vm.isCompletedAllStep = false;
        vm.langdingPageSteps = [];
        vm.isPatientNoNPQ = false;
        vm.isLaunchAction = false;
        vm.isCompleteHAQ = false;
        vm.hasHaqAdhocTesting = false;
        vm.haqAdhocId = null;
        vm.batteryTestAdhocId = null;
        vm.adhocTestName = '';
        vm.percentProgressOfHAQAdhoc = 0;
        vm.percentProgressOfPsychIntake = 0;
        vm.isLaunchFromHaqAdhoc = false;
        vm.currentSurveyResultId = null;
        vm.disableAutoHaqNewStep = true; // Disable Launch HAQ
        vm.isLaunching = getLaunchFrom() != null;
        vm.clickAction = clickAction;
        vm.isShowStep = isShowStep;
        vm.getNumberOfNpqNotYetComplete = getNumberOfNpqNotYetComplete;
        vm.getNumberOfPsychIntakeFormNotYetComplete = getNumberOfPsychIntakeFormNotYetComplete;
        vm.isCompletedAgreementStep = isCompletedAgreementStep;
        vm.isCompletedNPQStep = isCompletedNPQStep;
        vm.isCompletedPsychStep = isCompletedPsychStep;
        vm.isCompletedHAQStep = isCompletedHAQStep;
        vm.isCompletedHAQBatteryStep = isCompletedHAQBatteryStep;
        vm.isResumeStep = isResumeStep;
        vm.isStartStep = isStartStep;
        vm.percentTextClass = percentTextClass;
        vm.timeRemainingTextClass = timeRemainingTextClass;
        vm.isShowTextStep = isShowTextStep;
        vm.isShowRemainingText = isShowRemainingText;
        vm.isShowCompletedText = isShowCompletedText;
        vm.isShowApproxText = isShowApproxText;
        vm.itemLandingPageClick = itemLandingPageClick;
        vm.itemLandingPageClickDownload = itemLandingPageClickDownload;
        vm.handleHAQBodyPartSubmitSuccess = handleHAQBodyPartSubmitSuccess;
        vm.isDisplayItemLandingPageForPatientNoNPQ = isDisplayItemLandingPageForPatientNoNPQ;
        vm.isDisplayItemLandingPageForAdhocTesting = isDisplayItemLandingPageForAdhocTesting;
        vm.isAgreementSignedAllByAPI = isAgreementSignedAllByAPI;
        vm.navigateAdhocTesting = navigateAdhocTesting;
        vm.navigateHaqBatteryTesting = navigateHaqBatteryTesting;
        vm.isShowAdhocTesting = isShowAdhocTesting;
        vm.checkShowActionStart = checkShowActionStart;
        vm.isShowHaqBatteries = isShowHaqBatteries;
        vm.isHaqBatteryCompleted = isHaqBatteryCompleted;
        vm.startPsychIntakeForm = startPsychIntakeForm;

        init();

        function init() {
            initLandingPage();
        }

        function initLandingPage() {
            initLandingPageBackground();

            vm.isLaunchAction = getHAQDirectLink();
            vm.noWait = $window.localStorage.getItem(constants.NOWAIT);
            var haqId = $window.localStorage.getItem(constants.SURVEY_RESULT_ID);
            var _passRestriction = $window.localStorage.getItem(constants.PASS_RESTRICTION);
            if (_passRestriction && true == Boolean(_passRestriction)) {
                vm.byPassRestriction = true;
            }

            LandingPageService.getLandingPage(vm.isLaunchAction, vm.noWait, haqId).then(function (response) {
                vm.landingpage = response ? response.data : null;
                // IPMproject-B1357 Landing page: The language is EN while the language of patient is SP
                var langKeyPatient = vm.landingpage.langKey;
                if (langKeyPatient) {
                    $rootScope.$emit("changeLanguage", { langKey: langKeyPatient });
                }

                if (vm.landingpage) {
                    vm.hasHaqAdhocTesting = vm.landingpage.hasHaqAdhocTesting;
                    if (!vm.hasHaqAdhocTesting && isLaunchFromHaqAdhoc()) {
                        ClearLocalStorageService.clearLaunchFrom();
                    }
                    vm.haqAdhocId = vm.landingpage.latestSurveyResultAdhocId;
                    vm.batteryTestAdhocId = vm.landingpage.latestBatteryTestAdhocId;
                    vm.adhocTestName = vm.landingpage.latestAdhocTestName;
                    vm.percentProgressOfHAQAdhoc = vm.landingpage.percentProgressOfHAQAdhoc;
                    vm.isLaunchFromHaqAdhoc = vm.landingpage.isLaunchFromHaqAdhoc;
                    vm.currentSurveyResultId = vm.landingpage.currentSurveyResultId;
                    vm.haqBatteries = vm.landingpage.haqBatteries;
                    vm.percentProgressOfPsychIntake = vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake;
                }

                setCurrentStep();
                // set isHideHAQStep
                setIsHideHAQStep();

                if (vm.landingpage.patientType === 'NEW_PATIENT_NO_NPQ') {
                    vm.batteryTestId = vm.landingpage && vm.landingpage.haqResponseInfo ? vm.landingpage.haqResponseInfo.batteryTestId : null;
                    vm.isPatientNoNPQ = true;
                    // define common variable
                    var completedTextTranslate = 'ipmApp.landingPage.details.completed';
                    var terminadoTextTranslate = 'ipmApp.landingPage.details.terminado';
                    var approxTextTranslate = 'ipmApp.landingPage.details.approx';
                    var minTextTranslate = 'ipmApp.landingPage.details.min';
                    var remainingTextTranslate = 'ipmApp.landingPage.details.remaining';
                    var clickToStartTextTranslate = 'ipmApp.landingPage.action.clickToStart';
                    var clickToResumeTextTranslate = 'ipmApp.landingPage.action.clickToResume';
                    var clickToDownloadTextTranslate = 'ipmApp.landingPage.action.clickToDownload';

                    var agreementItem = {
                        isAgreement: true,
                        image: './content/images/assets_agreement.png',
                        titleTextTranslate: 'ipmApp.landingPage.details.newPatientAgreements',
                        stepNumber: 1,
                        isCurrentStep: vm.landingpage.agreement.percentProgressOfAgreement !== vm.percentCompleted,
                        percentProgress: vm.landingpage.agreement.percentProgressOfAgreement,
                        numberTimeRemaining: vm.landingpage.agreement.numberTimeRemainingOfAgreement,
                        canDownload: true,
                        completedTextTranslate: completedTextTranslate,
                        terminadoTextTranslate: terminadoTextTranslate,
                        approxTextTranslate: approxTextTranslate,
                        minTextTranslate: minTextTranslate,
                        remainingTextTranslate: remainingTextTranslate,
                        clickToStartTextTranslate: clickToStartTextTranslate,
                        clickToResumeTextTranslate: clickToResumeTextTranslate,
                        clickToDownloadTextTranslate: clickToDownloadTextTranslate
                    }

                    var haqItem = {
                        isHAQ: true,
                        image: './content/images/assets_haq.png',
                        titleTextTranslate: 'ipmApp.landingPage.details.healthAssessmentQuestionnaire',
                        stepNumber: 2,
                        isCurrentStep: vm.landingpage.agreement.percentProgressOfAgreement === vm.percentCompleted && vm.landingpage.percentProgressOfHAQ !== vm.percentCompleted,
                        percentProgress: vm.landingpage.percentProgressOfHAQ,
                        numberTimeRemaining: vm.landingpage.numberTimeRemainingOfHAQ,
                        completedTextTranslate: completedTextTranslate,
                        terminadoTextTranslate: terminadoTextTranslate,
                        approxTextTranslate: approxTextTranslate,
                        minTextTranslate: minTextTranslate,
                        remainingTextTranslate: remainingTextTranslate,
                        clickToStartTextTranslate: clickToStartTextTranslate,
                        clickToResumeTextTranslate: clickToResumeTextTranslate,
                        clickToDownloadTextTranslate: clickToDownloadTextTranslate
                    }

                    vm.langdingPageSteps = [agreementItem, haqItem];
                }

                vm.isCompletedAllStep = isCompletedAllStep();

            });
        }

        function setIsHideHAQStep() {
            //vm.isHideHAQStep = (vm.landingpage ? vm.landingpage.haqTestServiceExclusion : false) || isLaunchFromHaqAdhoc() || checkDisableAutoHaqNewStep();
            vm.isHideHAQStep = true; // IPMproject-891 - Admin/Staff Portal - Patient Details Page – New Batteries Table: default hide HAQ
            vm.isHideHAQStepBackground = vm.landingpage ? vm.landingpage.haqTestServiceExclusion && vm.currentStep === vm.step3 && !isCompletedHAQStep() : false;
        }

        function initLandingPageBackground() {
            var currIndex = 0;
            vm.slides.push({
                image: 'content/images/assets_bg.jpg',
                id: currIndex++
            });
        }

        function clickAction(step, $event) {
            if (vm.isPatientNoNPQ) {
                angular.forEach(vm.langdingPageSteps, function (step) {
                    if (step && step.isCurrentStep) {
                        itemLandingPageClick(step);
                        return;
                    }
                });
                return;
            }

            if (step && step == vm.step1 && isCompletedAgreementStep() && !vm.isProcessing) {
                if (!vm.isAgreementSignedAllByAPI()) {
                    clickToDownload();
                }
                return;
            }

            if ((vm.currentStep && vm.currentStep === vm.stepPsychIntake) || (step && step == vm.stepPsychIntake)) {
                startPsychIntakeForm();
                return;
            } else {
                $window.localStorage.removeItem(constants.PSYCH_INTAKE_FORM_ID);
            }

            if (step && step != vm.currentStep) {
                return;
            }

            if ((!vm.currentStep || vm.currentStep && vm.currentStep === 4) &&
                !isCompletedAllHAQBatteryStep()) {
                navigateHaqBatteryTestingFistNotCompleted();
                return;
            }

            if ((!vm.currentStep || vm.currentStep && vm.currentStep === 4) && isCompletedAllHAQBatteryStep() && isCompletedHAQStep() && !isLaunchFromHaq() && !isCompletedHAQAdhocStep()) {
                navigateAdhocTesting();
                return;
            }
            goToHome();
        }

        function startPsychIntakeForm() {
            var psychIntakeFormId = $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID);
            if (!psychIntakeFormId && vm.landingpage.psychIntakeForm.psychIntakeFormId) {
                psychIntakeFormId = vm.landingpage.psychIntakeForm.psychIntakeFormId;
                $window.localStorage.setItem(constants.PSYCH_INTAKE_FORM_ID, psychIntakeFormId);
            }
            if (psychIntakeFormId) {
                $window.localStorage.removeItem(constants.NPQ_QUESTIONNAIRE_ID);
                if (vm.landingpage && vm.landingpage.psychIntakeForm.numberOfPsychIntakeNotYetComplete > 1) {
                    openPsychCountDialog(vm.landingpage.psychIntakeForm.numberOfPsychIntakeNotYetComplete);
                } else {
                    goToHome();
                }
            }
        }

        function openPsychCountDialog(countPsych) {
            vm.openCountDialog = true;
            $uibModal.open({
                templateUrl: 'app/landing-page/psych-count-dialog.html',
                controller: 'PsychCountDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    count: function () {
                        return countPsych;
                    }
                }
            }).result.then(function (result) {
                vm.openCountDialog = false;
                if (result && result === true) {
                    goToHome();
                }
            }, function () {
                vm.openCountDialog = false;
            });
        }

        function navigateHaqBatteryTestingFistNotCompleted() {
            if (vm.landingpage && vm.haqBatteries && vm.haqBatteries.length > 0) {
                const haqBatteryItemNotCompleted = vm.haqBatteries.find(function (item) {
                    return item && item.percentProgress < vm.percentCompleted;
                });
                if (haqBatteryItemNotCompleted) {
                    navigateHaqBatteryTesting(haqBatteryItemNotCompleted);
                }
            }
        }

        function goToHome() {
            ClearLocalStorageService.setLandingPage(true); // landing page is null or false will open landing page
            $state.go('home');
        }

        function navigateAdhocTesting() {
            ClearLocalStorageService.setSurveyResultId(vm.haqAdhocId);
            $state.go('survey-workflow', { id: vm.batteryTestAdhocId });
        }

        function navigateHaqBatteryTesting(haqBattery) {
            if (!haqBattery.batteryTestId || !haqBattery.surveyResultId || isHaqBatteryCompleted(haqBattery)) {
                return;
            }
            ClearLocalStorageService.setSurveyResultId(haqBattery.surveyResultId);
            $state.go('survey-workflow', { id: haqBattery.batteryTestId });
        }

        function clickToDownload() {
            vm.isProcessing = true;
            if (isCompletedAgreementStep()) {
                AgreementsWorkflowService.downloadAgreements().then(function (response) {
                    vm.isProcessing = false;
                });
            }
        }

        function isCompletedAgreementStep() {
            if (vm.isAgreementSignedAllByAPI() || !vm.isShowStep(vm.step1)) {
                return true;
            }
            return vm.landingpage && vm.landingpage.agreement.percentProgressOfAgreement && vm.landingpage.agreement.percentProgressOfAgreement === vm.percentCompleted ? true : false;
        }

        function isCompletedNPQStep() {
            return vm.landingpage && vm.landingpage.npq.percentProgressOfNPQ && vm.landingpage.npq.percentProgressOfNPQ == vm.percentCompleted ? true : false;
        }

        function isCompletedPsychStep() {
            return vm.landingpage && vm.landingpage.psychIntakeForm &&
                vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake &&
                vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake == vm.percentCompleted ? true : false;
        }

        function isCompletedHAQStep() {
            if (checkDisableAutoHaqNewStep()) {
                return true;
            }
            return vm.landingpage && vm.landingpage.percentProgressOfHAQ && vm.landingpage.percentProgressOfHAQ == vm.percentCompleted ? true : false;
        }

        function isCompletedHAQBatteryStep(haqBattery) {
            return vm.landingpage && haqBattery && haqBattery.percentProgress == vm.percentCompleted ? true : false;
        }

        function isCompletedAllHAQBatteryStep() {
            if (vm.landingpage && vm.haqBatteries && vm.haqBatteries.length > 0) {
                return vm.haqBatteries.every(function (item) {
                    return item && item.percentProgress === vm.percentCompleted;
                });
            }
            return true;
        }

        function isCompletedHAQAdhocStep() {
            return vm.landingpage && ((vm.landingpage.percentProgressOfHAQAdhoc && vm.landingpage.percentProgressOfHAQAdhoc === vm.percentCompleted) || !vm.hasHaqAdhocTesting);
        }

        function isStartStep(step) {
            if (step && step == vm.step1) {
                return !isCompletedAgreementStep() && !isResumeStep(step);
            } else if (step && step == vm.step2) {
                return !isCompletedNPQStep() && !isResumeStep(step);
            } else if (step && step == vm.step3) {
                return !isCompletedHAQStep() && !isResumeStep(step);
            } else if (step && step == vm.step4) {
                return !isCompletedHAQAdhocStep() && !isResumeStep(step);
            } else if (step && step == vm.stepPsychIntake) {
                return !isCompletedPsychStep() && !isResumeStep(step);
            }
        }

        function isResumeStep(step) {
            if (step && step == vm.step1) {
                return vm.landingpage && vm.landingpage.agreement.percentProgressOfAgreement && vm.landingpage.agreement.percentProgressOfAgreement > 0 && vm.landingpage.agreement.percentProgressOfAgreement < vm.percentCompleted ? true : false;
            } else if (step && step == vm.step2) {
                return vm.landingpage && vm.landingpage.npq.percentProgressOfNPQ && vm.landingpage.npq.percentProgressOfNPQ > 0 && vm.landingpage.npq.percentProgressOfNPQ < vm.percentCompleted ? true : false;
            } else if (step && step == vm.step3) {
                return vm.landingpage && vm.landingpage.percentProgressOfHAQ && vm.landingpage.percentProgressOfHAQ > 0 && vm.landingpage.percentProgressOfHAQ < vm.percentCompleted ? true : false;
            } else if (step && step == vm.step4) {
                return vm.landingpage && vm.landingpage.percentProgressOfHAQAdhoc && vm.landingpage.percentProgressOfHAQAdhoc > 0 && vm.landingpage.percentProgressOfHAQAdhoc < vm.percentCompleted ? true : false;
            } else if (step && step == vm.stepPsychIntake) {
                return vm.landingpage && vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake && vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake > 0 && vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake < vm.percentCompleted ? true : false;
            }
        }

        function isShowStep(step) {
            if (step === vm.step1) {
                if (getKeepLandingPage()) {
                    return false;
                }
                if (vm.isLaunching) {
                    return getLaunchFrom() === constants.PATIENT_AGREEMENT;
                }
                return vm.landingpage && vm.landingpage.agreement.showCard == true ? true : false
            }
            if (step === vm.step2) {
                if (getKeepLandingPage() || vm.isLaunching) {
                    return false;
                }
                return vm.landingpage && vm.landingpage.npq.showCard == true ? true : false;
            }
            if (step === vm.step3) {
                return !vm.isHideHAQStep;
            }
            if (step === vm.stepPsychIntake) {
                if (vm.isLaunching) {
                    return false;
                }
                return vm.landingpage && vm.landingpage.psychIntakeForm.showCard;
            }
            return true;
        }

        function isShowAdhocTesting() {
            return vm.hasHaqAdhocTesting && (!vm.isLaunching || (vm.isLaunching && isLaunchFromHaqAdhoc()));
        }

        function isShowHaqBatteries() {
            return vm.haqBatteries && vm.haqBatteries.length > 0 && (!vm.isLaunching || (vm.isLaunching && getLaunchFrom() === constants.HAQ_BATTERY));
        }

        function isHaqBatteryCompleted(haqBattery) {
            return vm.haqBatteries && haqBattery && (haqBattery.surveyResultStatus === 'COMPLETE' || haqBattery.surveyResultStatus === 'DOWNLOADED');
        }

        function isLaunchFromHaqAdhoc() {
            return getLaunchFrom() === constants.HAQ_ADHOC;
        }

        function checkDisableAutoHaqNewStep() {
            return vm.disableAutoHaqNewStep && vm.landingpage && !vm.landingpage.currentSurveyResultId;
        }

        function checkShowActionStart() {
            return !vm.isCompletedAllStep;
        }

        function isLaunchFromHaq() {
            return getLaunchFrom() === constants.HAQ;
        }
        function isShowTextStep(step) {
            if (step === vm.step3) {
                if (getHAQDirectLink() || (!isShowStep(vm.step1) && !isShowStep(vm.step2))) {
                    return false;
                }
            }
            return true;
        }

        function isShowRemainingText(percent) {
            if (percent && percent > 0 && percent < vm.percentCompleted) {
                return true;
            }
            return false;
        }

        function isShowCompletedText(percent) {
            if (percent && percent === vm.percentCompleted) {
                return true;
            }
            return false;
        }

        function isShowApproxText(percent) {
            if (percent && percent > 0) {
                return false;
            }
            return true;
        }

        function getHAQDirectLink() {
            var _surveyResultId = getSurveyResultId();
            return _surveyResultId && true === Boolean(_surveyResultId);
        }

        function getSurveyResultId() {
            return ClearLocalStorageService.getSurveyResultId();
        }

        function getLaunchFrom() {
            return ClearLocalStorageService.getLaunchFrom();
        }

        function getKeepLandingPage() {
            var _keepLandingPage = $window.localStorage.getItem(constants.KEEP_LANDING_PAGE);
            return _keepLandingPage && true === Boolean(_keepLandingPage);
        }

        function getNumberOfNpqNotYetComplete() {
            return vm.landingpage ? vm.landingpage.npq.numberOfNPQNotYetComplete : 0;
        }

        function getNumberOfPsychIntakeFormNotYetComplete() {
            return vm.landingpage ? vm.landingpage.psychIntakeForm.numberOfPsychIntakeNotYetComplete : 0;
        }

        function percentTextClass(percent) {
            if (percent && percent == vm.percentCompleted) {
                return 'text-success';
            } else if (percent && percent > 0 && percent < vm.percentCompleted) {
                return 'text-warning';
            }
            return '';
        }

        function timeRemainingTextClass(percent) {
            if (percent && percent == vm.percentCompleted) {
                return '';
            } else if (percent && percent > 0 && percent < vm.percentCompleted) {
                return 'text-warning';
            }
            return 'text-success';
        }

        function setCurrentStep() {
            if (isShowStep(vm.step1) && !isCompletedAgreementStep()) {
                return vm.currentStep = vm.step1;
            } else if (isShowStep(vm.step2) && !isCompletedNPQStep()) {
                return vm.currentStep = vm.step2;
            } else if (isShowStep(vm.step3) && !isCompletedHAQStep()) {
                return vm.currentStep = vm.step3;
            } else if (isShowStep(vm.stepPsychIntake) && !isCompletedPsychStep()) {
                return vm.currentStep = vm.stepPsychIntake;
            }
            return null;
        }

        function isCompletedAllStep() {
            if (vm.isPatientNoNPQ) {
                var a = [];
                angular.forEach(vm.langdingPageSteps, function (step) {
                    if (step && step.percentProgress < vm.percentCompleted) {
                        a.push(step);
                    }
                });
                return a.length === 0;
            }
            return isCompletedAgreementStep() && isCompletedNPQStep() && isCompletedPsychStep() && isCompletedHAQStep() && isCompletedAllHAQBatteryStep() && (isLaunchFromHaq() || isCompletedHAQAdhocStep());
        }

        function itemLandingPageClick(item) {
            if (item && item.isCurrentStep) {
                if (item.isAgreement) {
                    // go to agreement workflow
                    $state.go('agreements-workflow');
                }
                if (item.isHAQ) {
                    var haqInfo = vm.landingpage.haqResponseInfo;
                    if ((haqInfo.allowStartNewBattery === null || haqInfo.allowStartNewBattery === true || vm.byPassRestriction) &&
                        haqInfo.isEmailConfirmed === false && haqInfo.disposition == true) {

                        // display body part
                        vm.isDisplayHaqBodyPart = true;
                        Principal.identity(false).then(function (account) {
                            vm.account = account;
                            vm.emailConfirmed = false;
                            vm.email = account.email === null ? account.email : account.email.trim();
                            vm.hasEmail = vm.email;
                            vm.injuredType = account.injuredType;
                            vm.patientInjuredTypes = vm.landingpage.injuredTypes;
                        });


                    } else {

                        $window.localStorage.removeItem(constants.NOWAIT); // old code (4 year ago), don't know this bussiness

                        if (haqInfo.disposition == true) {
                            if (vm.byPassRestriction) {
                                if (haqInfo.status === 'COMPLETE' && haqInfo.courseRegisterConfirmed === false) {
                                    $state.go('course-registration-workflow');
                                } else {
                                    $state.go('survey-workflow', { id: vm.batteryTestId });
                                }
                                return;
                            }
                            if (haqInfo.status !== 'COMPLETE' && haqInfo.status !== 'INCOMPLETE' && haqInfo.status !== 'NO_RESULT' &&
                                (haqInfo.allowStartNewBattery == null || haqInfo.allowStartNewBattery == true || vm.byPassRestriction)) {
                                // go to  haq workflow

                                $state.go('survey-workflow', { id: vm.batteryTestId });
                            } else {
                                if (haqInfo.status === 'COMPLETE' && haqInfo.courseRegisterConfirmed === false) {
                                    $state.go('course-registration-workflow');
                                    return;
                                } else {
                                    vm.isCompleteHAQ = true;
                                }
                            }
                        } else {
                            vm.isInActiveHAQ = true;
                        }
                    }
                }
            }
        }

        function itemLandingPageClickDownload() {
            if (!vm.isProcessing) {
                clickToDownload();
            }
        }

        function handleHAQBodyPartSubmitSuccess() {
            $state.go('survey-workflow', { id: vm.batteryTestId });
        }

        function isDisplayItemLandingPageForPatientNoNPQ() {
            if (vm.isPatientNoNPQ) {
                return !vm.isDisplayHaqBodyPart;
            }
            return false;
        }

        function isDisplayItemLandingPageForAdhocTesting() {
            if (vm.isAdhocTesting) {
                return !vm.isDisplayHaqBodyPart;
            }
            return false;
        }

        function isAgreementSignedAllByAPI() {
            return vm.landingpage && vm.landingpage.agreement.agreementSignedAllByAPI;
        }
    }
})();
;
(function() {
    'use strict';


    ItemLandingPageController.$inject = ['$scope', '$state', '$window', 'LandingPageService', 'ClearLocalStorageService', 'AgreementsWorkflowService', 'ipmConstants'];

    function ItemLandingPageController($scope, $state, $window, LandingPageService, ClearLocalStorageService, AgreementsWorkflowService, constants) {
        var vm = this; //jshint ignore:line
        vm.percentCompleted = 100; // completed 100%

        vm.percentTextClass = percentTextClass;
        vm.isShowCompletedText = isShowCompletedText;
        vm.timeRemainingTextClass = timeRemainingTextClass;
        vm.isShowApproxText = isShowApproxText;
        vm.isShowRemainingText = isShowRemainingText;
        vm.isCompleted = isCompleted;
        vm.isStart = isStart;
        vm.isNotYetCompleted = isNotYetCompleted;
        vm.clickAction = clickAction;
        vm.isCursorDefault = isCursorDefault;

        init();

        function init() {
            // setCurrentStep();
        }

        function percentTextClass() {
            if (vm.item && vm.item.percentProgress) {
                if (vm.item.percentProgress === vm.percentCompleted) {
                    return 'text-success';
                } else if (vm.item.percentProgress > 0 && vm.item.percentProgress  < vm.percentCompleted) {
                    return 'text-warning';
                }
            }
            return '';
        }

        function isShowCompletedText() {
            return isCompleted();
        }

        function timeRemainingTextClass() {
            if (vm.item.percentProgress === 0 || vm.item.percentProgress) {
                if (vm.item.percentProgress == vm.percentCompleted) {
                    return '';
                } else if (vm.item.percentProgress > 0 && vm.item.percentProgress < vm.percentCompleted) {
                    return 'text-warning';
                }
                return 'text-success';
            }
            return '';
        }
        function isShowApproxText() {
            return !(vm.item.percentProgress && vm.item.percentProgress > 0);
        }

        function isShowRemainingText() {
            return vm.item.percentProgress && vm.item.percentProgress > 0 && vm.item.percentProgress < vm.percentCompleted
        }

        function isStart() {
            return vm.item && vm.item.percentProgress === 0;
        }

        function isCompleted() {
            return vm.item && vm.item.percentProgress === vm.percentCompleted;
        }

        function isNotYetCompleted() {
            return !isCompleted();
        }

        function setCurrentStep() {
            if (vm.item) {
                if (vm.item.isHAQ && (vm.isHAQDirectLink || !isCompleted())) {
                    vm.item.currentStep = vm.item.stepNumber;
                } else if (vm.item.isAgreement && !isCompleted()) {
                    vm.item.currentStep = vm.item.stepNumber;
                }
            }
        }

        function clickAction() {
            if (vm.item.canDownload && isCompleted()) {
                vm.onClickDownload();
                return;
            }
            vm.onClick();
        }

        function isCursorDefault() {
            return !vm.item.isCurrentStep && !(vm.item.canDownload && isCompleted());
        }
    }

    angular.module('ipmApp').component('itemLandingPage', {
        bindings: {
            item: '<',
            onClick: '&',
            onClickDownload: '&'
        },
        templateUrl: 'app/landing-page/item.html',
        controller: ItemLandingPageController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';


    HAQBodyPartController.$inject = ['$scope', '$filter', 'Auth', 'Principal', 'ClearLocalStorageService', 'AgreementsWorkflowService', 'ipmConstants'];

    function HAQBodyPartController($scope, $filter, Auth, Principal, ClearLocalStorageService, AgreementsWorkflowService, constants) {
        var vm = this; //jshint ignore:line
        vm.isSaving = false;
        vm.patientInjuredTypes = [];
        vm.injuredTypes = [
            { name: "register.form.injured.legsfeet", value: "LEGS_FEET", checked: false, disabled: false },
            { name: "register.form.injured.backspine", value: "BACK_SPINE", checked: false, disabled: false },
            { name: "register.form.injured.neck", value: "NECK", checked: false, disabled: false },
            { name: "register.form.injured.armhand", value: "ARM_HAND", checked: false, disabled: false },
            { name: "register.form.injured.none", value: "NONE", checked: false, disabled: false }
         ];
         vm.confirmEmailAndInjuredType = confirmEmailAndInjuredType;
         vm.selectedInjuredTypes = selectedInjuredTypes;
        

        init();

        function init() {
            // set default email by email user login
            Principal.identity(false).then(function(account) {
                vm.email = account.email === null ? account.email : account.email.trim();
            });
            vm.injuredTypes.forEach(function(item) {
                if (vm.patientInjuredTypes.length > 0) {
                    item.checked = vm.patientInjuredTypes.includes(item.value);
                    if(vm.patientInjuredTypes[0] && vm.patientInjuredTypes[0] === 'NONE') {
                        if(item.value !== 'NONE') {
                            item.disabled = true;
                        }
                    } else {
                        if(vm.patientInjuredTypes.length > 0) {
                            if(item.value === 'NONE') {
                                item.disabled = true;
                            }
                        }
                    }
                }
            });
        }

        function confirmEmailAndInjuredType() {
            vm.isSaving = true;
            var tempEmail = encodeURIComponent(vm.email);
            Auth.confirmEmailAndInjuredTypes(tempEmail, vm.patientInjuredTypes).then(function(response){
                vm.isSaving = false;
                if(response.data === 'e-mail address already in use'){
                    vm.errorEmailExists = 'ERROR';
                } else {
                    vm.errorEmailExists = null;
                    if(response.status === 200) {
                        vm.onSubmitSuccess();
                    }
                }
            });
        }

        function selectedInjuredTypes(injuredType) {
        	if(injuredType.value === 'NONE') {
        		if(injuredType.checked == true) {
        			vm.patientInjuredTypes = [injuredType.value];
       			 	vm.injuredTypes.forEach(function(item) {
       			 		if(item.value !== 'NONE') {
       			 			item.checked = false;
       			 			item.disabled = true;
       			 		}
                    });
       		 	} else {
       		 		vm.patientInjuredTypes = [];
       		 		vm.injuredTypes.forEach(function(item) {
       		 			if(item.value !== 'NONE') {
       		 				item.disabled = false;
       		 			}
                    });
       		 	}
   		 	} else {
   		 		vm.patientInjuredTypes = $filter('filter')(vm.injuredTypes, {checked: true}).map(function(item) {
   		 			return item.value;
   		 		});
   		 		vm.injuredTypes.forEach(function(item) {
   		 			if(item.value === 'NONE') {
   		 				item.disabled = vm.patientInjuredTypes.length > 0;
   		 			}
   		 		});
   		 	}
        }
        
    }

    angular.module('ipmApp').component('haqBodyPart', {
        bindings: {
            patientInjuredTypes: '<',
            onSubmitSuccess: '&',
        },
        templateUrl: 'app/landing-page/haq-body-part.html',
        controller: HAQBodyPartController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('home');
                $translatePartialLoader.addPart('register');
                return $translate.refresh();
            }]
        }
    })
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionnaireResumeDialogController', QuestionnaireResumeDialogController);

    QuestionnaireResumeDialogController.$inject = ['$uibModalInstance', 'NPQQuestionnaireService'];

    function QuestionnaireResumeDialogController($uibModalInstance, NPQQuestionnaireService) {
        var vm = this;
        vm.managerAddNewQuestionnaire = null;
        vm.patientAccessMultipleDevice = null;


        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.yes = function() {
            resumeQuestionnaire();
        };

        function resumeQuestionnaire() {
            vm.isSaving = true;
            NPQQuestionnaireService.resumeNPQQuestionnaire().then(function() {
                onSaveSuccess();
            }).catch(function (error) {
                onSaveError(error);
            });
        }

        function onSaveSuccess () {
            vm.isSaving = false;
            $uibModalInstance.close(true);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if (error.status === 400) {
                if (errorMessage === 'Manager has been request new Questionnaire') {
                    vm.managerAddNewQuestionnaire = 'ERROR';
                } else if (errorMessage === 'Patient may be access multiple device') {
                    vm.patientAccessMultipleDevice = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionnaireCountDialogController', QuestionnaireCountDialogController);

    QuestionnaireCountDialogController.$inject = ['$uibModalInstance', 'countQuestionnaire'];

    function QuestionnaireCountDialogController($uibModalInstance, countQuestionnaire) {
        var vm = this;
        vm.countQuestionnaire = countQuestionnaire;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.yes = function() {
            $uibModalInstance.close(true);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
					$translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }],
                supportedDataList: ['Auth', function(Auth) {
                	return Auth.getSupportedListRegister();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$filter', 'Principal', 'LoginService', 'Auth', '$rootScope', '$state', 'ipmConstants', 'SurveyResultService', 'NPQQuestionnaireService', 'supportedDataList', '$window', 'tmhDynamicLocale', '$localStorage', '$uibModal', 'ClearLocalStorageService', 'AgreementsWorkflowService', '$sessionStorage', 'PsychIntakeService'];

    function HomeController($scope, $filter, Principal, LoginService, Auth, $rootScope, $state, constants, SurveyResultService, NPQQuestionnaireService, supportedDataList, $window, tmhDynamicLocale, $localStorage, $uibModal, ClearLocalStorageService, AgreementsWorkflowService, $sessionStorage, PsychIntakeService) {
        var vm = this;

        vm.isInActive = null;
        vm.isWorflowComplete = null;
        vm.account = null;
        vm.isAuthenticated = $window.localStorage.getItem(constants.INVITATION_WORKFLOW) ? true : false;
        vm.sessionTimeOut = null;
        vm.emailConfirmed = null;
        vm.errorEmailExists = null;
        vm.noWait = false;
        vm.isQuestionnaireIncomplete = null;
        vm.isQuestionnaireCount = null;
        vm.byPassRestriction = false;
        vm.loginProcess = true; // used to disable login form
        vm.isAdHocHaq = false;
        vm.isProcessingLogin = false;
        vm.surveyResultType = null;
        vm.SURVEY_RESULT_TYPE_BATTERY = constants.SURVEY_RESULT_TYPE_BATTERY;
        // home page will redirect to main page after login to don't show login form
        forwardHomePage();

        // load offices, providers
        vm.offices = supportedDataList.officeList;
        vm.providers = supportedDataList.providerList;

        vm.loginAzure = loginAzure;
        vm.login = login;
        vm.username = null;
        vm.password = null;
        vm.rememberMe = false;
        vm.authenticationError = false;
        vm.azureLogoutProcessing = false;
        vm.isAzurePatientLogin = $window.localStorage.getItem(constants.AZURE_PATIENT) ? true : false;

        vm.confirmEmailAndInjuredType = confirmEmailAndInjuredType;
        vm.selectedInjuredTypes = selectedInjuredTypes;
        vm.patientInjuredTypes = [];
        vm.injuredTypes = [
            { name: "register.form.injured.legsfeet", value: "LEGS_FEET", checked: false, disabled: false },
            { name: "register.form.injured.backspine", value: "BACK_SPINE", checked: false, disabled: false },
            { name: "register.form.injured.neck", value: "NECK", checked: false, disabled: false },
            { name: "register.form.injured.armhand", value: "ARM_HAND", checked: false, disabled: false },
            { name: "register.form.injured.none", value: "NONE", checked: false, disabled: false }
        ];

        vm.agreement = null; // used to open Agreement Workflow

        function selectedInjuredTypes(injuredType) {
            if (injuredType.value === 'NONE') {
                if (injuredType.checked == true) {
                    vm.patientInjuredTypes = [injuredType.value];
                    vm.injuredTypes.forEach(function (item) {
                        if (item.value !== 'NONE') {
                            item.checked = false;
                            item.disabled = true;
                        }
                    });
                } else {
                    vm.patientInjuredTypes = [];
                    vm.injuredTypes.forEach(function (item) {
                        if (item.value !== 'NONE') {
                            item.disabled = false;
                        }
                    });
                }
            } else {
                vm.patientInjuredTypes = $filter('filter')(vm.injuredTypes, { checked: true }).map(function (item) {
                    return item.value;
                });
                vm.injuredTypes.forEach(function (item) {
                    if (item.value === 'NONE') {
                        item.disabled = vm.patientInjuredTypes.length > 0;
                    }
                });
            }
        }

        $rootScope.$on("sessionTimeOut", function (event, args) {
            vm.sessionTimeOut = true;
            vm.isInActive = null;
            vm.isWorflowComplete = null;
            vm.emailConfirmed = null;
            vm.isAdHocHaq = false;
            vm.surveyResultType = null;
            vm.isQuestionnaireIncomplete = null;
            vm.isQuestionnaireCount = null;
        });

        if ($rootScope.sessionTimeOut) {
            vm.sessionTimeOut = true;
            $rootScope.sessionTimeOut = null;
        }

        vm.requestResetPassword = requestResetPassword;

        $scope.$on(constants.EVT_LOG_OUT, function () {
            $window.localStorage.removeItem(constants.NOWAIT);
            clearPassRestriction();
            clearLoginProcess();
            vm.noWait = false;
            vm.sessionTimeOut = null;
            vm.isInActive = null;
            vm.isWorflowComplete = null;
            vm.emailConfirmed = null;
            vm.isAdHocHaq = false;
            vm.surveyResultType = null;
            vm.isAuthenticated = null;
            vm.username = null;
            vm.password = null;
            vm.isQuestionnaireIncomplete = null;
            vm.isQuestionnaireCount = null;
            ClearLocalStorageService.clearLandingPage();
            ClearLocalStorageService.clearKeepLandingPage();
            ClearLocalStorageService.clearTimeSpent();
            ClearLocalStorageService.clearTimeSpent();
        });

        // keep old logic Login
        function processAfterLogin() {
            vm.isWorflowComplete = false;
            vm.isInActive = false;
            vm.authenticationError = false;
            vm.isAuthenticated = true;
            // If we're redirected to login, our
            // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
            /*if ($rootScope.redirected && $rootScope.previousStateName) {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);

            } else {}*/
            $rootScope.$broadcast(constants.EVT_AUTHENTICATION_SUCCESS);
            if (Principal.hasAnyAuthority([constants.ROLE_ADMIN]) === true) {
                if (checkDownloadPreviousState()) {
                    goToPreviousState();
                } else {
                    $state.go('user-management');
                }
            } else if (Principal.hasAnyAuthority([constants.ROLE_BILLER]) === true) {
                if (checkDownloadPreviousState()) {
                    goToPreviousState();
                } else {
                    $state.go('patient-list');
                }
            } else if (Principal.hasAnyAuthority([constants.ROLE_STAFF]) === true || Principal.hasAnyAuthority([constants.ROLE_MANAGER]) === true) {
                $state.go('patient-list');
            } else if (Principal.hasAnyAuthority([constants.ROLE_PATIENT]) === true) {
                // $state.go('npq-questionnaire.workflow');
                forwardToCurrentWorkflow();
            } else if (Principal.hasAnyAuthority([constants.ROLE_QHP]) === true) {
                goToHAQEvaluationWorkflow();
            } else {
                vm.authenticationError = true;
            }
            $rootScope.redirected = false;
        }

        function goToPreviousState() {
            if ($rootScope && $rootScope.previousStateName && $rootScope.previousStateName.name) {
                $state.go($rootScope.previousStateName.name, $rootScope.previousStateNameParams);
                return;
            }
        }

        function checkDownloadPreviousState() {
            return $rootScope.previousStateName && $rootScope.previousStateName.name
                && ($rootScope.previousStateName.name === 'download-haq-activity-report.requested' || $rootScope.previousStateName.name === 'download-haq-results-reports.requested');
        }

        function clearAzurePatient() {
            $window.localStorage.removeItem(constants.AZURE_PATIENT);
            vm.isAzurePatientLogin = false;
        }

        function loginAzure(event) {
            vm.isProcessingLogin = true;
            event.preventDefault();
            clearAzurePatient();
            clearPassRestriction();
            clearLoginProcess();
            vm.sessionTimeOut = null;
            $state.go('samlLogin', null, { reload: true });
            return;
        }

        function login(event) {
            event.preventDefault();
            clearAzurePatient();
            clearPassRestriction();
            clearLoginProcess();
            vm.sessionTimeOut = null;
            if (vm.username != null && vm.username.indexOf(constants.NO_WAIT, vm.username.length - constants.NO_WAIT.length) !== -1) {
                vm.username = vm.username.substring(0, vm.username.lastIndexOf("+"));
                vm.noWait = true;
            }

            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function (res) {
                processAfterLogin();
            }).catch(function () {
                vm.authenticationError = true;
            });
            if (vm.authenticationError && vm.noWait) {
                vm.noWait = false;
                vm.username = vm.username.concat(constants.NO_WAIT);
            }
        }

        function confirmEmailAndInjuredType() {
            vm.isSaving = true;
            var tempEmail = encodeURIComponent(vm.email);
            Auth.confirmEmailAndInjuredTypes(tempEmail, vm.patientInjuredTypes).then(function (response) {
                vm.isSaving = false;
                if (response.data === 'e-mail address already in use') {
                    vm.errorEmailExists = 'ERROR';
                } else {
                    vm.errorEmailExists = null;
                    if (response.status === 200) {
                        if (vm.byPassRestriction && $window.localStorage.getItem(constants.SURVEY_RESULT_ID)) {
                            getCurrentSurvey();
                        } else if ($window.localStorage.getItem(constants.SURVEY_RESULT_ID)) {
                            forwardToDirectLinkWorkflow();
                        } else {
                            forwardToCurrentWorkflow();
                        }
                    }
                }
            });
        }

        $scope.$watch('vm.email', function () {
            vm.errorEmailExists = null;
        });

        function requestResetPassword() {
            $state.go('requestReset');
        }

        $scope.$on(constants.EVT_AUTHENTICATION_SUCCESS, function () {
            getAccount(false);
        });

        function getAccount(force) {
            Principal.identity(force).then(function (account) {
                vm.account = account;
                vm.isAuthenticated = $window.localStorage.getItem(constants.INVITATION_WORKFLOW) ? true : Principal.isAuthenticated;
                if (account && account.langKey !== tmhDynamicLocale.get()) {
                    $rootScope.$emit("changeLanguage", { langKey: account.langKey });
                }
            });

        }

        function forwardHomePage() {
            vm.isWorflowComplete = false;
            vm.isInActive = false;
            if ($window.localStorage.getItem(constants.SURVEY_RESULT_ID) ||
                $window.localStorage.getItem(constants.NPQ_QUESTIONNAIRE_ID) ||
                $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID) ||
                $window.localStorage.getItem(constants.PATIENT_AGREEMENT_ID)
            ) {
                forwardToDirectLinkWorkflow();
            } else {
                Principal.identity(false).then(function (account) {
                    if (!account) {
                        // clear all local storage
                        ClearLocalStorageService.clearAll();
                        ClearLocalStorageService.clearLandingPage();
                        ClearLocalStorageService.clearKeepLandingPage();
                        $sessionStorage.currentSurveyResultId = null;
                        clearLoginProcess();
                    }
                    if (Principal.hasAnyAuthority([constants.ROLE_PATIENT]) === true && account.azureLogoutUrl !== '') {
                        vm.azureLogoutProcessing = true;
                        // Patient login azure
                        $window.localStorage.setItem(constants.AZURE_PATIENT, true);
                        vm.isAzurePatientLogin = true;
                        Auth.logout();
                        $state.go('home');
                        ClearLocalStorageService.clearAfterLogout();
                        $rootScope.$broadcast(constants.EVT_LOG_OUT);
                        $window.location.href = account.azureLogoutUrl;
                    }
                    if (Principal.hasAnyAuthority([constants.ROLE_ADMIN]) === true) {
                        $state.go('user-management');
                    } else if (Principal.hasAnyAuthority([constants.ROLE_BILLER]) === true) {
                        $state.go('patient-list');
                    } else if (Principal.hasAnyAuthority([constants.ROLE_STAFF]) === true || Principal.hasAnyAuthority([constants.ROLE_MANAGER]) === true) {
                        $state.go('survey-result-list');
                    } else if (Principal.hasAnyAuthority([constants.ROLE_PATIENT]) === true) {
                        if (checkLandingPage()) {
                            return;
                        }
                        forwardToCurrentWorkflow();

                    } else if (Principal.hasAnyAuthority([constants.ROLE_QHP]) === true) {
                        goToHAQEvaluationWorkflow();
                    }
                });
            }
        }

        function forwardToDirectLinkWorkflow() {
            // this block code using for invitation work flow [ reload this route when user logged]
            if ($window.localStorage.getItem(constants.SURVEY_RESULT_ID) ||
                $window.localStorage.getItem(constants.NPQ_QUESTIONNAIRE_ID) ||
                $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID) ||
                $window.localStorage.getItem(constants.PATIENT_AGREEMENT_ID)
            ) {
                vm.loginProcess = true; // start disable Login
                var _passRestriction = $window.localStorage.getItem(constants.PASS_RESTRICTION);
                if (_passRestriction && true == Boolean(_passRestriction)) {
                    vm.byPassRestriction = true;
                }

                Principal.identity(true).then(function (account) {
                    vm.account = account;
                    vm.isWorflowComplete = false;
                    vm.isInActive = false;
                    vm.authenticationError = false;
                    vm.isAuthenticated = Principal.isAuthenticated;
                    $rootScope.$broadcast(constants.EVT_AUTHENTICATION_SUCCESS);
                    if (account && account.langKey !== tmhDynamicLocale.get()) {
                        $rootScope.$emit("changeLanguage", { langKey: account.langKey });
                    }

                    if (Principal.hasAnyAuthority([constants.ROLE_PATIENT]) === true) {
                        if (checkLandingPage()) {
                            return;
                        }
                        if ($window.localStorage.getItem(constants.SURVEY_RESULT_ID)) {
                            getCurrentSurvey();
                        } else if ($window.localStorage.getItem(constants.NPQ_QUESTIONNAIRE_ID)) {
                            AgreementsWorkflowService.getCurrentAgreementWorkflow(null).then(function (res) {
                                setAgreement(res);
                                getTheMostRecentNPQQuestionnaire();
                            });
                        } else if ($window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID)) {
                            getTheMostRecentPsychIntakeForm();
                        } else if ($window.localStorage.getItem(constants.PATIENT_AGREEMENT_ID)) {
                            goToAgreementsWorkflow();
                        }
                    }
                    if (!vm.account) {
                        // clear all local storage
                        ClearLocalStorageService.clearAll();
                        ClearLocalStorageService.clearLandingPage();
                        ClearLocalStorageService.clearKeepLandingPage();
                        $sessionStorage.currentSurveyResultId = null;
                        clearLoginProcess();
                    }
                });

            }
        }

        function forwardToCurrentWorkflow() {
            if (checkLandingPage()) {
                return;
            }
            AgreementsWorkflowService.getCurrentAgreementWorkflow(null).then(function (res) {
                setAgreement(res);

                if ($localStorage.isQuestionnaireCount === true) {
                    goToNPQWorkflow();
                    return;
                } else if ($localStorage.isQuestionnaireCount === false) {
                    getCurrentSurvey();
                    return;
                }
                NPQQuestionnaireService.checkingStatusPatient().then(function (res) {
                    if (res) {
                        if (checkAgreementsWorkflow()) {
                            return;
                        } else
                            if (res.isFullyComplete) {
                                getCurrentSurvey();
                            } else if (res.isOpenCountDialog) {
                                vm.isQuestionnaireCount = true;
                                openQuestionnaireCountDialog(res.numberOfNpqNotYetComplete, null);
                            } else if (res.isOpenResumeDialog) {
                                vm.isQuestionnaireIncomplete = true;
                                openQuestionnaireResumeDialog();
                            } else {
                                goToNPQWorkflow();
                            }
                    } else {
                        if (
                            $localStorage.isQuestionnaireIncomplete === true
                        ) {
                            goToNPQWorkflow();
                        } else if (
                            $localStorage.isQuestionnaireIncomplete === false
                        ) {
                            getCurrentSurvey();
                        }
                    }
                });
            });
        }

        function getTheMostRecentNPQQuestionnaire() {
            // if local storage have npqQuestionairId we will get by id, else we get by most recent
            var npqQuestionnaireId = $window.localStorage.getItem(constants.NPQ_QUESTIONNAIRE_ID);
            NPQQuestionnaireService.getTheMostRecentNPQQuestionnaireOrById(npqQuestionnaireId).then(function (res) {
                if (res) {
                    goToNPQWorkflow();
                } else {
                    if ($window.localStorage.getItem(constants.NOWAIT)) {
                        vm.noWait = true;
                    }
                    getCurrentSurvey();
                }
            }).catch(function (error) {
                if ($window.localStorage.getItem(constants.NOWAIT)) {
                    vm.noWait = true;
                }
                getCurrentSurvey();
            });
        }

        function getTheMostRecentPsychIntakeForm() {
            // if local storage have psychIntakeFormId we will get by id, else we get by most recent
            var psychIntakeFormId = $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID);
            PsychIntakeService.getTheMostRecentPsychIntakeFormOrById(psychIntakeFormId).then(function (res) {
                if (res) {
                    goToPsychIntakeWorkflow();
                } else {
                    if ($window.localStorage.getItem(constants.NOWAIT)) {
                        vm.noWait = true;
                    }
                    getCurrentSurvey();
                }
            }).catch(function (error) {
                if ($window.localStorage.getItem(constants.NOWAIT)) {
                    vm.noWait = true;
                }
                getCurrentSurvey();
            });
        }

        function openQuestionnaireResumeDialog() {
            $uibModal.open({
                templateUrl: 'app/home/questionnaire-resume-dialog.html',
                controller: 'QuestionnaireResumeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center vertical-center'
            }).result.then(function (result) {
                if (result && result === true) {
                    // case yes
                    $localStorage.isQuestionnaireIncomplete = true;
                    goToNPQWorkflow();
                } else {
                    // case no
                    // getCurrentSurvey();
                    clearAndDirectToLandingPage();
                }
            }, function () {
                // case escape key
                // getCurrentSurvey();
                clearAndDirectToLandingPage();
            });
        }

        function openQuestionnaireCountDialog(countQuestionnaire, id) {
            $uibModal.open({
                templateUrl: 'app/home/questionnaire-count-dialog.html',
                controller: 'QuestionnaireCountDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowClass: 'absolute-center vertical-center',
                resolve: {
                    countQuestionnaire: function () {
                        return countQuestionnaire;
                    }
                }
            }).result.then(function (result) {
                if (result && result === true) {
                    // case yes
                    $localStorage.firstIdOfAllNPQQuestionnaireNotComplete = id;
                    $localStorage.isQuestionnaireCount = true;
                    vm.isQuestionnaireCount = false;
                    goToNPQWorkflow();
                } else {
                    // case no
                    // getCurrentSurvey();
                    clearAndDirectToLandingPage();
                }
            }, function () {
                // case escape key
                // getCurrentSurvey();
                clearAndDirectToLandingPage();
            });
        }

        function getCurrentSurvey() {
            // if local storage have surveyResultId we will get by id, else we get by most recent
            var surveyResultId = $window.localStorage.getItem(constants.SURVEY_RESULT_ID);
            SurveyResultService.getCurrentSurveyResult(vm.noWait, surveyResultId).then(function (res) {
                vm.isAdHocHaq = res ? res.isAdHoc : false;
                vm.surveyResultType = res ? res.surveyResultType : null;
                if ((res.allowStartNewBattery === null ||
                    res.allowStartNewBattery === true ||
                    vm.byPassRestriction) &&
                    res.isEmailConfirmed === false &&
                    res.disposition === true &&
                    !vm.isAdHocHaq &&
                    vm.surveyResultType != vm.SURVEY_RESULT_TYPE_BATTERY
                ) {
                    if (vm.noWait) {
                        $window.localStorage.setItem(constants.NOWAIT, true);
                    }
                    Principal.identity(false).then(function (account) {
                        vm.account = account;
                        vm.emailConfirmed = false;
                        vm.email = account.email === null ? account.email : account.email.trim();
                        vm.hasEmail = vm.email;
                        vm.injuredType = account.injuredType;
                        vm.patientInjuredTypes = account.injuredTypes ? account.injuredTypes : [];
                        vm.injuredTypes.forEach(function (item) {
                            item.checked = vm.patientInjuredTypes.indexOf(item.value) !== -1;
                            if (vm.patientInjuredTypes[0] && vm.patientInjuredTypes[0] === 'NONE') {
                                if (item.value !== 'NONE') {
                                    item.disabled = true;
                                }
                            } else {
                                if (vm.patientInjuredTypes.length > 0) {
                                    if (item.value === 'NONE') {
                                        item.disabled = true;
                                    }
                                }
                            }
                        });
                    });
                } else {
                    $window.localStorage.removeItem(constants.NOWAIT);
                    if (res.disposition == true) {
                        if (res.status !== 'COMPLETE' && res.status !== 'INCOMPLETE' && res.status !== 'NO_RESULT' && (res.allowStartNewBattery == null || res.allowStartNewBattery == true || vm.byPassRestriction)) {
                            // forward to survey workflow
                            if (res.goToCourseWorkflow) {
                                $state.go('course-registration-workflow');
                            } else {
                                $state.go('survey-workflow', { id: res.batteryTestId });
                            }
                        } else {
                            vm.isWorflowComplete = true;
                        }
                    } else {
                        vm.isInActive = true;
                    }
                }
                $localStorage.isQuestionnaireIncomplete = false;
                $localStorage.isQuestionnaireCount = false;
                vm.isQuestionnaireIncomplete = false;
                vm.isQuestionnaireCount = false;
            });
        }
        vm.getCurrentSurvey = getCurrentSurvey;

        function clearPassRestriction() {
            vm.byPassRestriction = false;
        }

        function clearLoginProcess() {
            vm.loginProcess = false;
        }


        function checkAgreementsWorkflow() {
            if (vm.agreement && !vm.agreement.isFinishAllAgreement) {
                goToAgreementsWorkflow();
                return true;
            }
            return false;
        }

        function goToAgreementsWorkflow() {
            $state.go('agreements-workflow');
        }

        function setAgreement(response) {
            vm.agreement = response ? response : null;
        }

        function goToNPQWorkflow() {
            // Check AgreementWorkflow before open NPQ Workflow, if AgreementWorkflow Not Complete, system will open Agreement Workflow
            if (checkAgreementsWorkflow()) {
                return;
            }
            $state.go('npq-questionnaire.workflow');
        }

        function goToPsychIntakeWorkflow() {
            // Check AgreementWorkflow before open Psych Intake Workflow, if AgreementWorkflow Not Complete, system will open Agreement Workflow
            if (checkAgreementsWorkflow()) {
                return;
            }
            $state.go('psych-intake.workflow');
        }

        function goToLandingPage() {
            $state.go('landing-page');
        }

        function checkLandingPage() {
            // landing page is null or false will open landing page
            var _landingPage = ClearLocalStorageService.getLandingPage();
            if (!_landingPage || !Boolean(_landingPage)) {
                goToLandingPage();
                return true;
            }
        }

        function clearAndDirectToLandingPage() {
            // allow open Resume NPQ next open
            vm.isQuestionnaireCount = null;
            vm.isQuestionnaireIncomplete = null;
            ClearLocalStorageService.clearAllAndWorkflow();
            goToLandingPage();
            return true;
        }

        function goToHAQEvaluationWorkflow() {
            Principal.identity(true).then(function (account) {
                vm.account = account;
                if (vm.account && vm.account.qhpUserDetail && vm.account.qhpUserDetail.tasks) {
                    var tasks = vm.account.qhpUserDetail.tasks;
                    if (tasks && tasks.length > 1) {
                        $state.go('qhp-workflow-landing-page');
                        return;
                    } else if (tasks && tasks[0] === constants.HAQ_EVALUATION) {
                        $state.go('haq-evaluation');
                        return;
                    } else if (tasks && tasks[0] === constants.CARE_PLAN_REVIEW) {
                        $state.go('care-plan-review');
                        return;
                    } else if (tasks && tasks[0] === constants.FRP_MDE) {
                        $state.go('frp-mde');
                        return;
                    } else if (tasks && tasks[0] === constants.INSTRUCTOR) {
                        $state.go('wellness-class-list');
                        return;
                    } else if (tasks && tasks[0] === constants.HAQ_BRIEF_REVIEW) {
                        $state.go('haq-brief-review');
                        return;
                    }
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('patientDetailController', patientDetailController);

    patientDetailController.$inject = ['$scope', '$state', '$window', 'Principal', 'ipmConstants', 'userDetails', 'frpMdeService', 'patient', 'supportedDataList', '$stateParams', '$uibModal', 'MdeReportService', 'FrpReportService', '$translate'];

    function patientDetailController($scope, $state, $window, Principal, ipmConstants, userDetails, frpMdeService, patient, supportedDataList, $stateParams, $uibModal, MdeReportService, FrpReportService, $translate) {
        var vm = this;

        vm.pageSize = 15;
        // config Page Report
        vm.predicate = 'f.startDate';
        vm.reverse = true;
        vm.page = 0;
        vm.totalItems = 0;

        // config Page Authorized
        vm.predicateAuthorized = 'id';
        vm.reverseAuthorized = true;
        vm.pageAuthorized = 0;
        vm.totalItemsAuthorized = 0;
        vm.loadAllAuthorizedHours = loadAllAuthorizedHours;

        vm.isFinish = true;
        vm.clear = clear;
        vm.save = save;
        vm.reports = {};
        vm.authorizedHours = {};
        vm.patient = {};
        vm.frpStatus = ipmConstants.FRP_STATUS;
        vm.offices = supportedDataList.officeList;
        vm.providers = supportedDataList.providerList;
        vm.frpPrograms = _.filter(supportedDataList.officeList, function(office) { return office.isFrpProgram || office.isViewFrpProgram });
        vm.mdeOffices = _.filter(supportedDataList.officeList, function(office) { return office.isMde || office.isViewMde });
        vm.isViewFrpProgram = isViewFrpProgram(patient.data.frpProgramId, vm.frpPrograms);
        vm.isViewMde = isViewMde(patient.data.mdeOfficeId, vm.mdeOffices);
        vm.editCaseNumber = false;
        vm.isDownLoading = false;
        vm.datePickerOpenStatus = {};
        vm.isDisabledStartDate = false;
        vm.isDeleting = false;
        vm.hoursAttendedCanNotExceed = ipmConstants.HOURS_ATTENDED_CAN_NOT_EXCEED; // default 160 hours
        vm.isSaving = false;
        init();

        function init() {
            patient.data.frpStartDate = patient.data.frpStartDate ? moment(patient.data.frpStartDate)._d : null;
            vm.patient = angular.copy(patient.data);
            setHoursAttendedCanNotExceed(vm.patient.sumHoursDaysAttended);
            loadAllAuthorizedHours();
            loadReport();
        }

        function loadReport() {
             var pageable = {
                page : vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.page === 0 ? vm.pageSize - 1 : vm.pageSize, //page 0 has 1 row mde report
                sort: sort()
            };

            frpMdeService.getReport($stateParams.id, pageable).then(function(response) {
                vm.reports = updateFormatTimeReport(response.data);
                vm.totalItems = response.totalItems;
                checkDisableStartDate();
            });
        }

        function setHoursAttendedCanNotExceed(sumHoursDaysAttended) {
            if (sumHoursDaysAttended && sumHoursDaysAttended > 0) {
                vm.hoursAttendedCanNotExceed = vm.hoursAttendedCanNotExceed - Number(sumHoursDaysAttended); // calc hours Attended Can Exceed
            }
        }

        function checkDisableStartDate(){
            if(vm.patient.frpStartDate) {
                vm.reports.forEach(function (report){
                    if(report.reportType ==='FRP' && report.status === 'FINALIZED') {
                        vm.isDisabledStartDate = true;
                    }
                })
            }
        }

        vm.loadAllReport = function () {
            loadReport();
        };

        vm.unChange = function (){
            return angular.equals(patient.data,  vm.patient);
        }

        vm.downloadFile = function(attachment){
            frpMdeService.downloadFile(attachment);
        }

        vm.updateEditCaseNumber = function (){
            vm.editCaseNumber = !vm.editCaseNumber;
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.uploadFile = function (files, authorizedHour) {
            var countFileValid = 0;
            var listType = ['tiff', 'docx', 'pdf'];
            files.forEach(function (element) {
                var names = element.name.split('.');
                var fileType = names[names.length - 1];
                listType.forEach(function (type) {
                    if(fileType == type) {
                        countFileValid ++;
                    }
                });
            });
            if(countFileValid != files.length){
                vm.errorDialog();
                return;
            }

            authorizedHour.files = files;
            frpMdeService.addUpdateRequestAuthorization(authorizedHour).then(function () {
                loadAllAuthorizedHours();
            });
        };

        function loadAllAuthorizedHours() {
            var pageable = {
                page: vm.pageAuthorized > 0 ? vm.pageAuthorized - 1 : vm.pageAuthorized,
                size: vm.pageSize,
                sort: sortAuthorized()
            };
            frpMdeService.getAuthorizedHours($stateParams.id, pageable).then(function(response) {
                vm.authorizedHours = response.data;
                vm.totalItemsAuthorized = response.totalItems;
                checkAddAuthorization();
            });
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function sortAuthorized() {
            return [vm.predicateAuthorized + ',' + (vm.reverseAuthorized ? 'asc' : 'desc')];
        }

         function checkAddAuthorization() {
            var isNull = false;
            if(vm.authorizedHours[0]) {
                for (var prop in vm.authorizedHours[0]) {
                    if(!vm.authorizedHours[0][prop]) {
                      isNull = true;
                    }
                }
                vm.isFinish = !isNull;
            }

        }

        vm.onChangeStartDate = function() {
            if(!vm.patient.frpStartDate || !moment(vm.patient.frpStartDate)._d) {
                vm.patient.frpStartDate = null;
            }
        }

        vm.onChangePreviouslyCompletedHours = function () {
            if (!vm.patient.previouslyCompletedHours && vm.patient.previouslyCompletedHours !==  0) {
                vm.patient.previouslyCompletedHours = null; // reset null if empty
            }
        }

        function clear(){
        	vm.patient = angular.copy(patient.data);
        	vm.editCaseNumber = false;
        }

        function save(){
            vm.isSaving = true;
        	frpMdeService.update(vm.patient).then(function(response) {
                loadReport();
                patient.data = angular.copy(vm.patient);
                vm.isSaving = false;
            });

        }

        function updateFormatTimeReport(report) {
            var isFirst = true;
            report.forEach(function(item) {
                if(isFirst) {
                    item.dateOfWeek = moment(item.dateOfWeek).format('MM/DD/YYYY') ;
                    isFirst = false;
                } else {
                    item.dateOfWeek = moment(item.dateOfWeek).format('MMM Do');
                }
            })
            return report;
        }

        vm.openReport = function (report) {
            if(report && report.reportType === 'MDE') {
                $state.go('mde-report', { id: report.id });
            } else if(report && report.reportType === 'FRP'){
                $state.go('frp-report', {id:report.id});
            }
        }

        vm.openViewReport = function(report) {
            if(report && report.status === "FINALIZED") {
                 vm.openReport(report);
            }
        }

        vm.downloadReport = function (report) {
            if (report && report.status === "FINALIZED") {
                if (report.reportType === 'MDE') {
                    downloadMDEReport(report.id);
                } else if (report.reportType === 'FRP') {
                    downloadFRPReport(report.id);
                }
            }
        }

        function downloadMDEReport(mdeReportId) {
            if (mdeReportId && !vm.isDownLoading) {
                vm.isDownLoading = true;
                MdeReportService.downloadMDEReport(mdeReportId).then(function (response) {
                    vm.isDownLoading = false;
                });
            }
        }

        function downloadFRPReport(frpReportId) {
            if (frpReportId && !vm.isDownLoading) {
                vm.isDownLoading = true;
                FrpReportService.downloadFrpReport(frpReportId).then(function (response) {
                    vm.isDownLoading = false;
                });
            }
        }

        function deleteReport(report,  password) {
            if (report) {
                vm.isDeleting = true;
                frpMdeService.deleteFRPMDEReport(report, password).then(function () {
                    vm.isDeleting = false;
                    loadReport();
                });
            }
        }

        vm.deleteReportClick = function (report) {
            vm.confirmDialogDeleteReport(report);
        }

        vm.checkDisableDeletedReport = function (report) {
            if (vm.isDeleting || (report && report.id && report.status === 'FINALIZED')) {
                return true;
            }
            return false;
        }

        vm.confirmDialogDeleteReport = function (report) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-password-dialog.html',
                controller: 'ConfirmPasswordDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center warning-dialog',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    isTranslate: function () {
                        return false
                    },
                    message: function () {
                        return $translate.instant('ipmApp.frpMde.dialogDeleteReport.confirmDelete');
                    },
                    title: function () {
                        return $translate.instant('ipmApp.frpMde.dialogDeleteReport.title');
                    },
                }
            }).result.then(function (result) {
                if (result) {
                    deleteReport(report, result);
                }
            });
        }

         vm.errorDialog = function () {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/notify-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message warning-dialog',
                size: 'sm',
                resolve: {
                    message: function () {
                        var message = {
                        'content': "ipmApp.patient.authorizedHours.errorMessage",
                         };
                        return message;
                    }
                }
            })
        }

        vm.changeFrpProgram = function() {
            vm.isViewFrpProgram = isViewFrpProgram(vm.patient.frpProgramId, vm.frpPrograms);
        }

        vm.changeMdeOffice = function() {
            vm.isViewMde = isViewMde(vm.patient.mdeOfficeId, vm.mdeOffices);
        }

        function isViewFrpProgram(frpProgramId, frpPrograms) {
            return !_.isEmpty(frpPrograms) && _.some(frpPrograms, function(item) { return item.id === frpProgramId && item.isViewFrpProgram });
        }

        function isViewMde(mdeOfficeId, mdeOffices) {
            return !_.isEmpty(mdeOffices) && _.some(mdeOffices, function(item) { return item.id === mdeOfficeId && item.isViewMde });
        }

        vm.isViewFrpMde = function() {
            return vm.isViewFrpProgram || vm.isViewMde;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('frp-mde', {
			parent: 'app',
			url: '/frp-mde?tab',
			data: {
				authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
				pageTitle: ''
			},
			views: {
				'content@': {
					templateUrl: 'app/frp-mde/frp-mde.html',
					controller: 'frpMdeController',
					controllerAs: 'vm'
				}
			},
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frpmde');
                    $translatePartialLoader.addPart('frpStatus');
                    $translatePartialLoader.addPart('reportStatus');
                    $translatePartialLoader.addPart('attendanceTracker');
					$translatePartialLoader.addPart('patientFrpMdeDetail');
					$translatePartialLoader.addPart('frpReport');
                    return $translate.refresh();
                }],
                supportedDataList: ['Auth', function(Auth) {
                    return Auth.getSupportedListRegister();
                }],
                userDetails: ['User', function (User) {
                    return User.getUserByCurrentLogin();
                }],
				frpPrograms: ['Principal', 'ipmConstants', 'userDetails', 'FrpProgramService', function (Principal, ipmConstants, userDetails, FrpProgramService) {
					var frpPrograms;
                    return Principal.identity(false).then(function(res) {
						if (Principal.hasAnyAuthority([ipmConstants.ROLE_STAFF]) === true) {
							frpPrograms  = userDetails.staffUserDetail ? userDetails.staffUserDetail.frpPrograms : [];
						} else if (Principal.hasAnyAuthority([ipmConstants.ROLE_QHP]) === true) {
							frpPrograms = userDetails.qhpUserDetail ? userDetails.qhpUserDetail.frpPrograms : [];
						} else if (Principal.hasAnyAuthority([ipmConstants.ROLE_ADMIN]) === true) {
							frpPrograms = FrpProgramService.findAll();
						}
						return frpPrograms;
					});
                }]

            },
            params: {
                tab: null
            }
		})
		.state('frp-mde-detail', {
			parent: 'frp-mde',
			url: '/{id}/detail',
			data: {
				authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
				pageTitle: ''
			},
			views: {
				'content@': {
					templateUrl: 'app/frp-mde/patient-frp-mde-detail.html',
					controller: 'patientDetailController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('patientFrpMdeDetail');
					return $translate.refresh();
				}],
				patient: ['frpMdeService', '$stateParams', function(frpMdeService, $stateParams) {
	                return frpMdeService.get($stateParams.id);
	            }],
	            supportedDataList: ['Auth', function(Auth) {
                    return Auth.getSupportedListRegister();
                }],
                userDetails: ['User', function (User) {
                    return User.getUserByCurrentLogin();
                }],
				isPatientActivated: ['frpMdeService',  '$stateParams', '$state' , function (frpMdeService, $stateParams, $state) {
                    frpMdeService.isPatientActivated($stateParams.id).then(function() {});
                 }]
			}

		})
		.state('frp-mde-detail.newRequest', {
			parent: 'frp-mde-detail',
			url: '/new-request',
			data: {
				authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
				pageTitle: ''
			},
			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/frp-mde/add-request-patient-detail-dialog.html',
					controller: 'addRequestPatientDetailController',
					controllerAs: 'vm',
					backdrop: 'static',
					windowClass: 'center-modal',
					size: 'md',
					resolve: {
						translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('patientFrpMdeDetail');
							return $translate.refresh();
						}],
						entity:  function() {
                            return {id: null, patientFRPMDEId : Number($stateParams.id), hoursRequested: null, hoursAuthorized: null, dateRequested: null, dateAuthorized: null, attachments: []};
                        }
					}
				}).result.then(function() {
					$state.go('frp-mde-detail', {searchUserParamsInfo: null}, { reload: true });
				}, function() {
					$state.go('^');
				});
			}]
		})
		.state('frp-mde-detail.editRequest', {
			parent: 'frp-mde-detail',
			url: '/{authorizedId}/edit-request',
			data: {
				authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
				pageTitle: ''
			},
			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/frp-mde/add-request-patient-detail-dialog.html',
					controller: 'addRequestPatientDetailController',
					controllerAs: 'vm',
					backdrop: 'static',
					windowClass: 'center-modal',
					size: 'md',
					resolve: {
						translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('patientFrpMdeDetail');
							return $translate.refresh();
						}],
						entity: ['frpMdeService', function(frpMdeService) {
                            return frpMdeService.getAuthorizedHoursById($stateParams.authorizedId);
                        }]
					}
				}).result.then(function() {
					$state.go('frp-mde-detail', {searchUserParamsInfo: null}, { reload: true });
				}, function() {
					$state.go('^');
				});
			}]
		})
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('frpMdeService', frpMdeService);

    frpMdeService.$inject = ['$http', 'halClient', '$q', 'DateUtils'];

    function frpMdeService ($http, halClient, $q, DateUtils) {
        var baseURL = 'api/frp-mde/';

        var service = {
            'frpMdeService': frpMdeService,
            'enrollPatient': enrollPatient,
            'enrollPatientById': enrollPatientById,
            'update': update,
            'getFPR': getFPR,
            'searchPatientFRPMDE': searchPatientFRPMDE,
            'searchEnrollPatient': searchEnrollPatient,
            'get': get,
            'getMDE': getMDE,
            'getReport': getReport,
            'getAuthorizedHours': getAuthorizedHours,
            'updateReport': updateReport,
            'inactivePatient': inactivePatient,
            'getAuthorizedHoursById': getAuthorizedHoursById,
            'addUpdateRequestAuthorization': addUpdateRequestAuthorization,
            'downloadFile': downloadFile,
            'deleteFRPMDEReport': deleteFRPMDEReport,
            "confirmPassword": confirmPassword,
            'isPatientActivated': isPatientActivated
        };

        /**
         *
         * @param {
         *  patientId, - required
         *  injuryDate, - required
         *  employer, - required
         *  title,
         *  caseInsurance,
         *  claimNumber, - required
         *  nurseCaseManager,
         *  applicantAttorney,
         *  providerId, - required
         *  OfficeId, - required
         *} data
         * @returns
         */
        function enrollPatient(data) {
            var url = baseURL + "add-enroll-patient";
            return $http.post(url, data).then(function (response) {
                return response;
            });
        };

        function enrollPatientById(patientFrpMdeId, frpStartDate) {
            var url = baseURL + patientFrpMdeId + '/enroll-patient';
            var data = { frpStartDate: DateUtils.convertLocalDateToServer(frpStartDate) };
            return $http.post(url, data).then(function (response) {
                return response;
            });
        };

        /**
         *
         * @param {
         *  mdeStatus, - required
         *  frpStatus, - required
         *  providerId, - required
         *  OfficeId, - required
         *} data
         * @returns
         */
        function update(patient) {
            var url = baseURL;
            var data = angular.copy(patient);
            if (data.frpStartDate) {
                data.frpStartDate = DateUtils.convertLocalDateToServer(data.frpStartDate);
            }
            return $http.put(url, data).then(function (response) {
                return response;
            });
        };

        function get(id) {
            var url = baseURL + id;
            return $http.get(url).then(function(response) {
                return response;
            });
        }

        function getFPR(param, pageable) {
            var deferred = $q.defer();
            var url = baseURL + "get-frp";
            return $http.get(url, {
                params: {
                    query: param.query,
                    patientId: param.patientId,
                    frpProgramIds: param.frpProgramIds,
                    startDate: param.startDate,
                    endDate: param.endDate,
                    frpStatus: param.frpStatus,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function searchPatientFRPMDE(param, pageable) {
            var deferred = $q.defer();
            var url = baseURL + "search-patient-frp-mde";
            return $http.get(url, {
                params: {
                    query: param.query,
                    patientId: param.patientId,
                    frpProgramIds: param.frpProgramIds,
                    startDate: param.startDate,
                    endDate: param.endDate,
                    frpStatus: param.frpStatus,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function searchEnrollPatient(param, pageable) {
            var deferred = $q.defer();
            var url = baseURL + "search-enroll-patient";
            return $http.get(url, {
                params: {
                    query: param.query,
                    frpProgramIds: param.frpProgramIds,
                    mdeStatus: param.mdeStatus,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function getMDE(param, pageable) {
            var url = baseURL + "get-mde";
            return $http.get(url, {
                params: {
                    patientId: param.patientId,
                    frpProgramIds: param.frpProgramIds,
                    mdeStatus: param.mdeStatus,
                    query: param.query,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).then(function (response) {
                return response;
            });
        };

        function inactivePatient(param, pageable) {
            var url = baseURL + "get-inactive-patients";
            return $http.get(url, {
                params: {
                    patientId: param.patientId,
                    frpProgramIds: param.frpProgramIds,
                    mdeStatus: param.mdeStatus,
                    frpStatus: param.frpStatus,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort,
                    query: param.query
                }
            }).then(function (response) {
                return response;
            });
        };

        function getReport(patientId, pageable) {
            var deferred = $q.defer();
            var url = baseURL + "get-reports";
            $http.get(url, {
                params: {
                    patientId: patientId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
             }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        function getAuthorizedHours(patientFRPMDEId, pageable) {
            var deferred = $q.defer();
            var url = baseURL + "get-authorized-hours";
            $http.get(url, {
                params: {
                    patientFRPMDEId: patientFRPMDEId,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        /**
         *
         * @param  {
         *  patientId, - required
         *  mdeStatus, - required
         *  frpStatus, - required
         *  providerId, - required
         *  OfficeId, - required
         *} data
         *
         * @returns
         */
        function updateReport(data) {
            var url = baseURL + "update-report";
            return $http.post(url, data).then(function (response) {
                return response;
            });
        };

        /**
         *
         * @param  id
         *
         * @returns
         */
        function getAuthorizedHoursById(id) {
            var url = baseURL + "get-authorized-hours";
            return $http.get(url + '/' + id).then(function (response) {
                return response.data;
            });
        };

        /**
         *
         * @param  {
         *  dateRequested, - required
         *  hoursRequested, - required
         *  dateAuthorized, - required
         *  hoursAuthorized, - required
         *  deleteFiles,
         *  newFiles
         *} data
         *
         * @returns
         */
        function addUpdateRequestAuthorization(data) {

            var formData = new FormData();

            formData.append('json', JSON.stringify(data));

            // new file
            _.forEach(data.files, function(file) {
                formData.append('newFiles', file);
            });
            var url = baseURL + "/add-update-request-authorization";
            return $http.post(url, formData,  {headers : {'Content-Type': undefined} }).then(function (response) {
                return response;
            });
        };

        /**
         *
         * @param  fileId
         *
         * @returns
         */
        function downloadFile(attachment) {
            var deferred = $q.defer();
            var url = 'api/frp-mde/files/' + attachment.id + '/download';
            $http({
                url: url,
                method: "GET",
                params: {},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var fileName = attachment.fileName;
                    var blob = new Blob([data], {type: contentType});
					saveAs(blob, fileName);
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        /**
         *
         * @param frpMdeReportListVM
         */
        function deleteFRPMDEReport(frpMdeReportListVM, password) {
            var url = baseURL + "delete-report";
            if (frpMdeReportListVM) {
                frpMdeReportListVM.dateOfWeek = null; // set null dateOfWeek (Oct 10th) to not format
                frpMdeReportListVM.password = password;
            }
            return $http.post(url , JSON.stringify(frpMdeReportListVM)).then(function (response) {
                return response;
            });
        }

        function confirmPassword(password) {
            var url = baseURL + "confirm-password";
            return $http.post(url, JSON.stringify({password: password})).then(function (response) {
                return response;
            });
        }

        function isPatientActivated(id) {
            var deferred = $q.defer();
            var url = baseURL + "is-patient-activated/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('frpMdeController', frpMdeController);

    frpMdeController.$inject = ['$scope', '$rootScope', '$state', '$window', '$uibModal', '$q', 'supportedDataList','Principal', 'ipmConstants', 'userDetails','frpMdeService', 'frpPrograms', '$stateParams', 'ClearLocalStorageService'];

    function frpMdeController($scope, $rootScope, $state, $window, $uibModal, $q, supportedDataList, Principal, ipmConstants, userDetails, frpMdeService, frpPrograms, $stateParams, ClearLocalStorageService) {
        var vm = this;
        vm.frpPrograms = frpPrograms;
        vm.searchPatient = searchPatient;
        vm.predicate ='pfm.id';
        vm.showPatientData = showPatientData;
        vm.searchResultEle = angular.element("#search-patient-auto-complete");
        vm.userDetails = userDetails;
        vm.frpProgramId = null;
        vm.tabFrp = 0;
        vm.tabMde = 1;
        vm.tabInactive = 2;
        vm.activeTabIndex = vm.tabFrp;
        vm.tabSelect = tabSelect;
        vm.patientSearchSelect = '';
        vm.isShowWarningMessagePreviousWeekNotFinalized = false;
        vm.isView = false;

        init();

        function init() {
            var paramTab = $stateParams && $stateParams.tab ? parseInt($stateParams.tab) : null;
            vm.activeTabIndex =  paramTab && paramTab <= vm.tabInactive && paramTab >= vm.tabFrp ? paramTab : vm.tabFrp;

            if (ClearLocalStorageService.getFRPProgram()) {
                vm.frpProgramId = Number(ClearLocalStorageService.getFRPProgram());
                var hasFRPProgramError = checkExistsFrpProgramError(vm.frpProgramId);
                if (hasFRPProgramError) {
                   setFrpProgramId();
                }
            } else if (vm.frpPrograms && vm.frpPrograms.length > 0) {
               setFrpProgramId();
            }

            setIsView();
        }

        function setIsView() {
            var frpProgramCurrent = getFrpProgramCurrent();
            vm.isView = frpProgramCurrent && !frpProgramCurrent.isFrpProgram && frpProgramCurrent.isViewFrpProgram;
        }

        function getFrpProgramCurrent() {
            if (vm.frpProgramId)
                return _.first(_.filter(vm.frpPrograms, function (frpProgram) {
                    return frpProgram && frpProgram.id === vm.frpProgramId;
                }));
        }

        function checkExistsFrpProgramError(frpProgramId) {
            var frpProgramsError = ClearLocalStorageService.getFRPProgramsError();
            if (_.isEmpty(frpProgramsError)) {
                return false;
            }
            return frpProgramsError.includes(frpProgramId);
        }

        function setFrpProgramId() {
            vm.frpProgramId = autoGetFRPProgramId();
            ClearLocalStorageService.setFRPProgram(vm.frpProgramId);
        }

        function autoGetFRPProgramId() {
            if (_.isEmpty(vm.frpPrograms)) {
                return null;
            }

            var frpPrograms = angular.copy(vm.frpPrograms);
            var frpProgramsError = ClearLocalStorageService.getFRPProgramsError();

            if (!_.isEmpty(frpProgramsError)) {
                frpPrograms = _.filter(frpPrograms, function(frpProgram) {
                    return !frpProgramsError.includes(frpProgram.id);
                });
            }
            // If frpPrograms is not empty, return the id of the first frpProgram;
            // otherwise, return the id of the default frpProgram
            return !_.isEmpty(frpPrograms) ? frpPrograms[0].id : vm.frpPrograms[0].id;
        }


        function searchPatient($item) {
            var inputData = $item ? $item : '';
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };
            var param = {
                patientId: null,
                frpProgramIds: vm.frpProgramId,
                frpStatus:null,
                startDate: null,
                query: inputData
            };
            return $q(function (resolve, reject) {
                frpMdeService.searchPatientFRPMDE(param, pageable).then(function (response) {
                    if (response.data && response.data.length) {
                        resolve(filterAutoCompletedPatientList(response.data));
                    }
                    resolve([]);
                },function () {
                    reject([]);
                });
            })
        }

        function filterAutoCompletedPatientList(data){
            var patients = _.compact(_.map(data, function(obj) {
                if (obj.patient){
                    return {
                        id: obj.id,
                        name: obj.patient.firstName + ' ' + obj.patient.lastName + " (" + obj.patient.patientId + ")"
                    }
                }
                return null;
            }));
            return patients;
        }

        function sort() {
            var  result = [vm.predicate + ',desc'];
            return result;
        }

        function showPatientData($item) {
            $state.go('frp-mde-detail', {'id': $item.id});
        }

        function addEnrollSuccess() {
            $scope.$broadcast(ipmConstants.ADD_ENROLL_SUCCESS);
        }

        function tabSelect(index) {
            vm.activeTabIndex = index;
            transitionTo();
        }

        function transitionTo() {
            $state.transitionTo($state.$current, {
                tab: vm.activeTabIndex,
            }, {notify: false});
        }

        vm.openPatientsDialog = function () {
            $uibModal.open({
                templateUrl: 'app/frp-mde/add-enroll-patients-dialog.html',
                controller: 'addEnrollPatientsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    frpPrograms: function () {
                        return supportedDataList.frpProgramsList;
                    },
                    selectedFrpProgram: function () {
                        return vm.frpProgramId
                    },
                    providers: function () {
                        return supportedDataList.providerList;
                    },
                    mdeOffices: ['MdeOfficeService', function (MdeOfficeService) {
                        return MdeOfficeService.findAll();
                    }]
                }
            }).result.then(function () {
                addEnrollSuccess();
            }, function () {
                // $state.go('^');
            });
        }

        vm.programChange = function() {
            $rootScope.$broadcast("CHANGE_PROGRAM_FRP_MDE_DROPDOWN", vm.frpProgramId);
            ClearLocalStorageService.setFRPProgram(vm.frpProgramId);
            setIsView();
        }

        $scope.$on(ipmConstants.EVT_LOG_OUT, function () {
            ClearLocalStorageService.clearFRPProgram();
            ClearLocalStorageService.clearFRPProgramsError();
        });

    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('FRPMDETemplateService', FRPMDETemplateService);

    FRPMDETemplateService.$inject = ['$resource', '$http', '$q'];

    function FRPMDETemplateService($resource, $http, $q) {
        var resourceUrl = "api/frp-mde-template";

        var service = $resource("api/frp-mde-template/:id", {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data = angular.toJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data = angular.toJson(data);
                    return data;
                }
            },
            'delete': { method: 'DELETE' }
        });

        service.getAllTemplateByInputTypes = getAllTemplateByInputTypes;

        function getAllTemplateByInputTypes(inputTypes) {
            var deferred = $q.defer();
            var url = resourceUrl;
            $http.get(url, {
                params: {
                    inputTypes: inputTypes
                }
            }).success(function (result) {
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('addRequestPatientDetailController', addRequestPatientDetailController);

    addRequestPatientDetailController.$inject = ['$scope', '$uibModalInstance', 'entity', 'frpMdeService', '$uibModal'];

    function addRequestPatientDetailController($scope, $uibModalInstance, entity, frpMdeService, $uibModal) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.authorizedHour = {};
        init(entity);
        vm.files = [];


        function init(data) {
            vm.authorizedHour = data;
            vm.authorizedHour.deleteFiles = [];
            if (data.dateRequested)
                vm.authorizedHour.dateRequested = moment(data.dateRequested)._d;
            if (data.dateAuthorized)
                vm.authorizedHour.dateAuthorized = moment(data.dateAuthorized)._d;

            vm.oldData = angular.copy(vm.authorizedHour);
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.save = function () {
            if (!vm.checkValidation()) {
                return;
            }
            vm.authorizedHour.files = vm.files;
            frpMdeService.addUpdateRequestAuthorization(vm.authorizedHour);
            $uibModalInstance.close('saved');
        }

        vm.checkValidation = function(){
            if(vm.authorizedHour.dateRequested && vm.authorizedHour.hoursRequested) {
                return true;
            }

            if(vm.authorizedHour.dateAuthorized && vm.authorizedHour.hoursAuthorized) {
                 return true;
            }

            return false;
        }

        vm.unChanged = function() {
            return angular.equals(vm.oldData, vm.authorizedHour);
        }

        vm.uploadFile = function (files) {
            var countFileValid = 0;
            var listType = ['tiff', 'docx', 'pdf'];
            files.forEach(function (element) {
                var names = element.name.split('.');
                var fileType = names[names.length - 1];
                listType.forEach(function (type) {
                    if(fileType == type) {
                        countFileValid ++;
                    }
                });
            });
            if(countFileValid != files.length){
                vm.errorDialog();
                return;
            }
            files.forEach(function (element) {
                var names = element.name.split('.');
                vm.authorizedHour.attachments.push({
                    fileName: element.name,
                    fileExt: names[names.length - 1]
                })
                vm.files.push(element);
            });
        }

        vm.confirmDialog = function (value) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message warning-dialog',
                size: 'sm',
                resolve: {
                    message: function () {
                        var message = {
                        'content': "ipmApp.patient.authorizedHours.message",
                        'param': value.fileName
                         };
                        return message;
                    }
                }
            }).result.then(function (result) {
                if(result) {
                    vm.deleteFile(value);
                }
            });
        }

       vm.errorDialog = function () {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/notify-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message warning-dialog',
                size: 'sm',
                resolve: {
                    message: function () {
                        var message = {
                        'content': "ipmApp.patient.authorizedHours.errorMessage",
                         };
                        return message;
                    }
                }
            })
        }

        vm.deleteFile = function (item) {
            vm.authorizedHour.deleteFiles.push(item);
            vm.authorizedHour.attachments = vm.authorizedHour.attachments.filter(function(value, index, arr){
               return !angular.equals(value, item);
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('addEnrollPatientsController', addEnrollPatientsController);

    addEnrollPatientsController.$inject = [
        '$scope',
        '$uibModalInstance',
        '$q',
        'frpMdeService',
        'Patient',
        'frpPrograms',
        'providers',
        'selectedFrpProgram',
        'mdeOffices'
    ];

    function addEnrollPatientsController(
        $scope,
        $uibModalInstance,
        $q,
        frpMdeService,
        Patient,
        frpPrograms,
        providers,
        selectedFrpProgram,
        mdeOffices
    ) {
        var vm = this;
        var searchEle = null,
            searchFormGroupEle = null
            ;
        // vm.validPatient = true,
        vm.searchResultEle = null;
        vm.isShowCalendar = false;
        vm.searchPatient = searchPatient;
        vm.setPatientNameAndChartNumber = setPatientNameAndChartNumber;
        vm.modalLoaded = modalLoaded;
        vm.patient = {
            frpProgramId: selectedFrpProgram
        };
        vm.frpPrograms = frpPrograms;
        vm.providers = providers;
        vm.mdeOffices = mdeOffices;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.clear = clear;
        vm.dateOptions = {maxDate: new Date()};
        vm.dateFormat = "MM/dd/yyyy";
        vm.checkValidPatient = checkValidPatient;
        vm.isExistsEnroll = false;
        init();

        function openCalendar() {
            vm.isShowCalendar = true;
        }

        function init() {
            setDefaultMdeOfficeId();
        }

        function setDefaultMdeOfficeId() {
            if (vm.mdeOffices && vm.frpPrograms) {
                var frpProgramSelected = _.first(_.filter(vm.frpPrograms, function (frp) {
                    return frp && frp.id === selectedFrpProgram;
                }));
                var mdeOfficeSelected = _.first(_.filter(vm.mdeOffices, function (item) {
                    return item && frpProgramSelected && item.officeCode === frpProgramSelected.officeCode;
                }));
                if (mdeOfficeSelected) {
                    vm.patient.mdeOfficeId = mdeOfficeSelected.id;
                }
            }
        }

        function searchPatient($item, $model, $label, $event) {
            var inputData = $item ? $item : '';
            return $q(function (resolve, reject) {
                Patient.findByNameOrChartNumber(inputData, null, 0).then(
                    function (response) {
                        resolve(response.data);
                        // vm.validPatient = response.data.length !== 0 ;
                    },
                    function () {
                        reject([]);
                        // vm.validPatient = false;
                    }
                );

            });
        }


        function setPatientNameAndChartNumber() {
            // vm.validPatient = true;
            vm.patient.patientId = vm.searchValue.id;
            vm.patient.patientName = vm.searchValue.firstName + ' ' + vm.searchValue.lastName;
            vm.patient.chartNumber = vm.searchValue.chartNumber;
        }

        function modalLoaded() {
            vm.searchResultEle = angular.element(
                '#search-patient-auto-complete-modal'
            );
            searchEle = angular.element('#modalPatientSearch');
            searchFormGroupEle =
                searchEle && searchEle.parents('.form-group.typeahead');
        }

        function fixSearchGroupValidateStyle(invalid) {
            searchFormGroupEle.toggleClass('has-error', invalid);
        }

        function checkValidPatient() {
            vm.isExistsEnroll = false;
            // vm.validPatient = vm.patient.patientId !== undefined;
        }

        // $scope.$watch('vm.validPatient', function(newVal) {
        //     vm.addEnrollPatientForm.searchPatient.$setValidity(
        //         'required',
        //         newVal
        //     );
        //     fixSearchGroupValidateStyle(newVal);
        // });
        $scope.$watch('vm.patient.injuryDate', function(newVal) {
            if (newVal) {
                vm.addEnrollPatientForm.injuryDate.$setValidity(
                    'wrongDate',
                    newVal <= new Date()
                );
            }
        });


        function save() {
            vm.patient.providerId = vm.patient.provider.id;
            frpMdeService.enrollPatient(vm.patient).then(
                function (response) {
                    vm.isExistsEnroll = false;
                    $uibModalInstance.close();
                },
                function (error) {
                    vm.isExistsEnroll = true;
                }
            );
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('download-result', {
            parent: 'app',
            url: '/download-result',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadResult'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-result/download-result.html',
                    controller: 'DownloadResultController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadResult');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadResultController', DownloadResultController);

        DownloadResultController.$inject = ['$state', '$filter', '$stateParams', '$window', 'NPQQuestionnaireService', 'DateUtils'];

    function DownloadResultController ($state, $filter, $stateParams, $window, NPQQuestionnaireService, DateUtils) {
        var vm = this;
        vm.downloadResult = downloadResult;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.inValidDates = false;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        
        init();
        
        function init() {            

            // set to Monday of this week
        	vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
        	// set to previous Monday
        	vm.fromDate.setDate(vm.fromDate.getDate() - 7);
        	
        	// set to previous Friday
        	vm.toDate = new Date(vm.fromDate);
        	vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function downloadResult() {
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            vm.noPdf = false;
            NPQQuestionnaireService.downloadQuestionnaire(fromDate, toDate).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-psych-intakes', {
            parent: 'app',
            url: '/download-psych-intakes',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadPsychIntake'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-psych-intakes/download-psych-intakes.html',
                    controller: 'DownloadPsychIntakesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadResult');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadPsychIntakesController', DownloadPsychIntakesController);

        DownloadPsychIntakesController.$inject = ['$filter', 'PsychIntakeService', 'DateUtils'];

    function DownloadPsychIntakesController ($filter, PsychIntakeService, DateUtils) {
        var vm = this;
        vm.download = download;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.inValidDates = false;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        
        init();
        
        function init() {

            // set to Monday of this week
        	vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
        	// set to previous Monday
        	vm.fromDate.setDate(vm.fromDate.getDate() - 7);
        	
        	// set to previous Friday
        	vm.toDate = new Date(vm.fromDate);
        	vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function download() {
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            vm.noPdf = false;
            PsychIntakeService.downloadPsychIntakes(fromDate, toDate).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('RequestHAQResultsReportsController', RequestHAQResultsReportsController);

    RequestHAQResultsReportsController.$inject = ['FileDownloadService', '$stateParams', '$state'];

    function RequestHAQResultsReportsController (FileDownloadService, $stateParams, $state) {
        var vm = this;
        vm.download = download;
        vm.noPdf = false;
        vm.secretKey = null;
        vm.validDownload = false;
        vm.isProcessing = false;
        init();

        function init() {
            vm.secretKey = $stateParams.secretKey;
            FileDownloadService.getFileDownloadBySecretKey(vm.secretKey).then(function (response) {
                if (response && response.status === 200) {
                    vm.validDownload = true;
                }
            }, function error(e) {
                if (e && e.status === 404) {
                    $state.go('accessdenied');
                } else { // BAD_REQUEST
                    $state.go('error');
                }
            });
        }

        function download() {
            if (vm.validDownload) {
                vm.isProcessing = true;
                FileDownloadService.downloadReport(vm.secretKey).then(function (res) {
                    vm.isProcessing = false;
                    if (res === 204) {
                        vm.noPdf = true;
                    }
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-haq-results-reports', {
            parent: 'app',
            url: '/download-haq-results-reports',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.downloadHAQResultsReports.home.pageTitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-haq-results-reports/download-haq-results-reports.html',
                    controller: 'DownloadHAQResultsReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadHAQResultsReports');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                isAdhoc: function () {
                    return false;
                }
            },
        }).state('download-adhoc-tests-reports', {
            parent: 'app',
            url: '/download-adhoc-tests-reports',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.downloadAdhocTestsReports.home.pageTitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-haq-results-reports/download-haq-results-reports.html',
                    controller: 'DownloadHAQResultsReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadHAQResultsReports');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                isAdhoc: function () {
                    return true;
                }
            }
        }).state('download-haq-results-reports.requested', {
            parent: 'download-haq-results-reports',
            url: '/requested/{secretKey}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadActivityReport'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-haq-results-reports/request-haq-results-reports.html',
                    controller: 'RequestHAQResultsReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadHAQResultsReports');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadHAQResultsReportsController', DownloadHAQResultsReportsController);

    DownloadHAQResultsReportsController.$inject = ['$state', '$filter', '$stateParams', '$window', 'SurveyResultService', 'DateUtils', 'isAdhoc', '$uibModal', '$interval', '$scope', 'ClearLocalStorageService', 'FileDownloadService', '$uibModalStack'];

    function DownloadHAQResultsReportsController ($state, $filter, $stateParams, $window, SurveyResultService, DateUtils, isAdhoc, $uibModal, $interval, $scope, ClearLocalStorageService, FileDownloadService, $uibModalStack) {
        var vm = this;
        var intervalLimitTimeDownload = null;
        var intervalCheckStatusDownload = null;
        vm.download = download;
        vm.checkProcessingDownload = checkProcessingDownload;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.isDownloadingHasSentMail = false;
        vm.inValidDates = false;
        vm.isAdhoc = isAdhoc;
        vm.isProcessing = false;
        vm.isProcessingDownload = false;
        vm.limitTimeMillisSecondsDownload = 1000*60*2; // 120 seconds
        vm.limitTimeRequestCheckStatus = 1000 * 30; // 30 seconds
        vm.limitTimeStart = null;
        vm.hasOpenningDialogRequest = false;
        vm.sessionDownloadId = null;
        vm.account = null;
        vm.fileDownload = null;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        init();

        function init() {
            // set to Monday of this week
        	vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
        	// set to previous Monday
        	vm.fromDate.setDate(vm.fromDate.getDate() - 7);

        	// set to previous Friday
        	vm.toDate = new Date(vm.fromDate);
        	vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function setSessionDownload() {
            vm.sessionDownloadId = new Date().getTime().toString(); // sessionDownloadId = account.id + '_' + timestamp. account.id will add after submit download
        }

        function createFileDownload(fromDate, toDate, sessionDownloadId) {
            vm.fileDownload = {
                fromDate: fromDate,
                toDate: toDate,
                sessionDownloadId: sessionDownloadId
            };
            return vm.fileDownload;
        }

        function download() {
            if (vm.isProcessingDownload === true) {
                return;
            }
            vm.isProcessingDownload = true;

            setSessionDownload();
            resetIntervalLimitTime();
            startIntervalLimitTimeDownload();
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            vm.noPdf = false;
            vm.isDownloadingHasSentMail = false;
            var fileDownload = createFileDownload(fromDate, toDate, vm.sessionDownloadId);
            FileDownloadService.createSessionDownload(fileDownload).then(function (result) {
                onSaveSuccess(result, fromDate, toDate);
            }).catch(function (error) {
                onSaveError(error);
            });
        }

        function onSaveSuccess(result, fromDate, toDate) {
            var adhocReport = vm.isAdhoc;
            if (result) {
                vm.fileDownload.id = result.id;
                SurveyResultService.downloadHAQResultsReports(fromDate, toDate, adhocReport, vm.fileDownload.id).then(function (res) {
                    vm.isProcessing = false;
                    vm.isProcessingDownload = false;
                    var typeDownload = 'SEND_MAIL';
                    if (res.status === 204 && res.statusDownload && res.statusDownload === typeDownload) {
                        vm.isDownloadingHasSentMail = true;
                    } else if (res.status === 204) {
                        vm.noPdf = true;
                        vm.isDownloadingHasSentMail = false;
                    } else if (res.status === 200 && vm.hasOpenningDialogRequest) {
                        closeForceDialog();
                    }
                    stopIntervalLimitTimeDownload();
                }).catch(function (error) {
                    onSaveError(error);
                });
            }
        }

        function onSaveError(error) {
            vm.isProcessingDownload = false;
            stopIntervalLimitTimeDownload();
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };

        function checkProcessingDownload() {
            return vm.isProcessingDownload === true || vm.isProcessing === true;
        }

        function requestSendMailDownloadHAQ(id) {
            vm.isProcessing = true;
            stopIntervalLimitTimeDownload();
            var data = {
                typeDownload: 'SEND_MAIL'
            };
            FileDownloadService.updateTypeDownloadFileHAQ(id, data).then(function (res) {
                vm.isProcessing = false;
                if (res && res.status !== 200) {
                    console.warn('The download process has finished, but the email update was not successful.');
                }
            });

        }

        function checkAndOpenDialogRequestDownloadHAQ() {
            if (vm.fileDownload && vm.fileDownload.id) {
                FileDownloadService.getDownloadStatusBy(vm.fileDownload.id).then(function (res) {
                    if (res && res.status && res.status === 'GENERATING') {
                        openDialogRequestDownloadHAQ();
                        startIntervalCheckStatusDownload();
                    } else { // create pdf completed, not update request send mail
                        stopIntervalLimitTimeDownload();
                    }
                });
            }
        }

        function openDialogRequestDownloadHAQ() {
            vm.hasOpenningDialogRequest = true;
            $uibModal.open({
                templateUrl: 'app/shared/confirm-download-dialog/confirm-download-dialog.controller.html',
                controller: 'ConfirmDownloadController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message warning-dialog',
                backdrop: 'static',
                size: 'sm'
            }).result.then(function (result) {
                if (result) { // Yes
                    requestSendMailDownloadHAQ(vm.fileDownload.id);
                }
                // case No
                stopIntervalLimitTimeDownload();
                stopIntervalCheckStatusDownload();
            });
        }

        function resetIntervalLimitTime() {
            vm.limitTimeStart = moment();
            vm.hasOpenningDialogRequest = false;
        }

        function stopIntervalLimitTimeDownload() {
            if (intervalLimitTimeDownload) {
                clearInterval(intervalLimitTimeDownload);
                $interval.cancel(intervalLimitTimeDownload);
            }
        }

        function startIntervalLimitTimeDownload() {
            intervalLimitTimeDownload = setInterval(function () {
                runIntervalLimitTimeDownload();
            }, 1000); // 1 seconds
        }
        function stopIntervalCheckStatusDownload() {
            if (intervalCheckStatusDownload) {
                clearInterval(intervalCheckStatusDownload);
                $interval.cancel(intervalCheckStatusDownload);
            }
        }

        function startIntervalCheckStatusDownload() {
            intervalCheckStatusDownload = setInterval(function () {
                runIntervalCheckStatusDownload();
            }, vm.limitTimeRequestCheckStatus); // 30 seconds
        }

        function runIntervalLimitTimeDownload() {
            var millisDiff = moment().diff(vm.limitTimeStart);
            if (millisDiff > vm.limitTimeMillisSecondsDownload) {
                var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
                var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
                if (!vm.hasOpenningDialogRequest) {
                    checkAndOpenDialogRequestDownloadHAQ();
                }
                // stop interval
                stopIntervalLimitTimeDownload();
            }
        }

        function runIntervalCheckStatusDownload(){
            FileDownloadService.getDownloadStatusBy(vm.fileDownload.id).then(function (res) {
                if (res && res.status && res.status !== 'GENERATING') {
                    closeForceDialog();
                    stopIntervalCheckStatusDownload(); // stop interval
                }
            });
        }

        function closeForceDialog() {
            $uibModalStack.dismissAll();
        }

        $scope.$on('$destroy', function () {
            stopIntervalLimitTimeDownload();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('download-haq-evaluation', {
            parent: 'app',
            url: '/download-haq-evaluation',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.haqEvaluationResults'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-haq-evaluation/download-haq-evaluation.html',
                    controller: 'DownloadHaqEvaluationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadHaqEvaluation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadHaqEvaluationController', DownloadHaqEvaluationController);

    DownloadHaqEvaluationController.$inject = ['$state', '$filter', '$stateParams', '$window', 'HAQEvaluationWorkflowService', 'DateUtils'];

    function DownloadHaqEvaluationController ($state, $filter, $stateParams, $window, HAQEvaluationWorkflowService, DateUtils) {
        var vm = this;
        vm.downloadHaqEvaluation = downloadHaqEvaluation;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.inValidDates = false;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        init();

        function init() {

            // set to Monday of this week
        	vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
        	// set to previous Monday
        	vm.fromDate.setDate(vm.fromDate.getDate() - 7);

        	// set to previous Friday
        	vm.toDate = new Date(vm.fromDate);
        	vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function downloadHaqEvaluation() {
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            vm.noPdf = false;
            HAQEvaluationWorkflowService.downloadHaqEvaluation(fromDate, toDate).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-detailed-adhoc-testing', {
            parent: 'app',
            url: '/download-detailed-adhoc-testing',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.entities.detailedAdhocTesting'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-detailed-adhoc-testing/download-detailed-adhoc-testing.html',
                    controller: 'DownloadDetailedAdhocTestingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adhoc-testing');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                tests: ['Test', function (Test) {
                    return Test.getAllActiveAdhocTests();
                }],
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadDetailedAdhocTestingController', DownloadDetailedAdhocTestingController);

    DownloadDetailedAdhocTestingController.$inject = ['$filter', 'AdhocTestingService', '$uibModal', '$interval', '$scope', 'ipmConstants', 'tests', 'DateUtils'];

    function DownloadDetailedAdhocTestingController ($filter, AdhocTestingService, $uibModal, $interval, $scope, ipmConstants, tests, DateUtils) {
        var vm = this;
        vm.download = download;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        vm.limitTimeMillisSecondsDownload = 1000*30; // 30 seconds
        vm.limitTimeStart = null;
        vm.hasSubmitedRequestDownloadCsv = false;
        vm.hasOpenningDialogRequest = false;
        vm.tests = tests;
        vm.selectedTest = tests[0];
        vm.invalidDates = false;

        init();

        function init() {
            vm.fromDate.setDate(vm.fromDate.getDate() - 30);
        }

        function download() {
            vm.isProcessing = true;
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            downloadCsvDetailedAdhocTesting(fromDate, toDate, vm.selectedTest);
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };

        function downloadCsvDetailedAdhocTesting(fromDate, toDate, selectedTest) {
            vm.noPdf = false;
            AdhocTestingService.downloadCsvDetailedAdhocTesting(fromDate, toDate, selectedTest.id).then(function(res) {
                vm.isProcessing = false;
                if (res === 204) { // SC_NO_CONTENT
                    vm.noPdf = true;
                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('RequestCaseExclusionsController', RequestCaseExclusionsController);

    RequestCaseExclusionsController.$inject = ['CaseExclusionsService', '$stateParams', '$state', 'User'];

    function RequestCaseExclusionsController (ActivityReportService, $stateParams, $state, User) {
        var vm = this;
        vm.download = download;
        vm.isUserRequest = false;
        vm.noPdf = false;

        init();

        function init() {
            vm.fileId = $stateParams.id;
            User.getUserByCurrentLogin().then(function (response) {
                var currentUser = response;
                vm.isUserRequest = currentUser.id === Number($stateParams.user);
                if (!vm.isUserRequest) {
                    $state.go('home');
                }
            });
        }

        function download() {
            CaseExclusionsService.downloadReport(vm.fileId).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-case-exclusions', {
            parent: 'app',
            url: '/download-case-exclusions',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.caseExclusions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-case-exclusions/download-case-exclusions.html',
                    controller: 'DownloadCaseExclusionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('case-exclusions');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('/download-case-exclusions.requested', {
            parent: 'download-case-exclusions',
            url: '/requested/{id}?user',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.caseExclusions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-case-exclusions/request-case-exclusions.html',
                    controller: 'RequestCaseExclusionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadActivityReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });

    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('CaseExclusionsService', CaseExclusionsService);

    CaseExclusionsService.$inject = ['$http', '$q', 'DownloadBlobService'];

    function CaseExclusionsService ($http, $q, DownloadBlobService) {
        var resourceUrl = "api/case-exclusions";

        var service = {
            'downloadCsvCaseExclusions': downloadCsvCaseExclusions,
            'requestDownloadCsvCaseExclusions': requestDownloadCsvCaseExclusions,
            'downloadReport': downloadReport
        };

        function downloadCsvCaseExclusions(fromDate, toDate, serviceFilters) {
            var deferred = $q.defer();
            var url = resourceUrl + '/download';
            var body = {fromDate: fromDate, toDate: toDate, serviceFilters: serviceFilters};
            $http.post(url, body).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function requestDownloadCsvCaseExclusions(fromDate, toDate, serviceFilters) {
            var deferred = $q.defer();
            var url = resourceUrl + '/request';
            var body = {fromDate: fromDate, toDate: toDate, serviceFilters: serviceFilters}
            $http.post(url, body)
            .success(function (response) {
                deferred.resolve(response);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function downloadReport(fileId) {
            var deferred = $q.defer();
            var url = 'api/case-exclusions/download-report/' + fileId;
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadCaseExclusionsController', DownloadCaseExclusionsController);

    DownloadCaseExclusionsController.$inject = ['$filter', 'CaseExclusionsService', '$uibModal', '$interval', '$scope', 'ipmConstants', 'DateUtils'];

    function DownloadCaseExclusionsController ($filter, CaseExclusionsService, $uibModal, $interval, $scope, ipmConstants, DateUtils) {
        var vm = this;
        vm.download = download;
        vm.loadServiceDetails = loadServiceDetails;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.isChangeService = false;
        vm.caseExclusionsTypes = ipmConstants.CASE_EXCLUSIONS_TYPES;
        vm.caseExclusionDetailsTypes = ipmConstants.CASE_EXCLUSION_DETAIL_TYPES;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        vm.limitTimeMillisSecondsDownload = 1000*30; // 30 seconds
        vm.limitTimeStart = null;
        vm.hasSubmitedRequestDownloadCsv = false;
        vm.hasOpenningDialogRequest = false;
        vm.caseExclusionsFilter = [];
        var intervalLimitTimeDownload = null;
        vm.inValidDates = false;

        init();

        function init() {

            vm.fromDate.setDate(vm.fromDate.getDate() - 30);

            _.forEach(vm.caseExclusionDetailsTypes, function (detailType) {
                vm.caseExclusionsFilter.push({type: detailType, isExcluded: null, isHidden: false});
            });
        }

        function download() {
            vm.isProcessing = true;
            resetIntervalLimitTime();
            startIntervalLimitTimeDownload();
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            var serviceFilters= vm.caseExclusionsFilter;
            downloadCsvCaseExclusions(fromDate, toDate, serviceFilters);
        }

        function loadServiceDetails() {
            if (!vm.caseExclusionsType) {
                _.forEach(vm.caseExclusionsFilter, function (detailType) {
                    detailType.isHidden = false;
                })
            } else {
                _.forEach(vm.caseExclusionsFilter, function (detailType) {
                    if (ipmConstants.CASE_EXCLUSIONS_MAP[detailType.type] === vm.caseExclusionsType) {
                        detailType.isHidden = false;
                    } else {
                        detailType.isHidden = true;
                    }
                })
            }
            vm.isChangeService = true;
        }

        function requestDownloadCsvCaseExclusions(fromDate, toDate, caseExclusionsType, isExcluded) {
            if (!vm.hasSubmitedRequestDownloadCsv) {
                vm.isProcessing = true;
                CaseExclusionsService.requestDownloadCsvCaseExclusions(fromDate, toDate, caseExclusionsType, isExcluded).then(function (res) {
                    vm.isProcessing = false;
                    vm.noPdf = false;
                    vm.hasSubmitedRequestDownloadCsv = true;
                });
            }
            stopIntervalLimitTimeDownload();
        }

        function downloadCsvCaseExclusions(fromDate, toDate, serviceFilters) {
            vm.noPdf = false;
            CaseExclusionsService.downloadCsvCaseExclusions(fromDate, toDate, serviceFilters).then(function(res) {
                vm.isProcessing = false;
                vm.isChangeService = false;
                if (res === 204) { // SC_NO_CONTENT
                    vm.noPdf = true;
                }
                if (res === 509) { // BANDWIDTH_LIMIT_EXCEEDED
                    if (!vm.hasOpenningDialogRequest)
                        openDialogRequestDownloadCsvCaseExclusions(fromDate, toDate, serviceFilters);
                }
                // call stop interval when download empty < 30s
                stopIntervalLimitTimeDownload();
            });
        }

        function openDialogRequestDownloadCsvCaseExclusions(fromDate, toDate, serviceFilters) {
            vm.hasOpenningDialogRequest = true;
            $uibModal.open({
                templateUrl: 'app/shared/confirm-download-dialog/confirm-download-dialog.controller.html',
                controller: 'ConfirmDownloadController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message warning-dialog',
                backdrop: 'static',
                size: 'sm'
            }).result.then(function (result) {
                if (result) { // Yes
                    requestDownloadCsvCaseExclusions(fromDate, toDate, serviceFilters);
                }
                // case No
                stopIntervalLimitTimeDownload();
                resetProcessingDownload();
            });
        }

        function resetProcessingDownload() {
            vm.isProcessing = false;
        }

        function resetIntervalLimitTime() {
            vm.hasSubmitedRequestDownloadCsv = false;
            vm.limitTimeStart = moment();
            vm.hasOpenningDialogRequest = false;
        }

        function stopIntervalLimitTimeDownload() {
            if (intervalLimitTimeDownload) {
                clearInterval(intervalLimitTimeDownload);
                $interval.cancel(intervalLimitTimeDownload);
            }
        }

        function startIntervalLimitTimeDownload() {
            intervalLimitTimeDownload = setInterval(function () {
                runIntervalLimitTimeDownload();
            }, 2000); // 2 seconds
        }

        function runIntervalLimitTimeDownload() {
            var millisDiff = moment().diff(vm.limitTimeStart);
            if (millisDiff > vm.limitTimeMillisSecondsDownload) {
                var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
                var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
                if (!vm.hasOpenningDialogRequest) {
                    openDialogRequestDownloadCsvCaseExclusions(fromDate, toDate);
                }
                // stop interval
                stopIntervalLimitTimeDownload();
            }
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };

        $scope.$on('$destroy', function () {
            stopIntervalLimitTimeDownload();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-care-plan-review', {
            parent: 'app',
            url: '/download-care-plan-review',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadCarePlanReview'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-care-plan-review/download-care-plan-review.html',
                    controller: 'DownloadCarePlanReviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadCarePlanReview');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadCarePlanReviewController', DownloadCarePlanReviewController);

    DownloadCarePlanReviewController.$inject = ['$state', '$filter', '$stateParams', '$window', 'CarePlanReviewService', 'DateUtils'];

    function DownloadCarePlanReviewController ($state, $filter, $stateParams, $window, CarePlanReviewService, DateUtils) {
        var vm = this;
        vm.download = download;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.inValidDates = false;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        init();

        function init() {

            // set to Monday of this week
        	vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
        	// set to previous Monday
        	vm.fromDate.setDate(vm.fromDate.getDate() - 7);

        	// set to previous Friday
        	vm.toDate = new Date(vm.fromDate);
        	vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function download() {
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            vm.noPdf = false;
            CarePlanReviewService.downloadCarePlanReview(fromDate, toDate).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('download-battery-results', {
                parent: 'app',
                url: '/download-battery-results',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                    pageTitle: 'global.menu.entities.downloadBatteryResults'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/download-battery-results/download-battery-results.html',
                        controller: 'DownloadBatteryResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('downloadResult');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadBatteryResultController', DownloadBatteryResultController);

    DownloadBatteryResultController.$inject = ['$state', '$filter', 'SurveyResultService', 'DateUtils'];

    function DownloadBatteryResultController($state, $filter, SurveyResultService, DateUtils) {
        var vm = this;
        vm.download = download;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.invalidDates = false;

        vm.datePickerOpenStatus = { fromDate: false, toDate: false };
        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };

        init();

        function init() {
            // set startDate to Monday of this week
            vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
            // set startDate to previous Monday
            vm.fromDate.setDate(vm.fromDate.getDate() - 7);

            // set endDate to previous Friday
            vm.toDate = new Date(vm.fromDate);
            vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function download() {
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            vm.noPdf = false;
            SurveyResultService.downloadBatteryResultsReports(fromDate, toDate).then(function (res) {
                vm.isProcessing = false;
                if(res && res.status === 204) {
                    vm.noPdf = true;
                }
            });
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('download-agreements', {
                parent: 'app',
                url: '/download-agreements',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                    pageTitle: 'global.menu.entities.downloadAgreement'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/download-agreements/download-agreements.html',
                        controller: 'DownloadAgreementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agreements');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                },
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadAgreementController', DownloadAgreementController);

    DownloadAgreementController.$inject = ['$state', '$filter', 'AgreementsWorkflowService', 'DateUtils'];

    function DownloadAgreementController($state, $filter, AgreementsWorkflowService, DateUtils) {
        var vm = this;
        vm.download = download;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPatientOrPdf = false;
        vm.invalidDates = false;

        vm.datePickerOpenStatus = { fromDate: false, toDate: false };
        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };

        init();

        function init() {
            // set startDate to Monday of this week
            vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
            // set startDate to previous Monday
            vm.fromDate.setDate(vm.fromDate.getDate() - 7);

            // set endDate to previous Friday
            vm.toDate = new Date(vm.fromDate);
            vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function download() {
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            vm.noPatientOrPdf = false;
            AgreementsWorkflowService.downloadAllAgreements(fromDate, toDate).then(function (res) {
                vm.isProcessing = false;
                if (res) {
                    if (res.status === 204 && (res.reason === 'no-patient' || res.reason === 'no-pdf')) {
                        vm.noPatientOrPdf = true;
                    }
                }
            });
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-adhoc-testing', {
            parent: 'app',
            url: '/download-adhoc-testing',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.entities.adhocTesting'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-adhoc-testing/download-adhoc-testing.html',
                    controller: 'DownloadAdhocTestingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adhoc-testing');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                tests: ['Test', function (Test) {
                    return Test.getAllActiveAdhocTests();
                }],
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('AdhocTestingService', AdhocTestingService);

    AdhocTestingService.$inject = ['$http', '$q', 'DownloadBlobService'];

    function AdhocTestingService ($http, $q, DownloadBlobService) {
        var resourceUrl = "api/adhoc-testing";

        var service = {
            'downloadCsvAdhocTesting': downloadCsvAdhocTesting,
            'downloadCsvDetailedAdhocTesting': downloadCsvDetailedAdhocTesting,
            'downloadReport': downloadReport
        };

        function downloadCsvAdhocTesting(fromDate, toDate, selectedTestIds) {
            var deferred = $q.defer();
            var url = resourceUrl + '/download';
            var body = {fromDate: fromDate, toDate: toDate, testIds: selectedTestIds};
            $http.post(url, body).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function downloadCsvDetailedAdhocTesting(fromDate, toDate, selectedTestId) {
            var deferred = $q.defer();
            var url = resourceUrl + '/download/detailed';
            var body = {fromDate: fromDate, toDate: toDate, testId: selectedTestId};
            $http.post(url, body).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function downloadReport(fileId) {
            var deferred = $q.defer();
            var url = 'api/adhoc-testing/download-report/' + fileId;
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadAdhocTestingController', DownloadAdhocTestingController);

    DownloadAdhocTestingController.$inject = ['$filter', 'AdhocTestingService', '$uibModal', '$interval', '$scope', 'ipmConstants', 'tests', 'DateUtils'];

    function DownloadAdhocTestingController ($filter, AdhocTestingService, $uibModal, $interval, $scope, ipmConstants, tests, DateUtils) {
        var vm = this;
        vm.download = download;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        vm.limitTimeMillisSecondsDownload = 1000*30; // 30 seconds
        vm.limitTimeStart = null;
        vm.hasSubmitedRequestDownloadCsv = false;
        vm.hasOpenningDialogRequest = false;
        vm.tests = tests;
        vm.selectedTests = [];
        vm.invalidDates = false;

        init();

        function init() {
            vm.fromDate.setDate(vm.fromDate.getDate() - 30);
        }

        function download() {
            vm.isProcessing = true;
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            var selectedTestIds = [];
            _.forEach(vm.selectedTests, function (test) {
                selectedTestIds.push(test.id);
            })
            downloadCsvAdhocTesting(fromDate, toDate, selectedTestIds);
        }

        function invalidDate() {
            var fromDate = vm.fromDate;
            var toDate = vm.toDate;
            if (!fromDate || !toDate) {
                return true;
            }
            fromDate.setHours(0, 0, 0, 0);
            toDate.setHours(0, 0, 0, 0);

            return fromDate > toDate;
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };

        function downloadCsvAdhocTesting(fromDate, toDate, selectedTestIds) {
            vm.noPdf = false;
            AdhocTestingService.downloadCsvAdhocTesting(fromDate, toDate, selectedTestIds).then(function(res) {
                vm.isProcessing = false;
                if (res === 204) { // SC_NO_CONTENT
                    vm.noPdf = true;
                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('RequestActivityReportController', RequestActivityReportController);

    RequestActivityReportController.$inject = ['ActivityReportService', '$stateParams', '$state', 'User', 'serviceType'];

    function RequestActivityReportController (ActivityReportService, $stateParams, $state, User, serviceType) {
        var vm = this;
        vm.download = download;
        vm.isUserRequest = false;
        vm.noPdf = false;
        vm.serviceType = serviceType;

        init();

        function init() {
            vm.fileId = $stateParams.id;
            User.getUserByCurrentLogin().then(function (response) {
                var currentUser = response;
                vm.isUserRequest = currentUser.id === Number($stateParams.user);
                if (!vm.isUserRequest) {
                    $state.go('home');
                }
            });
        }

        function download() {
            ActivityReportService.downloadReport(vm.fileId, vm.serviceType).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-haq-activity-report', {
            parent: 'app',
            url: '/download-haq-activity-report',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadActivityReport'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-activity-report/download-activity-report.html',
                    controller: 'DownloadActivityReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadActivityReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                serviceType: function () {
                    return "HAQ";
                }
            }
        }).state('download-cpr-activity-report', {
                parent: 'app',
                url: '/download-cpr-activity-report',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                    pageTitle: 'global.menu.entities.downloadActivityReport'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/download-activity-report/download-activity-report.html',
                        controller: 'DownloadActivityReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('downloadActivityReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    serviceType: function () {
                        return "CPR";
                    }
                }
            })
        .state('download-haq-activity-report.requested', {
            parent: 'download-haq-activity-report',
            url: '/requested/{id}?user',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.entities.downloadActivityReport'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-activity-report/request-activity-report.html',
                    controller: 'RequestActivityReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadActivityReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                serviceType: function () {
                    return "HAQ";
                }
            }
        })
            .state('download-cpr-activity-report.requested', {
                parent: 'download-cpr-activity-report',
                url: '/requested/{id}?user',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'global.menu.entities.downloadActivityReport'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/download-activity-report/request-activity-report.html',
                        controller: 'RequestActivityReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('downloadActivityReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    serviceType: function () {
                        return "CPR";
                    }
                }
            });

    }

})();
;
(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('ActivityReportService', ActivityReportService);

    ActivityReportService.$inject = ['$http', '$q', 'DownloadBlobService'];

    function ActivityReportService ($http, $q, DownloadBlobService) {

        var service = {
            'downloadCsvHAQ': downloadCsvHAQ,
            'downloadCsvCPR': downloadCsvCPR,
            'requestDownloadCsvHAQ': requestDownloadCsvHAQ,
            'requestDownloadCsvCPR': requestDownloadCsvCPR,
            'downloadReport': downloadReport
        };

        function downloadCsvCPR(fromDate, toDate) {
            var deferred = $q.defer();
            $http({
                url: 'api/activity-report/cpr',
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function downloadCsvHAQ(fromDate, toDate) {
            var deferred = $q.defer();
            $http({
                url: 'api/activity-report/haq',
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function requestDownloadCsvHAQ(fromDate, toDate) {
            var deferred = $q.defer();
            $http({
                url: 'api/activity-report/request-report-haq',
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate}
            }).success(function (response) {
                deferred.resolve(response);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function requestDownloadCsvCPR(fromDate, toDate) {
            var deferred = $q.defer();
            $http({
                url: 'api/activity-report/request-report-cpr',
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate}
            }).success(function (response) {
                deferred.resolve(response);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function downloadReport(fileId, serviceType) {
            var deferred = $q.defer();
            var url = 'api/activity-report/download-report/' + fileId;
            $http({
                url: url,
                method: "GET",
                params: {serviceType: serviceType},
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('DownloadActivityReportController', DownloadActivityReportController);

    DownloadActivityReportController.$inject = ['$filter', 'ActivityReportService', '$uibModal', 'serviceType', '$interval', '$scope', 'DateUtils'];

    function DownloadActivityReportController ($filter, ActivityReportService, $uibModal, serviceType, $interval, $scope, DateUtils) {
        var vm = this;
        vm.download = download;

        vm.dateFormatToServer = 'yyyy-MM-dd';
        vm.dateFormat = 'MM/dd/yyyy';
        vm.fromDate = new Date();
        vm.toDate = new Date();
        vm.toDateInvalid = null;
        vm.fromDateInvalid = null;
        vm.noPdf = false;
        vm.serviceType = serviceType;
        vm.invalidDates = false;

        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        vm.limitTimeMillisSecondsDownload = 1000*30; // 30 seconds
        vm.limitTimeStart = null;
        vm.hasSubmitedRequestDownloadCsv = false;
        vm.hasOpenningDialogRequest = false;
        var intervalLimitTimeDownload = null;

        init();

        function init() {

            // set to Monday of this week
            vm.fromDate.setDate(vm.fromDate.getDate() - (vm.fromDate.getDay() + 6) % 7);
            // set to previous Monday
            vm.fromDate.setDate(vm.fromDate.getDate() - 7);

            // set to previous Friday
            vm.toDate = new Date(vm.fromDate);
            vm.toDate.setDate(vm.toDate.getDate() + 4);
        }

        function download() {
            vm.isProcessing = true;
            resetIntervalLimitTime();
            startIntervalLimitTimeDownload();
            var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
            var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
            if (vm.serviceType === 'HAQ') {
                downloadCsvHAQ(fromDate, toDate);
            } else if (vm.serviceType === 'CPR') {
                downloadCsvCPR(fromDate, toDate);
            }
        }

        function requestDownloadCsvHAQ(fromDate, toDate) {
            if (!vm.hasSubmitedRequestDownloadCsv) {
                vm.isProcessing = true;
                ActivityReportService.requestDownloadCsvHAQ(fromDate, toDate).then(function (res) {
                    vm.isProcessing = false;
                    vm.noPdf = false;
                    vm.hasSubmitedRequestDownloadCsv = true;
                });
            }
            stopIntervalLimitTimeDownload();
        }

        function requestDownloadCsvCPR(fromDate, toDate) {
            if (!vm.hasSubmitedRequestDownloadCsv) {
                ActivityReportService.requestDownloadCsvCPR(fromDate, toDate).then(function(res) {
                    vm.isProcessing = false;
                    vm.noPdf = false;
                    vm.hasSubmitedRequestDownloadCsv = true;
                });
            }
            stopIntervalLimitTimeDownload();
        }

        function downloadCsvHAQ(fromDate, toDate) {
            vm.noPdf = false;
            ActivityReportService.downloadCsvHAQ(fromDate, toDate).then(function(res) {
                vm.isProcessing = false;
                if (res === 204) { // SC_NO_CONTENT
                    vm.noPdf = true;
                }
                if (res === 509) { // BANDWIDTH_LIMIT_EXCEEDED
                    if (!vm.hasOpenningDialogRequest)
                        openDialogRequestDownloadCsvHAQ(fromDate, toDate);
                }
                // call stop interval when download empty < 30s
                stopIntervalLimitTimeDownload();
            });
        }

        function downloadCsvCPR(fromDate, toDate) {
            vm.noPdf = false;
            ActivityReportService.downloadCsvCPR(fromDate, toDate).then(function(res) {
                vm.isProcessing = false;
                if (res === 204) { // SC_NO_CONTENT
                    vm.noPdf = true;
                }
                if (res === 509) { // BANDWIDTH_LIMIT_EXCEEDED
                    if (!vm.hasOpenningDialogRequest)
                        openDialogRequestDownloadCsvCPR(fromDate, toDate);
                }
                // call stop interval when download empty < 30s
                stopIntervalLimitTimeDownload();
            });
        }

        function openDialogRequestDownloadCsvHAQ(fromDate, toDate) {
            vm.hasOpenningDialogRequest = true;
            $uibModal.open({
                templateUrl: 'app/shared/confirm-download-dialog/confirm-download-dialog.controller.html',
                controller: 'ConfirmDownloadController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message warning-dialog',
                backdrop: 'static',
                size: 'sm'
            }).result.then(function (result) {
                if (result) { // Yes
                    requestDownloadCsvHAQ(fromDate, toDate);
                }
                // case No
                stopIntervalLimitTimeDownload();
                resetProcessingDownload();
            });
        }

        function openDialogRequestDownloadCsvCPR(fromDate, toDate) {
            vm.hasOpenningDialogRequest = true;
            $uibModal.open({
                templateUrl: 'app/shared/confirm-download-dialog/confirm-download-dialog.controller.html',
                controller: 'ConfirmDownloadController',
                controllerAs: 'vm',
                windowClass: 'center-dialog-message warning-dialog',
                backdrop: 'static',
                size: 'sm'
            }).result.then(function (result) {
                if (result) { // Yes
                    requestDownloadCsvCPR(fromDate, toDate);
                }
                // case No
                stopIntervalLimitTimeDownload();
                resetProcessingDownload();
            });
        }

        function resetProcessingDownload() {
            vm.isProcessing = false;
        }

        function resetIntervalLimitTime() {
            vm.hasSubmitedRequestDownloadCsv = false;
            vm.limitTimeStart = moment();
            vm.hasOpenningDialogRequest = false;
        }

        function stopIntervalLimitTimeDownload() {
            if (intervalLimitTimeDownload) {
                clearInterval(intervalLimitTimeDownload);
                $interval.cancel(intervalLimitTimeDownload);
            }
        }

        function startIntervalLimitTimeDownload() {
            intervalLimitTimeDownload = setInterval(function () {
                runIntervalLimitTimeDownload();
            }, 2000); // 2 seconds
        }

        function runIntervalLimitTimeDownload() {
            var millisDiff = moment().diff(vm.limitTimeStart);
            if (millisDiff > vm.limitTimeMillisSecondsDownload) {
                var fromDate = $filter('date')(vm.fromDate, vm.dateFormatToServer);
                var toDate = $filter('date')(vm.toDate, vm.dateFormatToServer);
                if (vm.serviceType === 'HAQ') {
                    if (!vm.hasOpenningDialogRequest)
                        openDialogRequestDownloadCsvHAQ(fromDate, toDate);
                } else if (vm.serviceType === 'CPR') {
                    if (!vm.hasOpenningDialogRequest)
                        openDialogRequestDownloadCsvCPR(fromDate, toDate);
                }
                // stop interval
                stopIntervalLimitTimeDownload();
            }
        }

        vm.onChangeDate = function () {
            vm.inValidDates = DateUtils.isValidFromDateAndToDate(vm.fromDate, vm.toDate);
        };

        $scope.$on('$destroy', function () {
            stopIntervalLimitTimeDownload();
        });
    }
})();
;
'use strict';

angular.module('ipmApp')
    .constant('ipmConstants', {

        // roles constant
        "ROLE_ADMIN": "ROLE_ADMIN",
        "ROLE_STAFF": "ROLE_STAFF",
        "ROLE_PATIENT": "ROLE_PATIENT",
        "ROLE_MANAGER": "ROLE_MANAGER",
        "ROLE_QHP": "ROLE_QHP",
        "ROLE_BILLER": "ROLE_BILLER",

        "BATTERY_NOT_COMPLETE": "batteryNotComplete",
        "BATTERY_COMPLETE": "batteryComplete",

        // event name using $broadcast
        "EVT_AUTHENTICATION_SUCCESS": "authenticationSuccess",
        "EVT_AUTHENTICATION_SUCCESS_BY_INVITATION": "authenticationSuccessByInvitation",
        "EVT_LOG_OUT": "eventLogOut",

        //Test constant
        "PHQ_9": "Patient Health Questionnaire (PHQ-9)",

        //Question contanst
        "SUICIDE_RISK_TEST": "Thoughts that you would be better off dead, or of hurting yourself",

        //No wait constants
        "NO_WAIT": "+NOWAIT",
        "NOWAIT": "noWait",

        "AZURE_PATIENT": "azurePatient",

        "CSV_EXT": ".csv",

        "PASS_RESTRICTION": "passRestriction",

        "SURVEY_RESULT_ID": "surveyResultId",

        "SURVEY_RESULT_TYPE_DEFAULT": "DEFAULT",

        "SURVEY_RESULT_TYPE_ADHOC": "ADHOC",

        "SURVEY_RESULT_TYPE_BATTERY": "BATTERY",

        "LAUNCH_FROM": "launchFrom",

        "QUESTION_ID_EVALUATION_WORKFLOW": "questionId",

        "ACTION_EVALUATION_WORKFLOW": "actionEvaluationWorkflow",

        "HAQ": "HAQ",

        "HAQ_ADHOC": "HAQ_ADHOC",

        "HAQ_BATTERY": "HAQ_BATTERY",

        "PATIENT_AGREEMENT": "PATIENT_AGREEMENT",

        "NPQ_QUESTIONNAIRE_ID": "npqQuestionnaireId",

        "PSYCH_INTAKE_FORM_ID": "psychIntakeFormId",

        "PATIENT_AGREEMENT_ID": "patientAgreementId",

        "EMAIL_PATTERN": "/^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*$/i",

        "SEARCH_TYPE_HAQ": "haq",

        "INVITATION_WORKFLOW": "invitationWorkflow",

        "INVITATION_SECRET_KEY": "invitationSecretKey",

        // Agreements type
        "AGREEMENT_CONSENT_TO_TREAT": "CONSENT_TO_TREAT",
        "AGREEMENT_PATIENT_RIGHTS_AND_RESPONSIBILITIES": "PATIENT_RIGHTS_AND_RESPONSIBILITIES",
        "AGREEMENT_ACKNOWLEDGMENT": "ACKNOWLEDGMENT",
        "AGREEMENT_TRANSFER_MEDICAL": "AUTHORIZATION_TO_TRANSFER_MEDICAL_RECORDS",
        "AGREEMENT_PRIVACY_PRACTICES": "NOTICE_OF_PRIVACY_PRACTICES",
        // "AGREEMENT_OPIOID_MONOGRAPH_AND_NARCOTICS" : "OPIOID_MONOGRAPH_AND_NARCOTICS_AGREEMENT",
        // "AGREEMENT_RISK_OF_OPIOIDS" : "RISK_OF_OPIOIDS",
        "AGREEMENT_TREATMENT": "TREATMENT",
        "AGREEMENT_CONTINUITY_OF_CARE": "CONTINUITY_OF_CARE",

        // Agreements Step
        "AGREEMENTS_STEP_SIGNATURE": "AGREEMENTS_STEP_SIGNATURE",

        // Agreements Welcome
        "AGREEMENTS_WELCOME": "AGREEMENTS_WELCOME",

        // LandingPage
        "PASS_LANDING_PAGE": "PASS_LANDING_PAGE",
        "KEEP_LANDING_PAGE": "KEEP_LANDING_PAGE",

        // SURVEY_WORKFLOW_STATE
        "SURVEY_WORKFLOW_STATE": ['home', 'survey-workflow', 'survey-workflow-thankyou'],

        "PAGE_SIZE_MAX": 1000,
        "PAGE_SIZE": 20,

        // timer
        "TIME_SPENT": "TIME_SPENT",
        "TIMER_HAS_ELAPSED": "TIMER_HAS_ELAPSED",
        "TIME_ELAPSED_DEFAULT": 31,

        // QHP Task
        "HAQ_EVALUATION": "HAQ_EVALUATION",
        "HAQ_BRIEF_REVIEW": "HAQ_BRIEF_REVIEW",
        "CARE_PLAN_REVIEW": "CARE_PLAN_REVIEW",
        "INSTRUCTOR": "INSTRUCTOR",
        "FRP_MDE": "FRP_MDE",
        "CONTINUITY_OF_CARE": "CONTINUITY_OF_CARE",

        // CarePlanReviewStatus
        "CARE_PLAN_REVIEW_STATUS": ['ALL', 'NOT_READY', 'NOT_STARTED', 'STARTED', 'SKIPPED'],

        // CPR
        "PATIENT_ID_FOR_CPR_WORKFLOW": "PATIENT_ID_FOR_CPR_WORKFLOW",
        "DAYS_PREVIOUS_CPR_COMPLETED": 31,
        "TREATMENT_HISTORY_TYPE": ['PHYSICAL_THERAPY', 'ACUPUNCTURE', 'CHIRO', 'PSYCH', 'MDE', 'FRP', 'INJECTIONS'],
        "CASE_STATUSES": ['TTD', 'PS_FUTURE_MEDICAL', 'PS_CR', 'NA_CASE_CLOSED'],
        "WORK_STATUSES": ['FT_UNMODIFIED', 'FT_MODIFIED', 'PT_UNMODIFIED', 'PT_MODIFIED', 'NOT_WORKING', 'RETIRED', 'NA_CASE_CLOSED'],
        "STATUS_INDICATORS": ['CONSERVATIVE_CARE', 'INTERVENTIONS', 'EVALUATION_MDE', 'PAIN_PROGRAM'],
        "CPR_MAP_KEY_VALUES": ['treatment_history_table', 'surgical_candidacy_status'],
        "TIME_SPENT_CPR_WORKFLOW": "TIME_SPENT_CPR_WORKFLOW",
        "TIME_CPR_LOGIN": "TIME_CPR_LOGIN",
        "INIT_DATA_CPR": "INIT_DATA_CPR",
        // Call Log
        "PARTY_TYPES": ['PATIENT', 'ATTORNEY', 'NCM', 'ADJUSTER', 'UTILIZATION_REVIEW', 'OTHER'],
        // MaximumNumberRegister
        "MAXIMUM_NUMBER_REGISTER": 8,
        // Wellness Class
        "CURRENT_SLIDE_WC": "CURRENT_SLIDE_ID_WC",
        "CURRENT_PAGE_PDF_VIEW": "CURRENT_PAGE_PDF_VIEW",
        "SCALE_ZOOM_IN": "SCALE_ZOOM_IN",
        "SCALE_ZOOM_OUT": "SCALE_ZOOM_OUT",
        "PRESENTATION_VIEW": "PRESENTATION_VIEW",
        "EVT_CURRENT_SLIDE_WC": "currentSlideWCEventChange",
        "EVT_BACK_SLIDE_WC": "backSlideWCEventChange",
        "EVT_NEXT_SLIDE_WC": "nextSlideWCEventChange",
        "EVT_ZOOM_IN_SLIDE_WC": "zoomInSlideWCEventChange",
        "EVT_ZOOM_OUT_SLIDE_WC": "zoomOutSlideWCEventChange",
        "EVT_GO_TO_PAGE_SLIDE_WC": "goToPageSlideWCEventChange",
        "PDF_DEFAULT_SCALE": 1.3,
        // All Course Registration Step
        "COURSE_REGISTRATION_STEPS": ['SUGGEST_COURSE', 'INSTRUCTION_DETAIL_LIST', 'CLASS_SESSION_DETAIL_LIST'],
        // MDE statuss
        "MDE_STATUS": ['MDE_PENDING', 'MDE_IN_PROGRESS', 'MDE_COMPLETED_RECOMMENDED', 'MDE_COMPLETED_REQUESTED', 'MDE_COMPLETED_AUTHORIZED', 'MDE_ABANDONED', 'MDE_COMPLETED_NOT_RECOMMENDED'],
        "MDE_REPORT_STATUS": { 'START_REPORT': 'START_REPORT', 'EDIT_REPORT': 'EDIT_REPORT', 'VIEW_REPORT': 'VIEW_REPORT' },
        // FRP status
        "FRP_STATUS_FILTER": ['PENDING_MDE', 'FRP_REQUESTED_PENDING', 'FRP_ENROLLED', 'FRP_ACTIVE_HOLD'],
        "FRP_STATUS": ['PENDING_MDE', 'FRP_REQUESTED_PENDING', 'FRP_ENROLLED', 'FRP_GRADUATED', 'FRP_EARLY_DISCHARGE', 'FRP_ACTIVE_HOLD', 'FRP_INACTIVE_HOLD'],
        "INACTIVE_PATIENTS_STATUS": ['FRP_GRADUATED', 'FRP_EARLY_DISCHARGE', 'FRP_INACTIVE_HOLD', 'MDE_COMPLETED_NOT_RECOMMENDED', 'MDE_ABANDONED'],
        // batteries-testing: Department
        "DEPARTMENT_TYPE": ['CLINIC', 'PSYCH'],
        "DROPDOWN_BATTERIES_TYPE": 'PATIENT_TESTING_BATTERIES',
        "SEND_NEW_AGREEMENT": 'SEND_NEW_AGREEMENT',
        // attendanceTrackers
        "ATTENDANCE_TRACKERS": ['1', '2', '3', '4', '5', '6', '7'], // 1-7 where 1 is Saturday and 7 is Friday
        "STATES_OF_AMERICA": ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE'
            , 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'AS', 'GU', 'MP', 'PR', 'VI', 'DC'],
        "ADD_ENROLL_SUCCESS": "addEnrollSuccess",
        // use to hidden Wellness Classes function
        "HIDE_WELLNESS_CLASSES": true,
        // use to disable state WELLNESS_CLASSES
        "ROLE_DISABLE_WELLNESS_CLASSES": "ROLE_DISABLE_WELLNESS_CLASSES",
        "FRP_REPORT_STATUS_VIEW": { 'EDIT_REPORT': 'EDIT_REPORT', 'FRP_REPORT_PREVIOUS_NOT_FINALIZED': 'FRP_REPORT_PREVIOUS_NOT_FINALIZED', 'VIEW_REPORT': 'VIEW_REPORT', 'ADD_NEW_REPORT': 'ADD_NEW_REPORT' },
        "FRP_REPORT_TYPE": { FIRST_REPORT: 'FIRST_REPORT', WEEKLY_REPORT: 'WEEKLY_REPORT', MID_SESSION_REPORT: 'MID_SESSION_REPORT', DISCHARGE_REPORT: 'DISCHARGE_REPORT', OTHER_REPORT: 'OTHER_REPORT' },
        "FRP_REPORT_TYPE_2": ['FIRST_REPORT', 'WEEKLY_REPORT', 'MID_SESSION_REPORT', 'DISCHARGE_REPORT', 'OTHER_REPORT'],
        "LECTURES": ['FIRST', 'SECOND', 'THREE', 'FOUR', 'FIVE'],
        // Template
        "FRP_MDE_TEMPLATE": {
            "USER": "USER",
            "GLOBAL": "GLOBAL",
            "MDE_MEDIAL": ['HISTORY_PRESENT_ILLNESS', 'MECHANISM_INJURY', 'PRESENT_COMPLAINTS', 'CONSERVATIVE_CARE', 'SURGICAL_HISTORY', 'SUMMARY_AND_RECOMMENDATIONS'],
            "HISTORY_PRESENT_ILLNESS": "HISTORY_PRESENT_ILLNESS",
            "MECHANISM_INJURY": "MECHANISM_INJURY",
            "PRESENT_COMPLAINTS": "PRESENT_COMPLAINTS",
            "CONSERVATIVE_CARE": "CONSERVATIVE_CARE",
            "SURGICAL_HISTORY": "SURGICAL_HISTORY",
            "MDE_PT": ['SUBJECTIVE_COMPLAINTS', 'PHYSICAL_FUNCTIONAL_NARRATIVE'],
            "SUBJECTIVE_COMPLAINTS_PSYCH": "SUBJECTIVE_COMPLAINTS_PSYCH",
            "PYSCHOSOCIAL_HISTORY": "PYSCHOSOCIAL_HISTORY",
            "MDE_PSYCH": ['SUBJECTIVE_COMPLAINTS_PSYCH', 'PYSCHOSOCIAL_HISTORY', 'MENTAL_STATUS', 'PSYCHOLOGICAL_GOALS_OF_TREATMENT', 'SUMMARY_AND_IMPRESSIONS'],
            "SUBJECTIVE_COMPLAINTS": "SUBJECTIVE_COMPLAINTS",
            "MENTAL_STATUS": "MENTAL_STATUS",
            "FRP_PSYCH": ['SUBJECTIVE', 'PSYCHOLOGICAL_NARRATIVE'],
            "SUBJECTIVE": "SUBJECTIVE",
            "PSYCHOLOGICAL_NARRATIVE": "PSYCHOLOGICAL_NARRATIVE",
            "FRP_PT": ['PHYSICAL_SUBJECTIVE', 'PHYSICAL_FUNCTIONAL_NARRATIVE'],
            "PHYSICAL_SUBJECTIVE": "PHYSICAL_SUBJECTIVE",
            "PHYSICAL_FUNCTIONAL_NARRATIVE": "PHYSICAL_FUNCTIONAL_NARRATIVE",
            "FRP_REPORT_CONCLUSION": ["TREATMENT_TEAM_OBSERVATION"],
            "TREATMENT_TEAM_OBSERVATION": "TREATMENT_TEAM_OBSERVATION",
            "FRP_REPORT_ADMIN": ["REPORT_TYPE"],
            "REPORT_TYPE": "REPORT_TYPE",
            "PSYCHOLOGICAL_GOALS_OF_TREATMENT": "PSYCHOLOGICAL_GOALS_OF_TREATMENT",
            "SUMMARY_AND_IMPRESSIONS": "SUMMARY_AND_IMPRESSIONS",
            "SUMMARY_AND_RECOMMENDATIONS": "SUMMARY_AND_RECOMMENDATIONS",
            "MDE_CONCLUSION": ["CONCLUSION"],
            "CONCLUSION": "CONCLUSION",
            "GENERAL": "GENERAL"
        },
        "FRP_PROGRAM": "FRP_PROGRAM",
        "FRP_PROGRAMS_ERROR": "FRP_PROGRAMS_ERROR",
        "SEVERITY": {
            "TSK": ["MINIMAL", "MILD", "MODERATE", "SEVERE"],
            "LEFS": ["EXTREME_DIF", "SEVERE", "MODERATE", "MILD", "NO_DIFFICULTY"],
            "NDI": ["NO_DISABILITY", "MIN", "MOD", "SEVERE", "COMPLETE"],
            "Oswestry": ["MINIMUM", "MOD", "SEVERE", "CRIPPLED", "BED_BND"],
            "PSEQ": ["NOT_CONFIDENT", "MILD", "MOD", "COMPLETE", "TO_FUNCT_WITH_PAIN"],
            "QuickDash": ["NO_DISABILITY", "MINIMUM", "MILD", "MODERATE", "SEVERE"],
            "ADL": ["INTERPRETATION", "MILD_DISABILITY", "MODERATE_DISABILITY", "SEVERE_DISABILITY"]
        },
        "FRP_PSYCH_SEVERITY": {
            "subjectives": {
                "CES_D": [
                    { "key": "WNL", "name": "WNL", "value": "0-15 (WNL)", "minRange": 0, "maxRange": 15 },
                    { "key": "MILD", "name": "Mild", "value": "16-25 (Mild)", "minRange": 16, "maxRange": 25 },
                    { "key": "MODERATE", "name": "Moderate", "value": "26-35 (Moderate)", "minRange": 26, "maxRange": 35 },
                    { "key": "SEVERE", "name": "Severe", "value": "36+ (Severe)", "minRange": 36, "maxRange": 1000 }
                ],
                "GAD_7": [
                    { "key": "MILD", "name": "Mild", "value": "0-6 (Mild)", "minRange": 0, "maxRange": 6 },
                    { "key": "MODERATE", "name": "Moderate", "value": "7-14 (Moderate)", "minRange": 7, "maxRange": 14 },
                    { "key": "SEVERE", "name": "Severe", "value": "15+ (Severe)", "minRange": 15, "maxRange": 1000 }
                ],
                "BPI": [
                    { "key": "WNL", "name": "WNL", "value": "0-3 (WNL)", "minRange": 0, "maxRange": 3 },
                    { "key": "MILD", "name": "Mild", "value": "4-5 (Mild)", "minRange": 4, "maxRange": 5 },
                    { "key": "MODERATE", "name": "Moderate", "value": "6-7 (Moderate)", "minRange": 6, "maxRange": 7 },
                    { "key": "SEVERE", "name": "Severe", "value": "8-10 (Severe)", "minRange": 8, "maxRange": 10 }
                ],
                "ISI": [
                    { "key": "WNL", "name": "WNL", "value": "0-7 (WNL)", "minRange": 0, "maxRange": 7 },
                    { "key": "MILD", "name": "Mild", "value": "8-14 (Mild)", "minRange": 8, "maxRange": 14 },
                    { "key": "MODERATE", "name": "Moderate", "value": "15-21 (Moderate)", "minRange": 15, "maxRange": 21 },
                    { "key": "SEVERE", "name": "Severe", "value": "22-28 (Severe)", "minRange": 22, "maxRange": 28 }
                ],
                "TSK": [
                    { "key": "MINIMAL", "name": "Minimal", "value": "0-29 (Minimal)", "minRange": 0, "maxRange": 29 },
                    { "key": "MILD", "name": "Mild", "value": "30-42 (Mild)", "minRange": 30, "maxRange": 42 },
                    { "key": "MODERATE", "name": "Moderate", "value": "43-55 (Moderate)", "minRange": 43, "maxRange": 55 },
                    { "key": "SEVERE", "name": "Severe", "value": "56-68 (Severe)", "minRange": 56, "maxRange": 68 }
                ],
                "PHQ_9": [
                    { "key": "NONE", "name": "None", "value": "0-4 (None)", "minRange": 0, "maxRange": 4 },
                    { "key": "MILD", "name": "Mild", "value": "5-9 (Mild)", "minRange": 5, "maxRange": 9 },
                    { "key": "MODERATE", "name": "Moderate", "value": "10-14 (Moderate)", "minRange": 10, "maxRange": 14 },
                    { "key": "MODERATELY_SEVERE", "name": "Moderately Severe", "value": "15-19 (Moderately Severe)", "minRange": 15, "maxRange": 19 },
                    { "key": "SEVERE", "name": "Severe", "value": "20-27 (Severe)", "minRange": 20, "maxRange": 27 }
                ]
            },
            "objectives": {
                "HAM_A": [
                    { "key": "WNL", "name": "WNL", "value": "0-10 (WNL)", "minRange": 0, "maxRange": 10 },
                    { "key": "MILD_ANXIETY", "name": "Mild anxiety", "value": "11-17 (Mild anxiety)", "minRange": 11, "maxRange": 17 },
                    { "key": "MODERATE_ANXIETY", "name": "Moderate anxiety", "value": "18-24 (Moderate anxiety)", "minRange": 18, "maxRange": 24 },
                    { "key": "SEVERE_ANXIETY", "name": "Severe anxiety", "value": ">25 (Severe anxiety)", "minRange": 25, "maxRange": 1000 }
                ],
                "HAM_D": [
                    { "key": "WNL", "name": "WNL", "value": "0-7 (WNL)", "minRange": 0, "maxRange": 7 },
                    { "key": "MILD_DEPRESSION", "name": "Mild depression", "value": "8-16 (Mild depression)", "minRange": 8, "maxRange": 16 },
                    { "key": "MODERATE_DEPRESSION", "name": "Moderate depression", "value": "17-23 (Moderate depression)", "minRange": 17, "maxRange": 23 },
                    { "key": "SEVERE_DEPRESSION", "name": "Severe depression", "value": ">24 (Severe depression)", "minRange": 24, "maxRange": 1000 }
                ]
            }
        },
        "STATUS_FINAL_FRP_MDE": "FINALIZED",
        "HOURS_ATTENDED_CAN_NOT_EXCEED": 160, // default 160 hours
        "NUMBER_HRS_ATTENDED": 4, // Hours in attendance is number of days attended x 4hrs
        // TimeSpentType
        "TIME_SPENT_TYPE": { START_RUN_TIMESPENT: 'START_RUN_TIMESPENT', RESET_TIMESPENT_LOGIN: 'RESET_TIMESPENT_LOGIN', UPDATE_TIMESPENT: 'UPDATE_TIMESPENT', UPDATE_AND_RESET_TIMESPENT_LOGIN: 'UPDATE_AND_RESET_TIMESPENT_LOGIN' },
        "SKIP_REASON": ["CASH_PAY", "DECEASED", "CURRENTLY_IN_FRP", "NO_VISITS_COMPLETED", "NO_NEW_INFORMATION_TO_REVIEW", "STABLE_AND_P_AND_S", "SKIPPING_INDEFINITELY", "WAITING_ON_PTP", "OTHER"],
        "TOTAL_NPQ_SECTION": 12,
        //Wed Worker
        "WEB_WORKER": {
            "START": "START",
            "CLOSE": "CLOSE",
            "START_TIME_SPENT": "START_TIME_SPENT",
            "START_LOGOFF_INTERVAL": "START_LOGOFF_INTERVAL",
            "RESET_LOGOFF_INTERVAL": "RESET_LOGOFF_INTERVAL",
            "CLEAR_LOGOFF_INTERVAL": "CLEAR_LOGOFF_INTERVAL",
            "START_NOTICING_LOGOFF_INTERVAL": "START_NOTICING_LOGOFF_INTERVAL",
            "RESET_NOTICING_LOGOFF_INTERVAL": "RESET_NOTICING_LOGOFF_INTERVAL",
            "CLEAR_NOTICING_LOGOFF_INTERVAL": "CLEAR_NOTICING_LOGOFF_INTERVAL",
            "START_TIME_SPENT_INTERVAL_EVL": "START_TIME_SPENT_INTERVAL_EVL",
            "RESET_TIME_SPENT_INTERVAL_EVL": "RESET_TIME_SPENT_INTERVAL_EVL",
            "CLEAR_TIME_SPENT_INTERVAL_EVL": "CLEAR_TIME_SPENT_INTERVAL_EVL",
            "START_AUTO_SAVE_INTERVAL_EVL": "START_AUTO_SAVE_INTERVAL_EVL",
            "RESET_AUTO_SAVE_INTERVAL_EVL": "RESET_AUTO_SAVE_INTERVAL_EVL",
            "CLEAR_AUTO_SAVE_INTERVAL_EVL": "CLEAR_AUTO_SAVE_INTERVAL_EVL"
        },
        "REFRESH": "REFRESH",

        "CASE_EXCLUSIONS_TYPES": ['HAQ', 'HAQ_EVAL', 'CPR', 'WELLNESS'],

        "CASE_EXCLUSION_DETAIL_TYPES": ['HAQ_SERVICE', 'HAQ_BILLING', 'HAQ_EVAL_SERVICE', 'HAQ_EVAL_BILLING', 'CPR_SERVICE', 'CPR_BILLING', 'PNE_SERVICE'],

        "CASE_EXCLUSIONS_MAP": {
            'HAQ_SERVICE': 'HAQ',
            'HAQ_BILLING': 'HAQ',
            'HAQ_EVAL_SERVICE': 'HAQ_EVAL',
            'HAQ_EVAL_BILLING': 'HAQ_EVAL',
            'CPR_SERVICE': 'CPR',
            'CPR_BILLING': 'CPR',
            'PNE_SERVICE': 'WELLNESS'
        },

        "CONTAINER_SUB_ACTION_MAPPING": { 'CPR_042': ['CPR_043', 'CPR_044', 'CPR_045', 'CPR_046'], 'CPR_051': ['CPR_052', 'CPR_053', 'CPR_054'] },
        "DISPLAY_OTHER_TEXT_FIELD_CODE": ['CPR_031', 'CPR_032', 'CPR_033'],
        "OPTION_ITEM_ID_REQUIRED": [16, 69, 70, 71, 72],
        "MINLENGTH_FREETEXT_REQUIRED_CODE": ['CPR_034', 'CPR_056', 'CPR_057', 'CPR_059'],
        "CHECKBOX_REQUIRED": ['CPR_031', 'CPR_032', 'CPR_033', 'CPR_042', 'CPR_043', 'CPR_044', 'CPR_045'],
        "DISPLAY_MESSAGE_REQUIRED_SUB_CHECKBOX": ['CPR_031', 'CPR_032', 'CPR_033', 'CPR_042', 'CPR_043', 'CPR_044', 'CPR_045', 'CPR_047', 'CPR_048', 'CPR_049', 'CPR_051', 'CPR_052', 'CPR_053', 'CPR_054', 'CPR_055', 'CPR_056', 'CPR_057'],
        "CONTAINER_CHECKBOX_CODE": ['CPR_042', 'CPR_051'],
        "HAVE_ANSWERS_CHECKBOX_QUESTION_CODE": ['CPR_031', 'CPR_032', 'CPR_033', 'CPR_047', 'CPR_048', 'CPR_049'],
        "DISPLAY_SCHEDULING_SUB_QUESTION_ACTION": ['CPR_042', 'CPR_043', 'CPR_044', 'CPR_045', 'CPR_046'],
        "DISPLAY_GATHER_SUB_QUESTION_ACTION": ['CPR_051', 'CPR_052', 'CPR_053', 'CPR_054'],
        "DISPLAY_SUB_QUESTION_ACTION": ['CPR_031', 'CPR_032', 'CPR_033', 'CPR_034', 'CPR_047', 'CPR_048', 'CPR_049', 'CPR_055', 'CPR_056', 'CPR_057', 'CPR_059'],
        "DISPLAY_LABEL_CODE": ['CPR_046', 'CPR_056', 'CPR_057'],

        // Psych Intake Agreements
        "AGREEMENT_PSYCHOTHERAPY_SESSIONS": "PSYCHOTHERAPY_SESSIONS",
        "AGREEMENT_PRIVACY_PRACTICE": "PRIVACY_PRACTICE",
        "AGREEMENT_POLICIES_PROCEDURES": "POLICIES_PROCEDURES",
        "AGREEMENT_PCSG_INFORMATION_POLICIES": "PCSG_INFORMATION_POLICIES",
        "AGREEMENT_TELEHEALTH_INFORMED_CONSENT": "TELEHEALTH_INFORMED_CONSENT",
        "AGREEMENT_PATIENT_ACKNOWLEDGEMENT": "PATIENT_ACKNOWLEDGEMENT",
    });
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('coc-agreement-invitation', {
                parent: 'app',
                url: '/coc/{secretKey}',
                data: {
                    authorities: [],
                    pageTitle: 'ipmApp.cocAgreement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/coc-agreement-invitation/coc-agreement-invitation.html',
                        controller: 'CocAgreementInvitationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('coc-agreement');
                        return $translate.refresh();
                    }],
                },
            });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CocAgreementInvitationController', CocAgreementInvitationController);

        CocAgreementInvitationController.$inject = ['$timeout', 'ipmConstants', '$stateParams', 'CocAgreementService', '$rootScope', '$state'];

    function CocAgreementInvitationController($timeout, constants, $stateParams, CocAgreementService, $rootScope, $state) {
        var vm = this;
        



        init();

        function init() {

            

            if ($stateParams.secretKey === null || $stateParams.secretKey === '') {
                $state.go('error');
            }

            vm.secretKey = $stateParams.secretKey;

            CocAgreementService.getBySecretKey(vm.secretKey).then(function(res) {
                $rootScope.$broadcast(constants.EVT_AUTHENTICATION_SUCCESS_BY_INVITATION);
                // change language
                $rootScope.$emit("changeLanguage", {langKey: res.langkeyOfPatient});

                $timeout(function(){
                    $state.go('agreements-workflow');
                }, 1000);

                
            }, function(error) {
                vm.isPageLoadFinish = true;
                if (error.status = 404) {
                    vm.errorNotFound = true;
                } else {
                    $state.go('error');
                }
            });
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agreements', {
                parent: 'app',
                url: '/agreements',
                data: {
                    authorities: ['ROLE_PATIENT'],
                    pageTitle: 'ipmApp.agreements.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/agreements-workflow/agreements.html',
                        controller: 'AgreementsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('agreements');
                        return $translate.refresh();
                    }],
                },
                params: {
                    id: 263447,
                }
            });

    }

})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AgreementsController', AgreementsController);

    AgreementsController.$inject = ['$scope', 'AgreementsWorkflowService', '$state', 'ipmConstants', 'ClearLocalStorageService'];

    function AgreementsController($scope, AgreementsWorkflowService, $state, constants, ClearLocalStorageService) {
        var vm = this;

        vm.pageSize = 10;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'position';
        vm.reverse = false;
        vm.agreements = [];
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.download = download;
        vm.back = back;
        vm.isShowDownloadAll = isShowDownloadAll;
        vm.isAgreementSignedAllByAPI = true;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: 10,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };
            AgreementsWorkflowService.getCurrentAgreementWorkflow(null).then(function (res) {
                setIsAgreementSignedAllByAPI(res);
            }).catch(function () {
                vm.isAgreementSignedAllByAPI = false;
            });
            AgreementsWorkflowService.findAllByPatientId(null, pageable, true, ['INTERNAL', 'EXTERNAL_NO_DATE_SIGN']).then(function (response) {
                vm.agreements = response && response.data ? response.data : [];
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        function download() {
            AgreementsWorkflowService.downloadAgreements().then(function(response) {
                vm.isProcessing = false;
            });
        }

        function back() {
            if (ClearLocalStorageService.getLaunchFrom() !== constants.HAQ_BATTERY) {
                ClearLocalStorageService.clearSurveyResultId();
            }
            $state.go('home');
        }

        function isShowDownloadAll() {
            if (!vm.agreements || !vm.agreements.length || vm.agreements.length === 0) {
                return false
            }
            return vm.agreements.some(function (item) {
                return item && String(item.status).toUpperCase().trim() === 'COMPLETE' && String(item.createdSource).toUpperCase().trim() !== 'EXTERNAL';
            });
        }

        function setIsAgreementSignedAllByAPI(patientAgreement) {
            vm.isAgreementSignedAllByAPI = patientAgreement && patientAgreement.agreementSignedAllByAPI;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agreements-workflow', {
                parent: 'app',
                url: '/agreements/workflow/:id',
                data: {
                    authorities: ['ROLE_PATIENT'],
                    pageTitle: 'ipmApp.agreements.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/agreements-workflow/agreements-workflow.html',
                        controller: 'AgreementsWorkflowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('agreements');
                        return $translate.refresh();
                    }],
                },
                params: {
                    id: null
                }
            });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('AgreementsWorkflowService', AgreementsWorkflowService);

    AgreementsWorkflowService.$inject = ['$http', 'halClient', '$q', 'DownloadBlobService', 'DateUtils'];

    function AgreementsWorkflowService ($http, halClient, $q, DownloadBlobService, DateUtils) {
        var baseURL = 'api/agreement/';

        var service = {
            'getAgreementByPatientId': getAgreementByPatientId,
            'saveAgreementWorkflow': saveAgreementWorkflow,
            'finalSignatureAgreementWorkflow': finalSignatureAgreementWorkflow,
            'downloadAgreements': downloadAgreements,
            'findAllByPatientId': findAllByPatientId,
            'downloadAllAgreementsByPatientId': downloadAllAgreementsByPatientId,
            'getCurrentAgreementWorkflow' : getCurrentAgreementWorkflow,
            'downloadAllAgreements': downloadAllAgreements
        };

        function getAgreementByPatientId() {
            var url = baseURL + 'get-agreement-workflow';
            return $http.get(url).then(function (resp) {
                convertLocalDateFromServer(resp.data);
                return resp;
            });
        };

        function saveAgreementWorkflow(agreement) {
            convertLocalDateToServer(agreement);
            var url = baseURL + 'save-agreement-workflow';
            return $http.post(url, agreement).then(function (resp) {
                convertLocalDateFromServer(resp.data);
                return resp.data;
            });
        };

        function finalSignatureAgreementWorkflow(agreement) {
            var url = baseURL + 'final-signature-agreement-workflow';
            convertLocalDateToServer(agreement);
            return $http.post(url, agreement).then(function (resp) {
                convertLocalDateFromServer(resp.data);
                return resp.data;
            });
        };

        function downloadAgreements() {
            var deferred = $q.defer();
            var url = baseURL + '/download';
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], { type: contentType });
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function findAllByPatientId(patientId, pageable, notDisplayedAgreementCoc, createdSources) {
            var deferred = $q.defer();
            var url = baseURL + 'find-all-agreements-by-patient';
            $http.get(url, {
                params: {
                    patientId: patientId,
                    notDisplayedAgreementCoc: notDisplayedAgreementCoc,
                    createdSources: createdSources,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function downloadAllAgreementsByPatientId(patientId) {
            var deferred = $q.defer();
            var url = baseURL + 'download-all-by-patient-id/' + patientId;
            $http.get(url, {
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if (status === 204) {
                    deferred.resolve(status);
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], { type: contentType });
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        };

        function getCurrentAgreementWorkflow(patientId) {
            var deferred = $q.defer();
            var url = baseURL + 'get-current-agreement-workflow';
            $http.get(url, {
                params: {patientId: patientId}
            }).success(function (result) {
                convertLocalDateFromServer(result);
                deferred.resolve(result);
            }).error(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function downloadAllAgreements(fromDate, toDate) {
            var deferred = $q.defer();
            var url = baseURL + '/download-all-agreements';
            $http({
                url: url,
                method: "GET",
                params: { fromDate: fromDate, toDate: toDate },
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if (status === 204) {
                    var reason = headers('no-content-reason');
                    deferred.resolve({"status": status, "reason": reason});
                } else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], { type: contentType });
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }
            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });

            return deferred.promise;
        }

        function convertLocalDateFromServer(agreement) {
            if(agreement) {
                if (agreement.patientDob) {
                    agreement.patientDob = DateUtils.convertLocalDateFromServer(agreement.patientDob);
                }
                if (agreement.dateSigned) {
                    agreement.dateSigned = DateUtils.convertDateTimeFromServer(agreement.dateSigned);
                }
            }
        };

        function convertLocalDateToServer(agreement) {
            if(agreement) {
                if (agreement.patientDob) {
                    agreement.patientDob = DateUtils.convertLocalDateToServer(agreement.patientDob);
                }
                if (agreement.dateSigned) {
                    agreement.dateSigned = DateUtils.convertLocalDateTimeToServer(agreement.dateSigned);
                }
            }
        }

        return service;
    };
})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('AgreementsWorkflowController', AgreementsWorkflowController);

    AgreementsWorkflowController.$inject = ['$scope', 'ipmConstants', '$stateParams', 'AgreementsWorkflowService', '$window', 'ClearLocalStorageService', 'Auth', '$rootScope', '$state', 'NPQQuestionnaireService'];

    function AgreementsWorkflowController($scope, constants, $stateParams, AgreementsWorkflowService, $window, ClearLocalStorageService, Auth, $rootScope, $state, NPQQuestionnaireService) {
        var vm = this;
        vm.agreement = null;
        vm.agreementsStepCurrent = null;
        vm.onChangeAgreement = onChangeAgreement;
        vm.percentProgress = 0;
        vm.isSaving = false;

        vm.AGREEMENTS_WELCOME = constants.AGREEMENTS_WELCOME;
        vm.AGREEMENT_CONSENT_TO_TREAT = constants.AGREEMENT_CONSENT_TO_TREAT;
        vm.AGREEMENT_PATIENT_RIGHTS_AND_RESPONSIBILITIES = constants.AGREEMENT_PATIENT_RIGHTS_AND_RESPONSIBILITIES;
        vm.AGREEMENT_ACKNOWLEDGMENT = constants.AGREEMENT_ACKNOWLEDGMENT;
        vm.AGREEMENT_TRANSFER_MEDICAL = constants.AGREEMENT_TRANSFER_MEDICAL;
        vm.AGREEMENT_PRIVACY_PRACTICES = constants.AGREEMENT_PRIVACY_PRACTICES;
        vm.AGREEMENT_TREATMENT = constants.AGREEMENT_TREATMENT;
        vm.AGREEMENT_CONTINUITY_OF_CARE = constants.AGREEMENT_CONTINUITY_OF_CARE;


        vm.isSignatureStep = isSignatureStep;


        init();

        function init() {
            vm.agreementsStepCurrent = constants.AGREEMENTS_WELCOME;
        }

        function initAgreementsWorkflow() {
            AgreementsWorkflowService.getAgreementByPatientId().then(function (response) {
                vm.agreement = response && response.data ? response.data : null;

                vm.isOnlyDefaultAgreement = vm.agreement.isOnlyDefault; // detect only-default or with coc

                setPercentProgress(vm.agreement);
                setAgreementsStepCurrent();

                // checking patient status
                NPQQuestionnaireService.checkingStatusPatient().then(function(res) {
                    if (res) {
                        if (res.isFullyComplete && res.isHaveOpenHAQ) {
                            vm.isHaveOpenHAQ = true;
                        }
                    }
                });
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
                $state.go('error');
            });
        }

        function setAgreementsStepCurrent() {
            if (vm.agreement) {

                if (vm.agreement.isFinishAllAgreement) {
                    goToLandingPage();
                    return;
                }

                if (vm.agreement.agreementName) {
                    vm.agreementsStepCurrent = vm.agreement.agreementName;
                } else {
                    vm.agreementsStepCurrent = constants.AGREEMENTS_STEP_SIGNATURE;
                }
            }
        }

        function setAgreement(response) {
            vm.agreement = response ? response : null;
        }

        function onChangeAgreement(agreement) {
            if (agreement) {
                if (vm.agreementsStepCurrent === constants.AGREEMENTS_STEP_SIGNATURE) {
                    // start save save SignatureAgreement
                    saveSignatureAgreement(agreement);
                } else {
                    // start save save Agreement
                    saveAgreement(agreement);
                }
            } else {
                initAgreementsWorkflow();
            }
        }

        function setPercentProgress(agreement) {
            vm.percentProgress = agreement && agreement.percentProgress ? agreement.percentProgress : 0;
        }

        function saveSignatureAgreement(agreement) {
            vm.isSaving = true;
            AgreementsWorkflowService.finalSignatureAgreementWorkflow(agreement).then(function(res) {
                onSaveSuccess(res);
            }, function errorSave(error) {
                onSaveError(error);
            });

        }

        function saveAgreement(agreement) {
            vm.isSaving = true;
            AgreementsWorkflowService.saveAgreementWorkflow(agreement).then(function(res) {
                onSaveSuccess(res);
            }, function errorSave(error) {
                onSaveError(error);
            });

        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            setAgreement(result);
            setPercentProgress(vm.agreement);
            setAgreementsStepCurrent();
            scrollToTop();
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function scrollToTop() {
            $window.scrollTo(0, 0);
        }

        function isSignatureStep() {
            return vm.agreementsStepCurrent === constants.AGREEMENTS_STEP_SIGNATURE;
        }

        function goToLandingPage() {
            ClearLocalStorageService.clearAllAndWorkflow();
            ClearLocalStorageService.clearLandingPage();
            $state.go('landing-page');
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'FooterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("ipmApp")

.constant("ENV", "prod")

.constant("VERSION", "0.0.1-SNAPSHOT")

;
})();
;
(function () {
    'use strict';
    angular
        .module('ipmApp')
        .constant('REGEX_PATTERN', {
        	EMAIL: /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/
        });
})();
;(function(){angular.module("ipmApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/agreements-workflow/agreements-workflow.html","<div class=\"page\"><div class=\"container\"><div class=\"content\" style=\"text-align: justify\"><!-- In Process step --><div ng-include=\"\'in-process\'\" ng-if=\"!vm.isSignatureStep()\"></div><!-- Final signature --><div ng-include=\"\'final\'\" ng-if=\"vm.isSignatureStep()\"></div></div></div></div><script type=\"text/ng-template\" id=\"in-process\"><!-- Progress bar -->\n    <div ng-include=\"\'progress-bar\'\"></div>\n\n    <div ng-include=\"\'agreements-welcome\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENTS_WELCOME\"></div>\n\n    <!-- Patient not have Continuity Of Care invitation -->\n    <div ng-include=\"\'only-default-step\'\" ng-if=\"vm.isOnlyDefaultAgreement\"></div>\n\n    <!-- Patient have Continuity Of Care invitation -->\n    <div ng-include=\"\'not-only-default-step\'\" ng-if=\"!vm.isOnlyDefaultAgreement\"></div></script><script type=\"text/ng-template\" id=\"final\"><!-- Progress bar -->\n    <div ng-include=\"\'progress-bar\'\"></div>\n    <!-- Signature -->\n    <div ng-include=\"\'signature\'\"></div></script><script type=\"text/ng-template\" id=\"only-default-step\"><div ng-include=\"\'agreements-consent-treat\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENT_CONSENT_TO_TREAT\"></div>\n    <div ng-include=\"\'agreements-patient-rights\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENT_PATIENT_RIGHTS_AND_RESPONSIBILITIES\"></div>\n    <div ng-include=\"\'agreements-acknowledgment\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENT_ACKNOWLEDGMENT\"></div>\n    <div ng-include=\"\'agreements-transfer-medical\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENT_TRANSFER_MEDICAL\"></div>\n    <div ng-include=\"\'agreements-privacy-practices\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENT_PRIVACY_PRACTICES\"></div>\n    <div ng-include=\"\'agreements-treatment\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENT_TREATMENT\"></div></script><script type=\"text/ng-template\" id=\"not-only-default-step\"><div ng-include=\"\'only-default-step\'\"></div>\n    <div ng-include=\"\'agreements-continuity-of-care\'\" ng-if=\"vm.agreementsStepCurrent && vm.agreementsStepCurrent === vm.AGREEMENT_CONTINUITY_OF_CARE\"></div></script><!-- Welcome Letter --><script type=\"text/ng-template\" id=\"agreements-welcome\"><agreements-welcome agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-welcome></script><!-- consent-treat --><script type=\"text/ng-template\" id=\"agreements-consent-treat\"><agreements-consent-treat agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-consent-treat></script><!-- patient-rights --><script type=\"text/ng-template\" id=\"agreements-patient-rights\"><agreements-patient-rights agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-patient-rights></script><!-- acknowledgment --><script type=\"text/ng-template\" id=\"agreements-acknowledgment\"><agreements-acknowledgment agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-acknowledgment></script><!-- transfer-medical --><script type=\"text/ng-template\" id=\"agreements-transfer-medical\"><agreements-transfer-medical agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-transfer-medical></script><!-- privacy-practices --><script type=\"text/ng-template\" id=\"agreements-privacy-practices\"><agreements-privacy-practices agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-privacy-practices></script><!-- agreements-treatment --><script type=\"text/ng-template\" id=\"agreements-treatment\"><agreements-treatment agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-treatment></script><!-- opioid-monograph-and-narcotics --><!--\n<script type=\"text/ng-template\" id=\"agreements-opioid-monograph-and-narcotics\">\n    <agreements-opioid-monograph-and-narcotics agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-opioid-monograph-and-narcotics>\n</script>\n--><!-- risk-of-opioids --><!--\n<script type=\"text/ng-template\" id=\"agreements-risk-of-opioids\">\n    <agreements-risk-of-opioids agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-risk-of-opioids>\n</script>\n--><!-- continuity-of-care  --><script type=\"text/ng-template\" id=\"agreements-continuity-of-care\"><agreements-continuity-of-care agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-continuity-of-care></script><!-- progress-bar --><script type=\"text/ng-template\" id=\"progress-bar\"><progress-bar percent=\"vm.percentProgress\"></progress-bar></script><!-- Signature --><script type=\"text/ng-template\" id=\"signature\"><agreements-signature agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-signature></script>");
$templateCache.put("app/agreements-workflow/agreements.html","<div ng-class=\"vm.getLanguage() === \'es\' ? \'es-lang\': \'\'\"><div class=\"container\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12 h2 title\"><span translate=\"ipmApp.agreements.home.download.title\">Agreements</span></div><div class=\"col-md-12 mb-3\"><button type=\"button\" ng-click=\"vm.download()\" ng-if=\"!vm.isAgreementSignedAllByAPI && vm.agreements\" ng-disabled=\"!vm.isShowDownloadAll()\" class=\"btn btn-primary\"><span translate=\"entity.action.download\">Download</span></button></div><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"agreementName\"><span translate=\"ipmApp.agreements.name\">Name</span>&nbsp;<span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateSigned\"><span translate=\"ipmApp.agreements.date\">Date</span>&nbsp;<span class=\"glyphicon glyphicon-sort\"></span></th><!-- <th></th> --></tr></thead><tbody ng-if=\"vm.agreements && vm.agreements.length > 0\"><tr ng-repeat=\"ag in vm.agreements track by ag.id\"><td>{{\'ipmApp.agreements.workflowName.\' + ag.agreementName | translate}}</td><td>{{ag.dateSigned | date:\'MM/dd/yyyy\'}}</td><!-- <td class=\"text-right\">\n                                                <div class=\"btn-group flex-btn-group-container\">\n                                                    <button type=\"submit\"\n                                                        ui-sref=\"download({id: ag.id})\"\n                                                        class=\"btn btn-link\">\n                                                        <span class=\"glyphicon glyphicon-download\"></span>\n                                                        <span class=\"hidden-xs hidden-sm\"\n                                                            translate=\"entity.action.download\">Download</span>\n                                                    </button>\n                                                </div>\n                                            </td> --></tr></tbody><tbody ng-if=\"!vm.agreements || vm.agreements.length === 0\"><tr><td colspan=\"2\"><p class=\"help-block\" translate=\"ipmApp.agreements.notExistsActive\">There is not exists active agreement</p></td></tr></tbody></table></div></div></div></div><div class=\"col-md-12\"><button type=\"button\" ng-click=\"vm.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/coc-agreement-invitation/coc-agreement-invitation.html","<div class=\"container\"><div class=\"content\" ng-if=\"vm.isPageLoadFinish\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 voffset5\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"voffset3 text-center mb-35 font-s15\"><span ng-if=\"vm.errorNotFound\">{{\'cocAgreement.home.messages.recordNotFound\' | translate}}</span></div></div></div></div></div></div>");
$templateCache.put("app/download-activity-report/download-activity-report.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span ng-if=\"vm.serviceType === \'HAQ\'\" translate=\"ipmApp.downloadActivityReport.home.titleHAQ\"></span> <span ng-if=\"vm.serviceType === \'CPR\'\" translate=\"ipmApp.downloadActivityReport.home.titleCPR\"></span></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.downloadActivityReport.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.downloadActivityReport.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.downloadActivityReport.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.downloadActivityReport.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.downloadActivityReport.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.fromDate > vm.toDate\" ng-click=\"vm.download()\" translate=\"ipmApp.downloadActivityReport.download\" class=\"btn btn-info\">Generate Report</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.downloadActivityReport.noActivityReport\">There is no Activity Report</p></div></div></div></div></div></form>");
$templateCache.put("app/download-activity-report/request-activity-report.html","<form ng-if=\"vm.isUserRequest\" name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span ng-if=\"vm.serviceType === \'HAQ\'\" translate=\"ipmApp.downloadActivityReport.home.titleHAQ\"></span> <span ng-if=\"vm.serviceType === \'CPR\'\" translate=\"ipmApp.downloadActivityReport.home.titleCPR\"></span></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"!vm.fileId\" ng-click=\"vm.download()\" translate=\"ipmApp.downloadActivityReport.start\" class=\"btn btn-info\">Start</button></div></div></div></div></div></div></div></form>");
$templateCache.put("app/download-adhoc-testing/download-adhoc-testing.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"ipmApp.adhocTesting.downloadAdhocTesting.title\"></span></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid || vm.inValidDates\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4 row align-items-end\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.inValidDates\" ng-click=\"vm.download()\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"form-group\"><label class=\"col-sm-12\"><span>{{\'ipmApp.adhocTesting.downloadAdhocTesting.tests\' | translate}}</span></label><div class=\"col-md-9 form-group\"><ui-select style=\"max-width: none\" multiple=\"multiple\" ng-model=\"vm.selectedTests\" name=\"selectedTests\" theme=\"bootstrap\" close-on-select=\"false\" style=\"width: 100%\"><ui-select-match placeholder=\"Choose...\"><span class=\"select-mde\" title=\"{{$item.nameEn}}\">{{$item.nameEn}}</span></ui-select-match><ui-select-choices repeat=\"test in vm.tests | filter: {nameEn: $select.search}\"><div ng-bind-html=\"test.nameEn | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf && !vm.isChangeService\"><p class=\"help-block\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.noAdhocTesting\">There is no Adhoc Testing</p></div></div></div></div></div></form>");
$templateCache.put("app/download-agreements/download-agreements.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.agreements.downloadAgreements.title\"></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\" translate=\"ipmApp.agreements.downloadAgreements.fromDate\">Start Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.agreements.downloadAgreements.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.agreements.downloadAgreements.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.agreements.downloadAgreements.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\" translate=\"ipmApp.agreements.downloadAgreements.toDate\">End Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.agreements.downloadAgreements.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.agreements.downloadAgreements.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.fromDate > vm.toDate\" ng-click=\"vm.download()\" translate=\"entity.action.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPatientOrPdf\"><p class=\"help-block\" translate=\"ipmApp.agreements.downloadAgreements.noAgreement\">There is no agreement</p></div></div></div></div></div></form>");
$templateCache.put("app/download-battery-results/download-battery-results.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"global.menu.entities.downloadBatteryResults\"></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\" translate=\"ipmApp.downloadResult.fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" ng-change=\"vm.onChangeDate()\" enable-time=\"false\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.downloadResult.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.downloadResult.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.downloadResult.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\" translate=\"ipmApp.downloadResult.toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.downloadResult.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.downloadResult.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.fromDate > vm.toDate\" ng-click=\"vm.download()\" translate=\"ipmApp.downloadResult.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.downloadResult.noPdf\">There is no PDF</p></div></div></div></div></div></form>");
$templateCache.put("app/download-care-plan-review/download-care-plan-review.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.downloadCarePlanReview.home.title\"></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.downloadCarePlanReview.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.downloadCarePlanReview.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.downloadCarePlanReview.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.downloadCarePlanReview.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.downloadCarePlanReview.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.fromDate > vm.toDate\" ng-click=\"vm.download()\" translate=\"ipmApp.downloadCarePlanReview.download\" class=\"btn btn-info\">Generate Report</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.downloadCarePlanReview.noPdf\">There is no PDF</p></div></div></div></div></div></form>");
$templateCache.put("app/download-case-exclusions/download-case-exclusions.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"ipmApp.caseExclusions.downloadCases.title\"></span></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid || vm.inValidDates\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.caseExclusions.downloadCases.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.caseExclusions.downloadCases.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.caseExclusions.downloadCases.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.caseExclusions.downloadCases.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.caseExclusions.downloadCases.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4 row align-items-end\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.inValidDates\" ng-click=\"vm.download()\" translate=\"ipmApp.caseExclusions.downloadCases.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">Service</label><select class=\"form-control\" name=\"caseExclusionsType\" id=\"caseExclusionsType\" ng-model=\"vm.caseExclusionsType\" ng-change=\"vm.loadServiceDetails()\" ng-options=\"opt as \'ipmApp.caseExclusions.type.\' + opt | translate for opt in vm.caseExclusionsTypes\"><option value=\"\">{{\'ipmApp.caseExclusions.downloadCases.all\' | translate}}</option></select></div></div><div class=\"col-xs-7\"><div class=\"form-group\"><label class=\"control-label\">Filter by Toggle</label><div class=\"form-control mb-2\" ng-repeat=\"filter in vm.caseExclusionsFilter track by $index \" ng-if=\"!filter.isHidden\"><div class=\"col-xs-6\" translate=\"{{\'ipmApp.caseExclusions.detailType.\' + filter.type}}\"></div><div class=\"col-xs-2\"><input type=\"radio\" name=\"all_{{filter.type}}\" ng-value=\"null\" ng-model=\"filter.isExcluded\"> All</div><div class=\"col-xs-2\"><input type=\"radio\" name=\"allowed_{{filter.type}}\" ng-value=\"false\" ng-model=\"filter.isExcluded\"> Allowed</div><div class=\"col-xs-2\"><input type=\"radio\" name=\"excluded_{{filter.type}}\" ng-value=\"true\" ng-model=\"filter.isExcluded\"> Excluded</div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf && !vm.isChangeService\"><p class=\"help-block\" translate=\"ipmApp.caseExclusions.downloadCases.noCaseExclusions\">There is no Case Exclusions</p></div></div></div></div></div></form>");
$templateCache.put("app/download-case-exclusions/request-case-exclusions.html","<form ng-if=\"vm.isUserRequest\" name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"ipmApp.caseExclusions.download.title\"></span></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"!vm.fileId\" ng-click=\"vm.download()\" translate=\"ipmApp.caseExclusions.download.start\" class=\"btn btn-info\">Start</button></div></div></div></div></div></div></div></form>");
$templateCache.put("app/download-detailed-adhoc-testing/download-detailed-adhoc-testing.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"ipmApp.adhocTesting.downloadAdhocTesting.detailed\"></span></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid || vm.inValidDates\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4 row align-items-end\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.inValidDates\" ng-click=\"vm.download()\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"form-group\"><label class=\"col-sm-12\"><span>{{\'ipmApp.adhocTesting.downloadAdhocTesting.showDetailed\' | translate}}</span></label><div class=\"col-md-9 form-group\"><select class=\"form-control\" name=\"selectedTest\" id=\"selectedTest\" ng-model=\"vm.selectedTest\" ng-options=\"opt as opt.nameEn | translate for opt in vm.tests\"></select></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.adhocTesting.downloadAdhocTesting.noDetailedAdhocTesting\">There is no Detailed Adhoc Testing</p></div></div></div></div></div></form>");
$templateCache.put("app/download-haq-evaluation/download-haq-evaluation.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.downloadHaqEvaluation.home.title\"></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.downloadHaqEvaluation.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.downloadHaqEvaluation.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.downloadHaqEvaluation.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.downloadHaqEvaluation.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.downloadHaqEvaluation.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.fromDate > vm.toDate\" ng-click=\"vm.downloadHaqEvaluation()\" translate=\"ipmApp.downloadHaqEvaluation.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.downloadHaqEvaluation.noPdf\">There is no PDF</p></div></div></div></div></div></form>");
$templateCache.put("app/download-haq-results-reports/download-haq-results-reports.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div ng-if=\"!vm.isAdhoc\" class=\"h2 title\" translate=\"ipmApp.downloadHAQResultsReports.home.title\"></div><div ng-if=\"vm.isAdhoc\" class=\"h2 title\" translate=\"ipmApp.downloadAdhocTestsReports.home.title\"></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.downloadCarePlanReview.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.downloadCarePlanReview.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.downloadHAQResultsReports.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.downloadCarePlanReview.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.downloadCarePlanReview.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.checkProcessingDownload() || vm.fromDate > vm.toDate\" ng-click=\"vm.download()\" translate=\"ipmApp.downloadHAQResultsReports.download\" class=\"btn btn-info\">Generate Report</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.downloadHAQResultsReports.noPdf\">There is no PDF</p></div><div class=\"col-xs-12\" ng-show=\"vm.isDownloadingHasSentMail\"><p class=\"help-block\" translate=\"ipmApp.downloadHAQResultsReports.downloadingHasSentMail\">The report has been sent via email.</p></div></div></div></div></div></form>");
$templateCache.put("app/download-haq-results-reports/request-haq-results-reports.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"ipmApp.downloadHAQResultsReports.home.title\"></span></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"!vm.validDownload || vm.isProcessing\" ng-click=\"vm.download()\" translate=\"ipmApp.downloadHAQResultsReports.start\" class=\"btn btn-info\">Start</button></div></div></div></div></div></div></div></form>");
$templateCache.put("app/download-psych-intakes/download-psych-intakes.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"global.menu.entities.downloadPsychIntake\"></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\" translate=\"ipmApp.downloadResult.fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" ng-change=\"vm.onChangeDate()\" enable-time=\"false\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.downloadResult.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.downloadResult.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.downloadResult.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\" translate=\"ipmApp.downloadResult.toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.downloadResult.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.downloadResult.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.fromDate > vm.toDate\" ng-click=\"vm.download()\" translate=\"ipmApp.downloadResult.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.downloadResult.noPdf\">There is no PDF</p></div></div></div></div></div></form>");
$templateCache.put("app/download-result/download-result.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.downloadResult.home.title\"></div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" ng-change=\"vm.onChangeDate()\" enable-time=\"false\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.downloadResult.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.downloadResult.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.downloadResult.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.downloadResult.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.downloadResult.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.fromDate > vm.toDate\" ng-click=\"vm.downloadResult()\" translate=\"ipmApp.downloadResult.download\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"ipmApp.downloadResult.noPdf\">There is no PDF</p></div></div></div></div></div></form>");
$templateCache.put("app/frp-mde/add-enroll-patients-dialog.html","<form name=\"vm.addEnrollPatientForm\" role=\"form\" novalidate show-validation ng-init=\"vm.modalLoaded()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\"><span translate=\"frpmdeDashboard.addEnrollPatient\">Add/Enroll Patient</span></h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group typeahead\"><div class=\"input-group search-input\"><span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span> </span><input type=\"text\" class=\"form-control\" name=\"searchPatient\" id=\"modalPatientSearch\" typeahead-editable placeholder=\"{{\'frpmdeDashboard.searchForPatient\' | translate}}\" ng-model=\"vm.searchValue\" typeahead-append-to=\"vm.searchResultEle\" typeahead-on-select=\"vm.setPatientNameAndChartNumber($viewValue)\" ng-model-options=\"{debounce: 800}\" uib-typeahead=\"patient as patient.displayFormat for patient in vm.searchPatient($viewValue)\" ng-maxlength=\"255\" autocomplete=\"off\" ng-blur=\"vm.checkValidPatient()\"></div><div class=\"ipm-auto-complete-container\"><div class=\"imp-auto-complete-box\" id=\"search-patient-auto-complete-modal\" ng-init=\"\"></div></div><div ng-show=\"vm.addEnrollPatientForm.searchPatient.$dirty\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.patientName.$error.required || vm.addEnrollPatientForm.chartNumber.$error.required\" translate=\"frpmdeDashboard.searchForPatient.required\">This field is required.</p></div><!--<div\n                ng-show=\"!vm.validPatient\"\n            >\n                <p\n                    class=\"help-block\"\n                    ng-show=\"!vm.patientId\"\n                    translate=\"frpmdeDashboard.searchForPatient.required\"\n                >\n                    This field is required.\n                </p>\n            </div>--></div><div class=\"form-group\"><input type=\"text\" disabled=\"disabled\" class=\"form-control\" name=\"patientName\" ng-model=\"vm.patient.patientName\" placeholder=\"{{\'frpmdeDashboard.enrollPopup.patientName\' | translate }}\" ng-maxlength=\"255\" required></div><div class=\"form-group\"><input type=\"text\" disabled=\"disabled\" class=\"form-control\" name=\"chartNumber\" ng-model=\"vm.patient.chartNumber\" placeholder=\"{{\'frpmdeDashboard.enrollPopup.chartNumber\' | translate }}\" ng-maxlength=\"255\" required><!-- <p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\"\n                    translate=\"entity.validation.maxlength\" translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p> --></div><!--authorizedProvider--><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.authorizedProvider\">Authorized Provider</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><ui-select ng-model=\"vm.patient.provider\" theme=\"bootstrap\" name=\"authorizedProvider\" id=\"authorizedProvider\" required><ui-select-match placeholder=\"Select provider...\">{{$select.selected.firstName}} {{$select.selected.lastName}}</ui-select-match><ui-select-choices repeat=\" p in vm.providers |  orderBy:[\'firstName\', \'lastName\'] : false | filter: $select.search\"><div ng-bind-html=\"(p.firstName + \' \' + p.lastName)  | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-show=\"vm.addEnrollPatientForm.authorizedProvider.$dirty && vm.addEnrollPatientForm.authorizedProvider.$invalid\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.authorizedProvider.$error.required\" translate=\"frpmdeDashboard.enrollPopup.authorizedProvider.required\">This field is required.</p></div></div><!--frpProgram--><!--<div class=\"form-group\">\n            <label translate=\"frpmdeDashboard.enrollPopup.frpProgram\">FRP program</label>\n            <span\n                class=\"glyphicon glyphicon-asterisk icon-required\"\n                aria-hidden=\"true\"\n            ></span>\n            <select\n                class=\"form-control\"\n                name=\"patientFrpProgram\"\n                id=\"patientFrpProgam\"\n                ng-model=\"vm.patient.frpProgramId\"\n                required\n                ng-options=\"frpProgram.id as frpProgram.name for frpProgram in vm.frpPrograms\"\n            >\n                <option value=\"\" selected></option>\n            </select>\n            <div\n                ng-show=\"vm.addEnrollPatientForm.patientFrpProgram.$dirty && vm.addEnrollPatientForm.patientFrpProgram.$invalid\"\n            >\n                <p\n                    class=\"help-block\"\n                    ng-show=\"vm.addEnrollPatientForm.patientFrpProgram.$error.required\"\n                    translate=\"frpmdeDashboard.enrollPopup.frpProgram.required\"\n                >\n                    This field is required.\n                </p>\n            </div>\n        </div>--><!--mdeOffices--><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.mdeOffice\">MDE Office</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"patientMdeOffice\" id=\"patientMdeOffice\" ng-model=\"vm.patient.mdeOfficeId\" required ng-options=\"mdeOffice.id as mdeOffice.name for mdeOffice in vm.mdeOffices\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.addEnrollPatientForm.patientMdeOffice.$dirty && vm.addEnrollPatientForm.patientMdeOffice.$invalid\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.patientMdeOffice.$error.required\" translate=\"frpmdeDashboard.enrollPopup.mdeOffice.required\">This field is required.</p></div></div><!-- Case Number --><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.caseNumber\">Case Number</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"caseNumber\" ng-model=\"vm.patient.caseNumber\" ng-maxlength=\"255\" required><div ng-show=\"vm.addEnrollPatientForm.caseNumber.$dirty && vm.addEnrollPatientForm.caseNumber.$invalid\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.caseNumber.$error.required\" translate=\"frpmdeDashboard.enrollPopup.caseNumber.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.caseNumber.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.injuryDate\">Injury Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"injuryDate\" name=\"injuryDate\" uib-datepicker-popup=\"{{vm.dateFormat}}\" ng-model=\"vm.patient.injuryDate\" is-open=\"vm.isShowCalendar\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" datepicker-options=\"vm.dateOptions\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.authorizedBodyPart\">Authorized Body Part</label><input type=\"text\" class=\"form-control\" name=\"authorizedBodyPart\" ng-model=\"vm.patient.authorizedBodyPart\"></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.employer\">Employer</label><input type=\"text\" class=\"form-control\" name=\"employer\" ng-model=\"vm.patient.employer\"></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.jobTitle\">Job Title</label><input type=\"text\" class=\"form-control\" name=\"jobTitle\" ng-model=\"vm.patient.jobTitle\"></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.caseInsurance\">Case Insurance</label><input type=\"text\" class=\"form-control\" name=\"caseInsurance\" ng-model=\"vm.patient.caseInsurance\"><div ng-show=\"vm.addEnrollPatientForm.caseInsurance.$dirty && vm.addEnrollPatientForm.caseInsurance.$invalid\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.caseInsurance.$error.required\" translate=\"frpmdeDashboard.enrollPopup.caseInsurance.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.claimNumber\">Claim Number</label><input type=\"text\" class=\"form-control\" name=\"claimNumber\" ng-model=\"vm.patient.claimNumber \"><div ng-show=\"vm.addEnrollPatientForm.claimNumber.$dirty && vm.addEnrollPatientForm.claimNumber.$invalid\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.claimNumber.$error.required\" translate=\"frpmdeDashboard.enrollPopup.claimNumber.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.nurseCaseManager\">Nurse Case Manager</label><input type=\"text\" class=\"form-control\" name=\"nurseCaseManager\" ng-model=\"vm.patient.nurseCaseManager\"><div ng-show=\"vm.addEnrollPatientForm.nurseCaseManager.$dirty && vm.addEnrollPatientForm.nurseCaseManager.$invalid\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.nurseCaseManager.$error.required\" translate=\"frpmdeDashboard.enrollPopup.nurseCaseManager.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"frpmdeDashboard.enrollPopup.applicantsAttorney\">Applicant\'s Attorney</label><input type=\"text\" class=\"form-control\" name=\"applicantAttorney\" ng-model=\"vm.patient.applicantAttorney\"><div ng-show=\"vm.addEnrollPatientForm.applicantAttorney.$dirty && vm.addEnrollPatientForm.applicantAttorney.$invalid\"><p class=\"help-block\" ng-show=\"vm.addEnrollPatientForm.applicantAttorney.$error.required\" translate=\"frpmdeDashboard.enrollPopup.applicantsAttorney.required\">This field is required.</p></div></div></div><div class=\"pt-3 text-center\" ng-show=\"vm.isExistsEnroll\"><p class=\"help-block\" translate=\"frpmdeDashboard.enrollPopup.errorEnrollExists\">This Enroll already exists.</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"vm.addEnrollPatientForm.$invalid\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span translate=\"frpmdeDashboard.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"frpmdeDashboard.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/frp-mde/add-request-patient-detail-dialog.html","<form name=\"vm.editForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"myUserLabel\"><!-- {{vm.title | translate}} --> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button> <span translate=\"ipmApp.patient.authorizedHours.addRequestAuthorization\" ng-if=\"!vm.authorizedHour.id\">Add Request/Authorization</span> <span translate=\"ipmApp.patient.authorizedHours.editRequestAuthorization\" ng-if=\"vm.authorizedHour.id\">Add Request/Authorization</span></h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><label translate=\"ipmApp.patient.authorizedHours.dateRequested\">Date Requested</label><span ng-if=\"vm.authorizedHour.dateRequested || vm.authorizedHour.hoursRequested || (vm.authorizedHour.id && vm.oldData.dateRequested)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"form-input\"></div><div class=\"form-group\"><div class=\"input-group\"><input name=\"daterequested\" id=\"field_dateRequested\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"dateRequestOptions\" ng-required=\"vm.authorizedHour.dateRequested || vm.authorizedHour.hoursRequested || (vm.authorizedHour.id && vm.oldData.dateRequested)\" ng-model=\"vm.authorizedHour.dateRequested\" is-open=\"vm.datePickerOpenStatus.dateRequested\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateRequested\')\"></span></div></div><div ng-show=\"vm.editForm.daterequested.$dirty && vm.editForm.daterequested.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.daterequested.$invalid && !vm.editForm.daterequested.$error.required\" translate=\"ipmApp.patient.authorizedHours.daterequested.invalid\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.editForm.daterequested.$error.required\" translate=\"ipmApp.patient.authorizedHours.daterequested.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.patient.authorizedHours.hoursRequested\">Hour Requested</label><span ng-if=\"vm.authorizedHour.dateRequested || vm.authorizedHour.hoursRequested || (vm.authorizedHour.id && vm.oldData.hoursRequested)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"number\" class=\"form-control\" name=\"hoursrequested\" ng-model=\"vm.authorizedHour.hoursRequested\" ng-required=\"vm.authorizedHour.dateRequested || vm.authorizedHour.hoursRequested || (vm.authorizedHour.id && vm.oldData.hoursRequested)\" ng-maxlength=\"10\" ng-model-options=\"{ allowInvalid: true }\"><div ng-show=\"vm.editForm.hoursrequested.$dirty && vm.editForm.hoursrequested.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.hoursrequested.$error.required\" translate=\"ipmApp.patient.authorizedHours.hoursrequested.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.editForm.hoursrequested.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</p></div></div><label translate=\"ipmApp.patient.authorizedHours.dateAuthorized\">Date Authorized</label><span ng-if=\"vm.authorizedHour.dateAuthorized || vm.authorizedHour.hoursAuthorized || (vm.authorizedHour.id && vm.oldData.dateAuthorized)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"form-group\"><div class=\"input-group\"><input name=\"dateauthorized\" id=\"field_dateAuthorized\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"dateAuthorOptions\" ng-required=\"vm.authorizedHour.dateAuthorized || vm.authorizedHour.hoursAuthorized || (vm.authorizedHour.id && vm.oldData.dateAuthorized)\" ng-model=\"vm.authorizedHour.dateAuthorized\" is-open=\"vm.datePickerOpenStatus.dateAuthorized\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateAuthorized\')\"></span></div></div><div ng-show=\"vm.editForm.dateauthorized.$dirty && vm.editForm.dateauthorized.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.dateauthorized.$invalid && !vm.editForm.dateauthorized.$error.required\" translate=\"ipmApp.patient.authorizedHours.dateauthorized.invalid\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.editForm.dateauthorized.$error.required\" translate=\"ipmApp.patient.authorizedHours.dateauthorized.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.patient.authorizedHours.hoursAuthorized\">Hour Authorized</label><span ng-if=\"vm.authorizedHour.dateAuthorized || vm.authorizedHour.hoursAuthorized || (vm.authorizedHour.id && vm.oldData.hoursAuthorized)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"number\" class=\"form-control\" name=\"hourauthorized\" ng-required=\"vm.authorizedHour.dateAuthorized || vm.authorizedHour.hoursAuthorized || (vm.authorizedHour.id && vm.oldData.hoursAuthorized)\" ng-model=\"vm.authorizedHour.hoursAuthorized\" ng-maxlength=\"10\" ng-model-options=\"{ allowInvalid: true }\"><div ng-show=\"vm.editForm.hourauthorized.$dirty && vm.editForm.hourauthorized.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.hourauthorized.$error.required\" translate=\"ipmApp.patient.authorizedHours.hoursAuthorized.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.editForm.hourauthorized.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</p></div></div><div><label translate=\"\">Attachment</label></div><div><span ng-repeat=\"attachment in vm.authorizedHour.attachments track by $index\" ng-class=\"{\'fa fa-file-word-o\' :  attachment.fileExt == \'docx\',\'fa fa-file-pdf-o\' : attachment.fileExt == \'pdf\', \'fa fa-file-picture-o\' : attachment.fileExt == \'tiff\'}\" style=\"font-size:30px\" ng-click=\"vm.downloadFile(attachment.id)\" title=\"{{attachment.fileName}}\"><button type=\"button\" class=\"close delete-file-icon\" aria-hidden=\"true\" ng-click=\"vm.confirmDialog(attachment)\">&times;</button></span></div><div><button class=\"btn btn-primary\" ngf-select ngf-change=\"vm.uploadFile($files)\" accept=\".tiff, .pdf, .docx\" ngf-multiple=\"true\"><span class=\"glyphicon glyphicon-open\"></span> <span translate=\"ipmApp.patient.upload\">Upload</span></button></div><div class=\"modal-footer\"><button type=\"button\" ng-disabled=\"vm.editForm.$invalid || !vm.checkValidation() || vm.unChanged()\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></div></form>");
$templateCache.put("app/frp-mde/frp-mde.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-3\"><select class=\"form-control\" name=\"frpProgram_name\" id=\"frpProgram_name\" ng-model=\"vm.frpProgramId\" ng-options=\"frpProgram.id as frpProgram.name for frpProgram in vm.frpPrograms\" ng-change=\"vm.programChange()\" required><option value=\"Frp Program Name\" selected=\"selected\"></option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-8 voffset3\"><button class=\"btn btn-primary\" ng-click=\"vm.openPatientsDialog()\" ng-disabled=\"!vm.frpProgramId || vm.isView\"><span translate=\"frpmdeDashboard.addEnrollPatient\">Add/Enroll Patient</span></button></div><div class=\"col-xs-12 co l-sm-6 col-md-4 voffset3\"><div class=\"form-group typeahead\"><div class=\"input-group search-input\"><span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span> </span><input type=\"text\" class=\"form-control\" name=\"searchPatient\" id=\"search\" ng-disabled=\"!vm.frpProgramId\" placeholder=\"{{\'frpmdeDashboard.searchForPatient\' | translate }}\" typeahead-append-to=\"vm.searchResultEle\" typeahead-on-select=\"vm.showPatientData($item)\" ng-model-options=\"{debounce: 600}\" ng-model=\"vm.patientSearchSelect\" typeahead-min-length=\"3\" typeahead-wait-ms=\"100\" uib-typeahead=\"patient as patient.name for patient in vm.searchPatient($viewValue)\" ng-maxlength=\"255\"></div><div class=\"ipm-auto-complete-container\"><div class=\"imp-auto-complete-box\" id=\"search-patient-auto-complete\"></div></div></div></div></div><div class=\"mt-5\"><uib-tabset active=\"vm.activeTabIndex\"><uib-tab index=\"vm.tabFrp\" select=\"vm.tabSelect(vm.tabFrp)\" class=\"primary\"><uib-tab-heading><span translate=\"frpmdeDashboard.frpTab.frp\">FRP</span></uib-tab-heading><div ng-if=\"vm.activeTabIndex === vm.tabFrp\"><frp-tab frp-program-id=\"vm.frpProgramId\" frp-programs=\"vm.frpPrograms\" is-view=\"vm.isView\" is-show-warning-message-previous-week-not-finalized=\"vm.isShowWarningMessagePreviousWeekNotFinalized\"></frp-tab></div></uib-tab><uib-tab index=\"vm.tabMde\" select=\"vm.tabSelect(vm.tabMde)\" class=\"primary\"><uib-tab-heading><span translate=\"frpmdeDashboard.mdeTab.mde\">MDE</span></uib-tab-heading><div ng-if=\"vm.activeTabIndex === vm.tabMde\"><mde-tab frp-program-id=\"vm.frpProgramId\" frp-programs=\"vm.frpPrograms\" is-view=\"vm.isView\"></mde-tab></div></uib-tab><uib-tab index=\"vm.tabInactive\" select=\"vm.tabSelect(vm.tabInactive)\" class=\"primary\"><uib-tab-heading><span translate=\"frpmdeDashboard.inactivePatientsTab.inactivePatients\">Inactive Patients</span></uib-tab-heading><div ng-if=\"vm.activeTabIndex === vm.tabInactive\"><inactive-patients-tab frp-program-id=\"vm.frpProgramId\" frp-programs=\"vm.frpPrograms\"></inactive-patients-tab></div></uib-tab></uib-tabset></div><div class=\"row\" ng-if=\"vm.isShowWarningMessagePreviousWeekNotFinalized && vm.activeTabIndex === vm.tabFrp\"><div class=\"col-md-12\"><label class=\"text-danger\" translate=\"ipmApp.frp.previousWeekNotFinalized\">Previous Week Not Finalized!</label></div></div></div></div></div>");
$templateCache.put("app/frp-mde/patient-frp-mde-detail.html","<div class=\"page\"><div class=\"container\"><div class=\"content\"><form name=\"vm.editForm\" role=\"form\" novalidate show-validation><div class=\"row\"><div class=\"col-md-12 h2 title\" translate=\"ipmApp.patient.title\">Patients FRP/MDE Detail</div><div class=\"col-md-12\"><span class=\"h4\">{{vm.patient.patient.firstName}} {{vm.patient.patient.lastName}}</span> <span ng-if=\"vm.patient.patient.firstName && vm.patient.patientId\">- </span><span class=\"h4\" ng-if=\"vm.patient.patientId\">{{vm.patient.patient.patientId}}</span></div></div><div class=\"mt-3\"></div><jhi-alert></jhi-alert><div class=\"row-v4 align-items-start mb-10 mt-15\"><div class=\"col-v4-lg-4 col-v4-md-6\"><div class=\"row-v4\"><div class=\"col-v4-lg-6 col-v4-md-6\"><div class=\"form-group mt-10px mb-1\"><label translate=\"ipmApp.patient.frpProgram\">FRP Program</label><select ng-class=\"vm.isViewFrpProgram ? \'ng-invalid-has-error\' : \'\'\" class=\"form-control\" name=\"frpPrograms\" id=\"frpPrograms\" ng-model=\"vm.patient.frpProgramId\" ng-options=\"frpProgram.id as frpProgram.name for frpProgram in vm.frpPrograms\" ng-change=\"vm.changeFrpProgram()\" required></select></div></div><div class=\"col-v4-lg-6 col-v4-md-6\"><div class=\"form-group mt-10px mb-1\"><label translate=\"ipmApp.patient.mdeOffice\">MDE Office</label><select ng-class=\"vm.isViewMde ? \'ng-invalid-has-error\' : \'\'\" class=\"form-control\" name=\"mdeOffices\" id=\"mdeOffices\" ng-model=\"vm.patient.mdeOfficeId\" ng-options=\"mdeOffices.id as mdeOffices.name for mdeOffices in vm.mdeOffices\" ng-change=\"vm.changeMdeOffice()\" required></select></div></div></div><div ng-show=\"vm.isViewFrpMde()\" class=\"row-v4 justify-content-center\"><div class=\"help-block\">This office is not FRP/MDE enabled</div></div></div><div class=\"col-v4-lg-2 col-v4-md-3\"><div class=\"form-group mt-10px\"><label translate=\"ipmApp.patient.FRP\">FRP</label><select class=\"form-control\" name=\"frp_status\" id=\"frp_status\" ng-model=\"vm.patient.frpStatus\" ng-options=\"status as \'ipmApp.patient.frpStatus.\' + status | translate for status in vm.frpStatus track by status\" required></select></div></div><div class=\"col-v4-lg-2 col-v4-md-3\"><div class=\"form-group mt-10px\"><label translate=\"ipmApp.patient.authorizedProvider\">Authorized Provider</label><select class=\"form-control\" name=\"patientProvider\" id=\"patientProvider\" ng-model=\"vm.patient.providerId\" ng-options=\"p.id as (p.firstName + \' \' + p.lastName) for p in vm.providers | orderBy:[\'firstName\', \'lastName\']\"><option value=\"\" selected=\"selected\"></option></select></div></div><div class=\"col-v4-lg-2\"><div class=\"form-group mt-10px\"><label>&nbsp;</label><div class=\"text-center\"><button type=\"button\" ng-disabled=\"vm.editForm.$invalid || vm.isSaving || vm.unChange() || vm.isViewFrpMde()\" class=\"btn btn-primary\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"button\" ng-disabled=\"vm.editForm.$invalid || vm.isSaving || vm.unChange() || !vm.patient.caseNumber || vm.isViewFrpMde()\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-2\"><div class=\"form-group\"><label translate=\"ipmApp.patient.frpStartDate\">FRP Start Date</label><div class=\"input-group\"><input ng-disabled=\"vm.isDisabledStartDate\" name=\"frpStartDate\" id=\"dateOfService\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" ng-model=\"vm.patient.frpStartDate\" is-open=\"vm.datePickerOpenStatus.frpStartDate\" ng-change=\"vm.onChangeStartDate()\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'frpStartDate\')\"></span></div></div></div></div><div class=\"col-v4-md-2\"><div class=\"form-group\"><label class=\"text-break\" translate=\"ipmApp.patient.previouslyCompletedHours\">Previously Completed Hours</label><input type=\"text\" class=\"form-control\" name=\"previouslyCompletedHours\" id=\"previouslyCompletedHours\" ng-model=\"vm.patient.previouslyCompletedHours\" ng-change=\"vm.onChangePreviouslyCompletedHours()\" ng-required=\"vm.patient.previouslyCompletedHours\" number-min-max min=\"0\" max=\"{{vm.hoursAttendedCanNotExceed}}\"><div ng-show=\"vm.editForm.previouslyCompletedHours.$dirty && vm.editForm.previouslyCompletedHours.$invalid\"><div class=\"help-block\" ng-show=\"vm.editForm.previouslyCompletedHours.$error.required\" translate=\"entity.validation.required\">This field is required.</div><div class=\"help-block\" ng-show=\"vm.editForm.previouslyCompletedHours.$error.invalidRange\" translate=\"ipmApp.patient.previouslyCompletedHours.error\">Hours Attended Can Not Exceed 160.</div></div></div></div></div></form><div class=\"d-flex align-items-center mt-3\"><div class=\"bold flex-grow-0\">{{\'ipmApp.patient.caseNumber\' | translate}}</div><span class=\"glyphicon glyphicon-asterisk icon-required\"></span><div class=\"flex-grow-1 pl-10\"><div class=\"d-flex\"><div class=\"case-number-value\" ng-if=\"!vm.editCaseNumber\"><span>{{vm.patient.caseNumber}}</span></div><div class=\"case-number-value\" ng-if=\"vm.editCaseNumber\"><input type=\"text\" class=\"form-control\" name=\"caseNumber\" id=\"caseNumber\" required placeholder=\"Case number name\" ng-model=\"vm.patient.caseNumber\"></div><div><button ng-disabled=\"vm.isViewFrpMde()\" type=\"button\" class=\"btn btn-info\" ng-click=\"vm.updateEditCaseNumber()\"><span ng-if=\"vm.editCaseNumber && vm.patient.caseNumber === null\">{{\'entity.action.add\' | translate}}</span> <span ng-if=\"vm.editCaseNumber && vm.patient.caseNumber !== null\">{{\'entity.action.save\' | translate}}</span> <span ng-if=\"!vm.editCaseNumber\">{{\'entity.action.edit\' | translate}}</span></button></div></div></div></div><div class=\"h2 primary bold text-center mt-40\" translate=\"ipmApp.patient.frpMdeReport.title\">FRP Reports</div><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr><th>{{\'ipmApp.patient.frpMdeReport.weekOf\' | translate}}</th><th>{{\'ipmApp.patient.frpMdeReport.reports\' | translate}}</th><th>{{\'ipmApp.patient.frpMdeReport.reportType\' | translate}}</th><th>{{\'ipmApp.patient.frpMdeReport.office\' | translate}}</th><th>{{\'ipmApp.patient.frpMdeReport.status\' | translate}}</th><th>{{\'ipmApp.patient.frpMdeReport.date\' | translate}}</th><th>{{\'ipmApp.patient.frpMdeReport.by\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports track by $index\"><td>{{report.dateOfWeek}}</td><td><div class=\"d-flex justify-content-space-around\"><span ng-if=\"report.status == \'FINALIZED\'\" class=\"glyphicon glyphicon-eye-open\" ng-click=\"vm.openReport(report)\"></span> <span ng-if=\"report.status != \'FINALIZED\'\" class=\"glyphicon glyphicon-eye-open disabled-color\"></span> <span ng-if=\"report.status == \'OPEN\'\" class=\"glyphicon glyphicon-pencil\" ng-click=\"vm.openReport(report)\"></span> <span ng-if=\"report.status != \'OPEN\'\" class=\"glyphicon glyphicon-pencil disabled-color\"></span> <span ng-if=\"report.status !== \'FINALIZED\'\" class=\"glyphicon glyphicon-save text-left disabled-color\"></span> <span ng-if=\"report.status === \'FINALIZED\'\" class=\"glyphicon glyphicon-save text-left\" ng-click=\"vm.downloadReport(report)\"></span></div></td><td><span>{{report.reportType}}</span><span ng-if=\"report.frpReportType\"> - </span><span ng-if=\"report.frpReportType\">{{\'ipmApp.patient.frpReportType.\' + report.frpReportType | translate}}</span></td><td>{{report.officeName}}</td><td>{{\'ipmApp.patient.statusType.\' + report.status | translate}}</td><td>{{report.dateFinalized| date:\'MM/dd/yyyy\'}}</td><td>{{report.finalizedBy}}</td><td width=\"5%\"><button type=\"button\" ng-click=\"vm.deleteReportClick(report)\" ng-disabled=\"vm.checkDisableDeletedReport(report)\" class=\"btn btn-danger btn-sm\"><span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.patient.action.clearReport\"></span></button></td></tr></tbody><tbody ng-if=\"!vm.reports || vm.reports.length == 0\"><tr><td colspan=\"6\" class=\"text-center\"><p ng-if=\"!vm.isLoading\"><span translate=\"ipmApp.patient.frpMdeReport.required\">We couldn\'t find any FRP/MDE report.</span></p></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"15\" rotate=\"false\" ng-change=\"vm.loadAllReport()\"></uib-pagination></div><div class=\"h2 primary bold text-center mt-30\" translate=\"ipmApp.patient.authorizedHours.title\">Authorized Hours</div><div class=\"row\"><div class=\"col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2\"><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr><th>{{\'ipmApp.patient.authorizedHours.dateRequested\' |	translate}}</th><th>{{\'ipmApp.patient.authorizedHours.hoursRequested\' |	translate}}</th><th>{{\'ipmApp.patient.authorizedHours.dateAuthorized\' |	translate}}</th><th>{{\'ipmApp.patient.authorizedHours.hoursAuthorized\' |	translate}}</th><th>{{\'ipmApp.patient.authorizedHours.attachments\' | translate}}</th><th>{{\'ipmApp.patient.authorizedHours.edit\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"authorizedHour in vm.authorizedHours track by $index\"><td>{{authorizedHour.dateRequested | date:\'MM/dd/yyyy\'}}</td><td>{{authorizedHour.hoursRequested}}</td><td>{{authorizedHour.dateAuthorized | date:\'MM/dd/yyyy\'}}</td><td>{{authorizedHour.hoursAuthorized}}</td><td><span ng-repeat=\"attachment in authorizedHour.attachments track by $index\" style=\"padding: 2px\" ng-class=\"{\'fa fa-file-word-o\' : attachment.fileExt == \'docx\', \'fa fa-file-pdf-o\' : attachment.fileExt == \'pdf\', \'fa fa-file-picture-o\' : attachment.fileExt == \'tiff\'}\" ng-click=\"vm.downloadFile(attachment)\" title=\"{{attachment.fileName}}\"></span> <span class=\"glyphicon glyphicon-open pull-right\" ngf-select ngf-change=\"vm.uploadFile($files, authorizedHour)\" accept=\".tiff, .pdf, .docx\" ngf-multiple=\"true\"></span></td><td><span class=\"glyphicon glyphicon-pencil\" ui-sref=\"frp-mde-detail.editRequest({authorizedId:authorizedHour.id})\"></span></td></tr></tbody><tbody ng-if=\"!vm.authorizedHours || vm.authorizedHours.length === 0\"><tr><td colspan=\"6\" class=\"text-center\"><p ng-if=\"!vm.isLoading\"><span translate=\"ipmApp.patient.authorizedHours.required\">We couldn\'t find any authorized hours.</span></p></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItemsAuthorized\" ng-model=\"vm.pageAuthorized\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAllAuthorizedHours()\"></uib-pagination></div></div></div><div class=\"row\"><div class=\"col-md-12 text-center\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.isFinish\" ui-sref=\"frp-mde-detail.newRequest()\"><span translate=\"ipmApp.patient.authorizedHours.addRequestAuthorization\">Add Request/Authorization</span></button></div></div><div class=\"row mt-15px\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"frp-mde\"><span translate=\"ipmApp.patient.back\">Back</span></button></div></div></div></div></div>");
$templateCache.put("app/home/home.html","<div class=\"page page--home\" ng-show=\"!vm.azureLogoutProcessing\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.isInActive === true || vm.isWorflowComplete === true || vm.emailConfirmed === false\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 voffset5\"><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.isInActive === true\"><div class=\"thank warning center-block voffset3 font-s15\">!</div><div class=\"voffset3 text-center mb-35 font-s15\">{{\'home.messages.inActive\' | translate}}</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.isWorflowComplete === true\"><div class=\"thank center-block voffset3 font-s15\"><span class=\"glyphicon glyphicon-ok\"></span></div><div class=\"voffset3 text-center mb-35 font-s15\">{{\'home.messages.surveyComplete\' | translate}}</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.emailConfirmed === false && !vm.isAdHocHaq && vm.surveyResultType != vm.SURVEY_RESULT_TYPE_BATTERY\"><form name=\"confirmlForm\" role=\"form\" novalidate ng-submit=\"vm.confirmEmailAndInjuredType()\" show-validation><div class=\"row\"><div class=\"col-md-12 h2 title\" ng-if=\"vm.hasEmail\" translate=\"home.confirmhasemail.header\">Please confirm your email address</div><div class=\"col-md-12\" ng-if=\"vm.hasEmail\" translate=\"home.confirmhasemail.text\">In order to ensure we have up to date contact information please review and confirm your email address below.</div><div class=\"col-md-12 h2 title\" ng-if=\"!vm.hasEmail\" translate=\"home.confirmnotemail.header\">Please provide your email address</div><div class=\"col-md-12\" ng-if=\"!vm.hasEmail\" translate=\"home.confirmnotemail.text\">In order to ensure we have up to date contact information please provide your email address below.</div></div><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3\"><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-model=\"vm.email\" ng-maxlength=\"100\" required></div><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><div ng-show=\"confirmlForm.email.$dirty && confirmlForm.email.$invalid\"><p class=\"help-block\" ng-show=\"confirmlForm.email.$error.email || confirmlForm.email.$error.pattern\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"confirmlForm.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"confirmlForm.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail required.</p></div><div ng-show=\"!confirmlForm.email.$invalid && vm.errorEmailExists\"><p class=\"help-block\" translate=\"error.emailexists\">E-mail is already in use!</p></div></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><label for=\"injuredTitle\" translate=\"register.form.injured.title\">What is your injured body part?</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div ng-repeat=\"injuredType in vm.injuredTypes\"><label for=\"injuredType_{{$index}}\"><input id=\"injuredType_{{$index}}\" type=\"checkbox\" ng-model=\"injuredType.checked\" ng-disabled=\"injuredType.disabled\" ng-change=\"vm.selectedInjuredTypes(injuredType)\"> {{injuredType.name | translate}}</label></div><!-- <select class=\"form-control\"\n									   name=\"injuredType\"\n									   ng-model=\"vm.injuredType\"\n									   id=\"injuredType\"\n									   ng-options=\"injuredType.value as injuredType.name | translate for injuredType in vm.injuredTypes\"\n									   required>\n									   <option value=\"\" selected></option>\n									</select> --></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button type=\"submit\" ng-disabled=\"confirmlForm.$invalid || vm.isSaving || vm.patientInjuredTypes.length === 0\" class=\"btn btn-primary\"><span translate=\"global.form.confirm\">Confirm</span></button></div></div><div class=\"row\"><div class=\"col-xs-12 voffset3\"><i translate=\"home.messages.disclaimerText\"></i></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1\" ng-if=\"vm.emailConfirmed !== false && vm.isInActive !== true && vm.isWorflowComplete !== true && vm.isAuthenticated !== true && vm.isQuestionnaireIncomplete === null && vm.isQuestionnaireCount === null && vm.loginProcess !== true\"><div class=\"frm-login\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"alert alert-danger text-center\" ng-show=\"vm.authenticationError || vm.isAzurePatientLogin\" translate=\"home.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><div class=\"alert alert-danger text-center\" ng-show=\"vm.sessionTimeOut\" translate=\"home.messages.error.sessionTimeOut\">Your session has timed out, please login to continue this test.</div></div><form name=\"loginForm\" class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"frm-login-top\"><div class=\"h4 text-center primary\">{{\'home.greeting\' | translate}}</div><div class=\"form-group\"><button ng-disabled=\"vm.isProcessingLogin\" type=\"button\" ng-click=\"vm.loginAzure($event)\" class=\"btn btn-default center-block\"><span><iconify-icon class=\"iconify-icon\" icon=\"mdi:microsoft\"></iconify-icon></span><span translate=\"home.loginAzure\">Login with Microsoft</span></button></div><div class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-user\"></span></div><input type=\"text\" class=\"form-control\" placeholder=\"{{\'home.userID\' | translate}}\" id=\"username\" name=\"username\" ng-model=\"vm.username\"></div></div><div class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-lock\"></span></div><input type=\"password\" class=\"form-control\" placeholder=\"{{\'home.password\' | translate}}\" id=\"password\" name=\"password\" ng-model=\"vm.password\"> <span class=\"forget-password\" ng-click=\"vm.requestResetPassword()\">{{\'home.forgot\' | translate}}</span></div></div><button ng-disabled=\"vm.isProcessingLogin\" type=\"submit\" class=\"btn btn-primary center-block w-120\">{{\'home.login\' | translate}}</button></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/home/questionnaire-count-dialog.html","<form name=\"resumeForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"home.countQuestionnaire.title\">Your Questionnaires</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"home.countQuestionnaire.text\" translate-values=\"{count: \'{{vm.countQuestionnaire}}\'}\">You have open New Patient Questionnaires. When you\'ve completed this you\'ll be asked to respond to the next one. Thank you.</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"isSaving\" ng-click=\"vm.yes()\"><span translate=\"entity.action.ok\">Ok</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/home/questionnaire-resume-dialog.html","<form name=\"resumeForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"home.resumeQuestionnaire.title\">Resume Your Questionnaire</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"home.resumeQuestionnaire.text\">You started a New Patient Questionnaire, but haven\'t completed it. Would you like to resume it now?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"isSaving\" ng-click=\"vm.yes()\"><span translate=\"home.resumeQuestionnaire.yes\">Yes, I\'d like to resume</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"isSaving\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"home.resumeQuestionnaire.no\">No, not now</span></button><div class=\"pt-3\" ng-show=\"vm.managerAddNewQuestionnaire !== null\"><p class=\"help-block\" translate=\"home.resumeQuestionnaire.error.managerAddNewQuestionnaire\">Manager has been request new Questionnaire.</p></div><div class=\"pt-3\" ng-show=\"vm.patientAccessMultipleDevice !== null\"><p class=\"help-block\" translate=\"home.resumeQuestionnaire.error.patientAccessMultipleDevice\">Patient may be access multiple device.</p></div></div></form>");
$templateCache.put("app/landing-page/haq-body-part.html","<div class=\"col-md-12 col-sm-12 col-xs-12\"><form name=\"confirmlForm\" role=\"form\" novalidate ng-submit=\"vm.confirmEmailAndInjuredType()\" show-validation><div class=\"row\"><div class=\"col-md-12 h2 title\" ng-if=\"vm.hasEmail\" translate=\"home.confirmhasemail.header\">Please confirm your email address</div><div class=\"col-md-12\" ng-if=\"vm.hasEmail\" translate=\"home.confirmhasemail.text\">In order to ensure we have up to date contact information please review and confirm your email address below.</div><div class=\"col-md-12 h2 title\" ng-if=\"!vm.hasEmail\" translate=\"home.confirmnotemail.header\">Please provide your email address</div><div class=\"col-md-12\" ng-if=\"!vm.hasEmail\" translate=\"home.confirmnotemail.text\">In order to ensure we have up to date contact information please provide your email address below.</div></div><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3\"><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-model=\"vm.email\" ng-maxlength=\"100\" required></div><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><div ng-show=\"confirmlForm.email.$dirty && confirmlForm.email.$invalid\"><p class=\"help-block\" ng-show=\"confirmlForm.email.$error.email || confirmlForm.email.$error.pattern\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"confirmlForm.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"confirmlForm.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail required.</p></div><div ng-show=\"!confirmlForm.email.$invalid && vm.errorEmailExists\"><p class=\"help-block\" translate=\"error.emailexists\">E-mail is already in use!</p></div></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><label for=\"injuredTitle\" translate=\"register.form.injured.title\">What is your injured body part?</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div ng-repeat=\"injuredType in vm.injuredTypes\"><label for=\"injuredType_{{$index}}\"><input id=\"injuredType_{{$index}}\" type=\"checkbox\" ng-model=\"injuredType.checked\" ng-disabled=\"injuredType.disabled\" ng-change=\"vm.selectedInjuredTypes(injuredType)\"> {{injuredType.name | translate}}</label></div><!-- <select class=\"form-control\"\n                   name=\"injuredType\"\n                   ng-model=\"vm.injuredType\"\n                   id=\"injuredType\"\n                   ng-options=\"injuredType.value as injuredType.name | translate for injuredType in vm.injuredTypes\"\n                   required>\n                   <option value=\"\" selected></option>\n                </select> --></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button type=\"submit\" ng-disabled=\"confirmlForm.$invalid || vm.isSaving || vm.patientInjuredTypes.length === 0\" class=\"btn btn-primary\"><span translate=\"global.form.confirm\">Confirm</span></button></div></div><div class=\"row\"><div class=\"col-xs-12 voffset3\"><i translate=\"home.messages.disclaimerText\"></i></div></div></form></div>");
$templateCache.put("app/landing-page/item.html","<div class=\"wrap-box\"><div class=\"content-box\" ng-class=\"{\'cursor-default\' : vm.isCursorDefault()}\" ng-click=\"vm.clickAction()\"><img src=\"{{vm.item.image}}\"><div class=\"title-box\">{{vm.item.titleTextTranslate | translate}}</div><div><span>{{\'ipmApp.landingPage.details.step\' + vm.item.stepNumber | translate}}:</span> <span ng-class=\"vm.percentTextClass()\"><span>{{vm.item.percentProgress}}</span>% <span ng-if=\"vm.isShowCompletedText()\">{{vm.item.completedTextTranslate | translate}}</span> <span ng-if=\"!vm.isShowCompletedText()\">{{vm.item.terminadoTextTranslate | translate}}</span></span></div><div class=\"small\" ng-class=\"vm.timeRemainingTextClass()\"><span ng-if=\"vm.item.isCurrentStep && vm.isStart()\">{{vm.item.clickToStartTextTranslate | translate}}</span> <span ng-if=\"vm.item.isCurrentStep && vm.isNotYetCompleted() && !vm.isStart()\">{{vm.item.clickToResumeTextTranslate | translate}}</span> <span ng-if=\"vm.item.canDownload && vm.isCompleted()\">{{vm.item.clickToDownloadTextTranslate | translate}}</span> <span ng-if=\"vm.item.isCurrentStep\">&nbsp;-&nbsp;</span> <span ng-if=\"vm.isShowApproxText()\">{{vm.item.approxTextTranslate | translate}}</span> <span ng-if=\"!vm.isCompleted()\">{{vm.item.numberTimeRemaining}}</span><span ng-if=\"!vm.isCompleted()\">{{vm.item.minTextTranslate | translate}}</span> <span ng-if=\"vm.isShowRemainingText()\">{{vm.item.remainingTextTranslate | translate}}</span></div></div></div>");
$templateCache.put("app/landing-page/landing-page.html","<div class=\"page\"><div class=\"container\"><div ng-if=\"vm.isCompleteHAQ || vm.isInActiveHAQ\"><div class=\"content page--home row\"><div class=\"col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 voffset5\"><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.isCompleteHAQ\"><div class=\"thank center-block voffset3 font-s15\"><span class=\"glyphicon glyphicon-ok\"></span></div><div class=\"voffset3 text-center mb-35 font-s15\">{{\'home.messages.surveyComplete\' | translate}}</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.isInActiveHAQ\"><div class=\"thank warning center-block voffset3 font-s15\">!</div><div class=\"voffset3 text-center mb-35 font-s15\">{{\'home.messages.inActive\' | translate}}</div></div></div></div></div><!-- Body part --><div ng-if=\"vm.isDisplayHaqBodyPart\"><div class=\"content page--home row\"><div class=\"col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 voffset5\"><haq-body-part patientinjuredtypes=\"vm.patientInjuredTypes\" on-submit-success=\"vm.handleHAQBodyPartSubmitSuccess()\"></haq-body-part></div></div></div><div class=\"landing-page\" ng-if=\"vm.landingpage && !vm.isCompleteHAQ && !vm.isDisplayHaqBodyPart\" ng-class=\"vm.openCountDialog ? \'d-none\' : \'d-block\'\"><div class=\"landing-page-background\" ng-class=\"vm.isCompletedAllStep ? \'landing-page-completed\' : \'landing-page-start\'\"><uib-carousel active=\"vm.active\" interval=\"vm.myInterval\" no-wrap=\"vm.noWrapSlides\"><uib-slide ng-repeat=\"item in vm.slides\" index=\"item.id\"><!-- <img ng-src=\"{{item.image}}\"> --><div class=\"carousel-caption row-v4 align-items-center mx-0 fix-on-safari-5\"><div class=\"col-v4-12 px-0\" ng-hide=\"vm.isHideHAQStepBackground\"><div ng-if=\"!vm.isCompletedAllStep\" class=\"title-landing\" translate=\"ipmApp.landingPage.details.text1\">It\'s time to take control of your pain</div><div ng-if=\"vm.isCompletedAllStep\" class=\"title-landing\" translate=\"ipmApp.landingPage.details.text1Completed\">Thank you for completing our onboarding process.</div><div ng-if=\"!vm.isCompletedAllStep\" class=\"title-description\" translate=\"ipmApp.landingPage.details.text2\">Prior to your first visit we need to completed your onboarding process and gather some initial information</div><div ng-if=\"vm.isCompletedAllStep\" class=\"title-description\" translate=\"ipmApp.landingPage.details.text2Completed\">We\'re honored to work with you towards your new, restore, lifestyle.</div><button ng-if=\"vm.checkShowActionStart()\" class=\"btn btn-warning\" ng-click=\"vm.clickAction(null, $event)\">{{\'ipmApp.landingPage.action.start\' | translate}}</button></div></div></uib-slide></uib-carousel></div><div class=\"text-center py-4\" translate=\"ipmApp.landingPage.details.text3\" ng-hide=\"vm.isHideHAQStep\">We don\'t want to leave any stone unturned when it comes to identifying what may be leading to your pain.<br>Please complete our patient onboarding process prior to your first appointment.</div><div class=\"landing-page-wrap\" ng-if=\"vm.landingpage\"><div class=\"row-v4 justify-content-center fix-on-safari-5\" ng-if=\"!vm.isPatientNoNPQ\"><!--Step 1--><div class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4\" ng-if=\"vm.isShowStep(vm.step1)\"><div class=\"wrap-box\"><div class=\"content-box\" ng-class=\"{\'cursor-default\' : vm.isAgreementSignedAllByAPI()}\" ng-click=\"vm.clickAction(vm.step1, $event)\"><img src=\"content/images/assets_agreement.png\"><div class=\"title-box\">{{\'ipmApp.landingPage.details.newPatientAgreements\' | translate}}</div><div><span>{{\'ipmApp.landingPage.details.step1\' | translate}}:</span> <span ng-class=\"vm.percentTextClass(vm.landingpage.agreement.percentProgressOfAgreement)\"><span>{{vm.landingpage.agreement.percentProgressOfAgreement}}</span>% <span ng-if=\"vm.isShowCompletedText(vm.landingpage.agreement.percentProgressOfAgreement)\">{{\'ipmApp.landingPage.details.completed\' | translate}}</span> <span ng-if=\"!vm.isShowCompletedText(vm.landingpage.agreement.percentProgressOfAgreement)\">{{\'ipmApp.landingPage.details.terminado\' | translate}}</span></span></div><div ng-if=\"!vm.isAgreementSignedAllByAPI()\" class=\"small\" ng-class=\"vm.timeRemainingTextClass(vm.landingpage.agreement.percentProgressOfAgreement)\"><span ng-if=\"vm.currentStep == vm.step1 && vm.isStartStep(vm.step1)\">{{\'ipmApp.landingPage.action.clickToStart\' | translate}}</span> <span ng-if=\"vm.currentStep == vm.step1 && vm.isResumeStep(vm.step1)\">{{\'ipmApp.landingPage.action.clickToResume\' | translate}}</span> <span ng-if=\"vm.isCompletedAgreementStep()\">{{\'ipmApp.landingPage.action.clickToDownload\' | translate}}</span> <span ng-if=\"!vm.isCompletedAgreementStep()\"><span>&nbsp;-&nbsp;</span> <span ng-if=\"vm.isShowApproxText(vm.landingpage.agreement.percentProgressOfAgreement)\">{{\'ipmApp.landingPage.details.approx\' | translate}}</span> <span>{{vm.landingpage.agreement.numberTimeRemainingOfAgreement}}</span><span>{{\'ipmApp.landingPage.details.min\' | translate}}</span> <span ng-if=\"vm.isShowRemainingText(vm.landingpage.agreement.percentProgressOfAgreement)\">{{\'ipmApp.landingPage.details.remaining\' | translate}}</span></span></div></div></div></div><!-- Step 2--><div class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4\" ng-if=\"vm.isShowStep(vm.step2)\"><div class=\"wrap-box\"><div class=\"content-box\" ng-class=\"{\'cursor-default\' : vm.currentStep != vm.step2}\" ng-click=\"vm.clickAction(vm.step2, $event)\"><img src=\"content/images/assets_npq.png\"><div class=\"title-box\">{{\'ipmApp.landingPage.details.newPatientQuestionnaire\' | translate}}</div><div><span>{{\'ipmApp.landingPage.details.step2\' | translate}}:</span> <span ng-class=\"vm.percentTextClass(vm.landingpage.npq.percentProgressOfNPQ)\"><span>{{vm.landingpage.npq.percentProgressOfNPQ}}</span>% <span ng-if=\"vm.isShowCompletedText(vm.landingpage.npq.percentProgressOfNPQ)\">{{\'ipmApp.landingPage.details.completed\' | translate}}</span> <span ng-if=\"!vm.isShowCompletedText(vm.landingpage.npq.percentProgressOfNPQ)\">{{\'ipmApp.landingPage.details.terminado\' | translate}}</span></span></div><div class=\"small\" ng-if=\"!vm.isCompletedNPQStep()\" ng-class=\"vm.timeRemainingTextClass(vm.landingpage.npq.percentProgressOfNPQ)\"><span ng-if=\"vm.currentStep == vm.step2 && vm.isStartStep(vm.step2)\">{{\'ipmApp.landingPage.action.clickToStart\' | translate}}</span> <span ng-if=\"vm.currentStep == vm.step2 && vm.isResumeStep(vm.step2)\">{{\'ipmApp.landingPage.action.clickToResume\' | translate}}</span> <span ng-if=\"vm.currentStep == vm.step2\">&nbsp;-&nbsp;</span> <span ng-if=\"vm.isShowApproxText(vm.landingpage.npq.percentProgressOfNPQ)\">{{\'ipmApp.landingPage.details.approx\' | translate}}</span> <span>{{vm.landingpage.npq.numberTimeRemainingOfNPQ}}</span><span>{{\'ipmApp.landingPage.details.min\' | translate}}</span> <span ng-if=\"vm.isShowRemainingText(vm.landingpage.npq.percentProgressOfNPQ)\">{{\'ipmApp.landingPage.details.remaining\' | translate}}</span></div></div></div><div ng-if=\"vm.getNumberOfNpqNotYetComplete() > 1\"><div class=\"multipleNpqText small text-center\">{{\'ipmApp.landingPage.details.multipleNpqText\' | translate}}</div></div></div><!-- Digital Psych Intake Forms --><div class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4\" ng-if=\"vm.isShowStep(vm.stepPsychIntake)\"><div class=\"wrap-box\"><div class=\"content-box\" ng-class=\"{\'cursor-default\' : vm.percentProgressOfPsychIntake === vm.percentCompleted}\" ng-click=\"vm.startPsychIntakeForm()\"><img src=\"content/images/assets_haq_battery.png\"><div class=\"title-box\">{{\'ipmApp.landingPage.details.psychIntakeForm\' | translate}}</div><div><span ng-class=\"vm.percentTextClass(vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake)\"><span>{{vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake}}</span>% <span ng-if=\"vm.isShowCompletedText(vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake)\">{{\'ipmApp.landingPage.details.completed\' | translate}}</span> <span ng-if=\"!vm.isShowCompletedText(vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake)\">{{\'ipmApp.landingPage.details.terminado\' | translate}}</span></span></div><div class=\"small\" ng-if=\"!vm.isCompletedPsychStep()\" ng-class=\"vm.timeRemainingTextClass(vm.landingpage.psychIntakeForm.percentProgressOfPsychIntake)\"><span ng-if=\"vm.isStartStep(vm.stepPsychIntake)\">{{\'ipmApp.landingPage.action.clickToStart\' | translate}}</span> <span ng-if=\"vm.isResumeStep(vm.stepPsychIntake)\">{{\'ipmApp.landingPage.action.clickToResume\' | translate}}</span></div></div></div><div ng-if=\"vm.getNumberOfPsychIntakeFormNotYetComplete() > 1\"><div class=\"multipleNpqText small text-center\">{{\'ipmApp.landingPage.details.multiplePsychIntakeFormText\' | translate}}</div></div></div><!-- Step 3--><div class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4\" ng-if=\"vm.isShowStep(vm.step3)\"><div class=\"wrap-box\"><div class=\"content-box\" ng-class=\"{\'cursor-default\' : vm.currentStep != vm.step3}\" ng-click=\"vm.clickAction(vm.step3, $event)\"><img src=\"content/images/assets_haq.png\"><div class=\"title-box\">{{\'ipmApp.landingPage.details.healthAssessmentQuestionnaire\' | translate}}</div><div><span ng-if=\"vm.isShowTextStep(vm.step3)\">{{\'ipmApp.landingPage.details.step3\' | translate}}:</span> <span ng-class=\"vm.percentTextClass(vm.landingpage.percentProgressOfHAQ)\"><span>{{vm.landingpage.percentProgressOfHAQ}}</span>% <span ng-if=\"vm.isShowCompletedText(vm.landingpage.percentProgressOfHAQ)\">{{\'ipmApp.landingPage.details.completed\' | translate}}</span> <span ng-if=\"!vm.isShowCompletedText(vm.landingpage.percentProgressOfHAQ)\">{{\'ipmApp.landingPage.details.terminado\' | translate}}</span></span></div><div class=\"small\" ng-if=\"!vm.isCompletedHAQStep()\" ng-class=\"vm.timeRemainingTextClass(vm.landingpage.percentProgressOfHAQ)\"><span ng-if=\"vm.currentStep == vm.step3 && vm.isStartStep(vm.step3)\">{{\'ipmApp.landingPage.action.clickToStart\' | translate}}</span> <span ng-if=\"vm.currentStep == vm.step3 && vm.isResumeStep(vm.step3)\">{{\'ipmApp.landingPage.action.clickToResume\' | translate}}</span> <span ng-if=\"vm.currentStep == vm.step3\">&nbsp;-&nbsp;</span> <span ng-if=\"vm.isShowApproxText(vm.landingpage.percentProgressOfHAQ)\">{{\'ipmApp.landingPage.details.approx\' | translate}}</span> <span>{{vm.landingpage.numberTimeRemainingOfHAQ}}</span><span>{{\'ipmApp.landingPage.details.min\' | translate}}</span> <span ng-if=\"vm.isShowRemainingText(vm.landingpage.percentProgressOfHAQ)\">{{\'ipmApp.landingPage.details.remaining\' | translate}}</span></div></div></div></div><div ng-if=\"vm.isShowHaqBatteries()\" ng-repeat=\"haqBattery in vm.haqBatteries track by haqBattery.surveyResultId\" class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4\"><div class=\"wrap-box\"><div class=\"content-box\" ng-class=\"{\'cursor-default\' : vm.isHaqBatteryCompleted(haqBattery)}\" ng-click=\"vm.navigateHaqBatteryTesting(haqBattery)\"><img src=\"content/images/assets_haq_battery.png\"><div class=\"title-box\"><span class=\"truncate\" data-toggle=\"tooltip\" title=\"{{haqBattery.name}}\">{{ haqBattery.name }}</span></div><div><span ng-class=\"vm.percentTextClass(haqBattery.percentProgress)\"><span>{{haqBattery.percentProgress}}</span>% <span ng-if=\"vm.isShowCompletedText(haqBattery.percentProgress)\">{{\'ipmApp.landingPage.details.completed\' | translate}}</span> <span ng-if=\"!vm.isShowCompletedText(haqBattery.percentProgress)\">{{\'ipmApp.landingPage.details.terminado\' | translate}}</span></span></div><div class=\"small\" ng-if=\"!vm.isCompletedHAQBatteryStep(haqBattery)\" ng-class=\"vm.timeRemainingTextClass(haqBattery.percentProgress)\"><span ng-if=\"haqBattery.percentProgress === 0\">{{\'ipmApp.landingPage.action.clickToStart\' | translate}}</span> <span ng-if=\"haqBattery.percentProgress > 0\">{{\'ipmApp.landingPage.action.clickToResume\' | translate}}</span> <span>&nbsp;-&nbsp;</span> <span ng-if=\"vm.isShowApproxText(haqBattery.percentProgress)\">{{\'ipmApp.landingPage.details.approx\' | translate}}</span> <span>{{haqBattery.numberTimeRemaining}}</span><span>{{\'ipmApp.landingPage.details.min\' | translate}}</span> <span ng-if=\"vm.isShowRemainingText(haqBattery.percentProgress)\">{{\'ipmApp.landingPage.details.remaining\' | translate}}</span></div></div></div></div><!-- Step 4--><div class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4\" ng-if=\"vm.isShowAdhocTesting()\"><div class=\"wrap-box\"><div class=\"content-box\" ng-click=\"vm.navigateAdhocTesting()\"><img src=\"content/images/assets_haq.png\"><div class=\"title-box\"><span class=\"truncate\" data-toggle=\"tooltip\" title=\"{{vm.adhocTestName}}\">{{ vm.adhocTestName }}</span></div><div><span ng-class=\"vm.percentTextClass(vm.landingpage.percentProgressOfHAQAdhoc)\"><span>{{vm.landingpage.percentProgressOfHAQAdhoc}}</span>% <span ng-if=\"vm.isShowCompletedText(vm.landingpage.percentProgressOfHAQAdhoc)\">{{\'ipmApp.landingPage.details.completed\' | translate}}</span> <span ng-if=\"!vm.isShowCompletedText(vm.landingpage.percentProgressOfHAQAdhoc)\">{{\'ipmApp.landingPage.details.terminado\' | translate}}</span></span></div><div class=\"small\" ng-if=\"!vm.isCompletedHAQStep()\" ng-class=\"vm.timeRemainingTextClass(vm.landingpage.percentProgressOfHAQAdhoc)\"><span ng-if=\"vm.landingpage.percentProgressOfHAQAdhoc === 0\">{{\'ipmApp.landingPage.action.clickToStart\' | translate}}</span> <span ng-if=\"vm.landingpage.percentProgressOfHAQAdhoc > 0\">{{\'ipmApp.landingPage.action.clickToResume\' | translate}}</span> <span>&nbsp;-&nbsp;</span> <span ng-if=\"vm.isShowApproxText(vm.landingpage.percentProgressOfHAQAdhoc)\">{{\'ipmApp.landingPage.details.approx\' | translate}}</span> <span>{{vm.landingpage.numberTimeRemainingOfHAQAdhoc}}</span><span>{{\'ipmApp.landingPage.details.min\' | translate}}</span> <span ng-if=\"vm.isShowRemainingText(vm.landingpage.percentProgressOfHAQAdhoc)\">{{\'ipmApp.landingPage.details.remaining\' | translate}}</span></div></div></div></div></div><!-- New Patient No NPQ --><div class=\"row-v4 justify-content-center fix-on-safari-5\" ng-if=\"vm.isDisplayItemLandingPageForPatientNoNPQ()\"><div class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4\" ng-repeat=\"item in vm.langdingPageSteps\" index=\"item.id\"><item-landing-page item=\"item\" on-click=\"vm.itemLandingPageClick(item)\" on-click-download=\"vm.itemLandingPageClickDownload(item)\"></item-landing-page></div></div></div></div></div></div>");
$templateCache.put("app/landing-page/psych-count-dialog.html","<form name=\"resumeForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\">Your Psych Intake Forms</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p>You have <span>{{vm.count}}</span> open Psych Intake Forms. When you\'ve completed this you\'ll be asked to respond to the next one. Thank you.</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"isSaving\" ng-click=\"vm.yes()\"><span translate=\"entity.action.ok\">Ok</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/notification-history/notification-history-list.html","<div class=\"page page--notification-history\"><div class=\"container\"><div class=\"content\"><patient-summary patient-id=\"vm.patientId\"></patient-summary><div class=\"h2 mt-4 title\" translate=\"ipmApp.notificationHistory.home.title\">Patient Notifications</div><div class=\"row\"><div class=\"col-md-12 h5 primary\">{{translate=\"ipmApp.notificationHistory.home.description\" | translate}}</div></div><jhi-alert></jhi-alert><div class=\"table-responsive\"><table class=\"jh-table table table-notification\"><thead><tr ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th class=\"date\">{{\'ipmApp.notificationHistory.label.date\' | translate}}</th><th class=\"date\">{{\'ipmApp.notificationHistory.label.time\' | translate}}</th><th>{{\'ipmApp.notificationHistory.label.title\' | translate}}</th><th class=\"date\">{{\'ipmApp.notificationHistory.label.type\' | translate}}</th><th class=\"address\">{{\'ipmApp.notificationHistory.label.address\' | translate}}</th><th class=\"date\">{{\'ipmApp.notificationHistory.label.status\' | translate}}</th><th class=\"address\">{{\'ipmApp.notificationHistory.label.sentBy\' | translate}}</th><th class=\"expand\">{{\'ipmApp.notificationHistory.label.expand\' | translate}}</th></tr></thead><tbody><tr ng-repeat-start=\"history in vm.notificationHistory track by $index\" ng-class=\"$index % 2 ? \'\' : \'odd\'\"><td><strong>{{history.dateSent | date:\'MM/dd/yyyy\'}}</strong></td><td><span>{{history.dateSent | date:\'shortTime\'}}</span></td><td><span>{{history.title}}</span></td><td><span>{{\'ipmApp.notificationHistory.type.\' + history.type | translate}}</span></td><td><span ng-if=\"history.email\">{{history.email}}</span> <span ng-if=\"history.sms\" ng-bind=\"vm.formatPhone(history.sms)\"></span></td><td><span>{{\'ipmApp.notificationHistory.status.\' + history.status | translate}}</span></td><td><span>{{history.sentBy}}</span></td><td><div ng-if=\"history.expanded\" ng-click=\"history.expanded = false\" class=\"expand-icon active\" uib-tooltip=\"{{\'ipmApp.notificationHistory.detail.viewContent\' | translate}}\"></div><div ng-if=\"!history.expanded\" ng-click=\"history.expanded = true\" class=\"expand-icon\" uib-tooltip=\"{{\'ipmApp.notificationHistory.detail.viewContent\' | translate}}\"></div></td></tr><tr ng-if=\"history.expanded\" ng-repeat-end=\"\" ng-class=\"$index % 2 ? \'\' : \'odd\'\"><td colspan=\"8\"><div ng-bind-html=\"vm.formatHtml(history.messageContent)\"></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageSize\" max-size=\"15\" rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\"></uib-pagination></div><div class=\"row\"><div class=\"col-md-12 voffset2\"><button class=\"btn btn-info\" ng-click=\"vm.back()\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/npq-questionnaire.html","<div class=\"page page--survey-workflow\" ng-class=\"vm.getLanguage() === \'es\' ? \'es-lang\': \'\'\"><div class=\"container\"><div class=\"content\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-attr-aria-valuenow=\"vm.percent\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-bind-html=\"vm.percent + \'%\'\" ng-style=\"vm.widthStyle()\">0%</div></div></div></div><div class=\"row\"><div class=\"col-md-12 h2 title\" ng-if=\"vm.npqQuestionnaire.currentSection.nameLangKey\" translate=\"{{vm.npqQuestionnaire.currentSection.nameLangKey}}\">Workflow Title</div><div class=\"col-md-12\"><div class=\"battery\"><ng-bind-html ng-bind-html=\"vm.vm.npqQuestionnaire.instructions\"></ng-bind-html></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ui-view=\"workflow-view@npq-questionnaire\"></div></div></div></div></div>");
$templateCache.put("app/patient/create-npq-or-psych-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><div ng-if=\"vm.notYetSelectedCase()\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myUserLabel\"><span ng-show=\"vm.type === \'NPQ\'\" translate=\"ipmApp.patient.home.questionnaire.title\"></span> <span ng-show=\"vm.type === \'PSYCH\'\" translate=\"ipmApp.patient.home.psychIntakeForm.title\"></span></h5></div><div ng-if=\"!vm.notYetSelectedCase()\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clearSelectedCase()\">&times;</button><h5 class=\"modal-title\" id=\"myUserLabel\"><span translate=\"ipmApp.patient.detail.newNpqOrPsychDialog.header\"></span></h5></div></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group text-left\"><div ng-show=\"vm.notYetSelectedCase()\"><label translate=\"ipmApp.patient.detail.questionnaire.caseNo\">Case #</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"pb-4\"><ui-select ng-model=\"vm.patientCaseSelect\" theme=\"bootstrap\" close-on-select=\"true\" style=\"width: 100%\" ng-change=\"vm.searchTextOnChange()\" required><ui-select-match placeholder=\"Select case number...\"><span title=\"{{$select.selected.caseNumber}}\">{{$select.selected.caseNumber}}</span></ui-select-match><ui-select-choices repeat=\"pc in vm.patientCases | filter:$select.search\"><div ng-bind-html=\"pc.caseNumber  | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><p class=\"help-block text-center\">{{\'ipmApp.patient.patientCase.inputPatientCaseNoResult\' | translate}}</p></ui-select-no-choice></ui-select></div></div><div ng-show=\"!vm.notYetSelectedCase()\"><label translate=\"ipmApp.patient.detail.newNpqOrPsychDialog.agreementsLabel\">Agreements</label><div class=\"pb-4\"><ui-select style=\"max-width: none; width: 100%; margin-bottom: 10px\" multiple=\"multiple\" ng-model=\"vm.agreementSeleted\" name=\"selectedAgreements\" theme=\"bootstrap\" ng-change=\"vm.selectAgreementsOnChange()\" close-on-select=\"false\"><ui-select-match placeholder=\"{{ \'ipmApp.patient.detail.newNpqOrPsychDialog.selectAgreementsPlaceholder\' | translate }}\"><span title=\"{{$item.name}}\">{{ \'ipmApp.agreements.workflowName.\' + $item.name | translate }}</span></ui-select-match><ui-select-choices repeat=\"agreement in vm.agreements | filter:$select.search\"><div ng-bind-html=\"\'ipmApp.agreements.workflowName.\' + agreement.name | translate | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><p class=\"help-block text-center\">{{\'ipmApp.patient.detail.newNpqOrPsychDialog.noAgreementFound\' | translate}}</p></ui-select-no-choice></ui-select><div class=\"pt-1\" ng-show=\"vm.invalidAgreementCount > 1\"><p class=\"help-block\" translate=\"ipmApp.patient.detail.agreements.dialogSend.messages.invalidAgreements\">These agreements are already signed. Do you really want to sign them again?</p></div><div class=\"pt-1\" ng-show=\"vm.invalidAgreementCount === 1\"><p class=\"help-block\" translate=\"ipmApp.patient.detail.agreements.dialogSend.messages.invalidAgreement\">This agreement is already signed. Do you really want to sign it again?</p></div></div><label translate=\"ipmApp.batteryTesting.batteryTestingAddDialog.batteriesLabel\">Batteries</label><div class=\"pb-4\"><ui-select style=\"max-width: none; width: 100%; margin-bottom: 10px\" multiple=\"multiple\" ng-model=\"vm.batterySeleted\" name=\"selectedBatteries\" theme=\"bootstrap\" ng-change=\"vm.selectBatteriesOnChange()\" close-on-select=\"false\"><ui-select-match placeholder=\"{{ \'ipmApp.batteryTesting.batteryTestingAddDialog.batteriesPlaceholder\'| translate }}\"><span title=\"{{$item.nameEn}}\">{{$item.nameEn}}</span></ui-select-match><ui-select-choices repeat=\"battery in vm.batteries | filter:$select.search\"><div ng-bind-html=\"battery.nameEn  | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><p class=\"help-block text-center\">{{\'ipmApp.batteryTesting.batteryTestingAddDialog.inputBatteryTestNoResult\' | translate}}</p></ui-select-no-choice></ui-select><div class=\"pt-1\" ng-show=\"vm.isInvalidBattery\"><p class=\"help-block\" translate=\"ipmApp.batteryTesting.batteryTestingAddDialog.messages.error.invalidBattery\">This battery cannot be assigned because it has no questions.</p></div></div></div></div></div><div class=\"modal-footer\"><div ng-if=\"vm.notYetSelectedCase()\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div><div ng-if=\"!vm.notYetSelectedCase()\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || vm.checkDisableSave() || vm.isInvalidBattery\" class=\"btn btn-primary\"><span translate=\"entity.action.send\">Send</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clearSelectedCase()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></div></form>");
$templateCache.put("app/patient/patient-detail.html","<div class=\"page page--survey-result-details\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.patient.detail.title\"></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.surveyResult.detail.patientInfo\"></span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.firstName\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.firstName}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.lastName\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.lastName}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.dateOfBirth\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.dateOfBirth | date:\'MM/dd/yyyy\'}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.patientIdCode\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.patientId}}</div></div><!-- <div class=\"row voffset\">\n	    				<div class=\"col-md-2 col-sm-2\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.disposition\' | translate}} </label></div>\n	    				<div class=\"col-md-10 col-sm-10\"><button type=\"button\" class=\"btn btn-default btn-toggle disable\" ng-class=\"{\'active\': vm.getDisposition()}\"></button></div>\n					</div> --><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" ng-click=\"vm.openAccountEdit()\" ng-if=\"vm.checkPermission()\"><span translate=\"ipmApp.patient.editPatient\">Edit Patient</span></button> <button class=\"btn btn-primary\" ng-click=\"vm.openNotificationHistory(vm.patient.id)\" ng-if=\"vm.checkPermission()\" ng-disabled=\"vm.isBiller\"><span translate=\"ipmApp.patient.detail.notificationHistory\">Notification History</span></button><div class=\"mt-3\" ng-if=\"vm.notAllowCreateQuestionnaire\"><p class=\"help-block\" translate=\"ipmApp.patient.detail.questionnaire.notAllowSendRequest\"></p></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.newPatientQuestionnaires\"></span></div></div><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" ng-click=\"vm.createNpqOrPsych(\'NPQ\')\" ng-disabled=\"vm.isBiller\"><span translate=\"ipmApp.patient.labelCreateRequest\">Create NPQ for new case</span></button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicateQn\" ascending=\"vm.reverse\" callback=\"vm.loadQuestionnaires()\"><th jh-sort-by=\"dateRequested\"><span>{{\'ipmApp.patient.detail.questionnaire.dateRequest\' | translate}}</span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"patientCase.caseNumber\"><span>{{\'ipmApp.patient.detail.questionnaire.caseNo\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.patient.detail.questionnaire.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"completionDate\"><span>{{\'ipmApp.patient.detail.questionnaire.completionDate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\"><span>{{\'ipmApp.patient.detail.questionnaire.downloadReport\' | translate}}</span></th><th class=\"text-center\" jh-sort-by=\"isDownloaded\"><span>{{\'ipmApp.patient.detail.questionnaire.download\' | translate}}</span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\"><span>{{\'ipmApp.patient.detail.questionnaire.launch\' | translate}}</span></th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"qn in vm.questionnaires track by qn.id\"><td>{{qn.dateRequested | date:\'MM/dd/yyyy\'}}</td><td>{{vm.getCaseNoNPQ(qn)}}</td><td style=\"width:  18%\">{{ \'ipmApp.QuestionnaireStatus.\' + qn.status | translate}}</td><td><span>{{ qn.completionDate| date:\'MM/dd/yyyy\' }}</span></td><td class=\"text-center\"><a ng-if=\"qn.status === \'COMPLETE\' || qn.status === \'INCOMPLETE\' || qn.status === \'DOWNLOADED\'\" class=\"glyphicon glyphicon-download-alt\" ng-click=\"vm.downloadQuestionnaire(qn.id)\"></a></td><td class=\"text-center\">{{qn.isDownloaded ? \'ipmApp.patient.detail.questionnaire.downloaded\' : \'\' | translate}}</td><td class=\"text-center\"><button type=\"button\" ng-if=\"(qn.status === \'NOT_STARTED\' || qn.status === \'STARTED\' || qn.status === \'INCOMPLETE\')\" class=\"glyphicon glyphicon-log-in button-reset\" data-toggle=\"Launch\" ng-click=\"vm.goToNPQ($event, qn)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></td><td class=\"text-center\"><u ng-if=\"(qn.status === \'NOT_STARTED\' || qn.status === \'STARTED\' || qn.status === \'INCOMPLETE\')\"><button type=\"button\" class=\"button-reset underline\" translate=\"ipmApp.surveyResult.button.resend\" ng-click=\"vm.resendNPQ(qn.id)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></u></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableQn.totalItems\" ng-model=\"vm.pageableQn.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadQuestionnaires()\"></uib-pagination></div></div></div><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.allAgreements\"></span></div></div><patient-agreements patient-id=\"vm.id\" is-biller=\"vm.isBiller\"></patient-agreements><!-- Digital Psych Intake Forms --><div class=\"row\"><div class=\"col-md-12 py-2\"><div class=\"mt-3\" ng-if=\"vm.notAllowCreatePsychIntakeForm\"><p class=\"help-block\" translate=\"ipmApp.patient.detail.psychIntakeForm.notAllowSendRequest\"></p></div></div></div><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.newPsychIntakeForm\"></span></div></div><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" ng-click=\"vm.createNpqOrPsych(\'PSYCH\')\" ng-disabled=\"vm.isBiller\"><span translate=\"ipmApp.patient.labelCreatePsychIntakeForm\">Create New Intake Form</span></button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicateQn\" ascending=\"vm.reverse\" callback=\"vm.loadPsychIntakeForms()\"><th jh-sort-by=\"dateRequested\"><span>{{\'ipmApp.patient.detail.questionnaire.dateRequest\' | translate}}</span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"patientCase.caseNumber\"><span>{{\'ipmApp.patient.detail.questionnaire.caseNo\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.patient.detail.questionnaire.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"completionDate\"><span>{{\'ipmApp.patient.detail.questionnaire.completionDate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\"><span>{{\'ipmApp.patient.detail.questionnaire.downloadReport\' | translate}}</span></th><th class=\"text-center\" jh-sort-by=\"isDownloaded\"><span>{{\'ipmApp.patient.detail.questionnaire.download\' | translate}}</span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\"><span>{{\'ipmApp.patient.detail.questionnaire.launch\' | translate}}</span></th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"pif in vm.psychIntakeForms track by pif.id\"><td>{{pif.dateRequested | date:\'MM/dd/yyyy\'}}</td><td>{{vm.getCaseNoNPQ(pif)}}</td><td style=\"width:  18%\">{{ \'ipmApp.QuestionnaireStatus.\' + pif.status | translate}}</td><td><span>{{ pif.completionDate| date:\'MM/dd/yyyy\' }}</span></td><td class=\"text-center\"><a ng-if=\"pif.status === \'COMPLETE\' || pif.status === \'INCOMPLETE\' || pif.status === \'DOWNLOADED\'\" class=\"glyphicon glyphicon-download-alt\" ng-click=\"vm.downloadPsychIntakeForm(pif.id)\"></a></td><td class=\"text-center\">{{pif.isDownloaded ? \'ipmApp.patient.detail.questionnaire.downloaded\' : \'\' | translate}}</td><td class=\"text-center\"><button type=\"button\" ng-if=\"(pif.status === \'NOT_STARTED\' || pif.status === \'STARTED\' || pif.status === \'INCOMPLETE\')\" class=\"glyphicon glyphicon-log-in button-reset\" data-toggle=\"Launch\" ng-click=\"vm.goToPsychIntakeForm($event, pif)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></td><td class=\"text-center\"><u ng-if=\"(pif.status === \'NOT_STARTED\' || pif.status === \'STARTED\' || pif.status === \'INCOMPLETE\')\"><button type=\"button\" class=\"button-reset underline\" translate=\"ipmApp.surveyResult.button.resend\" ng-click=\"vm.resendPsychIntakeForm(pif.id)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></u></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableQn.totalItems\" ng-model=\"vm.pageableQn.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadPsychIntakeForms()\"></uib-pagination></div></div></div><!-- End Digital Psych Intake Forms --><!-- Batteries /START--><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.batteries.title\">Patient Testing – Batteries</span></div></div><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" ui-sref=\"battery-testing-add({id : vm.patient.id})\" ng-disabled=\"vm.isBiller\"><span translate=\"ipmApp.patient.detail.batteries.assignBatteriesBtn\">Assign Batteries</span></button></div></div><battery-testing-list patient-id=\"vm.id\" is-biller=\"vm.isBiller\" is-manager=\"vm.isManager\"></battery-testing-list><!-- Batteries /END--><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.adHocTesting.title\"></span></div></div><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" ui-sref=\"add-adhoc-testing({id : vm.patient.id})\" ng-disabled=\"vm.isBiller\"><span translate=\"ipmApp.patient.detail.adHocTesting.assignInstrument\">Assign Instrument</span></button></div></div><ad-hoc-testing-list patient-id=\"vm.id\" is-biller=\"vm.isBiller\" is-manager=\"vm.isManager\"></ad-hoc-testing-list><div class=\"row d-none\"><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.allAppointments\"></span></div></div><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" ui-sref=\"appointment-new({id : vm.patient.id})\" ng-disabled=\"vm.isBiller\"><span translate=\"ipmApp.patient.detail.appointment.createNew\">Create new Appointment</span></button></div></div><appointment-list patient-id=\"vm.id\" is-biller=\"vm.isBiller\"></appointment-list></div><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.cprReports\"></span></div></div><patient-cpr-reports patient-id=\"vm.id\"></patient-cpr-reports><!-- wellnessClass--><div class=\"row\" ng-if=\"!vm.hideWellnessClasses\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.patient.detail.wellnessClass.title\"></span></div></div><class-session-registration ng-if=\"!vm.hideWellnessClasses\" patient-id=\"vm.id\" is-biller=\"vm.isBiller\"></class-session-registration><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span class=\"text-inactive\" translate=\"ipmApp.patient.detail.archivedHAQs.title\">Archived HAQs</span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"inactive-wrap is-inactive\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAllResults()\"><th><span>{{\'ipmApp.surveyResult.id\' | translate}}</span></th><th jh-sort-by=\"battery.id\"><span>{{\'ipmApp.surveyResult.batteryNumber\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.surveyResult.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\"><span>{{\'ipmApp.surveyResult.caseNumber\' | translate}}</span></th><th jh-sort-by=\"id\"><span>{{\'ipmApp.surveyResult.dateLastUpdated\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"finalCompletionDate\"><span>{{\'ipmApp.surveyResult.completionDate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\" ng-show=\"vm.isManager\"><span>{{\'ipmApp.surveyResult.downloadresult\' | translate}}</span></th><th class=\"text-center\"><span>{{\'ipmApp.surveyResult.downloadresponse\' | translate}}</span></th><th class=\"text-center\"><span>{{\'ipmApp.surveyResult.launch\' | translate}}</span></th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"sr in vm.surveyResults track by sr.id\"><td>{{vm.getIndex($index)}}</td><td>{{sr.batteryNameEn}}</td><td>{{\'ipmApp.SurveyResultStatus.\' + sr.status | translate}}</td><td class=\"text-center\"><span ng-if=\"!sr.patientCase\">{{\'ipmApp.surveyResult.notSelected\' | translate}}</span> <span ng-if=\"sr.patientCase\">{{sr.patientCase.caseNumber}}</span></td><td><span ng-if=\"sr.lastModifiedDate\">{{ sr.lastModifiedDate | date:\'MM/dd/yyyy\' }}</span> <span ng-if=\"!sr.lastModifiedDate\">{{ sr.createdDate | date:\'MM/dd/yyyy\' }}</span></td><td><span>{{ sr.finalCompletionDate| date:\'MM/dd/yyyy\' }}</span></td><td class=\"text-center\" ng-show=\"vm.isManager\"><a ng-if=\"sr.status === \'COMPLETE\' || sr.status === \'INCOMPLETE\' || sr.status === \'DOWNLOADED\'\" href=\"{{ \'api/survey-results/download/\' + sr.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td><td class=\"text-center\"><a ng-if=\"sr.status === \'COMPLETE\' || sr.status === \'INCOMPLETE\' || sr.status === \'DOWNLOADED\'\" href=\"{{ \'api/survey-results/download-response/\' + sr.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td><td class=\"text-center\"><button type=\"button\" ng-if=\"vm.mostRecentHAQ && sr && vm.mostRecentHAQ.id === sr.id && !vm.disableStartHAQ\" class=\"glyphicon glyphicon-log-in button-reset\" data-toggle=\"Launch\" ng-click=\"vm.goToHAQBattery($event, sr)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></td><td class=\"text-center\"><u ng-if=\"vm.mostRecentHAQ && sr && vm.mostRecentHAQ.id === sr.id && !vm.disableStartHAQ\"><button type=\"button\" class=\"button-reset underline\" translate=\"ipmApp.surveyResult.button.resend\" ng-click=\"vm.resendHAQ(sr)\" ng-disabled=\"vm.checkDisableLaunchResendHAQ(sr)\" ng-class=\"vm.checkDisableLaunchResendHAQ(sr) ? \'not_allowed\' : \'\'\"></button></u></td></tr></tbody></table></div></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAllResults()\"></uib-pagination></div></div></div><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span class=\"text-inactive\" translate=\"ipmApp.downloadHaqEvaluation.detail.haqEvaluations\"></span></div></div><patient-haq-evaluations patient-id=\"vm.id\" is-manager=\"vm.isManager\" is-biller=\"vm.isBiller\"></patient-haq-evaluations><div class=\"row\"><div class=\"col-md-12 voffset2\"><button class=\"btn btn-info\" ng-click=\"vm.backToList()\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/patient/patient-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myUserLabel\" translate=\"ipmApp.patient.home.createOrEditLabel\">Create or edit a Patient</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"ipmApp.patient.firstName\">FirstName</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"firstName\" required ng-model=\"vm.patient.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$dirty && editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.required\" translate=\"ipmApp.patient.firstName.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.patient.middleName\">Middle Name</label><input type=\"text\" class=\"form-control\" name=\"middleName\" ng-model=\"vm.patient.middleName\" ng-maxlength=\"50\"></div><div class=\"form-group\"><label translate=\"ipmApp.patient.lastName\">LastName</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"lastName\" required ng-model=\"vm.patient.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$dirty && editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.required\" translate=\"ipmApp.patient.lastName.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.patient.patientIdCode\">patient ID</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientIdCode\" required ng-model=\"vm.patient.patientIdCode\" ng-maxlength=\"50\"><div ng-show=\"editForm.patientIdCode.$dirty && editForm.patientIdCode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.patientIdCode.$error.required\" translate=\"ipmApp.patient.patientIdCode.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div><div ng-show=\"!editForm.patientIdCode.$invalid && vm.errorPatientCodeIdexists\"><p class=\"help-block\" translate=\"error.patientCodeExists\">E-mail is already in use!</p></div></div><div class=\"form-group\"><label for=\"password\" translate=\"ipmApp.patient.password\">Password</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" required ng-model=\"vm.patient.password\" ng-minlength=\"5\" ng-maxlength=\"50\"><div ng-show=\"editForm.password.$dirty && editForm.password.$invalid\"><p class=\"help-block\" ng-show=\"editForm.password.$error.required\" translate=\"ipmApp.patient.password.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"editForm.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label for=\"confirmPassword\" translate=\"register.form.confirmPassword\">New password confirmation</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" confirm-password-check=\"password\"><div ng-show=\"editForm.confirmPassword.$dirty && editForm.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"editForm.confirmPassword.$error.pwmatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.patient.email\">Email</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"email\" class=\"form-control\" name=\"email\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-model=\"vm.patient.email\" ng-maxlength=\"100\" ng-required=\"vm.requirePhoneAndEmail()\"><div ng-show=\"editForm.email.$dirty && editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"ipmApp.patient.email.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email || editForm.email.$error.pattern\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div><div ng-show=\"!editForm.email.$invalid && vm.errorEmailExists\"><p class=\"help-block\" translate=\"error.emailexists\">E-mail is already in use!</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.patient.turnOffEmail\" class=\"mr-3\">Turn Off Email</label><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patient.ignoreSendEmail}\" ng-click=\"vm.changeIgnoreEmail()\"></button></div><div class=\"form-group\"><label translate=\"ipmApp.patient.phone\">Mobile or Primary Phone #</label><input type=\"text\" class=\"form-control\" name=\"phone\" phone-input ng-model=\"vm.patient.phone\" ng-maxlength=\"100\" ng-required=\"vm.requirePhoneAndEmail()\"><div ng-show=\"!editForm.phone.$invalid && vm.errorPhoneExists\"><p class=\"help-block\" translate=\"error.phoneExists\">Mobile or Primary Phone # is already in use!</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.patient.turnOffSms\" class=\"mr-3\">Turn Off SMS</label><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patient.ignoreSendSms}\" ng-click=\"vm.changeIgnoreSendSms()\"></button></div><div class=\"form-group\"><label class=\"pr-10\" translate=\"ipmApp.patient.dateOfBirth\">Date of Birth</label><input type=\"text\" class=\"mt-0 dateOfBirth\" id=\"dateOfBirth\" name=\"dateOfBirth\" data-format=\"DD-MM-YYYY\" data-template=\"D MMM YYYY\" year-name=\"yearOfBirth\" day-name=\"dayOfBirth\" month-name=\"monthOfBirth\" ng-model=\"vm.patient.dateOfBirth\" ng-required=\"false\" rsmdatedropdowns></div><patient-case-table ng-if=\"vm.isAllowActionPatientCase\" is-allow-action=\"vm.isAllowActionPatientCase\" is-update-billable=\"vm.checkUpdateBillablePatientCase()\" patient-id=\"null\" patient-cases=\"vm.patientCases\" patient-case-ids-remove=\"vm.patientCaseIdsRemove\"></patient-case-table></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/patient-list.html","<div class=\"page page--survey-result-list\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.patient.home.title\">Patients</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 voffset2\"><div class=\"row\"><div class=\"col-md-5 col-sm-5 col-xs-12 has-feedback-left\"><div class=\"form-group\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.patient.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search():0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></div></div><div class=\"col-md-2 col-sm-4 col-xs-12\"><div class=\"form-group\"><select class=\"form-control\" name=\"status\" id=\"status\" ng-model=\"vm.status\" ng-change=\"vm.search()\" ng-options=\"opt.displayName as opt.translateKey | translate for opt in vm.statuses\"><option value=\"\" selected=\"selected\" disabled=\"disabled\" hidden>{{\'ipmApp.patient.status\' | translate}}</option></select></div></div><div class=\"col-md-3 col-sm-3 col-xs-12\"><button class=\"btn btn-primary\" ui-sref=\"patient-list.new\" ng-disabled=\"vm.isBiller\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.patient.home.createLabel\">Create a new Patient</span></button></div></div></div></div><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th rowspan=\"2\" jh-sort-by=\"p.user.firstName\"><span>{{\'ipmApp.patient.firstName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th rowspan=\"2\" jh-sort-by=\"p.user.lastName\"><span>{{\'ipmApp.patient.lastName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th rowspan=\"2\" jh-sort-by=\"p.dateOfBirth\"><span>{{\'ipmApp.patient.dateOfBirth\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th rowspan=\"2\" jh-sort-by=\"p.patientId\"><span>{{\'ipmApp.patient.patientIdCode\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th colspan=\"3\" class=\"text-center\">New Patient Questionnaire</th></tr><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"p.createdDate\"><span>{{\'ipmApp.patient.lastRequested\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"p.completionDate\"><span>{{\'ipmApp.patient.lastCompleted\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"p.status\"><span>{{\'ipmApp.patient.requestStatus\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"patient in vm.patients track by patient.id\">{{patient.firstName}}<td ng-click=\"vm.goToPatientDetails(patient.id)\"><a>{{patient.firstName}}</a></td><td ng-click=\"vm.goToPatientDetails(patient.id)\">{{patient.lastName}}</td><td ng-click=\"vm.goToPatientDetails(patient.id)\">{{patient.dateOfBirth | date:\'MM/dd/yyyy\'}}</td><td ng-click=\"vm.goToPatientDetails(patient.id)\">{{patient.patientId}}</td><td ng-click=\"vm.goToPatientDetails(patient.id)\">{{patient.lastRequested | date:\'MM/dd/yyyy\'}}</td><td ng-click=\"vm.goToPatientDetails(patient.id)\">{{patient.lastCompleted | date:\'MM/dd/yyyy\'}}</td><td><a ng-if=\"patient.requestStatus\" ng-click=\"vm.goToPatientDetails(patient.id)\">{{ \'ipmApp.QuestionnaireStatus.\' + patient.requestStatus | translate}} &nbsp;</a></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"15\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/patient/resend-invitation-dialog.html","<form name=\"resumeForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.patient.resendInvitation.title\">Resend Invitation</h5></div><div class=\"modal-body\"><p translate=\"ipmApp.patient.resendInvitation.success\">This request has been resent.</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"isSaving\" ng-click=\"vm.yes()\"><span translate=\"entity.action.ok\">Ok</span></button></div></form>");
$templateCache.put("app/presentation-controls-instructor/presentation-controls-instructor-final-dialog.html","<form name=\"confirmForm\" ng-submit=\"vm.confirm(vm.user.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.presentationControls.confirmDialog.title\">Stop presentation confirmation</h5></div><div class=\"modal-body\"><p translate=\"ipmApp.presentationControls.confirmDialog.stopPresentingWarningMessage\">Warning: Are you sure you want to stop presenting? This will close the window you are sharing with the patients.</p></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><span translate=\"entity.action.yes\">Yes</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.no\">No</span></button></div></form>");
$templateCache.put("app/presentation-controls-instructor/presentation-controls-instructor.html","<div class=\"page\"><div class=\"container-fluid\"><div class=\"content presentation-instructor-content\"><jhi-alert></jhi-alert><div class=\"h5 primary pb-2\">{{vm.wellnessClassName}}</div><div class=\"presentation-controls\"><div class=\"presentation-title\"><label>Slides</label></div><!--View Attendence--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep === \'START\'\" ng-include=\"\'view-attendence\'\"></div><!--summary-view-info--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep === \'FINAL\'\" ng-include=\"\'summary-view-info\'\"></div><!--Start pdf-viewer-info--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep === \'INPROGRESS\'\" ng-include=\"\'pdf-viewer-info\'\"></div><!--start pdf-viewer--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep === \'INPROGRESS\'\" ng-include=\"\'pdf-viewer\'\"></div><!--class-notes--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep !== \'START\'\" ng-include=\"\'class-notes\'\"></div></div><!--presentation-patient--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep !== \'FINAL\'\" ng-include=\"\'presentation-patient\'\"></div><!--presentation-patient-not-present--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep !== \'FINAL\'\" ng-include=\"\'presentation-patient-not-present\'\"></div><!--start summary--><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep === \'FINAL\'\" ng-include=\"\'summary-view\'\"></div><div ng-if=\"vm.wellnessClass.instructorPatientPresentation.currentStep === \'FINAL\'\" ng-include=\"\'summary-view-not-present\'\"></div></div></div></div><script type=\"text/ng-template\" id=\"view-attendence\"><div class=\"row\">\n        <div class=\"col-md-8\">\n            <div>\n                <label translate=\"ipmApp.presentationControls.label.deck\">Deck: </label>\n                <span class=\"pl-1\">{{vm.wellnessClass.deckName}}</span>\n                <span> - </span>\n                <label translate=\"ipmApp.presentationControls.label.class\">Class </label>\n                <span class=\"pl-1\">#{{vm.wellnessClass.sequence}}</span>\n            </div>\n            <div>\n                <span translate=\"ipmApp.presentationControls.label.pleaseIndicateWhichPatientsArePresent\">\n                </span>\n            </div>\n        </div>\n        <div class=\"col-auto text-right px-3 py-2\">\n            <div class=\"btn-group flex-btn-group-container\">\n                <div class=\"btn-bn-item\">\n                    <button type=\"button\"\n                            ng-disabled=\"vm.isLoading\"\n                            ng-click=\"vm.startClick()\"\n                            class=\"btn btn-info btn-sm\">\n                                    <span class=\"hidden-xs hidden-sm\"\n                                          translate=\"ipmApp.presentationControls.action.start\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div></script><script type=\"text/ng-template\" id=\"summary-view-info\"><div class=\"row\">\n        <div class=\"col-md-8\">\n            <span>Class Summary</span>\n        </div>\n        <div class=\"col-auto text-right px-3 py-2\">\n            <div class=\"btn-group flex-btn-group-container\">\n                <div class=\"btn-bn-item\">\n                    <button type=\"button\"\n                            ng-disabled=\"vm.isLoading || vm.wellnessClass.instructorPatientPresentation.status === \'FINAL\'\"\n                            ng-click=\"vm.finalizeClick()\"\n                            class=\"btn btn-info btn-sm\">\n                                    <span class=\"hidden-xs hidden-sm\"\n                                          translate=\"ipmApp.presentationControls.action.finalize\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div></script><script type=\"text/ng-template\" id=\"pdf-viewer-info\"><div class=\"row\">\n        <div class=\"col-md-8\">\n            <div>\n                <label translate=\"ipmApp.presentationControls.label.currentSlide\">Current\n                    Slide: </label>\n                <span class=\"pl-1\">#<span>{{vm.currentSlideIndex + 1}}</span>/<span>{{vm.deck.numberOfSlides}}</span> - <span>{{vm.currentSlide.name}}</span></span>\n            </div>\n            <div ng-if=\"vm.currentSlide.type === \'QUESTION\'\">\n                <label translate=\"ipmApp.presentationControls.label.question\">Question:</label>\n                <span class=\"pl-1\" ng-if=\"vm.currentSlide.question\">{{vm.currentSlide.question.prompt}}</span>\n            </div>\n        </div>\n        <div class=\"col-auto text-right px-3 py-2\">\n            <div class=\"btn-group flex-btn-group-container\">\n                <div class=\"btn-bn-item\">\n                    <button type=\"button\"\n                            ng-disabled=\"vm.inValidBack() || vm.isLoading\"\n                            ng-click=\"vm.backClick()\"\n                            class=\"btn btn-info btn-sm\">\n                        <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.presentationControls.action.back\"></span>\n                    </button>\n                </div>\n                <div class=\"btn-bn-item\" ng-if=\"!vm.isLastSilde()\">\n                    <button type=\"button\"\n                            ng-disabled=\"vm.inValidNext() || vm.isLoading\"\n                            ng-click=\"vm.nextClick()\"\n                            class=\"btn btn-info btn-sm\">\n                                    <span class=\"hidden-xs hidden-sm\"\n                                          translate=\"ipmApp.presentationControls.action.next\"></span>\n                    </button>\n                </div>\n                <div class=\"btn-bn-item\" ng-if=\"vm.isLastSilde()\">\n                    <button type=\"button\"\n                            ng-disabled=\"vm.isLoading\"\n                            ng-click=\"vm.stopPresentingClick()\"\n                            class=\"btn btn-info btn-sm\">\n                                    <span class=\"hidden-xs hidden-sm\"\n                                          translate=\"ipmApp.presentationControls.action.stopPresenting\"></span>\n                    </button>\n                </div>\n                <div class=\"btn-bn-item\" ng-if=\"vm.isLastSilde()\">\n                    <button type=\"button\"\n                            ng-disabled=\"vm.isLoading\"\n                            ng-click=\"vm.finalizeClick()\"\n                            class=\"btn btn-info btn-sm\">\n                                    <span class=\"hidden-xs hidden-sm\"\n                                          translate=\"ipmApp.presentationControls.action.finalize\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div></script><script type=\"text/ng-template\" id=\"pdf-viewer\"><div class=\"row-v4\">\n        <!--Slide-->\n        <div class=\"col-v4-md-9\">\n            <div class=\"pdf-viewer\">\n                <div class=\"pdf-viewer-scroll-content instructor\" drag-to-scroll\n                     on-scroll=\"vm.sendScrollPositionToPresentationView(position)\">\n                    <pdf-view ng-if=\"vm.pdfCurrentData\" pdf-data=\"vm.pdfCurrentData\" uint8-enable=\"true\"\n                              is-show-toolbar=\"true\"\n                              onchange-back=\"vm.onchangePdfBack(currentPage)\"\n                              onchange-next=\"vm.onchangePdfNext(currentPage)\"\n                              onchange-zoom-in=\"vm.onchangeZoomIn(scaleZoom)\"\n                              onchange-zoom-out=\"vm.onchangeZoomOut(scaleZoom)\"\n                              onchange-go-to-page=\"vm.onchangeGoToPage(currentPage)\"\n                    ></pdf-view>\n                </div>\n            </div>\n        </div>\n        <!--Speaker Note-->\n        <div class=\"col-v4-md-3\">\n            <div class=\"speaker-note\">\n                {{vm.currentSlide.speakerNotes}}\n            </div>\n        </div>\n    </div></script><script type=\"text/ng-template\" id=\"presentation-patient\"><presentation-patient-response-management ng-if=\"!vm.isLoading && vm.wellnessClass && vm.wellnessClass.instructorPatientPresentation\"\n                                                      deck=\"vm.deck\"\n                                                      slide=\"vm.currentSlide\"\n                                                      wellness-class=\"vm.wellnessClass\"\n                                                      presentation-status=\"\'PRESENT\'\"\n                                                      is-reload-change=\"vm.isReloadChangeListPatient\"\n                                                      is-show-response-open=\"vm.wellnessClass.instructorPatientPresentation.currentStep !== \'START\'\"\n                                                      is-show-attendance-open=\"vm.wellnessClass.instructorPatientPresentation.currentStep === \'START\'\"\n                                                      show-expand-all=\"true\"\n                                                      is-manager-template=\"true\"\n                                                      is-saving-drap-change=\"vm.isSavingDrapChange\"\n                                                      on-change=\"vm.dragOnchange(patientPresentations)\"\n                                                      reload-change-list=\"vm.onChangeReloadPPList()\"\n            ></presentation-patient-response-management></script><script type=\"text/ng-template\" id=\"presentation-patient-not-present\"><div class=\"row-v4\">\n        <div class=\"col-v4-md-12\">\n            <presentation-patient-response-management ng-if=\"!vm.isLoading && vm.wellnessClass && vm.wellnessClass.instructorPatientPresentation\"\n                                                      deck=\"vm.deck\"\n                                                      slide=\"vm.currentSlide\"\n                                                      wellness-class=\"vm.wellnessClass\"\n                                                      show-expand-all=\"false\"\n                                                      show-patient-not-presents-label=\"true\"\n                                                      is-reload-change=\"vm.isReloadChangeListPatient\"\n                                                      is-show-response-open=\"false\"\n                                                      is-show-attendance-open=\"false\"\n                                                      presentation-status=\"\'NOT_PRESENT\'\"\n                                                      is-disable-drap-drop=\"true\"\n                                                      is-manager-template=\"true\"\n                                                      reload-change-list=\"vm.onChangeReloadPNPList()\"\n            ></presentation-patient-response-management></script><script type=\"text/ng-template\" id=\"summary-view\"><div class=\"row-v4\">\n        <div class=\"col-v4-md-12\">\n            <presentation-patient-response-management ng-if=\"!vm.isLoading && vm.wellnessClass && vm.wellnessClass.instructorPatientPresentation && vm.deck\"\n                                                      deck=\"vm.deck\"\n                                                      wellness-class=\"vm.wellnessClass\"\n                                                      slides=\"vm.deck.slides\"\n                                                      show-expand-all=\"true\"\n                                                      is-reload-change=\"vm.isReloadChangeListPatient\"\n                                                      is-summary-template=\"true\"\n                                                      presentation-status=\"\'PRESENT\'\"\n                                                      is-disable-drap-drop=\"false\"\n                                                      is-saving-drap-change=\"vm.isSavingDrapChange\"\n                                                      on-change=\"vm.dragOnchange(patientPresentations)\"\n                                                      reload-change-list=\"vm.onChangeReloadPPList()\"\n                                                      >\n            </presentation-patient-response-management>\n        </div>\n    </div></script><script type=\"text/ng-template\" id=\"summary-view-not-present\"><div class=\"row-v4\">\n        <div class=\"col-v4-md-12\">\n            <presentation-patient-response-management ng-if=\"!vm.isLoading && vm.wellnessClass && vm.wellnessClass.instructorPatientPresentation && vm.deck\"\n                                                      deck=\"vm.deck\"\n                                                      wellness-class=\"vm.wellnessClass\"\n                                                      slides=\"vm.deck.slides\"\n                                                      show-expand-all=\"false\"\n                                                      is-reload-change=\"vm.isReloadChangeListPatient\"\n                                                      show-patient-not-presents-label=\"true\"\n                                                      is-summary-template=\"true\"\n                                                      presentation-status=\"\'NOT_PRESENT\'\"\n                                                      is-disable-drap-drop=\"true\"\n                                                      reload-change-list=\"vm.onChangeReloadPNPList()\"\n            >\n            </presentation-patient-response-management>\n        </div>\n    </div></script><script type=\"text/ng-template\" id=\"class-notes\"><uib-accordion close-others=\"true\">\n        <div uib-accordion-group class=\"panel-default\" is-open=\"vm.classNotesOpen\">\n            <uib-accordion-heading>\n                <i class=\"pull-left glyphicon\"\n                   ng-class=\"{\'glyphicon-chevron-down\': vm.classNotesOpen, \'glyphicon-chevron-up\': !vm.classNotesOpen}\">\n                </i>\n                <span class=\"pl-2\">Class Notes</span>\n            </uib-accordion-heading>\n            <div>\n                <textarea class=\"form-control auto-height no-resize\"\n                          rows=\"2\"\n                          name=\"classNotes\"\n                          id=\"classNotes\"\n                          ng-mouseenter=\"vm.classNotesMouseEnter()\"\n                          ng-mouseleave=\"vm.classNotesMouseleave()\"\n                          ng-model=\"vm.wellnessClass.instructorPatientPresentation.classNotes\"\n                ></textarea>\n            </div>\n        </div>\n    </uib-accordion></script>");
$templateCache.put("app/psych-intake/psych-intake.html","<div class=\"page page--survey-workflow\" ng-class=\"vm.getLanguage() === \'es\' ? \'es-lang\': \'\'\"><div class=\"container\"><div class=\"content\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-attr-aria-valuenow=\"vm.percent\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-bind-html=\"vm.percent + \'%\'\" ng-style=\"vm.widthStyle()\">0%</div></div></div></div><div class=\"row\"><div class=\"col-md-12 h2 title\" ng-if=\"vm.psychIntake.currentSection.nameLangKey &&\n                                vm.psychIntake.currentSection.code !== \'PSYCHOTHERAPY_SESSIONS\' &&\n                                vm.psychIntake.currentSection.code !== \'PRIVACY_PRACTICE\' &&\n                                vm.psychIntake.currentSection.code !== \'POLICIES_PROCEDURES\' &&\n                                vm.psychIntake.currentSection.code !== \'PCSG_INFORMATION_POLICIES\' &&\n                                vm.psychIntake.currentSection.code !== \'TELEHEALTH_INFORMED_CONSENT\' &&\n                                vm.psychIntake.currentSection.code !== \'PATIENT_ACKNOWLEDGEMENT\'\" translate=\"{{vm.psychIntake.currentSection.nameLangKey}}\">Workflow Title</div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ui-view=\"workflow-view@psych-intake\"></div></div></div></div></div>");
$templateCache.put("app/qhp-workflow/item-landing-page.html","<div class=\"wrap-box\"><div class=\"content-box\" ng-click=\"vm.clickAction()\"><img src=\"{{vm.item.image}}\"><div class=\"title-box\">{{vm.item.titleTextTranslate | translate}}</div><div class=\"small text-success\"><span translate=\"{{vm.item.approxTextTranslate}}\" translate-value-min=\"{{vm.item.minApprox}}\"></span></div></div></div>");
$templateCache.put("app/qhp-workflow/landing-page.html","<div class=\"page\"><div class=\"container\"><div class=\"landing-page\"><div class=\"landing-page-background landing-page-start\"><uib-carousel active=\"vm.active\" interval=\"vm.myInterval\" no-wrap=\"false\"><uib-slide ng-repeat=\"item in vm.slides\" index=\"item.id\"><div class=\"carousel-caption row-v4 align-items-center mx-0 fix-on-safari-5\"><div class=\"col-v4-12 px-0\"><div class=\"title-landing\" translate=\"ipmApp.qhpWorkflow.landingPage.text1\"></div></div></div></uib-slide></uib-carousel></div><div class=\"text-center py-4\" translate=\"ipmApp.qhpWorkflow.landingPage.text2\"></div><div class=\"landing-page-wrap\"><div class=\"row-v4 justify-content-center fix-on-safari-5\"><div class=\"col-v4-sm-7 col-v4-md-6 col-v4-lg-5 col-v4-xl-4 pb-4\" ng-repeat=\"item in vm.langdingPageItems\" index=\"item.id\"><!-- <item-landing-page item=\"item\" on-click=\"vm.itemLandingPageClick(item)\"></item-landing-page> --><qhp-item-landing-page item=\"item\" on-click=\"vm.itemLandingPageClick(item)\"></qhp-item-landing-page></div></div></div></div></div></div>");
$templateCache.put("app/survey-result/survey-result-details.html","<div class=\"page page--survey-result-details\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.surveyResult.detail.title\"></div><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.surveyResult.detail.patientInfo\"></span></div></div><div class=\"row\"><div class=\"col-md-12 mb-15\"><div class=\"row voffset\"><div class=\"col-md-2 col-sm-2\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.firstName\' | translate}}</label></div><div class=\"col-md-10 col-sm-10\">{{vm.surveyResult.patientFirstName}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-sm-2\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.lastName\' | translate}}</label></div><div class=\"col-md-10 col-sm-10\">{{vm.surveyResult.patientLastName}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-sm-2\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.dateOfBirth\' | translate}}</label></div><div class=\"col-md-10 col-sm-10\">{{vm.surveyResult.patientDOB | date:\'MM/dd/yyyy\'}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-sm-2\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.patientIdCode\' | translate}}</label></div><div class=\"col-md-10 col-sm-10\">{{vm.surveyResult.patientIdCode}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-sm-2\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.disposition\' | translate}}</label></div><div class=\"col-md-10 col-sm-10\"><button type=\"button\" class=\"btn btn-default btn-toggle disable\" ng-class=\"{\'active\': vm.getDisposition()}\"></button></div></div></div></div><!--    		\n   				<li><label class=\"control-label\"> : </label>\n   					<input type=\"checkbox\" name=\"disposition\" id=\"disposition\" \n                  	ng-model=\"vm.surveyResult.disposition\" ng-click=\"vm.changeDisposition()\"></li>  		\n   			 --><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.surveyResult.detail.allBattery\"></span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAllResults()\"><th><span>{{\'ipmApp.surveyResult.id\' | translate}}</span></th><th jh-sort-by=\"battery.id\"><span>{{\'ipmApp.surveyResult.batteryNumber\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.surveyResult.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"id\"><span>{{\'ipmApp.surveyResult.dateLastUpdated\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"completionDate\"><span>{{\'ipmApp.surveyResult.completionDate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\" ng-show=\"vm.isManager\"><span>{{\'ipmApp.surveyResult.downloadresult\' | translate}}</span></th><th class=\"text-center\"><span>{{\'ipmApp.surveyResult.downloadresponse\' | translate}}</span></th></tr></thead><tbody><tr ng-repeat=\"sr in vm.surveyResults track by sr.id\"><td>{{vm.getIndex($index)}}</td><td>{{sr.batteryNameEn}}</td><td>{{\'ipmApp.SurveyResultStatus.\' + sr.status | translate}}</td><td><span ng-if=\"sr.lastModifiedDate\">{{ sr.lastModifiedDate| date:\'MM/dd/yyyy\' }}</span> <span ng-if=\"!sr.lastModifiedDate\">{{ sr.createdDate| date:\'MM/dd/yyyy\' }}</span></td><td><span>{{ sr.completionDate| date:\'MM/dd/yyyy\' }}</span></td><td class=\"text-center\" ng-show=\"vm.isManager\"><a ng-if=\"sr.status === \'COMPLETE\' || sr.status === \'INCOMPLETE\' || sr.status === \'DOWNLOADED\'\" href=\"{{ \'api/survey-results/download/\' + sr.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td><td class=\"text-center\"><a ng-if=\"sr.status === \'COMPLETE\' || sr.status === \'INCOMPLETE\' || sr.status === \'DOWNLOADED\'\" href=\"{{ \'api/survey-results/download-response/\' + sr.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAllResults()\"></uib-pagination></div></div></div><div class=\"row\"><div class=\"col-md-12 voffset2\"><button class=\"btn btn-info\" ng-click=\"vm.backToList()\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/survey-result/survey-result-list.html","<div class=\"page page--survey-result-list\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.surveyResult.home.title\">SurveyResults</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 voffset3\"><div class=\"row\"><div class=\"col-sm-5 col-xs-12 has-feedback-left\"><div class=\"form-group\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.surveyResult.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search():0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></div></div><div class=\"col-sm-2 col-xs-12\"><div class=\"form-group\"><select class=\"form-control\" name=\"surveyStatus\" id=\"surveyStatus\" ng-model=\"vm.status\" ng-change=\"vm.search()\" ng-options=\"opt.displayName as opt.translateKey | translate for opt in vm.statuses\"><option value=\"\" selected=\"selected\" disabled=\"disabled\" hidden>{{\'ipmApp.surveyResult.surveyStatus\' | translate}}</option></select></div></div><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group pull-right\" ng-show=\"vm.isManager\"><button class=\"btn btn-info\" ng-click=\"vm.downloadAllReport()\">Download All Complete Tests</button></div></div></div></div></div><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"u.firstName\"><span>{{\'ipmApp.surveyResult.firstName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"u.lastName\"><span>{{\'ipmApp.surveyResult.lastName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pa.dateOfBirth\"><span>{{\'ipmApp.surveyResult.dateOfBirth\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pa.patientId\"><span>{{\'ipmApp.surveyResult.patientIdCode\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ba.nameEn\"><span>{{\'ipmApp.surveyResult.currentBattery\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" jh-sort-by=\"disposition\"><span>{{\'ipmApp.surveyResult.disposition\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.surveyResult.surveyStatus\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status, sr.completionDate\"><span>{{\'ipmApp.surveyResult.lastCompletedDate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"surveyResult in vm.surveyResults track by surveyResult.id\"><td ng-click=\"vm.goToPatientDetails(surveyResult.patientId)\">{{surveyResult.patientFirstName}}</td><td ng-click=\"vm.goToPatientDetails(surveyResult.patientId)\">{{surveyResult.patientLastName}}</td><td ng-click=\"vm.goToPatientDetails(surveyResult.patientId)\">{{surveyResult.patientDOB | date:\'MM/dd/yyyy\'}}</td><td ng-click=\"vm.goToPatientDetails(surveyResult.patientId)\">{{surveyResult.patientIdCode}}</td><td ng-click=\"vm.goToPatientDetails(surveyResult.patientId)\">{{surveyResult.batteryNameEn}}</td><td class=\"text-center\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.getDisposition(surveyResult)}\" ng-click=\"vm.changeDisposition(surveyResult)\"></button></td><td>{{ \'ipmApp.SurveyResultStatus.\' + surveyResult.status | translate}} &nbsp;<!-- action btn --> <a ng-if=\"(surveyResult.status === \'COMPLETE\' || surveyResult.status === \'INCOMPLETE\' || surveyResult.status === \'DOWNLOADED\') && vm.isManager\" ng-href=\"{{ \'api/survey-results/download/\' + surveyResult.id }}\" class=\"glyphicon glyphicon-download-alt\"></td><td><span ng-if=\"surveyResult.status === \'COMPLETE\'\">{{surveyResult.completionDate | date:\'MM/dd/yyyy\'}}</span></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"15\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/survey-workflow/survey-workflow.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><form name=\"surveyForm\" role=\"form\" novalidate><div class=\"row\" ng-if=\"vm.batteryTest.test.name !== null || vm.batteryTest.test.instructions !== null\"><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.currentQuestionIndex != -1 && vm.currentQuestion != vm.batteryTest.test.sections[vm.currentSection].questions.length\"><div class=\"col-md-12\"><div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-attr-aria-valuenow=\"vm.percent\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-bind-html=\"vm.percent + \'%\'\" ng-style=\"vm.widthStyle()\">0%</div></div></div></div><div class=\"row\"><div class=\"col-md-12 h2 title\" ng-if=\"vm.batteryTest.test.name !== null\">{{vm.batteryTest.test.name}}</div><div class=\"col-md-12\" ng-if=\"!(vm.batteryTest.nextBatteryTestId === null && (vm.currentSection == vm.totalSection - 1 && vm.currentQuestion == vm.batteryTest.test.sections[vm.currentSection].questions.length)) && vm.batteryTest.test.instructions !== null\"><div class=\"battery\"><ng-bind-html ng-bind-html=\"vm.batteryTest.test.instructions\"></ng-bind-html></div></div></div></div></div><div class=\"row\" ng-repeat=\"section in vm.batteryTest.test.sections track by section.id\"><div class=\"col-md-12\" ng-if=\"vm.currentSection == $index\"><div class=\"row section-name\" ng-if=\"vm.currentQuestionIndex !=-1 && !(vm.batteryTest.nextBatteryTestId === null && (vm.currentSection == vm.totalSection - 1 && vm.currentQuestion == vm.batteryTest.test.sections[vm.currentSection].questions.length)) && (section.name !== null || section.instructions !== null)\"><div class=\"col-md-12 bold voffset3 font-s15\" ng-if=\"section.name !== null\">{{section.name}}</div><div class=\"col-md-12 voffset3 font-s15 bold\" ng-if=\"section.instructions !== null\" ng-bind-html=\"section.instructions\"></div></div><!-- Question --><div ng-if=\"vm.currentQuestionIndex != -1\"><!-- SHORT_ANSWER - MULTIPLE_CHOICE - MULTI_SELECT - DATE_TIME - MISC Section --><div class=\"row voffset3 question-content\" ng-repeat=\"question in section.questions track by question.id\" ng-if=\"section.type !== \'RANK\' && $index==vm.currentQuestion\"><!-- content question --><div class=\"col-md-12\" ng-if=\"question.type !== \'RANK\'\"><div class=\"form-group bold question-name font-s15\" ng-if=\"question.name !== null\" ng-bind-html=\"question.name\"></div></div><!-- SHORT_ANSWER --><div class=\"col-md-12 select-one\" ng-include=\"\'free-text-partial.html\'\" ng-if=\"question.type === \'SHORT_ANSWER\'\"></div><!-- MULTIPLE_CHOICE --><div class=\"col-md-12 select-one\" ng-include=\"\'select-one-partial.html\'\" ng-if=\"question.type === \'MULTIPLE_CHOICE\'\"></div><!-- MULTI_SELECT --><div class=\"col-md-12 select-one\" ng-include=\"\'select-multiple-partial.html\'\" ng-if=\"question.type === \'MULTI_SELECT\'\"></div><!-- DATE_TIME --><div ng-include=\"\'datetime-partial.html\'\" ng-if=\"question.type === \'DATE_TIME\'\"></div><!-- RANK for MISC --><div class=\"col-md-12 table-responsive question-content ng-scope\" ng-if=\"question.type === \'RANK\'\"><div ng-include=\"\'rank-partial.html\'\"></div></div></div><!-- RANK Section --><div class=\"table-responsive voffset3 question-content\" ng-if=\"section.type === \'RANK\'\"><div ng-include=\"\'rank-partial.html\'\" ng-repeat=\"question in section.questions track by question.id\"></div></div></div><!-- BUTTONS --><nav aria-label=\"Page navigation\" class=\"text-center\" ng-if=\"(vm.batteryTest.nextBatteryTestId !== null || vm.currentQuestionIndex < vm.totalQuestion) && vm.currentQuestionIndex != -1\"><ul class=\"pagination d-block d-md-inline-block\"><li ng-class=\"{\'disabled\': vm.isSaving || (vm.currentQuestionIndex == 0)}\"><a aria-label=\"First\" ng-click=\"vm.goto(\'First\')\"><span aria-hidden=\"true\">&laquo;</span></a></li><li ng-class=\"{\'disabled\': vm.isSaving || (vm.batteryTest.prevBatteryTestId == null && vm.currentQuestionIndex == 0)}\"><a aria-label=\"Previous\" ng-click=\"vm.goto(\'Previous\')\"><span aria-hidden=\"true\" translate=\"surveyWorkflow.action.previous\">Previous</span></a></li><li ng-class=\"{\'disabled\': vm.isSaving || (vm.currentQuestionIndex == vm.totalQuestionAnswered && vm.totalQuestionAnswered != vm.totalQuestion)}\"><a aria-label=\"Next\" ng-click=\"vm.goto(\'Next\')\"><span aria-hidden=\"true\" translate=\"surveyWorkflow.action.next\">Next</span></a></li><li ng-class=\"{\'disabled\': vm.isSaving || (vm.currentQuestionIndex == vm.totalQuestionAnswered || (vm.currentQuestionIndex == vm.totalQuestionAnswered - 1 && vm.totalQuestionAnswered == vm.totalQuestion))}\"><a aria-label=\"Last\" ng-click=\"vm.goto(\'Last\')\"><span aria-hidden=\"true\">&raquo;</span></a></li></ul><span class=\"jump-to\" translate=\"surveyWorkflow.action.jumpto\">Jump to</span><div class=\"form-group\"><select class=\"form-control\" style=\"min-width: 60px\" ng-model=\"vm.currentQuestionIndex\" ng-change=\"vm.moveQuestionByIndex()\"><option ng-repeat=\"option in vm.totalQuestionAnsweredArray\" ng-selected=\"{{option == vm.currentQuestionIndex}}\" value=\"{{option}}\">{{option + 1}}</option></select></div></nav></div></div><div class=\"row\"><!-- <div class=\"col-md-12 btn-step\" ng-if=\"vm.batteryTest.prevBatteryTestId !== null || vm.batteryTest.nextBatteryTestId !== null\">\n				        <div class=\"btn-step-child\" ng-if=\"vm.batteryTest.prevBatteryTestId !== null\" ng-disabled=\"isSaving || vm.batteryTest.prevBatteryTestId === null\" ng-click=\"vm.previous()\">\n				        	<span class=\"btn-arrow left\"></span>\n				        	<span class=\"btn-arrow-text\" translate=\"surveyWorkflow.action.previous\">Previous</span>\n				        </div>\n                        <div class=\"btn-step-child btn-next\" ng-if=\"(vm.currentSection == vm.totalSection - 1 && vm.currentQuestion == vm.batteryTest.test.sections[vm.currentSection].questions.length) && vm.batteryTest.nextBatteryTestId !== null\" ng-disabled=\"isSaving || vm.batteryTest.nextBatteryTestId === null\" ng-click=\"vm.next()\">\n				        	<span class=\"btn-arrow-text\" translate=\"surveyWorkflow.action.next\">Next</span>\n				        	<span class=\"btn-arrow right\"></span>\n				        </div>\n				    </div> --><div class=\"col-md-12 voffset2 text-center\" ng-if=\"vm.currentQuestionIndex == -1\" style=\"margin-top: 20px\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.start()\"><span translate=\"surveyWorkflow.action.begin\">Begin</span></button></div></div></form></div></div></div><script type=\"text/ng-template\" id=\"select-one-partial.html\"><div class=\"radio\" ng-repeat=\"questionOption in question.questionOptions track by questionOption.id\">\n        <label>\n			<input type=\"radio\" id=\"radio{{questionOption.id}}\" name=\"radio{{questionOption.id}}\" value=\"{{questionOption.value}}\" ng-model=\"question.answer\" ng-disabled=\"vm.isSaving\" ng-change=\"vm.questionChecked(questionOption)\"> {{questionOption.name}}\n		</label>\n        <p style=\"margin-left: 20px; margin-bottom: 15px; font-style: italic;\" ng-if=\"vm.checkshowOtherText(question, questionOption)\" translate=\"surveyWorkflow.maxlengthvalidate\">This field cannot be longer than 255 characters.</p>\n        <textarea rows=\"4\" class=\"form-control w-30 auto-height none-resize\" name=\"text_{{question.id}}\" ng-model=\"question.answerText\" ng-if=\"vm.checkshowOtherText(question, questionOption)\" maxlength=\"255\"></textarea>\n	</div>\n\n    <div class=\"col-md-12 voffset2\" ng-if=\"vm.showSaveButton\">\n        <button type=\"submit\" ng-disabled=\"vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.questionChecked()\">\n            <span translate=\"surveyWorkflow.action.saveanswer\">Save Answer</span>\n        </button>\n    </div></script><script type=\"text/ng-template\" id=\"free-text-partial.html\"><div>\n        <textarea rows=\"4\" class=\"form-control auto-height none-resize\" name=\"text_{{question.id}}\" ng-model=\"question.answerText\" maxlength=\"255\" required></textarea>\n    </div>\n    <div class=\"col-md-12 voffset2\">\n        <button type=\"submit\" ng-disabled=\"surveyForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.questionChecked()\">\n            <span translate=\"surveyWorkflow.action.saveanswer\">Save Answer</span>\n        </button>\n    </div></script><script type=\"text/ng-template\" id=\"datetime-partial.html\"><div class=\"row\">\n        <div class=\"col-md-2 col-sm-3\">   \n            <div class=\"form-group\">\n                <div class=\"input-group\">\n    \n                    <input type=\"text\" class=\"form-control\"\n                            id=\"datetime\"\n                            name=\"datetime\"\n                            uib-datepicker-popup=\"MM/dd/yyyy\"\n                            close-text=\"{{\'global.datepicker.done\' | translate}}\"\n                            current-text=\"{{\'global.datepicker.today\' | translate}}\"\n                            clear-text=\"{{\'global.datepicker.clear\' | translate}}\"\n                            datepicker-options=\"vm.datePickerOptions\"\n                            ng-model=\"question.dateValueDisplay\"\n                            is-open=\"vm.datePickerOpenStatus.datetime\"\n                            required>\n                           <div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'datetime\')\"></span></div>\n                    \n                </div>\n                <div ng-show=\"surveyForm.datetime.$dirty && surveyForm.datetime.$invalid\">\n                    <p class=\"help-block\" ng-show=\"surveyForm.datetime.$error.required\"\n                            translate=\"surveyWorkflow.validation.datetime.required\">\n                            This field is required.\n                    </p>\n                    <p class=\"help-block\" ng-show=\"surveyForm.datetime.$error.date\"\n                            translate=\"surveyWorkflow.validation.datetime.invalid\">\n                            This field is invalid.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 voffset2\">\n            <button type=\"submit\" ng-disabled=\"surveyForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.questionChecked()\">\n                <span translate=\"surveyWorkflow.action.saveanswer\">Save Answer</span>\n            </button>\n        </div>\n	</div></script><script type=\"text/ng-template\" id=\"rank-partial.html\"><table class=\"table table-striped\" ng-if=\"$index==vm.currentQuestion\">\n        <thead ng-hide=\"vm.currentSection == vm.totalSection - 1 && vm.currentQuestion == vm.batteryTest.test.sections[vm.currentSection].questions.length\">\n            <tr>\n                <th></th>\n                <th class=\"text-center font-s15 w8 {{opt.cssClass}}\" ng-repeat=\"opt in question.questionOptions track by opt.id\">\n                    {{::opt.name}}\n                </th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr>\n                <td class=\"question-text font-s15\">\n                    <ng-bind-html ng-bind-html=\"question.name\"></ng-bind-html>\n                </td>\n                <td class=\"text-center pt-8\" ng-repeat=\"questionOption in question.questionOptions\">\n                    <label>\n                        <input type=\"radio\" name=\"radio{{question.id}}\" value=\"{{questionOption.value}}\" ng-disabled=\"vm.isSaving\" ng-model=\"question.answer\" ng-change=\"vm.questionChecked()\">\n                    </label>\n                </td>\n            </tr>\n        </tbody>\n    </table></script><script type=\"text/ng-template\" id=\"select-multiple-partial.html\"><div ng-repeat=\"question in section.questions track by question.id\" ng-if=\"$index==vm.currentQuestion\">\n        <div class=\"radio\" ng-repeat=\"questionOption in question.questionOptions track by questionOption.id\">\n            <label>\n                <input type=\"checkbox\" \n                	id=\"checkbox_{{questionOption.id}}\" \n									name=\"checkbox_{{questionOption.id}}\" \n									value=\"{{questionOption.value}}\"\n									ng-model=\"questionOption.checked\" \n									ng-disabled=\"vm.isSaving\"> {{questionOption.name}}\n            </label>\n        </div>\n    </div>\n    <div class=\"col-md-12 voffset2\">\n			<button type=\"submit\" ng-disabled=\"vm.noMultipleSelect(question) || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.questionChecked()\">\n					<span translate=\"surveyWorkflow.action.saveanswer\">Save Answer</span>\n			</button>\n		</div></script><!-- Start of ipmdoctors Zendesk Widget script --><chat-support is-show=\"true\"></chat-support><!-- End of ipmdoctors Zendesk Widget script -->");
$templateCache.put("app/account/password/password.html","<div class=\"page page--password\"><div class=\"container\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2\"><div class=\"h2 title text-center voffset5\">{{\'password.change.title\' | translate}}</div><div class=\"frm-password\"><div class=\"text-center\"><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" ng-model=\"vm.password\" ng-minlength=\"5\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><!-- <password-strength-bar password-to-check=\"vm.password\"></password-strength-bar> --></div><div class=\"form-group\"><label for=\"confirmPassword\">{{\'global.form.confirmpassword\' | translate}}</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class=\"voffset4 text-center\"><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.back()\" translate=\"entity.action.back\">Back</button></div></form></div></div></div></div></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/register/register.html","<!-- <div class=\"page page--register\">\n	<div class=\"container\">\n		<div class=\"content\">\n		    <div class=\"row\">\n		        <div class=\"col-md-12\">\n		            <div class=\"h2 title\" translate=\"register.title\">Registration</div>\n		\n		            <div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\">\n		                <strong>Registration failed!</strong> Please try again later.\n		            </div>\n		            \n		            <div class=\"alert alert-danger\" ng-show=\"vm.loginExists !== null\">\n                        {{ \'home.messages.error.existPatientID\' | translate}}\n                    </div>  \n		\n		        </div>\n		        <div class=\"col-md-12\" translate=\"register.welcome\">\n		        </div>\n		        <div class=\"col-md-12 voffset2\">\n		        	<div class=\"row\">\n			            <form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation>\n			            	<div class=\"col-md-6 col-sm-6\">\n			            		<div class=\"form-group\">\n			            			<label for=\"firstName\" translate=\"register.form.firstName\">First Name</label>\n			            			<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n			            			<input type=\"text\" class=\"form-control\" \n					                	id=\"firstName\" \n					                    name=\"firstName\" \n					                    ng-model=\"vm.registerAccount.firstName\" \n					                    maxlength=\"50\"  \n					                    required>\n									<div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\">\n										<p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"register.messages.validate.firstName.required\">\n					                		First name is required.\n					                    </p>\n									</div>\n			            		</div>\n			            	</div>\n			            	\n			            	<div class=\"col-md-6 col-sm-6\">\n			            		<div class=\"form-group\">\n			            			<label for=\"lastName\" translate=\"register.form.lastName\">Last Name</label>\n			            			<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n			            			<input type=\"text\" class=\"form-control\" \n					                	id=\"lastName\" \n					                    name=\"lastName\" \n					                    ng-model=\"vm.registerAccount.lastName\" \n					                    maxlength=\"50\"\n					                    required>\n									<div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\">\n										<p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"register.messages.validate.lastName.required\">\n					                    	Last name is required.\n					                    </p>\n									</div>     \n			            		</div>\n			            	</div>\n			            	\n			            	<div class=\"clearfix\"></div>\n			            	\n							 <div class=\"col-md-6 col-sm-6\">\n							 	<div class=\"row\">\n							 		<div class=\"col-md-12\">\n							 			<label for=\"dateOfBirth\" translate=\"register.form.dateOfBirth\">Date of Birth</label>\n			            				<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n							 		</div>\n							 		<div class=\"col-md-12\">\n										 <div class=\"form-group\">\n											<input type=\"text\" class=\"date-time-drop-down\" id=\"dateOfBirth\" name=\"dateOfBirth\" data-format=\"DD-MM-YYYY\" \n											data-template=\"D MMM YYYY\" ng-model=\"vm.registerAccount.dateOfBirth\" day-name=\"dayOfBirth\" month-name=\"monthOfBirth\" \n											year-name=\"yearOfBirth\" rsmdatedropdowns/>\n											<div class=\"col-md-12\" ng-show=\"(form.dayOfBirth.$dirty && form.dayOfBirth.$invalid)\n															|| (form.monthOfBirth.$dirty && form.monthOfBirth.$invalid)\n															|| (form.yearOfBirth.$dirty && form.yearOfBirth.$invalid)\">\n												<p class=\"help-block\" translate=\"register.messages.validate.dateOfBirth.required\">\n													Date of birth is required.\n												</p>\n											</div> \n										 </div>\n									 </div>\n							 	</div> \n			            	</div>	\n			            	\n							 <div class=\"col-md-6 col-sm-6\">\n			            		<div class=\"form-group\">\n			            			<label for=\"phone\" translate=\"register.form.phone\">Mobile or Primary Phone #</label>\n			            			<span class=\"glyphicon\" aria-hidden=\"true\"></span>\n			            			<input type=\"tel\" pattern=\"[0-9]*\" class=\"form-control\" \n					                	id=\"phone\" \n					                    name=\"phone\" \n					                    ng-model=\"vm.registerAccount.phone\" \n					                    phone-input>\n					                <div ng-show=\"vm.phoneExists !== null\">\n                                        <p class=\"help-block\">\n                                            {{ \'register.messages.error.phoneExists\' | translate}}\n                                        </p>\n                                    </div>\n			            		</div>\n			            	</div>				            	\n							\n							<div class=\"clearfix\"></div>\n							\n			            	<div class=\"col-md-6 col-sm-6\">\n			            		<div class=\"form-group\">\n			            			<label for=\"email\" translate=\"register.form.email\">E-mail</label>\n			            			<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n			            			<input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" ng-pattern=\"constants.EMAIL_PATTERN\"\n				                           ng-model=\"vm.registerAccount.email\" ng-minlength=5 ng-maxlength=100\n				                           required>\n				                    <div ng-show=\"form.email.$dirty && form.email.$invalid\">\n				                        <p class=\"help-block\"\n				                               ng-show=\"form.email.$error.email || form.email.$error.pattern\" translate=\"global.messages.validate.email.invalid\">\n				                            Your e-mail is invalid.\n				                        </p>\n				                        <p class=\"help-block\"\n				                               ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">\n				                            Your e-mail is required to be at least 5 characters.\n				                        </p>\n				                        <p class=\"help-block\"\n				                               ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">\n				                            Your e-mail cannot be longer than 100 characters.\n				                        </p>\n				                        <p class=\"help-block\"\n				                               ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">\n				                            Your e-mail required.\n				                        </p>\n				                    </div>\n				                    <div ng-show=\"!form.email.$error.required && vm.errorEmailExists !== null\">\n					                    <p class=\"help-block\" translate=\"register.messages.error.emailexists\">\n					                	</p>\n					                </div>   \n			            		</div>\n			            	</div>\n			            	\n			            	<div class=\"col-md-6 col-sm-6\">\n			            		<div class=\"form-group\">\n			            			<label for=\"confirmEmail\" translate=\"register.form.confirmEmail\">E-mail</label>\n			            			<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n			            			<input type=\"email\" class=\"form-control\" id=\"confirmEmail\" name=\"confirmEmail\" ng-pattern=\"constants.EMAIL_PATTERN\"\n				                           ng-model=\"vm.registerAccount.confirmEmail\" ng-minlength=5 ng-maxlength=100 confirm-password-check=\"email\" required>\n				                    <div ng-show=\"form.confirmEmail.$dirty && form.confirmEmail.$invalid\">\n				                        <p class=\"help-block\" ng-show=\"form.confirmEmail.$error.pwmatch\" translate=\"register.messages.error.emailDontMatch\">\n							                The email and its confirmation do not match!\n							            </p>\n							            <p class=\"help-block\" ng-show=\"form.confirmEmail.$error.required\" translate=\"global.messages.validate.email.confirmrequire\">\n							                The confirm email is required.\n							            </p>\n				                    </div>	  \n			            		</div>\n			            	</div>\n			            	\n			            	<div class=\"clearfix\"></div>\n			            	\n			            	<div class=\"col-md-6 col-sm-6\">\n			            		<div class=\"form-group\">\n			            			<label for=\"password\" translate=\"register.form.password\">New password</label>\n			            			<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n			            			<input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\"\n				                           ng-model=\"vm.registerAccount.password\" ng-minlength=5 ng-maxlength=50 required>\n				                    <div ng-show=\"form.password.$dirty && form.password.$invalid\">\n				                        <p class=\"help-block\"\n				                               ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">\n				                            Your password is required.\n				                        </p>\n				                        <p class=\"help-block\"\n				                               ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">\n				                            Your password is required to be at least 5 characters.\n				                        </p>\n				                        <p class=\"help-block\"\n				                               ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">\n				                            Your password cannot be longer than 50 characters.\n				                        </p>\n				                    </div>						   \n			            		</div>\n			            	</div>\n			            	\n			            	 <div class=\"col-md-6 col-sm-6\">\n			            		<div class=\"form-group\">\n			            			<label for=\"confirmPassword\" translate=\"register.form.confirmPassword\">New password confirmation</label>\n			            			<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n			            			<input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\"\n				                           ng-model=\"vm.confirmPassword\" ng-minlength=5 ng-maxlength=50 confirm-password-check=\"password\">\n				                    <div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\">\n				                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.pwmatch\" translate=\"global.messages.error.dontmatch\">\n							                	The password and its confirmation do not match!\n							            </p>\n				                    </div>									   \n			            		</div>\n			            	</div>				                    				            \n							\n							<div class=\"clearfix\"></div>\n							\n							<div class=\"col-md-6 col-sm-6\" ng-if=\"vm.isShowInjured\">\n						      	<p>\n									<label for=\"injuredTitle\" translate=\"register.form.injured.title\">What is your injured body part?</label>\n									<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n									<div ng-repeat=\"injuredType in vm.injuredTypes\">\n							            <label for=\"injuredType_{{$index}}\">\n							                <input id=\"injuredType_{{$index}}\" type=\"checkbox\" ng-model=\"injuredType.checked\" ng-disabled=\"injuredType.disabled\" ng-change=\"vm.selectedInjuredTypes(injuredType)\"/>\n							                {{injuredType.name | translate}}\n							            </label>\n							        </div>\n									<select class=\"form-control\"\n									   name=\"injuredType\"\n									   ng-model=\"vm.registerAccount.injuredType\"\n									   id=\"injuredType\"\n									   ng-options=\"injuredType.value as injuredType.name | translate for injuredType in vm.injuredTypes\"\n									   required>\n									   <option value=\"\" selected></option>\n									</select>\n								</p>						      						      						      						       \n						    </div>\n			                \n			                <div class=\"col-md-12 col-sm-12 col-xs-12 voffset5\">\n								<div class=\"form-group\">\n									<button type=\"submit\" ng-disabled=\"form.$invalid || vm.registerAccount.injuredTypes.length === 0\" class=\"btn btn-primary\" translate=\"register.form.button\">Register</button>\n				                </div>\n			                </div>				            				            				            	\n			            </form>\n			    	</div>\n		        </div>\n		    </div>\n		</div>\n	</div>\n</div> -->");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"settings.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"settings.messages.error.fail\"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/account/sessions/sessions.html","<div><h2 translate=\"sessions.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"sessions.messages.success\"><strong>Session invalidated!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"sessions.messages.error\"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"sessions.table.ipaddress\">IP Address</th><th translate=\"sessions.table.useragent\">User agent</th><th translate=\"sessions.table.date\">Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"session in vm.sessions\"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.formattedTokenDate}}</td><td><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.invalidate(session.series)\" translate=\"sessions.table.button\">Invalidate</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(page)\"></uib-pagination></div></div>");
$templateCache.put("app/admin/coc-agreement/coc-agreement-management.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"cocAgreement.home.title.management\"></div><form name=\"submitForm\" role=\"form\" novalidate><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3\"><label translate=\"cocAgreement.home.managementPage.patientChartNumbers\">Patient Chart Numbers</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12\"><p><em translate=\"cocAgreement.home.managementPage.text1\">Enter patient chart numbers you\'d like to invite to fill out the CoC, one per line.</em></p></div></div><div class=\"row\"><!-- Input Area --><div class=\"col-md-4 col-sm-8 col-xs-12\"><textarea class=\"form-control auto-height none-resize\" rows=\"10\" name=\"chartNumbersValue\" id=\"chartNumbersValue\" ng-model=\"vm.chartNumbersValue\" ng-required=\"true\"></textarea></div><!-- Notify Area --><div class=\"col-md-6 col-sm-8 col-xs-12\"><!-- Success Singular --><coc-notify-component ng-if=\"vm.isAddedSuccess && vm.numberAddedSuccess === 1\" patient-ids=\"vm.patientIdAddSuccesses\" text-notify=\"\'cocAgreement.home.managementPage.success.addedSingular\'\" type=\"\'success\'\" values=\"vm.numberAddedSuccess\"></coc-notify-component><!-- Success plural --><coc-notify-component ng-if=\"vm.isAddedSuccess && vm.numberAddedSuccess > 1\" patient-ids=\"vm.patientIdAddSuccesses\" text-notify=\"\'cocAgreement.home.managementPage.success.addedPlural\'\" type=\"\'success\'\" values=\"vm.numberAddedSuccess\"></coc-notify-component><!-- Error --><div ng-if=\"vm.haveError\"><!-- Not Found --><coc-notify-component ng-if=\"vm.havePatientIdNotFounds\" patient-ids=\"vm.patientIdNotFounds\" text-notify=\"\'cocAgreement.home.managementPage.error.patientNotFound\'\" type=\"\'error\'\"></coc-notify-component><!-- Already In List Singular --><coc-notify-component ng-if=\"vm.havePatientIdSents && vm.patientIdSents.length === 1\" patient-ids=\"vm.patientIdSents\" text-notify=\"\'cocAgreement.home.managementPage.error.patientSentSingular\'\" type=\"\'error\'\"></coc-notify-component><!-- Already In List Plural --><coc-notify-component ng-if=\"vm.havePatientIdSents && vm.patientIdSents.length > 1\" patient-ids=\"vm.patientIdSents\" text-notify=\"\'cocAgreement.home.managementPage.error.patientSentPlural\'\" type=\"\'error\'\"></coc-notify-component><!-- None Provider Singular --><coc-notify-component ng-if=\"vm.havePatientIdNoneProviders && vm.patientIdNoneProviders.length === 1\" patient-ids=\"vm.patientIdNoneProviders\" text-notify=\"\'cocAgreement.home.managementPage.error.patientNoneProviderSingular\'\" type=\"\'error\'\"></coc-notify-component><!-- None Provider Plural --><coc-notify-component ng-if=\"vm.havePatientIdNoneProviders && vm.patientIdNoneProviders.length > 1\" patient-ids=\"vm.patientIdNoneProviders\" text-notify=\"\'cocAgreement.home.managementPage.error.patientNoneProviderPlural\'\" type=\"\'error\'\"></coc-notify-component></div></div></div><div class=\"row\"><div class=\"col-md-12 voffset3\"><button type=\"button\" ng-disabled=\"submitForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.sendInvitations()\"><span translate=\"cocAgreement.home.managementPage.button.sendInvitations\">Send</span></button></div></div></form></div></div></div>");
$templateCache.put("app/admin/completion-reports/completion-reports.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.patient.report.completion.title\">Import Patients</div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.patient.report.completion.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.patient.report.completion.errors.fromDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.patient.report.completion.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.patient.report.completion.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing\" ng-click=\"vm.report()\" translate=\"ipmApp.patient.report.completion.button.generateReport\" class=\"btn btn-info\">Generate Report</button></div></div></div></div></div></div></div></form>");
$templateCache.put("app/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/frp-mde-reports/frp-mde-reports.html","<form name=\"reportForm\" role=\"form\" novalidate><div class=\"page page--user-management\"><div ng-show=\"vm.isProcessing==true\" id=\"page-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.patient.report.frpMde.title\">FRP/MDE Reports Download</div><br><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fromDate\">From Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.fromDate.$dirty && reportForm.fromDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.required\" translate=\"ipmApp.patient.report.frpMde.errors.fromDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.fromDate.$error.datetime\" translate=\"ipmApp.patient.report.frpMde.errors.fromDate.invalid\">This field is invalid.</p></div><div ng-show=\"vm.inValidDates\"><p class=\"help-block\" translate=\"ipmApp.patient.report.frpMde.errors.fromDateToDate.invalid\">From Date must be less than the To Date.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_toDate\">To Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\" enable-time=\"false\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"reportForm.toDate.$dirty && reportForm.toDate.$invalid\"><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.required\" translate=\"ipmApp.patient.report.frpMde.errors.toDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"reportForm.toDate.$error.datetime\" translate=\"ipmApp.patient.report.frpMde.errors.toDate.invalid\">This field is invalid.</p></div></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><button type=\"button\" id=\"reportBtn\" ng-disabled=\"reportForm.$invalid || vm.isProcessing || vm.inValidDates\" ng-click=\"vm.report()\" translate=\"ipmApp.patient.report.frpMde.button.downloadReport\" class=\"btn btn-info\">Download</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"vm.noPdf\"><p class=\"help-block\" translate=\"error.noPdf\">There is no PDF</p></div></div></div></div></div></form>");
$templateCache.put("app/admin/logs/logs.html","<div><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("app/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.ehcache.title\">Ehcache statistics</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.ehcache.cachename\">Cache name</th><th class=\"text-right\" translate=\"metrics.ehcache.objects\">Objects</th><th class=\"text-right\" translate=\"metrics.ehcache.hits\">Hits</th><th class=\"text-right\" translate=\"metrics.ehcache.misses\">Misses</th><th class=\"text-right\" translate=\"metrics.ehcache.evictioncount\">Eviction count</th><th class=\"text-right\" translate=\"metrics.ehcache.mean\">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.cachesStats\" ng-once><td>{{v.name}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/patient-import/patient-import.html","<div class=\"page page--user-management\"><div ng-show=\"vm.isSaving==true\" id=\"patient-import-loader\"></div><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.patient.import.title\">Import Patients</div><br><div><p class=\"help-block\">This feature is not available.</p></div><button type=\"button\" id=\"fileImport\" ng-disabled=\"true\" translate=\"ipmApp.patient.import.button.label\" class=\"btn btn-info\" ngf-select ngf-change=\"vm.importPatient($files)\" accept=\".csv\" ngf-multiple=\"false\">Select a file to import</button><br><br><div ng-show=\"vm.isNotCsvFile\"><p class=\"help-block\" translate=\"ipmApp.patient.import.error.notCsvFile\">Please select a csv file to import !</p></div><div ng-show=\"vm.isError\"><p class=\"help-block\" translate=\"ipmApp.patient.import.error.notify\">There is an error while importing !</p></div><div ng-show=\"vm.numPatientsCreated || vm.numPatientsUpdated\"><p translate=\"ipmApp.patient.import.numCreated\" translate-values=\"{param: \'{{vm.numPatientsCreated}}\'}\"></p><p translate=\"ipmApp.patient.import.numUpdated\" translate-values=\"{param: \'{{vm.numPatientsUpdated}}\'}\"></p></div><div ng-show=\"vm.errorImportInfo\"><div class=\"h4 title\" translate=\"ipmApp.patient.import.error.header\">No records were imported. There was an error processing the selected file. Please see the list of errors below for details:</div><br><div ng-show=\"vm.errorNumMore\" translate=\"ipmApp.patient.import.error.inforMore100\" translate-values=\"{number: \'{{vm.errorNumMore}}\'}\"></div><div ng-repeat=\"error in vm.errorImportInfo\" translate=\"ipmApp.patient.import.error.infoRow\" translate-values=\"{columnName: \'{{error.split(\';\')[1]}}\', row: \'{{error.split(\';\')[0]}}\'}\"></div></div></div></div></div>");
$templateCache.put("app/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"userManagement.delete.title\">Confirm delete operation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management-detail.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"table table-striped\"><tbody><tr><td><span translate=\"userManagement.firstName\">FirstName</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.firstName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastName\">LastName</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.role\">Role</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{\'userManagement.authorities.\' + vm.user.authorities[0] | translate}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.email\">Email</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.email}}\" readonly=\"readonly\"></td></tr><tr ng-if=\"vm.isPatient === true\"><td><span translate=\"userManagement.phone\">Mobile or Primary Phone #</span></td><td><input type=\"text\" class=\"input-sm form-control\" phone-input ng-model=\"vm.user.phone\" readonly=\"readonly\"></td></tr><tr ng-if=\"vm.isPatient === true\"><td><span translate=\"userManagement.office\">Office</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.officeName}}\" readonly=\"readonly\"></td></tr><tr ng-if=\"vm.isPatient === true\"><td><span translate=\"userManagement.providerName\">Provider\'s Name</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.providerName}}\" readonly=\"readonly\"></td></tr><tr ng-if=\"vm.isPatient === true\"><td><span translate=\"userManagement.dateOfBirth\">Date of Birth</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.dateOfBirth | date: \'MM/dd/yyyy\'}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.langKey\">LangKey</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{\'userManagement.languages.\' + vm.user.langKey | translate}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.createdBy\">CreatedBy</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.createdBy}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.createdDate\">CreatedDate</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.createdDate | date:\'MM/dd/yyyy HH:mm\' }}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastModifiedBy\">LastModifiedBy</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastModifiedBy}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastModifiedDate\">LastCreatedDate</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastModifiedDate | date:\'MM/dd/yyyy HH:mm\'}}\" readonly=\"readonly\"></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.backToList()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myUserLabel\">{{vm.title | translate}}</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"userManagement.firstName\">FirstName</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"firstName\" required ng-disabled=\"vm.isBiller\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$dirty && editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.required\" translate=\"userManagement.firstName.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.middleName\">Middle Name</label><input type=\"text\" class=\"form-control\" name=\"middleName\" ng-model=\"vm.user.middleName\" ng-maxlength=\"50\" ng-disabled=\"vm.isBiller\"><div ng-show=\"editForm.middleName.$dirty && editForm.middleName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.middleName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">LastName</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"lastName\" required ng-model=\"vm.user.lastName\" ng-maxlength=\"50\" ng-disabled=\"vm.isBiller\"><div ng-show=\"editForm.lastName.$dirty && editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.required\" translate=\"userManagement.lastName.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div ng-if=\"!vm.patientDetailEditState\" class=\"form-group\" has-any-authority=\"ROLE_ADMIN\"><label translate=\"userManagement.role\">Role</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"authority\" id=\"authority\" ng-model=\"vm.user.authorities\" ng-change=\"vm.roleChange()\" ng-options=\"auth as \'userManagement.authorities.\'+auth | translate for auth in vm.authorities track by auth\" ng-required=\"true\" ng-disabled=\"vm.disabledRole===true\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.authority.$dirty && editForm.authority.$invalid\"><p class=\"help-block\" ng-show=\"editForm.authority.$error.required\" translate=\"userManagement.role.required\">This field is required.</p></div></div><!--Role QHP--><div class=\"form-group\" ng-if=\"vm.isQHPRole\"><qhp-tasks tasks=\"vm.qhpUserDetail.tasks\" on-change=\"vm.qhpTasksOnChange(tasks)\"></qhp-tasks><!--credentials--><div class=\"form-group\"><label translate=\"userManagement.tasks.credentials\">Credentials</label><input type=\"text\" placeholder=\"{{\'userManagement.tasks.credentials.placeholder\' | translate}}\" class=\"form-control\" name=\"credentials\" id=\"credentials\" ng-model=\"vm.qhpUserDetail.credentials\" ng-maxlength=\"255\"></div><multi-frp-programs ng-if=\"vm.checkTaskFRP(vm.qhpUserDetail.tasks)\" frp-programs=\"vm.frpPrograms\" selected-frp-programs=\"vm.qhpUserDetail.frpPrograms\" translate-key=\"\'userManagement.frpPrograms\'\" form-reference=\"editForm\"></multi-frp-programs></div><!--Role Staff--><div class=\"form-group\" ng-if=\"vm.isStaffRole\"><qhp-tasks role=\"vm.roleStaff\" tasks=\"vm.staffUserDetail.tasks\" on-change=\"vm.staffTasksOnChange(tasks)\"></qhp-tasks><multi-frp-programs ng-if=\"vm.checkTaskFRP(vm.staffUserDetail.tasks)\" frp-programs=\"vm.frpPrograms\" selected-frp-programs=\"vm.staffUserDetail.frpPrograms\" translate-key=\"\'userManagement.frpPrograms\'\" form-reference=\"editForm\"></multi-frp-programs></div><div class=\"form-group\"><label translate=\"userManagement.email\">Email</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"email\" class=\"form-control\" name=\"email\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-disabled=\"(vm.account.authorities.indexOf(\'ROLE_ADMIN\') !== -1 && vm.account.email === vm.user.email && vm.user.id !== null) || vm.isBiller\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$dirty && editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"userManagement.email.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email || editForm.email.$error.pattern\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div><div ng-show=\"!editForm.email.$invalid && vm.errorEmailExists\"><p class=\"help-block\" translate=\"error.emailexists\">E-mail is already in use!</p></div></div><div class=\"form-group\" ng-if=\"vm.isPatientRole===true || vm.isAllowEdit===true\"><label translate=\"ipmApp.patient.turnOffEmail\" class=\"mr-3\">Turn Off Email</label><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.user.ignoreSendEmail}\" ng-click=\"vm.changeIgnoreEmail()\" ng-disabled=\"vm.isBiller\"></button></div><div class=\"form-group\" ng-if=\"vm.isPatientRole===true || vm.isAllowEdit===true\"><label translate=\"userManagement.phone\">Mobile or Primary Phone #</label><span class=\"glyphicon\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"phone\" phone-input ng-model=\"vm.user.phone\" ng-maxlength=\"100\" ng-disabled=\"vm.isBiller\"><div ng-show=\"!editForm.phone.$invalid && vm.errorPhoneExists\"><p class=\"help-block\" translate=\"error.phoneExists\">Mobile or Primary Phone # is already in use!</p></div></div><div class=\"form-group\" ng-if=\"vm.isPatientRole===true || vm.isAllowEdit===true\"><label translate=\"ipmApp.patient.turnOffSms\" class=\"mr-3\">Turn Off SMS</label><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.user.ignoreSendSms}\" ng-click=\"vm.changeIgnoreSendSms()\" ng-disabled=\"vm.isBiller\"></button></div><div class=\"form-group\" ng-if=\"vm.user.id === null\"><label for=\"password\" translate=\"userManagement.password\">Password</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" ng-model=\"vm.user.password\" ng-minlength=\"5\" ng-maxlength=\"50\" required ng-disabled=\"vm.isBiller\"><div ng-show=\"editForm.password.$dirty && editForm.password.$invalid\"><p class=\"help-block\" ng-show=\"editForm.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"editForm.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"editForm.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.user.id === null\"><label for=\"confirmPassword\" translate=\"userManagement.confirmPassword\">New password confirmation</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" confirm-password-check=\"password\" ng-disabled=\"vm.isBiller\"><div ng-show=\"editForm.confirmPassword.$dirty && editForm.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"editForm.confirmPassword.$error.pwmatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</p></div></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">LangKey</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as \'userManagement.languages.\'+language | translate for language in vm.languages track by language\" required ng-disabled=\"vm.isBiller\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.langKey.$dirty && editForm.langKey.$invalid\"><p class=\"help-block\" ng-show=\"editForm.langKey.$error.required\" translate=\"userManagement.langKey.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.isPatientRole===true || vm.isAllowEdit===true\"><label translate=\"userManagement.patientId\">Patient ID</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientId\" required ng-model=\"vm.user.patientIdCode\" ng-maxlength=\"50\" ng-disabled=\"vm.isBiller\"><div ng-show=\"editForm.patientId.$dirty && editForm.patientId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.patientId.$error.required\" translate=\"userManagement.patientId.required\">This field is required.</p></div><div ng-show=\"!editForm.patientId.$invalid && vm.errorPatientID\"><p class=\"help-block\" translate=\"error.patientCodeExists\">Patient ID is already in use!</p></div></div><div class=\"form-group\" ng-if=\"vm.isPatientRole===true || vm.isAllowEdit===true\"><label translate=\"userManagement.dateOfBirth\">Date of Birth</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"form-group\"><div class=\"input-group\"><input id=\"dateOfBirth\" type=\"text\" class=\"form-control\" name=\"dateOfBirth\" uib-datepicker-popup=\"MM/dd/yyyy\" required ng-model=\"vm.user.dateOfBirth\" is-open=\"vm.datePickerOpenStatus.dateOfBirth\" ng-disabled=\"vm.isBiller\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateOfBirth\')\"></span></div></div></div><div ng-show=\"(editForm.dateOfBirth.$dirty && editForm.dateOfBirth.$invalid) || vm.birthdayInvalid\"><p class=\"help-block\" ng-show=\"editForm.dateOfBirth.$error.required\" translate=\"userManagement.dateOfBirth.required\">This field is required.</p><p class=\"help-block\" ng-show=\"!editForm.dateOfBirth.$error.required && (editForm.dateOfBirth.$error.date || vm.birthdayInvalid)\" translate=\"userManagement.dateOfBirth.error\">Date of Birth is invalid.</p></div></div><div class=\"form-group\" ng-if=\"vm.isPatientRole===true || vm.isAllowEdit===true\"><label translate=\"userManagement.office\">Office</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"officeId\" id=\"officeId\" ng-model=\"vm.user.officeId\" required ng-disabled=\"vm.isBiller\" ng-options=\"o.id as o.name for o in vm.offices\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.officeId.$dirty && editForm.officeId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.officeId.$error.required\" translate=\"userManagement.office.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.isPatientRole===true || vm.isAllowEdit===true\"><label translate=\"userManagement.providerName\">Provider\'s Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"providerId\" id=\"providerId\" ng-model=\"vm.user.providerId\" required ng-disabled=\"vm.isBiller\" ng-options=\"p.id as p.titleFullName for p in vm.providers\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.providerId.$dirty && editForm.providerId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.providerId.$error.required\" translate=\"userManagement.providerName.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.isPatientRole === true || vm.isAllowEdit === true\"><patient-case-table ng-if=\"vm.user\" is-allow-action=\"vm.isAllowActionPatientCase\" is-update-billable=\"vm.checkUpdateBillablePatientCase()\" patient-id=\"vm.user.patientId\" patient-cases=\"vm.patientCases\" patient-case-ids-remove=\"vm.patientCaseIdsRemove\"></patient-case-table></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || !vm.validateRoleTasks()\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"userManagement.home.title\">Users</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3 has-feedback-left\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'userManagement.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search():0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></div><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"u.firstName\">{{\'userManagement.firstName\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"u.lastName\">{{\'userManagement.lastName\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"a.name\">{{\'userManagement.role\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"u.login\">{{\'userManagement.username\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th>{{\'userManagement.createdBy\' | translate}}</th><th>{{\'userManagement.lastModifiedDate\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ \'userManagement.authorities.\' + authority | translate }}</span></div></td><td>{{user.login}}</td><td>{{user.createdBy}}</td><td>{{user.lastModifiedDate | date:\'MM/dd/yyyy HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.goToUserDetails(user.id)\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({id:user.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({id:user.id})\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.currentAccount.login!==user.login\" ng-disabled=\"vm.checkDisableDeleted(user)\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button> <button type=\"submit\" disabled=\"disabled\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.currentAccount.login===user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/agreements-workflow/agreements-acknowledgment/agreements-acknowledgment.html","<p translate=\"ipmApp.agreements.acknowledgment.dear\">Dear</p><div translate=\"ipmApp.agreements.acknowledgment.thank\">Thank you</div><div translate=\"ipmApp.agreements.acknowledgment.insurances\">Private Insurances</div><div translate=\"ipmApp.agreements.acknowledgment.hmo\">HMO</div><div translate=\"ipmApp.agreements.acknowledgment.ppo\">PPO</div><p translate=\"ipmApp.agreements.acknowledgment.woker\">Worker’s Compensation</p><p translate=\"ipmApp.agreements.acknowledgment.title\" class=\"bold\">Acknowledgment of Assignment of Benefits and Financial Responsibility</p><p translate=\"ipmApp.agreements.acknowledgment.text1\">text1</p><p translate=\"ipmApp.agreements.acknowledgment.text2\">text2</p><p translate=\"ipmApp.agreements.acknowledgment.text3\">text3</p><h5 class=\"text-center mt-4\" translate=\"ipmApp.agreements.acknowledgment.general\">general</h5><ul class=\"bullet bullet-check bold mb-4\"><li translate=\"ipmApp.agreements.acknowledgment.policies1\">policies1</li><li translate=\"ipmApp.agreements.acknowledgment.policies2\">policies2</li><li translate=\"ipmApp.agreements.acknowledgment.policies3\">policies3</li><li translate=\"ipmApp.agreements.acknowledgment.policies4\">policies4</li><li translate=\"ipmApp.agreements.acknowledgment.policies5\">policies5</li><li translate=\"ipmApp.agreements.acknowledgment.policies6\">policies6</li></ul><div translate=\"ipmApp.agreements.acknowledgment.text4\">text4</div><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.namePrint\">Patient Name (Print)</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"ipmApp.agreements.patient.name.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"agreementForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form>");
$templateCache.put("app/agreements-workflow/agreements-consent-treat/agreements-consent-treat.html","<!-- <div class=\"h4 bold text-center mb-4 mt-5\">\n	<span translate=\"ipmApp.agreements.consentTreat.title\">Consent for Treatment</span>\n</div> --><p translate=\"ipmApp.agreements.consentTreat.consentTreatment\" class=\"bold\">Consent for Treatment</p><p translate=\"ipmApp.agreements.consentTreat.consentTreatmentText\">[consentTreatmentText]</p><p translate=\"ipmApp.agreements.consentTreat.telehealth\" class=\"bold\">Telehealth Services</p><p translate=\"ipmApp.agreements.consentTreat.telehealthText\">[telehealthText]</p><p translate=\"ipmApp.agreements.consentTreat.communication\" class=\"bold\">Communication with Me</p><p translate=\"ipmApp.agreements.consentTreat.communicationText\">[communicationText]</p><p translate=\"ipmApp.agreements.consentTreat.communicationPreferences\" class=\"bold\">Communication Preferences</p><p translate=\"ipmApp.agreements.consentTreat.communicationPreferencesText\" style=\"white-space: pre-line\">[communicationPreferencesText]</p><p translate=\"ipmApp.agreements.consentTreat.aiScribe\" class=\"bold\">Use of AI Scribe Technology</p><p translate=\"ipmApp.agreements.consentTreat.aiScribeText\">[aiScribeText]</p><p translate=\"ipmApp.agreements.consentTreat.photos\" class=\"bold\">Photos/Video for Care Purposes</p><p translate=\"ipmApp.agreements.consentTreat.photosText\">[photosText]</p><p translate=\"ipmApp.agreements.consentTreat.privacy\" class=\"bold\">Privacy and Information Sharing</p><p translate=\"ipmApp.agreements.consentTreat.privacyText\">[privacyText]</p><p translate=\"ipmApp.agreements.consentTreat.payment\" class=\"bold\">Guarantee of Payment</p><p translate=\"ipmApp.agreements.consentTreat.paymentText\">[paymentText]</p><p style=\"margin-left: 3em\"><span class=\"bold\" translate=\"ipmApp.agreements.consentTreat.workersCompensation\">California Workers\' Compensation Patients:</span> <span translate=\"ipmApp.agreements.consentTreat.workersCompensationText\">[workersCompensationText]</span></p><p translate=\"ipmApp.agreements.consentTreat.patientRights\" class=\"bold\">Patient Rights and Responsibilities</p><p translate=\"ipmApp.agreements.consentTreat.patientRightsText\">[patientRightsText]</p><p translate=\"ipmApp.agreements.consentTreat.affirmation\" class=\"bold\">Affirmation</p><p translate=\"ipmApp.agreements.consentTreat.affirmationText\">[affirmationText]</p><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.parentGuardianPrint\">Patient/Parent/Guardian Name (Print)</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"ipmApp.agreements.patient.name.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"agreementForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form>");
$templateCache.put("app/agreements-workflow/agreements-continuity-of-care/agreements-continuity-of-care.html","<div class=\"h4 bold text-center mb-1\"><p translate=\"ipmApp.agreements.continuityOfCare.title\">Continuity of Care</p></div><p translate=\"ipmApp.agreements.continuityOfCare.text1\" translate-values=\"{docterName: \'{{vm.agreement.doctorName}}\'}\"></p><p translate=\"ipmApp.agreements.continuityOfCare.text2\"></p><p translate=\"ipmApp.agreements.continuityOfCare.text3\"></p><p translate=\"ipmApp.agreements.continuityOfCare.text4\"></p><p translate=\"ipmApp.agreements.continuityOfCare.text5\" translate-values=\"{docterName: \'{{vm.agreement.doctorName}}\'}\"></p><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row\"><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"agreementForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></div></form>");
$templateCache.put("app/agreements-workflow/agreements-narcotics/agreements-narcotics.html","<!-- Start STEP agreementsOpioidMonograph--><agreements-opioid-monograph agreement=\"vm.agreement\"></agreements-opioid-monograph><!-- End STEP agreementsOpioidMonograph--><!-- Start STEP agreementsNarcotics--><div class=\"h4 bold text-center mb-4 mt-5\"><span translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.title\">Narcotics Agreement</span></div><p translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q1\">Q1</p><p translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q2\"></p><p translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3\">Q3</p><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><ul class=\"bullet bullet-decimal-privacy\"><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.1\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.2\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.3\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.4\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.5\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.6\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.7\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.8\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.9\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.10\"></li><li translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.11\"></li><li><span translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.Q3.12\" for=\"q12\"></span> <input class=\"form-check-input-v4 ml-2\" type=\"checkbox\" name=\"q12\" ng-model=\"vm.agreement.ignorePrescribedControlledSubstances\"></li></ul><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.patientName\">Patient Name (Print)</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\" value=\"{{vm.agreement.patientName}}\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"ipmApp.agreements.npqWorkflowNarcoticsAgreement.patientName.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input type=\"checkbox\" ng-model=\"vm.agreement.agree\" class=\"form-check-input-v4\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"agreementForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form><!-- End STEP agreementsNarcotics-->");
$templateCache.put("app/agreements-workflow/agreements-notice-patients/agreements-notice-patients.html","<div class=\"h4 bold text-center mb-4 pt-5\"><span translate=\"ipmApp.agreements.noticePatients.title\">Notice to patients regarding BoomerangHC referral to physical therapy, pain psychology, and the Functional Restoration Programs</span></div><p class=\"mb-4\" translate=\"ipmApp.agreements.noticePatients.R.1\">Dear BoomerangHC Patient:</p><p class=\"text-justify\" translate=\"ipmApp.agreements.noticePatients.R.2\">Your BoomerangHC treating physician may refer you, if necessary, for various treatments including physical therapy, pain psychology, and functional restoration. Sometimes you may be referred to pain clinicians for these treatments who are employees or partners in Boomerang Healthcare. Sometimes you may be referred to pain clinicians outside of Boomerang Healthcare.</p><p class=\"text-justify\" translate=\"ipmApp.agreements.noticePatients.R.3\">If you are referred to an BoomerangHC employee for such treatment, I am legally required to explain to you that I (your BoomerangHC treating physician) am a part owner of Boomerang Healthcare, which means that I receive a part of the profits of the program and/or pain clinician that I am referring you to. I also want you to know that I do not get paid anything extra for having referred you to an BoomerangHC pain clinician/program. I will refer you for additional treatment only when I think you need the treatment and it is medically necessary and indicated.</p><p class=\"text-justify\" translate=\"ipmApp.agreements.noticePatients.R.4\">You are free to get your treatment elsewhere (outside of Boomerang Healthcare and its employees and programs) if you wish. All referrals for treatment, whether to BoomerangHC employees, BoomerangHC independent contractors or to outside clinicians are subject to insurance authorization and restrictions that may apply to your situation.</p><p class=\"mb-5 text-justify\" translate=\"ipmApp.agreements.noticePatients.R.5\">Please let me know if you have any questions about this and I will be happy to discuss them with you.</p><p class=\"mb-4\" translate=\"ipmApp.agreements.noticePatients.R.6\">Sincerely,</p><div class=\"mb-3 pt-3\" translate=\"ipmApp.agreements.noticePatients.R.7\">Your BoomerangHC Treating Physician</div>");
$templateCache.put("app/agreements-workflow/agreements-opioid-monograph/agreements-opioid-monograph.html","<div class=\"h4 bold text-center mb-4\"><span translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.title\">Opioid Monograph</span></div><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q1\">Q1</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q2\">Q2</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q3\">Q3</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q4\">Q4</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q5\">Q5</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q6\">Q6</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q7\">Q7</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q8\">Q8</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q9\">Q9</p><p translate=\"ipmApp.agreements.npqWorkflowOpioiMonograph.Q10\">Q10</p>");
$templateCache.put("app/agreements-workflow/agreements-patient-rights/agreements-patient-rights.html","<div class=\"h4 bold text-center mb-4 mt-5\"><span translate=\"ipmApp.agreements.patientRights.title\">PATIENT RIGHTS AND RESPONSIBILITIES</span></div><p translate=\"ipmApp.agreements.patientRights.intro\">[patientRightsIntro]</p><div style=\"height: 2px; background-color: #b0b0b0; width: 100%; margin: 20px 0\"></div><p translate=\"ipmApp.agreements.patientRights.yourRights\" class=\"bold\">Your Rights as a Patient</p><p translate=\"ipmApp.agreements.patientRights.yourRights.1\" class=\"bold\">Right to Fair Treatment</p><p translate=\"ipmApp.agreements.patientRights.yourRights.1.text\">[yourRights1Text]</p><p translate=\"ipmApp.agreements.patientRights.yourRights.2\" class=\"bold\">Right to Safe and Quality Care</p><p translate=\"ipmApp.agreements.patientRights.yourRights.2.text\">[yourRights2Text]</p><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.patientRights.yourRights.2.1\"></li><li translate=\"ipmApp.agreements.patientRights.yourRights.2.2\"></li><li translate=\"ipmApp.agreements.patientRights.yourRights.2.3\"></li><li translate=\"ipmApp.agreements.patientRights.yourRights.2.4\"></li><li translate=\"ipmApp.agreements.patientRights.yourRights.2.5\"></li><li translate=\"ipmApp.agreements.patientRights.yourRights.2.6\"></li><li translate=\"ipmApp.agreements.patientRights.yourRights.2.7\"></li></ul><p translate=\"ipmApp.agreements.patientRights.yourRights.3\" class=\"bold\">Right to Privacy</p><p translate=\"ipmApp.agreements.patientRights.yourRights.3.text\">[yourRights3Text]</p><div style=\"height: 2px; background-color: #b0b0b0; width: 100%; margin: 20px 0\"></div><p translate=\"ipmApp.agreements.patientRights.responsibilities\" class=\"bold\">Your Responsibilities and Code of Conduct</p><p translate=\"ipmApp.agreements.patientRights.responsibilities.text\">[responsibilitiesText]</p><p translate=\"ipmApp.agreements.patientRights.respect\" class=\"bold\">Respect and Kindness</p><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.patientRights.respect.1\"></li><li translate=\"ipmApp.agreements.patientRights.respect.2\"></li><li translate=\"ipmApp.agreements.patientRights.respect.3\"></li></ul><p translate=\"ipmApp.agreements.patientRights.behavior\" class=\"bold\">Safe and Appropriate Behavior</p><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.patientRights.behavior.1\"></li><li translate=\"ipmApp.agreements.patientRights.behavior.2\"></li></ul><p translate=\"ipmApp.agreements.patientRights.privacy\" class=\"bold\">Privacy and Consideration</p><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.patientRights.privacy.1\"></li><li translate=\"ipmApp.agreements.patientRights.privacy.2\"></li></ul><p translate=\"ipmApp.agreements.patientRights.takePart\" class=\"bold\">Take Part in Your Care</p><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.patientRights.takePart.1\"></li><li translate=\"ipmApp.agreements.patientRights.takePart.2\"></li><li translate=\"ipmApp.agreements.patientRights.takePart.3\"></li><li translate=\"ipmApp.agreements.patientRights.takePart.4\"></li></ul><p translate=\"ipmApp.agreements.patientRights.takePart.text\">[takePartText]</p><div style=\"height: 2px; background-color: #b0b0b0; width: 100%; margin: 20px 0\"></div><p translate=\"ipmApp.agreements.patientRights.rules\" class=\"bold\">If These Rules Are Not Followed</p><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.patientRights.rules.1\"></li><li translate=\"ipmApp.agreements.patientRights.rules.2\"></li></ul><div style=\"height: 2px; background-color: #b0b0b0; width: 100%; margin: 20px 0\"></div><p translate=\"ipmApp.agreements.patientRights.thankyou\">Thank you for helping us keep a safe, respectful, and welcoming environment.</p><div style=\"height: 2px; background-color: #b0b0b0; width: 100%; margin: 20px 0\"></div><p translate=\"ipmApp.agreements.patientRights.acknowledgment\" class=\"bold\">Acknowledgment</p><p translate=\"ipmApp.agreements.patientRights.acknowledgment.text\">[acknowledgmentText]</p><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.name\">Patient Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"ipmApp.agreements.patient.name.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"agreementForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form>");
$templateCache.put("app/agreements-workflow/agreements-privacy-practices/agreements-privacy-practices.html","<!--Start STEP agreementsPrivacyPractices--><div id=\"sectionA\" class=\"h4 bold text-center mb-1\"><span translate=\"ipmApp.agreements.privacy.title\">Notice of Privacy Practices</span></div><div class=\"text-center\" translate=\"ipmApp.agreements.privacy.effective\">Effective</div><div class=\"text-center my-4\"><span translate=\"ipmApp.agreements.privacy.office\">Compliance Office:</span> <img src=\"content/images/phone.png\" style=\"width: 12px; padding-bottom: 4px\"> 877-222-3167 &nbsp;&nbsp;<img src=\"content/images/email.png\" style=\"width: 12px; padding-bottom: 4px\"> <a href=\"mailto:complianceoffice@boomeranghc.com\">complianceoffice@boomeranghc.com</a><br><span>450 N Wiget Ln, Walnut Creek, CA 94598</span></div><p translate=\"ipmApp.agreements.privacy.text2\">text2</p><p translate=\"ipmApp.agreements.privacy.text3\">text3</p><p class=\"text-center my-4\"><b translate=\"ipmApp.agreements.privacy.text4\">text4</b></p><h5 id=\"sectionB\" class=\"text-center my-4\">B. <span translate=\"ipmApp.agreements.privacy.B\">B</span></h5><div class=\"toc\"><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionA\')\"><div>A.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.A\">A</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 1</div></div><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionB\')\"><div>B.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.B\">B</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 2</div></div><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionC\')\"><div>C.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.C\">C</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 3–5</div></div><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionD\')\"><div>D.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.D\">D</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 5</div></div><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionE\')\"><div>E.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.E\">E</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 5–7</div></div><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionF\')\"><div>F.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.F\">F</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 7</div></div><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionG\')\"><div>G.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.G\">G</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 7</div></div><div class=\"toc-item\" ng-click=\"vm.moveTo(\'sectionH\')\"><div>H.</div><div class=\"toc-title\"><span class=\"toc-text\" translate=\"ipmApp.agreements.privacy.HPage\">HPage</span></div><div class=\"toc-page\"><span translate=\"ipmApp.agreements.privacy.page\">Page</span> 8</div></div></div><h5 id=\"sectionC\" class=\"text-center my-4\">C. <span translate=\"ipmApp.agreements.privacy.C\">C</span></h5><p translate=\"ipmApp.agreements.privacy.text5\">text5</p><ul class=\"bullet bullet-decimal-privacy\"><li translate=\"ipmApp.agreements.privacy.C.1\"></li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.C.1.1\"></li><li translate=\"ipmApp.agreements.privacy.C.1.2\"></li><li translate=\"ipmApp.agreements.privacy.C.1.3\"></li></ul><li translate=\"ipmApp.agreements.privacy.C.2\"></li><li translate=\"ipmApp.agreements.privacy.C.3\"></li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.C.3.1\"></li><li translate=\"ipmApp.agreements.privacy.C.3.2\"></li><li translate=\"ipmApp.agreements.privacy.C.3.3\"></li><li translate=\"ipmApp.agreements.privacy.C.3.4\"></li></ul><p style=\"padding-left: 15px\" translate=\"ipmApp.agreements.privacy.C.3.text1\"></p><p style=\"padding-left: 15px\" translate=\"ipmApp.agreements.privacy.C.3.text2\"></p><li translate=\"ipmApp.agreements.privacy.C.4\"></li><li translate=\"ipmApp.agreements.privacy.C.5\"></li><li translate=\"ipmApp.agreements.privacy.C.6\"></li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.C.6.1\"></li><li translate=\"ipmApp.agreements.privacy.C.6.2\"></li><li translate=\"ipmApp.agreements.privacy.C.6.3\"></li><li translate=\"ipmApp.agreements.privacy.C.6.4\"></li></ul><li translate=\"ipmApp.agreements.privacy.C.7\"></li><li translate=\"ipmApp.agreements.privacy.C.8\"></li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.C.8.1\"></li><li translate=\"ipmApp.agreements.privacy.C.8.2\"></li><li translate=\"ipmApp.agreements.privacy.C.8.3\"></li></ul><li translate=\"ipmApp.agreements.privacy.C.9\"></li><li translate=\"ipmApp.agreements.privacy.C.10\"></li><li translate=\"ipmApp.agreements.privacy.C.11\"></li><li translate=\"ipmApp.agreements.privacy.C.12\"></li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.C.12.1\"></li><li translate=\"ipmApp.agreements.privacy.C.12.2\"></li><li translate=\"ipmApp.agreements.privacy.C.12.3\"></li><li translate=\"ipmApp.agreements.privacy.C.12.4\"></li><li translate=\"ipmApp.agreements.privacy.C.12.5\"></li></ul><li translate=\"ipmApp.agreements.privacy.C.13\"></li><li translate=\"ipmApp.agreements.privacy.C.14\"></li><li translate=\"ipmApp.agreements.privacy.C.15\"></li><li translate=\"ipmApp.agreements.privacy.C.16\"></li><li translate=\"ipmApp.agreements.privacy.C.17\"></li><li translate=\"ipmApp.agreements.privacy.C.18\"></li><li translate=\"ipmApp.agreements.privacy.C.19\"></li></ul><h5 id=\"sectionD\" class=\"text-center my-4\">D. <span translate=\"ipmApp.agreements.privacy.D\">D</span></h5><p translate=\"ipmApp.agreements.privacy.text6\">text6</p><h5 id=\"sectionE\" class=\"text-center my-4\">E. <span translate=\"ipmApp.agreements.privacy.E\">E</span></h5><ul class=\"bullet bullet-decimal-privacy\"><li translate=\"ipmApp.agreements.privacy.E.1\">E.1</li><li translate=\"ipmApp.agreements.privacy.E.2\">E.2</li><li translate=\"ipmApp.agreements.privacy.E.3\">E.3</li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.E.3.1\"></li><li translate=\"ipmApp.agreements.privacy.E.3.2\"></li><li translate=\"ipmApp.agreements.privacy.E.3.3\"></li><li translate=\"ipmApp.agreements.privacy.E.3.4\"></li><li translate=\"ipmApp.agreements.privacy.E.3.5\"></li></ul><li translate=\"ipmApp.agreements.privacy.E.4\">E.4</li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.E.4.1\"></li><li translate=\"ipmApp.agreements.privacy.E.4.2\"></li><ul class=\"bullet bullet-circle\"><li translate=\"ipmApp.agreements.privacy.E.4.2.1\"></li><li translate=\"ipmApp.agreements.privacy.E.4.2.2\"></li><li translate=\"ipmApp.agreements.privacy.E.4.2.3\"></li><li translate=\"ipmApp.agreements.privacy.E.4.2.4\"></li></ul><li translate=\"ipmApp.agreements.privacy.E.4.3\"></li></ul><li translate=\"ipmApp.agreements.privacy.E.5\">E.5</li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.E.5.1\"></li><li translate=\"ipmApp.agreements.privacy.E.5.2\"></li><li translate=\"ipmApp.agreements.privacy.E.5.3\"></li><li translate=\"ipmApp.agreements.privacy.E.5.4\"></li><li translate=\"ipmApp.agreements.privacy.E.5.5\"></li><li translate=\"ipmApp.agreements.privacy.E.5.6\"></li><li translate=\"ipmApp.agreements.privacy.E.5.7\"></li><li translate=\"ipmApp.agreements.privacy.E.5.8\"></li></ul><li translate=\"ipmApp.agreements.privacy.E.6\">E.6</li><li translate=\"ipmApp.agreements.privacy.E.7\">E.7</li><ul class=\"bullet bullet-disc\"><li translate=\"ipmApp.agreements.privacy.E.7.1\"></li><li translate=\"ipmApp.agreements.privacy.E.7.2\"></li><li translate=\"ipmApp.agreements.privacy.E.7.3\"></li><li translate=\"ipmApp.agreements.privacy.E.7.4\"></li><li translate=\"ipmApp.agreements.privacy.E.7.5\"></li></ul><li translate=\"ipmApp.agreements.privacy.E.8\">E.8</li></ul><h5 id=\"sectionF\" class=\"text-center my-4\">F. <span translate=\"ipmApp.agreements.privacy.F\">F</span></h5><p translate=\"ipmApp.agreements.privacy.text7\">text7</p><h5 id=\"sectionG\" class=\"text-center my-4\">G. <span translate=\"ipmApp.agreements.privacy.G\">G</span></h5><p translate=\"ipmApp.agreements.privacy.text8\">text8</p><ul class=\"bullet bullet-decimal\"><li translate=\"ipmApp.agreements.privacy.G.1\"></li><div class=\"ml-5\"><span style=\"padding-left: 3rem\" translate=\"ipmApp.agreements.privacy.G.1.1\"></span><br><span style=\"padding-left: 3rem\" translate=\"ipmApp.agreements.privacy.G.1.2\"></span><br></div><li translate=\"ipmApp.agreements.privacy.G.2\"></li><li translate=\"ipmApp.agreements.privacy.G.3\"></li></ul><h5 id=\"sectionH\" class=\"text-center my-4\"><span translate=\"ipmApp.agreements.privacy.H\">H</span></h5><p translate=\"ipmApp.agreements.privacy.text9\">text9</p><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.name\">Patient Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\" name=\"patientName\" id=\"patientName\" required><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"ipmApp.agreements.patient.name.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.telephone\" class=\"ng-scope\">Telephone</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" phone-input ng-model=\"vm.agreement.patientPhone\" ng-minlength=\"10\" ng-maxlength=\"14\" name=\"patientPhone\" id=\"patientPhone\" required><div ng-show=\"agreementForm.patientPhone.$dirty && agreementForm.patientPhone.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientPhone.$error.required\" translate=\"ipmApp.agreements.patient.telephone.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientPhone.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</div><div class=\"help-block\" ng-show=\"agreementForm.patientPhone.$error.minlength\" translate=\"ipmApp.agreements.patient.telephone.invalid\">Patient Phone is invalid</div></div></div></div></div><!--End STEP agreementsPrivacyPractices--><p translate=\"ipmApp.agreements.privacy.text10\">text10</p><div class=\"mb-4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.parentSigned\" id=\"chbox_parent\" ng-disabled=\"vm.disabledParentSigned()\"><label class=\"form-check-label-v4\" translate=\"ipmApp.agreements.privacy.text11\" for=\"chbox_parent\">parent</label></div><div class=\"mb-4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.conservatorSigned\" id=\"chbox_conservator\" ng-disabled=\"vm.disabledConservatorSigned()\"><label class=\"form-check-label-v4\" translate=\"ipmApp.agreements.privacy.text12\" for=\"chbox_conservator\">conservator</label></div><!--Start STEP agreementsNoticePatients--><!-- <agreements-notice-patients agreement=\"vm.agreement\"></agreements-notice-patients> --><!--End STEP agreementsNoticePatients--><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"agreementForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form>");
$templateCache.put("app/agreements-workflow/agreements-risk-of-opioids/agreements-risk-of-opioids.html","<div class=\"h4 bold text-center mb-4\"><span translate=\"ipmApp.agreements.risk.title\">Opioid Risks</span></div><p translate=\"ipmApp.agreements.risk.text17\"></p><p class=\"bold\" translate=\"ipmApp.agreements.risk.text19\">RISKS:</p><ul class=\"bullet bullet-decimal-privacy\"><li translate=\"ipmApp.agreements.risk.R.1\"></li><li translate=\"ipmApp.agreements.risk.R.2\"></li><li translate=\"ipmApp.agreements.risk.R.3\"></li><li translate=\"ipmApp.agreements.risk.R.4\"></li><li translate=\"ipmApp.agreements.risk.R.5\"></li><li translate=\"ipmApp.agreements.risk.R.6\"></li><li translate=\"ipmApp.agreements.risk.R.7\"></li><li translate=\"ipmApp.agreements.risk.R.8\"></li><li translate=\"ipmApp.agreements.risk.R.9\"></li></ul><p><span class=\"bold\" translate=\"ipmApp.agreements.risk.text21\"></span> <span translate=\"ipmApp.agreements.risk.text21.1\"></span></p><p translate=\"ipmApp.agreements.risk.text22\"></p><div class=\"pt-5 pb-4\" translate=\"ipmApp.agreements.risk.text23\"></div><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.namePrint\">Patient Name (Print)</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\" value=\"{{vm.agreement.patientName}}\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"ipmApp.agreements.patient.name.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div></form>");
$templateCache.put("app/agreements-workflow/agreements-signature/agreements-signature.html","<div class=\"h4 bold text-center mb-4\"><span translate=\"ipmApp.agreements.home.final\">Final Signature</span></div><div class=\"mt-3\"><label class=\"mb-3\" translate=\"ipmApp.agreements.home.download.title\">Agreements</label><ul class=\"bullet\" ng-class=\"vm.agreements.length > 1 ? \'bullet-decimal-privacy\' : \'\'\"><li ng-repeat=\"ag in vm.agreements track by ag.id\"><span>{{\'ipmApp.agreements.workflowName.\' + ag.agreementName | translate}}</span>&nbsp;<span class=\"glyphicon glyphicon-ok text-success\"></span></li></ul></div><div class=\"row-v4 justify-content-center fix-on-safari-5\"><div class=\"col-v4-auto\"><label class=\"mb-3\">{{\'ipmApp.agreements.home.signature\' | translate}}</label><signature-pad width=\"auto\" height=\"200\" on-change=\"vm.onChangeSignature(data)\" remove-blank=\"true\" clear=\"true\" get=\"false\" disabled=\"false\"></signature-pad></div></div><div class=\"mt-4 text-center\"><button type=\"button\" ng-disabled=\"vm.isSaving || !vm.agreement.patientSignature\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span translate=\"entity.action.submit\">Submit</span></button></div>");
$templateCache.put("app/agreements-workflow/agreements-transfer-medical/agreements-transfer-medical.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"h4 bold text-center mb-5 text-uppercase\"><span translate=\"ipmApp.agreements.transferMedical.title\">AUTHORIZATION TO TRANSFER MEDICAL RECORDS</span></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label><span translate=\"ipmApp.agreements.patient.name\">Patient Name</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\"><div ng-show=\"editForm.patientName.$dirty && editForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"editForm.patientName.$error.required\" translate=\"ipmApp.agreements.patient.name.required\">This field is required.</div><div class=\"help-block\" ng-show=\"editForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label><span translate=\"ipmApp.agreements.patient.dateOfBirth\">DOB</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"dateOfBirth\" name=\"dateOfBirth\" uib-datepicker-popup=\"MM/dd/yyyy\" required close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-model=\"vm.agreement.patientDob\" is-open=\"vm.datePickerOpenStatus.dateOfBirth\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateOfBirth\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"(editForm.dateOfBirth.$dirty && editForm.dateOfBirth.$invalid) || vm.birthdayInvalid\"><div class=\"help-block\" ng-show=\"editForm.dateOfBirth.$error.required\" translate=\"ipmApp.agreements.patient.dateOfBirth.required\">This field is required.</div><div class=\"help-block\" ng-show=\"!editForm.dateOfBirth.$error.required && (editForm.dateOfBirth.$error.date || vm.birthdayInvalid)\" translate=\"ipmApp.agreements.patient.dateOfBirth.error\">Date of Birth is invalid.</div></div></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label><span translate=\"ipmApp.agreements.patient.address\">Patient Address</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" name=\"patientAddress\" id=\"patientAddress\" required ng-model=\"vm.agreement.patientAddress\" ng-maxlength=\"150\"><div ng-show=\"editForm.patientAddress.$dirty && editForm.patientAddress.$invalid\"><div class=\"help-block\" ng-show=\"editForm.patientAddress.$error.required\" translate=\"ipmApp.agreements.patient.address.required\">This field is required.</div><div class=\"help-block\" ng-show=\"editForm.patientAddress.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</div></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.phone\">Patient Phone</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientPhone\" id=\"patientPhone\" required phone-input ng-model=\"vm.agreement.patientPhone\" ng-minlength=\"10\" ng-maxlength=\"14\"><div ng-show=\"editForm.patientPhone.$dirty && editForm.patientPhone.$invalid\"><div class=\"help-block\" ng-show=\"editForm.patientPhone.$error.required\" translate=\"ipmApp.agreements.patient.phone.required\">This field is required.</div><div class=\"help-block\" ng-show=\"editForm.patientPhone.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</div><div class=\"help-block\" ng-show=\"editForm.patientPhone.$error.minlength\" translate=\"ipmApp.agreements.patient.phone.invalid\">Patient Phone is invalid</div></div></div></div></div><div class=\"form-group\"><label><span translate=\"ipmApp.agreements.transferMedical.medicalRecord\">Please list the clinics (doctor, clinic name, address, phone) that possess the patient’s medical records</span></label><textarea class=\"form-control auto-height none-resize\" name=\"medicalRecord\" id=\"medicalRecord\" ng-model=\"vm.agreement.medicalRecord\" ng-maxlength=\"3000\" rows=\"4\"></textarea><div ng-show=\"editForm.medicalRecord.$dirty && editForm.medicalRecord.$invalid\"><div class=\"help-block\" ng-show=\"editForm.medicalRecord.$error.required\" translate=\"ipmApp.agreements.transferMedical.medicalRecord.required\">This field is required.</div><div class=\"help-block\" ng-show=\"editForm.medicalRecord.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"3000\">This field cannot be longer than 3000 characters.</div></div></div><h5 class=\"mt-4\" translate=\"ipmApp.agreements.transferMedical.authorizationForRelease\">Authorization for Release</h5><p translate=\"ipmApp.agreements.transferMedical.iHereby\">I hereby authorize the medical provider to release, disclose, and deliver medical records and information described below to</p><div class=\"text-center\"><span translate=\"ipmApp.agreements.transferMedical.company\">BHC Medical Records</span><br><span translate=\"ipmApp.agreements.transferMedical.address\">PO Box 399444, San Francisco, CA 94139-9444</span><br><span translate=\"ipmApp.agreements.transferMedical.phone\">Phone: (925) 691-9806</span><br><span translate=\"ipmApp.agreements.transferMedical.fax\">Fax: (925) 691-9807</span></div><div class=\"mt-4\"><span translate=\"ipmApp.agreements.transferMedical.iSpecifically\">I specifically authorize the release of ALL medical information relating to the above-named patient including but not limited to the following categories protected by state or federal law</span></div><ul class=\"bullet bullet-decimal my-2 ml-5\"><li translate=\"ipmApp.agreements.transferMedical.iSpecifically1\">Substance abuse (drug/alcohol) treatment;</li><li translate=\"ipmApp.agreements.transferMedical.iSpecifically2\">Mental Health treatment and</li><li translate=\"ipmApp.agreements.transferMedical.iSpecifically3\">HIV/AIDS related information,</li></ul><div translate=\"ipmApp.agreements.transferMedical.iSpecifically4\">if such correspondence, tests, results and any other information in the records exists, whether generated by the authorized provider or another entity.</div><div class=\"my-3\" translate=\"ipmApp.agreements.transferMedical.permission\">I do not give permission for any other use or disclosure of this information.</div><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mt-4 mb-3\" translate=\"ipmApp.agreements.transferMedical.reDisclosure\">Re-Disclosure: This release does not authorize re-disclosure of medical information beyond the limits of this consent. The recipient of this information is prohibited from using the information for any purpose other than that which is stated and from disclosing it to any other party without further authorization.</div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || vm.birthdayInvalid\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form>");
$templateCache.put("app/agreements-workflow/agreements-treatment/agreements-treatment.html","<!-- Start STEP Treatment --><div class=\"h4 bold text-center mb-4 mt-5\"><span translate=\"ipmApp.agreements.treatmentAgreement.title\">Controlled Substances Treatment Agreement</span></div><p translate=\"ipmApp.agreements.treatmentAgreement.QDescription\" class=\"bold\">QDescription</p><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><ul class=\"bullet bullet-decimal-privacy\"><li translate=\"ipmApp.agreements.treatmentAgreement.Q1\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q2\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q3\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q4\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q5\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q6\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q7\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q8\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q9\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q10\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q11\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q12\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q13\"></li><li translate=\"ipmApp.agreements.treatmentAgreement.Q14\"></li></ul><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group agreement-ignore-check\"><span translate=\"ipmApp.agreements.treatmentAgreement.pleaseCheck\" for=\"pleaseCheck\"></span> <input class=\"form-check-input-v4 ml-2\" type=\"checkbox\" name=\"pleaseCheck\" id=\"pleaseCheck\" ng-model=\"vm.agreement.ignorePrescribedControlledSubstances\"></div></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"ipmApp.agreements.patient.namePrint\">Patient Name (Print)</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.agreement.patientName\" ng-maxlength=\"50\" value=\"{{vm.agreement.patientName}}\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"ipmApp.agreements.patient.name.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"ipmApp.agreements.text.signaturePlaceholder\"></div></div></div></div><!-- End STEP agreementsNarcotics--><!-- Start STEP RISK OF OPIOIDS --><div class=\"row pt-4\"><agreements-risk-of-opioids agreement=\"vm.agreement\" on-change=\"vm.onChangeAgreement(agreement)\"></agreements-risk-of-opioids></div><!-- End STEP RISK OF OPIOIDS --><div class=\"mb-4 text-center\"><input type=\"checkbox\" ng-model=\"vm.agreement.agree\" class=\"form-check-input-v4\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"ipmApp.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"agreementForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form>");
$templateCache.put("app/agreements-workflow/agreements-welcome/agreements-welcome.html","<p translate=\"ipmApp.agreements.welcomeLetter.dear\">Dear</p><p translate=\"ipmApp.agreements.welcomeLetter.welcomeMessage\">Welcome Message</p><p class=\"mt-4\" translate=\"ipmApp.agreements.welcomeLetter.includedForms\">Included Forms</p><ul class=\"bullet bullet-disc mb-4\"><li translate=\"ipmApp.agreements.welcomeLetter.includedForms.1\">includedForms.1</li><li translate=\"ipmApp.agreements.welcomeLetter.includedForms.2\">includedForms.2</li><li translate=\"ipmApp.agreements.welcomeLetter.includedForms.3\">includedForms.3</li><li translate=\"ipmApp.agreements.welcomeLetter.includedForms.4\">includedForms.4</li><li translate=\"ipmApp.agreements.welcomeLetter.includedForms.5\">includedForms.5</li><li translate=\"ipmApp.agreements.welcomeLetter.includedForms.6\">includedForms.6</li><li translate=\"ipmApp.agreements.welcomeLetter.includedForms.7\">includedForms.7</li></ul><form name=\"agreementForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"text-center\"><button type=\"submit\" class=\"btn btn-primary\"><span translate=\"ipmApp.agreements.action.saveAgreement\">Agreement</span></button></div></form>");
$templateCache.put("app/agreements-workflow/partial/progress-bar.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-attr-aria-valuenow=\"vm.percent\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-bind-html=\"vm.percent + \'%\'\" ng-style=\"vm.widthStyle()\">0%</div></div></div></div>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"login.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><!-- <div class=\"alert alert-warning\" translate=\"global.messages.info.register\" translate-compile>\n                You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a>\n            </div> --></div></div></div>");
$templateCache.put("app/components/upload-images/upload-images.component.html","<div class=\"row\"><div class=\"col-v4-auto py-2\"><button type=\"button\" id=\"imageUpload\" name=\"imageUpload\" class=\"btn btn-info\" ngf-select ng-model=\"vm.picFile\" accept=\"image/*\" ngf-change=\"vm.onImageSelect($files)\" ngf-multiple=\"false\">Upload Image</button> <button type=\"button\" class=\"btn btn-danger\" ng-if=\"vm.hasChanged || vm.imageData\" ng-click=\"vm.removeImage()\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div><div class=\"row-v4 justify-content-center fix-on-safari-5\"><div class=\"col-v4-auto\"><div class=\"cropArea\" ng-if=\"vm.hasChanged\"><img-crop image=\"vm.picFile | ngfDataUrl\" area-type=\"square\" area-min-size=\"vm.cropSize\" result-image-format=\"string\" result-image-quality=\"1.0\" result-image-size=\"vm.cropSize\" result-image=\"vm.imageData\" on-change=\"vm.imgCropOnChange()\" ng-init=\"vm.imageData = vm.imageData ? vm.imageData : \'\'\"></img-crop></div><div class=\"cropArea\" ng-if=\"!vm.hasChanged && vm.imageData\"><img ng-src=\"{{ vm.imageData }}\"></div></div></div>");
$templateCache.put("app/directives/signature-pad/signature-pad.html","<div><div class=\"mb-2\"><canvas width=\"auto\" class=\"border border-secondary\" ng-mouseleave=\"onMouseleave()\" ng-mouseup=\"onMouseup()\" ng-mousedown=\"notifyDrawing({ drawing: true })\"></canvas></div><button type=\"button\" class=\"btn btn-link px-0 m-auto\" ng-class=\"showGet() ? \'d-block\' : \'d-none\'\" ng-click=\"getDataURL()\">Get</button> <button type=\"button\" class=\"btn btn-link px-0 m-auto\" ng-class=\"showClear() ? \'d-block\' : \'d-none\'\" ng-click=\"clearDataURL()\">{{\'global.datepicker.clear\' | translate}}</button></div>");
$templateCache.put("app/entities/adhoc-haq-evaluation/adhoc-haq-evaluation.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.adhocHaqEvaluation.title\"></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 voffset2\"><div class=\"row\"><div class=\"col-sm-5 col-xs-12 has-feedback-left\"><div class=\"form-group\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.carePlanReview.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)? vm.search($event): 0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></div></div></div></div></div><div class=\"row px-3\"><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"patient.id\"><span>{{\'ipmApp.patient.patientId\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"patient.user.firstName\"><span>{{\'ipmApp.patient.firstName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"patient.user.lastName\"><span>{{\'ipmApp.patient.lastName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"batteryTest.battery.id\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.batteryName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"batteryTest.id\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.testId\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th><span>{{(!vm.isLoadingUser && vm.isAdmin() ? \'\' : \'ipmApp.carePlanReview.launch\') | translate}}</span></th></tr></thead><tbody><tr ng-repeat=\"haq in vm.haqEvaluations\"><td>{{haq.patientId }}</td><td>{{haq.patientFirstName }}</td><td>{{haq.patientLastName }}</td><td>{{haq.batteryName}}</td><td>{{haq.batteryTestId}}-{{haq.surveyResultVersionId}}</td><td><button type=\"button\" ng-disabled=\"!haq.wholeBatteries\" class=\"btn btn-primary\" ng-click=\"vm.confirmAndStartHaqEvaluation(haq)\"><span>Begin Evaluation</span></button></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableHaq.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/entities/battery/batteries.html","<div><h2 translate=\"ipmApp.battery.home.title\">Batteries</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"battery.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"ipmApp.battery.home.createLabel\">Create new Battery</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.battery.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"ipmApp.battery.nameEn\">NameEn</span></th><th><span translate=\"ipmApp.battery.nameEs\">NameEs</span></th><th><span translate=\"ipmApp.battery.orderNumber\">OrderNumber</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"battery in vm.batteries track by battery.id\"><td><a ui-sref=\"battery-detail({id:battery.id})\">{{battery.id}}</a></td><td>{{battery.nameEn}}</td><td>{{battery.nameEs}}</td><td>{{battery.orderNumber}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"battery-detail({id:battery.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"battery.edit({id:battery.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"battery.delete({id:battery.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/battery/battery-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.battery.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.battery.delete.question\" translate-values=\"{id: \'{{vm.battery.id}}\'}\">Are you sure you want to delete this Battery?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/battery/battery-detail.html","<div><h2><span translate=\"ipmApp.battery.detail.title\">Battery</span> {{vm.battery.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.battery.nameEn\">NameEn</span></dt><dd><span>{{vm.battery.nameEn}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.battery.nameEs\">NameEs</span></dt><dd><span>{{vm.battery.nameEs}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.battery.orderNumber\">OrderNumber</span></dt><dd><span>{{vm.battery.orderNumber}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/battery/battery-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBatteryLabel\" translate=\"ipmApp.battery.home.createOrEditLabel\">Create or edit a Battery</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.battery.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.battery.nameEn\" for=\"field_nameEn\">NameEn</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.battery.nameEn\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.battery.nameEs\" for=\"field_nameEs\">NameEs</label><input type=\"text\" class=\"form-control\" name=\"nameEs\" id=\"field_nameEs\" ng-model=\"vm.battery.nameEs\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.battery.orderNumber\" for=\"field_orderNumber\">OrderNumber</label><input type=\"number\" class=\"form-control\" name=\"orderNumber\" id=\"field_orderNumber\" ng-model=\"vm.battery.orderNumber\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/battery-test/battery-test-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.batteryTest.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.batteryTest.delete.question\" translate-values=\"{id: \'{{vm.batteryTest.id}}\'}\">Are you sure you want to delete this BatteryTest?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/battery-test/battery-test-detail.html","<div><h2><span translate=\"ipmApp.batteryTest.detail.title\">BatteryTest</span> {{vm.batteryTest.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.batteryTest.orderNumber\">OrderNumber</span></dt><dd><span>{{vm.batteryTest.orderNumber}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.batteryTest.battery\">battery</span></dt><dd><a ui-sref=\"battery-detail({id:vm.batteryTest.batteryId})\">{{vm.batteryTest.batteryId}}</a></dd><hr><dt><span translate=\"ipmApp.batteryTest.test\">test</span></dt><dd><a ui-sref=\"test-detail({id:vm.batteryTest.testId})\">{{vm.batteryTest.testId}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/battery-test/battery-test-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBatteryTestLabel\" translate=\"ipmApp.batteryTest.home.createOrEditLabel\">Create or edit a BatteryTest</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.batteryTest.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.batteryTest.orderNumber\" for=\"field_orderNumber\">OrderNumber</label><input type=\"number\" class=\"form-control\" name=\"orderNumber\" id=\"field_orderNumber\" ng-model=\"vm.batteryTest.orderNumber\"></div><div class=\"form-group\"><label translate=\"ipmApp.batteryTest.battery\" for=\"field_battery\">battery</label><select class=\"form-control\" id=\"field_battery\" name=\"battery\" ng-model=\"vm.batteryTest.batteryId\" ng-options=\"battery.id as battery.id for battery in vm.batterys\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"ipmApp.batteryTest.test\" for=\"field_test\">test</label><select class=\"form-control\" id=\"field_test\" name=\"test\" ng-model=\"vm.batteryTest.testId\" ng-options=\"test.id as test.id for test in vm.tests\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/battery-test/battery-tests.html","<div><h2 translate=\"ipmApp.batteryTest.home.title\">BatteryTests</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"battery-test.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"ipmApp.batteryTest.home.createLabel\">Create new BatteryTest</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.batteryTest.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"ipmApp.batteryTest.orderNumber\">OrderNumber</span></th><th><span translate=\"ipmApp.batteryTest.battery\">battery</span></th><th><span translate=\"ipmApp.batteryTest.test\">test</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"batteryTest in vm.batteryTests track by batteryTest.id\"><td><a ui-sref=\"battery-test-detail({id:batteryTest.id})\">{{batteryTest.id}}</a></td><td>{{batteryTest.orderNumber}}</td><td><a ui-sref=\"battery-detail({id:batteryTest.batteryId})\">{{batteryTest.batteryId}}</a></td><td><a ui-sref=\"test-detail({id:batteryTest.testId})\">{{batteryTest.testId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"battery-test-detail({id:batteryTest.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"battery-test.edit({id:batteryTest.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"battery-test.delete({id:batteryTest.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/care-plan-review/care-plan-review-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"ipmApp.carePlanReview.createOrEditLabel\">Edit Time Spent</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"ipmApp.carePlanReview.timeSpent\" for=\"field_timeSpent\">Time Spent</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group mb-3\"><input type=\"number\" class=\"form-control\" placeholder=\"Time Spent\" name=\"timeSpent\" id=\"field_timeSpent\" ng-model=\"vm.timeSpentMinute\" min=\"0\" required><div class=\"input-group-addon\"><span class=\"input-group-text\">min</span></div></div><div ng-show=\"editForm.timeSpent.$dirty && editForm.timeSpent.$invalid\"><p class=\"help-block\" ng-show=\"editForm.timeSpent.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/care-plan-review/care-plan-review.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.carePlanReview.home.title\"></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 voffset2\"><div class=\"row\"><div class=\"col-sm-5 col-xs-12 has-feedback-left\"><div class=\"form-group\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.carePlanReview.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search():0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></div></div><div class=\"col-sm-2 col-xs-12\"><div class=\"form-group\"><select class=\"form-control\" name=\"cprStatus\" id=\"cprStatus\" ng-model=\"vm.status\" ng-change=\"vm.search()\" ng-options=\"opt as \'ipmApp.carePlanReviewStatus.\' + opt | translate for opt in vm.statuses\"><option value=\"\" selected=\"selected\" disabled=\"disabled\" hidden>{{\'ipmApp.carePlanReview.cprStatus\' | translate}}</option></select></div></div></div></div></div><div class=\"row px-3\"><uib-tabset active=\"vm.activeTabIndex\"><uib-tab index=\"vm.tabAssignedPatients\" select=\"vm.tabSelect(vm.tabAssignedPatients)\" class=\"primary\"><uib-tab-heading><div><span translate=\"ipmApp.carePlanReview.myQueue\"></span></div></uib-tab-heading><div ng-if=\"vm.activeTabIndex === vm.tabAssignedPatients\"><div ng-include=\"\'cprList\'\"></div></div></uib-tab><uib-tab ng-if=\"vm.isShowTabAllPatients()\" index=\"vm.tabAllPatients\" select=\"vm.tabSelect(vm.tabAllPatients)\" class=\"primary\"><uib-tab-heading><div><span translate=\"ipmApp.carePlanReview.allAssignedPatients\"></span></div></uib-tab-heading><div ng-if=\"vm.activeTabIndex === vm.tabAllPatients\"><div ng-include=\"\'cprList\'\"></div></div></uib-tab><uib-tab ng-if=\"vm.isShowTabAllPatients()\" index=\"vm.tabUnassignedPatients\" select=\"vm.tabSelect(vm.tabUnassignedPatients)\" class=\"primary\"><uib-tab-heading><div><span translate=\"ipmApp.carePlanReview.unassignedPatients\"></span></div></uib-tab-heading><div ng-if=\"vm.activeTabIndex === vm.tabUnassignedPatients\"><div ng-include=\"\'patientList\'\"></div></div></uib-tab></uib-tabset></div><script type=\"text/ng-template\" id=\"cprList\"><div class=\"table-responsive voffset2\">\n                <table class=\"jh-table table table-striped\">\n                    <thead>\n                    <tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\">\n                        <th jh-sort-by=\"patient_id\">\n                            <span> {{\'ipmApp.carePlanReview.patientId\' | translate}} </span>\n                            <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"first_name\">\n                            <span> {{\'ipmApp.carePlanReview.firstName\' | translate}} </span>\n                            <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"last_name\">\n                            <span> {{\'ipmApp.carePlanReview.lastName\' | translate}} </span>\n                            <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"office.name\">\n                            <span> {{\'ipmApp.carePlanReview.office\' | translate}} </span>\n                            <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"provider.firstName\">\n                            <span> {{\'ipmApp.carePlanReview.provider\' | translate}} </span>\n                            <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"completed_date\">\n                            <span> {{\'ipmApp.carePlanReview.lastCompleted\' | translate}} </span>\n                            <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"status\">\n                            <span> {{\'ipmApp.carePlanReview.currentStatus\' | translate}} </span> <span\n                            class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"started_date\">\n                            <span> {{\'ipmApp.carePlanReview.started\' | translate}} </span>\n                            <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th >\n                            <span> {{\'ipmApp.carePlanReview.notes\' | translate}} </span></th>\n                        <th ng-if=\"!vm.isLoadingUser && !vm.isAdmin()\">\n                            <span> {{\'ipmApp.callLog.detail.callLog\' | translate}} </span></th>\n                        <th>\n                            <span> {{\'ipmApp.carePlanReview.timeSpent\' | translate}} </span>\n                        </th>\n                        <th>\n                            <span> {{(!vm.isLoadingUser && vm.isAdmin() ? \'\' : \'ipmApp.carePlanReview.launch\') | translate}} </span>\n                        </th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat=\"cpr in vm.carePlanReviews track by cpr.id\" ng-class=\"vm.cprRowTextClass(cpr)\">\n                        <td>\n                            <span ng-if=\"cpr.patient\">{{cpr.patient.patientId}}</span>\n                        </td>\n                        <td>\n                            <span ng-if=\"cpr.patient\">{{cpr.patient.firstName}}</span>\n                        </td>\n                        <td>\n                            <span ng-if=\"cpr.patient\">{{cpr.patient.lastName}}</span>\n                        </td>\n                        <td>\n                            <span ng-if=\"cpr.office\">{{cpr.office.name}}</span>\n                        </td>\n                        <td>\n                            <span ng-if=\"cpr.provider\">{{cpr.provider.titleFullName}}</span>\n                        </td>\n                        <td>\n                            <span ng-if=\"cpr.completedDatePrevious\">{{cpr.completedDatePrevious | date:\'MM/dd/yyyy\'}}</span>\n                            <a ng-if=\"cpr.completedDatePrevious && cpr.previousId\" ng-href=\"{{ \'api/care-plan-review/download/\' + cpr.previousId }}\"\n                               class=\"glyphicon glyphicon-download-alt\"/>\n                        </td>\n                        <td>\n                            {{vm.formatAndUpdateStatus(cpr)}}\n                        </td>\n                        <td>\n                            <span ng-if=\"cpr.startedDate\">{{cpr.startedDate | date:\'MM/dd/yyyy\'}}</span>\n                        </td>\n                        <td>\n                            <a ng-if=\"cpr.status && !cpr.notes && !cpr.addHocInProgress\" class=\"glyphicon glyphicon-pencil\"\n                                    ng-click=\"vm.openNotesDialog(cpr)\">\n                            </a>\n                            <span ng-if=\"cpr.status && cpr.notes\" ng-click=\"vm.openNotesDialog(cpr)\" ng-class=\"cpr.addHocInProgress ? \'cursor-default\' : \'\'\">{{cpr.notes}}</span>\n                        </td>\n                        <td ng-if=\"!vm.isLoadingUser && !vm.isAdmin()\">\n                            <call-log\n                                care-plan-review-id=\"cpr.id\"\n                                patient-id=\"cpr.patient.id\"\n                                qhp-user-id=\"cpr.qhpUser.id\"\n                                is-ad-hoc=\"vm.checkCallLogAdHoc(cpr)\"\n                            >\n                            </call-log>\n                        </td>\n                        <td><seconds-transfer total-seconds=\"cpr.timeSpent\"></seconds-transfer></td>\n                        <td ng-if=\"!vm.isLoadingUser && vm.isAdmin()\">\n                            <button type=\"button\" class=\"btn\"\n                                    ng-disabled=\"cpr.status !== \'STARTED\' || cpr.addHocInProgress\"\n                                    ng-click=\"vm.editTimeSpent(cpr)\">\n                                <span class=\"glyphicon glyphicon-pencil\"></span>\n                                <span translate=\"ipmApp.carePlanReview.action.edit\">Edit Time Spent</span>\n                            </button>\n                        </td>\n                        <td ng-if=\"!vm.isLoadingUser && !vm.isAdmin()\">\n                            <button ng-if=\"cpr.status && !cpr.isSkippingReview && cpr.addHocInProgress\" type=\"button\" class=\"btn btn-secondary-gray disabled\"\n                                    ng-disable=\"cpr.addHocInProgress\">\n                                <span ng-if=\"cpr.status === \'NOT_STARTED\' || cpr.status === \'NOT_READY\'\">Start Review</span>\n                                <span ng-if=\"cpr.status === \'STARTED\'\">Continue Review</span>\n                            </button>\n                            <button ng-if=\"cpr.status && !cpr.isSkippingReview && !cpr.addHocInProgress\" type=\"button\" class=\"btn\"\n                                    ng-class=\"(cpr.status === \'NOT_READY\') ? \'btn-secondary-gray\' : \'btn-primary\'\"\n                                    ng-disable=\"cpr.addHocInProgress\"\n                                    ng-click=\"vm.launchCPR(cpr)\">\n                                <span ng-if=\"cpr.status === \'NOT_STARTED\' || cpr.status === \'NOT_READY\'\">Start Review</span>\n                                <span ng-if=\"cpr.status === \'STARTED\'\">Continue Review</span>\n                            </button>\n                            <button ng-if=\"cpr.isSkippingReview\" type=\"button\"\n                                    class=\"btn btn-primary\"\n                                    ng-click=\"vm.unskipReview(cpr)\">\n                                <span>Unskip Review</span>\n                            </button>\n                            <span class=\"text-break text-danger\" ng-if=\"cpr.addHocInProgress\" translate=\"ipmApp.carePlanReview.cprReviewing\"></span>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tbody ng-if=\"!vm.carePlanReviews || vm.carePlanReviews.length === 0\">\n                    <tr>\n                        <td colspan=\"10\">\n                            <p ng-if=\"!vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"ipmApp.carePlanReview.dialog.notExists\">There Are No Assigned Patients.</p>\n                            <p ng-if=\"vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"ipmApp.carePlanReview.dialog.notExistsFilter\">We couldn\'t find any assigned patients.</p>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n            <div class=\"text-center\">\n                <uib-pagination boundary-links=\"true\"\n                                class=\"pagination-sm\"\n                                total-items=\"vm.pageableAP.totalItems\"\n                                ng-model=\"vm.pageableAP.page\"\n                                items-per-page=\"vm.pageableAP.size\"\n                                max-size=\"vm.pageableAP.size\"\n                                rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\"></uib-pagination>\n            </div></script><script type=\"text/ng-template\" id=\"patientList\"><div class=\"table-responsive voffset2\">\n                    <table class=\"jh-table table table-striped\">\n                        <thead>\n                        <tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\">\n                            <th jh-sort-by=\"patient_id\">\n                                <span> {{\'ipmApp.carePlanReview.patientId\' | translate}} </span>\n                                <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"first_name\">\n                                <span> {{\'ipmApp.carePlanReview.firstName\' | translate}} </span>\n                                <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"last_name\">\n                                <span> {{\'ipmApp.carePlanReview.lastName\' | translate}} </span>\n                                <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"office.name\">\n                                <span> {{\'ipmApp.carePlanReview.office\' | translate}} </span>\n                                <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"provider.firstName\">\n                                <span> {{\'ipmApp.carePlanReview.provider\' | translate}} </span>\n                                <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th>\n                                <span> {{(!vm.isLoadingUser && vm.isAdmin() ? \'\' : \'ipmApp.carePlanReview.launch\') | translate}} </span>\n                            </th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat=\"patient in vm.patients\">\n                            <td>\n                                <span>{{patient.patientId}}</span>\n                            </td>\n                            <td>\n                                <span>{{patient.firstName}}</span>\n                            </td>\n                            <td>\n                                <span>{{patient.lastName}}</span>\n                            </td>\n                            <td>\n                                <span>{{patient.officeName}}</span>\n                            </td>\n                            <td>\n                                <span>{{patient.providerTitleFullName}}</span>\n                            </td>\n                            <td ng-if=\"!vm.isLoadingUser && !vm.isAdmin()\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                        ng-disabled=\"vm.isSaving\"\n                                        ng-click=\"vm.addAssignment(patient.id)\">\n                                    <span>Start Review</span>\n                                </button>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tbody ng-if=\"!vm.patients || vm.patients.length === 0\">\n                        <tr>\n                            <td colspan=\"10\">\n                                <p ng-if=\"!vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"ipmApp.carePlanReview.dialog.notExists\">There Are No Assigned Patients.</p>\n                                <p ng-if=\"vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"ipmApp.carePlanReview.dialog.notExistsFilter\">We couldn\'t find any assigned patients.</p>\n                            </td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <div class=\"text-center\">\n                    <uib-pagination boundary-links=\"true\"\n                                    class=\"pagination-sm\"\n                                    total-items=\"vm.pageableAP.totalItems\"\n                                    ng-model=\"vm.pageableAP.page\"\n                                    items-per-page=\"vm.pageableAP.size\"\n                                    max-size=\"vm.pageableAP.size\"\n                                    rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\"></uib-pagination>\n                </div></script></div></div></div>");
$templateCache.put("app/entities/class-session/class-session-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.classSession.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"ipmApp.classSession.delete.title\"></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.classSession.delete.question\" translate-value-class=\"{{vm.classSession.wellnessClassName}}\" ng-if=\"vm.classSession\">Are you sure you want to delete [class name] session?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/class-session/class-session-editor.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" ng-if=\"vm.isCreateNew\" id=\"classSessionTitle\" translate=\"ipmApp.classSession.editor.titleAddNew\"></h4><h4 class=\"modal-title\" ng-if=\"vm.isEdit\" id=\"classSessionTitle\" translate=\"ipmApp.classSession.editor.titleEdit\"></h4><h4 class=\"modal-title\" ng-if=\"vm.isView\" id=\"classSessionTitle\" translate=\"ipmApp.classSession.editor.titleView\"></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!-- id --> <input type=\"hidden\" name=\"id\" ng-model=\"vm.classSession.id\"><div class=\"row\"><!-- date start --><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.classSession.editor.date\" for=\"field_dateInput\">Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input name=\"dateInput\" id=\"field_dateInput\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" ng-required=\"true\" ng-disabled=\"vm.isView\" datepicker-options=\"startDateOptions\" ng-model=\"vm.classSession.date\" is-open=\"vm.datePickerOpenStatus.dateLog\"><div class=\"input-group-addon\" ng-if=\"!vm.isView\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateLog\')\"></span></div></div><div ng-show=\"editForm.dateInput.$dirty && editForm.dateInput.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateInput.$error.required\" translate=\"ipmApp.classSession.editor.validation.dateRequired\">This field is required.</p><p ng-show=\"editForm.dateInput.$error.date\" class=\"help-block\" translate=\"ipmApp.classSession.editor.validation.dateInvalid\">This field is invalid.</p></div><div ng-show=\"vm.invalidDate\"><p class=\"help-block\" translate=\"ipmApp.classSession.editor.validation.dateInvalid\">This field is invalid.</p></div></div></div></div><!-- time start --><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-3\"><label class=\"control-label\" translate=\"ipmApp.classSession.editor.time\" for=\"field_dateTime\">Time</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><uib-timepicker ng-model=\"vm.classSession.time\" id=\"time\" name=\"time\" readonly-input=\"true\" ng-disabled=\"vm.isView\" hour-step=\"vm.hourStep\" minute-step=\"vm.minuteStep\" class=\"time-picker\" ng-required=\"true\"></uib-timepicker><div ng-show=\"vm.invalidTime\"><p class=\"help-block\" translate=\"ipmApp.classSession.editor.validation.timeInvalid\">This field is invalid.</p></div></div></div></div></div><!-- wellness class --><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.classSession.editor.class\" for=\"field_class\">Class</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"class\" ng-model=\"vm.classSession.wellnessClass\" ng-disabled=\"vm.isView\" ng-change=\"vm.classChange()\" ng-options=\"wellnessClass as wellnessClass.name for wellnessClass in vm.course.classes track by wellnessClass.id\" required></select></div></div><!-- course --><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.classSession.editor.course\" for=\"field_course\">Course</label><div class=\"input-group\"><span>{{vm.classSession.courseName}}</span></div></div></div><!-- session number --><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.classSession.editor.session\" for=\"field_session\">Session #</label><div class=\"input-group\"><span>{{vm.classSession.classSequence}}</span></div></div></div></div><!-- instructor --><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><label class=\"control-label\" translate=\"ipmApp.classSession.editor.instructor\" for=\"field_instructor\">Instructor</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"class\" ng-model=\"vm.classSession.instructorId\" ng-disabled=\"vm.isView\" ng-options=\"instructor.instructorId as instructor.instructorName for instructor in vm.instructors | orderBy : \'instructorName\'\" required></select></div></div></div><!-- attendees list  --><div class=\"row\" ng-if=\"vm.classSession.id\"><div class=\"form-group\"><div class=\"col-sm-6\"><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th jh-sort-by=\"wellnessClass.sequence\">{{\'ipmApp.classSession.editor.attendee\' | translate}}</th><th jh-sort-by=\"wellnessClass.name\">{{\'ipmApp.classSession.editor.dateRegistered\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"attendee in vm.classSession.classRegistrations track by attendee.id\"><td>{{attendee.patientName}}</td><td>{{attendee.registeredDate | date:\'MM/dd/yyyy\'}}</td></tr></tbody><tbody ng-if=\"!vm.classSession.classRegistrations || vm.classSession.classRegistrations.length === 0\"><tr><td colspan=\"4\"><p class=\"text-center\" translate=\"ipmApp.classSession.editor.attendeeNotExists\">No attendee.</p></td></tr></tbody></table></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.invalidDate || vm.invalidTime || isSaving\" class=\"btn btn-primary\" ng-if=\"!vm.isView\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/class-session/class-session-schedule-day-dialog.html","<form name=\"generateForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"ipmApp.classSession.home.scheduleXDays\"></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group text-left\"><label class=\"control-label\" translate=\"ipmApp.classSession.scheduleXDays.numberOfDays\" for=\"field_numberOfDate\">Number of days</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"numberOfDate\" ng-model=\"vm.numberOfDate\" number-min-max min=\"{{vm.min}}\" max=\"{{vm.max}}\" required><div ng-show=\"generateForm.numberOfDate.$dirty\"><p class=\"help-block\" ng-show=\"generateForm.numberOfDate.$error.invalidRange\" translate=\"ipmApp.classSession.scheduleXDays.validation.numberRange\" translate-value-min=\"{{vm.min}}\" translate-value-max=\"{{vm.max}}\"></p><p class=\"help-block\" ng-show=\"generateForm.numberOfDate.$error.pattern\" translate=\"ipmApp.classSession.scheduleXDays.validation.numberPattern\"></p></div><div ng-show=\"generateForm.numberOfDate.$dirty && generateForm.numberOfDate.$invalid\"><p class=\"help-block\" translate=\"entity.validation.required\" ng-show=\"generateForm.numberOfDate.$error.required\">This field is required.</p></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-disabled=\"generateForm.$invalid\" class=\"btn btn-primary\" ng-click=\"vm.doGenerate()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/class-session/class-session.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.classSession.home.path\" translate-value-course=\"{{vm.course.name}}\">Class Session</div><jhi-alert></jhi-alert><!-- button create --><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"class-session.list.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.classSession.home.createLabel\">Add Session</span></button> <button class=\"btn btn-primary\" ng-click=\"vm.openAutoGenerateDialog()\"><span class=\"glyphicon glyphicon-calendar\"></span> <span translate=\"ipmApp.classSession.home.scheduleXDays\">Schedule X Days</span></button></div></div><!-- Test Table --><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><!-- <th jh-sort-by=\"wellnessClass.sequence\">{{\'ipmApp.classSession.listPage.classSequence\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"wellnessClass.name\">{{\'ipmApp.classSession.listPage.className\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"formatInstructorName\">{{\'ipmApp.classSession.listPage.instructor\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"numOfRegistered\">{{\'ipmApp.classSession.listPage.numberRegistered\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"dateStart\">{{\'ipmApp.classSession.listPage.date\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th>\n                            <th jh-sort-by=\"timeStart\">{{\'ipmApp.classSession.listPage.time\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th> --><th>{{\'ipmApp.classSession.listPage.classSequence\' | translate}}</th><th>{{\'ipmApp.classSession.listPage.className\' | translate}}</th><th>{{\'ipmApp.classSession.listPage.instructor\' | translate}}</th><th>{{\'ipmApp.classSession.listPage.numberRegistered\' | translate}}</th><th>{{\'ipmApp.classSession.listPage.date\' | translate}}</th><th>{{\'ipmApp.classSession.listPage.time\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"classSession in vm.classSessions track by classSession.id\"><td style=\"width:5%\">{{classSession.classSequenceNumber}}</td><td style=\"width:40%\">{{classSession.className}}</td><td style=\"width:15%\">{{classSession.instructorName}}</td><td style=\"width:10%\">{{classSession.numberOfRegisterStringFormat}}</td><td style=\"width:10%\">{{classSession.classStart | date:\'MM/dd/yyyy\'}}</td><td style=\"width:10%\">{{classSession.classStart | date:\'hh:mm a\'}}</td><td style=\"width:10%\" class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"class-session.list.edit({classSessionId: classSession.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" class=\"btn btn-danger btn-sm\" ui-sref=\"class-session.list.delete({classSessionId: classSession.id})\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!-- Paging --><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/entities/course/course-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.course.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p ng-if=\"!vm.course.used\" translate=\"ipmApp.course.delete.question\" translate-values=\"{id: \'{{vm.course.name}}\'}\">Are you sure you want to delete this Course?</p><p ng-if=\"vm.course.used\" translate=\"ipmApp.course.delete.error\">You cannot remove this Course, there is at least one Class session scheduled for this Course.</p></div><div class=\"modal-footer\"><div ng-if=\"!vm.course.used\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div><div ng-if=\"vm.course.used\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.ok\">Ok</span></button></div></div></form>");
$templateCache.put("app/entities/course/course-editor.html","<div class=\"page page--section\" ng-if=\"vm.course\"><div class=\"container\"><div class=\"content\"><!-- Title --><div class=\"h2 title\"><span translate=\"ipmApp.course.home.createLabel\" ng-if=\"vm.isCreateNew === true\"></span> <span translate=\"ipmApp.course.home.editLabel\" ng-if=\"vm.isCreateNew === false\"></span></div><!-- content --><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!-- Name --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.course.name\" for=\"field_name\">Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.course.name\" ng-maxlength=\"255\" required><div ng-show=\"editForm.name.$dirty && editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"ipmApp.course.error.requiredCourseName\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><!-- description --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.course.description\" for=\"field_description\">Description</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><textarea type=\"text\" class=\"form-control auto-height text-summary\" id=\"field_description\" name=\"description\" rows=\"5\" ng-model=\"vm.course.description\" ng-minlength=\"1\" ng-maxlength=\"1000\" required></textarea><div ng-show=\"editForm.description.$dirty && editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.required\" translate=\"ipmApp.course.error.requiredDescription\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.description.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1000\">This field cannot be longer than 1000 characters.</p></div></div><!-- HAQ Indicator --><div class=\"form-group\"><label class=\"control-label h5 primary\" translate=\"ipmApp.course.detail.haqIndicators\" for=\"field_wellnessClasses\">HAQ Indicators</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"table-responsive\"><table class=\"jh-table table table-stripeds courseEditor\"><thead><tr><th class=\"haqTest\"><span translate=\"ipmApp.course.detail.haqTest\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th class=\"threshold\"><span translate=\"ipmApp.course.detail.threshold\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th><span translate=\"ipmApp.course.detail.recommendationType\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th></tr></thead><tbody><tr ng-repeat=\"haqIndicator in vm.course.haqIndicators\" ng-value=\"haqIndicatorIndex = $index\"><td style=\"padding-top: 0px\"><select class=\"form-control haqIndicator\" ng-change=\"vm.onChangeIndicator()\" name=\"haqTest_{{haqIndicatorIndex}}\" id=\"field_haqTest.{{haqIndicatorIndex}}\" required ng-model=\"haqIndicator.testId\" ng-options=\"test.id as test.nameEn for test in vm.tests | filter: {activated: \'true\'} | orderBy : \'nameEn\' \"><option value=\"\">Choose HAQ Test</option></select><div ng-show=\"editForm.haqTest_{{haqIndicatorIndex}}.$dirty && editForm.haqTest_{{haqIndicatorIndex}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.course.error.requiredHAQTest\">This field is required.</p></div></td><td colspan=\"3\"><table class=\"jh-table table table-stripeds courseEditor\"><tbody><tr ng-repeat=\"haqTrigger in haqIndicator.haqTriggers\" ng-init=\"haqTriggerIndex = $index\"><td style=\"padding-top: 0px\" class=\"threshold-value\"><input type=\"text\" ng-pattern=\"/^\\d+$/\" class=\"form-control\" name=\"value_{{haqIndicatorIndex}}_{{haqTriggerIndex}}\" id=\"field_value.{{haqIndicatorIndex}}_{{haqTriggerIndex}}\" ng-model=\"haqTrigger.value\" required><div ng-show=\"editForm.value_{{haqIndicatorIndex}}_{{haqTriggerIndex}}.$dirty && editForm.value_{{haqIndicatorIndex}}_{{haqTriggerIndex}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.value_{{haqIndicatorIndex}}_{{haqTriggerIndex}}.$error.required\" translate=\"ipmApp.course.error.requiredThreshold\">This field is required.</p><!-- <p class=\"help-block\" ng-show=\"editForm.value_{{haqIndicatorIndex}}_{{haqTriggerIndex}}.$error.maxlength\"\n                                                                            translate=\"entity.validation.maxlength\"\n                                                                            translate-value-max=\"5\">\n                                                                            This field cannot be longer than 5 characters.\n                                                                        </p> --><p class=\"help-block\" ng-show=\"editForm.value_{{haqIndicatorIndex}}_{{haqTriggerIndex}}.$error.pattern\" translate=\"entity.validation.number\">This field should be a number.</p></div></td><td style=\"padding-top: 0px\" class=\"recommendationType\"><select class=\"form-control\" ng-change=\"vm.onChangeRecommendationType()\" name=\"recommendationType_{{haqIndicatorIndex}}_{{haqTriggerIndex}}\" id=\"field_recommendationType.{{haqIndicatorIndex}}_{{haqTriggerIndex}}\" ng-model=\"haqTrigger.recommendationType\" ng-options=\"item as \'ipmApp.recommendationType.\' + item | translate for item in vm.recommendationTypes track by item\" required><option value=\"\"></option></select><div ng-show=\"editForm.recommendationType_{{haqIndicatorIndex}}_{{haqTriggerIndex}}.$dirty && editForm.recommendationType_{{haqIndicatorIndex}}_{{haqTriggerIndex}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.course.error.requiredRecommendationType\">This field is required.</p></div></td><td style=\"padding-top: 0px\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.course.haqIndicators.length == 1 && haqIndicator.haqTriggers.length == 1\" ng-click=\"vm.removeRecommendation(haqIndicatorIndex, $index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody><tfoot><tr><td colspan=\"2\" class=\"text-right\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.addRecommendation(haqIndicatorIndex)\"><span translate=\"ipmApp.course.detail.addRecommendation\">Add a Recommendation</span></a></td></tr></tfoot></table></td></tr><tr ng-if=\"vm.isDuplicateIndicator\"><td colspan=\"4\"><p class=\"help-block\" translate=\"ipmApp.course.detail.duplicateHaqIndicator\" translate-value-duplicate=\"{{vm.duplicateIndicator}}\">You have included more than one threshold for the Recommendation Type on HAQ Indicator.</p></td></tr><tr ng-if=\"!vm.course.haqIndicators || vm.course.haqIndicators.length === 0\"><td colspan=\"4\"><p class=\"help-block text-center\" translate=\"ipmApp.course.detail.haqIndicatorsEmpty\">There is no HAQ Indicators</p></td></tr><tr ng-if=\"!vm.isDuplicateIndicator && vm.isDuplicateRecommendationType\"><td colspan=\"4\"><p class=\"help-block\" translate=\"ipmApp.course.detail.duplicateHaqIndicator\" translate-value-duplicate=\"{{vm.duplicateRecommendationType}}\">You have included more than one threshold for the Recommendation Type on HAQ Indicator.</p></td></tr></tbody><tfoot><tr><td colspan=\"4\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addHaqIndicator()\"><span translate=\"ipmApp.course.detail.addHAQIndicator\">Add a HAQ Indicator</span></button></td></tr></tfoot></table></div></div><!-- Classes --><div class=\"form-group\"><label class=\"control-label h5 primary\" translate=\"ipmApp.course.detail.classes\" for=\"field_wellnessClasses\">Classes</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"table-responsive\"><table class=\"jh-table table table-stripeds courseEditor\"><thead><tr><th><span translate=\"ipmApp.course.detail.sequence\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th><span translate=\"ipmApp.course.detail.name\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th><span translate=\"ipmApp.course.detail.deck\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"wellnessClass in vm.course.classes track by $index\"><td><input type=\"number\" min=\"1\" max=\"9999\" ng-maxlength=\"5\" class=\"form-control\" name=\"sequence_{{$index}}\" id=\"field_sequence.{{$index}}\" ng-model=\"wellnessClass.sequence\" ng-change=\"vm.onChangeSequence(wellnessClass.sequence, $index)\" required><div ng-show=\"editForm.sequence_{{$index}}.$dirty && editForm.sequence_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.sequence_{{$index}}.$error.required\" translate=\"ipmApp.course.error.requiredClassesSequence\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.sequence_{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"5\">This field cannot be longer than 5 characters.</p><p class=\"help-block\" ng-show=\"editForm.sequence_{{$index}}.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be a number.</p><p class=\"help-block\" ng-show=\"editForm.sequence_{{$index}}.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"9999\">This field should be a number.</p></div></td><td><input type=\"text\" class=\"form-control\" name=\"name_{{$index}}\" id=\"field_name.{{$index}}\" ng-model=\"wellnessClass.name\" required><div ng-show=\"editForm.name_{{$index}}.$dirty && editForm.name_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name_{{$index}}.$error.required\" translate=\"ipmApp.course.error.requiredClassesName\">This field is required.</p></div></td><td><select class=\"form-control\" name=\"deckName_{{$index}}\" id=\"field_deckName.{{$index}}\" ng-model=\"wellnessClass.deckId\" ng-options=\"deck.id as deck.name for deck in vm.decks\" required><option value=\"\"></option></select><div ng-show=\"editForm.deckName_{{$index}}.$dirty && editForm.deckName_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.deckName_{{$index}}.$error.required\" translate=\"ipmApp.course.error.requiredClassesDeck\">This field is required.</p></div></td><td><button type=\"button\" ng-disabled=\"vm.course.classes.length == 1\" class=\"btn btn-default\" ng-click=\"vm.removeClass($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"vm.isDuplicateSequence\"><td colspan=\"4\"><p class=\"help-block\" translate=\"ipmApp.course.detail.duplicateSequence\" translate-value-duplicate=\"{{vm.duplicateSequence}}\">You have included more than one sequence for the Classes.</p></td></tr><tr ng-if=\"!vm.course.classes || vm.course.classes.length === 0\"><td colspan=\"4\"><p class=\"help-block text-center\" translate=\"ipmApp.course.detail.classesEmpty\">There is no Classes</p></td></tr></tbody><tfoot><tr><td colspan=\"4\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addClass()\"><span translate=\"ipmApp.course.detail.addClass\">Add a Class</span></button></td></tr></tfoot></table></div></div><!-- Qualified Instructors --><div class=\"form-group\"><label class=\"control-label h5 primary\" translate=\"ipmApp.course.detail.qualifiedInstructors\" for=\"field_wellnessClasses\">Qualified Instructors</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"table-responsive\"><table class=\"jh-table table table-stripeds courseEditor\"><thead><tr><th><span translate=\"ipmApp.course.detail.instructor\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th><span translate=\"ipmApp.course.detail.dayOfWeek\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th><span translate=\"ipmApp.course.detail.timeOfDay\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"courseInstructor in vm.course.instructors track by $index\"><td><select class=\"form-control\" name=\"instructorName_{{$index}}\" id=\"field_instructorName.{{$index}}\" ng-model=\"courseInstructor.instructorId\" ng-options=\"user.userId as user.fullName for user in vm.users | orderBy : \'fullName\'\" required><option value=\"\"></option></select><div ng-show=\"editForm.instructorName_{{$index}}.$dirty && editForm.instructorName_{{$index}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.course.error.requiredInstructor\">This field is required.</p></div></td><td><select class=\"form-control\" name=\"dayOfWeek_{{$index}}\" id=\"field_dayOfWeek.{{$index}}\" ng-model=\"courseInstructor.dayOfWeek\" ng-options=\"item as \'ipmApp.dayOfWeek.\' + item | translate for item in vm.dayOfWeeks track by item\" required><option value=\"\"></option></select><div ng-show=\"editForm.dayOfWeek_{{$index}}.$dirty && editForm.dayOfWeek_{{$index}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.course.error.requiredDayOfWeek\">This field is required.</p></div></td><td><div class=\"row\"><div class=\"col-lg-4\"><select class=\"form-control time-of-day\" ng-model=\"courseInstructor.hourOfDay\" name=\"hourOfDay_{{$index}}\" id=\"field_hourOfDay.{{$index}}\" ng-options=\"hour for hour in vm.hourOfDays\" required><option value=\"\"></option></select></div><div class=\"col-lg-4\"><select class=\"form-control time-of-day\" ng-model=\"courseInstructor.minuteOfHour\" name=\"minuteOfHour_{{$index}}\" id=\"field_minuteOfHour.{{$index}}\" ng-options=\"minute.value as minute.label for minute in vm.minuteOfHours\" required><option value=\"\"></option></select></div><div class=\"col-lg-4\"><select class=\"form-control time-of-day\" name=\"amPm_{{$index}}\" id=\"field_amPm.{{$index}}\" ng-model=\"courseInstructor.amPM\" ng-options=\"item as \'ipmApp.amPm.\' + item | translate for item in vm.amPms track by item\" required><option value=\"\"></option></select></div></div><div ng-show=\"  (editForm.hourOfDay_{{$index}}.$dirty && editForm.hourOfDay_{{$index}}.$invalid) ||\n                                                                    (editForm.minuteOfHour_{{$index}}.$dirty && editForm.minuteOfHour_{{$index}}.$invalid) ||\n                                                                    (editForm.amPm_{{$index}}.$dirty && editForm.amPm_{{$index}}.$invalid)\"><p class=\"help-block\" translate=\"ipmApp.course.error.requiredTimeOfDay\">This field is required.</p></div></td><td><button type=\"button\" ng-disabled=\"vm.course.instructors.length == 1\" class=\"btn btn-default\" ng-click=\"vm.removeInstructor($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"!vm.course.instructors || vm.course.instructors.length === 0\"><td colspan=\"5\"><p class=\"help-block text-center\" translate=\"ipmApp.course.detail.qualifiedInstructorsEmpty\">There is no Qualified Instructors</p></td></tr></tbody><tfoot><tr><td colspan=\"4\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addInstructor()\"><span translate=\"ipmApp.course.detail.addInstructor\">Add an Instructor</span></button></td></tr></tfoot></table></div></div></form></div></div></div><!-- Buttons --><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.back()\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp; <span translate=\"entity.action.back\">Back</span></button> <button type=\"button\" ng-disabled=\"editForm.$invalid || vm.isSaving || vm.isDuplicateSequence || vm.isDuplicateIndicator || vm.isDuplicateRecommendationType\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button></div></div></div></div></div>");
$templateCache.put("app/entities/course/course-remove-class-dialog.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h5></div><div class=\"modal-body\"><p>{{\'ipmApp.course.delete.\' + vm.errorKey | translate}}</p></div><div class=\"modal-footer\"><div><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.ok\">Ok</span></button></div></div>");
$templateCache.put("app/entities/course/courses.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.course.home.title\">Courses</div><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"course.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span class=\"hidden-xs\" translate=\"ipmApp.course.home.createLabel\">Create a new Course</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"name\"><span translate=\"ipmApp.course.name\">Course Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"numOfClasses\"><span translate=\"ipmApp.course.numOfClasses\"># of Classes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"triggerHaqTests\"><span translate=\"ipmApp.course.haqIndicators\">HAQ Indicators</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"course in vm.courses track by course.id\"><td>{{course.name}}</td><td>{{course.numOfClasses}}</td><td>{{course.triggerHaqTests}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"course.edit({id:course.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"class-session.list({courseId: course.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-calendar\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.course.schedule\">Schedule</span></button> <button type=\"submit\" ui-sref=\"course.delete({id:course.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/deck/deck-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.deck.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.deck.delete.title\">Delete confirmation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p ng-if=\"!vm.deck.used\" translate=\"ipmApp.deck.delete.question\" translate-values=\"{name : \'{{vm.deck.name}}\'}\">Are you sure you want to delete Deck?</p><p ng-if=\"vm.deck.used\" translate=\"ipmApp.deck.delete.error\">\"You cannot remove this Deck, it is linked to an active Class.</p></div><div ng-if=\"!vm.deck.used\" class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div><div ng-if=\"vm.deck.used\" class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.ok\">Ok</span></button></div></form>");
$templateCache.put("app/entities/deck/deck-editor.html","<div class=\"page page--section\" ng-if=\"vm.deck\"><div class=\"container\"><div class=\"content\"><!-- Title --><div class=\"h2 title\"><span translate=\"ipmApp.deck.home.createLabel\" ng-if=\"vm.isCreateNew === true\"></span> <span translate=\"ipmApp.deck.home.editLabel\" ng-if=\"vm.isCreateNew === false\"></span></div><!-- content --><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!-- Question Name --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.deck.deckName\" for=\"field_name\">Deck Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.deck.name\" ng-maxlength=\"255\" required><div ng-show=\"editForm.name.$dirty && editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"ipmApp.deck.error.requiredName\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><div class=\"table-responsive\" style=\"overflow: hidden\"><table class=\"jh-table table\" ng-repeat=\"slide in vm.deck.slides track by $index\"><tr><td style=\"background: #FFFFFF !important; border: 1px solid #ccc\"><div class=\"row form-group\"><div class=\"col-xs-2\"><span translate=\"ipmApp.deck.slide.number\"></span> <input type=\"text\" class=\"form-control\" id=\"field_slide_name_{{$index}}\" name=\"slide_number_{{$index}}\" value=\"{{$index + 1}}\" readonly=\"readonly\"></div><div class=\"col-xs-9\"><span translate=\"ipmApp.deck.slide.name\" class=\"control-label\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" id=\"field_slide_output_{{$index}}\" name=\"name_{{$index}}\" ng-model=\"slide.name\" ng-maxlength=\"255\" required><div ng-show=\"editForm.name_{{$index}}.$dirty && editForm.name_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name_{{$index}}.$error.required\" translate=\"ipmApp.deck.error.requiredSlideName\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><div class=\"col-xs-1 text-right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.removeSlide($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div><div class=\"row form-group\"><div class=\"col-xs-3\"><label class=\"control-label\" translate=\"ipmApp.deck.slide.type\">Slide Type</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"slideType_{{$index}}\" id=\"type_{{$index}}\" ng-model=\"slide.type\" ng-options=\"type as \'ipmApp.slideType.\' + type | translate for type in vm.slideType track by type\" required><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.slideType_{{$index}}.$dirty && editForm.slideType_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.slideType_{{$index}}.$error.required\" translate=\"ipmApp.deck.error.requiredType\">This field is required.</p></div></div><div class=\"col-xs-8\"><div ng-if=\"slide.type === \'PRESENTATION\'\"><label class=\"control-label\" translate=\"ipmApp.deck.slide.downloadContent\">Content</label><div ng-if=\"!slide.fileId || hasChanged\"><button type=\"button\" id=\"fileUpload_{{$index}}\" class=\"btn btn-info\" ngf-select ng-model=\"slide.file\" name=\"slide_{{slide.id}}_file\" ngf-change=\"vm.uploadChanged($files, slide)\" accept=\".pdf\" ngf-multiple=\"false\">Upload</button> <span>{{slide.file.name}}</span></div><div ng-if=\"slide.fileId\"><a ng-click=\"vm.downloadPdf(slide)\" class=\"pr-2\" style=\"font-size:24px\"><i class=\"fa fa-file-pdf-o\"></i></a> <a ng-click=\"vm.removePdf(slide)\">Remove</a></div></div></div><div class=\"col-xs-4\"><div ng-if=\"slide.type === \'QUESTION\'\"><label class=\"control-label\" translate=\"ipmApp.deck.slide.question\">Question</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"question_{{$index}}\" id=\"type_{{$index}}\" ng-model=\"slide.question.id\" required ng-options=\"question.id as question.name for question in vm.questions\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.question_{{$index}}.$dirty && editForm.question_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.question_{{$index}}.$error.required\" translate=\"ipmApp.deck.error.requiredQuestion\">This field is required.</p></div></div></div><div class=\"col-xs-4\"><div ng-if=\"slide.type === \'QUESTION\'\"><label class=\"control-label\" translate=\"ipmApp.deck.slide.questionRepeate\">Question Type</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"questionType_{{$index}}\" id=\"type_{{$index}}\" ng-model=\"slide.questionRepeatType\" required ng-options=\"type as \'ipmApp.questionRepeatType.\' + type | translate for type in vm.questionRepeatType track by type\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.questionType_{{$index}}.$dirty && editForm.questionType_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.questionType_{{$index}}.$error.required\" translate=\"ipmApp.deck.error.requiredQuestionType\">This field is required.</p></div></div></div></div><div class=\"row\"><div class=\"col-xs-11\"><label class=\"control-label\" translate=\"ipmApp.deck.speakerNotes\" for=\"field_speakerNotes\">speakerNotes</label><textarea type=\"text\" class=\"form-control auto-height text-summary\" id=\"field_speakerNotes_{{$index}}\" name=\"speakerNotes_{{$index}}\" rows=\"5\" ng-model=\"slide.speakerNotes\" ng-minlength=\"1\" ng-maxlength=\"10000\"></textarea><div ng-show=\"editForm.speakerNotes_{{$index}}.$dirty && editForm.speakerNotes_{{$index}}.$invalid\"><!-- <p class=\"help-block\" ng-show=\"editForm.speakerNotes_{{$index}}.$error.required\"\n						                                        translate=\"ipmApp.deck.error.speakerNotes\">\n						                                        This field is required.\n						                                    </p> --><p class=\"help-block\" ng-show=\"editForm.speakerNotes_{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10000\">This field cannot be longer than 10000 characters.</p></div></div></div></td></tr></table><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.addSlide()\"><span>Add a Slide</span></button></div></div></form></div></div></div><!-- Buttons --><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-if=\"!vm.isView\" ng-disabled=\"editForm.$invalid || vm.isSaving\"><span translate=\"entity.action.save\">Save</span></button></div></div></div></div></div>");
$templateCache.put("app/entities/deck/deck.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.deck.home.title\"></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3 has-feedback-left\"><button class=\"btn btn-primary\" ui-sref=\"deck.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.deck.home.createLabel\">Create a new User</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"d.name\">{{\'ipmApp.deck.deckName\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th>{{\'ipmApp.deck.numberOfSlides\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"deck in vm.decks track by deck.id\"><td>{{deck.name}}</td><td>{{deck.numberOfSlides}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"deck.edit({id:deck.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"deck.delete({id:deck.id})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.checkDisableDeleted(user)\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/haq-evaluation-skips/haq-evaluation-multiple-skips-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title title-small\" id=\"myUserLabel\" translate=\"ipmApp.haqEvaluationSkips.dialog.addToBack.title\">Add To Back</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"ipmApp.haqEvaluationSkips.dialog.addToBack.dateAddedBack\">Date Added Back</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"form-group\"><div class=\"input-group\"><input id=\"dateAddedBack\" type=\"text\" class=\"form-control\" name=\"dateAddedBack\" uib-datepicker-popup=\"MM/dd/yyyy\" required datepicker-options=\"vm.datePickerOptions\" ng-model=\"vm.dateAddedBack\" is-open=\"vm.datePickerOpenStatus.dateAddedBack\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateAddedBack\')\"></span></div></div></div><div ng-show=\"(editForm.dateAddedBack.$dirty && editForm.dateAddedBack.$invalid) || vm.isInValidDate\"><p class=\"help-block\" ng-show=\"editForm.dateAddedBack.$error.required\" translate=\"ipmApp.haqEvaluationSkips.validate.dateAddedBack.required\">Date Added Back is required.</p><p class=\"help-block\" ng-show=\"!editForm.dateAddedBack.$error.required && (editForm.dateAddedBack.$error.date || vm.isInValidDate)\" translate=\"ipmApp.haqEvaluationSkips.validate.dateAddedBack.invalid\">Date Added Back is invalid.</p></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || vm.isInValidDate\" class=\"btn btn-primary\"><span translate=\"entity.action.ok\">OK</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haq-evaluation-skips/haq-evaluation-skips-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title title-small\" id=\"myUserLabel\" translate=\"ipmApp.haqEvaluationSkips.dialog.addToBack.title\">Add To Back</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"ipmApp.haqEvaluationSkips.dialog.addToBack.dateAddedBack\">Date Added Back</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"form-group\"><div class=\"input-group\"><input id=\"dateAddedBack\" type=\"text\" class=\"form-control\" name=\"dateAddedBack\" uib-datepicker-popup=\"MM/dd/yyyy\" required datepicker-options=\"vm.datePickerOptions\" ng-model=\"vm.haqEvaluationSkip.dateAddedBack\" is-open=\"vm.datePickerOpenStatus.dateAddedBack\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateAddedBack\')\"></span></div></div></div><div ng-show=\"(editForm.dateAddedBack.$dirty && editForm.dateAddedBack.$invalid) || vm.isInValidDate\"><p class=\"help-block\" ng-show=\"editForm.dateAddedBack.$error.required\" translate=\"ipmApp.haqEvaluationSkips.validate.dateAddedBack.required\">Date Added Back is required.</p><p class=\"help-block\" ng-show=\"!editForm.dateAddedBack.$error.required && (editForm.dateAddedBack.$error.date || vm.isInValidDate)\" translate=\"ipmApp.haqEvaluationSkips.validate.dateAddedBack.invalid\">Date Added Back is invalid.</p></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || vm.isInValidDate\" class=\"btn btn-primary\"><span translate=\"entity.action.ok\">OK</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haq-evaluation-skips/haq-evaluation-skips-multiple-remove-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"ipmApp.haqEvaluationSkips.dialog.remove.title\">Remove HAQ Evaluation Skips</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.haqEvaluationSkips.dialog.remove.question\">Are you sure you want to delete this HaqTrack?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"ipmApp.haqEvaluationSkips.action.remove\">Remove</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haq-evaluation-skips/haq-evaluation-skips-remove-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"ipmApp.haqEvaluationSkips.dialog.remove.title\">Remove HAQ Evaluation Skips</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.haqEvaluationSkips.dialog.remove.question\">Are you sure you want to delete this HaqTrack?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"ipmApp.haqEvaluationSkips.action.remove\">Remove</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haq-evaluation-skips/haq-evaluation-skips.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.haqEvaluationSkips.home.title\">HAQ Evaluation Skips</div><jhi-alert></jhi-alert><div class=\"row-v4 justify-content-between\"><div class=\"col-v4-auto voffset3\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': !vm.hideRemoved}\" ng-click=\"vm.onChangeShowRemovedTests()\"></button> <span class=\"title\">Show removed tests</span></div><div class=\"col-v4-auto voffset3 text-right\"><div class=\"col-haq-skips-multiple-actions\" ng-if=\"vm.haqSkipsSelectedRows && vm.haqSkipsSelectedRows.length > 0\"><button type=\"button\" ng-click=\"vm.onClickAddBackMultiselect()\" class=\"btn btn-primary btn-sm\" ng-disabled=\"haqSkip.selected\"><span class=\"glyphicon glyphicon-flash\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.haqEvaluationSkips.action.addBack\"></span></button> <button type=\"button\" ng-click=\"vm.onClickRemoveMultiselect()\" class=\"btn btn-danger btn-sm\" ng-disabled=\"haqSkip.selected\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.haqEvaluationSkips.action.remove\"></span></button></div></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th></th><th>{{\'ipmApp.haqEvaluationSkips.label.patientName\' | translate}}</th><th>{{\'ipmApp.haqEvaluationSkips.label.patientId\' | translate}}</th><th>{{\'ipmApp.haqEvaluationSkips.label.testName\' | translate}}</th><th>{{\'ipmApp.haqEvaluationSkips.label.completedDate\' | translate}}</th><th jh-sort-by=\"userSkippedId\">{{\'ipmApp.haqEvaluationSkips.label.skippedBy\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateSkipped\">{{\'ipmApp.haqEvaluationSkips.label.skippedDate\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reason\" style=\"width: 140px\">{{\'ipmApp.haqEvaluationSkips.label.reason\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th>{{\'ipmApp.haqEvaluationSkips.label.action\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"haqSkip in vm.haqSkips track by haqSkip.id\" ng-class=\"{\'greyed-out-row\': haqSkip.action===\'REMOVED\'}\"><td><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"haqSkip_{{haqSkip.id}}\" name=\"haqSkip_{{haqSkip.id}}\" ng-model=\"haqSkip.selected\" ng-change=\"vm.updateSelectionHaqSkip(haqSkip)\" ng-disabled=\"haqSkip && haqSkip.action\"></td><td>{{haqSkip.haqEvaluation.patientName}}</td><td>{{haqSkip.haqEvaluation.patientId}}</td><td>{{haqSkip.haqEvaluation.testName}}</td><td>{{haqSkip.haqEvaluation.finalCompletionDate | date:\'MM/dd/yyyy\'}}</td><td>{{haqSkip.userSkippedName}}</td><td>{{haqSkip.dateSkipped | date:\'MM/dd/yyyy\'}}</td><td>{{haqSkip.reasonUi}} <button type=\"button\" ng-if=\"haqSkip.reasonView\" ng-click=\"vm.showReasonDialog(haqSkip.reason)\" style=\"float: right\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td><td class=\"\"><div class=\"btn-group flex-btn-group-container-left\" ng-if=\"!haqSkip.action\"><button type=\"submit\" ng-click=\"vm.onClickAddBack(haqSkip)\" class=\"btn btn-primary btn-sm\" ng-disabled=\"haqSkip.selected\"><span class=\"glyphicon glyphicon-flash\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.haqEvaluationSkips.action.addBack\"></span></button> <button type=\"button\" ng-click=\"vm.onClickRemove(haqSkip)\" class=\"btn btn-danger btn-sm\" ng-disabled=\"haqSkip.selected\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.haqEvaluationSkips.action.remove\"></span></button></div><div class=\"text-left\" ng-if=\"haqSkip.status\"><span ng-if=\"haqSkip.action===\'REMOVED\'\">Removed by {{haqSkip.removedByName}}</span> <span ng-if=\"haqSkip.action===\'PICK_TODAY\'\">Added back on {{haqSkip.actionDate | date:\'MM/dd/yyyy\'}} by {{haqSkip.addedByName}}</span> <span ng-if=\"haqSkip.action===\'ADDED_BACK\'\">Added back on {{haqSkip.dateAddedBack | date:\'MM/dd/yyyy\'}} by {{haqSkip.addedByName}}</span></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageSize\" max-size=\"vm.pageSize\" rotate=\"false\" ng-change=\"vm.paginationOnChange(vm.pageableAP.page)\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/haq-evaluation-skips/skip-reason-dialog.html","<form name=\"warningForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.close()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.haqEvaluationSkips.label.reason\">Reason</h5></div><div class=\"modal-body\"><p>{{vm.reason}}</p></div><div class=\"modal-footer\"><button type=\"button\" translate=\"entity.action.ok\" class=\"btn btn-primary\" ng-click=\"vm.close()\">OK</button></div></form>");
$templateCache.put("app/entities/haq-tracks/haq-tracks-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.haqTrack.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"ipmApp.haqTracks.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.haqTracks.delete.question\" translate-values=\"{name: \'{{vm.haqTrack.name}}\'}\">Are you sure you want to delete this HaqTrack?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haq-tracks/haq-tracks-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myUserLabel\" translate=\"ipmApp.haqTracks.home.createOrEditLabel\">Create or edit a HAQ Tracks</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"name\" translate=\"ipmApp.haqTracks.detail.name\">name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.haqTracks.name\" ng-maxlength=\"255\" required><div ng-show=\"editForm.name.$dirty && editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"ipmApp.haqTracks.validate.name\">The name is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.haqTracks.detail.code\" for=\"field_code\">Code</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.haqTracks.code\" ng-maxlength=\"50\" required><div ng-show=\"editForm.code.$dirty && editForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"ipmApp.haqTracks.validate.code\">The code is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div><div ng-show=\"!editForm.code.$invalid && vm.haqTracksCodeExists\"><p class=\"help-block\" translate=\"ipmApp.haqTracks.validate.haqTracksCodeExists\">haqTracks Code Id is already in use!</p></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.haqTracks.detail.assignedBatteries\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div></div><tracks-assigneds-list is-ad-hoc=\"vm.haqTracks.isAdhoc\" tracks-assigneds=\"vm.haqTracks.tracksAssigneds ? vm.haqTracks.tracksAssigneds : []\" on-change=\"vm.onchangeTracksAssigneds(tracksAssigneds)\"></tracks-assigneds-list></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || !vm.haqTracks.tracksAssigneds || vm.haqTracks.tracksAssigneds.length < 1\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haq-tracks/haq-tracks.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.haqTracks.home.title\">HAQ Tracks</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"haq-tracks.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.haqTracks.home.createLabel\">Create a new HAQ Tracks</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"name\">{{\'ipmApp.haqTracks.label.name\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\">{{\'ipmApp.haqTracks.label.code\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"numberOfTrackAssigned\">{{\'ipmApp.haqTracks.label.ofHAQBatteries\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"haqTrack in vm.haqTracks track by haqTrack.id\"><td>{{haqTrack.name}}</td><td>{{haqTrack.code}}</td><td>{{haqTrack.numberOfTrackAssigned ? haqTrack.numberOfTrackAssigned : 0}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"haq-tracks.edit({id:haqTrack.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ng-disabled=\"haqTrack.isDefault || haqTrack.isAdhoc\" ui-sref=\"haq-tracks.delete({id:haqTrack.id})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"haqTrack.isDefault || haqTrack.isAdhoc\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageSize\" max-size=\"vm.pageSize\" rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/haqs-battery/haqs-battery-editor.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\">{{(vm.isStateDuplicate == true ? \'ipmApp.haqsBattery.home.duplicateHaqBattery\' : \'ipmApp.haqsBattery.home.createOrEditLabel\') | translate}}</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"ipmApp.haqsBattery.detail.nameEn\" for=\"nameEn\">Name En</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" id=\"nameEn\" name=\"nameEn\" ng-model=\"vm.haqsBattery.nameEn\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEn.$dirty && editForm.nameEn.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.required\" translate=\"ipmApp.haqsBattery.validate.nameEn\">The name is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.haqsBattery.detail.nameEs\" for=\"nameEs\">Name Es</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"nameEs\" id=\"nameEs\" ng-model=\"vm.haqsBattery.nameEs\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEs.$dirty && editForm.nameEs.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.required\" translate=\"ipmApp.haqsBattery.validate.nameEs\">The name is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.haqsBattery.detail.pdfDescription\" for=\"field_pdfDescription\">PDF Description</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><textarea id=\"field_pdfDescription\" ng-model=\"vm.haqsBattery.pdfDescription\" name=\"pdfDescription\" ng-hide=\"true\" required></textarea><quill-editor class=\"d-block min-height-115\" ids=\"\'pdfDescription\'\" id=\"pdfDescription\" hide-toolbar=\"true\" name=\"pdfDescription\" value=\"vm.haqsBattery.pdfDescription\" on-edit-change=\"vm.handlePdfDescription(data, editForm)\" required></quill-editor><div ng-show=\"editForm.pdfDescription.$dirty && editForm.pdfDescription.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pdfDescription.$error.required\" translate=\"ipmApp.haqsBattery.validate.pdfDescription\">The pdf description is required.</p></div></div><tests-assigneds-list battery-id=\"vm.haqsBattery.id\" battery-tests=\"vm.batteryTests\" is-state-duplicate=\"vm.isStateDuplicate\" is-ad-hoc=\"vm.haqsBattery.isAdHoc\" tests-on-change=\"vm.testsOnChange(test)\" on-change=\"vm.onchangeAssignedBatteryTests(batteryTests, batteryTestsDeleted)\"></tests-assigneds-list></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || !vm.batteryTests || vm.batteryTests.length == 0\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haqs-battery/haqs-battery.html","<div class=\"page page--haqs-battery\"><div class=\"container\"><div class=\"content\"><div class=\"h2 mt-4 title\" translate=\"ipmApp.haqsBattery.home.title\">haqs Battery</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"haqs-battery.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.haqsBattery.home.createLabel\">Create a new HAQ Tracks</span></button> <button class=\"btn btn-primary\" ui-sref=\"test\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span translate=\"ipmApp.haqsBattery.home.viewListOfHAQTests\">view the list of available HAQ tests</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-notification\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"id\"><span>{{\'ipmApp.haqsBattery.label.batteryId\' | translate}}</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span>{{\'ipmApp.haqsBattery.label.nameEn\' | translate}}</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEs\"><span>{{\'ipmApp.haqsBattery.label.nameEs\' | translate}}</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat-start=\"battery in vm.haqsBattery track by $index\" ng-class=\"$index % 2 ? \'even\' : \'odd\'\"><td><strong>{{battery.id}}</strong></td><td><span>{{battery.nameEn}}</span></td><td><span>{{battery.nameEs}}</span></td><td><div ng-if=\"battery.expanded\" ng-click=\"battery.expanded = false\" class=\"expand-icon active\" uib-tooltip=\"{{\'ipmApp.haqsBattery.label.haqBatteryDetails\' | translate}}\"></div><div ng-if=\"!battery.expanded\" ng-click=\"battery.expanded = true\" class=\"expand-icon\" uib-tooltip=\"{{\'ipmApp.haqsBattery.label.haqBatteryDetails\' | translate}}\"></div></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"haqs-battery.edit({id:battery.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.haqsBattery.action.edit\"></span></button> <button type=\"button\" ui-sref=\"haq-tracks.duplicate({id:battery.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-duplicate\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.haqsBattery.action.duplicate\"></span></button></div></td></tr><tr ng-if=\"battery.expanded\" ng-repeat-end=\"\" ng-class=\"$index % 2 ? \'even-child\' : \'odd-child\'\"><td colspan=\"7\"><!--batteryTests--><battery-tests-list battery-tests=\"battery.batteryTests\"></battery-tests-list></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageSize\" max-size=\"vm.pageSize\" rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/invitation/invitation.html","<div class=\"container\"><div class=\"content\" ng-if=\"vm.isPageLoadFinish\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 voffset5\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"voffset3 text-center mb-35 font-s15\"><span ng-if=\"vm.errorNotFound\">{{\'ipmApp.invitation.home.messages.recordNotFound\' | translate}}</span> <span ng-if=\"vm.expiration\">{{\'ipmApp.invitation.home.messages.recordExpiration\' | translate}}</span> <span ng-if=\"vm.haqStatus === \'COMPLETE\' || vm.haqStatus === \'DOWNLOADED\' || vm.haqStatus === \'NOT_STARTED\'\">{{\'ipmApp.invitation.home.messages.haqCompletedOrDownloaded\' | translate}}</span> <span ng-if=\"vm.npqStatus === \'COMPLETE\' || vm.npqStatus === \'COMPLETED_OFF_PLATFORM\' || vm.npqStatus === \'NOT_NEEDED\'\">{{\'ipmApp.invitation.home.messages.npqCompleted\' | translate}}</span> <span ng-if=\"vm.psychIntakeStatus === \'COMPLETE\' || vm.psychIntakeStatus === \'COMPLETED_OFF_PLATFORM\' || vm.psychIntakeStatus === \'NOT_NEEDED\'\">{{\'ipmApp.invitation.home.messages.psychIntakeCompleted\' | translate}}</span> <span ng-if=\"vm.patientAgreementStatus === \'COMPLETE\'\">{{\'ipmApp.invitation.home.messages.patientAgreementCompleted\' | translate}}</span> <span ng-if=\"vm.patientAgreementStatus === \'CANCEL\'\">{{\'ipmApp.invitation.home.messages.patientAgreementCancel\' | translate}}</span> <span ng-if=\"vm.errorHaqTestService\">{{\'ipmApp.invitation.home.messages.errorHaqTestService\' | translate}}</span></div></div><!-- <div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.isWorflowComplete === true\">\n                    <div class=\"thank center-block voffset3 font-s15\"><span class=\"glyphicon glyphicon-ok\"></span></div>\n                    <div class=\"voffset3 text-center mb-35 font-s15\">{{\'home.messages.surveyComplete\' | translate}}</div>\n                </div> --></div></div></div></div>");
$templateCache.put("app/entities/patient/patient-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patient.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.patient.delete.question\" translate-values=\"{id: \'{{vm.patient.id}}\'}\">Are you sure you want to delete this Patient?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patient/patient-detail.html","<div><h2><span translate=\"ipmApp.patient.detail.title\">Patient</span> {{vm.patient.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.patient.dateOfBirth\">DateOfBirth</span></dt><dd><span>{{vm.patient.dateOfBirth | date:\'mediumDate\'}}</span></dd><hr><dt><span translate=\"ipmApp.patient.patientId\">PatientId</span></dt><dd><span>{{vm.patient.patientId}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.patient.user\">user</span></dt><dd>{{vm.patient.userId}}</dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patient/patient-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatientLabel\" translate=\"ipmApp.patient.home.createOrEditLabel\">Create or edit a Patient</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patient.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.patient.dateOfBirth\" for=\"field_dateOfBirth\">DateOfBirth</label><div class=\"input-group\"><input id=\"field_dateOfBirth\" type=\"text\" class=\"form-control\" name=\"dateOfBirth\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.patient.dateOfBirth\" is-open=\"vm.datePickerOpenStatus.dateOfBirth\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateOfBirth\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.patient.patientId\" for=\"field_patientId\">PatientId</label><input type=\"text\" class=\"form-control\" name=\"patientId\" id=\"field_patientId\" ng-model=\"vm.patient.patientId\"></div><div class=\"form-group\"><label translate=\"ipmApp.patient.user\" for=\"field_user\">user</label><select class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.patient.userId\" ng-options=\"user.id as user.id for user in vm.users\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/patient/patients.html","<div><h2 translate=\"ipmApp.patient.home.title\">Patients</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patient.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"ipmApp.patient.home.createLabel\">Create new Patient</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.patient.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"ipmApp.patient.dateOfBirth\">DateOfBirth</span></th><th><span translate=\"ipmApp.patient.patientId\">PatientId</span></th><th><span translate=\"ipmApp.patient.user\">user</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patient in vm.patients track by patient.id\"><td><a ui-sref=\"patient-detail({id:patient.id})\">{{patient.id}}</a></td><td>{{patient.dateOfBirth | date:\'mediumDate\'}}</td><td>{{patient.patientId}}</td><td>{{patient.userId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patient-detail({id:patient.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patient.edit({id:patient.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patient.delete({id:patient.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/provider/provider-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.provider.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.provider.delete.title\">Delete confirmation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.provider.delete.question\" translate-values=\"{id: \'{{vm.provider.fullName}}\'}\">Are you sure you want to delete this Provider?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/provider/provider-detail.html","<div class=\"page page--provider\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"ipmApp.provider.detail.title\">Provider</span> \"{{vm.provider.firstName}}\"</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"table table-striped\"><tbody><tr><td><span translate=\"ipmApp.provider.title\">Title</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.provider.title}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.provider.firstName\">First Name</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.provider.firstName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.provider.lastName\">Last Name</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.provider.lastName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.provider.contactNumber\">Mobile Phone</span></td><td><input type=\"tel\" class=\"input-sm form-control\" value=\"{{vm.provider.contactNumber | tel}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.provider.emailAddress\">Email</span></td><td><input type=\"tel\" class=\"input-sm form-control\" value=\"{{vm.provider.emailAddress}}\" readonly=\"readonly\"></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ui-sref=\"provider\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/entities/provider/provider-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myProviderLabel\" translate=\"ipmApp.provider.home.createOrEditLabel\">Create or edit a Provider</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.provider.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.provider.title\" ng-maxlength=\"45\"><div ng-show=\"editForm.title.$dirty && editForm.title.$invalid\"><p class=\"help-block\" ng-show=\"editForm.title.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"45\">This field cannot be longer than 45 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.provider.firstName\" for=\"field_firstName\">FirstName</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"field_firstName\" ng-model=\"vm.provider.firstName\" required ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$dirty && editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.required\" translate=\"ipmApp.provider.firstName.required\">The First Name is required.</p><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.provider.lastName\" for=\"field_lastName\">LastName</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.provider.lastName\" required ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$dirty && editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.required\" translate=\"ipmApp.provider.lastName.required\">The Last Name is required.</p><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.provider.credentials \" for=\"field_credentials\">credentials</label><input type=\"text\" class=\"form-control\" name=\"credentials\" id=\"field_credentials\" ng-model=\"vm.provider.credentials\" ng-maxlength=\"50\"></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label\" translate=\"ipmApp.provider.contactNumber\" for=\"field_contactNumber\">Mobile Phone</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-md-6\"><label translate=\"ipmApp.provider.emailAddress\" for=\"field_email\">Email</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div></div><div class=\"row\"><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"contactNumber\" phone-input id=\"field_contactNumber\" ng-model=\"vm.provider.contactNumber\" required ng-maxlength=\"100\"><div ng-show=\"editForm.contactNumber.$dirty && editForm.contactNumber.$invalid\"><p class=\"help-block\" ng-show=\"editForm.contactNumber.$error.required\" translate=\"ipmApp.provider.contactNumber.required\">This field is required.</p></div><div ng-show=\"!editForm.contactNumber.$invalid && vm.errorContactNumberExists\"><p class=\"help-block\" translate=\"error.phoneExists\">Mobile Phone is already in use!</p></div></div><div class=\"col-md-6\"><input type=\"email\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-model=\"vm.provider.emailAddress\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$dirty && editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"ipmApp.provider.email.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div><div ng-show=\"!editForm.email.$invalid && vm.errorEmailExists\"><p class=\"help-block\" translate=\"error.emailexists\">E-mail is already in use!</p></div></div></div></div><!-- [Start Provider ID Section] --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.provider.providerId\" for=\"field_providerId\">Provider Id</label><input type=\"text\" class=\"form-control\" name=\"providerId\" id=\"field_providerId\" ng-model=\"vm.provider.providerId\" numbers-only ng-pattern=\"/^[0-9]{1,10}(\\[0-9]{1})?$/\" ng-maxlength=\"10\"><div ng-show=\"editForm.providerId.$dirty && editForm.providerId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.providerId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</p></div><div ng-show=\"!editForm.providerId.$invalid && vm.errorProviderIdExists\"><p class=\"help-block\" translate=\"error.providerIdExists\">Provider Id is already in use!</p></div></div><!-- [End Provider ID Section] --><!-- [Start External ID Section] --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.provider.externalId\" for=\"field_externalId\">External ID</label><input type=\"text\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\" ng-model=\"vm.provider.externalId\" numbers-only ng-pattern=\"/^[0-9]{1,10}(\\[0-9]{1})?$/\" ng-maxlength=\"10\"><div ng-show=\"editForm.externalId.$dirty && editForm.externalId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.externalId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</p></div></div><!-- [End External ID Section] --><!--signature--><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.provider.signature\">Signature</label><div class=\"row\"><div class=\"col-md-12\"><upload-images image-data=\"vm.provider.signature.data\"></upload-images></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/provider/providers.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.provider.home.title\">Providers</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3 has-feedback-left\"><form name=\"searchForm\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.provider.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search(vm.searchQuery):0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></form></div><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"provider.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.provider.home.createLabel\">Create a new Provider</span></button></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"title\"><span translate=\"ipmApp.provider.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"ipmApp.provider.firstName\">FirstName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"ipmApp.provider.lastName\">LastName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"contactNumber\"><span translate=\"ipmApp.provider.contactNumber\">ContactNumber</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"emailAddress\"><span translate=\"ipmApp.provider.emailAddress\">Email Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"provider in vm.providers track by provider.id\"><td>{{provider.title}}</td><td>{{provider.firstName}}</td><td>{{provider.lastName}}</td><td>{{provider.contactNumber | tel}}</td><td>{{provider.emailAddress | tel}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"provider-detail({id:provider.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"provider.edit({id:provider.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"provider.delete({id:provider.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" boundary-links=\"true\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/question/question-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.question.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"ipmApp.question.delete.title\"></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.question.delete.question\" translate-values=\"{name: \'{{vm.question.nameEn}}\'}\" ng-if=\"vm.question\">Are you sure you want to delete this Question?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/question/question-detail.html","<div><h2><span translate=\"ipmApp.question.detail.title\">Question</span> {{vm.question.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.question.nameEn\">NameEn</span></dt><dd><span>{{vm.question.nameEn}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.question.nameEs\">NameEs</span></dt><dd><span>{{vm.question.nameEs}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.question.type\">Type</span></dt><dd><span translate=\"{{\'ipmApp.QuestionType.\' + vm.question.type}}\">{{vm.question.type}}</span></dd><hr><dt><span translate=\"ipmApp.question.orderNumber\">OrderNumber</span></dt><dd><span>{{vm.question.orderNumber}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.question.section\">section</span></dt><dd><a ui-sref=\"section-detail({id:vm.question.sectionId})\">{{vm.question.sectionId}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/question/question-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myQuestionLabel\" translate=\"ipmApp.question.home.createOrEditLabel\">Create or edit a Question</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"ipmApp.question.nameEn\">NameEn</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"nameEn\" ng-model=\"vm.question.nameEn\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEn.$dirty && editForm.nameEn.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.required\" translate=\"ipmApp.question.error.requiredNameEnglish\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.question.nameEs\">NameEs</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"input-sm form-control\" name=\"nameEs\" ng-model=\"vm.question.nameEs\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEs.$dirty && editForm.nameEs.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.required\" translate=\"ipmApp.question.error.requiredNameSpanish\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><!--  dislay only MISC type --><div class=\"form-group\" ng-if=\"vm.isMiscType\"><label translate=\"ipmApp.section.questionType\" for=\"field_test\">Question Type</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" id=\"field_test\" name=\"questionType\" ng-model=\"vm.question.type\" ng-disabled=\"vm.question.id\" ng-change=\"vm.questionTypeChange()\" ng-options=\"item as \'ipmApp.HAQQuestionType.\'+item | translate for item in [\'SHORT_ANSWER\', \'RANK\', \'MULTIPLE_CHOICE\', \'MULTI_SELECT\', \'DATE_TIME\']\" required><option value=\"\"></option></select><div ng-show=\"editForm.questionType.$dirty && editForm.questionType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.questionType.$error.required\" translate=\"ipmApp.question.error.requiredQuestionType\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.question.type === \'RANK\' || vm.question.type === \'MULTIPLE_CHOICE\' || vm.question.type === \'MULTI_SELECT\'\"><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.question.options\"></span><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped optionQuestion\"><thead><tr><th></th><th><span translate=\"ipmApp.question.nameEn\">NameEn</span></th><th><span translate=\"ipmApp.question.nameEs\">NameEs</span></th><th>Value</th><th ng-if=\"vm.question.type !== \'RANK\'\"></th></tr></thead><tbody ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.question.options\"><tr ng-if=\"!option.deleted\" ng-repeat=\"option in vm.question.options track by $index\"><td>{{option.orderNumber}}.</td><td><div class=\"form-group mb-0\"><input type=\"text\" class=\"form-control\" name=\"nameEn_{{$index}}\" id=\"field_nameEn.{{$index}}\" value=\"{{option.nameEn}}\" ng-model=\"option.nameEn\" ng-required=\"vm.optionRequired($index)\"><div ng-show=\"editForm.nameEn_{{$index}}.$dirty && editForm.nameEn_{{$index}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.question.error.requiredNameEnglish\">This field is required.</p></div></div></td><td><div class=\"form-group mb-0\"><input type=\"text\" class=\"form-control\" name=\"nameEs_{{$index}}\" id=\"field_nameEs.{{$index}}\" value=\"{{option.nameEs}}\" ng-model=\"option.nameEs\" ng-required=\"vm.optionRequired($index)\"><div ng-show=\"editForm.nameEs_{{$index}}.$dirty && editForm.nameEs_{{$index}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.question.error.requiredNameSpanish\">This field is required.</p></div></div></td><td><div class=\"form-group mb-0\"><input type=\"text\" class=\"form-control\" name=\"value_{{$index}}\" id=\"field_value.{{$index}}\" value=\"{{option.value}}\" ng-model=\"option.value\" ng-pattern=\"/^[0-9]*$/\" ng-maxlength=\"5\" ng-required=\"vm.optionRequired($index)\"><div ng-show=\"editForm.value_{{$index}}.$dirty && editForm.value_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.value_{{$index}}.$error.required\" translate=\"ipmApp.question.error.requiredValue\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.value_{{$index}}.$error.pattern || editForm.value_{{$index}}.$error.maxlength\" translate=\"ipmApp.question.error.numberValue\">This field is required.</p></div></div></td><td ng-if=\"vm.question.type !== \'RANK\'\" style=\"text-align: right\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"(vm.question.type === \'RANK\' && vm.question.options.length > 1) || vm.question.options.length > 2\" ng-click=\"vm.removeOption(option.id)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody><tfoot ng-if=\"vm.question.options.length < vm.maxOption\"><tr><td colspan=\"{{vm.question.type !== \'RANK\' ? 5: 4}}\" style=\"text-align: right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.addOption()\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tfoot></table></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/question/questions.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.question.home.title\">Questions</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3 has-feedback-left\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.question.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search():0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></div><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"question.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.question.home.createLabel\">Create a new Question</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"ipmApp.question.nameEn\">NameEn</span></th><th><span translate=\"ipmApp.question.nameEs\">NameEs</span></th><th><span translate=\"ipmApp.question.type\">Type</span></th><th><span translate=\"ipmApp.question.orderNumber\">OrderNumber</span></th><th><span translate=\"ipmApp.question.section\">section</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"question in vm.questions track by question.id\"><td><a ui-sref=\"question-detail({id:question.id})\">{{question.id}}</a></td><td>{{question.nameEn}}</td><td>{{question.nameEs}}</td><td translate=\"{{\'ipmApp.QuestionType.\' + question.type}}\">{{question.type}}</td><td>{{question.orderNumber}}</td><td><a ui-sref=\"section-detail({id:question.sectionId})\">{{question.sectionId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"question-detail({id:question.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"question.edit({id:question.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"question.delete({id:question.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr><tr ng-if=\"!vm.questions || vm.questions.length === 0\"><td colspan=\"5\"><p class=\"help-block text-center\" translate=\"ipmApp.question.home.listEmpty\">There is no Question</p></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/office/office-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.office.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.office.delete.title\">Delete confirmation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.office.delete.question\" translate-values=\"{id: \'{{vm.office.name}}\'}\">Are you sure you want to delete this Office?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/office/office-detail.html","<div class=\"page page--office\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\"><span translate=\"ipmApp.office.detail.title\">Office</span> \"{{vm.office.name}}\"</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"table table-striped\"><tbody><tr><td><span translate=\"ipmApp.office.name\">Name</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.office.name}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.office.officeCode\">Office Code</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.office.officeCode}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.office.testAdminBy\">Test Admin By</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.office.testAdminBy | capitalize}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.office.address\">Address</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.office.address}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.office.phoneNumber\">Phone Number</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.office.phoneNumber}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.office.faxNumber\">Fax Number</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.office.faxNumber}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"ipmApp.office.contactNumber\">Mobile Phone</span></td><td><span translate=\"ipmApp.office.contact.emailAddress\">Email</span></td></tr><tr ng-repeat=\"contact in vm.office.contacts\"><td><input type=\"tel\" class=\"input-sm form-control\" value=\"{{contact.phoneNumber | tel}}\" readonly=\"readonly\"></td><td><input class=\"input-sm form-control\" value=\"{{contact.emailAddress}}\" readonly=\"readonly\"></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ui-sref=\"office\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/entities/office/office-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myOfficeLabel\" translate=\"ipmApp.office.home.createOrEditLabel\">Create or edit a Office</h5></div><div class=\"modal-body\"><div class=\"alert alert-danger\" ng-show=\"vm.duplicatePhoneNumber\">Mobile Phones are duplicated!</div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.office.name\" for=\"field_name\">Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" required ng-model=\"vm.office.name\" ng-maxlength=\"50\"><div ng-show=\"editForm.name.$dirty && editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"ipmApp.office.name.required\">The Name is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.office.officeCode\" for=\"field_officeCode\">Office Code</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"officeCode\" id=\"field_officeCode\" required ng-model=\"vm.office.officeCode\" ng-maxlength=\"50\"><div ng-show=\"editForm.officeCode.$dirty && editForm.officeCode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.officeCode.$error.required\" translate=\"ipmApp.office.officeCode.required\">The Office Code is required.</p><p class=\"help-block\" ng-show=\"editForm.officeCode.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div><div ng-show=\"!editForm.officeCode.$invalid && vm.errorOfficeCodeExists\"><p class=\"help-block\" translate=\"ipmApp.office.officeCodeExist\">Office code is already in use!</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.office.testAdminBy\" for=\"field_officeCode\">Tests Administered by</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"testAdminBy\" ng-model=\"vm.office.testAdminBy\" id=\"testAdminBy\" ng-options=\"testAdminBy.value as testAdminBy.name for testAdminBy in vm.testAdminBy\" required><option value=\"\" selected=\"selected\"></option></select></div><div class=\"form-group\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"isFrpProgram\" ng-model=\"vm.office.isFrpProgram\" id=\"isFrpProgram\"><label class=\"form-check-label-v4\" for=\"isFrpProgram\" translate=\"ipmApp.office.frp\">FRP</label></div><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"isMde\" ng-model=\"vm.office.isMde\" id=\"isMde\"><label class=\"form-check-label-v4\" for=\"isMde\" translate=\"ipmApp.office.mde\">MDE</label></div></div><div ng-if=\"vm.office.isFrpProgram || vm.office.isMde\" ng-include=\"\'detail-frp-mde\'\"></div><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\" translate=\"ipmApp.office.contact.phoneNumber\" for=\"field_contactNumber\">Mobile Phone</label></div><div class=\"col-md-6\"><label translate=\"ipmApp.office.contact.emailAddress\" for=\"field_email\">Email</label></div></div><div ng-repeat=\"contact in vm.office.contacts track by $index\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><input type=\"text\" class=\"form-control\" phone-input name=\"contactNumber_{{$index}}\" id=\"field_contactNumber\" ng-maxlength=\"100\" ng-model=\"contact.phoneNumber\" ng-required=\"contact.emailAddress\"><div ng-show=\"editForm.contactNumber_{{$index}}.$dirty && editForm.contactNumber_{{$index}}.$invalid\"><div ng-show=\"editForm.contactNumber_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"ipmApp.office.contactNumber.required\">This field is required.</p></div></div></div><div class=\"col-sm-5 col-xs-12\"><input type=\"email\" class=\"form-control\" name=\"email_{{$index}}\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-model=\"contact.emailAddress\" ng-maxlength=\"100\" ng-required=\"contact.phoneNumber\"><div ng-show=\"editForm.email_{{$index}}.$dirty && editForm.email_{{$index}}.$invalid\"><div ng-show=\"editForm.email_{{$index}}.$error.maxlength\"><p class=\"help-block\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div><div ng-show=\"editForm.email_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"ipmApp.office.email.required\">This field is required.</p></div><div ng-show=\"editForm.email_{{$index}}.$error.email\"><p class=\"help-block\">Your e-mail is invalid.</p></div></div></div><div class=\"col-sm-3 col-xs-12\"><button ng-show=\"vm.office.contacts.length > 1\" ng-click=\"vm.removePhone($index)\" type=\"button\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-minus\"></button> <button ng-show=\"$index === vm.office.contacts.length - 1\" ng-click=\"vm.addPhone()\" type=\"button\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-plus\"></button></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form><script type=\"text/ng-template\" id=\"detail-frp-mde\"><div class=\"form-group\">\n        <label class=\"control-label\" translate=\"ipmApp.office.address\" for=\"field_address\">address</label>\n        <input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\"\n               ng-model=\"vm.office.address\" ng-maxlength=\"255\"/>\n        <div ng-show=\"editForm.address.$dirty && editForm.address.$invalid\">\n            <p class=\"help-block\"\n               ng-show=\"editForm.address.$error.maxlength\" translate=\"entity.validation.maxlength\"\n               translate-value-max=\"255\">\n                This field cannot be longer than 255 characters.\n            </p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label class=\"control-label\" translate=\"ipmApp.office.phoneNumber\" for=\"field_phoneNumber\">phoneNumber</label>\n        <input type=\"text\" phone-input class=\"form-control\" name=\"phoneNumber\" id=\"field_phoneNumber\"\n               ng-model=\"vm.office.phoneNumber\" ng-maxlength=\"50\"/>\n        <div ng-show=\"editForm.phoneNumber.$dirty && editForm.phoneNumber.$invalid\">\n            <p class=\"help-block\"\n               ng-show=\"editForm.phoneNumber.$error.maxlength\" translate=\"entity.validation.maxlength\"\n               translate-value-max=\"50\">\n                This field cannot be longer than 50 characters.\n            </p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label class=\"control-label\" translate=\"ipmApp.office.faxNumber\" for=\"field_faxNumber\">faxNumber</label>\n        <input type=\"text\" phone-input class=\"form-control\" name=\"faxNumber\" id=\"field_faxNumber\"\n               ng-model=\"vm.office.faxNumber\" ng-maxlength=\"50\"/>\n        <div ng-show=\"editForm.faxNumber.$dirty && editForm.faxNumber.$invalid\">\n            <p class=\"help-block\"\n               ng-show=\"editForm.faxNumber.$error.maxlength\" translate=\"entity.validation.maxlength\"\n               translate-value-max=\"50\">\n                This field cannot be longer than 50 characters.\n            </p>\n        </div>\n    </div></script>");
$templateCache.put("app/entities/office/offices.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.office.home.title\">Offices</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3 has-feedback-left\"><form name=\"searchForm\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.office.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search(vm.searchQuery):0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></form></div><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"office.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.office.home.createLabel\">Create a new Office</span></button></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"name\"><span translate=\"ipmApp.office.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"ipmApp.office.officeCode\">Office Code</span></th><th><span translate=\"ipmApp.office.frp\">FRP</span></th><th><span translate=\"ipmApp.office.mde\">MDE</span></th><th><span translate=\"ipmApp.office.contactNumber\">ContactNumber</span></th><th><span translate=\"ipmApp.office.contact.emailAddress\">EmailAddress</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"office in vm.offices track by office.id\"><td>{{office.name}}</td><td>{{office.officeCode}}</td><td><input type=\"checkbox\" id=\"office_frp_{{office.id}}\" name=\"office_frp_{{office.id}}\" ng-disabled=\"true\" value=\"{{office.name}}\" ng-model=\"office.isFrpProgram\"></td><td><input type=\"checkbox\" id=\"office_mde_{{office.id}}\" name=\"office_mde_{{office.id}}\" ng-disabled=\"true\" value=\"{{office.name}}\" ng-model=\"office.isMde\"></td><td><span uib-tooltip=\"{{office.listPhoneNumber}}\">{{office.listPhoneNumberToShow}}</span></td><td><span uib-tooltip=\"{{office.listEmailAddress}}\">{{office.listEmailAddressToShow}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"office-detail({id:office.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"office.edit({id:office.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"office.delete({id:office.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" boundary-links=\"true\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/question-option/question-option-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.questionOption.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.questionOption.delete.question\" translate-values=\"{id: \'{{vm.questionOption.id}}\'}\">Are you sure you want to delete this QuestionOption?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/question-option/question-option-detail.html","<div><h2><span translate=\"ipmApp.questionOption.detail.title\">QuestionOption</span> {{vm.questionOption.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.questionOption.nameEn\">NameEn</span></dt><dd><span>{{vm.questionOption.nameEn}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.questionOption.nameEs\">NameEs</span></dt><dd><span>{{vm.questionOption.nameEs}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.questionOption.orderNumber\">OrderNumber</span></dt><dd><span>{{vm.questionOption.orderNumber}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.questionOption.value\">Value</span></dt><dd><span>{{vm.questionOption.value}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.questionOption.question\">question</span></dt><dd><a ui-sref=\"question-detail({id:vm.questionOption.questionId})\">{{vm.questionOption.questionId}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/question-option/question-option-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myQuestionOptionLabel\" translate=\"ipmApp.questionOption.home.createOrEditLabel\">Create or edit a QuestionOption</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.questionOption.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.questionOption.nameEn\" for=\"field_nameEn\">NameEn</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.questionOption.nameEn\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.questionOption.nameEs\" for=\"field_nameEs\">NameEs</label><input type=\"text\" class=\"form-control\" name=\"nameEs\" id=\"field_nameEs\" ng-model=\"vm.questionOption.nameEs\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.questionOption.orderNumber\" for=\"field_orderNumber\">OrderNumber</label><input type=\"number\" class=\"form-control\" name=\"orderNumber\" id=\"field_orderNumber\" ng-model=\"vm.questionOption.orderNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.questionOption.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.questionOption.value\"></div><div class=\"form-group\"><label translate=\"ipmApp.questionOption.question\" for=\"field_question\">question</label><select class=\"form-control\" id=\"field_question\" name=\"question\" ng-model=\"vm.questionOption.questionId\" ng-options=\"question.id as question.id for question in vm.questions\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/question-option/question-options.html","<div><h2 translate=\"ipmApp.questionOption.home.title\">QuestionOptions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"question-option.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"ipmApp.questionOption.home.createLabel\">Create new QuestionOption</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.questionOption.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"ipmApp.questionOption.nameEn\">NameEn</span></th><th><span translate=\"ipmApp.questionOption.nameEs\">NameEs</span></th><th><span translate=\"ipmApp.questionOption.orderNumber\">OrderNumber</span></th><th><span translate=\"ipmApp.questionOption.value\">Value</span></th><th><span translate=\"ipmApp.questionOption.question\">question</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"questionOption in vm.questionOptions track by questionOption.id\"><td><a ui-sref=\"question-option-detail({id:questionOption.id})\">{{questionOption.id}}</a></td><td>{{questionOption.nameEn}}</td><td>{{questionOption.nameEs}}</td><td>{{questionOption.orderNumber}}</td><td>{{questionOption.value}}</td><td><a ui-sref=\"question-detail({id:questionOption.questionId})\">{{questionOption.questionId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"question-option-detail({id:questionOption.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"question-option.edit({id:questionOption.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"question-option.delete({id:questionOption.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/section/section-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.section.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.section.delete.question\" translate-values=\"{id: \'{{vm.section.id}}\'}\">Are you sure you want to delete this Section?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/section/section-detail.html","<div><h2><span translate=\"ipmApp.section.detail.title\">Section</span> {{vm.section.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.section.nameEn\">NameEn</span></dt><dd><span>{{vm.section.nameEn}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.section.nameEs\">NameEs</span></dt><dd><span>{{vm.section.nameEs}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.section.orderNumber\">OrderNumber</span></dt><dd><span>{{vm.section.orderNumber}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.section.instructionsEn\">InstructionsEn</span></dt><dd><span>{{vm.section.instructionsEn}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.section.instructionsEs\">InstructionsEs</span></dt><dd><span>{{vm.section.instructionsEs}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.section.test\">test</span></dt><dd><a ui-sref=\"test-detail({id:vm.section.testId})\">{{vm.section.testId}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/section/section-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySectionLabel\" translate=\"ipmApp.section.home.createOrEditLabel\">Create or edit a Section</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.section.orderNumber\" for=\"field_orderNumber\">OrderNumber</label><input type=\"number\" class=\"form-control\" name=\"orderNumber\" id=\"field_orderNumber\" ng-model=\"vm.section.orderNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.section.nameEn\" for=\"field_nameEn\">NameEn</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.section.nameEn\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.section.nameEs\" for=\"field_nameEs\">NameEs</label><input type=\"text\" class=\"form-control\" name=\"nameEs\" id=\"field_nameEs\" ng-model=\"vm.section.nameEs\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.section.instructionsEn\" for=\"field_instructionsEn\">InstructionsEn</label><input type=\"text\" class=\"form-control\" name=\"instructionsEn\" id=\"field_instructionsEn\" ng-model=\"vm.section.instructionsEn\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.section.instructionsEs\" for=\"field_instructionsEs\">InstructionsEs</label><input type=\"text\" class=\"form-control\" name=\"instructionsEs\" id=\"field_instructionsEs\" ng-model=\"vm.section.instructionsEs\"></div><div class=\"form-group\"><label translate=\"ipmApp.section.test\" for=\"field_test\">test</label><select class=\"form-control\" id=\"field_test\" name=\"test\" ng-model=\"vm.section.testId\" ng-options=\"test.id as test.id for test in vm.tests\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"ipmApp.section.questionType\" for=\"field_test\">Question Type</label><select class=\"form-control\" id=\"field_test\" name=\"test\" ng-model=\"vm.section.questionType\" ng-options=\"item as \'ipmApp.HAQQuestionType.\'+item | translate for item in [\'RANK\', \'SHORT_ANSWER\', \'MULTIPLE_CHOICE\', \'MULTI_SELECT\', \'DATE_TIME\']\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/section/section-editor.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" ng-if=\"!vm.section.id\"><span translate=\"ipmApp.section.home.new\"></span></div><div class=\"h2 title\" ng-if=\"vm.section.id\"><span translate=\"ipmApp.section.home.edit\"></span></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><table class=\"table table-striped\"><tbody><tr><td style=\"width: 15%\"><label class=\"control-label\" translate=\"ipmApp.section.nameEn\" for=\"field_nameEn\">NameEn</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></td><td><div class=\"form-group\"><input type=\"text\" class=\"input-sm form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.section.nameEn\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEn.$dirty && editForm.nameEn.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.required\" translate=\"ipmApp.section.error.requiredNameEnglish\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div></td></tr><tr><td><span translate=\"ipmApp.section.nameEs\">NameEs</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></td><td><div class=\"form-group\"><input type=\"text\" class=\"input-sm form-control\" name=\"nameEs\" ng-model=\"vm.section.nameEs\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEs.$dirty && editForm.nameEs.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.required\" translate=\"ipmApp.section.error.requiredNameSpanish\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div></td></tr><tr><td><span translate=\"ipmApp.section.instructionsEn\">InstructionsEn</span></td><td><input type=\"text\" class=\"input-sm form-control\" ng-model=\"vm.section.instructionsEn\"></td></tr><tr><td><span translate=\"ipmApp.section.instructionsEs\">InstructionsEs</span></td><td><input type=\"text\" class=\"input-sm form-control\" ng-model=\"vm.section.instructionsEs\"></td></tr><tr><td><span translate=\"ipmApp.section.questionType\">Question Type</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></td><td><div class=\"form-group\"><select class=\"form-control\" id=\"field_test\" name=\"questionType\" ng-model=\"vm.section.questionType\" ng-disabled=\"vm.section.questions && vm.section.questions.length > 0\" ng-options=\"item as \'ipmApp.HAQQuestionType.\'+item | translate for item in [\'SHORT_ANSWER\', \'RANK\', \'MULTIPLE_CHOICE\', \'MULTI_SELECT\', \'DATE_TIME\', \'MISC\']\" ng-change=\"vm.questionTypeChange()\" required><option value=\"\"></option></select><div ng-show=\"editForm.questionType.$dirty && editForm.questionType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.questionType.$error.required\" translate=\"ipmApp.section.error.requiredQuestionType\">This field is required.</p></div></div></td></tr><tr><td colspan=\"2\" style=\"text-align: right\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button></td></tr></tbody></table></form></div></div></div><div ng-if=\"vm.section.id\"><div class=\"h2 title\"><span translate=\"ipmApp.question.home.title\">Questions</span></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"test.edit.section-editor.questionNew({})\" ng-disabled=\"vm.disabledCreateQuestion\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.question.home.createLabel\">Create a new Question</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.section.questions\"><thead><tr><th><span translate=\"ipmApp.question.nameEn\">NameEn</span></th><th><span translate=\"ipmApp.question.nameEs\">NameEs</span></th><th><span translate=\"ipmApp.question.InvertScoring\">InvertScoring</span></th><th></th></tr></thead><tbody ng-repeat=\"question in vm.section.questions track by question.id\"><tr><td>{{question.orderNumber ? question.orderNumber : ($index + 1)}}. {{question.nameEn}}</td><td>{{question.nameEs}}</td><td><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': question.invertScoring}\" ng-click=\"vm.invertScoring(question)\"></button></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"test.edit.section-editor.questionEdit({id:vm.section.testId, sectionId:vm.section.id, questionId:question.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-click=\"vm.deleteQuestion(question, $index)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr><tr ng-repeat=\"option in question.options track by option.id\" ng-if=\"option.nameEs || option.nameEn || option.value\"><td style=\"padding-left: 40px\">{{option.orderNumber ? option.orderNumber : ($index+1) }}. {{option.nameEn}}</td><td>{{option.nameEs}}</td><td></td><td></td></tr></tbody><tbody><tr ng-if=\"!vm.section.questions || vm.section.questions.length === 0\"><td colspan=\"5\"><p class=\"help-block text-center\" translate=\"ipmApp.question.home.listEmpty\">There is no Question</p></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/entities/section/sections-test.html","<div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.section.home.title\">Sections</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"test.edit.section-new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.section.home.createLabel\">Create a new Section</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"ipmApp.section.orderNumber\">OrderNumber</span></th><th><span translate=\"ipmApp.section.nameEn\">NameEn</span></th><th><span translate=\"ipmApp.section.nameEs\">NameEs</span></th><th><span translate=\"ipmApp.section.questionType\">Question Type</span></th><th></th></tr></thead><tbody ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.sections\"><tr ng-repeat=\"section in vm.sections track by section.id\"><td>{{section.orderNumber}}</td><td>{{section.nameEn}}</td><td>{{section.nameEs}}</td><td>{{\'ipmApp.HAQQuestionType.\' + section.questionType | translate}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"test.edit.section-editor({sectionId: section.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button><!-- <button type=\"submit\"\n                                    ui-sref=\"section.delete({id:section.id})\"\n                                    class=\"btn btn-danger btn-sm\">\n                                <span class=\"glyphicon glyphicon-remove-circle\"></span>\n                                <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>\n                            </button> --></div></td></tr><tr ng-if=\"!vm.sections || vm.sections.length === 0\"><td colspan=\"5\"><p class=\"help-block text-center\" translate=\"ipmApp.section.home.listEmpty\">There is no Section</p></td></tr></tbody></table></div><div class=\"text-center\" ng-if=\"false\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.getSectionByTest()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/section/sections.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.section.home.title\">Sections</div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-6 col-sm-8 col-xs-12 voffset3 has-feedback-left\"><input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.section.home.search\' | translate }}\" ng-keypress=\"($event.which === 13)?vm.search():0\"> <span class=\"form-control-feedback glyphicon glyphicon-search\"></span></div><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"section.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.section.home.createLabel\">Create a new Section</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"ipmApp.section.orderNumber\">OrderNumber</span></th><th><span translate=\"ipmApp.section.nameEn\">NameEn</span></th><th><span translate=\"ipmApp.section.nameEs\">NameEs</span></th><th><span translate=\"ipmApp.section.questionType\">Question Type</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"section in vm.sections track by section.id\"><td>{{section.orderNumber}}</td><td>{{section.nameEn}}</td><td>{{section.nameEs}}</td><td>{{\'ipmApp.HAQQuestionType.\' + section.questionType | translate}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"section-editor({id:section.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"section.edit({id:section.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"section.delete({id:section.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/survey-response/survey-response-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.surveyResponse.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.surveyResponse.delete.question\" translate-values=\"{id: \'{{vm.surveyResponse.id}}\'}\">Are you sure you want to delete this SurveyResponse?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/survey-response/survey-response-detail.html","<div><h2><span translate=\"ipmApp.surveyResponse.detail.title\">SurveyResponse</span> {{vm.surveyResponse.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.surveyResponse.answer\">Answer</span></dt><dd><span>{{vm.surveyResponse.answer}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.surveyResponse.value\">Value</span></dt><dd><span>{{vm.surveyResponse.value}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.surveyResponse.batteryTest\">batteryTest</span></dt><dd><a ui-sref=\"battery-test-detail({id:vm.surveyResponse.batteryTestId})\">{{vm.surveyResponse.batteryTestId}}</a></dd><hr><dt><span translate=\"ipmApp.surveyResponse.patient\">patient</span></dt><dd><a ui-sref=\"patient-detail({id:vm.surveyResponse.patientId})\">{{vm.surveyResponse.patientId}}</a></dd><hr><dt><span translate=\"ipmApp.surveyResponse.question\">question</span></dt><dd><a ui-sref=\"question-detail({id:vm.surveyResponse.questionId})\">{{vm.surveyResponse.questionId}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/survey-response/survey-response-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySurveyResponseLabel\" translate=\"ipmApp.surveyResponse.home.createOrEditLabel\">Create or edit a SurveyResponse</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.surveyResponse.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.surveyResponse.answer\" for=\"field_answer\">Answer</label><input type=\"text\" class=\"form-control\" name=\"answer\" id=\"field_answer\" ng-model=\"vm.surveyResponse.answer\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.surveyResponse.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.surveyResponse.value\"></div><div class=\"form-group\"><label translate=\"ipmApp.surveyResponse.batteryTest\" for=\"field_batteryTest\">batteryTest</label><select class=\"form-control\" id=\"field_batteryTest\" name=\"batteryTest\" ng-model=\"vm.surveyResponse.batteryTestId\" ng-options=\"batteryTest.id as batteryTest.id for batteryTest in vm.batterytests\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"ipmApp.surveyResponse.patient\" for=\"field_patient\">patient</label><select class=\"form-control\" id=\"field_patient\" name=\"patient\" ng-model=\"vm.surveyResponse.patientId\" ng-options=\"patient.id as patient.id for patient in vm.patients\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"ipmApp.surveyResponse.question\" for=\"field_question\">question</label><select class=\"form-control\" id=\"field_question\" name=\"question\" ng-model=\"vm.surveyResponse.questionId\" ng-options=\"question.id as question.id for question in vm.questions\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/survey-response/survey-responses.html","<div><h2 translate=\"ipmApp.surveyResponse.home.title\">SurveyResponses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"survey-response.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"ipmApp.surveyResponse.home.createLabel\">Create new SurveyResponse</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.surveyResponse.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"ipmApp.surveyResponse.answer\">Answer</span></th><th><span translate=\"ipmApp.surveyResponse.value\">Value</span></th><th><span translate=\"ipmApp.surveyResponse.batteryTest\">batteryTest</span></th><th><span translate=\"ipmApp.surveyResponse.patient\">patient</span></th><th><span translate=\"ipmApp.surveyResponse.question\">question</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"surveyResponse in vm.surveyResponses track by surveyResponse.id\"><td><a ui-sref=\"survey-response-detail({id:surveyResponse.id})\">{{surveyResponse.id}}</a></td><td>{{surveyResponse.answer}}</td><td>{{surveyResponse.value}}</td><td><a ui-sref=\"battery-test-detail({id:surveyResponse.batteryTestId})\">{{surveyResponse.batteryTestId}}</a></td><td><a ui-sref=\"patient-detail({id:surveyResponse.patientId})\">{{surveyResponse.patientId}}</a></td><td><a ui-sref=\"question-detail({id:surveyResponse.questionId})\">{{surveyResponse.questionId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"survey-response-detail({id:surveyResponse.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"survey-response.edit({id:surveyResponse.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"survey-response.delete({id:surveyResponse.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/survey-result/survey-result-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.surveyResult.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.surveyResult.delete.question\" translate-values=\"{id: \'{{vm.surveyResult.id}}\'}\">Are you sure you want to delete this SurveyResult?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/survey-result/survey-result-detail.html","<div><h2><span translate=\"ipmApp.surveyResult.detail.title\">SurveyResult</span> {{vm.surveyResult.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.surveyResult.status\">Status</span></dt><dd><span translate=\"{{\'ipmApp.SurveyResultStatus.\' + vm.surveyResult.status}}\">{{vm.surveyResult.status}}</span></dd><hr><dt><span translate=\"ipmApp.surveyResult.createdDate\">CreatedDate</span></dt><dd><span>{{vm.surveyResult.createdDate | date:\'medium\'}}</span></dd><hr><dt><span translate=\"ipmApp.surveyResult.lastModifiedDate\">LastModifiedDate</span></dt><dd><span>{{vm.surveyResult.lastModifiedDate | date:\'medium\'}}</span></dd><hr><dt><span translate=\"ipmApp.surveyResult.disposition\">Disposition</span></dt><dd><span>{{vm.surveyResult.disposition}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.surveyResult.patient\">patient</span></dt><dd><a ui-sref=\"patient-detail({id:vm.surveyResult.patientId})\">{{vm.surveyResult.patientId}}</a></dd><hr><dt><span translate=\"ipmApp.surveyResult.battery\">battery</span></dt><dd><a ui-sref=\"battery-detail({id:vm.surveyResult.batteryId})\">{{vm.surveyResult.batteryId}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/survey-result/survey-result-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySurveyResultLabel\" translate=\"ipmApp.surveyResult.home.createOrEditLabel\">Create or edit a SurveyResult</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.surveyResult.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.surveyResult.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.surveyResult.status\" id=\"field_status\"><option value=\"NOT_STARTED\" translate=\"ipmApp.SurveyResultStatus.NOT_STARTED\">NOT_STARTED</option><option value=\"STARTED\" translate=\"ipmApp.SurveyResultStatus.STARTED\">STARTED</option><option value=\"COMPLETE\" translate=\"ipmApp.SurveyResultStatus.COMPLETE\">COMPLETE</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.surveyResult.createdDate\" for=\"field_createdDate\">CreatedDate</label><div class=\"input-group\"><input id=\"field_createdDate\" type=\"text\" class=\"form-control\" name=\"createdDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.surveyResult.createdDate\" is-open=\"vm.datePickerOpenStatus.createdDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createdDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.surveyResult.lastModifiedDate\" for=\"field_lastModifiedDate\">LastModifiedDate</label><div class=\"input-group\"><input id=\"field_lastModifiedDate\" type=\"text\" class=\"form-control\" name=\"lastModifiedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.surveyResult.lastModifiedDate\" is-open=\"vm.datePickerOpenStatus.lastModifiedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastModifiedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.surveyResult.disposition\" for=\"field_disposition\">Disposition</label><input type=\"checkbox\" class=\"form-control\" name=\"disposition\" id=\"field_disposition\" ng-model=\"vm.surveyResult.disposition\"></div><div class=\"form-group\"><label translate=\"ipmApp.surveyResult.patient\" for=\"field_patient\">patient</label><select class=\"form-control\" id=\"field_patient\" name=\"patient\" ng-model=\"vm.surveyResult.patientId\" ng-options=\"patient.id as patient.id for patient in vm.patients\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"ipmApp.surveyResult.battery\" for=\"field_battery\">battery</label><select class=\"form-control\" id=\"field_battery\" name=\"battery\" ng-model=\"vm.surveyResult.batteryId\" ng-options=\"battery.id as battery.id for battery in vm.batterys\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/survey-result/survey-results.html","<div><h2 translate=\"ipmApp.surveyResult.home.title\">SurveyResults</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"survey-result.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"ipmApp.surveyResult.home.createLabel\">Create new SurveyResult</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.surveyResult.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"ipmApp.surveyResult.status\">Status</span></th><th><span translate=\"ipmApp.surveyResult.createdDate\">CreatedDate</span></th><th><span translate=\"ipmApp.surveyResult.lastModifiedDate\">LastModifiedDate</span></th><th><span translate=\"ipmApp.surveyResult.disposition\">Disposition</span></th><th><span translate=\"ipmApp.surveyResult.patient\">patient</span></th><th><span translate=\"ipmApp.surveyResult.battery\">battery</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"surveyResult in vm.surveyResults track by surveyResult.id\"><td><a ui-sref=\"survey-result-detail({id:surveyResult.id})\">{{surveyResult.id}}</a></td><td translate=\"{{\'ipmApp.SurveyResultStatus.\' + surveyResult.status}}\">{{surveyResult.status}}</td><td>{{surveyResult.createdDate | date:\'medium\'}}</td><td>{{surveyResult.lastModifiedDate | date:\'medium\'}}</td><td>{{surveyResult.disposition}}</td><td><a ui-sref=\"patient-detail({id:surveyResult.patientId})\">{{surveyResult.patientId}}</a></td><td><a ui-sref=\"battery-detail({id:surveyResult.batteryId})\">{{surveyResult.batteryId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"survey-result-detail({id:surveyResult.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"survey-result.edit({id:surveyResult.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"survey-result.delete({id:surveyResult.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/test/test-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.test.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.test.delete.question\" translate-values=\"{id: \'{{vm.test.id}}\'}\">Are you sure you want to delete this Test?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/test/test-detail.html","<div><h2><span translate=\"ipmApp.test.detail.title\">Test</span> {{vm.test.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"ipmApp.test.nameEn\">NameEn</span></dt><dd><span>{{vm.test.nameEn}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.test.nameEs\">NameEs</span></dt><dd><span>{{vm.test.nameEs}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.test.instructionsEn\">InstructionsEn</span></dt><dd><span>{{vm.test.instructionsEn}}<span></span></span></dd><hr><dt><span translate=\"ipmApp.test.instructionsEs\">InstructionsEs</span></dt><dd><span>{{vm.test.instructionsEs}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/test/test-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTestLabel\" translate=\"ipmApp.test.home.createOrEditLabel\">Create or edit a Test</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.test.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.nameEn\" for=\"field_nameEn\">NameEn</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.test.nameEn\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.nameEs\" for=\"field_nameEs\">NameEs</label><input type=\"text\" class=\"form-control\" name=\"nameEs\" id=\"field_nameEs\" ng-model=\"vm.test.nameEs\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.instructionsEn\" for=\"field_instructionsEn\">InstructionsEn</label><input type=\"text\" class=\"form-control\" name=\"instructionsEn\" id=\"field_instructionsEn\" ng-model=\"vm.test.instructionsEn\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.instructionsEs\" for=\"field_instructionsEs\">InstructionsEs</label><input type=\"text\" class=\"form-control\" name=\"instructionsEs\" id=\"field_instructionsEs\" ng-model=\"vm.test.instructionsEs\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/test/test-editor.html","<div class=\"page page--section\" ng-if=\"vm.test\"><div class=\"container\"><div class=\"content\"><!-- Title --><div class=\"h2 title\"><span translate=\"ipmApp.test.view.title\" ng-if=\"vm.isView === true\"></span> <span translate=\"ipmApp.test.duplicate.title\" ng-if=\"vm.isDuplicate === true\"></span> <span translate=\"ipmApp.test.addNew.title\" ng-if=\"vm.isCreateNew === true\"></span> <span translate=\"ipmApp.test.edit.title\" ng-if=\"vm.isEdit === true\"></span></div><!-- content --><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!-- Name En --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.nameEn\" for=\"field_nameEn\">NameEn</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.test.nameEn\" ng-disabled=\"vm.isView\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEn.$dirty && editForm.nameEn.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.required\" translate=\"ipmApp.test.error.requiredNameEnglish\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEn.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><!-- Name Es --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.nameEs\" for=\"field_nameEs\">NameEs</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"nameEs\" id=\"field_nameEs\" ng-model=\"vm.test.nameEs\" ng-disabled=\"vm.isView\" ng-maxlength=\"255\" required><div ng-show=\"editForm.nameEs.$dirty && editForm.nameEs.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.required\" translate=\"ipmApp.test.error.requiredNameSpanish\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nameEs.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><!-- PDF Description --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.pdfDescription\" for=\"field_pdfDescription\">PDF Description</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><textarea id=\"field_pdfDescription\" ng-model=\"vm.test.pdfDescription\" name=\"pdfDescription\" ng-hide=\"true\" required></textarea><quill-editor class=\"d-block min-height-115\" ids=\"\'pdfDescription\'\" id=\"pdfDescription\" hide-toolbar=\"true\" name=\"pdfDescription\" value=\"vm.test.pdfDescription\" view=\"vm.isView\" on-edit-change=\"vm.handlePdfDescription(data, editForm)\" required></quill-editor><div ng-show=\"editForm.pdfDescription.$dirty && editForm.pdfDescription.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pdfDescription.$error.required\" translate=\"ipmApp.test.error.requiredPdfDescription\">This field is required.</p></div></div><!-- Instruction En --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.instructionsEn\" for=\"field_instructionsEn\">InstructionsEn</label><quill-editor class=\"d-block min-height-115\" ids=\"\'instructionsEn\'\" id=\"instructionsEn\" value=\"vm.test.instructionsEn\" view=\"vm.isView\" on-edit-change=\"vm.handleInstructionsEn(data)\"></quill-editor></div><!-- Instruction Es --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.instructionsEs\" for=\"field_instructionsEs\">InstructionsEs</label><quill-editor class=\"d-block min-height-115\" ids=\"\'instructionsEs\'\" id=\"instructionsEs\" value=\"vm.test.instructionsEs\" view=\"vm.isView\" on-edit-change=\"vm.handleInstructionsEs(data)\"></quill-editor></div><!-- Scoring Type --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.scoringType\" for=\"field_scoringType\">Scoring Type</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"scoringType\" id=\"scoringType\" ng-model=\"vm.test.scoringType\" required ng-options=\"scoringType as \'ipmApp.test.typeOfScoringType.\' + scoringType | translate for scoringType in vm.scoringTypes track by scoringType\" ng-disabled=\"vm.isView\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.scoringType.$dirty && editForm.scoringType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.scoringType.$error.required\" translate=\"ipmApp.test.error.requiredScoringType\">This field is required.</p></div></div><!-- Threshold Type --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.thresholdType \" for=\"field_thresholdType\">Threshold Type</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"thresholdType\" id=\"thresholdType\" ng-model=\"vm.test.thresholdType\" required ng-options=\"thresholdType as \'ipmApp.test.typeOfThresholdType.\' + thresholdType | translate for thresholdType in vm.thresholdTypes track by thresholdType\" ng-disabled=\"vm.isView\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.thresholdType.$dirty && editForm.thresholdType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.thresholdType.$error.required\" translate=\"ipmApp.test.error.requiredThresholdType\">This field is required.</p></div></div><!-- Threshold value --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.thresholdValue \" for=\"field_thresholdValue\">Threshold Value</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" ng-if=\"vm.test.thresholdType && vm.test.thresholdType !== \'NONE\'\"></span> <input type=\"text\" class=\"form-control\" name=\"thresholdValue\" id=\"field_thresholdValue\" ng-required=\"vm.test.thresholdType && vm.test.thresholdType !== \'NONE\'\" ng-model=\"vm.test.thresholdValue\" ng-disabled=\"vm.isView\" ng-pattern=\"/^[0-9]*$/\" ng-maxlength=\"5\"><div ng-show=\"editForm.thresholdValue.$dirty && editForm.thresholdValue.$invalid\"><p class=\"help-block\" ng-show=\"editForm.thresholdValue.$error.required\" translate=\"ipmApp.test.error.requiredThresholdValue\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.thresholdValue.$error.pattern || editForm.thresholdValue.$error.maxlength\" translate=\"ipmApp.test.error.thresholdValue\"></p></div></div><!-- Scoring Messages --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.scoringMessages\" for=\"field_scoringMessages\">Scoring Messages</label><div class=\"table-responsive\"><table class=\"jh-table table table-striped scoringMessages\"><thead><tr><th><span translate=\"ipmApp.test.atLeast\"></span></th><th><span translate=\"ipmApp.test.lessThan\"></span></th><th ng-class=\"!vm.test.id ? \'w-55\' : \'\'\"><span translate=\"ipmApp.test.textMessage\"></span></th><th ng-if=\"!vm.test.id\"></th></tr></thead><tbody><tr ng-repeat=\"scoreMessage in vm.test.scoreMessages track by $index\"><td><input type=\"text\" class=\"form-control\" name=\"atLeast_{{$index}}\" id=\"field_atLeast.{{$index}}\" ng-model=\"scoreMessage.atLeast\" ng-disabled=\"vm.isView\" ng-pattern=\"/^[0-9]*$/\"><div ng-show=\"editForm.atLeast_{{$index}}.$dirty && editForm.atLeast_{{$index}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.test.error.numberAtLeast\">This field is required.</p></div></td><td><input type=\"text\" class=\"form-control\" name=\"lessThan_{{$index}}\" id=\"field_lessThan.{{$index}}\" ng-model=\"scoreMessage.lessThan\" ng-disabled=\"vm.isView\" ng-pattern=\"/^[0-9]*$/\"><div ng-show=\"editForm.lessThan_{{$index}}.$dirty && editForm.lessThan_{{$index}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.test.error.numberLessthan\">This field is required.</p></div></td><td><textarea type=\"text\" class=\"form-control auto-height no-resize\" name=\"textMessage_{{$index}}\" id=\"field_textMessage.{{$index}}\" ng-model=\"scoreMessage.textMessage\" ng-disabled=\"vm.isView\"></textarea></td><td ng-if=\"!vm.test.id\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.removeScoringMessages($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"!vm.test.scoreMessages || vm.test.scoreMessages.length === 0\"><td colspan=\"5\"><p class=\"help-block text-center\" translate=\"ipmApp.test.home.scoringMessagesEmpty\">There is no Scoring Messages</p></td></tr></tbody><tfoot ng-if=\"!vm.isView\"><tr><td colspan=\"4\" style=\"text-align: right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.addNewScoreMessage()\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tfoot></table></div></div><!-- Description En --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.descriptionEn\" for=\"field_descriptionEn\">Description En</label><quill-editor class=\"d-block min-height-115\" ids=\"\'descriptionEn\'\" id=\"descriptionEn\" value=\"vm.test.descriptionEn\" view=\"vm.isView\" on-edit-change=\"vm.handleDescriptionEn(data)\"></quill-editor></div><!-- Description Es --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.descriptionEs\" for=\"field_descriptionEs\">Description Es</label><quill-editor class=\"d-block min-height-115\" ids=\"\'descriptionEs\'\" id=\"descriptionEs\" value=\"vm.test.descriptionEs\" view=\"vm.isView\" on-edit-change=\"vm.handleDescriptionEs(data)\"></quill-editor></div><!--HAQEvaluationType--><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.test.textHaqEvaluationType\" for=\"haqEvaluationType\">HAQEvaluation Type</label><select class=\"form-control\" name=\"haqEvaluationType\" id=\"haqEvaluationType\" ng-model=\"vm.test.haqEvaluationType\" ng-options=\"haqEvaluationType as \'ipmApp.test.haqEvaluationType.\' + haqEvaluationType | translate for haqEvaluationType in vm.haqEvaluationTypes track by haqEvaluationType\" ng-disabled=\"vm.isView\"><option value=\"\" selected=\"selected\"></option></select></div></form></div></div></div><!-- Buttons --><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.back()\" class=\"btn btn-info\" ng-if=\"vm.isCreateNew || vm.isDuplicate\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-if=\"!vm.isView\"><span translate=\"entity.action.save\">Save</span></button></div></div><!-- Sections List --><div class=\"row\" ng-if=\"vm.isView || vm.isEdit\"><section-list-for-test idt=\"vm.test.id\"></section-list-for-test></div><div class=\"row\" ng-if=\"vm.isView || vm.isEdit\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div></div></div>");
$templateCache.put("app/entities/test/tests.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.test.home.title\">Instruments</div><jhi-alert></jhi-alert><!-- button create --><div class=\"row\"><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"test.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.test.home.createLabel\">Create a new Test</span></button></div></div><!-- Test Table --><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"nameEn\">{{\'ipmApp.test.nameEn\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEs\">{{\'ipmApp.test.nameEs\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"numberOfBatteries\">{{\'ipmApp.test.numberOfBatteries\' | translate}} <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"ipmApp.test.activated\">Activated</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"test in vm.tests track by test.id\"><td>{{test.nameEn}}</td><td>{{test.nameEs}}</td><td>{{test.numberOfBatteries}}</td><td><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': test.activated}\" ng-click=\"vm.changeActivated(test.id)\"></button></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><!-- <button type=\"submit\"\n                                            ui-sref=\"test-detail({id:test.id})\"\n                                            class=\"btn btn-info btn-sm\">\n                                        <span class=\"glyphicon glyphicon-eye-open\"></span>\n                                        <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>\n                                    </button> --> <button type=\"submit\" ui-sref=\"test.edit({id:test.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"test.duplicate({id:test.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-duplicate\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.duplicate\"></span></button><!-- <button type=\"submit\"\n                                            ui-sref=\"test.delete({id:test.id})\"\n                                            class=\"btn btn-danger btn-sm\">\n                                        <span class=\"glyphicon glyphicon-remove-circle\"></span>\n                                        <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>\n                                    </button> --></div></td></tr></tbody></table></div><!-- Paging --><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/wellness-question/wellness-question-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.question.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.wellnessQuestion.delete.title\">Delete confirmation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p ng-if=\"vm.question.slides.length === 0\" translate=\"ipmApp.wellnessQuestion.delete.question\" translate-values=\"{name: \'{{vm.question.name}}\'}\">Are you sure you want to delete this Question?</p><p ng-if=\"vm.question.slides.length > 0\" translate=\"ipmApp.wellnessQuestion.delete.error\">You cannot remove this Question, it is linked to an active Slide.</p></div><div class=\"modal-footer\"><div ng-if=\"vm.question.slides.length === 0\"><button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div><div ng-if=\"vm.question.slides.length > 0\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.ok\">Ok</span></button></div></div></form>");
$templateCache.put("app/entities/wellness-question/wellness-question-editor.html","<div class=\"page page--section\" ng-if=\"vm.question\"><div class=\"page page--section\" ng-if=\"vm.question\"><div class=\"container\"><div class=\"content\"><!-- Title --><div class=\"h2 title\"><span translate=\"ipmApp.wellnessQuestion.home.createLabel\" ng-if=\"vm.isCreateNew === true\"></span> <span translate=\"ipmApp.wellnessQuestion.home.editLabel\" ng-if=\"vm.isCreateNew === false\"></span></div><!-- content --><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!-- Question Name --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.wellnessQuestion.name\" for=\"field_name\">Question Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.question.name\" ng-maxlength=\"255\" required><div ng-show=\"editForm.name.$dirty && editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"ipmApp.wellnessQuestion.error.requiredName\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><!-- Question Prompt --><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.wellnessQuestion.prompt\" for=\"field_prompt\">Question Prompt</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"prompt\" id=\"field_prompt\" ng-model=\"vm.question.prompt\" ng-maxlength=\"255\" required><div ng-show=\"editForm.prompt.$dirty && editForm.prompt.$invalid\"><p class=\"help-block\" ng-show=\"editForm.prompt.$error.required\" translate=\"ipmApp.wellnessQuestion.error.requiredPrompt\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.prompt.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 50 characters.</p></div></div><!-- Question Type --><div class=\"row\" style=\"margin-left: 0px; margin-right: 0px\"><div class=\"form-group col-md-5 pl-0\"><label class=\"control-label\" translate=\"ipmApp.wellnessQuestion.type\">Question Type</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"type\" id=\"type\" ng-model=\"vm.question.type\" required ng-options=\"type as \'ipmApp.wellnessQuestionType.\' + type | translate for type in vm.questionTypes track by type\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.type.$dirty && editForm.type.$invalid\"><p class=\"help-block\" ng-show=\"editForm.type.$error.required\" translate=\"ipmApp.wellnessQuestion.error.requiredType\">This field is required.</p></div></div><div class=\"form-group col-md-7\"><label class=\"control-label\" translate=\"ipmApp.wellnessQuestion.patientFacingContent\">Patient Facing Content</label><div ng-if=\"vm.fileId == null || vm.hasChanged\"><button type=\"button\" id=\"fileUpload\" class=\"btn btn-info\" ngf-select ng-model=\"vm.file\" name=\"file\" ngf-change=\"vm.uploadChanged($files)\" accept=\".pdf\" ngf-multiple=\"false\">Upload</button> <span>{{vm.file.name}}</span></div><div ng-if=\"vm.fileId != null\"><a ng-click=\"vm.downloadPdf()\" class=\"pr-2\" style=\"font-size:24px\"><i class=\"fa fa-file-pdf-o\"></i></a> <a ng-click=\"vm.removePdf()\">Remove</a></div></div></div><!-- Options --><div class=\"form-group\" ng-if=\"vm.question.type === \'SELECT_ONE\' || vm.question.type === \'MULTI_SELECT\'\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped question-option\"><thead><tr><th><span translate=\"ipmApp.wellnessQuestion.option\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th><span translate=\"ipmApp.wellnessQuestion.output\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"option in vm.question.options track by $index\"><td><input type=\"text\" class=\"form-control\" id=\"field_option_name_{{$index}}\" name=\"option_name_{{$index}}\" ng-model=\"option.name\" required></td><td><input type=\"text\" class=\"form-control\" id=\"field_option_output_{{$index}}\" name=\"option_output_{{$index}}\" ng-model=\"option.output\" required></td><td><button ng-disabled=\"vm.question.options.length === 1 || vm.question.options.length === 2 \" type=\"button\" class=\"btn btn-default\" ng-click=\"vm.removeOption($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"!vm.question.options || vm.question.options.length === 0\"><td colspan=\"3\"><p class=\"help-block text-center\" translate=\"ipmApp.wellnessQuestion.home.listOptionEmpty\">There is no Option</p></td></tr></tbody><tfoot><tr><td colspan=\"3\" style=\"text-align: left\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addOption()\"><span translate=\"ipmApp.wellnessQuestion.addOnOption\">Add on Option</span></button></td></tr></tfoot></table></div></div></form></div></div></div><!-- Buttons --><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-click=\"vm.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-if=\"!vm.isView\"><span translate=\"entity.action.save\">Save</span></button></div></div></div></div></div></div>");
$templateCache.put("app/entities/wellness-question/wellness-question.html","<div class=\"page page--user-management\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.wellnessQuestion.home.title\">Questions</div><jhi-alert></jhi-alert><div class=\"row\"><!--	            <div class=\"col-md-6 col-sm-8 col-xs-12 voffset3 has-feedback-left\">--><!--					<input type=\"text\" class=\"form-control search-box\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'ipmApp.wellnessQuestion.home.search\' | translate }}\"--><!--						ng-keypress=\"($event.which === 13)?vm.search(vm.searchQuery):0\">--><!--					<span class=\"form-control-feedback glyphicon glyphicon-search\"></span>--><!--				</div>--><div class=\"col-md-6 col-sm-4 col-xs-12 voffset3\"><button class=\"btn btn-primary\" ui-sref=\"wellness-question.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"ipmApp.wellnessQuestion.home.createLabel\">Create a new Question</span></button></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"name\"><span translate=\"ipmApp.wellnessQuestion.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span translate=\"ipmApp.wellnessQuestion.type\">Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"question in vm.questions track by question.id\"><td>{{question.name}}</td><td translate=\"{{\'ipmApp.wellnessQuestionType.\' + question.type}}\">{{question.type}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"wellness-question.edit({id:question.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"wellness-question.delete({id:question.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr><tr ng-if=\"!vm.questions || vm.questions.length === 0\"><td colspan=\"3\"><p class=\"help-block text-center\" translate=\"ipmApp.wellnessQuestion.home.listEmpty\">There is no Question</p></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" boundary-links=\"true\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/frp-mde/confirm-dialog/confirm-dialog.html","<form name=\"vm.confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.no()\">&times;</button><h5 class=\"modal-title\">Warning</h5></div><div class=\"modal-body text-center\"><span ng-if=\"vm.message.param\" translate=\"{{vm.message.content}}\" translate-values=\"{username: \'{{vm.message.param}}\'}\"></span> <span ng-if=\"!vm.message.param\" translate=\"{{vm.message.content}}\"></span></div><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"vm.yes()\" class=\"btn btn-primary\"><span translate=\"entity.action.yes\">Yes</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.no()\"><span translate=\"entity.action.no\">No</span></button></div></form>");
$templateCache.put("app/frp-mde/confirm-dialog/confirm-password-dialog.html","<form name=\"confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.no()\">&times;</button><h5 class=\"modal-title\">{{vm.title | translate}}</h5></div><div class=\"modal-body text-center\"><jhi-alert-error></jhi-alert-error><p>{{vm.message}}</p><input type=\"password\" id=\"password\" name=\"password\" ng-model=\"vm.password\"><p class=\"help-block\" ng-show=\"vm.inCorrectPassword && vm.password\" translate=\"entity.validation.inCorrectPassword\"></p></div><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"vm.confirmDeleteReport()\" ng-disabled=\"!vm.password\" class=\"btn btn-primary\"><span translate=\"entity.action.continue\">Continue</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.no()\"><span translate=\"entity.action.cancel\">No</span></button></div></form>");
$templateCache.put("app/frp-mde/confirm-dialog/notify-dialog.html","<form name=\"vm.confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.no()\">&times;</button><h5 class=\"modal-title\">Warning</h5></div><div class=\"modal-body text-center\"><span translate=\"{{vm.message.content}}\"></span></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.no()\"><span translate=\"entity.action.ok\">ok</span></button></div></form>");
$templateCache.put("app/frp-mde/header/header-report.html","<h3 class=\"primary title my-3 text-left\"><span>{{ vm.titleTextTranslate | translate}}</span></h3><div class=\"row-v4\"><div class=\"col-v4-md mb-3\" ng-if=\"vm.report\"><div class=\"mb-2\"><span class=\"bold\" translate=\"frpmdeDashboard.headerReport.patient\"></span>: <span ng-if=\"vm.report.patientName\">{{vm.report.patientName}}</span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"frpmdeDashboard.headerReport.chartNumber\"></span>: <span ng-if=\"vm.report.chartNumber\">{{vm.report.chartNumber}}</span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"frpmdeDashboard.headerReport.authorizedProvider\"></span>: <span ng-if=\"vm.report.authorizedProviderName\">{{vm.report.authorizedProviderName}}</span></div><div ng-if=\"vm.report.frpProgramName && !vm.isShowMdeOffice\" class=\"mb-2\"><span class=\"bold\" translate=\"frpmdeDashboard.headerReport.frpProgram\"></span>: <span>{{vm.report.frpProgramName}}</span></div><div ng-if=\"vm.isShowMdeOffice && vm.report.mdeOfficeName\" class=\"mb-2\"><span class=\"bold\" translate=\"frpmdeDashboard.headerReport.mdeOffice\"></span>: <span>{{vm.report.mdeOfficeName}}</span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"frpmdeDashboard.headerReport.caseNumber\"></span>: <span ng-if=\"vm.report.caseNumber\">{{vm.report.caseNumber}}</span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"frpmdeDashboard.headerReport.dob\"></span>: <span ng-if=\"vm.report.dateOfBirth\">{{vm.report.dateOfBirth | date:\'MM/dd/yyyy\'}}</span></div></div></div>");
$templateCache.put("app/frp-mde/pdf-report-preview-dialog/pdf-report-preview-dialog.html","<form name=\"previewForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.action.previewReport\">Preview Report</h4></div><div class=\"modal-body\"><pdf-preview ng-if=\"vm.pdfData\" pdf-data=\"vm.pdfData\" uint8-enable=\"true\" is-show-toolbar=\"true\" scale-zoom-max=\"1.4\"></pdf-preview></div></form>");
$templateCache.put("app/frp-mde/select-score-frp-mde-component/select-score-frp-mde.component.html","<div class=\"row-v4\"><div ng-class=\"vm.isHideSeverity ? \'col-v4\' : \'col-v4-6\'\"><input type=\"text\" id=\"{{vm.selectId}}\" name=\"{{vm.selectId}}\" class=\"form-control\" ng-model=\"vm.scoreModel\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.isRequired\" ng-model-options=\"{debounce: 600}\" ng-change=\"vm.selectScoreOnChange()\" check-maxlength=\"{{vm.numberMaxlength}}\"></div><div ng-if=\"!vm.isHideSeverity\" class=\"col-v4-6 col-classification\"><span>{{vm.severityModel}}</span><div ng-show=\"vm.scoreModel && !vm.severityModel\"><p class=\"help-block\" translate=\"entity.validation.scoreDoesntMatch\">Score doesn\'t match.</p></div></div></div>");
$templateCache.put("app/frp-mde/template/template-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\">{{vm.titleKey | translate }} {{\'ipmApp.frpMdeTemplate.template\' | translate}}</h5></div><div class=\"modal-body\" ng-if=\"vm.template\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><div class=\"d-flex\"><div class=\"flex-grow-0 text-nowrap d-flex align-items-center\"><span>{{\'ipmApp.frpMdeTemplate.name\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> &nbsp;&nbsp;&nbsp;</div><div class=\"flex-grow-1\"><input type=\"text\" class=\"form-control\" name=\"templateName\" id=\"templateName\" ng-required=\"true\" ng-model=\"vm.name\" ng-maxlength=\"255\"></div></div><div class=\"d-flex\" ng-show=\"editForm.templateName.$invalid && editForm.templateName.$dirty\"><div class=\"flex-grow-0 text-nowrap d-flex align-items-center transparent\"><span>{{\'ipmApp.frpMdeTemplate.name\' | translate}}</span> &nbsp;&nbsp;&nbsp;&nbsp;</div><p class=\"help-block\" ng-show=\"editForm.templateName.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.templateName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label>{{\'ipmApp.frpMdeTemplate.template\' | translate}}</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><textarea class=\"form-control auto-height none-resize\" rows=\"10\" name=\"templateContent\" id=\"templateContent\" ng-model=\"vm.content\" ng-required=\"true\">\n            </textarea><div ng-show=\"editForm.templateContent.$dirty\"><p class=\"help-block\" ng-show=\"editForm.templateContent.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"vm.template.id\" ng-disabled=\"editForm.$invalid\" class=\"btn btn-danger\" ng-click=\"vm.deleteTemplate()\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" ng-if=\"!vm.template.id\" class=\"btn btn-danger\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/layouts/error/accessdenied.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1\"><div class=\"frm-login\"><div class=\"frm-login-top\"><div class=\"h4 text-center primary pb-0\" translate=\"error.title\">Error Page!</div><div class=\"alert text-danger mb-0 text-center\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div></div></div>");
$templateCache.put("app/layouts/error/error-sso.html","<div ng-cloak><div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1\"><div class=\"frm-login\"><div class=\"frm-login-top\"><div class=\"h4 text-center primary pb-0\" translate=\"error.title\">Error Page!</div><div class=\"alert text-danger mb-0 text-center\">An unexpected error has occurred. We are sorry for the inconvenience !</div><div class=\"alert text-danger mb-0 text-center\">Please <a href=\"{{vm.logoutUri}}\" class=\"text-info\">sign out</a> of your Microsoft account and try again.</div></div></div></div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1\"><div class=\"frm-login\"><div class=\"frm-login-top\"><div class=\"h4 text-center primary pb-0\" translate=\"error.title\">Error Page!</div><div class=\"alert text-danger mb-0 text-center\">An unexpected error has occurred. We are sorry for the inconvenience !</div></div></div></div></div></div></div>");
$templateCache.put("app/layouts/footer/footer.html","<div class=\"footer ipm-footer\" ng-cloak><div class=\"container\"><div class=\"row\"><div class=\"copyright\">&copy <span class=\"px-1\">{{vm.currentYear}}</span> Boomerang Healthcare, Inc.</div>{{}}<div class=\"description\">Pain Management Programs</div><!--\n        <div class=\"col-md-6 col-sm-6 hidden-xs\">&copy 2017 IPM Medical Group, Inc.</div>\n        <div class=\"col-md-6 col-sm-6 hidden-xs text-right\">Pain Management Programs</div>\n        <div class=\"col-xs-12 text-center visible-xs\">&copy 2017 IPM Medical Group, Inc.</div>\n        <div class=\"col-xs-12 text-center visible-xs\">Pain Management Programs</div>\n        --></div></div></div>");
$templateCache.put("app/layouts/navbar/navbar.html","<nav class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"d-flex align-items-center justify-content-between py-3 navbar-flex\"><div class=\"img-logo\"><img src=\"content/images/logo.jpg\" class=\"navbar-brand\"></div><div class=\"navbar-menu\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"d-lg-flex align-items-center\"><li class=\"d-none-special d-lg-inline-flex-special\" ng-if=\"vm.checkShowHomeForFRPMDE()\"><a ng-class=\"{active: vm.isActive(\'/home\')}\" ng-click=\"vm.goToHome()\" translate=\"global.menu.entities.home\">Home</a></li><!--start menu QHP Care Plan Review --><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_QHP\" ng-if=\"vm.carePlanReview(vm.navBarHomeId)\"><a ng-class=\"{active: vm.isActive(\'/\')}\" ng-click=\"vm.goToHome()\" translate=\"global.menu.entities.home\">Home</a></li><li class=\"d-none-special d-lg-inline-flex-special\" ng-if=\"vm.isHaqEvaluationTestMode()\"><a ng-class=\"{active: vm.isActive(\'/adhoc-haq-evaluation\')}\" ui-sref=\"adhoc-haq-evaluation\" translate=\"global.menu.entities.adhocHAQEvaluation\">Adhoc HAQ Evaluation</a></li><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_QHP\" ng-if=\"vm.carePlanReview(vm.navBarCPRId)\"><a ng-class=\"{active: vm.isActive(\'/care-plan-review\')}\" ui-sref=\"care-plan-review\" translate=\"global.menu.entities.carePlanReview\">CPR Admin Portal</a></li><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_QHP\" ng-if=\"vm.isShowWellnessClassList()\"><a ng-class=\"{active: vm.isActive(\'/presentation-controls\')}\" ui-sref=\"wellness-class-list\" translate=\"global.menu.entities.wellnessClasses\">Wellness Classes</a></li><!--end menu QHP Care Plan Review --><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\"><a ng-class=\"{active: vm.isActive(\'/patient-list\')}\" ui-sref=\"patient-list\" translate=\"global.menu.entities.patients\">Patients list</a></li><!--                    IPMproject-891 - Admin/Staff Portal - Patient Details Page – New Batteries Table: IPMproject-Q676: The screen is no longer in use.--><!--                    <li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\">--><!--                        <a ng-class=\"{active: vm.isActive(\'/survey-result-list\')}\" ui-sref=\"survey-result-list\" translate=\"global.menu.entities.surveyResult\">Survey Result</a>--><!--                    </li>--><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\"><a ng-class=\"{active: vm.isActive(\'/download-result\')}\" ui-sref=\"download-result\" translate=\"global.menu.entities.downloadResult\">Download NPQs</a></li><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\"><a ng-class=\"{active: vm.isActive(\'/download-agreements\')}\" ui-sref=\"download-agreements\" translate=\"global.menu.entities.downloadAgreement\">Download agreements</a></li><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\"><a ng-class=\"{active: vm.isActive(\'/download-psych-intakes\')}\" ui-sref=\"download-psych-intakes\" translate=\"global.menu.entities.downloadPsychIntake\">Download Psych Intakes</a></li><li class=\"d-none-special d-lg-inline-flex-special\" has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\"><a ng-class=\"{active: vm.isActive(\'/download-battery-results\')}\" ui-sref=\"download-battery-results\" translate=\"global.menu.entities.downloadBatteryResults\">Download Battery Results</a></li><div class=\"w-100 d-lg-none\"></div><div class=\"d-inline-flex align-items-center flex-hello ml-2\" ng-if=\"!vm.isBiller()\"><li class=\"col-v4-auto ml-md-auto dropdown pointer hello\" uib-dropdown end-to-body=\"true\" ng-switch-when=\"true\" ng-if=\"vm.account\" ng-class=\"(vm.account && vm.account.authorities.indexOf(\'ROLE_PATIENT\') !== -1) ? \'haveAccount-Patient\' : (vm.account ? \'haveAccount\' : \'\')\" is-open=\"vm.ddOpen\" adjust-body-height><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\" ng-class=\"{active: vm.$state.includes(\'entity\'), language: vm.account.authorities.indexOf(\'ROLE_PATIENT\') !== -1}\"><span translate=\"global.menu.account.greeting\">Hello,</span>&nbsp;<span>{{vm.account.firstName + \' \' + vm.account.lastName }}</span> </a><b class=\"caret ml-2\"></b><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"user-management\"><span class=\"glyphicon glyphicon-user pr-3\"></span><span translate=\"global.menu.admin.userManagement\">User Management</span></a></li><li has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"patient-list\"><span class=\"glyphicon glyphicon-user pr-3\"></span><span translate=\"global.menu.entities.patients\">Patients list</span></a></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"provider\"><span class=\"glyphicon glyphicon-user pr-3\"></span><span translate=\"global.menu.entities.provider\">Providers</span></a></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"office\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:home-city-outline\"></iconify-icon></span><span translate=\"global.menu.entities.office\">Offices</span></a></li><li has-any-authority=\"ROLE_STAFF, ROLE_MANAGER, ROLE_ADMIN\" ng-if=\"vm.isStaffOrManager() || vm.account.authorities.indexOf(\'ROLE_ADMIN\') !== -1\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-result\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span>{{vm.account.authorities.indexOf(\'ROLE_ADMIN\') !== -1 ? \'global.menu.entities.admin.downloadResult\' : \'global.menu.entities.downloadResult\' | translate}}</span></a></li><li has-any-authority=\"ROLE_STAFF, ROLE_MANAGER, ROLE_ADMIN\" ng-if=\"vm.isStaffOrManager() || vm.account.authorities.indexOf(\'ROLE_ADMIN\') !== -1\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-agreements\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadAgreement\"></span></a></li><li has-any-authority=\"ROLE_STAFF, ROLE_MANAGER, ROLE_ADMIN\" ng-if=\"vm.isStaffOrManager() || vm.account.authorities.indexOf(\'ROLE_ADMIN\') !== -1\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-psych-intakes\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadPsychIntake\"></span></a></li><li has-any-authority=\"ROLE_STAFF, ROLE_MANAGER, ROLE_ADMIN\" ng-if=\"vm.isStaffOrManager() || vm.account.authorities.indexOf(\'ROLE_ADMIN\') !== -1\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-battery-results\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadBatteryResults\"></span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-adhoc-testing\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.adhocTesting\">Adhoc Testing Report</span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-detailed-adhoc-testing\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.detailedAdhocTesting\">Detailed Adhoc Testing Report</span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-case-exclusions\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.caseExclusions\">Case Exclusions Report</span></a></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_STAFF\" ng-if=\"vm.isAdmin() || vm.isStaff()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"coc-agreement-management\"><span class=\"glyphicon glyphicon-import pr-3\"></span><span translate=\"global.menu.entities.assignCoC\">Assign CoC</span></a></li><li class=\"navbar-border-bottom\" ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"patientimport\"><span class=\"glyphicon glyphicon-import pr-3\"></span><span translate=\"global.menu.entities.importpatient\">Import Patients</span></a></li><!--navbar group1 end--><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"care-plan-review\"><span class=\"glyphicon glyphicon-tasks pr-3\"></span><span translate=\"global.menu.entities.carePlanReviews\">CPR Admin Portal</span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-cpr-activity-report\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.downloadCPRActivityReport\">CPR Activity Report</span></a></li><li class=\"navbar-border-bottom\" has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-care-plan-review\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadCarePlanReview\">Download CPR Reports</span></a></li><!--navbar group2 end--><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"frp-mde\"><span class=\"glyphicon glyphicon-tasks pr-3\"></span><span translate=\"global.menu.entities.FRP_MDE\">FRP/MDE Portal</span></a></li><li class=\"navbar-border-bottom\" ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"frp-mde-reports\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.frpMdeReports\">Download FRP/MDE Reports</span></a></li><!--navbar group3 end--><!--IPMproject-Q670: hide menu HaqTracks --><!--                                <li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\">--><!--                                    <a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"haq-tracks\">--><!--                                        <span class=\"glyphicon glyphicon-tasks pr-3\"></span><span translate=\"global.menu.entities.haqTracks\">HAQ Tracks</span>--><!--                                    </a>--><!--                                </li>--><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"haqs-battery\"><span class=\"glyphicon glyphicon-tasks pr-3\"></span><span translate=\"global.menu.entities.haqs\">Batteries</span></a></li><li class=\"navbar-border-bottom\" ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"test\"><span class=\"glyphicon glyphicon-tasks pr-3\"></span><span translate=\"global.menu.entities.haqInstruments\">Instruments</span></a></li><li class=\"menu\" ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"!vm.isHideWellnessClass && vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-education pr-3\"></span><span translate=\"global.menu.entities.coursesAndContent\">Courses and Content</span></a><ul class=\"sub-menu\"><li class=\"sub-menu-item\" ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"wellness-question\"><span class=\"glyphicon glyphicon-question-sign pr-3\"></span><span translate=\"global.menu.entities.manageQuestions\">Manage Questions</span></a></li><li class=\"sub-menu-item\" ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"deck\"><span class=\"glyphicon glyphicon-blackboard pr-3\"></span><span translate=\"global.menu.entities.manageDecks\">Manage Decks</span></a></li><li class=\"sub-menu-item\" ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"course\"><span class=\"glyphicon glyphicon-education pr-3\"></span><span translate=\"global.menu.entities.manageCourses\">Manage Courses</span></a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"completion-reports\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.completionReports\">HAQ Billing Report</span></a></li><li has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"patient-list\"><span class=\"glyphicon glyphicon-user pr-3\"></span><span translate=\"global.menu.entities.patients\">Patients list</span></a></li><!--                                IPMproject-891 - Admin/Staff Portal - Patient Details Page – New Batteries Table: IPMproject-Q676: The screen is no longer in use.--><!--                                <li has-any-authority=\"ROLE_STAFF, ROLE_MANAGER\" ng-if=\"vm.isStaffOrManager()\">--><!--                                    <a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"survey-result-list\">--><!--                                        <span class=\"glyphicon glyphicon-th-list pr-3\"></span><span translate=\"global.menu.entities.surveyResult\">Survey Result</span>--><!--                                    </a>--><!--                                </li>--><li has-any-authority=\"ROLE_STAFF\" ng-if=\"vm.isStaff()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"frp-mde\"><span class=\"glyphicon glyphicon-th-list pr-3\"></span><span translate=\"global.menu.entities.FRP_MDE\"></span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-haq-activity-report\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.downloadHAQActivityReport\">HAQ Activity Report</span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-haq-results-reports\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadHAQResultsReports\">Download HAQ Tests</span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-adhoc-tests-reports\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadAdhocTestsReports\">Download Adhoc Tests</span></a></li><li has-any-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-haq-evaluation\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.haqEvaluationResults\">Download HAQ Evals</span></a></li><!--IPMproject-Q670: hide menu HaqTracks --><!--                                <li ng-class=\"{active: vm.$state.includes(\'admin\')}\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.isAdmin()\">--><!--                                    <a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"haq-evaluation-skips\">--><!--                                        <span class=\"glyphicon glyphicon-tasks pr-3\"></span><span translate=\"global.menu.entities.haqEvaluationSkips\">Skipped HAQs</span>--><!--                                    </a>--><!--                                </li>--><li has-any-authority=\"ROLE_PATIENT\" ng-if=\"vm.isPatient()\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"agreements\"><span class=\"glyphicon glyphicon-th-list pr-3\"></span><span translate=\"global.menu.account.agreement\">Agreements</span></a></li><li><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"password\"><span class=\"glyphicon glyphicon-lock pr-3\"></span><span translate=\"global.menu.account.changepassword\">Change Password</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"battery\" ng-click=\"vm.logout()\" id=\"logout\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-log-out pr-3\"></span><span translate=\"global.menu.account.logout\">Sign out</span></a></li></ul></li></div><div class=\"d-inline-flex align-items-center flex-hello ml-2\" ng-if=\"vm.isBiller()\"><li class=\"col-v4-auto ml-md-auto dropdown pointer hello\" uib-dropdown ng-if=\"vm.account\" ng-class=\"(vm.account && vm.account.authorities.indexOf(\'ROLE_PATIENT\') !== -1) ? \'haveAccount-Patient\' : (vm.account ? \'haveAccount\' : \'\')\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\" ng-class=\"{active: vm.$state.includes(\'entity\'), language: vm.account.authorities.indexOf(\'ROLE_PATIENT\') !== -1}\"><span translate=\"global.menu.account.greeting\">Hello,</span>&nbsp;<span>{{vm.account.firstName + \' \' + vm.account.lastName }}</span> </a><b class=\"caret ml-2\"></b><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu><li has-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"patient-list\"><span class=\"glyphicon glyphicon-user pr-3\"></span><span translate=\"global.menu.entities.patients\">Patients list</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-result\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span>{{vm.account.authorities.indexOf(\'ROLE_BILLER\') !== -1 ? \'global.menu.entities.admin.downloadResult\' : \'global.menu.entities.downloadResult\' | translate}}</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-agreements\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadAgreement\"></span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-psych-intakes\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadPsychIntake\"></span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-battery-results\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadBatteryResults\"></span></a></li><li has-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-case-exclusions\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.caseExclusions\">Case Exclusions Reports</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-cpr-activity-report\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.downloadCPRActivityReport\">CPR Activity Report</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-care-plan-review\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadCarePlanReview\">Download CPR Reports</span></a></li><li has-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"frp-mde-reports\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.frpMdeReports\">FRP/MDE Reports</span></a></li><li has-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"completion-reports\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.completionReports\">HAQ Billing Report</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-haq-activity-report\"><span class=\"glyphicon\"><iconify-icon class=\"iconify-icon\" icon=\"mdi:table-arrow-down\"></iconify-icon></span><span translate=\"global.menu.entities.downloadHAQActivityReport\">HAQ Activity Report</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-haq-results-reports\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadHAQResultsReports\">Download HAQ Tests</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-adhoc-tests-reports\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.downloadAdhocTestsReports\">Download Adhoc Tests</span></a></li><li has-any-authority=\"ROLE_BILLER\"><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"download-haq-evaluation\"><span class=\"glyphicon glyphicon-download-alt pr-3\"></span><span translate=\"global.menu.entities.haqEvaluationResults\">Download HAQ Evals</span></a></li><li><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\" ui-sref=\"password\"><span class=\"glyphicon glyphicon-lock pr-3\"></span><span translate=\"global.menu.account.changepassword\">Change Password</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"battery\" ng-click=\"vm.logout()\" id=\"logout\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-log-out pr-3\"></span><span translate=\"global.menu.account.logout\">Sign out</span></a></li></ul></li></div><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span translate=\"global.menu.account.login\">Sign in</span></a></li><li ng-if=\"vm.account.authorities.indexOf(\'ROLE_PATIENT\') !== -1\" ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span translate=\"global.menu.language\">Language</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a class=\"language-selection\" href=\"\" ng-click=\"languageVm.changeLanguage(language)\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></div></nav>");
$templateCache.put("app/notification-history/patient-summary/patient-summary.html","<div class=\"h2 title\" translate=\"ipmApp.patient.detail.title\"></div><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.surveyResult.detail.patientInfo\"></span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.firstName\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.firstName}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.lastName\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.lastName}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.dateOfBirth\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.dateOfBirth | date:\'MM/dd/yyyy\'}}</div></div><div class=\"row voffset\"><div class=\"col-md-2 col-xs-4\"><label class=\"control-label ml-8\">{{\'ipmApp.surveyResult.patientIdCode\' | translate}}</label></div><div class=\"col-md-10 col-xs-8\">{{vm.patient.patientId}}</div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/workflow.html","<form name=\"form\" role=\"form\" novalidate><div ng-include=\"vm.template\"></div><div class=\"row\" ng-show=\"vm.dataWorkflow.action != \'COMPLETE\'\"><div class=\"col-md-12 voffset2 text-center\" style=\"margin-top: 20px\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.back()\" ng-disabled=\"!vm.dataWorkflow.backActive\"><span translate=\"surveyWorkflow.action.back\">Back</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.next()\" ng-disabled=\"!vm.dataWorkflow.nextActive || form.$invalid\"><span translate=\"surveyWorkflow.action.next\">Next</span></button><div ng-show=\"form.lastName.$error.required || form.firstName.$error.required \n                        || form.dateOfBirth.$error.required || form.cellNumber.$error.required || form.homeTelephone.$error.required \"><p class=\"help-block\" translate=\"surveyWorkflow.error.requireAllFill\">* Please fill in all required fields above</p></div></div></div></form>");
$templateCache.put("app/patient/adhoc-testing/adhoc-testing-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.haqBatteryAdHoc.home.createOrEditLabel\">Assign Instrument</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group text-left\"><label translate=\"ipmApp.haqBatteryAdHoc.instrument\">Instrument</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"pb-4\"><ui-select ng-model=\"vm.haqBatteryAdHocSeleted\" theme=\"bootstrap\" close-on-select=\"true\" style=\"width: 100%\" ng-change=\"vm.selectTextOnChange()\" required><ui-select-match placeholder=\"Select instrument...\"><span title=\"{{$select.selected.test.nameEn}}\">{{$select.selected.test.nameEn}}</span></ui-select-match><ui-select-choices repeat=\"hbah in vm.haqBatteryAdHocs | filter:$select.search\"><div ng-bind-html=\"hbah.test.nameEn  | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><p class=\"help-block text-center\">{{\'ipmApp.haqBatteryAdHoc.inputBatteryTestNoResult\' | translate}}</p></ui-select-no-choice></ui-select></div><div class=\"pt-1 text-center\" ng-show=\"vm.isInvalidBatteryAdHoc\"><p class=\"help-block\" translate=\"ipmApp.haqBatteryAdHoc.error.invalidBatteryAdHoc\">This instrument cannot be assigned because it has no questions.</p></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || vm.isInvalidBatteryAdHoc\" class=\"btn btn-primary\"><span translate=\"entity.action.assign\">Assign</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/adhoc-testing/adhoc-testing-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.haqBatteryAdHoc.delete.title\">Confirm delete operation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.haqBatteryAdHoc.delete.question\">Are you sure you want to delete Assign Instrument ?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/adhoc-testing/adhoc-testing.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"batteryTest.test.nameEn\"><span>{{\'ipmApp.haqBatteryAdHoc.instrumentName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.haqBatteryAdHoc.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"surveyResult.lastModifiedDate\"><span>{{\'ipmApp.haqBatteryAdHoc.dateLastUpdate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"dateTest\"><span class=\"px-1\">{{\'ipmApp.haqBatteryAdHoc.completionDate\' | translate}}</span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\"><span>{{\'ipmApp.haqBatteryAdHoc.score\' | translate}} </span></th><th class=\"text-center\" ng-show=\"vm.isManager\"><span>{{\'ipmApp.haqBatteryAdHoc.downloadResult\' | translate}} </span></th><th><span>{{\'ipmApp.haqBatteryAdHoc.downloadResponses\' | translate}} </span></th><th><span>{{\'ipmApp.haqBatteryAdHoc.action\' | translate}} </span></th><th class=\"text-center\"><span>{{\'ipmApp.surveyResult.launch\' | translate}}</span></th></tr></thead><tbody><tr ng-repeat=\"haq in vm.haqBatteryAdHocs track by $index\"><td><span>{{haq.batteryTestName}}</span></td><td>{{\'ipmApp.adHocHAQStatus.\' + haq.status | translate}}</td><td><span ng-if=\"haq.dateLastUpdate\">{{ haq.dateLastUpdate | date:\'MM/dd/yyyy\' }}</span></td><td><span ng-if=\"haq.completionDate\">{{ haq.completionDate | date:\'MM/dd/yyyy\' }}</span></td><td class=\"text-center column-nowrap\"><span>{{ haq.score}}</span></td><td class=\"text-center\" ng-show=\"vm.isManager\"><a ng-if=\"haq.status === \'COMPLETED\'\" href=\"{{ \'api/survey-results/download/\' + haq.surveyResult.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td><td class=\"text-center\"><a ng-if=\"haq.status === \'COMPLETED\'\" href=\"{{ \'api/survey-results/download-response/\' + haq.surveyResult.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td><td class=\"text-center\"><button type=\"button\" title=\"Delete Assign Instrument\" class=\"btn btn-danger btn-sm btn-smaller\" ng-if=\"haq.status === \'NOT_STARTED\'\" ui-sref=\"adhoc-testing-delete({haqBatteryAdHocId: haq.id})\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td class=\"text-center\"><button type=\"button\" ng-if=\"haq.status !== \'COMPLETED\'\" class=\"glyphicon glyphicon-log-in button-reset\" data-toggle=\"Launch\" ng-click=\"vm.goToHAQBattery($event, haq)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableHaq.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div>");
$templateCache.put("app/patient/agreements/patient-agreements-send-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.patient.detail.agreements.dialogSend.header\">Send New Agreement</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group text-left\"><label translate=\"ipmApp.patient.detail.agreements.dialogSend.agreementsLabel\">Agreements</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><ui-select ng-model=\"vm.agreementSeleted\" theme=\"bootstrap\" close-on-select=\"true\" style=\"width: 100%\" ng-change=\"vm.selectAgreementOnChange()\" required><ui-select-match placeholder=\"{{ \'ipmApp.patient.detail.agreements.dialogSend.agreementsPlaceholder\'| translate }}\"><span title=\"{{$select.selected.nameText}}\">{{$select.selected.nameText}}</span></ui-select-match><ui-select-choices repeat=\"agreement in vm.agreements | filter:$select.search\"><div ng-bind-html=\"agreement.nameText  | highlight: $select.nameText\"></div></ui-select-choices><ui-select-no-choice><p class=\"help-block text-center\">{{\'ipmApp.patient.detail.agreements.dialogSend.inputAgreementTestNoResult\' | translate}}</p></ui-select-no-choice></ui-select><div class=\"pt-1\"><p class=\"help-block\" ng-show=\"vm.isInvalidAgreement\" translate=\"ipmApp.patient.detail.agreements.dialogSend.messages.invalidAgreement\">This agreement is already signed. Do you really want to sign it again?</p></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || !vm.agreementSeleted\" class=\"btn btn-primary\"><span translate=\"entity.action.send\">Send</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/agreements/patient-agreements.html","<div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" type=\"button\" ui-sref=\"agreements-send({id : vm.patientId})\" ng-disabled=\"vm.isDisableAddNewPatientAgreement()\"><span translate=\"ipmApp.patient.detail.agreements.sendNewAgreementLabelBtn\">Send New Agreement</span></button> <button class=\"btn btn-primary\" type=\"button\" ng-if=\"vm.patientAgreements && !vm.isAgreementSignedAllByAPI(vm.patientAgreements)\" ng-disabled=\"!vm.isShowDownloadAll(vm.patientAgreements)\" ng-click=\"vm.downloadAll()\"><span translate=\"ipmApp.patient.detail.agreements.downloadAll\">Download All</span></button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"agreementName\" class=\"col-md-5\"><span translate=\"ipmApp.patient.detail.agreements.agreementName\"></span> <span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"status\"><span translate=\"ipmApp.patient.detail.agreements.statusLabel\"></span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdSource\" class=\"col-md-3\"><span translate=\"ipmApp.patient.detail.agreements.agreementSource\"></span> <span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"dateSigned\" class=\"col-md-2\"><span translate=\"ipmApp.patient.detail.agreements.dateSigned\"></span> <span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"expirationDate\" class=\"col-md-2\"><span translate=\"ipmApp.patient.detail.agreements.expirationDate\"></span> <span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\"><span>{{\'ipmApp.patient.detail.agreements.launchLabel\' | translate}}</span></th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"pa in vm.patientAgreements track by pa.id\"><td class=\"col-md-5\"><span>{{\'ipmApp.agreements.workflowName.\' + pa.agreementName | translate}}</span></td><td>{{\'ipmApp.patient.detail.agreements.status.\' + pa.status | translate}}</td><td class=\"col-md-3 text-nowrap\">{{\'ipmApp.agreements.agreementSource.\' + pa.createdSource | translate}}</td><td class=\"col-md-2\">{{pa.dateSigned | date: \'MM/dd/yyyy\'}}</td><td class=\"col-md-2\">{{pa.expirationDate | date: \'MM/dd/yyyy\'}}</td><td class=\"text-center\"><button type=\"button\" ng-if=\"pa.status !== \'COMPLETE\' && pa.status !== \'CANCEL\'\" class=\"glyphicon glyphicon-log-in button-reset\" data-toggle=\"Launch\" ng-click=\"vm.goToPatientAgreement($event, pa)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></td><td class=\"text-center\"><u ng-if=\"(pa.status === \'NOT_STARTED\' || pa.status === \'STARTED\')\"><button type=\"button\" class=\"button-reset underline\" translate=\"ipmApp.batteryTesting.button.resendLabel\" ng-click=\"vm.resendPatientAgreement(pa)\" ng-disabled=\"(vm.isBiller || vm.isDisableLaunchResendPatientAgreement(pa))\" ng-class=\"(vm.isBiller || vm.isDisableLaunchResendPatientAgreement(pa)) ? \'not_allowed\' : \'\'\"></button></u></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\" ng-if=\"vm.pageableAP.totalItems > vm.pageSize\"></uib-pagination></div></div></div>");
$templateCache.put("app/patient/appointment/appointment-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myUserLabel\" translate=\"ipmApp.appointment.home.createOrEditLabel\">Create or edit an Appointment</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"ipmApp.appointment.label.date\">Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"mt-0 dateOfBirth\" id=\"dateOfAppointment\" name=\"dateOfAppointment\" data-format=\"DD-MM-YYYY\" data-template=\"D MMM YYYY\" year-name=\"yearOfBirth\" day-name=\"dayOfBirth\" month-name=\"monthOfBirth\" decrement-year=\"vm.decrementYear\" min-year=\"vm.minYear\" format-date=\"true\" ng-model=\"vm.appointment.dateOfAppointment\" ng-required=\"true\" rsmdatedropdowns><div class=\"col-md-12\" ng-show=\"(editForm.dayOfBirth.$dirty && editForm.dayOfBirth.$invalid) || (editForm.monthOfBirth.$dirty && editForm.monthOfBirth.$invalid) || (editForm.yearOfBirth.$dirty && editForm.yearOfBirth.$invalid)\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.appointment.label.time\">Time</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><div uib-timepicker ng-model=\"vm.appointment.timeOfAppointment\" id=\"timeOfAppointment\" name=\"timeOfAppointment\" ng-change=\"vm.changedTime()\" hour-step=\"vm.hourStep\" minute-step=\"vm.minuteStep\" class=\"time-picker\" ng-required=\"true\"></div></div><div ng-show=\"editForm.timeOfAppointment.$dirty && editForm.timeOfAppointment.$invalid\"><p class=\"help-block\" ng-show=\"editForm.timeOfAppointment.$error.required\" translate=\"ipmApp.appointment.validation.timeInvalid\">This time is invalid.</p></div></div><div class=\"form-group\"><label translate=\"ipmApp.appointment.label.office\">Office</label><select ng-if=\"vm.appointment\" class=\"form-control\" name=\"officeId\" id=\"officeId\" ng-model=\"vm.appointment.officeId\" ng-required=\"false\" ng-options=\"o.id as vm.officeCustom(o) for o in vm.offices\"><option value=\"\" selected=\"selected\"></option></select></div><div class=\"form-group\"><label translate=\"ipmApp.appointment.label.provider\">Provider</label><select ng-if=\"vm.appointment\" class=\"form-control\" name=\"providerId\" id=\"providerId\" ng-model=\"vm.appointment.providerId\" ng-required=\"false\" ng-options=\"p.id as p.titleFullName for p in vm.providers\"><option value=\"\" selected=\"selected\"></option></select></div></div><div class=\"pt-3 text-center\" ng-show=\"vm.appointmentExist !== null\"><p class=\"help-block\" translate=\"ipmApp.appointment.error.appointmentExist\">This Appointment already exists.</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/appointment/appointment-create-questionnaire.html","<form name=\"deleteForm\" ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myUserLabel\" translate=\"ipmApp.patient.home.questionnaire.title\">Create a new Questionnaire</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-if=\"vm.appointment != null && vm.appointment.dateOfAppointment != null && vm.appointment.timeOfAppointment != null\"><label>{{ \'ipmApp.patient.detail.appointment.title\' | translate }}:</label><span>{{ (vm.appointment.dateOfAppointment | date:\'MM/dd/yyyy\') + (vm.appointment.timeOfAppointment | date:\'shortTime\') }}</span></div><div ng-if=\"vm.notAllowCreateQuestionnaire\"><p class=\"help-block\" translate=\"ipmApp.patient.detail.questionnaire.notAllowSendRequest\"></p></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"vm.isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" ng-disabled=\"vm.isSaving\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/appointment/appointment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.appointmentId)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.appointment.delete.title\">Confirm delete operation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.appointment.delete.question\">Are you sure you want to delete this Appointment ?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/appointment/appointment-list.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"dateOfAppointment\"><span translate=\"ipmApp.patient.detail.appointment.date\"></span><span class=\"glyphicon glyphicon-sort\"></th><th><span>{{\'ipmApp.patient.detail.appointment.time\' | translate}}</span></th><th jh-sort-by=\"officeName\"><span>{{\'ipmApp.patient.detail.appointment.office\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"providerTitleFullName\"><span>{{\'ipmApp.patient.detail.appointment.provider\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"ap in vm.appointments track by ap.id\"><td>{{ap.timeOfAppointment | date:\'MM/dd/yyyy\'}}</td><td>{{ap.timeOfAppointment | date:\'shortTime\'}}</td><td>{{ap.officeName}}</td><td>{{ap.providerTitleFullName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"appointment-edit({appointmentId: ap.id})\" class=\"btn btn-primary btn-sm\" ng-disabled=\"vm.isBiller\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"appointment-delete({appointmentId: ap.id})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.isBiller\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\"></uib-pagination></div></div></div>");
$templateCache.put("app/patient/cpr-reports/cpr-reports.html","<div class=\"col-md-12\"><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"id\"><span>{{\'ipmApp.carePlanReview.patientId\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"u.firstName\"><span>{{\'ipmApp.carePlanReview.firstName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"u.lastName\"><span>{{\'ipmApp.carePlanReview.lastName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"o.name\"><span>{{\'ipmApp.carePlanReview.office\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"provider.firstName\"><span>{{\'ipmApp.carePlanReview.provider\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"completedDate\"><span>{{\'ipmApp.carePlanReview.completed\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.carePlanReview.currentStatus\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startedDate\"><span>{{\'ipmApp.carePlanReview.started\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span>{{\'ipmApp.carePlanReview.notes\' | translate}}</span></th><th><span>{{\'ipmApp.carePlanReview.timeSpent\' | translate}}</span></th></tr></thead><tbody><tr ng-repeat=\"cpr in vm.carePlanReviews track by cpr.id\" ng-class=\"vm.cprRowTextClass(cpr)\"><td><span ng-if=\"cpr.patient\">{{cpr.patient.patientId}}</span></td><td><span ng-if=\"cpr.patient\">{{cpr.patient.firstName}}</span></td><td><span ng-if=\"cpr.patient\">{{cpr.patient.lastName}}</span></td><td><span ng-if=\"cpr.office\">{{cpr.office.name}}</span></td><td><span ng-if=\"cpr.provider\">{{cpr.provider.titleFullName}}</span></td><td><span ng-if=\"cpr.completedDate\">{{cpr.completedDate | date:\'MM/dd/yyyy\'}}</span> <a ng-if=\"cpr.status === \'COMPLETED\' && cpr.id\" ng-href=\"{{ \'api/care-plan-review/download/\' + cpr.id }}\" class=\"glyphicon glyphicon-download-alt\"></td><td><span>{{vm.formatAndUpdateStatus(cpr)}}</span></td><td><span ng-if=\"cpr.startedDate\">{{cpr.startedDate | date:\'MM/dd/yyyy\'}}</span></td><td><span ng-if=\"cpr.notes\">{{cpr.notes}}</span></td><td><seconds-transfer total-seconds=\"cpr.timeSpent\"></seconds-transfer></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageableAP.size\" max-size=\"vm.pageableAP.size\" rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\"></uib-pagination></div></div>");
$templateCache.put("app/patient/battery-testing/battery-testing-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.batteryTesting.batteryTestingAddDialog.header\">Assign Battery</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group text-left\"><label translate=\"ipmApp.batteryTesting.batteryTestingAddDialog.batteriesLabel\">Batteries</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><ui-select ng-model=\"vm.haqBatterySeleted\" theme=\"bootstrap\" close-on-select=\"true\" style=\"width: 100%\" ng-change=\"vm.selectBatteriesOnChange()\" required><ui-select-match placeholder=\"{{ \'ipmApp.batteryTesting.batteryTestingAddDialog.batteriesPlaceholder\'| translate }}\"><span title=\"{{$select.selected.nameEn}}\">{{$select.selected.nameEn}}</span></ui-select-match><ui-select-choices repeat=\"battery in vm.haqBatteries | filter:$select.search\"><div ng-bind-html=\"battery.nameEn  | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><p class=\"help-block text-center\">{{\'ipmApp.batteryTesting.batteryTestingAddDialog.inputBatteryTestNoResult\' | translate}}</p></ui-select-no-choice></ui-select><div class=\"pt-1\" ng-show=\"vm.isInvalidBattery\"><p class=\"help-block\" translate=\"ipmApp.batteryTesting.batteryTestingAddDialog.messages.error.invalidBattery\">This battery cannot be assigned because it has no questions.</p></div></div><div class=\"form-group text-left\"><label translate=\"ipmApp.batteryTesting.batteryTestingAddDialog.departmentLabel\">Department</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"pb-4\"><select class=\"form-control\" name=\"departmentTypes\" id=\"frpStatus\" ng-model=\"vm.departmentSeleted\" ng-options=\"opt as \'ipmApp.departmentType.\'+ opt | translate for opt in vm.departmentTypes\"></select></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || vm.isInvalidBattery\" class=\"btn btn-primary\"><span translate=\"entity.action.assign\">Assign</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/battery-testing/battery-testing-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.batteryTesting.batteryTestingDeleteDialog.header\">Delete confirmation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.batteryTesting.batteryTestingDeleteDialog.question\">Are you sure you want to delete Assign Battery?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/battery-testing/battery-testing-list.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"surveyResult.battery.nameEn\"><span>{{\'ipmApp.batteryTesting.tableLabel.batteryNameLabel\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyResult.status\"><span>{{\'ipmApp.batteryTesting.tableLabel.statusLabel\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyResult.lastModifiedDate\"><span>{{\'ipmApp.batteryTesting.tableLabel.dateLastUpdatedLabel\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyResult.finalCompletionDate\"><span class=\"px-1\">{{\'ipmApp.batteryTesting.tableLabel.completionDateLabel\' | translate}}</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" ng-show=\"vm.isManager\"><span>{{\'ipmApp.batteryTesting.tableLabel.downloadResultsLabel\' | translate}}</span></th><th class=\"text-center\"><span>{{\'ipmApp.batteryTesting.tableLabel.downloadResponsesLabel\' | translate}}</span></th><th class=\"text-center\"><span>{{\'ipmApp.batteryTesting.tableLabel.actionLabel\' | translate}}</span></th><th class=\"text-center\"><span>{{\'ipmApp.batteryTesting.tableLabel.launchLabel\' | translate}}</span></th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"sr in vm.surveyResults track by $index\"><td><span>{{sr.batteryNameEn}}</span></td><td>{{\'ipmApp.batteryTesting.batteryTestingStatus.\' + sr.status | translate}} <span ng-if=\"sr.status && sr.status === \'STARTED\'\">- {{ sr.progressDisplay }}</span></td><td><span ng-if=\"sr.lastModifiedDate\">{{ sr.lastModifiedDate | date:\'MM/dd/yyyy\' }}</span> <span ng-if=\"!sr.lastModifiedDate\">{{ sr.createdDate | date:\'MM/dd/yyyy\' }}</span></td><td><span ng-if=\"sr.finalCompletionDate\">{{ sr.finalCompletionDate | date:\'MM/dd/yyyy\' }}</span></td><td class=\"text-center\" ng-show=\"vm.isManager\"><a ng-if=\"sr.status === \'COMPLETE\' || sr.status === \'INCOMPLETE\' || sr.status === \'DOWNLOADED\'\" href=\"{{ \'api/survey-results/download/\' + sr.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td><td class=\"text-center\"><a ng-if=\"sr.status === \'COMPLETE\' || sr.status === \'INCOMPLETE\' || sr.status === \'DOWNLOADED\'\" href=\"{{ \'api/survey-results/download-response/\' + sr.id }}\" class=\"glyphicon glyphicon-download-alt\"></a></td><td class=\"text-center\"><button type=\"button\" title=\"Delete Assign Battery\" class=\"btn btn-danger btn-sm btn-smaller\" ng-if=\"sr.status === \'NOT_STARTED\'\" ng-disabled=\"vm.isBiller\" ui-sref=\"battery-testing-delete({surveyResultId: sr.id})\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td class=\"text-center\"><button type=\"button\" ng-if=\"sr.status !== \'COMPLETE\' && sr.status !== \'DOWNLOADED\'\" class=\"glyphicon glyphicon-log-in button-reset\" data-toggle=\"Launch\" ng-click=\"vm.goToHAQBattery($event, sr)\" ng-disabled=\"vm.isBiller\" ng-class=\"vm.isBiller ? \'not_allowed\' : \'\'\"></button></td><td class=\"text-center\"><u ng-if=\"(sr.status === \'NOT_STARTED\' || sr.status === \'STARTED\' || sr.status === \'INCOMPLETE\')\"><button type=\"button\" class=\"button-reset underline\" translate=\"ipmApp.batteryTesting.button.resendLabel\" ng-click=\"vm.resendHAQBattery(sr)\" ng-disabled=\"(vm.isBiller || vm.isDisableLaunchResendHAQBattery(sr))\" ng-class=\"(vm.isBiller || vm.isDisableLaunchResendHAQBattery(sr)) ? \'not_allowed\' : \'\'\"></button></u></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableHaq.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div>");
$templateCache.put("app/patient/haq-evaluations/haq-evaluations.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"inactive-wrap is-inactive\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span>{{\'ipmApp.downloadHaqEvaluation.detail.id\' | translate}}</span></th><th jh-sort-by=\"batteryTest.battery.id\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.batteryName\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"batteryTest.id\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.testId\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"status\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"dateStarted\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.startedDate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"dateCompleted\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.completionDate\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th jh-sort-by=\"timeSpent\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.timeSpent\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></th><th class=\"text-center\" ng-show=\"vm.isManager || vm.isBiller\"><span>{{\'ipmApp.downloadHaqEvaluation.detail.downloadHaq\' | translate}}</span></th></tr></thead><tbody><tr ng-repeat=\"haq in vm.haqEvaluations\"><td>{{vm.getIndex($index)}}</td><td>{{haq.batteryName}}</td><td>{{haq.batteryTestId}}-{{haq.surveyResultVersionId}}<span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" ng-if=\"haq.briefReview\"></span></td><td>{{\'ipmApp.downloadHaqEvaluation.status.\' + haq.status | translate}}</td><td><span>{{ haq.startedDate | date:\'MM/dd/yyyy\' }}</span></td><td><span>{{ haq.completedDate| date:\'MM/dd/yyyy\' }}</span></td><td><seconds-transfer total-seconds=\"haq.timeSpent\"></seconds-transfer></td><td class=\"text-center\" ng-show=\"vm.isManager || vm.isBiller\"><a ng-if=\"haq.status === \'REVIEWED\'\" href=\"{{ \'api/haq-evaluation-workflow/download/\' + haq.haqEvaluationId }}\" class=\"glyphicon glyphicon-download-alt\"></a></td></tr></tbody></table></div></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableHaq.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div>");
$templateCache.put("app/patient/input-patient-case-dialog/input-patient-case-dialog.html","<form name=\"enrollPatientForm\" role=\"form\" novalidate ng-init=\"vm.modalLoaded()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.patient.patientCase.inputCaseNumber\">Input Case Number</h5></div><div class=\"modal-body mb-2 patient-case\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><ui-select ng-model=\"vm.patientCaseSelect\" theme=\"bootstrap\" ng-disabled=\"vm.patientCases.length === 0\" close-on-select=\"true\" style=\"width: 100%\" ng-keydown=\"vm.clearPatientCaseSelection()\" ng-change=\"vm.searchTextOnChange()\"><ui-select-match allow-clear placeholder=\"Select case number...\"><span title=\"{{$select.selected.caseNumber}}\">{{$select.selected.caseNumber}}</span></ui-select-match><ui-select-choices refresh=\"vm.updateSearchText($select.search)\" repeat=\"pc in vm.patientCases | filter:$select.search\"><div ng-bind-html=\"pc.caseNumber  | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><p class=\"help-block text-center\">{{\'ipmApp.patient.patientCase.inputPatientCaseNoResult\' | translate}}</p></ui-select-no-choice></ui-select></div><div class=\"form-group\"><div class=\"text-center\"><p class=\"help-block voffset3\" ng-if=\"vm.loadedData && vm.patientCases.length === 0\">{{\'ipmApp.patient.patientCase.messageNoCaseFound\' | translate}}</p><p class=\"help-block voffset3\" ng-if=\"vm.checkCaseHasBeenOptedOut()\">{{\'ipmApp.patient.patientCase.messageHasBeenOptedOut\' | translate}}</p></div></div></div><div class=\"modal-footer d-flex justify-content-end\"><button type=\"button\" ng-click=\"vm.clickOk()\" ng-disabled=\"!vm.checkValidInputCase() || vm.isSaving || vm.searchText\" class=\"btn btn-primary mx-3\"><span translate=\"entity.action.ok\">Ok</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/input-patient-case-dialog/opted-out-haq-test-dialog.html","<form name=\"vm.confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.no()\">&times;</button><h5 class=\"modal-title\">Warning</h5></div><div class=\"modal-body text-center\"><label><span translate=\"ipmApp.patient.patientCase.messageOptedOutOfHAQTests\">This case has been opted out of HAQ tests, do you want to override?</span></label><div class=\"form-group text-left\"><label translate=\"ipmApp.patient.patientCase.overrideReason\">Override reason</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><textarea class=\"form-control vertical-resize-textarea\" ng-model=\"vm.exclusionReason\" rows=\"3\" required></textarea></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.no()\"><span translate=\"entity.action.no\">No</span></button> <button type=\"button\" ng-disabled=\"vm.confirmForm.$invalid\" ng-click=\"vm.yes()\" class=\"btn btn-primary\"><span translate=\"entity.action.yes\">Yes</span></button></div></form>");
$templateCache.put("app/patient/wellness-class/class-session-registration-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.classSessionRegistration.action.addACourse\">Add a Course</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--course--><div class=\"form-group\"><label translate=\"ipmApp.classSessionRegistration.label.course\">Course</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select ng-if=\"vm.courses\" class=\"form-control\" name=\"course\" id=\"course\" ng-model=\"vm.classSessionRegistration.course.id\" ng-change=\"vm.courseChange()\" ng-required=\"true\" ng-options=\"c.id as c.name for c in vm.courses\"><option value=\"\" selected=\"selected\"></option></select><div class=\"col-md-12\" ng-show=\"(editForm.course.$dirty && editForm.course.$invalid)\"><p class=\"help-block\" translate=\"ipmApp.classSessionRegistration.validation.courseRequired\">The course is required.</p></div></div><!--nextClass--><div class=\"form-group\"><label translate=\"ipmApp.classSessionRegistration.label.nextClass\">Next Class</label><span class=\"pl-2\" ng-if=\"vm.wellnessClassCurrent\"><span ng-if=\"vm.wellnessClassCurrent.sequence\">(#{{vm.wellnessClassCurrent.sequence}})</span> <span>{{vm.wellnessClassCurrent.name}}</span></span></div><!--classSession--><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th class=\"col-md-4\"><span translate=\"ipmApp.classSessionRegistration.label.instructor\"></span></th><th class=\"col-md-4\"><span translate=\"ipmApp.classSessionRegistration.label.date\"></span></th><th class=\"col-md-4\"><span translate=\"ipmApp.classSessionRegistration.label.time\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"cs in vm.wellnessClassCurrent.classSessions track by cs.id\"><td class=\"col-md-5 text-nowrap\"><span ng-if=\"cs\">{{cs.instructorFirstName}} {{cs.instructorLastName}}</span></td><td class=\"col-md-3 text-nowrap\"><span ng-if=\"cs\">{{cs.classStart | date: \'MM/dd/yyyy\'}}</span></td><td class=\"col-md-3 text-nowrap\"><span ng-if=\"cs\">{{cs.classStart | date: \'hh:mm a\'}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ng-click=\"vm.registerClick(cs)\" ng-disabled=\"editForm.$invalid || isSaving || vm.isMaximumNumberRegister(cs)\" class=\"btn btn-primary\"><span translate=\"ipmApp.classSessionRegistration.action.register\">Register</span></button></div></td></tr></tbody></table></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/wellness-class/class-session-registration-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.classSessionRegistration.delete.title\">Confirm delete operation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"ipmApp.classSessionRegistration.delete.question\" translate-values=\"{wellnessClassName: \'{{vm.wellnessClassName}}\'}\">Are you sure you want to delete this Course ?</p></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\"><span translate=\"entity.action.delete\">Delete</span></button> <button type=\"button\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/patient/wellness-class/class-session-registration.html","<div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" type=\"button\" ui-sref=\"course-add\"><span translate=\"ipmApp.classSessionRegistration.action.addACourse\">Add a Course</span></button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th class=\"w-40-p\" jh-sort-by=\"course.name\"><span translate=\"ipmApp.classSessionRegistration.course\"></span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"w-35-p\"><span translate=\"ipmApp.classSessionRegistration.nextClass\"></span></th><th class=\"w-20-p\"><span translate=\"ipmApp.classSessionRegistration.nextClassDateTime\"></span></th><th class=\"w-5-p\"></th></tr></thead><tbody><tr ng-repeat=\"csr in vm.classSessionRegistrations track by csr.id\"><td width=\"40%\"><span ng-if=\"csr.course\">{{csr.course.name}}</span></td><td width=\"35%\"><span ng-if=\"csr.classSession && csr.classSession.wellnessClass\">{{csr.classSession.wellnessClass.name}}</span></td><td width=\"20%\"><span ng-if=\"csr.classSession\">{{csr.classSession.classStart | date: \'MM/dd/yyyy hh:mm a\'}}</span></td><td width=\"5%\" class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ui-sref=\"course-delete({csrId: csr.id})\" class=\"btn btn-sm\" ng-disabled=\"vm.isBiller\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></td></tr></tbody><tbody ng-if=\"!vm.classSessionRegistrations || vm.classSessionRegistrations.length === 0\"><tr><td colspan=\"4\"><p class=\"text-center\" translate=\"ipmApp.classSessionRegistration.dialog.notExists\">No registered courses.</p></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.pageableAP.totalItems\" ng-model=\"vm.pageableAP.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadPage(vm.pageableAP.page)\" ng-if=\"vm.pageableAP.totalItems > vm.pageSize\"></uib-pagination></div></div></div>");
$templateCache.put("app/presentation-controls-instructor/presentation-patient-response/presentation-patient-response-management.html","<div ng-if=\"vm.showPatientNotPresentsLabel\" class=\"mb-3\"><button class=\"btn-transparent\" ng-click=\"vm.isShowingAbsentPatients =! vm.isShowingAbsentPatients\">[<span class=\"glyphicon\" ng-class=\"vm.isShowingAbsentPatients?\'glyphicon-minus\':\'glyphicon-plus\'\"></span>] <span translate=\"ipmApp.presentationControls.label.showPatientNotPresents\" translate-value-show=\"{{vm.isShowingAbsentPatients}}\" translate-value-count=\"{{vm.countPP}}\">{{vm.isShowingAbsentPatients?\'Hide\':\'Show\'}} {{vm.countPP}} patient(s) not present</span></button></div><div ng-if=\"vm.showExpandAll && vm.countPP > 0\"><button ng-if=\"vm.isExpandAll\" class=\"patient-card-collapse-btn\" ng-click=\"vm.expandAllClick()\" translate=\"ipmApp.presentationControls.action.expandAll\">Expand All</button> <button ng-if=\"!vm.isExpandAll\" class=\"patient-card-collapse-btn\" ng-click=\"vm.expandAllClick()\" translate=\"ipmApp.presentationControls.action.collapseAll\">Collapse All</button></div><div ui-sortable=\"vm.isDisableDrapDrop || vm.sortableOptions\" ng-show=\"!vm.showPatientNotPresentsLabel || vm.isShowingAbsentPatients\" ng-model=\"vm.patientPresentations\"><div class=\"row-v4 patient-card-drag-list\" ng-include=\"\'patient-presentations-details\'\"></div></div><script type=\"text/ng-template\" id=\"patient-presentations-details\"><div class=\"col-v4-sm-6 col-v4-md-4 patient-card-drag-area\" ng-repeat=\"patientPresentation in vm.patientPresentations track by patientPresentation.patient.id\">\n        <uib-accordion close-others=\"true\">\n            <div\n                class=\"panel-default primary patient-card-accordion\"\n                uib-accordion-group\n                heading=\"Custom template\"\n                is-open=\"true\"\n                is-disabled=\"true\">\n                <uib-accordion-heading>\n                        <span class=\"patient-card-drag-icon\">\n                            <span class=\"glyphicon glyphicon-option-vertical\"></span>\n                            <span class=\"glyphicon glyphicon-option-vertical\"></span>\n                        </span>\n                    <a ng-click=\"vm.accordionStatus[patientPresentation.patient.id] = !vm.accordionStatus[patientPresentation.patient.id]\">\n                        {{patientPresentation.patient.lastName}}, {{patientPresentation.patient.firstName}}  - {{patientPresentation.patient.patientId}}\n                        <i class=\"glyphicon patient-card-toggle-icon\" ng-class=\"{\'glyphicon glyphicon-minus\': (vm.accordionStatus[patientPresentation.patient.id]), \'glyphicon glyphicon-plus\': !(vm.accordionStatus[patientPresentation.patient.id])}\"></i>\n                    </a>\n                </uib-accordion-heading>\n                <div ng-if=\"vm.isManagerTemplate\">\n                    <patient-response-details deck=\"vm.deck\" slide=\"vm.slide\"\n                                              patient-presentation=\"patientPresentation\"\n                                              is-patient-open=\"vm.accordionStatus[patientPresentation.patient.id]\"\n                                              is-change-patient-presentation=\"vm.isChangePatientPresentation\"\n                                              is-show-response-open=\"vm.isShowResponseOpen\"\n                                              is-saving-drap-change=\"vm.isSavingDrapChange\"\n                                              is-show-attendance-open=\"vm.isShowAttendanceOpen\"\n                                              on-change=\"vm.onChangePatientPresentation(patientPresentation)\"\n                    >\n                    </patient-response-details>\n                </div>\n                <div ng-if=\"vm.isSummaryTemplate\">\n                    <patient-response-summary deck=\"vm.deck\"\n                                              slides=\"vm.slides\"\n                                              accordion-status=\"vm.accordionStatus[patientPresentation.patient.id]\"\n                                              patient-presentation=\"patientPresentation\"\n                                              is-patient-open=\"vm.accordionStatus[patientPresentation.patient.id]\"\n                                              is-change-patient-presentation=\"vm.isChangePatientPresentation\"\n                                              is-saving-drap-change=\"vm.isSavingDrapChange\"\n                                              on-change=\"vm.onChangePatientPresentation(patientPresentation)\"\n                    >\n                    </patient-response-summary>\n                </div>\n            </div>\n        </uib-accordion>\n    </div></script>");
$templateCache.put("app/presentation-controls-instructor/presentation-view-patient/presentation-view-patient.html","<div class=\"presentation-view\"><header class=\"header\"><div class=\"container\"><div class=\"img-logo\"><img src=\"content/images/logo.jpg\"></div></div></header><div class=\"container\"><div class=\"content\"><div class=\"h5 presentation-view-name primary\"><div class=\"container-fluid\">{{vm.className}}</div></div><div class=\"presentation-view-content\"><div class=\"pdf-viewer-scroll-content\"><pdf-only-view ng-if=\"vm.pdfData\" pdf-data=\"vm.pdfData\" uint8-enable=\"true\" current-page=\"vm.pdfCurrentSlide\" zoom-to-scale=\"vm.zoomToScale\"></pdf-only-view></div></div></div></div></div>");
$templateCache.put("app/psych-intake/workflow/workflow.html","<form name=\"form\" role=\"form\" novalidate><div ng-include=\"vm.template\"></div><div class=\"row\" ng-show=\"vm.dataWorkflow.action != \'COMPLETE\'\"><div class=\"col-md-12 voffset2 text-center\" style=\"margin-top: 20px\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.back()\" ng-disabled=\"!vm.dataWorkflow.backActive\"><span translate=\"psychIntake.action.back\">Back</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.next()\" ng-disabled=\"!vm.dataWorkflow.nextActive || form.$invalid || vm.disabledIfNotSigned()\"><span translate=\"psychIntake.action.next\">Next</span></button><div ng-show=\"form.lastName.$error.required || form.firstName.$error.required \n                        || form.dateOfBirth.$error.required || form.cellNumber.$error.required || form.homeTelephone.$error.required \"><p class=\"help-block\" translate=\"surveyWorkflow.error.requireAllFill\">* Please fill in all required fields above</p></div></div></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/care-plan-review-workflow.html","<div class=\"page page--survey-workflow\" mouse-change on-change-mouse-move=\"vm.onChangeMouseMove(position)\"><div class=\"container\"><div class=\"content\"><div class=\"border-bottom pb-3\"><div class=\"row-v4\"><div class=\"col-v4-md mb-3\"><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.qhpWorkflow.patientName\"></span>: {{vm.cprEntity.patientFirstName + \' \' + vm.cprEntity.patientLastName + \' (\' + vm.cprEntity.patientId + \')\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.qhpWorkflow.dob\"></span>: {{vm.cprEntity.dateOfBirth | date:\'MM/dd/yyyy\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.qhpWorkflow.lastCPRDate\"></span>: {{vm.cprEntity.previous ? vm.cprEntity.previous.completedDate : \'\' | date:\'MM/dd/yyyy\'}} <span ng-if=\"vm.cprEntity.previous\"><span class=\"mx-2\">-</span> <a ng-click=\"vm.downloadLastedCPR()\" href=\"javascript:void(0)\" class=\"text-reset\"><span>{{\'ipmApp.qhpWorkflow.action.download\' | translate}}</span></a></span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.qhpWorkflow.timeSpent\"></span>: <span ng-class=\"vm.getCssTimeSpent()\" ng-hide=\"!vm.isDislayTimer\"><time-spent-worker start-time=\"vm.duration\"></time-spent-worker></span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.qhpWorkflow.performingProvider\"></span>: {{vm.cprEntity.qhpUserFirstName + \' \' + vm.cprEntity.qhpUserLastName}}<span ng-if=\"vm.cprEntity.qhpUserCredentials\">{{\', \' + vm.cprEntity.qhpUserCredentials}}</span></div></div><div class=\"col-v4-md-auto\"><call-log care-plan-review-id=\"vm.cprEntity.cprId\" patient-id=\"vm.patientId\" qhp-user-id=\"vm.cprEntity && vm.cprEntity.qhpUserId ? vm.cprEntity.qhpUserId : null\" is-ad-hoc=\"vm.cprEntity.adHoc\"></call-log></div></div></div><form name=\"evaluationForm\" role=\"form\" novalidate><div class=\"row\"><div class=\"col-md-8\"><div class=\"step mt-3\"><div class=\"indicator\" ng-repeat=\"statusIndicator in vm.statusIndicators track by $index\"><cpr-status-indicator status-indicator=\"statusIndicator\" css=\"vm.getCssStatusIndicator(statusIndicator)\"></cpr-status-indicator></div></div></div><div class=\"col-md-4 mt-3\"><div class=\"row-v4 justify-content-center\"><div class=\"pr-1 mt-2\"><label translate=\"ipmApp.qhpWorkflow.lastOfficeVisitDate\">Date Of Last Office Visit:</label></div><div class=\"ml-2 form-group\"><div class=\"input-group\"><input id=\"field_openVisitDate\" type=\"text\" class=\"form-control\" name=\"openVisitDate\" uib-datepicker-popup=\"{{vm.dateFormat}}\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" datepicker-options=\"vm.datePickerOptions\" ng-model=\"vm.cprEntity.lastOfficeVisitDate\" is-open=\"vm.isOpenVisitDate\" ng-change=\"vm.openVisitDateChange(evaluationForm.openVisitDate)\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"evaluationForm.openVisitDate.$dirty && evaluationForm.openVisitDate.$invalid\"><p class=\"help-block\" ng-show=\"evaluationForm.openVisitDate.$error.required\" translate=\"ipmApp.qhpWorkflow.validation.openVisitDate.required\">This field is required.</p><p class=\"help-block\" ng-show=\"evaluationForm.openVisitDate.$error.date\" translate=\"ipmApp.qhpWorkflow.validation.openVisitDate.error\">This field is invalid.</p><p class=\"help-block\" ng-show=\"!evaluationForm.openVisitDate.$error.date && evaluationForm.openVisitDate.$error.errorMaxDate\" translate=\"ipmApp.qhpWorkflow.validation.openVisitDate.errorMaxDate\">This field can not be in the future.</p></div></div></div></div></div><div ng-repeat=\"section in vm.cprEntity.sections track by section.id\"><cpr-section section=\"section\" values=\"vm.mapSectionValues\" all-answers=\"vm.allAnswers\" all-previous-answers=\"vm.allPreviousAnswers\" patient-work-status=\"vm.cprEntity.patientWorkStatus\" surgical-candidacy-status=\"vm.surgicalCandidacyStatus\" on-section-answer-change=\"vm.handleSectionAnswerChange(data)\" on-section-values-change=\"vm.handleSectionValuesChange(data)\" cases=\"vm.cprEntity.cases\" deleted-cases=\"vm.deletedCases\" cpr-id=\"vm.cprEntity.cprId\"></cpr-section></div><!--internal review--><internal-review cpr=\"vm.cprEntity\"></internal-review><!-- Signature --><h3 class=\"primary title my-5 text-left\">{{\'ipmApp.qhpWorkflow.signature\' | translate}}<span class=\"glyphicon glyphicon-asterisk icon-required ml-2\" aria-hidden=\"true\"></span></h3><signature-pad ng-if=\"vm.isShowSignaturePad\" width=\"300\" height=\"200\" on-change=\"vm.onChangeSignature(data)\" remove-blank=\"true\" clear=\"true\" get=\"false\" disabled=\"false\" class=\"d-inline-block\"></signature-pad><div style=\"width: 300px\" ng-if=\"!vm.isShowSignaturePad\"><div class=\"signature border border-secondary mb-2\"><img ng-if=\"vm.signatureData\" src=\"{{vm.signatureData}}\"></div><button type=\"button\" class=\"btn btn-link px-0 m-auto\" ng-class=\"!vm.isShowSignaturePad ? \'d-block\' : \'d-none\'\" ng-click=\"vm.isShowSignaturePad = !vm.isShowSignaturePad\">{{\'global.datepicker.clear\' | translate}}</button></div><div class=\"text-danger text-left mb-0 pb-2\" ng-if=\"vm.isShowTimeSpentErrorMessage()\"><span translate=\"ipmApp.qhpWorkflow.validation.timeSpentErrorMessage\"></span></div><div class=\"text-danger text-left mb-0 pb-2\" ng-if=\"vm.isShowPatientCaseError\"><span translate=\"ipmApp.qhpWorkflow.validation.patientCaseError\" translate-values=\"{caseNumbers: \'{{vm.patientCasesExists}}\'}\"></span></div><!-- Buttons --><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" class=\"btn btn-info\" ng-click=\"vm.back()\"><span translate=\"entity.action.cancel\">Back</span></button> <button type=\"button\" ng-disabled=\"vm.isSaving || vm.isDisableSaveAndLater(evaluationForm)\" class=\"btn btn-primary\" ng-click=\"vm.saveAndLater()\"><span translate=\"entity.action.saveForLater\">Save For Later</span></button> <button type=\"button\" ng-disabled=\"evaluationForm.$invalid || vm.isSaving || vm.isInvalidTimespent || vm.notHaveSignature() || invalidOpenVisitDateChange || vm.checkInValidBillTo()\" class=\"btn btn-primary\" ng-click=\"vm.submit(true)\"><span translate=\"entity.action.submit\">Submit</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.skipReview()\"><span translate=\"ipmApp.qhpWorkflow.skipReview\">SkipReview</span></button></div></div></form></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-brief-review-workflow/brief-review-overview.html","<div class=\"text-left\"><span ng-if=\"vm.type === \'COMM\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.COMM\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'SOAPP_5\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.SOAPP_5\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'EPWORTH\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.EPWORTH\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'ISI\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.ISI\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'CES_D\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.CES_D\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'GAD_7\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.GAD_7\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'FAB_Q\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.FAB_Q\" translate-values=\"{name: \'{{vm.patientName}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'TSK\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.TSK\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'PCS\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.PCS\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'OSWESTRY\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.OSWESTRY\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'QUICKDASH\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.QUICKDASH\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'PDI\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.PDI\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'NDI\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.NDI\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', rangeReview: \'{{vm.rangeReviewText}}\' }\"></span></div>");
$templateCache.put("app/qhp-workflow/haq-brief-review-workflow/haq-brief-review-workflow.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.haqTest\"><div class=\"border-bottom pb-3\"><div class=\"row-v4\"><div class=\"col-v4 col-v4-md-6 mb-3\"><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.patientName\"></span>: {{vm.briefReviewEntity.patientFirstName + \' \' + vm.briefReviewEntity.patientLastName + \' (\' + vm.briefReviewEntity.patientId + \')\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.dob\"></span>: {{vm.briefReviewEntity.dateOfBirth | date:\'MM/dd/yyyy\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.testReviewDate\"></span>: {{vm.briefReviewEntity.testReviewDate | date:\'MM/dd/yyyy\'}}</div><div hidden=\"true\" class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.timeSpent\"></span>: <span ng-class=\"vm.timerTextClass()\" timer time-sec=\"vm.timerSeconds\" on-change=\"vm.onChangeTimer(data)\" stop=\"vm.isStopTimer()\"></span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.performingProvider\"></span>: {{vm.briefReviewEntity.qhpUserFirstName + \' \' + vm.briefReviewEntity.qhpUserLastName}}<span ng-if=\"vm.briefReviewEntity.qhpUserCredentials\">{{\', \' + vm.briefReviewEntity.qhpUserCredentials}}</span></div></div><div class=\"col-v4 col-v4-md-6 pl-lg-5 mb-3\"><div class=\"mb-2\"><span class=\"bold\">{{vm.briefReviewEntity.batteryName}}</span>: <span><a ng-click=\"vm.downloadResultPdf(vm.briefReviewEntity.haqTest.surveyResultId)\" href=\"javascript:void(0)\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResult\' | translate}}</span> </a><span class=\"mx-2\">|</span> <a ng-click=\"vm.downloadResponsePdf(vm.briefReviewEntity.haqTest.surveyResultId)\" href=\"javascript:void(0)\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResponse\' | translate}}</span></a></span></div><div ng-if=\"vm.briefReviewEntity.evaluationTestScores\"><div class=\"form-row-v4 py-2\" ng-repeat=\"evaluationTestScores in vm.briefReviewEntity.evaluationTestScores track by evaluationTestScores.type\"><div class=\"col-v4 col-v4-md-12\"><span ng-if=\"vm.checkQuestionSkipCommon(evaluationTestScores)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <span>{{\'ipmApp.landingPageHAQ.home.haqEvaluationType.\' + evaluationTestScores.type | translate}}</span> - Score: <span ng-class=\"{\'text-danger\' : (evaluationTestScores.typeScore === \'HIGH_SCORES\')}\">{{evaluationTestScores.typeScore !== \'NA_SCORES\' ? evaluationTestScores.score : \'N/A\'}}</span></div></div></div></div></div></div><form name=\"briefReviewForm\" role=\"form\" novalidate><!-- Question --><h3 class=\"primary title my-5 text-left\"><span translate=\"ipmApp.landingPageHAQ.home.selectOption.title\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h3><div class=\"pb-4\"><div class=\"form-check-v4\" ng-repeat=\"(key, option) in [true, false]\"><input type=\"radio\" class=\"form-check-input-v4\" id=\"radio_{{option}}\" name=\"radio_SINGLE_CHOICE_{{option}}\" ng-value=\"option\" ng-model=\"vm.briefReviewEntity.briefReviewResponse.showTemplate\" required><label class=\"form-check-label-v4\" for=\"radio_{{option}}\">{{ \'ipmApp.landingPageHAQ.home.selectOption.\' + option | translate }}</label></div><!--                    <div ng-show=\"evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$dirty && !vm.valueOtherSingleChoiceTextInputValue\">--><!--                        <p class=\"help-block\"--><!--                           ng-show=\"evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$error.required\" translate=\"entity.validation.required\">--><!--                            This field is required.--><!--                        </p>--><!--                    </div>--></div><h3 class=\"primary title my-5 text-left\"><span translate=\"ipmApp.landingPageHAQ.home.reportAnything\"></span></h3><div><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"freeTextField\" id=\"freeTextField\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleFreeTextChange()\" ng-model=\"vm.briefReviewEntity.briefReviewResponse.report\">\n                    </textarea><!--                    <div ng-show=\"evaluationForm.freeTextField.$dirty && !vm.valueAnswer\">--><!--                        <p class=\"help-block\"--><!--                           ng-show=\"evaluationForm.freeTextField.$error.required\" translate=\"entity.validation.required\">--><!--                            This field is required.--><!--                        </p>--><!--                    </div>--><!--                    <div ng-show=\"evaluationForm.freeTextField.$dirty && evaluationForm.freeTextField.$error.minimumValue\">--><!--                        <p class=\"help-block\">--><!--                            <span translate=\"ipmApp.landingPageHAQ.validation.minimumValue\">You must include at least 50 words.</span>--><!--                        </p>--><!--                    </div>--></div><!--Note--><!-- BUTTONS --><nav aria-label=\"Page navigation\" class=\"text-center\"><ul class=\"pagination d-block d-md-inline-block\"><li ng-class=\"{\'disabled\': vm.isSaving || vm.isDisablePreviousButton()}\"><a aria-label=\"Previous\" ng-click=\"vm.previous()\" ng-disabled=\"vm.isSaving || vm.isDisablePreviousButton()\"><span aria-hidden=\"true\" translate=\"surveyWorkflow.action.previous\">Previous</span></a></li><li ng-class=\"{\'disabled\': vm.isSaving || briefReviewForm.$invalid || vm.isDisableNextButton()}\"><a aria-label=\"Next\" ng-click=\"vm.next(briefReviewForm.$invalid)\" ng-disabled=\"vm.isSaving\"><span aria-hidden=\"true\" translate=\"surveyWorkflow.action.next\">Next</span></a></li></ul></nav></form><!--<div class=\"voffset2 text-center\" ng-if=\"vm.mainQuestion.lastQuestion\">\n                <span>{{\'ipmApp.landingPageHAQ.home.test2\' | translate}}</span>\n            </div>--></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-brief-review-workflow/landing-page.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><div class=\"px-md-5\" ng-if=\"!vm.noHaveHaqBriefReadyForReview\"><div class=\"mb-4 text-center\"><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.patientName\"></span>: {{vm.briefReviewEntity.patientFirstName + \' \' + vm.briefReviewEntity.patientLastName + \' (\' + vm.briefReviewEntity.patientId + \')\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.dob\"></span>: {{vm.briefReviewEntity.dateOfBirth | date:\'MM/dd/yyyy\'}}</div><div class=\"mb-2\"><span class=\"bold\">{{vm.briefReviewEntity.batteryId}}-{{vm.briefReviewEntity.batteryName}}</span>: <span><a ng-click=\"vm.downloadResultPdf(vm.briefReviewEntity.haqTest.surveyResultId)\" href=\"javascript:void(0)\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResult\' | translate}}</span> </a><span class=\"mx-2\">|</span> <a ng-click=\"vm.downloadResponsePdf(vm.briefReviewEntity.haqTest.surveyResultId)\" href=\"javascript:void(0)\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResponse\' | translate}}</span></a></span></div><div class=\"py-4\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.instruments\">Instruments</span></div><div ng-if=\"vm.briefReviewEntity.evaluationTestScores\"><div class=\"form-row-v4 py-2\" ng-repeat=\"evaluationTestScores in vm.briefReviewEntity.evaluationTestScores\"><div class=\"col-v4 col-v4-md-12\"><span>{{\'ipmApp.landingPageHAQ.home.haqEvaluationType.\' + evaluationTestScores.type | translate}}</span>: <span ng-class=\"{\'text-danger\' : (evaluationTestScores.typeScore === vm.typeScores.highScores)}\">{{evaluationTestScores.typeScore !== \'NA_SCORES\' ? evaluationTestScores.score : \'N/A\'}}</span></div></div></div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.testReviewDate\"></span>: {{vm.briefReviewEntity.testReviewDate | date:\'MM/dd/yyyy\'}}</div><!--                    <div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.timeSpent\"></span>:--><!--                        <span ng-class=\"vm.timerTextClass()\" timer time-sec=\"vm.timerSeconds\" stop=\"vm.isStopTimer()\"></span>--><!--                    </div>--><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.performingProvider\"></span>: {{vm.briefReviewEntity.qhpUserFirstName + \' \' + vm.briefReviewEntity.qhpUserLastName}}<span ng-if=\"vm.briefReviewEntity.qhpUserCredentials\">{{\', \' + vm.briefReviewEntity.qhpUserCredentials}}</span></div></div><div class=\"mb-4 text-center\"><span translate=\"ipmApp.landingPageHAQ.home.test1\" translate-values=\"{patientFirstName: \'{{vm.briefReviewEntity.patientFirstName}}\', patientLastName: \'{{vm.briefReviewEntity.patientLastName}}\'}\"></span> {{vm.briefReviewEntity.testReviewDate | date:\'MM/dd/yyyy\'}}</div><div class=\"form-row-v4 py-2\" ng-repeat=\"evaluationTestScores in vm.briefReviewEntity.evaluationTestScores track by evaluationTestScores.type\"><div class=\"mb-4 text-center\" ng-if=\"evaluationTestScores.typeScore === vm.typeScores.highScores\"><haq-brief-review-overview type=\"evaluationTestScores.type\" patient-name=\"vm.briefReviewEntity.patientFirstName\" score=\"evaluationTestScores.scoreText\" score-interpretation=\"evaluationTestScores.scoreMessage\" range-review=\"evaluationTestScores.rangeReview\"></haq-brief-review-overview></div></div><div class=\"text-center\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.briefReviewEntity.wholeBatteries\" ng-click=\"vm.start()\"><span translate=\"ipmApp.landingPageHAQ.action.beginBriefReview\" ng-if=\"!vm.isResume\">Begin BriefReview</span> <span translate=\"ipmApp.landingPageHAQ.action.resumeBriefReview\" ng-if=\"vm.isResume\">Resume BriefReview</span></button></div></div><div ng-if=\"vm.noHaveHaqBriefReadyForReview\"><div class=\"row-v4 justify-content-md-center\"><div class=\"col-v4-auto\"><div class=\"thank center-block voffset3 font-s15\"><span class=\"glyphicon glyphicon-ok\"></span></div><div class=\"voffset3 text-center mb-35 font-s15\">{{\'ipmApp.landingPageHAQ.home.noHaveHaqBriefReadyForReview\' | translate}}</div></div></div></div></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-brief-review-workflow/submit-page.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12 voffset2 text-center\"><div class=\"row-v4 justify-content-center fix-on-safari-5\"><div class=\"col-v4-auto\"><label class=\"mb-3\">{{\'ipmApp.landingPageHAQ.home.signature\' | translate}}</label><div ng-if=\"vm.isShowSignaturePad\"><signature-pad width=\"auto\" height=\"200\" on-change=\"vm.onChangeSignature(data)\" remove-blank=\"true\" clear=\"true\" get=\"false\" disabled=\"false\"></signature-pad></div><div ng-if=\"!vm.isShowSignaturePad\"><div class=\"signature border border-secondary mb-2\"><img src=\"{{vm.mostRecentSignature.data}}\"></div><button type=\"button\" class=\"btn btn-link px-0 m-auto\" ng-class=\"!vm.isShowSignaturePad ? \'d-block\' : \'d-none\'\" ng-click=\"vm.isShowSignaturePad = !vm.isShowSignaturePad\">{{\'global.datepicker.clear\' | translate}}</button></div></div></div><div class=\"mt-4 text-center\"><button type=\"button\" ng-disabled=\"vm.isSaving || vm.checkSignature()\" class=\"btn btn-primary\" ng-click=\"vm.finishBriefReview()\"><span translate=\"entity.action.submit\">Submit</span></button></div></div></div></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/haq-evaluation-workflow.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.haqTest\"><div class=\"border-bottom pb-3\"><div class=\"row-v4\"><div class=\"col-v4 col-v4-md-6 mb-3\"><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.patientName\"></span>: {{vm.evaluationEntity.patientFirstName + \' \' + vm.evaluationEntity.patientLastName + \' (\' + vm.evaluationEntity.patientId + \')\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.dob\"></span>: {{vm.evaluationEntity.dateOfBirth | date:\'MM/dd/yyyy\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.testReviewDate\"></span>: {{vm.evaluationEntity.testReviewDate | date:\'MM/dd/yyyy\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.timeSpent\"></span>: <span ng-class=\"vm.timerTextClass()\"><time-spent-worker start-time=\"vm.timerSeconds\"></time-spent-worker></span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.performingProvider\"></span>: {{vm.evaluationEntity.qhpUserFirstName + \' \' + vm.evaluationEntity.qhpUserLastName}}<span ng-if=\"vm.evaluationEntity.qhpUserCredentials\">{{\', \' + vm.evaluationEntity.qhpUserCredentials}}</span></div></div><div class=\"col-v4 col-v4-md-6 pl-lg-5 mb-3\"><div class=\"mb-2\"><span class=\"bold\">{{vm.evaluationEntity.batteryName}}</span>: <span><a ng-click=\"vm.downloadResultPdf(vm.evaluationEntity.haqTest.surveyResultId)\" href=\"javascript:void(0)\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResult\' | translate}}</span> </a><span class=\"mx-2\">|</span> <a ng-click=\"vm.downloadResponsePdf(vm.evaluationEntity.haqTest.surveyResultId)\" href=\"javascript:void(0)\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResponse\' | translate}}</span></a></span></div><div ng-if=\"vm.evaluationEntity.evaluationTestScores\"><div class=\"form-row-v4 py-2\" ng-repeat=\"evaluationTestScores in vm.evaluationEntity.evaluationTestScores track by evaluationTestScores.type\"><div class=\"col-v4 col-v4-md-12\"><span ng-if=\"vm.checkQuestionSkipCommon(evaluationTestScores)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <span ng-if=\"evaluationTestScores.scoreMap\"><span ng-repeat=\"(type, score) in evaluationTestScores.scoreMap track by type\"><span>{{\'ipmApp.landingPageHAQ.home.haqEvaluationType.\' + type | translate}}</span> - Score: <span ng-class=\"{\'text-danger\' : (evaluationTestScores.highScoreMap && evaluationTestScores.highScoreMap[type] === true)}\">{{evaluationTestScores.typeScore !== \'NA_SCORES\' ? score : \'N/A\'}}</span> <span ng-if=\"!$last\" class=\"pr-1\">, </span></span></span><span ng-if=\"!evaluationTestScores.scoreMap\"><span>{{\'ipmApp.landingPageHAQ.home.haqEvaluationType.\' + evaluationTestScores.type | translate}}</span> - Score: <span ng-class=\"{\'text-danger\' : (evaluationTestScores.typeScore === \'HIGH_SCORES\')}\">{{evaluationTestScores.typeScore !== \'NA_SCORES\' ? evaluationTestScores.score : \'N/A\'}}</span></span></div></div></div></div></div></div><form name=\"evaluationForm\" role=\"form\" novalidate><div ng-if=\"vm.mainQuestion\"><!-- Question --><haq-evaluation-question question=\"vm.mainQuestion\" main-question=\"vm.mainQuestion\" answers=\"vm.answers\" new-answers=\"vm.newAnswersSubmitServer\" evaluation-storage=\"vm.evaluationStorage\" on-answer-change=\"vm.handleQuestionAnswerChange(data)\"></haq-evaluation-question><!--Note--><div class=\"alert text-danger text-center mb-0 pb-0\" ng-if=\"vm.isShowTimeSpentErrorMessage()\"><span translate=\"ipmApp.landingPageHAQ.validation.timeSpentErrorMessage\"></span></div><!-- BUTTONS --><nav aria-label=\"Page navigation\" class=\"text-center\"><ul class=\"pagination d-block d-md-inline-block\"><li ng-class=\"{\'disabled\': vm.isSaving || vm.isDisablePreviousButton()}\"><a aria-label=\"Previous\" ng-click=\"vm.previous()\" ng-disabled=\"vm.isSaving || vm.isDisablePreviousButton()\"><span aria-hidden=\"true\" translate=\"surveyWorkflow.action.previous\">Previous</span></a></li><li ng-class=\"{\'disabled\': vm.isSaving || evaluationForm.$invalid || vm.isDisableNextButton()}\"><a aria-label=\"Next\" ng-click=\"vm.next(evaluationForm.$invalid)\" ng-disabled=\"vm.isSaving\"><span aria-hidden=\"true\" translate=\"surveyWorkflow.action.next\">Next</span></a></li></ul></nav></div></form><!--<div class=\"voffset2 text-center\" ng-if=\"vm.mainQuestion.lastQuestion\">\n                <span>{{\'ipmApp.landingPageHAQ.home.test2\' | translate}}</span>\n            </div>--></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/landing-page.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><div class=\"px-md-5\" ng-if=\"!vm.noHaveHaqReadyForReview\"><div class=\"mb-4 text-center\"><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.patientName\"></span>: {{vm.evaluationEntity.patientFirstName + \' \' + vm.evaluationEntity.patientLastName + \' (\' + vm.evaluationEntity.patientId + \')\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.dob\"></span>: {{vm.evaluationEntity.dateOfBirth | date:\'MM/dd/yyyy\'}}</div><div class=\"mb-2\"><span class=\"bold\">{{vm.evaluationEntity.batteryId}}-{{vm.evaluationEntity.batteryName}}</span>: <span><a href=\"{{ \'api/survey-results/download/\' + vm.evaluationEntity.haqTest.surveyResultId }}\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResult\' | translate}}</span> </a><span class=\"mx-2\">|</span> <a href=\"{{ \'api/survey-results/download-response/\' + vm.evaluationEntity.haqTest.surveyResultId }}\" class=\"text-reset\"><span>{{\'ipmApp.landingPageHAQ.home.downloadResponse\' | translate}}</span></a></span></div><div class=\"py-4\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.instruments\">Instruments</span></div><div ng-if=\"vm.evaluationEntity.evaluationTestScores\"><div class=\"form-row-v4 py-2\" ng-repeat=\"evaluationTestScores in vm.evaluationEntity.evaluationTestScores\"><div ng-if=\"evaluationTestScores.scoreMap\" class=\"col-v4 col-v4-md-12\"><span ng-repeat=\"(type, score) in evaluationTestScores.scoreMap track by type\"><span>{{\'ipmApp.landingPageHAQ.home.haqEvaluationType.\' + type | translate}}:</span> <span ng-class=\"{\'text-danger\' : (evaluationTestScores.highScoreMap && evaluationTestScores.highScoreMap[type] === true)}\">{{evaluationTestScores.typeScore !== \'NA_SCORES\' ? score : \'N/A\'}}</span> <span ng-if=\"!$last\" class=\"pr-1\">,</span></span></div><div ng-if=\"!evaluationTestScores.scoreMap\" class=\"col-v4 col-v4-md-12\"><span>{{\'ipmApp.landingPageHAQ.home.haqEvaluationType.\' + evaluationTestScores.type | translate}}</span>: <span ng-class=\"{\'text-danger\' : (evaluationTestScores.typeScore === vm.typeScores.highScores)}\">{{evaluationTestScores.typeScore !== \'NA_SCORES\' ? evaluationTestScores.score : \'N/A\'}}</span></div></div></div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.testReviewDate\"></span>: {{vm.evaluationEntity.testReviewDate | date:\'MM/dd/yyyy\'}}</div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.timeSpent\"></span>: <span ng-class=\"vm.timerTextClass()\" timer time-sec=\"vm.timerSeconds\" stop=\"vm.isStopTimer()\"></span></div><div class=\"mb-2\"><span class=\"bold\" translate=\"ipmApp.landingPageHAQ.home.performingProvider\"></span>: {{vm.evaluationEntity.qhpUserFirstName + \' \' + vm.evaluationEntity.qhpUserLastName}}<span ng-if=\"vm.evaluationEntity.qhpUserCredentials\">{{\', \' + vm.evaluationEntity.qhpUserCredentials}}</span></div></div><div class=\"mb-4 text-center\"><span translate=\"ipmApp.landingPageHAQ.home.test1\" translate-values=\"{patientFirstName: \'{{vm.evaluationEntity.patientFirstName}}\', patientLastName: \'{{vm.evaluationEntity.patientLastName}}\'}\"></span> {{vm.evaluationEntity.testReviewDate | date:\'MM/dd/yyyy\'}}</div><div class=\"form-row-v4 py-2\" ng-repeat=\"evaluationTestScores in vm.evaluationEntity.evaluationTestScores track by evaluationTestScores.type\"><div class=\"mb-4 text-center\" ng-if=\"evaluationTestScores.typeScore === vm.typeScores.highScores\"><haq-review-overview type=\"evaluationTestScores.type\" patient-name=\"vm.evaluationEntity.patientFirstName\" score=\"evaluationTestScores.scoreText\" score-interpretation=\"evaluationTestScores.scoreMessage\" range-review=\"evaluationTestScores.rangeReview\"></haq-review-overview></div></div><div class=\"text-center\"><button type=\"button\" ng-disabled=\"!vm.evaluationEntity.wholeBatteries || vm.isLoading\" class=\"btn btn-primary\" ng-click=\"vm.start()\"><span translate=\"ipmApp.landingPageHAQ.action.beginEvaluation\" ng-if=\"!vm.isResume\">Begin Evaluation</span> <span translate=\"ipmApp.landingPageHAQ.action.resumeEvaluation\" ng-if=\"vm.isResume\">Resume Evaluation</span></button> <button type=\"button\" ng-disabled=\"vm.isLoading\" class=\"btn btn-secondary-gray\" ng-click=\"vm.skipReviewEvaluation()\"><span translate=\"ipmApp.landingPageHAQ.action.skipReview\">Skip Review</span></button></div></div><div ng-if=\"vm.noHaveHaqReadyForReview\"><div class=\"row-v4 justify-content-md-center\"><div class=\"col-v4-auto\"><div class=\"thank center-block voffset3 font-s15\"><span class=\"glyphicon glyphicon-ok\"></span></div><div class=\"voffset3 text-center mb-35 font-s15\">{{\'ipmApp.landingPageHAQ.home.noHaveHaqReadyForReview\' | translate}}</div></div></div></div></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/question.html","<form name=\"evaluationForm\" role=\"form\" novalidate><h3 class=\"primary title my-5 text-left\" ng-if=\"vm.question.description\"><span ng-bind-html=\"vm.question.description\"></span></h3><h5 ng-if=\"vm.isDisplayQuestionName()\">{{vm.question.name}} <span ng-if=\"vm.isCommonLast()\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h5><!--SINGLE_CHOICE --><div class=\"pb-4\" ng-if=\"vm.isSingleChoiceQuestion()\"><div class=\"form-check-v4\" ng-class=\"vm.isDisplayCheckBoxInline() ? \'form-check-inline-v4\': \'\'\" ng-repeat=\"(key, option) in vm.question.optionNames\">{{vm.question.optionNames.length}} <input type=\"radio\" class=\"form-check-input-v4\" id=\"radio_{{option.value + \'_\' + vm.question.id}}\" name=\"radio_SINGLE_CHOICE_{{vm.question.id}}\" ng-change=\"vm.handleYesNoChange()\" ng-value=\"option.value\" ng-model=\"vm.valueAnswer\" required><label class=\"form-check-label-v4\" for=\"radio_{{option.value + \'_\' + vm.question.id}}\">{{option.key}}</label></div><textarea ng-if=\"vm.isDisplayFreeTextOtherSingleChoice()\" class=\"form-control auto-height none-resize\" rows=\"5\" name=\"otherSingleChoiceFreeTextField_{{vm.question.id}}\" id=\"otherSingleChoiceFreeTextField_{{vm.question.id}}\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleOtherSingleChoiceTextInput()\" ng-model=\"vm.valueOtherSingleChoiceTextInputValue\" ng-required=\"vm.isOtherSingleChoiceTextInputRequired()\">\n        </textarea><div ng-show=\"evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$dirty && !vm.valueOtherSingleChoiceTextInputValue\"><p class=\"help-block\" ng-show=\"evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- CHECKBOX --><div ng-if=\"vm.isCheckBoxQuestion() && vm.isCheckboxQuestionHaveOption()\"><div class=\"row-v4\" ng-repeat=\"optionItem in vm.question.questionItems track by optionItem.id\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input type=\"checkbox\" id=\"checkbox_{{optionItem.id}}_{{vm.question.id}}\" class=\"form-check-input-v4\" name=\"checkbox_{{optionItem.id}}_{{vm.question.id}}\" value=\"{{optionItem}}\" ng-model=\"optionItem.checked\" ng-required=\"vm.checkBoxRequired()\" ng-change=\"vm.handleCheckboxChange(optionItem, optionItem.checked)\"><label class=\"form-check-label-v4\" for=\"checkbox_{{optionItem.id}}_{{vm.question.id}}\">{{optionItem.name}}</label></div></div></div><!-- other checkbox autocomplete --><search-checkbox-auto-complete ng-if=\"vm.question.haveAutoComplete\" on-selected=\"vm.handleOrtherCheckboxSelected(data)\" exclude-ids=\"vm.ortherCheckboxExcludeIds\" type=\"vm.question.type\"></search-checkbox-auto-complete><textarea ng-if=\"vm.isDisplayFreeTextOtherCheckbox()\" class=\"form-control auto-height none-resize\" rows=\"5\" name=\"otherFreeTextField_{{vm.question.id}}\" id=\"otherFreeTextField_{{vm.question.id}}\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleOtherCheckboxTextInput()\" ng-model=\"vm.valueOtherCheckboxTextInputValue\" placeholder=\"{{vm.getPlaceHolderForOtherCheckbox()}}\" ng-required=\"vm.isOtherCheckboxTextInputRequired()\">\n        </textarea><div ng-show=\"evaluationForm.otherFreeTextField_{{vm.question.id}}.$dirty && !vm.valueOtherCheckboxTextInputValue\"><p class=\"help-block\" ng-show=\"evaluationForm.otherFreeTextField_{{vm.question.id}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- NUMERICAL ENTRY --><div class=\"row-v4\" ng-if=\"vm.isNumericalEntryQuestion()\"><div class=\"col-v4-95\"><input type=\"text\" class=\"form-control\" name=\"numericalField\" id=\"numericalField\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleNumericalChange()\" ng-model=\"vm.valueAnswer\" number-min-max min=\"0\" max=\"500\" required></div><div class=\"col-v4-12\"><div ng-show=\"evaluationForm.numericalField.$dirty && !vm.valueAnswer\"><p class=\"help-block\" ng-show=\"evaluationForm.numericalField.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div ng-show=\"evaluationForm.numericalField.$dirty\"><p class=\"help-block\" ng-show=\"evaluationForm.numericalField.$error.invalidRange\" translate=\"ipmApp.landingPageHAQ.validation.mmeNumber\"></p><p class=\"help-block\" ng-show=\"evaluationForm.numericalField.$error.pattern\" translate=\"ipmApp.landingPageHAQ.validation.mmeNumberPattern\"></p></div></div></div><!-- FREE_TEXT --><div ng-if=\"vm.isFreeTextQuestion()\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"freeTextField\" id=\"freeTextField\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleFreeTextChange()\" ng-model=\"vm.valueAnswer\" ng-required=\"vm.isFreeTextInputRequired()\" minimum-value=\"{{vm.minlengthInputRequired()}}\">\n        </textarea><div ng-show=\"evaluationForm.freeTextField.$dirty && !vm.valueAnswer\"><p class=\"help-block\" ng-show=\"evaluationForm.freeTextField.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div ng-show=\"evaluationForm.freeTextField.$dirty && evaluationForm.freeTextField.$error.minimumValue\"><p class=\"help-block\"><span translate=\"ipmApp.landingPageHAQ.validation.minimumValue\">You must include at least 50 words.</span></p></div></div><!-- MULTIPLE_COLUMN_CHECKBOX --><multiple-column-checkbox ng-if=\"vm.isMultipleCheckBoxColumnQuestion()\" config=\"vm.multipleCheckBoxColumnConfig\" evaluation-storage=\"vm.evaluationStorage\" on-answer-change=\"vm.handleMultipleColumnCheckboxAnswerChange(data)\"></multiple-column-checkbox><!-- sub-question --><div class=\"ml-4\" ng-repeat=\"subQuestion in vm.question.childs track by subQuestion.id\"><haq-evaluation-question question=\"subQuestion\" main-question=\"vm.mainQuestion\" answers=\"vm.answers\" new-answers=\"vm.newAnswers\" evaluation-storage=\"vm.evaluationStorage\" on-answer-change=\"vm.handleSubQuestionAnswerChange(data)\" ng-if=\"vm.isDisplaySubQuestion(subQuestion)\"></haq-evaluation-question></div><question-description-bottom question-code=\"vm.question.code\" translate-key=\"\'ipmApp.landingPageHAQ.home.test3\'\"></question-description-bottom></form>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/review-overview.html","<div class=\"text-left\"><span ng-if=\"vm.type === \'COMM\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.COMM\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'SOAPP_5\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.SOAPP_5\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'EPWORTH\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.EPWORTH\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'ISI\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.ISI\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'CES_D\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.CES_D\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'GAD_7\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.GAD_7\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'FAB_Q\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.FAB_Q\" translate-values=\"{name: \'{{vm.patientName}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'TSK\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.TSK\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\'}\"></span> <span ng-if=\"vm.type === \'PCS\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.PCS\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'OSWESTRY\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.OSWESTRY\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'QUICKDASH\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.QUICKDASH\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'PDI\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.PDI\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', scoreInterpretation: \'{{vm.scoreInterpretation}}\', rangeReview: \'{{vm.rangeReviewText}}\'}\"></span> <span ng-if=\"vm.type === \'NDI\'\" translate=\"ipmApp.landingPageHAQ.home.reviewOverview.NDI\" translate-values=\"{name: \'{{vm.patientName}}\', score: \'{{vm.score}}\', rangeReview: \'{{vm.rangeReviewText}}\' }\"></span></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/search-checkbox-autocomplete.html","<div class=\"row-v4\"><div class=\"col-v4-lg-3 col-v4-md-4\"><div class=\"form-group\"><input type=\"text\" id=\"ortherCheckboxSelected\" name=\"ortherCheckboxSelected\" class=\"form-control\" ng-model=\"vm.ortherCheckbox\" placeholder=\"Select other medication\" ng-model-options=\"{debounce: 800}\" uib-typeahead=\"ortherCheckbox as ortherCheckbox.name for ortherCheckbox in vm.loader($viewValue)\" autocomplete=\"off\" typeahead-on-select=\"vm.handleSelected()\"></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/submit-page.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-12 voffset2 text-center\"><div class=\"row-v4 justify-content-center fix-on-safari-5\"><div class=\"col-v4-auto\"><label class=\"mb-3\">{{\'ipmApp.landingPageHAQ.home.signature\' | translate}}</label><div ng-if=\"vm.isShowSignaturePad\"><signature-pad width=\"auto\" height=\"200\" on-change=\"vm.onChangeSignature(data)\" remove-blank=\"true\" clear=\"true\" get=\"false\" disabled=\"false\"></signature-pad></div><div ng-if=\"!vm.isShowSignaturePad\"><div class=\"signature border border-secondary mb-2\"><img src=\"{{vm.mostRecentSignature.data}}\"></div><button type=\"button\" class=\"btn btn-link px-0 m-auto\" ng-class=\"!vm.isShowSignaturePad ? \'d-block\' : \'d-none\'\" ng-click=\"vm.isShowSignaturePad = !vm.isShowSignaturePad\">{{\'global.datepicker.clear\' | translate}}</button></div></div></div><div class=\"mt-4 text-center\"><button type=\"button\" ng-disabled=\"vm.isSaving || vm.checkSignature()\" class=\"btn btn-primary\" ng-click=\"vm.finishEvaluation()\"><span translate=\"entity.action.submit\">Submit</span></button></div></div></div></div></div></div>");
$templateCache.put("app/qhp-workflow/wellness-class-list/wellness-class-list.html","<div class=\"page page--survey-workflow\"><div class=\"container\"><div class=\"content\"><div class=\"h2 title\" translate=\"ipmApp.qhpWorkflow.wellnessClass.home.title\"></div><jhi-alert></jhi-alert><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span>{{\'ipmApp.qhpWorkflow.wellnessClass.home.courseName\' | translate}}</span></th><th><span>{{\'ipmApp.qhpWorkflow.wellnessClass.home.classSequence\' | translate}}</span></th><th><span>{{\'ipmApp.qhpWorkflow.wellnessClass.home.className\' | translate}}</span></th><th><span>{{\'ipmApp.qhpWorkflow.wellnessClass.home.userRegistered\' | translate}}</span></th><th><span>{{\'ipmApp.qhpWorkflow.wellnessClass.home.startDate\' | translate}}</span></th><th><span>{{\'ipmApp.qhpWorkflow.wellnessClass.home.startTime\' | translate}}</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"classSession in vm.classSessions track by classSession.id\"><td>{{classSession.courseName}}</td><td>{{classSession.classSequenceNumber}}</td><td>{{classSession.className}}</td><td>{{classSession.numberOfRegisterStringFormat}}</td><td>{{classSession.classStart | date:\'MM/dd/yyyy\'}}</td><td>{{classSession.classStart | date:\'hh:mm a\'}}</td><td><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"wellness-class-list.view({classSessionId: classSession.id})\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.qhpWorkflow.wellnessClass.home.action.view\"></span></button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.checkDisabledLaunchClass(classSession)\" ng-click=\"vm.openControlsInterface(classSession.id)\"><span class=\"glyphicon glyphicon-share\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"ipmApp.qhpWorkflow.wellnessClass.home.action.launchClass\"></span></button></div></td></tr><tr ng-if=\"!vm.isLoading && vm.classSessions.length == 0\"><td colspan=\"7\"><p class=\"text-center text-danger mt-2\" translate=\"ipmApp.qhpWorkflow.wellnessClass.home.noClass\">There is no Classes\"</p></td></tr></tbody></table></div><!-- Paging --><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/shared/confirm-dialog/confirm-yes-no-dialog.controller.html","<form name=\"confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.no()\">&times;</button><h5 class=\"modal-title\" ng-if=\"vm.title\">{{vm.title | translate}}</h5><h5 class=\"modal-title\" ng-if=\"!vm.title\">Warning</h5></div><div class=\"modal-body text-center\"><jhi-alert-error></jhi-alert-error><span ng-if=\"!vm.isTranslate\">{{vm.message}}</span> <span ng-if=\"vm.isTranslate\">{{vm.message | translate}}</span></div><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"vm.yes()\" class=\"btn btn-primary\"><span translate=\"entity.action.yes\">Yes</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.no()\"><span translate=\"entity.action.no\">No</span></button></div></form>");
$templateCache.put("app/shared/confirm-download-dialog/confirm-download-dialog.controller.html","<form name=\"confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.no()\">&times;</button><h5 class=\"modal-title\">Requested Wellness Portal Report</h5></div><div class=\"modal-body text-center\"><span>You have asked for a significant amount of data. Would you like us to email you this report when it is ready?</span></div><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"vm.yes()\" class=\"btn btn-primary\"><span translate=\"entity.action.yes\">Yes</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.no()\"><span translate=\"entity.action.no\">No</span></button></div></form>");
$templateCache.put("app/shared/error-dialog/error-dialog.controller.html","<form name=\"confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.yes()\">&times;</button><h5 class=\"modal-title\">{{vm.title | translate}}</h5></div><div class=\"modal-body text-center text-danger\"><jhi-alert-error></jhi-alert-error><span ng-if=\"!vm.isTranslate\">{{vm.message}}</span> <span ng-if=\"vm.isTranslate\">{{vm.message | translate}}</span></div><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"vm.yes()\" class=\"btn btn-primary\"><span translate=\"entity.action.ok\">Ok</span></button></div></form>");
$templateCache.put("app/survey-workflow/partial/confirm-dialog.html","<form name=\"warningForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.close()\">&times;</button><h5 class=\"modal-title\">Warning message</h5></div><div class=\"modal-body\"><p>You have not completed the questionnaire yet, do you want to finish and come back later ?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.logout()\">OK</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.close()\">Cancel</button></div></form>");
$templateCache.put("app/survey-workflow/partial/skype-confirm-dialog.html","<form name=\"warningForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.close()\">&times;</button><h5 class=\"modal-title\" translate=\"surveyWorkflow.skype.information\">Information</h5></div><div class=\"modal-body\"><p translate=\"surveyWorkflow.skype.body\"></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.close()\">OK</button></div></form>");
$templateCache.put("app/survey-workflow/partial/thank-you.html","<div class=\"page page--thank-you\"><div class=\"container\"><div class=\"content text-center\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12\"><div class=\"voffset6 bold font-s15\" translate=\"surveyWorkflow.thankyou.title\">THANK YOU</div><div class=\"voffset3 font-s15\" translate=\"surveyWorkflow.thankyou.content\">Thank you for completing your questions! Your answers will be sent to your physician. Be sure to check back next month to complete your next set of questions.</div><div class=\"voffset3 font-s15\"><button type=\"button\" ng-disabled=\"vm.isSaving || !vm.currentSurveyResultId\" class=\"btn btn-primary\" ng-click=\"vm.goToLandingPage()\"><span ng-if=\"vm.surveyResultType === \'DEFAULT\'\" translate=\"surveyWorkflow.action.saveComment\">Submit</span> <span ng-if=\"vm.surveyResultType === \'ADHOC\' || vm.surveyResultType === \'BATTERY\'\" translate=\"surveyWorkflow.action.continue\">Continue</span></button> <button ng-if=\"vm.isAdHoc && vm.hasNextAdHoc\" type=\"button\" ng-disabled=\"vm.isSaving || !vm.currentSurveyResultId\" class=\"btn btn-primary\" ng-click=\"vm.nextAdHoc()\"><span translate=\"surveyWorkflow.action.nextAdHoc\">Next</span></button></div></div></div></div></div></div>");
$templateCache.put("app/survey-workflow/partial/unexpected-error-dialog.html","<form name=\"errorForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.close()\">&times;</button><h5 class=\"modal-title\" translate=\"surveyWorkflow.error.title\">Error message</h5></div><div class=\"modal-body\"><p class=\"alert alert-danger\" translate=\"surveyWorkflow.error.content\">We\'re sorry, there was an unexpected error. Please submit there response again.</p><span ng-if=\"vm.currentQuestionObj\"><p translate=\"surveyWorkflow.error.question\" translate-value-question-name=\"{{ vm.currentQuestionObj.name }}\">Question: ...</p><p translate=\"surveyWorkflow.error.response\" translate-value-response=\"{{ vm.getResponse() }}\">Response: ...</p></span><br><p translate=\"surveyWorkflow.error.details\" translate-value-function-name=\"{{ vm.functionName }}\" translate-value-status-code=\"{{ vm.statusCode }}\">Error Details: {{ methodName }} - {{ status }}.</p><p>{{vm.errorDetails}}</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.close()\">OK</button></div></form>");
$templateCache.put("app/survey-workflow/partial/validation-error-dialog.html","<form name=\"warningForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.close()\">&times;</button><h5 class=\"modal-title\" translate=\"surveyWorkflow.warning.title\">Warning message</h5></div><div class=\"modal-body\"><p translate=\"surveyWorkflow.warning.content\">Please respond to all questions in this test before proceeding.</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.close()\">OK</button></div></form>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1\"><div class=\"frm-login\"><div class=\"row\"><div class=\"col-md-12\"><div ng-hide=\"vm.keyMissing\"><div class=\"frm-login-top\"><div class=\"h4 text-center primary pb-0\">{{vm.invitation==\'true\' ? \'reset.finish.invitation.title\' : \'reset.finish.title\' | translate}}</div><div class=\"alert text-danger mb-0 text-center\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert text-warning mb-0 text-center\" ng-hide=\"vm.success || vm.keyMissing\"><p>{{vm.invitation==\'true\' ? \'reset.finish.messages.invitation.info\' : \'reset.finish.messages.info\' | translate}}</p></div><div class=\"alert text-danger mb-0 text-center\" ng-show=\"vm.error\"><p translate=\"{{vm.error}}\"></p></div><div class=\"alert text-success mb-0 text-center\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"login\">sign in</a>.</p></div><div class=\"alert text-danger mb-0 text-center\" ng-show=\"vm.doNotMatch && !vm.success\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label for=\"password\" translate=\"global.form.newpassword\">New password</label><div class=\"input-group\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-lock\"></span></div><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"5\" ng-maxlength=\"50\" required></div><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><div class=\"input-group\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-lock\"></span></div><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" required></div><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\">{{vm.invitation==\'true\' ? \'reset.finish.form.invitation.button\' : \'reset.finish.form.button\' | translate}}</button></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1\"><div class=\"frm-login\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"frm-login-top\"><div class=\"h4 text-center primary pb-0\" translate=\"reset.request.title\">Reset your password</div><div class=\"alert text-danger mb-0 text-center\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert text-warning mb-0 text-center\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert text-success mb-0 text-center\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-pattern=\"constants.EMAIL_PATTERN\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"text-center\"><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/coc-agreement/notify-component/notify.component.html","<div class=\"mb-3\"><div ng-include=\"\'success\'\" ng-if=\"vm.type === \'success\'\"></div><div ng-include=\"\'error\'\" ng-if=\"vm.type === \'error\'\"></div><div ng-include=\"\'detail\'\"></div></div><script type=\"text/ng-template\" id=\"success\"><div class=\"mb-2 text-success\">\n        <span translate=\"{{vm.textNotify}}\" translate-values=\"{number: \'{{vm.values}}\'}\"></span>\n        <span class=\"border-success\" ng-click=\"vm.changeCollapse()\" ng-if=\"!vm.collapse\">&minus;</span>\n        <span class=\"border-success\" ng-click=\"vm.changeCollapse()\" ng-if=\"vm.collapse\">&plus;</span>\n    </div></script><script type=\"text/ng-template\" id=\"error\"><div class=\"mb-2 text-danger\">\n        <span translate=\"{{vm.textNotify}}\" translate-values=\"{number: \'{{vm.values}}\'}\"></span>\n        <span class=\"border-danger\" ng-click=\"vm.changeCollapse()\" ng-if=\"!vm.collapse\">&minus;</span>\n        <span class=\"border-danger\" ng-click=\"vm.changeCollapse()\" ng-if=\"vm.collapse\">&plus;</span>\n    </div></script><script type=\"text/ng-template\" id=\"detail\"><div class=\"pl-3\" uib-dropdown-menu ng-if=\"!vm.collapse\">\n        <div ng-repeat=\"patientId in vm.patientIds\">\n            - {{patientId}}\n        </div>\n    </div></script>");
$templateCache.put("app/admin/user-management/multi-frp-programs/multi-frp-programs.html","<div><label ng-if=\"vm.translateKey\">{{vm.translateKey | translate}}</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div ng-repeat=\"selectedFrpProgram in vm.selectedFrpPrograms track by $index\"><div class=\"row-v4 pb-2\"><div class=\"col-v4\"><select class=\"form-control\" name=\"selectedFrpProgram_{{$index}}\" id=\"selectedFrpProgram.{{ $index}}\" ng-model=\"selectedFrpProgram\" ng-change=\"vm.changeSelectedFrpProgram($index, selectedFrpProgram)\" ng-options=\"frpProgram as frpProgram.name for frpProgram in vm.filteredFrpPrograms(selectedFrpProgram) track by frpProgram.id\" required></select></div><div class=\"col-v4-auto\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.selectedFrpPrograms.length === 1\" ng-click=\"vm.removeSelectedFrpProgram($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div><div ng-show=\"vm.formReference.selectedFrpPrograms_{{$index}}.$dirty && vm.formReference.selectedFrpPrograms_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.formReference.selectedFrpPrograms_{{$index}}.$error.required\" translate=\"userManagement.office.required\">This field is required.</p></div></div><div class=\"pt-2 text-right\"><a class=\"btn-link primary\" href=\"\" ng-show=\"vm.isShowAddAnotherFrpProgramLink()\" ng-click=\"vm.addAnotherFrpProgram()\"><b translate=\"userManagement.addAnotherFRPProgram\">Add another FRP Program</b></a></div></div>");
$templateCache.put("app/admin/user-management/multi-offices/multi-offices.html","<div><label ng-if=\"!vm.translateKey\" translate=\"userManagement.offices\">Offices</label><label ng-if=\"vm.translateKey\">{{vm.translateKey | translate}}</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div ng-repeat=\"selectedOffice in vm.selectedOffices track by $index\"><div class=\"row-v4 pb-2\"><div class=\"col-v4\"><select class=\"form-control\" name=\"selectOffice_{{$index}}\" id=\"selectOffice.{{ $index}}\" ng-model=\"selectedOffice\" ng-change=\"vm.changeSelectedOffice($index, selectedOffice)\" ng-options=\"office as office.name for office in vm.filteredOffices(selectedOffice) track by office.id\" required></select></div><div class=\"col-v4-auto\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.selectedOffices.length === 1\" ng-click=\"vm.removeSelectedOffice($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div><div ng-show=\"vm.formReference.selectedOffices_{{$index}}.$dirty && vm.formReference.selectedOffices_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.formReference.selectedOffices_{{$index}}.$error.required\" translate=\"userManagement.office.required\">This field is required.</p></div></div><div class=\"pt-2 text-right\"><a class=\"btn-link primary\" href=\"\" ng-show=\"vm.isShowAddAnotherOfficeLink()\" ng-click=\"vm.addAnotherOFfice()\"><b translate=\"userManagement.addAnotherOffice\">Add another</b></a></div></div>");
$templateCache.put("app/admin/user-management/patient-case-table/patient-billable-config.html","<div><!-- haqTestServiceExclusion --><div class=\"form-group\"><div class=\"form-row-v4 align-items-center text-center\"><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2 col-form-label-v4\"><label class=\"control-label\" translate=\"ipmApp.patient.haqTestServiceExclusion\">HAQ Test Service Exclusion</label></div><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patientBillableConfig.haqTestServiceExclusion}\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.changeHaqTestServiceExclusion()\"></button></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-3\"><label translate=\"ipmApp.patient.exclusionReason\" class=\"control-label\">Exclusion Reason</label><span ng-if=\"vm.patientBillableConfig.haqTestServiceExclusion\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4 col-v4-xl-5 col-v4-lg-5\"><input type=\"text\" class=\"form-control\" name=\"haqTestServiceExclusionReason\" required ng-model=\"vm.patientBillableConfig.haqTestServiceExclusionReason\" ng-required=\"vm.patientBillableConfig.haqTestServiceExclusion\" ng-show=\"vm.patientBillableConfig.haqTestServiceExclusion\" ng-disabled=\"vm.checkDisabledReason(\'haqTestServiceExclusionReason\')\" ng-maxlength=\"255\"></div></div></div><!-- haqTestBillingExclusion --><div class=\"form-group\"><div class=\"form-row-v4 align-items-center text-center\"><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2 col-form-label-v4\"><label translate=\"ipmApp.patient.haqTestBillingExclusion\" class=\"control-label\">HAQ Test Billing Exclusion</label></div><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patientBillableConfig.haqTestBillingExclusion}\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.changeHaqTestBillingExclusion()\"></button></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-3\"><label translate=\"ipmApp.patient.exclusionReason\" class=\"control-label\">Exclusion Reason</label><span ng-if=\"vm.patientBillableConfig.haqTestBillingExclusion\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4 col-v4-xl-5 col-v4-lg-5\"><input type=\"text\" class=\"form-control\" name=\"haqTestBillingExclusionReason\" ng-model=\"vm.patientBillableConfig.haqTestBillingExclusionReason\" ng-required=\"vm.patientBillableConfig.haqTestBillingExclusion\" ng-show=\"vm.patientBillableConfig.haqTestBillingExclusion\" ng-disabled=\"vm.checkDisabledReason(\'haqTestBillingExclusionReason\')\" ng-maxlength=\"255\"></div></div></div><!-- haqEvalServiceExclusion --><div class=\"form-group\"><div class=\"form-row-v4 align-items-center text-center\"><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2 col-form-label-v4\"><label translate=\"ipmApp.patient.haqEvalServiceExclusion\" class=\"control-label\">HAQ Eval Service Exclusion</label></div><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patientBillableConfig.haqEvalServiceExclusion}\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.changeHaqEvalServiceExclusion()\"></button></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-3\"><label translate=\"ipmApp.patient.exclusionReason\" class=\"control-label\">Exclusion Reason</label><span ng-if=\"vm.patientBillableConfig.haqEvalServiceExclusion\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4 col-v4-xl-5 col-v4-lg-5\"><input type=\"text\" class=\"form-control\" name=\"haqEvalServiceExclusionReason\" ng-model=\"vm.patientBillableConfig.haqEvalServiceExclusionReason\" ng-required=\"vm.patientBillableConfig.haqEvalServiceExclusion\" ng-show=\"vm.patientBillableConfig.haqEvalServiceExclusion\" ng-disabled=\"vm.checkDisabledReason(\'haqEvalServiceExclusionReason\')\" ng-maxlength=\"255\"></div></div></div><!-- haqEvalBillingExclusion --><div class=\"form-group\"><div class=\"form-row-v4 align-items-center text-center\"><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2 col-form-label-v4\"><label translate=\"ipmApp.patient.haqEvalBillingExclusion\" class=\"control-label\">HAQ Eval Billing Exclusion</label></div><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patientBillableConfig.haqEvalBillingExclusion}\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.changeHaqEvalBillingExclusion()\"></button></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-3\"><label translate=\"ipmApp.patient.exclusionReason\" class=\"control-label\">Exclusion Reason</label><span ng-if=\"vm.patientBillableConfig.haqEvalBillingExclusion\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4 col-v4-xl-5 col-v4-lg-5\"><input type=\"text\" class=\"form-control\" name=\"haqEvalBillingExclusionReason\" ng-model=\"vm.patientBillableConfig.haqEvalBillingExclusionReason\" ng-required=\"vm.patientBillableConfig.haqEvalBillingExclusion\" ng-show=\"vm.patientBillableConfig.haqEvalBillingExclusion\" ng-disabled=\"vm.checkDisabledReason(\'haqEvalBillingExclusionReason\')\" ng-maxlength=\"255\"></div></div></div><!-- CPR Service Exclusion --><div class=\"form-group\"><div class=\"form-row-v4 align-items-center text-center\"><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2 col-form-label-v4\"><label translate=\"ipmApp.patient.cprServiceExclusion\" class=\"control-label\">CPR Service Exclusion</label></div><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patientBillableConfig.cprServiceExclusion}\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.changeCprServiceExclusion()\"></button></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-3\"><label translate=\"ipmApp.patient.exclusionReason\" class=\"control-label\">Exclusion Reason</label><span ng-if=\"vm.patientBillableConfig.cprServiceExclusion\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4 col-v4-xl-5 col-v4-lg-5\"><input type=\"text\" class=\"form-control\" name=\"cprServiceExclusionReason\" ng-model=\"vm.patientBillableConfig.cprServiceExclusionReason\" ng-required=\"vm.patientBillableConfig.cprServiceExclusion\" ng-show=\"vm.patientBillableConfig.cprServiceExclusion\" ng-disabled=\"vm.checkDisabledReason(\'cprServiceExclusionReason\')\" ng-maxlength=\"255\"></div></div></div><!-- CPR Billing Exclusion --><div class=\"form-group\"><div class=\"form-row-v4 align-items-center text-center\"><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2 col-form-label-v4\"><label translate=\"ipmApp.patient.cprBillingExclusion\" class=\"control-label\">CPR Billing Exclusion</label></div><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patientBillableConfig.cprBillingExclusion}\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.changeCprBillingExclusion()\"></button></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-3\"><label translate=\"ipmApp.patient.exclusionReason\" class=\"control-label\">Exclusion Reason</label><span ng-if=\"vm.patientBillableConfig.cprBillingExclusion\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4 col-v4-xl-5 col-v4-lg-5\"><input type=\"text\" name=\"cprBillingExclusionReason\" class=\"form-control\" ng-model=\"vm.patientBillableConfig.cprBillingExclusionReason\" ng-required=\"vm.patientBillableConfig.cprBillingExclusion\" ng-show=\"vm.patientBillableConfig.cprBillingExclusion\" ng-disabled=\"vm.checkDisabledReason(\'cprBillingExclusionReason\')\" ng-maxlength=\"255\"></div></div></div><!-- PNE Service Exclusion --><div class=\"form-group\"><div class=\"form-row-v4 align-items-center text-center\"><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2 col-form-label-v4\"><label translate=\"ipmApp.patient.pneServiceExclusion\" class=\"control-label\">PNE Service Exclusion</label></div><div class=\"col-v4 col-v4-xl-2 col-v4-lg-2\"><button type=\"button\" class=\"btn btn-default btn-toggle\" ng-class=\"{\'active\': vm.patientBillableConfig.pneServiceExclusion}\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.changePneServiceExclusion()\"></button></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-3\"><label translate=\"ipmApp.patient.exclusionReason\" class=\"control-label\">Exclusion Reason</label><span ng-if=\"vm.patientBillableConfig.pneServiceExclusion\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4 col-v4-xl-5 col-v4-lg-5\"><input type=\"text\" class=\"form-control\" name=\"pneServiceExclusionReason\" ng-model=\"vm.patientBillableConfig.pneServiceExclusionReason\" ng-required=\"vm.patientBillableConfig.pneServiceExclusion\" ng-show=\"vm.patientBillableConfig.pneServiceExclusion\" ng-disabled=\"vm.checkDisabledReason(\'pneServiceExclusionReason\')\" ng-maxlength=\"255\"></div></div></div></div>");
$templateCache.put("app/admin/user-management/patient-case-table/patient-case-edit.html","<form name=\"vm.confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" ng-if=\"!vm.isEdit\" translate=\"userManagement.patientCase.addPatientCase\"></h5><h5 class=\"modal-title\" ng-if=\"vm.isEdit\" translate=\"userManagement.patientCase.editPatientCase\"></h5></div><div class=\"modal-body text-center\"><div class=\"form-group text-left\"><label translate=\"userManagement.patientCase.caseNumber\">Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input class=\"form-control\" name=\"caseNumber\" id=\"caseNumber\" ng-change=\"vm.namePatientCaseOnChange()\" ng-model=\"vm.caseNumber\" required></div><div ng-show=\"!vm.confirmForm.$invalid && vm.error\"><p class=\"help-block\" translate=\"userManagement.patientCase.caseNameExists\">Case name is already in use!</p></div></div><div class=\"modal-footer\"><button type=\"button\" ng-disabled=\"vm.confirmForm.$invalid\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/admin/user-management/patient-case-table/patient-case-table.html","<div class=\"patient-case\"><div class=\"form-group\"><label translate=\"userManagement.patientCase.case\">Case</label><button type=\"button\" class=\"btn btn-primary btn-sm mx-2\" ng-if=\"vm.isAllowAction\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.openPatientCaseEdit();\"><span translate=\"userManagement.patientCase.addPatientCase\">Add Patient Case</span></button></div><div class=\"form-group\" ng-if=\"vm.patientCases\"><uib-accordion close-others=\"true\"><uib-accordion-group ng-repeat=\"patientCase in vm.patientCases track by $index\" is-open=\"patientCase.isOpen\" is-disabled=\"true\"><uib-accordion-heading><div class=\"panel-default\"><div class=\"row\"><div class=\"col-md-8 col-title-case\"><button type=\"button\" ng-click=\"vm.editCaseNumber($index)\" ng-if=\"vm.isAllowAction\" class=\"btn btn-primary btn-case\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button type=\"button\" ng-click=\"vm.removeCaseNumber($index, $event)\" class=\"btn btn-danger btn-case\" ng-if=\"vm.isAllowAction\"><span class=\"glyphicon glyphicon-trash\"></span></button> <span class=\"titleCaseNumber\" title=\"{{patientCase.caseNumber}}\">{{patientCase.caseNumber}}</span></div><div class=\"col-md-4 text-right\" ng-click=\"patientCase.isOpen = !patientCase.isOpen\"><span ng-if=\"patientCase.isOpen\">Hide Exclusions</span> <span ng-if=\"!patientCase.isOpen\">Show Exclusions</span> <i class=\"glyphicon\" ng-class=\"!patientCase.isOpen ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-up\'\"></i></div></div></div></uib-accordion-heading><div><patient-billable-config is-disabled=\"vm.isUpdateBillable\" patient-billable-config=\"patientCase.billableConfig\"></patient-billable-config></div></uib-accordion-group></uib-accordion></div></div>");
$templateCache.put("app/admin/user-management/qhp-tasks/qhp-tasks.html","<div class=\"row\"><div class=\"col-md-12\"><label translate=\"userManagement.tasks.title\">Tasks</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-md-12\" ng-if=\"vm.tasksInit\"><div ng-repeat=\"task in vm.tasksInit track by $index\" class=\"form-check\"><input class=\"form-check-input\" id=\"task_{{$index}}\" type=\"checkbox\" ng-model=\"task.active\" ng-change=\"vm.checkboxChange()\"><label class=\"form-check-label\" for=\"task_{{$index}}\">{{\'ipmApp.qhpTaskType.\' + task.type | translate}}</label></div><div ng-show=\"vm.isTaskCheckBoxDirty && !vm.checkRequired()\"><p class=\"help-block\" translate=\"userManagement.tasks.required\">This field is required.</p></div></div></div>");
$templateCache.put("app/components/dialog/common-question/common-question.modal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\">{{vm.tests.title | translate}}</h5></div><div class=\"modal-body\"><p>{{vm.tests.question | translate}}</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.confirm()\"><span>{{vm.tests.actionConfirm | translate}}</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span>{{vm.tests.actionCancel | translate}}</span></button></div>");
$templateCache.put("app/entities/care-plan-review/partial/confirm-dialog.html","<form name=\"warningForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.close()\">&times;</button><h5 class=\"modal-title\">Warning message</h5></div><div class=\"modal-body\"><p>{{ \'ipmApp.carePlanReview.\' + vm.message | translate}}</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.okClick()\">Yes</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.close()\">No</button></div></form>");
$templateCache.put("app/entities/care-plan-review/partial/notes-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h5 class=\"modal-title\">{{\'ipmApp.carePlanReview.notes\' | translate}}</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><textarea ng-model=\"vm.cpr.notes\" class=\"form-control none-resize\" rows=\"6\"> </textarea></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || !editForm.$dirty\" class=\"btn btn-primary\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/haq-tracks/tracks-assigneds/tracks-assigneds-list.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive table-scroll-h\"><table class=\"jh-table table table-striped\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.tracksAssigneds\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span translate=\"ipmApp.haqTracks.detail.order\"></span></th><th><span translate=\"ipmApp.haqTracks.detail.batteryName\"></span></th><th></th></tr></thead><tbody ng-repeat=\"tra in vm.tracksAssigneds\"><tr><td>{{tra.orderNumber}}</td><td>{{tra.batteryName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.unassignBatteryClick(tra)\" ng-disabled=\"vm.isAdHoc\" type=\"button\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\">{{\'ipmApp.haqTracks.action.unassign\' | translate}}</span></button></div></td></tr></tbody><tbody ng-if=\"!vm.tracksAssigneds || vm.tracksAssigneds.length === 0\"><tr><td colspan=\"3\"><p class=\"help-block text-center\" translate=\"ipmApp.haqTracks.dialog.notExistsTracksAssigneds\">There is no Assigned battery</p></td></tr></tbody></table></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.haqTracks.detail.unassignedBatteries\"></span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive table-scroll-h\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span translate=\"ipmApp.haqTracks.detail.batteryName\"></span></th><th></th></tr></thead><tbody ng-if=\"vm.unassignedBatteries && vm.unassignedBatteries.length > 0\"><tr ng-repeat=\"ba in vm.unassignedBatteries | orderBy:\'-id\'\"><td><span ng-if=\"ba\">{{ba.nameEn}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.assignBatteryClick(ba)\" ng-disabled=\"vm.isAdHoc\" type=\"button\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs hidden-sm\">{{\'ipmApp.haqTracks.action.assign\' | translate}}</span></button></div></td></tr></tbody><tbody ng-if=\"!vm.unassignedBatteries || vm.unassignedBatteries.length === 0\"><tr><td colspan=\"2\"><p class=\"help-block text-center\" translate=\"ipmApp.haqTracks.dialog.notExistsTracksUnassigned\">There is no Unassigned battery</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/entities/haqs-battery/battery-tests-list/battery-tests-list.html","<div class=\"table-responsive\"><table class=\"jh-table table\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th class=\"w-107\"><span translate=\"ipmApp.haqsBattery.detail.orderNumber\"></span></th><th><span translate=\"ipmApp.haqsBattery.detail.batteryTestName\"></span></th><th class=\"w-101\"><span translate=\"ipmApp.haqsBattery.detail.countOfBatteries\"></span></th><th class=\"w-121\"></th></tr></thead><tbody><tr ng-repeat=\"bt in vm.batteryTestsView\"><td>{{bt.orderNumber ? bt.orderNumber : ($index + 1)}}</td><td><span ng-if=\"bt.test\">{{bt.test.nameEn}}</span></td><td><span ng-if=\"bt.test\">{{bt.test.numberOfBatteries}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.batteryTestsClick(bt)\" type=\"button\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\">{{\'entity.action.edit\' | translate}}</span></button></div></td></tr><tr ng-if=\"!vm.batteryTestsView || vm.batteryTestsView.length === 0\"><td colspan=\"4\"><p class=\"help-block text-center\" translate=\"ipmApp.haqsBattery.dialog.notExistsAssignBatteryTests\">There is no Assigned test</p></td></tr></tbody></table></div>");
$templateCache.put("app/entities/haqs-battery/tests-assigned/tests-assigned-list.html","<div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.haqsBattery.detail.assignedBatteryTests\"></span><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive table-scroll-h\"><table class=\"jh-table table table-striped\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.batteryTests\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span translate=\"ipmApp.haqsBattery.detail.orderNumber\"></span></th><th><span translate=\"ipmApp.haqsBattery.detail.batteryTestName\"></span></th><th><span translate=\"ipmApp.haqsBattery.detail.countOfQuestion\"></span></th><th></th></tr></thead><tbody ng-repeat=\"bt in vm.batteryTests\"><tr><td>{{bt.orderNumber ? bt.orderNumber : ($index + 1)}}</td><td><span ng-if=\"bt.test\">{{bt.test.nameEn}}</span></td><td><span ng-if=\"bt.test\">{{bt.test.countSections}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.batteryTestsClick(bt)\" type=\"button\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\">{{\'entity.action.edit\' | translate}}</span></button> <button ng-click=\"vm.unassignBatteryTestsClick(bt)\" type=\"button\" ng-disabled=\"!!vm.isAdHoc\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\">{{\'ipmApp.haqsBattery.action.unassign\' | translate}}</span></button></div></td></tr></tbody><tbody ng-if=\"!vm.batteryTests || vm.batteryTests.length === 0\"><tr><td colspan=\"3\"><p class=\"help-block text-center\" translate=\"ipmApp.haqsBattery.dialog.notExistsAssignBatteryTests\">There is no Assigned test</p></td></tr></tbody></table></div></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 h5 primary\"><span translate=\"ipmApp.haqsBattery.detail.unassignedBatteryTests\"></span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive table-scroll-h\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span translate=\"ipmApp.haqsBattery.detail.batteryTestName\"></span></th><th><span translate=\"ipmApp.haqsBattery.detail.countOfQuestion\"></span></th><th></th></tr></thead><tbody ng-if=\"vm.unassignedBatteryTests && vm.unassignedBatteryTests.length > 0\"><tr ng-repeat=\"test in vm.unassignedBatteryTests | orderBy:\'nameEn\'\"><td><span ng-if=\"test\">{{test.nameEn}}</span></td><td><span ng-if=\"test\">{{test.countSections}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.testClick(test)\" type=\"button\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\">{{\'entity.action.edit\' | translate}}</span></button> <button ng-click=\"vm.assignedBatteryTestsClick(test)\" type=\"button\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs hidden-sm\">{{\'ipmApp.haqsBattery.action.assign\' | translate}}</span></button></div></td></tr></tbody><tbody ng-if=\"!vm.unassignedBatteryTests || vm.unassignedBatteryTests.length === 0\"><tr><td colspan=\"2\"><p class=\"help-block text-center\" translate=\"ipmApp.haqsBattery.dialog.notExistsUnassignBatteryTests\">There is no Unassigned test</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/frp-mde/frp-report/addendum/frp-report-addendum.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><div class=\"row-v4\"><div class=\"col-v4-md-6\"><h3 class=\"primary title my-3 text-left\"><span translate=\"ipmApp.frpReport.addendum.title\">FRP - Report Builder - Addendum</span></h3></div></div><form name=\"vm.editForm\" role=\"form\" novalidate><div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"form-group\"><div><h4 class=\"primary title\"><span>{{\'ipmApp.frpReport.addendum.addendum\' | translate}}</span></h4></div><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"addendum\" id=\"addendum\" ng-model=\"vm.frpReport.frpReportAddendum.addendum\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.isRequired\">\n                        </textarea><div ng-show=\"vm.editForm.addendum.$dirty && vm.editForm.addendum.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.addendum.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"mt-4\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || !vm.isChanged() || vm.isView\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></div></div></form></div></div></div>");
$templateCache.put("app/frp-mde/frp-report/admin/frp-report-admin.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><form name=\"vm.editForm\" role=\"form\" novalidate><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.frpReport.admin.title\'\" report=\"vm.dataHeaderReport\"></header-report><div><div class=\"mt-4 h4 title\">{{\'ipmApp.frpReport.admin.assignedTeam\' | translate}}</div><div class=\"row mt-4\"><div class=\"col-md-2\"><label class=\"control-label\" translate=\"ipmApp.frpReport.admin.table.admin\">admin</label><select class=\"form-control\" name=\"admin\" id=\"admin\" ng-model=\"vm.admin.frpReportAdminUserId\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.adminUsers | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select></div><div class=\"form-group col-md-2\"><label class=\"control-label\"><span>{{\'ipmApp.frpReport.admin.table.medical\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><select class=\"form-control\" name=\"medical\" id=\"medical\" ng-model=\"vm.admin.frpReportMedicalUserId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.editForm.medical.$dirty && vm.editForm.medical.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.medical.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-2\"><label class=\"control-label\"><span>{{\'ipmApp.frpReport.admin.table.pt\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><select class=\"form-control\" name=\"pt\" id=\"pt\" ng-model=\"vm.admin.frpReportPTUserId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.editForm.pt.$dirty && vm.editForm.pt.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.pt.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-2\"><label class=\"control-label\"><span>{{\'ipmApp.frpReport.admin.table.psych\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><select class=\"form-control\" name=\"psych\" id=\"psych\" ng-model=\"vm.admin.frpReportPsychUserId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.editForm.psych.$dirty && vm.editForm.psych.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.psych.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-md-2\"><label class=\"control-label\" translate=\"ipmApp.frpReport.admin.table.conclusion\">conclusion</label><select class=\"form-control\" name=\"conclusion\" id=\"conclusion\" ng-model=\"vm.admin.frpReportConclusionUserId\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select></div></div><div class=\"row mt-4\"><div class=\"col-md-2\"><span class=\"h4 title\">{{\'ipmApp.frpReport.admin.patientDetail\' | translate}}</span></div><div class=\"col-md-4\" ng-if=\"!vm.submitted\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.submitButton()\" disabled=\"disabled\"><span>{{\'ipmApp.frpReport.admin.requestUpdateFromIMS\' | translate}}</span></button></div><div class=\"col-md-4\" ng-if=\"vm.submitted\"><span>Update pending at 3:45PM on 2/26/2022</span></div><div class=\"col-md-4\" ng-if=\"vm.submitted\"><button type=\"button\" class=\"btn btn-link primary\" ng-click=\"vm.submitButton()\"><span>{{\'ipmApp.frpReport.admin.cancelRequest\' | translate}}</span></button></div></div><div class=\"mt-4\"><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.address\' | translate}}</span><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" name=\"street\" placeholder=\"Street\" ng-model=\"vm.admin.streetAddress\" ng-disabled=\"vm.isDisabled\"></div><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"city\" placeholder=\"City\" ng-model=\"vm.admin.city\" ng-disabled=\"vm.isDisabled\"></div><div class=\"col-sm-1\"><select class=\"form-control\" name=\"state_field\" id=\"state\" ng-model=\"vm.admin.state\" ng-disabled=\"vm.isDisabled\" ng-options=\"state for state in vm.states\"><option value=\"\" selected=\"selected\"></option></select></div><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"zipCode\" placeholder=\"Zip Code\" ng-model=\"vm.admin.zipCode\" ng-disabled=\"vm.isDisabled\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.race\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"race\" ng-model=\"vm.admin.race\" ng-disabled=\"vm.isDisabled\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.gender\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"gender\" ng-model=\"vm.admin.gender\" ng-disabled=\"vm.isDisabled\"></div></div></div><div class=\"row mt-4\"><div class=\"col-md-2\"><span class=\"h4 title\">{{\'ipmApp.frpReport.admin.caseDetail\' | translate}}</span></div></div><div><div class=\"form-group row mt-4\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.injuryDate\' | translate}}</span><div class=\"col-sm-2\"><div class=\"input-group\"><input name=\"daterequested\" id=\"field_dateRequested\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"dateRequestOptions\" ng-model=\"vm.admin.injuryDate\" is-open=\"vm.datePickerOpenStatus.dateRequested\" ng-disabled=\"vm.isDisabled\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateRequested\')\" ng-disabled=\"vm.isDisabled\"></span></div></div></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.caseInsurance\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"caseInsurance\" ng-model=\"vm.admin.caseInsurance\" ng-disabled=\"vm.isDisabled\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.authorizedBodyPart\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"employer\" ng-model=\"vm.admin.authorizedBodyPart\" ng-disabled=\"vm.isDisabled\"></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.claimNumber\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"claimNumber\" ng-model=\"vm.admin.claimNumber\" ng-disabled=\"vm.isDisabled\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.employer\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"employer\" ng-model=\"vm.admin.employer\" ng-disabled=\"vm.isDisabled\"></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.nurseCaseManager\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"nurseCaseManager\" ng-model=\"vm.admin.nurseCaseManager\" ng-disabled=\"vm.isDisabled\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.jobTitle\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"jobTitle\" ng-model=\"vm.admin.jobTitle\" ng-disabled=\"vm.isDisabled\"></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.applicantAttorney\' | translate}}</span><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" name=\"applicantAttorney\" ng-model=\"vm.admin.applicantAttorney\" ng-disabled=\"vm.isDisabled\"></div></div><div class=\"form-group row mt-4\"><span class=\"col-sm-2\">{{\'ipmApp.frpReport.admin.clinicalTeam\' | translate}}</span><div class=\"col-sm-2\"><input name=\"clinicalTeam\" id=\"field_clinicalTeam\" type=\"text\" class=\"form-control\" ng-model=\"vm.admin.clinicalTeam\" ng-disabled=\"vm.isDisabled\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><span>{{\'ipmApp.frpReport.admin.attendanceTracker\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-md-12\"><attendance-tracker attendance-tracker=\"vm.admin.attendanceTracker\" is-view=\"vm.checkDisableAttendanceTracker()\" start-date=\"vm.trackerStartDate\" end-date=\"vm.trackerEndDate\" on-change=\"vm.attendanceTrackersChange(attendanceTracker)\"></attendance-tracker></div><div class=\"col-md-12\" ng-show=\"vm.attendanceTrackerInvalid\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"col-md-12\" ng-if=\"vm.checkInValidHoursAttendedExceed()\"><div class=\"help-block\" translate=\"ipmApp.frpReport.admin.hoursAttendedCanNotExceed\">Hours Attended Can Not Exceed 160.</div></div></div><div class=\"row\"><label class=\"col-sm-12\"><span>{{\'ipmApp.frpReport.admin.lectures\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"col-md-6 form-group\"><ui-select style=\"max-width: none\" multiple=\"multiple\" ng-model=\"vm.admin.lectures\" name=\"lectures\" ng-required=\"true\" theme=\"bootstrap\" ng-disabled=\"vm.isDisabled\" close-on-select=\"false\" style=\"width: 100%\"><ui-select-match placeholder=\"Choose...\"><span class=\"select-mde\" title=\"{{$item.title}}\">{{$item.title}}</span></ui-select-match><ui-select-choices repeat=\"lecture in vm.lectures | filter: {title: $select.search}\"><div ng-bind-html=\"lecture.title | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-md-12\" ng-show=\"vm.editForm.lectures.$dirty && vm.editForm.lectures.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"row-v4 justify-content-between align-items-center pb-1\"><label class=\"col-v4-md-auto\"><span>{{\'ipmApp.frpReport.admin.introduction\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"col-v4-md-auto\"><!-- <select class=\"form-control\" name=\"reportType\" id=\"reportType\" ng-model=\"vm.admin.reportType\"\n                                    ng-required=\"true\"\n                                    ng-disabled=\"vm.isDisabled\"\n                                    ng-options=\"type as \'ipmApp.frpReport.admin.reportTypeList.\' + type | translate for type in vm.reportType track by type\">\n                                    <option hidden  value=\"\">Select GLOBAL Template</option>\n                                </select> --><template-select is-disabled=\"vm.isDisabled\" templates=\"vm.templates\" report=\"vm.admin.introduction\" option=\"vm.admin.introductionTemplate\" input-type=\"vm.templateInputType.REPORT_TYPE\" is-global-template=\"true\" gender=\"vm.frpReport.gender\" lastname=\"vm.frpReport.patientFRPMDE.patient.lastName\" is-report-type=\"true\" report-type=\"vm.admin.reportType\"></template-select><div ng-show=\"vm.editForm.templateSelect_REPORT_TYPE.$dirty && vm.editForm.templateSelect_REPORT_TYPE.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group\"><textarea type=\"text\" class=\"form-control auto-height text-summary\" id=\"introduction\" name=\"introduction\" rows=\"5\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.admin.introduction\">\n                        </textarea></div></div><div class=\"mt-4\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"vm.isDisabled || vm.isSaving || !vm.isChanged() || vm.checkInValidHoursAttendedExceed()\" ng-click=\"vm.save()\"><span>{{\'entity.action.save\' | translate}}</span></button> <button type=\"button\" class=\"btn btn-info\" ng-disabled=\"vm.isDisabled || vm.isSaving || (vm.isFinalize && !vm.isChanged()) || vm.checkInValidHoursAttendedExceed()\" ng-click=\"vm.finalize()\"><span>{{\'entity.action.finalize\' | translate}}</span></button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.cancel()\"><span>{{\'entity.action.cancel\' | translate}}</span></button></div></div></form></div></div></div>");
$templateCache.put("app/frp-mde/frp-report/conclusion/frp-report-conclusion.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.report\"><jhi-alert></jhi-alert><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.frpReport.conclusion.title\'\" report=\"vm.dataHeaderReport\"></header-report><form name=\"vm.conclusionReportForm\" role=\"form\" novalidate><!-- treatment-team-observations --><div ng-include=\"\'treatment-team-observations-template\'\"></div><!-- treatment-goals --><div ng-include=\"\'treatment-goals-template\'\"></div><!-- request-for-treatment --><div ng-include=\"\'request-for-treatment-template\'\" ng-if=\"vm.isMidsessionReport\"></div><!-- Buttons --><div class=\"mt-4\"><button type=\"submit\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || !vm.isChanged() || vm.isDisabled\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving || (vm.isFinalize && !vm.isChanged()) || vm.isDisabled\" class=\"btn btn-primary\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">Save For Later</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Submit</span></button></div></form></div></div></div><!-- treatment-team-observations-template --><script type=\"text/ng-template\" id=\"treatment-team-observations-template\"><h4 class=\"primary title mt-4 mb-4\" translate=\"ipmApp.frpReport.conclusion.header\">Conclusion</h4>\n\n    <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n        <div class=\"col-v4-md-auto\">\n            <h4 class=\"primary title ml-1\">\n                <span>{{\'ipmApp.frpReport.conclusion.treatmentTeamObservations\' | translate}}</span>\n                <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n            </h4>\n        </div>\n        <div class=\"col-v4-md-auto\">\n            <template-select\n                is-disabled=\"vm.isDisabled\"\n                templates=\"vm.templates\"\n                report=\"vm.report.treatmentTeamObservations\"\n                option=\"vm.report.treatmentTeamObservationsTemplate\"\n                input-type=\"vm.templateInputType.TREATMENT_TEAM_OBSERVATION\">\n            </template-select>\n        </div>\n    </div>\n    <!--<form name=\"conclusionReportForm\" role=\"form\" novalidate>-->\n        <div class=\"form-group\">\n            <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"treatment_team_observations\" id=\"treatment_team_observations\"\n                ng-model=\"vm.report.treatmentTeamObservations\"\n                      ng-required=\"true\"\n                      ng-disabled=\"vm.isDisabled\">\n            </textarea>\n            <div ng-show=\"vm.conclusionReportForm.treatment_team_observations.$dirty && vm.conclusionReportForm.treatment_team_observations.$invalid\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.conclusionReportForm.treatment_team_observations.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n    <!--</form>--></script><!-- treatment-goals-template --><script type=\"text/ng-template\" id=\"treatment-goals-template\"><h4 class=\"primary title mt-5 mb-4\" translate=\"ipmApp.frpReport.conclusion.treatmentGoals\">Treatment Goals</h4>\n\n    <div class=\"row-v4 mb-3 mb-md-0\">\n        <div class=\"col-v4-xl-9 col-v4-md-9\">\n            <h4 class=\"primary title\">\n                <span ng-class=\"{\'text-danger\':vm.conclusionReportForm.$submitted && (!vm.checkValidationShortTermGoals() || !vm.hasTermGoalChecked(true))}\">{{\'ipmApp.frpReport.conclusion.shortTermGoals\' | translate}}</span>\n                <span ng-if=\"vm.isMidsessionReport\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n            </h4>\n        </div>\n        <div class=\"col-v4-xl-2 col-v4-md-2\">\n            <h4 class=\"primary title text-left\" translate=\"ipmApp.frpReport.conclusion.goalStatus\">Goal Status</h4>\n        </div>\n    </div>\n\n    <h4 class=\"primary title mt-4\" translate=\"ipmApp.frpReport.conclusion.physicalFunctionalGoals\">Physical/Functional Goals</h4>\n    <div ng-repeat=\"goal in vm.report.ptSortTermGoalResponses track by $index\">\n        <frp-goal-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" show-add-goal=\"vm.showAddGoal($last, false, \'PT\')\" on-click-add-new-goal=\"vm.addNewSortTermGoal(\'PT\')\"\n                      type=\"vm.typeGoalsPT\"></frp-goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.ptSortTermGoalAddNewResponses track by $index\">\n        <frp-goal-add-new-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" last-item=\"$last\" on-delete=\"vm.deleteSortTermGoalAddNew(data, \'PT\')\" on-click-add-new-goal=\"vm.addNewSortTermGoal(\'PT\')\" ng-if=\"goal.active\"\n                              type=\"vm.typeGoalsPT\"></frp-goal-add-new-row>\n    </div>\n\n    <h4 class=\"primary title mt-4\" translate=\"ipmApp.frpReport.conclusion.psychologicalGoals\">Psychological Goals</h4>\n    <div ng-repeat=\"goal in vm.report.psychSortTermGoalResponses track by $index\">\n        <frp-goal-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" show-add-goal=\"vm.showAddGoal($last, false, \'PSYCH\')\" on-click-add-new-goal=\"vm.addNewSortTermGoal(\'PSYCH\')\"\n                      type=\"vm.typeGoalsPSYCH\"></frp-goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.psychSortTermGoalAddNewResponses track by $index\">\n        <frp-goal-add-new-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" last-item=\"$last\" on-delete=\"vm.deleteSortTermGoalAddNew(data, \'PSYCH\')\" on-click-add-new-goal=\"vm.addNewSortTermGoal(\'PSYCH\')\" ng-if=\"goal.active\"\n                              type=\"vm.typeGoalsPSYCH\"></frp-goal-add-new-row>\n    </div>\n\n    <h4 class=\"primary title mt-4\">\n        <span ng-class=\"{\'text-danger\':vm.conclusionReportForm.$submitted && (!vm.checkValidationLongTermGoals() || !vm.hasTermGoalChecked(false))}\">{{\'ipmApp.frpReport.conclusion.longTermGoals\' | translate}}</span>\n        <span ng-if=\"vm.isMidsessionReport\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <h4 class=\"primary title mt-4\" translate=\"ipmApp.frpReport.conclusion.physicalFunctionalGoals\">Physical/Functional Goals</h4>\n    <div ng-repeat=\"goal in vm.report.ptLongTermGoalResponses track by $index\">\n        <frp-goal-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" show-add-goal=\"vm.showAddGoal($last, true, \'PT\')\" on-click-add-new-goal=\"vm.addNewLongTermGoal(\'PT\')\"\n                      type=\"vm.typeGoalsPT\"></frp-goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.ptLongTermGoalAddNewResponses track by $index\">\n        <frp-goal-add-new-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" last-item=\"$last\" on-delete=\"vm.deleteLongTermGoalAddNew(data, \'PT\')\" on-click-add-new-goal=\"vm.addNewLongTermGoal(\'PT\')\" ng-if=\"goal.active\"\n                              type=\"vm.typeGoalsPT\"></frp-goal-add-new-row>\n    </div>\n\n    <h4 class=\"primary title mt-4\" translate=\"ipmApp.frpReport.conclusion.psychologicalGoals\">Psychological Goals</h4>\n    <div ng-repeat=\"goal in vm.report.psychLongTermGoalResponses track by $index\">\n        <frp-goal-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" show-add-goal=\"vm.showAddGoal($last, true, \'PSYCH\')\" on-click-add-new-goal=\"vm.addNewLongTermGoal(\'PSYCH\')\"\n                      type=\"vm.typeGoalsPSYCH\"></frp-goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.psychLongTermGoalAddNewResponses track by $index\">\n        <frp-goal-add-new-row form-reference=\"vm.conclusionReportForm\" is-disabled=\"vm.isDisabled\" item=\"goal\" last-item=\"$last\" on-delete=\"vm.deleteLongTermGoalAddNew(data, \'PSYCH\')\" on-click-add-new-goal=\"vm.addNewLongTermGoal(\'PSYCH\')\" ng-if=\"goal.active\"\n                              type=\"vm.typeGoalsPSYCH\"></frp-goal-add-new-row>\n    </div></script><!-- request-for-treatment-template --><script type=\"text/ng-template\" id=\"request-for-treatment-template\"><h4 class=\"primary title my-4\">\n        <span>{{\"ipmApp.frpReport.conclusion.requestForTreatment\" | translate}}</span>\n    </h4>\n    <!--<form name=\"conclusionReportForm\" role=\"form\" novalidate>-->\n        <div>\n            <input type=\"checkbox\"\n                id=\"checkbox_request_for_treatment\"\n                name=\"checkbox_request_for_treatment\"\n                ng-model=\"vm.report.remainingSessions\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.isMidsessionReport\"\n                class=\"form-check-input-v4 mt-0\">\n            <label for=\"checkbox_request_for_treatment\" class=\"form-check-label-v4\" ng-class=\"{\'text-danger\': vm.isMidsessionReport && vm.conclusionReportForm.checkbox_request_for_treatment.$dirty && !vm.report.remainingSessions }\">{{\'ipmApp.frpReport.conclusion.remainingSessions\' | translate}}</label>\n            <span ng-if=\"vm.isMidsessionReport\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n        </div>\n        <div class=\"form-group row-v4 ml-0 form-check-v4\">\n            <label class=\"m-0\">{{\'ipmApp.frpReport.conclusion.hoursCompleted\' | translate}}</label>\n            <span ng-if=\"vm.isMidsessionReport\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n            <div class=\"col-v4-md-3 col-v4-sm-6\">\n                <input type=\"text\" class=\"form-control\" id=\"input_hours_completed\" name=\"input_hours_completed\" ng-model=\"vm.report.hoursCompleted\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.isMidsessionReport\"/>\n            </div>\n            <div ng-show=\"vm.conclusionReportForm.input_hours_completed.$dirty\">\n                <p class=\"help-block m-0\" ng-show=\"vm.conclusionReportForm.input_hours_completed.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        <div class=\"form-group row-v4 ml-0 form-check-v4\">\n            <label class=\"m-0\">{{\'ipmApp.frpReport.conclusion.hoursRequested\' | translate}}</label>\n            <span ng-if=\"vm.isMidsessionReport\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n            <div class=\"col-v4-md-3 col-v4-sm-6\">\n                <input type=\"text\" class=\"form-control\" id=\"input_hours_requested\" name=\"input_hours_requested\" ng-model=\"vm.report.hoursRequested\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.isMidsessionReport\"/>\n            </div>\n            <div ng-show=\"vm.conclusionReportForm.input_hours_requested.$dirty\">\n                <p class=\"help-block m-0\" ng-show=\"vm.conclusionReportForm.input_hours_requested.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n    <!--</form>--></script>");
$templateCache.put("app/frp-mde/frp-report/psych/frp-report-psych.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\" ng-show=\"vm.isLoadingData\"><jhi-alert></jhi-alert><form name=\"vm.editForm\" role=\"form\" novalidate><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.frpReport.psych.title\'\" report=\"vm.dataHeaderReport\"></header-report><div class=\"row-v4\"><div class=\"col-v4-md-7\"><div class=\"row-v4 my-4\"><div class=\"col-v4-md-12\"><h4 class=\"primary title pt-4\" translate=\"ipmApp.frpReport.psych.psychologicalProgressSummary\">Psychological Progress Summary</h4></div></div><div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title\"><span>{{\"ipmApp.frpReport.psych.subjective\" | translate}}</span> <span ng-if=\"!vm.isWeekly\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select is-disabled=\"vm.isDisabled\" templates=\"vm.templates\" report=\"vm.frpReport.frpReportPsych.subjective\" input-type=\"vm.templateInputType.SUBJECTIVE\" option=\"vm.frpReport.frpReportPsych.subjectiveTemplate\" control-title-key=\"\'ipmApp.frpReport.psych.subjective\'\"></template-select></div></div><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"subjective\" id=\"subjective\" ng-model=\"vm.frpReport.frpReportPsych.subjective\" ng-disabled=\"vm.isDisabled || vm.disableFields.subjective\" ng-required=\"!vm.isWeekly\"></textarea><div ng-show=\"vm.editForm.subjective.$dirty && vm.editForm.subjective.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.subjective.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-10\"><div class=\"row-v4 my-4\"><div class=\"col-v4-md-12\"><h4 class=\"primary title\" translate=\"ipmApp.frpReport.psych.psychTesting\">Psych Testing</h4></div></div><div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-auto\"><h5 class=\"primary title ml-1\"><span ng-class=\"{\'text-danger\':vm.editForm.$submitted && !vm.reportType}\">{{\"ipmApp.frpReport.psych.subjectiveTesting\" | translate}}</span></h5></div><div ng-if=\"vm.frpReport.firstReport && vm.frpReport.frpReportAdmin.reportType\" class=\"col-v4-md-auto text-center\"><label class=\"form-check-label-v4\" style=\"margin-right: 4px\" for=\"chbox_subjective_importMdeScores\">Import MDE Scores</label><input type=\"checkbox\" class=\"form-check-input-v4\" id=\"chbox_subjective_importMdeScores\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.subjectiveImportMdeScores\" ng-change=\"vm.importMdeScores(\'subjective\')\"></div></div><psych-subjective-testing-controller ng-if=\"vm.frpReport && vm.frpReport.frpReportAdmin.reportType\" disable-fields=\"vm.disableFields\" report-type=\"vm.frpReport.frpReportAdmin.reportType\" subjective-responses=\"vm.frpReport.frpReportPsych.subjectiveResponses\" midsessions-removed-list=\"vm.midsessionsRemovedList\" parent-form=\"vm.editForm\" have-midsession-previous=\"vm.frpReport.haveMidsessionPrevious\" subjective-import-mde-scores=\"vm.subjectiveImportMdeScores\" severity=\"vm.severitySubjectives\" on-change-midsessions=\"vm.updateSeveritySubjectives(subjectiveResponses)\"></psych-subjective-testing-controller><div class=\"pl-5\" ng-if=\"!vm.frpReport.frpReportAdmin.reportType\"><span class=\"text-danger\" translate=\"ipmApp.frpReport.pleaseSelectAReportType\">Please select a Report Type in the Admin section of the report builder to enable this table.</span></div></div></div></div></div></div><div class=\"row-v4 my-4\"><div class=\"col-v4-md-10\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-auto\"><h5 class=\"primary title ml-1\"><span ng-class=\"{\'text-danger\':vm.editForm.$submitted && !vm.reportType}\">{{\"ipmApp.frpReport.psych.objectiveTesting\" | translate}}</span></h5></div><div ng-if=\"vm.frpReport.firstReport && vm.frpReport.frpReportAdmin.reportType\" class=\"col-v4-md-auto text-center\" style=\"margin-left: 8px\"><label class=\"form-check-label-v4\" style=\"margin-right: 4px\" for=\"chbox_objective_importMdeScores\">Import MDE Scores</label><input type=\"checkbox\" class=\"form-check-input-v4\" id=\"chbox_objective_importMdeScores\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.objectiveImportMdeScores\" ng-change=\"vm.importMdeScores(\'objective\')\"></div></div><psych-objective-testing-controller ng-if=\"vm.frpReport && vm.frpReport.frpReportAdmin.reportType\" disable-fields=\"vm.disableFields\" report-type=\"vm.frpReport.frpReportAdmin.reportType\" objective-responses=\"vm.frpReport.frpReportPsych.objectiveResponses\" midsessions-removed-list=\"vm.midsessionsRemovedList\" is-mid-session-objective-updated=\"vm.frpReport.frpReportPsych.isMidSessionObjectiveUpdated\" parent-form=\"vm.editForm\" have-midsession-previous=\"vm.frpReport.haveMidsessionPrevious\" objective-import-mde-scores=\"vm.objectiveImportMdeScores\" severity=\"vm.severityObjectives\" on-change-midsessions=\"vm.updateSeverityObjectives(objectiveResponses)\"></psych-objective-testing-controller><div class=\"pl-5\" ng-if=\"!vm.frpReport.frpReportAdmin.reportType\"><span class=\"text-danger\" translate=\"ipmApp.frpReport.pleaseSelectAReportType\">Please select a Report Type in the Admin section of the report builder to enable this table.</span></div></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-7\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title\"><span>{{\"ipmApp.frpReport.psych.psychologicalNarrative\" | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select is-disabled=\"vm.isDisabled\" templates=\"vm.templates\" report=\"vm.frpReport.frpReportPsych.psychologicalNarrative\" input-type=\"vm.templateInputType.PSYCHOLOGICAL_NARRATIVE\" option=\"vm.frpReport.frpReportPsych.psychologicalNarrativeTemplate\" control-title-key=\"\'ipmApp.frpReport.psych.psychologicalNarrative\'\"></template-select></div></div><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"psychologicalNarrative\" id=\"psychologicalNarrative\" ng-model=\"vm.frpReport.frpReportPsych.psychologicalNarrative\" ng-disabled=\"vm.isDisabled || vm.disableFields.subjective\" ng-required=\"true\"></textarea><div ng-show=\"vm.editForm.psychologicalNarrative.$dirty && vm.editForm.psychologicalNarrative.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.psychologicalNarrative.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div></div></div><div class=\"mt-4\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || !vm.isChanged() || vm.isDisabled\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving || (vm.isFinalize && !vm.isChanged()) || vm.isDisabled\" class=\"btn btn-primary\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">finalize</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Submit</span></button></div></form></div></div></div>");
$templateCache.put("app/frp-mde/frp-report/home/frp-report-home.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.frpReport.home.title\'\" report=\"vm.dataHeaderReport\"></header-report><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped table-hover mb-0\"><thead><tr><th>{{\'ipmApp.frpReport.home.table.role\' | translate}}</th><th>{{\'ipmApp.frpReport.home.table.assignedTo\' | translate}}</th><th>{{\'ipmApp.frpReport.home.table.status\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports track by $index\"><td>{{\'ipmApp.frpReport.home.table.\' +report.role | translate}}</td><td ng-if=\"report.assignedTo\"><span ng-if=\"report.role !== \'ADDENDUM\'\">{{report.assignedTo}}</span></td><td ng-if=\"!report.assignedTo\"><span ng-if=\"report.role !== \'ADDENDUM\'\">{{\'ipmApp.frpReport.home.table.unassigned\' | translate}}</span></td><td>{{\'ipmApp.frpReport.home.status.\' + report.status| translate}}</td><td class=\"text-right\"><button type=\"submit\" ng-if=\"(!vm.isView || report.role === \'ADDENDUM\') && !vm.frpReport.patientFRPMDE.isViewFrpProgram\" ng-click=\"vm.editPage(report.role)\" class=\"btn btn-primary btn-sm\"><span translate=\"entity.action.edit\" ng-if=\"report.status !== \'NOT_STARTED\'\"></span> <span translate=\"ipmApp.frpReport.home.start\" ng-if=\"report.status === \'NOT_STARTED\'\"></span></button> <button type=\"submit\" ng-if=\"(vm.isView && report.role !== \'ADDENDUM\') || vm.frpReport.patientFRPMDE.isViewFrpProgram\" ng-click=\"vm.viewPage(report.role)\" class=\"btn btn-primary btn-sm\"><span translate=\"entity.action.view\"></span></button></td></tr><tr class=\"not-hover\"><td colspan=\"2\" class=\"pt-5 pl-0\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"frp-mde\"><span translate=\"entity.action.back\">Back</span></button></td><td colspan=\"2\" class=\"pt-5\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.finalAndSignOffClick()\" ng-if=\"vm.checkCompletedAllReport() && !vm.isView\" ng-disabled=\"!vm.checkCompletedAllReport()\"><span>{{\'entity.action.finalAndSignOff\' | translate}}</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.preview()\"><span translate=\"entity.action.previewReport\">Preview Report</span></button></td></tr></tbody></table></div><div class=\"row mt-15px\" ng-if=\"!vm.reports\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"frp-mde\"><span translate=\"entity.action.back\">Back</span></button></div></div></div></div></div>");
$templateCache.put("app/frp-mde/frp-report/pt/frp-report-pt.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.report\"><jhi-alert></jhi-alert><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.frpReport.pt.title\'\" report=\"vm.dataHeaderReport\"></header-report><form name=\"vm.editForm\" role=\"form\" novalidate><!-- progress-summary --><div ng-include=\"\'progress-summary-template\'\"></div><!-- subjective-testing --><div ng-include=\"\'subjective-testing-template\'\"></div><!-- objective-testing --><div ng-include=\"\'objective-testing-template\'\"></div><!-- physical-functional-narrative --><div ng-include=\"\'physical-functional-narrative-template\'\"></div><div class=\"mt-4\"><button type=\"submit\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || !vm.isChanged() || vm.isDisabled\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving || (vm.isFinalize && !vm.isChanged()) || vm.isDisabled\" class=\"btn btn-primary\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">Save For Later</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Submit</span></button></div></form></div></div></div><!-- progress-summary --><script type=\"text/ng-template\" id=\"progress-summary-template\"><h4 class=\"primary title mt-4 mb-4\" translate=\"ipmApp.frpReport.pt.physicalFunctionalProgressSummry\">Physical/Functional Progress Summary</h4>\n    <form name=\"vm.editForm\" role=\"form\" novalidate>\n        <div class=\"col-v4-md-12\">\n            <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n                <div class=\"col-v4-md-auto\">\n                    <h4 class=\"primary title\">\n                        {{\'ipmApp.frpReport.pt.subjective\' | translate}}\n                        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" ng-show=\"vm.isSubjectiveRequired\"></span>\n                    </h4>\n                </div>\n                <div class=\"col-v4-md-auto\">\n                    <template-select\n                        is-disabled=\"vm.isDisabled\"\n                        templates=\"vm.templates\"\n                        report=\"vm.report.subjective\"\n                        input-type=\"vm.templateInputType.PHYSICAL_SUBJECTIVE\"\n                        option=\"vm.report.subjectiveTemplate\"\n                        control-title-key=\"\'ipmApp.frpReport.pt.subjective\'\">\n                    </template-select>\n                </div>\n            </div>\n            <div class=\"form-group\">\n            <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"subjective\" id=\"subjective\"\n                      ng-model=\"vm.report.subjective\" ng-required=\"vm.isSubjectiveRequired\" ng-disabled=\"vm.isDisabled\">\n            </textarea>\n                <div ng-show=\"vm.editForm.subjective.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.subjective.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </form></script><!-- subjective-testing --><script type=\"text/ng-template\" id=\"subjective-testing-template\"><h4 class=\"primary title mt-4 mb-4\" translate=\"ipmApp.frpReport.pt.ptTesting\">Physical/Functional Testing</h4>\n    <div class=\"row-v4\">\n        <div class=\"col-v4-md-auto\">\n            <h4 class=\"primary title ml-1\">\n                <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasItemChecked(vm.report.subjectives) || vm.hasItemCheckedInvalid(vm.report.subjectives))}\">\n                    {{\'ipmApp.frpReport.pt.subjectiveTesting\' | translate}}</span>\n                <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" ng-if=\"!vm.isOtherReport\"></span>\n            </h4>\n        </div>\n        <div ng-if=\"vm.frpReport.firstReport && vm.reportType\" class=\"col-v4-md-auto text-center\">\n            <label class=\"form-check-label-v4\" style=\"margin-right: 4px;\" for=\"chbox_subjective_importMdeScores\">Import MDE Scores</label>\n            <input type=\"checkbox\" class=\"form-check-input-v4\" id=\"chbox_subjective_importMdeScores\"\n                ng-disabled=\"vm.isDisabled\"\n                ng-model=\"vm.subjectiveImportMdeScores\"\n                ng-change=\"vm.importMdeScores(\'subjective\')\" />\n        </div>\n    </div>\n    <div class=\"form-group table-responsive voffset2\" ng-if=\"vm.reportType\">\n        <table class=\"jh-table table table-striped table-bordered\">\n            <thead>\n            <tr class=\"header-vertical-middle fixed-width\">\n                <th class=\"w-60\">\n                    <span translate=\"ipmApp.frpReport.pt.select\"></span>\n                    <div>\n                        <input type=\"checkbox\"\n                               id=\"checkbox_select_all_subjective\"\n                               name=\"checkbox_select_all\"\n                               ng-model=\"vm.subjectiveChecked\"\n                               ng-disabled=\"vm.isDisabled\"\n                               ng-click=\"vm.onClickSelectAllSubjective()\" />\n                    </div>\n                </th>\n                <th class=\"w-120\">\n                    <span translate=\"ipmApp.frpReport.pt.instrument\"></span>\n                </th>\n                <th class=\"w-180\">\n                    <span translate=\"ipmApp.frpReport.pt.score\"></span>\n                </th>\n                <th class=\"w-240\" ng-repeat=\"ms in vm.report.subjectives[0].midsessions track by $index\">\n                    <div class=\"d-flex\">\n                        <div class=\"flex-grow-0 text-nowrap d-flex align-items-center\">\n                            Midsession&nbsp;-&nbsp;\n                        </div>\n                        <div class=\"flex-grow-1\">\n                            <div class=\"input-group input-midsession\">\n                                <input type=\"text\" class=\"form-control\"\n                                       id=\"field_subjective_midsession_date_{{$index}}\"\n                                       name=\"field_subjective_midsession_date_{{$index}}\"\n                                       uib-datepicker-popup=\"{{vm.dateFormat}}\"\n                                       ng-model=\"vm.report.subjectives[0].midsessions[$index].dated\"\n                                       is-open=\"ms.datePickerOpenStatus.dateRequested\"\n                                       enable-time=\"false\"\n                                       ng-change=\"vm.subjectiveChangedTime($index)\"\n                                       ng-required=\"vm.checkRequiredDateMidsessionSubjectives($index)\"\n                                       ng-disabled=\"vm.checkDisableColMidsessions($index, vm.report.subjectives[0].midsessions)\"\n                                />\n                                <div class=\"input-group-addon\">\n                                    <span class=\"glyphicon glyphicon-calendar\"\n                                          ng-class=\"{\'disabled\': vm.checkDisableColMidsessions($index, vm.report.subjectives[0].midsessions)}\"\n                                          ng-click=\"vm.openSubjectiveCalendar($index, \'dateRequested\')\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"flex-grow-2 mx-1 mt-1\">\n                            <button type=\"button\"\n                                    ng-disabled=\"vm.disableRemoveColMidsessions()\"\n                                    ng-click=\"vm.removeColMidsessionsSubjectives(ms, $index)\"\n                                    class=\"btn btn-sm\">\n                                <span class=\"glyphicon glyphicon-remove\"></span>\n                            </button>\n                        </div>\n                    </div>\n                    <div class=\"d-flex\"\n                         ng-show=\"vm.editForm.field_subjective_midsession_date_{{$index}}.$dirty && vm.editForm.field_subjective_midsession_date_{{$index}}.$error.required\">\n                        <div class=\"flex-grow-0 text-nowrap d-flex align-items-center transparent\">\n                            Midsessions&nbsp;-&nbsp;\n                        </div>\n                        <div class=\"flex-grow-1\">\n                            <p class=\"help-block\" translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                </th>\n                <th class=\"w-120\">\n                    <span translate=\"ipmApp.frpReport.pt.discharge\"></span>\n                </th>\n                <th class=\"w-180\">\n                    <span translate=\"ipmApp.frpReport.pt.notes\"></span>\n                </th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"subjective in vm.report.subjectives track by $index\" ng-include=\"\'subjective-testing-row-template\'\"></tr>\n            </tbody>\n        </table>\n    </div>\n    <div class=\"ml-4 mb-4\" ng-if=\"vm.reportType\">\n        <button type=\"button\" class=\"btn btn-info\" ng-disabled=\"!vm.isMidsessionReport || vm.isDisabled\" ng-click=\"vm.addMidsessionToSubjectiveTesting()\">\n            <span translate=\"ipmApp.frpReport.pt.addMidsession\">Add Midsession Column to Table</span>\n        </button>\n    </div>\n    <div class=\"form-group table-responsive voffset2\" ng-if=\"!vm.reportType\">\n        <span class=\"pl-5 text-danger\" translate=\"ipmApp.frpReport.pleaseSelectAReportType\">Please select a Report Type in the Admin section of the report builder to enable this table.</span>\n    </div></script><!-- subjective-testing-row --><script type=\"text/ng-template\" id=\"subjective-testing-row-template\"><td>\n        <input type=\"checkbox\"\n               id=\"checkbox_{{subjective.code}}\"\n               name=\"checkbox_{{subjective.code}}\"\n               ng-disabled=\"vm.isDisabled\"\n               ng-model=\"subjective.checked\"\n               ng-change=\"vm.checkboxSubjectiveTestingChange(subjective)\" />\n    </td>\n    <td>\n        <label for=\"checkbox_{{subjective.code}}\">{{\'ipmApp.mdeReport.pt.subjectives.\' + subjective.code | translate}}</label>\n        <span ng-if=\"subjective.checked && !vm.isOtherReport\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </td>\n    <td>\n        <input type=\"text\" class=\"form-control\"\n               id=\"score_{{subjective.code}}\" name=\"score_{{subjective.code}}\"\n               ng-disabled=\"vm.isDisabled\"\n               ng-model=\"subjective.score\"\n               ng-required=\"subjective.checked && vm.checkRequiredFieldScore()\"\n               check-maxlength=\"255\"/>\n        <div ng-show=\"vm.editForm.score_{{subjective.code}}.$dirty\">\n            <p class=\"help-block\"\n               ng-show=\"vm.editForm.score_{{subjective.code}}.$error.required\" translate=\"entity.validation.required\">\n                This field is required.\n            </p>\n            <p class=\"help-block\"\n               ng-show=\"vm.editForm.score_{{subjective.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n               translate-value-max=\"255\">\n                This field cannot be longer than 255 characters.\n            </p>\n        </div>\n    </td>\n    <td ng-repeat=\"ms in subjective.midsessions track by $index\">\n        <input type=\"text\" class=\"form-control\"\n               id=\"{{subjective.code}}_midsession_{{$index}}\" name=\"{{subjective.code}}_midsession_{{$index}}\"\n               ng-model=\"ms.testScore\"\n               check-maxlength=\"50\"\n               ng-required=\"subjective.checked && vm.checkRequiredColMidsessions($index, subjective.midsessions)\"\n               ng-disabled=\"vm.checkDisableColMidsessions($index, subjective.midsessions)\" />\n        <div ng-show=\"vm.editForm.{{subjective.code}}_midsession_{{$index}}.$dirty\">\n            <p class=\"help-block\"\n                ng-show=\"vm.editForm.{{subjective.code}}_midsession_{{$index}}.$error.required\" translate=\"entity.validation.required\">\n                This field is required.\n            </p>\n            <p class=\"help-block\"\n               ng-show=\"vm.editForm.{{subjective.code}}_midsession_{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n               translate-value-max=\"50\">\n                This field cannot be longer than 50 characters.\n            </p>\n        </div>\n    </td>\n    <td>\n        <input type=\"text\" class=\"form-control\"\n               id=\"discharge_{{subjective.code}}\" name=\"discharge_{{subjective.code}}\"\n               ng-disabled=\"vm.isDisabled\"\n               ng-required=\"subjective.checked && vm.checkRequiredFieldDischarge()\"\n               ng-model=\"subjective.discharge\"\n               check-maxlength=\"255\"/>\n        <div ng-show=\"vm.editForm.discharge_{{subjective.code}}.$dirty\">\n            <p class=\"help-block\"\n                ng-show=\"vm.editForm.discharge_{{subjective.code}}.$error.required\" translate=\"entity.validation.required\">\n                This field is required.\n            </p>\n            <p class=\"help-block\"\n               ng-show=\"vm.editForm.discharge_{{subjective.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n               translate-value-max=\"255\">\n                This field cannot be longer than 255 characters.\n            </p>\n        </div>\n    </td>\n    <td>\n        <div>\n        <input type=\"text\" class=\"form-control\"\n               id=\"notes_{{subjective.code}}\" name=\"notes_{{subjective.code}}\"\n               ng-disabled=\"vm.isDisabled\"\n               ng-model=\"subjective.notes\"\n               check-maxlength=\"5000\"/>\n            <div ng-show=\"vm.editForm.notes_{{subjective.code}}.$dirty\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.notes_{{subjective.code}}.$error.maxlength\"\n                   translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"5000\">\n                    This field cannot be longer than 5000 characters.\n                </p>\n            </div>\n        </div>\n    </td></script><!-- objective-testing --><script type=\"text/ng-template\" id=\"objective-testing-template\"><div class=\"row-v4\">\n        <div class=\"col-v4-md-auto\">\n            <h4 class=\"primary title ml-1\">\n                <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasObjectiveChecked())}\">\n                    {{\'ipmApp.frpReport.pt.objectiveTesting\' | translate}}</span>\n                <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" ng-if=\"!vm.isOtherReport\"></span>\n            </h4>\n        </div>\n        <div ng-if=\"vm.frpReport.firstReport && vm.reportType\" class=\"col-v4-md-auto text-center\" style=\"margin-left: 8px;\">\n            <label class=\"form-check-label-v4\" style=\"margin-right: 4px;\" for=\"chbox_objective_importMdeScores\">Import MDE Scores</label>\n            <input type=\"checkbox\" class=\"form-check-input-v4\" id=\"chbox_objective_importMdeScores\"\n                ng-disabled=\"vm.isDisabled\"\n                ng-model=\"vm.objectiveImportMdeScores\"\n                ng-change=\"vm.importMdeScores(\'objective\')\" />\n        </div>\n    </div>\n    <div class=\"objective form-group\" ng-if=\"vm.reportType\">\n        <div ng-repeat=\"objective in vm.report.objectives track by $index\">\n            <div class=\"objective-header\" ng-class=\"vm.hasChildCheckedNotCheckRom(objective) ? \'has-checked\' : \'\'\" ng-click=\"objective.$isCollapsed = !objective.$isCollapsed\">\n                <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasChildChecked(objective) || vm.hasChildCheckedInvalid(objective) || vm.hasOtherCheckedInvalid(objective))}\">\n                    {{\'ipmApp.frpReport.pt.objectives.\' + objective.code | translate}}</span>\n                <span ng-if=\"vm.isChildRequired(objective)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                <span ng-class=\"{\'active\': !objective.$isCollapsed}\" class=\"expand-icon\"></span>\n            </div>\n            <div class=\"objective-content\" uib-collapse=\"objective.$isCollapsed\">\n                <div class=\"table-responsive\">\n                    <table class=\"jh-table table table-striped table-bordered mb-0\">\n                        <thead>\n                        <tr class=\"header-vertical-middle fixed-width\">\n                            <th class=\"w-60 pt-4 pb-0\">\n                                <span translate=\"ipmApp.frpReport.pt.select\"></span>\n                                <div>\n                                    <input type=\"checkbox\"\n                                           id=\"checkbox_select_all_{{objective.code}}\"\n                                           name=\"checkbox_select_all_{{objective.code}}\"\n                                           ng-model=\"objective.checked\"\n                                           ng-disabled=\"vm.isDisabled\"\n                                           ng-click=\"vm.onClickSelectAll(objective)\" />\n                                </div>\n\n                            </th>\n                            <th class=\"w-270\">\n                                <span translate=\"ipmApp.frpReport.pt.instrument\"></span>\n                            </th>\n                            <th class=\"w-240\">\n                                <span translate=\"ipmApp.frpReport.pt.score\"></span>\n                            </th>\n                            <th class=\"w-300\" ng-repeat=\"ms in objective.childs[0].midsessions track by $index\">\n                                <div class=\"d-flex\">\n                                    <div class=\"flex-grow-0 text-nowrap d-flex align-items-center\">\n                                        Midsession&nbsp;-&nbsp;\n                                    </div>\n                                    <div class=\"flex-grow-1\">\n                                        <div class=\"input-group input-midsession\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   id=\"field_objective_midsession_date_{{objective.code}}_{{$index}}\"\n                                                   name=\"field_objective_midsession_date_{{objective.code}}_{{$index}}\"\n                                                   uib-datepicker-popup=\"{{vm.dateFormat}}\"\n                                                   ng-model=\"objective.childs[0].midsessions[$index].dated\"\n                                                   is-open=\"objective.childs[0].midsessions[$index].datePickerOpenStatus.dateRequested\"\n                                                   enable-time=\"false\"\n                                                   ng-required=\"vm.checkRequiredDateMidsession(objective, $index)\"\n\n                                                   ng-change=\"vm.objectiveChangedTime(objective, $index)\"\n                                                   ng-disabled=\"vm.checkDisableColMidsessions($index, objective.childs[0].midsessions )\"\n                                            />\n                                            <div class=\"input-group-addon\">\n                                                <span class=\"glyphicon glyphicon-calendar\"\n                                                      ng-class=\"{\'disabled\': vm.checkDisableColMidsessions($index, objective.childs[0].midsessions )}\"\n                                                      ng-click=\"vm.openObjectiveCalendar(objective, $index, \'dateRequested\')\"></span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"flex-grow-2 mx-1 mt-1\">\n                                        <button type=\"button\"\n                                                ng-disabled=\"vm.disableRemoveColMidsessions()\"\n                                                ng-click=\"vm.removeColMidsessionsObjectives(objective, $index)\"\n                                                class=\"btn btn-sm\">\n                                            <span class=\"glyphicon glyphicon-remove\"></span>\n                                        </button>\n                                    </div>\n                                </div>\n                                <div class=\"d-flex\"\n                                     ng-show=\"vm.editForm.field_objective_midsession_date_{{objective.code}}_{{$index}}.$dirty && vm.editForm.field_objective_midsession_date_{{objective.code}}_{{$index}}.$error.required\">\n                                    <div class=\"flex-grow-0 text-nowrap d-flex align-items-center transparent\">\n                                        Midsessions&nbsp;-&nbsp;\n                                    </div>\n                                    <div class=\"flex-grow-1\">\n                                        <p class=\"help-block\" translate=\"entity.validation.required\">\n                                            This field is required.\n                                        </p>\n                                    </div>\n                                </div>\n                            </th>\n                            <th class=\"w-240\">\n                                <span translate=\"ipmApp.frpReport.pt.discharge\"></span>\n                            </th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat=\"child in objective.childs track by $index\" ng-include=\"\'objective-testing-row-template\'\"></tr>\n                        <tr ng-repeat=\"child in vm.report.otherObjectives track by $index\" ng-if=\"child.typeReportId == objective.typeReportId && child.active\" ng-include=\"\'other-objective-testing-row-template\'\"></tr>\n                        <tr>\n                            <td></td>\n                            <td><span ng-class=\"{\'disabled-button\' : (vm.isDisabled)}\" ng-click=\"!(vm.isDisabled) && vm.addOtherObjective(objective)\" class=\"add-other-objective\">Add other</span></td>\n                            <td></td>\n                            <td ng-repeat=\"ms in objective.childs[0].midsessions track by $index\"></td>\n                            <td></td>\n                        </tr>\n                        <tr>\n                            <td>\n                                <label>{{\'ipmApp.frpReport.pt.notes\' | translate}}</label>:\n                            </td>\n                            <td colspan=\"{{vm.calculatorColspan(objective.childs[0])}}\">\n                                <textarea class=\"form-control auto-height none-resize\" rows=\"2\"\n                                          id=\"field_objective_notes_{{$index}}\" name=\"field_objective_notes_{{$index}}\"\n                                          ng-disabled=\"vm.isDisabled\"\n                                          ng-model=\"objective.childs[0].notes\">\n                                </textarea>\n                            </td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <div class=\"mt-3\">\n                    <button type=\"button\" class=\"btn btn-info\" ng-disabled=\"!vm.isMidsessionReport || vm.isDisabled\" ng-click=\"vm.addMidsessionToObjectiveTesting(objective)\">\n                        <span translate=\"ipmApp.frpReport.pt.addMidsession\">Add Midsession Column to Table</span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group table-responsive voffset2\" ng-if=\"!vm.reportType\">\n        <span class=\"pl-5 text-danger\" translate=\"ipmApp.frpReport.pleaseSelectAReportType\">Please select a Report Type in the Admin section of the report builder to enable this table.</span>\n    </div></script><!-- objective-testing-row --><script type=\"text/ng-template\" id=\"objective-testing-row-template\"><td>\n        <input type=\"checkbox\"\n               id=\"checkbox_{{child.code}}\"\n               name=\"checkbox_{{child.code}}\"\n               ng-disabled=\"vm.isDisabled || vm.isAverage(child)\"\n               ng-model=\"child.checked\"\n               ng-class=\"{\'invisible\': vm.isAverage(child)}\"\n               ng-change=\"vm.checkboxObjectiveTestingChange(objective, child)\" />\n    </td>\n    <td>\n        <label for=\"checkbox_{{child.code}}\" ng-bind-html=\"\'ipmApp.frpReport.pt.objectives.\' + child.code | translate\"></label>\n    </td>\n    <td>\n        <!-- normal-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'normal-input\'\" ng-if=\"child.type === \'NORMAL_TEXT_FIELD\'\"></div>\n\n        <!-- left-right-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'left-right-input\'\" ng-if=\"child.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div>\n    </td>\n    <td ng-repeat=\"ms in child.midsessions track by $index\">\n        <!-- ms-normal-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'ms-normal-input\'\" ng-if=\"child.type === \'NORMAL_TEXT_FIELD\'\"></div>\n\n        <!-- ms-left-right-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'ms-left-right-input\'\" ng-if=\"child.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div>\n    </td>\n    <td>\n        <div class=\"row-v4 justify-content-md-center\" ng-if=\"child.type === \'NORMAL_TEXT_FIELD\'\">\n            <div class=\"col-v4\">\n                <div>\n                    <input type=\"text\" class=\"form-control\"\n                        id=\"discharge_{{child.code}}\" name=\"discharge_{{child.code}}\"\n                        ng-disabled=\"vm.isDisabled\"\n                        ng-model=\"child.discharge\"\n                        ng-required=\"child.checked && vm.checkRequiredFieldDischarge() && !vm.isAverage(child)\"\n                        check-maxlength=\"255\"/>\n                </div>\n                <div ng-show=\"vm.editForm.discharge_{{child.code}}.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                       translate-value-max=\"255\">\n                        This field cannot be longer than 255 characters.\n                    </p>\n                </div>\n            </div>\n        </div>\n        <div class=\"row-v4\" ng-if=\"child.type === \'LEFT_RIGHT_TEXT_FIELD\'\">\n            <!--RIGHT-->\n            <div class=\"col-v4-6\">\n                <div class=\"\">\n                    <div class=\"form-row-v4\">\n                        <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                            <span>R</span>\n                        </div>\n                        <div class=\"col-v4\">\n                            <input type=\"text\" class=\"form-control\"\n                                   id=\"discharge_right_{{child.code}}\" name=\"discharge_right_{{child.code}}\"\n                                   ng-disabled=\"vm.isDisabled || vm.isAverage(child)\"\n                                   ng-change=\"vm.calculatorLR(objective)\"\n                                   ng-model=\"child.dischargeRight\"\n                                   ng-required=\"child.checked && vm.checkRequiredFieldDischarge() && !vm.isAverage(child)\"\n                                   check-maxlength=\"255\"/>\n                        </div>\n                    </div>\n                </div>\n                <div ng-show=\"vm.editForm.discharge_right_{{child.code}}.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_right_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_right_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                       translate-value-max=\"255\">\n                        This field cannot be longer than 255 characters.\n                    </p>\n                </div>\n            </div>\n            <!--LEFT-->\n            <div class=\"col-v4-6\">\n                <div class=\"\">\n                    <div class=\"form-row-v4\">\n                        <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                            <span>L</span>\n                        </div>\n                        <div class=\"col-v4\">\n                            <input type=\"text\" class=\"form-control\"\n                                   id=\"discharge_left_{{child.code}}\" name=\"discharge_left_{{child.code}}\"\n                                   ng-disabled=\"vm.isDisabled || vm.isAverage(child)\"\n                                   ng-change=\"vm.calculatorLR(objective)\"\n                                   ng-model=\"child.dischargeLeft\"\n                                   ng-required=\"child.checked && vm.checkRequiredFieldDischarge() && !vm.isAverage(child)\" check-maxlength=\"255\"/>\n                        </div>\n                    </div>\n                </div>\n                <div ng-show=\"vm.editForm.discharge_left_{{child.code}}.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_left_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_left_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                       translate-value-max=\"255\">\n                        This field cannot be longer than 255 characters.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </td></script><!-- other-objective-testing-row --><script type=\"text/ng-template\" id=\"other-objective-testing-row-template\"><td>\n        <input type=\"checkbox\"\n               id=\"checkbox_{{child.code}}\"\n               name=\"checkbox_{{child.code}}\"\n               ng-disabled=\"vm.isDisabled\"\n               ng-change=\"vm.updateOtherObjective(child)\"\n               ng-model=\"child.checked\"/>\n\n        <span ng-click=\"!(vm.isDisabled) && vm.deleteOtherObjectives(child)\" class=\"glyphicon glyphicon-minus glyphicon-lightred other-remove\"></span>\n    </td>\n    <td>\n        <div class=\"col-v4 pl-0\">\n            <div class=\"row-v4 justify-content-md-center\">\n                <div class=\"col-v4\">\n                    <div>\n                        <input type=\"text\" class=\"form-control\"\n                            id=\"name_{{child.code}}\" name=\"name_{{child.code}}\"\n                            ng-model=\"child.name\"\n                            ng-required=\"child.checked\"\n                            ng-disabled=\"vm.isDisabled\"\n                            check-maxlength=\"255\"/>\n                    </div>\n                    <div ng-show=\"vm.editForm.name_{{child.code}}.$dirty\">\n                        <p class=\"help-block\"\n                           ng-show=\"vm.editForm.name_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                        <p class=\"help-block\"\n                           ng-show=\"vm.editForm.name_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                           translate-value-max=\"255\">\n                            This field cannot be longer than 255 characters.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </td>\n    <td>\n        <!-- normal-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'normal-input\'\" ng-if=\"child.type === \'NORMAL_TEXT_FIELD\'\"></div>\n\n        <!-- left-right-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'left-right-input\'\" ng-if=\"child.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div>\n    </td>\n    <td ng-repeat=\"ms in child.midsessions track by $index\">\n        <!-- ms-normal-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'ms-normal-input\'\" ng-if=\"child.type === \'NORMAL_TEXT_FIELD\'\"></div>\n\n        <!-- ms-left-right-input -->\n        <div class=\"col-v4 pl-0\" ng-include=\"\'ms-left-right-input\'\" ng-if=\"child.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div>\n    </td>\n    <td>\n        <div class=\"row-v4 justify-content-md-center\" ng-if=\"child.type === \'NORMAL_TEXT_FIELD\'\">\n            <div class=\"col-v4\">\n                <div>\n                    <input type=\"text\" class=\"form-control\"\n                        id=\"discharge_{{child.code}}\" name=\"discharge_{{child.code}}\"\n                        ng-disabled=\"vm.isDisabled\"\n                        ng-model=\"child.discharge\"\n                        ng-required=\"child.checked && vm.checkRequiredFieldDischarge()\"\n                        check-maxlength=\"255\"/>\n                </div>\n                <div ng-show=\"vm.editForm.discharge_{{child.code}}.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                       translate-value-max=\"255\">\n                        This field cannot be longer than 255 characters.\n                    </p>\n                </div>\n            </div>\n        </div>\n        <div class=\"row-v4\" ng-if=\"child.type === \'LEFT_RIGHT_TEXT_FIELD\'\">\n            <!--RIGHT-->\n            <div class=\"col-v4-6\">\n                <div class=\"\">\n                    <div class=\"form-row-v4\">\n                        <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                            <span>R</span>\n                        </div>\n                        <div class=\"col-v4\">\n                            <input type=\"text\" class=\"form-control\"\n                                   id=\"discharge_right_{{child.code}}\" name=\"discharge_right_{{child.code}}\"\n                                   ng-disabled=\"vm.isDisabled\"\n                                   ng-model=\"child.dischargeRight\"\n                                   ng-required=\"child.checked\"\n                                   check-maxlength=\"255\"/>\n                        </div>\n                    </div>\n                </div>\n                <div ng-show=\"vm.editForm.discharge_right_{{child.code}}.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_right_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_right_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                       translate-value-max=\"255\">\n                        This field cannot be longer than 255 characters.\n                    </p>\n                </div>\n            </div>\n            <!--LEFT-->\n            <div class=\"col-v4-6\">\n                <div class=\"\">\n                    <div class=\"form-row-v4\">\n                        <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                            <span>L</span>\n                        </div>\n                        <div class=\"col-v4\">\n                            <input type=\"text\" class=\"form-control\"\n                                   id=\"discharge_left_{{child.code}}\" name=\"discharge_left_{{child.code}}\"\n                                   ng-disabled=\"vm.isDisabled\"\n                                   ng-model=\"child.dischargeLeft\"\n                                   ng-required=\"child.checked\" check-maxlength=\"255\"/>\n                        </div>\n                    </div>\n                </div>\n                <div ng-show=\"vm.editForm.discharge_left_{{child.code}}.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_left_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.discharge_left_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                       translate-value-max=\"255\">\n                        This field cannot be longer than 255 characters.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </td></script><!-- physical-functional-narrative --><script type=\"text/ng-template\" id=\"physical-functional-narrative-template\"><form name=\"vm.editForm\" role=\"form\" novalidate>\n        <div class=\"col-v4-md-12\">\n            <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n                <div class=\"col-v4-md-auto\">\n                    <h4 class=\"primary title\">\n                        {{\'ipmApp.frpReport.pt.physicalFunctionalNarrative\' | translate}}\n                        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                    </h4>\n                </div>\n                <div class=\"col-v4-md-auto\">\n                    <template-select\n                        is-disabled=\"vm.isDisabled\"\n                        templates=\"vm.templates\"\n                        report=\"vm.report.physicalFunctionalNarrative\"\n                        input-type=\"vm.templateInputType.PHYSICAL_FUNCTIONAL_NARRATIVE\"\n                        option=\"vm.report.physicalFunctionalNarrativeTemplate\"\n                        control-title-key=\"\'ipmApp.frpReport.pt.physicalFunctionalNarrative\'\">\n                    </template-select>\n                </div>\n            </div>\n            <div class=\"form-group\">\n            <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"physical_functional_narrative\" id=\"physical_functional_narrative\"\n                      ng-model=\"vm.report.physicalFunctionalNarrative\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n            </textarea>\n                <div ng-show=\"vm.editForm.physical_functional_narrative.$dirty\">\n                    <p class=\"help-block\"\n                       ng-show=\"vm.editForm.physical_functional_narrative.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </form></script><!-- normal-input --><script type=\"text/ng-template\" id=\"normal-input\"><div class=\"row-v4 justify-content-md-center\">\n        <div class=\"col-v4\">\n            <div class=\"\">\n                <input type=\"text\" class=\"form-control\"\n                       id=\"input_{{child.code}}\" name=\"input_{{child.code}}\"\n                       ng-disabled=\"vm.isDisabled\"\n                       ng-model=\"child.value\"\n                       ng-required=\"child.checked && vm.checkRequiredFieldScore() && !vm.isAverage(child)\" check-maxlength=\"255\"/>\n            </div>\n            <div ng-show=\"vm.editForm.input_{{child.code}}.$dirty\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.input_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.input_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"255\">\n                    This field cannot be longer than 255 characters.\n                </p>\n            </div>\n        </div>\n    </div></script><!-- left-right-input --><script type=\"text/ng-template\" id=\"left-right-input\"><div class=\"row-v4\">\n        <!--RIGHT-->\n        <div class=\"col-v4-6\">\n            <div class=\"\">\n                <div class=\"form-row-v4\">\n                    <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                        <span>R</span>\n                    </div>\n                    <div class=\"col-v4\">\n                        <input type=\"text\" class=\"form-control\"\n                               id=\"right_input_{{child.code}}\"  name=\"right_input_{{child.code}}\"\n                               ng-change=\"vm.calculatorLR(objective)\"\n                               ng-disabled=\"vm.isDisabled || vm.isAverage(child)\"\n                               ng-model=\"child.rightValue\"\n                               ng-required=\"child.checked && vm.checkRequiredFieldScore() && !vm.isAverage(child)\"\n                               check-maxlength=\"255\"/>\n                    </div>\n                </div>\n            </div>\n            <div ng-show=\"vm.editForm.right_input_{{child.code}}.$dirty\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.right_input_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.right_input_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"255\">\n                    This field cannot be longer than 255 characters.\n                </p>\n            </div>\n        </div>\n        <!--LEFT-->\n        <div class=\"col-v4-6\">\n            <div class=\"\">\n                <div class=\"form-row-v4\">\n                    <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                        <span>L</span>\n                    </div>\n                    <div class=\"col-v4\">\n                        <input type=\"text\" class=\"form-control\"\n                               id=\"left_input_{{child.code}}\" name=\"left_input_{{child.code}}\"\n                               ng-change=\"vm.calculatorLR(objective)\"\n                               ng-disabled=\"vm.isDisabled || vm.isAverage(child)\"\n                               ng-model=\"child.leftValue\"\n                               ng-required=\"child.checked && vm.checkRequiredFieldScore() && !vm.isAverage(child)\"\n                               check-maxlength=\"255\"/>\n                    </div>\n                </div>\n            </div>\n            <div ng-show=\"vm.editForm.left_input_{{child.code}}.$dirty\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.left_input_{{child.code}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.left_input_{{child.code}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"255\">\n                    This field cannot be longer than 255 characters.\n                </p>\n            </div>\n        </div>\n    </div></script><!-- ms-normal-input --><script type=\"text/ng-template\" id=\"ms-normal-input\"><div class=\"row-v4 justify-content-md-center\">\n        <div class=\"col-v4\">\n            <div class=\"\">\n                <input type=\"text\" class=\"form-control\"\n                        id=\"{{child.code}}_midsession_{{$index}}\" name=\"{{child.code}}_midsession_{{$index}}\"\n                        ng-disabled=\"vm.checkDisableColMidsessions($index, child.midsessions)\"\n                        check-maxlength=\"50\"\n                        ng-model=\"ms.testScore\" ng-required=\"child.checked && vm.checkRequiredColMidsessions($index, child.midsessions) && !vm.isAverage(child)\" />\n            </div>\n            <div ng-show=\"vm.editForm.{{child.code}}_midsession_{{$index}}.$dirty\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.{{child.code}}_midsession_{{$index}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.{{child.code}}_midsession_{{$index}}.$error.maxlength\"\n                   translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n    </div></script><!-- ms-left-right-input --><script type=\"text/ng-template\" id=\"ms-left-right-input\"><div class=\"row-v4\">\n        <!--RIGHT-->\n        <div class=\"col-v4-6\">\n            <div class=\"\">\n                <div class=\"form-row-v4\">\n                    <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                        <span>R</span>\n                    </div>\n                    <div class=\"col-v4\">\n                        <input type=\"text\" class=\"form-control\"\n                                id=\"{{child.code}}_midsession_right_{{$index}}\" name=\"{{child.code}}_midsession_right_{{$index}}\"\n                                ng-change=\"vm.calculatorLR(objective)\"\n                                check-maxlength=\"50\"\n                                ng-disabled=\"vm.checkDisableColMidsessions($index, child.midsessions) || vm.isAverage(child)\"\n                                ng-model=\"ms.testScoreRight\" ng-required=\"child.checked && vm.checkRequiredColMidsessions($index, child.midsessions) && !vm.isAverage(child)\" />\n                    </div>\n                </div>\n            </div>\n            <div ng-show=\"vm.editForm.{{child.code}}_midsession_right_{{$index}}.$dirty\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.{{child.code}}_midsession_right_{{$index}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.{{child.code}}_midsession_right_{{$index}}.$error.maxlength\"\n                   translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <!--LEFT-->\n        <div class=\"col-v4-6\">\n            <div class=\"\">\n                <div class=\"form-row-v4\">\n                    <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                        <span>L</span>\n                    </div>\n                    <div class=\"col-v4\">\n                        <input type=\"text\" class=\"form-control\"\n                                id=\"{{child.code}}_midsession_left_{{$index}}\" name=\"{{child.code}}_midsession_left_{{$index}}\"\n                                ng-change=\"vm.calculatorLR(objective)\"\n                                check-maxlength=\"50\"\n                                ng-disabled=\"vm.checkDisableColMidsessions($index, child.midsessions) || vm.isAverage(child)\"\n                                ng-model=\"ms.testScoreLeft\" ng-required=\"child.checked && vm.checkRequiredColMidsessions($index, child.midsessions) && !vm.isAverage(child)\" />\n                    </div>\n                </div>\n            </div>\n            <div ng-show=\"vm.editForm.{{child.code}}_midsession_left_{{$index}}.$dirty\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.{{child.code}}_midsession_left_{{$index}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.editForm.{{child.code}}_midsession_left_{{$index}}.$error.maxlength\"\n                   translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/frp-mde/frp-report/ptp/frp-report-ptp.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.frpReport.ptp.title\'\" report=\"vm.dataHeaderReport\"></header-report><form name=\"vm.editForm\" role=\"form\" novalidate><div class=\"form-group\"><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title mt-4 mb-4\" translate=\"ipmApp.frpReport.ptp.medicalSummary\">Medical Summary</h4><h4 class=\"primary title ml-1\">{{\'ipmApp.frpReport.ptp.general\' | translate}}</h4></div><div class=\"col-v4-md-auto\"><template-select is-disabled=\"vm.isDisabled\" templates=\"vm.templates\" report=\"vm.report.general\" option=\"vm.report.generalTemplate\" input-type=\"vm.templateInputType.GENERAL\" control-title-key=\"\'ipmApp.frpReport.ptp.general\'\"></template-select></div></div><div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"general\" id=\"general\" ng-model=\"vm.report.general\" ng-disabled=\"vm.isDisabled\">\n						        </textarea></div></div></div></div><div><h4 class=\"primary title ml-1\" translate=\"ipmApp.frpReport.ptp.medicationUpdate\">Medication Update</h4><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"medicationUpdate\" id=\"medicationUpdate\" ng-model=\"vm.report.medicationUpdate\" ng-disabled=\"vm.isDisabled\">\n						</textarea></div></div><div class=\"mt-4\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"vm.isDisabled || vm.isSaving || !vm.isChanged()\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" ng-disabled=\"vm.isDisabled || vm.isSaving || (vm.isFinalize && !vm.isChanged())\" class=\"btn btn-primary\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">Finalize</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form></div></div></div>");
$templateCache.put("app/frp-mde/mde-report/addendum/mde-report-addendum.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><div class=\"row-v4\"><div class=\"col-v4-md-6\"><h3 class=\"primary title my-3 text-left\"><span translate=\"ipmApp.mdeReport.addendum.title\">MDE - Report Builder - Addendum</span></h3></div></div><form name=\"vm.editForm\" role=\"form\" novalidate><div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"form-group\"><div><h4 class=\"primary title\"><span>{{\'ipmApp.mdeReport.addendum.addendum\' | translate}}</span></h4></div><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"addendum\" id=\"addendum\" ng-model=\"vm.mdeReport.mdeReportAddendum.addendum\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.isRequired\">\n                        </textarea><div ng-show=\"vm.editForm.addendum.$dirty && vm.editForm.addendum.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.addendum.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"mt-4\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || !vm.isChanged() || vm.isView\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></div></div></form></div></div></div>");
$templateCache.put("app/frp-mde/mde-report/admin/mde-report-admin.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><form name=\"vm.editForm\" role=\"form\" novalidate><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.mdeReport.admin.title\'\" is-show-mde-office=\"true\" report=\"vm.dataHeaderReport\"></header-report><div class=\"row mt-4\"><div class=\"col-md-12\"><span class=\"h4 title\">{{\'ipmApp.mdeReport.admin.assignedTeam\' | translate}}</span></div><div class=\"col-md-2\"><label class=\"control-label\" translate=\"ipmApp.mdeReport.admin.table.admin\">admin</label><select class=\"form-control\" name=\"admin\" id=\"admin\" ng-model=\"vm.admin.mdeReportAdminUserId\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.adminUsers | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select></div><div class=\"form-group col-md-2\"><label class=\"control-label\"><span>{{\'ipmApp.mdeReport.admin.table.medical\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><select class=\"form-control\" name=\"medical\" id=\"medical\" ng-model=\"vm.admin.mdeReportMedicalUserId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.editForm.medical.$dirty && vm.editForm.medical.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.medical.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-2\"><label class=\"control-label\"><span>{{\'ipmApp.mdeReport.admin.table.pt\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><select class=\"form-control\" name=\"pt\" id=\"pt\" ng-model=\"vm.admin.mdeReportPTUserId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.editForm.pt.$dirty && vm.editForm.pt.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.pt.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-2\"><label class=\"control-label\"><span>{{\'ipmApp.mdeReport.admin.table.psych\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><select class=\"form-control\" name=\"psych\" id=\"psych\" ng-model=\"vm.admin.mdeReportPsychUserId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.editForm.psych.$dirty && vm.editForm.psych.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.psych.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-md-2\"><label class=\"control-label\" translate=\"ipmApp.mdeReport.admin.table.conclusion\">conclusion</label><select class=\"form-control\" name=\"conclusion\" id=\"conclusion\" ng-model=\"vm.admin.mdeReportConclusionUserId\" ng-disabled=\"vm.isDisabled\" ng-options=\"user.userId as (user.lastName + \', \' + user.firstName) for user in vm.users | orderBy:[\'lastName\', \'firstName\'] : false\"><option value=\"\" selected=\"selected\"></option></select></div></div><div class=\"row mt-4\"><div class=\"col-sm-3\"><span class=\"h4 title\">{{\'ipmApp.mdeReport.admin.dateOfService\' | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-sm-2 date-of-service-picker form-group\"><div class=\"input-group\"><input ng-disabled=\"vm.isDisabled\" name=\"dateOfService\" id=\"dateOfService\" type=\"text\" class=\"form-control\" required uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"dateRequestOptions\" ng-model=\"vm.admin.dateOfService\" is-open=\"vm.datePickerOpenStatus.dateOfService\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateOfService\')\"></span></div></div><div ng-show=\"vm.editForm.dateOfService.$dirty && vm.editForm.dateOfService.$invalid\"><p class=\"help-block\" ng-show=\"vm.editForm.dateOfService.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"row mt-4\"><div class=\"col-md-2\"><span class=\"h4\">{{\'ipmApp.mdeReport.admin.patientDetail\' | translate}}</span></div><div class=\"col-md-4\" ng-if=\"!vm.submitted\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.submitButton()\" disabled=\"disabled\"><span>{{\'ipmApp.mdeReport.admin.requestUpdateFromIMS\' | translate}}</span></button></div><div class=\"col-md-4\" ng-if=\"vm.submitted\"><span>Update pending at 3:45PM on 2/26/2022</span></div><div class=\"col-md-4\" ng-if=\"vm.submitted\"><button type=\"button\" class=\"btn btn-link primary\" ng-click=\"vm.submitButton()\"><span>{{\'ipmApp.mdeReport.admin.cancelRequest\' | translate}}</span></button></div></div><div class=\"mt-4\"><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.address\' | translate}}</span><div class=\"col-sm-3\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"street\" placeholder=\"Street\" ng-model=\"vm.admin.streetAddress\"></div><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"city\" placeholder=\"City\" ng-model=\"vm.admin.city\"></div><div class=\"col-sm-1\"><select ng-disabled=\"vm.isDisabled\" class=\"form-control\" name=\"state_field\" id=\"state\" ng-model=\"vm.admin.state\" ng-options=\"state for state in vm.states\"><option value=\"\" selected=\"selected\"></option></select></div><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"zipCode\" placeholder=\"Zip Code\" ng-model=\"vm.admin.zipCode\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.race\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"race\" ng-model=\"vm.admin.race\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.gender\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"gender\" ng-model=\"vm.admin.gender\"></div></div></div><div class=\"row mt-4\"><div class=\"col-md-2\"><span class=\"h4\">{{\'ipmApp.mdeReport.admin.caseDetail\' | translate}}</span></div></div><div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.injuryDate\' | translate}}</span><div class=\"col-sm-2\"><div class=\"input-group\"><input ng-disabled=\"vm.isDisabled\" name=\"daterequested\" id=\"field_dateRequested\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"dateRequestOptions\" ng-model=\"vm.admin.injuryDate\" is-open=\"vm.datePickerOpenStatus.dateRequested\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateRequested\')\"></span></div></div></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.caseInsurance\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"caseInsurance\" ng-model=\"vm.admin.caseInsurance\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.authorizedBodyPart\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"employer\" ng-model=\"vm.admin.authorizedBodyPart\"></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.claimNumber\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"claimNumber\" ng-model=\"vm.admin.claimNumber\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.employer\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"employer\" ng-model=\"vm.admin.employer\"></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.nurseCaseManager\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"nurseCaseManager\" ng-model=\"vm.admin.nurseCaseManager\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.jobTitle\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"jobTitle\" ng-model=\"vm.admin.jobTitle\"></div><div class=\"col-sm-2\"></div><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.applicantAttorney\' | translate}}</span><div class=\"col-sm-2\"><input ng-disabled=\"vm.isDisabled\" type=\"text\" class=\"form-control\" name=\"applicantAttorney\" ng-model=\"vm.admin.applicantAttorney\"></div></div><div class=\"form-group row\"><span class=\"col-sm-2\">{{\'ipmApp.mdeReport.admin.clinicalTeam\' | translate}}</span><div class=\"col-sm-2\"><input name=\"clinicalTeam\" id=\"clinicalTeam\" type=\"text\" class=\"form-control\" ng-model=\"vm.admin.clinicalTeam\" ng-disabled=\"vm.isDisabled\"></div></div></div><div class=\"row mt-4\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.save()\" ng-disabled=\"vm.isDisabled || !vm.isChanged() || vm.isView\"><span>{{\'entity.action.save\' | translate}}</span></button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.final()\" ng-disabled=\"(vm.admin.status === \'COMPLETE\' && !vm.isChanged())  || vm.isDisabled || vm.isView\"><span>{{\'ipmApp.mdeReport.admin.finalize\' | translate}}</span></button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.checkCancel(vm.isChanged() && !vm.isDisabled)\"><span>{{\'entity.action.cancel\' | translate}}</span></button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.confirmDialog(vm.abandonedMessage, vm.updateAdminAbandoned)\" ng-disabled=\"vm.isDisabled || vm.isView\"><span>{{\'ipmApp.mdeReport.admin.mdeAbandoned\' | translate}}</span></button></div></div></form></div></div></div>");
$templateCache.put("app/frp-mde/mde-report/conclusion/mde-report-conclusion.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.report\"><jhi-alert></jhi-alert><div class=\"row-v4\"><div class=\"col-v4-md-6\"><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.mdeReport.conclusion.title\'\" is-show-mde-office=\"true\" report=\"vm.dataHeaderReport\"></header-report></div></div><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title ml-1\">{{\'ipmApp.mdeReport.conclusion.conclusion\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select templates=\"vm.templates\" report=\"vm.report.conclusion\" option=\"vm.report.conclusionTemplate\" input-type=\"vm.templateInputType.CONCLUSION\" control-title-key=\"\'ipmApp.mdeReport.conclusion.conclusion\'\" is-disabled=\"vm.isDisabled\"></template-select></div></div><form name=\"vm.editForm\" role=\"form\" novalidate><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" id=\"field_conclusion\" name=\"field_conclusion\" ng-model=\"vm.report.conclusion\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n                    </textarea><div ng-show=\"vm.editForm.field_conclusion.$dirty\"><p class=\"help-block\" ng-show=\"vm.editForm.field_conclusion.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group mb-0\"><h4 class=\"primary title ml-1\">{{\'ipmApp.mdeReport.conclusion.whatTreatment\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4><select class=\"form-control\" id=\"field_frp\" name=\"field_frp\" ng-model=\"vm.report.frp\" ng-change=\"vm.frpChange()\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\" ng-options=\"item as \'ipmApp.mdeReport.conclusion.questionFrp.\'+item | translate for item in [\'FRP\', \'WORK_HARDENING\', \'CONSERVATIVE_CARE\', \'OTHER\']\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.editForm.field_frp.$dirty\"><p class=\"help-block\" ng-show=\"vm.editForm.field_frp.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-v4-md-6\" ng-if=\"vm.report.frp === \'FRP\'\"><h4 class=\"primary title ml-1\" for=\"field_hours\">{{\'ipmApp.mdeReport.conclusion.hours\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4><select class=\"form-control\" id=\"field_hours\" name=\"hours\" ng-model=\"vm.report.hours\" ng-disabled=\"vm.isDisabled\" ng-options=\"item as \'ipmApp.mdeReport.conclusion.questionHours.\'+item | translate for item in [\'MDE_HOURS_180\', \'MDE_HOURS_80\']\" required><option value=\"MDE_HOURS_180\" selected=\"selected\"></option></select></div><div class=\"col-v4-md-6 form-group\" ng-if=\"vm.report.frp === \'OTHER\' || vm.report.frp === \'CONSERVATIVE_CARE\'\"><h4 class=\"primary title ml-1\" for=\"field_hours\">{{\'ipmApp.mdeReport.conclusion.description\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4><input id=\"field_description\" name=\"field_description\" ng-model=\"vm.report.treatmentContent\" class=\"form-control\" ng-disabled=\"vm.isDisabled\" ng-required=\"true\"><div ng-show=\"vm.editForm.field_description.$dirty\"><p class=\"help-block\" ng-show=\"vm.editForm.field_description.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></form><div class=\"mt-4\"><button type=\"submit\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || vm.isDisabled || !vm.isChange() || vm.isView\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.isSaving || vm.isDisabled || (vm.report.status === \'COMPLETE\' && !vm.isChange()) || vm.isView\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">Save For Later</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Submit</span></button></div></div></div></div>");
$templateCache.put("app/frp-mde/mde-report/home/mde-report-home.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.mdeReport.home.title\'\" is-show-mde-office=\"true\" report=\"vm.dataHeaderReport\"></header-report><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped table-hover mb-0\"><thead><tr><th>{{\'ipmApp.mdeReport.home.table.role\' | translate}}</th><th>{{\'ipmApp.mdeReport.home.table.assignedTo\' | translate}}</th><th>{{\'ipmApp.mdeReport.home.table.status\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports track by $index\"><td>{{\'ipmApp.mdeReport.home.table.\' +report.role | translate}}</td><td ng-if=\"report.assignedTo\"><span ng-if=\"report.role !== \'ADDENDUM\'\">{{report.assignedTo}}</span></td><td ng-if=\"!report.assignedTo\"><span ng-if=\"report.role !== \'ADDENDUM\'\">{{\'ipmApp.mdeReport.home.table.unassigned\' | translate}}</span></td><td>{{\'ipmApp.mdeReport.home.status.\' + report.status| translate}}</td><td class=\"text-right\"><button type=\"submit\" ng-if=\"(!vm.isView || report.role === \'ADDENDUM\') && !vm.mdeReport.patientFRPMDE.isViewFrpProgram\" ng-click=\"vm.editPage(report.role)\" class=\"btn btn-primary btn-sm\"><span translate=\"entity.action.edit\" ng-if=\"report.status !== \'NOT_STARTED\'\"></span> <span translate=\"ipmApp.mdeReport.home.start\" ng-if=\"report.status === \'NOT_STARTED\'\"></span></button> <button type=\"submit\" ng-if=\"(vm.isView && report.role !== \'ADDENDUM\') || vm.mdeReport.patientFRPMDE.isViewFrpProgram\" ng-click=\"vm.viewPage(report.role)\" class=\"btn btn-primary btn-sm\"><span translate=\"entity.action.view\"></span></button></td></tr><tr class=\"not-hover\"><td colspan=\"2\" class=\"pt-5 pl-0\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"frp-mde({tab:1})\"><span translate=\"entity.action.back\">Back</span></button></td><td colspan=\"2\" class=\"pt-5\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.finalAndSignOffClick()\" ng-if=\"vm.checkCompletedAllReport() && !vm.isView\" ng-disabled=\"!vm.checkCompletedAllReport()\"><span>{{\'entity.action.finalAndSignOff\' | translate}}</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.preview()\"><span translate=\"entity.action.previewReport\">Preview Report</span></button></td></tr></tbody><tbody ng-if=\"false\"><tr><td colspan=\"6\"><p ng-if=\"!vm.isLoading\"><span translate=\"ipmApp.patient.mdeReport.home.required\">We couldn\'t find any FRP/MDE report.</span></p></td></tr></tbody></table></div><div class=\"row mt-15px\" ng-if=\"!vm.reports\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"frp-mde({tab:1})\"><span translate=\"entity.action.back\">Back</span></button></div></div></div></div></div>");
$templateCache.put("app/frp-mde/mde-report/psych/mde-report-psych.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.report\"><jhi-alert></jhi-alert><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.mdeReport.psych.title\'\" is-show-mde-office=\"true\" report=\"vm.dataHeaderReport\"></header-report><form name=\"vm.psychReportForm\" role=\"form\" novalidate><!-- Pyschosocial History --><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title\">{{\'ipmApp.mdeReport.psych.psychosocialHistory\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select is-disabled=\"vm.isDisabled\" templates=\"vm.templates\" report=\"vm.report.pyschosocialHistory\" option=\"vm.report.pyschosocialHistoryTemplate\" input-type=\"vm.templateInputType.PYSCHOSOCIAL_HISTORY\" control-title-key=\"\'ipmApp.mdeReport.psych.psychosocialHistory\'\"></template-select></div></div><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"pyschosocialHistory\" id=\"pyschosocialHistory\" ng-model=\"vm.report.pyschosocialHistory\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n                    </textarea><div ng-show=\"vm.psychReportForm.pyschosocialHistory.$dirty\"><p class=\"help-block\" ng-show=\"vm.psychReportForm.pyschosocialHistory.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- Subjective Complaints and History --><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title\">{{\'ipmApp.mdeReport.psych.subjectiveComplaints\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select is-disabled=\"vm.isDisabled\" templates=\"vm.templates\" report=\"vm.report.subjectiveComplaints\" option=\"vm.report.subjectiveComplaintsTemplate\" input-type=\"vm.templateInputType.SUBJECTIVE_COMPLAINTS_PSYCH\" control-title-key=\"\'ipmApp.mdeReport.psych.subjectiveComplaints\'\"></template-select></div></div><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"subjectiveComplaints\" id=\"subjectiveComplaints\" ng-model=\"vm.report.subjectiveComplaints\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n                    </textarea><div ng-show=\"vm.psychReportForm.subjectiveComplaints.$dirty\"><p class=\"help-block\" ng-show=\"vm.psychReportForm.subjectiveComplaints.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- Mental Status --><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title\">{{\'ipmApp.mdeReport.psych.mentalStatus\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select is-disabled=\"vm.isDisabled\" templates=\"vm.templates\" report=\"vm.report.mentalStatus\" option=\"vm.report.mentalStatusTemplate\" input-type=\"vm.templateInputType.MENTAL_STATUS\" control-title-key=\"\'ipmApp.mdeReport.psych.mentalStatus\'\"></template-select></div></div><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"mentalStatus\" id=\"mentalStatus\" ng-model=\"vm.report.mentalStatus\" ng-disabled=\"vm.isDisabled\" ng-required=\"true\">\n                    </textarea><div ng-show=\"vm.psychReportForm.mentalStatus.$dirty\"><p class=\"help-block\" ng-show=\"vm.psychReportForm.mentalStatus.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- Psychological Sequelae of Work Injury --><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.psych.psychologicalSequelaeOfWorkInjury\">Psychological Sequelae of Work Injury</h4><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"psychologicalSequelaeOfWorkInjury\" id=\"psychologicalSequelaeOfWorkInjury\" ng-model=\"vm.report.psychologicalSequelaeOfWorkInjury\" ng-disabled=\"vm.isDisabled\">\n                    </textarea></div><!-- Psych Testing --><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.psych.psychTesting\">Psych Testing</h4><!-- Subjective Testing --><div ng-include=\"\'subjective\'\"></div><!-- Objective Testing --><div ng-include=\"\'objective\'\"></div><!-- Psychological Goals of Treatment --><div ng-include=\"\'goals\'\"></div><!-- Psychiatric Diagnosis --><h4 class=\"primary title mt-4\" translate=\"ipmApp.mdeReport.psych.psychiatricDiagnosis\">Psychiatric Diagnosis</h4><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"psychiatricDiagnosis\" id=\"psychiatricDiagnosis\" ng-model=\"vm.report.psychiatricDiagnosis\" ng-disabled=\"vm.isDisabled\">\n                    </textarea></div><!-- Psychological Goals of Treatment Narrative --><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title\">{{\'ipmApp.mdeReport.psych.psychologicalGoalsOfTreatmentNarrative\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select templates=\"vm.templates\" report=\"vm.report.psychologicalGoalsOfTreatment\" option=\"vm.report.psychologicalGoalsOfTreatmentTemplate\" input-type=\"vm.templateInputType.PSYCHOLOGICAL_GOALS_OF_TREATMENT\" control-title-key=\"\'ipmApp.mdeReport.psych.psychologicalGoalsOfTreatmentNarrative\'\" is-disabled=\"vm.isDisabled\"></template-select></div></div><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"psychologicalGoalsOfTreatment\" id=\"psychologicalGoalsOfTreatment\" ng-model=\"vm.report.psychologicalGoalsOfTreatment\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n                    </textarea><div ng-show=\"vm.psychReportForm.psychologicalGoalsOfTreatment.$dirty\"><p class=\"help-block\" ng-show=\"vm.psychReportForm.psychologicalGoalsOfTreatment.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- Summary and Impressions --><div class=\"row-v4 justify-content-between align-items-center pb-1\"><div class=\"col-v4-md-auto\"><h4 class=\"primary title\">{{\'ipmApp.mdeReport.psych.summaryAndImpressions\' | translate}} <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h4></div><div class=\"col-v4-md-auto\"><template-select templates=\"vm.templates\" report=\"vm.report.summaryAndImpressions\" option=\"vm.report.summaryAndImpressionsTemplate\" input-type=\"vm.templateInputType.SUMMARY_AND_IMPRESSIONS\" control-title-key=\"\'ipmApp.mdeReport.psych.summaryAndImpressions\'\" is-disabled=\"vm.isDisabled\"></template-select></div></div><div class=\"form-group\"><textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"summaryAndImpressions\" id=\"summaryAndImpressions\" ng-model=\"vm.report.summaryAndImpressions\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n                    </textarea><div ng-show=\"vm.psychReportForm.summaryAndImpressions.$dirty\"><p class=\"help-block\" ng-show=\"vm.psychReportForm.summaryAndImpressions.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- Buttons --><div class=\"mt-4\"><button type=\"submit\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || vm.isDisabled || !vm.isChanged() || vm.isView\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.isSaving || vm.isDisabled || (vm.isFinalize && !vm.isChanged()) || vm.isView\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">Save For Later</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Submit</span></button></div></form></div></div></div><!-- Subjective Testing --><script type=\"text/ng-template\" id=\"subjective\"><h4 class=\"primary title\">\n        <span ng-class=\"{\'text-danger\':vm.psychReportForm.$submitted && (!vm.hasTestingChecked() || vm.hasItemCheckedInvalid())}\">{{\'ipmApp.mdeReport.psych.subjectiveTesting\' | translate}}</span>\n        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <div class=\"row-v4\">\n        <div class=\"col-v4-xl-2 col-md-3 col-v4-4\">\n            <span class=\"ml-4 pl-2\" translate=\"ipmApp.mdeReport.psych.test\"></span>\n        </div>\n        <div class=\"col-v4-xl-2 col-v4\">\n            <span translate=\"ipmApp.mdeReport.psych.score\"></span>\n        </div>\n        <div class=\"col-v4-xl-2 col-v4\">\n            <span translate=\"ipmApp.mdeReport.psych.classification\"></span>\n        </div>\n        <div class=\"col-v4-xl-4 col-v4\">\n            <span translate=\"ipmApp.mdeReport.psych.notes\"></span>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <select-all-checkbox item=\"vm.report\" is-disabled=\"vm.isDisabled\" report-type=\"vm.reportType.SUBJECTIVE\"></select-all-checkbox>\n        <div ng-repeat=\"subjective in vm.report.subjectives track by $index\">\n            <checkbox-row is-disabled=\"vm.isDisabled\" item=\"subjective\"\n                          on-change=\"vm.updateSelectAllCheckbox(vm.reportType.SUBJECTIVE)\"\n                          severity=\"vm.severitySubjectives\"\n                          type-row=\"\'subjectives\'\"></checkbox-row>\n        </div>\n    </div></script><!-- Objective Testing --><script type=\"text/ng-template\" id=\"objective\"><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.psych.objectiveTesting\">Objective Testing</h4>\n    <div class=\"row-v4\">\n        <div class=\"col-v4-xl-2 col-md-3 col-v4-4\">\n            <!-- <span class=\"ml-4 pl-2\" translate=\"ipmApp.mdeReport.psych.test\"></span> -->\n        </div>\n        <div class=\"col-v4-xl-2 col-v4\">\n            <span translate=\"ipmApp.mdeReport.psych.score\"></span>\n        </div>\n        <div class=\"col-v4-xl-2 col-v4\">\n            <span translate=\"ipmApp.mdeReport.psych.severity\"></span>\n        </div>\n        <div class=\"col-v4-xl-4 col-v4\">\n            <span translate=\"ipmApp.mdeReport.psych.notes\"></span>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <select-all-checkbox item=\"vm.report\" is-disabled=\"vm.isDisabled\" report-type=\"vm.reportType.OBJECTIVE\"></select-all-checkbox>\n        <div ng-repeat=\"objective in vm.report.objectives track by $index\">\n            <checkbox-row is-disabled=\"vm.isDisabled\" item=\"objective\"\n                          on-change=\"vm.updateSelectAllCheckbox(vm.reportType.OBJECTIVE)\"\n                          severity=\"vm.severityObjectives\"\n                          type-row=\"\'objectives\'\"></checkbox-row>\n        </div>\n    </div></script><!-- goals --><script type=\"text/ng-template\" id=\"goals\"><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.psych.psychologicalGoalsOfTreatment\">Psychological Goals of Treatment</h4>\n    <h4 class=\"primary title\">\n        <span ng-class=\"{\'text-danger\':vm.psychReportForm.$submitted && (!vm.hasTermGoalChecked(true) || vm.hasTermGoalCheckedInvalid(true))}\">{{\'ipmApp.mdeReport.psych.shortTermGoals\' | translate}}</span>\n        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <div ng-repeat=\"goal in vm.report.sortTermGoalResponses track by $index\">\n        <goal-row item=\"goal\" is-disabled=\"vm.isDisabled\" show-add-goal=\"vm.showAddGoal($last, false)\" on-click-add-new-goal=\"vm.addNewSortTermGoal()\"></goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.sortTermGoalAddNewResponses track by $index\">\n        <goal-add-new-row item=\"goal\" is-disabled=\"vm.isDisabled\" last-item=\"$last\" on-delete=\"vm.deleteSortTermGoalAddNew(data)\" on-click-add-new-goal=\"vm.addNewSortTermGoal()\" ng-if=\"goal.active\"></goal-add-new-row>\n    </div>\n\n    <h4 class=\"primary title mt-4\">\n        <span ng-class=\"{\'text-danger\':vm.psychReportForm.$submitted && (!vm.hasTermGoalChecked(false) || vm.hasTermGoalCheckedInvalid(false))}\">{{\'ipmApp.mdeReport.psych.longTermGoals\' | translate}}</span>\n        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <div ng-repeat=\"goal in vm.report.longTermGoalResponses track by $index\">\n        <goal-row item=\"goal\" is-disabled=\"vm.isDisabled\" show-add-goal=\"vm.showAddGoal($last, true)\" on-click-add-new-goal=\"vm.addNewLongTermGoal()\"></goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.longTermGoalAddNewResponses track by $index\">\n        <goal-add-new-row item=\"goal\" is-disabled=\"vm.isDisabled\" last-item=\"$last\" on-delete=\"vm.deleteLongTermGoalAddNew(data)\" on-click-add-new-goal=\"vm.addNewLongTermGoal()\" ng-if=\"goal.active\"></goal-add-new-row>\n    </div></script>");
$templateCache.put("app/frp-mde/mde-report/pt/mde-report-pt.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\" ng-if=\"vm.report\"><jhi-alert></jhi-alert><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.mdeReport.pt.title\'\" is-show-mde-office=\"true\" report=\"vm.dataHeaderReport\"></header-report><form name=\"vm.editForm\" role=\"form\" novalidate><!-- evaluation-details --><div ng-include=\"\'evaluation-details\'\"></div><!-- pt-testing --><div ng-include=\"\'pt-testing\'\"></div><!-- subjective --><div ng-include=\"\'subjective\'\"></div><!-- objective --><div ng-include=\"\'objective\'\"></div><!-- physical-demand-levels --><div ng-include=\"\'physical-demand-levels\'\"></div><!-- Physical/Functional Goals of Treatmen --><div ng-include=\"\'goals\'\"></div><!-- physical_functional_narrative --><div ng-include=\"\'physical_functional_narrative\'\"></div><!-- Buttons --><div class=\"mt-4\"><button type=\"submit\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || vm.isDisabled || !vm.isChanged() || vm.isView\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving || vm.isDisabled || (vm.isFinalize && !vm.isChanged()) || vm.isView\" class=\"btn btn-primary\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">Save For Later</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Submit</span></button></div></form></div></div></div><!-- evaluation-details --><script type=\"text/ng-template\" id=\"evaluation-details\"><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.pt.evaluationDetails\">Evaluation Details</h4>\n    <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n        <div class=\"col-v4-md-auto\">\n            <h4 class=\"primary title ml-1\">\n                {{\'ipmApp.mdeReport.pt.subjectiveComplaints\' | translate}}\n                <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n            </h4>\n        </div>\n        <div class=\"col-v4-md-auto\">\n            <template-select\n                templates=\"vm.templates\"\n                report=\"vm.report.subjectiveComplaints\"\n                option=\"vm.report.subjectiveComplaintsTemplate\"\n                input-type=\"vm.templateInputType.SUBJECTIVE_COMPLAINTS\"\n                control-title-key=\"\'ipmApp.mdeReport.pt.subjectiveComplaints\'\"\n                is-disabled=\"vm.isDisabled\">\n            </template-select>\n        </div>\n    </div>\n    <form name=\"vm.editForm\" role=\"form\" novalidate>\n        <div class=\"form-group\">\n            <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"subjective_complaints\" id=\"subjective_complaints\"\n                ng-model=\"vm.report.subjectiveComplaints\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n            </textarea>\n            <div ng-show=\"vm.editForm.subjective_complaints.$dirty\">\n                <p class=\"help-block\"\n                    ng-show=\"vm.editForm.subjective_complaints.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n    </form></script><!-- pt-testing --><script type=\"text/ng-template\" id=\"pt-testing\"><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.pt.ptTesting\">PT Testing</h4></script><!-- subjective --><script type=\"text/ng-template\" id=\"subjective\"><h4 class=\"primary title\">\n        <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasItemChecked(vm.report.subjectives) || vm.hasItemCheckedInvalid(vm.report.subjectives))}\">{{\'ipmApp.mdeReport.pt.subjective\' | translate}}</span>\n        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <div class=\"row-v4\">\n        <div class=\"col-v4-xl-2 col-md-3 col-v4-4\">\n            <span class=\"ml-4 pl-2\" translate=\"ipmApp.mdeReport.pt.test\"></span>\n        </div>\n        <div class=\"col-v4-xl-2 col-v4\">\n            <span translate=\"ipmApp.mdeReport.pt.score\"></span>\n        </div>\n        <div class=\"col-v4-xl-2 col-v4\">\n            <span translate=\"ipmApp.mdeReport.pt.classification\"></span>\n        </div>\n        <div class=\"col-v4-xl-4 col-v4\">\n            <span translate=\"ipmApp.mdeReport.pt.notes\"></span>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <select-all-checkbox item=\"vm.report\" is-disabled=\"vm.isDisabled\" report-type=\"vm.reportSubjectiveType\"></select-all-checkbox>\n        <div ng-repeat=\"subjective in vm.report.subjectives track by $index\">\n            <subjective-row item=\"subjective\" on-change=\"vm.updateSelectAllCheckboxSubjective()\" is-disabled=\"vm.isDisabled\"></subjective-row>\n        </div>\n    </div></script><!-- objective --><script type=\"text/ng-template\" id=\"objective\"><h4 class=\"primary title\">\n        <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasObjectiveChecked() || vm.hasObjectiveCheckedInvalid() || !vm.hasOtherObjectiveChecked() || vm.hasOtherCheckedInvalid())}\">{{\'ipmApp.mdeReport.pt.objective\' | translate}}</span>\n        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <div class=\"objective form-group\">\n        <div ng-repeat=\"objective in vm.report.objectives track by $index\">\n            <div class=\"objective-header\" ng-class=\"vm.hasChildCheckedNotCheckRom(objective) ? \'has-checked\' : \'\'\" ng-click=\"objective.isCollapsed = !objective.isCollapsed\">\n                <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasChildChecked(objective) || vm.hasChildCheckedInvalid(objective) || vm.hasOtherCheckedInvalid(objective))}\">{{\'ipmApp.mdeReport.pt.objectives.\' + objective.code | translate}}</span>\n                <span ng-if=\"vm.isChildRequired(objective)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                <span ng-class=\"{\'active\': !objective.isCollapsed}\" class=\"expand-icon\"></span>\n            </div>\n            <div class=\"objective-content\" uib-collapse=\"objective.isCollapsed\">\n                <objective-select-all item=\"objective\" others=\"vm.report.otherObjectives\" is-disabled=\"vm.isDisabled\"></objective-select-all>\n                <div ng-repeat=\"child in objective.childs track by $index\">\n                    <objective-row item=\"child\" is-disabled=\"vm.isDisabled\" on-change=\"vm.calculatorLR()\" on-click=\"vm.updateSelectAllCheckbox(objective)\"></objective-row>\n                </div>\n                <div ng-repeat=\"child in vm.report.otherObjectives track by $index\">\n                    <other-objective-row item=\"child\" is-disabled=\"vm.isDisabled\" ng-if=\"child.typeReportId == objective.typeReportId && child.active\" on-change=\"vm.updateSelectAllCheckbox(objective)\" on-delete=\"vm.deleteOtherObjectives(child)\"></other-objective-row>\n                </div>\n                <div class=\"add-other-objective mb-3\"><span ng-class=\"{\'disabled-button\': vm.isWeeklyReport || vm.isDisabled}\" ng-click=\"!(vm.isWeeklyReport || vm.isDisabled) && vm.addOtherObjective(objective)\">Add other</span></div>\n                <div class=\"row-v4 mb-3 mb-md-0 col-v4-12 col-form-label-v4\">\n                    <div><label>Notes: </label></div>\n                    <div class=\"col-v4-11\">\n                        <textarea class=\"form-control auto-height none-resize\" rows=\"2\"\n                                    id=\"field_objective_notes_{{$index}}\" name=\"field_objective_notes_{{$index}}\"\n                                    ng-disabled=\"vm.isWeeklyReport || vm.isDisabled\"\n                                    ng-model=\"objective.childs[0].notes\">\n                        </textarea>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!-- physical-demand-levels --><script type=\"text/ng-template\" id=\"physical-demand-levels\"><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.pt.physicalDemandLevels\">Physical Demand Levels</h4>\n    <div class=\"form-row-v4 justify-content-end\">\n        <div class=\"col-v4-xl-8 col-v4-md-6 col-v4-3\">\n            <span translate=\"ipmApp.mdeReport.pt.notes\"></span>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div ng-repeat=\"physicalDemandLevel in vm.report.physicalDemandLevels track by $index\">\n            <physical-demand-level-row item=\"physicalDemandLevel\" is-disabled=\"vm.isDisabled\"></physical-demand-level-row>\n        </div>\n    </div></script><!-- Physical Functional Narrative --><script type=\"text/ng-template\" id=\"physical_functional_narrative\"><div class=\"row-v4 justify-content-between align-items-center pb-1\">\n        <div class=\"col-v4-md-auto\">\n            <h4 class=\"primary title ml-1\">\n                {{\'ipmApp.mdeReport.pt.physicalFunctionalNarrative\' | translate}}\n                <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n            </h4>\n        </div>\n        <div class=\"col-v4-md-auto\">\n            <template-select\n                templates=\"vm.templates\"\n                report=\"vm.report.physicalFunctionalNarrative\"\n                option=\"vm.report.physicalFunctionalNarrativeTemplate\"\n                input-type=\"vm.templateInputType.PHYSICAL_FUNCTIONAL_NARRATIVE\"\n                control-title-key=\"\'ipmApp.mdeReport.pt.physicalFunctionalNarrative\'\"\n                is-disabled=\"vm.isDisabled\">\n            </template-select>\n        </div>\n    </div>\n    <form name=\"vm.editForm\" role=\"form\" novalidate>\n        <div class=\"form-group\">\n            <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"physical_functional_narrative\" id=\"physical_functional_narrative\"\n                ng-model=\"vm.report.physicalFunctionalNarrative\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\">\n            </textarea>\n            <div ng-show=\"vm.editForm.physical_functional_narrative.$dirty\">\n                <p class=\"help-block\"\n                    ng-show=\"vm.editForm.physical_functional_narrative.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n    </form></script><!-- goals --><script type=\"text/ng-template\" id=\"goals\"><h4 class=\"primary title\" translate=\"ipmApp.mdeReport.pt.physicalFunctionalGoalsOfTreatment\">Physical/Functional Goals of Treatment</h4>\n    <h4 class=\"primary title\">\n        <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasTermGoalChecked(true) || vm.hasTermGoalCheckedInvalid(true))}\">{{\'ipmApp.mdeReport.pt.shortTermGoals\' | translate}}</span>\n        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <div ng-repeat=\"goal in vm.report.sortTermGoalResponses track by $index\">\n        <goal-row item=\"goal\" is-disabled=\"vm.isDisabled\" show-add-goal=\"vm.showAddGoal($last, false)\" on-click-add-new-goal=\"vm.addNewSortTermGoal()\"></goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.sortTermGoalAddNewResponses track by $index\">\n        <goal-add-new-row item=\"goal\" is-disabled=\"vm.isDisabled\" last-item=\"$last\" on-delete=\"vm.deleteSortTermGoalAddNew(data)\" on-click-add-new-goal=\"vm.addNewSortTermGoal()\" ng-if=\"goal.active\"></goal-add-new-row>\n    </div>\n\n    <h4 class=\"primary title mt-4\">\n        <span ng-class=\"{\'text-danger\':vm.editForm.$submitted && (!vm.hasTermGoalChecked(false) || vm.hasTermGoalCheckedInvalid(false))}\">{{\'ipmApp.mdeReport.pt.longTermGoals\' | translate}}</span>\n        <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n    </h4>\n    <div ng-repeat=\"goal in vm.report.longTermGoalResponses track by $index\">\n        <goal-row item=\"goal\" is-disabled=\"vm.isDisabled\" show-add-goal=\"vm.showAddGoal($last, true)\" on-click-add-new-goal=\"vm.addNewLongTermGoal()\"></goal-row>\n    </div>\n    <div ng-repeat=\"goal in vm.report.longTermGoalAddNewResponses track by $index\">\n        <goal-add-new-row item=\"goal\" is-disabled=\"vm.isDisabled\" last-item=\"$last\" on-delete=\"vm.deleteLongTermGoalAddNew(data)\" on-click-add-new-goal=\"vm.addNewLongTermGoal()\" ng-if=\"goal.active\"></goal-add-new-row>\n    </div></script>");
$templateCache.put("app/frp-mde/mde-report/ptp/mde-report-ptp.html","<div class=\"page page--section\"><div class=\"container\"><div class=\"content\"><jhi-alert></jhi-alert><form name=\"vm.editForm\" role=\"form\" novalidate><div class=\"row-v4\"><div class=\"col-v4-md-6\"><header-report ng-if=\"vm.dataHeaderReport\" title-text-translate=\"\'ipmApp.mdeReport.ptp.title\'\" is-show-mde-office=\"true\" report=\"vm.dataHeaderReport\"></header-report><!-- history-of-present-illness --><div ng-include=\"\'history-of-present-illness\'\"></div><!--mechanism-of-injury--><div ng-include=\"\'mechanism-of-injury\'\"></div><div ng-include=\"\'present-complaints\'\"></div><!--medicalRecords--><div ng-include=\"\'medical-records\'\"></div><!--conservativeCare--><div ng-include=\"\'conservative-care\'\"></div><!--surgicalHistory--><div ng-include=\"\'surgical-history\'\"></div><!--Current Medication(s)--><div ng-include=\"\'current-medications\'\"></div><!--Vital Signs--><div ng-include=\"\'vital-signs\'\"></div><!--surgicalHistory--><div ng-include=\"\'summary-and-recommendations\'\"></div><div class=\"mt-4\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"vm.isSaving || !vm.isChanged() || vm.isView\" ng-click=\"vm.save()\"><span translate=\"entity.action.save\">Save</span></button> <button type=\"button\" ng-disabled=\"vm.isSaving || (vm.isFinalize && !vm.isChanged()) || vm.isView || vm.isDisabled\" class=\"btn btn-primary\" ng-click=\"vm.finalize()\"><span translate=\"entity.action.finalize\">finalize</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></div></div></form></div></div></div><!-- History of Present Illness --><script type=\"text/ng-template\" id=\"history-of-present-illness\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\">\n                    <span>{{\'ipmApp.mdeReport.ptp.historyofPresentIllness\' | translate}}</span>\n                    <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                </h4>\n            </div>\n            <div class=\"col-v4-md-auto\">\n                <template-select\n                    is-disabled=\"vm.isDisabled\"\n                    templates=\"vm.templates\"\n                    report=\"vm.mdeReport.mdeReportMediacal.historyofPresentIllness\"\n                    option=\"vm.mdeReport.mdeReportMediacal.historyofPresentIllnessTemplate\"\n                    input-type=\"vm.templateInputType.HISTORY_PRESENT_ILLNESS\"\n                    control-title-key=\"\'ipmApp.mdeReport.ptp.historyofPresentIllness\'\">\n                </template-select>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <div class=\"form-group\">\n                <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"historyofPresentIllness\"\n                          id=\"historyofPresentIllness\"\n                          ng-model=\"vm.mdeReport.mdeReportMediacal.historyofPresentIllness\"\n                          ng-disabled=\"vm.isDisabled\"\n                          ng-required=\"vm.isRequired\"\n                          >\n                </textarea>\n                    <div ng-show=\"vm.editForm.historyofPresentIllness.$dirty && vm.editForm.historyofPresentIllness.$invalid\">\n                        <p class=\"help-block\" ng-show=\"vm.editForm.historyofPresentIllness.$error.required\"\n                           translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    </div></script><!--Mechanism of Injury--><script type=\"text/ng-template\" id=\"mechanism-of-injury\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\">\n                    <span>{{\'ipmApp.mdeReport.ptp.mechanismOfInjury\' | translate}}</span>\n                    <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                </h4>\n            </div>\n            <div class=\"col-v4-md-auto\">\n                <template-select\n                    is-disabled=\"vm.isDisabled\"\n                    templates=\"vm.templates\"\n                    report=\"vm.mdeReport.mdeReportMediacal.mechanismOfInjury\"\n                    option=\"vm.mdeReport.mdeReportMediacal.mechanismOfInjuryTemplate\"\n                    input-type=\"vm.templateInputType.MECHANISM_INJURY\"\n                    control-title-key=\"\'ipmApp.mdeReport.ptp.mechanismOfInjury\'\">\n                </template-select>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <div class=\"form-group\">\n                <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"mechanismOfInjury\"\n                          id=\"mechanismOfInjury\"\n                          ng-model=\"vm.mdeReport.mdeReportMediacal.mechanismOfInjury\"\n                          ng-disabled=\"vm.isDisabled\"\n                          ng-required=\"vm.isRequired\"\n                          >\n                </textarea>\n                    <div ng-show=\"vm.editForm.mechanismOfInjury.$dirty && vm.editForm.mechanismOfInjury.$invalid\">\n                        <p class=\"help-block\" ng-show=\"vm.editForm.mechanismOfInjury.$error.required\"\n                           translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        </div>\n    </div></script><!--presentComplaints--><script type=\"text/ng-template\" id=\"present-complaints\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\">\n                    <span>{{\'ipmApp.mdeReport.ptp.presentComplaints\' | translate}}</span>\n                    <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                </h4>\n            </div>\n            <div class=\"col-v4-md-auto\">\n                <template-select\n                    is-disabled=\"vm.isDisabled\"\n                    templates=\"vm.templates\"\n                    report=\"vm.mdeReport.mdeReportMediacal.presentComplaints\"\n                    option=\"vm.mdeReport.mdeReportMediacal.presentComplaintsTemplate\"\n                    input-type=\"vm.templateInputType.PRESENT_COMPLAINTS\"\n                    control-title-key=\"\'ipmApp.mdeReport.ptp.presentComplaints\'\">\n                </template-select>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <div class=\"form-group\">\n                <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"presentComplaints\"\n                          id=\"presentComplaints\"\n                          ng-model=\"vm.mdeReport.mdeReportMediacal.presentComplaints\"\n                          ng-disabled=\"vm.isDisabled\"\n                          ng-required=\"vm.isRequired\"\n                          >\n                </textarea>\n                    <div ng-show=\"vm.editForm.presentComplaints.$dirty && vm.editForm.presentComplaints.$invalid\">\n                        <p class=\"help-block\" ng-show=\"vm.editForm.presentComplaints.$error.required\"\n                           translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!--Medical Records--><script type=\"text/ng-template\" id=\"medical-records\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\" translate=\"ipmApp.mdeReport.ptp.medicalRecords\">Present Complaints</h4>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <div class=\"form-group\">\n                    <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"medicalRecords\"\n                              id=\"medicalRecords\"\n                              ng-model=\"vm.mdeReport.mdeReportMediacal.medicalRecords\"\n                              ng-disabled=\"vm.isDisabled\"\n                              >\n                    </textarea>\n                    <div ng-show=\"vm.editForm.medicalRecords.$dirty && vm.editForm.medicalRecords.$invalid\">\n                        <p class=\"help-block\" ng-show=\"vm.editForm.medicalRecords.$error.required\"\n                           translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!--Conservative Care--><script type=\"text/ng-template\" id=\"conservative-care\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\">\n                    <span>{{\'ipmApp.mdeReport.ptp.conservativeCare\' | translate}}</span>\n                    <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                </h4>\n            </div>\n            <div class=\"col-v4-md-auto\">\n                <template-select\n                    is-disabled=\"vm.isDisabled\"\n                    templates=\"vm.templates\"\n                    report=\"vm.mdeReport.mdeReportMediacal.conservativeCare\"\n                    option=\"vm.mdeReport.mdeReportMediacal.conservativeCareTemplate\"\n                    input-type=\"vm.templateInputType.CONSERVATIVE_CARE\"\n                    control-title-key=\"\'ipmApp.mdeReport.ptp.conservativeCare\'\">\n                </template-select>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <div class=\"form-group\">\n                    <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"conservativeCare\"\n                              id=\"conservativeCare\"\n                              ng-model=\"vm.mdeReport.mdeReportMediacal.conservativeCare\"\n                              ng-disabled=\"vm.isDisabled\"\n                              ng-required=\"vm.isRequired\"\n                              >\n                    </textarea>\n                    <div ng-show=\"vm.editForm.conservativeCare.$dirty && vm.editForm.conservativeCare.$invalid\">\n                        <p class=\"help-block\" ng-show=\"vm.editForm.conservativeCare.$error.required\"\n                           translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!--surgicalHistory--><script type=\"text/ng-template\" id=\"surgical-history\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\">\n                    <span>{{\'ipmApp.mdeReport.ptp.surgicalHistory\' | translate}}</span>\n                    <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                </h4>\n            </div>\n            <div class=\"col-v4-md-auto\">\n                <template-select\n                    is-disabled=\"vm.isDisabled\"\n                    templates=\"vm.templates\"\n                    report=\"vm.mdeReport.mdeReportMediacal.surgicalHistory\"\n                    option=\"vm.mdeReport.mdeReportMediacal.surgicalHistoryTemplate\"\n                    input-type=\"vm.templateInputType.SURGICAL_HISTORY\"\n                    control-title-key=\"\'ipmApp.mdeReport.ptp.surgicalHistory\'\">\n                </template-select>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <div class=\"form-group\">\n                <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"surgicalHistory\"\n                          id=\"surgicalHistory\"\n                          ng-model=\"vm.mdeReport.mdeReportMediacal.surgicalHistory\"\n                          ng-disabled=\"vm.isDisabled\"\n                          ng-required=\"vm.isRequired\"\n                          >\n                </textarea>\n                    <div ng-show=\"vm.editForm.surgicalHistory.$dirty && vm.editForm.surgicalHistory.$invalid\">\n                        <p class=\"help-block\" ng-show=\"vm.editForm.surgicalHistory.$error.required\"\n                           translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!--current-medications--><script type=\"text/ng-template\" id=\"current-medications\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\">\n                    <span>{{\'ipmApp.mdeReport.ptp.currentMedications\' | translate}}</span>\n                    <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                </h4>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                    <div class=\"form-group\">\n                    <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"currentMedications\"\n                              id=\"currentMedications\"\n                              ng-model=\"vm.mdeReport.mdeReportMediacal.currentMedications\"\n                              ng-disabled=\"vm.isDisabled\"\n                              ng-required=\"vm.isRequired\"\n                              >\n                    </textarea>\n                        <div ng-show=\"vm.editForm.currentMedications.$dirty && vm.editForm.currentMedications.$invalid\">\n                            <p class=\"help-block\" ng-show=\"vm.editForm.currentMedications.$error.required\"\n                               translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                            <p class=\"help-block\"\n                               ng-show=\"vm.editForm.currentMedications.$error.maxlength\"\n                               translate=\"entity.validation.maxlength\"\n                               translate-value-max=\"1000\">\n                                This field cannot be longer than 1000 characters.\n                            </p>\n                        </div>\n                    </div>\n            </div>\n        </div>\n    </div></script><!--Vital Signs--><script type=\"text/ng-template\" id=\"vital-signs\"><div class=\"form-group\">\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <h4 class=\"primary title\" translate=\"ipmApp.mdeReport.ptp.vitalSigns\">Vital Signs</h4>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md-4\">\n                <div><label translate=\"ipmApp.mdeReport.ptp.height\">Height</label></div>\n                <div class=\"row-v4 justify-content-start align-items-center pl-3\">\n                    <div class=\"pr-1\">\n                        <input type=\"number\" class=\"form-control vital-signs-height\"\n                               name=\"vitalSignsHeight\"\n                               id=\"vitalSignsHeight\"\n                               ng-model=\"vm.mdeReport.mdeReportMediacal.vitalSignsHeight\"\n                               ng-disabled=\"vm.isDisabled\"\n                               ng-maxlength=\"50\">\n                    </div>\n                    <div><span>ft</span></div>\n                    <div class=\"px-1\">\n                        <input type=\"number\" class=\"form-control vital-signs-height\"\n                               name=\"vitalSignsIn\"\n                               id=\"vitalSignsIn\"\n                               ng-model=\"vm.mdeReport.mdeReportMediacal.vitalSignsIn\"\n                               ng-disabled=\"vm.isDisabled\"\n                               ng-maxlength=\"50\">\n                    </div>\n                    <div><span>in</span></div>\n                    <div class=\"col-12\">\n                        <div ng-show=\"(vm.editForm.vitalSignsHeight.$dirty && vm.editForm.vitalSignsHeight.$invalid) || (vm.editForm.vitalSignsIn.$dirty && vm.editForm.vitalSignsIn.$invalid)\">\n                            <p class=\"help-block\"\n                               ng-show=\"vm.editForm.vitalSignsHeight.$error.required || vm.editForm.vitalSignsIn.$error.required\"\n                               translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                            <p class=\"help-block\" ng-show=\"vm.editForm.vitalSignsHeight.$error.number || vm.editForm.vitalSignsIn.$error.number\"\n                               translate=\"entity.validation.invalidValue\">\n                                This field is invalid.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-v4-md-auto\">\n                <div class=\"pl-3\">\n                    <label translate=\"ipmApp.mdeReport.ptp.temperature\">Temperature</label>\n                </div>\n                <div class=\"row-v4 justify-content-start align-items-center pl-3\">\n                    <div class=\"col-v4-md-auto\">\n                        <input type=\"number\" class=\"form-control\"\n                               name=\"temperature\"\n                               id=\"temperature\"\n                               ng-model=\"vm.mdeReport.mdeReportMediacal.temperature\"\n                               ng-disabled=\"vm.isDisabled\"\n                               ng-maxlength=\"50\">\n                    </div>\n                    <div><span>F</span></div>\n                    <div class=\"col-v4-12\">\n                        <div ng-show=\"vm.editForm.temperature.$dirty && vm.editForm.temperature.$invalid\">\n                            <p class=\"help-block\"\n                               ng-show=\"vm.editForm.temperature.$error.required\"\n                               translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                            <p class=\"help-block\" ng-show=\"vm.editForm.temperature.$error.number\"\n                               translate=\"entity.validation.invalidValue\">\n                                This field is invalid.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!--surgicalHistory--><script type=\"text/ng-template\" id=\"summary-and-recommendations\"><div class=\"form-group\">\n        <div class=\"row-v4 justify-content-between align-items-center pb-1\">\n            <div class=\"col-v4-md-auto\">\n                <h4 class=\"primary title\">\n                    <span>{{\'ipmApp.mdeReport.ptp.summaryAndRecommendations\' | translate}}</span>\n                    <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span>\n                </h4>\n            </div>\n            <div class=\"col-v4-md-auto\">\n                <template-select\n                    is-disabled=\"vm.isDisabled\"\n                    templates=\"vm.templates\"\n                    report=\"vm.mdeReport.mdeReportMediacal.summaryAndRecommendations\"\n                    option=\"vm.mdeReport.mdeReportMediacal.summaryAndRecommendationsTemplate\"\n                    input-type=\"vm.templateInputType.SUMMARY_AND_RECOMMENDATIONS\"\n                    control-title-key=\"\'ipmApp.mdeReport.ptp.summaryAndRecommendations\'\">\n                </template-select>\n            </div>\n        </div>\n        <div class=\"row-v4\">\n            <div class=\"col-v4-md\">\n                <div class=\"form-group\">\n                <textarea class=\"form-control auto-height none-resize\" rows=\"5\" name=\"summaryAndRecommendations\"\n                          id=\"summaryAndRecommendations\"\n                          ng-model=\"vm.mdeReport.mdeReportMediacal.summaryAndRecommendations\"\n                          ng-disabled=\"vm.isDisabled\"\n                          ng-required=\"vm.isRequired\"\n                >\n                </textarea>\n                    <div ng-show=\"vm.editForm.summaryAndRecommendations.$dirty && vm.editForm.summaryAndRecommendations.$invalid\">\n                        <p class=\"help-block\" ng-show=\"vm.editForm.summaryAndRecommendations.$error.required\"\n                           translate=\"entity.validation.required\">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/frp-mde/tab/attendance-tracker/attendance-tracker.html","<div class=\"nowrap\" ng-if=\"vm.attendanceTrackers\"><label ng-repeat=\"at in vm.attendanceTrackers track by $index\" class=\"tracker-label form-check px-2\"><check-box-v value=\"at.value\" type=\"at.type\" check=\"at.check\" id=\"$index\" is-view=\"vm.isView || vm.checkDisableInFuture(at)\" on-change=\"vm.checkboxChange(value, check, type)\"></check-box-v></label></div>");
$templateCache.put("app/frp-mde/tab/attendance-tracker/check-box-v.html","<span id=\"attendance-tracker_{{vm.value}}\" class=\"checkBox-at\"><label class=\"pl-2\">{{\'ipmApp.attendanceTracker.\' + vm.value | translate}}</label><br><input id=\"cb_{{vm.id}}_{{vm.value}}_{{vm.type}}\" name=\"cb_{{vm.id}}_{{vm.value}}_{{vm.type}}\" type=\"checkbox\" ng-model=\"vm.check\" ng-disabled=\"vm.isView\" ng-click=\"vm.checkboxChange(vm.value, vm.type)\"> <i ng-if=\"vm.type == 1 || vm.type == 0\" ng-class=\"{\'disabled-at\': vm.isView}\"></i> <ins ng-if=\"vm.type == 2\" ng-class=\"{\'disabled-at\': vm.isView}\"></ins> </span>");
$templateCache.put("app/frp-mde/tab/frp/frp.html","<form name=\"searchForm\"><div class=\"row\"><div class=\"col-v4-md-12\"><div class=\"row-v4 justify-content-center align-items-center\"><!--back day--><div class=\"col-v4-md-auto\"><button type=\"button\" name=\"btnBack\" class=\"btn btn-default\" ng-disabled=\"vm.isLoading\" ng-click=\"vm.btnBackClick()\"><i class=\"glyphicon glyphicon-circle-arrow-left\"></i></button></div><!--start Date--><div class=\"col-v4-md-auto\"><label translate=\"ipmApp.frp.label.startDate\">startDate</label></div><div class=\"col-v4-md-auto\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"startDate\" name=\"startDate\" uib-datepicker-popup=\"{{vm.dateFormat}}\" ng-model=\"vm.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\" ng-required=\"true\" close-text=\"Close\" datepicker-options=\"vm.dateOptions\" ng-change=\"vm.changedTime()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openStartDate(\'startDate\')\"><span class=\"glyphicon glyphicon-calendar\"></span></button></span></div><div ng-show=\"searchForm.startDate.$dirty && searchForm.startDate.$invalid\"><p class=\"help-block\" ng-show=\"searchForm.startDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"searchForm.startDate.$error.date\" translate=\"entity.validation.invalidValue\">This field is invalid.</p></div></div><!--end start Date--><!--End Date--><div class=\"col-v4-md-auto\"><label translate=\"ipmApp.frp.label.endDate\">endDate</label></div><div class=\"col-v4-md-auto\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"endDate\" name=\"endDate\" datetime-picker=\"{{vm.dateFormat}}\" ng-model=\"vm.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\" enable-time=\"false\" disabled=\"disabled\" ng-required=\"true\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\"><span class=\"glyphicon glyphicon-calendar\"></span></button></span></div></div><!--end End Date--><!--next Date--><div class=\"col-v4-md-auto\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.isLoading\" ng-click=\"vm.btnNextClick()\"><i class=\"glyphicon glyphicon-circle-arrow-right\"></i></button></div></div></div></div><!--row 2--><div class=\"row pt-4\"><div class=\"col-v4-md-12\"><div class=\"row-v4 justify-content-end align-items-center\"><!--enroll patient--><div class=\"col-v4-md-4\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.openEnrollPatient()\" ng-disabled=\"!vm.frpProgramId || vm.isView\"><span translate=\"frpmdeDashboard.enrollPatient\">Enroll Patient</span></button></div><!--status--><div class=\"col-v4-md-2\"><select class=\"form-control\" name=\"frpStatus\" id=\"frpStatus\" ng-model=\"vm.status\" ng-change=\"vm.filterStatus()\" ng-options=\"opt as \'ipmApp.frpStatus.\'+ opt | translate for opt in vm.frpStatus\"><option value=\"\" selected=\"selected\">{{\'ipmApp.frpStatus.status\' | translate}}</option></select></div><!--search--><div class=\"col-v4-md-6\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-group-form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'frpmdeDashboard.filterTableResults\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div></div></div></div></form><!--row table--><div class=\"pt-4\"><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"patient\"><span>{{\'ipmApp.frp.table.patient\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span>{{\'ipmApp.frp.table.reports\' | translate}}</span></th><th jh-sort-by=\"reportstatus\"><span>{{\'ipmApp.frp.table.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span>{{\'ipmApp.frp.table.attendanceTracker\' | translate}}</span></th><th jh-sort-by=\"reportFinalized\" class=\"frp-col-report-finalized\"><span>{{\'ipmApp.frp.table.reportFinalized\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"remainingHours\" class=\"frp-col-remaining-hours\"><span>{{\'ipmApp.frp.table.remainingHours\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"authorizedHours\" class=\"frp-col-authorized-hours\"><span>{{\'ipmApp.frp.table.authorizedHours\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"frp in vm.frps track by frp.id\"><td class=\"frp-text-patient\"><a class=\"link\" ui-sref=\"frp-mde-detail({id:frp.id})\" ng-class=\"vm.checkPreviousWeekNotFinalized(frp)\"><span ng-if=\"vm.checkPreviousWeekNotFinalized(frp)\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <span>{{frp.patient.firstName}} {{frp.patient.lastName}} </span><span class=\"d-block\">({{frp.patient.patientId}})</span></a></td><td class=\"frp-text-report-status\"><div class=\"d-flex align-items-center\" ng-if=\"frp.reportStatus !== \'OTHER\'\"><button class=\"btn btn-primary\" ng-click=\"vm.openReport(frp)\" ng-disabled=\"vm.checkDisableStatus(frp) || vm.isSaving\"><span>{{\'ipmApp.reportStatus.\' + vm.getReportStatus(frp) | translate}}</span></button> <button type=\"button\" ng-disabled=\"vm.isDownLoading\" class=\"btn btn-sm px-0\" ng-if=\"vm.checkShowDownload(frp)\" ng-click=\"vm.downloadReport(frp)\"><span class=\"glyphicon glyphicon-save ml-10\"></span></button></div><!-- <div class=\"d-flex align-items-center\"\n                         ng-if=\"frp.reportStatus === \'FRP_REPORT_PREVIOUS_NOT_FINALIZED\'\">\n                        <span class=\"text-danger\">Week of\n                        <span ng-bind-html=\"vm.formatStartDatePrevious(frp.startDateFRPReportPrevious)\"></span>\n                        not finalized.</span>\n                    </div>--></td><td class=\"status-frp\"><select-status-frp patient-frp=\"frp\" is-view=\"!vm.checkEditReport(frp) || vm.isView\" on-change-status=\"vm.onChangeStatusFRP(data)\"></select-status-frp></td><td><span ng-if=\"frp\"><attendance-tracker attendance-tracker=\"frp.frpReport.attendanceTracker\" is-view=\"vm.checkDisableAttendanceTracker(frp) || vm.isView\" start-date=\"vm.startDate\" end-date=\"vm.endDate\" on-change=\"vm.attendanceTrackersChange(attendanceTracker, frp)\"></attendance-tracker></span><label class=\"text-danger\" ng-if=\"frp.frpReport && frp.frpReport.attendanceTracker && frp.frpReport.attendanceTracker.isInValidAttendance\" translate=\"ipmApp.patient.previouslyCompletedHours.error\">Hours Attended Can Not Exceed 160.</label></td><td class=\"text-center frp-col-report-finalized\"><report-finalized-view report-finalized-type=\"frp.reportFinalized\"></report-finalized-view></td><td class=\"text-center frp-col-remaining-hours\"><span ng-class=\"{\'text-danger\': frp.remainingHours && frp.remainingHours < 0}\">{{frp.remainingHours ? frp.remainingHours : 0}}</span></td><td class=\"text-center frp-col-authorized-hours\"><span>{{frp.authorizedHours ? frp.authorizedHours : 0}}</span></td></tr></tbody><tbody ng-if=\"!vm.frps || vm.frps.length === 0\"><tr><td colspan=\"10\"><p ng-if=\"!vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"ipmApp.frp.table.notExists\">There Are No Assigned Patients.</p><p ng-if=\"vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"ipmApp.frp.table.notExistsFilter\">We couldn\'t find any assigned FRP.</p></td></tr></tbody></table><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"15\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div>");
$templateCache.put("app/frp-mde/tab/inactive-patients/inactive-patients.html","<div class=\"row\"><div class=\"col-md-8 col-md-offset-4\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><div class=\"form-group\"><select class=\"form-control\" name=\"status\" id=\"status\" ng-model=\"vm.status\" ng-change=\"vm.filterStatus()\" ng-options=\"inactivePatients as \'frpmdeDashboard.inactivePatientsTab.statusList.\' + inactivePatients | translate for inactivePatients in vm.inactivePatientsStatus\"><option value=\"\" selected=\"selected\">{{\'frpmdeDashboard.inactivePatientsTab.status\' | translate}}</option></select></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-group-form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'frpmdeDashboard.filterTableResults\' | translate }}\" ng-keypress=\" ($event.which===13) ? vm.search(vm.searchQuery) : 0\"><div class=\"input-group-btn\"><button class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-search\" ng-click=\"vm.search(vm.searchQuery) \"></span></button></div></div></div></div></div></div><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"us.firstName\"><span>{{\'frpmdeDashboard.inactivePatientsTab.table.patient\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"frprLast\"><span>{{\'frpmdeDashboard.inactivePatientsTab.table.frpStatus\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mder.status\"><span>{{\'frpmdeDashboard.inactivePatientsTab.table.mdeStatus\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span>{{\'frpmdeDashboard.inactivePatientsTab.table.lastDateAttended\' | translate}}</span></th></tr></thead><tbody><tr ng-repeat=\"inactivePatient in vm.inactivePatients track by $index\"><td><a class=\"link\" ui-sref=\"frp-mde-detail({id:inactivePatient.id})\">{{inactivePatient.patient}}</a></td><td><span>{{\'ipmApp.frpStatus.\' + inactivePatient.frpStatus | translate}}</span></td><td><span>{{\'frpmdeDashboard.mdeStatus.\' + inactivePatient.mdeStatus | translate}}</span></td><td><span>{{inactivePatient.lastDateAttended | date:\'MM/dd/yyyy\'}}</span></td></tr></tbody><tbody ng-if=\"!vm.inactivePatients || vm.inactivePatients.length === 0\"><tr><td colspan=\"10\"><p ng-if=\"!vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"frpmdeDashboard.inactivePatientsTab.table.notExists\">There Are No Assigned Patients.</p><p ng-if=\"vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"frpmdeDashboard.inactivePatientsTab.table.notExistsFilter\">We couldn\'t find any assigned patients.</p></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div>");
$templateCache.put("app/frp-mde/tab/mde/mde.html","<div class=\"row\"><div class=\"col-md-9 col-md-offset-3\"><div class=\"row\"><div class=\"col-sm-7 col-xs-12\"><div class=\"form-group\"><ui-select multiple=\"multiple\" ng-model=\"vm.status\" theme=\"bootstrap\" ng-disabled=\"false\" close-on-select=\"false\" style=\"width: 100%\" ng-change=\"vm.selectedStatus()\"><ui-select-match placeholder=\"Select MDE status...\"><span class=\"select-mde\" title=\"{{\'frpmdeDashboard.mdeStatus.\' + $item | translate}}\">{{\'frpmdeDashboard.mdeStatus.\' + $item | translate}}</span></ui-select-match><ui-select-choices repeat=\"mde in vm.mdeStatus | filter:$select.search\">{{\'frpmdeDashboard.mdeStatus.\' + mde | translate}}</ui-select-choices></ui-select></div></div><div class=\"col-sm-5 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-group-form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'frpmdeDashboard.filterTableResults\' | translate }}\" ng-keypress=\" ($event.which===13) ? vm.search() : 0\"><div class=\"input-group-btn\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\"><span class=\"glyphicon glyphicon-search\"></span></button></div></div></div></div></div></div><div class=\"table-responsive voffset2\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"us.firstName\"><span>{{\'frpmdeDashboard.mdeTab.table.patient\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mder.statusFinal\"><span>{{\'frpmdeDashboard.mdeTab.table.reports\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mder.status\"><span>{{\'frpmdeDashboard.mdeTab.table.status\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span>{{\'frpmdeDashboard.mdeTab.table.progressTracker\' | translate}}</span></th><th jh-sort-by=\"mder.startDate\"><span>{{\'frpmdeDashboard.mdeTab.table.dateOfServices\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"medicalMdeu.firstName\"><span>{{\'frpmdeDashboard.mdeTab.table.medical\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"psychMdeu.firstName\"><span>{{\'frpmdeDashboard.mdeTab.table.psych\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ptMdeu.firstName\"><span>{{\'frpmdeDashboard.mdeTab.table.pt\' | translate}} </span><span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"patientFrpMde in vm.patientFrpMdes track by patientFrpMde.patient\"><td><a class=\"link\" ui-sref=\"frp-mde-detail({id:patientFrpMde.id})\">{{patientFrpMde.patient}}</a></td><td><span><button class=\"btn btn-block btn-primary\" ng-if=\"patientFrpMde.reportStatus==vm.constants.MDE_REPORT_STATUS.START_REPORT || patientFrpMde.displayStartButton\" ng-disabled=\"vm.isView\" ng-click=\"vm.startReport(patientFrpMde.id)\"><span translate=\"frpmdeDashboard.mdeTab.startReport\">Start report</span></button> <button class=\"btn btn-block btn-primary\" ng-if=\"patientFrpMde.reportStatus==vm.constants.MDE_REPORT_STATUS.EDIT_REPORT\" ng-click=\"vm.editReport(patientFrpMde.mdeReportId)\"><span translate=\"frpmdeDashboard.mdeTab.editReport\">Edit report</span></button><div class=\"d-flex align-items-center\" ng-if=\"patientFrpMde.reportStatus==vm.constants.MDE_REPORT_STATUS.VIEW_REPORT\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.viewReport(patientFrpMde.mdeReportId)\"><span translate=\"frpmdeDashboard.mdeTab.viewReport\">View report</span></button> <button type=\"button\" ng-disabled=\"vm.isDownLoading\" class=\"btn btn-sm px-0\" ng-click=\"vm.downloadReport(patientFrpMde)\"><span class=\"glyphicon glyphicon-save ml-10\"></span></button></div></span></td><td class=\"text-center\"><span>{{\'frpmdeDashboard.mdeStatus.\' + patientFrpMde.status | translate }}</span></td><td><div class=\"form-row-v4 flex-nowrap progressTracker\"><div class=\"col-v4-auto\" ng-repeat=\"processTracker in patientFrpMde.processTrackers\"><progress-tracker-item item=\"processTracker\"></progress-tracker-item></div></div></td><td><span>{{patientFrpMde.startDate | date:\'MM/dd/yyyy\'}}</span></td><td><span>{{patientFrpMde.medicalAssignUserName}}</span></td><td><span>{{patientFrpMde.psychAssignUserName}}</span></td><td><span>{{patientFrpMde.ptAssignUserName}}</span></td></tr></tbody><tbody ng-if=\"!vm.patientFrpMdes || vm.patientFrpMdes.length === 0\"><tr><td colspan=\"10\"><p ng-if=\"!vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"frpmdeDashboard.mdeTab.table.notExists\">There Are No Assigned Patients.</p><p ng-if=\"vm.isSearching && !vm.isLoading\" class=\"help-block text-center\" translate=\"frpmdeDashboard.mdeTab.table.notExistsFilter\">We couldn\'t find any assigned patients.</p></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination boundary-links=\"true\" class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\" max-size=\"20\" rotate=\"false\" ng-change=\"vm.loadAll()\"></uib-pagination></div>");
$templateCache.put("app/frp-mde/tab/report-finalized-view/report-finalized-view.html","<div class=\"rounded-circle\" ng-class=\"vm.reportFinalizedStyle(vm.reportFinalizedType)\"></div>");
$templateCache.put("app/frp-mde/tab/select-status-frp/select-status-frp.html","<select class=\"form-control\" name=\"frp_status_{{vm.patientFrp.id}}\" id=\"frp_status_{{vm.patientFrp.id}}\" ng-model=\"vm.patientFrp.frpStatus\" ng-change=\"vm.changeStatusFrpSelected()\" ng-disabled=\"vm.isView\" ng-options=\"status as \'ipmApp.frpStatus.\' + status | translate for status in vm.frpStatus track by status\" required></select>");
$templateCache.put("app/frp-mde/template/components/template-select.html","<div class=\"d-flex align-items-center\"><span class=\"bold glyphicon-lightblue\" ng-if=\"vm.option && vm.option.id && !vm.isGlobalTemplate && vm.option.active\" ng-click=\"vm.createOrEditTemplate(false)\"><span ng-class=\"{\'disabled\': vm.option.disabled || vm.isDisabled}\">Edit&nbsp;</span></span><select ng-if=\"!vm.isReportType && !vm.isAllowClearTemplate\" class=\"form-control\" name=\"templateSelect_{{vm.inputType}}\" id=\"templateSelect_{{vm.inputType}}\" ng-options=\"option as option.name for option in vm.filterTemplate() track by option.value\" ng-change=\"vm.change()\" ng-model=\"vm.option\" ng-disabled=\"vm.isDisabled\"><option hidden ng-selected=\"true\" value=\"\">{{\'ipmApp.frpMdeTemplate.selectText.\' + vm.templateType | translate}}</option></select><select ng-if=\"!vm.isReportType && vm.isAllowClearTemplate\" class=\"form-control\" name=\"templateSelect_{{vm.inputType}}\" id=\"templateSelect_{{vm.inputType}}\" ng-options=\"option as option.name for option in vm.filterTemplate() track by option.value\" ng-change=\"vm.change()\" ng-model=\"vm.option\" ng-disabled=\"vm.isDisabled\"><option ng-selected=\"true\" value=\"\">{{\'ipmApp.frpMdeTemplate.selectText.\' + vm.templateType | translate}}</option></select><select ng-if=\"vm.isReportType\" class=\"form-control\" name=\"templateSelect_{{vm.inputType}}\" id=\"templateSelect_{{vm.inputType}}\" ng-options=\"option as \'ipmApp.frpReport.admin.reportTypeList.\' + option.name | translate for option in vm.filterTemplate() track by option.value\" ng-change=\"vm.change()\" ng-required=\"true\" ng-model=\"vm.option\" ng-disabled=\"vm.isDisabled\"><option hidden ng-selected=\"true\" value=\"\">{{\'ipmApp.frpMdeTemplate.selectText.\' + vm.templateType | translate}}</option></select></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/allergies.html","<allergies-component workflow=\"vm.dataWorkflow\"></allergies-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/current-indications.html","<current-indications-component workflow=\"vm.dataWorkflow\"></current-indications-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/demographics.html","<demographics-component workflow=\"vm.dataWorkflow\"></demographics-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/diagnostic-studies.html","<diagnostic-studies-component workflow=\"vm.dataWorkflow\"></diagnostic-studies-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/injury-details.html","<injury-details-component workflow=\"vm.dataWorkflow\"></injury-details-component><work-related-injuries-component workflow=\"vm.dataWorkflow\"></work-related-injuries-component><personal-injury-component ng-show=\"vm.dataWorkflow.answer.coveredWorkerCompensation === \'NO\'\" workflow=\"vm.dataWorkflow.answer.workflowPersonalInjuryResponse\"></personal-injury-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/medications.html","<medications-component workflow=\"vm.dataWorkflow\" medication-groups=\"vm.medicationGroups\"></medications-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/past-medical-history-finish.html","<label translate=\"npqWorkflowPastMedicalHistoryFinish.Q1\">Please list surgeries not listed elsewhere:</label><textarea class=\"form-control auto-height none-resize\" ng-model=\"vm.dataWorkflow.answer.surgeriesNotListedElsewhere\" rows=\"5\"></textarea>");
$templateCache.put("app/npq-questionnaire/workflow/partial/past-medical-history.html","<past-medical-history-component workflow=\"vm.dataWorkflow\" past-medical-history-groups=\"vm.pastMedicalHistoryGroups\"></past-medical-history-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/personal-injury.html","<personal-injury-component workflow=\"vm.dataWorkflow\"></personal-injury-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/present-complaints.html","<present-complaints-component workflow=\"vm.dataWorkflow\"></present-complaints-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/review-of-systems.html","<review-of-systems-component workflow=\"vm.dataWorkflow\" symptom-groups=\"vm.symptomGroups\"></review-of-systems-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/social-history.html","<social-history-component workflow=\"vm.dataWorkflow\"></social-history-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/thanks.html","<div class=\"text-center font-s15 voffset3 center-block mb-15\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.nextNPQOrLogout()\"><span translate=\"npqQuestionnaire.action.continue\">Continue</span></button></div><div class=\"voffset4 font-s15 text-center\" translate=\"npqQuestionnaire.thankyou.title\">THANK YOU</div><div class=\"voffset3 font-s15 text-center mb-35\" translate=\"npqQuestionnaire.thankyou.content\">Thank you for completing your questions! Your answers will be sent to your physician.</div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/treatment-history.html","<treatment-history-component workflow=\"vm.dataWorkflow\"></treatment-history-component>");
$templateCache.put("app/npq-questionnaire/workflow/partial/work-related-injuries.html","<work-related-injuries-component workflow=\"vm.dataWorkflow\"></work-related-injuries-component>");
$templateCache.put("app/presentation-controls-instructor/presentation-patient-response/patient-response-details/patient-response-details.html","<uib-accordion close-others=\"true\"><div ng-show=\"vm.isShowResponseOpen\" uib-accordion-group class=\"panel-default\" is-open=\"vm.accordionStatus.responseOpen\" template-url=\"patient-response-template.html\"><div ng-if=\"vm.patientPresentation.presentationStatus === \'PRESENT\'\"><div class=\"form-group\" ng-if=\"vm.slide.type === \'QUESTION\'\"><div ng-include=\"\'select-one\'\" ng-if=\"vm.slide.question.type === \'SELECT_ONE\'\"></div><div ng-include=\"\'multi-select\'\" ng-if=\"vm.slide.question.type === \'MULTI_SELECT\'\"></div><div ng-include=\"\'free-text\'\" ng-if=\"vm.slide.question.type === \'FREE_TEXT\'\"></div></div><div class=\"form-group\"><label class=\"control-label\">Notes:</label><textarea class=\"form-control auto-height\" rows=\"3\" ng-model=\"vm.patientPresentation.patientPresentationResponses[vm.currentResponseIndex].notes\"></textarea></div></div></div><div uib-accordion-group class=\"panel-default\" is-open=\"vm.accordionStatus.attendanceOpen\"><uib-accordion-heading>Attendance & Notes <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-menu-down\': vm.accordionStatus.attendanceOpen, \'glyphicon-menu-up\': !vm.accordionStatus.attendanceOpen}\"></i></uib-accordion-heading><div><div class=\"form-group\"><label class=\"control-label\">Patient is:</label><label class=\"radio-inline\"><input type=\"radio\" name=\"presentationStatus_{{vm.patientPresentation.classSessionRegistrationId}}\" value=\"PRESENT\" ng-model=\"vm.patientPresentation.presentationStatus\"> Present</label><label class=\"radio-inline\"><input type=\"radio\" name=\"presentationStatus_{{vm.patientPresentation.classSessionRegistrationId}}\" value=\"NOT_PRESENT\" ng-model=\"vm.patientPresentation.presentationStatus\"> Not Present</label></div><div class=\"form-group\"><label class=\"control-label\">Notes:</label><textarea class=\"form-control auto-height\" rows=\"3\" ng-model=\"vm.patientPresentation.notes\"></textarea></div></div></div></uib-accordion><script type=\"text/ng-template\" id=\"patient-response-template.html\"><div class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n        <div class=\"panel-body\" ng-transclude></div>\n    </div></script><script type=\"text/ng-template\" id=\"select-one\"><form name=\"responseForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">\n                Response:\n            </label>\n            <div ng-repeat=\"option in vm.slide.question.options track by option.id\">\n                <label class=\"radio-inline\">\n                    <input type=\"radio\" name=\"response_{{option.id}}_{{vm.currentResponseId}}\"\n                           id=\"response_{{option.id}}_{{vm.currentResponseId}}\" value=\"{{option.output}}\"\n                           ng-model=\"vm.patientPresentation.patientPresentationResponses[vm.currentResponseIndex].response\">\n                    {{option.name}}\n                </label>\n            </div>\n        </div>\n    </form></script><script type=\"text/ng-template\" id=\"multi-select\"><form name=\"responseForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">\n                Response:\n            </label>\n            <div ng-repeat=\"option in vm.slide.question.options track by option.id\">\n                <label class=\"checkbox-inline\">\n                    <input type=\"checkbox\" id=\"resentationStatus_{{option.id}}\" name=\"presentationStatus_{{option.id}}\"\n                           value=\"{{option.id}}\"\n                           ng-model=\"vm.patientPresentation.patientPresentationResponses[vm.currentResponseIndex].multiResponse[option.id]\">\n                    {{option.name}}\n                </label>\n            </div>\n        </div>\n    </form></script><script type=\"text/ng-template\" id=\"free-text\"><form name=\"responseForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">Response:</label>\n            <textarea class=\"form-control auto-height\" rows=\"3\"\n                      ng-model=\"vm.patientPresentation.patientPresentationResponses[vm.currentResponseIndex].response\"></textarea>\n        </div>\n    </form></script>");
$templateCache.put("app/presentation-controls-instructor/presentation-patient-response/patient-response-summary/patient-response-summary-slide.html","<div style=\"border-top: 1px grey solid\"><div ng-if=\"vm.patientPresentationResponse\"><h4>Slide {{vm.slide.number}}/{{vm.slidesCountAll}} - <span ng-if=\"vm.slide.type !== \'QUESTION\'\">{{vm.slide.name}}</span> <span ng-if=\"vm.slide.type === \'QUESTION\'\">{{vm.slide.question.name}}</span></h4><div class=\"form-group\" ng-if=\"vm.slide.type === \'QUESTION\'\"><div ng-include=\"\'select-one\'\" ng-if=\"vm.slide.question.type === \'SELECT_ONE\'\"></div><div ng-include=\"\'multi-select\'\" patientpresentationresponse=\"patientPresentationResponse\" ng-if=\"vm.slide.question.type === \'MULTI_SELECT\'\"></div><div ng-include=\"\'free-text\'\" patientpresentationresponse=\"patientPresentationResponse\" ng-if=\"vm.slide.question.type === \'FREE_TEXT\'\"></div></div><div class=\"form-group\"><label class=\"control-label\">Notes:</label><textarea class=\"form-control auto-height none-resize\" rows=\"3\" ng-model=\"vm.patientPresentationResponse.notes\"></textarea></div></div></div><script type=\"text/ng-template\" id=\"select-one\"><form name=\"responseForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">\n                Response:\n            </label>\n            <div ng-repeat=\"option in vm.patientPresentationResponse.slide.question.options track by option.id\">\n                <label class=\"radio-inline\">\n                    <input type=\"radio\" name=\"response_{{option.id}}_{{vm.patientPresentationResponse.response.id}}\"\n                           id=\"response_{{option.id}}_{{vm.patientPresentationResponse.response.id}}\"\n                           value=\"{{option.output}}\"\n                           ng-model=\"vm.patientPresentationResponse.response\"> {{option.name}}\n                </label>\n            </div>\n        </div>\n    </form></script><script type=\"text/ng-template\" id=\"multi-select\"><form name=\"responseForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">\n                Response:\n            </label>\n            <div ng-repeat=\"option in vm.patientPresentationResponse.slide.question.options track by option.id\">\n                <label class=\"checkbox-inline\">\n                    <input type=\"checkbox\" id=\"resentationStatus_{{option.id}}\" name=\"presentationStatus_{{option.id}}\"\n                           value=\"{{option.id}}\" ng-model=\"vm.patientPresentationResponse.multiResponse[option.id]\">\n                    {{option.name}}\n                </label>\n            </div>\n        </div>\n    </form></script><script type=\"text/ng-template\" id=\"free-text\"><form name=\"responseForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">Response:</label>\n            <textarea class=\"form-control auto-height\" rows=\"3\" ng-model=\"vm.patientPresentationResponse.response\"></textarea>\n        </div>\n    </form></script>");
$templateCache.put("app/presentation-controls-instructor/presentation-patient-response/patient-response-summary/patient-response-summary.html","<uib-accordion close-others=\"true\"><div uib-accordion-group class=\"panel-default\" is-open=\"vm.accordionStatus\" template-url=\"patient-response-summary-template.html\"><div><div ng-include=\"\'is-patient\'\"></div><div class=\"form-group\"><label class=\"control-label\">Notes:</label><textarea class=\"form-control auto-height\" rows=\"3\" ng-model=\"vm.patientPresentation.notes\"></textarea></div><!--slide--><div ng-repeat=\"patientPresentationResponse in vm.patientPresentation.patientPresentationResponses track by patientPresentationResponse.id\"><patient-response-summary-slide patient-presentation-response=\"patientPresentationResponse\" slides-count-all=\"vm.slides.length\"></patient-response-summary-slide></div></div></div></uib-accordion><script type=\"text/ng-template\" id=\"patient-response-summary-template.html\"><div class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n        <div class=\"panel-body\" ng-transclude></div>\n    </div></script><script type=\"text/ng-template\" id=\"is-patient\"><form name=\"isPatientForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">\n                Patient is:\n            </label>\n            <label class=\"radio-inline\">\n                <input type=\"radio\" name=\"presentationStatus\" value=\"PRESENT\"\n                       ng-model=\"vm.patientPresentation.presentationStatus\"> Present\n            </label>\n            <label class=\"radio-inline\">\n                <input type=\"radio\" name=\"presentationStatus\" value=\"NOT_PRESENT\"\n                       ng-model=\"vm.patientPresentation.presentationStatus\"> Not Present\n            </label>\n        </div>\n    </form></script>");
$templateCache.put("app/psych-intake/workflow/partial/agreement-patient-acknowledgement.html","<agreement-patient-acknowledgement-component workflow=\"vm.dataWorkflow\"></agreement-patient-acknowledgement-component>");
$templateCache.put("app/psych-intake/workflow/partial/agreement-pcsg-information-policies.html","<agreement-pcsg-information-policies-component workflow=\"vm.dataWorkflow\"></agreement-pcsg-information-policies-component>");
$templateCache.put("app/psych-intake/workflow/partial/agreement-policies-procedures.html","<agreement-policies-procedures-component workflow=\"vm.dataWorkflow\"></agreement-policies-procedures-component>");
$templateCache.put("app/psych-intake/workflow/partial/agreement-privacy-practice.html","<agreement-privacy-practice-component workflow=\"vm.dataWorkflow\"></agreement-privacy-practice-component>");
$templateCache.put("app/psych-intake/workflow/partial/agreement-psychotherapy-sessions.html","<agreement-psychotherapy-sessions-component workflow=\"vm.dataWorkflow\"></agreement-psychotherapy-sessions-component>");
$templateCache.put("app/psych-intake/workflow/partial/agreement-telehealth-informed-consent.html","<agreement-telehealth-informed-consent-component workflow=\"vm.dataWorkflow\"></agreement-telehealth-informed-consent-component>");
$templateCache.put("app/psych-intake/workflow/partial/chief-complaint.html","<psych-intake-chief-complaint-component workflow=\"vm.dataWorkflow\"></psych-intake-chief-complaint-component>");
$templateCache.put("app/psych-intake/workflow/partial/demographics.html","<psych-intake-demographics-component workflow=\"vm.dataWorkflow\"></psych-intake-demographics-component>");
$templateCache.put("app/psych-intake/workflow/partial/diagnostic-studies.html","<psych-intake-diagnostic-studies-component workflow=\"vm.dataWorkflow\"></psych-intake-diagnostic-studies-component>");
$templateCache.put("app/psych-intake/workflow/partial/habits.html","<psych-intake-habits-component workflow=\"vm.dataWorkflow\"></psych-intake-habits-component>");
$templateCache.put("app/psych-intake/workflow/partial/medical-history.html","<psych-intake-medical-history-component workflow=\"vm.dataWorkflow\"></psych-intake-medical-history-component>");
$templateCache.put("app/psych-intake/workflow/partial/medications.html","<psych-intake-medications-component workflow=\"vm.dataWorkflow\"></psych-intake-medications-component>");
$templateCache.put("app/psych-intake/workflow/partial/personal-injury.html","<psych-intake-personal-injury-component workflow=\"vm.dataWorkflow\"></psych-intake-personal-injury-component>");
$templateCache.put("app/psych-intake/workflow/partial/previous-treatment.html","<psych-intake-previous-treatment-component workflow=\"vm.dataWorkflow\"></psych-intake-previous-treatment-component>");
$templateCache.put("app/psych-intake/workflow/partial/social-history.html","<psych-intake-social-history-component workflow=\"vm.dataWorkflow\"></psych-intake-social-history-component>");
$templateCache.put("app/psych-intake/workflow/partial/thanks.html","<div class=\"text-center font-s15 voffset3 center-block mb-15\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.nextPsychOrLogout()\"><span translate=\"psychIntake.action.continue\">Continue</span></button></div><div class=\"voffset4 font-s15 text-center\" translate=\"psychIntake.thankyou.title\">THANK YOU</div><div class=\"voffset3 font-s15 text-center mb-35\" translate=\"psychIntake.thankyou.content\">Thank you for completing your questions! Your answers will be sent to your physician.</div>");
$templateCache.put("app/psych-intake/workflow/partial/wellness-status.html","<psych-intake-wellness-status-component workflow=\"vm.dataWorkflow\"></psych-intake-wellness-status-component>");
$templateCache.put("app/psych-intake/workflow/partial/workers-compensation-info.html","<psych-intake-workers-compensation-component workflow=\"vm.dataWorkflow\"></psych-intake-workers-compensation-component>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/Internal-review/internal-review.html","<h3 class=\"primary title my-5 text-left\">{{\'ipmApp.qhpWorkflow.internalReview.title\' | translate}}</h3><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"form-check-v4\"><input type=\"checkbox\" id=\"checkbox_evaluatedForMDE\" name=\"checkbox_evaluatedForMDE\" ng-model=\"vm.cpr.evaluatedForMDE\"><label class=\"form-check-label-v4\" for=\"checkbox_evaluatedForMDE\" ng-bind-html=\"\'ipmApp.qhpWorkflow.internalReview.evaluatedForMDE\' | translate\"></label></div></div><div class=\"col-v4-md-12\"><div class=\"form-check-v4\"><input type=\"checkbox\" id=\"checkbox_evaluatedForPS\" name=\"checkbox_evaluatedForPS\" ng-model=\"vm.cpr.evaluatedForPS\"><label class=\"form-check-label-v4\" for=\"checkbox_evaluatedForPS\" ng-bind-html=\"\'ipmApp.qhpWorkflow.internalReview.evaluatedForPS\' | translate\"></label></div></div></div></div>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/call-log/call-log.html","<div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.callLogClick()\"><span translate=\"ipmApp.callLog.detail.callLog\">Call Log</span></button></div></div>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/section.html","<h3 class=\"primary title my-5 text-left\">{{vm.section.text}}<span class=\"glyphicon glyphicon-asterisk icon-required ml-2\" aria-hidden=\"true\" ng-if=\"vm.isSectionRequired()\"></span></h3><cpr-treatment-history-table ng-if=\"vm.isTreatmentHistorySection()\" treatment-types=\"vm.treatmentTypes\" on-value-change=\"vm.handleTreatmentHistoryTable(data)\"></cpr-treatment-history-table><div ng-repeat=\"question in vm.section.questions track by question.id\"><cpr-question question=\"question\" patient-work-status=\"vm.patientWorkStatus\" surgical-candidacy-status=\"vm.surgicalCandidacyStatus\" answers=\"vm.answers\" on-change=\"vm.onAnswerChange(data)\" ng-if=\"vm.displayQuestion(question)\"></cpr-question></div><h3 class=\"primary title my-5 text-left\" ng-if=\"vm.isTreatmentHistorySection()\"><span translate=\"ipmApp.qhpWorkflow.cases.table.title\" ng-class=\"{\'text-danger\': vm.checkInValidBillTo()}\"></span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></h3><div ng-if=\"vm.isTreatmentHistorySection()\"><h5 translate=\"ipmApp.qhpWorkflow.cases.table.selectAppropriateCase\">Please select the most appropriate case for billing.</h5><cpr-cases-table section=\"vm.section\" cases-master=\"vm.casesMaster\" cases=\"vm.cases\" deleted-cases=\"vm.deletedCases\" cpr-id=\"vm.cprId\"></cpr-cases-table></div>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-timeout-dialog/section-timeout-dialog.html","<form name=\"vm.confirmForm\" role=\"form\" novalidate show-validation class=\"section-timeout-dialog\"><div class=\"modal-header\"><h3 class=\"modal-title\" translate=\"ipmApp.carePlanReview.sectionTimeoutDialog.title\">Section Timout</h3></div><div class=\"modal-body\"><div class=\"form-group\"><p class=\"mb-1 section-timeout-text\" translate=\"ipmApp.carePlanReview.sectionTimeoutDialog.body.p1\"></p><p class=\"mb-1 section-timeout-text\" translate=\"ipmApp.carePlanReview.sectionTimeoutDialog.body.p2\"></p><p class=\"mb-1 section-timeout-text\" translate=\"ipmApp.carePlanReview.sectionTimeoutDialog.body.p3\"></p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-light\" data-dismiss=\"modal\" ng-click=\"vm.logOff()\"><span>Log Off</span></button> <button type=\"submit\" ng-click=\"vm.stayLoggedIn()\" class=\"btn btn-primary\"><span>Stay Logged In </span><span>({{vm.remainingSeconds}})</span></button></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/skip-review-dialog/skip-dialog.html","<form name=\"vm.confirmForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.no()\">&times;</button><h3 class=\"modal-title\" translate=\"ipmApp.qhpWorkflow.skipReview\"></h3></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"Reason\" translate=\"ipmApp.qhpWorkflow.reason\">Reason</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"Reason\" id=\"Reason\" ng-model=\"vm.skipReview.skipReason\" ng-options=\"reason as \'ipmApp.qhpWorkflow.skipReason.\' + reason | translate for reason in vm.skipReasons\" required></select></div><div class=\"form-group\"><label for=\"skipTime\" translate=\"ipmApp.qhpWorkflow.timeNextReview\">Time Next Review</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" id=\"skipTime\" name=\"skipTime\" ng-pattern=\"/^[1-9][0-9]*$/\" ng-model=\"vm.skipReview.skipTime\" required></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"vm.yes()\" ng-disabled=\"vm.confirmForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"entity.action.ok\">ok</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.no()\"><span translate=\"entity.action.cancel\">No</span></button></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/status-indicator/status-indicator.html","<div class=\"pointer text-center\" ng-class=\"vm.css\"><span ng-bind-html=\"\'ipmApp.qhpWorkflow.statusIndicator.\' + vm.statusIndicator.value | translate\"></span></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/multiple-column-checkbox-question/column-checkbox-item.html","<div class=\"form-row-v4 align-items-center limit-width\"><div class=\"checkbox-column\" ng-repeat=\"column in vm.columns track by $index\"><div class=\"form-row-v4 align-items-center\"><div class=\"col-v4\"><label class=\"mb-0 wrapword\" for=\"checkbox_{{optionItem.id}}_{{vm.question.id}}\">{{vm.item.name}}</label></div><div class=\"col-v4-checkbox\"><input type=\"checkbox\" id=\"checkbox_{{column.value}}_{{vm.item.id}}\" name=\"checkbox_{{column.value}}_{{vm.item.id}}\" value=\"{{value}}\" ng-model=\"column.checked\" ng-change=\"vm.change(column, column.checked)\"></div></div></div></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/multiple-column-checkbox-question/multiple-column-checkbox.html","<div class=\"header-list pb-2\"><div class=\"form-row-v4 justify-content-end limit-width\"><div class=\"col-v4-checkbox\">BHC Prescribed</div><div class=\"col-v4-checkbox\">Externally Prescribed</div></div></div><div class=\"checkbox-row\" ng-repeat=\"checkboxItem in vm.config.checkboxItems track by $index\"><column-checkbox-item config=\"vm.config\" item=\"checkboxItem\" on-change=\"vm.handleItemCheckboxChange(data)\"></column-checkbox-item></div><div class=\"mt-4\"><search-checkbox-auto-complete ng-if=\"vm.config.question.haveAutoComplete\" on-selected=\"vm.handleOrtherCheckboxSelected(data)\" exclude-ids=\"vm.ortherCheckboxExcludeIds\" type=\"vm.config.question.type\"></search-checkbox-auto-complete></div>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/question-description-bottom/question-description-bottom.html","<h3 class=\"primary title my-5 text-left\" ng-if=\"vm.isDisplayDescriptionBottom()\">{{vm.translateKey | translate}}</h3>");
$templateCache.put("app/qhp-workflow/haq-evaluation-workflow/skip-evaluation/skip-evaluation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.landingPageHAQ.skipEvaluation.title\">Skip Review Evaluation</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group text-left\"><label translate=\"ipmApp.landingPageHAQ.skipEvaluation.reason\">Reason</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><textarea class=\"form-control auto-height none-resize\" rows=\"2\" id=\"reason\" name=\"reason\" ng-model=\"vm.skipReviewEvaluation.reason\" ng-maxlength=\"1000\" ng-minlength=\"10\" required></textarea><div ng-show=\"editForm.reason.$dirty && editForm.reason.$invalid\"><p class=\"help-block\" ng-show=\"editForm.reason.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.reason.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1000\">This field cannot be longer than 1000 characters.</p><p class=\"help-block\" ng-show=\"editForm.reason.$error.minlength\" translate=\"entity.validation.min\" translate-value-min=\"10\">This field is required to be at least 10 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span translate=\"ipmApp.landingPageHAQ.action.skipReview\">Skip Review</span></button> <button type=\"button\" ng-disabled=\"vm.isSaving\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/survey-workflow/partial/course-register-workflow/course-register-workflow.html","<div class=\"page\"><div class=\"container\"><div class=\"content\"><!-- In Process step --><div ng-include=\"\'suggest-course-step\'\" ng-if=\"vm.currentStep === vm.suggestCourseStep\"></div><div ng-include=\"\'instruction-detail-list-step\'\" ng-if=\"vm.currentStep === vm.instructionDetailListStep\"></div><div ng-include=\"\'class-session-detail-list-step\'\" ng-if=\"vm.currentStep === vm.classSessionDetailListStep\"></div></div></div></div><!-- suggest course step --><script type=\"text/ng-template\" id=\"suggest-course-step\"><suggest-course-step patient-course-registration=\"vm.patientCourseRegistration\" next=\"vm.handleSuggestCourseNext()\" skip=\"vm.skip()\"></suggest-course-step></script><!-- instruction-detail-list step --><script type=\"text/ng-template\" id=\"instruction-detail-list-step\"><instruction-detail-list-step patient-course-registration=\"vm.patientCourseRegistration\" next=\"vm.handleInstructionDetailListNext()\" skip=\"vm.skip()\" back=\"vm.handleInstructionDetailListBack()\"></instruction-detail-list-step></script><!-- class-session-detail-list step --><script type=\"text/ng-template\" id=\"class-session-detail-list-step\"><class-session-detail-list-step patient-course-registration=\"vm.patientCourseRegistration\" next=\"vm.handleClassSessionDetailListNext()\" skip=\"vm.skip()\" back=\"vm.handleClassSessionDetailListBack()\"></class-session-detail-list-step></script>");
$templateCache.put("app/frp-mde/frp-report/conclusion/components/frp-goal-add-new-row.html","<!--<form name=\"ptReportForm\" role=\"form\" novalidate>--><div class=\"row-v4 mb-3 mb-md-0 align-items-center\"><div class=\"col-v4-7 mb-md-0 form-group\"><div class=\"form-check-v4\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}\" name=\"checkbox_{{vm.item.code}}\" ng-model=\"vm.item.checked\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.checkboxChange()\" class=\"form-check-input-v4 mt-0\"> <input type=\"text\" class=\"form-group form-control form-check-label-v4\" id=\"input_m_{{vm.item.code}}\" name=\"input_m_{{vm.item.code}}\" ng-model=\"vm.item.goal\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.item.checked\" class=\"form-check-label-v4\"></div><div class=\"ml-4\" ng-show=\"vm.formReference.input_m_{{vm.item.code}}.$dirty\"><p class=\"help-block\" ng-show=\"vm.formReference.input_m_{{vm.item.code}}.$error.required && vm.item.checked\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-v4-2\"><div><div class=\"row-v4\"><div class=\"col-v4-2\"><div class=\"d-flex align-items-center\"><span class=\"glyphicon glyphicon-minus glyphicon-lightred glyphicon-medium\" ng-click=\"vm.removeGoalAddNew()\"></span></div></div><div class=\"col-v4-2\"><div class=\"d-flex align-items-center\"><span ng-if=\"vm.lastItem\" class=\"glyphicon glyphicon-plus glyphicon-lightblue glyphicon-medium pl-4\" ng-click=\"vm.addNewGoal()\"></span></div></div></div></div></div><!--goalStatus--><div class=\"col-v4-2 col-goal-status\"><div class=\"align-self-center\"><select-goal-status form-reference=\"vm.formReference\" goal-status-name=\"vm.item.code + \'_\' +vm.item.goalType + \'_\' + vm.type\" goal-status=\"vm.item.goalStatus\" is-required=\"vm.item.checked\" select-onchange=\"vm.selectGoalStatusOnchange(goalStatus)\" disabled=\"vm.isDisabled || !vm.item.checked\"></select-goal-status></div></div><!--goalExplanation--><div class=\"col-v4 col-goal-explanation\"><div ng-if=\"vm.item.goalStatus && vm.item.goalStatus === \'INPROGRESS\'\"><input type=\"text\" class=\"form-control\" id=\"goalExplanation_{{vm.item.code}}_{{vm.item.goalType}}\" name=\"goalExplanation_{{vm.item.code}}_{{vm.item.goalType}}\" ng-model=\"vm.item.goalExplanation\" ng-disabled=\"vm.isDisabled\" ng-maxlength=\"255\" ng-required=\"false\"></div></div></div><!--</form>-->");
$templateCache.put("app/frp-mde/frp-report/conclusion/components/frp-goal-row.html","<!--<form name=\"ptReportForm\" role=\"form\" novalidate>--><div class=\"row-v4 mb-3 mb-md-2\" ng-class=\"{\'align-items-center\' : vm.showAddGoal}\"><div class=\"col-v4-7\"><div class=\"form-check-v4 align-items-start\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}_{{vm.item.goalType}}\" name=\"checkbox_{{vm.item.code}}_{{vm.item.goalType}}\" ng-model=\"vm.item.checked\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.checkboxChange()\" class=\"form-check-input-v4 mt-0\"><label for=\"checkbox_{{vm.item.code}}_{{vm.item.goalType}}\" class=\"form-check-label-v4\">{{\'ipmApp.mdeReport.pt.goalsItem.\' + vm.item.code | translate}}</label></div></div><div class=\"col-v4-2 d-flex align-items-center\"><!-- input --><div ng-include=\"\'input\'\" ng-if=\"vm.item.checked && vm.item.type === \'TEXT_FIELD\'\"></div><!-- select --><div ng-include=\"\'select\'\" ng-if=\"vm.item.checked && vm.item.type === \'DROP_DOWN\'\"></div><!-- add new goal --><div ng-if=\"vm.showAddGoal\"><div class=\"row-v4\"><div class=\"col-v4-2\"></div><div class=\"col-v4-2\"><div class=\"d-flex align-items-center\"><span class=\"glyphicon glyphicon-plus glyphicon-lightblue glyphicon-medium pl-4\" ng-click=\"vm.addNewGoal()\"></span></div></div></div></div></div><!--select goalStatus--><div class=\"col-v4-2 col-goal-status d-flex align-items-center\"><select-goal-status form-reference=\"vm.formReference\" goal-status-name=\"vm.item.code + \'_\' +vm.item.goalType + \'_\' + vm.type\" goal-status=\"vm.item.goalStatus\" is-required=\"vm.item.checked\" select-onchange=\"vm.selectGoalStatusOnchange(goalStatus)\" disabled=\"vm.isDisabled || !vm.item.checked\"></select-goal-status></div><!--goalExplanation--><div class=\"col-v4 col-goal-explanation d-flex align-items-center\"><div ng-if=\"vm.item.goalStatus && vm.item.goalStatus === \'INPROGRESS\'\"><input type=\"text\" class=\"form-control\" id=\"goalExplanation_{{vm.item.code}}_{{vm.item.goalType}}\" name=\"goalExplanation_{{vm.item.code}}_{{vm.item.goalType}}\" ng-model=\"vm.item.goalExplanation\" ng-disabled=\"vm.isDisabled || !vm.item.checked\" ng-maxlength=\"255\" ng-required=\"false\"></div></div></div><!--</form>--><!-- input --><script type=\"text/ng-template\" id=\"input\"><div class=\"row-v4\">\n        <div class=\"col-v4\">\n            <div>\n                <div class=\"d-flex position-relative\">\n                    <div class=\"flex-grow-0 form-group mb-0\">\n                        <input type=\"text\" class=\"form-control\" id=\"input_m_{{vm.item.code}}_{{vm.item.goalType}}\" name=\"input_m_{{vm.item.code}}_{{vm.item.goalType}}\" ng-model=\"vm.item.inputValue\" ng-disabled=\"vm.isDisabled\" ng-required=\"true\"/>\n                    </div>\n                    <div class=\"flex-grow-1 d-flex align-items-center ml-1\">\n                        <span ng-if=\"vm.item.code === \'G5\'\" translate=\"ipmApp.frpReport.pt.mins\"></span>\n                        <span ng-if=\"vm.item.code === \'G6\'\" translate=\"ipmApp.frpReport.pt.pounds\"></span>\n                    </div>\n                </div>\n                <div class=\"row-v4\">\n                    <div class=\"col-v4-md\">\n                        <div ng-show=\"vm.formReference.input_m_{{vm.item.code}}_{{vm.item.goalType}}.$dirty\">\n                            <p class=\"help-block\"\n                            ng-show=\"vm.formReference.input_m_{{vm.item.code}}_{{vm.item.goalType}}.$error.required\" translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!-- select --><script type=\"text/ng-template\" id=\"select\"><div class=\"row-v4\">\n        <div class=\"col-v4\">\n            <div class=\"form-group mb-0\">\n                <label for=\"score\" class=\"d-inline-block d-md-none\">Mid-Session</label>\n                <select\n                    class=\"form-control\"\n                    name=\"select_m_{{vm.item.code}}_{{vm.item.goalType}}\"\n                    id=\"select_m_{{vm.item.code}}_{{vm.item.goalType}}\"\n                    ng-model=\"vm.item.selectedValue\"\n                    ng-disabled=\"vm.isDisabled\"\n                    ng-required=\"true\"\n                    ng-options=\"p for p in vm.dropdownValues track by p\">\n                    <option value=\"\" selected></option>\n                </select>\n                <div ng-show=\"vm.formReference.select_m_{{vm.item.code}}_{{vm.item.goalType}}.$dirty\">\n                    <p class=\"help-block\"\n                    ng-show=\"vm.formReference.select_m_{{vm.item.code}}_{{vm.item.goalType}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/frp-mde/frp-report/conclusion/components/select-goal-status.html","<div class=\"form-group mb-0\"><select class=\"form-control\" name=\"goalStatus_{{vm.goalStatusName}}\" id=\"goalStatus_{{vm.goalStatusName}}\" ng-model=\"vm.goalStatus\" ng-change=\"vm.goalStatusChange()\" ng-options=\"gs as \'ipmApp.goalStatus.\'+gs | translate for gs in vm.goalsStatus track by gs\" ng-required=\"vm.isRequired\" ng-disabled=\"vm.disabled\"><option ng-selected=\"true\" value=\"\">{{\'ipmApp.frpReport.conclusion.selectGoalStatus\'| translate}}</option></select><div ng-show=\"vm.isShowValidation && vm.formReference.goalStatus.$dirty && vm.formReference.goalStatus.$invalid\"><p class=\"help-block\" ng-show=\"vm.formReference.goalStatus.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div>");
$templateCache.put("app/frp-mde/frp-report/psych/components/psych-objective-testing.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group table-responsive table-psych voffset2\"><table class=\"table table-striped table-bordered\"><thead><tr><th><span translate=\"ipmApp.frpReport.psych.table.select\"></span><div><input type=\"checkbox\" id=\"checkbox_select_all_objective_testing\" name=\"checkbox_select_all_objective_testing\" ng-model=\"vm.checked\" ng-disabled=\"vm.disableFields.psychTestingSelect\" ng-click=\"vm.onClickSelectAll()\"></div></th><th><span translate=\"ipmApp.frpReport.psych.table.instrument\"></span></th><th><span translate=\"ipmApp.frpReport.psych.table.initialScore\"></span></th><th ng-repeat=\"colSub in vm.colMidsessions track by $index | limitTo: vm.colLimit\"><div class=\"d-flex align-items-end col-midsession\"><div class=\"flex-grow-0\"><span translate=\"ipmApp.frpReport.psych.table.midsession\"></span><div ng-if=\"colSub\" class=\"input-group input-midsession\"><input class=\"form-control\" id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"colMisDate_objective_{{$index}}\" uib-datepicker-popup=\"{{vm.dateFormat}}\" ng-model=\"colSub.dated\" is-open=\"colSub.$isOpenCalendar\" enable-time=\"false\" ng-required=\"vm.checkRequiredDateMidsession($index)\" ng-disabled=\"vm.checkDisableColMidsessions($index)\" ng-change=\"vm.colSubjectiveDateChange(colSub)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.checkDisableColMidsessions($index)\" ng-click=\"vm.openCalendar(colSub)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"flex-grow-1 mx-1 mt-1\"><button type=\"button\" ng-disabled=\"vm.checkDisableRemoveColMidsessions()\" ng-click=\"vm.removeColMidsessions(colSub, $index)\" class=\"btn btn-sm\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=\"d-flex\" ng-show=\"vm.parentForm.colMisDate_objective_{{$index}}.$dirty && vm.parentForm.colMisDate_objective_{{$index}}.$invalid\"><div class=\"flex-grow-0 text-nowrap d-flex align-items-center transparent\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></div></th><th><span translate=\"ipmApp.frpReport.psych.table.discharge\"></span></th></tr></thead><tbody ng-if=\"vm.objectiveResponses\"><tr ng-repeat-start=\"sr in vm.objectiveResponses track by $index\" ng-class=\"$index % 2 ? \'\' : \'odd\'\"><td><span><input type=\"checkbox\" name=\"chbox_select_{{sr.instrument}}\" ng-model=\"sr.checked\" ng-change=\"vm.updateSelectAllCheckbox()\" ng-disabled=\"vm.disableFields.psychTestingSelect\" id=\"chbox_select_{{sr.instrument}}\"></span></td><td><label for=\"chbox_select_{{sr.instrument}}\">{{\'ipmApp.instrumentObjective.\' + sr.instrument | translate}}</label></td><td><div><select-score-frp-mde ng-if=\"vm.severity\" is-init-data=\"true\" update-severity-data=\"vm.objectiveImportMdeScores\" placeholder-label=\"\'Select initial score\'\" is-disabled=\"vm.disableFields.testingInitialScore\" is-required=\"sr.checked && vm.checkRequiredFieldScore()\" select-data=\"vm.severity[sr.instrument]\" select-id=\"vm.getIdInitialScore(sr)\" severity-model=\"sr.initialScoreSeverity\" score-no-match=\"sr.scoreNoMatch\" score-model=\"sr.initialScore\" number-maxlength=\"50\"></select-score-frp-mde></div><div ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$dirty && vm.parentForm.initialScore_{{sr.instrument}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></td><td ng-repeat=\"rowMid in sr.midsessions track by $index | limitTo: vm.colLimit\"><span><select-score-frp-mde ng-if=\"vm.severity\" is-init-data=\"true\" update-severity-data=\"vm.objectiveImportMdeScores\" is-disabled=\"vm.disableFields.testingMidsession || vm.checkDisableMidsessions($index, sr.midsessions)\" is-required=\"sr.checked && vm.checkRequiredColMidsessions($index)\" select-data=\"vm.severity[sr.instrument]\" select-id=\"vm.getIdMidSession(sr, $index)\" severity-model=\"rowMid.testScoreSeverity\" score-no-match=\"rowMid.scoreNoMatch\" score-model=\"rowMid.testScore\" number-maxlength=\"50\"></select-score-frp-mde></span><div ng-show=\"vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$dirty && vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></td><td><span><select-score-frp-mde ng-if=\"vm.severity\" is-init-data=\"true\" update-severity-data=\"vm.objectiveImportMdeScores\" is-disabled=\"vm.disableFields.testingDischarge\" is-required=\"sr.checked && vm.checkRequiredFieldDischarge()\" select-data=\"vm.severity[sr.instrument]\" select-id=\"vm.getIdDischarge(sr)\" severity-model=\"sr.dischargeSeverity\" score-no-match=\"sr.scoreNoMatch\" score-model=\"sr.discharge\" number-maxlength=\"50\"></select-score-frp-mde></span><div ng-show=\"vm.parentForm.discharge_{{sr.instrument}}.$dirty && vm.parentForm.discharge_{{sr.instrument}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.parentForm.discharge_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.parentForm.discharge_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></td></tr><tr ng-repeat-end=\"\" ng-class=\"$index % 2 ? \'\' : \'odd\'\"><td><span translate=\"ipmApp.frpReport.psych.table.notes\"></span></td><td colspan=\"{{vm.colspanNotes}}\"><span><input class=\"form-control\" type=\"text\" name=\"notes_{{sr.instrument}}\" id=\"notes_{{sr.instrument}}\" ng-model=\"sr.notes\" ng-disabled=\"vm.disableFields.testingNotes\" check-maxlength=\"255\" class=\"w-100\"><div ng-show=\"vm.parentForm.notes_{{sr.instrument}}.$dirty && vm.parentForm.notes_{{sr.instrument}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.parentForm.notes_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.parentForm.notes_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></span></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.isMidSessionReport || vm.disableFields.testingMidsession\" ng-click=\"vm.addMidsessionClick()\"><span translate=\"ipmApp.frpReport.psych.addMidsession\">Add Midsession Column to Table</span></button></div></div>");
$templateCache.put("app/frp-mde/frp-report/psych/components/psych-subjective-testing.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group table-responsive table-psych voffset2\"><table class=\"table table-striped table-bordered\"><thead><tr><th><span translate=\"ipmApp.frpReport.psych.table.select\"></span><div><input type=\"checkbox\" id=\"checkbox_select_all\" name=\"checkbox_select_all\" ng-model=\"vm.checked\" ng-disabled=\"vm.disableFields.psychTestingSelect\" ng-click=\"vm.onClickSelectAllSubjective()\"></div></th><th style=\"width: 104px\"><span translate=\"ipmApp.frpReport.psych.table.instrument\"></span></th><th><span translate=\"ipmApp.frpReport.psych.table.initialScore\"></span></th><th ng-repeat=\"colSub in vm.colMidsessionsSubjective track by $index | limitTo: vm.colLimit\"><div class=\"d-flex align-items-end col-midsession\"><div class=\"flex-grow-0\"><span translate=\"ipmApp.frpReport.psych.table.midsession\"></span><div ng-if=\"colSub\" class=\"input-group input-midsession\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"colMisDate_subjective_{{$index}}\" uib-datepicker-popup=\"{{vm.dateFormat}}\" ng-model=\"colSub.dated\" is-open=\"colSub.$isOpenCalendar\" enable-time=\"false\" ng-required=\"vm.checkRequiredDateMidsession($index)\" ng-change=\"vm.colSubjectiveDateChange(colSub)\" ng-disabled=\"vm.checkDisableColMidsessions($index)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.checkDisableColMidsessions($index)\" ng-click=\"vm.openCalendar(colSub)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"flex-grow-1 mx-1 mt-1\"><button type=\"button\" ng-disabled=\"vm.checkDisableRemoveColMidsessions()\" ng-click=\"vm.removeColMidsessions(colSub, $index)\" class=\"btn btn-sm\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=\"d-flex\" ng-show=\"vm.parentForm.colMisDate_subjective_{{$index}}.$dirty && vm.parentForm.colMisDate_subjective_{{$index}}.$invalid\"><div class=\"flex-grow-0 text-nowrap d-flex align-items-center transparent\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></div></th><th><span translate=\"ipmApp.frpReport.psych.table.discharge\"></span></th><th><span translate=\"ipmApp.frpReport.psych.table.notes\"></span></th></tr></thead><tbody ng-if=\"vm.subjectiveResponses\"><tr ng-repeat=\"sr in vm.subjectiveResponses track by sr.instrument\"><td><span><input type=\"checkbox\" name=\"chbox_select_{{sr.instrument}}\" ng-change=\"vm.updateSelectAllCheckboxSubjective()\" ng-model=\"sr.checked\" ng-disabled=\"vm.disableFields.psychTestingSelect\" id=\"chbox_select_{{sr.instrument}}\"></span></td><td><label for=\"chbox_select_{{sr.instrument}}\">{{\'ipmApp.instrumentSubjective.\' + sr.instrument | translate}}</label></td><td><div ng-include=\"\'normal-input\'\" ng-if=\"sr.type === \'NORMAL_TEXT_FIELD\'\"></div><div ng-include=\"\'left-right-input\'\" ng-if=\"sr.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div></td><td ng-repeat=\"rowMid in sr.midsessions track by $index | limitTo: vm.colLimit\"><div ng-include=\"\'ms-normal-input\'\" ng-if=\"sr.type === \'NORMAL_TEXT_FIELD\'\"></div><div ng-include=\"\'ms-left-right-input\'\" ng-if=\"sr.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div></td><td><div ng-include=\"\'discharge-normal-input\'\" ng-if=\"sr.type === \'NORMAL_TEXT_FIELD\'\"></div><div ng-include=\"\'discharge-left-right-input\'\" ng-if=\"sr.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div></td><td><span><input class=\"form-control\" type=\"text\" name=\"notes_{{sr.instrument}}\" id=\"notes_{{sr.instrument}}\" ng-model=\"sr.notes\" ng-disabled=\"vm.disableFields.testingNotes\" check-maxlength=\"255\"><div ng-show=\"vm.parentForm.notes_{{sr.instrument}}.$dirty && vm.parentForm.notes_{{sr.instrument}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.parentForm.notes_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"vm.parentForm.notes_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></span></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-12 py-2\"><button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.isMidSessionReport || vm.disableFields.testingMidsession\" ng-click=\"vm.addMidsessionClick()\"><span translate=\"ipmApp.frpReport.psych.addMidsession\">Add Midsession Column to Table</span></button></div></div><!-- Initial Score normal-input --><script type=\"text/ng-template\" id=\"normal-input\"><span>\n        <select-score-frp-mde\n                ng-if=\"vm.severity\"\n                is-init-data=\"true\"\n                update-severity-data=\"vm.subjectiveImportMdeScores\"\n                is-disabled=\"vm.disableFields.testingInitialScore\"\n                is-required=\"sr.checked && vm.checkRequiredFieldScore()\"\n                select-data=\"vm.severity[sr.instrument]\"\n                select-id=\"vm.getIdInitialScore(sr)\"\n                severity-model=\"sr.initialScoreSeverity\"\n                score-no-match=\"sr.scoreNoMatch\"\n                score-model=\"sr.initialScore\"\n                number-maxlength=\"50\"></select-score-frp-mde>\n\n    </span>\n    <div ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$dirty && vm.parentForm.initialScore_{{sr.instrument}}.$invalid\">\n        <p class=\"help-block\"\n            ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$error.required\"\n            translate=\"entity.validation.required\">\n            This field is required.\n        </p>\n        <p class=\"help-block\"\n           ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n           translate-value-max=\"50\">\n            This field cannot be longer than 50 characters.\n        </p>\n    </div></script><!-- initialScore left-right-input --><script type=\"text/ng-template\" id=\"left-right-input\"><div class=\"row-v4-column\">\n        <!--RIGHT-->\n        <div class=\"px-3\">\n            <div class=\"form-row\">\n                <label class=\"label-score-rl\" translate=\"ipmApp.frpReport.psych.bpiSeverity\">BPI - Severity</label>\n                <select-score-frp-mde\n                        ng-if=\"vm.severity\"\n                        is-init-data=\"true\"\n                        update-severity-data=\"vm.subjectiveImportMdeScores\"\n                        placeholder-label=\"\'Select initial score\'\"\n                        is-disabled=\"vm.disableFields.testingInitialScore\"\n                        is-required=\"sr.checked && vm.checkRequiredFieldScore()\"\n                        select-data=\"vm.severity[sr.instrument]\"\n                        select-id=\"vm.getIdInitialScoreLR(sr, \'Right\')\"\n                        severity-model=\"sr.initialScoreSeverityRight\"\n                        score-no-match=\"sr.scoreNoMatch\"\n                        score-model=\"sr.initialScoreRight\"\n                        number-maxlength=\"50\"\n                        ></select-score-frp-mde>\n            </div>\n            <div ng-show=\"vm.parentForm.initialScoreRight_{{sr.instrument}}.$dirty && vm.parentForm.initialScoreRight_{{sr.instrument}}.$invalid\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.initialScoreRight_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.initialScoreRight_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <!--LEFT-->\n        <div class=\"px-3\">\n            <div class=\"form-row\">\n                <label class=\"label-score-rl\" translate=\"ipmApp.frpReport.psych.bpiInterference\">BPI - Interference</label>\n                <select-score-frp-mde\n                        ng-if=\"vm.severity\"\n                        is-init-data=\"true\"\n                        update-severity-data=\"vm.subjectiveImportMdeScores\"\n                        is-disabled=\"vm.disableFields.testingInitialScore\"\n                        is-required=\"sr.checked && vm.checkRequiredFieldScore()\"\n                        select-data=\"vm.severity[sr.instrument]\"\n                        select-id=\"vm.getIdInitialScoreLR(sr, \'Left\')\"\n                        severity-model=\"sr.initialScoreSeverityLeft\"\n                        score-no-match=\"sr.scoreNoMatch\"\n                        score-model=\"sr.initialScoreLeft\"\n                        number-maxlength=\"50\"\n                ></select-score-frp-mde>\n            </div>\n            <div ng-show=\"vm.parentForm.initialScoreLeft_{{sr.instrument}}.$dirty && vm.parentForm.initialScoreLeft_{{sr.instrument}}.$invalid\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.initialScoreLeft_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.initialScoreLeft_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n    </div></script><!-- discharge-normal-input --><script type=\"text/ng-template\" id=\"discharge-normal-input\"><span>\n        <select-score-frp-mde\n                ng-if=\"vm.severity\"\n                is-init-data=\"true\"\n                update-severity-data=\"vm.subjectiveImportMdeScores\"\n                is-disabled=\"vm.disableFields.testingDischarge\"\n                is-required=\"sr.checked && vm.checkRequiredFieldDischarge()\"\n                select-data=\"vm.severity[sr.instrument]\"\n                select-id=\"vm.getIdDischarge(sr)\"\n                severity-model=\"sr.dischargeSeverity\"\n                score-no-match=\"sr.scoreNoMatch\"\n                score-model=\"sr.discharge\"\n                number-maxlength=\"50\"></select-score-frp-mde>\n    </span>\n    <div ng-show=\"vm.parentForm.discharge_{{sr.instrument}}.$dirty && vm.parentForm.discharge_{{sr.instrument}}.$invalid\">\n        <p class=\"help-block\"\n            ng-show=\"vm.parentForm.discharge_{{sr.instrument}}.$error.required\"\n            translate=\"entity.validation.required\">\n            This field is required.\n        </p>\n        <p class=\"help-block\"\n           ng-show=\"vm.parentForm.discharge_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n           translate-value-max=\"50\">\n            This field cannot be longer than 50 characters.\n        </p>\n    </div></script><!-- discharge-left-right-input --><script type=\"text/ng-template\" id=\"discharge-left-right-input\"><div class=\"row-v4-column\">\n        <!--RIGHT-->\n        <div class=\"px-3\">\n            <div class=\"form-row\">\n                <label class=\"label-score-rl\" translate=\"ipmApp.frpReport.psych.bpiSeverity\">BPI - Severity</label>\n                <select-score-frp-mde\n                        ng-if=\"vm.severity\"\n                        is-init-data=\"true\"\n                        update-severity-data=\"vm.subjectiveImportMdeScores\"\n                        is-disabled=\"vm.disableFields.testingDischargeRight\"\n                        is-required=\"sr.checked && vm.checkRequiredFieldDischarge()\"\n                        select-data=\"vm.severity[sr.instrument]\"\n                        select-id=\"vm.getIdDischargeLR(sr, \'Right\')\"\n                        severity-model=\"sr.dischargeSeverityRight\"\n                        score-no-match=\"sr.scoreNoMatch\"\n                        score-model=\"sr.dischargeRight\"\n                        number-maxlength=\"50\"></select-score-frp-mde>\n            </div>\n            <div ng-show=\"vm.parentForm.dischargeRight_{{sr.instrument}}.$dirty && vm.parentForm.dischargeRight_{{sr.instrument}}.$invalid\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.dischargeRight_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.dischargeRight_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <!--LEFT-->\n        <div class=\"px-3\">\n            <div class=\"form-row\">\n                <label class=\"label-score-rl\" translate=\"ipmApp.frpReport.psych.bpiInterference\">BPI - Interference</label>\n                <select-score-frp-mde\n                        ng-if=\"vm.severity\"\n                        is-init-data=\"true\"\n                        update-severity-data=\"vm.subjectiveImportMdeScores\"\n                        is-disabled=\"vm.disableFields.testingDischargeLeft\"\n                        is-required=\"sr.checked && vm.checkRequiredFieldDischarge()\"\n                        select-data=\"vm.severity[sr.instrument]\"\n                        select-id=\"vm.getIdDischargeLR(sr, \'Left\')\"\n                        severity-model=\"sr.dischargeSeverityLeft\"\n                        score-no-match=\"sr.scoreNoMatch\"\n                        score-model=\"sr.dischargeLeft\"\n                        number-maxlength=\"50\"></select-score-frp-mde>\n            </div>\n            <div ng-show=\"vm.parentForm.dischargeLeft_{{sr.instrument}}.$dirty && vm.parentForm.dischargeLeft_{{sr.instrument}}.$invalid\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.dischargeLeft_{{sr.instrument}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.dischargeLeft_{{sr.instrument}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n    </div></script><!-- ms-normal-input --><script type=\"text/ng-template\" id=\"ms-normal-input\"><span>\n        <select-score-frp-mde\n                ng-if=\"vm.severity\"\n                is-init-data=\"true\"\n                update-severity-data=\"vm.subjectiveImportMdeScores\"\n                is-disabled=\"vm.disableFields.testingMidsession || vm.checkDisableMidsessions($index, sr.midsessions)\"\n                is-required=\"sr.checked && vm.checkRequiredColMidsessions($index)\"\n                select-data=\"vm.severity[sr.instrument]\"\n                select-id=\"vm.getIdMidSession(sr, $index)\"\n                severity-model=\"rowMid.testScoreSeverity\"\n                score-no-match=\"rowMid.scoreNoMatch\"\n                score-model=\"rowMid.testScore\"\n                number-maxlength=\"50\"\n        ></select-score-frp-mde>\n    </span>\n    <div ng-show=\"vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$dirty && vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$invalid\">\n        <p class=\"help-block\"\n            ng-show=\"vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$error.required\"\n            translate=\"entity.validation.required\">\n            This field is required.\n        </p>\n        <p class=\"help-block\"\n           ng-show=\"vm.parentForm.rowMid_{{sr.instrument}}_{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n           translate-value-max=\"50\">\n            This field cannot be longer than 50 characters.\n        </p>\n    </div></script><!-- ms-left-right-input --><script type=\"text/ng-template\" id=\"ms-left-right-input\"><div class=\"row-v4-column\">\n        <!--RIGHT-->\n        <div class=\"px-3\">\n            <div class=\"form-row\">\n                <label class=\"label-score-rl\" translate=\"ipmApp.frpReport.psych.bpiSeverity\">BPI - Severity</label>\n                <select-score-frp-mde\n                        ng-if=\"vm.severity\"\n                        is-init-data=\"true\"\n                        update-severity-data=\"vm.subjectiveImportMdeScores\"\n                        is-disabled=\"vm.disableFields.testingMidsessionRight || vm.checkDisableMidsessions($index, sr.midsessions)\"\n                        is-required=\"sr.checked && vm.checkRequiredColMidsessions($index)\"\n                        select-data=\"vm.severity[sr.instrument]\"\n                        select-id=\"vm.getIdMidsessionLR(sr, \'Right\', $index)\"\n                        severity-model=\"rowMid.testScoreSeverityRight\"\n                        score-no-match=\"rowMid.scoreNoMatch\"\n                        score-model=\"rowMid.testScoreRight\"\n                        number-maxlength=\"50\"></select-score-frp-mde>\n            </div>\n            <div ng-show=\"vm.parentForm.rowMidRight_{{sr.instrument}}_{{$index}}.$dirty && vm.parentForm.rowMidRight_{{sr.instrument}}_{{$index}}.$invalid\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.rowMidRight_{{sr.instrument}}_{{$index}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.rowMidRight_{{sr.instrument}}_{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <!--LEFT-->\n        <div class=\"px-3\">\n            <div class=\"form-row\">\n                <label class=\"label-score-rl\" translate=\"ipmApp.frpReport.psych.bpiInterference\">BPI - Interference</label>\n                <select-score-frp-mde\n                        ng-if=\"vm.severity\"\n                        is-init-data=\"true\"\n                        update-severity-data=\"vm.subjectiveImportMdeScores\"\n                        is-disabled=\"vm.disableFields.testingMidsessionLeft || vm.checkDisableMidsessions($index, sr.midsessions)\"\n                        is-required=\"sr.checked && vm.checkRequiredColMidsessions($index)\"\n                        select-data=\"vm.severity[sr.instrument]\"\n                        select-id=\"vm.getIdMidsessionLR(sr, \'Left\', $index)\"\n                        severity-model=\"rowMid.testScoreSeverityLeft\"\n                        score-no-match=\"rowMid.scoreNoMatch\"\n                        score-model=\"rowMid.testScoreLeft\"\n                        number-maxlength=\"50\"></select-score-frp-mde>\n            </div>\n            <div ng-show=\"vm.parentForm.rowMidLeft_{{sr.instrument}}_{{$index}}.$dirty && vm.parentForm.rowMidLeft_{{sr.instrument}}_{{$index}}.$invalid\">\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.rowMidLeft_{{sr.instrument}}_{{$index}}.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                   ng-show=\"vm.parentForm.rowMidLeft_{{sr.instrument}}_{{$index}}.$error.maxlength\" translate=\"entity.validation.maxlength\"\n                   translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n    </div></script><!-- normal-input --><script type=\"text/ng-template\" id=\"select-input\"><span>\n        <select class=\"form-control\" name=\"initialScore_{{sr.instrument}}\" id=\"initialScore_{{sr.instrument}}\" ng-model=\"sr.initialScore\"\n                ng-disabled=\"vm.disableFields.testingInitialScore\"\n                ng-required=\"sr.checked && vm.checkRequiredFieldScore()\"\n                ng-options=\"severity as \'ipmApp.frpReport.psych.severities.subjectives.{{sr.instrument}}.\' + severity | translate for severity in vm.severity.{{sr.instrument}}\">\n            <option value=\"\" selected></option>\n        </select>\n    </span>\n    <div ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$dirty && vm.parentForm.initialScore_{{sr.instrument}}.$invalid\">\n        <p class=\"help-block\"\n           ng-show=\"vm.parentForm.initialScore_{{sr.instrument}}.$error.required\"\n           translate=\"entity.validation.required\">\n            This field is required.\n        </p>\n    </div></script>");
$templateCache.put("app/frp-mde/frp-report/home/upload-signature-dialog/upload-signature-dialog.html","<form name=\"editForm\" role=\"form\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" id=\"myProviderLabel\" translate=\"ipmApp.frpReport.home.uploadSignatureAndFinal\">Upload Signature And Final</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--signature--><div class=\"form-group\"><label class=\"control-label\" translate=\"ipmApp.frpReport.home.signature\">Signature</label><div class=\"row\"><div class=\"col-md-12\"><upload-images image-data=\"vm.signature.data\"></upload-images></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span translate=\"entity.action.finalAndSignOff\">Finalize & Sign-Off</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/frp-mde/mde-report/psych/components/checkbox-row.html","<form name=\"checkBoxRow_{{vm.item.convertItemCode}}\" role=\"form\" novalidate><div class=\"row-v4 mt-2\"><div class=\"col-v4-xl-2 col-md-3 col-v4-4 col-form-label-v4\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}\" name=\"checkbox_{{vm.item.code}}\" ng-model=\"vm.item.checked\" ng-change=\"vm.checkboxChange()\" ng-disabled=\"vm.isDisabled\"><label for=\"checkbox_{{vm.item.code}}\">{{\'ipmApp.mdeReport.psych.\' + vm.typeRow + \'.\' + vm.item.code | translate}}</label>&nbsp;<span ng-if=\"vm.item.checked && vm.typeRow === \'subjectives\'\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><!--score row--><div class=\"col-v4-xl-2 col-v4\" ng-show=\"vm.item.checked && vm.item.type !== vm.specialTextField\"><select-score-frp-mde ng-if=\"vm.severity\" is-init-data=\"false\" is-hide-severity=\"true\" is-disabled=\"vm.isDisabled\" is-required=\"vm.item.checked && vm.typeRow === \'subjectives\' && vm.item.type !== vm.specialTextField\" select-data=\"vm.severity[vm.item.convertItemCode]\" select-id=\"vm.getIdScore(vm.item.convertItemCode)\" score-no-match=\"vm.item.scoreNoMatch\" severity-model=\"vm.item.severity\" score-model=\"vm.item.score\"></select-score-frp-mde><div ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.score_{{vm.item.convertItemCode}}.$dirty\"><p class=\"help-block\" ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.score_{{vm.item.convertItemCode}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-v4-xl-2\" ng-show=\"vm.item.checked && vm.item.type === vm.specialTextField\"><div class=\"row-v4-column\"><!--RIGHT--><div class=\"px-3\"><div class=\"form-row\"><label class=\"label-score-rl\" translate=\"ipmApp.mdeReport.psych.bpiSeverity\">BPI - Severity</label><select-score-frp-mde ng-if=\"vm.severity\" is-init-data=\"false\" is-hide-severity=\"true\" is-disabled=\"vm.isDisabled\" is-required=\"vm.item.checked && vm.typeRow === \'subjectives\' && vm.item.type === vm.specialTextField\" select-data=\"vm.severity[vm.item.convertItemCode]\" select-id=\"vm.getIdScoreRight(vm.item.convertItemCode)\" score-no-match=\"vm.item.scoreNoMatchRight\" severity-model=\"vm.item.severityRight\" score-model=\"vm.item.scoreRight\"></select-score-frp-mde><div ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.scoreRight_{{vm.item.convertItemCode}}.$dirty\"><p class=\"help-block\" ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.scoreRight_{{vm.item.convertItemCode}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><!--LEFT--><div class=\"px-3\"><div class=\"form-row\"><label class=\"label-score-rl\" translate=\"ipmApp.mdeReport.psych.bpiInterference\">BPI - Interference</label><select-score-frp-mde ng-if=\"vm.severity\" is-init-data=\"false\" is-hide-severity=\"true\" is-disabled=\"vm.isDisabled\" is-required=\"vm.item.checked && vm.typeRow === \'subjectives\' && vm.item.type === vm.specialTextField\" select-data=\"vm.severity[vm.item.convertItemCode]\" select-id=\"vm.getIdScoreLeft(vm.item.convertItemCode)\" score-no-match=\"vm.item.scoreNoMatchLeft\" severity-model=\"vm.item.severityLeft\" score-model=\"vm.item.scoreLeft\"></select-score-frp-mde><div ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.scoreLeft_{{vm.item.convertItemCode}}.$dirty\"><p class=\"help-block\" ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.scoreLeft_{{vm.item.convertItemCode}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div></div><!--Classification--><div class=\"col-v4-xl-2 col-v4\" ng-show=\"vm.item.checked && vm.item.type !== vm.specialTextField\"><input type=\"text\" class=\"form-control\" id=\"severity_{{vm.item.convertItemCode}}\" name=\"severity_{{vm.item.convertItemCode}}\" ng-model=\"vm.item.severity\" ng-required=\"vm.item.checked && vm.typeRow === \'subjectives\' && !vm.isDisableClassification\" ng-disabled=\"vm.isDisabled || vm.isDisableClassification\" ng-hide=\"vm.item.scoreNoMatch && vm.item.score && !vm.item.severity\"><div ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.severity_{{vm.item.convertItemCode}}.$dirty\"><p class=\"help-block\" ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.severity_{{vm.item.convertItemCode}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div ng-show=\"vm.item.scoreNoMatch && vm.item.score && !vm.item.severity\"><p class=\"help-block\" translate=\"entity.validation.scoreDoesntMatch\">Score doesn\'t match.</p></div></div><!--Classification RL--><div class=\"col-v4-xl-2 col-v4\" ng-show=\"vm.item.checked && vm.item.type === vm.specialTextField\"><!--Right--><div><label class=\"label-score-rl\"></label><input type=\"text\" class=\"form-control\" id=\"severity_right_{{vm.item.convertItemCode}}\" name=\"severity_right_{{vm.item.convertItemCode}}\" ng-model=\"vm.item.severityRight\" ng-required=\"vm.item.checked && vm.typeRow === \'subjectives\' && !vm.isDisableClassification\" ng-disabled=\"vm.isDisabled || vm.isDisableClassification\" ng-hide=\"vm.item.scoreNoMatchRight && vm.item.scoreRight && !vm.item.severityRight\"><div ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.severity_right_{{vm.item.convertItemCode}}.$dirty\" class=\"pb-0\"><p class=\"help-block\" ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.severity_right_{{vm.item.convertItemCode}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div ng-show=\"vm.item.scoreNoMatchRight && vm.item.scoreRight && !vm.item.severityRight\"><p class=\"help-block\" translate=\"entity.validation.scoreDoesntMatch\">Score doesn\'t match.</p></div></div><!--LEFT--><div class=\"pt-0\"><label class=\"label-score-rl\"></label><input type=\"text\" class=\"form-control\" id=\"severity_left_{{vm.item.convertItemCode}}\" name=\"severity_left_{{vm.item.convertItemCode}}\" ng-model=\"vm.item.severityLeft\" ng-required=\"vm.item.checked && vm.typeRow === \'subjectives\' && !vm.isDisableClassification\" ng-disabled=\"vm.isDisabled || vm.isDisableClassification\" ng-hide=\"vm.item.scoreNoMatchLeft && vm.item.scoreLeft && !vm.item.severityLeft\"><div ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.severity_left_{{vm.item.convertItemCode}}.$dirty\"><p class=\"help-block\" ng-show=\"checkBoxRow_{{vm.item.convertItemCode}}.severity_left_{{vm.item.convertItemCode}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div ng-show=\"vm.item.scoreNoMatchLeft && vm.item.scoreLeft && !vm.item.severityLeft\"><p class=\"help-block\" translate=\"entity.validation.scoreDoesntMatch\">Score doesn\'t match.</p></div></div></div><div class=\"col-v4-xl-4 col-v4\" ng-if=\"vm.item.checked\"><label class=\"label-score-rl\" ng-if=\"vm.item.type === vm.specialTextField\"></label><input type=\"text\" class=\"form-control\" id=\"notes_{{vm.item.convertItemCode}}\" ng-model=\"vm.item.notes\" ng-disabled=\"vm.isDisabled\"></div></div></form>");
$templateCache.put("app/frp-mde/mde-report/pt/components/goal-add-new-row.html","<form name=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}\" role=\"form\" novalidate><div class=\"row-v4 mb-3 mb-md-0 align-items-center\"><div class=\"col-v4-8\"><div class=\"form-check-v4 form-group\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}\" name=\"checkbox_{{vm.item.code}}\" ng-model=\"vm.item.checked\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.checkboxChange()\" class=\"form-check-input-v4 mt-0\"> <input type=\"text\" class=\"form-control form-check-label-v4\" id=\"input_m_{{vm.item.code}}\" name=\"input_m_{{vm.item.code}}\" ng-model=\"vm.item.goal\" ng-required=\"vm.item.checked\" class=\"form-check-label-v4\" ng-disabled=\"vm.isDisabled\"></div><div class=\"ml-4\" ng-show=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}.input_m_{{vm.item.code}}.$dirty\"><p class=\"help-block\" ng-show=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}.input_m_{{vm.item.code}}.$error.required && vm.item.checked\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- checkbox --><div class=\"col-v4-2\"></div><div class=\"col-v4-2\"><div class=\"\"><div class=\"row-v4\"><div class=\"col-v4-2\"><div class=\"d-flex align-items-center\"><span class=\"glyphicon glyphicon-minus glyphicon-lightred glyphicon-medium\" ng-click=\"vm.removeGoalAddNew()\"></span></div></div><div class=\"col-v4-2\"><div class=\"d-flex align-items-center\"><span ng-if=\"vm.lastItem\" class=\"glyphicon glyphicon-plus glyphicon-lightblue glyphicon-medium pl-4\" ng-click=\"vm.addNewGoal()\"></span></div></div></div></div></div></div></form>");
$templateCache.put("app/frp-mde/mde-report/pt/components/goal-row.html","<form name=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}\" role=\"form\" novalidate><div class=\"row-v4 mb-3 mb-md-0\"><div class=\"col-v4-8\"><div class=\"form-check-v4 align-items-start\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}_{{vm.item.goalType}}\" name=\"checkbox_{{vm.item.code}}_{{vm.item.goalType}}\" ng-model=\"vm.item.checked\" ng-change=\"vm.checkboxChange()\" class=\"form-check-input-v4 mt-0\" ng-disabled=\"vm.isDisabled\"><label for=\"checkbox_{{vm.item.code}}_{{vm.item.goalType}}\" class=\"form-check-label-v4\"><span>{{\'ipmApp.mdeReport.pt.goalsItem.\' + vm.item.code | translate}} <span ng-if=\"vm.item.checked && (vm.item.type === \'TEXT_FIELD\' || vm.item.type === \'DROP_DOWN\')\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></span></label></div></div><div class=\"col-v4-2\"><!-- input --><div ng-include=\"\'input\'\" ng-show=\"vm.item.checked && vm.item.type === \'TEXT_FIELD\'\"></div><!-- select --><div ng-include=\"\'select\'\" ng-show=\"vm.item.checked && vm.item.type === \'DROP_DOWN\'\"></div></div><div class=\"col-v4-2\"><div ng-if=\"vm.showAddGoal\"><div class=\"row-v4\"><div class=\"col-v4-2\"></div><div class=\"col-v4-2\"><div class=\"d-flex align-items-center\"><span class=\"glyphicon glyphicon-plus glyphicon-lightblue glyphicon-medium pl-4\" ng-click=\"vm.addNewGoal()\"></span></div></div></div></div></div></div></form><!-- input --><script type=\"text/ng-template\" id=\"input\"><div class=\"row-v4\">\n        <div class=\"col-v4-md\">\n            <div class=\"mt-2 form-group\">\n                <div class=\"d-flex position-relative\">\n                    <div class=\"flex-grow-0\">\n                        <input type=\"text\" class=\"form-control\" id=\"input_m_{{vm.item.code}}_{{vm.item.goalType}}\" name=\"input_m_{{vm.item.code}}_{{vm.item.goalType}}\" ng-model=\"vm.item.inputValue\" ng-required=\"vm.item.checked && vm.item.type === \'TEXT_FIELD\'\" ng-disabled=\"vm.isDisabled\"/>\n                    </div>\n                    <div class=\"flex-grow-1 d-flex align-items-center ml-1\">\n                        <span ng-if=\"vm.item.code === \'G5\'\" translate=\"ipmApp.mdeReport.pt.mins\"></span>\n                        <span ng-if=\"vm.item.code === \'G6\'\" translate=\"ipmApp.mdeReport.pt.pounds\"></span>\n                    </div>\n                </div>\n                <div class=\"row-v4\">\n                    <div class=\"col-v4-md\">\n                        <div ng-show=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}.input_m_{{vm.item.code}}_{{vm.item.goalType}}.$dirty\">\n                            <p class=\"help-block\"\n                            ng-show=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}.input_m_{{vm.item.code}}_{{vm.item.goalType}}.$error.required\" translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script><!-- select --><script type=\"text/ng-template\" id=\"select\"><div class=\"row-v4\">\n        <div class=\"col-v4-md\">\n            <div class=\"mt-2 form-group\">\n                <label for=\"score\" class=\"d-inline-block d-md-none\">Mid-Session</label>\n                <select\n                    class=\"form-control\"\n                    name=\"select_m_{{vm.item.code}}_{{vm.item.goalType}}\"\n                    id=\"select_m_{{vm.item.code}}_{{vm.item.goalType}}\"\n                    ng-model=\"vm.item.selectedValue\"\n                    ng-required=\"vm.item.checked && vm.item.type === \'DROP_DOWN\'\"\n                    ng-disabled=\"vm.isDisabled\"\n                    ng-options=\"p for p in vm.dropdownValues track by p\">\n                    <option value=\"\" selected></option>\n                </select>\n                <div ng-show=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}.select_m_{{vm.item.code}}_{{vm.item.goalType}}.$dirty\">\n                    <p class=\"help-block\"\n                    ng-show=\"termGoalRow_{{vm.item.code}}_{{vm.item.goalType}}.select_m_{{vm.item.code}}_{{vm.item.goalType}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/frp-mde/mde-report/pt/components/objective-row.html","<form name=\"objectiveRow_{{vm.item.code}}\" role=\"form\" novalidate><div class=\"row-v4 mb-3 mb-md-0\"><div class=\"col-v4-md-objective col-v4-12 col-form-label-v4\"><div class=\"mt-2\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}\" name=\"checkbox_{{vm.item.code}}\" ng-model=\"vm.item.checked\" ng-change=\"vm.change()\" ng-class=\"{\'invisible\': vm.isAverage}\" ng-click=\"vm.updateSelectAll()\" ng-disabled=\"vm.isDisabled || vm.isAverage\"><label for=\"checkbox_{{vm.item.code}}\" ng-bind-html=\"\'ipmApp.mdeReport.pt.objectives.\' + vm.item.code | translate\"></label>&nbsp;<span ng-if=\"vm.item.checked && !vm.isAverage\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div></div><!-- normal-input --><div class=\"col-v4-xl-4 col-v4-lg-5 col-v4-md\" ng-include=\"\'normal-input\'\" ng-show=\"vm.item.checked && vm.item.type === \'NORMAL_TEXT_FIELD\'\"></div><!-- input --><div class=\"col-v4-xl-4 col-v4-lg-5 col-v4-md\" ng-include=\"\'left-right-input\'\" ng-show=\"vm.item.checked && vm.item.type === \'LEFT_RIGHT_TEXT_FIELD\'\"></div></div></form><!-- normal-input --><script type=\"text/ng-template\" id=\"normal-input\"><div class=\"row-v4\">\n        <div class=\"col-v4-6\">\n            <div class=\"mt-2\">\n                <input type=\"text\" class=\"form-control normal-input\" id=\"input_{{vm.item.code}}\" name=\"input_{{vm.item.code}}\" ng-model=\"vm.item.value\"\n                       ng-required=\"vm.item.checked && vm.item.type === \'NORMAL_TEXT_FIELD\' && !vm.isAverage\" ng-disabled=\"vm.isDisabled\"/>\n                <div ng-show=\"objectiveRow_{{vm.item.code}}.input_{{vm.item.code}}.$dirty\">\n                    <p class=\"help-block normal-input\"\n                    ng-show=\"objectiveRow_{{vm.item.code}}.input_{{vm.item.code}}.$error.required\" translate=\"entity.validation.required\">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div></script><!-- left-right-input --><script type=\"text/ng-template\" id=\"left-right-input\"><div class=\"row-v4\">\n        <!--RIGHT-->\n        <div class=\"col-v4-6\">\n            <div class=\"mt-2\">\n                <div class=\"form-row-v4\">\n                    <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                        <span>R</span>\n                    </div>\n                    <div class=\"col-v4\">\n                        <input type=\"text\" class=\"form-control\" id=\"right_input_{{vm.item.code}}\" name=\"right_input_{{vm.item.code}}\" ng-change=\"vm.changeLR()\" ng-model=\"vm.item.rightValue\" ng-required=\"vm.item.checked && vm.item.type === \'LEFT_RIGHT_TEXT_FIELD\' && !vm.isAverage\" ng-disabled=\"vm.isDisabled || vm.isAverage\"/>\n                        <div ng-show=\"objectiveRow_{{vm.item.code}}.right_input_{{vm.item.code}}.$dirty\">\n                            <p class=\"help-block\"\n                               ng-show=\"objectiveRow_{{vm.item.code}}.right_input_{{vm.item.code}}.$error.required\" translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!--LEFT-->\n        <div class=\"col-v4-6\">\n            <div class=\"mt-2\">\n                <div class=\"form-row-v4\">\n                    <div class=\"col-v4-auto col-form-label-v4 pr-0\">\n                        <span>L</span>\n                    </div>\n                    <div class=\"col-v4\">\n                        <input type=\"text\" class=\"form-control\" id=\"left_input_{{vm.item.code}}\" name=\"left_input_{{vm.item.code}}\" ng-change=\"vm.changeLR()\" ng-model=\"vm.item.leftValue\" ng-required=\"vm.item.checked && vm.item.type === \'LEFT_RIGHT_TEXT_FIELD\' && !vm.isAverage\" ng-disabled=\"vm.isDisabled || vm.isAverage\"/>\n                        <div ng-show=\"objectiveRow_{{vm.item.code}}.left_input_{{vm.item.code}}.$dirty\">\n                            <p class=\"help-block\"\n                            ng-show=\"objectiveRow_{{vm.item.code}}.left_input_{{vm.item.code}}.$error.required\" translate=\"entity.validation.required\">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/frp-mde/mde-report/pt/components/objective-select-all.html","<form name=\"objectiveRow_{{vm.item.code}}\" role=\"form\" novalidate><div class=\"row-v4 mb-3 mb-md-0\"><div class=\"col-v4-md-objective col-v4-12 col-form-label-v4\"><div class=\"mt-2\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}\" name=\"checkbox_{{vm.item.code}}\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.item.checked\" ng-click=\"vm.onClick()\"><label for=\"checkbox_{{vm.item.code}}\" ng-bind-html=\"\'ipmApp.mdeReport.pt.selectAll\' | translate\"></label></div></div></div></form>");
$templateCache.put("app/frp-mde/mde-report/pt/components/other-objective-row.html","<form name=\"otherObjectiveRow_{{vm.item.code}}\" role=\"form\" novalidate class=\"mb-3\"><div class=\"row-v4 mb-3 mb-md-0 col-v4-12 col-form-label-v4\"><div class=\"mt-2\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}\" name=\"checkbox_{{vm.item.code}}\" ng-model=\"vm.item.checked\" ng-change=\"vm.change()\" ng-disabled=\"vm.isDisabled\"></div><div class=\"col-v4-3-5 pl-0 other-object-input-name\"><input type=\"text\" class=\"form-control normal-input\" id=\"name_{{vm.item.code}}\" name=\"name_{{vm.item.code}}\" ng-model=\"vm.item.name\" ng-required=\"vm.item.checked && vm.item.type === \'NORMAL_TEXT_FIELD\'\" ng-disabled=\"vm.isDisabled\"><div ng-show=\"otherObjectiveRow_{{vm.item.code}}.name_{{vm.item.code}}.$dirty\"><p class=\"help-block normal-input\" ng-show=\"otherObjectiveRow_{{vm.item.code}}.name_{{vm.item.code}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- normal-input --><div class=\"col-v4-xl-4 col-v4-lg-5 col-v4-md\" ng-include=\"\'normal-input\'\" ng-show=\"vm.item.checked && vm.item.type === \'NORMAL_TEXT_FIELD\'\"></div><div class=\"mt-2\"><span class=\"glyphicon glyphicon-minus glyphicon-lightred glyphicon-medium\" ng-click=\"vm.removeOtherObjective()\"></span></div></div></form><!-- normal-input --><script type=\"text/ng-template\" id=\"normal-input\"><div class=\"row-v4\">\n        <div class=\"col-v4-6 normal-input-other\">\n            <input type=\"text\" class=\"form-control normal-input\" id=\"input_{{vm.item.code}}\" name=\"input_{{vm.item.code}}\" ng-model=\"vm.item.value\"\n                   ng-required=\"vm.item.checked && vm.item.type === \'NORMAL_TEXT_FIELD\'\" ng-disabled=\"vm.isDisabled\"/>\n            <div ng-show=\"otherObjectiveRow_{{vm.item.code}}.input_{{vm.item.code}}.$dirty\">\n                <p class=\"help-block normal-input\"\n                ng-show=\"otherObjectiveRow_{{vm.item.code}}.input_{{vm.item.code}}.$error.required\" translate=\"entity.validation.required\">\n                This field is required.\n                </p>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/frp-mde/mde-report/pt/components/physical-demand-level-row.html","<div class=\"form-row-v4 mt-2\"><div class=\"col-v4-xl-2 col-v4-md-3 col-v4-5 col-form-label-v4\"><span>{{\'ipmApp.mdeReport.pt.physicalDemandLevelsItem.\' + vm.item.code | translate}}</span></div><div class=\"col-v4-xl-2 col-v4-md-3 col-v4\"><select class=\"form-control\" name=\"select_{{vm.item.code}}\" id=\"select_{{vm.item.code}}\" ng-model=\"vm.item.value\" ng-disabled=\"vm.isDisabled\" ng-options=\"p for p in vm.dropdownValues track by p\"><option value=\"\" selected=\"selected\"></option></select></div><div class=\"col-v4-xl-4 col-v4-3\"><input type=\"text\" class=\"form-control\" id=\"note_{{vm.item.code}}\" ng-model=\"vm.item.note\" ng-disabled=\"vm.isDisabled\"></div></div>");
$templateCache.put("app/frp-mde/mde-report/pt/components/select-all-checkbox.html","<form name=\"subjectiveRow\" role=\"form\" novalidate><div class=\"row-v4 mb-3 mb-md-0\"><div class=\"col-v4-md-objective col-v4-12 col-form-label-v4\"><div class=\"mt-2\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_selectAll_{{vm.reportType}}\" name=\"checkbox_selectAll_{{vm.reportType}}\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.item[vm.reportType + \'Checked\']\" ng-click=\"vm.onClick()\"><label for=\"checkbox_selectAll_{{vm.reportType}}\" ng-bind-html=\"\'ipmApp.mdeReport.pt.selectAll\' | translate\"></label></div></div></div></form>");
$templateCache.put("app/frp-mde/mde-report/pt/components/subjective-row.html","<form name=\"subjectiveRow_{{vm.item.code}}\" role=\"form\" novalidate><div class=\"row-v4 mt-2\"><div class=\"col-v4-xl-2 col-md-3 col-v4-4 col-form-label-v4\"><input type=\"checkbox\" class=\"mr-3\" id=\"checkbox_{{vm.item.code}}\" name=\"checkbox_{{vm.item.code}}\" ng-model=\"vm.item.checked\" ng-change=\"vm.checkboxChange()\" ng-disabled=\"vm.isDisabled\"><label for=\"checkbox_{{vm.item.code}}\">{{\'ipmApp.mdeReport.pt.subjectives.\' + vm.item.code | translate}}</label>&nbsp;<span ng-if=\"vm.item.checked\" class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></div><div class=\"col-v4-xl-2 col-v4\" ng-show=\"vm.item.checked\"><input type=\"text\" class=\"form-control\" id=\"score_{{vm.item.code}}\" name=\"score_{{vm.item.code}}\" ng-model=\"vm.item.score\" ng-required=\"vm.item.checked\" ng-disabled=\"vm.isDisabled\"><div ng-show=\"subjectiveRow_{{vm.item.code}}.score_{{vm.item.code}}.$dirty\"><p class=\"help-block\" ng-show=\"subjectiveRow_{{vm.item.code}}.score_{{vm.item.code}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-v4-xl-2 col-v4\" ng-show=\"vm.item.checked\"><input ng-if=\"vm.item.code === \'PSEQ\'\" type=\"text\" class=\"form-control\" id=\"severity_{{vm.item.code}}\" name=\"severity_{{vm.item.code}}\" ng-model=\"vm.item.severity\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.item.checked\"><select ng-if=\"vm.item.code !== \'PSEQ\'\" class=\"form-control\" name=\"severity_{{vm.item.code}}\" id=\"severity_{{vm.item.code}}\" ng-model=\"vm.item.severity\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.item.checked\" ng-options=\"severity as \'ipmApp.mdeReport.pt.subjectives.severities.{{vm.item.code}}.\' + severity | translate for severity in vm.severity.{{vm.item.code}}\"></select><div ng-show=\"subjectiveRow_{{vm.item.code}}.severity_{{vm.item.code}}.$dirty\"><p class=\"help-block\" ng-show=\"subjectiveRow_{{vm.item.code}}.severity_{{vm.item.code}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-v4-xl-4 col-v4\" ng-show=\"vm.item.checked\"><input type=\"text\" class=\"form-control\" id=\"notes_{{vm.item.code}}\" ng-model=\"vm.item.notes\" ng-disabled=\"vm.isDisabled\"></div></div></form>");
$templateCache.put("app/frp-mde/tab/frp/enroll-patient/enroll-patient-dialog.html","<form name=\"enrollPatientForm\" role=\"form\" novalidate ng-init=\"vm.modalLoaded()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h5 class=\"modal-title\" translate=\"frpmdeDashboard.enrollPatient\">Enroll Patient</h5></div><div class=\"modal-body mb-3\"><jhi-alert-error></jhi-alert-error><div class=\"form-group typeahead\"><div class=\"input-group search-input\"><span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span> </span><input type=\"text\" class=\"form-control\" name=\"searchEnrollPatient\" id=\"searchEnrollPatient\" ng-disabled=\"!vm.frpProgramId\" placeholder=\"{{\'frpmdeDashboard.searchForPatient\' | translate }}\" typeahead-append-to=\"vm.searchResultEle\" typeahead-on-select=\"vm.selectPatientData($item)\" ng-model-options=\"{debounce: 600}\" ng-model=\"vm.patientSearchSelect\" typeahead-min-length=\"3\" typeahead-wait-ms=\"100\" uib-typeahead=\"patient as patient.name for patient in vm.searchPatient($viewValue)\" typeahead-editable=\"true\" typeahead-no-results=\"vm.isNoResult\" ng-maxlength=\"255\"></div><div class=\"ipm-auto-complete-container\"><div class=\"imp-auto-complete-box\" id=\"searchEnrollPatientAutoComplete\" ng-init=\"\"></div></div><div class=\"col-md-12 text-center\"><p class=\"help-block voffset3\" ng-if=\"vm.isNoResult\">{{\'frpmdeDashboard.enrollPatientNoResult\' | translate}}</p></div></div></div><div class=\"modal-footer d-flex justify-content-end\"><button type=\"button\" ng-disabled=\"vm.isDeleting\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"button\" ng-click=\"vm.enrollPatient()\" ng-disabled=\"vm.checkDisabledEnroll() || vm.isSaving\" class=\"btn btn-primary mx-3\"><span translate=\"entity.action.enroll\">Enroll</span></button></div></form>");
$templateCache.put("app/frp-mde/tab/mde/component/progress-tracker-item.html","<div class=\"process-tracker-text\">{{vm.item.text | translate}}</div><div class=\"statusPTracker\" ng-class=\"vm.getClass()\"><span class=\"glyphicon\" ng-class=\"vm.getIcon()\"></span></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/allergies.directive.html","<div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowAllergies.Q1\">Are you allergic to any medications?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"allergicToAnyMedications\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.allergicToAnyMedications\" id=\"allergicToAnyMedications.{{item}}\"><label class=\"form-check-label-v4\" for=\"allergicToAnyMedications.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.allergicToAnyMedications === \'YES\'\"><label class=\"d-block\"><span translate=\"npqWorkflowAllergies.Q1.1\">If yes, which ones?</span></label><div class=\"form-check-v4 form-check-inline-v4-lg\" ng-repeat=\"item in [\'PENICILLIN\', \'SULFA\', \'LATEX\', \'CONTRAST_DIE\', \'IODINE\', \'NONE_OF_THESE\'] track by $index\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"allergicWhichOnesSelected_{{item}}\" ng-model=\"vm.workflow.answer.allergicWhichOnesSelected[item]\" id=\"allergicWhichOnesSelected.{{item}}\"><label class=\"form-check-label-v4\" for=\"allergicWhichOnesSelected.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label translate=\"npqWorkflowAllergies.Q2\">Please list any other allergies</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.otherAllergies\" ng-maxlength=\"255\"></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/current-indications.directive.html","<div class=\"current-indications\"><ol class=\"pdl-14\"><!-- 1 --><li><p class=\"form-control-static\">{{\'npqWorkflowCurrentIndications.Q1\' | translate}}</p><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"x in [].constructor(11) track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\" currentPainIntensity\" value=\"{{$index}}\" id=\"currentPainIntensity.{{$index}}\" ng-model=\"vm.workflow.answer.currentPainIntensity\"><label class=\"form-check-label-v4\" for=\"currentPainIntensity.{{$index}}\">{{$index}}</label></div></li><!-- 2 --><li><p class=\"form-control-static\">{{\'npqWorkflowCurrentIndications.Q2\' | translate}}</p><div class=\"row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'CONSTANTLY\', \'FREQUENTLY\', \'INTERMITTENTLY\', \'OCCASIONALLY\'] track by $index\"><div class=\"form-check-v4 align-items-start\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q2\" value=\"{{item}}\" id=\"CurrentIndications_Q2.{{item}}\" ng-model=\"vm.workflow.answer.havePain\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q2.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div></li><li><p class=\"form-control-static\">{{\'npqWorkflowCurrentIndications.Q3.main\' | translate}}</p><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"currentIndications_main_Q3\" value=\"{{item}}\" id=\"currentIndications_main_Q3.{{item}}\" ng-model=\"vm.workflow.answer.doYouHaveBackPain\"><label class=\"form-check-label-v4\" for=\"currentIndications_main_Q3.{{item}}\">{{\'npqQuestionnaire.text.\' + item | translate}}</label></div><ol class=\"mt-3\" ng-show=\"vm.workflow.answer.doYouHaveBackPain === \'YES\'\"><!-- 3a --><li><p class=\"form-control-static\">{{\'npqWorkflowCurrentIndications.Q3\' | translate}}</p><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\', \'NO_BACK_PAIN\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q3\" value=\"{{item}}\" id=\"CurrentIndications_Q3.{{item}}\" ng-model=\"vm.workflow.answer.haveBackPain\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q3.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div><div class=\"mt-3\" ng-show=\"vm.workflow.answer.haveBackPain === \'YES\'\"><p class=\"form-control-static\"><span translate=\"npqWorkflowCurrentIndications.Q3.1\">If yes, which leg does it radiate down?</span></p><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'L\', \'R\', \'BOTH\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q2a\" value=\"{{item}}\" id=\"CurrentIndications_Q2a.{{item}}\" ng-model=\"vm.workflow.answer.whichLegRadiateDown\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q2a.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"mt-3\" ng-show=\"vm.workflow.answer.haveBackPain === \'YES\'\"><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4 pb-3\"><span translate=\"npqWorkflowCurrentIndications.Q3.2\">If you have BOTH back and leg pain</span></div><div class=\"col-v4-lg\"><div class=\"form-row-v4 mt-3 mt-lg-0\"><div class=\"col-v4-auto col-form-label-v4 yourLeg\"><span translate=\"npqWorkflowCurrentIndications.yourBack\">Your back is</span></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-4 mb-3\"><div class=\"form-row-v4\"><div class=\"col-v4 col-v4-md-3 col-v4-lg\"><input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" name=\"percentOfBackPain\" ng-model=\"vm.workflow.answer.percentOfBackPain\"></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqWorkflowCurrentIndications.percentYourPain\">% of your pain.</span></div><div class=\"col-v4-12\" ng-show=\"form.percentOfBackPain.$dirty\"><p class=\"help-block\" ng-if=\"form.percentOfBackPain.$error.max || form.percentOfBackPain.$error.min || form.percentOfBackPain.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-auto col-form-label-v4 yourLeg\"><span translate=\"npqWorkflowCurrentIndications.yourLeg\">Your leg is</span></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-4\"><div class=\"form-row-v4\"><div class=\"col-v4 col-v4-md-3 col-v4-lg\"><input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" name=\"percentOfLegPain\" ng-model=\"vm.workflow.answer.percentOfLegPain\"></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqWorkflowCurrentIndications.percentYourPain\">% of your pain.</span></div><div class=\"col-v4-12\" ng-show=\"form.percentOfLegPain.$dirty\"><p class=\"help-block\" ng-if=\"form.percentOfLegPain.$error.max || form.percentOfLegPain.$error.min || form.percentOfLegPain.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div></div></div></div></div></div></li><!-- 3.b --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4\">{{ \'npqWorkflowCurrentIndications.Q4\' | translate }}</div><div class=\"col-v4-md-auto col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4 mr-0\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"backPainWorseWith\" value=\"BENDING_FORWARD\" ng-model=\"vm.workflow.answer.backPainWorseWith\" id=\"backPainWorseWith.BENDING_FORWARD\"><label class=\"form-check-label-v4\" for=\"backPainWorseWith.BENDING_FORWARD\">{{ \'npqQuestionnaire.text.BENDING_FORWARD\' | translate}}</label></div></div><div class=\"col-v4-md-auto col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"backPainWorseWith\" value=\"BENDING_BACKWARD\" ng-model=\"vm.workflow.answer.backPainWorseWith\" id=\"backPainWorseWith.BENDING_BACKWARD\"><label class=\"form-check-label-v4\" for=\"backPainWorseWith.BENDING_BACKWARD\">{{ \'npqQuestionnaire.text.BENDING_BACKWARD\' | translate}}</label></div></div></div></li><!-- 3c --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4 currentIndications-q5\">{{ \'npqWorkflowCurrentIndications.Q5\' | translate }}</div><div class=\"col-v4-md col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q5\" value=\"{{item}}\" id=\"CurrentIndications_Q5.{{item}}\" ng-model=\"vm.workflow.answer.backPainReliefWhenSupport\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q5.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div></li></ol></li><!-- 4 --><li><p class=\"form-control-static\">{{\'npqWorkflowCurrentIndications.Q4.main\' | translate}}</p><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"currentIndications_main_Q4\" value=\"{{item}}\" id=\"currentIndications_main_Q4.{{item}}\" ng-model=\"vm.workflow.answer.doYouHaveNeckPain\"><label class=\"form-check-label-v4\" for=\"currentIndications_main_Q4.{{item}}\">{{\'npqQuestionnaire.text.\' + item | translate}}</label></div><ol class=\"mt-3\" ng-show=\"vm.workflow.answer.doYouHaveNeckPain === \'YES\'\"><!-- 4.a --><li><p class=\"form-control-static\">{{\'npqWorkflowCurrentIndications.Q6\' | translate}}</p><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\', \'NO_NECK_PAIN\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q6\" value=\"{{item}}\" id=\"CurrentIndications_Q6.{{item}}\" ng-model=\"vm.workflow.answer.haveNeckPain\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q6.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div><div class=\"mt-3\" ng-show=\"vm.workflow.answer.haveNeckPain === \'YES\'\"><p class=\"form-control-static\"><span translate=\"npqWorkflowCurrentIndications.Q6.1\">If yes, which arm does it radiate down?</span></p><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'L\', \'R\', \'BOTH\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q6a\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.whichArmRadiateDown\" id=\"CurrentIndications_Q6a.{{item}}\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q6a.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"mt-3\" ng-show=\"vm.workflow.answer.haveNeckPain === \'YES\'\"><div class=\"form-row-v4 mt-3\"><div class=\"col-v4-12 col-form-label-v4 pb-3\"><span translate=\"npqWorkflowCurrentIndications.Q6.2\">If you have BOTH neck and arm pain</span></div><div class=\"col-v4-lg\"><div class=\"form-row-v4 mt-3 mt-lg-0\"><div class=\"col-v4-auto col-form-label-v4 yourArm\"><span translate=\"npqWorkflowCurrentIndications.yourNeck\">Your neck is</span></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-4 mb-3\"><div class=\"form-row-v4\"><div class=\"col-v4 col-v4-md-3 col-v4-lg\"><input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" name=\"percentOfNeckPain\" ng-model=\"vm.workflow.answer.percentOfNeckPain\"></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqWorkflowCurrentIndications.percentYourPain\">% of your pain.</span></div><div class=\"col-v4-12\" ng-show=\"form.percentOfNeckPain.$dirty\"><p class=\"help-block\" ng-if=\"form.percentOfNeckPain.$error.max || form.percentOfNeckPain.$error.min || form.percentOfNeckPain.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-auto col-form-label-v4 yourArm\"><span translate=\"npqWorkflowCurrentIndications.yourArm\">Your arm is</span></div><div class=\"col-v4 col-v4-xl-3 col-v4-lg-4\"><div class=\"form-row-v4\"><div class=\"col-v4 col-v4-md-3 col-v4-lg\"><input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" name=\"percentOfArmPain\" ng-model=\"vm.workflow.answer.percentOfArmPain\"></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqWorkflowCurrentIndications.percentYourPain\">% of your pain.</span></div><div class=\"col-v4-12\" ng-show=\"form.percentOfArmPain.$dirty\"><p class=\"help-block\" ng-if=\"form.percentOfArmPain.$error.max || form.percentOfArmPain.$error.min || form.percentOfArmPain.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div></div></div></div></div></div></li><!-- 4.b --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4\">{{ \'npqWorkflowCurrentIndications.Q7\' | translate }}</div><div class=\"col-v4-md-auto col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4 mr-0\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"neckPainWorseWith\" value=\"LOOKING_UP\" ng-model=\"vm.workflow.answer.neckPainWorseWith\" id=\"neckPainWorseWith.LOOKING_UP\"><label class=\"form-check-label-v4\" for=\"neckPainWorseWith.LOOKING_UP\">{{ \'npqQuestionnaire.text.LOOKING_UP\' | translate }}</label></div></div><div class=\"col-v4-md-auto col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"neckPainWorseWith\" value=\"LOOKING_DOWN\" ng-model=\"vm.workflow.answer.neckPainWorseWith\" id=\"neckPainWorseWith.LOOKING_DOWN\"><label class=\"form-check-label-v4\" for=\"neckPainWorseWith.LOOKING_DOWN\">{{ \'npqQuestionnaire.text.LOOKING_DOWN\' | translate }}</label></div></div></div></li></ol></li><!-- 8 --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4 currentIndications-q8\">{{ \'npqWorkflowCurrentIndications.Q8\' | translate }}</div><div class=\"col-v4-md col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q8\" value=\"{{item}}\" id=\"CurrentIndications_Q8.{{item}}\" ng-model=\"vm.workflow.answer.haveAnyNumbnessOrTingling\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q8.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div class=\"row-v4\" ng-show=\"vm.workflow.answer.haveAnyNumbnessOrTingling === \'YES\'\"><div class=\"col-v4-12\"><p class=\"form-control-static\"><span translate=\"npqWorkflowCurrentIndications.Q8.1\">If yes, where do you have it?</span>&nbsp;</p></div><div class=\"col-v4-md-6\" ng-repeat=\"item in vm.workflow.answer.numbnessTinglingResponse track by $index\"><div class=\"form-row-v4 align-items-center\"><div class=\"col-v4-lg-auto\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"numbnessTinglingResponse_{{$index}}\" name=\"numbnessTinglingResponse_{{$index}}\" ng-model=\"item.checked\"><label class=\"form-check-label-v4\" for=\"numbnessTinglingResponse_{{$index}}\">{{\'npqQuestionnaire.text.\'+item.haveNumbnessTingling | translate}}</label></div></div><div class=\"col-v4-lg-auto mb-3 mb-lg-0\" ng-show=\"item.checked\"><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"opt in [\'L\', \'R\', \'BOTH\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q8a_{{item.haveNumbnessTingling}}\" value=\"{{opt}}\" id=\"CurrentIndications_Q8a_{{item.haveNumbnessTingling}}.{{opt}}\" ng-model=\"item.whereHaveIt\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q8a_{{item.haveNumbnessTingling}}.{{opt}}\">{{\'npqQuestionnaire.text.\'+opt | translate}}</label></div></div></div></div></div></li><!-- 9 --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4\">{{ \'npqWorkflowCurrentIndications.Q9\' | translate }}</div><div class=\"col-v4-md col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q9\" value=\"{{item}}\" id=\"CurrentIndications_Q9.{{item}}\" ng-model=\"vm.workflow.answer.haveAnyWeakness\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q9.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div class=\"row-v4\" ng-show=\"vm.workflow.answer.haveAnyWeakness === \'YES\'\"><div class=\"col-v4-12\"><p class=\"form-control-static\"><label translate=\"npqWorkflowCurrentIndications.Q9.1\">If yes, where do you have it?</label></p></div><div class=\"col-v4-md-6\" ng-repeat=\"item in vm.workflow.answer.weaknessResponse track by $index\"><div class=\"form-row-v4 align-items-center\"><div class=\"col-v4-lg-auto\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"weaknessResponse_{{$index}}\" name=\"weaknessResponse_{{$index}}\" ng-model=\"item.checked\"><label class=\"form-check-label-v4\" for=\"weaknessResponse_{{$index}}\">{{\'npqQuestionnaire.text.\'+item.haveWeakness | translate}}</label></div></div><div class=\"col-v4-lg-auto mb-3 mb-lg-0\" ng-show=\"item.checked\"><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"opt in [\'L\', \'R\', \'BOTH\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q9a_{{item.haveWeakness}}\" value=\"{{opt}}\" id=\"CurrentIndications_Q9a_{{item.haveWeakness}}.{{opt}}\" ng-model=\"item.whereHaveIt\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q9a_{{item.haveWeakness}}.{{opt}}\">{{\'npqQuestionnaire.text.\'+opt | translate}}</label></div></div></div></div></div></li><!-- 10 --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4\">{{ \'npqWorkflowCurrentIndications.Q10\' | translate }}</div><div class=\"col-v4-md col-form-label-v4\"><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q10\" value=\"{{item}}\" id=\"CurrentIndications_Q10.{{item}}\" ng-model=\"vm.workflow.answer.haveBowelOrBladderChanges\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q10.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div class=\"form-row-v4\" ng-show=\"vm.workflow.answer.haveBowelOrBladderChanges === \'YES\'\"><div class=\"col-v4-12\"><p class=\"form-control-static\"><span translate=\"npqWorkflowCurrentIndications.Q10.1\">If yes, what?</span></p></div><div class=\"col-v4-12\" ng-repeat=\"item in [\'CONSTIPATION\', \'LOSING_URINE\', \'LOSING_BOWELS\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q10a\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.whatBowelOrBladderChanges\" id=\"CurrentIndications_Q10a.{{item}}\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q10a.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q10a\" value=\"OTHER\" ng-model=\"vm.workflow.answer.whatBowelOrBladderChanges\" id=\"CurrentIndications_Q10a.other\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q10a.other\">{{\'npqQuestionnaire.text.OTHER\' | translate}}</label><span ng-show=\"vm.workflow.answer.haveBowelOrBladderChanges === \'YES\' && vm.workflow.answer.whatBowelOrBladderChanges == \'OTHER\'\"></span></div></div><div class=\"col-v4-md\" ng-show=\"vm.workflow.answer.haveBowelOrBladderChanges === \'YES\' && vm.workflow.answer.whatBowelOrBladderChanges == \'OTHER\'\"><input type=\"text\" class=\"form-control\" ng-maxlength=\"255\" ng-model=\"vm.workflow.answer.whatBowelOrBladderOtherChanges\"></div></div></div></div></li><!-- 11 --><li><p class=\"form-control-static\">{{ \'npqWorkflowCurrentIndications.Q11\' | translate }}</p><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'REST_LYING_DOWN\', \'MEDICATION\', \'HEAT\', \'ICE\', \'ELEVATION\', \'BRACING\', \'COMPRESSION\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"CurrentIndications_Q11_{{item}}\" name=\"CurrentIndications_Q11_{{item}}\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.whatHasHelpedPainSelected[item]\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q11_{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"col-v4-md-6\"><div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" type=\"checkbox\" id=\"CurrentIndications_Q11_OTHER\" name=\"CurrentIndications_Q11_OTHER\" value=\"OTHER\" ng-model=\"vm.workflow.answer.whatHasHelpedPainSelected[\'OTHER\']\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q11_OTHER\">{{\'npqQuestionnaire.text.OTHER\' | translate}}</label><span ng-show=\"vm.workflow.answer.whatHasHelpedPainSelected[\'OTHER\']\"></span></div></div><div class=\"col-v4-md\" ng-show=\"vm.workflow.answer.whatHasHelpedPainSelected[\'OTHER\']\"><input type=\"text\" class=\"form-control\" ng-maxlength=\"255\" ng-model=\"vm.workflow.answer.otherHelpedPain\"></div></div></div></div></li><!-- 12 --><li><p class=\"form-control-static\">{{ \'npqWorkflowCurrentIndications.Q12\' | translate }}</p><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'PROLONGED_WALKING\', \'OVERHEAD_ACTIVITIES\', \'GRIPPING\', \'GRASPING\', \'LIFTING_AND_CARRYING\', \'PROLONGED_STANDING\', \'KNEELING\', \'TYPING\', \'PROLONGED_SITTING\', \'STOOPING\', \'COUGHING_OR_STRAINING\', \'CRAWLING\', \'REACHING\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"CurrentIndications_Q12_{{item}}\" name=\"CurrentIndications_Q12_{{item}}\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.whatAggravatesPainSelected[item]\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q12_{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div></li><!-- 13 --><li><p class=\"form-control-static\">{{ \'npqWorkflowCurrentIndications.Q13\' | translate }}</p><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'LESS_THAN_5_POUNDS\', \'NO_MORE_THAN_10_POUNDS\', \'NO_MORE_THAN_20_POUNDS\', \'NO_MORE_THAN_50_POUNDS\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"CurrentIndications_Q13\" value=\"{{item}}\" id=\"CurrentIndications_Q13.{{item}}\" ng-model=\"vm.workflow.answer.howMuchLiftAndCarry\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q13.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div></li><!-- 14 --><li><p class=\"form-control-static\">{{ \'npqWorkflowCurrentIndications.Q14\' | translate }}</p><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'CANE\', \'ROLLER_WALKER\', \'WHEELCHAIR\', \'I_DO_NOT_USER_ANY_OF_THESE\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"radio\" id=\"CurrentIndications_Q14.{{item}}\" name=\"CurrentIndications_Q14\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.useTheHelp\"><label class=\"form-check-label-v4\" for=\"CurrentIndications_Q14.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div class=\"form-row-v4 mt-md-3\" ng-show=\"vm.workflow.answer.useTheHelp != \'I_DO_NOT_USER_ANY_OF_THESE\' && vm.workflow.answer.useTheHelp != null\"><div class=\"col-v4-12 col-form-label-v4\"><label translate=\"npqWorkflowCurrentIndications.Q14.1\">a. If yes, for how long</label>&nbsp;</div><div class=\"col-v4-md\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.howLongUseTheHelp\" ng-maxlength=\"20\"></div></div></li><!-- 15 --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4 currentIndications-q15\">{{ \'npqWorkflowCurrentIndications.Q15\' | translate }}</div><div class=\"col-v4-md-auto col-v4\"><input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"vm.workflow.answer.howLongSitAtOneTime\" name=\"howLongSitAtOneTime\" ng-maxlength=\"15\"><div ng-show=\"form.howLongSitAtOneTime.$dirty\"><p class=\"help-block\" ng-if=\"form.howLongSitAtOneTime.$error.max || form.howLongSitAtOneTime.$error.min || form.howLongSitAtOneTime.$error.maxlength || form.howLongSitAtOneTime.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqWorkflowCurrentIndications.minutes\">minutes</span></div></div></li><!-- 16 --><li><div class=\"form-row-v4\"><div class=\"col-v4-12 col-form-label-v4 currentIndications-q16\">{{\'npqWorkflowCurrentIndications.Q16\' | translate }}</div><div class=\"col-v4-md-auto col-v4\"><input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"vm.workflow.answer.howLongStandAtOneTime\" name=\"howLongStandAtOneTime\" ng-maxlength=\"15\"><div ng-show=\"form.howLongStandAtOneTime.$dirty\"><p class=\"help-block\" ng-if=\"form.howLongStandAtOneTime.$error.max || form.howLongStandAtOneTime.$error.min || form.howLongStandAtOneTime.$error.maxlength || form.howLongStandAtOneTime.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqWorkflowCurrentIndications.minutes\">minutes</span></div></div></li></ol></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/demographics.directive.html","<div class=\"form-group\"><label translate=\"npqWorkflowDemographics.prompt\">Please complete this questionnaire before your first clinic appointment. Your careful answers will help us to understand your pain problem and design the most appropriate treatment program for you.</label></div><div class=\"pb-4\"><div class=\"row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowDemographics.Q1\">In today\'s interview and examination, will you need the assistance of an interpreter?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"needAssistance\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.needAssistance\" id=\"{{item}}\"><label class=\"form-check-label-v4\" for=\"{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.needAssistance === \'YES\'\"><label translate=\"npqWorkflowDemographics.Q1.a\">If you know, what is the interpreter\'s name?</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.interpreterName\" ng-maxlength=\"150\"></div></div></div></div><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4-md-6 order-first\"><div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.lastName\" ng-maxlength=\"50\" name=\"lastName\" required></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.firstName\">First Name</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.firstName\" ng-maxlength=\"50\" name=\"firstName\" required></div></div><div class=\"col-v4-lg-3 col-v4-md\"><div class=\"form-group\"><label translate=\"npqQuestionnaire.text.label.middleInit\">Middle Initl</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.middleName\" ng-maxlength=\"50\"></div></div></div></div><div class=\"col-v4-md-6 order-lg-2 order-last\"><div class=\"row-v4\"><div class=\"col-v4-lg-auto col-v4-md-4\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqQuestionnaire.text.label.genderAtBirth\">Sex at Birth</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'M\', \'F\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"genderAtBirth\" value=\"{{item}}\" id=\"genderAtBirth.{{item}}\" ng-model=\"vm.workflow.answer.genderAtBirth\"><label class=\"form-check-label-v4\" for=\"genderAtBirth.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div class=\"col-v4-lg-auto col-v4-md\"><div class=\"form-group\"><label translate=\"npqQuestionnaire.text.label.genderYouIdentifyWith\">Preferred pronouns</label><input type=\"text\" class=\"form-control\" ng-maxlength=\"30\" placeholder=\"{{\'npqQuestionnaire.text.placeholder.preferredPronouns\' | translate}}\" ng-model=\"vm.workflow.answer.genderYouIdentifyWith\"></div></div></div></div><div class=\"col-v4-md-6 order-lg-last order-2\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.dateOfBirth\">Date of Birth</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" id=\"dateOfBirth\" name=\"dateOfBirth\" data-format=\"DD-MM-YYYY\" data-template=\"D MMM YYYY\" year-name=\"yearOfBirth\" day-name=\"dayOfBirth\" month-name=\"monthOfBirth\" ng-model=\"vm.workflow.answer.dateOfBirth\" ng-required=\"true\" rsmdatedropdowns></div></div><!--genderIndentity--><div class=\"col-v4-md-6 order-lg-last order-3\"><div class=\"row-v4\"><div class=\"col-v4-lg-auto col-v4-md-4\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqQuestionnaire.text.label.genderIndentity\">Gender Indentity</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'M\', \'F\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"genderIndentity\" value=\"{{item}}\" id=\"genderIndentity.{{item}}\" ng-model=\"vm.workflow.answer.genderIndentity\"><label class=\"form-check-label-v4\" for=\"genderIndentity.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div></div></div></div></div><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.homeTelephone\">Home telephone</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.homeTelephone\" name=\"homeTelephone\" ng-required=\"vm.requirePhoneNumbers()\" ng-maxlength=\"20\" phone-input></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.cellNumber\">Cell Number</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.cellNumber\" name=\"cellNumber\" ng-required=\"vm.requirePhoneNumbers()\" ng-maxlength=\"20\" phone-input> <span translate=\"npqQuestionnaire.text.label.cellNumberMessages\">By providing your phone number, you agree to receive text messages from Boomerang Healthcare. Message and data rates may apply. Message frequency varies.</span></div></div><div class=\"col-v4-md-6\"><div class=\"form-group\"><label translate=\"npqQuestionnaire.text.label.emailAddress\">Email Address</label><input type=\"email\" class=\"form-control\" ng-model=\"vm.workflow.answer.emailAddress\" ng-maxlength=\"255\" ng-pattern=\"constants.EMAIL_PATTERN\"></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.homeAddress\">Home Address</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.homeAddress\" ng-maxlength=\"255\"></div></div><div class=\"col-v4-lg-8 col-v4-7\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.city\">City</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.city\" ng-maxlength=\"50\"></div></div><div class=\"col-v4-lg-4 col-v4\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.zip\">ZIP</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.zip\" ng-maxlength=\"5\"></div></div></div></div><div class=\"col-v4-md-6\"><div class=\"form-group\"><label translate=\"npqQuestionnaire.text.label.socialSecurityNumber\">Social Security Number</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.socialSecurityNumberEncrypted\" ng-maxlength=\"20\" ng-disabled=\"vm.workflow.answer.doNotHaveSSN\"></div><div class=\"form-group\"><div class=\"form-check-v4 my-0\"><input type=\"checkbox\" class=\"form-check-input-v4\" name=\"remainingMedicationsLeft\" ng-change=\"vm.doNotHaveSSNChanged()\" ng-model=\"vm.workflow.answer.doNotHaveSSN\" id=\"doNotHaveSSN\"><label class=\"form-check-label-v4\" translate=\"npqQuestionnaire.text.label.doNotHaveSSN\" for=\"doNotHaveSSN\">I do not have a Social Security Number</label></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-lg-6\"><div class=\"row-v4\"><div class=\"col-v4-lg-8 col-v4-md\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.emergencyContact\">Emergency Contact</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.emergencyContactName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.label.phone\">Phone</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.emergencyContactPhone\" ng-maxlength=\"20\" phone-input></div></div></div></div><div class=\"col-v4-lg-6\"><div class=\"row-v4\"><div class=\"col-v4-lg-8 col-v4-md\"><div class=\"form-group\"><label translate=\"npqQuestionnaire.text.label.referringDoctor\">Referring Doctor/Attorney/Other</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.referringName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label translate=\"npqQuestionnaire.text.label.phone\">Phone</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.referringPhone\" ng-maxlength=\"20\" phone-input></div></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/diagnostic-studies.directive.html","<label><span translate=\"npqWorkflowDiagnosticStudies.Q1\">Have you had any diagnostic studies performed? Please check all that apply</span> <span ng-if=\"vm.hadAnyDiagnosticStudiesResponse()\" translate=\"npqWorkflowDiagnosticStudies.important\"></span></label><div class=\"form-row-v4\" ng-repeat=\"item in vm.workflow.answer.diagnostics track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"{{$index}}\" ng-model=\"item.checked\"><label class=\"form-check-label-v4\" for=\"{{$index}}\">{{item.diagnosticStudy.nameLangKey | translate}}</label></div><div class=\"form-row-v4\" ng-show=\"item.checked\"><div class=\"col-v4-md-6\" ng-if=\"item.diagnosticStudy.name !== \'EMG/NCV\'\"><div class=\"form-group\"><label><span translate=\"npqWorkflowDiagnosticStudies.Q1.1\">What body parts were studied ?</span></label><input type=\"text\" class=\"form-control\" ng-model=\"item.bodyPartsStudied\"></div></div><div class=\"col-v4-md-auto\" ng-if=\"item.diagnosticStudy.name === \'EMG/NCV\'\"><label class=\"d-block\"><span translate=\"npqWorkflowDiagnosticStudies.Q1.1\">What body parts were studied ?</span></label><div class=\"form-check-v4 form-check-inline-v4-md\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"upper-extremities\" ng-model=\"item.upperExtremities\" id=\"item.upperExtremities\"><label class=\"form-check-label-v4\" translate=\"npqWorkflowDiagnosticStudies.Q1.1.1\" for=\"item.upperExtremities\">Upper Extremities</label></div><div class=\"form-check-v4 form-check-inline-v4-md\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"upper-extremities\" ng-model=\"item.lowerExtremities\" id=\"item.lowerExtremities\"><label class=\"form-check-label-v4\" translate=\"npqWorkflowDiagnosticStudies.Q1.1.2\" for=\"item.lowerExtremities\">Lower Extremities</label></div></div><div class=\"col-v4-md-6\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label><span translate=\"npqWorkflowDiagnosticStudies.Q1.2\">Date of Exam</span></label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6 input-group-v4\"><input id=\"diagnostic_dateOfExam_{{$index}}\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"vm.datePickerOptions\" ng-model=\"item.dateOfExam\" is-open=\"item.opened\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"item.opened =!item.opened\" enable-time=\"false\"><div class=\"input-group-addon\"><span ng-click=\"item.opened =!item.opened\" class=\"glyphicon glyphicon-calendar\"></span></div></div><div class=\"col-v4-sm-6\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"diagnostic_dateOfExam_unsure_{{$index}}\" ng-model=\"item.dateOfExamUnsure\"><label class=\"form-check-label-v4\" for=\"diagnostic_dateOfExam_unsure_{{$index}}\" translate=\"npqQuestionnaire.text.label.unsureOfDate\">Unsure of date</label></div></div></div></div></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/injury-details.directive.html","<div class=\"form-group\"><span translate=\"npqWorkflowInjuryDetails.prompt\">Please complete the following</span></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowInjuryDetails.Q1\">Was there a specific injury?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\', \'UNSURE\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"wasThereASpecificInjury\" value=\"{{item}}\" id=\"wasThereASpecificInjury_{{item}}\" ng-model=\"vm.workflow.answer.wasThereASpecificInjury\"><label class=\"form-check-label-v4\" for=\"wasThereASpecificInjury_{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-row-v4\" ng-show=\"vm.workflow.answer.wasThereASpecificInjury === \'YES\'\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label><span translate=\"npqWorkflowInjuryDetails.Q1.Yes\">What is the approximate date of the injury</span>&nbsp;</label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6 input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"theApproximateDateOfTheInjury\" name=\"theApproximateDateOfTheInjury\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"vm.datePickerOptions\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"vm.datePickerOpenStatus.theApproximateDateOfTheInjury = !vm.datePickerOpenStatus.theApproximateDateOfTheInjury\" ng-model=\"vm.workflow.answer.theApproximateDateOfTheInjury\" is-open=\"vm.datePickerOpenStatus.theApproximateDateOfTheInjury\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.theApproximateDateOfTheInjury = !vm.datePickerOpenStatus.theApproximateDateOfTheInjury\"></span></div></div><div class=\"col-v4-sm-6\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"theApproximateDateOfTheInjuryUnsure\" ng-model=\"vm.workflow.answer.theApproximateDateOfTheInjuryUnsure\"><label class=\"form-check-label-v4\" for=\"theApproximateDateOfTheInjuryUnsure\" translate=\"npqQuestionnaire.text.label.unsureOfDate\">Unsure of date</label></div></div></div></div></div></div><div class=\"form-group\"><label><span translate=\"npqWorkflowInjuryDetails.Q2\">Please describe HOW your pain started, in as much detail as you can. If you had an injury, describe the injury and how it happened.</span></label><textarea class=\"form-control auto-height none-resize\" ng-model=\"vm.workflow.answer.describeYourPainStarted\" rows=\"5\"></textarea></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/medications.directive.html","<div class=\"form-group\"><span translate=\"npqWorkflowMedications.prompt\">Please include dosage</span></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><label translate=\"npqWorkflowMedications.Q1\">Who prescribes your medications now?</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.prescribersName\" ng-maxlength=\"100\"></div></div><div class=\"col-v4-md-6\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label translate=\"npqWorkflowMedications.Q2\">When were your prescriptions last filled?</label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6\"><div class=\"input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"prescriptionsLastFilled\" name=\"prescriptionsLastFilled\" uib-datepicker-popup=\"MM/dd/yyyy\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"vm.datePickerOpenStatus.prescriptionsLastFilled = !vm.datePickerOpenStatus.prescriptionsLastFilled\" datepicker-options=\"vm.datePickerOptions\" ng-model=\"vm.workflow.answer.prescriptionsLastFilled\" is-open=\"vm.datePickerOpenStatus.prescriptionsLastFilled\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.prescriptionsLastFilled = !vm.datePickerOpenStatus.prescriptionsLastFilled\"></span></div></div></div><div class=\"col-v4-sm-6 pb-2\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"prescriptionsLastFilledUnsure\" ng-model=\"vm.workflow.answer.prescriptionsLastFilledUnsure\"><label class=\"form-check-label-v4\" for=\"prescriptionsLastFilledUnsure\" translate=\"npqQuestionnaire.text.label.unsureOfDate\">Unsure of date</label></div></div></div></div></div><div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowMedications.Q3\">Do you have remaining medications left?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"remainingMedicationsLeft\" value=\"{{item}}\" id=\"remainingMedicationsLeft.{{item}}\" ng-model=\"vm.workflow.answer.remainingMedicationsLeft\"><label class=\"form-check-label-v4\" for=\"remainingMedicationsLeft.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.remainingMedicationsLeft === \'YES\'\"><label translate=\"npqWorkflowMedications.Q3.1\">If yes, for how long?</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.howLongOfMedication\" ng-maxlength=\"20\"></div><div class=\"form-group\"><span translate=\"npqWorkflowMedications.Q4\">Please check all medications you are currently taking. Indicate the dosage and number of pills you are taking daily</span></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><!-- PAIN_MEDICATIONS --><div class=\"text-uppercase mb-3\">{{vm.medicationGroups[0].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[0].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[0].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[0].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[0].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- ANTIDEPRESSANTS --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[3].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[3].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[3].id}}_{{item.id}}\" value=\"{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[3].id}}.{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[3].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- TOPICALS --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[7].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[7].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[7].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[7].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[7].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- SEIZURE_MEDICATIONS --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[9].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[9].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[9].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[9].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[9].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div></div><div class=\"col-v4-md-6\"><!-- ANTI_INFLAMMATORIES_NSAIDS --><div class=\"text-uppercase mt-4 mt-md-0 mb-3\">{{vm.medicationGroups[1].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[1].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[1].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[1].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[1].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- SLEEPING_MEDS --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[2].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[2].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[2].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[2].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[2].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- MUSCLE_RELAXANTS --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[4].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[4].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[4].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[4].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[4].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- ANTI_ANXIETY --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[5].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[5].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[5].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[5].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[5].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- NERVE_PAIN_MEDICATIONS --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[6].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[6].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[6].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[6].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[6].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div><!-- BLOOD_THINNERS --><div class=\"text-uppercase mt-4 mb-3\">{{vm.medicationGroups[8].nameLangKey | translate}}</div><div class=\"form-row-v4\" ng-repeat=\"item in vm.medicationGroups[8].medications track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"medicationIdsSelected_{{vm.medicationGroups[8].id}}_{{item.id}}\" id=\"medicationIdsSelected.{{vm.medicationGroups[8].id}}.{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.medicationIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"medicationIdsSelected.{{vm.medicationGroups[8].id}}.{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div><div class=\"col-v4-12\"><div class=\"form-row-v4 mt-3\" ng-show=\"vm.workflow.answer.medicationIdsSelected[item.id] == true\"><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.dosage\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].dosage\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.pills\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].numberOfPills\" ng-maxlength=\"20\"></div></div><div class=\"col-v4-4 col-v4-lg-3\"><div class=\"form-group\"><label>{{ \'npqWorkflowMedications.frequency\' | translate}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsResponse[item.id].frequency\" ng-maxlength=\"50\"></div></div></div></div></div></div><div class=\"col-v4-12\"><div class=\"row-v4\"><div class=\"col-v4-12 col-form-label-v4\"><div class=\"form-check-v4 my-0\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"haveMedicationsOther\" ng-model=\"vm.workflow.answer.haveMedicationsOther\" id=\"haveMedicationsOther.other\"><label class=\"form-check-label-v4\" translate=\"npqQuestionnaire.text.OTHER\" for=\"haveMedicationsOther.other\">(list below):</label></div></div><div class=\"col-v4-12\"><div class=\"form-group\"><input type=\"text\" ng-show=\"vm.workflow.answer.haveMedicationsOther == true\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsOther\"></div></div></div></div></div><div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowMedications.Q5\">Have you ever stopped medications because of side effects or because they didn\'t work?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"haveEverStoppedMedications\" value=\"{{item}}\" id=\"haveEverStoppedMedications.{{item}}\" ng-model=\"vm.workflow.answer.haveEverStoppedMedications\" ng-change=\"vm.haveEverStoppedMedicationsChanged()\"><label class=\"form-check-label-v4\" for=\"haveEverStoppedMedications.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"row-v4\" ng-show=\"vm.workflow.answer.haveEverStoppedMedications === \'YES\'\"><div class=\"col-v4-12\"><div class=\"d-none d-md-block safari_5\"><div class=\"form-row-v4\"><div class=\"col-v4-md-11\"><div class=\"row-v4\"><div class=\"col-v4-md-6\">{{ \'npqWorkflowMedications.Q5.1\' | translate }}</div><div class=\"col-v4-md-6\">{{ \'npqWorkflowMedications.Q5.2\' | translate }}</div></div></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-md-11\"><div class=\"row-v4\" ng-repeat=\"item in vm.workflow.answer.medicationStoppedsResponse track by $index\"><div class=\"col-v4-md-6 mt-md-2\"><div class=\"form-group\"><label class=\"d-md-none safari_5\">{{ \'npqWorkflowMedications.Q5.1\' | translate }}</label><input type=\"text\" class=\"form-control\" name=\"discontinuedMedications_{{$index}}\" ng-model=\"item.discontinuedMedications\" ng-maxlength=\"255\"></div></div><div class=\"col-v4-md mt-md-2\"><div class=\"form-group\"><label class=\"d-md-none safari_5\">{{ \'npqWorkflowMedications.Q5.2\' | translate }}</label><input type=\"text\" class=\"form-control\" name=\"sideEffectReasonStopping_{{$index}}\" ng-model=\"item.sideEffectReasonStopping\"></div></div><div class=\"col-v4-md-auto mt-md-2\"><div class=\"form-group\"><button class=\"btn btn-info\" ng-click=\"vm.removeMedicationStopped($index)\" ng-disabled=\"vm.workflow.answer.medicationStoppedsResponse.length == 1\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div></div></div><div class=\"col-v4-md-auto mt-md-2\"><button class=\"btn btn-info\" ng-click=\"vm.addMedicationStopped()\"><span class=\"glyphicon glyphicon-plus\"></span></button></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/past-medical-history.directive.html","<div class=\"form-group\"><label translate=\"npqWorkflowPastMedicalHistory.Q1\">Please check all that apply</label></div><div class=\"row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"group in vm.pastMedicalHistoryGroups track by $index\"><div class=\"form-row-v4\" ng-repeat=\"item in group.pastMedicalHistories track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"pastMedicalHistoryIdsSelected_{{group.id}}_{{item.id}}\" id=\"pastMedicalHistoryIdsSelected_{{group.id}}_{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.pastMedicalHistoryIdsSelected[item.id]\"><label class=\"form-check-label-v4\" for=\"pastMedicalHistoryIdsSelected_{{group.id}}_{{item.id}}\">{{item.nameLangKey | translate}}</label></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"row-v4\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"havePastMedicalHistoryOther\" ng-model=\"vm.workflow.answer.havePastMedicalHistoryOther\" id=\"other\"><label class=\"form-check-label-v4\" translate=\"npqQuestionnaire.text.OTHER\" for=\"other\">(list below)</label></div></div><div class=\"col-v4-12\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.pastMedicalHistoryOther\" ng-show=\"vm.workflow.answer.havePastMedicalHistoryOther == true\"></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/personal-injury.directive.html","<div class=\"pb-4\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowPersonalInjury.Q0\">Does the reason for your visit relate to an automotive accident?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" id=\"automotiveAccident.{{item}}\" name=\"automotiveAccident\" value=\"{{item}}\" ng-model=\"vm.workflow.automotiveAccident\"><label class=\"form-check-label-v4\" for=\"automotiveAccident.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div ng-show=\"vm.workflow.automotiveAccident === \'YES\'\"><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4-md-3\"><div class=\"form-group\"><label class=\"form-check-label-v4\"><span translate=\"npqWorkflowPersonalInjury.Q1.a.dateOfAccident\">Date of Accident</span></label><div class=\"input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"dateOfAccident\" name=\"dateOfAccident\" uib-datepicker-popup=\"MM/dd/yyyy\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" datepicker-options=\"vm.datePickerOptions\" ng-click=\"vm.datePickerOpenStatus.dateOfAccident = !vm.datePickerOpenStatus.dateOfAccident\" ng-model=\"vm.workflow.dateOfAccident\" is-open=\"vm.datePickerOpenStatus.dateOfAccident\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.dateOfAccident = !vm.datePickerOpenStatus.dateOfAccident\"></span></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q1.b.chooseOne\">Choose One:</span></label><div class=\"d-flex align-items-center\"><div class=\"col-v4 d-flex pl-0\"><div class=\"mr-4 d-flex align-items-center\" ng-repeat=\"item in [\'MOTO_VEHICLE_ACCIDENT\', \'OTHER\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"accidentType\" value=\"{{item}}\" ng-model=\"vm.workflow.accidentType\" id=\"{{item}}\"><label class=\"form-check-label-v4\" for=\"{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div><div class=\"col-v4-md-3 pl-0\" ng-show=\"vm.workflow.accidentType === \'OTHER\'\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.otherAccidentType\" ng-maxlength=\"255\"></div></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q1.c.rolesInAccident\">I was (Check all that apply):</span></label><div class=\"col-v4-md-3 pl-0\"><div ng-repeat=\"item in [\'DRIVER\', \'PASSENGER\', \'REAR_ENDED\', \'T_BONED\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"rolesInAccident_Q2_{{item}}\" name=\"rolesInAccident_Q2_{{item}}\" value=\"{{item}}\" ng-model=\"vm.workflow.rolesInAccidentSelected[item]\"><label class=\"form-check-label-v4\" for=\"rolesInAccident_Q2_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" type=\"checkbox\" id=\"rolesInAccident_Q2_OTHER\" name=\"rolesInAccident_Q2_OTHER\" value=\"OTHER\" ng-model=\"vm.workflow.rolesInAccidentSelected[\'OTHER\']\"><label class=\"form-check-label-v4\" for=\"rolesInAccident_Q2_OTHER\">{{\'npqQuestionnaire.text.personalInjury.OTHER\' | translate}}</label><span ng-show=\"vm.workflow.rolesInAccidentSelected[\'OTHER\']\"></span></div><div class=\"pr-0\" ng-show=\"vm.workflow.rolesInAccidentSelected[\'OTHER\']\"><input type=\"text\" class=\"form-control\" ng-maxlength=\"255\" ng-model=\"vm.workflow.otherRoleInAccident\"></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q1.d.impactToVehicle\">Impact to my vehicle was on the (Check all that apply):</span></label><div class=\"col-v4-md-3 pl-0\"><div ng-repeat=\"item in [\'RIGHT\', \'LEFT\', \'FRONT\', \'REAR\', \'SIDE\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"impactToVehicle_Q2_{{item}}\" name=\"impactToVehicle_Q2_{{item}}\" value=\"{{item}}\" ng-model=\"vm.workflow.impactToVehicleSelected[item]\"><label class=\"form-check-label-v4\" for=\"impactToVehicle_Q2_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-12 col-form-label-v4\">{{ \'npqWorkflowPersonalInjury.Q2\' | translate }}</div><div class=\"col-v4-md-auto col-v4\"><input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"vm.workflow.vehicleVelocity\" name=\"vehicleVelocity\" ng-maxlength=\"15\"><div ng-show=\"form.vehicleVelocity.$dirty\"><p class=\"help-block\" ng-if=\"form.vehicleVelocity.$error.max || form.vehicleVelocity.$error.min || form.vehicleVelocity.$error.maxlength || form.vehicleVelocity.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqQuestionnaire.text.personalInjury.MPH\">MPH</span></div></div><div class=\"row-v4\"><div class=\"col-v4-12 col-form-label-v4\">{{ \'npqWorkflowPersonalInjury.Q3\' | translate }}</div><div class=\"col-v4-md-auto col-v4\"><input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"vm.workflow.otherVehicleVelocity\" name=\"otherVehicleVelocity\" ng-maxlength=\"15\"><div ng-show=\"form.otherVehicleVelocity.$dirty\"><p class=\"help-block\" ng-if=\"form.otherVehicleVelocity.$error.max || form.otherVehicleVelocity.$error.min || form.otherVehicleVelocity.$error.maxlength || form.otherVehicleVelocity.$invalid\" translate=\"entity.validation.invalidValue\">invalid value</p></div></div><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqQuestionnaire.text.personalInjury.MPH\">MPH</span></div></div><div class=\"row-4 mt-3\"><div class=\"form-group\"><div><label><span translate=\"npqWorkflowPersonalInjury.Q4.a.seatBeltWorn\">Seat belt worn:</span></label></div><div class=\"d-flex\"><div class=\"mr-4 d-flex align-items-center\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-v4 form-check-inline-v4\" type=\"radio\" name=\"seatBeltWorn\" value=\"{{item}}\" ng-model=\"vm.workflow.seatBeltWorn\" id=\"seatBeltWorn_{{item}}\"><label class=\"form-check-label-v4\" for=\"seatBeltWorn_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div></div><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q4.b.airBagDeployed\">Air bag deployed:</span></label><div class=\"d-flex\"><div class=\"mr-4 d-flex align-items-center\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-v4 form-check-inline-v4\" type=\"radio\" name=\"airBagDeployed\" value=\"{{item}}\" ng-model=\"vm.workflow.airBagDeployed\" id=\"airBagDeployed_{{item}}\"><label class=\"form-check-label-v4\" for=\"airBagDeployed_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div></div><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q4.c.hitHead\">Did you hit your head:</span></label><div class=\"d-flex\"><div class=\"mr-4 d-flex align-items-center\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-v4 form-check-inline-v4\" type=\"radio\" name=\"hitHead\" value=\"{{item}}\" ng-model=\"vm.workflow.hitHead\" id=\"hitHead_{{item}}\"><label class=\"form-check-label-v4\" for=\"hitHead_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div></div></div><div class=\"row-4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q4.d.lostConsciousness\">Lost consciousness:</span></label><div class=\"d-flex\"><div class=\"mr-4 d-flex align-items-center\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"lostConsciousness\" value=\"{{item}}\" ng-model=\"vm.workflow.lostConsciousness\" id=\"lostConsciousness_{{item}}\"><label class=\"form-check-label-v4\" for=\"lostConsciousness_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div><div class=\"pt-2\" ng-show=\"vm.workflow.lostConsciousness === \'YES\'\"><label><span translate=\"npqWorkflowPersonalInjury.Q4.e.lostConsciousnessTime\">If yes, for how long?</span></label><div class=\"row-v4\"><div class=\"col-v4-md-auto col-v4\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.lostConsciousnessTime\" ng-maxlength=\"255\"></div></div></div></div></div><div class=\"row-4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q5.accidentDetails\">Please describe the accident in detail in your own words (Use back of sheet if needed):</span></label><textarea class=\"form-control auto-height none-resize\" ng-model=\"vm.workflow.accidentDetails\" rows=\"2\"></textarea></div></div><div class=\"row-v4-12\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q6.preferredHand\">I am:</span></label><div class=\"d-flex row-v4-12\"><div ng-repeat=\"item in [\'RIGHT_HANDED\', \'LEFT_HANDED\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"preferredHand_Q6_{{item}}\" name=\"impactToVehicle_Q6_{{item}}\" value=\"{{item}}\" ng-model=\"vm.workflow.preferredHandSelected[item]\"><label class=\"form-check-label-v4 mr-4\" for=\"preferredHand_Q6_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div></div></div></div><div class=\"row-4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q7.medicalSought\">Medical attention was sought:</span></label><div class=\"d-flex align-items-center\"><div class=\"col-v4 d-flex pl-0\"><div class=\"mr-4 d-flex align-items-center\" ng-repeat=\"item in [\'BY_AMBULANCE\', \'SAME_DAY\', \'ANOTHER_DAY\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"medicalSought\" value=\"{{item}}\" ng-model=\"vm.workflow.medicalSought\" id=\"medicalSought_{{item}}\"><label class=\"form-check-label-v4\" for=\"medicalSought_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div><div class=\"input-group-v4 col-v4-md-3 pl-0\" ng-show=\"vm.workflow.medicalSought === \'ANOTHER_DAY\'\"><input type=\"text\" class=\"form-control\" id=\"medicalSoughtDate\" name=\"medicalSoughtDate\" uib-datepicker-popup=\"MM/dd/yyyy\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" datepicker-options=\"vm.datePickerOptions\" ng-click=\"vm.datePickerOpenStatus.medicalSoughtDate = !vm.datePickerOpenStatus.medicalSoughtDate\" ng-model=\"vm.workflow.medicalSoughtDate\" is-open=\"vm.datePickerOpenStatus.medicalSoughtDate\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.medicalSoughtDate = !vm.datePickerOpenStatus.medicalSoughtDate\"></span></div></div></div></div></div></div><div class=\"row-4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q8.a.xRayPerformed\">X rays performed:</span></label><div class=\"d-flex align-items-center\"><div class=\"mr-4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"xRayPerformed\" value=\"{{item}}\" ng-model=\"vm.workflow.xRayPerformed\" id=\"xRayPerformed_{{item}}\"><label class=\"form-check-label-v4\" for=\"xRayPerformed_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div><div class=\"pt-2\"><label><span translate=\"npqWorkflowPersonalInjury.Q8.b.fractures\">Fractures:</span></label></div><div class=\"d-flex align-items-center\"><div class=\"mr-4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"fractures\" value=\"{{item}}\" ng-model=\"vm.workflow.fractures\" id=\"fractures_{{item}}\"><label class=\"form-check-label-v4\" for=\"fractures_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div><div class=\"pt-2\" ng-show=\"vm.workflow.fractures === \'YES\'\"><label><span translate=\"npqWorkflowPersonalInjury.Q8.c.fracturesDescribe\">If yes, describe?</span></label><div class=\"row-v4\"><div class=\"col-v4-md-auto col-v4\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.fracturesDescribe\" ng-maxlength=\"255\"></div></div></div></div></div><div class=\"row-4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowPersonalInjury.Q9.a.mriPerformed\">MRI\'s performed:</span></label><div class=\"d-flex align-items-center\"><div class=\"mr-4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"mriPerformed\" value=\"{{item}}\" ng-model=\"vm.workflow.mriPerformed\" id=\"mriPerformed_{{item}}\"><label class=\"form-check-label-v4\" for=\"mriPerformed_{{item}}\">{{\'npqQuestionnaire.text.personalInjury.\'+item | translate}}</label></div></div><div class=\"pt-2\" ng-show=\"vm.workflow.mriPerformed === \'YES\'\"><label><span translate=\"npqWorkflowPersonalInjury.Q9.b.mriBodyPart\">If yes, what body part?</span></label><div class=\"row-v4\"><div class=\"col-v4-md-auto col-v4\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.mriBodyPart\" ng-maxlength=\"255\"></div></div></div></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/present-complaints.directive.html","<p translate=\"npqWorkflowPresentComplaints.Q1\">Please checkmark the location(s) of your pain. If whole areas are painful, please checkmark the entire painful area. Checkmark any words that best describe your pain.</p><div class=\"border\"><div class=\"col-v4-lg-4 col-v4-md-6 border-right-md\"><div class=\"row\"><div class=\"col-xs-4\" translate=\"npqWorkflowPresentComplaints.RIGHT\">RIGHT</div><div class=\"col-xs-4 text-center\">({{ \'npqWorkflowPresentComplaints.FRONT\' | translate }})</div><div class=\"col-xs-4 text-right\" translate=\"npqWorkflowPresentComplaints.LEFT\">LEFT</div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"checkbox-group\"><div ng-repeat=\"front in vm.frontBody track by $index\" class=\"custom-control custom-checkbox front-{{$index+1}}\"><input type=\"checkbox\" class=\"custom-control-input\" id=\"front-{{$index+1}}\" ng-model=\"vm.workflow.answer.presentComplaintsFrontSelected[front]\"><label class=\"custom-control-label\" for=\"front-{{$index+1}}\"></label></div><img src=\"content/images/body-front.jpg\" class=\"img-responsive\"></div></div></div></div><div class=\"col-v4-lg-4 col-v4-md-6 border-right-lg border-top border-top-md-0\"><div class=\"row\"><div class=\"col-xs-4\" translate=\"npqWorkflowPresentComplaints.LEFT\">LEFT</div><div class=\"col-xs-4 text-center\">({{ \'npqWorkflowPresentComplaints.BACK\' | translate}})</div><div class=\"col-xs-4 text-right\" translate=\"npqWorkflowPresentComplaints.RIGHT\">RIGHT</div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"checkbox-group\"><div ng-repeat=\"back in vm.backBody track by $index\" class=\"custom-control custom-checkbox back-{{$index+1}}\"><input type=\"checkbox\" class=\"custom-control-input\" id=\"back-{{$index+1}}\" ng-model=\"vm.workflow.answer.presentComplaintsBackSelected[back]\"><label class=\"custom-control-label\" for=\"back-{{$index+1}}\"></label></div><img src=\"content/images/body-back.jpg\" class=\"img-responsive\"></div></div></div></div><div class=\"col-v4-md border-top border-top-lg-0 py-3\"><div class=\"row-v4 justify-content-center\"><div class=\"col-v4-auto\"><div class=\"form-check-v4\" ng-repeat=\"item in [\n                    \'SHARP\',\n                    \'CUTTING\',\n                    \'THROBBING\',\n                    \'DULL_ACHING\',\n                    \'PRESSURE\',\n                    \'MUSCLE_PAIN\',\n                    \'CRAMPING\',\n                    \'SHOOTING_OR_SHOCKING\',\n                    \'PINS_AND_NEEDLES\'] track by $index\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"presentComplaintPainsLocationSelected_{{item}}\" ng-model=\"vm.workflow.answer.presentComplaintPainsLocationSelected[item]\" id=\"presentComplaintPainsLocationSelected_{{item}}\"><label class=\"form-check-label-v4\" for=\"presentComplaintPainsLocationSelected_{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div></div></div><p translate=\"npqWorkflowPresentComplaints.Q2\">Please check the areas in which you are experiencing pain below</p><div class=\"row-v4\"><div class=\"col-v4-lg-4 col-v4-md-6\" ng-repeat=\"pain in vm.workflow.answer.experiencesPain track by $index\"><div class=\"form-row-v4 align-items-center\" ng-if=\"pain.bodyPartPains != \'OTHER\'\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"pain_{{item}}\" ng-model=\"pain.checked\" id=\"{{pain.bodyPartPains}}\"><label class=\"form-check-label-v4\" for=\"{{pain.bodyPartPains}}\">{{\'npqQuestionnaire.text.presentComplaints.\'+ pain.bodyPartPains | translate}}</label><span ng-if=\"pain.checked && pain.bodyPartPains !== \'HEAD\'\n                    && pain.bodyPartPains !== \'NECK\'\n                    && pain.bodyPartPains !== \'UPPER_BACK\'\n                    && pain.bodyPartPains !== \'HEADACHES\'\n                    && pain.bodyPartPains !== \'LOWER_BACK\'\n                    && pain.bodyPartPains !== \'MID_BACK\'\n                    && pain.bodyPartPains !== \'LOWER_BACK\'\n                    && pain.bodyPartPains !== \'OTHER\'\" aria-hidden=\"true\"></span></div></div><div class=\"col-v4-12 mb-3\" ng-if=\"pain.checked && pain.bodyPartPains !== \'HEAD\'\n                && pain.bodyPartPains !== \'NECK\'\n                && pain.bodyPartPains !== \'UPPER_BACK\'\n                && pain.bodyPartPains !== \'HEADACHES\'\n                && pain.bodyPartPains !== \'LOWER_BACK\'\n                && pain.bodyPartPains !== \'MID_BACK\'\n                && pain.bodyPartPains !== \'LOWER_BACK\'\n                && pain.bodyPartPains !== \'OTHER\'\"><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'L\', \'R\', \'BOTH\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" value=\"{{item}}\" ng-model=\"pain.bodyPartPainsExtraInfo\" id=\"{{pain.bodyPartPains}}_{{item}}\"><label class=\"form-check-label-v4\" for=\"{{pain.bodyPartPains}}_{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div class=\"form-row-v4\" ng-if=\"pain.bodyPartPains == \'OTHER\'\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"pain_{{item}}\" ng-model=\"pain.checked\" id=\"other\"><label class=\"form-check-label-v4\" for=\"other\">{{\'npqQuestionnaire.text.presentComplaints.\'+ pain.bodyPartPains | translate}}</label><span ng-if=\"pain.checked\" aria-hidden=\"true\"></span></div></div><div class=\"col-v4-12\"><input type=\"text\" class=\"form-control\" ng-if=\"pain.checked\" ng-model=\"pain.bodyPartPainsExtraInfo\"></div></div></div></div><div class=\"form-row-v4 mt-3\"><div class=\"col-v4-auto col-form-label-v4\"><span translate=\"npqWorkflowPresentComplaints.Q3\">What is your current pain on a scale of 1-10 (10 being the worst)</span></div><div class=\"col-v4-xl-1 col-v4-md-2\"><select class=\"form-control\" name=\"presentComplaintCurrentPainScale\" ng-model=\"vm.workflow.answer.presentComplaintCurrentPainScale\" ng-options=\"x for x in [1,2,3,4,5,6,7,8,9,10]\"><option value=\"\" selected=\"selected\"></option></select></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/review-of-systems.directive.html","<div class=\"form-group\"><span translate=\"npqWorkflowReviewOfSystems.currentSystoms\">Please check your current symptoms only.</span></div><div class=\"form-row-v4\"><div class=\"col-v4-lg-3 col-v4-md-4 fix-height\" ng-repeat=\"group in vm.symptomGroups track by $index\"><div class=\"form-row-v4\"><div class=\"col-v4-12 category\">{{group.nameLangKey | translate}}</div><div class=\"col-v4-12\"><div class=\"form-row-v4\"><div class=\"col-v4-12\" ng-repeat=\"item in group.symptomsSorted track by $index\"><div class=\"form-check-v4 align-items-start\" ng-class=\"(item.id == null) ? \'d-none\' : \'\'\"><input class=\"form-check-input-v4\" ng-if=\"item.id != null\" type=\"checkbox\" name=\"symptomIdsSelected_{{group.id}}_{{item.id}}\" id=\"symptomIdsSelected_{{group.id}}_{{item.id}}\" value=\"{{item.id}}\" ng-model=\"vm.workflow.answer.symptomIdsSelected[item.id]\" ng-disabled=\"item.disabled\" ng-change=\"vm.symptomChanged(group)\"><label class=\"form-check-label-v4 max-w\" for=\"symptomIdsSelected_{{group.id}}_{{item.id}}\">{{item.nameLangKey | translate}}&nbsp;</label></div></div></div></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/social-history.directive.html","<div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowSocialHistory.Q1\">Do you drink alcohol?</label><div class=\"form-check-v4 form-check-inline-v4-md\" ng-repeat=\"item in [\'NOT_AT_ALL\', \'RARELY\', \'OCCASIONALLY\', \'OFTEN\', \'EVERY_DAY\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"drinkAlcohol\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.drinkAlcohol\" id=\"drinkAlcohol.{{item}}\"><label class=\"form-check-label-v4\" for=\"drinkAlcohol.{{item}}\">{{\'npqQuestionnaire.text.socialHistory.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowSocialHistory.Q2\">Have you ever abused alcohol?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"everAbusedAlcohol\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.everAbusedAlcohol\" id=\"everAbusedAlcohol.{{item}}\"><label class=\"form-check-label-v4\" for=\"everAbusedAlcohol.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowSocialHistory.Q3\">Have you ever been in Alcoholics Anonymous?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"everBeenInAlcoholicsAnonymous\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.everBeenInAlcoholicsAnonymous\" id=\"everBeenInAlcoholicsAnonymous.{{item}}\"><label class=\"form-check-label-v4\" for=\"everBeenInAlcoholicsAnonymous.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowSocialHistory.Q4\">Have you ever abused drugs?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"everAbusedDrugs\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.everAbusedDrugs\" id=\"everAbusedDrugs.{{item}}\"><label class=\"form-check-label-v4\" for=\"everAbusedDrugs.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.everAbusedDrugs === \'YES\'\"><label translate=\"npqWorkflowSocialHistory.Q4.1\">If yes, please name them</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.drugNames\" ng-maxlength=\"255\"></div><div class=\"form-group\"><label class=\"d-block\" translate=\"npqWorkflowSocialHistory.Q5\">Do you currently smoke?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\', \'I_QUIT_SMOKING\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"currentlySmoke\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.currentlySmoke\" id=\"currentlySmoke.{{item}}\"><label class=\"form-check-label-v4\" for=\"currentlySmoke.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.currentlySmoke == \'I_QUIT_SMOKING\'\"><label translate=\"npqWorkflowSocialHistory.quitWhen\">When</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.quitWhen\" ng-maxlength=\"255\"></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/treatment-history.directive.html","<div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"pb-2\"><label class=\"text-uppercase\" translate=\"npqWorkflowTreatmentHistory.Q1\">Conservative Treatments</label></div><div class=\"row-v4\" ng-repeat=\"item in vm.workflow.answer.conservativeTreatmentsResponse track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"conservativeTreatment-{{$index}}\" ng-model=\"item.checked\" id=\"{{item.conservativeTreatment.nameLangKey}}\"><label class=\"form-check-label-v4\" for=\"{{item.conservativeTreatment.nameLangKey}}\">{{item.conservativeTreatment.nameLangKey | translate}}</label></div><div class=\"row-v4\" ng-show=\"item.checked\"><div class=\"col-v4-12\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.howMany\">How Many</span></label><input type=\"text\" class=\"form-control\" name=\"conservativeTreatment-howMany-{{item.conservativeTreatment.id}}\" ng-model=\"item.howMany\" ng-maxlength=\"255\"></div></div><div class=\"col-v4-12\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqQuestionnaire.text.helpFul\">Helpful? Circle Yes or No</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"opt in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"conservativeTreatment-helpful-{{item.conservativeTreatment.id}}\" value=\"{{opt}}\" id=\"conservativeTreatment_{{item.conservativeTreatment.id}}_{{opt}}\" ng-model=\"item.helpful\"><label class=\"form-check-label-v4\" for=\"conservativeTreatment_{{item.conservativeTreatment.id}}_{{opt}}\">{{\'npqQuestionnaire.text.\'+opt | translate}}</label></div></div></div></div></div></div></div><div class=\"col-v4-md pt-4 pt-md-0\"><div class=\"pb-2\"><label class=\"text-uppercase\" translate=\"npqWorkflowTreatmentHistory.Q2\">Interventions</label></div><div class=\"row-v4\" ng-repeat=\"item in vm.workflow.answer.interventionsResponse track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"intervention-{{$index}}\" ng-model=\"item.checked\" id=\"{{item.intervention.nameLangKey}}\"><label class=\"form-check-label-v4\" for=\"{{item.intervention.nameLangKey}}\">{{item.intervention.nameLangKey | translate}}</label></div><div class=\"row-v4\" ng-show=\"item.checked\"><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.howMany\">How Many</span></label><input type=\"text\" class=\"form-control\" name=\"intervention-howMany-{{item.intervention.id}}\" ng-model=\"item.howMany\" ng-maxlength=\"255\"></div></div><div class=\"col-v4-md-6\" ng-show=\"item.intervention.code == \'SJIWJ\'\"><div class=\"form-group\"><label><span translate=\"npqQuestionnaire.text.whichJoint\">Which Joint</span></label><input type=\"text\" class=\"form-control\" name=\"intervention-whichJoint-{{item.intervention.id}}\" ng-model=\"item.whichJoint\"></div></div><div class=\"col-v4-12\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqQuestionnaire.text.helpFul\">Helpful? Circle Yes or No</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"opt in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"intervention-helpful-{{item.intervention.id}}\" value=\"{{opt}}\" id=\"intervention.{{item.intervention.id}}.{{opt}}\" ng-model=\"item.helpful\" ng-model=\"item.helpful\"><label class=\"form-check-label-v4\" for=\"intervention.{{item.intervention.id}}.{{opt}}\">{{\'npqQuestionnaire.text.\'+opt | translate}}</label></div></div></div></div></div></div></div></div>");
$templateCache.put("app/npq-questionnaire/workflow/partial/directive/work-related-injuries.directive.html","<div class=\"pb-4\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowWorkRelatedInjuries.Q1\">Is your injury work related, or covered by worker\'s compensation?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" id=\"coveredWorkerCompensation.{{item}}\" name=\"coveredWorkerCompensation\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.coveredWorkerCompensation\"><label class=\"form-check-label-v4\" for=\"coveredWorkerCompensation.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div><div ng-show=\"vm.workflow.answer.coveredWorkerCompensation === \'YES\'\"><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a\">Who is the Worker\'s Compensation Carrier?</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.workerCompensationCarrier\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-lg-3 col-v4-md-auto\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.claimNumber\">Claim Number</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.claimNumber\" ng-maxlength=\"20\"></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.claimsAdjuster\">Claims Adjuster</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.claimsAdjusterName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.telephone\">Telephone</span></label><input type=\"text\" class=\"form-control\" phone-input ng-model=\"vm.workflow.answer.claimsAdjusterTelephone\" ng-maxlength=\"20\"></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.fax\">Fax</span></label><input type=\"text\" class=\"form-control\" phone-input ng-model=\"vm.workflow.answer.claimsAdjusterFax\" ng-maxlength=\"20\"></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.nurseCaseManager\">Nurse Case Manager</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.nurseCaseManagerName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.telephone\">Telephone</span></label><input type=\"text\" class=\"form-control\" phone-input ng-model=\"vm.workflow.answer.nurseCaseManagerTelephone\" ng-maxlength=\"20\"></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.fax\">Fax</span></label><input type=\"text\" class=\"form-control\" phone-input ng-model=\"vm.workflow.answer.nurseCaseManagerFax\" ng-maxlength=\"20\"></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.attorneyName\">Attorney Name</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.attorneyName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md-6\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.attorneyFirm\">Attorney Firm</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.attorneyFirm\" ng-maxlength=\"150\"></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.email\">Attorney Email</span></label><input type=\"email\" class=\"form-control\" ng-model=\"vm.workflow.answer.attorneyEmail\" ng-maxlength=\"255\" ng-pattern=\"constants.EMAIL_PATTERN\"></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.telephone\">Telephone</span></label><input type=\"text\" class=\"form-control\" phone-input ng-model=\"vm.workflow.answer.attorneyTelephone\" ng-maxlength=\"20\"></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.fax\">Fax</span></label><input type=\"text\" class=\"form-control\" phone-input ng-model=\"vm.workflow.answer.attorneyFax\" ng-maxlength=\"20\"></div></div></div></div><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4-md-9\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.employer\">Employer</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.employer\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md-3\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.dateOfInjury\">Date of Injury</span></label><div class=\"input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"dateOfInjury\" name=\"dateOfInjury\" uib-datepicker-popup=\"MM/dd/yyyy\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" datepicker-options=\"vm.datePickerOptions\" ng-click=\"vm.datePickerOpenStatus.dateOfInjury = !vm.datePickerOpenStatus.dateOfInjury\" ng-model=\"vm.workflow.answer.dateOfInjury\" is-open=\"vm.datePickerOpenStatus.dateOfInjury\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.dateOfInjury = !vm.datePickerOpenStatus.dateOfInjury\"></span></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-9\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.jobTitle\">Job title at time of injury</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.jobTitle\" ng-maxlength=\"255\"></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q1.a.forHowLong\">For how long?</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.forHowLong\" ng-maxlength=\"255\"></div></div></div></div><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowWorkRelatedInjuries.Q2\">Do you have more than one Claim open (multiple injuries)?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"claimOpen\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.claimOpen\" id=\"claimOpen.{{item}}\"><label class=\"form-check-label-v4\" for=\"claimOpen.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowWorkRelatedInjuries.Q3\">Are you designated</span></label><div class=\"form-check-v4 form-check-inline-v4-lg\" ng-repeat=\"item in [\'TEMPORARILY_DISABLED\', \'PERMANENTLY_DISABLED\', \'PERMANENT_AND_STATIONARY\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"designated\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.designated\" id=\"{{item}}\"><label class=\"form-check-label-v4\" for=\"{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowWorkRelatedInjuries.Q4\">Are there any disputed body parts (parts not accepted by the insurer)?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"areThereAnyDisputedBodyParts\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.areThereAnyDisputedBodyParts\" id=\"areThereAnyDisputedBodyParts.{{item}}\"><label class=\"form-check-label-v4\" for=\"areThereAnyDisputedBodyParts.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.areThereAnyDisputedBodyParts === \'YES\'\"><label><span translate=\"npqWorkflowWorkRelatedInjuries.Q4.a\">If yes, please list these disputed body parts</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.disputedBodyParts\" ng-maxlength=\"255\"></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"form-group\"><label class=\"relatedInjuries-q5\"><span translate=\"npqWorkflowWorkRelatedInjuries.Q5\">Who is your current primary treating physician?</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.currentPrimaryTreatingPhysician\" ng-maxlength=\"255\"></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"npqWorkflowWorkRelatedInjuries.Q6\">Are you currently working?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"currentlyWorking\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.currentlyWorking\" id=\"currentlyWorking.{{item}}\"><label class=\"form-check-label-v4\" for=\"currentlyWorking.{{item}}\">{{\'npqQuestionnaire.text.\'+item | translate}}</label></div></div></div></div><div class=\"row-v4\" ng-show=\"vm.workflow.answer.currentlyWorking == \'NO\'\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label class=\"relatedInjuries-q6\"><span translate=\"npqWorkflowWorkRelatedInjuries.Q6.a\">If not, when is the last day you worked?</span></label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6 input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"lastDayWorked\" name=\"lastDayWorked\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"vm.datePickerOptions\" ng-model=\"vm.workflow.answer.lastDayWorked\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"vm.datePickerOpenStatus.lastDayWorked = !vm.datePickerOpenStatus.lastDayWorked\" is-open=\"vm.datePickerOpenStatus.lastDayWorked\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.lastDayWorked = !vm.datePickerOpenStatus.lastDayWorked\"></span></div></div><div class=\"col-v4-sm-6\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"lastDayWorkedUnsure\" ng-model=\"vm.workflow.answer.lastDayWorkedUnsure\"><label class=\"form-check-label-v4\" for=\"lastDayWorkedUnsure\" translate=\"npqQuestionnaire.text.label.unsureOfDate\">Unsure of date</label></div></div></div></div></div></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/agreement-patient-acknowledgement.directive.html","<div class=\"col-v4-12 text-justify\"><div class=\"h4 bold text-center mb-1\"><span translate=\"psychIntake.agreements.workflow.patientAcknowledgement\">Patient Acknowledgement</span></div><p translate=\"psychIntake.agreements.patientAcknowledgement.p1\" translate-values=\"{patientName: \'{{vm.workflow.answer.agreement.patientName}}\'}\">paragraph 1</p></div><div class=\"row-v4 justify-content-center fix-on-safari-5\"><div class=\"col-v4-auto\"><label class=\"mb-3\">{{\'psychIntake.agreements.home.signature\' | translate}}</label><signature-pad width=\"auto\" height=\"200\" on-change=\"vm.onChangeSignature(data)\" remove-blank=\"true\" clear=\"true\" get=\"false\" disabled=\"false\"></signature-pad></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/agreement-pcsg-information-policies.directive.html","<div class=\"col-v4-12 text-justify\"><div class=\"h4 bold text-center mb-1\"><span translate=\"psychIntake.agreements.workflow.pcsgInformationPolicies\">Pain Coping Skills Group (PCSG) Information & Policies</span></div><div class=\"row\"><div class=\"col-md-12 h4 title\" translate=\"psychIntake.agreements.pcsgInformationPolicies.information\">PCSG Information</div></div><p translate=\"psychIntake.agreements.pcsgInformationPolicies.p1\">paragraph 1</p><p translate=\"psychIntake.agreements.pcsgInformationPolicies.p2\">paragraph 2</p><ul class=\"bullet mb-4\"><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p2.1\">1</li><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p2.2\">2</li><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p2.3\">3</li><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p2.4\">4</li><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p2.5\">5</li><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p2.6\">6</li></ul><div class=\"row\"><div class=\"col-md-12 h4 title\" translate=\"psychIntake.agreements.pcsgInformationPolicies.confidentiality\">PCSG Confidentiality</div></div><ul class=\"bullet bullet-decimal mb-4\"><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p3\">paragraph 3</li><li translate=\"psychIntake.agreements.pcsgInformationPolicies.p4\">paragraph 4</li></ul></div><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"psychIntake.agreements.text.patientName\">Patient Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.workflow.answer.agreement.patientName\" ng-maxlength=\"150\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"psychIntake.agreements.text.patientName.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"psychIntake.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.workflow.answer.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"psychIntake.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/agreement-policies-procedures.directive.html","<div class=\"col-v4-12 policiesProcedures text-justify\"><div class=\"h4 bold text-center mb-1\"><span translate=\"psychIntake.agreements.workflow.policiesProcedures\">Policies and Procedures</span></div><ul class=\"bullet bullet-decimal mb-4\"><li translate=\"psychIntake.agreements.policiesProcedures.p1\">paragraph 1</li><li translate=\"psychIntake.agreements.policiesProcedures.p2\">paragraph 2</li><li translate=\"psychIntake.agreements.policiesProcedures.p3\">paragraph 3</li><li translate=\"psychIntake.agreements.policiesProcedures.p4\">paragraph 4</li><li translate=\"psychIntake.agreements.policiesProcedures.p5\">paragraph 5</li><li translate=\"psychIntake.agreements.policiesProcedures.p6\">paragraph 6</li><li translate=\"psychIntake.agreements.policiesProcedures.p7\">paragraph 7</li><li translate=\"psychIntake.agreements.policiesProcedures.p8\">paragraph 8</li><li translate=\"psychIntake.agreements.policiesProcedures.p9\">paragraph 9</li><ul class=\"bullet bullet-lower-alpha mb-4\"><li><span translate=\"psychIntake.agreements.policiesProcedures.p9.a\">9.a</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.a.address\">address</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.a.city\">city</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.a.phone\">phone</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.a.www\">www</span></li><li><span translate=\"psychIntake.agreements.policiesProcedures.p9.b\">9.b</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.b.name\">name</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.b.address\">address</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.b.city\">city</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.b.phone\">phone</span><br><span translate=\"psychIntake.agreements.policiesProcedures.p9.b.www\">www</span></li></ul></ul></div><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"psychIntake.agreements.text.patientName\">Patient Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.workflow.answer.agreement.patientName\" ng-maxlength=\"150\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"psychIntake.agreements.text.patientName.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"psychIntake.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.workflow.answer.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"psychIntake.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/agreement-privacy-practice.directive.html","<div class=\"col-v4-12 text-justify\"><div class=\"h4 bold text-center mb-1\"><span translate=\"psychIntake.agreements.workflow.privacyPractice\">Notice of Privacy Practice</span></div><ul class=\"bullet bullet-decimal mb-4\"><li translate=\"psychIntake.agreements.privacyPractice.p1\">paragraph 1</li><ul class=\"bullet bullet-lower-alpha mb-4\"><li translate=\"psychIntake.agreements.privacyPractice.p1.a\">1.a</li><li translate=\"psychIntake.agreements.privacyPractice.p1.b\">1.b</li><li translate=\"psychIntake.agreements.privacyPractice.p1.c\">1.c</li><li translate=\"psychIntake.agreements.privacyPractice.p1.d\">1.d</li><li translate=\"psychIntake.agreements.privacyPractice.p1.e\">1.e</li><li translate=\"psychIntake.agreements.privacyPractice.p1.f\">1.f</li><li translate=\"psychIntake.agreements.privacyPractice.p1.g\">1.g</li><li translate=\"psychIntake.agreements.privacyPractice.p1.h\">1.h</li><li translate=\"psychIntake.agreements.privacyPractice.p1.i\">1.i</li><li translate=\"psychIntake.agreements.privacyPractice.p1.j\">1.j</li><li translate=\"psychIntake.agreements.privacyPractice.p1.k\">1.k</li><li translate=\"psychIntake.agreements.privacyPractice.p1.l\">1.l</li><li translate=\"psychIntake.agreements.privacyPractice.p1.m\">1.m</li><li translate=\"psychIntake.agreements.privacyPractice.p1.n\">1.n</li><li translate=\"psychIntake.agreements.privacyPractice.p1.o\">1.o</li><li translate=\"psychIntake.agreements.privacyPractice.p1.p\">1.p</li><li translate=\"psychIntake.agreements.privacyPractice.p1.q\">1.q</li><li translate=\"psychIntake.agreements.privacyPractice.p1.r\">1.r</li></ul><li translate=\"psychIntake.agreements.privacyPractice.p2\">paragraph 2</li><ul class=\"bullet bullet-lower-alpha mb-4\"><li translate=\"psychIntake.agreements.privacyPractice.p2.a\">2.a</li></ul><li translate=\"psychIntake.agreements.privacyPractice.p3\">paragraph 3</li><ul class=\"bullet bullet-lower-alpha mb-4\"><li translate=\"psychIntake.agreements.privacyPractice.p3.a\">3.a</li><ul class=\"bullet bullet-lower-roman mb-4\"><li><span translate=\"psychIntake.agreements.privacyPractice.p3.a.department\">department</span><br><span translate=\"psychIntake.agreements.privacyPractice.p3.a.office\">office</span><br><span translate=\"psychIntake.agreements.privacyPractice.p3.a.address\">address</span><br><span translate=\"psychIntake.agreements.privacyPractice.p3.a.room\">room</span><br><span translate=\"psychIntake.agreements.privacyPractice.p3.a.building\">building</span><br><span translate=\"psychIntake.agreements.privacyPractice.p3.a.city\">city</span></li></ul></ul></ul></div><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"psychIntake.agreements.text.patientName\">Patient Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.workflow.answer.agreement.patientName\" ng-maxlength=\"150\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"psychIntake.agreements.text.patientName.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"psychIntake.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.workflow.answer.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"psychIntake.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/agreement-psychotherapy-sessions.directive.html","<div class=\"col-v4-12 text-justify\"><div class=\"h4 bold text-center mb-1\"><span translate=\"psychIntake.agreements.workflow.psychotherapySessions\">Limits of Confidentiality and Informed Consent: Psychotherapy Sessions</span></div><ul class=\"bullet bullet-decimal mb-4\"><li translate=\"psychIntake.agreements.psychotherapySessions.p1\">paragraph 1</li><li translate=\"psychIntake.agreements.psychotherapySessions.p2\">paragraph 2</li><ul class=\"bullet bullet-disc mb-4\"><li translate=\"psychIntake.agreements.psychotherapySessions.p2.1\">paragraph 2.1</li><li translate=\"psychIntake.agreements.psychotherapySessions.p2.2\">paragraph 2.2</li><li translate=\"psychIntake.agreements.psychotherapySessions.p2.3\">paragraph 2.3</li><li translate=\"psychIntake.agreements.psychotherapySessions.p2.4\">paragraph 2.4</li></ul><li translate=\"psychIntake.agreements.psychotherapySessions.p3\">paragraph 3</li><li translate=\"psychIntake.agreements.psychotherapySessions.p4\">paragraph 4</li></ul></div><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"psychIntake.agreements.text.patientName\">Patient Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.workflow.answer.agreement.patientName\" ng-maxlength=\"150\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"psychIntake.agreements.text.patientName.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"psychIntake.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.workflow.answer.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"psychIntake.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/agreement-telehealth-informed-consent.directive.html","<div class=\"col-v4-12 text-justify\"><div class=\"h4 bold text-center mb-1\"><span translate=\"psychIntake.agreements.workflow.telehealthInformedConsent\">Telehealth Informed Consent</span></div><p translate=\"psychIntake.agreements.telehealthInformedConsent.p1\" translate-values=\"{patientName: \'{{vm.workflow.answer.agreement.patientName}}\'}\">paragraph 1</p><p translate=\"psychIntake.agreements.telehealthInformedConsent.p2\">paragraph 2</p><ul class=\"bullet bullet-decimal mb-4\"><li translate=\"psychIntake.agreements.telehealthInformedConsent.p2.1\">1</li><li translate=\"psychIntake.agreements.telehealthInformedConsent.p2.2\">2</li><li translate=\"psychIntake.agreements.telehealthInformedConsent.p2.3\">3</li><li translate=\"psychIntake.agreements.telehealthInformedConsent.p2.4\">4</li><li translate=\"psychIntake.agreements.telehealthInformedConsent.p2.5\">5</li><li translate=\"psychIntake.agreements.telehealthInformedConsent.p2.6\">6</li><li translate=\"psychIntake.agreements.telehealthInformedConsent.p2.7\">7</li></ul><div class=\"row\"><div class=\"col-md-12 h4 title\" translate=\"psychIntake.agreements.telehealthInformedConsent.emergencyProtocols\">Emergency Protocols</div></div><ul class=\"bullet bullet-decimal mb-4\"><li translate=\"psychIntake.agreements.telehealthInformedConsent.p3\">paragraph 3</li><li translate=\"psychIntake.agreements.telehealthInformedConsent.p4\">paragraph 4</li></ul></div><div class=\"row mt-4\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group\"><label translate=\"psychIntake.agreements.text.patientName\">Patient Name</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"text\" class=\"form-control\" name=\"patientName\" id=\"patientName\" required ng-model=\"vm.workflow.answer.agreement.patientName\" ng-maxlength=\"150\"><div ng-show=\"agreementForm.patientName.$dirty && agreementForm.patientName.$invalid\"><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.required\" translate=\"psychIntake.agreements.text.patientName.required\">This field is required.</div><div class=\"help-block\" ng-show=\"agreementForm.patientName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</div></div></div></div><div class=\"col-sm-8 col-xs-12\"><div class=\"form-group\"><div class=\"signature-placeholder\" translate=\"psychIntake.agreements.text.signaturePlaceholder\"></div></div></div></div><div class=\"mb-4 text-center\"><input class=\"form-check-input-v4\" type=\"checkbox\" name=\"chbox_iagree\" ng-model=\"vm.workflow.answer.agreement.agree\" id=\"chbox_iagree\" required><label class=\"form-check-label-v4 text-large\" translate=\"psychIntake.agreements.text.iAgree\" for=\"chbox_iagree\">I Agree</label></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/chief-complaint.directive.html","<div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.chiefComplaint.reasonSeekingHelp\">Main Reason for Seeking Help</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.reasonSeekingHelp\" ng-maxlength=\"255\" required></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.chiefComplaint.currentSymptoms\">Current Symptoms</span></label><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'ANXIETY\', \'DEPRESSION\', \'SLEEP_PROBLEMS\', \'IRRITABILITY_ANGER\', \'PANIC_ATTACKS\', \'NIGHTMARES_FLASHBACKS\', \'OTHER\', \'NONE\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"currentSymptoms_{{item}}\" name=\"currentSymptoms_{{item}}\" ng-disabled=\"vm.disabledCheck(item)\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.currentSymptomsSelected[item]\"><label class=\"form-check-label-v4\" for=\"currentSymptoms_{{item}}\"><span>{{\'psychIntake.chiefComplaint.symptom.\'+item | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" style=\"top: 0\" ng-if=\"item === \'OTHER\' && vm.workflow.answer.currentSymptomsSelected[\'OTHER\']\"></span></label></div></div><div class=\"col-v4-md-6\"><div class=\"form-row-v4\"><div class=\"col-v4-md\" ng-show=\"vm.workflow.answer.currentSymptomsSelected[\'OTHER\']\"><input type=\"text\" class=\"form-control\" ng-maxlength=\"255\" ng-model=\"vm.workflow.answer.otherCurrentSymptoms\" ng-required=\"vm.workflow.answer.currentSymptomsSelected[\'OTHER\']\"></div></div></div></div></div></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/demographics.directive.html","<div class=\"form-group\"><label translate=\"psychIntake.demographics.prompt\">Please complete this questionnaire before your first clinic appointment. Your careful answers will help us to understand your pain problem and design the most appropriate treatment program for you.</label></div><div class=\"pb-4\"><div class=\"row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label class=\"d-block\" translate=\"psychIntake.demographics.Q1\">In today\'s interview and examination, will you need the assistance of an interpreter?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"needAssistance\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.needAssistance\" id=\"Q1-{{item}}\"><label class=\"form-check-label-v4\" for=\"Q1-{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.needAssistance === \'YES\'\"><label><span translate=\"psychIntake.demographics.Q1.a\">If you know, what is the interpreter\'s name?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.interpreterName\" ng-maxlength=\"150\" ng-required=\"vm.workflow.answer.needAssistance === \'YES\'\"></div></div></div></div><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4-md-7 order-first\"><div class=\"row-v4\"><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.lastName\" ng-maxlength=\"50\" name=\"lastName\" required></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.firstName\">First Name</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.firstName\" ng-maxlength=\"50\" name=\"firstName\" required></div></div><div class=\"col-v4-lg-4 col-v4-md\"><div class=\"form-group\"><label translate=\"psychIntake.demographics.middleInit\">Middle Initl</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.middleName\" ng-maxlength=\"50\"></div></div></div></div><div class=\"col-v4-md-5 order-lg-2 order-last\"><div class=\"row-v4\"><div class=\"col-v4-lg-auto col-v4-md-4\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.demographics.genderAtBirth\">Sex at Birth</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'M\', \'F\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"genderAtBirth\" value=\"{{item}}\" id=\"genderAtBirth.{{item}}\" ng-model=\"vm.workflow.answer.genderAtBirth\"><label class=\"form-check-label-v4\" for=\"genderAtBirth.{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div></div><div class=\"col-v4-lg-auto col-v4-md\"><div class=\"form-group\"><label translate=\"psychIntake.demographics.genderYouIdentifyWith\">Preferred pronouns</label><input type=\"text\" class=\"form-control\" ng-maxlength=\"30\" placeholder=\"{{\'psychIntake.demographics.preferredPronouns\' | translate}}\" ng-model=\"vm.workflow.answer.genderYouIdentifyWith\"></div></div><div class=\"col-v4-lg-auto col-v4-md\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.demographics.genderIndentity\">Gender Indentity</span></label><!-- <div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'M\', \'F\'] track by $index\">\n                            <input class=\"form-check-input-v4\" type=\"radio\" name=\"genderIndentity\" value=\"{{item}}\"\n                                   id=\"genderIndentity.{{item}}\"\n                                   ng-model=\"vm.workflow.answer.genderIndentity\">\n                            <label class=\"form-check-label-v4\" for=\"genderIndentity.{{item}}\"> {{\'psychIntake.text.\'+item | translate}}</label>\n                        </div> --> <input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.genderIndentity\" ng-maxlength=\"50\"></div></div></div></div></div></div><div class=\"pb-5\"><div class=\"row-v4\"><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.homeTelephone\">Home telephone</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.homeTelephone\" name=\"homeTelephone\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input required></div></div><div class=\"col-v4\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.cellNumber\">Cell Number</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.cellNumber\" name=\"cellNumber\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input> <span translate=\"psychIntake.demographics.cellNumberMessages\">By providing your phone number, you agree to receive text messages from Boomerang Healthcare. Message and data rates may apply. Message frequency varies.</span></div></div><div class=\"col-v4-md-6\"><div class=\"form-group\"><label translate=\"psychIntake.demographics.emailAddress\">Email Address</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span> <input type=\"email\" class=\"form-control\" ng-model=\"vm.workflow.answer.emailAddress\" ng-maxlength=\"255\" ng-pattern=\"constants.EMAIL_PATTERN\" required></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6 order-first\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.homeAddress\">Home Address</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.homeAddress\" ng-maxlength=\"255\" required></div></div><div class=\"col-v4-md-6 order-lg-2 order-last\"><div class=\"row-v4\"><div class=\"col-v4-lg-auto col-v4-md-4\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.demographics.city\">City</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.city\" ng-maxlength=\"50\" required></div></div><div class=\"col-v4-lg-auto col-v4-md\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.demographics.state\">State</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.state\" ng-maxlength=\"50\" required></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.demographics.zip\">ZIP</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.zip\" ng-maxlength=\"10\" required></div></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-lg-12\"><div class=\"row-v4\"><div class=\"col-v4-lg-4 col-v4-md\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.emergencyContactFirstName\">Emergency Contact First Name</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.emergencyContactFirstName\" ng-maxlength=\"50\" required></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.emergencyContactLastName\">Emergency Contact Last Name</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.emergencyContactLastName\" ng-maxlength=\"50\" required></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label><span translate=\"psychIntake.demographics.emergencyContactPhone\">Emergency Contact Phone Number</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.emergencyContactPhone\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input required></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-lg-12\"><div class=\"row-v4\"><div class=\"col-v4-lg-8 col-v4-md\"><div class=\"form-group\"><label translate=\"psychIntake.demographics.referringDoctor\">Referring Doctor/Attorney/Other</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.referringName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md\"><div class=\"form-group\"><label translate=\"psychIntake.demographics.phone\">Phone</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.referringPhone\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input></div></div></div></div></div><div class=\"pb-4\"><!--\n    <div class=\"row-v4\">\n        <div class=\"col-v4-12\">\n            <div class=\"form-group\">\n                <label class=\"d-block\" translate=\"psychIntake.demographics.Q2\">Is this the result of being injured at work?</label>\n                <div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\">\n                    <input class=\"form-check-input-v4\" type=\"radio\" name=\"injuredAtWork\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.injuredAtWork\" id=\"Q2-{{item}}\">\n                    <label class=\"form-check-label-v4\" for=\"Q2-{{item}}\"> {{\'psychIntake.text.\'+item | translate}}</label>\n                </div>\n            </div>\n        </div>\n    </div>\n    --><div class=\"row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label class=\"d-block\" translate=\"psychIntake.demographics.Q3\">Are you seeking treatment for an injury/problem for which you have an active legal claim?</label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"seekingTreatmentInjury\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.seekingTreatmentInjury\" id=\"Q3-{{item}}\"><label class=\"form-check-label-v4\" for=\"Q3-{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.seekingTreatmentInjury === \'YES\'\"><label><span translate=\"psychIntake.demographics.Q3.promt\">Choose one of the following</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4\" ng-repeat=\"item in [\'WORKERS_COMPENSATION\', \'PERSONAL_INJURY\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"workRelatedInjury\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.workRelatedInjury\" id=\"Q3y-{{item}}\" ng-required=\"vm.workflow.answer.seekingTreatmentInjury === \'YES\'\"><label class=\"form-check-label-v4\" for=\"Q3y-{{item}}\">{{\'psychIntake.demographics.Q3.\'+item | translate}}</label></div></div></div></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/diagnostic-studies.directive.html","<label><span translate=\"psychIntake.diagnosticStudies.Q1\">Have you had any of the following diagnostics performed?</span> <span ng-if=\"vm.hadAnyDiagnosticStudiesResponse()\" translate=\"psychIntake.diagnosticStudies.important\"></span></label><div class=\"form-row-v4\" ng-repeat=\"item in vm.workflow.answer.diagnostics track by $index\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"{{$index}}\" ng-model=\"item.checked\" ng-disabled=\"vm.disabledCheck(item)\"><label class=\"form-check-label-v4\" for=\"{{$index}}\">{{item.diagnosticStudy.nameLangKey | translate}}</label></div><div class=\"form-row-v4\" ng-show=\"item.checked && item.diagnosticStudy.code !== \'NONE\'\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><label><span translate=\"psychIntake.diagnosticStudies.Q1.1\">What body parts were studied ?</span></label><input type=\"text\" class=\"form-control\" ng-model=\"item.bodyPartsStudied\" ng-maxlength=\"1000\"></div></div><div class=\"col-v4-md-6\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label><span translate=\"psychIntake.diagnosticStudies.Q1.2\">Date of Exam</span></label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6 input-group-v4\"><input id=\"diagnostic_dateOfExam_{{$index}}\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"vm.datePickerOptions\" ng-model=\"item.dateOfExam\" is-open=\"item.opened\" readonly=\"true\" close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"item.opened =!item.opened\" enable-time=\"false\"><div class=\"input-group-addon\"><span ng-click=\"item.opened =!item.opened\" class=\"glyphicon glyphicon-calendar\"></span></div></div><div class=\"col-v4-sm-6\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"diagnostic_dateOfExam_unsure_{{$index}}\" ng-model=\"item.dateOfExamUnsure\"><label class=\"form-check-label-v4\" for=\"diagnostic_dateOfExam_unsure_{{$index}}\" translate=\"psychIntake.diagnosticStudies.unsureOfDate\">Unsure of date</label></div></div></div></div></div></div></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/habits.directive.html","<div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q1\">Do you drink alcohol?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4-md\" ng-repeat=\"item in [\'NOT_AT_ALL\', \'RARELY\', \'OCCASIONALLY\', \'OFTEN\', \'EVERY_DAY\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"drinkAlcohol\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.drinkAlcohol\" id=\"drinkAlcohol_{{item}}\" required><label class=\"form-check-label-v4\" for=\"drinkAlcohol_{{item}}\">{{\'psychIntake.habits.drinkAlcohol.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q2\">Have you ever abused alcohol?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"everAbusedAlcohol\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.everAbusedAlcohol\" id=\"everAbusedAlcohol_{{item}}\" required><label class=\"form-check-label-v4\" for=\"everAbusedAlcohol_{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q3\">Have you ever been in Alcoholics Anonymous?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"everBeenInAlcoholicsAnonymous\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.everBeenInAlcoholicsAnonymous\" id=\"everBeenInAlcoholicsAnonymous_{{item}}\" required><label class=\"form-check-label-v4\" for=\"everBeenInAlcoholicsAnonymous_{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q4\">Have you ever abused drugs?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" id=\"everAbusedDrugs_{{item}}\" name=\"everAbusedDrugs\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.everAbusedDrugs\" required><label class=\"form-check-label-v4\" for=\"everAbusedDrugs_{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.everAbusedDrugs === \'YES\'\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q4.1\">If yes, please name them</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.drugNames\" ng-maxlength=\"255\" ng-required=\"vm.workflow.answer.everAbusedDrugs === \'YES\'\"></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q5\">Do you currently smoke?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"currentlySmoke\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.currentlySmoke\" id=\"currentlySmoke_{{item}}\" required><label class=\"form-check-label-v4\" for=\"currentlySmoke_{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.currentlySmoke == \'YES\'\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q5.1\">Average Cigarettes per day</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"number\" min=\"1\" max=\"100\" class=\"form-control\" ng-model=\"vm.workflow.answer.avgCigarettesPerDay\" ng-maxlength=\"50\" ng-required=\"vm.workflow.answer.currentlySmoke == \'YES\'\"></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.currentlySmoke == \'NO\'\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q5.2\">Have you ever smoked?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"everSmoked\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.everSmoked\" id=\"everSmoked_{{item}}\" ng-required=\"vm.workflow.answer.currentlySmoke == \'NO\'\"><label class=\"form-check-label-v4\" for=\"everSmoked_{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.habits.Q6\">How much caffeine do you drink per day on average? (coffee, soda, energy drinks)</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4-md\" ng-repeat=\"item in [\'NEVER\', \'RARELY\', \'ONE_TO_TWO_PER_DAY\', \'THREE_TO_FOUR_PER_DAY\', \'FIVE_PLUS_PER_DAY\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"drinkCaffeine\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.drinkCaffeine\" id=\"drinkCaffeine_{{item}}\" required><label class=\"form-check-label-v4\" for=\"drinkCaffeine_{{item}}\">{{\'psychIntake.habits.drinkCaffeine.\'+item | translate}}</label></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/medical-history.directive.html","<div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.medicalHistory.medical\">Medical History</span></label><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'ASTHMA_COPD\', \'ATRIAL_FIBRILLATION\', \'BLADDER_BOWEL\', \'CONVULSIONS_SEIZURES\', \'DIABETES\', \'HEAD_INJURY\', \'HEART_ATTACK\',\n	                \'HIGH_BLOOD_PRESSURE\', \'MIGRAINE_HEADACHE\', \'SERIOUS_INFECTION\', \'SLEEP_APNEA\', \'STROKE\', \'OTHER\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"medicalHistory_{{item}}\" name=\"medicalHistory_{{item}}\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.medicalHistorySelected[item]\"><label class=\"form-check-label-v4\" for=\"medicalHistory_{{item}}\"><span>{{\'psychIntake.medicalHistory.medicalOption.\'+item | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" style=\"top: 0\" ng-if=\"item === \'OTHER\' && vm.workflow.answer.medicalHistorySelected[\'OTHER\']\"></span></label></div></div></div><div class=\"col-v4-md-6\"><div class=\"form-row-v4\"><div class=\"col-v4-md\" ng-show=\"vm.workflow.answer.medicalHistorySelected[\'OTHER\']\"><input type=\"text\" class=\"form-control\" ng-maxlength=\"255\" ng-model=\"vm.workflow.answer.otherMedicalHistory\" ng-required=\"vm.workflow.answer.medicalHistorySelected[\'OTHER\']\"></div></div></div></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.medicalHistory.surgical\">Surgical History</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.surgicalHistory\" ng-maxlength=\"255\"></div></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.medicalHistory.Q1\">Are you allergic to any medications?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"allergicToAnyMedications\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.allergicToAnyMedications\" id=\"allergicToAnyMedications.{{item}}\" required><label class=\"form-check-label-v4\" for=\"allergicToAnyMedications.{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.allergicToAnyMedications === \'YES\'\"><label class=\"d-block\"><span translate=\"psychIntake.medicalHistory.Q1.1\">If yes, which ones?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.allergicWhichOnes\" ng-maxlength=\"255\" ng-required=\"vm.workflow.answer.allergicToAnyMedications === \'YES\'\"></div><div class=\"form-group\"><label translate=\"psychIntake.medicalHistory.Q2\">Please list any other allergies</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.otherAllergies\" ng-maxlength=\"255\"></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/medications.directive.html","<div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.medications.medicationsCurrentlyTaking\">What medications are you currently taking?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.medicationsCurrentlyTaking\" ng-maxlength=\"255\" required></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.medications.currentSupplements\">Current supplements, vitamins and herbal remedies</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.currentSupplements\" ng-maxlength=\"255\"></div></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/personal-injury.directive.html","<div class=\"form-row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label><span translate=\"psychIntake.personalInjury.dateOfInjury\">Date of Injury</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6 input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"datePersonalInjury\" name=\"datePersonalInjury\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"vm.datePickerOptions\" readonly=\"true\" required close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"vm.datePickerOpenStatus.datePersonalInjury = !vm.datePickerOpenStatus.datePersonalInjury\" ng-model=\"vm.workflow.answer.datePersonalInjury\" is-open=\"vm.datePickerOpenStatus.datePersonalInjury\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.datePersonalInjury = !vm.datePickerOpenStatus.datePersonalInjury\"></span></div></div></div></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.personalInjury.describeOfInjury\">Description of events that lead to injury</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.descriptionPersonalInjury\" ng-maxlength=\"255\" required></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6 order-first\"><div class=\"form-group\"><label><span translate=\"psychIntake.personalInjury.attorneyName\">Attorney Name</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.attorneyNamePersonalInjury\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md-6 order-last\"><div class=\"form-group\"><label><span translate=\"psychIntake.personalInjury.attorneyPhone\">Attorney Phone Number</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.attorneyPhonePersonalInjury\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input></div></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/previous-treatment.directive.html","<div class=\"row-v4\"><div class=\"col-v4-md-12\"><div class=\"form-group\"><label><span translate=\"psychIntake.previousTreatment.Q1\">Have you tried the following treatment options? Please select all that apply.</span></label><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'PHYSICAL_THERAPY\', \'AQUATIC_THERAPY\', \'CHIROPRACTIC\', \'ACUPUNCTURE\', \'TENS_HWAVE\', \'INJECTIONS\', \'GROUP_PSYCHOTHERAPY\',\n	                \'INDIVIDUAL_PSYCHOTHERAPY\', \'FAMILY_THERAPY\', \'MEDICATION_PSYCHIATRY\', \'INPATIENT_CARE\', \'SCS_EVALUATION_TRIAL\', \'OTHER\', \'NONE\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"followingTreatment_{{item}}\" name=\"followingTreatment_{{item}}\" ng-disabled=\"vm.disabledCheck(item)\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.followingTreatmentSelected[item]\"><label class=\"form-check-label-v4\" for=\"followingTreatment_{{item}}\" style=\"margin-right: 8px; flex-wrap: nowrap\"><span>{{\'psychIntake.previousTreatment.treatmentOption.\'+item | translate}}</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\" style=\"top: 0\" ng-if=\"(item === \'OTHER\' && vm.workflow.answer.followingTreatmentSelected[\'OTHER\']) || (item === \'INJECTIONS\' && vm.workflow.answer.followingTreatmentSelected[\'INJECTIONS\'])\"></span></label><input type=\"text\" class=\"form-control\" ng-maxlength=\"255\" ng-show=\"item === \'INJECTIONS\' && vm.workflow.answer.followingTreatmentSelected[\'INJECTIONS\']\" ng-model=\"vm.workflow.answer.injections\" ng-required=\"vm.workflow.answer.followingTreatmentSelected[\'INJECTIONS\']\"> <input type=\"text\" class=\"form-control\" ng-maxlength=\"255\" ng-show=\"item === \'OTHER\' && vm.workflow.answer.followingTreatmentSelected[\'OTHER\']\" ng-model=\"vm.workflow.answer.otherFollowingTreatment\" ng-required=\"vm.workflow.answer.followingTreatmentSelected[\'OTHER\']\"></div></div></div></div></div></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/social-history.directive.html","<div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.socialHistory.maritalStatus\">Marital Status</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4-md\" ng-repeat=\"item in [\'MARRIED\', \'DIVORCED\', \'SINGLE\', \'WIDOWED\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"maritalStatus\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.maritalStatus\" id=\"maritalStatus_{{item}}\" required><label class=\"form-check-label-v4\" for=\"maritalStatus_{{item}}\">{{\'psychIntake.socialHistory.maritalOption.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.socialHistory.employmentStatus\">Employment Status</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.employmentStatus\" required ng-maxlength=\"255\"></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.socialHistory.levelEducation\">Highest level of education</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.levelEducation\" ng-maxlength=\"255\"></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.socialHistory.Q1\">Do you have Children?</span></label><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"haveChildren\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.haveChildren\" id=\"haveChildren_{{item}}\"><label class=\"form-check-label-v4\" for=\"haveChildren_{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.haveChildren == \'YES\'\"><label class=\"d-block\"><span translate=\"psychIntake.socialHistory.Q1.1\">How many</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"number\" min=\"1\" max=\"100\" class=\"form-control\" ng-model=\"vm.workflow.answer.numChildren\" ng-maxlength=\"50\" ng-required=\"vm.workflow.answer.haveChildren == \'YES\'\"></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/wellness-status.directive.html","<div class=\"form-group\"><label><span translate=\"psychIntake.wellnessStatus.Q1\">Are you currently experiencing any of the following stressors?</span></label><div class=\"form-row-v4\"><div class=\"col-v4-md-6\" ng-repeat=\"item in [\'RELATIONSHIP_PROBLEMS\', \'FINANCIAL_PROBLEMS\', \'HOUSING_PROBLEMS\', \'DEATH_OF_LOVED_ONE\', \'SERIOUS_FAMILY_ILLNESS\', \'JOB_ISSUES\', \'NONE\'] track by $index\"><div class=\"form-check-v4\"><input class=\"form-check-input-v4\" type=\"checkbox\" id=\"stressors_{{item}}\" name=\"stressors_{{item}}\" ng-disabled=\"vm.disabledCheck(item)\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.stressorsSelected[item]\"><label class=\"form-check-label-v4\" for=\"stressors_{{item}}\">{{\'psychIntake.wellnessStatus.stressorsOption.\'+item | translate}}</label></div></div></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.wellnessStatus.Q2\">What is the average amount of exercise you get per day?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4-md\" ng-repeat=\"item in [\'ZERO_MIN\', \'THIRTY_MINS\', \'ONE_TO_TWO_HOURS\', \'THREE_PLUS_HOURS\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"avgAmountExercise\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.avgAmountExercise\" id=\"avgAmountExercise_{{item}}\" required><label class=\"form-check-label-v4\" for=\"avgAmountExercise_{{item}}\">{{\'psychIntake.wellnessStatus.avgAmountExercise.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.wellnessStatus.Q3\">What is the average amount of sleep you get per night?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><div class=\"form-check-v4 form-check-inline-v4-md\" ng-repeat=\"item in [\'LESS_FIVE_HOURS\', \'SIX_TO_SEVEN_HOURS\', \'EIGHT_TO_TEN_HOURS\', \'ELEVEN_PLUS_HOURS\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"avgAmountSleep\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.avgAmountSleep\" id=\"avgAmountSleep_{{item}}\" required><label class=\"form-check-label-v4\" for=\"avgAmountSleep_{{item}}\">{{\'psychIntake.wellnessStatus.avgAmountSleep.\'+item | translate}}</label></div></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.wellnessStatus.Q4\">What are your current coping skills</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.currentCopingSkills\" ng-maxlength=\"255\"></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.wellnessStatus.Q5\">What are your current support systems</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.currentSupportSystems\" ng-maxlength=\"255\"></div><div class=\"form-group\"><label class=\"d-block\"><span translate=\"psychIntake.wellnessStatus.goalsTreatment\">Goals for treatment</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.goalsTreatment\" ng-maxlength=\"255\" required></div>");
$templateCache.put("app/psych-intake/workflow/partial/directive/workers-compensation.directive.html","<div class=\"form-row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label><span translate=\"psychIntake.workersCompensation.dateOfInjury\">Date of Injury</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6 input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"dateOfInjury\" name=\"dateOfInjury\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"vm.datePickerOptions\" readonly=\"true\" required close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"vm.datePickerOpenStatus.dateOfInjury = !vm.datePickerOpenStatus.dateOfInjury\" ng-model=\"vm.workflow.answer.dateOfInjury\" is-open=\"vm.datePickerOpenStatus.dateOfInjury\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.dateOfInjury = !vm.datePickerOpenStatus.dateOfInjury\"></span></div></div></div></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-12\"><div class=\"form-group\"><div><label><span translate=\"psychIntake.workersCompensation.Q1\">Which of the following is the claim related to?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label></div><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'PHYSICAL\', \'MENTAL\', \'PHYSICAL_MENTAL\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"claimRelatedTo\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.claimRelatedTo\" id=\"Q1-{{item}}\" required><label class=\"form-check-label-v4\" for=\"Q1-{{item}}\">{{\'psychIntake.workersCompensation.Q1.\'+item | translate}}</label></div></div><div class=\"form-group\" ng-show=\"vm.workflow.answer.claimRelatedTo === \'PHYSICAL\' || vm.workflow.answer.claimRelatedTo === \'PHYSICAL_MENTAL\'\"><label><span translate=\"psychIntake.workersCompensation.acceptedBodyParts\">Accepted Body Parts</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.acceptedBodyParts\" ng-maxlength=\"255\" ng-required=\"vm.workflow.answer.claimRelatedTo === \'PHYSICAL\' || vm.workflow.answer.claimRelatedTo === \'PHYSICAL_MENTAL\'\"></div><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.brieflyDescribe\">Briefly describe how your pain/problem started</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.descriptionOfInjury\" ng-maxlength=\"255\" required></div><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.jobTitle\">Job Title at time of Injury</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.jobTitleInjury\" ng-maxlength=\"150\" required></div><div class=\"form-group\"><div><label><span translate=\"psychIntake.workersCompensation.Q2\">Do you have more than one claim open?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label></div><div class=\"form-check-v4 form-check-inline-v4\" ng-repeat=\"item in [\'YES\', \'NO\'] track by $index\"><input class=\"form-check-input-v4\" type=\"radio\" name=\"moreThanOneClaim\" value=\"{{item}}\" ng-model=\"vm.workflow.answer.moreThanOneClaim\" id=\"Q1-{{item}}\"><label class=\"form-check-label-v4\" for=\"Q1-{{item}}\">{{\'psychIntake.text.\'+item | translate}}</label></div></div></div></div><div class=\"form-row-v4\"><div class=\"col-v4-md-6\"><div class=\"form-group\"><div class=\"row-v4\"><div class=\"col-v4-md-12\"><label><span translate=\"psychIntake.workersCompensation.lastDayWorked\">What is the last day you worked?</span> <span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span></label></div></div><div class=\"row-v4\"><div class=\"col-v4-sm-6 input-group-v4\"><input type=\"text\" class=\"form-control\" id=\"lastDayWorked\" name=\"lastDayWorked\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-options=\"vm.datePickerOptions\" readonly=\"true\" required close-text=\"{{\'global.datepicker.done\' | translate}}\" current-text=\"{{\'global.datepicker.today\' | translate}}\" clear-text=\"{{\'global.datepicker.clear\' | translate}}\" ng-click=\"vm.datePickerOpenStatus.lastDayWorked = !vm.datePickerOpenStatus.lastDayWorked\" ng-model=\"vm.workflow.answer.lastDayWorked\" is-open=\"vm.datePickerOpenStatus.lastDayWorked\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.datePickerOpenStatus.lastDayWorked = !vm.datePickerOpenStatus.lastDayWorked\"></span></div></div></div></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6 order-first\"><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.attorneyName\">Attorney Name</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.attorneyName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md-6 order-last\"><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.attorneyPhone\">Attorney Phone Number</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.attorneyPhone\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6 order-first\"><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.adjusterName\">Adjuster Name</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.adjusterName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md-6 order-last\"><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.adjusterPhone\">Adjuster Phone Number</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.adjusterPhone\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input></div></div></div><div class=\"row-v4\"><div class=\"col-v4-md-6 order-first\"><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.nurseName\">Nurse Case Manager Name</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.nurseName\" ng-maxlength=\"150\"></div></div><div class=\"col-v4-md-6 order-last\"><div class=\"form-group\"><label><span translate=\"psychIntake.workersCompensation.nursePhone\">Nurse Case Manager Phone Number</span></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.workflow.answer.nursePhone\" ng-minlength=\"10\" ng-maxlength=\"20\" phone-input></div></div></div>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/call-log/partial/call-log-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.close()\">&times;</button><h5 class=\"modal-title\" translate=\"ipmApp.callLog.home.title\">Call Log</h5></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><div class=\"col-sm-12\"><div class=\"form-group\"><strong translate=\"ipmApp.callLog.detail.logACall\">log A Call</strong></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"ipmApp.callLog.detail.date\">Date</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><div class=\"input-group\"><input id=\"dateLog\" type=\"text\" class=\"form-control\" name=\"dateLog\" uib-datepicker-popup=\"MM/dd/yyyy\" required ng-model=\"vm.callLog.dateLog\" is-open=\"vm.datePickerOpenStatus.dateLog\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateLog\')\"></span></div></div><div ng-show=\"(editForm.dateLog.$dirty && editForm.dateLog.$invalid)\"><p class=\"help-block\" ng-show=\"editForm.dateLog.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"ipmApp.callLog.detail.party\">Party</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><select class=\"form-control\" name=\"party\" id=\"party\" ng-model=\"vm.callLog.party\" required ng-options=\"opt as \'ipmApp.partyType.\' + opt | translate for opt in vm.partyTypes\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"editForm.party.$dirty && editForm.party.$invalid\"><p class=\"help-block\" ng-show=\"editForm.party.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"row\" ng-if=\"vm.callLog.party === \'OTHER\'\"><div class=\"col-sm-5\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"selectedProvide\" id=\"field_selectedProvide\" required ng-model=\"vm.callLog.selectedProvide\" ng-maxlength=\"255\"></div></div><div class=\"col-sm-12 col-party-other\"><div ng-show=\"editForm.selectedProvide.$dirty && editForm.selectedProvide.$invalid\"><p class=\"help-block\" ng-show=\"editForm.selectedProvide.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.selectedProvide.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div></div><div class=\"form-group\"><label for=\"summary\" translate=\"ipmApp.callLog.detail.summary\">Summary</label><span class=\"glyphicon glyphicon-asterisk icon-required\" aria-hidden=\"true\"></span><textarea type=\"text\" class=\"form-control auto-height text-summary\" id=\"summary\" name=\"summary\" ng-model=\"vm.callLog.summary\" ng-minlength=\"1\" ng-maxlength=\"1000\" required></textarea><div ng-show=\"editForm.summary.$dirty && editForm.summary.$invalid\"><p class=\"help-block\" ng-show=\"editForm.summary.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.summary.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1000\">This field cannot be longer than 1000 characters.</p></div></div><div class=\"form-group text-center\"><button type=\"submit\" ng-disabled=\"editForm.$invalid\" class=\"btn btn-primary\"><span translate=\"ipmApp.callLog.action.logCall\">Log Call</span></button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"vm.close()\"><span translate=\"entity.action.cancel\">Cancel</span></button></div></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><div class=\"form-group\"><strong translate=\"ipmApp.callLog.calls\">Calls</strong></div><!--start table calls--><div><call-log-list call-logs=\"vm.callLogs\"></call-log-list></div></div></div></div><div class=\"modal-footer\"></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/call-log/partial/call-log-list.html","<div class=\"table-responsive table-scroll-h\"><table class=\"jh-table table table-striped\"><thead><tr><th width=\"5%\"><span translate=\"ipmApp.callLog.date\"></span></th><th width=\"30%\"><span translate=\"ipmApp.callLog.qhp\"></span></th><th width=\"30%\"><span translate=\"ipmApp.callLog.performedBy\"></span></th><th width=\"30%\"><span translate=\"ipmApp.callLog.party\">Party</span></th><th width=\"5%\"><span translate=\"ipmApp.callLog.summary\">Summary</span></th></tr></thead><tbody><tr ng-repeat-start=\"cl in vm.callLogs track by $index\" ng-class=\"$index % 2 ? \'even\' : \'odd\'\"><td><strong>{{cl.dateLog | date:\'MM/dd/yyyy\'}}</strong></td><td>{{cl.qhpUserFullName}}</td><td>{{cl.qhpUserAdHocFullName}}</td><td class=\"col-party\"><span ng-if=\"cl.party !== \'OTHER\'\">{{\'ipmApp.partyType.\' + cl.party | translate}}</span> <span ng-if=\"cl.party === \'OTHER\'\">{{cl.selectedProvide}}</span></td><td><div ng-if=\"cl.expanded\" ng-click=\"cl.expanded = false\" class=\"expand-icon active\" uib-tooltip=\"{{\'ipmApp.callLog.dialog.viewSummary\' | translate}}\"></div><div ng-if=\"!cl.expanded\" ng-click=\"cl.expanded = true\" class=\"expand-icon\" uib-tooltip=\"{{\'ipmApp.callLog.dialog.viewSummary\' | translate}}\"></div></td></tr><tr ng-if=\"cl.expanded\" ng-repeat-end=\"\" ng-class=\"$index % 2 ? \'even-child\' : \'odd-child\'\"><td colspan=\"5\">{{cl.summary}}</td></tr></tbody><tbody ng-if=\"!vm.callLogs || vm.callLogs.length === 0\"><tr><td colspan=\"5\"><p class=\"help-block text-center\" translate=\"ipmApp.callLog.dialog.notExists\">There is no Call Log</p></td></tr></tbody></table></div>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/cases-table/cases-table.html","<div class=\"form-group\"><form name=\"vm.evaluationForm\" role=\"form\" novalidate><div class=\"table-responsive\"><table class=\"jh-table table table-striped optionQuestion\"><!-- fix bug : IPMproject-B1253--><thead><tr><th></th><th><span translate=\"ipmApp.qhpWorkflow.cases.table.caseNumber\"></span></th><th class=\"authDate\"><span translate=\"ipmApp.qhpWorkflow.cases.table.doi\"></span></th><th><span translate=\"ipmApp.qhpWorkflow.cases.table.caseStatus\"></span></th><th><span translate=\"ipmApp.qhpWorkflow.cases.table.workStatus\"></span></th><th><span translate=\"ipmApp.qhpWorkflow.cases.table.ptp\"></span></th><th><span translate=\"ipmApp.qhpWorkflow.cases.table.carrier\"></span></th><th><span translate=\"ipmApp.qhpWorkflow.cases.table.bodyParts\"></span></th></tr></thead><tbody><tr ng-repeat=\"caseItem in vm.cases track by $index\" ng-if=\"caseItem.active == true\"><td><div class=\"form-check\"><input class=\"form-check-input\" type=\"radio\" name=\"radioCaseBillTo\" id=\"caseBillTo_{{$index}}\" ng-model=\"vm.selectedCaseIndex\" ng-value=\"$index\" ng-change=\"vm.caseBillToOnChange()\"></div></td><td><input type=\"text\" class=\"form-control\" name=\"caseNumber_{{$index}}\" id=\"caseNumber_{{$index}}\" ng-model=\"caseItem.caseNumber\" ng-disabled=\"caseItem.patientCaseId\" ng-model-options=\"{debounce: 600}\" ng-change=\"vm.handleCaseNumberOnChange(caseItem, $index)\" required><div ng-show=\"vm.evaluationForm.caseNumber_{{$index}}.$dirty && vm.evaluationForm.caseNumber_{{$index}}.$error\"><p class=\"help-block\" ng-show=\"vm.evaluationForm.caseNumber_{{$index}}.$error.existsValue\" translate=\"ipmApp.qhpWorkflow.cases.validation.caseNumberExists\">CaseNumber is already in use.</p></div><div ng-show=\"vm.evaluationForm.caseNumber_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><div class=\"input-group\"><input name=\"doi_{{$index}}\" id=\"field_doi.{{$index}}\" type=\"text\" class=\"form-control\" ng-change=\"vm.handleDoiChange(caseItem)\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-append-to-body=\"true\" ng-required=\"vm.isDoiRequired(caseItem)\" ng-model=\"caseItem.doi\" is-open=\"caseItem.datePickerOpenStatus.doiLog\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(caseItem, \'doiLog\')\"></span></div></div><div ng-show=\"vm.evaluationForm.doi_{{$index}}.$dirty && vm.evaluationForm.doi_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"vm.evaluationForm.doi_{{$index}}.$error.date\" translate=\"ipmApp.qhpWorkflow.cases.validation.doiInvalid\">This field is invalid.</p></div><div ng-show=\"vm.evaluationForm.doi_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><select class=\"form-control\" name=\"caseStatus_{{$index}}\" id=\"field_case_status.{{$index}}\" ng-model=\"caseItem.caseStatus\" ng-change=\"vm.handleCaseStatusChange(caseItem)\" ng-required=\"vm.isCaseStatusRequired(caseItem)\" ng-options=\"status as \'ipmApp.qhpWorkflow.cases.caseStatus.\' + status | translate for status in vm.caseStatuses track by status\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.evaluationForm.caseStatus_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><select class=\"form-control\" name=\"workStatus_{{$index}}\" id=\"field_work_status.{{$index}}\" ng-model=\"caseItem.workStatus\" ng-change=\"vm.handleWorkStatusChange(caseItem)\" ng-required=\"vm.isWorkStatusRequired(caseItem)\" ng-options=\"status as \'ipmApp.qhpWorkflow.cases.workStatus.\' + status | translate for status in vm.workStatuses track by status\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"vm.evaluationForm.workStatus_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><input type=\"text\" class=\"form-control\" name=\"ptp_{{$index}}\" id=\"field_ptp.{{$index}}\" ng-model=\"caseItem.ptp\"></td><td><input type=\"text\" class=\"form-control\" name=\"carrier_{{$index}}\" id=\"field_carrier.{{$index}}\" ng-model=\"caseItem.carrier\"></td><td><input type=\"text\" class=\"form-control\" name=\"bodyParts_{{$index}}\" id=\"field_bodyParts.{{$index}}\" ng-model=\"caseItem.bodyParts\"></td><td><button type=\"button\" class=\"btn btn-danger btn-sm ng-scope\" ng-click=\"vm.clearCaseRowData(caseItem, $index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr><td colspan=\"9\"><button ng-click=\"vm.addNewCase()\" class=\"btn btn-success btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><div class=\"form-group text-danger\" ng-if=\"vm.selectedIsNotBillable\"><span translate=\"ipmApp.qhpWorkflow.cases.validation.selectedIsNotBillable\" translate-values=\"{exclusionReason: \'{{vm.getServiceExclusionReason()}}\'}\">Warning: The case you have selected is not billable.</span></div></div></form></div>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/question-component/question.html","<form name=\"evaluationForm\" role=\"form\" novalidate><h4>{{vm.question.text}}<span class=\"glyphicon glyphicon-asterisk icon-required ml-2\" aria-hidden=\"true\" ng-if=\"vm.question.text && vm.isRequiredQuestion()\"></span></h4><div ng-if=\"vm.isDisplayMessageRequiredSubCheckbox()\"><p class=\"help-block\" translate=\"entity.validation.selectAtLeast1Sub\">This field is required.</p></div><!-- Single choice --><cpr-single-choice-question question=\"vm.question\" answers=\"vm.answers\" on-change=\"vm.handleSingleChoiceQuestion(data)\" ng-if=\"vm.isSingleChoiceQuestion()\"></cpr-single-choice-question><!-- Text input --><cpr-text-input-question question=\"vm.question\" answers=\"vm.answers\" on-change=\"vm.handleTextInputQuestion(data)\" ng-if=\"vm.isTextInputQuestion()\"></cpr-text-input-question><!-- Checkbox --><cpr-checkbox-question question=\"vm.question\" answers=\"vm.answers\" on-change=\"vm.handleCheckboxQuestion(data)\" ng-if=\"vm.isCheckBoxQuestion() && vm.isDisplayCheckboxQuestion()\"></cpr-checkbox-question><!-- Date input --><cpr-date-input-question question=\"vm.question\" answers=\"vm.answers\" on-change=\"vm.handleDateQuestion(data)\" ng-if=\"vm.isDateQuestion()\"></cpr-date-input-question><!-- sub-question --><div ng-class=\"vm.getCssClass()\" ng-repeat=\"subQuestion in vm.question.childs track by subQuestion.id\"><cpr-question question=\"subQuestion\" patient-work-status=\"vm.patientWorkStatus\" surgical-candidacy-status=\"vm.surgicalCandidacyStatus\" answers=\"vm.answers\" ng-if=\"vm.isDisplaySubQuestion(subQuestion)\" on-change=\"vm.subQuestionChange(data)\"></cpr-question></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/treatment-history-table/treatment-history-table.html","<div class=\"form-group\"><form name=\"evaluationForm\" role=\"form\" novalidate><div class=\"table-responsive\"><table class=\"jh-table table table-striped optionQuestion\"><!-- fix bug : IPMproject-B1253--><thead><tr><th width=\"15%\"><span translate=\"ipmApp.qhpWorkflow.treatmentHistory.table.treatment\"></span></th><th width=\"10%\" class=\"w1\"><span translate=\"ipmApp.qhpWorkflow.treatmentHistory.table.sessionsCompleted\"></span></th><th width=\"20%\" class=\"authDate\"><span translate=\"ipmApp.qhpWorkflow.treatmentHistory.table.lastDate\"></span></th><th width=\"30%\"><span translate=\"ipmApp.qhpWorkflow.treatmentHistory.table.status\"></span></th><th width=\"20%\" class=\"authDate\"><span translate=\"ipmApp.qhpWorkflow.treatmentHistory.table.authResponseDate\"></span></th><th width=\"5%\"></th></tr></thead><tbody><tr ng-repeat=\"treatmentType in vm.treatmentTypes track by $index\"><td>{{\'ipmApp.qhpWorkflow.treatmentHistory.treatmentType.\' + treatmentType.value | translate}}</td><td><input type=\"text\" class=\"form-control\" name=\"sessionsCompleted_{{$index}}\" id=\"field_sessionsCompleted.{{$index}}\" ng-model=\"treatmentType.sessionsCompleted\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleSessionsCompletedChange(treatmentType)\" ng-required=\"vm.isSessionCompletedRequired(treatmentType)\" number-min-max min=\"{{treatmentType.sessionsCompletedMin}}\" max=\"{{treatmentType.sessionsCompletedMax}}\"><div ng-show=\"evaluationForm.sessionsCompleted_{{$index}}.$dirty\"><p class=\"help-block\" ng-show=\"treatmentType.value !==\'MDE\' && evaluationForm.sessionsCompleted_{{$index}}.$error.invalidRange\" translate=\"ipmApp.qhpWorkflow.treatmentHistory.validation.numberRange\" translate-value-min=\"{{treatmentType.sessionsCompletedMin}}\" translate-value-max=\"{{treatmentType.sessionsCompletedMax}}\"></p><p class=\"help-block\" ng-show=\"treatmentType.value ===\'MDE\' && evaluationForm.sessionsCompleted_{{$index}}.$error.invalidRange\" translate=\"ipmApp.qhpWorkflow.treatmentHistory.validation.onlyOneInput\" translate-value-min=\"{{treatmentType.sessionsCompletedMin}}\" translate-value-max=\"{{treatmentType.sessionsCompletedMax}}\"></p><p class=\"help-block\" ng-show=\"evaluationForm.sessionsCompleted_{{$index}}.$error.pattern\" translate=\"ipmApp.qhpWorkflow.treatmentHistory.validation.numberPattern\"></p></div><div ng-show=\"evaluationForm.sessionsCompleted_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><div class=\"input-group\"><input name=\"lastDate_{{$index}}\" id=\"field_lastDate.{{$index}}\" type=\"text\" class=\"form-control\" ng-change=\"vm.handleLastDateChange(treatmentType)\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-append-to-body=\"true\" ng-required=\"vm.isLastDateRequired(treatmentType)\" ng-model=\"treatmentType.lastDate\" is-open=\"treatmentType.datePickerOpenStatus.lastDateLog\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(treatmentType, \'lastDateLog\')\"></span></div></div><div ng-show=\"evaluationForm.lastDate_{{$index}}.$dirty && evaluationForm.lastDate_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"evaluationForm.lastDate_{{$index}}.$error.date\" translate=\"ipmApp.qhpWorkflow.treatmentHistory.validation.lastDateInvalid\">This field is invalid.</p></div><div ng-show=\"evaluationForm.lastDate_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><select class=\"form-control\" name=\"status_{{$index}}\" id=\"field_status.{{$index}}\" ng-model=\"treatmentType.status\" ng-change=\"vm.handleStatusChange(treatmentType)\" ng-required=\"vm.isStatusRequired(treatmentType)\" ng-options=\"status as \'ipmApp.qhpWorkflow.treatmentHistory.treatmentStatus.\' + status | translate for status in treatmentType.treatmentStatuses track by status\"><option value=\"\" selected=\"selected\"></option></select><div ng-show=\"evaluationForm.status_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><div class=\"input-group\"><input name=\"authResponseDate_{{$index}}\" id=\"field_authResponseDate.{{$index}}\" type=\"text\" class=\"form-control\" ng-change=\"vm.handleAuthResponseDateChange(treatmentType)\" uib-datepicker-popup=\"MM/dd/yyyy\" datepicker-append-to-body=\"true\" ng-required=\"vm.isAuthResponseDateRequired(treatmentType)\" ng-model=\"treatmentType.authResponseDate\" is-open=\"treatmentType.datePickerOpenStatus.authResponseDateLog\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(treatmentType, \'authResponseDateLog\')\"></span></div></div><div ng-show=\"evaluationForm.authResponseDate_{{$index}}.$dirty && evaluationForm.authResponseDate_{{$index}}.$invalid\"><p class=\"help-block\" ng-show=\"evaluationForm.authResponseDate_{{$index}}.$error.date\" translate=\"ipmApp.qhpWorkflow.treatmentHistory.validation.authResponseDateInvalid\">This field is invalid.</p></div><div ng-show=\"evaluationForm.authResponseDate_{{$index}}.$error.required\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></td><td><button type=\"button\" class=\"btn btn-danger btn-sm ng-scope\" ng-disabled=\"vm.isButtonClearTreamentDataDisable(treatmentType, $index)\" ng-click=\"vm.clearTreatmentRowData(treatmentType, $index)\"><span class=\"glyphicon glyphicon-remove-circle\"></span></button></td></tr></tbody></table></div></form></div>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/question-component/checkbox/checkbox.html","<form name=\"evaluationForm\" role=\"form\" novalidate><div class=\"row-v4\" ng-repeat=\"optionItem in vm.question.questionItems track by optionItem.id\"><div class=\"col-v4-12\"><div class=\"form-check-v4\"><input type=\"checkbox\" id=\"checkbox_{{optionItem.id}}_{{vm.question.id}}\" class=\"form-check-input-v4\" name=\"checkbox_{{optionItem.id}}_{{vm.question.id}}\" value=\"{{optionItem}}\" ng-model=\"optionItem.checked\" ng-change=\"vm.handleCheckboxChange(optionItem, optionItem.checked)\"><label class=\"form-check-label-v4\" for=\"checkbox_{{optionItem.id}}_{{vm.question.id}}\">{{optionItem.name}}</label><span ng-if=\"vm.checkShowLabelRequiredCheckBox(optionItem)\" class=\"glyphicon glyphicon-asterisk icon-required\"></span></div></div></div><div ng-class=\"vm.isDisplayLabelCheckbox() ? \'ml-4\' : \'\'\"><label ng-if=\"vm.isDisplayLabelCheckbox()\">{{ \'ipmApp.carePlanReview.actionSection.label.\' + vm.question.code | translate}}</label><textarea ng-if=\"vm.isDisplayTextAreaOtherCheckbox()\" class=\"form-control vertical-resize-textarea\" rows=\"5\" name=\"otherFreeTextField_{{vm.question.id}}\" id=\"otherFreeTextField_{{vm.question.id}}\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleOtherCheckboxTextInput()\" ng-model=\"vm.valueOtherCheckboxTextInputValue\" ng-required=\"vm.isOtherCheckboxTextInputRequired()\">\n        </textarea><div class=\"form-group row\"><div class=\"col-sm-3\"><input ng-if=\"vm.isDisplayTextFieldOtherCheckbox()\" type=\"text\" class=\"form-control\" name=\"otherFreeTextField_{{vm.question.id}}\" id=\"otherFreeTextField_{{vm.question.id}}\" ng-model=\"vm.valueOtherCheckboxTextInputValue\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleOtherCheckboxTextInput()\" ng-required=\"vm.isOtherCheckboxTextInputRequired()\"><div ng-show=\"evaluationForm.otherFreeTextField_{{vm.question.id}}.$dirty && !vm.valueOtherCheckboxTextInputValue\"><p class=\"help-block\" ng-show=\"evaluationForm.otherFreeTextField_{{vm.question.id}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/question-component/single-choice/single-choice.html","<form name=\"evaluationForm\" role=\"form\" novalidate><div class=\"form-check-v4\" ng-class=\"vm.isDisplayCheckBoxInline() ? \'form-check-inline-v4\': \'\'\" ng-repeat=\"option in vm.question.optionNames\"><input type=\"radio\" class=\"form-check-input-v4\" id=\"radio_{{option.value + \'_\' + vm.question.id}}\" name=\"radio_SINGLE_CHOICE_{{vm.question.id}}\" ng-change=\"vm.handleSingleChoiceChange()\" ng-value=\"option.value\" ng-model=\"vm.valueAnswer\" ng-required=\"vm.question.required\"><label class=\"form-check-label-v4\" for=\"radio_{{option.value + \'_\' + vm.question.id}}\">{{option.key}} <span ng-if=\"vm.checkShowLabelRequiredCheckBox(option)\" class=\"glyphicon glyphicon-asterisk icon-required mt-1\"></span></label></div><textarea ng-if=\"vm.isDisplayTextAreaOtherSingleChoice()\" class=\"form-control auto-height none-resize\" rows=\"5\" name=\"otherSingleChoiceFreeTextField_{{vm.question.id}}\" id=\"otherSingleChoiceFreeTextField_{{vm.question.id}}\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleOtherSingleChoiceTextInput()\" ng-model=\"vm.valueOtherSingleChoiceTextInputValue\" ng-required=\"vm.isOtherSingleChoiceTextInputRequired()\">\n    </textarea><div ng-show=\"vm.isDisplayTextAreaOtherSingleChoice() && evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$dirty && !vm.valueOtherSingleChoiceTextInputValue\"><p class=\"help-block\" ng-show=\"evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group row\"><div class=\"col-sm-3\"><input ng-if=\"vm.isDisplayTextFieldOtherSingleChoice()\" type=\"text\" class=\"form-control\" name=\"otherSingleChoiceFreeTextField_{{vm.question.id}}\" id=\"otherSingleChoiceFreeTextField_{{vm.question.id}}\" ng-model=\"vm.valueOtherSingleChoiceTextInputValue\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.handleOtherSingleChoiceTextInput()\" ng-required=\"vm.isOtherSingleChoiceTextInputRequired()\"><div ng-show=\"vm.isDisplayTextFieldOtherSingleChoice() && evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$dirty && !vm.valueOtherSingleChoiceTextInputValue\"><p class=\"help-block\" ng-show=\"evaluationForm.otherSingleChoiceFreeTextField_{{vm.question.id}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/question-component/date-input/date-input.html","<form name=\"evaluationForm\" role=\"form\" novalidate><div class=\"form-group\"><div class=\"input-group\"><div class=\"input-group\"><input name=\"dateInut_{{$index}}\" id=\"field_dateInut.{{$index}}\" type=\"text\" class=\"form-control\" ng-change=\"vm.handleTextChange()\" uib-datepicker-popup=\"MM/dd/yyyy\" ng-required=\"vm.question.required\" ng-model=\"vm.valueAnswer\" is-open=\"vm.datePickerOpenStatus.dateLog\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openCalendar(\'dateLog\')\"></span></div></div><div ng-show=\"evaluationForm.dateInut_{{$index}}.$dirty && evaluationForm.dateInut_{{$index}}.$invalid\"><p class=\"help-block\" translate=\"ipmApp.qhpWorkflow.treatmentHistory.validation.lastDateInvalid\">This field is invalid.</p></div></div></div></form>");
$templateCache.put("app/qhp-workflow/care-plan-review-workflow/section-component/question-component/text-input/text-input.html","<form name=\"evaluationForm\" role=\"form\" novalidate><label ng-if=\"vm.isDisplayLabel()\">{{ \'ipmApp.carePlanReview.actionSection.label.\' + vm.question.code | translate }}</label><textarea class=\"form-control vertical-resize-textarea\" rows=\"5\" name=\"freeTextField_{{vm.question.id}}\" id=\"freeTextField_{{vm.question.id}}\" ng-model-options=\"{debounce: 100}\" ng-model=\"vm.valueAnswer\" ng-required=\"vm.isFreeTextInputRequired()\" minimum-value=\"{{vm.minlengthInputRequired()}}\" ng-maxlength=\"vm.getMaxLength()\" ng-hide=\"true\">\n    </textarea><div id=\"quillContainer\" class=\"quill-container\" style=\"height: 106px\"><div class=\"text-quill-editor-cpr\" name=\"vm.getEditorTextId\" id=\"{{vm.getEditorTextId}}\" ng-required=\"vm.isFreeTextInputRequired()\"></div><div id=\"resizeHandle\" class=\"resize-handle\"></div><quill-editor ng-if=\"vm.question\" ids=\"vm.getEditorTextId\" value=\"vm.valueAnswer\" hide-toolbar=\"true\" enable-format-copy-event=\"true\" max-length=\"vm.getMaxLength()\" on-edit-change=\"vm.handleTextChange(data, evaluationForm)\"></quill-editor></div><div ng-show=\"evaluationForm.freeTextField_{{vm.question.id}}.$dirty && !vm.valueAnswer\"><p class=\"help-block\" ng-show=\"evaluationForm.freeTextField_{{vm.question.id}}.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div ng-show=\"(evaluationForm.freeTextField_{{vm.question.id}}.$dirty || vm.valueAnswer) && evaluationForm.freeTextField_{{vm.question.id}}.$error.minimumValue\"><p class=\"help-block\"><span translate=\"ipmApp.qhpWorkflow.validation.minimumWordsValue\" translate-value-number=\"{{vm.minlengthInputRequired()}}\">You must include at least 25 words.</span></p></div><div class=\"help-block\" ng-show=\"evaluationForm.freeTextField_{{vm.question.id}}.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"{{vm.getMaxLength()}}\">This field cannot be longer than 50 characters.</div></form>");
$templateCache.put("app/survey-workflow/partial/course-register-workflow/step/class-session-detail-list/class-session-detail-list.html","<div class=\"row\"><div class=\"col-sm-10 col-sm-offset-1 voffset5\"><div class=\"title h2\">{{vm.patientCourseRegistration.courseNameSelected}} - <span translate=\"surveyWorkflow.courseRegistration.classSession.Registration\">Registration</span></div><p translate=\"surveyWorkflow.courseRegistration.classSession.description\" translate-value-course-name=\"{{vm.patientCourseRegistration.courseNameSelected}}\" translate-value-class-number=\"{{vm.patientCourseRegistration.scheduledClassesSelected.length}}\"></p><jhi-alert></jhi-alert><div class=\"table-responsive pt-2 pb-4\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Class\">Class </span>&nbsp;#</th><th class=\"w-20-p\"><span translate=\"surveyWorkflow.courseRegistration.classSession.className\">Class Name</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Instructor\">Instructor</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Date\">Date</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.DateOfWeek\">Date Of Week</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Time\">Time</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.edit\">Edit</span></th></tr></thead><tbody><tr ng-repeat=\"class in vm.patientCourseRegistration.scheduledClassesSelected track by class.id\"><td><span translate=\"surveyWorkflow.courseRegistration.classSession.Class\">Class</span>&nbsp;<span>{{class.wellnessClass.sequence}}</span></td><td width=\"20%\"><span ng-if=\"class.wellnessClass\">{{class.wellnessClass.name}}</span></td><td><span>{{class.instructorFirstName}} {{class.instructorLastName}}</span></td><td><span>{{class.classStart | date:\'MM/dd/yyyy\'}}</span></td><td><span class=\"text-capitalize\">{{class.classStart | date:\'EEEE\'}}</span></td><td><span class=\"text-uppercase\">{{class.classStart | date:\'hh:mm a\' }}</span></td><td><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.openClassDialog($index, class.id, class.wellnessClass.sequence)\"><span translate=\"surveyWorkflow.courseRegistration.classSession.action.Edit\">Edit</span></button></td></tr></tbody><tbody ng-if=\"!vm.patientCourseRegistration.scheduledClassesSelected || vm.patientCourseRegistration.scheduledClassesSelected.length === 0\"><tr><td colspan=\"7\"><p class=\"text-center\" translate=\"surveyWorkflow.courseRegistration.classSession.noClass\">There is no Class.</p></td></tr></tbody></table></div><div class=\"voffset2\"><div class=\"row\"><!-- wrong bootstrap grid because need fix UI btn-link spacing --> <button ng-click=\"vm.skip()\" class=\"btn btn-link primary\"><b translate=\"surveyWorkflow.courseRegistration.classSession.action.NoThank\">No thanks, I\'ll schedule one later</b></button><div class=\"col-md-6 pull-right text-right\"><button type=\"button\" ng-click=\"vm.back()\" class=\"btn btn-primary\"><span translate=\"surveyWorkflow.courseRegistration.classSession.action.back\">Back</span></button> <button type=\"button\" ng-click=\"vm.register()\" class=\"btn btn-primary\"><span translate=\"surveyWorkflow.courseRegistration.classSession.action.registerAll\">Register All</span></button></div></div><div class=\"clearfix\"></div></div></div></div>");
$templateCache.put("app/survey-workflow/partial/course-register-workflow/step/class-session-detail-list/class-session-modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">{{vm.courseName}}&nbsp;- <span translate=\"surveyWorkflow.courseRegistration.classSession.Registration\">Registration</span> - <span translate=\"surveyWorkflow.courseRegistration.classSession.Class\"></span> {{vm.classSequence}}</h4></div><div class=\"modal-body\"><p class=\"text-left\"><span translate=\"surveyWorkflow.courseRegistration.classSession.modalDescription\">Please select the class you would like to register for</span></p><jhi-alert></jhi-alert><div class=\"table-responsive pt-2 table-scroll-class\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Class\">Class </span>&nbsp;#</th><th class=\"w-20-p\"><span translate=\"surveyWorkflow.courseRegistration.classSession.className\">Class Name</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Instructor\">Instructor</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Date\">Date</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.DateOfWeek\">DateOfWeek</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.Time\">Time</span></th><th><span translate=\"surveyWorkflow.courseRegistration.classSession.action.Select\">Select</span></th></tr></thead><tbody><tr ng-repeat=\"class in vm.classList track by $index\" class=\"text-left\"><td><span translate=\"surveyWorkflow.courseRegistration.classSession.Class\">Class</span>&nbsp;<span>{{class.wellnessClass.sequence}}</span></td><td width=\"20%\"><span ng-if=\"class.wellnessClass\">{{class.wellnessClass.name}}</span></td><td><span>{{class.instructorFirstName}} {{class.instructorLastName}}</span></td><td><span>{{class.classStart | date: \'MM/dd/yyyy\' }}</span></td><td><span class=\"text-capitalize\">{{class.classStart | date: \'EEEE\'}}</span></td><td><span class=\"text-uppercase\">{{class.classStart | date:\'hh:mm a\'}}</span></td><td><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.selectedClass(class)\"><span translate=\"surveyWorkflow.courseRegistration.classSession.action.Select\">Select</span></button></td></tr></tbody><tbody ng-if=\"!vm.classList || vm.classList.length === 0\"><tr><td colspan=\"7\"><p class=\"text-center\" translate=\"surveyWorkflow.courseRegistration.classSession.noClass\">There is no Class.</p></td></tr></tbody></table></div></div>");
$templateCache.put("app/survey-workflow/partial/course-register-workflow/step/instruction-detail-list/instruction-detail-list.html","<div class=\"row\"><div class=\"col-sm-10 col-sm-offset-1 voffset5\"><div class=\"h2 title\"><span>{{vm.patientCourseRegistration.courseNameSelected}}</span> <span translate=\"surveyWorkflow.courseRegistration.instruction.home.title\"></span></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12 has-feedback-left\"><span translate=\"surveyWorkflow.courseRegistration.instruction.home.content\" translate-value-course-name=\"{{ vm.patientCourseRegistration.courseNameSelected }}\">Content</span></div></div><div class=\"table-responsive voffset3\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th>{{\'surveyWorkflow.courseRegistration.instruction.instructor\' | translate}}</th><th>{{\'surveyWorkflow.courseRegistration.instruction.date\' | translate}}</th><th>{{\'surveyWorkflow.courseRegistration.instruction.dayOfWeek\' | translate}}</th><th>{{\'surveyWorkflow.courseRegistration.instruction.time\' | translate}}</th><th class=\"text-center\">{{\'surveyWorkflow.courseRegistration.instruction.action.select\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"instructorSchedule in vm.patientCourseRegistration.instructorSchedules track by instructorSchedule.id\"><td>{{instructorSchedule.instructorFirstName}} {{instructorSchedule.instructorLastName}}</td><td>{{instructorSchedule.classStart | date:\'MM/dd/yyyy\'}}</td><td><span class=\"text-capitalize\">{{instructorSchedule.classStart | date:\'EEEE\'}}</span></td><td><span class=\"text-uppercase\">{{instructorSchedule.classStart | date:\'hh:mm a\'}}</span></td><td class=\"text-center\"><div class=\"btn-group\"><button type=\"submit\" ng-click=\"vm.select(instructorSchedule)\" class=\"btn btn-primary btn-sm\"><span translate=\"surveyWorkflow.courseRegistration.instruction.action.select\"></span></button></div></td></tr></tbody></table></div><div class=\"row\"><button type=\"button\" ng-click=\"vm.skip()\" class=\"btn btn-link primary\"><b translate=\"surveyWorkflow.courseRegistration.instruction.action.noThank\">No thanks, not now</b></button></div></div></div>");
$templateCache.put("app/survey-workflow/partial/course-register-workflow/step/suggest-course/suggest-course.html","<div class=\"row\" ng-if=\"vm.loadingFinish\"><div class=\"col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-12 voffset5\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><form name=\"confirmlForm\" role=\"form\" novalidate ng-submit=\"vm.confirmEmailAndInjuredType()\" show-validation><div class=\"row\"><div class=\"col-md-12 h2 title\" translate=\"surveyWorkflow.courseRegistration.suggestCourse.header\">Consider the following Wellness Classes</div><div class=\"col-md-12\" translate=\"surveyWorkflow.courseRegistration.suggestCourse.text1\">At BoomerangHC we are dedicated to carefully assessing and thoroughly treating our patients, offering additional support through patient education. Our Wellness Department offers online interactive courses once a month. These classes are designed to assist with effective pain management skills, a healthy lifestyle and overall better quality of life.</div><div ng-repeat=\"recommendation in vm.recommendations\"><recommendation-item text=\"recommendation.text\" items=\"recommendation.items\" on-change=\"vm.handleRecommendationChange(data)\" ng-if=\"recommendation.items && recommendation.items.length > 0\"></recommendation-item></div></div></form><div class=\"row\"><div class=\"col-sm-12 voffset3\"><button type=\"button\" ng-click=\"vm.register()\" ng-disabled=\"vm.isRegisterDisable()\" class=\"btn btn-info\"><span translate=\"surveyWorkflow.courseRegistration.suggestCourse.register\">Register</span></button> <button type=\"button\" ng-click=\"vm.skip()\" class=\"btn btn-link primary\"><b translate=\"surveyWorkflow.courseRegistration.suggestCourse.noThank\">No thanks, not now</b></button></div></div></div></div></div>");}]);})();